export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: any; output: any; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: any; output: any; }
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: any; output: any; }
  DriverBreakDurationInput: { input: any; output: any; }
  /** The Scalar for processing the list of Global IDs to the list of ids */
  FromGlobalIDValuesList: { input: any; output: any; }
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: { input: any; output: any; }
  GeoJSON: { input: any; output: any; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any; }
  /** The Scalar for a list of datetime for DateTimeRangeField */
  RangeDateTimeScalar: { input: any; output: any; }
  /** The Scalar for a list of available options of ticket event types. */
  TicketEventTypeValuesList: { input: any; output: any; }
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: { input: any; output: any; }
  /**
   * Leverages the internal Python implmeentation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: any; output: any; }
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: { input: any; output: any; }
};

/** An enumeration. */
export enum AbortiveReason {
  ACCESS_BLOCKED = 'ACCESS_BLOCKED',
  CUSTOMER_ABSENT = 'CUSTOMER_ABSENT',
  OTHER = 'OTHER',
  OVERLOADED = 'OVERLOADED',
  PERMIT_MISSING = 'PERMIT_MISSING',
  PROHIBITED_ITEMS = 'PROHIBITED_ITEMS'
}

/**
 * Mark a suggestion ACCEPTED and link the Flow built from it — the
 * suggestion-lifecycle write the builder calls after creating a draft
 * from a Pulse suggestion, so the pitch stops re-appearing as a "top
 * thing to automate" once it has been built (founder-reported gap).
 * Tenant-scoped on both rows; idempotent (re-accepting is a no-op).
 */
export type AcceptAutopilotSuggestion = {
  __typename: 'AcceptAutopilotSuggestion';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Convert a customer request into a customer, a property and a rental
 * in one step (PRODUCT-484). ``contactId`` / ``propertyId`` override the
 * automatic match the preview showed.
 */
export type AcceptCustomerRequest = {
  __typename: 'AcceptCustomerRequest';
  contact?: Maybe<ContactDef>;
  /** The contact this Accept created; null when one was reused. */
  createdContact?: Maybe<ContactDef>;
  /** The property this Accept created; null when one was reused. */
  createdProperty?: Maybe<PropertyDef>;
  property?: Maybe<PropertyDef>;
  rentalTicket?: Maybe<TicketDef>;
};

/**
 * RS-1203 accept with audit: acted_by/acted_at on the row plus
 * the route_studio.recommendation.accepted event; acceptance is the
 * EV-RECS positive label.
 */
export type AcceptRecommendationMutation = {
  __typename: 'AcceptRecommendationMutation';
  recommendation?: Maybe<RecommendationDef>;
};

/**
 * Called by the frontend after a successful SSO login that originated from
 * an invite link.  Activates the invited IoUser once the SSO identity has
 * been verified (email of the logged-in SSO user must match the invite).
 */
export type AcceptSsoInvite = {
  __typename: 'AcceptSsoInvite';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AcknowledgeInsightCard = {
  __typename: 'AcknowledgeInsightCard';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum AcosAcosArchiveLogStatusChoices {
  /** Failed */
  FAILED = 'FAILED',
  /** In progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Pending */
  PENDING = 'PENDING',
  /** Skipped */
  SKIPPED = 'SKIPPED',
  /** Succeeded */
  SUCCEEDED = 'SUCCEEDED'
}

export type AcosArchiveLogDef = {
  __typename: 'AcosArchiveLogDef';
  archiveOperationId?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idempotencyKey: Scalars['String']['output'];
  status: AcosArchiveStatus;
  ticketId: Scalars['Int']['output'];
};

/**
 * Read-side GraphQL representation of an ``AcosArchiveLog`` row.
 *
 * Lets the platform answer "was this ticket archived to ACOS WebSak?" — the
 * verification surface that previously did not exist (the app only exposed
 * the ``archiveTicketToAcos`` mutation). The frontend queries the logs for a
 * ticket and can render the per-document-type status + operation id +, on
 * failure, the reason.
 *
 * Only non-PII dispatch-journal fields are exposed. ``request_payload`` and
 * ``response_body`` (which carry name/address/masked tax-id/phone metadata)
 * are deliberately NOT in ``fields``.
 */
export type AcosArchiveLogType = Node & {
  __typename: 'AcosArchiveLogType';
  archiveOperationId?: Maybe<Scalars['String']['output']>;
  attempts: Scalars['Int']['output'];
  company: CompanyType;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  documentType: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  responseStatusCode?: Maybe<Scalars['Int']['output']>;
  status: AcosAcosArchiveLogStatusChoices;
  ticket: TicketDef;
  ticketType: TicketTypeDef;
  updatedAt: Scalars['DateTime']['output'];
  zipSha256?: Maybe<Scalars['String']['output']>;
};

export type AcosArchiveLogTypeConnection = {
  __typename: 'AcosArchiveLogTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AcosArchiveLogTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AcosArchiveLogType` and its cursor. */
export type AcosArchiveLogTypeEdge = {
  __typename: 'AcosArchiveLogTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AcosArchiveLogType>;
};

/** An enumeration. */
export enum AcosArchiveStatus {
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  SKIPPED = 'SKIPPED',
  SUCCEEDED = 'SUCCEEDED'
}

/**
 * Acquire an edit-lease on entering edit mode (idempotent for the
 * same user). Also returns the entity's currentVersion so the client
 * skips a separate version fetch (API contract).
 */
export type AcquireRecordLease = {
  __typename: 'AcquireRecordLease';
  currentVersion?: Maybe<Scalars['Int']['output']>;
  lease?: Maybe<RecordLeaseDef>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ActionCatalogDef = {
  __typename: 'ActionCatalogDef';
  actionClass: Scalars['String']['output'];
  actionKind: Scalars['String']['output'];
  deprecated: Scalars['Boolean']['output'];
  domain: Scalars['String']['output'];
  inputSchema: Scalars['JSONString']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  outputSchema: Scalars['JSONString']['output'];
  policyMode: Scalars['String']['output'];
  subjectTypes: Array<Scalars['String']['output']>;
};

/**
 * Promote a `test`-state Flow to `live` (AP-703: the activation gate).
 *
 * The one gated path to `live` in this schema -- see the module
 * docstring's "AP-703/Activation gate" paragraph and
 * `autopilot.runtime.activation_gate`'s own docstring for the full
 * contract. Deny by default: `gate_kind` must be `simulation` (an AP-701
 * replay already recorded for the exact `FlowVersion` being activated,
 * see `autopilot.runtime.activation_gate.record_simulation_run`) or
 * `override` (a non-blank `gate_reason`); anything else -- including
 * omitting `gate_reason` for an override -- is refused as a business
 * error (`ok=False` + `errors`), never a silent default and never a
 * GraphQL exception. All the real gate logic and the audit write live in
 * `activate_flow` itself, not here, so a direct Python caller (tests,
 * future internal callers) gets the exact same enforcement and the exact
 * same `FlowAuditLogEntry` this mutation does. `activate_flow` also
 * re-runs `validate_for_builder` against the target version (review fix);
 * a registry-drift violation comes back as a per-field `errors` entry,
 * the same shape `PromoteAutopilotFlow`/`RollbackAutopilotFlow` use.
 *
 * Story-fidelity note (updated, Wave 2 Lane E): `gate_kind='simulation'`
 * is reachable end-to-end -- record a `SimulationRun` first via
 * `RecordAutopilotSimulation` (one flow) or
 * `RecordAutopilotEstateSimulations` (every estate candidate at once),
 * then activate through this gate or through `ActivateConvertedFlows`.
 */
export type ActivateAutopilotFlow = {
  __typename: 'ActivateAutopilotFlow';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  flow?: Maybe<FlowType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * AP-704's one-click "promote to live" action, the one edge
 * `AutopilotFlowPromotableState` deliberately does not expose through
 * the generic `PromoteAutopilotFlow`: `shadow` -> `live`, and only from
 * `shadow`.
 *
 * The accrued shadow report *is* this path's activation gate --
 * `04_BACKLOG.md`'s AC is "one-click promote to live carrying the
 * shadow evidence forward", not a second approval step -- so this
 * mutation does not ask for a reason or a confirmation beyond the flow
 * already having been watching live events. Separate from, and does not
 * call, `ActivateAutopilotFlow`/`autopilot.runtime.activation_gate
 * .activate_flow` (AP-703's general activation gate: "a simulation
 * record on file, or an explicit reasoned override"): that gate covers
 * every *other* route to `live`; this is the one dedicated route AP-704
 * adds on top of it, gated on its own evidence instead. What IS enforced
 * here, because the docstring above claims the report itself is the
 * gate: `report.run_count` must be nonzero. A flow can be promoted
 * straight from `test` to `shadow` and this mutation called in the very
 * next request, before a single live event has ever reached it; an empty
 * report is not evidence of anything and must not be accepted as this
 * path's gate. This is a floor, not AP-703's real activation gate
 * (a minimum run count is not "the flow behaves correctly"), and is
 * deliberately conservative alongside that gate, not a replacement for
 * it.
 *
 * Also refuses when `flow.has_unsaved_changes()`, the same guard
 * `PromoteAutopilotFlow` enforces before promoting into `test` or
 * `shadow`: an autosaved-but-uncommitted draft edit must not be able to
 * one-click activate the older committed version while the canvas shows
 * different logic, on this, the highest-stakes transition of all.
 *
 * "Carrying the shadow evidence forward" means literally: the report is
 * computed once, before the state changes, and written into the
 * `FlowAuditLogEntry.after` payload (`Action.PROMOTED_FROM_SHADOW`) so
 * it is preserved permanently in the audit trail, not merely
 * reconstructable for as long as the flow happens to still have shadow
 * `FlowRun` rows and someone remembers to look. The same report is also
 * returned on the mutation's response, for the confirmation screen.
 *
 * Review fix (AP-704 shadow-mode v2 hostile review, finding 2): also
 * freezes an `ImpactRecord` via `autopilot.impact_ledger
 * .freeze_impact_record`, the same "every route to live gets one" rule
 * `activate_flow` enforces for AP-703's routes -- this mutation not
 * calling `activate_flow` (see above) does not mean it gets to skip
 * that freeze too; without it a shadow-promoted flow was invisible in
 * the tenant Impact Ledger, could never accrue a `MeasuredOutcome`, and
 * was unrecognized by `rollback_flow`'s own gated check. Gated with
 * `gate_kind=ImpactRecord.GateKind.SHADOW` (AP-704) rather than
 * `OVERRIDE`: the accrued shadow report is neither a `SimulationRun`
 * nor a reasoned override, and mislabeling it as one would misrepresent
 * the audit trail (the Amir principle: never fabricate). `projected_
 * impact` is the same "unavailable" sentinel `activate_flow` defaults
 * to when AP-602's calculator has no real numbers to hand it (true here
 * too, as of this task). The promotion, the audit row, and the freeze
 * rise or fall together inside one `transaction.atomic()` block, the
 * same shape `activate_flow` already uses, for the same reason: a
 * failure freezing the ledger must not leave a Flow live-and-audited
 * with no frozen projection behind it.
 *
 * Wave 2 Lane D S3: this route now carries the same supersession
 * conflict gate as `ActivateAutopilotFlow` (it was the one ungated door
 * to LIVE for a converted flow): a still-firing non-GREEN source rule,
 * or a current trigger that has drifted away from the rule's
 * transition, is refused as a `sourceRuleConflict` error unless the
 * operator confirms via `disable_source_rule` -- confirming the former
 * force-suspends the rule atomically with the promotion, confirming the
 * latter goes live without touching the rule (see
 * `autopilot.services.legacy_rule_migration.SupersessionConflict`).
 * S5: the response also carries the same non-fatal legacy-origin
 * honesty `warnings` (`_legacy_origin_activation_warnings`).
 */
export type ActivateAutopilotFlowFromShadow = {
  __typename: 'ActivateAutopilotFlowFromShadow';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  flow?: Maybe<FlowType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  shadowReport?: Maybe<AutopilotShadowReportType>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * Wave 2 Lane E S5: the wizard's "turn on" step -- evidence-gated
 * batch activation of converted flows. Each row goes through ONE atomic
 * `activate_flow(gate_kind='simulation')` (a DRAFT row is promoted to
 * TEST inside the same per-row transaction first), so every row gets
 * the full gate: a recorded `SimulationRun` for the exact current
 * version (record it with `RecordAutopilotEstateSimulations` first; a
 * row without one is `skipped_no_evidence`, NEVER silently downgraded
 * to an override), registry re-validation, the supersession conflict
 * gate, the frozen impact record, and the ACTIVATED audit row -- which
 * this mutation stamps with `batchLabel` so the whole batch can be
 * found and rolled back as one unit (`DeactivateConvertedFlows`).
 *
 * Refusals are per row and honest, never batch-fatal: a
 * `SourceRuleConflictError` comes back as `skipped_needs_confirm` for
 * THAT rule's own one-click confirm on the single-flow route -- this
 * mutation NEVER passes `disable_source_rule`, because a blanket
 * batch-wide rule-kill confirmation would hide exactly the decision the
 * conflict gate exists to force. Approval-class flows (an
 * approval-required step in the definition) are refused unless
 * explicitly listed in `approvalOptIn`, with the pause forecast priced
 * from the recorded simulation's own fired count, because the rule they
 * replace acted immediately and a flow that pauses ~N times a month is
 * a real behavioural change to opt into, not a default.
 */
export type ActivateConvertedFlows = {
  __typename: 'ActivateConvertedFlows';
  activatedCount: Scalars['Int']['output'];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  results: Array<AutopilotEstateActivationResultType>;
};

export type ActivePriceDef = Node & {
  __typename: 'ActivePriceDef';
  amount: Scalars['Int']['output'];
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['Date']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  product: ProductDef;
  recurringInterval: CrmActivePriceViewRecurringIntervalChoices;
  startDate: Scalars['Date']['output'];
  weightAmount: Scalars['Int']['output'];
};

export type ActivePriceDefConnection = {
  __typename: 'ActivePriceDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ActivePriceDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ActivePriceDef` and its cursor. */
export type ActivePriceDefEdge = {
  __typename: 'ActivePriceDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ActivePriceDef>;
};

export type AddAssociatedTicketsToCompanyEmailAccountMessage = {
  __typename: 'AddAssociatedTicketsToCompanyEmailAccountMessage';
  companyEmailAccountMessage?: Maybe<CompanyEmailAccountMessageDef>;
};

export type AddCard = {
  __typename: 'AddCard';
  billingInformation?: Maybe<BillingInformationType>;
};

/**
 * Office-only (B1.3): add one custom non-driving day. Idempotent
 * per (company, date) — re-adding an already-active date just
 * refreshes its name rather than erroring or duplicating.
 */
export type AddCompanyHolidayDay = {
  __typename: 'AddCompanyHolidayDay';
  holidayDay?: Maybe<CompanyHolidayDayDef>;
};

export type AddContactToProperties = {
  __typename: 'AddContactToProperties';
  contact?: Maybe<ContactDef>;
};

export type AddContactToPropertyInput = {
  debtorNumber?: InputMaybe<Scalars['String']['input']>;
  propertyId: Scalars['ID']['input'];
  role: ContactRole;
};

/**
 * Office-only, audited: exclude one event from reliability with a
 * reason (D6). The event stays visible, flagged; it leaves the
 * denominator. Idempotent — re-adding refreshes the reason.
 */
export type AddReliabilityExclusion = {
  __typename: 'AddReliabilityExclusion';
  exclusion?: Maybe<ReliabilityExclusionType>;
  pickupOrder?: Maybe<PickUpOrderType>;
};

/**
 * Office-only, audited (R2-S12, R2-D19): book a manual one-off ± line
 * on a settlement period, with a mandatory reason. OPEN periods only —
 * the line flows into the settlement totals and freezes into the
 * snapshot when the period closes.
 */
export type AddSettlementAdjustment = {
  __typename: 'AddSettlementAdjustment';
  adjustment?: Maybe<SettlementAdjustmentType>;
  report?: Maybe<SettlementReportType>;
};

/** Correct a spare-part count at a warehouse (+/-N, reason, A1). */
export type AdjustSpareParts = {
  __typename: 'AdjustSpareParts';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Correct the count of an item type at a warehouse (ADR-0005):
 * one anonymous reason-coded ledger row, +N or -N. The recount tool
 * and the only non-ticket write path for warehouse counts; never
 * blocked by the current count - a disagreeing correction takes it
 * negative, and the negative renders red.
 */
export type AdjustStock = {
  __typename: 'AdjustStock';
  message?: Maybe<Scalars['String']['output']>;
  requiresConfirmation?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * RS-1501 one-click adoption: a normal draft scenario the
 * planner OWNS is branched from the exploration candidate. Adoption
 * is manual, never autonomous; nothing is solved or promoted here
 * (D37, D35).
 */
export type AdoptExplorationCandidateMutation = {
  __typename: 'AdoptExplorationCandidateMutation';
  scenario?: Maybe<ScenarioDef>;
};

export type AdoptFeatureConfigDrift = {
  __typename: 'AdoptFeatureConfigDrift';
  rule?: Maybe<FeatureConfigRuleType>;
};

/**
 * An agreement's ``billingPrice`` split the way the invoice will split
 * it — the same line-VAT rule, payer and rate
 * (``invoicing.services.agreement_vat``) — so the agreements table can
 * total VAT-exclusive, VAT and VAT-inclusive amounts that match the
 * invoice. Integer minor units, like ``billingPrice``;
 * ``net + vat == gross``.
 */
export type AgreementBillingVatDef = {
  __typename: 'AgreementBillingVatDef';
  gross: Scalars['Int']['output'];
  net: Scalars['Int']['output'];
  /** The VAT rate applied, in percent; 0 when the invoice charges this payer no VAT. */
  percentage: Scalars['Decimal']['output'];
  vat: Scalars['Int']['output'];
};

/**
 * One recorded back-dated change of an agreement (BRIDGE-9 retroactive
 * corrections): what changed, from which month, who recorded it and whether
 * the nightly pass has settled it (``settledAt``), with any skip note.
 */
export type AgreementChangeDef = {
  __typename: 'AgreementChangeDef';
  effectiveFrom: Scalars['Date']['output'];
  effectiveTo?: Maybe<Scalars['Date']['output']>;
  field: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  recordedAt: Scalars['DateTime']['output'];
  recordedByName?: Maybe<Scalars['String']['output']>;
  settledAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AgreementDef = Node & {
  __typename: 'AgreementDef';
  accessFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  accessFeeInterval?: Maybe<CrmAgreementAccessFeeIntervalChoices>;
  /** The live suspension covering today, if any. */
  activeSuspension?: Maybe<AgreementSuspensionDef>;
  agreements: IntegrationUrbaserCallResponseHistoryAgreementDefConnection;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<UserType>;
  archivedByRule?: Maybe<ArchivalRuleDef>;
  availableDates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  /** Back-dated changes recorded on this agreement (retroactive corrections), newest first. */
  backdatedChanges?: Maybe<Array<AgreementChangeDef>>;
  billingPrice?: Maybe<Scalars['Int']['output']>;
  billingSchedule?: Maybe<BillingScheduleDef>;
  /** billingPrice split into VAT-exclusive, VAT and VAT-inclusive amounts the way the invoice will split it. Null for legacy agreements, whose catalogue prices already include VAT. */
  billingVat?: Maybe<AgreementBillingVatDef>;
  coefficient?: Maybe<Scalars['Decimal']['output']>;
  company: CompanyType;
  container?: Maybe<ContainerType>;
  /** @deprecated use `product { productType, activePrice { ... } }` instead */
  containerPrice?: Maybe<AgreementDeprecatedPriceDef>;
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  /** The effective industry classification for this agreement: the per-agreement override when set, else the payer contact's default, else null. */
  effectiveIndustry?: Maybe<IndustryCodeDef>;
  endDate?: Maybe<Scalars['Date']['output']>;
  endedByTicket?: Maybe<TicketDef>;
  eventLog?: Maybe<AgreementEventLogEventWrapper>;
  excludeFromBilling: Scalars['Boolean']['output'];
  /** Contractor associated with this agreement. Empty = no contractor (the default for every normal agreement). */
  hauler?: Maybe<HaulerDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  industry?: Maybe<IndustryCodeDef>;
  industrySpecify: Scalars['String']['output'];
  invoice?: Maybe<InvoiceDef>;
  invoiceItems: InvoiceItemDefConnection;
  isActive: Scalars['Boolean']['output'];
  isCustomSplit: Scalars['Boolean']['output'];
  isEnded?: Maybe<Scalars['Boolean']['output']>;
  isFuture: Scalars['Boolean']['output'];
  /** True when this agreement is the one a skip rental runs under (started by a rental ticket); the same rows allAgreements(excludeRentalBacked: true) hides. */
  isRentalBacked: Scalars['Boolean']['output'];
  isSplit: Scalars['Boolean']['output'];
  /** True while a live suspension covers today. */
  isSuspended: Scalars['Boolean']['output'];
  kmdEasyFu51008FileLine: Fu51008FileLineDefConnection;
  kmdEasyFu63303FileLine: KmdEasyFileFu63303FileLineDefConnection;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  myShare?: Maybe<Scalars['Float']['output']>;
  nextTicket?: Maybe<TicketDef>;
  payerContact?: Maybe<ContactDef>;
  ppPrices?: Maybe<AgreementPpPricesDef>;
  ppProduct?: Maybe<PpProductDef>;
  /** The Products & Prices unit price this agreement bills at, at the company's price precision (companySettings.priceDecimalPlaces). Null for legacy agreements. */
  ppUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  prices?: Maybe<AgreementPricesDef>;
  product?: Maybe<ProductDef>;
  property: PropertyDef;
  quantity: Scalars['Int']['output'];
  /** @deprecated use `product { productType, activePrice { ... } }` instead */
  recurringPrice?: Maybe<AgreementDeprecatedPriceDef>;
  scpMembership?: Maybe<ScpMembershipDef>;
  searchUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  serviceResponsibility?: Maybe<ServiceResponsibilityDef>;
  shares?: Maybe<AgreementShareDefConnection>;
  startDate: Scalars['Date']['output'];
  startedByTicket?: Maybe<TicketDef>;
  /** Live (not cancelled) suspensions of this agreement, oldest first. Empty unless the company has agreement suspension enabled. */
  suspensions?: Maybe<Array<AgreementSuspensionDef>>;
  uniqueExternalId: Scalars['String']['output'];
  /** The next live suspension starting after today, if any. */
  upcomingSuspension?: Maybe<AgreementSuspensionDef>;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
  weight?: Maybe<Scalars['Decimal']['output']>;
};


export type AgreementDefAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AgreementDefAvailableDatesArgs = {
  periodEnd?: InputMaybe<Scalars['Date']['input']>;
  periodStart?: InputMaybe<Scalars['Date']['input']>;
};


export type AgreementDefEventLogArgs = {
  addAgreementEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addContainerEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addRecordLeaseEvents?: InputMaybe<Scalars['Boolean']['input']>;
  agreementEventTypes?: InputMaybe<Array<InputMaybe<AgreementEventTypesGraphene>>>;
  containerEventTypes?: InputMaybe<Array<InputMaybe<DeviceContainerEventTypesGraphene>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type AgreementDefInvoiceItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AgreementDefKmdEasyFu51008FileLineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AgreementDefKmdEasyFu63303FileLineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AgreementDefSharesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};

export type AgreementDefConnection = {
  __typename: 'AgreementDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AgreementDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AgreementDef` and its cursor. */
export type AgreementDefEdge = {
  __typename: 'AgreementDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AgreementDef>;
};

export type AgreementDeprecatedPriceDef = {
  __typename: 'AgreementDeprecatedPriceDef';
  amount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recurringInterval?: Maybe<Scalars['Int']['output']>;
};

export type AgreementEventDef = Node & {
  __typename: 'AgreementEventDef';
  agreement?: Maybe<AgreementDef>;
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<AgreementEventTypesGraphene>>>;
  fromAccessFeeAmount?: Maybe<Scalars['Float']['output']>;
  fromAccessFeeInterval?: Maybe<Scalars['String']['output']>;
  fromCoefficient?: Maybe<Scalars['Float']['output']>;
  fromEndDate?: Maybe<Scalars['Date']['output']>;
  fromExcludeFromBilling?: Maybe<Scalars['Boolean']['output']>;
  fromQuantity?: Maybe<Scalars['Int']['output']>;
  fromStartDate?: Maybe<Scalars['Date']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toAccessFeeAmount?: Maybe<Scalars['Float']['output']>;
  toAccessFeeInterval?: Maybe<Scalars['String']['output']>;
  toCoefficient?: Maybe<Scalars['Float']['output']>;
  toEndDate?: Maybe<Scalars['Date']['output']>;
  toExcludeFromBilling?: Maybe<Scalars['Boolean']['output']>;
  toQuantity?: Maybe<Scalars['Int']['output']>;
  toStartDate?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<UserType>;
};

export type AgreementEventLogEvent = AgreementEventDef | AgreementSuspensionEventDef | ContainerEventDef | RecordLeaseEventDef;

export type AgreementEventLogEventWrapper = {
  __typename: 'AgreementEventLogEventWrapper';
  edges?: Maybe<Array<Maybe<AgreementEventLogEvent>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum AgreementEventTypesGraphene {
  ACCESS_FEE_CHANGE = 'ACCESS_FEE_CHANGE',
  ARCHIVED_AT_CHANGE = 'ARCHIVED_AT_CHANGE',
  COEFFICIENT_CHANGE = 'COEFFICIENT_CHANGE',
  END_DATE_CHANGE = 'END_DATE_CHANGE',
  EXCLUDE_FROM_BILLING_CHANGE = 'EXCLUDE_FROM_BILLING_CHANGE',
  QUANTITY_CHANGE = 'QUANTITY_CHANGE',
  START_DATE_CHANGE = 'START_DATE_CHANGE',
  SUSPENSION_ADDED = 'SUSPENSION_ADDED',
  SUSPENSION_CANCELLED = 'SUSPENSION_CANCELLED'
}

export type AgreementExportDef = Node & {
  __typename: 'AgreementExportDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  exportFile?: Maybe<Scalars['String']['output']>;
  fromDate: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  mode: CrmAgreementExportModeChoices;
  modeChangeIncludeNew: Scalars['Boolean']['output'];
  modeChangeIncludeRemoved: Scalars['Boolean']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  toDate: Scalars['DateTime']['output'];
  totalObjects: Scalars['Int']['output'];
  totalObjectsCompleted: Scalars['Int']['output'];
};

export type AgreementExportDefConnection = {
  __typename: 'AgreementExportDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AgreementExportDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AgreementExportDef` and its cursor. */
export type AgreementExportDefEdge = {
  __typename: 'AgreementExportDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AgreementExportDef>;
};

/**
 * PRO-695: the Products & Prices change options for an agreement's
 * container — what ``AgreementPricesDef`` is for the legacy catalogue.
 */
export type AgreementPpPricesDef = {
  __typename: 'AgreementPpPricesDef';
  changeContainerType: Array<PpContainerOfferDef>;
  changePickupSetting: Array<PpContainerOfferDef>;
};

export type AgreementPricesChangeContainerTypeDef = {
  __typename: 'AgreementPricesChangeContainerTypeDef';
  containerType: ContainerTypeType;
  price: PriceDef;
};

export type AgreementPricesChangePickupSettingDef = {
  __typename: 'AgreementPricesChangePickupSettingDef';
  pickupSetting: PickupSettingsType;
  price: PriceDef;
};

export type AgreementPricesDef = {
  __typename: 'AgreementPricesDef';
  changeContainerType: Array<Maybe<AgreementPricesChangeContainerTypeDef>>;
  changePickupSetting: Array<Maybe<AgreementPricesChangePickupSettingDef>>;
};

export type AgreementShareDef = Node & {
  __typename: 'AgreementShareDef';
  agreement: AgreementDef;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  property: PropertyDef;
  share: Scalars['Decimal']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type AgreementShareDefConnection = {
  __typename: 'AgreementShareDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AgreementShareDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AgreementShareDef` and its cursor. */
export type AgreementShareDefEdge = {
  __typename: 'AgreementShareDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AgreementShareDef>;
};

/**
 * Per-container split share audit rows (QA-104). The INSERT is the
 * 'split set' event; the end_date update closes the previous slice.
 */
export type AgreementShareEventDef = Node & {
  __typename: 'AgreementShareEventDef';
  agreement?: Maybe<AgreementDef>;
  agreementShare?: Maybe<AgreementShareDef>;
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<AgreementShareEventTypesGraphene>>>;
  fromEndDate?: Maybe<Scalars['Date']['output']>;
  fromShare?: Maybe<Scalars['Float']['output']>;
  fromStartDate?: Maybe<Scalars['Date']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  property?: Maybe<PropertyDef>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toEndDate?: Maybe<Scalars['Date']['output']>;
  toShare?: Maybe<Scalars['Float']['output']>;
  toStartDate?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<UserType>;
};

export enum AgreementShareEventTypesGraphene {
  SPLIT_SHARE_ENDED = 'SPLIT_SHARE_ENDED',
  SPLIT_SHARE_SET = 'SPLIT_SHARE_SET'
}

export type AgreementShareInput = {
  propertyId: Scalars['ID']['input'];
  share: Scalars['Decimal']['input'];
};

/**
 * A keskeytys: the agreement's collections are paused for
 * ``[startDate, endDate]`` (both inclusive) while the agreement and its
 * base fee keep running (COMPASS-1773). ``cancelledAt`` set = no longer in
 * effect.
 */
export type AgreementSuspensionDef = Node & {
  __typename: 'AgreementSuspensionDef';
  agreement: AgreementDef;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<UserType>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  endDate: Scalars['Date']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Live and covering today (company time). */
  isActive: Scalars['Boolean']['output'];
  isCancelled: Scalars['Boolean']['output'];
  /** Live and starting after today. */
  isUpcoming: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
  /** How many already-planned stops recording the suspension took off routes (restored on cancellation where possible). */
  releasedStops: Scalars['Int']['output'];
  startDate: Scalars['Date']['output'];
};

export type AgreementSuspensionDefConnection = {
  __typename: 'AgreementSuspensionDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AgreementSuspensionDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AgreementSuspensionDef` and its cursor. */
export type AgreementSuspensionDefEdge = {
  __typename: 'AgreementSuspensionDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AgreementSuspensionDef>;
};

/**
 * A suspension (keskeytys) recorded or cancelled, in the agreement's
 * and the property's unified event logs (COMPASS-1773). One row of
 * ``crm.AgreementSuspension`` appears once per event it carries:
 * ``event_type`` says which (from the event-log annotation),
 * ``event_datetime`` when. ``id`` is therefore a composite of the row and
 * the event, not a relay node id — use ``suspension { id }`` for the
 * node.
 *
 * ``eventType`` is served as the camelCase wire value
 * (``suspensionAdded`` / ``suspensionCancelled`` — the
 * ``AgreementEventTypes`` VALUES), a list like the other members'
 * ``eventType`` so union consumers can treat it uniformly. This is the
 * contract the frontend was built against (COMPASS-1773).
 */
export type AgreementSuspensionEventDef = {
  __typename: 'AgreementSuspensionEventDef';
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<UserType>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  endDate: Scalars['Date']['output'];
  eventDatetime: Scalars['DateTime']['output'];
  /** One of suspensionAdded / suspensionCancelled (camelCase wire values). */
  eventType: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  startDate: Scalars['Date']['output'];
  suspension?: Maybe<AgreementSuspensionDef>;
  user?: Maybe<UserType>;
};

export type AgreementTemplateDef = Node & {
  __typename: 'AgreementTemplateDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  products: AgreementTemplateProductDefConnection;
  propertyType: PropertyTypeDef;
  version: Scalars['Int']['output'];
};


export type AgreementTemplateDefProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateDefConnection = {
  __typename: 'AgreementTemplateDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AgreementTemplateDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AgreementTemplateDef` and its cursor. */
export type AgreementTemplateDefEdge = {
  __typename: 'AgreementTemplateDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AgreementTemplateDef>;
};

export type AgreementTemplateProductDef = Node & {
  __typename: 'AgreementTemplateProductDef';
  agreementtemplateSet: AgreementTemplateDefConnection;
  company: CompanyType;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  pickupSetting?: Maybe<PickupSettingsType>;
  ppProduct?: Maybe<PpProductDef>;
  product?: Maybe<ProductDef>;
  quantity: Scalars['Int']['output'];
};


export type AgreementTemplateProductDefAgreementtemplateSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateProductDefConnection = {
  __typename: 'AgreementTemplateProductDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AgreementTemplateProductDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AgreementTemplateProductDef` and its cursor. */
export type AgreementTemplateProductDefEdge = {
  __typename: 'AgreementTemplateProductDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AgreementTemplateProductDef>;
};

export type AgreementTemplateProductMultipleChoiceFieldInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  pickupSetting?: InputMaybe<Scalars['ID']['input']>;
  ppProduct?: InputMaybe<Scalars['ID']['input']>;
  product?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
};

export type AlertDef = Node & {
  __typename: 'AlertDef';
  alertRule: AlertRuleDef;
  alerteventSet: AlertEventDefConnection;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  closedBy?: Maybe<UserType>;
  company: CompanyType;
  container: ContainerType;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};


export type AlertDefAlerteventSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertDefConnection = {
  __typename: 'AlertDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AlertDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AlertDef` and its cursor. */
export type AlertDefEdge = {
  __typename: 'AlertDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AlertDef>;
};

export type AlertEventDef = Node & {
  __typename: 'AlertEventDef';
  alert: AlertDef;
  alertRecipient: AlertRecipientDef;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  type: AlertsAlertEventTypeChoices;
};

export type AlertEventDefConnection = {
  __typename: 'AlertEventDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AlertEventDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AlertEventDef` and its cursor. */
export type AlertEventDefEdge = {
  __typename: 'AlertEventDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AlertEventDef>;
};

/** An enumeration. */
export enum AlertEventTypeChoices {
  CLOSED = 'CLOSED',
  NEW = 'NEW',
  OPEN = 'OPEN'
}

export type AlertRecipientDef = Node & {
  __typename: 'AlertRecipientDef';
  alertEventType?: Maybe<Array<AlertEventTypeChoices>>;
  alerteventSet: AlertEventDefConnection;
  alertruleSet: AlertRuleDefConnection;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  team?: Maybe<TeamType>;
  user?: Maybe<UserType>;
};


export type AlertRecipientDefAlerteventSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AlertRecipientDefAlertruleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertRecipientDefConnection = {
  __typename: 'AlertRecipientDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AlertRecipientDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AlertRecipientDef` and its cursor. */
export type AlertRecipientDefEdge = {
  __typename: 'AlertRecipientDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AlertRecipientDef>;
};

export type AlertRuleAlertRecipientMultipleChoiceFieldInput = {
  alertEventType: Array<AlertEventTypeChoices>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type AlertRuleDef = Node & {
  __typename: 'AlertRuleDef';
  alertRecipients?: Maybe<Array<Maybe<AlertRecipientDef>>>;
  alertSet: AlertDefConnection;
  company?: Maybe<CompanyType>;
  containerTypes?: Maybe<Array<Maybe<ContainerTypeType>>>;
  containers?: Maybe<Array<Maybe<ContainerType>>>;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  intervalCount: Scalars['Int']['output'];
  intervalType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentageThreshold?: Maybe<Scalars['String']['output']>;
  wasteFractions?: Maybe<Array<Maybe<WasteFractionType>>>;
};


export type AlertRuleDefAlertSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertRuleDefConnection = {
  __typename: 'AlertRuleDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AlertRuleDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AlertRuleDef` and its cursor. */
export type AlertRuleDefEdge = {
  __typename: 'AlertRuleDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AlertRuleDef>;
};

/** An enumeration. */
export enum AlertsAlertEventTypeChoices {
  /** Closed */
  CLOSED = 'CLOSED',
  /** New */
  NEW = 'NEW',
  /** Open */
  OPEN = 'OPEN'
}

/**
 *
 *     Types that can be used in ExportTemplate data dict
 *     Database value should represent model name
 *
 */
export enum AllExportTypes {
  ACTIVE_PRICE = 'ACTIVE_PRICE',
  AGREEMENT = 'AGREEMENT',
  AREA = 'AREA',
  COLLECTION_CALENDAR = 'COLLECTION_CALENDAR',
  COLLECTION_CALENDAR_DATE = 'COLLECTION_CALENDAR_DATE',
  COMPANY = 'COMPANY',
  CONTACT = 'CONTACT',
  CONTAINER = 'CONTAINER',
  CONTAINER_GROUP = 'CONTAINER_GROUP',
  CONTAINER_TYPE = 'CONTAINER_TYPE',
  DEPOT = 'DEPOT',
  DRIVER = 'DRIVER',
  HAULER_PRICE = 'HAULER_PRICE',
  IOUSER = 'IOUSER',
  LOCATION = 'LOCATION',
  PICKUP_ORDER = 'PICKUP_ORDER',
  PICKUP_SETTINGS = 'PICKUP_SETTINGS',
  PRODUCT = 'PRODUCT',
  PROJECT = 'PROJECT',
  PROPERTY = 'PROPERTY',
  PROPERTY_CONTACT = 'PROPERTY_CONTACT',
  PROPERTY_GROUP = 'PROPERTY_GROUP',
  PROPERTY_MANAGEMENT_COMPANY = 'PROPERTY_MANAGEMENT_COMPANY',
  PROPERTY_TYPE = 'PROPERTY_TYPE',
  ROUTE = 'ROUTE',
  ROUTEVEHICLE = 'ROUTEVEHICLE',
  ROUTE_SCHEME = 'ROUTE_SCHEME',
  SERVICE = 'SERVICE',
  TICKET = 'TICKET',
  TICKET_TYPE = 'TICKET_TYPE',
  VEHICLE = 'VEHICLE',
  VEHICLE_SIZE = 'VEHICLE_SIZE',
  VEHICLE_TYPE = 'VEHICLE_TYPE',
  WASTE_FRACTION = 'WASTE_FRACTION',
  WASTE_STATION = 'WASTE_STATION',
  WEEK = 'WEEK'
}

/**
 * One analyst exchange (W5.2): prose + engine-computed artefacts.
 *
 * ``charts`` are validated ChartSpecs from propose_chart; ``lineage``
 * carries the trust chips of every run_metric_query the answer rests
 * on; ``tool_trace`` is the structured funnel record the W5.6 eval
 * scorer reads.
 */
export type AnalystAnswerResult = {
  __typename: 'AnalystAnswerResult';
  answer?: Maybe<Scalars['String']['output']>;
  charts?: Maybe<Array<Maybe<Scalars['GenericScalar']['output']>>>;
  error?: Maybe<Scalars['String']['output']>;
  figures?: Maybe<Scalars['GenericScalar']['output']>;
  grounding?: Maybe<Scalars['GenericScalar']['output']>;
  lineage?: Maybe<Array<Maybe<Scalars['GenericScalar']['output']>>>;
  recordToken?: Maybe<Scalars['String']['output']>;
  sessionState?: Maybe<Scalars['GenericScalar']['output']>;
  suggestions?: Maybe<Array<Maybe<Scalars['GenericScalar']['output']>>>;
  toolTrace?: Maybe<Array<Maybe<Scalars['GenericScalar']['output']>>>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * RS-1604 conversational analytics answer (D44): read-only,
 * numeral-checked, with evidence links naming the artifacts read.
 */
export type AnalyticsAnswerDef = {
  __typename: 'AnalyticsAnswerDef';
  /** [{tool, arguments, artifacts}] per read. */
  evidence?: Maybe<Scalars['GenericScalar']['output']>;
  modelId?: Maybe<Scalars['String']['output']>;
  numeralCheck?: Maybe<Scalars['GenericScalar']['output']>;
  status: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/** An enumeration. */
export enum AnalyticsComparisonSettingsAmountOfCollectionPeriodChoices {
  A = 'A_',
  /** day */
  DAY = 'DAY',
  /** month */
  MONTH = 'MONTH',
  /** week */
  WEEK = 'WEEK',
  /** year */
  YEAR = 'YEAR'
}

/** An enumeration. */
export enum AnalyticsCostSettingsAmountOfCollectionPeriodChoices {
  A = 'A_',
  /** day */
  DAY = 'DAY',
  /** month */
  MONTH = 'MONTH',
  /** week */
  WEEK = 'WEEK',
  /** year */
  YEAR = 'YEAR'
}

export type AnalyticsCount = {
  __typename: 'AnalyticsCount';
  count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsType = {
  __typename: 'AnalyticsType';
  containerLogs_FillPercentage?: Maybe<ContainerLogAnalyticsType>;
  containers_BatteryPercentage?: Maybe<ContainerAnalyticsType>;
  containers_Efficient?: Maybe<Scalars['Float']['output']>;
  containers_FillPercentage?: Maybe<ContainerAnalyticsType>;
  containers_FillingFrequency?: Maybe<ContainerAnalyticsType>;
  containers_Status?: Maybe<ContainerAnalyticsType>;
  containers_TotalVolume?: Maybe<Scalars['Float']['output']>;
  containers_TotalWeight?: Maybe<Scalars['Float']['output']>;
  heatMapWeight?: Maybe<Array<Maybe<ObjectAnalyticsHeatMapType>>>;
  routes_Status?: Maybe<RouteAnalyticsType>;
  timeSeriesWeight?: Maybe<Array<Maybe<ObjectAnalyticsTimeSeriesType>>>;
  totalDistance?: Maybe<Scalars['Float']['output']>;
  vehicles_Status?: Maybe<VehicleAnalyticsType>;
};


export type AnalyticsTypeContainerLogs_FillPercentageArgs = {
  From?: InputMaybe<Scalars['DateTime']['input']>;
  To?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsTypeContainers_BatteryPercentageArgs = {
  From?: InputMaybe<Scalars['DateTime']['input']>;
  To?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsTypeContainers_FillPercentageArgs = {
  From?: InputMaybe<Scalars['DateTime']['input']>;
  To?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};


export type AnalyticsTypeContainers_FillingFrequencyArgs = {
  From?: InputMaybe<Scalars['DateTime']['input']>;
  To?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsTypeContainers_StatusArgs = {
  status: Scalars['String']['input'];
};


export type AnalyticsTypeContainers_TotalVolumeArgs = {
  From: Scalars['DateTime']['input'];
  To: Scalars['DateTime']['input'];
};


export type AnalyticsTypeContainers_TotalWeightArgs = {
  From: Scalars['DateTime']['input'];
  To: Scalars['DateTime']['input'];
};


export type AnalyticsTypeHeatMapWeightArgs = {
  From?: InputMaybe<Scalars['DateTime']['input']>;
  To?: InputMaybe<Scalars['DateTime']['input']>;
};


export type AnalyticsTypeRoutes_StatusArgs = {
  From: Scalars['DateTime']['input'];
  To: Scalars['DateTime']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type AnalyticsTypeTimeSeriesWeightArgs = {
  From?: InputMaybe<Scalars['DateTime']['input']>;
  To?: InputMaybe<Scalars['DateTime']['input']>;
};


export type AnalyticsTypeVehicles_StatusArgs = {
  status: Scalars['String']['input'];
};

/**
 * Answer or explicitly defer a case question (stage D): a
 * deferred question is a visible open risk, never an invisible
 * default (D62, D63).
 */
export type AnswerCaseQuestionMutation = {
  __typename: 'AnswerCaseQuestionMutation';
  caseQuestion?: Maybe<CaseQuestionDef>;
};

/**
 * RS-1101/RS-1102 + RS-E11 (wave 2): apply the day's need-based
 * selection. The interactive tier sequences the selected units into
 * today's slack route (overlay, unchanged), and the accepted
 * insertions are materialized as real stops
 * (``created_from=dynamic``) on TODAY's live route through
 * ``services.live_dispatch``, so the driver app sees them today.
 * D35 gates, all hard: explicit human apply only, L3 (Guarded
 * Autopilot) areas only, audited
 * (``route_studio.dynamic_day.applied``). SBX-537 P1-1 (wave D23):
 * the explicit human is a MASTER; materializing stops onto today's
 * live route is the sharpest live-operations act on the surface
 * (RS-2009), and combined with the ungated autonomy dial any
 * assigned user could previously self-escalate an area to L3 and
 * inject stops the driver app saw the same day. Hygiene-bound
 * fractions were never selected (calendar keeps, by construction);
 * the plan artifact, its calendar entries and every container
 * calendar stay byte-identical.
 */
export type ApplyDynamicDayMutation = {
  __typename: 'ApplyDynamicDayMutation';
  dynamicDayRun?: Maybe<DynamicDayRunDef>;
};

/**
 * Match an uploaded bank statement against outstanding invoices and
 * REGISTER the confident matches through the S1-M5 payment service
 * (``register_invoice_payment``) — invoices flip PAID exactly when
 * covered. HAUL-919 v1's apply half.
 *
 * Nothing is transmitted: the file came from the operator and the only
 * output is the inert reconciliation report. Each line is independent and
 * the service guards the running total, so re-uploading the same statement
 * lands matched lines on "already paid" / "exceeds outstanding" — never a
 * double charge. No second payment path exists (INV-B): this is a matcher
 * on top of the one payment service.
 */
export type ApplyHaulerBankReconciliation = {
  __typename: 'ApplyHaulerBankReconciliation';
  result?: Maybe<HaulerBankReconciliationDef>;
};

/**
 * REQ 3.3.25: apply an index (CPI/fuel) percentage to a hauler's active
 * prices — computed from the ORIGINAL contract price (``appliedTo: BASE``)
 * or the CURRENT amount (``appliedTo: CURRENT``), the user's choice.
 * Superseding rows carry ``base_amount`` forward; it is never mutated.
 * ``dryRun: true`` previews without writing.
 */
export type ApplyHaulerPriceIndexAdjustment = {
  __typename: 'ApplyHaulerPriceIndexAdjustment';
  affectedEventCount?: Maybe<Scalars['Int']['output']>;
  haulerPrices?: Maybe<Array<Maybe<HaulerPriceDef>>>;
  preview?: Maybe<Array<Maybe<HaulerPriceMassChangePreviewType>>>;
  skippedCount?: Maybe<Scalars['Int']['output']>;
  skippedNoActiveCount?: Maybe<Scalars['Int']['output']>;
  skippedNoActivePpProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  skippedNoActiveProductIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  updatedCount?: Maybe<Scalars['Int']['output']>;
};

export type ApplyTemplatePayload = {
  __typename: 'ApplyTemplatePayload';
  automation: AutomationDef;
};

/**
 * 3.9.23 decision 7 (bulk-migrate): stamp a type's CURRENT visibility
 * scope onto its existing tickets. Overridden tickets (3.9.6) survive.
 *
 * Payload is a bare ``ok`` — progress surfaces through the existing
 * ``UserJobsNotification`` jobs feed (``BulkActionProgress`` is created
 * INSIDE the celery task); no progress handle exists at this layer.
 */
export type ApplyTicketTypeVisibilityToTickets = {
  __typename: 'ApplyTicketTypeVisibilityToTickets';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type ApprovalCountsDef = {
  __typename: 'ApprovalCountsDef';
  overdue: Scalars['Int']['output'];
  pendingForMe: Scalars['Int']['output'];
  pendingForMyTeams: Scalars['Int']['output'];
  pendingTotal: Scalars['Int']['output'];
};

export type ApprovalDef = {
  __typename: 'ApprovalDef';
  actionKey?: Maybe<Scalars['String']['output']>;
  actionKind?: Maybe<Scalars['String']['output']>;
  assigneeTeam?: Maybe<TeamType>;
  assigneeUser?: Maybe<UserType>;
  canDecide: Scalars['Boolean']['output'];
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  decidedBy?: Maybe<UserType>;
  decisionNote?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  nodeKey: Scalars['String']['output'];
  preview: Scalars['JSONString']['output'];
  previewHash: Scalars['String']['output'];
  remindedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedAt: Scalars['DateTime']['output'];
  run?: Maybe<RunDef>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subjectId?: Maybe<Scalars['ID']['output']>;
  subjectLabel?: Maybe<Scalars['String']['output']>;
  subjectLinkPath?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  summaryText: Scalars['String']['output'];
};

export type ApprovalDefConnection = {
  __typename: 'ApprovalDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ApprovalDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ApprovalDef` and its cursor. */
export type ApprovalDefEdge = {
  __typename: 'ApprovalDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ApprovalDef>;
};

/**
 * Office-only, FOUR-EYES (PRO-465): a SECOND permission holder approves a
 * draft entry so it lands in settlement. The creator can NEVER approve their
 * own entry — refused at the API level, not just hidden in the client.
 */
export type ApproveContractorManualEntry = {
  __typename: 'ApproveContractorManualEntry';
  entry?: Maybe<ContractorManualEntryType>;
};

/**
 * The D42 gate: a human approves every document before it leaves
 * the system. Draft to approved, stamped, one way.
 */
export type ApproveNarrativeDocumentMutation = {
  __typename: 'ApproveNarrativeDocumentMutation';
  narrativeDocument?: Maybe<NarrativeDocumentDef>;
};

/**
 * The D18 approval step; blocked without a notification plan
 * (F11: promotion cannot complete with notifications unresolved).
 * SBX-370: when the diff's cross-area conflict count is nonzero,
 * approval additionally requires the explicit
 * ``acknowledgeConflicts`` flag; taking over another area's
 * containers is a human call (D18/D32), never a side effect.
 * SBX-376: when the stop-set churn exceeds the warn threshold
 * (snapshot age + containers added/removed/moved since), approval
 * requires the explicit ``acknowledgeChurn`` flag, same pattern.
 * SBX-368: with the company's optional two-step chain ON
 * (``CompanySettings.route_studio_two_step_approval``), a
 * non-designated user's call records a PROPOSAL (state
 * ``proposed``, audited event) and a designated approver
 * (``access.is_designated_approver``: master for now, the
 * CompanyRolePermission seam) must call again for the final
 * approval; execute always requires that final approval.
 */
export type ApprovePromotionMutation = {
  __typename: 'ApprovePromotionMutation';
  promotion?: Maybe<PromotionDef>;
};

/**
 * REQ-267 approval: creates the previewed follow-up tickets.
 * Idempotent — a second approval creates nothing new.
 */
export type ApproveTicketBatch = {
  __typename: 'ApproveTicketBatch';
  createdTicketIds?: Maybe<Scalars['GenericScalar']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum ArchivableDataType {
  AGREEMENT = 'AGREEMENT',
  CONTACT = 'CONTACT',
  CONTAINER = 'CONTAINER',
  PROPERTY = 'PROPERTY',
  ROUTE = 'ROUTE',
  TICKET = 'TICKET'
}

/**
 * Registry entry — drives the FE rule form (which types exist, which
 * timestamp fields each may condition on).
 */
export type ArchivableDataTypeDef = {
  __typename: 'ArchivableDataTypeDef';
  dataType: Scalars['String']['output'];
  timestampFields: Array<Scalars['String']['output']>;
};

export type ArchivalRuleDef = {
  __typename: 'ArchivalRuleDef';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  dataType: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastArchivedCount: Scalars['Int']['output'];
  lastEvaluatedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  olderThanDays: Scalars['Int']['output'];
  retentionDays?: Maybe<Scalars['Int']['output']>;
  timestampField: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ArchiveAutomationPayload = {
  __typename: 'ArchiveAutomationPayload';
  automation: AutomationDef;
};

export type ArchiveBillingRun = {
  __typename: 'ArchiveBillingRun';
  billingRun?: Maybe<BillingRunDef>;
};

export type ArchiveProduct = {
  __typename: 'ArchiveProduct';
  product?: Maybe<ProductDef>;
};

/**
 * Manually archive (``archive: true``) or restore (``archive: false``)
 * one record. The generic counterpart of ``archiveProduct`` — restoring
 * just clears the archive metadata, so the record returns to its exact
 * pre-archiving state.
 */
export type ArchiveRecord = {
  __typename: 'ArchiveRecord';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type ArchiveScenarioMutation = {
  __typename: 'ArchiveScenarioMutation';
  scenario?: Maybe<ScenarioDef>;
};

/**
 * Manually trigger an ACOS archive POST for a ticket + document_type.
 *
 * Validates that the caller is permitted to edit tickets in the company
 * and that an `AcosTicketTypeMapping` exists for the (ticket_type,
 * document_type) pair. Schedules `archive_ticket_to_acos.delay(...)` via
 * `transaction.on_commit` and returns the freshly-created log row.
 */
export type ArchiveTicketToAcos = {
  __typename: 'ArchiveTicketToAcos';
  archiveLog?: Maybe<AcosArchiveLogDef>;
};

/** One row in the cross-entity archive browser. */
export type ArchivedRecordDef = {
  __typename: 'ArchivedRecordDef';
  archivalRuleId?: Maybe<Scalars['ID']['output']>;
  archivalRuleName?: Maybe<Scalars['String']['output']>;
  archivedAt: Scalars['DateTime']['output'];
  archivedBy?: Maybe<Scalars['String']['output']>;
  dataType: Scalars['String']['output'];
  label: Scalars['String']['output'];
  recordId: Scalars['ID']['output'];
};

export type ArchivedRecordsPageDef = {
  __typename: 'ArchivedRecordsPageDef';
  records: Array<ArchivedRecordDef>;
  totalCount: Scalars['Int']['output'];
};

/**
 * lane-B (PRO-96/PRO-100): one entry of the contract area's merged
 * change history (stored change-log rows + price-change audit rows +
 * transfer audit rows — see ``routes.selectors.area_changelog``). Plain
 * ObjectType: rows are read-time merges, never a Django model 1:1.
 */
export type AreaChangeLogEntryDef = {
  __typename: 'AreaChangeLogEntryDef';
  /** Who did it — null for system/derived events. */
  actorName?: Maybe<Scalars['String']['output']>;
  /** Structured field diffs: [{"field","old","new"}]. */
  changes?: Maybe<Scalars['GenericScalar']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Event-specific context (ids with names, reasons). */
  payload?: Maybe<Scalars['GenericScalar']['output']>;
};

export type AreaDef = Node & {
  __typename: 'AreaDef';
  allContainerTypes?: Maybe<Scalars['Boolean']['output']>;
  allWasteFractions?: Maybe<Scalars['Boolean']['output']>;
  /** Attach new agreements matching this area's scope automatically while the area is in force. */
  autoAttachAgreements: Scalars['Boolean']['output'];
  /** Contract area this bonus model governs (D7). NULL = a contractor-wide (with hauler) or company-wide (both NULL) model. */
  bonusModels: BonusModelTypeConnection;
  boundaryGeojson?: Maybe<Scalars['String']['output']>;
  /** "ZONES", "IMPORTED" or null. */
  boundarySource?: Maybe<Scalars['String']['output']>;
  carveOutOf?: Maybe<AreaDef>;
  carveOuts?: Maybe<Array<AreaDef>>;
  /** The area's merged change history, newest first (capped at 500): creation, edits, lifecycle, agreements, zones, price changes, transfers. Office-only. */
  changeLog?: Maybe<Array<AreaChangeLogEntryDef>>;
  changeLogEntries: Array<AreaExpiringEventDef>;
  /** Stable per-company identifier ("CA-0001"), auto-assigned at creation. */
  code?: Maybe<Scalars['String']['output']>;
  /** Limit the deviation to properties in these areas. */
  collectionDeviations: CollectionCalendarDeviationDefConnection;
  company: CompanyType;
  completionRadiusMeters?: Maybe<Scalars['Int']['output']>;
  containerTypes?: Maybe<Array<Maybe<ContainerTypeType>>>;
  contractDocuments: ContractAreaDocumentDefConnection;
  /** Date the contract was signed (office-entered). */
  contractSignedDate?: Maybe<Scalars['Date']['output']>;
  /** Contract area this task belongs to (the tender contract link). Stamped at creation from the container's agreement/property evidence and kept for historical billing. */
  contractTasks: PickUpOrderTypeConnection;
  createdAt: Scalars['DateTime']['output'];
  defaultCostCentreCode?: Maybe<Scalars['String']['output']>;
  /**
   * Fallback cost centre (invoicing CostCentre ULID) stamped on charges
   * from this area when no accounting routing rule matches (R3-S4).
   */
  defaultCostCentreId?: Maybe<Scalars['String']['output']>;
  defaultCostCentreName?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  effectiveExpiringLeadMonths?: Maybe<Scalars['Int']['output']>;
  /** Resolved policy after inheritance (mirrors effectiveExpiringLeadMonths). */
  effectiveHolidayPolicy: Scalars['String']['output'];
  /** Resolved spread-days after inheritance. */
  effectiveHolidaySpreadDays: Scalars['Int']['output'];
  /** HSY-258: resolved permitted operating weekdays — the override, else the company's, else null (nothing entered). */
  effectiveOperatingWeekdays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Agreements excluded from this area. Office-only. */
  excludedAgreements?: Maybe<Array<AreaExcludedAgreementDef>>;
  /** Areas that keep collecting during the period. */
  excludedFromCollectionDeviations: CollectionCalendarDeviationDefConnection;
  /** Months before the end date at which the area counts as Expiring. Empty = the platform default (12). */
  expiringLeadMonths?: Maybe<Scalars['Int']['output']>;
  hasHistory?: Maybe<Scalars['Boolean']['output']>;
  /** Contractor this area is awarded to. NULL = legacy/unassigned area. SET_NULL so a (soft-deletable) hauler removal never blocks the delete nor cascades away an area referenced by millions of pickup orders — the area just falls back to unassigned. */
  hauler?: Maybe<HaulerDef>;
  haulerpriceSet: HaulerPriceDefConnection;
  haulerpricechangelogSet: HaulerPriceChangeLogDefConnection;
  /** Override of the company's holiday collection policy for this contract area. Empty = inherit the company default. String token, same choice set as CompanySettings.holiday_collection_policy. */
  holidayPolicy?: Maybe<Scalars['String']['output']>;
  /** Override of the company's spread-policy day count for this contract area. Empty = inherit the company default. */
  holidaySpreadDays?: Maybe<Scalars['Int']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isInForce?: Maybe<Scalars['Boolean']['output']>;
  /** Optional contract area. NULL = a contractor-level entry. */
  manualEntries: ContractorManualEntryTypeConnection;
  /** Contract area the measured quantity was recorded for. */
  manualMeteredQuantities: HaulerManualMeteredQuantityTypeConnection;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Office-internal notes. Never exposed to contractor users. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Key contractual obligations (office-internal — the baseline the KPIs are read against). Never exposed to contractor users. */
  obligations?: Maybe<Scalars['String']['output']>;
  /** Override of the company's permitted collection weekdays for this contract area (mon..sun). Empty = inherit. */
  operatingWeekdays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Payment terms of this contract, in days (e.g. 21). Numeric on purpose: the hauler-level free-text payment_terms stays the vendor-card default; this is the per-contract term. */
  paymentTermsDays?: Maybe<Scalars['Int']['output']>;
  /** Agreements matching this area's scope that are neither attached nor excluded — the auto-attach queue (computed, never a maintained table). Office-only. */
  pendingAgreements?: Maybe<Array<ContractScopeProductDef>>;
  pickuporderSet: PickUpOrderTypeConnection;
  /** Area this one was transferred to. Set by the future transfer flow; read-only in v1. */
  predecessors: AreaDefConnection;
  products?: Maybe<Array<AreaProductInfo>>;
  productsCount?: Maybe<Scalars['Int']['output']>;
  propertySet: PropertyDefConnection;
  /** Contract reference (office-entered). */
  reference?: Maybe<Scalars['String']['output']>;
  scheduleonrouteactionSet: ScheduleOnRouteActionDefConnection;
  settlementPeriods: SettlementPeriodTypeConnection;
  /** Derived lifecycle status: DRAFT, UPCOMING, ACTIVE, EXPIRING, EXPIRED or TERMINATED. */
  status?: Maybe<Scalars['String']['output']>;
  /** Area this one was transferred to. Set by the future transfer flow; read-only in v1. */
  successor?: Maybe<AreaDef>;
  /** When the termination was executed. */
  terminatedAt?: Maybe<Scalars['DateTime']['output']>;
  terminatedByName?: Maybe<Scalars['String']['output']>;
  /** Last effective day of the contract after a manual termination. NULL = never terminated. Set only by the terminate action. */
  terminatedOn?: Maybe<Scalars['Date']['output']>;
  /** Mandatory internal comment recorded with the termination. */
  terminationComment?: Maybe<Scalars['String']['output']>;
  /** Why the contract was terminated (office-internal). */
  terminationReason?: Maybe<Scalars['String']['output']>;
  /** The contract area this window applies in. */
  ticketTypeExecutionWindows: TicketTypeAreaExecutionWindowDefConnection;
  transferredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Contract-area validity start. Required on write when a hauler is assigned; stays NULL on legacy areas. */
  validFrom?: Maybe<Scalars['Date']['output']>;
  /** Contract-area validity end. NULL = open-ended. */
  validTo?: Maybe<Scalars['Date']['output']>;
  /** The service area this wash list plans (§6.7 step 1). */
  washLists: WashListDefConnection;
  wasteFractions?: Maybe<Array<Maybe<WasteFractionType>>>;
  zones?: Maybe<Array<AreaZoneInfo>>;
};


export type AreaDefBonusModelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AreaDefCollectionDeviationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AreaDefContractDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AreaDefContractTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AreaDefExcludedFromCollectionDeviationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AreaDefHaulerpriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AreaDefHaulerpricechangelogSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AreaDefManualEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AreaDefManualMeteredQuantitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AreaDefPickuporderSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AreaDefPredecessorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AreaDefPropertySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AreaDefScheduleonrouteactionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AreaDefSettlementPeriodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AreaDefTicketTypeExecutionWindowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ticketType?: InputMaybe<Scalars['ID']['input']>;
};


export type AreaDefWashListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AreaDefConnection = {
  __typename: 'AreaDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AreaDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AreaDef` and its cursor. */
export type AreaDefEdge = {
  __typename: 'AreaDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AreaDef>;
};

/**
 * lane-B (PRO-118): one agreement the office excluded from a contract
 * area — visible and reversible.
 */
export type AreaExcludedAgreementDef = {
  __typename: 'AreaExcludedAgreementDef';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productCode?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

/**
 * A contract area that entered its renewal window (Expiring), as the
 * ``event`` of a bell-icon UserNotification (PRO-221, a member of the
 * notifications event union). The row is the lifecycle sweep's LIFECYCLE
 * change-log entry (``routes.AreaChangeLog``); it carries the area's
 * name/code and expiry date so the card can read "Contract area X enters
 * its renewal window — expires DATE" and deep-link to the area detail.
 *
 * Only reachable through the owner's own notifications (no root query
 * field, no Node interface) — the same exposure as StockAlertEventDef.
 */
export type AreaExpiringEventDef = {
  __typename: 'AreaExpiringEventDef';
  areaCode?: Maybe<Scalars['String']['output']>;
  areaId?: Maybe<Scalars['ID']['output']>;
  areaName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expiresOn?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
};

/**
 * A P&P product attached to a contract area — the raw ULID plus its
 * catalog name resolved from ``pp_products`` (Area stores only the reference).
 */
export type AreaProductInfo = {
  __typename: 'AreaProductInfo';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A P&P zone attached to a contract area — ULID + name from ``pp_zones``. */
export type AreaZoneInfo = {
  __typename: 'AreaZoneInfo';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * SBX-361 / RS-2013 item (b), the human door (D35, D18): bulk
 * assign needs-assignment containers (see the nightly report on the
 * promotion's ``materializationLog.needs_assignment``) into the
 * LIVE promotion's scheme, each onto the scheme's nearest-cohort
 * collection calendar, through the platform's own setters. Per-row
 * honest skips ride the returned report; nothing is ever assigned
 * without this explicit call.
 */
export type AssignContainersToPromotedSchemeMutation = {
  __typename: 'AssignContainersToPromotedSchemeMutation';
  promotion?: Maybe<PromotionDef>;
  report?: Maybe<Scalars['GenericScalar']['output']>;
};

export type AssignCustomerFunctionsToContact = {
  __typename: 'AssignCustomerFunctionsToContact';
  contact?: Maybe<ContactDef>;
};

/** Update a key's customer refs / handover fields (AC1/AC4). */
export type AssignKey = {
  __typename: 'AssignKey';
  physicalKey?: Maybe<PhysicalKeyType>;
};

/** Assign a role to an SCP membership from an optional start date. */
export type AssignScpMembershipRole = {
  __typename: 'AssignScpMembershipRole';
  membershipRole?: Maybe<ScpMembershipRoleDef>;
};

export type AssignTicket = {
  __typename: 'AssignTicket';
  ticket?: Maybe<TicketDef>;
};

/**
 * PRO-824 (HSY req 147): hand a ticket to a third-party contractor.
 *
 * Omitting ``hauler_id`` (or passing null) takes the hand-over back, and
 * the ticket returns to the derived contract-area attribution.
 *
 * This is a SHARING action, not just a label: ``service_provider`` is a
 * disjunct of ``hauler_ticket_scope_q``, so the named contractor gains
 * the ticket in their own list. Two things bound that grant — the hauler
 * must belong to the ticket's company (checked in
 * ``Ticket.set_service_provider``), and ``Ticket.visible_to`` still
 * composes BEFORE the hauler scope on every read path, so handing over a
 * visibility-restricted ticket does not by itself expose it.
 *
 * Authorization mirrors ``AssignTicket`` / ``SetTicketDeadline``
 * (login + company scope + visibility scope + the 3.12.5 edit lease),
 * plus the office wall: a contractor account must not be able to pass
 * work to another contractor. ``assert_office_user`` is explicitly only
 * half a gate (see its docstring) — the other half here is that the
 * fetch is already narrowed to tickets this caller can see.
 */
export type AssignTicketServiceProvider = {
  __typename: 'AssignTicketServiceProvider';
  ticket?: Maybe<TicketDef>;
};

export type AssignTicketToTeam = {
  __typename: 'AssignTicketToTeam';
  ticket?: Maybe<TicketDef>;
};

export type AssignToTeamActionDef = Node & {
  __typename: 'AssignToTeamActionDef';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  rule: AutopilotLegacyRuleType;
  team: TeamType;
};

export type AssignToTeamActionDefConnection = {
  __typename: 'AssignToTeamActionDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AssignToTeamActionDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AssignToTeamActionDef` and its cursor. */
export type AssignToTeamActionDefEdge = {
  __typename: 'AssignToTeamActionDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AssignToTeamActionDef>;
};

export type AssignToTeamActionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  team: Scalars['ID']['input'];
};

export type AssignToUserActionDef = Node & {
  __typename: 'AssignToUserActionDef';
  assignee: UserType;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  rule: AutopilotLegacyRuleType;
};

export type AssignToUserActionDefConnection = {
  __typename: 'AssignToUserActionDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AssignToUserActionDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AssignToUserActionDef` and its cursor. */
export type AssignToUserActionDefEdge = {
  __typename: 'AssignToUserActionDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AssignToUserActionDef>;
};

export type AssignToUserActionMutationInput = {
  assignee: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type AssignUserCompanyRole = {
  __typename: 'AssignUserCompanyRole';
  user?: Maybe<UserType>;
};

/**
 * Office-only (PRO-118): attach ONE agreement from the Pending queue
 * (an office decision, change-logged as an attach).
 */
export type AttachAreaAgreement = {
  __typename: 'AttachAreaAgreement';
  area?: Maybe<AreaDef>;
};

export type AttachDeviceToContainer = {
  __typename: 'AttachDeviceToContainer';
  fillLevelDevice?: Maybe<BaseDeviceInterface>;
};

/**
 * The F11/D09 comms gate artifact: audiences, languages, lead
 * time, per-language copy ({lang: {subject, body[,
 * rollback_subject, rollback_body]}}).
 */
export type AttachNotificationPlanMutation = {
  __typename: 'AttachNotificationPlanMutation';
  notificationPlan?: Maybe<NotificationPlanDef>;
  promotion?: Maybe<PromotionDef>;
};

/**
 * Attach existing Container assets to a Block/Regional SCP (NEXUS-642).
 *
 * ADR-0003: the containers stay the SAME ``device.Container`` assets, so
 * every container workflow (pickup, cleaning, replacement tickets, routing)
 * keeps working untouched. Kind-gated: Shared Residential points derive
 * containers from member agreements and cannot attach. Blocked on a
 * terminated SCP.
 */
export type AttachScpContainers = {
  __typename: 'AttachScpContainers';
  attachments?: Maybe<Array<Maybe<ScpContainerAttachmentDef>>>;
};

export type AttentionItemDef = {
  __typename: 'AttentionItemDef';
  approval?: Maybe<ApprovalDef>;
  at: Scalars['DateTime']['output'];
  automation?: Maybe<AutomationDef>;
  effect?: Maybe<EffectDef>;
  kind: Scalars['String']['output'];
  run?: Maybe<RunDef>;
  summary: Scalars['String']['output'];
};

export type AuditLogDef = {
  __typename: 'AuditLogDef';
  action: Scalars['String']['output'];
  actorKind: Scalars['String']['output'];
  actorUser?: Maybe<UserType>;
  automation?: Maybe<AutomationDef>;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['JSONString']['output'];
  fromState?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  toState?: Maybe<Scalars['String']['output']>;
};

export type AuditLogDefConnection = {
  __typename: 'AuditLogDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AuditLogDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AuditLogDef` and its cursor. */
export type AuditLogDefEdge = {
  __typename: 'AuditLogDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AuditLogDef>;
};

export type AuthorizationMethodDef = Node & {
  __typename: 'AuthorizationMethodDef';
  /** Stable machine code, e.g. SUOMI_FI */
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AuthorizationTypeDef = Node & {
  __typename: 'AuthorizationTypeDef';
  /** Stable machine code, e.g. POWER_OF_ATTORNEY */
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** What the frontend needs to gate every automation screen (D-API10). */
export type AutomationBootstrap = {
  __typename: 'AutomationBootstrap';
  canCreate: Scalars['Boolean']['output'];
  canDecideApprovals: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  canView: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  heldEvents: Scalars['Int']['output'];
  pauseReason?: Maybe<Scalars['String']['output']>;
  paused: Scalars['Boolean']['output'];
  pausedAt?: Maybe<Scalars['DateTime']['output']>;
  pausedBy?: Maybe<UserType>;
};

export type AutomationCatalog = {
  __typename: 'AutomationCatalog';
  actions: Array<ActionCatalogDef>;
  domainLabels: Array<LabelDef>;
  domains: Array<Scalars['String']['output']>;
  events: Array<EventCatalogDef>;
  limits: Scalars['JSONString']['output'];
  nodeKinds: Array<NodeKindDef>;
  policy: Array<PolicyCatalogDef>;
  subjects: Array<SubjectCatalogDef>;
  templateCategories: Array<LabelDef>;
  triggerKinds: Array<TriggerKindDef>;
};

export type AutomationDef = Node & {
  __typename: 'AutomationDef';
  copiedFromAutomation?: Maybe<AutomationDef>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  dailyFireCap?: Maybe<Scalars['Int']['output']>;
  definitionChecksum?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  edges: Array<EdgeDef>;
  engineOverlaps: Array<EngineOverlapDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  lastRun?: Maybe<RunDef>;
  latestTemplateVersion?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nodes: Array<NodeDef>;
  overlapWarnings: Array<OverlapWarningDef>;
  owner?: Maybe<UserType>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  replacedBy?: Maybe<AutomationDef>;
  replacementDraft?: Maybe<AutomationDef>;
  replacesAutomation?: Maybe<AutomationDef>;
  runsLast7Days: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  stateChangedAt?: Maybe<Scalars['DateTime']['output']>;
  stateReason?: Maybe<Scalars['String']['output']>;
  subjectTypes: Array<Scalars['String']['output']>;
  templateKey?: Maybe<Scalars['String']['output']>;
  templateUpdateAvailable: Scalars['Boolean']['output'];
  templateVersion?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export type AutomationDefConnection = {
  __typename: 'AutomationDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutomationDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AutomationDef` and its cursor. */
export type AutomationDefEdge = {
  __typename: 'AutomationDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AutomationDef>;
};

/** ``id`` read against ``otherId`` (SBX-565). */
export type AutomationDiffDef = {
  __typename: 'AutomationDiffDef';
  addedEdges: Array<EdgeDef>;
  addedNodes: Array<NodeDef>;
  changedNodes: Array<NodeChangeDef>;
  identical: Scalars['Boolean']['output'];
  removedEdges: Array<EdgeDef>;
  removedNodes: Array<NodeDef>;
};

export type AutomationSettingsDef = {
  __typename: 'AutomationSettingsDef';
  backfill?: Maybe<BackfillStatusDef>;
  channels: Array<ChannelPolicyDef>;
  defaultDailyFireCap?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  enabledAt?: Maybe<Scalars['DateTime']['output']>;
  heldEvents: Scalars['Int']['output'];
  pauseReason?: Maybe<Scalars['String']['output']>;
  paused: Scalars['Boolean']['output'];
  pausedAt?: Maybe<Scalars['DateTime']['output']>;
  pausedBy?: Maybe<UserType>;
  policies: Array<PolicyDef>;
};

/**
 * RS-1502 audit row: applied, refused and rolled-back L3
 * decisions with their overlay states, engine evidence and
 * notification records.
 */
export type AutopilotActionDef = Node & {
  __typename: 'AutopilotActionDef';
  actionDate: Scalars['Date']['output'];
  actionType?: Maybe<Scalars['String']['output']>;
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  appliedState: Scalars['JSONString']['output'];
  createdAt: Scalars['DateTime']['output'];
  engineEvidence: Scalars['JSONString']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  notificationIds: Scalars['JSONString']['output'];
  params: Scalars['JSONString']['output'];
  plan?: Maybe<PlanDef>;
  planningArea: PlanningAreaDef;
  priorState: Scalars['JSONString']['output'];
  proposedActionType: Scalars['String']['output'];
  refusalReason: Scalars['String']['output'];
  rolledBackAt?: Maybe<Scalars['DateTime']['output']>;
  rolledBackBy?: Maybe<UserType>;
  routeKey: Scalars['String']['output'];
  status: RouteStudioAutopilotActionStatusChoices;
  transitions: Scalars['JSONString']['output'];
};

export type AutopilotActionDefConnection = {
  __typename: 'AutopilotActionDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutopilotActionDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AutopilotActionDef` and its cursor. */
export type AutopilotActionDefEdge = {
  __typename: 'AutopilotActionDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AutopilotActionDef>;
};

export type AutopilotActionMinutesInput = {
  kind: Scalars['String']['input'];
  minutes: Scalars['Float']['input'];
};

/**
 * The two ways `ActivateAutopilotFlow` may gate a live activation
 * (AP-703), matching `ImpactRecord.GateKind` and `contracts/events.yaml`'s
 * `autopilot.flow_activated#gate_kind` verbatim.
 */
export enum AutopilotActivationGateKind {
  OVERRIDE = 'override',
  SIMULATION = 'simulation'
}

/**
 * The two decisions `DecideAutopilotApproval` accepts for a paused,
 * approval-required flow run.
 */
export enum AutopilotApprovalDecision {
  APPROVE = 'APPROVE',
  REJECT = 'REJECT'
}

/**
 * One per-action-kind minutes component of the active assumption
 * set. ``is_default`` is the honesty bit the editor shows beside each
 * number: True means the documented default, False means the tenant
 * stated this value themselves.
 */
export type AutopilotAssumptionComponentType = {
  __typename: 'AutopilotAssumptionComponentType';
  isDefault: Scalars['Boolean']['output'];
  kind: Scalars['String']['output'];
  minutes: Scalars['Float']['output'];
};

/**
 * The ACTIVE assumption set, openable/editable from the FE. Every
 * number here is a stated, editable assumption -- input to estimates,
 * never a measurement.
 */
export type AutopilotAssumptionSetType = {
  __typename: 'AutopilotAssumptionSetType';
  /** Per-kind handling minutes. Honesty note for the editor: the 'email', 'sms' and 'route_scheduling' kinds are stored and editable but feed no output yet -- no surface can price them until their history rows carry an automation flag; the editor should say so next to those rows. */
  actionMinutes: Array<AutopilotAssumptionComponentType>;
  adminCostPerHour: Scalars['Float']['output'];
  /** What an approval-gated run still costs a human, in minutes: read the preview line, click approve (Builder V2 item 4b -- gated runs are never priced at zero; hours saved for a gated run = manual-touch minutes minus this). Provisional default 2, editable like every other assumption. */
  approvalTouchMinutes: Scalars['Float']['output'];
  callMinutes: Scalars['Float']['output'];
  /** Deep-work interruption cost in minutes, added per manual action ON TOP of the kind's own minutes and always shown separately in derivations. */
  contextSwitchMinutes: Scalars['Float']['output'];
  /** Who confirmed or edited this version; null for system-seeded defaults. */
  editedByName?: Maybe<Scalars['String']['output']>;
  minutesPerManualTouch: Scalars['Float']['output'];
  /** When this version became active (its creation instant; versions are immutable). */
  sinceWhen: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

/** An enumeration. */
export enum AutopilotAutopilotSuggestionStatusChoices {
  /** Accepted */
  ACCEPTED = 'ACCEPTED',
  /** Dismissed */
  DISMISSED = 'DISMISSED',
  /** New */
  NEW = 'NEW'
}

/**
 * The frozen `ContactBaseline` row's numbers, verbatim: what the
 * tenant's own completed tickets of this type did BEFORE the flow went
 * live. `rate` always ships beside its raw counts (`repeatContacts` of
 * `completedTickets` -- K over L) so the derivation is inspectable,
 * never a bare percentage. All fields NonNull: a baseline either exists
 * whole or was never frozen at all.
 */
export type AutopilotContactBaselineType = {
  __typename: 'AutopilotContactBaselineType';
  channelsPresent: Array<Scalars['String']['output']>;
  completedTickets: Scalars['Int']['output'];
  doorCounts: AutopilotContactDoorCountsType;
  rate: Scalars['Float']['output'];
  repeatContacts: Scalars['Int']['output'];
  repeatWindowDays: Scalars['Int']['output'];
  windowEnd: Scalars['DateTime']['output'];
  windowStart: Scalars['DateTime']['output'];
};

/**
 * The deflected-contact figure: (baseline rate - measured rate) x
 * observed tickets, negatives kept. `null` + `unavailable: true` +
 * a stated `reason` until every precondition holds (observed-ticket
 * floor cleared, inbound-channel rows existed in the baseline window)
 * -- never an estimate, never a silent zero.
 */
export type AutopilotContactDeflectedType = {
  __typename: 'AutopilotContactDeflectedType';
  count?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  unavailable: Scalars['Boolean']['output'];
};

/**
 * The per-door split of a repeat-contact count (Impact dimensions
 * Stage 3, `autopilot.repeat_contact`'s three doors): inbound ticket
 * messages, inbound thread emails (door-(a) mirrors excluded so one
 * physical email never counts twice), and identity-window matched
 * follow-up tickets -- the last one a heuristic over recorded anchors,
 * never a recorded link (no ticket-to-ticket relation exists in the
 * schema), and always labeled as such wherever it renders.
 */
export type AutopilotContactDoorCountsType = {
  __typename: 'AutopilotContactDoorCountsType';
  emailThread: Scalars['Int']['output'];
  inboundMessage: Scalars['Int']['output'];
  repeatTicket: Scalars['Int']['output'];
};

/**
 * The measured side: repeat contacts on tickets this flow actually
 * handled, counted only after each ticket's follow-up window FULLY
 * elapsed (N over M). `pendingTickets` says how many handled tickets
 * are still inside their windows -- the honest "why is M small".
 * Nullable-`rate` + NonNull-`unavailable` copies
 * `AutopilotImpactProjectedMetricType`: zero observed tickets renders
 * `null`/`true`, never a zero pretending to be a measurement.
 */
export type AutopilotContactMeasuredType = {
  __typename: 'AutopilotContactMeasuredType';
  observedTickets: Scalars['Int']['output'];
  pendingTickets: Scalars['Int']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  repeatContacts: Scalars['Int']['output'];
  unavailable: Scalars['Boolean']['output'];
};

/**
 * One Context Store layer's freshness/row-count/provenance (AP-506).
 *
 * Not a `DjangoObjectType`: computed by
 * `autopilot.context_store.get_context_health`, never its own stored
 * row. `distilled=False` (every other field `None`) is the honest "not
 * yet distilled" state -- the Amir principle
 * (`01_DOMAIN_PRIMER.md` §3: missing data renders as unavailable, never
 * a fabricated number) -- not a zero pretending to be a real count.
 */
export type AutopilotContextLayerHealthType = {
  __typename: 'AutopilotContextLayerHealthType';
  distilled: Scalars['Boolean']['output'];
  lastDistilledAt?: Maybe<Scalars['DateTime']['output']>;
  lastEventId?: Maybe<Scalars['UUID']['output']>;
  layer: Scalars['String']['output'];
  rowCount?: Maybe<Scalars['Int']['output']>;
  sourceEventCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * One frozen contact baseline's full deflected-inbound-contact story
 * (Impact dimensions Stage 3): frozen before-rate, measured after-rate
 * with raw counts, and the deflection figure -- rendered per ticket
 * type the activation actually froze. A flow that froze nothing renders
 * no rows and the FE says 'unavailable', never 0. `label` carries the
 * observational caveat verbatim; `method` states the whole derivation
 * in words; `callsUnavailableReason` states the permanent structural
 * truth that phone calls can never be measured from tenant records.
 */
export type AutopilotDeflectedContactDimensionType = {
  __typename: 'AutopilotDeflectedContactDimensionType';
  baseline: AutopilotContactBaselineType;
  callsUnavailableReason: Scalars['String']['output'];
  deflected: AutopilotContactDeflectedType;
  label: Scalars['String']['output'];
  measured: AutopilotContactMeasuredType;
  method: Scalars['String']['output'];
  ticketType: Scalars['String']['output'];
};

/**
 * One (area, service type) group of the tenant's own measured
 * ad-hoc trips: the lower-median recorded driven distance (GPS,
 * `Route.real_distance`) and the trip count it stands on, over the
 * stated trailing window. `area`/`serviceType` are null when the
 * stop's own row honestly carries none -- never invented.
 */
export type AutopilotDrivingBaselineCellType = {
  __typename: 'AutopilotDrivingBaselineCellType';
  area?: Maybe<Scalars['String']['output']>;
  medianKm: Scalars['Float']['output'];
  serviceType?: Maybe<Scalars['String']['output']>;
  tripCount: Scalars['Int']['output'];
};

/**
 * Stage 5's one real measured number: "your typical ad-hoc trip:
 * X km (measured, N trips, 12 weeks)" -- baseline CONTEXT beside the
 * honest-empty savings figure, never a saving itself. `definition`
 * carries the ad-hoc-trip heuristic verbatim (nothing in the schema
 * records 'this was an ad-hoc trip'; the definition is a stated
 * product decision pending founder sign-off). Empty `cells` +
 * `unavailable: true` + the precise `reason` when no group clears the
 * sample floor or no recorded trip distances exist at all.
 * Deliberately a rolling read-time measurement, not an activation
 * freeze: context is never subtracted from anything (Stage 6 freezes
 * a baseline the moment a subtraction exists).
 */
export type AutopilotDrivingBaselineType = {
  __typename: 'AutopilotDrivingBaselineType';
  cells: Array<AutopilotDrivingBaselineCellType>;
  definition: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  unavailable: Scalars['Boolean']['output'];
  windowEnd: Scalars['DateTime']['output'];
  windowStart: Scalars['DateTime']['output'];
};

/**
 * The fuel/driving story (Impact dimensions Stage 5, honest-empty
 * by design): savings 'unavailable' with the quote-seam reason stated
 * verbatim, measured quote facts (none can exist until Stage 6), and
 * the tenant's own measured ad-hoc-trip baseline card -- the
 * credibility demo proving the no-fabrication path end to end BEFORE
 * any routing quote exists. `label` says what the baseline number is
 * ("baseline context, never savings"); `method` states the whole
 * derivation in words, including the ad-hoc-trip definition.
 */
export type AutopilotDrivingDimensionType = {
  __typename: 'AutopilotDrivingDimensionType';
  baseline: AutopilotDrivingBaselineType;
  label: Scalars['String']['output'];
  measured: AutopilotDrivingMeasuredType;
  method: Scalars['String']['output'];
  savings: AutopilotDrivingSavingsType;
};

/**
 * The accrued `DRIVING_DELTA` facts for this record: how many
 * quoted stop insertions were really serviced, and their summed
 * measured marginal driving (km). Empty today by construction -- the
 * producer cannot fire until Stage 6's quote seam ships -- rendering
 * `deltaKmTotal: null` + `unavailable: true` with a real zero count.
 * Direction warning: delta km is driving ADDED to an existing route by
 * an insertion (raw context for Stage 6's saving subtraction), never
 * itself a 'saved' figure.
 */
export type AutopilotDrivingMeasuredType = {
  __typename: 'AutopilotDrivingMeasuredType';
  completedQuotedInsertions: Scalars['Int']['output'];
  deltaKmTotal?: Maybe<Scalars['Float']['output']>;
  unavailable: Scalars['Boolean']['output'];
};

/**
 * The fuel/driving dimension's headline: km of driving saved.
 * `null` + `unavailable: true` + a stated verbatim `reason` -- ALWAYS,
 * in this codebase snapshot (Impact dimensions Stage 5): the routing
 * quote seam (Stage 6) does not exist, so no driving delta has ever
 * been measured, and a saving is never estimated in its place. Never a
 * zero pretending to be a measurement, never money (A-D10), never
 * minutes.
 */
export type AutopilotDrivingSavingsType = {
  __typename: 'AutopilotDrivingSavingsType';
  km?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  unavailable: Scalars['Boolean']['output'];
};

/**
 * One frozen `DwellBaseline` cell's numbers, verbatim (Impact
 * dimensions Stage 2): what tickets of this (type, status) historically
 * did over the closed pre-activation window, frozen at go-live and never
 * repointed. All fields NonNull because a cell either exists whole or
 * was never frozen at all -- there is no partially-known baseline.
 */
export type AutopilotDwellBaselineType = {
  __typename: 'AutopilotDwellBaselineType';
  p50Hours: Scalars['Float']['output'];
  p90Hours: Scalars['Float']['output'];
  sampleCount: Scalars['Int']['output'];
  windowEnd: Scalars['DateTime']['output'];
  windowStart: Scalars['DateTime']['output'];
};

/**
 * One frozen dwell cell's full service-level story (Impact dimensions
 * Stage 2, "response time dropped from X to Y"): frozen baseline,
 * attributed measured side, SLA share before vs after, weekly trend.
 * Rendered per (ticketType, status) the activation actually froze --
 * a flow that froze nothing renders no rows, and the FE says
 * 'unavailable', never 0. `label` carries the observational caveat
 * verbatim; `method` states the whole derivation in words.
 */
export type AutopilotDwellDimensionType = {
  __typename: 'AutopilotDwellDimensionType';
  baseline: AutopilotDwellBaselineType;
  label: Scalars['String']['output'];
  measured: AutopilotDwellMeasuredType;
  method: Scalars['String']['output'];
  sla: AutopilotDwellSlaType;
  status: Scalars['String']['output'];
  ticketType: Scalars['String']['output'];
  trend: Array<AutopilotDwellTrendPointType>;
};

/**
 * The attributed measured side of one dwell cell: the accrued
 * `DWELL_DELTA` rows for tickets this flow really handled. The
 * nullable-value + NonNull-`unavailable` shape copies
 * `AutopilotImpactProjectedMetricType`: with zero measured legs,
 * `observedP50Hours`/`deltaMinutesTotal` are `null` and `unavailable`
 * is `true` -- never a zero pretending to be a measurement.
 */
export type AutopilotDwellMeasuredType = {
  __typename: 'AutopilotDwellMeasuredType';
  deltaMinutesTotal?: Maybe<Scalars['Float']['output']>;
  legCount: Scalars['Int']['output'];
  observedP50Hours?: Maybe<Scalars['Float']['output']>;
  ticketCount: Scalars['Int']['output'];
  unavailable: Scalars['Boolean']['output'];
};

/**
 * A k-of-n share ("k of n legs left this status within the
 * threshold"), always carried as the raw counts beside the ratio so the
 * derivation is inspectable, never a bare percentage.
 */
export type AutopilotDwellShareType = {
  __typename: 'AutopilotDwellShareType';
  k: Scalars['Int']['output'];
  n: Scalars['Int']['output'];
  pct: Scalars['Float']['output'];
};

/**
 * The cell's service-level line. `thresholdHours` IS the cell's own
 * frozen baseline p50 (`thresholdSource: "baseline_p50"`) -- no invented
 * SLA number; a tenant-declared SLA field is an open product question
 * and deliberately absent. `before`/`after` are whole-cohort shares
 * (tickets arriving in the frozen window vs since activation), each
 * independently `null` + `...Unavailable: true` on zero samples.
 */
export type AutopilotDwellSlaType = {
  __typename: 'AutopilotDwellSlaType';
  after?: Maybe<AutopilotDwellShareType>;
  afterUnavailable: Scalars['Boolean']['output'];
  before?: Maybe<AutopilotDwellShareType>;
  beforeUnavailable: Scalars['Boolean']['output'];
  thresholdHours: Scalars['Float']['output'];
  thresholdSource: Scalars['String']['output'];
};

/**
 * One ISO week (Monday-keyed) of measured, flow-handled legs: the
 * lower-median observed hours and how many legs that median stands on.
 */
export type AutopilotDwellTrendPointType = {
  __typename: 'AutopilotDwellTrendPointType';
  p50Hours: Scalars['Float']['output'];
  sampleCount: Scalars['Int']['output'];
  weekStart: Scalars['Date']['output'];
};

/**
 * What an "automate this" entry point needs to open the builder (or
 * hand back an existing automation instead of minting a duplicate).
 */
export type AutopilotEntryPointContextType = {
  __typename: 'AutopilotEntryPointContextType';
  matchingFlow?: Maybe<FlowType>;
  notes: Array<Scalars['String']['output']>;
  suggestedTrigger: AutopilotTriggerScaffoldType;
  ticketTypeName?: Maybe<Scalars['String']['output']>;
};

/**
 * The three "automate this" entry points named in `04_BACKLOG.md`'s
 * AP-405 AC and `12_EXPERIENCE_SPEC.md` §2. Values match
 * `autopilot.builder.entry_points.EntryPointSource` exactly, the same
 * "member value is the string a resolver compares against directly"
 * convention `AutopilotFlowPromotableState` above already uses.
 */
export enum AutopilotEntryPointSource {
  KANBAN_COLUMN = 'kanban_column',
  LIST_SELECTION = 'list_selection',
  TICKET_DETAIL = 'ticket_detail'
}

/**
 * One flow's outcome from `ActivateConvertedFlows` /
 * `DeactivateConvertedFlows`. `warnings` carries the same non-fatal
 * legacy-origin honesty warnings single activations get (fire cap,
 * approval pauses); `resumedRuleCount` is only populated by the
 * deactivation direction.
 */
export type AutopilotEstateActivationResultType = {
  __typename: 'AutopilotEstateActivationResultType';
  flowId: Scalars['ID']['output'];
  flowName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
  resumedRuleCount?: Maybe<Scalars['Int']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

/**
 * One colliding pair from the estate preview: both flows' triggers
 * matched the identical recorded event `overlapCount` times within the
 * shared `triggerEvent` stream. Exact trigger decisions, never sampled;
 * pairs are listed only when the overlap is nonzero (comparedPairs on
 * the parent reports how many pairs were checked).
 */
export type AutopilotEstateCollisionType = {
  __typename: 'AutopilotEstateCollisionType';
  flowAId: Scalars['ID']['output'];
  flowAName: Scalars['String']['output'];
  flowBId: Scalars['ID']['output'];
  flowBName: Scalars['String']['output'];
  overlapCount: Scalars['Int']['output'];
  triggerEvent: Scalars['String']['output'];
};

/**
 * One GREEN rule's outcome from `ConvertAllGreenLegacyRules`:
 * ``drafted`` (a new draft flow was created), ``already_converted``
 * (the Lane D dedupe guard found an existing non-archived flow -- the
 * idempotent case, `flowId` links it), or ``failed_validation`` (the
 * recomputed definition failed the registry-aware validator; `message`
 * carries every violation).
 */
export type AutopilotEstateConversionResultType = {
  __typename: 'AutopilotEstateConversionResultType';
  flowId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
  ruleId: Scalars['ID']['output'];
};

/**
 * One flow's own replay facts inside the estate preview (Wave 2 Lane
 * E S4): exact `corpusSize`/`firedCount` over the shared window, plus
 * `coverageState` so a zero is readable (VERIFIED_ZERO vs
 * NO_REPLAY_DATA), `triggerEvent` so the stream grouping is visible,
 * and `isCandidate` separating the flows being previewed from the live
 * fleet they are checked against.
 */
export type AutopilotEstatePreviewFlowType = {
  __typename: 'AutopilotEstatePreviewFlowType';
  corpusSize: Scalars['Int']['output'];
  coverageState: Scalars['String']['output'];
  firedCount: Scalars['Int']['output'];
  flowId: Scalars['ID']['output'];
  flowName: Scalars['String']['output'];
  flowState: Scalars['String']['output'];
  isCandidate: Scalars['Boolean']['output'];
  triggerEvent: Scalars['String']['output'];
};

/**
 * Wave 2 Lane E S4: the whole-estate dry run -- every candidate AND
 * the live fleet replayed over the same window, pairwise-intersected
 * within trigger event streams (including candidate-vs-candidate, the
 * blind spot the single-flow `autopilotPortfolioCollisions` preview
 * structurally has). See `autopilot.portfolio.estate_preview_for_
 * company` for the full honesty contract.
 */
export type AutopilotEstatePreviewType = {
  __typename: 'AutopilotEstatePreviewType';
  collisions: Array<AutopilotEstateCollisionType>;
  comparedPairs: Scalars['Int']['output'];
  flows: Array<AutopilotEstatePreviewFlowType>;
  notCompared: Array<AutopilotPortfolioNotComparedType>;
  windowDays: Scalars['Int']['output'];
};

/**
 * One candidate's persisted evidence from
 * `RecordAutopilotEstateSimulations`: the `SimulationRun` id the
 * activation gate will check, plus its own replay facts.
 */
export type AutopilotEstateSimulationRecordType = {
  __typename: 'AutopilotEstateSimulationRecordType';
  corpusSize: Scalars['Int']['output'];
  coverageState: Scalars['String']['output'];
  firedCount: Scalars['Int']['output'];
  flowId: Scalars['ID']['output'];
  flowName: Scalars['String']['output'];
  simulationRunId: Scalars['ID']['output'];
};

/**
 * `totalCount` + one page of `results` -- the house offset-pagination
 * wrapper (like AutopilotFlowRunListType) for the paginated Flows table.
 * Returns full `FlowType` rows so the table can read whatever it needs
 * (name/state/currentVersion for the trigger/createdAt/killed).
 */
export type AutopilotFlowListType = {
  __typename: 'AutopilotFlowListType';
  results: Array<FlowType>;
  totalCount: Scalars['Int']['output'];
};

/**
 * The only states `PromoteAutopilotFlow` may target.
 *
 * Deliberately excludes `live` and `archived`: there is no generic
 * deploy-to-live path through this mutation. Two dedicated, gated
 * mutations reach `live` instead, each covering its own route:
 * `ActivateAutopilotFlow` (AP-703's general activation gate: a recorded
 * simulation or an explicit reasoned override, from `test`) and
 * `ActivateAutopilotFlowFromShadow` (AP-704's one-click promotion, from
 * `shadow` only, gated on the accrued shadow report). The possibility is
 * removed at the schema level here, not gated by a runtime check a
 * caller could route around.
 *
 * `shadow` (AP-704) is reachable from `test`: entering shadow mode means
 * the flow starts being exercised against real live events (stubbed),
 * the same "last save-time gate before it runs for real" story `test`
 * already has, so it gets the same guards below (`has_unsaved_changes`,
 * `validate_for_builder`).
 */
export enum AutopilotFlowPromotableState {
  DRAFT = 'draft',
  SHADOW = 'shadow',
  TEST = 'test'
}

/**
 * `totalCount` + one page of `results`, the house offset-pagination
 * wrapper shape (e.g. `crm.schema.defs`' `*EventsWrapper` types).
 */
export type AutopilotFlowRunListType = {
  __typename: 'AutopilotFlowRunListType';
  results: Array<AutopilotFlowRunType>;
  totalCount: Scalars['Int']['output'];
};

/**
 * One execution of a live flow against one triggering event, plus its
 * full step ledger. Read-only: the ledger is written exclusively by the
 * executor (`autopilot.runtime.executor`).
 *
 * `displayNumber` is the per-tenant, chronological run number (see
 * `run_display_number`) -- what the UI calls "Run N"; `id` remains the
 * global pk for audit/deep links.
 */
export type AutopilotFlowRunType = {
  __typename: 'AutopilotFlowRunType';
  displayNumber: Scalars['Int']['output'];
  dryRun: Scalars['Boolean']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  flowId?: Maybe<Scalars['ID']['output']>;
  flowName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  steps: Array<AutopilotStepRunType>;
  triggerSummary: Scalars['String']['output'];
};

/**
 * Stateless validate-only result (AP-402): "validation surfaced live"
 * without a round trip through persistence -- the canvas UI can call this
 * on every edit, independent of the autosave debounce.
 */
export type AutopilotFlowValidationResultType = {
  __typename: 'AutopilotFlowValidationResultType';
  errors: Array<ErrorType>;
  valid: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

/**
 * One Flow's honesty-loop row (AP-1003, `02_PRD.md` F12 "Impact
 * ledger and honesty loop"): the projection frozen at activation
 * beside the measured outcomes accrued against it since, rendered
 * from a real, tenant-scoped `ImpactRecord` row
 * (`impact_ledger_for_company` below, over
 * `autopilot.impact_ledger.ledger_summary`). `frozenAt` never changes
 * after creation (`ImpactRecord` is immutable); an assumption-set edit
 * reprices only a *future* freeze, never this one
 * (`05_UAT.md` U-PULSE).
 */
export type AutopilotImpactLedgerEntryType = {
  __typename: 'AutopilotImpactLedgerEntryType';
  approvalTouchMinutes: Scalars['Float']['output'];
  assistedMinutesFloored: Scalars['Boolean']['output'];
  assistedMinutesPerCompletion: Scalars['Float']['output'];
  assumptionSetVersion: Scalars['Int']['output'];
  deflectedContactDimensions: Array<AutopilotDeflectedContactDimensionType>;
  drivingDimension: AutopilotDrivingDimensionType;
  dwellDimensions: Array<AutopilotDwellDimensionType>;
  flowId: Scalars['ID']['output'];
  flowName: Scalars['String']['output'];
  frozenAt: Scalars['DateTime']['output'];
  gateKind: Scalars['String']['output'];
  gateReason: Scalars['String']['output'];
  lastMeasuredAt?: Maybe<Scalars['DateTime']['output']>;
  measuredAssistedHoursSaved: Scalars['Float']['output'];
  measuredHoursSaved: Scalars['Float']['output'];
  measuredOutcomeCount: Scalars['Int']['output'];
  measuredOutcomes: Array<AutopilotMeasuredOutcomeTotalType>;
  measuredZeroTouchHoursSaved: Scalars['Float']['output'];
  measurementStartedAt: Scalars['DateTime']['output'];
  minutesPerManualTouch: Scalars['Float']['output'];
  projectedImpact: Array<AutopilotImpactProjectedMetricType>;
  simulationWindowDays?: Maybe<Scalars['Int']['output']>;
};

/**
 * One key of a frozen `ImpactRecord.projected_impact` snapshot
 * (AP-1003): `hours`, `wait_days`, `messages`, `calls` --
 * `ImpactRecord.REQUIRED_PROJECTED_IMPACT_KEYS`. `value` is `null`
 * when the input was `"unavailable"` at freeze time (the Amir
 * principle, `01_DOMAIN_PRIMER.md` #3: never fabricate a number for a
 * missing input); `unavailable` says honestly why, `value` never
 * guesses instead.
 */
export type AutopilotImpactProjectedMetricType = {
  __typename: 'AutopilotImpactProjectedMetricType';
  metric: Scalars['String']['output'];
  unavailable: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

/**
 * One line of a legacy rule's action list, pre-digested for display.
 * Read-only, not tied to any Django model (a `RuleAction` row is one of
 * several concrete subclasses via multi-table inheritance; this type is
 * the flattened, display-ready shape).
 */
export type AutopilotLegacyRuleActionType = {
  __typename: 'AutopilotLegacyRuleActionType';
  kind: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
  supported: Scalars['Boolean']['output'];
};

/**
 * The MERGE-REPRODUCTION-CONTRACT verdict for superseding a legacy rule
 * with its converted flow: GREEN = safe to merge now, YELLOW = converts but
 * drops a behaviour (review first), RED = must stay on the classic engine.
 */
export enum AutopilotLegacyRuleEligibilityTier {
  GREEN = 'GREEN',
  RED = 'RED',
  YELLOW = 'YELLOW'
}

/**
 * Whether this rule can be faithfully reproduced by Autopilot (and so
 * superseded), plus the human reasons behind the verdict.
 */
export type AutopilotLegacyRuleEligibilityType = {
  __typename: 'AutopilotLegacyRuleEligibilityType';
  reasons: Array<Scalars['String']['output']>;
  tier: AutopilotLegacyRuleEligibilityTier;
};

/**
 * `totalCount` + one page of `results` -- the same house offset-pagination
 * wrapper shape as `AutopilotFlowRunListType`. Added so the estate view's
 * legacy-rule table can page server-side instead of resolving every rule's
 * per-row `actions`/`convertible`/`eligibility` (the un-paginated
 * `autopilotLegacyRules` field did all ~110 at once -- measured ~44s -- because
 * graphene ran those resolvers for every row). Paging means those resolvers
 * run for at most `first` rows per request.
 */
export type AutopilotLegacyRuleListType = {
  __typename: 'AutopilotLegacyRuleListType';
  results: Array<AutopilotLegacyRuleType>;
  totalCount: Scalars['Int']['output'];
};

/**
 * One row of the existing per-type automation engine
 * (`ticket.models.rule.Rule`, DISCOVERY.md section 3), exposed read-only
 * for the estate view. There is deliberately no mutation on this type:
 * the existing CRM rule-builder GraphQL (`crm.schema.defs.TicketRuleDef`)
 * remains the only way to edit these rows; Autopilot only reads them,
 * per 06_DECISIONS_RISKS.md ("legacy rules untouched by default").
 */
export type AutopilotLegacyRuleType = {
  __typename: 'AutopilotLegacyRuleType';
  actions: Array<AutopilotLegacyRuleActionType>;
  alreadyConverted: Scalars['Boolean']['output'];
  convertedFlow?: Maybe<FlowType>;
  convertible: Scalars['Boolean']['output'];
  eligibility: AutopilotLegacyRuleEligibilityType;
  fromStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastTriggered?: Maybe<Scalars['DateTime']['output']>;
  supersededByFlow?: Maybe<FlowType>;
  supersededByFlowId?: Maybe<Scalars['ID']['output']>;
  ticketTypeName: Scalars['String']['output'];
  toStatus: Scalars['String']['output'];
};

/**
 * One `MeasuredOutcome.Kind` summed since activation
 * (`autopilot.impact_ledger.ledger_summary`): `zero_touch_completion`,
 * `assisted_completion` (a run a person approved -- disjoint from
 * zero-touch per sweep, with an explicit guard against pre-#1094
 * historical zero-touch rows, so the fully-automatic vs assisted split
 * stays visible), `dwell_delta`, `comms_sent`, `approval_overridden`,
 * `repeat_contact_observation`. `total` is `0` when nothing of this
 * kind has accrued yet -- a real, honest zero, not the "unavailable"
 * sentinel (absence of a measured fact is itself a fact, unlike a
 * missing projection input).
 *
 * Direction warning: `repeat_contact_observation` is INVERTED relative
 * to every other kind -- its total is observed repeat contacts on
 * flow-handled tickets, so MORE is WORSE. It is a raw observation,
 * never a 'saved' count; generic "bigger is better" totals rendering
 * must special-case or exclude it, and the deflected-contact panel
 * derives its real figure from `deflectedContactDimensions`, never
 * from this total. `driving_delta` (Stage 5; permanently 0 until the
 * Stage 6 quote seam ships) is likewise a raw observation -- measured
 * marginal km an inserted stop ADDED to an existing route, context for
 * a future saving subtraction, never itself a saving; the fuel/driving
 * panel renders from `drivingDimension`, never from this total.
 */
export type AutopilotMeasuredOutcomeTotalType = {
  __typename: 'AutopilotMeasuredOutcomeTotalType';
  kind: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

/**
 * Wave 2 Lane E S2: the estate migration's headline numbers, straight
 * from `autopilot.services.estate_assessment.migration_progress_for_
 * company` (see `MigrationProgress` for the exact semantics of each
 * count). Every number is computed from the live rows in one pass, never
 * cached or estimated -- the wizard's "14 of 37 steps run in Autopilot"
 * meter must always be traceable to real data.
 */
export type AutopilotMigrationProgressType = {
  __typename: 'AutopilotMigrationProgressType';
  drafted: Scalars['Int']['output'];
  greenRemaining: Scalars['Int']['output'];
  redTotal: Scalars['Int']['output'];
  superseded: Scalars['Int']['output'];
  totalWithActions: Scalars['Int']['output'];
  yellowRemaining: Scalars['Int']['output'];
};

/**
 * One parked flow (draft/test/shadow, not killed) on the
 * Opportunity-Cost Ledger (frontier #49): what its own simulation says
 * it would save, currently not being captured because it is not live.
 * Priced ONLY from a persisted `SimulationRun` for the flow's current
 * version (the same evidence standard as the AP-703 activation gate,
 * via the gate's own pricing helper -- one formula for promise and
 * opportunity alike); a flow with no simulation is honestly
 * `priced=False` with no number, never an estimate. Legacy rules are
 * deliberately absent: they still execute, so nothing is being lost.
 */
export type AutopilotOpportunityCostRowType = {
  __typename: 'AutopilotOpportunityCostRowType';
  corpusSize?: Maybe<Scalars['Int']['output']>;
  firedCount?: Maybe<Scalars['Int']['output']>;
  flowId: Scalars['ID']['output'];
  flowName: Scalars['String']['output'];
  parkedSince: Scalars['DateTime']['output'];
  priced: Scalars['Boolean']['output'];
  projectedHours?: Maybe<Scalars['Float']['output']>;
  simulatedAt?: Maybe<Scalars['DateTime']['output']>;
  simulationWindowDays?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
};

/**
 * One paused, approval-required action step awaiting a human decision
 * (`autopilot.models.AutopilotPendingApproval`). Read-only: the rows are
 * written by the executor's pause and resolved by
 * `DecideAutopilotApproval`, never mutated directly through this type.
 *
 * `flowId`/`flowName` are pulled off the paused run so a reviewer can see
 * which flow is blocked without a second query; `resolvedInput` is the
 * action's input at pause time, surfaced as a JSON string for the FE
 * approval surface.
 *
 * Persona-audit blocker #1 (all three cold-start personas refused to
 * approve a raw template + machine refs): the card must show what the
 * citizen will actually receive. `renderedSubject`/`renderedBody` are the
 * final message, substituted by the SAME rendering path the execute
 * binding uses at send time (`autopilot.actions.comms`, via the
 * registered simulation renderer -- one engine, so preview and send can
 * never drift). `unresolvedVariables` names, honestly, any `{token}` that
 * could not (ticket unresolvable) or will not (unknown vocabulary) be
 * substituted -- never curly brackets presented as final, never a faked
 * value. `ticketNumber` (the same `#<id>` the platform's ticket screens
 * show), `propertyAddress`, `recipientName`, and `channelLabel` replace
 * the machine refs ("ticket:84", "EMAIL") with what a person says.
 * All of these resolve tenant-scoped through one memoized query per
 * request (`_approval_ticket_map`): a foreign or dangling ref renders
 * them null together, never a leak, never an N+1.
 */
export type AutopilotPendingApprovalType = {
  __typename: 'AutopilotPendingApprovalType';
  actionClass: Scalars['String']['output'];
  actionKey: Scalars['String']['output'];
  channelLabel?: Maybe<Scalars['String']['output']>;
  flowId?: Maybe<Scalars['ID']['output']>;
  flowName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  previewDigest?: Maybe<Scalars['String']['output']>;
  propertyAddress?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  renderedBody?: Maybe<Scalars['String']['output']>;
  renderedSubject?: Maybe<Scalars['String']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedInput?: Maybe<Scalars['JSONString']['output']>;
  status: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  ticketNumber?: Maybe<Scalars['String']['output']>;
  unresolvedVariables: Array<Scalars['String']['output']>;
};

/**
 * One starter-gallery entry, resolved for the requesting tenant and
 * language. Not a Django model -- the catalog
 * (`autopilot/builder/playbooks.py`) is code/config, not tenant data; only
 * the per-tenant annotations below are computed per request.
 *
 * `mappable`/`matchedTicketTypeName`: whether this tenant has a real
 * `TicketType` for the template (canonical ref or a curated synonym,
 * see `resolve_ticket_type`). `alreadyBuiltFlow*`: the tenant's own
 * earliest non-archived Flow instantiated FROM this template
 * (`Flow.origin == "playbook:<key>"`), so the gallery card can say
 * "you already built this (in shadow)" instead of contradicting a flow
 * that visibly exists (persona-audit wave 4: the gallery claimed no
 * matching type while a shadow flow watched that exact name). All three
 * null together when the tenant never instantiated the template.
 */
export type AutopilotPlaybookType = {
  __typename: 'AutopilotPlaybookType';
  alreadyBuiltFlowId?: Maybe<Scalars['ID']['output']>;
  alreadyBuiltFlowName?: Maybe<Scalars['String']['output']>;
  alreadyBuiltFlowState?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  mappable?: Maybe<Scalars['Boolean']['output']>;
  matchedTicketTypeName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ticketTypeRef?: Maybe<Scalars['String']['output']>;
};

/**
 * One live flow compared against the candidate over the same replay
 * window (frontier #50). `overlapCount` is the number of SAME recorded
 * events both triggers fired on -- exact trigger decisions, never a
 * sampled estimate. Zero is a real "compared and clean" result.
 */
export type AutopilotPortfolioCollisionType = {
  __typename: 'AutopilotPortfolioCollisionType';
  flowId: Scalars['ID']['output'];
  flowName: Scalars['String']['output'];
  otherFiredCount: Scalars['Int']['output'];
  overlapCount: Scalars['Int']['output'];
};

/**
 * A live flow the preview could NOT honestly compare (different
 * trigger event stream, or no saved version) -- named with its reason
 * instead of being folded into a vacuous "0 collisions".
 */
export type AutopilotPortfolioNotComparedType = {
  __typename: 'AutopilotPortfolioNotComparedType';
  flowId: Scalars['ID']['output'];
  flowName: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

/**
 * Frontier #50, "simulate the fleet together": the candidate flow
 * replayed beside every LIVE flow over the same window of recorded
 * history, intersected on the exact events each fired on. Generalizes
 * the activation gate's flow-vs-source-rule double-execution guard
 * (zero-loss audit #8) to flow-vs-fleet.
 */
export type AutopilotPortfolioPreviewType = {
  __typename: 'AutopilotPortfolioPreviewType';
  candidateFiredCount: Scalars['Int']['output'];
  collisions: Array<AutopilotPortfolioCollisionType>;
  corpusSize: Scalars['Int']['output'];
  notCompared: Array<AutopilotPortfolioNotComparedType>;
  windowDays: Scalars['Int']['output'];
};

/** An enumeration. */
export enum AutopilotRegisteredActionActionClassChoices {
  /** bulk */
  BULK = 'BULK',
  /** mass_comms */
  MASS_COMMS = 'MASS_COMMS',
  /** money */
  MONEY = 'MONEY',
  /** standard */
  STANDARD = 'STANDARD'
}

/**
 * One (kind, month) line of the retro estimate; the two minutes
 * components are separate on purpose (the interruption cost is never
 * silently folded in).
 */
export type AutopilotRetroKindType = {
  __typename: 'AutopilotRetroKindType';
  contextSwitchMinutes: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  flowActionsExcluded: Scalars['Int']['output'];
  hours: Scalars['Float']['output'];
  kind: Scalars['String']['output'];
  minutesPerAction: Scalars['Float']['output'];
};

export type AutopilotRetroMonthType = {
  __typename: 'AutopilotRetroMonthType';
  actions: Scalars['Int']['output'];
  hours: Scalars['Float']['output'];
  kinds: Array<AutopilotRetroKindType>;
  /** The estimate label, on every row -- these numbers must never render without it. */
  label: Scalars['String']['output'];
  /** Calendar month, "YYYY-MM". */
  month: Scalars['String']['output'];
};

/**
 * The Provas-shaped business case: what the tenant's legacy rules
 * already did, priced with their stated assumptions. Estimates only --
 * nothing here ever comes from, or writes to, the impact ledger's
 * measured columns.
 */
export type AutopilotRetroSavingsType = {
  __typename: 'AutopilotRetroSavingsType';
  assumptionSetVersion: Scalars['Int']['output'];
  /** False means every number rests on system-seeded default assumptions no one at the tenant has reviewed; the panel must render that state distinctly, never as 'your stated assumptions'. */
  assumptionsConfirmed: Scalars['Boolean']['output'];
  exclusionReason: Scalars['String']['output'];
  flowActionsExcluded: Scalars['Int']['output'];
  /** NonNull on purpose: 'estimated from your own history and stated assumptions -- not a measurement'. */
  label: Scalars['String']['output'];
  months: Array<AutopilotRetroMonthType>;
  /** Honest gaps: automation work the history cannot attribute, stated instead of guessed. */
  notCounted: Array<Scalars['String']['output']>;
  /** The editable rate 'worth' is computed at; a bare number, no currency is ever attached. */
  ratePerHour: Scalars['Float']['output'];
  /** 'input' (caller-provided) | 'tenant_set' (the active version was confirmed/edited by a person at the tenant) | 'default_never_confirmed' (system-seeded defaults nobody has reviewed). */
  rateSource: Scalars['String']['output'];
  totalActions: Scalars['Int']['output'];
  totalHours: Scalars['Float']['output'];
  /** The requested window; null means all history. */
  windowMonths?: Maybe<Scalars['Int']['output']>;
  worth: Scalars['Float']['output'];
};

/**
 * One distinct action key's stub count within a shadow report
 * (`autopilot.runtime.shadow.ShadowActionCount`): "this is what it would
 * have done, this many times".
 */
export type AutopilotShadowActionCountType = {
  __typename: 'AutopilotShadowActionCountType';
  actionKey: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

/**
 * AP-704's accruing "would have done" report for one flow's shadow
 * trial (`autopilot.runtime.shadow.shadow_report_for_flow`). Unlike
 * `AutopilotSimulateReportType`, which replays a bounded historical
 * window in one shot, this accrues continuously for as long as the flow
 * stays in `Flow.State.SHADOW` -- every field here can only grow (or
 * stay the same) between two calls while the trial is ongoing.
 */
export type AutopilotShadowReportType = {
  __typename: 'AutopilotShadowReportType';
  failedCount: Scalars['Int']['output'];
  firstRunAt?: Maybe<Scalars['DateTime']['output']>;
  flowId: Scalars['ID']['output'];
  flowName: Scalars['String']['output'];
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  matchedCount: Scalars['Int']['output'];
  runCount: Scalars['Int']['output'];
  stubbedActionCounts: Array<AutopilotShadowActionCountType>;
  succeededCount: Scalars['Int']['output'];
};

/**
 * AP-702's aggregate impact projection over one Simulate report's
 * whole matched corpus (`autopilot.simulate_impact.aggregate_impact`;
 * `12_EXPERIENCE_SPEC.md`'s impact breakdown card). `touchesAutomated`
 * is `firedCount` (exact over the whole window, independent of
 * `sampleLimit`); `hoursSaved` is AP-602's real `calculate_impact`
 * `hours` metric over that count, never a second formula.
 * `assumptionSetVersion` pins the exact `AssumptionSet` version this
 * projection priced against (03_DATA_MODEL.md #2).
 *
 * Approval-aware since Builder V2 item 4a/4b ([W9-r1], the
 * 0.4-vs-0.3 cross-surface split): `gated` is the server-side
 * flow-level classification (the definition contains a
 * waits-for-approval action, per the Action Registry's own
 * `approval_required` rows -- the same classes the builder's catalog
 * badges show); when `gated` is true, `hoursSaved` prices every fired
 * run at `minutesPerManualTouch - approvalTouchMinutes` (floored at 0)
 * instead of the full manual minutes, so every consumer of this
 * breakdown (Simulate tab, Hero what-if, the builder) shows the same
 * number for the same flow. All three new fields are additive;
 * `minutesPerManualTouch` keeps meaning the FULL manual handling
 * minutes (the builder derives its own arithmetic from it), and
 * `approvalTouchMinutes` is always the assumption set's published
 * value whether or not it entered the math. `gatedRunCount` is
 * `touchesAutomated` for a gated flow and 0 otherwise -- the dry
 * replay has no per-run approval-pause state, so this is honestly the
 * flow-level classification applied to every fired run, never a
 * per-run observation.
 */
export type AutopilotSimulateImpactBreakdownType = {
  __typename: 'AutopilotSimulateImpactBreakdownType';
  /** The ACTIVE assumption set's approval-touch minutes (what an approval-gated run still costs a person: read the preview, click approve). Always the published assumption-set value; `gated` says whether it entered this breakdown's math. */
  approvalTouchMinutes: Scalars['Float']['output'];
  assumptionSetVersion: Scalars['Int']['output'];
  /** Server-side flow-level classification: the definition contains at least one waits-for-approval action (per the Action Registry's approval_required rows -- the same rows the runtime pauses on). When true, hoursSaved prices every fired run at minutesPerManualTouch - approvalTouchMinutes, floored at 0 per run. */
  gated: Scalars['Boolean']['output'];
  /** How many of touchesAutomated were priced gated: equal to touchesAutomated when `gated`, else 0. This is the flow-level classification applied to every fired run, NOT a per-run observation -- the dry replay has no per-run approval-pause state. */
  gatedRunCount: Scalars['Int']['output'];
  hoursSaved: Scalars['Float']['output'];
  minutesPerManualTouch: Scalars['Float']['output'];
  touchesAutomated: Scalars['Int']['output'];
};

/**
 * AP-701's "would have happened" report for one flow, over one
 * tenant's own recorded history -- `12_EXPERIENCE_SPEC.md`'s Simulate
 * report headline ("Over your last N days this would have fired X
 * times"). `runs` is a bounded sample (the first `sampleLimit` fired
 * runs in corpus order, so deterministic) for display, not the full
 * corpus; `firedCount`/`corpusSize`/`determinismHash` are exact, over
 * the whole window -- the engine only step-simulates the sampled runs
 * (`autopilot.runtime.replay`), which is what keeps this query
 * interactive on a season-scale corpus.
 *
 * `impactAvailable` (AP-702): always `true` now that
 * `autopilot.simulate_impact` is wired in -- `projectedGainHours`/
 * `impactBreakdown` are always real numbers (`touches_avoided` is
 * always a real int, never a missing input, so `calculate_impact`'s
 * `UNAVAILABLE` sentinel never applies here). Kept as a field, not
 * dropped, so a frontend built against an older backend (no AP-702)
 * still degrades to its own "impact estimate coming" copy instead of a
 * hard GraphQL error -- see `GET_AUTOPILOT_SIMULATE_IMPACT`'s own
 * frontend-side docstring for why this stayed a separate query.
 *
 * `coverageState`/`triggerTypeEventCount`: the honest-zero caveat 10 of
 * 12 panel reviewers flagged -- `firedCount == 0` alone cannot say
 * whether this flow's trigger ticket type simply never happens
 * (`NO_REPLAY_DATA`, `triggerTypeEventCount == 0`: the number is
 * unmeasured) or really never fires despite showing up in the window
 * (`VERIFIED_ZERO`). `VERIFIED_NONZERO` covers the normal firing case.
 * See `autopilot.runtime.replay._trigger_type_target` for how the
 * trigger's ticket type is derived from its filter.
 */
export type AutopilotSimulateReportType = {
  __typename: 'AutopilotSimulateReportType';
  corpusSize: Scalars['Int']['output'];
  coverageState: Scalars['String']['output'];
  determinismHash: Scalars['String']['output'];
  estimatorUsed: Scalars['Boolean']['output'];
  firedCount: Scalars['Int']['output'];
  flowId: Scalars['ID']['output'];
  flowName: Scalars['String']['output'];
  impactAvailable: Scalars['Boolean']['output'];
  impactBreakdown: AutopilotSimulateImpactBreakdownType;
  projectedGainHours: Scalars['Float']['output'];
  runs: Array<AutopilotSimulateRunType>;
  triggerTypeEventCount: Scalars['Int']['output'];
  watchingSince?: Maybe<Scalars['DateTime']['output']>;
  windowDays: Scalars['Int']['output'];
  windowEnd: Scalars['DateTime']['output'];
  windowStart: Scalars['DateTime']['output'];
};

/**
 * One historical event replayed against the flow version: what would
 * have happened, step by step. Nothing here was executed -- every
 * action step dispatched in SIMULATE mode by construction
 * (`autopilot.runtime.replay`), the same structural guarantee the
 * Activity feed's real runs carry.
 *
 * `runImpactHours` (AP-702) is this one run's own priced impact
 * (`autopilot.simulate_impact.run_impact`): a real `1`-touch `hours`
 * figure when the run actually completed a succeeded action end to end,
 * a real `0` when every action was guard-skipped or the run did not
 * fire -- never a fabricated estimate (the Amir principle). Costs
 * nothing beyond the step walk this run already renders.
 */
export type AutopilotSimulateRunType = {
  __typename: 'AutopilotSimulateRunType';
  eventId: Scalars['String']['output'];
  matched: Scalars['Boolean']['output'];
  occurredAt: Scalars['DateTime']['output'];
  runImpactHours: Scalars['Float']['output'];
  steps: Array<AutopilotSimulateStepType>;
};

/**
 * One step of one replayed run: `autopilot.runtime.replay.ReplayStep`
 * rendered for the Simulate tab. `estimator=True` is the A-D11 caveat
 * (`12_EXPERIENCE_SPEC.md`: "styled as a first-class caveat ... never a
 * footnote") -- no routing insertion-quote seam exists yet, so this
 * step's scheduling number is a historical-cadence estimate, never a
 * real quote.
 */
export type AutopilotSimulateStepType = {
  __typename: 'AutopilotSimulateStepType';
  actionKey?: Maybe<Scalars['String']['output']>;
  estimator: Scalars['Boolean']['output'];
  kind: Scalars['String']['output'];
  output?: Maybe<Scalars['JSONString']['output']>;
  state: Scalars['String']['output'];
  stepId: Scalars['String']['output'];
  summary: Scalars['String']['output'];
};

/**
 * A message an Autopilot automation sent to the people it names
 * (``notify.staff`` with ``channel: "platform"``), as the ``event`` of a
 * bell UserNotification. One row backs every recipient's notification;
 * the card reads the message, names the automation and links to the
 * property the notice is about.
 *
 * ``get_queryset`` is the gate: a person reads a notice only if it was
 * sent to them. Company scoping alone would not do, because
 * graphene-django auto-attaches the reverse relation to ``CompanyType``
 * (see CompostingFiledEventDef's note), and notices sent to one team
 * must not be readable by the rest of the company.
 */
export type AutopilotStaffNoticeEventDef = {
  __typename: 'AutopilotStaffNoticeEventDef';
  createdAt: Scalars['DateTime']['output'];
  /** Raw autopilot Flow pk, for /app/autopilot/flows?flow=. */
  flowId?: Maybe<Scalars['ID']['output']>;
  flowName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  propertyAddress?: Maybe<Scalars['String']['output']>;
  /** PropertyDef gid, when about one. */
  propertyId?: Maybe<Scalars['ID']['output']>;
};

/**
 * One run-ledger entry (trigger evaluation, condition evaluation, or
 * action dispatch). Read-only.
 *
 * Carries both the digested fields DEMO-GLUE shipped for the Activity feed
 * (`simulated`, `resultSummary`) and, as of AP-306, the raw ledger detail
 * the AC asks for: `inputSnapshot`, `effect` (the model's `output_snapshot`
 * -- `03_DATA_MODEL.md` §2 calls it the "output/effect snapshot"),
 * `startedAt`/`endedAt`/`durationMs`.
 *
 * `retryCount`/`idempotencyKey`/`errorClass`/`deadLettered` are read with
 * `getattr(..., None)`/a string state-comparison rather than a normal field
 * reference: AP-303 (this story's declared dependency, PR #1043 as of this
 * writing) is the story that adds `StepRun.attempt_count`/
 * `idempotency_key`/`error_class` and the `dead_lettered` state, and it is
 * not yet merged into `autopilot/integration`. Referencing those as plain
 * model fields today would fail at schema-import time, not just at query
 * time. Written this way, the four fields are always present and always
 * null on this branch, and start returning real values the moment AP-303
 * lands -- no further change needed here (see the `## AP-306` entry in
 * `PROGRESS.md`).
 *
 * Durable step retry (D-FR-3) made `retryCount` real exactly as reserved:
 * `StepRun.attempt_count` now exists and carries the attempt number (1 =
 * the original dispatch) on every ledger row of a retried step, null
 * everywhere else. The other three stay null until their own stories land.
 */
export type AutopilotStepRunType = {
  __typename: 'AutopilotStepRunType';
  actionKey: Scalars['String']['output'];
  deadLettered: Scalars['Boolean']['output'];
  durationMs?: Maybe<Scalars['Float']['output']>;
  effect?: Maybe<Scalars['JSONString']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  errorClass?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  inputSnapshot?: Maybe<Scalars['JSONString']['output']>;
  kind: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  resultSummary: Scalars['String']['output'];
  retryCount?: Maybe<Scalars['Int']['output']>;
  simulated: Scalars['Boolean']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  /** 'trigger', or the flow definition's step id (e.g. 's1'). */
  stepId: Scalars['String']['output'];
};

/**
 * The small `{id, name, status}` projection of the most-recent flow
 * started from one Pulse suggestion (Builder V2 item 1(i)), so Pulse can
 * render "Draft started -- resume it" cross-session. Deliberately not the
 * full `FlowType`: the card needs exactly these three fields, and `status`
 * is the raw stored `Flow.state` literal (`draft`/`test`/`shadow`/`live`/
 * `archived`) so the FE can also recognize a linked flow that has since
 * been turned on.
 */
export type AutopilotSuggestionDraftFlowType = {
  __typename: 'AutopilotSuggestionDraftFlowType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/**
 * One plain-language line of a grounded suggestion draft
 * (`autopilot.services.suggestion_grounded_draft.GroundedSuggestionDraftStep`):
 * what it does (`label`, e.g. "Assign to Sanne Klausen"), the registered
 * action it maps to (`actionKey`), and which real rule (or fallback
 * reasoning) produced it (`evidence`).
 */
export type AutopilotSuggestionDraftStepType = {
  __typename: 'AutopilotSuggestionDraftStepType';
  actionKey: Scalars['String']['output'];
  evidence: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/**
 * AP-601c: an `AutopilotSuggestion` grounded in the tenant's own real
 * per-type automation (`ticket.models.rule.Rule`), via
 * `autopilot.services.suggestion_grounded_draft`. `definition` is a
 * complete, registry-valid Flow definition -- concrete targets (a status,
 * a priority, a named person, a named team) come from a real `Rule` this
 * tenant already configured, never guessed. `hasRules=False` means no
 * convertible rule was found for this suggestion's ticket type: `definition`
 * is then a harmless one-step placeholder (an internal note, nothing that
 * changes ticket state) and `warnings` says plainly why, never a fabricated
 * stand-in for a real rule.
 */
export type AutopilotSuggestionDraftType = {
  __typename: 'AutopilotSuggestionDraftType';
  definition: Scalars['JSONString']['output'];
  flowName: Scalars['String']['output'];
  hasRules: Scalars['Boolean']['output'];
  steps: Array<AutopilotSuggestionDraftStepType>;
  ticketTypeName: Scalars['String']['output'];
  warnings: Array<Scalars['String']['output']>;
};

/**
 * The exact, unrounded factors behind one suggestion's projected
 * hours/month (persona-audit wave 4: all three personas demanded the
 * headline be recomputable on the surface that shows it). Frozen at
 * generation time in `AutopilotSuggestion.stats["formula"]` -- never
 * recomputed at read time, so the breakdown can never drift from the
 * stored evidence line and headline it explains.
 *
 * `ticketsPerMonth x touchesPerTicket x minutesPerTouch / 60`
 * (+ `tailTicketsPerMonth x callMinutes / 60` for a dwell-outlier
 * suggestion, where `tailTicketsPerMonth`/`callMinutes` are non-null)
 * lands on `computedHoursPerMonth` after the documented one-decimal
 * rounding -- `computedHoursPerMonth` IS the row's `projectedGainHours`.
 * `basis` says in plain words what `ticketsPerMonth` counts: ALL
 * `ticketsObserved` arrivals of the type over the `windowMonths` window
 * since `windowSince`, not just the completed sample the evidence line
 * leads with (the audited "6.8 vs 6.2" confusion was exactly that
 * undocumented basis difference).
 */
export type AutopilotSuggestionFormulaType = {
  __typename: 'AutopilotSuggestionFormulaType';
  basis: Scalars['String']['output'];
  callMinutes?: Maybe<Scalars['Float']['output']>;
  computedHoursPerMonth: Scalars['Float']['output'];
  minutesPerTouch: Scalars['Float']['output'];
  tailTicketsPerMonth?: Maybe<Scalars['Float']['output']>;
  ticketsObserved: Scalars['Int']['output'];
  ticketsPerMonth: Scalars['Float']['output'];
  touchesPerTicket: Scalars['Float']['output'];
  windowMonths: Scalars['Float']['output'];
  windowSince: Scalars['String']['output'];
};

/**
 * One mined-and-narrated Pulse suggestion (see
 * `autopilot.services.suggestions`). Every number in here (`evidence`,
 * `projectedGainHours`, `sampleSize`) is deterministic miner/assumption
 * math; only `title`/`rationale` are Gateway-phrased, and
 * `narrationSource` says honestly whether the Gateway or the template
 * fallback wrote them.
 *
 * `minutesPerTouch` is the assumption-set figure the projection was
 * priced with (frozen: from the stored formula when present, else the
 * row's own pinned `assumption_set`); `formula` is the full recomputable
 * breakdown (`AutopilotSuggestionFormulaType`) -- `null` only for rows
 * generated before the miner persisted its stats, an honest absence the
 * FE labels rather than a number recomputed after the fact.
 *
 * `draftFlow` (Builder V2 item 1(i)) is the most recent still-existing
 * flow started from this suggestion (`Flow.source_suggestion_id`, stamped
 * by both create paths), resolved strictly within the suggestion's own
 * company -- a foreign tenant's flow can never surface here even if ids
 * collide. `null` means no draft was ever started, or every started draft
 * has since been hard-deleted (`deleteAutopilotFlow`): the honest "nothing
 * to resume" answer either way.
 */
export type AutopilotSuggestionType = {
  __typename: 'AutopilotSuggestionType';
  draftFlow?: Maybe<AutopilotSuggestionDraftFlowType>;
  /** Deterministic evidence line, computed by the miner from the tenant's own tickets -- never LLM text. */
  evidence: Scalars['String']['output'];
  formula?: Maybe<AutopilotSuggestionFormulaType>;
  generatedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  minutesPerTouch: Scalars['Float']['output'];
  narrationSource: Scalars['String']['output'];
  projectedGainHours: Scalars['Float']['output'];
  /** Short plain-language why (same source as title). */
  rationale: Scalars['String']['output'];
  /** How many tickets the pattern was mined from. */
  sampleSize: Scalars['Int']['output'];
  status: AutopilotAutopilotSuggestionStatusChoices;
  ticketTypeName: Scalars['String']['output'];
  /** One-sentence plain-language suggestion (Gateway-phrased, or the deterministic template fallback). */
  title: Scalars['String']['output'];
};

/**
 * One tenant's context health, for the WasteHero internal console's
 * fleet-wide view (`internalAutopilotContextHealth`). Deliberately
 * carries only the same freshness/row-count/provenance metrics
 * `AutopilotContextLayerHealthType` exposes to a tenant admin about
 * their own company -- never raw ticket content -- matching
 * `02_PRD.md` §7's visibility matrix cell for the internal console
 * exactly: "Health metrics only".
 */
export type AutopilotTenantContextHealthType = {
  __typename: 'AutopilotTenantContextHealthType';
  companyId: Scalars['ID']['output'];
  companyName: Scalars['String']['output'];
  layers: Array<AutopilotContextLayerHealthType>;
};

/**
 * A prefilled `trigger` block in the `contracts/flow.schema.json`
 * shape: an event key plus an optional safe-expression filter.
 */
export type AutopilotTriggerScaffoldType = {
  __typename: 'AutopilotTriggerScaffoldType';
  event: Scalars['String']['output'];
  filter?: Maybe<Scalars['String']['output']>;
};

/**
 * One Watchtower siren card (`12_EXPERIENCE_SPEC.md`): a deduplicated,
 * severity-ranked, tenant-facing rendering of an open `AnomalyRecord`
 * finding (AP-1001), assembled by AP-1004's `autopilot.watchtower.
 * surfacing.surface_alerts` over the real queryset
 * (`autopilot.watchtower.api.open_watchtower_alerts` -- see that
 * module's docstring for the Watchtower lane reconciliation this seam
 * closes). `narration` is the deterministic template sentence
 * (`autopilot.watchtower.narration.TemplateWatchtowerAlertNarrator`); no
 * Model Gateway call, per that lane's own BLOCKED.md entry. `proposedResponse`
 * is `null` only for a detector kind the classifier does not yet recognize
 * (see `AutopilotWatchtowerProposedResponseType`'s own docstring) -- never a
 * shortcut.
 */
export type AutopilotWatchtowerAlertType = {
  __typename: 'AutopilotWatchtowerAlertType';
  alertKey: Scalars['String']['output'];
  findingId: Scalars['ID']['output'];
  headline: Scalars['String']['output'];
  isStale: Scalars['Boolean']['output'];
  kind: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  narration: Scalars['String']['output'];
  proposedResponse?: Maybe<AutopilotWatchtowerProposedResponseType>;
  severity: Scalars['String']['output'];
  thresholdRatio?: Maybe<Scalars['Float']['output']>;
  windowEnd: Scalars['DateTime']['output'];
  windowStart: Scalars['DateTime']['output'];
};

/**
 * AP-605's weekly digest brief -- anomalies + impact + suggestions
 * rolled into one per-tenant read (`02_PRD.md` F10/F12), assembled by
 * AP-1002's `autopilot.digest.assemble_digest` over AP-1001's real
 * `AnomalyRecord`/`AutopilotSuggestion` rows (`autopilot.watchtower.api.
 * weekly_digest_for_company`). Narration strings are the deterministic
 * template (`autopilot.digest_narration.TemplateDigestNarrator`); no
 * Model Gateway call, per that lane's own BLOCKED.md entry.
 */
export type AutopilotWatchtowerDigestType = {
  __typename: 'AutopilotWatchtowerDigestType';
  anomaliesHigh: Scalars['Int']['output'];
  anomaliesLow: Scalars['Int']['output'];
  anomaliesMedium: Scalars['Int']['output'];
  anomaliesTotal: Scalars['Int']['output'];
  determinismHash: Scalars['String']['output'];
  impactMetrics: Array<AutopilotWatchtowerImpactMetricType>;
  narrationAnomalies: Scalars['String']['output'];
  narrationImpact: Scalars['String']['output'];
  narrationSuggestions: Scalars['String']['output'];
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
  suggestionsAcceptedCount: Scalars['Int']['output'];
  suggestionsDismissedCount: Scalars['Int']['output'];
  suggestionsNewCount: Scalars['Int']['output'];
  topAnomalyHeadlines: Array<Scalars['String']['output']>;
  topSuggestionTitles: Array<Scalars['String']['output']>;
};

/**
 * One row of the digest's impact headline (`autopilot.digest.
 * IMPACT_METRICS`). `measuredTotal`/`projectedTotal` are `null` (never
 * `0`) when nothing is measurable yet -- the Amir principle, never a
 * fabricated number. Always `null` today: see `autopilot/watchtower/
 * api.py`'s own docstring for why `impact_movements` is wired empty for
 * now.
 */
export type AutopilotWatchtowerImpactMetricType = {
  __typename: 'AutopilotWatchtowerImpactMetricType';
  measuredTotal?: Maybe<Scalars['Float']['output']>;
  metric: Scalars['String']['output'];
  movementCount: Scalars['Int']['output'];
  projectedTotal?: Maybe<Scalars['Float']['output']>;
  unavailableCount: Scalars['Int']['output'];
};

/**
 * A SUGGESTION only -- never auto-executed, never wired to any
 * execution path. One classified next step for a Watchtower alert,
 * grounded entirely in that alert's own detected pattern and evidence
 * (`autopilot.watchtower.surfacing.ProposedResponse`/
 * `_classify_proposed_response`). `kind` is a closed classification tag
 * (e.g. "recheck_route" | "draft_citizen_notice" | "capacity_review" |
 * "investigate_spike"); `rationale` cites the alert's own real counts/
 * area/window, never a fabricated number; `confidence` reuses the same
 * ratio-over-threshold math the alert's own `severity` is computed
 * from.
 */
export type AutopilotWatchtowerProposedResponseType = {
  __typename: 'AutopilotWatchtowerProposedResponseType';
  confidence: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  rationale: Scalars['String']['output'];
  summary: Scalars['String']['output'];
};

/**
 * Persist the canvas UI's in-progress edit as the mutable working copy
 * (`Flow.draft_definition`), unconditionally (AP-402).
 *
 * Unlike `UpdateAutopilotFlowDefinition`, this never blocks on validation
 * and never creates a `FlowVersion`: autosave exists precisely so an
 * incomplete, mid-edit canvas is never lost. Validation still runs, its
 * result comes back as `validationErrors`/`validationWarnings` -- data for
 * the UI to render inline, never a reason to refuse the write. `errors`
 * (and `ok`) only ever reflect structural problems with the request itself
 * (tenant disabled, flow not found or not this tenant's, flow not in
 * `draft` state): the same three guards `UpdateAutopilotFlowDefinition`
 * enforces, because autosave is still bounded to "editing a draft flow"
 * (a `test`/`live` flow must be demoted first, same as a full commit).
 */
export type AutosaveAutopilotFlowDraft = {
  __typename: 'AutosaveAutopilotFlowDraft';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  flow?: Maybe<FlowType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  validationErrors?: Maybe<Array<Maybe<ErrorType>>>;
  validationWarnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type BBoxInput = {
  maxLat: Scalars['Float']['input'];
  maxLon: Scalars['Float']['input'];
  minLat: Scalars['Float']['input'];
  minLon: Scalars['Float']['input'];
};

export type BackfillStatusDef = {
  __typename: 'BackfillStatusDef';
  eventsWritten?: Maybe<Scalars['Int']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type BarcodeGenerationInput = {
  containerId?: InputMaybe<Scalars['String']['input']>;
  /** Code printed on this item's label. Both encode the same value. Omitted means BARCODE. */
  labelType?: InputMaybe<LabelCodeType>;
  ticket?: InputMaybe<Scalars['String']['input']>;
};

export type BaseDeviceInterface = {
  company?: Maybe<CompanyType>;
  connectionType?: Maybe<Scalars['String']['output']>;
  containerDevice?: Maybe<DeviceToContainerTypeConnection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  devId?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<DeviceTypeType>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isContainer?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type BaseDeviceInterfaceContainerDeviceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type BaselineDef = Node & {
  __typename: 'BaselineDef';
  baselineType: RouteStudioBaselineBaselineTypeChoices;
  claimGrade: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  methodVersion: Scalars['String']['output'];
  name: Scalars['String']['output'];
  planKpis: PlanKpisDefConnection;
  planningArea: PlanningAreaDef;
  sourceStopSet?: Maybe<StopSetDef>;
  totals: Scalars['JSONString']['output'];
  windowEnd?: Maybe<Scalars['Date']['output']>;
  windowStart?: Maybe<Scalars['Date']['output']>;
};


export type BaselineDefPlanKpisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type BaselineDefConnection = {
  __typename: 'BaselineDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BaselineDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `BaselineDef` and its cursor. */
export type BaselineDefEdge = {
  __typename: 'BaselineDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BaselineDef>;
};

/**
 * The overage (excess weight) line a weight posted or corrected - the
 * invoicing billable event, read-only (the events page is the REST v3
 * surface).
 */
export type BillableEventDef = {
  __typename: 'BillableEventDef';
  amount?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['Date']['output']>;
  eventIdExternal?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Tonnes over the allowance. */
  quantity?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  /** The collected weight, kg. */
  weight?: Maybe<Scalars['Float']['output']>;
  weightBasis?: Maybe<Scalars['String']['output']>;
};

/** Per-frequency roll-up of the due list. */
export type BillingDueListCycleSummaryType = {
  __typename: 'BillingDueListCycleSummaryType';
  count?: Maybe<Scalars['Int']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  estimatedTotal?: Maybe<Scalars['Decimal']['output']>;
  frequencyCode?: Maybe<Scalars['String']['output']>;
  frequencyLabel?: Maybe<Scalars['String']['output']>;
  hasOverdue?: Maybe<Scalars['Boolean']['output']>;
};

/** One due-list row: an agreement-period that is due to bill. */
export type BillingDueListRowType = {
  __typename: 'BillingDueListRowType';
  address?: Maybe<Scalars['String']['output']>;
  agreementId?: Maybe<Scalars['ID']['output']>;
  contactId?: Maybe<Scalars['ID']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  /** INDIVIDUAL | COMPANY */
  contactType?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  estimatedAmount?: Maybe<Scalars['Decimal']['output']>;
  frequencyChange?: Maybe<FrequencyChangeDetailType>;
  frequencyChangedSinceLastRun?: Maybe<Scalars['Boolean']['output']>;
  frequencyCode?: Maybe<Scalars['String']['output']>;
  frequencyLabel?: Maybe<Scalars['String']['output']>;
  isOverdue?: Maybe<Scalars['Boolean']['output']>;
  overdueCycles?: Maybe<Scalars['Int']['output']>;
  periodEnd?: Maybe<Scalars['Date']['output']>;
  periodStart?: Maybe<Scalars['Date']['output']>;
  scheduleId?: Maybe<Scalars['ID']['output']>;
};

/** The standing billing due list: cycle summaries + rows + watermark. */
export type BillingDueListType = {
  __typename: 'BillingDueListType';
  /** When the nightly job last recomputed the due list. */
  lastComputed?: Maybe<Scalars['DateTime']['output']>;
  rows?: Maybe<Array<Maybe<BillingDueListRowType>>>;
  summaries?: Maybe<Array<Maybe<BillingDueListCycleSummaryType>>>;
};

export type BillingFeatureProductPriceType = Node & {
  __typename: 'BillingFeatureProductPriceType';
  billingScheme: CoreBillingFeatureProductPriceBillingSchemeChoices;
  currency: Scalars['String']['output'];
  default: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  maxAmount?: Maybe<Scalars['Int']['output']>;
  minAmount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  tiersUnitAmount?: Maybe<Scalars['Int']['output']>;
  tiersUpTo?: Maybe<Scalars['Int']['output']>;
  unitAmount?: Maybe<Scalars['Int']['output']>;
};

export type BillingFeatureProductType = Node & {
  __typename: 'BillingFeatureProductType';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  isSeat: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  prices?: Maybe<Array<Maybe<BillingFeatureProductPriceType>>>;
  recurring: Scalars['Boolean']['output'];
  shippable: Scalars['Boolean']['output'];
  shippableStock: Scalars['Boolean']['output'];
  unitLabel?: Maybe<Scalars['String']['output']>;
};


export type BillingFeatureProductTypePricesArgs = {
  recurringInterval: Scalars['String']['input'];
  recurringIntervalCount: Scalars['Int']['input'];
};

export type BillingFeatureType = Node & {
  __typename: 'BillingFeatureType';
  feature: CoreBillingFeatureFeatureChoices;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<BillingFeatureProductType>>>;
};

export type BillingFeatureTypeConnection = {
  __typename: 'BillingFeatureTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BillingFeatureTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `BillingFeatureType` and its cursor. */
export type BillingFeatureTypeEdge = {
  __typename: 'BillingFeatureTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BillingFeatureType>;
};

export type BillingFrequencyDef = {
  __typename: 'BillingFrequencyDef';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  monthsPerCycle: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type BillingInformationCardType = {
  __typename: 'BillingInformationCardType';
  brand?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BillingInformationType = Node & {
  __typename: 'BillingInformationType';
  address: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  availableMpFeatures?: Maybe<Array<Maybe<BillingFeatureType>>>;
  availableWhFeatures?: Maybe<Array<Maybe<BillingFeatureType>>>;
  cards?: Maybe<Array<Maybe<BillingInformationCardType>>>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  defaultCollectionMethod: CoreBillingInformationDefaultCollectionMethodChoices;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  invoiceEmail: Scalars['String']['output'];
  invoicePhone: Scalars['String']['output'];
  invoices?: Maybe<Array<Maybe<BillingInvoice>>>;
  mpSubscription?: Maybe<BillingSubscription>;
  name: Scalars['String']['output'];
  shippingAddress: Scalars['String']['output'];
  shippingAddress2: Scalars['String']['output'];
  shippingCity: Scalars['String']['output'];
  shippingCountry: Scalars['String']['output'];
  shippingName: Scalars['String']['output'];
  shippingZipCode: Scalars['String']['output'];
  stripeId?: Maybe<Scalars['String']['output']>;
  vatNumber: Scalars['String']['output'];
  whSubscription?: Maybe<BillingSubscription>;
  zipCode: Scalars['String']['output'];
};

export type BillingInvoice = {
  __typename: 'BillingInvoice';
  amountDue?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  invoicePdf?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  paymentDue?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BillingRunDef = Node & {
  __typename: 'BillingRunDef';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  billingCutoffDateInclusive: Scalars['Date']['output'];
  canExport: Scalars['Boolean']['output'];
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  error: Scalars['String']['output'];
  exports: BillingRunExportDefConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  invoiceSet: InvoiceDefConnection;
  latestExport?: Maybe<BillingRunExportDef>;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  numberOfInvoiceItems?: Maybe<Scalars['Int']['output']>;
  numberOfPropertiesBilled?: Maybe<Scalars['Int']['output']>;
  propertiesToBill: PropertyDefConnection;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CrmBillingRunStatusChoices;
  totalAmount: Scalars['Decimal']['output'];
};


export type BillingRunDefExportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BillingRunDefInvoiceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BillingRunDefPropertiesToBillArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingRunDefConnection = {
  __typename: 'BillingRunDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BillingRunDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `BillingRunDef` and its cursor. */
export type BillingRunDefEdge = {
  __typename: 'BillingRunDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BillingRunDef>;
};

/**
 * What a billing run did to ONE selected due-list entry.
 *
 * The mirror of ``BillingDueListRowType``: same ``schedule_id`` /
 * ``agreement_id`` / period, but reporting the verdict instead of the
 * forecast. ``schedule_id`` is the same raw schedule PK the due-list row
 * carries and the run mutation accepts in ``scheduleIds``, so a caller can
 * join a result straight back onto the card it clicked.
 *
 * ``advanced`` is the load-bearing bit: True means the entry consumed its
 * period (the schedule moved on and the card is gone), False means the
 * period was left billable and the card is still there to click again.
 */
export type BillingRunEntryOutcomeType = {
  __typename: 'BillingRunEntryOutcomeType';
  /** True when this entry consumed its period (the schedule advanced and the due row was cleared); False when the period was left billable, so the card stays and the click can be repeated. */
  advanced?: Maybe<Scalars['Boolean']['output']>;
  agreementId?: Maybe<Scalars['ID']['output']>;
  /** billed | partially_billed_work_left | under_minimum_deferred | under_minimum_deferred_work_left | events_blocked | events_not_invoiced | nothing_billable. Mirrors the ENTRY_* codes in invoicing.services.billing_schedule. */
  outcome?: Maybe<Scalars['String']['output']>;
  periodEnd?: Maybe<Scalars['Date']['output']>;
  periodStart?: Maybe<Scalars['Date']['output']>;
  /** Raw BillingSchedule PK — the same value billingDueList rows carry, so a result joins straight back onto its card. */
  scheduleId?: Maybe<Scalars['ID']['output']>;
};

export type BillingRunExportDef = Node & {
  __typename: 'BillingRunExportDef';
  billingRun: BillingRunDef;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  error: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CrmBillingRunExportStatusChoices;
};

export type BillingRunExportDefConnection = {
  __typename: 'BillingRunExportDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BillingRunExportDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `BillingRunExportDef` and its cursor. */
export type BillingRunExportDefEdge = {
  __typename: 'BillingRunExportDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BillingRunExportDef>;
};

export type BillingScheduleDef = {
  __typename: 'BillingScheduleDef';
  agreement: AgreementDef;
  anchor: InvoicingBillingScheduleAnchorChoices;
  frequency: BillingFrequencyDef;
  frequencyChangedSinceLastRun: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastBilledPeriodEnd?: Maybe<Scalars['Date']['output']>;
  nextBillingDate?: Maybe<Scalars['Date']['output']>;
};

export type BillingSubscription = {
  __typename: 'BillingSubscription';
  currency?: Maybe<Scalars['String']['output']>;
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  features?: Maybe<Array<Maybe<BillingSubscriptionFeature>>>;
  recurringInterval?: Maybe<Scalars['String']['output']>;
  recurringIntervalCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BillingSubscriptionFeature = {
  __typename: 'BillingSubscriptionFeature';
  currency?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  minQuantity?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<BillingFeatureProductPriceType>;
  quantity?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BillingSubscriptionQuote = {
  __typename: 'BillingSubscriptionQuote';
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lineItems?: Maybe<Array<Maybe<BillingSubscriptionQuoteFeature>>>;
  recurringInterval?: Maybe<Scalars['String']['output']>;
  recurringIntervalCount?: Maybe<Scalars['Int']['output']>;
  recurringSubtotal?: Maybe<Scalars['Int']['output']>;
  recurringTotal?: Maybe<Scalars['Int']['output']>;
  upfrontLineItems?: Maybe<Array<Maybe<BillingSubscriptionQuoteFeature>>>;
  upfrontSubtotal?: Maybe<Scalars['Int']['output']>;
  upfrontTotal?: Maybe<Scalars['Int']['output']>;
};

export type BillingSubscriptionQuoteFeature = {
  __typename: 'BillingSubscriptionQuoteFeature';
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  featurePrice?: Maybe<BillingFeatureProductPriceType>;
  quantity?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BillingSubscriptionQuoteFeatureInput = {
  featureProductPriceId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

/**
 * Cross-fact BLEND spec: 2..10 metric ids aligned on ONE conformed
 * dimension (or a day/week/month time bucket). Resolved through the same
 * ``insights.blend.blend_by_dimension`` engine the insightsBlend query and
 * analyst tool use — each metric keeps its own governed computation; only
 * the per-bucket results are aligned. Field names camelCase on the wire
 * (metricIds); Python reads ``.metric_ids`` / ``.dimension`` / ``.days``.
 */
export type BlendInput = {
  days?: InputMaybe<Scalars['Int']['input']>;
  dimension: Scalars['String']['input'];
  metricIds: Array<Scalars['String']['input']>;
};

/**
 * The bonus-calculation breakdown for one settlement period (PRO-466):
 * named inputs, the compensation model's own factors, the formula
 * walk-through and the euro result — inputs → computation → euro.
 *
 * ``bonusPenaltyCents == round(compensationBaseCents * (coefficient - 1))``
 * always holds from these fields, so the euro reconciles with the shown
 * coefficient. Built from a period's (possibly frozen) report, so a closed
 * period's breakdown reproduces its frozen number.
 */
export type BonusBreakdownType = {
  __typename: 'BonusBreakdownType';
  /** complaints_per_emptyings | reliability | custom_metered. */
  basis?: Maybe<Scalars['String']['output']>;
  bonusModelId?: Maybe<Scalars['ID']['output']>;
  bonusModelName?: Maybe<Scalars['String']['output']>;
  /** Signed cents: compensation × (Bc - 1). */
  bonusPenaltyCents: Scalars['Int']['output'];
  capApplied: Scalars['Boolean']['output'];
  /** The effective coefficient Bc (1.0 = neutral). */
  coefficient?: Maybe<Scalars['Float']['output']>;
  coefficientOverridden: Scalars['Boolean']['output'];
  coefficientOverrideReason?: Maybe<Scalars['String']['output']>;
  compensationBaseCents: Scalars['Int']['output'];
  /** Pay-affecting complaints per completed emptying. */
  complaintShare: Scalars['Float']['output'];
  complaintsAffectingPay: Scalars['Int']['output'];
  complaintsTotal: Scalars['Int']['output'];
  /** Completed emptyings (the pay basis count). */
  emptyingCount: Scalars['Int']['output'];
  /** Human-readable formula with the values in place. */
  formula: Scalars['String']['output'];
  /** True when a compensation model governs the period (factors populated); false for an aggregate roll-up, a contractor-level line or an area with no model. */
  hasModel: Scalars['Boolean']['output'];
  /** Cap on |Bc - 1| as a percentage. */
  maxAdjustmentPct?: Maybe<Scalars['Float']['output']>;
  /** The metric m fed to Bc = a·(b - m) + 1. */
  metric?: Maybe<Scalars['Float']['output']>;
  /** a·(b - m) + 1 before the gate / structure / cap clamps. */
  rawCoefficient?: Maybe<Scalars['Float']['output']>;
  reliabilityGateApplied: Scalars['Boolean']['output'];
  reliabilityPct?: Maybe<Scalars['Float']['output']>;
  reliabilityTargetPct?: Maybe<Scalars['Float']['output']>;
  /** bonus_only | bonus_penalty | penalty_only. */
  structure?: Maybe<Scalars['String']['output']>;
  structureClamped: Scalars['Boolean']['output'];
  /** coefficient_b — the neutral reference point 'b'. */
  toleratedShareB?: Maybe<Scalars['Float']['output']>;
  /** coefficient_a (slope 'a'). */
  weightingA?: Maybe<Scalars['Float']['output']>;
};

export type BonusModelType = Node & {
  __typename: 'BonusModelType';
  /** Start of the model's active window. */
  activeFrom: Scalars['Date']['output'];
  /** End of the active window; NULL = open-ended. */
  activeTo?: Maybe<Scalars['Date']['output']>;
  /** Contract area this bonus model governs (D7). NULL = a contractor-wide (with hauler) or company-wide (both NULL) model. */
  area?: Maybe<AreaDef>;
  /** Which measured metric drives the coefficient (PRO-362). */
  basis: RoutesBonusModelBasisChoices;
  /** Complaint weighting (slope 'a'). */
  coefficientA: Scalars['Float']['output'];
  /** Tolerated complaint-share reference point ('b'). */
  coefficientB: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** Contractor this model defaults for across their areas (REQ 3.3.22/3.5.57). Set only for a contractor-wide model (area NULL); NULL together with area = the company default. */
  hauler?: Maybe<HaulerDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Cap on |Bc - 1| as a percentage (REQ 3.3.22 max %). */
  maxAdjustmentPct: Scalars['Float']['output'];
  /** Metered component driving a custom_metered basis (PRO-362). */
  meteredComponent?: Maybe<HaulerPriceMeteredComponentDef>;
  /** Display name of the compensation model (PRO-109). */
  name?: Maybe<Scalars['String']['output']>;
  /** Optional reliability gate: below this %, no bonus is awarded. */
  reliabilityTargetPct?: Maybe<Scalars['Float']['output']>;
  structure: RoutesBonusModelStructureChoices;
  /** Optional task type this model is limited to. NULL = whole area. */
  taskType?: Maybe<RoutesBonusModelTaskTypeChoices>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BonusModelTypeConnection = {
  __typename: 'BonusModelTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BonusModelTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BonusModelType` and its cursor. */
export type BonusModelTypeEdge = {
  __typename: 'BonusModelTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BonusModelType>;
};

export enum BorderRadiusEnum {
  LARGE = 'large',
  MEDIUM = 'medium',
  NONE = 'none',
  SMALL = 'small'
}

/**
 * RS-1602 tenant brain rule (D39): statement, structured
 * interpretation, provenance and lifecycle. Exportable by
 * construction: the full row is the export.
 */
export type BrainRuleDef = Node & {
  __typename: 'BrainRuleDef';
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedBy?: Maybe<UserType>;
  constraintId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  history: Scalars['JSONString']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  interpretation: Scalars['JSONString']['output'];
  name: Scalars['String']['output'];
  project: ProjectType;
  provenance: Scalars['JSONString']['output'];
  statement: Scalars['String']['output'];
  status: RouteStudioBrainRuleStatusChoices;
  version: Scalars['Int']['output'];
};

export type BrainRuleDefConnection = {
  __typename: 'BrainRuleDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BrainRuleDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `BrainRuleDef` and its cursor. */
export type BrainRuleDefEdge = {
  __typename: 'BrainRuleDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BrainRuleDef>;
};

/**
 * Branch a scenario: a fresh draft copying the full config with
 * lineage kept via ``parent`` (RS-202 AC).
 */
export type BranchScenarioMutation = {
  __typename: 'BranchScenarioMutation';
  scenario?: Maybe<ScenarioDef>;
};

export type BrregCompanyAddressType = {
  __typename: 'BrregCompanyAddressType';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type BrregCompanyInfoType = {
  __typename: 'BrregCompanyInfoType';
  forretningsadresse?: Maybe<BrregCompanyAddressType>;
  navn: Scalars['String']['output'];
  orgnr: Scalars['String']['output'];
};

/**
 * Build Baseline Zero from an imported stop set when no history
 * exists (RS-602). Clearly labeled kind='reconstruction' and never
 * claim-grade (D32).
 */
export type BuildReconstructionBaselineMutation = {
  __typename: 'BuildReconstructionBaselineMutation';
  baseline?: Maybe<BaselineDef>;
};

/**
 * Build the digital-twin replay baseline from the RS-303 replay
 * observations in a window (RS-602, D17, 05_ENGINE_SPEC section 9).
 * Naming is mandatory: every KPI delta names its baseline.
 */
export type BuildReplayBaselineMutation = {
  __typename: 'BuildReplayBaselineMutation';
  baseline?: Maybe<BaselineDef>;
};

export type BuilderAdminCompanyType = {
  __typename: 'BuilderAdminCompanyType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BuilderAdminDashboardType = {
  __typename: 'BuilderAdminDashboardType';
  audience: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  /** The Metabase dashboard it was copied from. */
  metabaseDashboardId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  /** The live roles it is shown to (Specific roles). */
  roles: Array<BuilderAdminRoleType>;
  tabs: Scalars['Int']['output'];
  tiles: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** The company's active users who see it now. */
  viewers: Scalars['Int']['output'];
  width?: Maybe<Scalars['String']['output']>;
};

/**
 * A dashboard Data & Analytics › Dashboards lists (analytics.Dashboard)
 * and the New dashboards copy made of it, if any.
 */
export type BuilderAdminMetabaseDashboardType = {
  __typename: 'BuilderAdminMetabaseDashboardType';
  copy?: Maybe<BuilderAdminDashboardType>;
  metabaseId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Its roles who can view; 0: everyone. */
  roles: Scalars['Int']['output'];
};

export type BuilderAdminRoleType = {
  __typename: 'BuilderAdminRoleType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BuilderDashboardResult = {
  __typename: 'BuilderDashboardResult';
  dashboard?: Maybe<BuilderDashboardType>;
  droppedWidgets?: Maybe<Array<Scalars['String']['output']>>;
  error?: Maybe<Scalars['String']['output']>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type BuilderDashboardType = {
  __typename: 'BuilderDashboardType';
  audience: Scalars['String']['output'];
  audienceCount?: Maybe<Scalars['Int']['output']>;
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOwner: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  rolesCanView: Array<Scalars['ID']['output']>;
  spec: Scalars['GenericScalar']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/**
 * One saved state of a builder dashboard (its History,
 * ``insights.dashboard_versions``).
 */
export type BuilderDashboardVersionType = {
  __typename: 'BuilderDashboardVersionType';
  id: Scalars['ID']['output'];
  isCurrent: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  savedAt: Scalars['String']['output'];
  savedBy?: Maybe<Scalars['String']['output']>;
  tileCount: Scalars['Int']['output'];
};

export type BuilderDashboardsAdminType = {
  __typename: 'BuilderDashboardsAdminType';
  builderEnabled: Scalars['Boolean']['output'];
  company: BuilderAdminCompanyType;
  dashboards: Array<BuilderAdminDashboardType>;
  /** The datasets its tiles may read (Feature configuration); none: the standard set. */
  datasets?: Maybe<Array<Scalars['String']['output']>>;
  metabase: Array<BuilderAdminMetabaseDashboardType>;
  /** The company's roles, for who sees a dashboard. */
  roles: Array<BuilderAdminRoleType>;
  sqlDatasets: Scalars['Int']['output'];
};

/**
 * A deleted builder dashboard the caller may bring back ("Deleted
 * dashboards" on the list).
 */
export type BuilderDeletedDashboardType = {
  __typename: 'BuilderDeletedDashboardType';
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  tileCount: Scalars['Int']['output'];
};

/**
 * Office-only: accepts the policy-computed outcome for the given
 * rows on one holiday. Per-row atomic, partial success — never
 * all-or-nothing. ``preview: true`` dry-runs every row (no writes) —
 * an additional optional backend argument beyond the FE/BE contract
 * (F6), harmless to clients that never pass it.
 */
export type BulkAcceptHolidayImpact = {
  __typename: 'BulkAcceptHolidayImpact';
  results: Array<HolidayImpactBulkResultDef>;
};

export type BulkActionProgressDef = Node & {
  __typename: 'BulkActionProgressDef';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  progress: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<BulkActionProgressStatus>;
  total: Scalars['Int']['output'];
  user: UserType;
};

export type BulkActionProgressDefConnection = {
  __typename: 'BulkActionProgressDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BulkActionProgressDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `BulkActionProgressDef` and its cursor. */
export type BulkActionProgressDefEdge = {
  __typename: 'BulkActionProgressDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BulkActionProgressDef>;
};

/** An enumeration. */
export enum BulkActionProgressStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NEW = 'NEW'
}

export type BulkAgreementUpdateInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optimistic-concurrency stamp (REQ 3.12.5): the Agreement.version the client loaded for THIS item. Stale -> STALE_VERSION refusal per the rollout phase. */
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
};

/**
 * SBX-518 (F1): confirm N same-class candidate tables in one
 * call with per-row outcomes {ref, label, outcome, reason_code,
 * reason} (snake_case wire, D74). Rows whose classifier verdict
 * already reads ``docClass`` are confirmed; every ambiguous or
 * conflicting row is refused BY NAME with its reason, never
 * bulk-swept (D62; the single confirm stays the override surface).
 * Whole-request refusals ride the D6 transport.
 */
export type BulkConfirmCandidateTableClassMutation = {
  __typename: 'BulkConfirmCandidateTableClassMutation';
  alreadyConfirmedCount?: Maybe<Scalars['Int']['output']>;
  candidateTables?: Maybe<Array<Maybe<CandidateTableDef>>>;
  confirmedCount?: Maybe<Scalars['Int']['output']>;
  importCase?: Maybe<ImportCaseDef>;
  refusedCount?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Scalars['GenericScalar']['output']>;
};

/**
 * SBX-518 (F6): confirm N grammar claims in one call with
 * per-row outcomes {ref, label, outcome, reason_code, reason}
 * (snake_case wire, D74); the sibling of the validation room's
 * batch verdicts (SBX-473) at the claims stage. Every row that
 * needs a HUMAN decision (below-threshold engine claims, claims a
 * newer upload disagrees with, undated calendar claims, pending
 * questions, recorded corrections or rejections) is refused BY
 * NAME with its reason, never bulk-swept (D62). Whole-request
 * refusals ride the D6 transport.
 */
export type BulkConfirmGrammarClaimsMutation = {
  __typename: 'BulkConfirmGrammarClaimsMutation';
  alreadyConfirmedCount?: Maybe<Scalars['Int']['output']>;
  confirmedCount?: Maybe<Scalars['Int']['output']>;
  grammarClaims?: Maybe<Array<Maybe<GrammarClaimDef>>>;
  importCase?: Maybe<ImportCaseDef>;
  refusedCount?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Scalars['GenericScalar']['output']>;
};

export type BulkCreateBulkWastePickupTicket = {
  __typename: 'BulkCreateBulkWastePickupTicket';
  results?: Maybe<Array<CreateBulkWastePickupTicketPayload>>;
};

export type BulkCreateContainerNotificationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  containers: Array<Scalars['ID']['input']>;
  daysBefore: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notificationType: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  property: Scalars['ID']['input'];
};

export type BulkCreateContainerNotificationPayload = {
  __typename: 'BulkCreateContainerNotificationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  containerNotification?: Maybe<ContainerNotificationDef>;
  containerNotifications?: Maybe<Array<ContainerNotificationDef>>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type BulkCreateManageContainerTicket = {
  __typename: 'BulkCreateManageContainerTicket';
  results?: Maybe<Array<CreateManageContainerTicketPayload>>;
};

export type BulkCreateTicket = {
  __typename: 'BulkCreateTicket';
  results?: Maybe<Array<CreateTicketPayload>>;
};

/**
 * Permanently delete the company's archived records of one data type,
 * optionally only those archived more than ``archivedForDays`` days ago.
 * Records referenced by protected data, and records whose deletion would
 * cascade to still-ACTIVE archivable dependents, are skipped and
 * counted.
 */
export type BulkDeleteArchived = {
  __typename: 'BulkDeleteArchived';
  deletedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

/**
 * Import real containers into a warehouse from a parsed file (Anders
 * C): materializes individual ``in_storage`` Container identities on the
 * shelf (visible in the In-storage tab) AND writes the matching receive
 * ledger rows so the counted Balances stays in sync. All-or-nothing.
 */
export type BulkImportContainers = {
  __typename: 'BulkImportContainers';
  createdContainers?: Maybe<Scalars['Int']['output']>;
  importedRows?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Handles operations related to bulk pairing of containers with RFID tags.
 *
 * This class is a GraphQL mutation that provides functionality for bulk pairing
 * containers with RFID tags. It ensures that multiple mappings can be created in
 * a single operation, optimizing efficiency and reducing manual errors. The
 * mutation performs validation, processes input, and returns an appropriate
 * response.
 *
 * Attributes:
 *     Input (graphene.InputObjectType): Defines the input type required for the
 *         mutation. This contains all necessary fields that the mutation needs to
 *         perform its operation.
 *     Output (graphene.ObjectType): Specifies the structure of the mutation's
 *         output. It holds the results of the mutation and any additional
 *         information, such as errors or success messages.
 */
export type BulkPairContainerRfid = {
  __typename: 'BulkPairContainerRFID';
  barcodeRfidPairs?: Maybe<Array<Maybe<PairContainerRfidOutput>>>;
};

/**
 * One line of a bulk receive (B6): an item type + quantity, and an
 * optional condition (defaults to new).
 */
export type BulkReceiveRowInput = {
  condition?: InputMaybe<Scalars['String']['input']>;
  containerTypeId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

/**
 * Receive many item types into one warehouse in a single action
 * (B6, Anders): the bulk counterpart of ReceiveStock for a large
 * purchase / delivery. All rows land in one transaction - a bad row
 * rolls the whole batch back, so the count never lands half-applied.
 */
export type BulkReceiveStock = {
  __typename: 'BulkReceiveStock';
  receivedRows?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type BulkSetFeatureConfig = {
  __typename: 'BulkSetFeatureConfig';
  batch?: Maybe<FeatureConfigBatchType>;
};

export type BulkSetTicketRoute = {
  __typename: 'BulkSetTicketRoute';
  /** Why a route could not be re-optimized after these tickets were scheduled on it; null when it was, or when the route does not auto-optimize. */
  optimizationError?: Maybe<Scalars['String']['output']>;
  tickets?: Maybe<Array<Maybe<TicketDef>>>;
};

export type BulkSetTicketRouteInput = {
  routeId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};

/**
 * This mutation is preferred over UpdateAgreement when updating multiple agreements
 * at once to update common fields for all agreements (recurring and non-recurring).
 * This mutation will update the container status if needed.
 */
export type BulkUpdateAgreement = {
  __typename: 'BulkUpdateAgreement';
  agreements?: Maybe<Array<Maybe<AgreementDef>>>;
};

export type BulkUpdateCompanyEmailAccountMessage = {
  __typename: 'BulkUpdateCompanyEmailAccountMessage';
  companyEmailAccountMessages: Array<CompanyEmailAccountMessageDef>;
};

export type BulkUpdateCompanyEmailAccountMessageInput = {
  assignedTeam?: InputMaybe<Scalars['ID']['input']>;
  assignee?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<CompanyEmailAccountMessageStatus>;
};

export type BulkUpdateContainer = {
  __typename: 'BulkUpdateContainer';
  containers?: Maybe<Array<Maybe<ContainerType>>>;
};

export type BulkUpdateContainerCollectionCalendarInput = {
  collectionCalendarId: Scalars['ID']['input'];
  containerId: Scalars['ID']['input'];
};

export type BulkUpdateContainerInput = {
  updateCollectionCalendar?: InputMaybe<Array<BulkUpdateContainerCollectionCalendarInput>>;
  updateRouteScheme?: InputMaybe<Array<BulkUpdateContainerRouteSchemeInput>>;
};

export type BulkUpdateContainerRouteSchemeInput = {
  containerId: Scalars['ID']['input'];
  routeSchemeId: Scalars['ID']['input'];
};

/**
 * REQ 3.3.24: apply a bulk price correction (a percentage or a fixed
 * additive cents delta) to all/selected products of a hauler, optionally
 * narrowed to one area. ``preview: true`` returns the impact — per-product
 * old/new amounts and the affected-unpaid-event count — without writing
 * anything.
 */
export type BulkUpdateHaulerPrices = {
  __typename: 'BulkUpdateHaulerPrices';
  affectedEventCount?: Maybe<Scalars['Int']['output']>;
  haulerPrices?: Maybe<Array<Maybe<HaulerPriceDef>>>;
  preview?: Maybe<Array<Maybe<HaulerPriceMassChangePreviewType>>>;
  skippedCount?: Maybe<Scalars['Int']['output']>;
  skippedNoActiveCount?: Maybe<Scalars['Int']['output']>;
  skippedNoActivePpProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  skippedNoActiveProductIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  updatedCount?: Maybe<Scalars['Int']['output']>;
};

export type BulkUpdateTicket = {
  __typename: 'BulkUpdateTicket';
  createTicketComment: Array<CreateTicketCommentPayload>;
  createTicketMessage: Array<CreateTicketMessagePayload>;
  tickets: Array<TicketDef>;
  updateAssignee: Array<TicketDef>;
  updateBulkWastePickupTicket: Array<UpdateBulkWastePickupTicketPayload>;
  updateManageContainerTicket: Array<UpdateManageContainerTicketPayload>;
  updatePriority: Array<TicketDef>;
  updateStatus: Array<TicketDef>;
  updateTicket: Array<UpdateTicketPayload>;
};

export type BulkUpdateTicketInput = {
  createTicketComment?: InputMaybe<Array<CreateTicketCommentInput>>;
  createTicketMessage?: InputMaybe<Array<CreateTicketMessageInput>>;
  updateAssignee?: InputMaybe<Array<UpdateTicketAssigneeInput>>;
  updateBulkWastePickupTicket?: InputMaybe<Array<UpdateBulkWastePickupTicketInput>>;
  updateManageContainerTicket?: InputMaybe<Array<UpdateManageContainerTicketInput>>;
  updatePriority?: InputMaybe<Array<UpdateTicketPriorityInput>>;
  updateStatus?: InputMaybe<Array<UpdateTicketStatusInput>>;
  updateTicket?: InputMaybe<Array<UpdateTicketInput>>;
};

export type BulkWastePickupTicketDef = Node & {
  __typename: 'BulkWastePickupTicketDef';
  /** When the abortive visit was reported. */
  abortiveAt?: Maybe<Scalars['DateTime']['output']>;
  /** The photo the driver attached to the last abortive visit. */
  abortiveAttachment?: Maybe<TicketAttachmentDef>;
  /** Driver's note on the abortive visit. */
  abortiveNote: Scalars['String']['output'];
  /** Why the last visit for this ticket could not be carried out (driver-reported); the ticket was re-opened for rescheduling. */
  abortiveReason?: Maybe<TicketTicketAbortiveReasonChoices>;
  affectsPay?: Maybe<Scalars['Boolean']['output']>;
  affectsPaySetAt?: Maybe<Scalars['DateTime']['output']>;
  affectsPaySetBy?: Maybe<UserType>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<UserType>;
  archivedByRule?: Maybe<ArchivalRuleDef>;
  assignedTeam?: Maybe<TeamType>;
  assignee?: Maybe<UserType>;
  company: CompanyType;
  container?: Maybe<ContainerType>;
  containerProduct?: Maybe<ProductDef>;
  createdAt: Scalars['DateTime']['output'];
  customFields: Scalars['JSONString']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  deadlineArea?: Maybe<AreaDef>;
  deadlineSource?: Maybe<TicketTicketDeadlineSourceChoices>;
  description: Scalars['String']['output'];
  externalReference?: Maybe<Scalars['String']['output']>;
  externalSource?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  ignoreServiceFee: Scalars['Boolean']['output'];
  items: BulkWastePickupTicketItemDefConnection;
  lastView?: Maybe<TicketViewEventDef>;
  location?: Maybe<LocationWithContainerType>;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  payerContact?: Maybe<ContactDef>;
  periodEndDate?: Maybe<Scalars['Date']['output']>;
  periodStartDate?: Maybe<Scalars['Date']['output']>;
  possibleContainerId: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  postalCodeName?: Maybe<Scalars['String']['output']>;
  ppContainerProduct?: Maybe<PpProductDef>;
  ppOriginalPrice?: Maybe<Scalars['Decimal']['output']>;
  ppOriginalWeight?: Maybe<Scalars['Decimal']['output']>;
  ppPrice?: Maybe<Scalars['Decimal']['output']>;
  ppPriceOverridden: Scalars['Boolean']['output'];
  ppServiceOriginalPrice?: Maybe<Scalars['Decimal']['output']>;
  ppServicePrice?: Maybe<Scalars['Decimal']['output']>;
  ppServicePriceOverridden: Scalars['Boolean']['output'];
  ppServiceProduct?: Maybe<PpProductDef>;
  ppWeight?: Maybe<Scalars['Decimal']['output']>;
  ppWeightOverridden: Scalars['Boolean']['output'];
  preferredDate?: Maybe<Scalars['Date']['output']>;
  priority: TicketTicketPriorityChoices;
  property?: Maybe<PropertyDef>;
  /** Reported accuracy radius of that fix, metres. */
  reportedGpsAccuracyM?: Maybe<Scalars['Float']['output']>;
  /** When the device took that fix (not the sync time). */
  reportedGpsCapturedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Device position when the ticket was filed. NULL = not recorded. */
  reportedPoint?: Maybe<Scalars['GeoJSON']['output']>;
  reporter?: Maybe<UserType>;
  reporterDriver?: Maybe<DriverType>;
  requestedBy?: Maybe<PropertyUserDef>;
  requestedByContact?: Maybe<ContactDef>;
  requestedByOther?: Maybe<Scalars['String']['output']>;
  rfid: Scalars['String']['output'];
  routeDescription: Scalars['String']['output'];
  searchUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  serviceFeeQuantity: Scalars['Int']['output'];
  serviceProvider?: Maybe<HaulerDef>;
  showOnPortal?: Maybe<Scalars['Boolean']['output']>;
  status: TicketTicketStatusChoices;
  /** The user who changed the status */
  statusChangedBy?: Maybe<UserType>;
  /** The reason for the status change */
  statusChangedReason?: Maybe<TicketTicketStatusChangedReasonChoices>;
  /** The platform where the status was changed */
  statusChangedVia?: Maybe<TicketTicketStatusChangedViaChoices>;
  statusCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  statusInProgressAt?: Maybe<Scalars['DateTime']['output']>;
  statusOnHoldAt?: Maybe<Scalars['DateTime']['output']>;
  statusOpenAt?: Maybe<Scalars['DateTime']['output']>;
  statusPendingAt?: Maybe<Scalars['DateTime']['output']>;
  statusRejectedAt?: Maybe<Scalars['DateTime']['output']>;
  ticketPtr: TicketDef;
  ticketType: TicketTypeDef;
  /** in minutes */
  timeSpent?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
  viaPortal: Scalars['Boolean']['output'];
  visibilityOverridden: Scalars['Boolean']['output'];
  visibilityScope: TicketTicketVisibilityScopeChoices;
  washingReturnOf?: Maybe<TicketDef>;
  wasteVolumeEstimate?: Maybe<Scalars['Float']['output']>;
  wasteWeightEstimate?: Maybe<Scalars['Float']['output']>;
};


export type BulkWastePickupTicketDefItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type BulkWastePickupTicketItemDef = Node & {
  __typename: 'BulkWastePickupTicketItemDef';
  estimatedVolume?: Maybe<Scalars['Int']['output']>;
  estimatedWeight?: Maybe<Scalars['Int']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  ticket: BulkWastePickupTicketDef;
  wasteFraction: WasteFractionType;
};

export type BulkWastePickupTicketItemDefConnection = {
  __typename: 'BulkWastePickupTicketItemDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BulkWastePickupTicketItemDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `BulkWastePickupTicketItemDef` and its cursor. */
export type BulkWastePickupTicketItemDefEdge = {
  __typename: 'BulkWastePickupTicketItemDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BulkWastePickupTicketItemDef>;
};

export type BulkWastePickupTicketItemInput = {
  estimatedVolume?: InputMaybe<Scalars['Int']['input']>;
  estimatedWeight?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  wasteFraction: Scalars['ID']['input'];
};

export type BusinessAnalyticsType = {
  __typename: 'BusinessAnalyticsType';
  co2Reduction?: Maybe<ComparisonType>;
  comparisonCostOverview?: Maybe<Array<Maybe<CostOverviewType>>>;
  comparisonDistance?: Maybe<ComparisonType>;
  comparisonSaving?: Maybe<ComparisonType>;
  costOverview?: Maybe<Array<Maybe<CostOverviewType>>>;
  costPerEmptyingAvg?: Maybe<Scalars['Int']['output']>;
  decreasedCollections?: Maybe<Scalars['Float']['output']>;
  decreasedOverflowingBins?: Maybe<Scalars['Float']['output']>;
  estimatedSavings?: Maybe<Scalars['Float']['output']>;
  fillLevelEfficiency?: Maybe<ComparisonType>;
  reduceOverflows?: Maybe<ComparisonType>;
  reducedCollections?: Maybe<ComparisonType>;
  stats?: Maybe<StatsType>;
};


export type BusinessAnalyticsTypeComparisonCostOverviewArgs = {
  comparisonFrom: Scalars['DateTime']['input'];
  comparisonTo: Scalars['DateTime']['input'];
  periodType: Scalars['String']['input'];
};


export type BusinessAnalyticsTypeCostOverviewArgs = {
  From: Scalars['DateTime']['input'];
  To: Scalars['DateTime']['input'];
};


export type BusinessAnalyticsTypeEstimatedSavingsArgs = {
  From: Scalars['DateTime']['input'];
  To: Scalars['DateTime']['input'];
  comparisonFrom: Scalars['DateTime']['input'];
  comparisonTo: Scalars['DateTime']['input'];
};


export type BusinessAnalyticsTypeFillLevelEfficiencyArgs = {
  From: Scalars['DateTime']['input'];
  To: Scalars['DateTime']['input'];
  comparisonFrom: Scalars['DateTime']['input'];
  comparisonTo: Scalars['DateTime']['input'];
  periodType: Scalars['String']['input'];
};


export type BusinessAnalyticsTypeStatsArgs = {
  From: Scalars['DateTime']['input'];
  To: Scalars['DateTime']['input'];
};

/** An enumeration. */
export enum BusinessRegistryBusinessRegistryConfigRegistryTypeChoices {
  /** FI – YTJ */
  FI_YTJ = 'FI_YTJ',
  /** NO – Brreg */
  NO_BRREG = 'NO_BRREG'
}

export type BusinessRegistryConfigDef = Node & {
  __typename: 'BusinessRegistryConfigDef';
  /** FI YTJ only: whether the registry also manages e-invoice fields. */
  eInvoiceEnabled: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  registryType: BusinessRegistryBusinessRegistryConfigRegistryTypeChoices;
  syncEnabled: Scalars['Boolean']['output'];
  /** Ticket type to create when a contact mismatch is detected */
  ticketType?: Maybe<TicketTypeDef>;
};

/**
 * One weekday row of the calendar board (SBX-360). Counts are
 * exact; only the map-dot list is capped, and ``stops_truncated``
 * says so honestly.
 *
 * SBX-495 (rewalk finding 6): ``bins`` stays the standing rhythm
 * count (every weekday the calendar names, cadence-blind);
 * ``bins_this_week`` is the SHOWN week's true workload per the
 * bins' cadences, with the unprovable share in
 * ``bins_this_week_unknown``, never silently mixed in.
 */
export type CalendarBoardDayDef = {
  __typename: 'CalendarBoardDayDef';
  bins: Scalars['Int']['output'];
  /** SBX-495: bins provably collecting this weekday in the shown week (cadence-true, W2/W4/W8 rhythms honored). */
  binsThisWeek: Scalars['Int']['output'];
  /** SBX-495: bins whose shown-week membership the board cannot prove (season config errors, missing cadence fields); when nonzero, weekCounts.exact is false. */
  binsThisWeekUnknown: Scalars['Int']['output'];
  /** Waste fraction name -> exact bin count. */
  byFraction?: Maybe<Scalars['GenericScalar']['output']>;
  /** SBX-495: waste fraction name -> bins provably collecting this weekday in the shown week. */
  byFractionThisWeek?: Maybe<Scalars['GenericScalar']['output']>;
  /** [{scheme_id, scheme, bins}] exact scheme-membership split (Container.route_scheme); scheme_id null collects the unassigned bins. */
  byScheme?: Maybe<Scalars['GenericScalar']['output']>;
  /** SBX-496: occurrences moved ONTO this weekday in the shown week (including deliveries from a deviation window outside the week: the receiving week absorbs, and says so). */
  movedIn: Scalars['Int']['output'];
  /** SBX-496: occurrences moved AWAY from this weekday in the shown week by deviation windows (the tiles move with the banner). */
  movedOut: Scalars['Int']['output'];
  stops: Array<CalendarBoardStopDef>;
  stopsTruncated: Scalars['Boolean']['output'];
  weekday: Scalars['String']['output'];
};

/**
 * The per-weekday view of the LIVE container collection calendars
 * (SBX-360): the platform's own weekday truth
 * (``Container.collection_calendar``), read-only (D18).
 */
export type CalendarBoardDef = {
  __typename: 'CalendarBoardDef';
  /** SBX-495 (rewalk finding 6): the per-fraction cadence mix, {by_fraction: [{fraction, cadences: [{cadence, bins}]}], unknown_cadence_bins}, so the surface renders the W1/W2/W4/W8 rhythm beside each fraction. */
  cadence?: Maybe<Scalars['GenericScalar']['output']>;
  days: Array<CalendarBoardDayDef>;
  planningArea: PlanningAreaDef;
  /** Live containers whose calendar names at least one weekday. */
  scheduledBins: Scalars['Int']['output'];
  /** SBX-377 season dimension: asOf date, combined (seasonal) bin count, bins whose weekday set varies by season, out-of-season bins (they also ride the unscheduled count; this block says why), period configuration errors, and active_periods (follow-ups mini-wave): the NAMED windows in force on asOf, [{period_id, label, bins}] with exact counts, largest first, so the board renders which season it is showing instead of the bare date. */
  seasons?: Maybe<Scalars['GenericScalar']['output']>;
  stopCap: Scalars['Int']['output'];
  /** Live containers with no live calendar weekday; surfaced so the board never silently drops bins. */
  unscheduledBins: Scalars['Int']['output'];
  /** SBX-363 deviation-week view (present when the week argument was given): the selected week, the standing platform deviations overlapping it (window, to-periods, exact scheduled-bin counts) and the total bins affected; dots of named calendars carry deviated: true. */
  week?: Maybe<Scalars['GenericScalar']['output']>;
  /** SBX-495: the shown week's exactness verdict, {week_start, week_end, exact, approximations}. exact is the ONLY licence for a 'Counts are exact' badge; any approximated shown-week membership makes it false, with per-reason bin counts in approximations. */
  weekCounts?: Maybe<Scalars['GenericScalar']['output']>;
};

/**
 * One map dot on the calendar board (SBX-360): a live container
 * on the weekday its collection calendar names.
 */
export type CalendarBoardStopDef = {
  __typename: 'CalendarBoardStopDef';
  /** SBX-495: the bin's rhythm chip (W1, W2, W8, 2xW1); null when the platform fields cannot express one. */
  cadence?: Maybe<Scalars['String']['output']>;
  /** SBX-495: whether this bin provably collects on this weekday IN THE SHOWN WEEK per its cadence; null when the board cannot prove it. */
  collectsThisWeek?: Maybe<Scalars['Boolean']['output']>;
  containerId: Scalars['Int']['output'];
  /** SBX-363: in the deviation-week view (week argument), a standing platform deviation overlapping that week names this bin's calendar. */
  deviated?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  /** SBX-377: the bin's weekday set differs between calendar periods (its collection day depends on the season). */
  seasonVarying?: Maybe<Scalars['Boolean']['output']>;
  /** SBX-377: the bin rides a COMBINED (seasonal) calendar; its weekdays come from the period active on the board's asOf date. */
  seasonal?: Maybe<Scalars['Boolean']['output']>;
  /** The board bucket's weekday (the dot's color). */
  weekday: Scalars['String']['output'];
  /** The container's full current weekday cohort; multi-day bins dot every weekday they collect on. */
  weekdays: Array<Scalars['String']['output']>;
};

/**
 * COMPASS-1773: cancel a live suspension. The window stops applying
 * at once (future dates are collected again by the next generation run)
 * and the stops it released are put back where the world has not moved
 * on since — a stop whose route has started, completed or vanished, or
 * whose day has been re-planned, is reported in ``skipped`` instead of
 * forced.
 */
export type CancelAgreementSuspension = {
  __typename: 'CancelAgreementSuspension';
  agreement?: Maybe<AgreementDef>;
  restoredStops: Scalars['Int']['output'];
  /** One human-readable reason per stop NOT put back. */
  skipped: Array<Scalars['String']['output']>;
  suspension?: Maybe<AgreementSuspensionDef>;
};

/** Abandon a promotion any time before materialization. */
export type CancelPromotionMutation = {
  __typename: 'CancelPromotionMutation';
  promotion?: Maybe<PromotionDef>;
};

/** Close an open purchase order; received quantities stay. */
export type CancelPurchaseOrder = {
  __typename: 'CancelPurchaseOrder';
  purchaseOrder?: Maybe<PurchaseOrderType>;
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Group-cancel a planned relocation before its moving date — every
 * composed write reversed through its own mechanism (req 3.1.38).
 */
export type CancelRelocation = {
  __typename: 'CancelRelocation';
  relocation?: Maybe<RelocationDef>;
};

/** Cancel a PENDING scheduled customer-data change (req 3.1.38). */
export type CancelScheduledChange = {
  __typename: 'CancelScheduledChange';
  scheduledChange?: Maybe<ScheduledChangeDef>;
};

/**
 * Session 4 CI-1 (SBX-493/SBX-502): cancel is truthful. A run
 * still queued, building its matrix or solving is TRULY canceled:
 * the row flips under a lock and the worker checks it at every
 * stage boundary and again inside the plan-record transaction, so
 * an accepted cancel means no plan will arrive. A run past the
 * point of no return (scoring or explaining, or already done)
 * REFUSES the cancel through the D6 transport (run_just_finished)
 * instead of accepting and delivering a plan anyway, which is
 * exactly the lie the walk caught.
 */
export type CancelSimulationJobMutation = {
  __typename: 'CancelSimulationJobMutation';
  simulationJob?: Maybe<SimulationJobDef>;
};

export type CancelTransferDocument = {
  __typename: 'CancelTransferDocument';
  transferDocument?: Maybe<TransferDocumentType>;
};

/**
 * RS-E20/RS-E21: one detected table region with its stage B
 * class verdict. ``sample_rows`` is bounded server-side; full file
 * content never crosses GraphQL.
 */
export type CandidateTableDef = Node & {
  __typename: 'CandidateTableDef';
  classifier: Scalars['String']['output'];
  columnCount: Scalars['Int']['output'];
  columnStats: Scalars['JSONString']['output'];
  confidence: Scalars['Float']['output'];
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedBy?: Maybe<UserType>;
  confirmedClass?: Maybe<RouteStudioCandidateTableConfirmedClassChoices>;
  createdAt: Scalars['DateTime']['output'];
  docClass: RouteStudioCandidateTableDocClassChoices;
  /** The operator's confirmed class when present, else the classifier's verdict. */
  effectiveClass?: Maybe<Scalars['String']['output']>;
  file: ImportFileDef;
  header: Scalars['JSONString']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importBatch?: Maybe<ImportBatchDef>;
  needsConfirmation: Scalars['Boolean']['output'];
  questions: CaseQuestionDefConnection;
  region: Scalars['JSONString']['output'];
  regionIndex: Scalars['Int']['output'];
  rowCount: Scalars['Int']['output'];
  sampleRows: Scalars['JSONString']['output'];
  signals: Scalars['JSONString']['output'];
  tabIndex: Scalars['Int']['output'];
  tabName: Scalars['String']['output'];
};


/**
 * RS-E20/RS-E21: one detected table region with its stage B
 * class verdict. ``sample_rows`` is bounded server-side; full file
 * content never crosses GraphQL.
 */
export type CandidateTableDefQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CandidateTableDefConnection = {
  __typename: 'CandidateTableDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CandidateTableDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CandidateTableDef` and its cursor. */
export type CandidateTableDefEdge = {
  __typename: 'CandidateTableDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CandidateTableDef>;
};

/** An enumeration. */
export enum CardConfigOptions {
  CONTAINER_LEVEL_STOP = 'container_level_stop',
  DEPOT_STOP = 'depot_stop',
  EMPTYING_STOP = 'emptying_stop',
  PROPERTY_LEVEL_STOP = 'property_level_stop',
  WASTE_STATION_STOP = 'waste_station_stop'
}

export type CardPaymentMethodDef = Node & {
  __typename: 'CardPaymentMethodDef';
  brand: Scalars['String']['output'];
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
  paymentmethodPtr: PaymentMethodDef;
};

/**
 * PRO-280 (H4 / decision 11): what happens to a parent area's carve-outs
 * when it is terminated. Required only when the area has live carve-outs;
 * there is no default (the office chooses explicitly).
 */
export enum CarveOutTerminationDisposition {
  PROMOTE_TO_STANDALONE = 'PROMOTE_TO_STANDALONE',
  TERMINATE_WITH = 'TERMINATE_WITH'
}

/**
 * RS-E24: the manifest as one payload; ``summary`` and
 * ``gap_prompts`` speak the D62 sentence shape.
 */
export type CaseManifestDef = {
  __typename: 'CaseManifestDef';
  /** Every non-optional requirement satisfied or explicitly marked unavailable (D62: every gap has an owner), or expected from the platform by the declared import purpose (SBX-521: the declaration owns the gap). */
  allGapsOwned: Scalars['Boolean']['output'];
  /** Requirements currently blocking materialization. */
  blocking?: Maybe<Array<Scalars['String']['output']>>;
  case: ImportCaseDef;
  gapPrompts?: Maybe<Array<Scalars['String']['output']>>;
  /** Every non-optional requirement satisfied by data. */
  green: Scalars['Boolean']['output'];
  /** SBX-521 + session-5 F5: the needs-coverage truth: {purpose, needs: [{requirement, label, optional, expectation, status, satisfied_by, unlocks, platform, fallback, note?}], declared_count, satisfied_count, headline, can: {preview, go_live}}. Render headline and the can sentences verbatim; the go-live door refuses from the same derivation, so panel and door cannot disagree. SBX-520: platform is {available, count, preview_sentence} (can the platform satisfy this need here and now, honest zeros) and fallback is the labeled mark-unavailable consequence; an open need offers upload always, use-my-WasteHero-data exactly when platform.available, and mark-unavailable always. */
  needsCoverage?: Maybe<Scalars['GenericScalar']['output']>;
  nodes?: Maybe<Array<ManifestNodeDef>>;
  summary: Scalars['String']['output'];
};

/**
 * RS-E25 (stage F, D56): one versioned materialization of a
 * case's confirmed claims. ``diff`` names the runs added, removed,
 * moved and changed versus the previous version, so a re-upload or
 * correction reads as its exact consequence, never a duplicate
 * world.
 */
export type CaseMaterializationDef = Node & {
  __typename: 'CaseMaterializationDef';
  anchorDate: Scalars['Date']['output'];
  case: ImportCaseDef;
  claimIds: Scalars['JSONString']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  diff: Scalars['JSONString']['output'];
  horizonMonths: Scalars['Int']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  promotions: PromotionDefConnection;
  /** Dated route-runs in this version. */
  runCount?: Maybe<Scalars['Int']['output']>;
  runs: MaterializedRunDefConnection;
  sourceMetrics: SourceMetricDefConnection;
  stats: Scalars['JSONString']['output'];
  validationVerdicts: ValidationVerdictDefConnection;
  version: Scalars['Int']['output'];
};


/**
 * RS-E25 (stage F, D56): one versioned materialization of a
 * case's confirmed claims. ``diff`` names the runs added, removed,
 * moved and changed versus the previous version, so a re-upload or
 * correction reads as its exact consequence, never a duplicate
 * world.
 */
export type CaseMaterializationDefPromotionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * RS-E25 (stage F, D56): one versioned materialization of a
 * case's confirmed claims. ``diff`` names the runs added, removed,
 * moved and changed versus the previous version, so a re-upload or
 * correction reads as its exact consequence, never a duplicate
 * world.
 */
export type CaseMaterializationDefRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * RS-E25 (stage F, D56): one versioned materialization of a
 * case's confirmed claims. ``diff`` names the runs added, removed,
 * moved and changed versus the previous version, so a re-upload or
 * correction reads as its exact consequence, never a duplicate
 * world.
 */
export type CaseMaterializationDefSourceMetricsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * RS-E25 (stage F, D56): one versioned materialization of a
 * case's confirmed claims. ``diff`` names the runs added, removed,
 * moved and changed versus the previous version, so a re-upload or
 * correction reads as its exact consequence, never a duplicate
 * world.
 */
export type CaseMaterializationDefValidationVerdictsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseMaterializationDefConnection = {
  __typename: 'CaseMaterializationDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CaseMaterializationDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CaseMaterializationDef` and its cursor. */
export type CaseMaterializationDefEdge = {
  __typename: 'CaseMaterializationDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CaseMaterializationDef>;
};

/**
 * RS-E29 (D63): the importer's plain-language readback, composed
 * deterministically server-side (the single source of truth for
 * the copy the UI shows; client-side narration is a fallback).
 * ``polished`` marks the strictly opt-in LLM smoothing (D54);
 * numerals always come from the composed state (RS-803), and any
 * polish failure degrades to the deterministic text with the
 * reason in ``polishNote``, never silently.
 */
export type CaseNarrationDef = {
  __typename: 'CaseNarrationDef';
  case: ImportCaseDef;
  /** The readback as five ordered sentences: uploaded, understood, have vs missing, verdict, next step. */
  humanReadable?: Maybe<Array<Scalars['String']['output']>>;
  /** Have vs missing: the completeness manifest with its D62 gap prompts, verbatim. */
  manifest?: Maybe<Scalars['GenericScalar']['output']>;
  /** ONE deterministic next step, derived from the same state the gates read. */
  nextStep?: Maybe<Scalars['String']['output']>;
  polishNote?: Maybe<Scalars['String']['output']>;
  polished: Scalars['Boolean']['output'];
  /** What we understood: grammar claims per kind in the decode engine's own evidence-cited sentences with their review state. */
  understood?: Maybe<Scalars['GenericScalar']['output']>;
  /** What you uploaded: files, tabs, class verdicts, humanized; {files, table_count, awaiting_confirmation, sentence}. SBX-518 (wave D17): each file entry carries families, one row per (tab, class) group of 2+ fragments {tab, doc_class, doc_class_label, count, confirmed, awaiting_confirmation, sentence}; render the family sentence instead of that family's per-tab lines. */
  uploaded?: Maybe<Scalars['GenericScalar']['output']>;
  /** The verdict: verification against the source, then the validation-room state (D61). */
  verdict?: Maybe<Scalars['GenericScalar']['output']>;
};

/**
 * Quality report v2 at case level (RS-E27, stage G): leads with
 * the category verdicts (wave I1), then the claims and questions
 * state (wave I2), then the verification verdicts. Machine-readable
 * fields plus the same story as ``human_readable`` sentences.
 */
export type CaseQualityReportDef = {
  __typename: 'CaseQualityReportDef';
  categorySummary: Scalars['String']['output'];
  /** Per candidate table: {file_name, tab, doc_class, confidence, confirmed, needs_confirmation}. THE leading section: what the files are. */
  categoryVerdicts?: Maybe<Scalars['GenericScalar']['output']>;
  /** {confirmed, corrected, proposed, rejected, open_conflicts}. */
  claims?: Maybe<Scalars['GenericScalar']['output']>;
  /** The report as ordered sentences, category first. */
  humanReadable?: Maybe<Array<Scalars['String']['output']>>;
  /** {open, deferred, answered}. */
  questions?: Maybe<Scalars['GenericScalar']['output']>;
  /** The newest materialization's verification summary, or {status: not_run}. */
  verification?: Maybe<Scalars['GenericScalar']['output']>;
};

/**
 * RS-E20 (stage D): one explicit question to the human; a
 * deferred question stays a visible open risk (D62). The
 * ``manifestNode`` ref (wave D1, SBX-437 item 9) is the
 * first-class node a manifest_gap question asks about, exposed
 * through ManifestNodeDef (client-safe fields only).
 */
export type CaseQuestionDef = Node & {
  __typename: 'CaseQuestionDef';
  answer?: Maybe<Scalars['JSONString']['output']>;
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  answeredBy?: Maybe<UserType>;
  candidateTable?: Maybe<CandidateTableDef>;
  case: ImportCaseDef;
  claim?: Maybe<GrammarClaimDef>;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  manifestNode?: Maybe<ManifestNodeDef>;
  options: Scalars['JSONString']['output'];
  question: Scalars['String']['output'];
  /** SBX-413: the manifest requirement a manifest_gap question owns, as a structured field (previously only buried inside the options payload); null for other question kinds. */
  requirement?: Maybe<Scalars['String']['output']>;
  status: RouteStudioCaseQuestionStatusChoices;
};

export type CaseQuestionDefConnection = {
  __typename: 'CaseQuestionDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CaseQuestionDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CaseQuestionDef` and its cursor. */
export type CaseQuestionDefEdge = {
  __typename: 'CaseQuestionDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CaseQuestionDef>;
};

/**
 * RS-E28 (stage H, D61): the validation room in one payload:
 * per-route side-by-side (source vs computed, discrepancies
 * itemized, current verdict) plus the sign-off progress and the
 * derived state. ``state`` is not_ready while the stage G gate
 * blocks the room (``reasons`` explains at category level, D62),
 * validation_ready while verdicts are incomplete or unwaived flags
 * remain, validated when the client has said "yes, this is my
 * routes" for every route (D61).
 */
export type CaseValidationDef = {
  __typename: 'CaseValidationDef';
  case: ImportCaseDef;
  materialization?: Maybe<CaseMaterializationDef>;
  /** {routes, confirmed, flagged, waived_flags, unwaived_flags, unreviewed, by_acceptance_label}. */
  progress?: Maybe<Scalars['GenericScalar']['output']>;
  /** Why the room is not open / not validated yet. */
  reasons?: Maybe<Array<Scalars['String']['output']>>;
  /** Per route identity (client labels only, D58): counts (stops/bins/runs, source vs computed), per-fraction rows, actuals observations, day pattern (source vs computed), itemized discrepancies and the current human verdict. */
  routes?: Maybe<Scalars['GenericScalar']['output']>;
  state: Scalars['String']['output'];
};

/**
 * RS-E27: the verification state of one materialization version
 * in one payload; the itemized rows ride ``allSourceMetrics``.
 */
export type CaseVerificationDef = {
  __typename: 'CaseVerificationDef';
  case: ImportCaseDef;
  materialization?: Maybe<CaseMaterializationDef>;
  /** {status, window, metrics, matches, discrepancies, observations, discrepant_scope_keys, notes}; status not_run before any verification. */
  summary?: Maybe<Scalars['GenericScalar']['output']>;
};

/**
 * Change a container's structured condition (PRO-391, 3.12.28).
 *
 * Writes are gated exactly like a container edit
 * (``CompanyRolePermission.check_edit``), mirroring
 * ``RecordContainerMaintenance``. Every change is logged in
 * ``condition_history`` (previous + new condition, who, when, an
 * optional note). ``raise_repair_ticket`` is honoured only when the NEW
 * condition type is itself configured to allow it
 * (``ConditionType.raises_repair_ticket``) - an admin decides which
 * conditions may raise a ticket, the caller only opts in per change.
 */
export type ChangeContainerCondition = {
  __typename: 'ChangeContainerCondition';
  conditionHistoryEvent?: Maybe<ContainerConditionHistoryType>;
  container?: Maybe<ContainerType>;
  repairTicketId?: Maybe<Scalars['ID']['output']>;
};

export type ChangePriorityActionDef = Node & {
  __typename: 'ChangePriorityActionDef';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  priority: TicketChangePriorityActionPriorityChoices;
  rule: AutopilotLegacyRuleType;
};

export type ChangePriorityActionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  priority: Scalars['String']['input'];
};

/**
 * Change the owner of a property (omistajanvaihto, REQ-499 / HSY req 86).
 *
 * Ends every currently open OWNER link on the property — individual and
 * company alike — at the effective instant and starts the new owner's link
 * at that same instant, in one transaction. The outgoing owner's row is kept
 * with its end date (history stays traceable); a previously scheduled owner
 * that never took effect is removed. If the new owner already holds
 * CO_OWNER on the property that link is ended too.
 *
 * ``effectiveDate`` is a calendar date. Today means "now"; any other day
 * means local midnight of that day. A future date schedules the hand-over:
 * the current owner stays active until then and the new owner shows as a
 * future link. A past date is accepted as a correction as long as it is
 * after the current owner's start date — billing already issued is not
 * re-resolved.
 *
 * ``transferPayerRole`` also moves PAYER to the new owner at the same
 * instant, but only when the outgoing owner is the payer. Invoices resolve
 * PAYER before OWNER, so this is what redirects billing when the two roles
 * sit on the same party; a property without a payer link is billed to its
 * owner and needs nothing extra.
 *
 * Requires create permission on the new link and delete permission on every
 * link that is ended.
 */
export type ChangePropertyOwner = {
  __typename: 'ChangePropertyOwner';
  contactProperty?: Maybe<ContactPropertyDef>;
  endedContactProperties: Array<ContactPropertyDef>;
  endedManagementCompanyProperties: Array<ManagementCompanyPropertyDef>;
  managementCompanyProperty?: Maybe<ManagementCompanyPropertyDef>;
  payerContactProperty?: Maybe<ContactPropertyDef>;
  payerManagementCompanyProperty?: Maybe<ManagementCompanyPropertyDef>;
};

/**
 * A route-day / emptying-interval change proposal (W2, decision D2).
 *
 * Company-walled; contractors are narrowed to their own hauler's
 * proposals (list resolver AND node access both funnel through
 * ``get_queryset``). Exposes current vs proposed values and the full
 * decision trail. ``applied_changes`` (the office-side apply breakdown)
 * is deliberately NOT masked from contractors — it references only
 * their own series' records.
 */
export type ChangeProposalDef = Node & {
  __typename: 'ChangeProposalDef';
  appliedChanges?: Maybe<Scalars['JSONString']['output']>;
  company: CompanyType;
  /** Names of the contract areas the proposal's route serves (via its stops; legacy-area fallback). Empty when the route's stops carry no area link. */
  contractAreaNames: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserType;
  currentValue: Scalars['String']['output'];
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  decidedBy?: Maybe<UserType>;
  /** Office-set date the change applies from (defaults to the proposed start date at decision time). NULL while pending and on rejections. */
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  /** Contractor the targeted route belongs to. Stamped from the route at propose time; proposals exist only on contractor-linked routes (D15). */
  hauler: HaulerDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  officeNote: Scalars['String']['output'];
  /** The date the contractor asks the change to apply from. */
  proposedStartDate: Scalars['Date']['output'];
  proposedValue: Scalars['String']['output'];
  /** The generated route (driving list) whose series the change targets. PROTECT keeps the audit trail intact — routes are soft-deleted in practice. */
  route: RouteType;
  /** The scheme that generates the route's series — the object the approval actually mutates (vehicle days / calendars). Resolved and validated at propose time. */
  routeScheme: RouteSchemeType;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ChangeProposalDefConnection = {
  __typename: 'ChangeProposalDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ChangeProposalDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ChangeProposalDef` and its cursor. */
export type ChangeProposalDefEdge = {
  __typename: 'ChangeProposalDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ChangeProposalDef>;
};

export type ChangeStatusActionDef = Node & {
  __typename: 'ChangeStatusActionDef';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  rule: AutopilotLegacyRuleType;
  status: TicketChangeStatusActionStatusChoices;
};

export type ChangeStatusActionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
};

export type ChannelPolicyDef = {
  __typename: 'ChannelPolicyDef';
  channel: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  perRecipientDailyCap?: Maybe<Scalars['Int']['output']>;
  quietEnd?: Maybe<Scalars['Time']['output']>;
  quietStart?: Maybe<Scalars['Time']['output']>;
};

export type CheckDeviceId = {
  __typename: 'CheckDeviceId';
  status?: Maybe<Scalars['String']['output']>;
};

export type CheckDriverEditableType = {
  __typename: 'CheckDriverEditableType';
  canEdit?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Record what the yard verified at the tip for one load. A verified
 * fraction that differs from the declared one needs a ``reasonCode``,
 * posts the reclassification surcharge event once
 * (``load-reclass:<classification pk>``) and re-issues the Waste
 * Transfer Note as a new revision; confirming the declared fraction
 * posts nothing. Office users and the company's own drivers; contractor
 * (hauler) logins are refused.
 */
export type ClassifyLoad = {
  __typename: 'ClassifyLoad';
  loadClassification?: Maybe<LoadClassificationDef>;
  surchargeEventId?: Maybe<Scalars['ID']['output']>;
  wasteTransferNote?: Maybe<WasteTransferNoteDef>;
};

/**
 * Office-only, audited: freeze a period's numbers (D9).
 *
 * Validation gate (R2-S11, decision R2-D17): when any settlement-relevant
 * event of the period cannot be priced, nothing is closed and the payload
 * carries ``blocked: true`` plus the blocking list — the GraphQL analogue
 * of a REST 409 + list. There is deliberately no ``force_close``: the
 * office fixes the listed events and closes again.
 */
export type CloseSettlementPeriod = {
  __typename: 'CloseSettlementPeriod';
  /** True when the close was refused because broken events block it (R2-D17); period/report are null and blockingIssues lists the events to fix. */
  blocked: Scalars['Boolean']['output'];
  /** The broken events; empty on a successful close. */
  blockingIssues: Array<SettlementBlockingIssueType>;
  period?: Maybe<SettlementPeriodType>;
  report?: Maybe<SettlementReportType>;
};

export type ClusteredContainerMapDef = {
  __typename: 'ClusteredContainerMapDef';
  areas?: Maybe<Array<AreaDef>>;
  clusters?: Maybe<Array<ContainerClusterDef>>;
  collectionCalendars?: Maybe<Array<CollectionCalendarDef>>;
  points?: Maybe<Array<ContainerMapPointDef>>;
  routeSchemes?: Maybe<Array<RouteSchemeType>>;
};

export type ClusteredPropertyMapDef = {
  __typename: 'ClusteredPropertyMapDef';
  clusters?: Maybe<Array<PropertyClusterDef>>;
  points?: Maybe<Array<PropertyPointMapDef>>;
  propertyTypes?: Maybe<Array<PropertyTypeDef>>;
  routeSchemes?: Maybe<Array<RouteSchemeType>>;
};

export type ClusteredTicketMapDef = {
  __typename: 'ClusteredTicketMapDef';
  clusters?: Maybe<Array<TicketClusterDef>>;
  points?: Maybe<Array<TicketMapPointDef>>;
  statuses?: Maybe<Array<TicketStatusDef>>;
  ticketTypes?: Maybe<Array<TicketTypeDef>>;
};

/**
 * One IN-FORCE contract area of a contractor (validity window
 * covers the requested day). Legacy areas (no validFrom) never appear
 * here — their stops are in the contractor's outsideContractAreas
 * bucket.
 */
export type CockpitAreaRowDef = {
  __typename: 'CockpitAreaRowDef';
  /** Relay id of the AreaDef node. */
  areaId: Scalars['ID']['output'];
  areaName: Scalars['String']['output'];
  completedStops: Scalars['Int']['output'];
  missedCustomerFault: Scalars['Int']['output'];
  missedExternalFault: Scalars['Int']['output'];
  missedHaulerFault: Scalars['Int']['output'];
  /** Misses per 1000 scheduled stops on the day. NULL when nothing was scheduled (never a fake 0). */
  missedPer1000?: Maybe<Scalars['Float']['output']>;
  missedTotal: Scalars['Int']['output'];
  openExceptions: Scalars['Int']['output'];
  overdueMisses: Scalars['Int']['output'];
  /** Relay ids (RouteType) of the routes with stops in this area today — for FE click-through to the live board. */
  routeIds: Array<Scalars['ID']['output']>;
  scheduledStops: Scalars['Int']['output'];
  validFrom: Scalars['Date']['output'];
  /** NULL = open-ended. */
  validTo?: Maybe<Scalars['Date']['output']>;
};

/**
 * An honest catch-all bucket: stops/misses that belong to no
 * contract-area row (no contract area, out-of-force or legacy area,
 * or — at the top level — no attributable contractor). Shown, never
 * hidden.
 */
export type CockpitBucketDef = {
  __typename: 'CockpitBucketDef';
  completedStops: Scalars['Int']['output'];
  missedTotal: Scalars['Int']['output'];
  openExceptions: Scalars['Int']['output'];
  scheduledStops: Scalars['Int']['output'];
};

/**
 * One contractor's operational day. A triage view — NEVER a
 * settlement figure (settlement is measured per contract area).
 */
export type CockpitContractorRowDef = {
  __typename: 'CockpitContractorRowDef';
  /** ONLY contract areas in force on the day. */
  areas: Array<CockpitAreaRowDef>;
  /** Mean age of the still-open missed collections. NULL when none are open. */
  avgOpenMissAgeMinutes?: Maybe<Scalars['Int']['output']>;
  /** Mean open-to-resolved time of the day's resolved missed collections. NULL when none were resolved. */
  avgResolvedMissMinutes?: Maybe<Scalars['Int']['output']>;
  completedStops: Scalars['Int']['output'];
  /** Relay id of the HaulerDef node. */
  haulerId: Scalars['ID']['output'];
  haulerName: Scalars['String']['output'];
  missedCustomerFault: Scalars['Int']['output'];
  missedExternalFault: Scalars['Int']['output'];
  missedHaulerFault: Scalars['Int']['output'];
  /** Misses per 1000 scheduled stops on the day. NULL when nothing was scheduled (never a fake 0). */
  missedPer1000?: Maybe<Scalars['Float']['output']>;
  missedTotal: Scalars['Int']['output'];
  /** routesCompletedOnPlan over completed routes WITH a derivable plan, ×100. NULL when no completed route has a plan (never a fake 0). */
  onTimePct?: Maybe<Scalars['Float']['output']>;
  openExceptions: Scalars['Int']['output'];
  /** Stops/misses on no contract area or on a legacy / out-of-force area — the honest bucket, never hidden. NULL when there is nothing outside. */
  outsideContractAreas?: Maybe<CockpitBucketDef>;
  /** Open missed collections past their return-by SLA deadline. */
  overdueMisses: Scalars['Int']['output'];
  /** Active routes the #12 forecast classifies at_risk. ESTIMATES — the FE must label them. */
  predictedAtRisk: Scalars['Int']['output'];
  /** Active routes the #12 forecast classifies late. ESTIMATES — the FE must label them. */
  predictedLate: Scalars['Int']['output'];
  /** Relay ids (RouteType) of the contractor's routes on the day — for FE click-through. */
  routeIds: Array<Scalars['ID']['output']>;
  routesCompleted: Scalars['Int']['output'];
  /** Completed routes that finished by their planned end (scheduledDay + endTime; fallback startedAt + totalDuration). */
  routesCompletedOnPlan: Scalars['Int']['output'];
  routesTotal: Scalars['Int']['output'];
  /** Routes with NO derivable planned end — on-time cannot be measured for these (surfaced, never counted as 0%). */
  routesWithoutPlan: Scalars['Int']['output'];
  scheduledStops: Scalars['Int']['output'];
};

export type CollectionCalendarDateDef = Node & {
  __typename: 'CollectionCalendarDateDef';
  collectionCalendar: CollectionCalendarDef;
  collectionDate: Scalars['Date']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CollectionCalendarDateDefConnection = {
  __typename: 'CollectionCalendarDateDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CollectionCalendarDateDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CollectionCalendarDateDef` and its cursor. */
export type CollectionCalendarDateDefEdge = {
  __typename: 'CollectionCalendarDateDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CollectionCalendarDateDef>;
};

export type CollectionCalendarDateEventDef = Node & {
  __typename: 'CollectionCalendarDateEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  collectionCalendarDate?: Maybe<CollectionCalendarDateDef>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<CollectionCalendarDateEventTypesGraphene>>>;
  fromCollectionCalendar?: Maybe<CollectionCalendarDef>;
  fromCollectionDate?: Maybe<Scalars['Date']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toCollectionCalendar?: Maybe<CollectionCalendarDef>;
  toCollectionDate?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<UserType>;
};

export enum CollectionCalendarDateEventTypesGraphene {
  COLLECTION_CALENDAR_CHANGE = 'COLLECTION_CALENDAR_CHANGE',
  COLLECTION_DATE_CHANGE = 'COLLECTION_DATE_CHANGE',
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  SOFT_DELETED = 'SOFT_DELETED'
}

export type CollectionCalendarDef = Node & {
  __typename: 'CollectionCalendarDef';
  /** It determines whether the collection calendar can only function as part of the combined collection calendars and not as a standalone collection calendar. */
  allowUsageInCombinedCalendarsOnly: Scalars['Boolean']['output'];
  collectioncalendardateSet: CollectionCalendarDateDefConnection;
  collectioncalendardeviationSet: CollectionCalendarDeviationDefConnection;
  combinedCollectionCalendars?: Maybe<Array<Maybe<CollectionCalendarPeriodDef>>>;
  containerSet: ContainerTypeConnection;
  containersCount?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  determinePeriodBy: RoutesCollectionCalendarDeterminePeriodByChoices;
  /** Further calendars the container is emptied on, beside ``collection_calendar``. A bin can stand on several of the customer's routes; the primary one drives planning, these are what an integration reads to see every route the bin is on. */
  extraContainers: ContainerTypeConnection;
  fromDate: Scalars['Date']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isCombined?: Maybe<Scalars['Boolean']['output']>;
  latestCollectionCalendarDate?: Maybe<Scalars['Date']['output']>;
  managecontainerticketSet: ManageContainerTicketDefConnection;
  /** Id of this calendar's route in the system it was migrated from (e.g. the ISY ProAktiv ruteId). */
  migratedFromId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pickupSettings: PickupSettingsType;
  /** The route's functional number in the customer's own system (e.g. the ISY ProAktiv ruteNr). */
  routeNumber?: Maybe<Scalars['String']['output']>;
  routeschemeSet: RouteSchemeTypeConnection;
  week: CollectionCalendarWeekDef;
  /** Weekdays when the pickup is happening, applicable only if the calendar is not combined. */
  weekdays: Array<Scalars['String']['output']>;
};


export type CollectionCalendarDefCollectioncalendardateSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCalendarDefCollectioncalendardeviationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCalendarDefContainerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCalendarDefExtraContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCalendarDefManagecontainerticketSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCalendarDefRouteschemeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectionCalendarDefConnection = {
  __typename: 'CollectionCalendarDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CollectionCalendarDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CollectionCalendarDef` and its cursor. */
export type CollectionCalendarDefEdge = {
  __typename: 'CollectionCalendarDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CollectionCalendarDef>;
};

export type CollectionCalendarDeviationDef = Node & {
  __typename: 'CollectionCalendarDeviationDef';
  /** Limit the deviation to properties in these areas. */
  areas: AreaDefConnection;
  collectionCalendars: CollectionCalendarDefConnection;
  collectioncalendardeviationtoperiodSet: CollectionCalendarDeviationToPeriodDefConnection;
  company: CompanyType;
  /** Limit the deviation to these containers. */
  containers: ContainerTypeConnection;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['Date']['output'];
  /** Areas that keep collecting during the period. */
  excludedAreas: AreaDefConnection;
  /** Containers that keep collecting during the period. */
  excludedContainers: ContainerTypeConnection;
  /** Properties that keep collecting during the period. */
  excludedProperties: PropertyDefConnection;
  /** Property groups that keep collecting during the period. */
  excludedPropertyGroups: PropertyGroupDefConnection;
  existingRoutesAction?: Maybe<Scalars['String']['output']>;
  futureCollectionsAction?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  periods?: Maybe<Array<Maybe<CollectionCalendarDeviationToPeriodDef>>>;
  /** Limit the deviation to these properties. */
  properties: PropertyDefConnection;
  /** Limit the deviation to these property groups. */
  propertyGroups: PropertyGroupDefConnection;
  /** Limit the deviation to these route schemes. */
  routeSchemes: RouteSchemeTypeConnection;
  startDate: Scalars['Date']['output'];
};


export type CollectionCalendarDeviationDefAreasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCalendarDeviationDefCollectionCalendarsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCalendarDeviationDefCollectioncalendardeviationtoperiodSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCalendarDeviationDefContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCalendarDeviationDefExcludedAreasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCalendarDeviationDefExcludedContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCalendarDeviationDefExcludedPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCalendarDeviationDefExcludedPropertyGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCalendarDeviationDefPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCalendarDeviationDefPropertyGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCalendarDeviationDefRouteSchemesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectionCalendarDeviationDefConnection = {
  __typename: 'CollectionCalendarDeviationDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CollectionCalendarDeviationDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CollectionCalendarDeviationDef` and its cursor. */
export type CollectionCalendarDeviationDefEdge = {
  __typename: 'CollectionCalendarDeviationDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CollectionCalendarDeviationDef>;
};

export type CollectionCalendarDeviationToPeriodDef = Node & {
  __typename: 'CollectionCalendarDeviationToPeriodDef';
  collectionCalendarDeviation: CollectionCalendarDeviationDef;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  routeSchemes: RouteSchemeTypeConnection;
  toEndDate: Scalars['Date']['output'];
  toStartDate: Scalars['Date']['output'];
};


export type CollectionCalendarDeviationToPeriodDefRouteSchemesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectionCalendarDeviationToPeriodDefConnection = {
  __typename: 'CollectionCalendarDeviationToPeriodDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CollectionCalendarDeviationToPeriodDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CollectionCalendarDeviationToPeriodDef` and its cursor. */
export type CollectionCalendarDeviationToPeriodDefEdge = {
  __typename: 'CollectionCalendarDeviationToPeriodDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CollectionCalendarDeviationToPeriodDef>;
};

export type CollectionCalendarDeviationToPeriodInput = {
  routeSchemes: Array<InputMaybe<Scalars['ID']['input']>>;
  toEndDate: Scalars['Date']['input'];
  toStartDate: Scalars['Date']['input'];
};

export type CollectionCalendarEventDef = Node & {
  __typename: 'CollectionCalendarEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  collectionCalendar?: Maybe<CollectionCalendarDef>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<CollectionCalendarEventTypesGraphene>>>;
  fromAllowUsageInCombinedCalendarsOnly?: Maybe<Scalars['Boolean']['output']>;
  fromDeterminePeriodBy?: Maybe<Scalars['String']['output']>;
  fromFromDate?: Maybe<Scalars['Date']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  fromPickupsSetting?: Maybe<PickupSettingsType>;
  fromWeek?: Maybe<CollectionCalendarWeekDef>;
  fromWeekdays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toAllowUsageInCombinedCalendarsOnly?: Maybe<Scalars['Boolean']['output']>;
  toDeterminePeriodBy?: Maybe<Scalars['String']['output']>;
  toFromDate?: Maybe<Scalars['Date']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
  toPickupsSetting?: Maybe<PickupSettingsType>;
  toWeek?: Maybe<CollectionCalendarWeekDef>;
  toWeekdays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  user?: Maybe<UserType>;
};

export enum CollectionCalendarEventTypesGraphene {
  ALLOW_USAGE_IN_COMBINED_CALENDARS_ONLY_CHANGE = 'ALLOW_USAGE_IN_COMBINED_CALENDARS_ONLY_CHANGE',
  DETERMINE_PERIOD_BY_CHANGE = 'DETERMINE_PERIOD_BY_CHANGE',
  FROM_DATE_CHANGE = 'FROM_DATE_CHANGE',
  NAME_CHANGE = 'NAME_CHANGE',
  WEEKDAYS_CHANGE = 'WEEKDAYS_CHANGE',
  WEEK_CHANGE = 'WEEK_CHANGE'
}

export type CollectionCalendarPeriodDef = Node & {
  __typename: 'CollectionCalendarPeriodDef';
  /** Calendar that is used as a base for this combined calendar. */
  basicCalendar: CollectionCalendarDef;
  /** Regular calendar that is combined into this calendar. */
  combinedCalendar: CollectionCalendarDef;
  endDate?: Maybe<Scalars['Date']['output']>;
  endWeekNumber?: Maybe<Scalars['Int']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  startWeekNumber?: Maybe<Scalars['Int']['output']>;
};

export type CollectionCalendarPeriodInput = {
  combinedCalendar?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endWeekNumber?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startWeekNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectionCalendarWeekDef = Node & {
  __typename: 'CollectionCalendarWeekDef';
  collectioncalendarSet: CollectionCalendarDefConnection;
  company: CompanyType;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startWeekNumber?: Maybe<Scalars['Int']['output']>;
};


export type CollectionCalendarWeekDefCollectioncalendarSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectionCalendarWeekDefConnection = {
  __typename: 'CollectionCalendarWeekDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CollectionCalendarWeekDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CollectionCalendarWeekDef` and its cursor. */
export type CollectionCalendarWeekDefEdge = {
  __typename: 'CollectionCalendarWeekDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CollectionCalendarWeekDef>;
};

/**
 * REQ-86 / 3.5.12: suggested collection dates for a container plus the
 * source they were resolved from (the active agreement's calendar, else the
 * container's route scheme).
 */
export type CollectionDateSuggestionType = {
  __typename: 'CollectionDateSuggestionType';
  agreement?: Maybe<AgreementDef>;
  source?: Maybe<Scalars['String']['output']>;
  suggestedDates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
};

/**
 * PRO-773: what a deviation will do, computed from the SAME resolution
 * route generation uses — the screen can never promise something generation
 * will not do.
 *
 * ``planned_stops`` (work that already exists) and
 * ``collections_suppressed``/``collections_moved`` (work not planned yet)
 * are reported SEPARATELY and never summed: a deviation created for next
 * week lands on existing routes, one created for next Christmas lands on
 * nothing yet, and one number for both would be misleading in both cases.
 */
export type CollectionDeviationImpactDef = {
  __typename: 'CollectionDeviationImpactDef';
  collectionsMoved: Scalars['Int']['output'];
  collectionsSuppressed: Scalars['Int']['output'];
  completedStops: Scalars['Int']['output'];
  containers: Scalars['Int']['output'];
  moveExamples: Array<Maybe<Scalars['String']['output']>>;
  plannedStops: Scalars['Int']['output'];
  properties: Scalars['Int']['output'];
  routes: Scalars['Int']['output'];
  warnings: Array<Maybe<Scalars['String']['output']>>;
};

/**
 * PRO-773: a CANDIDATE deviation, saved or not.
 *
 * Mirrors the mutation's input so the office can ask "what would this do"
 * before committing. Every id list is optional; all of them empty means the
 * deviation covers the whole company.
 */
export type CollectionDeviationImpactInput = {
  areas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  collectionCalendars?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  excludedAreas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludedContainers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludedProperties?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludedPropertyGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  existingRoutesAction?: InputMaybe<Scalars['String']['input']>;
  futureCollectionsAction?: InputMaybe<Scalars['String']['input']>;
  periods?: InputMaybe<Array<InputMaybe<CollectionCalendarDeviationToPeriodInput>>>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate: Scalars['Date']['input'];
};

export type CollectionInquiryType = Node & {
  __typename: 'CollectionInquiryType';
  collectionMethod?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<CommentType>;
  contactAddress?: Maybe<LocationWithContainerType>;
  container?: Maybe<ContainerType>;
  createdAt: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<FileObjectType>>>;
  fromPickUpOrders: PickUpOrderTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  inquiryId: Scalars['UUID']['output'];
  inquiryTyping?: Maybe<CollectionInquiryTypingType>;
  issueType: RoutesCollectionInquiryIssueTypeChoices;
  location?: Maybe<LocationWithContainerType>;
  locationNotes?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  project?: Maybe<ProjectType>;
  reporter?: Maybe<UserType>;
  status?: Maybe<Scalars['String']['output']>;
  /** in minutes */
  timeSpent?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  voiceRecordFile: Scalars['String']['output'];
  wasteFraction?: Maybe<WasteFractionType>;
  /** Approximate of waste size, m³ */
  wasteVolume?: Maybe<Scalars['Float']['output']>;
  wasteWeightEstimate?: Maybe<Scalars['Float']['output']>;
};


export type CollectionInquiryTypeFromPickUpOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectionInquiryTypeConnection = {
  __typename: 'CollectionInquiryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CollectionInquiryTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CollectionInquiryType` and its cursor. */
export type CollectionInquiryTypeEdge = {
  __typename: 'CollectionInquiryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CollectionInquiryType>;
};

export type CollectionInquiryTypingType = Node & {
  __typename: 'CollectionInquiryTypingType';
  addTimeSpent: Scalars['Boolean']['output'];
  automaticallyAddToRoutes: Scalars['Boolean']['output'];
  collectioninquirySet: CollectionInquiryTypeConnection;
  defaultForUnhandledContainers: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: ProjectType;
  status: RoutesCollectionInquiryTypingStatusChoices;
};


export type CollectionInquiryTypingTypeCollectioninquirySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectionInquiryTypingTypeConnection = {
  __typename: 'CollectionInquiryTypingTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CollectionInquiryTypingTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CollectionInquiryTypingType` and its cursor. */
export type CollectionInquiryTypingTypeEdge = {
  __typename: 'CollectionInquiryTypingTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CollectionInquiryTypingType>;
};

/** A declared emptying location of a Shared Collection Point (NEXUS-538). */
export type CollectionLocationDef = Node & {
  __typename: 'CollectionLocationDef';
  container?: Maybe<ContainerType>;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Site-specific access/handover instructions. */
  lockInstructions: Scalars['String']['output'];
  /** The kind of key that opens this locked point. */
  lockKeyType?: Maybe<KeyTypeType>;
  /** Whether this emptying point is locked. */
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  physicalKeys: PhysicalKeyTypeConnection;
  point: Scalars['GeoJSON']['output'];
  propertyGroup: PropertyGroupDef;
};


/** A declared emptying location of a Shared Collection Point (NEXUS-538). */
export type CollectionLocationDefPhysicalKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectionLocationDefConnection = {
  __typename: 'CollectionLocationDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CollectionLocationDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CollectionLocationDef` and its cursor. */
export type CollectionLocationDefEdge = {
  __typename: 'CollectionLocationDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CollectionLocationDef>;
};

export type CollectionLocationEventDef = Node & {
  __typename: 'CollectionLocationEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<CollectionLocationEventTypesGraphene>>>;
  fromContainer?: Maybe<ContainerType>;
  fromName?: Maybe<Scalars['String']['output']>;
  fromNote?: Maybe<Scalars['String']['output']>;
  fromPoint?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toContainer?: Maybe<ContainerType>;
  toName?: Maybe<Scalars['String']['output']>;
  toNote?: Maybe<Scalars['String']['output']>;
  toPoint?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
};

export enum CollectionLocationEventTypesGraphene {
  CONTAINER_CHANGE = 'CONTAINER_CHANGE',
  NAME_CHANGE = 'NAME_CHANGE',
  NOTE_CHANGE = 'NOTE_CHANGE',
  POINT_CHANGE = 'POINT_CHANGE'
}

export type CommentType = Node & {
  __typename: 'CommentType';
  author?: Maybe<UserType>;
  comments?: Maybe<CollectionInquiryType>;
  /** Relation to the Comment */
  containers: ContainerTypeConnection;
  created: Scalars['DateTime']['output'];
  /** Relation to the Comment */
  depots: DepotTypeConnection;
  /** Relation to the Comment */
  drivers: DriverTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  route?: Maybe<RouteType>;
  terms?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** Relation to the Comment */
  vehicles: VehicleTypeConnection;
};


export type CommentTypeContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommentTypeDepotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommentTypeDriversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommentTypeVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CommentTypeConnection = {
  __typename: 'CommentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CommentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CommentType` and its cursor. */
export type CommentTypeEdge = {
  __typename: 'CommentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CommentType>;
};

export type CommitteePackResult = {
  __typename: 'CommitteePackResult';
  error?: Maybe<Scalars['String']['output']>;
  pack?: Maybe<Scalars['GenericScalar']['output']>;
};

export type CommonUserNotificationUnionDef = UserNotificationType;

export type CommonUserNotificationsWrapper = {
  __typename: 'CommonUserNotificationsWrapper';
  edges?: Maybe<Array<Maybe<CommonUserNotificationUnionDef>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * One communication channel's state for a Contact (staff view).
 *
 * Mirrors the portal REST shape so both surfaces expose the same store.
 */
export type CommsChannelDef = {
  __typename: 'CommsChannelDef';
  address?: Maybe<Scalars['String']['output']>;
  available: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type CommsChannelInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type CommsChannelsDef = {
  __typename: 'CommsChannelsDef';
  channels: Array<CommsChannelDef>;
  primaryChannel?: Maybe<Scalars['String']['output']>;
  restrictToSingle: Scalars['Boolean']['output'];
};

export type CompanyAddressType = {
  __typename: 'CompanyAddressType';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type CompanyContainerMetaTypeType = Node & {
  __typename: 'CompanyContainerMetaTypeType';
  company: CompanyType;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export type CompanyContainerMetaTypeTypeConnection = {
  __typename: 'CompanyContainerMetaTypeTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyContainerMetaTypeTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CompanyContainerMetaTypeType` and its cursor. */
export type CompanyContainerMetaTypeTypeEdge = {
  __typename: 'CompanyContainerMetaTypeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyContainerMetaTypeType>;
};

export type CompanyEInvoiceType = {
  __typename: 'CompanyEInvoiceType';
  address?: Maybe<Scalars['String']['output']>;
  operatorIdentifier?: Maybe<Scalars['String']['output']>;
  operatorName?: Maybe<Scalars['String']['output']>;
};

export type CompanyEmailAccountDef = Node & {
  __typename: 'CompanyEmailAccountDef';
  accessToken?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  attachmentsThreshold: Scalars['Int']['output'];
  authUrl?: Maybe<Scalars['String']['output']>;
  billingState: CoreCompanyEmailAccountBillingStateChoices;
  company: CompanyType;
  companyemailaccountmessageSet: CompanyEmailAccountMessageDefConnection;
  companyemailaccountruleSet: CompanyEmailAccountRuleDefConnection;
  companysettingsSet: CompanySettingsTypeConnection;
  email: Scalars['String']['output'];
  grantDeletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Grant represents the concept of 'connected accounts' in Nylas v3 */
  grantId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Synthetic account backing citizen-portal ('Beskeder') conversations. Has no Nylas grant_id; its messages are dispatched via the portal multi-channel notifier, never sent over Nylas email. One per company. */
  isPortal: Scalars['Boolean']['output'];
  needsReauth?: Maybe<Scalars['Boolean']['output']>;
  /** Account ID from Nylas v2 */
  providerId?: Maybe<Scalars['String']['output']>;
  sendState: CoreCompanyEmailAccountSendStateChoices;
  syncState: CoreCompanyEmailAccountSyncStateChoices;
};


export type CompanyEmailAccountDefCompanyemailaccountmessageSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyEmailAccountDefCompanyemailaccountruleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyEmailAccountDefCompanysettingsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyEmailAccountDefConnection = {
  __typename: 'CompanyEmailAccountDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyEmailAccountDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CompanyEmailAccountDef` and its cursor. */
export type CompanyEmailAccountDefEdge = {
  __typename: 'CompanyEmailAccountDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyEmailAccountDef>;
};

export type CompanyEmailAccountMessageAttachmentDef = Node & {
  __typename: 'CompanyEmailAccountMessageAttachmentDef';
  companyEmailAccountMessage: CompanyEmailAccountMessageDef;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  file: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  originalFileName?: Maybe<Scalars['String']['output']>;
};

export type CompanyEmailAccountMessageAttachmentDefConnection = {
  __typename: 'CompanyEmailAccountMessageAttachmentDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyEmailAccountMessageAttachmentDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CompanyEmailAccountMessageAttachmentDef` and its cursor. */
export type CompanyEmailAccountMessageAttachmentDefEdge = {
  __typename: 'CompanyEmailAccountMessageAttachmentDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyEmailAccountMessageAttachmentDef>;
};

export type CompanyEmailAccountMessageChangedSubscription = {
  __typename: 'CompanyEmailAccountMessageChangedSubscription';
  companyEmailAccountMessage?: Maybe<CompanyEmailAccountMessageDef>;
};

export type CompanyEmailAccountMessageDef = Node & {
  __typename: 'CompanyEmailAccountMessageDef';
  assignedTeam?: Maybe<TeamType>;
  assignee?: Maybe<UserType>;
  /** Tickets associated with the message */
  associatedTickets: TicketDefConnection;
  associatedTicketsCount?: Maybe<Scalars['Int']['output']>;
  attachments?: Maybe<Array<Maybe<CompanyEmailAccountMessageAttachmentDef>>>;
  body: Scalars['String']['output'];
  companyEmailAccount: CompanyEmailAccountDef;
  companyemailaccountmessageeventSet: CompanyEmailAccountMessageEventDefConnection;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorAt?: Maybe<Scalars['DateTime']['output']>;
  eventLog?: Maybe<CompanyEmailAccountMessageEventWrapper>;
  fromEmail: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isInbound?: Maybe<Scalars['Boolean']['output']>;
  isThreadStarter?: Maybe<Scalars['Boolean']['output']>;
  latestNotificationCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  notificationmessageSet: NotificationMessageDefConnection;
  notificationsLog?: Maybe<CommonUserNotificationsWrapper>;
  portalConversation?: Maybe<PortalConversationDef>;
  providerId?: Maybe<Scalars['String']['output']>;
  sendAt?: Maybe<Scalars['DateTime']['output']>;
  snippet: Scalars['String']['output'];
  status?: Maybe<CompanyEmailAccountMessageStatus>;
  subject?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  threadMessages: CompanyEmailAccountMessageDefConnection;
  threadStarter?: Maybe<CompanyEmailAccountMessageDef>;
  ticket?: Maybe<TicketDef>;
  ticketMessage?: Maybe<TicketMessageDef>;
  ticketdraftSet: TicketDraftDefConnection;
  toEmail?: Maybe<Scalars['String']['output']>;
  toEmailName?: Maybe<Scalars['String']['output']>;
  userNotifications: UserNotificationTypeConnection;
};


export type CompanyEmailAccountMessageDefAssociatedTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyEmailAccountMessageDefCompanyemailaccountmessageeventSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyEmailAccountMessageDefEventLogArgs = {
  addCompanyAccountEmailMessageEvents?: InputMaybe<Scalars['Boolean']['input']>;
  companyAccountEmailMessageEventTypes?: InputMaybe<Array<InputMaybe<CompanyEmailAccountMessageEventType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  isMessageInbound?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CompanyEmailAccountMessageDefNotificationmessageSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyEmailAccountMessageDefNotificationsLogArgs = {
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  directOnly?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  unseen?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyEmailAccountMessageDefThreadMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyEmailAccountMessageDefTicketdraftSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyEmailAccountMessageDefUserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyEmailAccountMessageDefConnection = {
  __typename: 'CompanyEmailAccountMessageDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyEmailAccountMessageDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CompanyEmailAccountMessageDef` and its cursor. */
export type CompanyEmailAccountMessageDefEdge = {
  __typename: 'CompanyEmailAccountMessageDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyEmailAccountMessageDef>;
};

export type CompanyEmailAccountMessageEventDef = Node & {
  __typename: 'CompanyEmailAccountMessageEventDef';
  company: CompanyType;
  companyEmailAccountMessage: CompanyEmailAccountMessageDef;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  createdByAction: Scalars['Boolean']['output'];
  eventType?: Maybe<CompanyEmailAccountMessageEventType>;
  fromAssignedTeam?: Maybe<TeamType>;
  fromAssignee?: Maybe<UserType>;
  fromAssociatedTickets: TicketDefConnection;
  fromStatus?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  toAssignedTeam?: Maybe<TeamType>;
  toAssignee?: Maybe<UserType>;
  toAssociatedTickets: TicketDefConnection;
  toStatus?: Maybe<Scalars['String']['output']>;
};


export type CompanyEmailAccountMessageEventDefFromAssociatedTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyEmailAccountMessageEventDefToAssociatedTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyEmailAccountMessageEventDefConnection = {
  __typename: 'CompanyEmailAccountMessageEventDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyEmailAccountMessageEventDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CompanyEmailAccountMessageEventDef` and its cursor. */
export type CompanyEmailAccountMessageEventDefEdge = {
  __typename: 'CompanyEmailAccountMessageEventDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyEmailAccountMessageEventDef>;
};

export type CompanyEmailAccountMessageEventLogEvent = CompanyEmailAccountMessageEventDef;

/** An enumeration. */
export enum CompanyEmailAccountMessageEventType {
  ASSIGNED_TEAM_CHANGED = 'ASSIGNED_TEAM_CHANGED',
  ASSIGNEE_CHANGED = 'ASSIGNEE_CHANGED',
  ASSOCIATED_TICKET_CREATED_AND_LINKED = 'ASSOCIATED_TICKET_CREATED_AND_LINKED',
  ASSOCIATED_TICKET_LINKED_EXISTING = 'ASSOCIATED_TICKET_LINKED_EXISTING',
  ASSOCIATED_TICKET_UNLINKED = 'ASSOCIATED_TICKET_UNLINKED',
  MESSAGE_RECEIVED = 'MESSAGE_RECEIVED',
  MESSAGE_SENT = 'MESSAGE_SENT',
  STATUS_CHANGED = 'STATUS_CHANGED'
}

export type CompanyEmailAccountMessageEventWrapper = {
  __typename: 'CompanyEmailAccountMessageEventWrapper';
  edges?: Maybe<Array<Maybe<CompanyEmailAccountMessageEventLogEvent>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum CompanyEmailAccountMessageStatus {
  COMPLETED = 'COMPLETED',
  NEW = 'NEW',
  OPEN = 'OPEN',
  REJECTED = 'REJECTED'
}

export type CompanyEmailAccountRuleDef = Node & {
  __typename: 'CompanyEmailAccountRuleDef';
  companyEmailAccount: CompanyEmailAccountDef;
  createdAt: Scalars['DateTime']['output'];
  defaultAssignee?: Maybe<UserType>;
  defaultProject?: Maybe<ProjectType>;
  defaultTicketType?: Maybe<TicketTypeDef>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  emailFilter: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

export type CompanyEmailAccountRuleDefConnection = {
  __typename: 'CompanyEmailAccountRuleDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyEmailAccountRuleDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CompanyEmailAccountRuleDef` and its cursor. */
export type CompanyEmailAccountRuleDefEdge = {
  __typename: 'CompanyEmailAccountRuleDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyEmailAccountRuleDef>;
};

export type CompanyEventDef = Node & {
  __typename: 'CompanyEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  company?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<CompanyEventTypesGraphene>>>;
  fromDashboardLocation?: Maybe<LocationType>;
  fromDescription?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toDashboardLocation?: Maybe<LocationType>;
  toDescription?: Maybe<Scalars['String']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
};

export enum CompanyEventTypesGraphene {
  DASHBOARD_LOCATION_CHANGE = 'DASHBOARD_LOCATION_CHANGE',
  DESCRIPTION_CHANGE = 'DESCRIPTION_CHANGE',
  NAME_CHANGE = 'NAME_CHANGE'
}

export type CompanyEventsEventLogWrapper = {
  __typename: 'CompanyEventsEventLogWrapper';
  edges?: Maybe<Array<Maybe<CompanyEventsWrapper>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CompanyEventsWrapper = CollectionCalendarDateEventDef | CollectionCalendarEventDef | CompanyEventDef | CompanyMetaTypeEventDef | CompanySettingsEventDef | ContainerTypeEventDef | DeletionEventDef | PickupSettingsEventDef | PortalRoleCapabilitiesEventDef | PriceEventDef | ProductEventDef | ProductManagementEventDef | TicketTypeEventDef | WasteFractionEventDef;

export type CompanyFeatureFlagInput = {
  key: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

/**
 * One labelled boolean feature toggle for the staff admin surface.
 *
 * The FE renders this generically ({key, label, description, value}); the
 * canonical set + labels come from ``core.feature_flags`` so a new flag needs
 * no GraphQL change here.
 */
export type CompanyFeatureFlagType = {
  __typename: 'CompanyFeatureFlagType';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

/**
 * One merged calendar row (national or custom) for display (B1.2).
 *
 * ``source`` is a string token ("national"/"custom"), not a graphene
 * enum — the plan's explicit graphene 2.1.8 pitfall guard. ``rowId``
 * is the ``CompanyHolidayDay`` global id for a custom row (needed by
 * ``removeCompanyHolidayDay``) and ``null`` for a national row —
 * there is nothing to remove.
 */
export type CompanyHolidayCalendarEntryDef = {
  __typename: 'CompanyHolidayCalendarEntryDef';
  date: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  /** HSY-258: "once" for a single-date row, "annually" for a crm.CompanyHoliday register row that repeats every year (shown with a Yearly badge); null for a national row. */
  recurrence?: Maybe<Scalars['String']['output']>;
  /** The `CompanyHolidayDay` global id for a Custom row; null for a National row. */
  rowId?: Maybe<Scalars['ID']['output']>;
  /** "national" or "custom". */
  source: Scalars['String']['output'];
};

/** One row of the tenant's OWN custom non-driving days (B1.3). */
export type CompanyHolidayDayDef = Node & {
  __typename: 'CompanyHolidayDayDef';
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['Date']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CompanyHolidayDayDefConnection = {
  __typename: 'CompanyHolidayDayDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyHolidayDayDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CompanyHolidayDayDef` and its cursor. */
export type CompanyHolidayDayDefEdge = {
  __typename: 'CompanyHolidayDayDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyHolidayDayDef>;
};

/**
 * HSY-258 — one company-entered non-working day.
 *
 * Read alongside the country pack's statutory dates: the resolver unions
 * the two, so this type is the editable half, not the whole calendar.
 */
export type CompanyHolidayDef = Node & {
  __typename: 'CompanyHolidayDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  /** The day itself. For a yearly holiday only the day and month are used, so any year may be entered. */
  date: Scalars['Date']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Turn off to stop a holiday applying without losing the row — a year when a normally-closed day is worked. */
  isActive: Scalars['Boolean']['output'];
  /** Shown to the office and in the customer notice. */
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  recurrence: CrmCompanyHolidayRecurrenceChoices;
  updatedAt: Scalars['DateTime']['output'];
};

export type CompanyHolidayDefConnection = {
  __typename: 'CompanyHolidayDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyHolidayDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CompanyHolidayDef` and its cursor. */
export type CompanyHolidayDefEdge = {
  __typename: 'CompanyHolidayDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyHolidayDef>;
};

export type CompanyInfoType = {
  __typename: 'CompanyInfoType';
  address?: Maybe<CompanyAddressType>;
  eInvoice?: Maybe<CompanyEInvoiceType>;
  name: Scalars['String']['output'];
  orgNumber: Scalars['String']['output'];
  status: CompanyStatusType;
};

/**
 * The warehouse-list footer: the aggregate view across all
 * warehouses. Total tracked = every non-decommissioned container
 * the system knows, including deployed and in-transit (decided).
 */
export type CompanyInventoryTotalsType = {
  __typename: 'CompanyInventoryTotalsType';
  inStock?: Maybe<Scalars['Int']['output']>;
  inTransit?: Maybe<Scalars['Int']['output']>;
  totalTracked?: Maybe<Scalars['Int']['output']>;
};

export type CompanyMetaTypeDef = Node & {
  __typename: 'CompanyMetaTypeDef';
  company: CompanyType;
  copyFrom?: Maybe<CoreCompanyMetaTypeCopyFromChoices>;
  createdAt: Scalars['DateTime']['output'];
  displayOn: Array<MetaTypeDisplayOnType>;
  enableFiltering: Scalars['Boolean']['output'];
  enableSearch: Scalars['Boolean']['output'];
  entity: CoreCompanyMetaTypeEntityChoices;
  helpText: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  inputType: CoreCompanyMetaTypeInputTypeChoices;
  label: Scalars['String']['output'];
  migratedFromId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  options: Array<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  rolesCanEdit: CompanyRoleDefConnection;
  rolesCanView: CompanyRoleDefConnection;
  scheduledexportmetatypeSet: ScheduledExportMetaTypeDefConnection;
  userCanEdit?: Maybe<Scalars['Boolean']['output']>;
};


export type CompanyMetaTypeDefRolesCanEditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyMetaTypeDefRolesCanViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyMetaTypeDefScheduledexportmetatypeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyMetaTypeDefConnection = {
  __typename: 'CompanyMetaTypeDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyMetaTypeDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CompanyMetaTypeDef` and its cursor. */
export type CompanyMetaTypeDefEdge = {
  __typename: 'CompanyMetaTypeDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyMetaTypeDef>;
};

export type CompanyMetaTypeEventDef = Node & {
  __typename: 'CompanyMetaTypeEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  companyMetaType?: Maybe<CompanyMetaTypeDef>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<CompanyMetaTypeEventTypesGraphene>>>;
  fromCopyFrom?: Maybe<Scalars['Int']['output']>;
  fromDisplayOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fromHelpText?: Maybe<Scalars['String']['output']>;
  fromInputType?: Maybe<Scalars['String']['output']>;
  fromLabel?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  fromOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toCopyFrom?: Maybe<Scalars['Int']['output']>;
  toDisplayOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  toHelpText?: Maybe<Scalars['String']['output']>;
  toInputType?: Maybe<Scalars['String']['output']>;
  toLabel?: Maybe<Scalars['String']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
  toOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  user?: Maybe<UserType>;
};

export enum CompanyMetaTypeEventTypesGraphene {
  COPY_FROM_CHANGE = 'COPY_FROM_CHANGE',
  CUSTOM_FIELD_CREATED = 'CUSTOM_FIELD_CREATED',
  CUSTOM_FIELD_DELETED = 'CUSTOM_FIELD_DELETED',
  DISPLAY_ON_CHANGE = 'DISPLAY_ON_CHANGE',
  HELP_TEXT_CHANGE = 'HELP_TEXT_CHANGE',
  INPUT_TYPE_CHANGE = 'INPUT_TYPE_CHANGE',
  LABEL_CHANGE = 'LABEL_CHANGE',
  NAME_CHANGE = 'NAME_CHANGE',
  OPTIONS_CHANGE = 'OPTIONS_CHANGE'
}

export type CompanyRoleConfigDef = {
  __typename: 'CompanyRoleConfigDef';
  description?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<CompanyRolesConfigItemDef>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyRoleDef = Node & {
  __typename: 'CompanyRoleDef';
  company: CompanyType;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  metaTypesCanEdit?: Maybe<Array<CompanyMetaTypeDef>>;
  metaTypesCanView?: Maybe<Array<CompanyMetaTypeDef>>;
  name: Scalars['String']['output'];
  permissions: Array<PermissionChoices>;
};

export type CompanyRoleDefConnection = {
  __typename: 'CompanyRoleDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyRoleDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CompanyRoleDef` and its cursor. */
export type CompanyRoleDefEdge = {
  __typename: 'CompanyRoleDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyRoleDef>;
};

export type CompanyRolePermissionDef = Node & {
  __typename: 'CompanyRolePermissionDef';
  company: CompanyType;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: CoreCompanyRolePermissionNameChoices;
};

export type CompanyRolePermissionDefConnection = {
  __typename: 'CompanyRolePermissionDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyRolePermissionDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CompanyRolePermissionDef` and its cursor. */
export type CompanyRolePermissionDefEdge = {
  __typename: 'CompanyRolePermissionDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyRolePermissionDef>;
};

export type CompanyRolesConfigItemDef = {
  __typename: 'CompanyRolesConfigItemDef';
  createPermission?: Maybe<Scalars['String']['output']>;
  deletePermission?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  editPermission?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  viewPermission?: Maybe<Scalars['String']['output']>;
};

export type CompanySearchEntitySetting = {
  __typename: 'CompanySearchEntitySetting';
  enabled: Scalars['Boolean']['output'];
  entityType: OmniSearchEntityType;
};

/**
 * PRO-519: one generic before/after diff row for a CompanySettings field
 * that has no dedicated ``from_*``/``to_*`` column. ``field`` is the snake_case
 * model field name; ``from_value``/``to_value`` are its stringified values.
 */
export type CompanySettingsChangedFieldDef = {
  __typename: 'CompanySettingsChangedFieldDef';
  field: Scalars['String']['output'];
  fromValue?: Maybe<Scalars['String']['output']>;
  toValue?: Maybe<Scalars['String']['output']>;
};

export type CompanySettingsEventDef = Node & {
  __typename: 'CompanySettingsEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  changedFields: Array<CompanySettingsChangedFieldDef>;
  companySettings?: Maybe<CompanySettingsType>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<CompanySettingsEventTypesGraphene>>>;
  fromCompanyName?: Maybe<Scalars['String']['output']>;
  fromContactsMaskIndividualTaxId?: Maybe<Scalars['Boolean']['output']>;
  fromContainerNotificationProviders?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fromCountry?: Maybe<Scalars['String']['output']>;
  fromCustomTextHome?: Maybe<Scalars['String']['output']>;
  fromCustomTextHomeTitle?: Maybe<Scalars['String']['output']>;
  fromCustomTextLogin?: Maybe<Scalars['String']['output']>;
  fromCustomTextLoginTitle?: Maybe<Scalars['String']['output']>;
  fromDefaultLanguage?: Maybe<Scalars['String']['output']>;
  fromDkdpEnabled?: Maybe<Scalars['Boolean']['output']>;
  fromHostname?: Maybe<Scalars['String']['output']>;
  fromInvoicingEnabled?: Maybe<Scalars['Boolean']['output']>;
  fromLoginMethod?: Maybe<Scalars['String']['output']>;
  fromMetabaseEnabled?: Maybe<Scalars['Boolean']['output']>;
  fromPdfFooter?: Maybe<Scalars['String']['output']>;
  fromPhoneNumber?: Maybe<Scalars['String']['output']>;
  fromProductPricingEnabled?: Maybe<Scalars['Boolean']['output']>;
  fromSmsSender?: Maybe<Scalars['String']['output']>;
  fromSmsSenderSignature?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toCompanyName?: Maybe<Scalars['String']['output']>;
  toContactsMaskIndividualTaxId?: Maybe<Scalars['Boolean']['output']>;
  toContainerNotificationProviders?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  toCountry?: Maybe<Scalars['String']['output']>;
  toCustomTextHome?: Maybe<Scalars['String']['output']>;
  toCustomTextHomeTitle?: Maybe<Scalars['String']['output']>;
  toCustomTextLogin?: Maybe<Scalars['String']['output']>;
  toCustomTextLoginTitle?: Maybe<Scalars['String']['output']>;
  toDefaultLanguage?: Maybe<Scalars['String']['output']>;
  toDkdpEnabled?: Maybe<Scalars['Boolean']['output']>;
  toHostname?: Maybe<Scalars['String']['output']>;
  toInvoicingEnabled?: Maybe<Scalars['Boolean']['output']>;
  toLoginMethod?: Maybe<Scalars['String']['output']>;
  toMetabaseEnabled?: Maybe<Scalars['Boolean']['output']>;
  toPdfFooter?: Maybe<Scalars['String']['output']>;
  toPhoneNumber?: Maybe<Scalars['String']['output']>;
  toProductPricingEnabled?: Maybe<Scalars['Boolean']['output']>;
  toSmsSender?: Maybe<Scalars['String']['output']>;
  toSmsSenderSignature?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
};

export enum CompanySettingsEventTypesGraphene {
  COMPANY_NAME_CHANGE = 'COMPANY_NAME_CHANGE',
  CONTACTS_MASK_INDIVIDUAL_TAX_ID_CHANGE = 'CONTACTS_MASK_INDIVIDUAL_TAX_ID_CHANGE',
  CONTAINER_NOTIFICATION_PROVIDERS_CHANGE = 'CONTAINER_NOTIFICATION_PROVIDERS_CHANGE',
  COUNTRY_CHANGE = 'COUNTRY_CHANGE',
  CUSTOM_TEXT_HOME_CHANGE = 'CUSTOM_TEXT_HOME_CHANGE',
  CUSTOM_TEXT_LOGIN_CHANGE = 'CUSTOM_TEXT_LOGIN_CHANGE',
  DEFAULT_LANGUAGE_CHANGE = 'DEFAULT_LANGUAGE_CHANGE',
  DKDP_ENABLED_CHANGE = 'DKDP_ENABLED_CHANGE',
  HOSTNAME_CHANGE = 'HOSTNAME_CHANGE',
  INVOICING_ENABLED_CHANGE = 'INVOICING_ENABLED_CHANGE',
  LOGIN_METHOD_CHANGE = 'LOGIN_METHOD_CHANGE',
  METABASE_ENABLED_CHANGE = 'METABASE_ENABLED_CHANGE',
  PDF_FOOTER_CHANGE = 'PDF_FOOTER_CHANGE',
  PHONE_NUMBER_CHANGE = 'PHONE_NUMBER_CHANGE',
  PRODUCT_PRICING_ENABLED_CHANGE = 'PRODUCT_PRICING_ENABLED_CHANGE',
  SETTINGS_UPDATED = 'SETTINGS_UPDATED',
  SMS_SENDER_CHANGE = 'SMS_SENDER_CHANGE',
  SMS_SENDER_SIGNATURE_CHANGE = 'SMS_SENDER_SIGNATURE_CHANGE'
}

export type CompanySettingsType = Node & {
  __typename: 'CompanySettingsType';
  /** Enable per-agreement price coefficients: when on, the office can set a multiplier on an agreement that scales the unit price of its recurring billing events (e.g. Renovasjon x1.6). OFF hides/blocks new coefficient writes only — already-stored coefficients keep billing unchanged. */
  agreementCoefficientEnabled: Scalars['Boolean']['output'];
  /** Lets the office pause an agreement's collections for a date range (keskeytys): route generation skips the container's due dates inside the range, already-planned undriven stops in it are released, and the base fee keeps running. OFF keeps today's behaviour byte for byte — suspension rows are ignored by route generation, the property calendar and the agreement API, and the mutations refuse. Built for HSY tender requirement 86/54 (COMPASS-1773). */
  agreementSuspensionEnabled: Scalars['Boolean']['output'];
  backgroundImageForHomePage: Scalars['String']['output'];
  backgroundImageForLoginPage: Scalars['String']['output'];
  barcodeTemplate: Scalars['String']['output'];
  billingExportSystem?: Maybe<CoreCompanySettingsBillingExportSystemChoices>;
  billingExportSystemParams: Scalars['JSONString']['output'];
  /** When a bin's size is changed, move the factor of the recurring fees that follow it (e.g. Renovasjon x1 for 140 L, x1.6 for 240 L) by the difference between the two sizes, from the 1st of the month the change is completed in. The factors are set in 'Bin size factors'. Off by default; requires Product pricing and Agreement price coefficients. */
  binSizeCoefficientEnabled: Scalars['Boolean']['output'];
  /** A list of rules: [{"waste_fraction_id": <id>, "factors": {"<container type id>": "1", "<container type id>": "1.6"}, "product_ids": ["<recurring product id>", ...]}]. A bin of that fraction contributes the factor of its size to the coefficient of the property's agreements on those products. Used while 'fee factor follows the bin size' is on. */
  binSizeCoefficientRules: Scalars['JSONString']['output'];
  borderRadius?: Maybe<BorderRadiusEnum>;
  canExportDebtors: Scalars['Boolean']['output'];
  canExportInvoiceLines: Scalars['Boolean']['output'];
  /** Offer the driver app's 'Closest' stop-list mode: stops ordered by GPS distance from the vehicle, with the nearest pending stop marked. Off (default) = the mode is hidden and the list follows the next stop in route order. On dense routes GPS error often makes the 'closest' stop not the physically nearest container, so enable only for a company that asked for it. */
  closestStopModeEnabled: Scalars['Boolean']['output'];
  color1: Scalars['String']['output'];
  color2: Scalars['String']['output'];
  color3: Scalars['String']['output'];
  color4: Scalars['String']['output'];
  color5: Scalars['String']['output'];
  colorClosestStop: Scalars['String']['output'];
  colorEmptiedStop: Scalars['String']['output'];
  colorEmptiedWithTicketStop: Scalars['String']['output'];
  colorNextStop: Scalars['String']['output'];
  colorNotEmptiedWithTicketStop: Scalars['String']['output'];
  colorPendingStop: Scalars['String']['output'];
  colorSkippedStop: Scalars['String']['output'];
  colorWillReturnStop: Scalars['String']['output'];
  /** Hauler Mode: commercial customer portal */
  commercialPortalEnabled: Scalars['Boolean']['output'];
  /** Hauler Mode: self-billing / partner settlement */
  commercialSelfbillingEnabled: Scalars['Boolean']['output'];
  company: CompanyType;
  companyLogo?: Maybe<Scalars['String']['output']>;
  /** Lets a driver complete a stop from beyond the configured completion radius by supplying a reason, instead of the completion being refused outright. OFF keeps today's hard block (routes.services.gps_range_exception.reject_out_of_range_completions) byte-for-byte, whatever verification the driver app sends (auto-completed stops were never radius-checked — PRO-684). Built for HSY tender requirement 37. */
  completionDistanceVerificationEnabled: Scalars['Boolean']['output'];
  /** Notifies the office through Live Operations when a driver gives a container a new location from the driver app, carrying the old and new coordinates and the distance moved. OFF keeps today's behaviour: the location changes silently. Built for HSY tender requirement 14. */
  containerRelocationNotificationEnabled: Scalars['Boolean']['output'];
  /** Users holding this company role may give the final approval of a wash list. Empty = company masters and superusers approve. */
  containerWashingApproverRole?: Maybe<CompanyRoleDef>;
  /** Adds the container-washing service type and the wash-list planning and approval flow (plan bins for a period, forward, approve, send to production). OFF hides the wash lists and refuses their mutations. Built for HSY tender requirement 182. */
  containerWashingEnabled: Scalars['Boolean']['output'];
  /** Lets an office user hand a contract area over to another contractor from a chosen date: future routes and route schemes move, properties are re-pointed at the cut-off and a checklist lists what is left to do. OFF hides the hand-over action; the hand-over API stays available with its earlier behaviour (old area closed at the cut-off, successor created or linked, future routes re-pointed; no route-scheme switch, property move or checklist). Built for HSY tender requirement 251. */
  contractAreaTransferEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  crmCompanyName?: Maybe<Scalars['String']['output']>;
  crmContactsAssignUniqueId?: Maybe<CoreCompanySettingsCrmContactsAssignUniqueIdChoices>;
  crmContactsMaskIndividualTaxId: Scalars['Boolean']['output'];
  crmCountry?: Maybe<Scalars['String']['output']>;
  crmCustomTextHome?: Maybe<Scalars['String']['output']>;
  crmCustomTextHomeTitle?: Maybe<Scalars['String']['output']>;
  crmCustomTextLogin?: Maybe<Scalars['String']['output']>;
  crmCustomTextLoginTitle?: Maybe<Scalars['String']['output']>;
  crmDefaultLanguage?: Maybe<Scalars['String']['output']>;
  crmEmailSender?: Maybe<CompanyEmailAccountDef>;
  /** Show the account overview section (Min konto) in the citizen portal. No backend yet — frontend visibility only. */
  crmEnableAccountOverview: Scalars['Boolean']['output'];
  /** Show the authority forms section (Myndighedsskemaer) in the citizen portal. No backend yet — frontend visibility only. */
  crmEnableAuthorityForms: Scalars['Boolean']['output'];
  /** Show the communication preferences section (Kommunikation), where the citizen picks their primary contact channel. */
  crmEnableCommsPreferences: Scalars['Boolean']['output'];
  /** Enable the Self Composting service for this company: the citizen portal section and its API, the office composting register surfaces and the notification-form builder. Off (default) = the portal composting API refuses (404) and every composting surface is hidden. */
  crmEnableComposting: Scalars['Boolean']['output'];
  /** Show each container's navigation-app description (access instructions) and attached files to the citizen under the container in the portal. Off (default) = the portal API withholds both. Do not enable for a tenant whose portal has no login (login method 'none'): there every property is readable by anyone holding the portal link, and access instructions often carry gate and lock codes. */
  crmEnableContainerInstructions: Scalars['Boolean']['output'];
  crmEnableContainerNotificationProviders: Array<Scalars['String']['output']>;
  /** Customer-service-request (CSR) admin surface: staff-facing review of citizen registration requests. No backend yet - frontend visibility only. */
  crmEnableCsrAdmin: Scalars['Boolean']['output'];
  /** Let customers end their own container agreements in the citizen portal (Agreements, a container's menu, End agreement), effective the same day. Off = the portal hides the action and the portal API refuses it (403), so agreements are only ended through the office. */
  crmEnableEndAgreement: Scalars['Boolean']['output'];
  /** Enable the messages section (Beskeder) in the citizen portal. This is the single switch for messaging: it both shows the section and routes company->citizen ticket messages into it as portal conversations instead of full-body email/SMS. Off by default until the portal conversations backend ships to production. */
  crmEnableMessaging: Scalars['Boolean']['output'];
  /** Show the property pools section (Kimppa) in the citizen portal. */
  crmEnablePools: Scalars['Boolean']['output'];
  /** Show the products section in the citizen portal. No backend yet — frontend visibility only. */
  crmEnableProducts: Scalars['Boolean']['output'];
  /** Show the self-registration flow in the citizen portal. No backend yet — frontend visibility only. */
  crmEnableRegistration: Scalars['Boolean']['output'];
  /** Show the waste report section, where the citizen builds private and business reports aggregating emptying and delivery events with weights and cost, and saves report presets. The YLVA report kind is gated separately by 'crm enable ylva reports'. */
  crmEnableReports: Scalars['Boolean']['output'];
  /** Show the services section in the citizen portal. No backend yet — frontend visibility only. */
  crmEnableServices: Scalars['Boolean']['output'];
  /** Show the YLVA reporting section in the citizen portal (Finnish waste-reporting flow). */
  crmEnableYlvaReports: Scalars['Boolean']['output'];
  crmHostname?: Maybe<Scalars['String']['output']>;
  crmLoginLogo?: Maybe<Scalars['String']['output']>;
  crmLoginMethod: CoreCompanySettingsCrmLoginMethodChoices;
  crmLoginMethodUser: CoreCompanySettingsCrmLoginMethodUserChoices;
  crmLoginMethodUserIsAdministrator: Scalars['Boolean']['output'];
  crmLoginMethodUserIsCoOwner: Scalars['Boolean']['output'];
  crmLoginMethodUserIsContact: Scalars['Boolean']['output'];
  crmLoginMethodUserIsOwner: Scalars['Boolean']['output'];
  crmLoginMethodUserIsPayer: Scalars['Boolean']['output'];
  crmLogo?: Maybe<Scalars['String']['output']>;
  crmMasterDataSyncRemovePayerOnOwnerOrAdminChanges: Scalars['Boolean']['output'];
  crmMasterDataSyncSyncEanNumbers: Scalars['Boolean']['output'];
  crmPdfFooter: Scalars['String']['output'];
  crmPhoneNumber?: Maybe<Scalars['String']['output']>;
  crmPortalMessagingEnabled: Scalars['Boolean']['output'];
  crmPortalRestrictToSingleChannel: Scalars['Boolean']['output'];
  crmPrimaryColor?: Maybe<Scalars['String']['output']>;
  /** Show the climate footprint (kg CO2e) on the customers' waste report, computed from the dated environmental factors set per waste fraction. Needs the environmental account. */
  crmReportsShowCo2: Scalars['Boolean']['output'];
  /** Show prices on the customers' waste report (total price card, price columns and export). */
  crmReportsShowPrice: Scalars['Boolean']['output'];
  /** Show the recycling rate on the customers' waste report (summary card, columns and export). */
  crmReportsShowRecycling: Scalars['Boolean']['output'];
  crmSecondaryColor?: Maybe<Scalars['String']['output']>;
  crmSmsSender?: Maybe<Scalars['String']['output']>;
  crmSmsSenderSignature?: Maybe<Scalars['String']['output']>;
  crmSyncPropertiesFromMasterData: Scalars['Boolean']['output'];
  crmSyncPropertyContactsFromMasterData: Scalars['Boolean']['output'];
  crmUseExternalContactIds: Scalars['Boolean']['output'];
  datetimeFormatCountry: Scalars['String']['output'];
  /** Default billing cadence prefilled onto new agreement schedules; overridable per agreement. Null = no default (choose per schedule). */
  defaultBillingFrequency?: Maybe<BillingFrequencyDef>;
  /** Distance (meters) a driver must be within to mark a stop done manually, on routes not governed by a contract area. Empty = no distance limit. */
  defaultCompletionRadiusMeters?: Maybe<Scalars['Int']['output']>;
  distanceUnit: Scalars['String']['output'];
  dkdpEnabled: Scalars['Boolean']['output'];
  dns: Scalars['String']['output'];
  /** The company invoices from an external finance system (e.g. Visma). Keeps the Invoicing module and the invoice-related customer fields visible but READ-ONLY: simulations still run, while real billing runs, invoice edits and every e-invoice export are refused. Requires Invoicing to be enabled. Nothing is deleted by toggling this. */
  externalBillingEnabled: Scalars['Boolean']['output'];
  externalFinanceSystem: Scalars['String']['output'];
  /** Show the Finnish CRM catalogue tabs (Service responsibilities and Industries under Customer Management settings). Finnish companies with product pricing enabled get these tabs automatically; this flag force-enables them for any company. Requires Product pricing and Invoicing to be enabled. */
  fiCataloguesEnabled: Scalars['Boolean']['output'];
  fileTemplateAgreementExport: Scalars['String']['output'];
  fileTemplateCoreScheduledExport: Scalars['String']['output'];
  fileTemplateWasteheroRouteExport: Scalars['String']['output'];
  /** Lets the nightly generation act on fixed route templates without a planner: adopt another scheme's template on a full address match, and place a new container into the template next to its nearest neighbour (marked for review). Off (default) = templates change only by a planner's hand; new containers drive last until placed. */
  fixedRoutesAutomationEnabled: Scalars['Boolean']['output'];
  /** Lets planners apply a fixed route template to many routes at once (the Apply to upcoming tab and the routes list's bulk Apply). Off (default) = a template is applied one route at a time, from that route's page; the nightly generation still follows the active template. */
  fixedRoutesBulkApplyEnabled: Scalars['Boolean']['output'];
  /** Lets planners fix the stop order of generated routes: a scheme-wide template is re-applied to every route the scheme generates, whatever truck the solver assigned, instead of the optimiser's order; an optional vehicle-specific template overrides it for that one truck. Off (default) = generated routes keep the stop order the optimiser produced. */
  fixedRoutesEnabled: Scalars['Boolean']['output'];
  /** Fixed SMS revenue */
  fixedSmsRevenue: Scalars['Decimal']['output'];
  fontFamily: CoreCompanySettingsFontFamilyChoices;
  /** Lets prices be entered, stored and shown with four decimals instead of two; line and invoice totals still round to two decimals. OFF keeps today's two-decimal prices. Built for HSY tender requirement 235. */
  fourDecimalPricesEnabled: Scalars['Boolean']['output'];
  /** Date the DPIA for driver-GPS monitoring was completed. */
  gpsDpiaCompletedAt?: Maybe<Scalars['Date']['output']>;
  /** Reference/URL of the DPIA covering driver-GPS monitoring. */
  gpsDpiaReference: Scalars['String']['output'];
  /** Date employees were informed of the GPS monitoring. */
  gpsMonitoringNoticeGivenAt?: Maybe<Scalars['Date']['output']>;
  /** Date the works council approved driver-GPS monitoring. */
  gpsWorksCouncilApprovedAt?: Maybe<Scalars['Date']['output']>;
  /** Enables the commercial Hauler Mode for this company */
  haulerB2bEnabled: Scalars['Boolean']['output'];
  /** ISO 3166-1 alpha-2 code of the tenant's hauler country pack */
  haulerComplianceCountry?: Maybe<Scalars['String']['output']>;
  /** Enables the Hauler/Contractor module for this company */
  haulerModuleEnabled: Scalars['Boolean']['output'];
  /** Hauler Mode: public webshop */
  haulerWebshopEnabled: Scalars['Boolean']['output'];
  /** ISO 3166-1 alpha-2 code of the tenant's public-holiday calendar. Empty = no holiday machinery anywhere (fail-closed). */
  holidayCalendarCountry?: Maybe<Scalars['String']['output']>;
  /** Lets a company set the weekdays it operates on and how a collection that falls on a public holiday is cancelled or moved. OFF keeps today's holiday handling, whatever the company stores. Built for HSY tender requirement 258. */
  holidayCancelPolicyEnabled: Scalars['Boolean']['output'];
  /** Template of the customer notice sent for a cancelled holiday collection. Placeholders: {date}, {holiday}, {address}. */
  holidayCancellationMessage: Scalars['String']['output'];
  /** When on, accepting a 'cancel' holiday outcome in the holiday impact view queues an SMS/e-mail notice to the payer/contact of every affected property. */
  holidayCancellationNotifyCustomers: Scalars['Boolean']['output'];
  /**
   * String token: same_week | next_visit | spread | none. A plain String,
   * not a graphene enum (2.1.8 pitfall — explicit-null inputs drop on
   * enums; F6/RD-33 convention). acl.ts owns the FE label map. Never
   * null on the model (Django default same_week).
   */
  holidayCollectionPolicy: Scalars['String']['output'];
  /** Only meaningful when holiday_collection_policy='spread': how many days forward the round-robin spread walks (1-7). */
  holidaySpreadDays: Scalars['Int']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  insightsAiEnabled: Scalars['Boolean']['output'];
  insightsAutoApproveExceptions: Scalars['Boolean']['output'];
  insightsBenchmarkNoticeAck: Scalars['Boolean']['output'];
  insightsBenchmarkOptIn: Scalars['Boolean']['output'];
  insightsEnabled: Scalars['Boolean']['output'];
  insightsPublicMetricAllowlist: Scalars['JSONString']['output'];
  insightsPublicPageEnabled: Scalars['Boolean']['output'];
  insightsPublicToken: Scalars['UUID']['output'];
  /** Enables the Inventory (stock) module for this company. Off = the Inventory side-nav item, its Settings tabs, and its routes are hidden; no data is affected. */
  inventoryEnabled: Scalars['Boolean']['output'];
  /** Show the Invoicing → Accounting accounts tab (the chart of accounts invoice lines post to). Off (default) = the tab and its routes are hidden; stored accounts still route charges exactly as before and nothing is deleted. Requires Invoicing to be enabled. */
  invoicingAccountingAccountsEnabled: Scalars['Boolean']['output'];
  invoicingEnabled: Scalars['Boolean']['output'];
  /** Show the Invoicing → Routing rules tab (which account and cost centre a charge is booked to). Off (default) = the tab, its routes and the 'Create rule' action on the unrouted-charges report are hidden; stored rules keep routing charges exactly as before and nothing is deleted. Requires Invoicing to be enabled. */
  invoicingRoutingRulesEnabled: Scalars['Boolean']['output'];
  isActiveDns: Scalars['Boolean']['output'];
  labelConfigDpi: Scalars['Int']['output'];
  labelConfigHeight: Scalars['Int']['output'];
  labelConfigHeightHtml: Scalars['Int']['output'];
  labelConfigMargin: Scalars['Int']['output'];
  labelConfigWidth: Scalars['Int']['output'];
  labelConfigWidthHtml: Scalars['Int']['output'];
  /** Keep the legacy CRM 'Billing Runs' screens available for this company AND allow creating new legacy billing runs (the createBillingRun mutation refuses when off; exporting/archiving historical runs stays open). Off (default) = hidden in the new UI and no new legacy runs; enable only for a tenant that still bills through the old flow. */
  legacyBillingRuns: Scalars['Boolean']['output'];
  /** Show the legacy per-property Contacts registry in the office UI. Off by default; enable only for a company not yet migrated to standalone contacts. Display only, no data is touched. */
  legacyContactsEnabled: Scalars['Boolean']['output'];
  /** Keep the legacy CRM 'Data sync' settings screen available for this company. Off (default) = the screen is hidden in the new UI; enable only for a tenant that still needs the old view. */
  legacyDataSync: Scalars['Boolean']['output'];
  /** Keep the legacy CRM 'Pricing' settings screens visible for this company (relocated under Contract Management as 'Legacy Pricing'). On by default; turn off for a tenant fully migrated off the old pricing screens. */
  legacyPricing: Scalars['Boolean']['output'];
  /** Keep the legacy fill-level sensor 'Alerts' feature (the Settings -> Alert Rules editor and its container alert screens) visible for this company. Off (default) = hidden in the new UI; auto-enabled at rollout for companies that already have alert rules. Staff-set only. */
  legacySensorAlerts: Scalars['Boolean']['output'];
  liveOperationsEnabled: Scalars['Boolean']['output'];
  locksmithEmail: Scalars['String']['output'];
  loginImages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mainPortalFont: Scalars['String']['output'];
  mainPortalFontFamily: Scalars['String']['output'];
  mapCountry: Scalars['String']['output'];
  /** Enables the Map Planning workspace for this company. Off = the Map Planning side-nav entry and /app/map-planning are hidden; no data is affected. */
  mapPlanningEnabled: Scalars['Boolean']['output'];
  /** Shows the "Receives marketing communications" consent field on the contact/company forms (NEXUS-773). */
  marketingConsentEnabled: Scalars['Boolean']['output'];
  masterDataProvider?: Maybe<CoreCompanySettingsMasterDataProviderChoices>;
  metabaseEnabled: Scalars['Boolean']['output'];
  metabasePrivateCollectionId?: Maybe<Scalars['String']['output']>;
  metabaseUserId?: Maybe<Scalars['String']['output']>;
  /** Require an emailed one-time code as a second step on platform-web logins for this company's office/admin users. Drivers are never challenged. */
  mfaEmailEnabled: Scalars['Boolean']['output'];
  /** Also require the email code on SSO logins. Off = SSO stays single-step (the identity provider owns the second factor); only applies while Email MFA is on. */
  mfaEmailIncludeSso: Scalars['Boolean']['output'];
  /** Shows the Finnish statutory non-disclosure (turvakielto) fields on contact forms (NEXUS-770); the contact_ndr__* permissions still apply on top. */
  ndrEnabled: Scalars['Boolean']['output'];
  /** Enables the new global omnisearch for this company: the office ⌘K search palette, the 'Global search configuration' settings tab and the omniSearch API. Off (default) = the legacy search modal stays in place and the omniSearch query refuses. */
  omnisearchEnabled: Scalars['Boolean']['output'];
  /** Permitted collection weekdays (mon..sun). Empty = not entered (the country pack's work week applies to shifted targets only and no weekday is ever treated as non-permitted). */
  operatingWeekdays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allow the recurring-fee generator to create charges for calendar periods before today, back to the date below. Off by default. Check the previous system's last billed period first to avoid double invoicing. */
  pastPeriodBillingEnabled: Scalars['Boolean']['output'];
  /** The earliest calendar period start to bill retroactively (inclusive) when past-period billing is on; usually the day after the previous system's last billed period. Periods before an agreement's start date are never billed. Empty = nothing is billed retroactively even when the switch is on. */
  pastPeriodBillingFrom?: Maybe<Scalars['Date']['output']>;
  /** Percentage of SMS revenue (0 - 100%) */
  percentageSmsRevenue: Scalars['Decimal']['output'];
  /** Enables the Physical Keys module for this company. Off = every key surface is inert (empty reads / denied writes); data is preserved and restored when re-enabled. */
  physicalKeysEnabled: Scalars['Boolean']['output'];
  portalColorSettings: Scalars['String']['output'];
  portalPageSettings?: Maybe<Array<Maybe<PortalPageDescriptionSettingType>>>;
  /** Serves the citizen portal the list of products a customer may order themselves, honouring the product's self-service switches. OFF makes the catalogue endpoints refuse, so no portal can read it. Built for HSY tender requirement 254. */
  portalProductCatalogueEnabled: Scalars['Boolean']['output'];
  /** Serves the citizen portal's self-service prices from the Products & Prices catalog instead of the legacy price catalog, honouring each product's portal switches and property-type eligibility. Requires Product pricing. OFF keeps today's legacy prices. */
  portalProductPricingEnabled: Scalars['Boolean']['output'];
  portalpagedescriptionsettingSet: PortalPageDescriptionSettingTypeConnection;
  /** Lets an office user amend many prices at once and schedule the amendment to take effect on a chosen date. OFF hides the amendment actions and refuses the amendment endpoints. Built for HSY tender requirement 234. */
  priceAmendmentsEnabled: Scalars['Boolean']['output'];
  priceDecimalPlaces: Scalars['Int']['output'];
  /** Adds the Export action to a price list, producing a workbook that can be edited and re-imported. OFF hides the action and refuses the export endpoints. Built for HSY tender requirement 245. */
  priceListExportEnabled: Scalars['Boolean']['output'];
  /** Adds the per-product channel controls: office visibility, self-service ordering from the citizen portal and how a self-service order is routed to a ticket. OFF hides the controls and keeps today's behaviour, whatever a product stores. Built for HSY tender requirements 243 and 254. */
  productChannelControlsEnabled: Scalars['Boolean']['output'];
  productPricingEnabled: Scalars['Boolean']['output'];
  /** Lets a product decide which ticket type ordering it creates (or none — bill only), and applies it at the portal and office order seams. OFF hides the setting and routes every order like today, whatever a product stores. Built for HSY tender requirement 243. */
  productWorkTasksEnabled: Scalars['Boolean']['output'];
  /** Bills a property's recurring fees (container hire, bill-only products) at the billing frequency of the contact who pays for it — monthly, quarterly, half-yearly or yearly — dividing the annual price accordingly, when the agreement has no billing schedule of its own. Falls back to the company's default billing frequency, then to the product's own cadence. OFF keeps today's behaviour: only an explicit per-agreement billing schedule changes the cadence. */
  recurringFeePayerCadenceEnabled: Scalars['Boolean']['output'];
  /** Lets an office user exclude periods such as strikes or severe weather from a contractor's reliability figures. OFF ignores stored windows and reports today's figures. Built for HSY tender requirement 263. */
  reliabilityExclusionWindowsEnabled: Scalars['Boolean']['output'];
  /** Request rate limit per minute */
  requestRateLimit: Scalars['Int']['output'];
  /** Reverse and re-book periods already invoiced when an agreement change is recorded with an effective date in the past. The correction lines land on the customer's next regular invoice. Off by default; requires Invoicing and Product pricing. */
  retroactiveCorrectionEnabled: Scalars['Boolean']['output'];
  routeStudioEnabled: Scalars['Boolean']['output'];
  routeStudioTwoStepApproval: Scalars['Boolean']['output'];
  routeVehiclePolicy?: Maybe<Scalars['String']['output']>;
  scimTenantId?: Maybe<Scalars['String']['output']>;
  /** Default radius (km) around a Shared Collection Point; members outside it are flagged */
  scpDefaultRadiusKm?: Maybe<Scalars['Float']['output']>;
  scpShareMaxPct?: Maybe<Scalars['Int']['output']>;
  scpShareMinPct?: Maybe<Scalars['Int']['output']>;
  /** Lets the percentage shares of a shared service (yhteiskäyttösopimus) total 100 within a company-set margin instead of exactly 100. OFF keeps today's exact-100 rule. Built for HSY tender requirement 70. */
  scpShareSumToleranceEnabled: Scalars['Boolean']['output'];
  /** How far the sum of member shares may deviate from 100 when the tolerance is enabled (0.05 = 99.95–100.05 accepted). Percentage points, two decimals. */
  scpShareSumTolerancePct: Scalars['Decimal']['output'];
  searchLocale: CoreCompanySettingsSearchLocaleChoices;
  secondaryPortalFont: Scalars['String']['output'];
  secondaryPortalFontFamily: Scalars['String']['output'];
  /** Show the Shared Services module for this company (the Customers 'Shared services' nav entry, its tabs and routes, and the property 'Waste arrangement' section). Off (default) = hidden in the office UI; auto-enabled at rollout for companies that already have shared-service data. Display only. */
  sharedServicesEnabled: Scalars['Boolean']['output'];
  /** Enable the Finland-specific Shared Services parts (waste-authority notification / kimppailmoitus, register-basis and compliance surfaces, municipal radius and member-cap rules, minimum-fee advisory, authority decisions). Off = the generic shared-collection-point core only, for reuse outside Finland. Seeded on from a Finnish company country at rollout. */
  sharedServicesFinlandEnabled: Scalars['Boolean']['output'];
  showCountryInAddress: Scalars['Boolean']['output'];
  /** Enable the Finnish SIIRTO transfer document flow for this company: eligible container stops require a driver-signed transfer document before completion, the waste holder and the receiver sign electronically, and fully signed documents are handed to the SIIRTO register integration. OFF (default) keeps today's behaviour. */
  siirtoEnabled: Scalars['Boolean']['output'];
  /** Couple the transfer document to the chained load confirmation: prefill the receiver's block from the load unit job and take the receiver signature at the Unloaded step. OFF (default) = the receiver signs from the depot stop and unloading writes nothing onto the document. Only meaningful with siirto_enabled and an app build that has the load chain. */
  siirtoLoadChainReceiverEnabled: Scalars['Boolean']['output'];
  /** The container-storage depot (yard) skips are dispatched from: the skip route scheme is linked to it and the seeded truck is based there. Set by the Skip hire setup wizard's Yards step; empty until chosen (a company with a single yard needs none). */
  skipHireDispatchingDepot?: Maybe<DepotType>;
  /** Enables the Skip hire module for this company: skip rentals with delivery / collection / exchange / relocation, customer requests on the portal, permits, load classification and waste transfer notes, hire-period / weight / waiting-time fees. Off = the platform behaves as before the module existed. */
  skipHireEnabled: Scalars['Boolean']['output'];
  /** At the waste-station stop the driver app asks for the weigh-in (gross) and weigh-out (tare) - or a net - read off the site's bridge, slip number optional. Source 'weighbridge' typed by the driver. */
  skipWeightDriverAtTipEnabled: Scalars['Boolean']['output'];
  skipWeightMixedLoadSplit: Scalars['String']['output'];
  /** The office (or the bridge operator with an office login) adds or corrects the weight on the rental's collection, at any time - including after the return - or matches an imported weigh ticket to the skip. */
  skipWeightOfficeEnabled: Scalars['Boolean']['output'];
  /** Skip weights may come off the truck's chassis scale (the driver reads the on-board display; supports the tare-after-tip pattern). Source 'vehicle_scale'. */
  skipWeightTruckScaleEnabled: Scalars['Boolean']['output'];
  smsProvider?: Maybe<CoreCompanySettingsSmsProviderChoices>;
  /** SMS revenue type */
  smsRevenueType: CoreCompanySettingsSmsRevenueTypeChoices;
  /** Lets a special price carry its own terms: a container-hire charge kind, a validity period and editing in place. OFF hides the terms and prices as today, whatever a special price stores. Built for HSY tender requirement 244. */
  specialPriceTermsEnabled: Scalars['Boolean']['output'];
  ssoEmailDomains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Show the standalone contact registries (Individuals and Companies) in the office UI. Display only, no data is touched. */
  standaloneContactsEnabled: Scalars['Boolean']['output'];
  stopListContainerLevel?: Maybe<StopListCardConfigType>;
  stopListDepotStop?: Maybe<StopListCardConfigType>;
  stopListEmptyingStop?: Maybe<StopListCardConfigType>;
  stopListPropertyLevel?: Maybe<StopListCardConfigType>;
  stopListWasteStation?: Maybe<StopListCardConfigType>;
  stoplistcustomisationconfigSet: StopListCardConfigTypeConnection;
  suomifiEnabled: Scalars['Boolean']['output'];
  supportedLanguages: Array<Scalars['String']['output']>;
  /** Replaces the stop reset with a correction that asks, in the same step, whether the undone task is transferred to a service provider for rerouting (onto one of its routes or as a rerouting ticket in its list) and records the decision. OFF keeps today's reset button and refuses the correction endpoint. Built for HSY tender requirement 253. */
  taskCorrectionHandoverEnabled: Scalars['Boolean']['output'];
  /** Computes ticket deadlines per contract area, anchored to the day the customer asked for rather than the day the ticket was created. OFF keeps today's deadline calculation, whatever an area stores. Built for HSY tender requirement 256. */
  ticketAreaDeadlinesEnabled: Scalars['Boolean']['output'];
  ticketTypeCategoriseBy?: Maybe<TicketTypeOrderCategoriseBy>;
  ticketTypeNavAppOrderType?: Maybe<OrderTypeChoices>;
  ticketTypePlatformOrderType?: Maybe<OrderTypeChoices>;
  ticketTypePortalOrderType?: Maybe<OrderTypeChoices>;
  ticketVisibilityScopeEnabled: Scalars['Boolean']['output'];
  /** Records which load (kuorma) each emptied container went into at task confirmation and exposes the loads in the Truckloads table, on each task and in the container-to-load export. OFF writes no loads and hides the surfaces. Built for HSY tender requirements 28 and 206. */
  truckloadsEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wasteCarrierLicence: Scalars['String']['output'];
  /** The day the licence expires. Blank = not entered. */
  wasteCarrierLicenceExpiry?: Maybe<Scalars['Date']['output']>;
  /** Who issued the licence (e.g. Environment Agency). */
  wasteCarrierLicenceIssuer: Scalars['String']['output'];
  /** The carrier registration number quoted on customer movement messages (e.g. CBDU123456). Blank = not entered. */
  wasteCarrierLicenceNumber: Scalars['String']['output'];
  /** Show the waste-fraction NAME next to its icon in office list cells (tables, pickers). Off (default) = icon only, with the name on hover — the compact form the multi-fraction product pricing model needs. Enable for a company that reads its lists by fraction name. Display only, no data is touched. */
  wasteFractionLabelsEnabled: Scalars['Boolean']['output'];
  wastewaterTreatmentEnabled: Scalars['Boolean']['output'];
};


export type CompanySettingsTypePortalpagedescriptionsettingSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanySettingsTypeStoplistcustomisationconfigSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanySettingsTypeConnection = {
  __typename: 'CompanySettingsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanySettingsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CompanySettingsType` and its cursor. */
export type CompanySettingsTypeEdge = {
  __typename: 'CompanySettingsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompanySettingsType>;
};

export type CompanyStatusType = {
  __typename: 'CompanyStatusType';
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isBankrupt?: Maybe<Scalars['Boolean']['output']>;
  isDissolved?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * One (item type x warehouse) cell of the fleet overview: the
 * same numbers that warehouse's own Balances row shows.
 */
export type CompanyStockMatrixCellType = {
  __typename: 'CompanyStockMatrixCellType';
  alertsEnabled?: Maybe<Scalars['Boolean']['output']>;
  available?: Maybe<Scalars['Int']['output']>;
  critical?: Maybe<Scalars['Int']['output']>;
  incoming?: Maybe<Scalars['Int']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
  onHand?: Maybe<Scalars['Int']['output']>;
  reserved?: Maybe<Scalars['Int']['output']>;
  stockLevel?: Maybe<Scalars['String']['output']>;
  warehouseId?: Maybe<Scalars['ID']['output']>;
};

/**
 * One item type across every warehouse. Cells exist only where
 * the type has presence - an absent cell is "blank", deliberately
 * distinct from a monitored zero. In transit is row-level: a
 * mid-journey container belongs to no warehouse column.
 */
export type CompanyStockMatrixRowType = {
  __typename: 'CompanyStockMatrixRowType';
  cells?: Maybe<Array<Maybe<CompanyStockMatrixCellType>>>;
  fitsContainerTypeIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  inTransit?: Maybe<Scalars['Int']['output']>;
  itemKind?: Maybe<Scalars['String']['output']>;
  itemTypeId?: Maybe<Scalars['ID']['output']>;
  itemTypeName?: Maybe<Scalars['String']['output']>;
  partTypeId?: Maybe<Scalars['ID']['output']>;
  partTypeName?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  totalAvailable?: Maybe<Scalars['Int']['output']>;
  totalOnHand?: Maybe<Scalars['Int']['output']>;
};

/**
 * A6: one overview across the fleet - item-type rows x warehouse
 * columns, low/out-of-stock visible fleet-wide. Columns are paginated
 * (PRO-211): ``warehouses`` is one page, ``warehouse_total_count`` the
 * full column count for the pager.
 */
export type CompanyStockMatrixType = {
  __typename: 'CompanyStockMatrixType';
  rows?: Maybe<Array<Maybe<CompanyStockMatrixRowType>>>;
  warehouseTotalCount: Scalars['Int']['output'];
  warehouses?: Maybe<Array<Maybe<CompanyStockMatrixWarehouseType>>>;
};

/**
 * A matrix column: id is the DepotType relay gid, so columns can
 * link into the warehouse detail.
 */
export type CompanyStockMatrixWarehouseType = {
  __typename: 'CompanyStockMatrixWarehouseType';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyType = Node & {
  __typename: 'CompanyType';
  activepriceviewSet: ActivePriceDefConnection;
  agreementSet: AgreementDefConnection;
  agreementexportSet: AgreementExportDefConnection;
  agreementsuspensionSet: AgreementSuspensionDefConnection;
  agreementtemplateSet: AgreementTemplateDefConnection;
  agreementtemplateproductSet: AgreementTemplateProductDefConnection;
  alertSet: AlertDefConnection;
  alertruleSet: AlertRuleDefConnection;
  archivalRules: Array<ArchivalRuleDef>;
  areaSet: AreaDefConnection;
  areachangelogSet: Array<AreaExpiringEventDef>;
  autopilotFlowRuns: Array<AutopilotFlowRunType>;
  autopilotFlows: Array<FlowType>;
  autopilotPendingApprovals: Array<AutopilotPendingApprovalType>;
  autopilotStaffNotices: Array<AutopilotStaffNoticeEventDef>;
  autopilotSuggestions: Array<AutopilotSuggestionType>;
  billinginformation?: Maybe<BillingInformationType>;
  billingrunSet: BillingRunDefConnection;
  businessRegistryConfig?: Maybe<BusinessRegistryConfigDef>;
  changeproposalSet: ChangeProposalDefConnection;
  collectioncalendardeviationSet: CollectionCalendarDeviationDefConnection;
  collectioncalendarweekSet: CollectionCalendarWeekDefConnection;
  /** Hex color code */
  color?: Maybe<Scalars['String']['output']>;
  companySettings?: Maybe<CompanySettingsType>;
  companycontainermetatypeSet: CompanyContainerMetaTypeTypeConnection;
  companyemailaccountSet: CompanyEmailAccountDefConnection;
  companymetatypeSet: CompanyMetaTypeDefConnection;
  companyroleSet: CompanyRoleDefConnection;
  companyrolepermissionSet: CompanyRolePermissionDefConnection;
  compostingFormSubmissions: Array<CompostingFiledEventDef>;
  compostingNotificationTemplates: CompostingNotificationTemplateDefConnection;
  compostingRegistryEntries: CompostingRegistryEntryDefConnection;
  /** Company that owns this condition-type library entry. */
  conditionTypes: ConditionTypeTypeConnection;
  contactAuthorizations: ContactAuthorizationDefConnection;
  contactSet: ContactDefConnection;
  contactpropertynotificationruleSet: ContactPropertyNotificationRuleDefConnection;
  containerIdGenerator?: Maybe<ContainerIdGeneratorSettingsDef>;
  containerTypeWasteFractionRules: ContainerTypeWasteFractionRuleTypeConnection;
  containercustomeventSet: CustomContainerEventDefConnection;
  containernotificationSet: ContainerNotificationDefConnection;
  containerpriceSet: ContainerPriceDefConnection;
  contractareadocumentSet: ContractAreaDocumentDefConnection;
  councilFeeEntries: CouncilFeeTableEntryDefConnection;
  createdAt: Scalars['DateTime']['output'];
  criiptoapplicationSet: CriiptoApplicationDefConnection;
  customerfunctionSet: CustomerFunctionDefConnection;
  dashboardLocation: LocationWithContainerType;
  dashboardSet: DashboardDefConnection;
  debtorexportSet: DebtorExportDefConnection;
  deletionLog?: Maybe<DeletionEventDefConnection>;
  deletionLogActors?: Maybe<Array<Maybe<EventLogActorDef>>>;
  /** Company of this Depot */
  depots: DepotTypeConnection;
  description?: Maybe<Scalars['String']['output']>;
  dkdpCreds?: Maybe<DkdpCompanyCredentialsDef>;
  eventLog?: Maybe<CompanyEventsEventLogWrapper>;
  eventLogChangedByUsers?: Maybe<Array<Maybe<EventLogActorDef>>>;
  externalCollectionEvents: ExternalCollectionEventDefConnection;
  externalCrmDealId?: Maybe<Scalars['String']['output']>;
  externalCrmId?: Maybe<Scalars['String']['output']>;
  externalmaplayerSet: ExternalMapLayerDefConnection;
  fixedroutetemplateeventSet: FixedRouteTemplateEventTypeConnection;
  haulerSet: HaulerDefConnection;
  haulercompliancedocumentSet: HaulerComplianceDocumentDefConnection;
  haulercompliancedocumenttypeSet: HaulerComplianceDocumentTypeDefConnection;
  haulerpriceSet: HaulerPriceDefConnection;
  haulerpricechangelogSet: HaulerPriceChangeLogDefConnection;
  holidayDays: CompanyHolidayDayDefConnection;
  holidays: CompanyHolidayDefConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  industrycodeSet: IndustryCodeDefConnection;
  integrationgpsSet: IntegrationGpsTypeConnection;
  invoiceSet: InvoiceDefConnection;
  invoiceitemSet: InvoiceItemDefConnection;
  iouserSet: UserTypeConnection;
  isActive: Scalars['Boolean']['output'];
  isDemo: Scalars['Boolean']['output'];
  /** Company that owns this key-type library entry. */
  keyTypes: KeyTypeTypeConnection;
  kmdEasyCompanySettings?: Maybe<KmdEasyCompanySettingsDef>;
  kmdEasyDeltaFiles: KmdEasyDeltaFileDefConnection;
  kmdEasyImportedFiles: ImportedKmdEasyFileDefConnection;
  kmdEasyPropertyTypeToKmdEasyStationCodeMap: PropertyTypeToKmdEasyStationCodeMapDefConnection;
  kmdEasyTotalFiles: KmdEasyTotalFileDefConnection;
  loadClassifications: LoadClassificationDefConnection;
  /** Tenant wall. load_id is unique WITHIN a company, not globally: a globally-unique client-minted string would let one tenant collide with — or probe the existence of — another tenant's load. */
  loadUnitJobs: LoadUnitJobTypeConnection;
  /** Tenant wall, consistent with every other read surface */
  loads: TruckloadTypeConnection;
  logo?: Maybe<Scalars['String']['output']>;
  lorawandeviceSet: LorawanDeviceTypeConnection;
  managecontainerticketSet: ManageContainerTicketDefConnection;
  masterUsers?: Maybe<Array<Maybe<UserType>>>;
  masterdatasyncSet: MasterDataSyncDefConnection;
  matrikkelConfig?: Maybe<MatrikkelConfigDef>;
  metabaseJwt?: Maybe<Scalars['String']['output']>;
  mobiledeviceSet: MobileDeviceTypeConnection;
  municipalitySet: MunicipalityDefConnection;
  name: Scalars['String']['output'];
  notificationmessageSet: NotificationMessageDefConnection;
  notificationmethodSet: NotificationMethodDefConnection;
  parametersetSet: ParameterSetDefConnection;
  /** Company that owns this part-type library entry. */
  partTypes: PartTypeTypeConnection;
  paymentmethodSet: PaymentMethodDefConnection;
  permits: PermitDefConnection;
  physicalKeys: PhysicalKeyTypeConnection;
  pickuporderapprovalSet: PickUpOrderApprovalDefConnection;
  pickuporderapprovalcollectionSet: PickUpOrderApprovalCollectionDefConnection;
  priceSet: PriceDefConnection;
  productSet: ProductDefConnection;
  projectSet?: Maybe<ProjectTypeConnection>;
  propertySet: PropertyDefConnection;
  propertyWasteWaterTreatments: PropertyWasteWaterTreatmentDefConnection;
  propertycontactSet: PropertyContactDefConnection;
  propertygroupSet: PropertyGroupDefConnection;
  propertymanagementcompanySet: PropertyManagementCompanyDefConnection;
  propertytypeSet: PropertyTypeDefConnection;
  propertyuserSet: PropertyUserDefConnection;
  propertyvieweventSet: PropertyViewEventDefConnection;
  recurringpriceSet: RecurringPriceDefConnection;
  rentalRelocations: Array<RentalRelocationDef>;
  routestudioeventSet: RouteStudioEventDefConnection;
  ryhtiConfig?: Maybe<RyhtiConfigDef>;
  salesofferSet: SalesOfferTypeConnection;
  scheduledexportSet: ScheduledExportDefConnection;
  scheduledexportrunSet: ScheduledExportRunDefConnection;
  scpRoleDefinitions: ScpRoleDefinitionDefConnection;
  serviceSet: ServiceDefConnection;
  servicepriceSet: ServicePriceDefConnection;
  serviceresponsibilitySet: ServiceResponsibilityDefConnection;
  settings?: Maybe<SettingsType>;
  sigfoxdeviceSet: SigFoxDeviceTypeConnection;
  siirtoSettings?: Maybe<SiirtoCompanySettingsType>;
  /** Company, which skill related to */
  skillSet: SkillTypeConnection;
  snapshotbatchSet: SnapshotBatchDefConnection;
  soapApiCallHistories: EvolutionSoapApiCallHistoryDefConnection;
  soapApiCredentials: EvolutionSoapApiCredentialsDefConnection;
  /** Company that owns this spare-part catalogue entry. */
  spareParts: SparePartTypeConnection;
  stockAlerts: Array<StockAlertEventDef>;
  /** Tenant that owns this dispatch. */
  svarutDispatches: SvarUtDispatchTypeConnection;
  systemHistory?: Maybe<SystemHistoryPageDef>;
  systemHistoryActions?: Maybe<Array<SystemHistoryActionDef>>;
  systemHistoryActors?: Maybe<Array<SystemHistoryOptionDef>>;
  systemHistoryCatalog?: Maybe<Array<SystemHistoryEntityTypeDef>>;
  systemHistoryRecordSearch?: Maybe<Array<SystemHistoryRecordHitDef>>;
  systemHistoryRecords?: Maybe<Array<SystemHistoryOptionDef>>;
  teamSet: TeamTypeConnection;
  ticketSet: TicketDefConnection;
  ticketcategorySet: TicketCategoryDefConnection;
  ticketcommentSet: TicketCommentDefConnection;
  ticketcustomfieldSet: TicketCustomFieldDefConnection;
  ticketdraftSet: TicketDraftDefConnection;
  ticketmessageSet: TicketMessageDefConnection;
  ticketmessagetemplateSet: TicketMessageTemplateDefConnection;
  tickettypeSet: TicketTypeDefConnection;
  updatedAt: Scalars['DateTime']['output'];
  urbaserCreds?: Maybe<UrbaserCredentialsDef>;
  /** Tenant the emitting vehicle belongs to. */
  vehicleConfirmationSignals: VehicleConfirmationSignalTypeConnection;
  vehicletrailerSet: VehicleTrailerTypeConnection;
  vehicletrailertickettypeholdSet: VehicleTrailerTicketTypeHoldTypeConnection;
  vehicletrailerwasteholdSet: VehicleTrailerWasteHoldTypeConnection;
  vehicletypeSet: VehicleTypeTypeConnection;
  vismaCompanySettings?: Maybe<VismaCompanySettingsType>;
  washlistSet: WashListDefConnection;
  wasteTransferNotes: WasteTransferNoteDefConnection;
  /** Company that owns this appliance-catalogue entry. */
  wasteWaterApplianceOptions: WasteWaterApplianceOptionDefConnection;
  /** Tenant this weighing belongs to (never client-supplied) */
  weighTickets: WeighTicketTypeConnection;
  zoneSet: ZoneDefConnection;
  zonelabelSet: ZoneLabelDefConnection;
};


export type CompanyTypeActivepriceviewSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeAgreementSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeAgreementexportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeAgreementsuspensionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeAgreementtemplateSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeAgreementtemplateproductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeAlertSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeAlertruleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeAreaSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeBillingrunSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeChangeproposalSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeCollectioncalendardeviationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeCollectioncalendarweekSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeCompanycontainermetatypeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeCompanyemailaccountSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeCompanymetatypeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeCompanyroleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeCompanyrolepermissionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeCompostingNotificationTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeCompostingRegistryEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeConditionTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeContactAuthorizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeContactSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeContactpropertynotificationruleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeContainerTypeWasteFractionRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeContainercustomeventSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeContainernotificationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeContainerpriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeContractareadocumentSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeCouncilFeeEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeCriiptoapplicationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeCustomerfunctionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeDashboardSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeDebtorexportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeDeletionLogArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customerSite?: InputMaybe<Scalars['String']['input']>;
  deletedBy?: InputMaybe<Scalars['String']['input']>;
  deletedByIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  entityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reasonCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyTypeDepotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeEventLogArgs = {
  addCollectionCalendarDateEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addCollectionCalendarEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addCompanyEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addCompanyMetaTypeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addCompanySettingsEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addContainerTypeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addDeletionEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addPickupSettingsEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addPortalRoleCapabilityEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addPriceEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addProductEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addProductManagementEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addTicketTypeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addWasteFractionEvents?: InputMaybe<Scalars['Boolean']['input']>;
  authorAuthority?: InputMaybe<Scalars['Boolean']['input']>;
  changedByIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  collectionCalendarEventTypes?: InputMaybe<Array<InputMaybe<CollectionCalendarEventTypesGraphene>>>;
  companyEventTypes?: InputMaybe<Array<InputMaybe<CompanyEventTypesGraphene>>>;
  companyMetaTypeEventTypes?: InputMaybe<Array<InputMaybe<CompanyMetaTypeEventTypesGraphene>>>;
  companySettingsEventTypes?: InputMaybe<Array<InputMaybe<CompanySettingsEventTypesGraphene>>>;
  containerTypeEventTypes?: InputMaybe<Array<InputMaybe<ContainerTypeEventTypesGraphene>>>;
  deletionEntityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pickupSettingsEventTypes?: InputMaybe<Array<InputMaybe<PickupSettingsEventTypesGraphene>>>;
  portalRoleCapabilityEventTypes?: InputMaybe<Array<InputMaybe<PortalRoleCapabilitiesEventTypesGraphene>>>;
  priceEventTypes?: InputMaybe<Array<InputMaybe<PriceEventTypesGraphene>>>;
  productEventTypes?: InputMaybe<Array<InputMaybe<ProductEventTypesGraphene>>>;
  productManagementActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productManagementEntityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketTypeEventTypes?: InputMaybe<Array<InputMaybe<TicketTypeEventTypesShortGraphene>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  wasteFractionEventTypes?: InputMaybe<Array<InputMaybe<WasteFractionEventTypesGraphene>>>;
};


export type CompanyTypeExternalCollectionEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeExternalmaplayerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeFixedroutetemplateeventSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeHaulerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeHaulercompliancedocumentSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeHaulercompliancedocumenttypeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeHaulerpriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeHaulerpricechangelogSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeHolidayDaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeHolidaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  recurrence?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyTypeIndustrycodeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeIntegrationgpsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeInvoiceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeInvoiceitemSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeIouserSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeKeyTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeKmdEasyDeltaFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeKmdEasyImportedFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeKmdEasyPropertyTypeToKmdEasyStationCodeMapArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeKmdEasyTotalFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeLoadClassificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeLoadUnitJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeLoadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  openedAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeLorawandeviceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  devId_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeManagecontainerticketSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeMasterdatasyncSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeMobiledeviceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  devId_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeMunicipalitySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeNotificationmessageSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeNotificationmethodSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeParametersetSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePartTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePaymentmethodSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePermitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePhysicalKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePickuporderapprovalSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePickuporderapprovalcollectionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeProductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeProjectSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePropertySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePropertyWasteWaterTreatmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePropertycontactSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePropertygroupSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePropertymanagementcompanySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePropertytypeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePropertyuserSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypePropertyvieweventSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeRecurringpriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeRoutestudioeventSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeSalesofferSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeScheduledexportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeScheduledexportrunSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeScpRoleDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeServiceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeServicepriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeServiceresponsibilitySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeSigfoxdeviceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  devId_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeSkillSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeSnapshotbatchSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeSoapApiCallHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeSoapApiCredentialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeSparePartsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeSvarutDispatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticket?: InputMaybe<Scalars['ID']['input']>;
  useCase?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyTypeSystemHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SystemHistoryFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeSystemHistoryActorsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyTypeSystemHistoryRecordSearchArgs = {
  search: Scalars['String']['input'];
};


export type CompanyTypeSystemHistoryRecordsArgs = {
  entityType: Scalars['String']['input'];
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyTypeTeamSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeTicketSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeTicketcategorySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeTicketcommentSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeTicketcustomfieldSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeTicketdraftSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeTicketmessageSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeTicketmessagetemplateSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeTickettypeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeVehicleConfirmationSignalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeVehicletrailerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeVehicletrailertickettypeholdSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeVehicletrailerwasteholdSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeVehicletypeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeWashlistSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeWasteTransferNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeWasteWaterApplianceOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeWeighTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeZoneSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeZonelabelSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyTypeConnection = {
  __typename: 'CompanyTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CompanyType` and its cursor. */
export type CompanyTypeEdge = {
  __typename: 'CompanyTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyType>;
};

export type ComparisonSettingsType = Node & {
  __typename: 'ComparisonSettingsType';
  amountOfCollection?: Maybe<Scalars['Int']['output']>;
  amountOfCollectionPeriod?: Maybe<AnalyticsComparisonSettingsAmountOfCollectionPeriodChoices>;
  averageFillLevel?: Maybe<Scalars['Decimal']['output']>;
  chanceOfOverflowing?: Maybe<Scalars['Decimal']['output']>;
  /** Cost per collection */
  collectionCost: Scalars['Float']['output'];
  /** Cost per tonne */
  costPerTonne?: Maybe<Scalars['Float']['output']>;
  costSettings: CostSettingsType;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Income per collection */
  incomePerTonne?: Maybe<Scalars['Float']['output']>;
  /** Cost per overflowing collection */
  overflowingCost?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** kg for m^3 */
  weightFactor: Scalars['Float']['output'];
};

export type ComparisonSettingsTypeConnection = {
  __typename: 'ComparisonSettingsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ComparisonSettingsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ComparisonSettingsType` and its cursor. */
export type ComparisonSettingsTypeEdge = {
  __typename: 'ComparisonSettingsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ComparisonSettingsType>;
};

export type ComparisonType = {
  __typename: 'ComparisonType';
  comparison?: Maybe<Scalars['Float']['output']>;
  selected?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/**
 * One bonus/penalty/correction that landed for a contractor (PRO-109).
 *
 * A labelled projection of the settlement engine's per-period coefficient
 * adjustment — the frozen snapshot for closed runs, the live engine read
 * for open ones. Amounts are the engine's, verbatim.
 */
export type CompensationEventType = {
  __typename: 'CompensationEventType';
  /** Signed cents: the engine's coefficient adjustment for the period (positive = bonus, negative = penalty). */
  amount: Scalars['Int']['output'];
  areaId?: Maybe<Scalars['ID']['output']>;
  areaName?: Maybe<Scalars['String']['output']>;
  bonusModelId?: Maybe<Scalars['ID']['output']>;
  bonusModelName?: Maybe<Scalars['String']['output']>;
  coefficient?: Maybe<Scalars['Float']['output']>;
  /** bonus | penalty | correction */
  eventType: Scalars['String']['output'];
  month: Scalars['Int']['output'];
  overrideReason?: Maybe<Scalars['String']['output']>;
  periodEnd?: Maybe<Scalars['String']['output']>;
  periodStart?: Maybe<Scalars['String']['output']>;
  /** When the settlement run froze this period (ISO datetime); null while the period is still open. */
  runClosedAt?: Maybe<Scalars['String']['output']>;
  /** manual_correction | reliability_band | complaint_share — what drove the event (labels on engine outputs). */
  source: Scalars['String']['output'];
  /** open | closed */
  status?: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};

/**
 * lane-E (PRO-103, REQ 3.3.22): the applied pay effect behind a
 * complaint's ``affectsPay`` flag — WHICH settlement run the complaint
 * lands in and WHAT amount that run's complaint-driven adjustment is.
 *
 * Strictly a READ-ONLY projection of the W9 settlement machinery (8B):
 * a closed period answers from its frozen snapshot; an open period
 * recomputes the period's base report live (no carry-over — the
 * complaint adjustment never depends on it). The engine prices
 * complaints at PERIOD grain (all pay-affecting complaints move one
 * coefficient together), so ``bonusPenaltyAmount`` is the period's
 * whole adjustment with ``complaintsAffectingPay`` alongside — never a
 * fabricated per-complaint split.
 */
export type ComplaintPayEffectType = {
  __typename: 'ComplaintPayEffectType';
  /** The office's pay ruling on this complaint (D5). */
  affectsPay?: Maybe<Scalars['Boolean']['output']>;
  areaId?: Maybe<Scalars['ID']['output']>;
  /** The contract area whose settlement the complaint lands in (the settlement unit of account, D8). Null when the complaint is not linked to an area — then no settlement effect exists. */
  areaName?: Maybe<Scalars['String']['output']>;
  /** Signed cents: the period's whole coefficient adjustment (compensation × (Bc − 1)). Null when no area is linked. */
  bonusPenaltyAmount?: Maybe<Scalars['Int']['output']>;
  /** The period's effective bonus coefficient Bc (computed or office-overridden). Null when no compensation model applies. */
  coefficient?: Maybe<Scalars['Float']['output']>;
  /** Pay-affecting complaints sharing this period's adjustment. */
  complaintsAffectingPay?: Maybe<Scalars['Int']['output']>;
  /** All complaints raised in the period for the area. */
  complaintsTotal?: Maybe<Scalars['Int']['output']>;
  month: Scalars['Int']['output'];
  /** open | closed — null when the complaint has no area to settle against. */
  periodStatus?: Maybe<Scalars['String']['output']>;
  /** Settlement period the complaint was raised in. */
  year: Scalars['Int']['output'];
};

export type ComplaintReasonCountType = {
  __typename: 'ComplaintReasonCountType';
  count: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type CompleteActionsRequirements = {
  __typename: 'CompleteActionsRequirements';
  requireContainerIdBarcodeScanning?: Maybe<Scalars['Boolean']['output']>;
  requireContainerLabelPrinted?: Maybe<Scalars['Boolean']['output']>;
  requireContainerLocation?: Maybe<Scalars['Boolean']['output']>;
  requireRfidPairing?: Maybe<Scalars['Boolean']['output']>;
  rfidPairingMode?: Maybe<Scalars['String']['output']>;
};

export type CompleteAlert = {
  __typename: 'CompleteAlert';
  alert?: Maybe<AlertDef>;
};

/**
 * Complete a skip exchange from the office (PRODUCT-471, BE-P2-1):
 * the Exchange ticket's completion modal, Issue-modal style - the office
 * picks the skip that was delivered (``deliveredContainerId``) and the
 * old skip comes back to stock, its hire ending the day before, while
 * the new skip goes out on its own hire from today
 * (``inventory.services.rental_exchange.complete_exchange``). Without
 * ``deliveredContainerId`` the old skip is returned and the new hire is
 * booked; the office then dispatches it through the Issue modal
 * (``issueRental``). ``warehouseId`` names the warehouse the old skip
 * goes back to (default: the hire's return warehouse). Same company
 * wall as the other rental mutations (checked before anything about the
 * ticket is revealed); a wrong pick is refused naming
 * ``deliveredIdentity``. Idempotent. ``deliveredContainerId`` in the
 * payload is the delivered skip's Container gid - the same value space
 * as the argument, so it round-trips; ``deliveredContainerLabel`` is
 * its human label (``container_id``).
 */
export type CompleteExchange = {
  __typename: 'CompleteExchange';
  deliveredContainerId?: Maybe<Scalars['ID']['output']>;
  deliveredContainerLabel?: Maybe<Scalars['String']['output']>;
  exchangeTicketId?: Maybe<Scalars['ID']['output']>;
  newTicketId?: Maybe<Scalars['ID']['output']>;
  oldTicketId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CompleteTicketDraft = {
  __typename: 'CompleteTicketDraft';
  ticketDraft?: Maybe<TicketDraftDef>;
};

/**
 * Renderable input types.
 *
 *     Deliberately NOT ``core.choices.MetaTypeInputType``: that enum has six
 *     members and is load-bearing for ticket/property custom fields, the
 *     ``meta_data`` JSON bag and the export pipeline, so widening it to cover a
 *     statutory form would ripple far outside this feature.
 *
 */
export enum CompostingFieldInputType {
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  EMAIL = 'EMAIL',
  MONTH_YEAR = 'MONTH_YEAR',
  MULTI_SELECT = 'MULTI_SELECT',
  NUMBER = 'NUMBER',
  PHONE = 'PHONE',
  SELECT = 'SELECT',
  SIGNATURE = 'SIGNATURE',
  TEXT = 'TEXT',
  TEXT_AREA = 'TEXT_AREA'
}

/**
 * Where a field's value comes from.
 *
 *     ``SYSTEM`` and ``SYSTEM_PREFILL`` both require a ``system_binding``; they
 *     differ only in whether the human may correct the resolved value. The
 *     register data behind these bindings is routinely stale in practice (a
 *     freshly split parcel, an unregistered address), so the seeded template uses
 *     ``SYSTEM_PREFILL`` for everything — a notification the citizen cannot
 *     correct is worse than one they can.
 *
 */
export enum CompostingFieldSource {
  SYSTEM = 'SYSTEM',
  SYSTEM_PREFILL = 'SYSTEM_PREFILL',
  USER = 'USER'
}

/**
 * A citizen's composting notification, as the ``event`` of a bell-icon
 * UserNotification.
 *
 * The office is told a statutory filing arrived, and the card deep-links to
 * the register entry it created so the row can be inspected without hunting
 * for it.
 *
 * The event is the SUBMISSION, not the register entry: the entry is
 * SoftDeletable and the bell's existence check runs through the default
 * manager, so a soft-deleted entry would take its notification out of the
 * feed while leaving it in the badge — the exact contradiction 8a133a07b
 * fixed. A submission is never deleted.
 *
 * ``get_queryset`` is NOT optional. Registering any DjangoObjectType for a
 * model makes graphene-django auto-attach reverse fields for it elsewhere in
 * the schema (CompanyDef.areachangelogSet is the standing proof), and
 * DjangoListField.list_resolver honours get_queryset — so this method is what
 * keeps a private notification card type from becoming a company-wide read
 * surface. AreaExpiringEventDef above is missing it; do not copy that.
 */
export type CompostingFiledEventDef = {
  __typename: 'CompostingFiledEventDef';
  contactId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  propertyAddress?: Maybe<Scalars['String']['output']>;
  propertyId?: Maybe<Scalars['ID']['output']>;
  registryEntryId?: Maybe<Scalars['ID']['output']>;
  submittedAt: Scalars['DateTime']['output'];
};

/**
 * One answered question, as it was asked at the time of filing.
 *
 * ``displayValue`` is a convenience and is ENGLISH for booleans ("Yes"/"No")
 * — a localized client must render those from ``value`` + ``inputType``.
 * Option labels are different: they come from the snapshot, so they are
 * already in the language the form was authored in.
 */
export type CompostingFilingAnswerDef = {
  __typename: 'CompostingFilingAnswerDef';
  displayValue?: Maybe<Scalars['String']['output']>;
  fieldKey: Scalars['String']['output'];
  helpText?: Maybe<Scalars['String']['output']>;
  inputType?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['GenericScalar']['output']>;
};

/**
 * The originating filing, rendered from its own frozen snapshot.
 *
 * There is deliberately no ``CompostingFormSubmissionDef`` Node type and no
 * edge from here to the live template: re-rendering a 2021 filing must show
 * the 2021 form. Anything that could navigate back to the current template
 * would make that guarantee depend on the client not following the link.
 */
export type CompostingFilingDef = {
  __typename: 'CompostingFilingDef';
  authorityName?: Maybe<Scalars['String']['output']>;
  legalReferences?: Maybe<Scalars['String']['output']>;
  rawAnswers?: Maybe<Scalars['GenericScalar']['output']>;
  sections: Array<CompostingFilingSectionDef>;
  snapshotVersion?: Maybe<Scalars['Int']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
};

export type CompostingFilingSectionDef = {
  __typename: 'CompostingFilingSectionDef';
  answers: Array<CompostingFilingAnswerDef>;
  helpText?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum CompostingInspectionResult {
  FAIL = 'FAIL',
  PASS = 'PASS'
}

/**
 * One question on the composting notification form.
 *
 * ``label`` and ``helpText`` are ENGLISH SOURCE STRINGS — the backend never
 * localizes them. The frontend runs them through Transifex, whose dashboard
 * holds every translation (see
 * ``manage.py export_composting_i18n_strings``).
 */
export type CompostingNotificationFieldDef = Node & {
  __typename: 'CompostingNotificationFieldDef';
  defaultValue?: Maybe<Scalars['GenericScalar']['output']>;
  helpText: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  inputType: CompostingFieldInputType;
  isRequired: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<CompostingNotificationFieldOptionDef>;
  order: Scalars['Int']['output'];
  placeholder: Scalars['String']['output'];
  systemBinding: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  validation?: Maybe<Scalars['GenericScalar']['output']>;
  valueSource: CompostingFieldSource;
  visibleWhen?: Maybe<Scalars['GenericScalar']['output']>;
};

/**
 * One choice of a SELECT / MULTI_SELECT field.
 *
 * ``requiresSpecification`` marks the "Other" choice, which demands the
 * companion free-text field (the core.IndustryCode precedent).
 */
export type CompostingNotificationFieldOptionDef = Node & {
  __typename: 'CompostingNotificationFieldOptionDef';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  requiresSpecification: Scalars['Boolean']['output'];
};

/** One numbered section of the form. Labels are English source strings. */
export type CompostingNotificationSectionDef = Node & {
  __typename: 'CompostingNotificationSectionDef';
  fields: Array<CompostingNotificationFieldDef>;
  helpText: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  visibleWhen?: Maybe<Scalars['GenericScalar']['output']>;
};

/**
 * A company's composting-notification form definition.
 *
 * Readable by any authenticated user of the company (the renderer needs it);
 * every WRITE is gated on ``login_is_staff_required`` in the mutations — see
 * crm/schema/mutations.py.
 */
export type CompostingNotificationTemplateDef = Node & {
  __typename: 'CompostingNotificationTemplateDef';
  authorityName: Scalars['String']['output'];
  authorityReturnAddress: Scalars['String']['output'];
  availableSystemBindings: Array<Scalars['String']['output']>;
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  fieldCount: Scalars['Int']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isSystemSeeded: Scalars['Boolean']['output'];
  legalReferences: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sectionCount: Scalars['Int']['output'];
  sections: Array<CompostingNotificationSectionDef>;
  status: CompostingTemplateStatus;
  updatedAt: Scalars['DateTime']['output'];
  validationProblems: Array<Scalars['String']['output']>;
};

export type CompostingNotificationTemplateDefConnection = {
  __typename: 'CompostingNotificationTemplateDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompostingNotificationTemplateDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CompostingNotificationTemplateDef` and its cursor. */
export type CompostingNotificationTemplateDefEdge = {
  __typename: 'CompostingNotificationTemplateDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompostingNotificationTemplateDef>;
};

/**
 * What this viewer may do to this row, right now.
 *
 * Permission AND state, resolved together, because the UI hides reserved
 * actions rather than disabling them and needs one answer per row. Each flag
 * mirrors the service guard the mutation actually enforces — a flag that said
 * yes where the service says no would render a button that always errors.
 */
export type CompostingRegistryEntryActionsDef = {
  __typename: 'CompostingRegistryEntryActionsDef';
  delete: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
  end: Scalars['Boolean']['output'];
  recordInspection: Scalars['Boolean']['output'];
};

/**
 * One notification in the register.
 *
 * ``properties`` is an M2M because a shared composter (*kimppa*) covers
 * several addresses — which is also why this type carries its own
 * ``company``, and why its permissions are its own rather than borrowed from
 * a parent property.
 */
export type CompostingRegistryEntryDef = Node & {
  __typename: 'CompostingRegistryEntryDef';
  apartmentDesignation: Scalars['String']['output'];
  apartmentIdentifier?: Maybe<Scalars['String']['output']>;
  brand: Scalars['String']['output'];
  company: CompanyType;
  contact?: Maybe<ContactDef>;
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  endReason: Scalars['String']['output'];
  expiryDate: Scalars['Date']['output'];
  filing?: Maybe<CompostingFilingDef>;
  hasReportedStop: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  inspectionDate?: Maybe<Scalars['Date']['output']>;
  inspectionNotes: Scalars['String']['output'];
  inspectionResult?: Maybe<CompostingInspectionResult>;
  isShared: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
  notes: Scalars['String']['output'];
  notificationDate: Scalars['Date']['output'];
  notifierEmail: Scalars['String']['output'];
  notifierName: Scalars['String']['output'];
  predecessor?: Maybe<CompostingRegistryEntryDef>;
  properties: Array<PropertyDef>;
  sizeLitres: Scalars['Int']['output'];
  state: CompostingRegistryStateEnum;
  successors: Array<CompostingRegistryEntryDef>;
  updatedAt: Scalars['DateTime']['output'];
  usageMonths: Array<Scalars['Int']['output']>;
  viewerCan: CompostingRegistryEntryActionsDef;
};

export type CompostingRegistryEntryDefConnection = {
  __typename: 'CompostingRegistryEntryDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompostingRegistryEntryDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CompostingRegistryEntryDef` and its cursor. */
export type CompostingRegistryEntryDefEdge = {
  __typename: 'CompostingRegistryEntryDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompostingRegistryEntryDef>;
};

/**
 * A register row's derived lifecycle state.
 *
 * Hand-written rather than ``from_enum`` because the authority,
 * ``crm.services.composting.CompostingRegistryState``, is a plain class and
 * not a ``TextChoices`` — it cannot become one, because its ``LEGALLY_VALID``
 * frozenset attribute would be swallowed as an enum member. The state is
 * derived on read (Ended > Expired > Expiring > Active) and is deliberately
 * not a column, so there is no model field to generate from either.
 *
 * An enum rather than a String on purpose: the frontend gets an exhaustive
 * union, so a fifth state becomes a compile error instead of a silently
 * unhandled branch. Going the other way later (String now, enum once it
 * settles) would be a breaking schema change needing the
 * ``acknowledged-graphql-breaking-change`` label.
 *
 * ``test_the_graphql_enum_matches_the_service`` pins these to the service.
 */
export enum CompostingRegistryStateEnum {
  ACTIVE = 'ACTIVE',
  ENDED = 'ENDED',
  EXPIRED = 'EXPIRED',
  EXPIRING = 'EXPIRING'
}

/** An enumeration. */
export enum CompostingTemplateStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

/**
 * Diff the plan against live: affected households (exact, RS-E5
 * semantics), route counts, detected frequency changes (D30).
 * Import promotions (RS-E28) diff their materialization + bindings
 * against live schemes per client route identity instead.
 */
export type ComputePromotionDiffMutation = {
  __typename: 'ComputePromotionDiffMutation';
  promotion?: Maybe<PromotionDef>;
};

/**
 * A Condition-type: an entry in the company's structured condition
 * library for individual containers (PRO-391, 3.12.28).
 */
export type ConditionTypeType = Node & {
  __typename: 'ConditionTypeType';
  /** Company that owns this condition-type library entry. */
  company: CompanyType;
  containers: ContainerTypeConnection;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Part of the canonical, system-seeded library. */
  isSystemSeeded: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** When a container is changed to this condition, the caller may optionally raise a repair ticket for it. */
  raisesRepairTicket: Scalars['Boolean']['output'];
};


/**
 * A Condition-type: an entry in the company's structured condition
 * library for individual containers (PRO-391, 3.12.28).
 */
export type ConditionTypeTypeContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ConditionTypeTypeConnection = {
  __typename: 'ConditionTypeTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ConditionTypeTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ConditionTypeType` and its cursor. */
export type ConditionTypeTypeEdge = {
  __typename: 'ConditionTypeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ConditionTypeType>;
};

/**
 * Confirm inbound in-transit containers at this warehouse and
 * make the usable-vs-scrap call per container (ADR-0005): usable is
 * +1 on the count and the identity goes dormant (labels kept, ready
 * to resurrect at a later deployment scan); scrap never enters the
 * count - a terminal decommission at the door.
 */
export type ConfirmArrival = {
  __typename: 'ConfirmArrival';
  containerIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * The human confirmation that makes a rule real (D39): assigns
 * the BR-<id> constraint identity; the rule binds the next run.
 */
export type ConfirmBrainRuleMutation = {
  __typename: 'ConfirmBrainRuleMutation';
  brainRule?: Maybe<BrainRuleDef>;
};

/**
 * Operator confirm/override of a candidate table's document
 * class (RS-E21 stage B): the human word beats the classifier and
 * is recorded as such. Also answers the table's open
 * class_confirmation question.
 */
export type ConfirmCandidateTableClassMutation = {
  __typename: 'ConfirmCandidateTableClassMutation';
  candidateTable?: Maybe<CandidateTableDef>;
};

/**
 * Applies a legacy-rule-to-flow conversion: creates a new `draft`
 * Flow + its first FlowVersion from the rule's *current* actions
 * (recomputed here, never trusting a client-echoed definition -- the
 * same defense the rest of this schema applies to derived state).
 *
 * The legacy `Rule` row (and its actions) are never written to by this
 * mutation -- it keeps running exactly as it did before, per
 * 06_DECISIONS_RISKS.md ("legacy rules untouched by default... conversion
 * is... reversible"). The new Flow starts in `draft` and does not
 * self-promote; `PromoteAutopilotFlow` (a separate, explicit step) is
 * still required before it can ever run live.
 *
 * Wave 2 Lane D S3 (dedupe guard): at most ONE non-archived flow per
 * `origin=legacy_rule:N`. A second confirm for the same rule is refused
 * with the EXISTING flow returned on the (ok=False) response envelope, so
 * the estate view can link straight to it instead of minting a
 * doppelgänger whose activation would fight the first one over the same
 * source rule (whichever activated last would own `superseded_by_flow_id`
 * while both fired). Serialized per rule with a `select_for_update` on
 * the Rule row, so two concurrent confirms cannot both pass the check.
 * An ARCHIVED converted flow does not block re-conversion: archiving is
 * the one terminal state, and re-converting is the supported way to
 * start over.
 */
export type ConfirmConvertLegacyRuleToFlow = {
  __typename: 'ConfirmConvertLegacyRuleToFlow';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  flow?: Maybe<FlowType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type ConfirmDriverPushNotification = {
  __typename: 'ConfirmDriverPushNotification';
  driverPushNotification?: Maybe<DriverPushNotificationType>;
};

/**
 * The office's attribution ruling on a futile visit. Only a
 * confirmed CUSTOMER fault produces a fee (through the money lane's
 * plain-data producer); hauler/external faults are recorded and
 * never bill; an unclear fault cannot be confirmed at all — doubt
 * never bills.
 *
 * FIXIT3-O1 (D-E22): confirming ANY fault also VOIDS the service
 * line (status ``futile_voided``, terminal) — the visit was futile,
 * so the service is never billed at order close; only the confirmed
 * customer-fault FEE bills. The void path IS this mutation (D-E22's
 * "fold into confirmFutileFault" option): a separate
 * voidHaulerOrderLine would be a second writer of the same ruling.
 * The returned ``order`` carries the voided line and the refreshed
 * execution rollup. Office-only like every hauler-order surface
 * (DENIED stance, D-E10): ``_require_company`` denies contractor
 * logins and unflagged tenants before any data is touched.
 */
export type ConfirmHaulerFutileFault = {
  __typename: 'ConfirmHaulerFutileFault';
  futileVisit?: Maybe<HaulerFutileVisitDef>;
  /** The line's order after the ruling — the voided line (status futile_voided) and the refreshed execution rollup, so the screen needs no second fetch. */
  order?: Maybe<HaulerOrderDef>;
};

/**
 * DRAFT → CONFIRMED, and the order becomes real work (HAUL-409 +
 * S2-O2 bridge: one ticket per line via existing primitives).
 */
export type ConfirmHaulerOrder = {
  __typename: 'ConfirmHaulerOrder';
  /** G2S1-O2 (HAUL-209): honest words about quoted lines that were below the stamped price list's minimum — adjusted or warned per the list's rule. Empty when no list is stamped or nothing was below a minimum. */
  minimumNotices?: Maybe<Array<Scalars['String']['output']>>;
  order?: Maybe<HaulerOrderDef>;
};

/** The human-confirm step (F1): no mapping applies without it. */
export type ConfirmImportMappingMutation = {
  __typename: 'ConfirmImportMappingMutation';
  importBatch?: Maybe<ImportBatchDef>;
};

export type ConfirmInsightsAlert = {
  __typename: 'ConfirmInsightsAlert';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/**
 * Confirm the stops for N simultaneously-read tags in ONE call.
 *
 * REQ 42's use case: a lift reader reads two containers at once (or two
 * readers each read one), and the system receives BOTH. Each confirmation
 * keeps its own provenance — which tag, which reader, when — so two
 * containers emptied in one lift stay distinguishable afterwards.
 *
 * Never all-or-nothing: every read gets its own status. A repeated tag is
 * a DUPLICATE, an already-completed stop is ALREADY_COMPLETED, and a stop
 * the funnel refuses is REJECTED with its sentence — none of which
 * prevents the stop beside it from being confirmed.
 */
export type ConfirmStopsByTags = {
  __typename: 'ConfirmStopsByTags';
  confirmedCount: Scalars['Int']['output'];
  duplicateCount: Scalars['Int']['output'];
  rejectedCount: Scalars['Int']['output'];
  results: Array<TagReadResultType>;
  route?: Maybe<RouteType>;
};

export type ConfirmStopsByTagsInput = {
  /** One collection instant for the whole simultaneous read. A read carrying its own readAt wins over it; absent both, now. */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reads: Array<TagReadInputType>;
  routeId: Scalars['ID']['input'];
};

export type ConflictField = {
  __typename: 'ConflictField';
  clientValue: Scalars['String']['output'];
  field: Scalars['String']['output'];
  serverValue: Scalars['String']['output'];
};

/** A zone shared by both sides of a collision. */
export type ConflictZoneDef = {
  __typename: 'ConflictZoneDef';
  /** Raw zone ULID. */
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ContactAddressDef = Node & {
  __typename: 'ContactAddressDef';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressType: CrmContactAddressAddressTypeChoices;
  coName?: Maybe<Scalars['String']['output']>;
  contact: ContactDef;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fullAddress?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  postalCodeName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ContactAddressDefConnection = {
  __typename: 'ContactAddressDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContactAddressDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContactAddressDef` and its cursor. */
export type ContactAddressDefEdge = {
  __typename: 'ContactAddressDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContactAddressDef>;
};

export type ContactAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressType?: InputMaybe<Scalars['String']['input']>;
  coName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeName?: InputMaybe<Scalars['String']['input']>;
};

export type ContactAuthorizationDef = Node & {
  __typename: 'ContactAuthorizationDef';
  authorizationMethod?: Maybe<AuthorizationMethodDef>;
  /** External reference number for this authorization */
  authorizationReference: Scalars['String']['output'];
  authorizationType?: Maybe<AuthorizationTypeDef>;
  /** Internal user who created this authorization */
  authorizedBy?: Maybe<UserType>;
  /** The contact receiving authorization */
  authorizedContact: ContactDef;
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** When the authorization ends (null for open-ended) */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Optional signed mandate document (PDF/image, ≤ 5 MB) */
  mandateDocument?: Maybe<Scalars['String']['output']>;
  mandateDocumentContentType: Scalars['String']['output'];
  mandateDocumentSizeBytes?: Maybe<Scalars['Int']['output']>;
  mandateDocumentUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The contact granting authorization */
  principalContact: ContactDef;
  /** When the authorization becomes effective */
  startDate: Scalars['DateTime']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ContactAuthorizationDefConnection = {
  __typename: 'ContactAuthorizationDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContactAuthorizationDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContactAuthorizationDef` and its cursor. */
export type ContactAuthorizationDefEdge = {
  __typename: 'ContactAuthorizationDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContactAuthorizationDef>;
};

export type ContactDef = Node & {
  __typename: 'ContactDef';
  /** The contact's currently-active agreements — the list behind activeContainerCount / activeRecurringFeeCount. Empty for contractor (hauler) logins. */
  activeAgreements: Array<AgreementDef>;
  activeContainerCount: Scalars['Int']['output'];
  activeNoteCount: Scalars['Int']['output'];
  activeRecurringFeeCount: Scalars['Int']['output'];
  additionalServicesSalesBan?: Maybe<Scalars['Boolean']['output']>;
  additionalServicesSalesBanReason: Scalars['String']['output'];
  addresses?: Maybe<ContactAddressDefConnection>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<UserType>;
  archivedByRule?: Maybe<ArchivalRuleDef>;
  authorityFeeDecision: Scalars['String']['output'];
  authorityFeeDecisionDate?: Maybe<Scalars['Date']['output']>;
  /** Per-customer invoice bundling override (canonical invoicing BundlingStrategy value), or null when inheriting the company default. */
  bundling?: Maybe<Scalars['String']['output']>;
  commsChannels?: Maybe<CommsChannelsDef>;
  company: CompanyType;
  compostingFormSubmissions: Array<CompostingFiledEventDef>;
  compostingRegistryEntries?: Maybe<CompostingRegistryEntryDefConnection>;
  contactFunctions?: Maybe<Array<CustomerFunctionDef>>;
  contactId: Scalars['String']['output'];
  contactNumber: Scalars['String']['output'];
  contactProperties?: Maybe<ContactPropertyDefConnection>;
  contactType: CrmContactContactTypeChoices;
  createdAt: Scalars['DateTime']['output'];
  customerNotes?: Maybe<CustomerNoteDefConnection>;
  /** Code of this contact's default billing cadence (invoicing.BillingFrequency.code), or null if unset. */
  defaultBillingFrequencyCode?: Maybe<Scalars['String']['output']>;
  defaultIndustry?: Maybe<IndustryCodeDef>;
  defaultIndustrySpecify: Scalars['String']['output'];
  defaultServiceResponsibility?: Maybe<ServiceResponsibilityDef>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  einvoiceAddress: Scalars['String']['output'];
  eventLog?: Maybe<PropertyEventLogEventWrapper>;
  externalContactId: Scalars['String']['output'];
  grantedAuthorizations?: Maybe<ContactAuthorizationDefConnection>;
  hasNonDisclosureRestriction: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  invoiceDeliveryMethod: CrmContactInvoiceDeliveryMethodChoices;
  invoiceLanguage: CrmContactInvoiceLanguageChoices;
  invoiceReference: Scalars['String']['output'];
  invoiceTemplateCode: Scalars['String']['output'];
  marketingOptOut?: Maybe<Scalars['Boolean']['output']>;
  marketingOptOutSetAt?: Maybe<Scalars['DateTime']['output']>;
  masterDataUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  ndrReason: Scalars['String']['output'];
  ndrSetAt?: Maybe<Scalars['DateTime']['output']>;
  ndrSetBy?: Maybe<UserType>;
  ndrSource: CrmContactNdrSourceChoices;
  nextCollection?: Maybe<NextCollectionType>;
  note: Scalars['String']['output'];
  notes: CustomerNoteDefConnection;
  notificationRules: ContactPropertyNotificationRuleDefConnection;
  openExceptionCount: Scalars['Int']['output'];
  overdueAmount: Scalars['Decimal']['output'];
  overdueInvoiceCount: Scalars['Int']['output'];
  payerAgreements: AgreementDefConnection;
  payerTickets: TicketDefConnection;
  /** The citizen (legal entity) the conversation belongs to. */
  portalConversations: PortalConversationDefConnection;
  pricingMode: CrmContactPricingModeChoices;
  privateData?: Maybe<ContactPrivateDataDef>;
  propertyAddressCount: Scalars['Int']['output'];
  propertyAddresses: Array<Scalars['String']['output']>;
  propertyCount: Scalars['Int']['output'];
  propertyManagementCompanies?: Maybe<Array<PropertyManagementCompanyDef>>;
  propertyUsers?: Maybe<Array<Maybe<PropertyUserDef>>>;
  receivedAuthorizations?: Maybe<ContactAuthorizationDefConnection>;
  recentExceptions?: Maybe<Array<Maybe<TicketDef>>>;
  recentInvoices?: Maybe<Array<Maybe<InvoiceDef>>>;
  relocations: RelocationDefConnection;
  requestedTickets: TicketDefConnection;
  reverseChargeVat: Scalars['Boolean']['output'];
  scheduledChanges: Array<ScheduledChangeDef>;
  scpMemberships: ScpMembershipDefConnection;
  searchUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  totalActiveAgreementAmount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vatEnabled: Scalars['Boolean']['output'];
};


export type ContactDefAddressesArgs = {
  addressType?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactDefCompostingRegistryEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  apartmentIdentifier?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasReportedStop?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  inspectionResult?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isInspected?: InputMaybe<Scalars['Boolean']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationDateFrom?: InputMaybe<Scalars['Date']['input']>;
  notificationDateTo?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  property?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageMonths?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validOn?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};


export type ContactDefContactPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchContacts?: InputMaybe<Scalars['String']['input']>;
  searchProperties?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type ContactDefCustomerNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['ID']['input']>;
  authorAuthority?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  dateRangeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  dateRangeStart?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noteType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  visibilityLevels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ContactDefEventLogArgs = {
  addPickupOrders?: InputMaybe<Scalars['Boolean']['input']>;
  addPropertyEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addTicketComments?: InputMaybe<Scalars['Boolean']['input']>;
  addTicketEvents?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  isTicketMessageInbound?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ticketEventTypes?: InputMaybe<Scalars['TicketEventTypeValuesList']['input']>;
  ticketMessageVia?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type ContactDefGrantedAuthorizationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorizationMethod?: InputMaybe<Scalars['ID']['input']>;
  authorizationType?: InputMaybe<Scalars['ID']['input']>;
  authorizedContact?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  principalContact?: InputMaybe<Scalars['ID']['input']>;
};


export type ContactDefNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactDefNotificationRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactDefPayerAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactDefPayerTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactDefPortalConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactDefPropertyAddressesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactDefReceivedAuthorizationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorizationMethod?: InputMaybe<Scalars['ID']['input']>;
  authorizationType?: InputMaybe<Scalars['ID']['input']>;
  authorizedContact?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  principalContact?: InputMaybe<Scalars['ID']['input']>;
};


export type ContactDefRecentExceptionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactDefRecentInvoicesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactDefRelocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactDefRequestedTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactDefScheduledChangesArgs = {
  includeFinished?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContactDefScpMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactDefConnection = {
  __typename: 'ContactDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContactDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContactDef` and its cursor. */
export type ContactDefEdge = {
  __typename: 'ContactDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContactDef>;
};

export type ContactEntryInput = {
  contactLabel?: InputMaybe<Scalars['String']['input']>;
  contactTypeId: Scalars['ID']['input'];
  contactValue: Scalars['String']['input'];
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactFieldConfigurationDef = {
  __typename: 'ContactFieldConfigurationDef';
  customLabel?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  fieldGroup?: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  isSystemMandatory: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
};

/**
 * One access-audit row: who viewed an NDR-restricted contact's
 * protected data, and when. Describes the VIEWER; ``contact_id`` answers
 * a DSAR ("whose protected data was viewed").
 */
export type ContactNdrAccessAuditDef = {
  __typename: 'ContactNdrAccessAuditDef';
  /** The person who viewed the data (name, never a raw id). */
  actorName?: Maybe<Scalars['String']['output']>;
  /** Relay id of the contact whose protected data was viewed. */
  contactId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

export type ContactPersonInputObject = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPersonType = Node & {
  __typename: 'ContactPersonType';
  /** Contact in this Depot */
  depots: DepotTypeConnection;
  /** Company email */
  email: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** First name / last name of contact */
  name: Scalars['String']['output'];
  /** Collector's, phone number */
  phone?: Maybe<Scalars['String']['output']>;
};


export type ContactPersonTypeDepotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactPrivateDataDef = Node & {
  __typename: 'ContactPrivateDataDef';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  coName?: Maybe<Scalars['String']['output']>;
  contact: ContactDef;
  country?: Maybe<Scalars['String']['output']>;
  emails: Array<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  issuingCountry?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumbers: Array<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  postalCodeName?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type ContactPropertyDef = Node & {
  __typename: 'ContactPropertyDef';
  contact: ContactDef;
  debtorNumber: Scalars['String']['output'];
  emails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  endedBySync?: Maybe<MasterDataSyncDef>;
  externalPropertyContactId: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  matrikkelRegistrationDate?: Maybe<Scalars['Date']['output']>;
  matrikkelRole: Scalars['String']['output'];
  municipalityCode?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  postalCodeName?: Maybe<Scalars['String']['output']>;
  property: PropertyDef;
  role: CrmContactPropertyRoleChoices;
  startDate: Scalars['DateTime']['output'];
  startedBySync?: Maybe<MasterDataSyncDef>;
  totalActiveAgreementAmount: Scalars['Int']['output'];
};

export type ContactPropertyDefConnection = {
  __typename: 'ContactPropertyDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContactPropertyDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContactPropertyDef` and its cursor. */
export type ContactPropertyDefEdge = {
  __typename: 'ContactPropertyDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContactPropertyDef>;
};

/**
 * PRO-755: a subject's per-property auto-subscribe rule. ``primaryPhone`` /
 * ``primaryEmail`` echo the value the toggles track; ``smsMissingDetail`` /
 * ``emailMissingDetail`` drive the advisory "add a phone/email" warning.
 */
export type ContactPropertyNotificationRuleDef = Node & {
  __typename: 'ContactPropertyNotificationRuleDef';
  company: CompanyType;
  contact?: Maybe<ContactDef>;
  containerNotifications: ContainerNotificationDefConnection;
  createdAt: Scalars['DateTime']['output'];
  emailAuto: Scalars['Boolean']['output'];
  emailDaysBefore: Scalars['Int']['output'];
  emailMissingDetail?: Maybe<Scalars['Boolean']['output']>;
  emailNotificationMethod?: Maybe<NotificationMethodDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  managementCompany?: Maybe<PropertyManagementCompanyDef>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  property: PropertyDef;
  smsAuto: Scalars['Boolean']['output'];
  smsDaysBefore: Scalars['Int']['output'];
  smsMissingDetail?: Maybe<Scalars['Boolean']['output']>;
  smsNotificationMethod?: Maybe<NotificationMethodDef>;
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * PRO-755: a subject's per-property auto-subscribe rule. ``primaryPhone`` /
 * ``primaryEmail`` echo the value the toggles track; ``smsMissingDetail`` /
 * ``emailMissingDetail`` drive the advisory "add a phone/email" warning.
 */
export type ContactPropertyNotificationRuleDefContainerNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactPropertyNotificationRuleDefConnection = {
  __typename: 'ContactPropertyNotificationRuleDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContactPropertyNotificationRuleDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContactPropertyNotificationRuleDef` and its cursor. */
export type ContactPropertyNotificationRuleDefEdge = {
  __typename: 'ContactPropertyNotificationRuleDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContactPropertyNotificationRuleDef>;
};

/** An enumeration. */
export enum ContactRole {
  ADMINISTRATOR = 'ADMINISTRATOR',
  CARETAKER = 'CARETAKER',
  CONTACT = 'CONTACT',
  CO_OWNER = 'CO_OWNER',
  OWNER = 'OWNER',
  PAYER = 'PAYER',
  PROPERTY_MANAGER = 'PROPERTY_MANAGER',
  TENANT = 'TENANT'
}

/** An enumeration. */
export enum ContactType {
  COMPANY = 'COMPANY',
  INDIVIDUAL = 'INDIVIDUAL'
}

export type ContactTypeType = Node & {
  __typename: 'ContactTypeType';
  category: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  userEntries: UserContactEntryTypeConnection;
};


export type ContactTypeTypeUserEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerActionDef = Node & {
  __typename: 'ContainerActionDef';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  requireContainerIdBarcodeScanning: Scalars['Boolean']['output'];
  requireContainerLabelPrinted: Scalars['Boolean']['output'];
  requireContainerLocation: Scalars['Boolean']['output'];
  requireRfidPairing: Scalars['Boolean']['output'];
  /** How "Require RFID pairing" pairs: "rfid_only", or "label_then_rfid" (scan the bin's label first; no skipping). */
  rfidPairingMode: Scalars['String']['output'];
  rule: AutopilotLegacyRuleType;
};

export type ContainerActionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  requireContainerIdBarcodeScanning?: InputMaybe<Scalars['Boolean']['input']>;
  requireContainerLabelPrinted?: InputMaybe<Scalars['Boolean']['input']>;
  requireContainerLocation?: InputMaybe<Scalars['Boolean']['input']>;
  requireRfidPairing?: InputMaybe<Scalars['Boolean']['input']>;
  rfidPairingMode?: InputMaybe<Scalars['String']['input']>;
};

export type ContainerAnalyticsType = {
  __typename: 'ContainerAnalyticsType';
  objects?: Maybe<ContainerTypeConnection>;
  objects_Count?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};


export type ContainerAnalyticsTypeObjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A file hung off a container (REQ-919).
 *
 * Same shape as ``PropertyNoteAttachmentDef`` / ``TicketAttachmentDef``
 * minus their back-links, so both the office front end and the driver app
 * render container attachments with the components they already have.
 * ``only_fields`` keeps the contract to exactly that — no ``deleted`` flag
 * and no back-reference to the container.
 */
export type ContainerAttachmentDef = Node & {
  __typename: 'ContainerAttachmentDef';
  createdAt: Scalars['DateTime']['output'];
  file: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  originalFileName?: Maybe<Scalars['String']['output']>;
};

/** Barcode generation history */
export type ContainerBarcodeGenerationHistoryDef = Node & {
  __typename: 'ContainerBarcodeGenerationHistoryDef';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  progress: Scalars['Int']['output'];
  status: DeviceContainerBarcodeGenerationHistoryStatusChoices;
  total: Scalars['Int']['output'];
};

export type ContainerBarcodeGenerationHistoryDefConnection = {
  __typename: 'ContainerBarcodeGenerationHistoryDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContainerBarcodeGenerationHistoryDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContainerBarcodeGenerationHistoryDef` and its cursor. */
export type ContainerBarcodeGenerationHistoryDefEdge = {
  __typename: 'ContainerBarcodeGenerationHistoryDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContainerBarcodeGenerationHistoryDef>;
};

export type ContainerClusterDef = {
  __typename: 'ContainerClusterDef';
  areas?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  collectionCalendars?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  duplicatedPoints?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  pointsOnTheSameLocation: Scalars['Boolean']['output'];
  routeSchemes?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  totalCount: Scalars['Int']['output'];
};

export type ContainerCollectionItemSnapshotDef = Node & {
  __typename: 'ContainerCollectionItemSnapshotDef';
  batch: SnapshotBatchDef;
  /** How many times per week this container is collected. NULL or 1 means a single AddServiceV2 with Sequence=pickup_repeat_period*7. Values >1 trigger N AddServiceV2 calls in the outbound service. */
  collectionPerWeek?: Maybe<Scalars['Int']['output']>;
  companyId: Scalars['Int']['output'];
  containerId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** What happened during sync for this specific item */
  externalSyncMessage: Scalars['String']['output'];
  /** Status of this specific item sync */
  externalSyncStatus: EvolutionContainerCollectionItemSnapshotExternalSyncStatusChoices;
  externalSyncStatusDisplay?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  pickupRepeatPeriod: Scalars['Int']['output'];
  pickupSettingId: Scalars['Int']['output'];
  productNumber: Scalars['String']['output'];
  /** Botek RouteID for the container at snapshot time, sourced from EvolutionContainerLink. Sent verbatim as the SOAP `RouteID` parameter. */
  routeId: Scalars['String']['output'];
  startServiceDate?: Maybe<Scalars['Date']['output']>;
  stopServiceDate?: Maybe<Scalars['Date']['output']>;
};

export type ContainerCollectionItemSnapshotDefConnection = {
  __typename: 'ContainerCollectionItemSnapshotDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContainerCollectionItemSnapshotDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContainerCollectionItemSnapshotDef` and its cursor. */
export type ContainerCollectionItemSnapshotDefEdge = {
  __typename: 'ContainerCollectionItemSnapshotDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContainerCollectionItemSnapshotDef>;
};

/**
 * GraphQL type for a container's condition-change log row (PRO-391).
 *
 * Read scope is inherited from the container, mirroring
 * ``ContainerMaintenanceType``.
 */
export type ContainerConditionHistoryType = Node & {
  __typename: 'ContainerConditionHistoryType';
  changedBy?: Maybe<UserType>;
  container: ContainerType;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  newConditionType: ConditionTypeType;
  note: Scalars['String']['output'];
  previousConditionType?: Maybe<ConditionTypeType>;
};

export type ContainerConditionHistoryTypeConnection = {
  __typename: 'ContainerConditionHistoryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContainerConditionHistoryTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContainerConditionHistoryType` and its cursor. */
export type ContainerConditionHistoryTypeEdge = {
  __typename: 'ContainerConditionHistoryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContainerConditionHistoryType>;
};

export type ContainerEmailNotificationMethodDef = {
  __typename: 'ContainerEmailNotificationMethodDef';
  daysBefore?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  notificationType?: Maybe<Scalars['String']['output']>;
};

export type ContainerEventDef = Node & {
  __typename: 'ContainerEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  container?: Maybe<ContainerType>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<DeviceContainerEventTypesGraphene>>>;
  fromCollectionCalendar?: Maybe<CollectionCalendarDef>;
  fromContainerId?: Maybe<Scalars['String']['output']>;
  fromContainerType?: Maybe<ContainerTypeType>;
  fromDescription?: Maybe<Scalars['String']['output']>;
  fromLocation?: Maybe<LocationType>;
  fromMetaData?: Maybe<Scalars['JSONString']['output']>;
  fromPickupMethod?: Maybe<Scalars['String']['output']>;
  fromPickupSetting?: Maybe<PickupSettingsType>;
  fromProject?: Maybe<ProjectType>;
  fromRfid?: Maybe<Scalars['String']['output']>;
  fromRouteDescription?: Maybe<Scalars['String']['output']>;
  fromRouteScheme?: Maybe<RouteSchemeType>;
  fromSensorFillLevel?: Maybe<Scalars['Int']['output']>;
  fromStatus?: Maybe<Scalars['String']['output']>;
  fromVehicle?: Maybe<VehicleType>;
  fromWasteFraction?: Maybe<WasteFractionType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toCollectionCalendar?: Maybe<CollectionCalendarDef>;
  toContainerId?: Maybe<Scalars['String']['output']>;
  toContainerType?: Maybe<ContainerTypeType>;
  toDescription?: Maybe<Scalars['String']['output']>;
  toLocation?: Maybe<LocationType>;
  toMetaData?: Maybe<Scalars['JSONString']['output']>;
  toPickupMethod?: Maybe<Scalars['String']['output']>;
  toPickupSetting?: Maybe<PickupSettingsType>;
  toProject?: Maybe<ProjectType>;
  toRfid?: Maybe<Scalars['String']['output']>;
  toRouteDescription?: Maybe<Scalars['String']['output']>;
  toRouteScheme?: Maybe<RouteSchemeType>;
  toSensorFillLevel?: Maybe<Scalars['Int']['output']>;
  toStatus?: Maybe<Scalars['String']['output']>;
  toVehicle?: Maybe<VehicleType>;
  toWasteFraction?: Maybe<WasteFractionType>;
  user?: Maybe<UserType>;
};

export type ContainerEventLogEvent = ContainerEventDef | CustomContainerEventDef | DeletionEventDef | PickUpOrderEventDef;

export type ContainerEventLogEventWrapper = {
  __typename: 'ContainerEventLogEventWrapper';
  edges?: Maybe<Array<Maybe<ContainerEventLogEvent>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ContainerGroupDef = Node & {
  __typename: 'ContainerGroupDef';
  containerTypes?: Maybe<Array<Maybe<ContainerTypeType>>>;
  containers: ContainerTypeConnection;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  eventLog?: Maybe<ContainerGroupEventLogEventWrapper>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  location: LocationWithContainerType;
  locationCurb: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pickupSettings?: Maybe<Array<Maybe<PickupSettingsType>>>;
  project: ProjectType;
  totalContainers?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  wasteFractions?: Maybe<Array<Maybe<WasteFractionType>>>;
};


export type ContainerGroupDefContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerGroupDefEventLogArgs = {
  addContainerEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addContainerGroupEvents?: InputMaybe<Scalars['Boolean']['input']>;
  containerEventTypes?: InputMaybe<Array<InputMaybe<DeviceContainerEventTypesGraphene>>>;
  containerGroupEventTypes?: InputMaybe<Array<InputMaybe<ContainerGroupEventTypesGraphene>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ContainerGroupDefConnection = {
  __typename: 'ContainerGroupDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContainerGroupDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContainerGroupDef` and its cursor. */
export type ContainerGroupDefEdge = {
  __typename: 'ContainerGroupDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContainerGroupDef>;
};

export type ContainerGroupEventDef = Node & {
  __typename: 'ContainerGroupEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  containerGroup?: Maybe<ContainerGroupDef>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<ContainerGroupEventTypesGraphene>>>;
  fromLocation?: Maybe<LocationType>;
  fromLocationCurb?: Maybe<Scalars['Boolean']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toLocation?: Maybe<LocationType>;
  toLocationCurb?: Maybe<Scalars['Boolean']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
};

export type ContainerGroupEventLogEvent = ContainerEventDef | ContainerGroupEventDef;

export type ContainerGroupEventLogEventWrapper = {
  __typename: 'ContainerGroupEventLogEventWrapper';
  edges?: Maybe<Array<Maybe<ContainerGroupEventLogEvent>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ContainerGroupEventTypesGraphene {
  LOCATION_CHANGE = 'LOCATION_CHANGE',
  LOCATION_CURB_CHANGE = 'LOCATION_CURB_CHANGE',
  NAME_CHANGE = 'NAME_CHANGE'
}

export type ContainerIdGeneratorSettingsDef = Node & {
  __typename: 'ContainerIDGeneratorSettingsDef';
  company: CompanyType;
  companyDisplayOption: DeviceContainerIdGeneratorSettingsCompanyDisplayOptionChoices;
  componentsOrder: Array<Scalars['String']['output']>;
  containerTypeDisplayOption: DeviceContainerIdGeneratorSettingsContainerTypeDisplayOptionChoices;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  incrementFrom: Scalars['Int']['output'];
  lastNumber: Scalars['Int']['output'];
  pickupSettingsDisplayOption: DeviceContainerIdGeneratorSettingsPickupSettingsDisplayOptionChoices;
  prefix: Scalars['String']['output'];
  preview?: Maybe<Scalars['String']['output']>;
  separator: Scalars['String']['output'];
  wasteFractionDisplayOption: DeviceContainerIdGeneratorSettingsWasteFractionDisplayOptionChoices;
};

/** Optional explicit identity + warranty for an imported container. */
export type ContainerImportIdentityInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  /**
   * The structured condition for this imported unit (PRO-391) — omitted
   * defaults to the company's seeded "New".
   */
  conditionTypeId?: InputMaybe<Scalars['ID']['input']>;
  containerId?: InputMaybe<Scalars['String']['input']>;
  rfid?: InputMaybe<Scalars['String']['input']>;
  warrantyEnd?: InputMaybe<Scalars['Date']['input']>;
  warrantyStart?: InputMaybe<Scalars['Date']['input']>;
};

/**
 * One import line: an item type, a count, and optional explicit
 * identities for (some of) those units.
 */
export type ContainerImportRowInput = {
  containerTypeId: Scalars['ID']['input'];
  identities?: InputMaybe<Array<InputMaybe<ContainerImportIdentityInput>>>;
  quantity: Scalars['Int']['input'];
};

export type ContainerImportType = Node & {
  __typename: 'ContainerImportType';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delimiter: Scalars['String']['output'];
  error: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importFile: Scalars['String']['output'];
  project: ProjectType;
  shouldCreate: Scalars['Boolean']['output'];
  shouldUpdate: Scalars['Boolean']['output'];
  shouldUpdateGeocodeLocation: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type ContainerImportTypeConnection = {
  __typename: 'ContainerImportTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContainerImportTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ContainerImportType` and its cursor. */
export type ContainerImportTypeEdge = {
  __typename: 'ContainerImportTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContainerImportType>;
};

export type ContainerItemSnapshotDef = Node & {
  __typename: 'ContainerItemSnapshotDef';
  address: Scalars['String']['output'];
  batch: SnapshotBatchDef;
  companyId: Scalars['Int']['output'];
  containerId: Scalars['Int']['output'];
  containerTypeName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** What happened during sync for this specific item */
  externalSyncMessage: Scalars['String']['output'];
  /** Status of this specific item sync */
  externalSyncStatus: EvolutionContainerItemSnapshotExternalSyncStatusChoices;
  externalSyncStatusDisplay?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  point?: Maybe<Scalars['GeoJSON']['output']>;
  /** Human-readable container_id string from device.Container — sent verbatim as the SOAP ProductNumber. Different from ``container_id``, which is the Django PK and is for joins only. */
  productNumber: Scalars['String']['output'];
  propertyId: Scalars['Int']['output'];
  rfid: Scalars['String']['output'];
};

export type ContainerItemSnapshotDefConnection = {
  __typename: 'ContainerItemSnapshotDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContainerItemSnapshotDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContainerItemSnapshotDef` and its cursor. */
export type ContainerItemSnapshotDefEdge = {
  __typename: 'ContainerItemSnapshotDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContainerItemSnapshotDef>;
};

export type ContainerLogAnalyticsType = {
  __typename: 'ContainerLogAnalyticsType';
  objects?: Maybe<ContainerLogTypeConnection>;
  objects_Count?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};


export type ContainerLogAnalyticsTypeObjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerLogDaysType = {
  __typename: 'ContainerLogDaysType';
  day?: Maybe<Scalars['DateTime']['output']>;
  totalCount?: Maybe<Scalars['Float']['output']>;
};

export type ContainerLogType = Node & {
  __typename: 'ContainerLogType';
  container: ContainerType;
  createdAt: Scalars['DateTime']['output'];
  durationToPreviousLog?: Maybe<Scalars['Float']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isOverflowed: Scalars['Boolean']['output'];
  newFillLevel: Scalars['Float']['output'];
  newFillPercentage: Scalars['Float']['output'];
  oldFillLevel: Scalars['Float']['output'];
  oldFillPercentage: Scalars['Float']['output'];
};

export type ContainerLogTypeConnection = {
  __typename: 'ContainerLogTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContainerLogTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContainerLogType` and its cursor. */
export type ContainerLogTypeEdge = {
  __typename: 'ContainerLogTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContainerLogType>;
};

/**
 * GraphQL type for a per-container maintenance event (PRO-213).
 *
 * Read scope is inherited from the container, mirroring
 * ``ContainerLogType``: only the owning company (or a superuser/reseller)
 * may resolve a node by id.
 */
export type ContainerMaintenanceType = Node & {
  __typename: 'ContainerMaintenanceType';
  container: ContainerType;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** e.g. inspection, repair, cleaning */
  maintenanceType: Scalars['String']['output'];
  /** Next-maintenance date this event scheduled, if any. */
  nextDue?: Maybe<Scalars['Date']['output']>;
  notes: Scalars['String']['output'];
  /** Date the maintenance was performed. */
  performedAt: Scalars['Date']['output'];
  /** Who performed it (free text — often an external technician). */
  performedBy: Scalars['String']['output'];
};

export type ContainerMaintenanceTypeConnection = {
  __typename: 'ContainerMaintenanceTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContainerMaintenanceTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContainerMaintenanceType` and its cursor. */
export type ContainerMaintenanceTypeEdge = {
  __typename: 'ContainerMaintenanceTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContainerMaintenanceType>;
};

export type ContainerMapPointDef = {
  __typename: 'ContainerMapPointDef';
  areaId?: Maybe<Scalars['ID']['output']>;
  areaName?: Maybe<Scalars['String']['output']>;
  collectionCalendarId?: Maybe<Scalars['ID']['output']>;
  collectionCalendarName?: Maybe<Scalars['String']['output']>;
  fillLevel?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  routeSchemeId?: Maybe<Scalars['ID']['output']>;
  routeSchemeName?: Maybe<Scalars['String']['output']>;
};

export type ContainerMetaValueInputObject = {
  companyContainerMetaTypeId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type ContainerNotificationDef = Node & {
  __typename: 'ContainerNotificationDef';
  autoMedium?: Maybe<CrmContainerNotificationAutoMediumChoices>;
  autoRule?: Maybe<ContactPropertyNotificationRuleDef>;
  company: CompanyType;
  container: ContainerType;
  createdAt: Scalars['DateTime']['output'];
  daysBefore: Scalars['Int']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isAuto?: Maybe<Scalars['Boolean']['output']>;
  lastSent?: Maybe<Scalars['DateTime']['output']>;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  notificationMethod: NotificationMethodDef;
  property: PropertyDef;
};

export type ContainerNotificationDefConnection = {
  __typename: 'ContainerNotificationDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContainerNotificationDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContainerNotificationDef` and its cursor. */
export type ContainerNotificationDefEdge = {
  __typename: 'ContainerNotificationDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContainerNotificationDef>;
};

export type ContainerNotificationMethodUnion = ContainerEmailNotificationMethodDef | ContainerSmsNotificationMethodDef;

export type ContainerNotificationsInput = {
  /** Number of days before the container notification fires */
  daysBefore?: InputMaybe<Scalars['Int']['input']>;
  /** Email to add a notification for, e.g. 'some@email.com' */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Method of notification, e.g. 'sms' or 'email'. */
  notificationType: Scalars['String']['input'];
  /** Phone number to add a notification for, e.g. '1234567890' */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ContainerPriceDef = Node & {
  __typename: 'ContainerPriceDef';
  amount: Scalars['Int']['output'];
  company: CompanyType;
  containerType: ContainerTypeType;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['Date']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  invoiceName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pickupSetting: PickupSettingsType;
  propertyType: PropertyTypeDef;
  recurringInterval: Scalars['Int']['output'];
  startDate: Scalars['Date']['output'];
  wasteFraction: WasteFractionType;
};

export type ContainerPriceDefConnection = {
  __typename: 'ContainerPriceDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContainerPriceDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContainerPriceDef` and its cursor. */
export type ContainerPriceDefEdge = {
  __typename: 'ContainerPriceDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContainerPriceDef>;
};

export type ContainerPriceOptionDef = {
  __typename: 'ContainerPriceOptionDef';
  amount: Scalars['Int']['output'];
  containerType: ContainerTypeType;
  id: Scalars['ID']['output'];
  pickupSetting: PickupSettingsType;
  product: ProductDef;
  recurringInterval: Scalars['Int']['output'];
  wasteFraction: WasteFractionType;
};

export type ContainerSmsNotificationMethodDef = {
  __typename: 'ContainerSMSNotificationMethodDef';
  daysBefore?: Maybe<Scalars['Int']['output']>;
  notificationType?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ContainerStorageLocationDef = Node & {
  __typename: 'ContainerStorageLocationDef';
  depot?: Maybe<DepotType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

export type ContainerStorageLocationInput = {
  depot?: InputMaybe<Scalars['ID']['input']>;
};

export type ContainerType = Node & {
  __typename: 'ContainerType';
  activeAgreement?: Maybe<AgreementDef>;
  activeProperty?: Maybe<PropertyDef>;
  /** Active temporary location override for this container, if any */
  activeTemporaryLocationOverride?: Maybe<TemporaryContainerLocationType>;
  agreements: AgreementDefConnection;
  alertSet: AlertDefConnection;
  alertruleSet: AlertRuleDefConnection;
  /** Union of availableDates and the days the container's extra routes collect it inside the window: an extra-route membership's own collection calendar when it has one, else the generated run days of that route. Always a superset of availableDates: empty for a container that is not available, exactly like availableDates itself. */
  allCollectionDates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  allowedHoursEnd?: Maybe<Scalars['Time']['output']>;
  allowedHoursStart?: Maybe<Scalars['Time']['output']>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<UserType>;
  archivedByRule?: Maybe<ArchivalRuleDef>;
  attachments?: Maybe<Array<Maybe<ContainerAttachmentDef>>>;
  availableDates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  availableMeasurementFilters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  availableVehiclesCount?: Maybe<Scalars['Int']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  collectionCalendar?: Maybe<CollectionCalendarDef>;
  collectionDateSuggestion?: Maybe<CollectionDateSuggestionType>;
  /** Limit the deviation to these containers. */
  collectionDeviations: CollectionCalendarDeviationDefConnection;
  /** Relation to the Comment */
  comments: CommentTypeConnection;
  /** Physical condition for stock purposes. Returned containers are flagged used; identity is never changed by condition. */
  condition: DeviceContainerConditionChoices;
  /** Condition-change log, newest-first (Relay connection). */
  conditionHistory: ContainerConditionHistoryTypeConnection;
  /**
   * The unit's current structured condition (PRO-391) — distinct from the
   * legacy `condition` new/used receive-time tag.
   */
  conditionType?: Maybe<ConditionTypeType>;
  containerGroup?: Maybe<ContainerGroupDef>;
  containerId: Scalars['String']['output'];
  containerLog?: Maybe<ContainerLogType>;
  containerType: ContainerTypeType;
  containercustomeventSet: CustomContainerEventDefConnection;
  containernotificationSet: ContainerNotificationDefConnection;
  createdAt: Scalars['DateTime']['output'];
  currentEffective?: Maybe<Scalars['Float']['output']>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  deviceToContainerSet: DeviceToContainerTypeConnection;
  efficient?: Maybe<Scalars['Float']['output']>;
  estimatedSavings?: Maybe<Scalars['Float']['output']>;
  eventLog?: Maybe<ContainerEventLogEventWrapper>;
  /** WasteHero container this link refers to. Cascades on delete so decommissioned containers don't leave dangling link rows. */
  evolutionLinks: EvolutionContainerLinkDefConnection;
  /** Containers that keep collecting during the period. */
  excludedFromCollectionDeviations: CollectionCalendarDeviationDefConnection;
  externalCollectionEvents: ExternalCollectionEventDefConnection;
  /** Route/area code of this container in the customer's master system (e.g. the PA tømmerute code '104' for HRA) — surfaced on generated routes as the drivers' day check for which sub-route of a combined scheme fires. */
  externalRouteCode?: Maybe<Scalars['String']['output']>;
  /** Further calendars the container is emptied on, beside ``collection_calendar``. A bin can stand on several of the customer's routes; the primary one drives planning, these are what an integration reads to see every route the bin is on. */
  extraCollectionCalendars: CollectionCalendarDefConnection;
  fillingFrequency?: Maybe<Scalars['Float']['output']>;
  fractionServiceBindings: FractionServiceBindingDefConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  inquiries: CollectionInquiryTypeConnection;
  latestPickUp?: Maybe<Scalars['DateTime']['output']>;
  location: LocationWithContainerType;
  locationCurb: Scalars['Boolean']['output'];
  logs: ContainerLogTypeConnection;
  /** Per-container maintenance events, newest-first (Relay connection). */
  maintenanceEvents?: Maybe<ContainerMaintenanceTypeConnection>;
  manufactured?: Maybe<Scalars['Date']['output']>;
  measurement?: Maybe<FillLevelMeasurementType>;
  metaData?: Maybe<Scalars['JSONString']['output']>;
  /** Id of this container in the system it was migrated from (e.g. the ISY ProAktiv produktId). */
  migratedFromId?: Maybe<Scalars['String']['output']>;
  /** Derived current next-maintenance date — the latest event's next_due. */
  nextMaintenanceDue?: Maybe<Scalars['Date']['output']>;
  nextPickUp?: Maybe<Scalars['Date']['output']>;
  notificationsettingsSet: NotificationSettingsTypeConnection;
  overflowingSettings?: Maybe<OverflowingSettingsType>;
  ownership?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  pickUpOrders?: Maybe<PickUpOrderTypeConnection>;
  pickupDays: PickupDayTypeConnection;
  pickupDaysFirstCollection?: Maybe<Scalars['Date']['output']>;
  pickupMethod: DeviceContainerPickupMethodChoices;
  pickupSetting?: Maybe<PickupSettingsType>;
  pickupSettings: PickupSettingsTypeConnection;
  prioritizeInStartOfRoute: Scalars['Boolean']['output'];
  project: ProjectType;
  rentalRelocations: Array<RentalRelocationDef>;
  rfid: Scalars['String']['output'];
  routeDescription: Scalars['String']['output'];
  /** Every route scheme this container is collected on: the primary routeScheme followed by live extra-route memberships. */
  routeMemberships?: Maybe<Array<Maybe<RouteSchemeType>>>;
  routeScheme?: Maybe<RouteSchemeType>;
  routeStudioStops: StopDefConnection;
  scheduledPickup?: Maybe<Scalars['DateTime']['output']>;
  scpAttachments: ScpContainerAttachmentDefConnection;
  scpCollectionLocations: CollectionLocationDefConnection;
  searchUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  sensorFillLevel?: Maybe<Scalars['Int']['output']>;
  sensorFillLevelPeriodHours?: Maybe<Scalars['Int']['output']>;
  serialNumber: Scalars['String']['output'];
  showOnRoute: Scalars['Boolean']['output'];
  status: DeviceContainerStatusChoices;
  storedAtDepot?: Maybe<DepotType>;
  /** Full history of scheduled temporary location changes for this container - scheduled, active and reverted - newest first. Feeds the Temporary changes tab. */
  temporaryLocationChanges?: Maybe<Array<Maybe<TemporaryContainerLocationType>>>;
  /** The container this scheduled change applies to */
  temporarycontainerlocationSet: TemporaryContainerLocationTypeConnection;
  ticketdraftSet: TicketDraftDefConnection;
  tickets: TicketDefConnection;
  totalCollections?: Maybe<Scalars['Int']['output']>;
  totalCost?: Maybe<Scalars['Float']['output']>;
  totalOverflowings?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vehicle?: Maybe<VehicleType>;
  warrantyEnd?: Maybe<Scalars['Date']['output']>;
  warrantyStart?: Maybe<Scalars['Date']['output']>;
  /** The enumerated bin references the plan covers. */
  washLists: WashListDefConnection;
  wasteCollector?: Maybe<WasteCollectorType>;
  wasteFraction?: Maybe<WasteFractionType>;
  wasteFractions?: Maybe<Array<Maybe<WasteFractionType>>>;
};


export type ContainerTypeAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeAlertSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeAlertruleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeAllCollectionDatesArgs = {
  periodEnd?: InputMaybe<Scalars['Date']['input']>;
  periodStart?: InputMaybe<Scalars['Date']['input']>;
};


export type ContainerTypeAvailableDatesArgs = {
  periodEnd?: InputMaybe<Scalars['Date']['input']>;
  periodStart?: InputMaybe<Scalars['Date']['input']>;
};


export type ContainerTypeCollectionDateSuggestionArgs = {
  periodEnd?: InputMaybe<Scalars['Date']['input']>;
  periodStart?: InputMaybe<Scalars['Date']['input']>;
};


export type ContainerTypeCollectionDeviationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeConditionHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeContainercustomeventSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeContainernotificationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeCurrentEffectiveArgs = {
  From?: InputMaybe<Scalars['DateTime']['input']>;
  To?: InputMaybe<Scalars['DateTime']['input']>;
};


export type ContainerTypeDeviceToContainerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeEventLogArgs = {
  addDeletionEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addPickupOrdersEvents?: InputMaybe<Scalars['Boolean']['input']>;
  containerCustomEventTypes?: InputMaybe<Array<InputMaybe<DeviceContainerCustomEventTypesGraphene>>>;
  containerEventTypes?: InputMaybe<Array<InputMaybe<DeviceContainerEventTypesGraphene>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pickupOrderEventTypes?: InputMaybe<Array<InputMaybe<PickUpOrderEventTypesGraphene>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type ContainerTypeEvolutionLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeExcludedFromCollectionDeviationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeExternalCollectionEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeExtraCollectionCalendarsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeFractionServiceBindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeInquiriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeMaintenanceEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeNotificationsettingsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypePickUpOrdersArgs = {
  acknowledgementType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  approvalCollection?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionCalendarIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  completeApproval?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  container?: InputMaybe<Scalars['ID']['input']>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerPickupSettings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  container_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  container_PickupMethod?: InputMaybe<Scalars['String']['input']>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdInquiry?: InputMaybe<Scalars['ID']['input']>;
  createdInquiry_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdInquiry_Status?: InputMaybe<Scalars['String']['input']>;
  createdTicketsTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  depotIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeOrderTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalPropertyNumber?: InputMaybe<Scalars['String']['input']>;
  fillLevel_Gte?: InputMaybe<Scalars['Float']['input']>;
  fillLevel_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  fillLevel_Lte?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isUnloading?: InputMaybe<Scalars['Boolean']['input']>;
  isUnloadingPending?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lifecycleIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  noApproval?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderType_Icontains?: InputMaybe<Scalars['String']['input']>;
  pendingApproval?: InputMaybe<Scalars['Boolean']['input']>;
  propertyGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  route?: InputMaybe<Scalars['ID']['input']>;
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routeScheduledDayGte?: InputMaybe<Scalars['Date']['input']>;
  routeScheduledDayLte?: InputMaybe<Scalars['Date']['input']>;
  route_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stopStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketAssigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketAssigneeTeams?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketCreatedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketOrContainerIsnull?: InputMaybe<Scalars['Boolean']['input']>;
  ticketPriority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketReportedByPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  ticketReporterByDriver?: InputMaybe<Scalars['Boolean']['input']>;
  ticketRequestedByPortal?: InputMaybe<Scalars['Boolean']['input']>;
  ticketStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticket_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type ContainerTypePickupDaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypePickupSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeRouteStudioStopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeScpAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeScpCollectionLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeTemporarycontainerlocationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeTicketdraftSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeWashListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * PRO-519: one generic before/after diff row for a ContainerType field
 * that has no dedicated ``from_*``/``to_*`` column (kind, mobility, container
 * access, colour, lid type, loading method, warranty months, lifecycle
 * status, related waste types). ``field`` is the snake_case model field name;
 * ``from_value``/``to_value`` are its stringified values.
 */
export type ContainerTypeChangedFieldDef = {
  __typename: 'ContainerTypeChangedFieldDef';
  field: Scalars['String']['output'];
  fromValue?: Maybe<Scalars['String']['output']>;
  toValue?: Maybe<Scalars['String']['output']>;
};

export type ContainerTypeConnection = {
  __typename: 'ContainerTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContainerTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContainerType` and its cursor. */
export type ContainerTypeEdge = {
  __typename: 'ContainerTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContainerType>;
};

export type ContainerTypeEventDef = Node & {
  __typename: 'ContainerTypeEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  changedFields: Array<ContainerTypeChangedFieldDef>;
  containerType?: Maybe<ContainerTypeType>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<ContainerTypeEventTypesGraphene>>>;
  fromContainerAccess?: Maybe<Scalars['String']['output']>;
  fromDiameter?: Maybe<Scalars['Float']['output']>;
  fromEmplacement?: Maybe<Scalars['String']['output']>;
  fromEmptyingTime?: Maybe<Scalars['Int']['output']>;
  fromHeight?: Maybe<Scalars['Float']['output']>;
  fromIsCylindrical?: Maybe<Scalars['Boolean']['output']>;
  fromLength?: Maybe<Scalars['Float']['output']>;
  fromMobility?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  fromOverflowingSettings?: Maybe<OverflowingSettingsType>;
  fromPickupSetting?: Maybe<PickupSettingsType>;
  fromVehicleCoupling?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fromVolume?: Maybe<Scalars['Float']['output']>;
  fromWidth?: Maybe<Scalars['Float']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toContainerAccess?: Maybe<Scalars['String']['output']>;
  toDiameter?: Maybe<Scalars['Float']['output']>;
  toEmplacement?: Maybe<Scalars['String']['output']>;
  toEmptyingTime?: Maybe<Scalars['Int']['output']>;
  toHeight?: Maybe<Scalars['Float']['output']>;
  toIsCylindrical?: Maybe<Scalars['Boolean']['output']>;
  toLength?: Maybe<Scalars['Float']['output']>;
  toMobility?: Maybe<Scalars['String']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
  toOverflowingSettings?: Maybe<OverflowingSettingsType>;
  toPickupSetting?: Maybe<PickupSettingsType>;
  toVehicleCoupling?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  toVolume?: Maybe<Scalars['Float']['output']>;
  toWidth?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<UserType>;
};

export enum ContainerTypeEventTypesGraphene {
  CONTAINER_TYPE_UPDATED = 'CONTAINER_TYPE_UPDATED',
  DIAMETER_CHANGE = 'DIAMETER_CHANGE',
  EMPLACEMENT_CHANGE = 'EMPLACEMENT_CHANGE',
  EMPTYING_TIME_CHANGE = 'EMPTYING_TIME_CHANGE',
  HEIGHT_CHANGE = 'HEIGHT_CHANGE',
  IS_CYLINDRICAL_CHANGE = 'IS_CYLINDRICAL_CHANGE',
  LENGTH_CHANGE = 'LENGTH_CHANGE',
  NAME_CHANGE = 'NAME_CHANGE',
  VEHICLE_COUPLING_CHANGE = 'VEHICLE_COUPLING_CHANGE',
  VOLUME_CHANGE = 'VOLUME_CHANGE',
  WIDTH_CHANGE = 'WIDTH_CHANGE'
}

export type ContainerTypeType = Node & {
  __typename: 'ContainerTypeType';
  alertruleSet: AlertRuleDefConnection;
  colour: Scalars['String']['output'];
  compatibleSpareParts?: Maybe<Array<Maybe<SparePartType>>>;
  containerAccess?: Maybe<Scalars['String']['output']>;
  containerSet: ContainerTypeConnection;
  costsettingsSet: CostSettingsTypeConnection;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** m */
  diameter?: Maybe<Scalars['Float']['output']>;
  emplacement?: Maybe<Scalars['String']['output']>;
  emptyingTime: Scalars['Int']['output'];
  /** seconds; overrides emptying_time when set */
  emptyingTimeSeconds?: Maybe<Scalars['Int']['output']>;
  /** m */
  height: Scalars['Float']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isCylindrical: Scalars['Boolean']['output'];
  isRentable: Scalars['Boolean']['output'];
  isSludgeTank: Scalars['Boolean']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  /** m */
  length?: Maybe<Scalars['Float']['output']>;
  lidType?: Maybe<Scalars['String']['output']>;
  /** e.g. active, retired, maintenance */
  lifecycleStatus: Scalars['String']['output'];
  /** Which kind of load unit this type is (pallet | compactor | skip), or null. Set it so the driver app offers the three-step loaded/emptied/unloaded confirmation (HSY REQ 249) by configuration; when null the name heuristic decides. */
  loadUnitType?: Maybe<Scalars['String']['output']>;
  loadingMethod?: Maybe<Scalars['String']['output']>;
  /** Maximum payload of this container type in kilograms (PRODUCT-475). Drives the expected-load warning before dispatch. Empty = not stated. */
  maxPayloadKg?: Maybe<Scalars['Int']['output']>;
  metaData: Scalars['JSONString']['output'];
  migratedFromId?: Maybe<Scalars['String']['output']>;
  mobility?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  overflowingSettings?: Maybe<OverflowingSettingsType>;
  photo?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  pickupSetting?: Maybe<PickupSettingsType>;
  project?: Maybe<ProjectType>;
  projectsVisible: ProjectTypeConnection;
  routeSettings: RouteSettingsTypeConnection;
  scheduledexportSet: ScheduledExportDefConnection;
  scheduledexportrunSet: ScheduledExportRunDefConnection;
  scpProfiles: ScpProfileDefConnection;
  spareParts: SparePartTypeConnection;
  stockAlerts: Array<StockAlertEventDef>;
  vehicleCoupling?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  vehicletrailerSet: VehicleTrailerTypeConnection;
  /** m³ */
  volume: Scalars['Float']['output'];
  warrantyMonths?: Maybe<Scalars['Int']['output']>;
  wasteFractionRules: ContainerTypeWasteFractionRuleTypeConnection;
  wasteTypes?: Maybe<Array<Maybe<WasteFractionType>>>;
  wasteTypesSummary: Scalars['String']['output'];
  /** m */
  width?: Maybe<Scalars['Float']['output']>;
};


export type ContainerTypeTypeAlertruleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeTypeContainerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeTypeCostsettingsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeTypeProjectsVisibleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeTypeRouteSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeTypeScheduledexportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeTypeScheduledexportrunSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeTypeScpProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeTypeSparePartsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeTypeVehicletrailerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContainerTypeTypeWasteFractionRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerTypeTypeConnection = {
  __typename: 'ContainerTypeTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContainerTypeTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ContainerTypeType` and its cursor. */
export type ContainerTypeTypeEdge = {
  __typename: 'ContainerTypeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContainerTypeType>;
};

/**
 * PRODUCT-475 (BE-P2-5): one row of the per-company fraction x
 * container-type compatibility table. ``allowed`` false DENIES booking
 * the fraction on the type (a hard stop at booking); a pair without a
 * row is allowed. Company-walled through the query / mutations.
 */
export type ContainerTypeWasteFractionRuleType = Node & {
  __typename: 'ContainerTypeWasteFractionRuleType';
  /** False denies booking this waste fraction on this container type (hard stop); True records an explicit allow. A pair without a rule is allowed. */
  allowed: Scalars['Boolean']['output'];
  containerType: ContainerTypeType;
  created: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  wasteFraction: WasteFractionType;
};

export type ContainerTypeWasteFractionRuleTypeConnection = {
  __typename: 'ContainerTypeWasteFractionRuleTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContainerTypeWasteFractionRuleTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ContainerTypeWasteFractionRuleType` and its cursor. */
export type ContainerTypeWasteFractionRuleTypeEdge = {
  __typename: 'ContainerTypeWasteFractionRuleTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContainerTypeWasteFractionRuleType>;
};

export type ContainerWeightImportType = Node & {
  __typename: 'ContainerWeightImportType';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delimiter: Scalars['String']['output'];
  error: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importFile: Scalars['String']['output'];
  project: ProjectType;
  status?: Maybe<Scalars['String']['output']>;
};

export type ContainerWeightImportTypeConnection = {
  __typename: 'ContainerWeightImportTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContainerWeightImportTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ContainerWeightImportType` and its cursor. */
export type ContainerWeightImportTypeEdge = {
  __typename: 'ContainerWeightImportTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContainerWeightImportType>;
};

/**
 * The area card's "collections completed" figure (PRO-325) — counted by
 * the ONE metrics service, never a raw table count. Carries the window it
 * counted over so the card can open the exact task list behind the number.
 */
export type ContractAreaCollectionsType = {
  __typename: 'ContractAreaCollectionsType';
  areaId?: Maybe<Scalars['ID']['output']>;
  /** Completed eligible stops on the awarded contractor's routes within the award's validity window. */
  completedCount?: Maybe<Scalars['Int']['output']>;
  /** Window start actually applied (validity floor). */
  fromDate?: Maybe<Scalars['Date']['output']>;
  /** The awarded contractor the count is scoped to (if any). */
  haulerId?: Maybe<Scalars['ID']['output']>;
  /** Window end actually applied (validity end, clamped to today). */
  toDate?: Maybe<Scalars['Date']['output']>;
};

/**
 * One existing contract area colliding on the full conflict key
 * (zone x waste fraction x container type x service x validity).
 */
export type ContractAreaConflictDef = {
  __typename: 'ContractAreaConflictDef';
  /** Its stable code ("CA-0003"). */
  areaCode?: Maybe<Scalars['String']['output']>;
  /** Relay global id of the colliding area. */
  areaId: Scalars['ID']['output'];
  areaName: Scalars['String']['output'];
  /** PRO-280 (decision 7): true when the evaluated definition lies FULLY inside this colliding area — so the office can offer 'create as a carve-out of this area' instead of just warning. A partial/unrelated overlap is false and stays a plain warning; never a block. */
  carveOutAvailable: Scalars['Boolean']['output'];
  containerTypeOverlap: Scalars['String']['output'];
  /** Who the colliding area is awarded to. */
  contractorName?: Maybe<Scalars['String']['output']>;
  /** The colliding area's last effective day (validity end or termination, whichever is earlier). Null = open-ended. */
  overlapUntil?: Maybe<Scalars['Date']['output']>;
  /** Always BOTH_ALL today: the platform has no per-area service scope, so the service dimension never narrows a collision. */
  serviceOverlap: Scalars['String']['output'];
  sharedContainerTypes?: Maybe<Array<Scalars['String']['output']>>;
  sharedWasteFractions?: Maybe<Array<Scalars['String']['output']>>;
  sharedZones?: Maybe<Array<ConflictZoneDef>>;
  /** The colliding area's start. */
  validFrom?: Maybe<Scalars['Date']['output']>;
  wasteFractionOverlap: Scalars['String']['output'];
};

/** One contract file on a contract area (R2-S14 / R2-D20). */
export type ContractAreaDocumentDef = Node & {
  __typename: 'ContractAreaDocumentDef';
  area: AreaDef;
  contentType: Scalars['String']['output'];
  /** Short-lived signed URL for the private object (15-minute default). Request the field again for a fresh link. */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Display name (defaults to the uploaded filename). */
  name: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
  uploadedAt: Scalars['DateTime']['output'];
  uploadedByName?: Maybe<Scalars['String']['output']>;
};

export type ContractAreaDocumentDefConnection = {
  __typename: 'ContractAreaDocumentDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContractAreaDocumentDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ContractAreaDocumentDef` and its cursor. */
export type ContractAreaDocumentDefEdge = {
  __typename: 'ContractAreaDocumentDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContractAreaDocumentDef>;
};

export type ContractCoverageDef = {
  __typename: 'ContractCoverageDef';
  fractions: Array<CoverageFractionDef>;
  totalCells: Scalars['Int']['output'];
  totalUncovered: Scalars['Int']['output'];
  zones: Array<CoverageZoneDef>;
};

/**
 * One product the wizard's step 3 resolves for the selected scope
 * (DEV-TASK-1 D-4). Plain ObjectType — rows come from a company-scoped ORM
 * query over ``pp_products``, never persisted per area.
 *
 * ``anyContainerType`` / ``anyWasteFraction`` surface the LEDGER-802
 * wildcard (an unconstrained dimension serves any value — the FE labels it
 * "Any" instead of an empty list).
 */
export type ContractScopeProductDef = {
  __typename: 'ContractScopeProductDef';
  anyContainerType?: Maybe<Scalars['Boolean']['output']>;
  anyWasteFraction?: Maybe<Scalars['Boolean']['output']>;
  containerTypeNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  productCode?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  wasteFractionNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/**
 * Purchase-invoice reconciliation over a period (PRO-468). ``haulerId`` is
 * set for a single-contractor report and null for the across-contractors
 * export (each period names its own contractor).
 */
export type ContractorInvoiceReconciliationReportType = {
  __typename: 'ContractorInvoiceReconciliationReportType';
  /** The reconciliation export (one row per contractor per period: system payable, invoice ref/total, difference, status) as base64 — same document for office and reporting role (decision 5). */
  csvBase64: Scalars['String']['output'];
  /** Requested range start (ISO). */
  fromDate?: Maybe<Scalars['String']['output']>;
  haulerId?: Maybe<Scalars['ID']['output']>;
  haulerName?: Maybe<Scalars['String']['output']>;
  /** One entry per (contractor, settlement month) in range. */
  periods: Array<PeriodReconciliationType>;
  /** Requested range end (ISO). */
  toDate?: Maybe<Scalars['String']['output']>;
};

/**
 * A manual contractor credit/receivable entry with four-eyes approval
 * (PRO-465). Append-only: never edited after approval — corrections are
 * counter-entries.
 */
export type ContractorManualEntryType = Node & {
  __typename: 'ContractorManualEntryType';
  /** POSITIVE magnitude in integer cents; the sign of the effect on Total payable comes from entry_type (deduction = minus, credit = plus). */
  amountCents: Scalars['Int']['output'];
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<UserType>;
  /** Optional contract area. NULL = a contractor-level entry. */
  area?: Maybe<AreaDef>;
  /** The entry this one reverses/replaces (four-eyes counter). */
  counterOf?: Maybe<ContractorManualEntryType>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** deduction | credit. */
  entryType: Scalars['String']['output'];
  /** The contractor the entry credits/deducts. */
  hauler: HaulerDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Free-text note; mandatory when reason is 'other'. */
  note: Scalars['String']['output'];
  /** contract_breach | damage_claim | agreed_adjustment | other. */
  reason: Scalars['String']['output'];
  /** Optional complaint / ticket reference. */
  reference: Scalars['String']['output'];
  settledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The entry's signed contribution to Total payable (cents): a deduction is negative, a credit positive. */
  signedAmountCents: Scalars['Int']['output'];
  /** draft | approved | settled. */
  status: Scalars['String']['output'];
  targetMonth: Scalars['Int']['output'];
  targetYear: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContractorManualEntryTypeConnection = {
  __typename: 'ContractorManualEntryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContractorManualEntryTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ContractorManualEntryType` and its cursor. */
export type ContractorManualEntryTypeEdge = {
  __typename: 'ContractorManualEntryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContractorManualEntryType>;
};

/**
 * One contract area's settlement for one month in the report range
 * (PRO-466). Carries the section figures, the bonus breakdown and the full
 * underlying settlement report for drill-through.
 */
export type ContractorReportSectionType = {
  __typename: 'ContractorReportSectionType';
  adjustmentsTotalCents: Scalars['Int']['output'];
  areaId?: Maybe<Scalars['ID']['output']>;
  areaName?: Maybe<Scalars['String']['output']>;
  /** The inputs → formula → euro bonus calculation. */
  bonusBreakdown: BonusBreakdownType;
  bonusPenaltyCents: Scalars['Int']['output'];
  coefficient?: Maybe<Scalars['Float']['output']>;
  compensationBaseCents: Scalars['Int']['output'];
  correctionsCarryoverCents: Scalars['Int']['output'];
  haulerId?: Maybe<Scalars['ID']['output']>;
  /** PRO-465 area-less contractor-level manual-entry line (no area). */
  isContractorLevel: Scalars['Boolean']['output'];
  /** PRO-280 roll-up line (parent + same-hauler carve-outs, labelled '{parent} (incl. carve-outs)'). A presentation aggregate — EXCLUDED from grandTotalCents (its members are already summed). */
  isRollup: Scalars['Boolean']['output'];
  /** The PRO-465 credit/deduction lines folded into total. */
  manualEntries: Array<ManualEntryLineType>;
  /** Signed cents: the sum of the manual-entry lines. */
  manualEntriesTotalCents: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  /** Completed emptyings (tasks performed). */
  performancesCount: Scalars['Int']['output'];
  periodEnd?: Maybe<Scalars['String']['output']>;
  periodStart?: Maybe<Scalars['String']['output']>;
  /** The full underlying per-area settlement report for drill-through (per-product lines, reliability, complaints, adjustments, manual-entry lines). */
  report: SettlementReportType;
  /** open | closed */
  status?: Maybe<Scalars['String']['output']>;
  /** The period's final settlement amount. */
  totalPayableCents: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

/**
 * A contractor's settlement over an arbitrary period (PRO-466): header,
 * per-area-per-period sections and a grand total that equals the sum of the
 * underlying period settlements exactly.
 */
export type ContractorSettlementReportType = {
  __typename: 'ContractorSettlementReportType';
  /** The CSV export (rows per area per period) as base64, reusing the settlement export's exact column labels (decision 4 / PRO-280) plus a Credits/deductions column. Same document for office and contractor manager (no surprises). */
  csvBase64: Scalars['String']['output'];
  /** Requested range start (ISO). */
  fromDate?: Maybe<Scalars['String']['output']>;
  /** The contractor grand total: the sum of every non-roll-up section's totalPayableCents — i.e. the sum of the underlying period settlements exactly. */
  grandTotalCents: Scalars['Int']['output'];
  hasClosed: Scalars['Boolean']['output'];
  hasOpen: Scalars['Boolean']['output'];
  haulerId?: Maybe<Scalars['ID']['output']>;
  haulerName?: Maybe<Scalars['String']['output']>;
  /** True when the range mixes open and closed periods. */
  isMixed: Scalars['Boolean']['output'];
  /** Settled (area, month) sections feeding the grand total. */
  periodCount: Scalars['Int']['output'];
  /** One section per contract area per settlement month. */
  sections: Array<ContractorReportSectionType>;
  /** Requested range end (ISO). */
  toDate?: Maybe<Scalars['String']['output']>;
};

/**
 * Wave 2 Lane E S3: draft a converted flow for EVERY GREEN legacy rule
 * in the tenant at once -- the wizard's "convert all N safe steps" click.
 * Exactly `ConfirmConvertLegacyRuleToFlow`'s contract applied per rule
 * (see `autopilot.services.estate_migration.convert_all_green_legacy_
 * rules` for the full semantics): GREEN only, per-rule dedupe under the
 * same row lock, definitions recomputed and validator-checked, every
 * created flow a DRAFT that never self-promotes, one audit row per
 * creation. Idempotent: a second call drafts nothing and reports
 * `already_converted` per row. `results` is the batch's complete
 * per-rule ledger; `draftedCount` is the number actually created by
 * THIS call.
 */
export type ConvertAllGreenLegacyRules = {
  __typename: 'ConvertAllGreenLegacyRules';
  draftedCount: Scalars['Int']['output'];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  results: Array<AutopilotEstateConversionResultType>;
};

export type CopilotConversationDef = Node & {
  __typename: 'CopilotConversationDef';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  messages?: Maybe<Array<CopilotMessageDef>>;
  project: ProjectType;
  title: Scalars['String']['output'];
  tokenBudget: Scalars['Int']['output'];
  tokensUsed: Scalars['Int']['output'];
  turnBudget: Scalars['Int']['output'];
  turnsUsed: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CopilotConversationDefConnection = {
  __typename: 'CopilotConversationDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CopilotConversationDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CopilotConversationDef` and its cursor. */
export type CopilotConversationDefEdge = {
  __typename: 'CopilotConversationDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CopilotConversationDef>;
};

/**
 * One Copilot turn (RS-802). ``tool_calls`` is the full action
 * trace: what ran, with which arguments, and what came back, so the
 * panel renders Copilot actions as normal, attributable state.
 */
export type CopilotMessageDef = Node & {
  __typename: 'CopilotMessageDef';
  content: Scalars['String']['output'];
  conversation: CopilotConversationDef;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  modelId: Scalars['String']['output'];
  numeralCheck?: Maybe<Scalars['GenericScalar']['output']>;
  role: RouteStudioCopilotMessageRoleChoices;
  status: RouteStudioCopilotMessageStatusChoices;
  toolCalls?: Maybe<Scalars['GenericScalar']['output']>;
  usage?: Maybe<Scalars['GenericScalar']['output']>;
};

/** An enumeration. */
export enum CoreBillingFeatureFeatureChoices {
  /** mp_rfid_kit_1 */
  MP_RFID_KIT_1 = 'MP_RFID_KIT_1',
  /** mp_rfid_long_range_antenna_1 */
  MP_RFID_LONG_RANGE_ANTENNA_1 = 'MP_RFID_LONG_RANGE_ANTENNA_1',
  /** mp_rfid_long_range_antenna_2 */
  MP_RFID_LONG_RANGE_ANTENNA_2 = 'MP_RFID_LONG_RANGE_ANTENNA_2',
  /** mp_rfid_manual_reader_1 */
  MP_RFID_MANUAL_READER_1 = 'MP_RFID_MANUAL_READER_1',
  /** mp_rfid_mobile_reader_1 */
  MP_RFID_MOBILE_READER_1 = 'MP_RFID_MOBILE_READER_1',
  /** mp_rfid_tag_1 */
  MP_RFID_TAG_1 = 'MP_RFID_TAG_1',
  /** mp_rfid_tag_2 */
  MP_RFID_TAG_2 = 'MP_RFID_TAG_2',
  /** mp_rfid_tag_3 */
  MP_RFID_TAG_3 = 'MP_RFID_TAG_3',
  /** mp_rfid_universal_antenna_1 */
  MP_RFID_UNIVERSAL_ANTENNA_1 = 'MP_RFID_UNIVERSAL_ANTENNA_1',
  /** mp_sensor_1 */
  MP_SENSOR_1 = 'MP_SENSOR_1',
  /** mp_sensor_2 */
  MP_SENSOR_2 = 'MP_SENSOR_2',
  /** wh_alerts */
  WH_ALERTS = 'WH_ALERTS',
  /** wh_analytics */
  WH_ANALYTICS = 'WH_ANALYTICS',
  /** wh_asset_management */
  WH_ASSET_MANAGEMENT = 'WH_ASSET_MANAGEMENT',
  /** wh_customer_management */
  WH_CUSTOMER_MANAGEMENT = 'WH_CUSTOMER_MANAGEMENT',
  /** wh_customer_management_portal */
  WH_CUSTOMER_MANAGEMENT_PORTAL = 'WH_CUSTOMER_MANAGEMENT_PORTAL',
  /** wh_fleet_management */
  WH_FLEET_MANAGEMENT = 'WH_FLEET_MANAGEMENT',
  /** wh_navigation */
  WH_NAVIGATION = 'WH_NAVIGATION',
  /** wh_operation_management */
  WH_OPERATION_MANAGEMENT = 'WH_OPERATION_MANAGEMENT',
  /** wh_user_management */
  WH_USER_MANAGEMENT = 'WH_USER_MANAGEMENT'
}

/** An enumeration. */
export enum CoreBillingFeatureProductPriceBillingSchemeChoices {
  /** per_unit */
  PER_UNIT = 'PER_UNIT',
  /** tiered */
  TIERED = 'TIERED'
}

/** An enumeration. */
export enum CoreBillingInformationDefaultCollectionMethodChoices {
  /** Stripe */
  A_1 = 'A_1',
  /** Wise */
  A_2 = 'A_2'
}

/** An enumeration. */
export enum CoreCompanyEmailAccountBillingStateChoices {
  /** Cancelled */
  CANCELLED = 'CANCELLED',
  /** Deleted */
  DELETED = 'DELETED',
  /** Need Initialization */
  NEED_INITIALIZATION = 'NEED_INITIALIZATION',
  /** Paid */
  PAID = 'PAID'
}

/** An enumeration. */
export enum CoreCompanyEmailAccountMessageStatusChoices {
  /** Completed */
  COMPLETED = 'COMPLETED',
  /** New */
  NEW = 'NEW',
  /** Open */
  OPEN = 'OPEN',
  /** Rejected */
  REJECTED = 'REJECTED'
}

/** An enumeration. */
export enum CoreCompanyEmailAccountSendStateChoices {
  /** Exception */
  EXCEPTION = 'EXCEPTION',
  /** Initializing */
  INITIALIZING = 'INITIALIZING',
  /** Running */
  RUNNING = 'RUNNING'
}

/** An enumeration. */
export enum CoreCompanyEmailAccountSyncStateChoices {
  /** Downloading */
  DOWNLOADING = 'DOWNLOADING',
  /** Exception */
  EXCEPTION = 'EXCEPTION',
  /** Initializing */
  INITIALIZING = 'INITIALIZING',
  /** Invalid */
  INVALID = 'INVALID',
  /** Invalid Credentials */
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  /** Need Initialization */
  NEED_INITIALIZATION = 'NEED_INITIALIZATION',
  /** Partial */
  PARTIAL = 'PARTIAL',
  /** Running */
  RUNNING = 'RUNNING',
  /** Stopped */
  STOPPED = 'STOPPED',
  /** Sync Error */
  SYNC_ERROR = 'SYNC_ERROR',
  /** Valid */
  VALID = 'VALID'
}

/** An enumeration. */
export enum CoreCompanyMetaTypeCopyFromChoices {
  /** Property */
  A_1 = 'A_1',
  /** Container */
  A_2 = 'A_2'
}

/** An enumeration. */
export enum CoreCompanyMetaTypeEntityChoices {
  /** Container */
  CONTAINER = 'CONTAINER',
  /** Container Type */
  CONTAINER_TYPE = 'CONTAINER_TYPE',
  /** Property */
  PROPERTY = 'PROPERTY',
  /** Property Group */
  PROPERTY_GROUP = 'PROPERTY_GROUP',
  /** Spare Part */
  SPARE_PART = 'SPARE_PART'
}

/** An enumeration. */
export enum CoreCompanyMetaTypeInputTypeChoices {
  /** Date */
  DATE = 'DATE',
  /** Multi Select */
  MULTI_SELECT = 'MULTI_SELECT',
  /** Number */
  NUMBER = 'NUMBER',
  /** Select */
  SELECT = 'SELECT',
  /** Signature */
  SIGNATURE = 'SIGNATURE',
  /** Text Area */
  TEXT_AREA = 'TEXT_AREA'
}

/** An enumeration. */
export enum CoreCompanyRolePermissionNameChoices {
  /** Agreement Suspension  Edit */
  AGREEMENT_SUSPENSION_EDIT = 'AGREEMENT_SUSPENSION__EDIT',
  /** Agreement Template  Create */
  AGREEMENT_TEMPLATE_CREATE = 'AGREEMENT_TEMPLATE__CREATE',
  /** Agreement Template  Delete */
  AGREEMENT_TEMPLATE_DELETE = 'AGREEMENT_TEMPLATE__DELETE',
  /** Agreement Template  Edit */
  AGREEMENT_TEMPLATE_EDIT = 'AGREEMENT_TEMPLATE__EDIT',
  /** Alert Rule  Create */
  ALERT_RULE_CREATE = 'ALERT_RULE__CREATE',
  /** Alert Rule  Delete */
  ALERT_RULE_DELETE = 'ALERT_RULE__DELETE',
  /** Alert Rule  Edit */
  ALERT_RULE_EDIT = 'ALERT_RULE__EDIT',
  /** Alert  Create */
  ALERT_CREATE = 'ALERT__CREATE',
  /** Alert  Delete */
  ALERT_DELETE = 'ALERT__DELETE',
  /** Alert  Edit */
  ALERT_EDIT = 'ALERT__EDIT',
  /** Analytics Dashboard  Create */
  ANALYTICS_DASHBOARD_CREATE = 'ANALYTICS_DASHBOARD__CREATE',
  /** Analytics Dashboard  Delete */
  ANALYTICS_DASHBOARD_DELETE = 'ANALYTICS_DASHBOARD__DELETE',
  /** Analytics Dashboard  Edit */
  ANALYTICS_DASHBOARD_EDIT = 'ANALYTICS_DASHBOARD__EDIT',
  /** Approval Collection  Create */
  APPROVAL_COLLECTION_CREATE = 'APPROVAL_COLLECTION__CREATE',
  /** Approval Collection  Delete */
  APPROVAL_COLLECTION_DELETE = 'APPROVAL_COLLECTION__DELETE',
  /** Approval Collection  Edit */
  APPROVAL_COLLECTION_EDIT = 'APPROVAL_COLLECTION__EDIT',
  /** Archived Data  Manage */
  ARCHIVED_DATA_MANAGE = 'ARCHIVED_DATA__MANAGE',
  /** Archived Data  View */
  ARCHIVED_DATA_VIEW = 'ARCHIVED_DATA__VIEW',
  /** Automation  Create */
  AUTOMATION_CREATE = 'AUTOMATION__CREATE',
  /** Automation  Delete */
  AUTOMATION_DELETE = 'AUTOMATION__DELETE',
  /** Automation  Edit */
  AUTOMATION_EDIT = 'AUTOMATION__EDIT',
  /** Billable Event  Override Legal Class */
  BILLABLE_EVENT_OVERRIDE_LEGAL_CLASS = 'BILLABLE_EVENT__OVERRIDE_LEGAL_CLASS',
  /** Billing Information  Create */
  BILLING_INFORMATION_CREATE = 'BILLING_INFORMATION__CREATE',
  /** Billing Information  Edit */
  BILLING_INFORMATION_EDIT = 'BILLING_INFORMATION__EDIT',
  /** Billing Run Export  Create */
  BILLING_RUN_EXPORT_CREATE = 'BILLING_RUN_EXPORT__CREATE',
  /** Billing Run  Create */
  BILLING_RUN_CREATE = 'BILLING_RUN__CREATE',
  /** Billing Run  Delete */
  BILLING_RUN_DELETE = 'BILLING_RUN__DELETE',
  /** Collection Calendar Date  Create */
  COLLECTION_CALENDAR_DATE_CREATE = 'COLLECTION_CALENDAR_DATE__CREATE',
  /** Collection Calendar Date  Delete */
  COLLECTION_CALENDAR_DATE_DELETE = 'COLLECTION_CALENDAR_DATE__DELETE',
  /** Collection Calendar Date  Edit */
  COLLECTION_CALENDAR_DATE_EDIT = 'COLLECTION_CALENDAR_DATE__EDIT',
  /** Collection Calendar Deviation  Create */
  COLLECTION_CALENDAR_DEVIATION_CREATE = 'COLLECTION_CALENDAR_DEVIATION__CREATE',
  /** Collection Calendar Deviation  Delete */
  COLLECTION_CALENDAR_DEVIATION_DELETE = 'COLLECTION_CALENDAR_DEVIATION__DELETE',
  /** Collection Calendar Deviation  Edit */
  COLLECTION_CALENDAR_DEVIATION_EDIT = 'COLLECTION_CALENDAR_DEVIATION__EDIT',
  /** Collection Calendar  Create */
  COLLECTION_CALENDAR_CREATE = 'COLLECTION_CALENDAR__CREATE',
  /** Collection Calendar  Delete */
  COLLECTION_CALENDAR_DELETE = 'COLLECTION_CALENDAR__DELETE',
  /** Collection Calendar  Edit */
  COLLECTION_CALENDAR_EDIT = 'COLLECTION_CALENDAR__EDIT',
  /** Collection Week  Create */
  COLLECTION_WEEK_CREATE = 'COLLECTION_WEEK__CREATE',
  /** Collection Week  Delete */
  COLLECTION_WEEK_DELETE = 'COLLECTION_WEEK__DELETE',
  /** Collection Week  Edit */
  COLLECTION_WEEK_EDIT = 'COLLECTION_WEEK__EDIT',
  /** Company Email Account Message  Delete */
  COMPANY_EMAIL_ACCOUNT_MESSAGE_DELETE = 'COMPANY_EMAIL_ACCOUNT_MESSAGE__DELETE',
  /** Company Email Account Message  Edit */
  COMPANY_EMAIL_ACCOUNT_MESSAGE_EDIT = 'COMPANY_EMAIL_ACCOUNT_MESSAGE__EDIT',
  /** Company Email Account  Create */
  COMPANY_EMAIL_ACCOUNT_CREATE = 'COMPANY_EMAIL_ACCOUNT__CREATE',
  /** Company Email Account  Delete */
  COMPANY_EMAIL_ACCOUNT_DELETE = 'COMPANY_EMAIL_ACCOUNT__DELETE',
  /** Company Email Account  Edit */
  COMPANY_EMAIL_ACCOUNT_EDIT = 'COMPANY_EMAIL_ACCOUNT__EDIT',
  /** Company Settings  Edit */
  COMPANY_SETTINGS_EDIT = 'COMPANY_SETTINGS__EDIT',
  /** Company  Edit */
  COMPANY_EDIT = 'COMPANY__EDIT',
  /** Contact Field Configuration  Edit */
  CONTACT_FIELD_CONFIGURATION_EDIT = 'CONTACT_FIELD_CONFIGURATION__EDIT',
  /** Contact Ndr  Edit */
  CONTACT_NDR_EDIT = 'CONTACT_NDR__EDIT',
  /** Contact Ndr  View */
  CONTACT_NDR_VIEW = 'CONTACT_NDR__VIEW',
  /** Contact Pic  Edit */
  CONTACT_PIC_EDIT = 'CONTACT_PIC__EDIT',
  /** Contact Pic  View */
  CONTACT_PIC_VIEW = 'CONTACT_PIC__VIEW',
  /** Contact Property  Create */
  CONTACT_PROPERTY_CREATE = 'CONTACT_PROPERTY__CREATE',
  /** Contact Property  Delete */
  CONTACT_PROPERTY_DELETE = 'CONTACT_PROPERTY__DELETE',
  /** Contact  Create */
  CONTACT_CREATE = 'CONTACT__CREATE',
  /** Contact  Delete */
  CONTACT_DELETE = 'CONTACT__DELETE',
  /** Contact  Edit */
  CONTACT_EDIT = 'CONTACT__EDIT',
  /** Container Group  Create */
  CONTAINER_GROUP_CREATE = 'CONTAINER_GROUP__CREATE',
  /** Container Group  Delete */
  CONTAINER_GROUP_DELETE = 'CONTAINER_GROUP__DELETE',
  /** Container Group  Edit */
  CONTAINER_GROUP_EDIT = 'CONTAINER_GROUP__EDIT',
  /** Container Type  Create */
  CONTAINER_TYPE_CREATE = 'CONTAINER_TYPE__CREATE',
  /** Container Type  Delete */
  CONTAINER_TYPE_DELETE = 'CONTAINER_TYPE__DELETE',
  /** Container Type  Edit */
  CONTAINER_TYPE_EDIT = 'CONTAINER_TYPE__EDIT',
  /** Container  Create */
  CONTAINER_CREATE = 'CONTAINER__CREATE',
  /** Container  Delete */
  CONTAINER_DELETE = 'CONTAINER__DELETE',
  /** Container  Edit */
  CONTAINER_EDIT = 'CONTAINER__EDIT',
  /** Contractor Reporting  Reconcile */
  CONTRACTOR_REPORTING_RECONCILE = 'CONTRACTOR_REPORTING__RECONCILE',
  /** Contractor Reporting  View */
  CONTRACTOR_REPORTING_VIEW = 'CONTRACTOR_REPORTING__VIEW',
  /** Criipto Application  Create */
  CRIIPTO_APPLICATION_CREATE = 'CRIIPTO_APPLICATION__CREATE',
  /** Criipto Application  Delete */
  CRIIPTO_APPLICATION_DELETE = 'CRIIPTO_APPLICATION__DELETE',
  /** Criipto Application  Edit */
  CRIIPTO_APPLICATION_EDIT = 'CRIIPTO_APPLICATION__EDIT',
  /** Crm Composting Registry  Create */
  CRM_COMPOSTING_REGISTRY_CREATE = 'CRM_COMPOSTING_REGISTRY__CREATE',
  /** Crm Composting Registry  Delete */
  CRM_COMPOSTING_REGISTRY_DELETE = 'CRM_COMPOSTING_REGISTRY__DELETE',
  /** Crm Composting Registry  Edit */
  CRM_COMPOSTING_REGISTRY_EDIT = 'CRM_COMPOSTING_REGISTRY__EDIT',
  /** Crm Composting Registry  View */
  CRM_COMPOSTING_REGISTRY_VIEW = 'CRM_COMPOSTING_REGISTRY__VIEW',
  /** Crm Composting Template  Manage */
  CRM_COMPOSTING_TEMPLATE_MANAGE = 'CRM_COMPOSTING_TEMPLATE__MANAGE',
  /** Crm Customer Function  Create */
  CRM_CUSTOMER_FUNCTION_CREATE = 'CRM_CUSTOMER_FUNCTION__CREATE',
  /** Crm Customer Function  Delete */
  CRM_CUSTOMER_FUNCTION_DELETE = 'CRM_CUSTOMER_FUNCTION__DELETE',
  /** Crm Customer Function  Edit */
  CRM_CUSTOMER_FUNCTION_EDIT = 'CRM_CUSTOMER_FUNCTION__EDIT',
  /** Crm Customer Note  Create */
  CRM_CUSTOMER_NOTE_CREATE = 'CRM_CUSTOMER_NOTE__CREATE',
  /** Crm Customer Note  Delete */
  CRM_CUSTOMER_NOTE_DELETE = 'CRM_CUSTOMER_NOTE__DELETE',
  /** Crm Customer Note  Edit */
  CRM_CUSTOMER_NOTE_EDIT = 'CRM_CUSTOMER_NOTE__EDIT',
  /** Crm Customer Note  View */
  CRM_CUSTOMER_NOTE_VIEW = 'CRM_CUSTOMER_NOTE__VIEW',
  /** Crm Municipality  Create */
  CRM_MUNICIPALITY_CREATE = 'CRM_MUNICIPALITY__CREATE',
  /** Crm Municipality  Delete */
  CRM_MUNICIPALITY_DELETE = 'CRM_MUNICIPALITY__DELETE',
  /** Crm Municipality  Edit */
  CRM_MUNICIPALITY_EDIT = 'CRM_MUNICIPALITY__EDIT',
  /** Crm Pricing  Create */
  CRM_PRICING_CREATE = 'CRM_PRICING__CREATE',
  /** Crm Pricing  Delete */
  CRM_PRICING_DELETE = 'CRM_PRICING__DELETE',
  /** Crm Pricing  Edit */
  CRM_PRICING_EDIT = 'CRM_PRICING__EDIT',
  /** Crm Property Group  Create */
  CRM_PROPERTY_GROUP_CREATE = 'CRM_PROPERTY_GROUP__CREATE',
  /** Crm Property Group  Delete */
  CRM_PROPERTY_GROUP_DELETE = 'CRM_PROPERTY_GROUP__DELETE',
  /** Crm Property Group  Edit */
  CRM_PROPERTY_GROUP_EDIT = 'CRM_PROPERTY_GROUP__EDIT',
  /** Crm Property Note  Create */
  CRM_PROPERTY_NOTE_CREATE = 'CRM_PROPERTY_NOTE__CREATE',
  /** Crm Property Note  Delete */
  CRM_PROPERTY_NOTE_DELETE = 'CRM_PROPERTY_NOTE__DELETE',
  /** Crm Property Note  Edit */
  CRM_PROPERTY_NOTE_EDIT = 'CRM_PROPERTY_NOTE__EDIT',
  /** Crm Property Note  View */
  CRM_PROPERTY_NOTE_VIEW = 'CRM_PROPERTY_NOTE__VIEW',
  /** Crm Property Type  Create */
  CRM_PROPERTY_TYPE_CREATE = 'CRM_PROPERTY_TYPE__CREATE',
  /** Crm Property Type  Delete */
  CRM_PROPERTY_TYPE_DELETE = 'CRM_PROPERTY_TYPE__DELETE',
  /** Crm Property Type  Edit */
  CRM_PROPERTY_TYPE_EDIT = 'CRM_PROPERTY_TYPE__EDIT',
  /** Crm Property  Create */
  CRM_PROPERTY_CREATE = 'CRM_PROPERTY__CREATE',
  /** Crm Property  Delete */
  CRM_PROPERTY_DELETE = 'CRM_PROPERTY__DELETE',
  /** Crm Property  Edit */
  CRM_PROPERTY_EDIT = 'CRM_PROPERTY__EDIT',
  /** Crm Service  Create */
  CRM_SERVICE_CREATE = 'CRM_SERVICE__CREATE',
  /** Crm Service  Delete */
  CRM_SERVICE_DELETE = 'CRM_SERVICE__DELETE',
  /** Crm Service  Edit */
  CRM_SERVICE_EDIT = 'CRM_SERVICE__EDIT',
  /** Debtor Export  Create */
  DEBTOR_EXPORT_CREATE = 'DEBTOR_EXPORT__CREATE',
  /** Depot  Create */
  DEPOT_CREATE = 'DEPOT__CREATE',
  /** Depot  Delete */
  DEPOT_DELETE = 'DEPOT__DELETE',
  /** Depot  Edit */
  DEPOT_EDIT = 'DEPOT__EDIT',
  /** Dkdp Company Credentials  Create */
  DKDP_COMPANY_CREDENTIALS_CREATE = 'DKDP_COMPANY_CREDENTIALS__CREATE',
  /** Dkdp Company Credentials  Delete */
  DKDP_COMPANY_CREDENTIALS_DELETE = 'DKDP_COMPANY_CREDENTIALS__DELETE',
  /** Dkdp Company Credentials  Edit */
  DKDP_COMPANY_CREDENTIALS_EDIT = 'DKDP_COMPANY_CREDENTIALS__EDIT',
  /** Document  Create */
  DOCUMENT_CREATE = 'DOCUMENT__CREATE',
  /** Document  Delete */
  DOCUMENT_DELETE = 'DOCUMENT__DELETE',
  /** Document  Edit */
  DOCUMENT_EDIT = 'DOCUMENT__EDIT',
  /** Driver  Create */
  DRIVER_CREATE = 'DRIVER__CREATE',
  /** Driver  Delete */
  DRIVER_DELETE = 'DRIVER__DELETE',
  /** Driver  Edit */
  DRIVER_EDIT = 'DRIVER__EDIT',
  /** Export Template  Create */
  EXPORT_TEMPLATE_CREATE = 'EXPORT_TEMPLATE__CREATE',
  /** Export Template  Delete */
  EXPORT_TEMPLATE_DELETE = 'EXPORT_TEMPLATE__DELETE',
  /** Export Template  Edit */
  EXPORT_TEMPLATE_EDIT = 'EXPORT_TEMPLATE__EDIT',
  /** Hauler Price  Create */
  HAULER_PRICE_CREATE = 'HAULER_PRICE__CREATE',
  /** Hauler Price  Delete */
  HAULER_PRICE_DELETE = 'HAULER_PRICE__DELETE',
  /** Hauler Price  Edit */
  HAULER_PRICE_EDIT = 'HAULER_PRICE__EDIT',
  /** Hauler Price  View */
  HAULER_PRICE_VIEW = 'HAULER_PRICE__VIEW',
  /** Hauler  Create */
  HAULER_CREATE = 'HAULER__CREATE',
  /** Hauler  Delete */
  HAULER_DELETE = 'HAULER__DELETE',
  /** Hauler  Edit */
  HAULER_EDIT = 'HAULER__EDIT',
  /** Hauler  View */
  HAULER_VIEW = 'HAULER__VIEW',
  /** Import History  Create */
  IMPORT_HISTORY_CREATE = 'IMPORT_HISTORY__CREATE',
  /** Import History  Delete */
  IMPORT_HISTORY_DELETE = 'IMPORT_HISTORY__DELETE',
  /** Import History  Edit */
  IMPORT_HISTORY_EDIT = 'IMPORT_HISTORY__EDIT',
  /** Industry Catalogue  Edit */
  INDUSTRY_CATALOGUE_EDIT = 'INDUSTRY_CATALOGUE__EDIT',
  /** Key  Manage */
  KEY_MANAGE = 'KEY__MANAGE',
  /** Key  View */
  KEY_VIEW = 'KEY__VIEW',
  /** Kmd Easy File Export  Create */
  KMD_EASY_FILE_EXPORT_CREATE = 'KMD_EASY_FILE_EXPORT__CREATE',
  /** Kmd Easy File Import  Create */
  KMD_EASY_FILE_IMPORT_CREATE = 'KMD_EASY_FILE_IMPORT__CREATE',
  /** Kmd Easy Settings  Edit */
  KMD_EASY_SETTINGS_EDIT = 'KMD_EASY_SETTINGS__EDIT',
  /** Kmd Easy Station Code Mapping  Create */
  KMD_EASY_STATION_CODE_MAPPING_CREATE = 'KMD_EASY_STATION_CODE_MAPPING__CREATE',
  /** Kmd Easy Station Code Mapping  Delete */
  KMD_EASY_STATION_CODE_MAPPING_DELETE = 'KMD_EASY_STATION_CODE_MAPPING__DELETE',
  /** Kmd Easy Station Code Mapping  Edit */
  KMD_EASY_STATION_CODE_MAPPING_EDIT = 'KMD_EASY_STATION_CODE_MAPPING__EDIT',
  /** Live Operations  Compliance Admin */
  LIVE_OPERATIONS_COMPLIANCE_ADMIN = 'LIVE_OPERATIONS__COMPLIANCE_ADMIN',
  /** Live Operations  View */
  LIVE_OPERATIONS_VIEW = 'LIVE_OPERATIONS__VIEW',
  /** Management Company Property  Create */
  MANAGEMENT_COMPANY_PROPERTY_CREATE = 'MANAGEMENT_COMPANY_PROPERTY__CREATE',
  /** Management Company Property  Delete */
  MANAGEMENT_COMPANY_PROPERTY_DELETE = 'MANAGEMENT_COMPANY_PROPERTY__DELETE',
  /** Measurement Settings  Create */
  MEASUREMENT_SETTINGS_CREATE = 'MEASUREMENT_SETTINGS__CREATE',
  /** Measurement Settings  Delete */
  MEASUREMENT_SETTINGS_DELETE = 'MEASUREMENT_SETTINGS__DELETE',
  /** Measurement Settings  Edit */
  MEASUREMENT_SETTINGS_EDIT = 'MEASUREMENT_SETTINGS__EDIT',
  /** Pickup Order  Create */
  PICKUP_ORDER_CREATE = 'PICKUP_ORDER__CREATE',
  /** Pickup Order  Delete */
  PICKUP_ORDER_DELETE = 'PICKUP_ORDER__DELETE',
  /** Pickup Order  Edit */
  PICKUP_ORDER_EDIT = 'PICKUP_ORDER__EDIT',
  /** Pickup Settings  Create */
  PICKUP_SETTINGS_CREATE = 'PICKUP_SETTINGS__CREATE',
  /** Pickup Settings  Delete */
  PICKUP_SETTINGS_DELETE = 'PICKUP_SETTINGS__DELETE',
  /** Pickup Settings  Edit */
  PICKUP_SETTINGS_EDIT = 'PICKUP_SETTINGS__EDIT',
  /** Portal Role Capabilities  Edit */
  PORTAL_ROLE_CAPABILITIES_EDIT = 'PORTAL_ROLE_CAPABILITIES__EDIT',
  /** Portal Role Capabilities  View */
  PORTAL_ROLE_CAPABILITIES_VIEW = 'PORTAL_ROLE_CAPABILITIES__VIEW',
  /** Project  Create */
  PROJECT_CREATE = 'PROJECT__CREATE',
  /** Project  Delete */
  PROJECT_DELETE = 'PROJECT__DELETE',
  /** Project  Edit */
  PROJECT_EDIT = 'PROJECT__EDIT',
  /** Property Management Company  Create */
  PROPERTY_MANAGEMENT_COMPANY_CREATE = 'PROPERTY_MANAGEMENT_COMPANY__CREATE',
  /** Property Management Company  Delete */
  PROPERTY_MANAGEMENT_COMPANY_DELETE = 'PROPERTY_MANAGEMENT_COMPANY__DELETE',
  /** Property Management Company  Edit */
  PROPERTY_MANAGEMENT_COMPANY_EDIT = 'PROPERTY_MANAGEMENT_COMPANY__EDIT',
  /** Role  Create */
  ROLE_CREATE = 'ROLE__CREATE',
  /** Role  Delete */
  ROLE_DELETE = 'ROLE__DELETE',
  /** Role  Edit */
  ROLE_EDIT = 'ROLE__EDIT',
  /** Route Scheme  Create */
  ROUTE_SCHEME_CREATE = 'ROUTE_SCHEME__CREATE',
  /** Route Scheme  Delete */
  ROUTE_SCHEME_DELETE = 'ROUTE_SCHEME__DELETE',
  /** Route Scheme  Edit */
  ROUTE_SCHEME_EDIT = 'ROUTE_SCHEME__EDIT',
  /** Route Vehicle  Edit */
  ROUTE_VEHICLE_EDIT = 'ROUTE_VEHICLE__EDIT',
  /** Route  Create */
  ROUTE_CREATE = 'ROUTE__CREATE',
  /** Route  Delete */
  ROUTE_DELETE = 'ROUTE__DELETE',
  /** Route  Edit */
  ROUTE_EDIT = 'ROUTE__EDIT',
  /** Scheduled Change  Cancel Others */
  SCHEDULED_CHANGE_CANCEL_OTHERS = 'SCHEDULED_CHANGE__CANCEL_OTHERS',
  /** Service Responsibility  Create */
  SERVICE_RESPONSIBILITY_CREATE = 'SERVICE_RESPONSIBILITY__CREATE',
  /** Service Responsibility  Delete */
  SERVICE_RESPONSIBILITY_DELETE = 'SERVICE_RESPONSIBILITY__DELETE',
  /** Service Responsibility  Edit */
  SERVICE_RESPONSIBILITY_EDIT = 'SERVICE_RESPONSIBILITY__EDIT',
  /** Spare Part  Create */
  SPARE_PART_CREATE = 'SPARE_PART__CREATE',
  /** Spare Part  Delete */
  SPARE_PART_DELETE = 'SPARE_PART__DELETE',
  /** Spare Part  Edit */
  SPARE_PART_EDIT = 'SPARE_PART__EDIT',
  /** Stop List Customisation Config  Edit */
  STOP_LIST_CUSTOMISATION_CONFIG_EDIT = 'STOP_LIST_CUSTOMISATION_CONFIG__EDIT',
  /** Tax Settings  Manage */
  TAX_SETTINGS_MANAGE = 'TAX_SETTINGS__MANAGE',
  /** Team  Create */
  TEAM_CREATE = 'TEAM__CREATE',
  /** Team  Delete */
  TEAM_DELETE = 'TEAM__DELETE',
  /** Team  Edit */
  TEAM_EDIT = 'TEAM__EDIT',
  /** Ticket Category  Create */
  TICKET_CATEGORY_CREATE = 'TICKET_CATEGORY__CREATE',
  /** Ticket Category  Delete */
  TICKET_CATEGORY_DELETE = 'TICKET_CATEGORY__DELETE',
  /** Ticket Category  Edit */
  TICKET_CATEGORY_EDIT = 'TICKET_CATEGORY__EDIT',
  /** Ticket Custom Field  Create */
  TICKET_CUSTOM_FIELD_CREATE = 'TICKET_CUSTOM_FIELD__CREATE',
  /** Ticket Custom Field  Delete */
  TICKET_CUSTOM_FIELD_DELETE = 'TICKET_CUSTOM_FIELD__DELETE',
  /** Ticket Custom Field  Edit */
  TICKET_CUSTOM_FIELD_EDIT = 'TICKET_CUSTOM_FIELD__EDIT',
  /** Ticket Custom Field  View */
  TICKET_CUSTOM_FIELD_VIEW = 'TICKET_CUSTOM_FIELD__VIEW',
  /** Ticket Message Template  Create */
  TICKET_MESSAGE_TEMPLATE_CREATE = 'TICKET_MESSAGE_TEMPLATE__CREATE',
  /** Ticket Message Template  Delete */
  TICKET_MESSAGE_TEMPLATE_DELETE = 'TICKET_MESSAGE_TEMPLATE__DELETE',
  /** Ticket Message Template  Edit */
  TICKET_MESSAGE_TEMPLATE_EDIT = 'TICKET_MESSAGE_TEMPLATE__EDIT',
  /** Ticket Type  Create */
  TICKET_TYPE_CREATE = 'TICKET_TYPE__CREATE',
  /** Ticket Type  Delete */
  TICKET_TYPE_DELETE = 'TICKET_TYPE__DELETE',
  /** Ticket Type  Edit */
  TICKET_TYPE_EDIT = 'TICKET_TYPE__EDIT',
  /** Ticket Visibility  Edit */
  TICKET_VISIBILITY_EDIT = 'TICKET_VISIBILITY__EDIT',
  /** Transfer Document  Edit */
  TRANSFER_DOCUMENT_EDIT = 'TRANSFER_DOCUMENT__EDIT',
  /** Transfer Document  View */
  TRANSFER_DOCUMENT_VIEW = 'TRANSFER_DOCUMENT__VIEW',
  /** User Absence  Create */
  USER_ABSENCE_CREATE = 'USER_ABSENCE__CREATE',
  /** User Absence  Delete */
  USER_ABSENCE_DELETE = 'USER_ABSENCE__DELETE',
  /** User Absence  Edit */
  USER_ABSENCE_EDIT = 'USER_ABSENCE__EDIT',
  /** User Project  Create */
  USER_PROJECT_CREATE = 'USER_PROJECT__CREATE',
  /** User Project  Delete */
  USER_PROJECT_DELETE = 'USER_PROJECT__DELETE',
  /** User Project  Edit */
  USER_PROJECT_EDIT = 'USER_PROJECT__EDIT',
  /** User  Create */
  USER_CREATE = 'USER__CREATE',
  /** User  Delete */
  USER_DELETE = 'USER__DELETE',
  /** User  Edit */
  USER_EDIT = 'USER__EDIT',
  /** Vehicle Absence  Create */
  VEHICLE_ABSENCE_CREATE = 'VEHICLE_ABSENCE__CREATE',
  /** Vehicle Absence  Delete */
  VEHICLE_ABSENCE_DELETE = 'VEHICLE_ABSENCE__DELETE',
  /** Vehicle Absence  Edit */
  VEHICLE_ABSENCE_EDIT = 'VEHICLE_ABSENCE__EDIT',
  /** Rfid Vehicle Connection  Create */
  VEHICLE_CONNECTION_CREATE = 'VEHICLE_CONNECTION__CREATE',
  /** Rfid Vehicle Connection  Delete */
  VEHICLE_CONNECTION_DELETE = 'VEHICLE_CONNECTION__DELETE',
  /** Rfid Vehicle Connection  Edit */
  VEHICLE_CONNECTION_EDIT = 'VEHICLE_CONNECTION__EDIT',
  /** Vehicle Type  Create */
  VEHICLE_TYPE_CREATE = 'VEHICLE_TYPE__CREATE',
  /** Vehicle Type  Delete */
  VEHICLE_TYPE_DELETE = 'VEHICLE_TYPE__DELETE',
  /** Vehicle Type  Edit */
  VEHICLE_TYPE_EDIT = 'VEHICLE_TYPE__EDIT',
  /** Vehicle  Create */
  VEHICLE_CREATE = 'VEHICLE__CREATE',
  /** Vehicle  Delete */
  VEHICLE_DELETE = 'VEHICLE__DELETE',
  /** Vehicle  Edit */
  VEHICLE_EDIT = 'VEHICLE__EDIT',
  /** Waste Fraction  Create */
  WASTE_FRACTION_CREATE = 'WASTE_FRACTION__CREATE',
  /** Waste Fraction  Delete */
  WASTE_FRACTION_DELETE = 'WASTE_FRACTION__DELETE',
  /** Waste Fraction  Edit */
  WASTE_FRACTION_EDIT = 'WASTE_FRACTION__EDIT'
}

/** An enumeration. */
export enum CoreCompanySettingsBillingExportSystemChoices {
  /** Navision */
  NAVISION = 'NAVISION'
}

/** An enumeration. */
export enum CoreCompanySettingsCrmContactsAssignUniqueIdChoices {
  /** Tax Id */
  TAX_ID = 'TAX_ID'
}

/** An enumeration. */
export enum CoreCompanySettingsCrmLoginMethodChoices {
  /** bankid */
  BANKID = 'BANKID',
  /** email_otp */
  EMAIL_OTP = 'EMAIL_OTP',
  /** idporten */
  IDPORTEN = 'IDPORTEN',
  /** none */
  NONE = 'NONE',
  /** suomifi */
  SUOMIFI = 'SUOMIFI',
  /** user */
  USER = 'USER'
}

/** An enumeration. */
export enum CoreCompanySettingsCrmLoginMethodUserChoices {
  /** Post auth search */
  POST_AUTH_SEARCH = 'POST_AUTH_SEARCH',
  /** Pre auth search */
  PRE_AUTH_SEARCH = 'PRE_AUTH_SEARCH'
}

/** An enumeration. */
export enum CoreCompanySettingsFontFamilyChoices {
  /** Helvetica Neue */
  HELVETICA = 'HELVETICA',
  /** Roboto */
  ROBOTO = 'ROBOTO'
}

/** An enumeration. */
export enum CoreCompanySettingsMasterDataProviderChoices {
  /** KMD Cognito */
  COGNITO = 'COGNITO',
  /** LIFA OIS */
  LIFAOIS = 'LIFAOIS'
}

/** An enumeration. */
export enum CoreCompanySettingsSearchLocaleChoices {
  /** Danish */
  DA = 'DA',
  /** Greek */
  EL = 'EL',
  /** English */
  EN = 'EN',
  /** Finnish */
  FI = 'FI',
  /** Norwegian */
  NO = 'NO',
  /** Swedish */
  SV = 'SV'
}

/** An enumeration. */
export enum CoreCompanySettingsSmsProviderChoices {
  /** F24 ServiceAlert */
  F24 = 'F24',
  /** GatewayAPI */
  GATEWAYAPI = 'GATEWAYAPI',
  /** InMobile */
  INMOBILE = 'INMOBILE'
}

/** An enumeration. */
export enum CoreCompanySettingsSmsRevenueTypeChoices {
  /** Fixed */
  FIXED = 'FIXED',
  /** Percentage */
  PERCENTAGE = 'PERCENTAGE'
}

/** An enumeration. */
export enum CoreExportExportTypeChoices {
  /** Agreements */
  AGREEMENTS = 'AGREEMENTS',
  /** Agreement Available Dates */
  AGREEMENT_AVAILABLE_DATES = 'AGREEMENT_AVAILABLE_DATES',
  /** Containers */
  CONTAINERS = 'CONTAINERS',
  /** Container Available Dates */
  CONTAINER_AVAILABLE_DATES = 'CONTAINER_AVAILABLE_DATES',
  /** Fill Level Measurements */
  FILL_LEVEL_MEASUREMENTS = 'FILL_LEVEL_MEASUREMENTS',
  /** Hauler Prices */
  HAULER_PRICES = 'HAULER_PRICES',
  /** Hauler Settlement */
  HAULER_SETTLEMENT = 'HAULER_SETTLEMENT',
  /** Pick Up Orders */
  PICK_UP_ORDERS = 'PICK_UP_ORDERS',
  /** Products */
  PRODUCTS = 'PRODUCTS',
  /** Properties */
  PROPERTIES = 'PROPERTIES',
  /** Routes */
  ROUTES = 'ROUTES',
  /** Static Routes */
  STATIC_ROUTES = 'STATIC_ROUTES',
  /** Recorded Positions */
  STOP_POSITIONS = 'STOP_POSITIONS',
  /** Tickets */
  TICKETS = 'TICKETS',
  /** Truckload Contents */
  TRUCKLOAD_CONTENTS = 'TRUCKLOAD_CONTENTS',
  /** Unloading Events */
  UNLOADING_EVENTS = 'UNLOADING_EVENTS'
}

/** An enumeration. */
export enum CoreExportStatusChoices {
  /** Completed */
  COMPLETED = 'COMPLETED',
  /** Failed */
  FAILED = 'FAILED',
  /** In Progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** New */
  NEW = 'NEW'
}

/** An enumeration. */
export enum CoreIoUserBrokerTypeChoices {
  /** Zitadel */
  ZITADEL = 'ZITADEL'
}

/** An enumeration. */
export enum CoreIoUserDatetimeFormatLocaleChoices {
  /** Arabic */
  AR = 'AR',
  /** Danish */
  DA = 'DA',
  /** English (us) */
  EN = 'EN',
  /** English (uk) */
  EN_GB = 'EN_GB',
  /** Finnish */
  FI = 'FI',
  /** Norwegian */
  NB = 'NB',
  /** Swedish */
  SV = 'SV'
}

/** An enumeration. */
export enum CoreIoUserLanguageChoices {
  /** Arabic */
  AR = 'AR',
  /** Czech */
  CS = 'CS',
  /** Danish */
  DA = 'DA',
  /** German */
  DE = 'DE',
  /** Greek */
  EL = 'EL',
  /** English */
  EN = 'EN',
  /** Spanish */
  ES = 'ES',
  /** Finnish */
  FI = 'FI',
  /** French */
  FR = 'FR',
  /** Italian */
  IT = 'IT',
  /** Dutch */
  NL = 'NL',
  /** Norwegian */
  NO = 'NO',
  /** Polish */
  PL = 'PL',
  /** Portuguese */
  PT = 'PT',
  /** Romanian */
  RO = 'RO',
  /** Swedish */
  SV = 'SV'
}

/** An enumeration. */
export enum CoreIoUserProvisioningStatusChoices {
  /** Manual */
  A = 'A_',
  /** Deprovisioned */
  DEPROVISIONED = 'DEPROVISIONED',
  /** Provisioned */
  PROVISIONED = 'PROVISIONED'
}

/** An enumeration. */
export enum CoreIoUserThemePreferenceChoices {
  /** Dark */
  DARK = 'DARK',
  /** Light */
  LIGHT = 'LIGHT',
  /** System */
  SYSTEM = 'SYSTEM'
}

/** An enumeration. */
export enum CoreServiceResponsibilityLegalClassChoices {
  /** Private */
  PRIVATE = 'PRIVATE',
  /** Public */
  PUBLIC = 'PUBLIC'
}

/** An enumeration. */
export enum CoreUserAbsenceAbsenceTypeChoices {
  /** Holiday */
  HOLIDAY = 'HOLIDAY',
  /** Maternity */
  MATERNITY = 'MATERNITY',
  /** Other */
  OTHER = 'OTHER',
  /** Sick */
  SICK = 'SICK'
}

/** An enumeration. */
export enum CoreUserLayoutConfigAnalyticsCalculationTypeChoices {
  /** Custom period */
  CUSTOM_PERIOD = 'CUSTOM_PERIOD',
  /** Historical data */
  HISTORICAL_DATA = 'HISTORICAL_DATA',
  /** Previous period */
  PREVIOUS_PERIOD = 'PREVIOUS_PERIOD'
}

/** An enumeration. */
export enum CoreUserLayoutConfigAnalyticsHistoricalPeriodChoices {
  /** day */
  DAY = 'DAY',
  /** month */
  MONTH = 'MONTH',
  /** quarter */
  QUARTER = 'QUARTER',
  /** week */
  WEEK = 'WEEK',
  /** year */
  YEAR = 'YEAR'
}

/** An enumeration. */
export enum CoreUserLayoutConfigAnalyticsPreviousPeriodChoices {
  /** day */
  DAY = 'DAY',
  /** month */
  MONTH = 'MONTH',
  /** quarter */
  QUARTER = 'QUARTER',
  /** week */
  WEEK = 'WEEK',
  /** year */
  YEAR = 'YEAR'
}

/**
 * Correct a completed work task to undone and decide, in the same step,
 * whether it is handed to the service provider for rerouting (HSY req
 * 253). Office-only; the hand-over branch is a hauler-module surface.
 */
export type CorrectTaskToUndone = {
  __typename: 'CorrectTaskToUndone';
  correction?: Maybe<WorkTaskCorrectionType>;
  pickupOrder?: Maybe<PickUpOrderType>;
};

/**
 * Correct a load's data (HSY req 202, Annex 3.1 §8.4).
 *
 * Writes ONLY authored slots: the platform's derived values survive
 * untouched, so a later membership reset re-derives without destroying
 * the correction. Naming a field in ``clear`` clears that correction and
 * falls back to the derived value; an omitted field is left alone.
 *
 * A weighed-weight correction is also spread over the load's completed
 * member tasks (proportionally to what they weighed) so the work tasks
 * show the corrected figure too, with `manual` provenance.
 */
export type CorrectTruckload = {
  __typename: 'CorrectTruckload';
  truckload?: Maybe<TruckloadType>;
};

/**
 * Re-attribute one member emptying to the collection point it really
 * happened at (req 202's "and in the work tasks").
 *
 * WasteHero holds a task's collection point through its container, so
 * this repoints ``PickUpOrder.container``. **Billing-affecting**: shared
 * collection points (*kimppa*) carry billing modes, and Annex 3.1 §8.3's
 * note that a correction "will generate a new billing line" applies.
 */
export type CorrectTruckloadCollectionPoint = {
  __typename: 'CorrectTruckloadCollectionPoint';
  truckload?: Maybe<TruckloadType>;
};

export type CostModelDef = Node & {
  __typename: 'CostModelDef';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  disposalPerTon: Scalars['JSONString']['output'];
  fixedPerVehicleYear: Scalars['Decimal']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  perHour: Scalars['Decimal']['output'];
  perKm: Scalars['Decimal']['output'];
  perLift: Scalars['Decimal']['output'];
  planningAreas: PlanningAreaDefConnection;
  premiumWindows: Scalars['JSONString']['output'];
  project: ProjectType;
  regionPack?: Maybe<RouteStudioCostModelRegionPackChoices>;
  source: RouteStudioCostModelSourceChoices;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<UserType>;
};


export type CostModelDefPlanningAreasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CostModelDefConnection = {
  __typename: 'CostModelDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CostModelDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CostModelDef` and its cursor. */
export type CostModelDefEdge = {
  __typename: 'CostModelDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CostModelDef>;
};

export type CostOverviewType = {
  __typename: 'CostOverviewType';
  avgCollection?: Maybe<Scalars['Float']['output']>;
  avgDisposal?: Maybe<Scalars['Float']['output']>;
  avgIncome?: Maybe<Scalars['Float']['output']>;
  avgOverflowing?: Maybe<Scalars['Float']['output']>;
  containerType?: Maybe<ContainerTypeType>;
  totalCollection?: Maybe<Scalars['Float']['output']>;
  totalDisposal?: Maybe<Scalars['Float']['output']>;
  totalIncome?: Maybe<Scalars['Float']['output']>;
  totalOverflowing?: Maybe<Scalars['Float']['output']>;
  wasteFraction?: Maybe<WasteFractionType>;
};

export type CostSettingsType = Node & {
  __typename: 'CostSettingsType';
  amountOfCollection?: Maybe<Scalars['Int']['output']>;
  amountOfCollectionPeriod?: Maybe<AnalyticsCostSettingsAmountOfCollectionPeriodChoices>;
  averageFillLevel?: Maybe<Scalars['Decimal']['output']>;
  chanceOfOverflowing?: Maybe<Scalars['Decimal']['output']>;
  /** Cost per collection */
  collectionCost: Scalars['Float']['output'];
  comparisonsettings?: Maybe<ComparisonSettingsType>;
  containerLogs?: Maybe<ContainerLogTypeConnection>;
  containerType?: Maybe<ContainerTypeType>;
  containers?: Maybe<ContainerTypeConnection>;
  /** Cost per tonne */
  costPerTonne?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Income per collection */
  incomePerTonne?: Maybe<Scalars['Float']['output']>;
  /** Cost per overflowing collection */
  overflowingCost?: Maybe<Scalars['Float']['output']>;
  ownValues: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
  wasteFraction?: Maybe<WasteFractionType>;
  /** kg for m^3 */
  weightFactor: Scalars['Float']['output'];
};


export type CostSettingsTypeContainerLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CostSettingsTypeContainersArgs = {
  From?: InputMaybe<Scalars['DateTime']['input']>;
  To?: InputMaybe<Scalars['DateTime']['input']>;
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  allowedForRoute?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  area_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionCalendar_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  collectionCalendars?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerId?: InputMaybe<Scalars['String']['input']>;
  containerType_Name_Iexact?: InputMaybe<Scalars['String']['input']>;
  containerType_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  containerTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  device_IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCollectionCalendars?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRouteSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  measurement_FillPercentage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noProperty?: InputMaybe<Scalars['Boolean']['input']>;
  noRouteOnDay?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyNumber?: InputMaybe<Scalars['String']['input']>;
  propertyTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  q?: InputMaybe<Scalars['String']['input']>;
  rfid?: InputMaybe<Scalars['String']['input']>;
  routeIdsNotCompletedStops?: InputMaybe<Scalars['String']['input']>;
  routeScheme_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scpAttachable?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchContact?: InputMaybe<Scalars['String']['input']>;
  sensor_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  storedAtDepot?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  temporarilyRelocated?: InputMaybe<Scalars['Boolean']['input']>;
  vehicle_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFractionIds?: InputMaybe<Scalars['String']['input']>;
  wasteFraction_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  wasteFraction_WasteTypes_Name_Iexact?: InputMaybe<Scalars['String']['input']>;
  wasteFraction_WasteTypes_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wasteTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zone_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CostSettingsTypeConnection = {
  __typename: 'CostSettingsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CostSettingsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CostSettingsType` and its cursor. */
export type CostSettingsTypeEdge = {
  __typename: 'CostSettingsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CostSettingsType>;
};

/** One authority row of the company's council fee table. */
export type CouncilFeeTableEntryDef = Node & {
  __typename: 'CouncilFeeTableEntryDef';
  authorityName: Scalars['String']['output'];
  company: CompanyType;
  created: Scalars['DateTime']['output'];
  feeProduct?: Maybe<PpProductDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  leadTimeDays: Scalars['Int']['output'];
  modified: Scalars['DateTime']['output'];
  notes: Scalars['String']['output'];
  permits: PermitDefConnection;
  standardDurationDays?: Maybe<Scalars['Int']['output']>;
};


/** One authority row of the company's council fee table. */
export type CouncilFeeTableEntryDefPermitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CouncilFeeTableEntryDefConnection = {
  __typename: 'CouncilFeeTableEntryDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CouncilFeeTableEntryDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CouncilFeeTableEntryDef` and its cursor. */
export type CouncilFeeTableEntryDefEdge = {
  __typename: 'CouncilFeeTableEntryDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CouncilFeeTableEntryDef>;
};

/**
 * Office-only (PRO-465): book an append-only counter-entry that reverses
 * an approved/settled entry (opposite kind, same magnitude), instead of
 * editing it. The counter is a new DRAFT needing its own four-eyes
 * approval; it lands in the next open period by default.
 */
export type CounterContractorManualEntry = {
  __typename: 'CounterContractorManualEntry';
  entry?: Maybe<ContractorManualEntryType>;
};

/** One zone × fraction slice. */
export type CoverageCellDef = {
  __typename: 'CoverageCellDef';
  /** Stable id ("CA-0003"). */
  areaCode?: Maybe<Scalars['String']['output']>;
  /** Relay global id of the winning area. */
  areaId?: Maybe<Scalars['ID']['output']>;
  areaName?: Maybe<Scalars['String']['output']>;
  /** In-force areas claiming this cell; > 1 = overlapping awards (full conflict key: contractAreaConflicts, PRO-104). */
  claimCount: Scalars['Int']['output'];
  /** Contractor of the award. */
  haulerName?: Maybe<Scalars['String']['output']>;
  /** contracted | own_fleet | uncovered */
  state: Scalars['String']['output'];
  wasteFractionId: Scalars['Int']['output'];
};

/** One column of the matrix — a fraction of the company register. */
export type CoverageFractionDef = {
  __typename: 'CoverageFractionDef';
  /** WasteFraction pk. */
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** One row of the matrix. */
export type CoverageZoneDef = {
  __typename: 'CoverageZoneDef';
  cells: Array<CoverageCellDef>;
  coveredCount: Scalars['Int']['output'];
  ownFleetWholeZone: Scalars['Boolean']['output'];
  uncoveredCount: Scalars['Int']['output'];
  /** Raw zone ULID. */
  zoneId: Scalars['String']['output'];
  zoneName: Scalars['String']['output'];
};

export type CreateAgreementInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coefficient?: InputMaybe<Scalars['Float']['input']>;
  containerTypeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  pickupSettingId?: InputMaybe<Scalars['Int']['input']>;
  ppProduct?: InputMaybe<Scalars['ID']['input']>;
  product?: InputMaybe<Scalars['ID']['input']>;
  property: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  startDate: Scalars['Date']['input'];
  wasteFractionId?: InputMaybe<Scalars['Int']['input']>;
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CreateAgreementPayload = {
  __typename: 'CreateAgreementPayload';
  agreement?: Maybe<AgreementDef>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateArchivalRule = {
  __typename: 'CreateArchivalRule';
  archivalRule?: Maybe<ArchivalRuleDef>;
};

export type CreateAutomationPayload = {
  __typename: 'CreateAutomationPayload';
  automation: AutomationDef;
};

/**
 * Create a new, empty draft Flow (no version yet). The canvas UI's
 * first save is `UpdateAutopilotFlowDefinition`, which creates version 1.
 *
 * `sourceSuggestionId` (optional, Builder V2 item 1(i)) stamps the new
 * flow with the Pulse suggestion the drawer was opened from, into
 * `Flow.source_suggestion_id` -- a separate field, deliberately NOT the
 * `origin` convention (`legacy_rule:`/`playbook:`/`suggestion:` prefixes):
 * the FE builder relaxes its explicit-choice target guard for ANY
 * non-manual origin (`BuildAutomationDrawer`'s `groundedOrigin` -- "every
 * target value came from a real source"), which is true for the grounded
 * `CreateFlowFromSuggestion` path but false for an empty drawer draft that
 * was merely STARTED from a suggestion, so an origin stamp here would
 * reopen the unconfirmed-default laundering hole item 2 closed. The
 * linkage is what lets `AutopilotSuggestionType.draftFlow` render "Draft
 * started -- resume it" cross-session; the suggestion's lifecycle status
 * is deliberately untouched here (`acceptAutopilotSuggestion` stays the
 * explicit accept, called at activate/explicit-keep).
 *
 * A `sourceSuggestionId` that does not resolve within the caller's tenant
 * (nonexistent, or another tenant's -- indistinguishable by design) refuses
 * and creates nothing: silently minting an unlinked draft would make the
 * Pulse card lie about there being no draft.
 */
export type CreateAutopilotFlow = {
  __typename: 'CreateAutopilotFlow';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  flow?: Maybe<FlowType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * SBX-339 perturbation seeding: move an explicit cohort (live
 * container ids or selected stop ids) to another weekday.
 * Consequence-free draft (D18, D35).
 */
export type CreateBatchMoveScenarioMutation = {
  __typename: 'CreateBatchMoveScenarioMutation';
  scenario?: Maybe<ScenarioDef>;
};

export type CreateBillingRun = {
  __typename: 'CreateBillingRun';
  billingRun?: Maybe<BillingRunDef>;
};

/**
 * Office-only: create a bonus model in one of three scopes
 * (REQ 3.3.22/3.5.57, D7). Give ``areaId`` for a per-area model,
 * ``haulerId`` (no ``areaId``) for a per-contractor default, or neither
 * for a company-wide default. Settlement resolves most-specific-wins.
 *
 * Additive sibling of ``createBonusModel`` (which stays area-required for
 * non-breaking master compatibility): the frontend targets this variant for
 * the company/contractor/area scoping UI.
 */
export type CreateBonusModelScoped = {
  __typename: 'CreateBonusModelScoped';
  bonusModel?: Maybe<BonusModelType>;
};

export type CreateBulkWastePickupTicketInput = {
  /** If true, the user creating the ticket will be added to the followers */
  addToFollowers?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTeam?: InputMaybe<Scalars['ID']['input']>;
  assignee?: InputMaybe<Scalars['ID']['input']>;
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  container?: InputMaybe<Scalars['ID']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<TicketCustomFieldValueInput>>>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ignoreServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<InputMaybe<BulkWastePickupTicketItemInput>>;
  location?: InputMaybe<Scalars['ID']['input']>;
  overridePeriodStartInPast?: InputMaybe<Scalars['Boolean']['input']>;
  periodEndDate?: InputMaybe<Scalars['Date']['input']>;
  periodStartDate?: InputMaybe<Scalars['Date']['input']>;
  ppServiceOriginalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  ppServicePrice?: InputMaybe<Scalars['Decimal']['input']>;
  ppServiceProductId?: InputMaybe<Scalars['String']['input']>;
  preferredDate?: InputMaybe<Scalars['Date']['input']>;
  /** If true, do not create the ticket, but preview what it would look like if created - e.g. to get the prices. */
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  priority: Scalars['String']['input'];
  property?: InputMaybe<Scalars['ID']['input']>;
  reporter?: InputMaybe<Scalars['ID']['input']>;
  reporterDriver?: InputMaybe<Scalars['ID']['input']>;
  requestedBy?: InputMaybe<Scalars['ID']['input']>;
  requestedByOther?: InputMaybe<Scalars['String']['input']>;
  routeDescription?: InputMaybe<Scalars['String']['input']>;
  sendSummary?: InputMaybe<SendTicketSummaryInput>;
  serviceProducts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  serviceProvider?: InputMaybe<Scalars['ID']['input']>;
  ticketType: Scalars['ID']['input'];
};

export type CreateBulkWastePickupTicketPayload = {
  __typename: 'CreateBulkWastePickupTicketPayload';
  bulkWastePickupTicket?: Maybe<TicketDef>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/** Manual question entry (stage D): ask, never assume (D62). */
export type CreateCaseQuestionMutation = {
  __typename: 'CreateCaseQuestionMutation';
  caseQuestion?: Maybe<CaseQuestionDef>;
};

export type CreateCompanyEmailAccountMessageInput = {
  addAttachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyEmailAccount: Scalars['ID']['input'];
  threadId?: InputMaybe<Scalars['String']['input']>;
  threadStarter?: InputMaybe<Scalars['ID']['input']>;
  toEmail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyEmailAccountMessagePayload = {
  __typename: 'CreateCompanyEmailAccountMessagePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companyEmailAccountMessage?: Maybe<CompanyEmailAccountMessageDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateComparisonSettingsMutationInput = {
  amountOfCollection?: InputMaybe<Scalars['Int']['input']>;
  amountOfCollectionPeriod?: InputMaybe<Scalars['String']['input']>;
  averageFillLevel?: InputMaybe<Scalars['Float']['input']>;
  chanceOfOverflowing?: InputMaybe<Scalars['Float']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cost per collection */
  collectionCost: Scalars['Float']['input'];
  /** Cost per tonne */
  costPerTonne?: InputMaybe<Scalars['Float']['input']>;
  costSettings: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Income per collection */
  incomePerTonne?: InputMaybe<Scalars['Float']['input']>;
  /** Cost per overflowing collection */
  overflowingCost?: InputMaybe<Scalars['Float']['input']>;
  /** kg for m^3 */
  weightFactor?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateComparisonSettingsMutationPayload = {
  __typename: 'CreateComparisonSettingsMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  comparisonSettings?: Maybe<ComparisonSettingsType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/**
 * Admin: add a company-defined condition type to the structured
 * condition library (PRO-391, 3.12.28).
 */
export type CreateConditionType = {
  __typename: 'CreateConditionType';
  conditionType?: Maybe<ConditionTypeType>;
};

export type CreateContact = {
  __typename: 'CreateContact';
  contact?: Maybe<ContactDef>;
  contactProperty?: Maybe<ContactPropertyDef>;
};

export type CreateContactAddress = {
  __typename: 'CreateContactAddress';
  address?: Maybe<ContactAddressDef>;
};

export type CreateContactAuthorizationInput = {
  authorizationMethod?: InputMaybe<Scalars['ID']['input']>;
  authorizationReference?: InputMaybe<Scalars['String']['input']>;
  authorizationType?: InputMaybe<Scalars['ID']['input']>;
  authorizedContact: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  mandateDocument?: InputMaybe<Scalars['String']['input']>;
  principalContact: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateContactAuthorizationPayload = {
  __typename: 'CreateContactAuthorizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contactAuthorization?: Maybe<ContactAuthorizationDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateContactInput = {
  additionalServicesSalesBan?: InputMaybe<Scalars['Boolean']['input']>;
  additionalServicesSalesBanReason?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addresses?: InputMaybe<Array<InputMaybe<ContactAddressInput>>>;
  authorityFeeDecision?: InputMaybe<Scalars['String']['input']>;
  authorityFeeDecisionDate?: InputMaybe<Scalars['Date']['input']>;
  bundling?: InputMaybe<Scalars['String']['input']>;
  coName?: InputMaybe<Scalars['String']['input']>;
  contactType: ContactType;
  country?: InputMaybe<Scalars['String']['input']>;
  customerFunctionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  debtorNumber?: InputMaybe<Scalars['String']['input']>;
  defaultBillingFrequencyCode?: InputMaybe<Scalars['String']['input']>;
  defaultServiceResponsibilityId?: InputMaybe<Scalars['ID']['input']>;
  einvoiceAddress?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  externalContactId?: InputMaybe<Scalars['String']['input']>;
  industryCode?: InputMaybe<Scalars['String']['input']>;
  industrySpecify?: InputMaybe<Scalars['String']['input']>;
  invoiceDeliveryMethod?: InputMaybe<Scalars['String']['input']>;
  invoiceLanguage?: InputMaybe<Scalars['String']['input']>;
  invoiceReference?: InputMaybe<Scalars['String']['input']>;
  invoiceTemplateCode?: InputMaybe<Scalars['String']['input']>;
  issuingCountry?: InputMaybe<Scalars['String']['input']>;
  marketingOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeName?: InputMaybe<Scalars['String']['input']>;
  pricingMode?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  reverseChargeVat?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<ContactRole>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateContainer = {
  __typename: 'CreateContainer';
  container?: Maybe<ContainerType>;
};

export type CreateContainerImport = {
  __typename: 'CreateContainerImport';
  containerImport?: Maybe<ContainerImportType>;
};

export type CreateContainerMobile = {
  __typename: 'CreateContainerMobile';
  container?: Maybe<ContainerType>;
};

export type CreateContainerPriceInput = {
  amount: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  containerType: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  invoiceName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pickupSetting: Scalars['ID']['input'];
  propertyType: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  wasteFraction: Scalars['ID']['input'];
};

export type CreateContainerPricePayload = {
  __typename: 'CreateContainerPricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  containerPrice?: Maybe<ContainerPriceDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateContainerType = {
  __typename: 'CreateContainerType';
  containerType?: Maybe<ContainerTypeType>;
};

export type CreateContainerWeightImport = {
  __typename: 'CreateContainerWeightImport';
  containerWeightImport?: Maybe<ContainerWeightImportType>;
};

/**
 * Office-only, four-eyes (PRO-465): book a DRAFT manual contractor
 * credit/receivable entry. Requires the compensation-manage permission (the
 * office + hauler-module gate); a SECOND permission holder must approve it
 * (``approveContractorManualEntry``) before it affects any settlement
 * figure. A draft is visible but excluded from settlement totals.
 *
 * ``amountCents`` is a POSITIVE magnitude — the sign of the settlement
 * effect comes from ``entryType`` (deduction subtracts, credit adds). Omit
 * ``areaId`` for a contractor-level entry; omit the target period to default
 * to the next open period.
 */
export type CreateContractorManualEntry = {
  __typename: 'CreateContractorManualEntry';
  entry?: Maybe<ContractorManualEntryType>;
};

/**
 * Create a tenant cost model, optionally seeded from a regional
 * default set (RS-205, D10). Explicit values win over defaults.
 *
 * SBX-362 (D32/D45): master-gated (rates are money truth for every
 * plan and baseline of the tenant). A row created purely from
 * defaults is labeled ``engineering_default``; explicit rate values
 * label it ``tenant_set`` with updated_by/updated_at recorded, and
 * the write is audited via route_studio.cost_model.updated.
 */
export type CreateCostModelMutation = {
  __typename: 'CreateCostModelMutation';
  costModel?: Maybe<CostModelDef>;
};

export type CreateCostSettingsMutationInput = {
  amountOfCollection?: InputMaybe<Scalars['Int']['input']>;
  amountOfCollectionPeriod?: InputMaybe<Scalars['String']['input']>;
  averageFillLevel?: InputMaybe<Scalars['Float']['input']>;
  chanceOfOverflowing?: InputMaybe<Scalars['Float']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cost per collection */
  collectionCost: Scalars['Float']['input'];
  containerType: Scalars['ID']['input'];
  /** Cost per tonne */
  costPerTonne?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Income per collection */
  incomePerTonne?: InputMaybe<Scalars['Float']['input']>;
  /** Cost per overflowing collection */
  overflowingCost?: InputMaybe<Scalars['Float']['input']>;
  ownValues?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
  wasteFraction: Scalars['ID']['input'];
  /** kg for m^3 */
  weightFactor?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateCostSettingsMutationPayload = {
  __typename: 'CreateCostSettingsMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  costSettings?: Maybe<CostSettingsType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateCustomerNoteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contact: Scalars['ID']['input'];
  /** The note content */
  content: Scalars['String']['input'];
  /** End of visibility period (required for scheduled notes) */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Permanent (always visible) or scheduled (visible during date range) */
  noteType: Scalars['String']['input'];
  /** Start of visibility period (required for scheduled notes) */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  visibilityLevels: Array<InputMaybe<Scalars['String']['input']>>;
};

export type CreateCustomerNotePayload = {
  __typename: 'CreateCustomerNotePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerNote?: Maybe<CustomerNoteDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/**
 * SBX-339 perturbation seeding: "what if everything moves off
 * Monday". Seeds a normal draft scenario FROM live platform objects
 * (container calendars are the cohort truth); consequence-free
 * (D18), so no master role is required, and nothing runs until a
 * human runs it (D35).
 */
export type CreateDayMoveScenarioMutation = {
  __typename: 'CreateDayMoveScenarioMutation';
  scenario?: Maybe<ScenarioDef>;
};

export type CreateDriverPushNotificationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isSilent?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  notificationType: PushNotificationTypes;
  route: Scalars['ID']['input'];
  stops: Array<InputMaybe<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
};

export type CreateDriverPushNotificationPayload = {
  __typename: 'CreateDriverPushNotificationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  driverPushNotification?: Maybe<DriverPushNotificationType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateExport = {
  __typename: 'CreateExport';
  export?: Maybe<ExportType>;
};

export type CreateFillLevelDeviceMobile = {
  __typename: 'CreateFillLevelDeviceMobile';
  fillLevelDevice?: Maybe<BaseDeviceInterface>;
};

/**
 * SBX-339 perturbation seeding: add or remove trucks against the
 * LIVE fleet (fleet_management project vehicles). Consequence-free
 * draft (D18, D35).
 */
export type CreateFleetChangeScenarioMutation = {
  __typename: 'CreateFleetChangeScenarioMutation';
  scenario?: Maybe<ScenarioDef>;
};

/**
 * AP-601c: create a new draft Flow + its version 1 from one
 * `AutopilotSuggestion`, grounded in the tenant's own real per-type
 * automation (`autopilot.services.suggestion_grounded_draft.
 * build_grounded_draft_for_suggestion` -- see that module's docstring for
 * the resolution order and why it is never Gateway-composed).
 *
 * Same "build -> validate -> create draft -> commit version 1" path
 * `InstantiateAutopilotPlaybook` uses: the definition is re-derived here
 * (never trusting a client-echoed one -- the same discipline
 * `ConfirmConvertLegacyRuleToFlow` applies to legacy rules) and run
 * through the same registry-aware `validate_for_builder` before anything
 * is written, so an invalid draft (a stale suggestion whose ticket type
 * was since renamed or deleted, say) creates no `Flow` row at all.
 * `hasRules=False` on the underlying draft is not itself an error: it
 * still produces a valid placeholder flow, per that module's own
 * "always something to commit" contract; `warnings` says why.
 *
 * Deny-by-default and tenant-scoped like every sibling mutation here: a
 * disabled tenant, or a suggestion that does not exist / belongs to
 * another tenant, both refuse with an honest error and write nothing.
 */
export type CreateFlowFromSuggestion = {
  __typename: 'CreateFlowFromSuggestion';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  flow?: Maybe<FlowType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Claims-ledger CRUD (RS-E20; the decode engine that generates
 * claims is RS-E22). Evidence citations reference case storage,
 * never committed artifacts.
 */
export type CreateGrammarClaimMutation = {
  __typename: 'CreateGrammarClaimMutation';
  grammarClaim?: Maybe<GrammarClaimDef>;
};

/** Office-only: add a compliance document to a contractor (PRO-99). */
export type CreateHaulerComplianceDocument = {
  __typename: 'CreateHaulerComplianceDocument';
  document?: Maybe<HaulerComplianceDocumentDef>;
};

/** Office-only: add a compliance-document type (PRO-99 / 3.12.28). */
export type CreateHaulerComplianceDocumentType = {
  __typename: 'CreateHaulerComplianceDocumentType';
  documentType?: Maybe<HaulerComplianceDocumentTypeDef>;
};

/** Create a draft hauler order with N service lines (HAUL-401/424). */
export type CreateHaulerOrder = {
  __typename: 'CreateHaulerOrder';
  order?: Maybe<HaulerOrderDef>;
};

/**
 * Create a price list (RD-46). Wraps
 * ``product.price_lists.service.create_price_list`` for name/description
 * (reusing its status state machine). The hauler LAYER's additive plain
 * fields the product service does not write — status, the validity window
 * (validFrom/validTo), inheritance (parentId) and minimumCharge (HAUL-
 * 202/209) — are set as a company-scoped plain-data patch afterward. No
 * currency input: the model carries no currency column (the G2 valuta-gap
 * decision); one tenant, one currency, resolved elsewhere.
 */
export type CreateHaulerPriceList = {
  __typename: 'CreateHaulerPriceList';
  priceList?: Maybe<HaulerPriceListDef>;
};

/**
 * Add a price row to one of the tenant's price lists (RD-46).
 *
 * Wraps ``product.price_rows.service.create_price_row`` — the ONE engine
 * validates the product/zone/tuple uniqueness/VAT rules; this seam adds
 * no calculation. ``unitPrice`` is stored verbatim. ``minimumCharge``
 * (HAUL-209) is the additive per-row floor the product service does not
 * itself write, set as a plain-data patch after the row persists.
 */
export type CreateHaulerPriceRow = {
  __typename: 'CreateHaulerPriceRow';
  priceRow?: Maybe<HaulerPriceRowDef>;
};

/**
 * Upload and parse a stop-list file (RS-101, RS-1601). CSV and
 * XLSX take the deterministic parser; PDF, PNG and JPG documents
 * take the vision extraction seam (D38: same pipeline, same human
 * confirm downstream).
 */
export type CreateImportBatchMutation = {
  __typename: 'CreateImportBatchMutation';
  importBatch?: Maybe<ImportBatchDef>;
};

/**
 * Open an onboarding case (RS-E20, blueprint stage A): the
 * long-lived container files upload into across sessions (D62).
 * ``useCase`` answers the orienting question in the same act
 * (SBX-521: case creation asks "What are you bringing in?" instead
 * of opening blank); omitted, the case serves the question on its
 * purpose payload until one is declared.
 */
export type CreateImportCaseMutation = {
  __typename: 'CreateImportCaseMutation';
  importCase?: Maybe<ImportCaseDef>;
};

/**
 * RS-E28 (D61): open the SAME F10 gated flow for a VALIDATED
 * import case. The payload is the case's newest materialization
 * plus its per-fraction service bindings; every downstream gate is
 * the existing promotion machinery in the existing order (diff,
 * comms gate, approval, schedule, execute, one-action rollback,
 * D18/D09). ``fractionMap`` is the human-confirmed mapping from the
 * client's own fraction codes to this project's waste fractions
 * (id or exact name); it must cover every active binding code,
 * never guessed (D62). Refuses while the case is not validated on
 * its newest version (the client sentence 'yes, this is my routes'
 * comes first, D61).
 */
export type CreateImportPromotionMutation = {
  __typename: 'CreateImportPromotionMutation';
  promotion?: Maybe<PromotionDef>;
};

/**
 * W8.3: compile an NL prompt into an inspectable rule. The result
 * is PENDING — the echoed rule must be confirmed before anything can
 * fire (Behavior 7's confirmation gate).
 */
export type CreateInsightsAlert = {
  __typename: 'CreateInsightsAlert';
  alert?: Maybe<Scalars['GenericScalar']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/**
 * Admin: add a company-defined key type to the catalogue (PRO-367).
 *
 * Mirrors ``device.CreatePartType``, gated like every key write
 * (module ON + ``Manage keys``). A chargeable type must carry its fee
 * product — that link is the entry point into the standard billing
 * chain, so ``billable`` without ``linked_product_id`` is rejected.
 */
export type CreateKeyType = {
  __typename: 'CreateKeyType';
  keyType?: Maybe<KeyTypeType>;
};

export type CreateManageContainerTicketInput = {
  /** If true, the user creating the ticket will be added to the followers */
  addToFollowers?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTeam?: InputMaybe<Scalars['ID']['input']>;
  assignee?: InputMaybe<Scalars['ID']['input']>;
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  collectionCalendar?: InputMaybe<Scalars['ID']['input']>;
  company: Scalars['ID']['input'];
  /** The ordering customer (ContactDef id, same company). The property gets a PAYER link for this contact when it has no payer yet, and payerContactId defaults to it. */
  contactId?: InputMaybe<Scalars['ID']['input']>;
  container?: InputMaybe<Scalars['ID']['input']>;
  containerDestination?: InputMaybe<ContainerStorageLocationInput>;
  containerNotifications?: InputMaybe<Array<InputMaybe<ContainerNotificationsInput>>>;
  containerProduct?: InputMaybe<Scalars['ID']['input']>;
  containerSource?: InputMaybe<ContainerStorageLocationInput>;
  containerToAdd?: InputMaybe<Scalars['ID']['input']>;
  containerType?: InputMaybe<Scalars['ID']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<TicketCustomFieldValueInput>>>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ignoreServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  /** The ordering management company (PropertyManagementCompanyDef id, same company) - the Company cockpit's alternative to contactId. The property gets a management-company PAYER link when it has no payer yet; payerContact stays null so the management-company payer chain bills the order. */
  managementCompanyId?: InputMaybe<Scalars['ID']['input']>;
  newContainerId?: InputMaybe<Scalars['String']['input']>;
  /** The customer's address when they have no registered property yet; requires contactId or managementCompanyId. An existing property of the company at the same address is reused. On a Relocate ticket type (RELOCATE_RENTAL) it is instead the address the rented skip moves TO (the alternative to targetPropertyId). */
  newPropertyAddress?: InputMaybe<NewPropertyAddressInput>;
  onPublicRoad?: InputMaybe<Scalars['Boolean']['input']>;
  originalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  overridePeriodStartInPast?: InputMaybe<Scalars['Boolean']['input']>;
  payerContactId?: InputMaybe<Scalars['ID']['input']>;
  periodEndDate?: InputMaybe<Scalars['Date']['input']>;
  periodStartDate?: InputMaybe<Scalars['Date']['input']>;
  pickupSetting?: InputMaybe<Scalars['ID']['input']>;
  ppContainerProductId?: InputMaybe<Scalars['String']['input']>;
  ppOriginalWeight?: InputMaybe<Scalars['Decimal']['input']>;
  ppServiceOriginalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  ppServicePrice?: InputMaybe<Scalars['Decimal']['input']>;
  ppServiceProductId?: InputMaybe<Scalars['String']['input']>;
  ppWeight?: InputMaybe<Scalars['Decimal']['input']>;
  ppWeightOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  preferredDate?: InputMaybe<Scalars['Date']['input']>;
  /** If true, do not create the ticket, but preview what it would look like if created - e.g. to get the prices. */
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priority: Scalars['String']['input'];
  /** The property the ticket serves. May be omitted when contactId and newPropertyAddress are sent (the property is then found or created from the address). */
  property?: InputMaybe<Scalars['ID']['input']>;
  /** RENT_STOCK: number of identical units to book over the order period (default 1). Must equal len(units) when both are given. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reporter?: InputMaybe<Scalars['ID']['input']>;
  reporterDriver?: InputMaybe<Scalars['ID']['input']>;
  requestedBy?: InputMaybe<Scalars['ID']['input']>;
  /** The customer's contact person who asked for this ticket (ContactDef id, same company). Shown to the driver as name and phone ahead of requestedByOther. */
  requestedByContactId?: InputMaybe<Scalars['ID']['input']>;
  requestedByOther?: InputMaybe<Scalars['String']['input']>;
  routeDescription?: InputMaybe<Scalars['String']['input']>;
  routeScheme?: InputMaybe<Scalars['ID']['input']>;
  sendSummary?: InputMaybe<SendTicketSummaryInput>;
  serviceProducts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  serviceProvider?: InputMaybe<Scalars['ID']['input']>;
  /** RELOCATE_RENTAL only: the NEW address the rented skip moves to (found or created like a customer-first booking, createdProperty on the payload) - the alternative to targetPropertyId; the name FE-P2-9 sends alongside the skip's current `property`. Same meaning as newPropertyAddress on a Relocate type. */
  targetNewPropertyAddress?: InputMaybe<NewPropertyAddressInput>;
  /** RELOCATE_RENTAL only: the property the rented skip (container) moves to - exactly one of targetPropertyId and newPropertyAddress. The ticket itself stays on the skip's current property; one MOVE route leg is raised and the hire follows the skip when the ticket completes. */
  targetPropertyId?: InputMaybe<Scalars['ID']['input']>;
  ticketType: Scalars['ID']['input'];
  /** RENT_STOCK: one entry per rented unit with its own periodStartDate / periodEndDate (each defaults to the order's). One unit ticket is booked per entry. */
  units?: InputMaybe<Array<RentalUnitInput>>;
  wasteFraction?: InputMaybe<Scalars['ID']['input']>;
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CreateManageContainerTicketPayload = {
  __typename: 'CreateManageContainerTicketPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The property created from newPropertyAddress for this ticket (customer-first booking). Null when the ticket serves an existing property. */
  createdProperty?: Maybe<PropertyDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  manageContainerTicket?: Maybe<TicketDef>;
  /** Every rental unit ticket booked by this create (RENT_STOCK only; the first is manageContainerTicket). Every unit carries the form fields; attachments and the summary are finalised onto the first unit only. Null otherwise. */
  rentalUnitTickets?: Maybe<Array<TicketDef>>;
};

export type CreateMeasurementSettings = {
  __typename: 'CreateMeasurementSettings';
  measurementSettings?: Maybe<MeasurementSettingsType>;
};

export type CreateMobileDevice = {
  __typename: 'CreateMobileDevice';
  device?: Maybe<MobileDeviceType>;
};

export type CreateNotificationSetting = {
  __typename: 'CreateNotificationSetting';
  notificationSetting?: Maybe<NotificationSettingsType>;
};

/**
 * Create or update a declared emptying location of an SCP (NEXUS-538).
 *
 * ``id`` present → update; absent → create (``property_group_id`` required).
 * The point is mandatory on the model, so latitude+longitude are required on
 * create. Blocked on a terminated SCP.
 */
export type CreateOrUpdateCollectionLocation = {
  __typename: 'CreateOrUpdateCollectionLocation';
  collectionLocation?: Maybe<CollectionLocationDef>;
};

export type CreateOrUpdateExportTemplate = {
  __typename: 'CreateOrUpdateExportTemplate';
  exportTemplate?: Maybe<ExportTemplateDef>;
};

/**
 * Record or edit an authority decision on a property (NEXUS-704).
 *
 * The operator RECORDS the jätehuoltoviranomainen's decision (keskeytys /
 * pidennys / käyttöoikeus) — reference, validity, note — it is never
 * granted here. Create requires ``propertyId``, ``kind`` and ``validFrom``;
 * update patches only the provided fields (``clearValidTo`` empties the
 * end, a null variable being indistinguishable from an omitted one). A
 * KESKEYTYS must be bounded, at most 4 years.
 */
export type CreateOrUpdatePropertyWasteDecision = {
  __typename: 'CreateOrUpdatePropertyWasteDecision';
  wasteDecision?: Maybe<PropertyWasteDecisionDef>;
};

/**
 * Create a custom SCP role, or rename/re-describe an existing one.
 *
 * System roles cannot be created here, nor renamed/re-keyed; only their
 * ``description`` may be edited. Custom roles are immediately assignable
 * (NEXUS-544).
 */
export type CreateOrUpdateScpRoleDefinition = {
  __typename: 'CreateOrUpdateScpRoleDefinition';
  scpRoleDefinition?: Maybe<ScpRoleDefinitionDef>;
};

export type CreateOrUpdateStopListCardConfig = {
  __typename: 'CreateOrUpdateStopListCardConfig';
  stopListCardConfig?: Maybe<StopListCardConfigType>;
};

/** Admin: add a company-defined part type to the picker library. */
export type CreatePartType = {
  __typename: 'CreatePartType';
  partType?: Maybe<PartTypeType>;
};

/**
 * Record a council permit for a placement: on a property (applied
 * for ahead of the booking) and/or on the rental unit ticket it covers.
 * ``status: GRANTED`` grants it in the same call.
 */
export type CreatePermit = {
  __typename: 'CreatePermit';
  permit?: Maybe<PermitDef>;
};

export type CreatePlanningAreaMutation = {
  __typename: 'CreatePlanningAreaMutation';
  planningArea?: Maybe<PlanningAreaDef>;
};

export type CreatePriceInput = {
  amount: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  product: Scalars['ID']['input'];
  recurringInterval: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
  weightAmount: Scalars['Int']['input'];
};

export type CreatePricePayload = {
  __typename: 'CreatePricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  price?: Maybe<PriceDef>;
};

/**
 * Open the F10 door for a plan (D18). ``hauler_proposal`` is a
 * defined channel but raises until the hauler module ships
 * (ADR-0002).
 */
export type CreatePromotionMutation = {
  __typename: 'CreatePromotionMutation';
  promotion?: Maybe<PromotionDef>;
};

export type CreatePropertyActionDef = Node & {
  __typename: 'CreatePropertyActionDef';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  rule: AutopilotLegacyRuleType;
};

export type CreatePropertyActionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePropertyManagementCompanyAddress = {
  __typename: 'CreatePropertyManagementCompanyAddress';
  address?: Maybe<PropertyManagementCompanyAddressDef>;
};

export type CreatePropertyNoteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The note content */
  content: Scalars['String']['input'];
  /** End of visibility period (required for scheduled notes) */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Permanent (always visible) or scheduled (visible during date range) */
  noteType: Scalars['String']['input'];
  property: Scalars['ID']['input'];
  /** Start of visibility period (required for scheduled notes) */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  visibilityLevels: Array<InputMaybe<Scalars['String']['input']>>;
};

export type CreatePropertyNotePayload = {
  __typename: 'CreatePropertyNotePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  propertyNote?: Maybe<PropertyNoteDef>;
};

/** Order stock from a supplier for one warehouse. */
export type CreatePurchaseOrder = {
  __typename: 'CreatePurchaseOrder';
  purchaseOrder?: Maybe<PurchaseOrderType>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CreateRecurringPriceInput = {
  amount: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  invoiceName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  propertyType?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
};

export type CreateRecurringPricePayload = {
  __typename: 'CreateRecurringPricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  recurringPrice?: Maybe<RecurringPriceDef>;
};

/**
 * Office-only, audited: create a period-scoped reliability exclusion
 * window (HSY 263). Scope is allAreas OR ≥ 1 areaIds; reason mandatory;
 * refused when the coverage touches a CLOSED settlement period.
 */
export type CreateReliabilityExclusionWindow = {
  __typename: 'CreateReliabilityExclusionWindow';
  window?: Maybe<ReliabilityExclusionWindowType>;
};

/**
 * Book ``quantity`` units of an item type over ``[startDate, endDate]``
 * (PRO-271). A null ``endDate`` is a SALE - a permanent issue with no
 * return leg. PRO-383 (spec decision C9): the dispatch warehouse is NOT a
 * user input - it is auto-selected (the container-storage warehouse with
 * the most projected availability across the window, nearest to the
 * served property on a tie). The booking hard-refuses (a clean error) if
 * the peak concurrent commitment over the window would exceed the chosen
 * pool, evaluated STRICT under the per-pool advisory lock
 * (``inventory.services.rental.create_rental``); on success it fans out
 * to ``quantity`` individual quantity-1 tickets, each returned as a relay
 * ticket id. ``propertyId`` is REQUIRED (PRODUCT-431): RENT_STOCK is
 * property-level (PRODUCT-430), so every unit is booked FOR the customer
 * property it serves - there is no property-less pool rental any more -
 * and the property steers the nearest-warehouse tie-break. An
 * optional ``payerContactId`` (PRODUCT-436) names the customer who pays
 * for the rental when that is not the property's payer-role chain; it is
 * stamped on every unit as ``Ticket.payer_contact``.
 *
 * PRODUCT-439 (BE-B4, customer-first booking): ``propertyId`` OR
 * (exactly one of ``contactId`` / ``managementCompanyId`` AND
 * ``newPropertyAddress``) is required - the same trio
 * ``createManageContainerTicket`` takes. With a contact the property
 * (existing or created from the address, an existing property of the
 * company at the same address reused) gets a PAYER link for the customer
 * when it has none, ``payerContactId`` defaults to the contact, and
 * ``createdProperty`` names the property this call created (null when an
 * existing one was used). With a management company (the Company
 * cockpit - a ``PropertyManagementCompany`` has no contact) the property
 * gets a ``ManagementCompanyProperty`` PAYER link when it has no payer
 * and ``payerContactId`` stays null, so the management-company payer
 * chain bills. Property, role link and booking share one transaction: a
 * refused booking leaves no property behind.
 */
export type CreateRental = {
  __typename: 'CreateRental';
  /** The property created from newPropertyAddress for this rental (customer-first booking). Null when an existing property was used. */
  createdProperty?: Maybe<PropertyDef>;
  status?: Maybe<Scalars['String']['output']>;
  ticketIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type CreateRouteMutation = {
  __typename: 'CreateRouteMutation';
  route?: Maybe<RouteType>;
};

/**
 * Create a scenario from a template (RS-202, PRD F5). Template
 * prefills seed the config; explicit arguments win.
 */
export type CreateScenarioMutation = {
  __typename: 'CreateScenarioMutation';
  scenario?: Maybe<ScenarioDef>;
};

export type CreateScheduledExportRun = {
  __typename: 'CreateScheduledExportRun';
  scheduledExportRun?: Maybe<ScheduledExportRunDef>;
};

/**
 * W12.3: schedule a governed bulk extract. Destination is a
 * signed URL by default; SFTP config is opaque JSON.
 */
export type CreateScheduledExtract = {
  __typename: 'CreateScheduledExtract';
  error?: Maybe<Scalars['String']['output']>;
  extract?: Maybe<Scalars['GenericScalar']['output']>;
};

/**
 * Add a management company as an SCP member (phase 2, feature 7).
 *
 * Company members share the sum-to-100 pool with property members: the pool
 * is re-balanced proportionally to make room for the newcomer's share.
 * They carry no roles and no property-specific attributes.
 */
export type CreateScpCompanyMembership = {
  __typename: 'CreateScpCompanyMembership';
  scpCompanyMembership?: Maybe<ScpCompanyMembershipDef>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/**
 * Add a property to an SCP (a PropertyGroup) with an initial share.
 *
 * The pool is re-balanced to sum to 100.00 in the same transaction: the
 * pre-existing members are scaled down proportionally to make room for the
 * newcomer's share, or the caller supplies ``shares`` — an explicit vector
 * for the EXISTING members (the newcomer's share comes from ``share``) — and
 * the combined vector must sum to 100.00. The first member keeps whatever
 * share it was created with (the FE sends 100.00).
 */
export type CreateScpMembership = {
  __typename: 'CreateScpMembership';
  memberships?: Maybe<Array<Maybe<ScpMembershipDef>>>;
  scpMembership?: Maybe<ScpMembershipDef>;
  seasonalConflict?: Maybe<Scalars['Boolean']['output']>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CreateSensor = {
  __typename: 'CreateSensor';
  fillLevelDevice?: Maybe<BaseDeviceInterface>;
};

export type CreateServicePriceInput = {
  amount: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  containerType?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['Date']['input'];
  invoiceName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  propertyType?: InputMaybe<Scalars['ID']['input']>;
  service: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  wasteFraction?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateServicePricePayload = {
  __typename: 'CreateServicePricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  servicePrice?: Maybe<ServicePriceDef>;
};

export type CreateSparePart = {
  __typename: 'CreateSparePart';
  sparePart?: Maybe<SparePartType>;
};

/**
 * Build a StopSet from live entities or a drawn boundary
 * (RS-103, D04). Project-scoped; contract-area semantics arrive
 * with the hauler module, not here (ADR-0002).
 */
export type CreateStopSetFromEntitiesMutation = {
  __typename: 'CreateStopSetFromEntitiesMutation';
  stopSet?: Maybe<StopSetDef>;
};

/**
 * SBX-336: the map polygon selection's backend half. Keep or
 * exclude a selection of stops into a NEW immutable stop set in the
 * same project; the source set is never modified (stop sets are
 * immutable snapshots), and service units are regenerated for the
 * new set, never copied.
 */
export type CreateStopSetSubsetMutation = {
  __typename: 'CreateStopSetSubsetMutation';
  stopSet?: Maybe<StopSetDef>;
};

/**
 * Request a temporary location change for a waste bin (REQ-315 kelirikko).
 *
 * Creates a TEMPORARY_CONTAINER_CHANGE ticket (container-level only, PRO-385
 * - no property/customer re-entry) plus a scheduled location change bound to
 * it. The window is the ticket's generic Include period (``periodStartDate``
 * / ``periodEndDate``, the ONE mechanism PRO-379 introduced), not a
 * bespoke pair of args. The change is NOT applied immediately: it is
 * scheduled for its window and the celery sweep applies it once
 * ``periodStartDate`` arrives and reverts it once ``periodEndDate`` has
 * passed. Cancelling the ticket stops it.
 */
export type CreateTemporaryContainerLocation = {
  __typename: 'CreateTemporaryContainerLocation';
  container?: Maybe<ContainerType>;
  temporaryLocationOverride?: Maybe<TemporaryContainerLocationType>;
};

export type CreateTicketActionAttachmentDef = Node & {
  __typename: 'CreateTicketActionAttachmentDef';
  action: CreateTicketActionDef;
  file: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
};

export type CreateTicketActionAttachmentDefConnection = {
  __typename: 'CreateTicketActionAttachmentDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CreateTicketActionAttachmentDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CreateTicketActionAttachmentDef` and its cursor. */
export type CreateTicketActionAttachmentDefEdge = {
  __typename: 'CreateTicketActionAttachmentDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CreateTicketActionAttachmentDef>;
};

export type CreateTicketActionDef = Node & {
  __typename: 'CreateTicketActionDef';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  newTicketAttachments: CreateTicketActionAttachmentDefConnection;
  newTicketDescription: Scalars['String']['output'];
  newTicketPriority: TicketCreateTicketActionNewTicketPriorityChoices;
  newTicketTicketType: TicketTypeDef;
  order: Scalars['Int']['output'];
  rule: AutopilotLegacyRuleType;
};


export type CreateTicketActionDefNewTicketAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTicketActionDefConnection = {
  __typename: 'CreateTicketActionDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CreateTicketActionDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CreateTicketActionDef` and its cursor. */
export type CreateTicketActionDefEdge = {
  __typename: 'CreateTicketActionDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CreateTicketActionDef>;
};

export type CreateTicketActionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newTicketAttachments?: InputMaybe<Array<Scalars['String']['input']>>;
  newTicketDescription?: InputMaybe<Scalars['String']['input']>;
  newTicketPriority: Scalars['String']['input'];
  newTicketTicketType: Scalars['ID']['input'];
};

export type CreateTicketCommentInput = {
  addAttachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional client-generated idempotency key (a UUID). A later call with the same key from the same user returns the entity the first call created instead of creating another one — re-send safely after a lost response. Keys are remembered for 30 days by default (CLIENT_IDEMPOTENCY_KEY_RETENTION_DAYS). */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  ticket: Scalars['ID']['input'];
};

export type CreateTicketCommentPayload = {
  __typename: 'CreateTicketCommentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ticketComment?: Maybe<TicketCommentDef>;
};

export type CreateTicketCustomFieldMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayHelpText?: InputMaybe<Scalars['Boolean']['input']>;
  displayOn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayPrefilledValue?: InputMaybe<Scalars['Boolean']['input']>;
  displayUnit?: InputMaybe<Scalars['Boolean']['input']>;
  helpText?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inputType?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<CustomFieldOptionSelectInput>>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prefilledValue?: InputMaybe<Scalars['Int']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTicketCustomFieldMutationPayload = {
  __typename: 'CreateTicketCustomFieldMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ticketCustomField?: Maybe<TicketCustomFieldDef>;
};

export type CreateTicketDraftEmailInput = {
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyEmailAccount: Scalars['ID']['input'];
  threadStarter?: InputMaybe<Scalars['ID']['input']>;
  ticketDraft: Scalars['ID']['input'];
};

export type CreateTicketDraftEmailPayload = {
  __typename: 'CreateTicketDraftEmailPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companyEmailAccountMessage?: Maybe<CompanyEmailAccountMessageDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateTicketInput = {
  /** If true, the user creating the ticket will be added to the followers */
  addToFollowers?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTeam?: InputMaybe<Scalars['ID']['input']>;
  assignee?: InputMaybe<Scalars['ID']['input']>;
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  container?: InputMaybe<Scalars['ID']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<TicketCustomFieldValueInput>>>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Accuracy radius of that fix, metres. */
  gpsAccuracy?: InputMaybe<Scalars['Float']['input']>;
  /** When the device took that fix. */
  gpsCapturedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ignoreServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Device latitude when the ticket was filed (HSY req 34). */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  /** Device longitude when the ticket was filed (HSY req 34). */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  overridePeriodStartInPast?: InputMaybe<Scalars['Boolean']['input']>;
  periodEndDate?: InputMaybe<Scalars['Date']['input']>;
  periodStartDate?: InputMaybe<Scalars['Date']['input']>;
  ppServiceOriginalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  ppServicePrice?: InputMaybe<Scalars['Decimal']['input']>;
  ppServiceProductId?: InputMaybe<Scalars['String']['input']>;
  preferredDate?: InputMaybe<Scalars['Date']['input']>;
  /** If true, do not create the ticket, but preview what it would look like if created - e.g. to get the prices. */
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  priority: Scalars['String']['input'];
  property?: InputMaybe<Scalars['ID']['input']>;
  reporter?: InputMaybe<Scalars['ID']['input']>;
  reporterDriver?: InputMaybe<Scalars['ID']['input']>;
  requestedBy?: InputMaybe<Scalars['ID']['input']>;
  requestedByOther?: InputMaybe<Scalars['String']['input']>;
  routeDescription?: InputMaybe<Scalars['String']['input']>;
  sendSummary?: InputMaybe<SendTicketSummaryInput>;
  serviceProducts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  serviceProvider?: InputMaybe<Scalars['ID']['input']>;
  ticketType: Scalars['ID']['input'];
};

export type CreateTicketMessageInput = {
  addAttachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyEmailAccount?: InputMaybe<Scalars['ID']['input']>;
  receiverContact?: InputMaybe<Scalars['ID']['input']>;
  receiverEmail?: InputMaybe<Scalars['String']['input']>;
  receiverManagementCompany?: InputMaybe<Scalars['ID']['input']>;
  receiverPropertyContact?: InputMaybe<Scalars['ID']['input']>;
  receiverPropertyUser?: InputMaybe<Scalars['ID']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  ticket: Scalars['ID']['input'];
  via?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTicketMessagePayload = {
  __typename: 'CreateTicketMessagePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ticketMessage?: Maybe<TicketMessageDef>;
};

export type CreateTicketPayload = {
  __typename: 'CreateTicketPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ticket?: Maybe<TicketDef>;
};

/**
 * Move a quantity of an item type between warehouses via a
 * transfer ticket (ADR-0005): creating the ticket reserves the
 * quantity at the source; it goes in transit when the ticket
 * starts, and lands at the destination when the receiving side
 * completes the ticket through the existing ticket UI. Rejecting
 * before then releases the reservation (or brings the in-transit
 * quantity home).
 */
export type CreateTransfer = {
  __typename: 'CreateTransfer';
  status?: Maybe<Scalars['String']['output']>;
  ticketId?: Maybe<Scalars['ID']['output']>;
};

export type CreateUnconfirmedUser = {
  __typename: 'CreateUnconfirmedUser';
  flow?: Maybe<CreateUnconfirmedUserFlow>;
  unconfirmedUser?: Maybe<UnconfirmedUserType>;
};

export type CreateUnconfirmedUserFlow = {
  __typename: 'CreateUnconfirmedUserFlow';
  enable?: Maybe<Scalars['Boolean']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type CreateUser = {
  __typename: 'CreateUser';
  user?: Maybe<UserType>;
};

export type CreateWasteCollector = {
  __typename: 'CreateWasteCollector';
  newWasteCollector?: Maybe<WasteCollectorType>;
};

export type CreateWasteFraction = {
  __typename: 'CreateWasteFraction';
  wasteFraction?: Maybe<WasteFractionType>;
};

/** PRO-946: add a dated factor version to a waste fraction. */
export type CreateWasteFractionEnvironmentalFactor = {
  __typename: 'CreateWasteFractionEnvironmentalFactor';
  environmentalFactor?: Maybe<WasteFractionEnvironmentalFactorType>;
};

/** Add a company appliance-catalogue option (mirrors createPartType). */
export type CreateWasteWaterApplianceOption = {
  __typename: 'CreateWasteWaterApplianceOption';
  applianceOption?: Maybe<WasteWaterApplianceOptionDef>;
};

export type CriiptoApplicationDef = Node & {
  __typename: 'CriiptoApplicationDef';
  allowBusiness: Scalars['Boolean']['output'];
  allowedAcrValues: Array<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  hostname: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

export type CriiptoApplicationDefConnection = {
  __typename: 'CriiptoApplicationDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CriiptoApplicationDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CriiptoApplicationDef` and its cursor. */
export type CriiptoApplicationDefEdge = {
  __typename: 'CriiptoApplicationDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CriiptoApplicationDef>;
};

/** An enumeration. */
export enum CrmActivePriceViewRecurringIntervalChoices {
  /** Once */
  ONCE = 'ONCE',
  /** Yearly */
  YEARLY = 'YEARLY'
}

/** An enumeration. */
export enum CrmAgreementAccessFeeIntervalChoices {
  /** Annual */
  ANNUAL = 'ANNUAL',
  /** Month */
  MONTHLY = 'MONTHLY'
}

/** An enumeration. */
export enum CrmAgreementExportModeChoices {
  /** Change */
  CHANGE = 'CHANGE',
  /** Total */
  TOTAL = 'TOTAL'
}

/** An enumeration. */
export enum CrmBillingRunExportStatusChoices {
  /** Exported */
  EXPORTED = 'EXPORTED',
  /** Exporting */
  EXPORTING = 'EXPORTING',
  /** Failed */
  FAILED = 'FAILED'
}

/** An enumeration. */
export enum CrmBillingRunStatusChoices {
  /** Created */
  CREATED = 'CREATED',
  /** Creating */
  CREATING = 'CREATING',
  /** Failed */
  FAILED = 'FAILED'
}

/** An enumeration. */
export enum CrmCompanyHolidayRecurrenceChoices {
  /** Every year — same day and month */
  ANNUALLY = 'ANNUALLY',
  /** Once — this exact date */
  ONCE = 'ONCE'
}

/** An enumeration. */
export enum CrmContactAddressAddressTypeChoices {
  /** Billing */
  BILLING = 'BILLING',
  /** Billing Reminder */
  BILLING_REMINDER = 'BILLING_REMINDER',
  /** Official */
  OFFICIAL = 'OFFICIAL',
  /** Other */
  OTHER = 'OTHER',
  /** Shipping */
  SHIPPING = 'SHIPPING'
}

/** An enumeration. */
export enum CrmContactContactTypeChoices {
  /** Company */
  COMPANY = 'COMPANY',
  /** Individual */
  INDIVIDUAL = 'INDIVIDUAL'
}

/** An enumeration. */
export enum CrmContactInvoiceDeliveryMethodChoices {
  /** Direct Payment */
  DIRECT_PAYMENT = 'DIRECT_PAYMENT',
  /** Email */
  EMAIL = 'EMAIL',
  /** E Invoice */
  E_INVOICE = 'E_INVOICE',
  /** Paper */
  PAPER = 'PAPER'
}

/** An enumeration. */
export enum CrmContactInvoiceLanguageChoices {
  /** Danish */
  DA = 'DA',
  /** English */
  EN = 'EN',
  /** Finnish */
  FI = 'FI',
  /** Norwegian */
  NO = 'NO',
  /** Swedish */
  SV = 'SV'
}

/** An enumeration. */
export enum CrmContactNdrSourceChoices {
  /** Dvv Sync */
  DVV_SYNC = 'DVV_SYNC',
  /** Manual */
  MANUAL = 'MANUAL'
}

/** An enumeration. */
export enum CrmContactPricingModeChoices {
  /** Gross — prices include VAT */
  GROSS = 'GROSS',
  /** Net — VAT added on top */
  NET = 'NET'
}

/** An enumeration. */
export enum CrmContactPropertyRoleChoices {
  /** Administrator */
  ADMINISTRATOR = 'ADMINISTRATOR',
  /** Caretaker */
  CARETAKER = 'CARETAKER',
  /** Contact */
  CONTACT = 'CONTACT',
  /** Co Owner */
  CO_OWNER = 'CO_OWNER',
  /** Owner */
  OWNER = 'OWNER',
  /** Payer */
  PAYER = 'PAYER',
  /** Property Manager */
  PROPERTY_MANAGER = 'PROPERTY_MANAGER',
  /** Tenant */
  TENANT = 'TENANT'
}

/** An enumeration. */
export enum CrmContainerNotificationAutoMediumChoices {
  /** email */
  EMAIL = 'EMAIL',
  /** SMS */
  SMS = 'SMS'
}

/** An enumeration. */
export enum CrmDebtorExportStatusChoices {
  /** Completed */
  COMPLETED = 'COMPLETED',
  /** Exporting */
  EXPORTING = 'EXPORTING',
  /** Failed */
  FAILED = 'FAILED'
}

/** An enumeration. */
export enum CrmHaulerPriceChangeLogAppliedToChoices {
  /** Original contract price */
  BASE = 'BASE',
  /** Current price */
  CURRENT = 'CURRENT'
}

/** An enumeration. */
export enum CrmHaulerPriceChangeLogKindChoices {
  /** Bulk update (fixed amount) */
  BULK_FIXED = 'BULK_FIXED',
  /** Bulk update (percent) */
  BULK_PERCENT = 'BULK_PERCENT',
  /** Index adjustment */
  INDEX_ADJUSTMENT = 'INDEX_ADJUSTMENT'
}

/** An enumeration. */
export enum CrmHaulerPriceComponentKindChoices {
  /** Flat amount (cents) */
  FLAT_CENTS = 'FLAT_CENTS',
  /** Percent of flat sum */
  PERCENT = 'PERCENT'
}

/** An enumeration. */
export enum CrmInvoiceStatusChoices {
  /** Draft */
  A_1 = 'A_1',
  /** Open */
  A_2 = 'A_2',
  /** Paid */
  A_3 = 'A_3',
  /** Void */
  A_4 = 'A_4',
  /** Transferred to External System */
  A_5 = 'A_5'
}

/** An enumeration. */
export enum CrmManagementCompanyPropertyRoleChoices {
  /** Administrator */
  ADMINISTRATOR = 'ADMINISTRATOR',
  /** Caretaker */
  CARETAKER = 'CARETAKER',
  /** Contact */
  CONTACT = 'CONTACT',
  /** Co Owner */
  CO_OWNER = 'CO_OWNER',
  /** Owner */
  OWNER = 'OWNER',
  /** Payer */
  PAYER = 'PAYER',
  /** Property Manager */
  PROPERTY_MANAGER = 'PROPERTY_MANAGER',
  /** Tenant */
  TENANT = 'TENANT'
}

/** An enumeration. */
export enum CrmMasterDataSyncStatusChoices {
  /** Completed */
  COMPLETED = 'COMPLETED',
  /** Failed */
  FAILED = 'FAILED',
  /** Syncing */
  SYNCING = 'SYNCING'
}

/** An enumeration. */
export enum CrmMasterDataSyncTypeChoices {
  /** Contacts */
  CONTACTS = 'CONTACTS',
  /** Properties */
  PROPERTIES = 'PROPERTIES'
}

/** An enumeration. */
export enum CrmNotificationMessageNotificationTypeChoices {
  /** email */
  EMAIL = 'EMAIL',
  /** SMS */
  SMS = 'SMS'
}

/** An enumeration. */
export enum CrmPhysicalKeyStatusChoices {
  /** At locksmith */
  AT_LOCKSMITH = 'AT_LOCKSMITH',
  /** Issued */
  ISSUED = 'ISSUED',
  /** Lost */
  LOST = 'LOST',
  /** Ordered */
  ORDERED = 'ORDERED',
  /** Ready */
  READY = 'READY',
  /** Replaced */
  REPLACED = 'REPLACED',
  /** Returned */
  RETURNED = 'RETURNED'
}

/** An enumeration. */
export enum CrmPriceRecurringIntervalChoices {
  /** Once */
  ONCE = 'ONCE',
  /** Yearly */
  YEARLY = 'YEARLY'
}

/** An enumeration. */
export enum CrmProductAreaRestrictionChoices {
  /** Area-restricted */
  AREA_RESTRICTED = 'AREA_RESTRICTED',
  /** None */
  NONE = 'NONE'
}

/** An enumeration. */
export enum CrmProductProductTypeChoices {
  /** Container */
  CONTAINER = 'CONTAINER',
  /** Recurring */
  RECURRING = 'RECURRING',
  /** Service */
  SERVICE = 'SERVICE'
}

/** An enumeration. */
export enum CrmPropertyContactContactTypeChoices {
  /** Company */
  COMPANY = 'COMPANY',
  /** Individual */
  INDIVIDUAL = 'INDIVIDUAL'
}

/** An enumeration. */
export enum CrmPropertyEmergencyPriorityChoices {
  /** High */
  HIGH = 'HIGH',
  /** Low */
  LOW = 'LOW',
  /** Medium */
  MEDIUM = 'MEDIUM'
}

/** An enumeration. */
export enum CrmPropertyGroupGroupTypeChoices {
  /** Single */
  A_1 = 'A_1',
  /** Split */
  A_2 = 'A_2'
}

/** An enumeration. */
export enum CrmPropertyManagementCompanyAddressAddressTypeChoices {
  /** Billing */
  BILLING = 'BILLING',
  /** Billing Reminder */
  BILLING_REMINDER = 'BILLING_REMINDER',
  /** Official */
  OFFICIAL = 'OFFICIAL',
  /** Other */
  OTHER = 'OTHER',
  /** Shipping */
  SHIPPING = 'SHIPPING'
}

/** An enumeration. */
export enum CrmPropertyManagementCompanyCountryChoices {
  /** Andorra */
  AD = 'AD',
  /** United Arab Emirates */
  AE = 'AE',
  /** Afghanistan */
  AF = 'AF',
  /** Antigua and Barbuda */
  AG = 'AG',
  /** Anguilla */
  AI = 'AI',
  /** Albania */
  AL = 'AL',
  /** Armenia */
  AM = 'AM',
  /** Angola */
  AO = 'AO',
  /** Antarctica */
  AQ = 'AQ',
  /** Argentina */
  AR = 'AR',
  /** American Samoa */
  AS = 'AS',
  /** Austria */
  AT = 'AT',
  /** Australia */
  AU = 'AU',
  /** Aruba */
  AW = 'AW',
  /** Åland Islands */
  AX = 'AX',
  /** Azerbaijan */
  AZ = 'AZ',
  /** Bosnia and Herzegovina */
  BA = 'BA',
  /** Barbados */
  BB = 'BB',
  /** Bangladesh */
  BD = 'BD',
  /** Belgium */
  BE = 'BE',
  /** Burkina Faso */
  BF = 'BF',
  /** Bulgaria */
  BG = 'BG',
  /** Bahrain */
  BH = 'BH',
  /** Burundi */
  BI = 'BI',
  /** Benin */
  BJ = 'BJ',
  /** Saint Barthélemy */
  BL = 'BL',
  /** Bermuda */
  BM = 'BM',
  /** Brunei Darussalam */
  BN = 'BN',
  /** Bolivia, Plurinational State of */
  BO = 'BO',
  /** Bonaire, Sint Eustatius and Saba */
  BQ = 'BQ',
  /** Brazil */
  BR = 'BR',
  /** Bahamas */
  BS = 'BS',
  /** Bhutan */
  BT = 'BT',
  /** Bouvet Island */
  BV = 'BV',
  /** Botswana */
  BW = 'BW',
  /** Belarus */
  BY = 'BY',
  /** Belize */
  BZ = 'BZ',
  /** Canada */
  CA = 'CA',
  /** Cocos (Keeling) Islands */
  CC = 'CC',
  /** Congo, Democratic Republic of the */
  CD = 'CD',
  /** Central African Republic */
  CF = 'CF',
  /** Congo */
  CG = 'CG',
  /** Switzerland */
  CH = 'CH',
  /** Côte d'Ivoire */
  CI = 'CI',
  /** Cook Islands */
  CK = 'CK',
  /** Chile */
  CL = 'CL',
  /** Cameroon */
  CM = 'CM',
  /** China */
  CN = 'CN',
  /** Colombia */
  CO = 'CO',
  /** Costa Rica */
  CR = 'CR',
  /** Cuba */
  CU = 'CU',
  /** Cabo Verde */
  CV = 'CV',
  /** Curaçao */
  CW = 'CW',
  /** Christmas Island */
  CX = 'CX',
  /** Cyprus */
  CY = 'CY',
  /** Czechia */
  CZ = 'CZ',
  /** Germany */
  DE = 'DE',
  /** Djibouti */
  DJ = 'DJ',
  /** Denmark */
  DK = 'DK',
  /** Dominica */
  DM = 'DM',
  /** Dominican Republic */
  DO = 'DO',
  /** Algeria */
  DZ = 'DZ',
  /** Ecuador */
  EC = 'EC',
  /** Estonia */
  EE = 'EE',
  /** Egypt */
  EG = 'EG',
  /** Western Sahara */
  EH = 'EH',
  /** Eritrea */
  ER = 'ER',
  /** Spain */
  ES = 'ES',
  /** Ethiopia */
  ET = 'ET',
  /** Finland */
  FI = 'FI',
  /** Fiji */
  FJ = 'FJ',
  /** Falkland Islands (Malvinas) */
  FK = 'FK',
  /** Micronesia, Federated States of */
  FM = 'FM',
  /** Faroe Islands */
  FO = 'FO',
  /** France */
  FR = 'FR',
  /** Gabon */
  GA = 'GA',
  /** United Kingdom of Great Britain and Northern Ireland */
  GB = 'GB',
  /** Grenada */
  GD = 'GD',
  /** Georgia */
  GE = 'GE',
  /** French Guiana */
  GF = 'GF',
  /** Guernsey */
  GG = 'GG',
  /** Ghana */
  GH = 'GH',
  /** Gibraltar */
  GI = 'GI',
  /** Greenland */
  GL = 'GL',
  /** Gambia */
  GM = 'GM',
  /** Guinea */
  GN = 'GN',
  /** Guadeloupe */
  GP = 'GP',
  /** Equatorial Guinea */
  GQ = 'GQ',
  /** Greece */
  GR = 'GR',
  /** South Georgia and the South Sandwich Islands */
  GS = 'GS',
  /** Guatemala */
  GT = 'GT',
  /** Guam */
  GU = 'GU',
  /** Guinea-Bissau */
  GW = 'GW',
  /** Guyana */
  GY = 'GY',
  /** Hong Kong */
  HK = 'HK',
  /** Heard Island and McDonald Islands */
  HM = 'HM',
  /** Honduras */
  HN = 'HN',
  /** Croatia */
  HR = 'HR',
  /** Haiti */
  HT = 'HT',
  /** Hungary */
  HU = 'HU',
  /** Indonesia */
  ID = 'ID',
  /** Ireland */
  IE = 'IE',
  /** Israel */
  IL = 'IL',
  /** Isle of Man */
  IM = 'IM',
  /** India */
  IN = 'IN',
  /** British Indian Ocean Territory */
  IO = 'IO',
  /** Iraq */
  IQ = 'IQ',
  /** Iran, Islamic Republic of */
  IR = 'IR',
  /** Iceland */
  IS = 'IS',
  /** Italy */
  IT = 'IT',
  /** Jersey */
  JE = 'JE',
  /** Jamaica */
  JM = 'JM',
  /** Jordan */
  JO = 'JO',
  /** Japan */
  JP = 'JP',
  /** Kenya */
  KE = 'KE',
  /** Kyrgyzstan */
  KG = 'KG',
  /** Cambodia */
  KH = 'KH',
  /** Kiribati */
  KI = 'KI',
  /** Comoros */
  KM = 'KM',
  /** Saint Kitts and Nevis */
  KN = 'KN',
  /** Korea, Democratic People's Republic of */
  KP = 'KP',
  /** Korea, Republic of */
  KR = 'KR',
  /** Kuwait */
  KW = 'KW',
  /** Cayman Islands */
  KY = 'KY',
  /** Kazakhstan */
  KZ = 'KZ',
  /** Lao People's Democratic Republic */
  LA = 'LA',
  /** Lebanon */
  LB = 'LB',
  /** Saint Lucia */
  LC = 'LC',
  /** Liechtenstein */
  LI = 'LI',
  /** Sri Lanka */
  LK = 'LK',
  /** Liberia */
  LR = 'LR',
  /** Lesotho */
  LS = 'LS',
  /** Lithuania */
  LT = 'LT',
  /** Luxembourg */
  LU = 'LU',
  /** Latvia */
  LV = 'LV',
  /** Libya */
  LY = 'LY',
  /** Morocco */
  MA = 'MA',
  /** Monaco */
  MC = 'MC',
  /** Moldova, Republic of */
  MD = 'MD',
  /** Montenegro */
  ME = 'ME',
  /** Saint Martin (French part) */
  MF = 'MF',
  /** Madagascar */
  MG = 'MG',
  /** Marshall Islands */
  MH = 'MH',
  /** North Macedonia */
  MK = 'MK',
  /** Mali */
  ML = 'ML',
  /** Myanmar */
  MM = 'MM',
  /** Mongolia */
  MN = 'MN',
  /** Macao */
  MO = 'MO',
  /** Northern Mariana Islands */
  MP = 'MP',
  /** Martinique */
  MQ = 'MQ',
  /** Mauritania */
  MR = 'MR',
  /** Montserrat */
  MS = 'MS',
  /** Malta */
  MT = 'MT',
  /** Mauritius */
  MU = 'MU',
  /** Maldives */
  MV = 'MV',
  /** Malawi */
  MW = 'MW',
  /** Mexico */
  MX = 'MX',
  /** Malaysia */
  MY = 'MY',
  /** Mozambique */
  MZ = 'MZ',
  /** Namibia */
  NA = 'NA',
  /** New Caledonia */
  NC = 'NC',
  /** Niger */
  NE = 'NE',
  /** Norfolk Island */
  NF = 'NF',
  /** Nigeria */
  NG = 'NG',
  /** Nicaragua */
  NI = 'NI',
  /** Netherlands */
  NL = 'NL',
  /** Norway */
  NO = 'NO',
  /** Nepal */
  NP = 'NP',
  /** Nauru */
  NR = 'NR',
  /** Niue */
  NU = 'NU',
  /** New Zealand */
  NZ = 'NZ',
  /** Oman */
  OM = 'OM',
  /** Panama */
  PA = 'PA',
  /** Peru */
  PE = 'PE',
  /** French Polynesia */
  PF = 'PF',
  /** Papua New Guinea */
  PG = 'PG',
  /** Philippines */
  PH = 'PH',
  /** Pakistan */
  PK = 'PK',
  /** Poland */
  PL = 'PL',
  /** Saint Pierre and Miquelon */
  PM = 'PM',
  /** Pitcairn */
  PN = 'PN',
  /** Puerto Rico */
  PR = 'PR',
  /** Palestine, State of */
  PS = 'PS',
  /** Portugal */
  PT = 'PT',
  /** Palau */
  PW = 'PW',
  /** Paraguay */
  PY = 'PY',
  /** Qatar */
  QA = 'QA',
  /** Réunion */
  RE = 'RE',
  /** Romania */
  RO = 'RO',
  /** Serbia */
  RS = 'RS',
  /** Russian Federation */
  RU = 'RU',
  /** Rwanda */
  RW = 'RW',
  /** Saudi Arabia */
  SA = 'SA',
  /** Solomon Islands */
  SB = 'SB',
  /** Seychelles */
  SC = 'SC',
  /** Sudan */
  SD = 'SD',
  /** Sweden */
  SE = 'SE',
  /** Singapore */
  SG = 'SG',
  /** Saint Helena, Ascension and Tristan da Cunha */
  SH = 'SH',
  /** Slovenia */
  SI = 'SI',
  /** Svalbard and Jan Mayen */
  SJ = 'SJ',
  /** Slovakia */
  SK = 'SK',
  /** Sierra Leone */
  SL = 'SL',
  /** San Marino */
  SM = 'SM',
  /** Senegal */
  SN = 'SN',
  /** Somalia */
  SO = 'SO',
  /** Suriname */
  SR = 'SR',
  /** South Sudan */
  SS = 'SS',
  /** Sao Tome and Principe */
  ST = 'ST',
  /** El Salvador */
  SV = 'SV',
  /** Sint Maarten (Dutch part) */
  SX = 'SX',
  /** Syrian Arab Republic */
  SY = 'SY',
  /** Eswatini */
  SZ = 'SZ',
  /** Turks and Caicos Islands */
  TC = 'TC',
  /** Chad */
  TD = 'TD',
  /** French Southern Territories */
  TF = 'TF',
  /** Togo */
  TG = 'TG',
  /** Thailand */
  TH = 'TH',
  /** Tajikistan */
  TJ = 'TJ',
  /** Tokelau */
  TK = 'TK',
  /** Timor-Leste */
  TL = 'TL',
  /** Turkmenistan */
  TM = 'TM',
  /** Tunisia */
  TN = 'TN',
  /** Tonga */
  TO = 'TO',
  /** Türkiye */
  TR = 'TR',
  /** Trinidad and Tobago */
  TT = 'TT',
  /** Tuvalu */
  TV = 'TV',
  /** Taiwan, Province of China */
  TW = 'TW',
  /** Tanzania, United Republic of */
  TZ = 'TZ',
  /** Ukraine */
  UA = 'UA',
  /** Uganda */
  UG = 'UG',
  /** United States Minor Outlying Islands */
  UM = 'UM',
  /** United States of America */
  US = 'US',
  /** Uruguay */
  UY = 'UY',
  /** Uzbekistan */
  UZ = 'UZ',
  /** Holy See */
  VA = 'VA',
  /** Saint Vincent and the Grenadines */
  VC = 'VC',
  /** Venezuela, Bolivarian Republic of */
  VE = 'VE',
  /** Virgin Islands, British */
  VG = 'VG',
  /** Virgin Islands, U.S. */
  VI = 'VI',
  /** Viet Nam */
  VN = 'VN',
  /** Vanuatu */
  VU = 'VU',
  /** Wallis and Futuna */
  WF = 'WF',
  /** Samoa */
  WS = 'WS',
  /** Kosovo */
  XK = 'XK',
  /** Yemen */
  YE = 'YE',
  /** Mayotte */
  YT = 'YT',
  /** South Africa */
  ZA = 'ZA',
  /** Zambia */
  ZM = 'ZM',
  /** Zimbabwe */
  ZW = 'ZW'
}

/** An enumeration. */
export enum CrmPropertyManagementCompanyInvoiceDeliveryMethodChoices {
  /** Direct Payment */
  DIRECT_PAYMENT = 'DIRECT_PAYMENT',
  /** Email */
  EMAIL = 'EMAIL',
  /** E Invoice */
  E_INVOICE = 'E_INVOICE',
  /** Paper */
  PAPER = 'PAPER'
}

/** An enumeration. */
export enum CrmPropertyManagementCompanyInvoiceLanguageChoices {
  /** Danish */
  DA = 'DA',
  /** English */
  EN = 'EN',
  /** Finnish */
  FI = 'FI',
  /** Norwegian */
  NO = 'NO',
  /** Swedish */
  SV = 'SV'
}

/** An enumeration. */
export enum CrmPropertyManagementCompanyPricingModeChoices {
  /** Gross — prices include VAT */
  GROSS = 'GROSS',
  /** Net — VAT added on top */
  NET = 'NET'
}

/** An enumeration. */
export enum CrmPropertyManagementCompanySegmentChoices {
  /** Bulk haulage */
  BULK_HAULAGE = 'BULK_HAULAGE',
  /** Commercial collection */
  COMMERCIAL_COLLECTION = 'COMMERCIAL_COLLECTION',
  /** Container rental */
  CONTAINER_RENTAL = 'CONTAINER_RENTAL',
  /** Municipal contract */
  MUNICIPAL = 'MUNICIPAL',
  /** Other */
  OTHER = 'OTHER',
  /** Recycler */
  RECYCLER = 'RECYCLER'
}

/** An enumeration. */
export enum CrmPropertyRegisterBasisChoices {
  /** Access-based */
  ACCESS_BASED = 'ACCESS_BASED',
  /** None */
  NONE = 'NONE',
  /** Own container */
  OWN_CONTAINER = 'OWN_CONTAINER',
  /** Shared service */
  SHARED_SERVICE = 'SHARED_SERVICE'
}

/** An enumeration. */
export enum CrmPropertyUserLanguageChoices {
  /** Arabic */
  AR = 'AR',
  /** Czech */
  CS = 'CS',
  /** Danish */
  DA = 'DA',
  /** German */
  DE = 'DE',
  /** Greek */
  EL = 'EL',
  /** English */
  EN = 'EN',
  /** Spanish */
  ES = 'ES',
  /** Finnish */
  FI = 'FI',
  /** French */
  FR = 'FR',
  /** Italian */
  IT = 'IT',
  /** Dutch */
  NL = 'NL',
  /** Norwegian */
  NO = 'NO',
  /** Polish */
  PL = 'PL',
  /** Portuguese */
  PT = 'PT',
  /** Romanian */
  RO = 'RO',
  /** Swedish */
  SV = 'SV'
}

/** An enumeration. */
export enum CrmPropertyWasteDecisionKindChoices {
  /** Regional-point use right (käyttöoikeus) */
  KAYTTOOIKEUS = 'KAYTTOOIKEUS',
  /** Collection suspension (keskeytys) */
  KESKEYTYS = 'KESKEYTYS',
  /** Emptying-interval extension (pidennys) */
  PIDENNYS = 'PIDENNYS'
}

/** An enumeration. */
export enum CrmScpCompanyMembershipStatusChoices {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Ended */
  ENDED = 'ENDED'
}

/** An enumeration. */
export enum CrmScpMembershipIntakeChannelChoices {
  /** E-mail */
  EMAIL = 'EMAIL',
  /** Form */
  FORM = 'FORM',
  /** Other */
  OTHER = 'OTHER',
  /** Phone */
  PHONE = 'PHONE'
}

/** An enumeration. */
export enum CrmScpMembershipStatusChoices {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Ended */
  ENDED = 'ENDED'
}

/** An enumeration. */
export enum CrmScpMembershipUsageProfileChoices {
  /** Summer */
  SUMMER = 'SUMMER',
  /** Year-round */
  YEAR_ROUND = 'YEAR_ROUND'
}

/** An enumeration. */
export enum CrmScpProfileAreaRestrictionChoices {
  /** Area-restricted */
  AREA_RESTRICTED = 'AREA_RESTRICTED',
  /** None */
  NONE = 'NONE'
}

/** An enumeration. */
export enum CrmScpProfileAvailabilityChoices {
  /** Seasonal */
  SEASONAL = 'SEASONAL',
  /** Year-round */
  YEAR_ROUND = 'YEAR_ROUND'
}

/** An enumeration. */
export enum CrmScpProfileBillingModeChoices {
  /** Share-split */
  SHARE_SPLIT = 'SHARE_SPLIT',
  /** Subscription */
  SUBSCRIPTION = 'SUBSCRIPTION'
}

/** An enumeration. */
export enum CrmScpProfileScpTypeChoices {
  /** Block */
  BLOCK = 'BLOCK',
  /** Regional */
  REGIONAL = 'REGIONAL',
  /** Shared Residential */
  SHARED_RESIDENTIAL = 'SHARED_RESIDENTIAL'
}

/** An enumeration. */
export enum CrmScpProfileStatusChoices {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Terminated */
  TERMINATED = 'TERMINATED'
}

/** An enumeration. */
export enum CrmScheduledExportFilterTicketDateChoices {
  /** Completed */
  COMPLETED_AT = 'COMPLETED_AT',
  /** Created */
  CREATED_AT = 'CREATED_AT',
  /** In progress */
  IN_PROGRESS_AT = 'IN_PROGRESS_AT',
  /** Open */
  OPEN_AT = 'OPEN_AT',
  /** Pending */
  PENDING_AT = 'PENDING_AT',
  /** Preferred Date */
  PREFERRED_DATE = 'PREFERRED_DATE'
}

/** An enumeration. */
export enum CrmScheduledExportIntervalTypeChoices {
  /** Day */
  DAY = 'DAY',
  /** Hour */
  HOUR = 'HOUR',
  /** Month */
  MONTH = 'MONTH',
  /** Week */
  WEEK = 'WEEK'
}

/** An enumeration. */
export enum CrmScheduledExportLanguageChoices {
  /** Arabic */
  AR = 'AR',
  /** Czech */
  CS = 'CS',
  /** Danish */
  DA = 'DA',
  /** German */
  DE = 'DE',
  /** Greek */
  EL = 'EL',
  /** English */
  EN = 'EN',
  /** Spanish */
  ES = 'ES',
  /** Finnish */
  FI = 'FI',
  /** French */
  FR = 'FR',
  /** Italian */
  IT = 'IT',
  /** Dutch */
  NL = 'NL',
  /** Norwegian */
  NO = 'NO',
  /** Polish */
  PL = 'PL',
  /** Portuguese */
  PT = 'PT',
  /** Romanian */
  RO = 'RO',
  /** Swedish */
  SV = 'SV'
}

/** An enumeration. */
export enum CrmScheduledExportRunFilterTicketDateChoices {
  /** Completed */
  COMPLETED_AT = 'COMPLETED_AT',
  /** Created */
  CREATED_AT = 'CREATED_AT',
  /** In progress */
  IN_PROGRESS_AT = 'IN_PROGRESS_AT',
  /** Open */
  OPEN_AT = 'OPEN_AT',
  /** Pending */
  PENDING_AT = 'PENDING_AT',
  /** Preferred Date */
  PREFERRED_DATE = 'PREFERRED_DATE'
}

/** An enumeration. */
export enum CrmScheduledExportRunLanguageChoices {
  /** Arabic */
  AR = 'AR',
  /** Czech */
  CS = 'CS',
  /** Danish */
  DA = 'DA',
  /** German */
  DE = 'DE',
  /** Greek */
  EL = 'EL',
  /** English */
  EN = 'EN',
  /** Spanish */
  ES = 'ES',
  /** Finnish */
  FI = 'FI',
  /** French */
  FR = 'FR',
  /** Italian */
  IT = 'IT',
  /** Dutch */
  NL = 'NL',
  /** Norwegian */
  NO = 'NO',
  /** Polish */
  PL = 'PL',
  /** Portuguese */
  PT = 'PT',
  /** Romanian */
  RO = 'RO',
  /** Swedish */
  SV = 'SV'
}

/** An enumeration. */
export enum CrmSiirtoRegistrySubmissionStatusChoices {
  /** Hand-off failed */
  FAILED = 'FAILED',
  /** Pending */
  PENDING = 'PENDING',
  /** Rejected */
  REJECTED = 'REJECTED',
  /** Sent */
  SENT = 'SENT'
}

/** An enumeration. */
export enum CrmTransferDocumentEventEventTypeChoices {
  /** Cancelled */
  CANCELLED = 'CANCELLED',
  /** Stop completed without a signed document */
  COMPLETION_OVERRIDDEN = 'COMPLETION_OVERRIDDEN',
  /** Created */
  CREATED = 'CREATED',
  /** Data changed */
  DATA_CHANGED = 'DATA_CHANGED',
  /** Signing link opened */
  LINK_OPENED = 'LINK_OPENED',
  /** Signing link revoked */
  LINK_REVOKED = 'LINK_REVOKED',
  /** Signing link sent */
  LINK_SENT = 'LINK_SENT',
  /** Reopened */
  REOPENED = 'REOPENED',
  /** Signature invalidated */
  SIGNATURE_INVALIDATED = 'SIGNATURE_INVALIDATED',
  /** Signed */
  SIGNED = 'SIGNED',
  /** Register hand-off failed */
  SUBMISSION_FAILED = 'SUBMISSION_FAILED',
  /** Register rejected */
  SUBMISSION_REJECTED = 'SUBMISSION_REJECTED',
  /** Submitted to register */
  SUBMITTED = 'SUBMITTED'
}

/** An enumeration. */
export enum CrmTransferDocumentSignatureActorKindChoices {
  /** Driver */
  DRIVER = 'DRIVER',
  /** On the driver's device */
  DRIVER_DEVICE = 'DRIVER_DEVICE',
  /** Public link */
  PUBLIC_LINK = 'PUBLIC_LINK',
  /** Office user */
  STAFF = 'STAFF',
  /** System */
  SYSTEM = 'SYSTEM'
}

/** An enumeration. */
export enum CrmTransferDocumentSignatureRoleChoices {
  /** Carrier */
  CARRIER = 'CARRIER',
  /** Driver */
  DRIVER = 'DRIVER',
  /** Receiver */
  RECEIVER = 'RECEIVER',
  /** Waste holder */
  WASTE_HOLDER = 'WASTE_HOLDER'
}

/** An enumeration. */
export enum CrmTransferDocumentStatusChoices {
  /** Cancelled */
  CANCELLED = 'CANCELLED',
  /** Complete */
  COMPLETE = 'COMPLETE',
  /** Open */
  OPEN = 'OPEN',
  /** Signed */
  SIGNED = 'SIGNED'
}

export type CurrentDriverLocationSubscription = {
  __typename: 'CurrentDriverLocationSubscription';
  drivers?: Maybe<Array<Maybe<DriverType>>>;
  vehicles?: Maybe<Array<Maybe<VehicleLocationType>>>;
};

export type CustomContainerEventDef = Node & {
  __typename: 'CustomContainerEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  barcodeFileUrl?: Maybe<Scalars['String']['output']>;
  container?: Maybe<ContainerType>;
  createdAt: Scalars['DateTime']['output'];
  customEventType?: Maybe<Array<Maybe<DeviceContainerCustomEventTypesGraphene>>>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  user?: Maybe<UserType>;
};

export type CustomContainerEventDefConnection = {
  __typename: 'CustomContainerEventDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomContainerEventDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CustomContainerEventDef` and its cursor. */
export type CustomContainerEventDefEdge = {
  __typename: 'CustomContainerEventDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CustomContainerEventDef>;
};

/**
 * Filter containers/properties by a CompanyMetaType custom field.
 *
 * Pass the CompanyMetaType global ID in ``field_id`` and one or more values
 * to match.  Include ``"__no_value__"`` in ``values`` to also match records
 * that have no value set for the field.
 */
export type CustomFieldFilterInput = {
  fieldId: Scalars['ID']['input'];
  values: Array<Scalars['String']['input']>;
};

export type CustomFieldOptionSelectDef = Node & {
  __typename: 'CustomFieldOptionSelectDef';
  customMultiSelectValues: CustomTicketValuesDefConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  metaValue: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  preSelected: Scalars['Boolean']['output'];
  ticketcustomfieldCustomFields: TicketCustomFieldDefConnection;
  ticketcustomvalueSet: CustomTicketValuesDefConnection;
};


export type CustomFieldOptionSelectDefCustomMultiSelectValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomFieldOptionSelectDefTicketcustomfieldCustomFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomFieldOptionSelectDefTicketcustomvalueSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomFieldOptionSelectInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  metaValue: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  preSelected: Scalars['Boolean']['input'];
};

export type CustomFieldTicketTypeInput = {
  connection?: InputMaybe<Scalars['ID']['input']>;
  customFieldId: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomTicketValuesDef = Node & {
  __typename: 'CustomTicketValuesDef';
  customFieldConnection?: Maybe<TicketTypeCustomFieldsConnection>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  multiSelectValue?: Maybe<Array<Maybe<CustomFieldOptionSelectDef>>>;
  numberValue?: Maybe<Scalars['Float']['output']>;
  selectValue?: Maybe<CustomFieldOptionSelectDef>;
  textValue?: Maybe<Scalars['String']['output']>;
  ticket: TicketDef;
};

export type CustomTicketValuesDefConnection = {
  __typename: 'CustomTicketValuesDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomTicketValuesDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CustomTicketValuesDef` and its cursor. */
export type CustomTicketValuesDefEdge = {
  __typename: 'CustomTicketValuesDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CustomTicketValuesDef>;
};

export type CustomerFunctionDef = Node & {
  __typename: 'CustomerFunctionDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  wh2Id?: Maybe<Scalars['String']['output']>;
};

export type CustomerFunctionDefConnection = {
  __typename: 'CustomerFunctionDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerFunctionDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CustomerFunctionDef` and its cursor. */
export type CustomerFunctionDefEdge = {
  __typename: 'CustomerFunctionDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerFunctionDef>;
};

export type CustomerItemSnapshotDef = Node & {
  __typename: 'CustomerItemSnapshotDef';
  address: Scalars['String']['output'];
  batch: SnapshotBatchDef;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerId: Scalars['Int']['output'];
  /** What happened during sync for this specific item */
  externalSyncMessage: Scalars['String']['output'];
  /** Status of this specific item sync */
  externalSyncStatus: EvolutionCustomerItemSnapshotExternalSyncStatusChoices;
  externalSyncStatusDisplay?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type CustomerItemSnapshotDefConnection = {
  __typename: 'CustomerItemSnapshotDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerItemSnapshotDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CustomerItemSnapshotDef` and its cursor. */
export type CustomerItemSnapshotDefEdge = {
  __typename: 'CustomerItemSnapshotDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerItemSnapshotDef>;
};

/**
 * Flat list of customer map points for the Individuals/Companies lists.
 *
 * PRO-331 decision 1. Mirrors ClusteredPropertyMapDef's ``points`` shape but
 * without the clustering machinery (which needs a materialized
 * ClusterMember table) — customer volume is modest and a flat list keeps the
 * read path light. Shared by ``contactMap`` (Individuals list, backed by
 * ContactDef) and ``propertyManagementCompanyMap`` (Companies list, backed by
 * PropertyManagementCompanyDef), which the two lists query separately just as
 * they do for their tables (allContacts vs allPropertyManagementCompanies).
 */
export type CustomerMapDef = {
  __typename: 'CustomerMapDef';
  points?: Maybe<Array<CustomerMapPointDef>>;
};

/**
 * A single plottable customer (Individual or Company) on the map.
 *
 * PRO-331: neither a Contact nor a PropertyManagementCompany carries
 * coordinates of its own — this point is derived from a linked property's
 * location (see resolve_contact_map / resolve_property_management_company_map).
 * ``id`` is the global id of the source Def (ContactDef or
 * PropertyManagementCompanyDef) so the frontend pin popup can load the
 * customer and link to its single view.
 */
export type CustomerMapPointDef = {
  __typename: 'CustomerMapPointDef';
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CustomerNoteDef = Node & {
  __typename: 'CustomerNoteDef';
  /** User who created this note */
  author?: Maybe<UserType>;
  authorName?: Maybe<Scalars['String']['output']>;
  authorityEntry: Scalars['Boolean']['output'];
  contact: ContactDef;
  /** The note content */
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** End of visibility period (required for scheduled notes) */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  excerpt?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  noteType?: Maybe<CustomerNoteType>;
  /** Start of visibility period (required for scheduled notes) */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** User who last updated this note */
  updatedBy?: Maybe<UserType>;
  visibilityLevels?: Maybe<Array<Maybe<NoteVisibility>>>;
};

export type CustomerNoteDefConnection = {
  __typename: 'CustomerNoteDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerNoteDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CustomerNoteDef` and its cursor. */
export type CustomerNoteDefEdge = {
  __typename: 'CustomerNoteDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerNoteDef>;
};

/**
 * Type of a CustomerNote.
 *
 *     - PERMANENT: always visible; date fields ignored at visibility time.
 *     - SCHEDULED: visible only between start_date and end_date (inclusive).
 *
 */
export enum CustomerNoteType {
  PERMANENT = 'PERMANENT',
  SCHEDULED = 'SCHEDULED'
}

/**
 * The customer-request detail row (see ``crm.models.customer_request``).
 * The ticket-carried parts of the request (skip type, waste type, the
 * requested window, the placement note) are resolved off the ticket so
 * the FE reads one object.
 */
export type CustomerRequestDef = Node & {
  __typename: 'CustomerRequestDef';
  addressLine: Scalars['String']['output'];
  city: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  containerType?: Maybe<ContainerTypeType>;
  convertedRentalTicket?: Maybe<TicketDef>;
  createdAt: Scalars['DateTime']['output'];
  /** PRIVATE | BUSINESS. */
  customerType: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  externalAddressId: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  indicativePriceSnapshot?: Maybe<Scalars['GenericScalar']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** PRODUCT-488: the requester placed the skip on the public highway - a council permit is part of the booking. */
  onPublicRoad: Scalars['Boolean']['output'];
  periodEndDate?: Maybe<Scalars['Date']['output']>;
  periodStartDate?: Maybe<Scalars['Date']['output']>;
  phone: Scalars['String']['output'];
  placementNote?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  registryNumber: Scalars['String']['output'];
  rejectionReason: Scalars['String']['output'];
  /** RECEIVED | ACCEPTED | REJECTED, derived from the ticket. */
  status: Scalars['String']['output'];
  ticket: TicketDef;
  updatedAt: Scalars['DateTime']['output'];
  wasteFraction?: Maybe<WasteFractionType>;
};

/** What ``acceptCustomerRequest`` would do for this request. */
export type CustomerRequestPreviewDef = {
  __typename: 'CustomerRequestPreviewDef';
  addressIssues: Array<Scalars['String']['output']>;
  /** The address can be turned into a property without a lookup: it has coordinates or matches an existing property. */
  addressValid: Scalars['Boolean']['output'];
  /** Units of the requested skip type bookable over the requested window (the same STRICT gate the booking runs); null when it could not be computed. */
  availableUnits?: Maybe<Scalars['Int']['output']>;
  /** REGISTRY_NUMBER | EMAIL | null (no match). */
  contactMatchedBy?: Maybe<Scalars['String']['output']>;
  /** True when Accept will book other dates than the requester asked for - show them before the office confirms. */
  datesAdjusted: Scalars['Boolean']['output'];
  /** The return day Accept will book; moves with the start when the requested one lies before it. Null for a sale. */
  effectivePeriodEndDate?: Maybe<Scalars['Date']['output']>;
  /** The delivery day Accept will book: the requested day, or today when that day has already passed (PRO-1009). */
  effectivePeriodStartDate?: Maybe<Scalars['Date']['output']>;
  /** The company's property at the requested address (register id, address line or coordinates) Accept would reuse; null = a property will be created. */
  existingProperty?: Maybe<PropertyDef>;
  /** The quote the requester was shown when submitting. */
  indicativePrice?: Maybe<Scalars['GenericScalar']['output']>;
  /** Existing contacts that look like the requester (registry number first, then e-mail). Accept reuses the first unless contactId overrides. */
  matchingContacts: Array<ContactDef>;
  /** PRO-1010: the property at the address belongs to another payer; Accept refuses the address match unless the office names the property (propertyId). */
  propertyHasOtherPayer: Scalars['Boolean']['output'];
  request: CustomerRequestDef;
  ticket: TicketDef;
  willCreateContact: Scalars['Boolean']['output'];
  willCreateProperty: Scalars['Boolean']['output'];
};

/**
 * One CVR registry record, normalised for the account create form
 * (S2-O1). Field-for-field the shape ``services.cvr.CvrCompanyInfo``
 * carries — the FE fills the existing PMC mutation from it.
 */
export type CvrCompanyInfoDef = {
  __typename: 'CvrCompanyInfoDef';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyType?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  cvr: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  productionUnits?: Maybe<Array<Scalars['String']['output']>>;
  protected?: Maybe<Scalars['Boolean']['output']>;
};

export type DkdpCompanyCredentialsDef = Node & {
  __typename: 'DKDPCompanyCredentialsDef';
  /** API token for DKDP system */
  apiToken: Scalars['String']['output'];
  certFile: Scalars['String']['output'];
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isTestEnv: Scalars['Boolean']['output'];
  keyFile: Scalars['String']['output'];
  /** CVR for sender */
  senderCvr: Scalars['String']['output'];
};

export type DkdpCompanyCredentialsMutationInput = {
  /** API token for DKDP system */
  apiToken: Scalars['String']['input'];
  certFile?: InputMaybe<Scalars['Upload']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dkdpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  keyFile?: InputMaybe<Scalars['Upload']['input']>;
  /** CVR for sender */
  senderCvr: Scalars['String']['input'];
};

export type DkdpCompanyCredentialsMutationPayload = {
  __typename: 'DKDPCompanyCredentialsMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dKDPCompanyCredentials?: Maybe<DkdpCompanyCredentialsDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type DashboardConfig = {
  __typename: 'DashboardConfig';
  place?: Maybe<DashboardConfigPlace>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum DashboardConfigPlace {
  HOME = 'home'
}

export type DashboardDef = Node & {
  __typename: 'DashboardDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  editUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  metabaseId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rolesCanView: CompanyRoleDefConnection;
  updatedAt: Scalars['DateTime']['output'];
  viewUrl?: Maybe<Scalars['String']['output']>;
};


export type DashboardDefRolesCanViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardDefConnection = {
  __typename: 'DashboardDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DashboardDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `DashboardDef` and its cursor. */
export type DashboardDefEdge = {
  __typename: 'DashboardDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DashboardDef>;
};

export type DashboardResult = {
  __typename: 'DashboardResult';
  dashboard?: Maybe<DashboardType>;
  droppedWidgets?: Maybe<Array<Scalars['String']['output']>>;
  error?: Maybe<Scalars['String']['output']>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/** A validated set of normalised widgets returned by generateInsightsDashboard. */
export type DashboardSpec = {
  __typename: 'DashboardSpec';
  widgets: Array<NormalizedWidget>;
};

export type DashboardSubscriptionResult = {
  __typename: 'DashboardSubscriptionResult';
  error?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<DashboardSubscriptionType>;
};

export type DashboardSubscriptionType = {
  __typename: 'DashboardSubscriptionType';
  attachFormat?: Maybe<Scalars['String']['output']>;
  cadence?: Maybe<Scalars['String']['output']>;
  dashboardId: Scalars['ID']['output'];
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  dayOfWeek?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  nextRunAt?: Maybe<Scalars['String']['output']>;
  recipients?: Maybe<Array<Scalars['String']['output']>>;
  sendHour?: Maybe<Scalars['Int']['output']>;
  sendMinute?: Maybe<Scalars['Int']['output']>;
  skipIfEmpty?: Maybe<Scalars['Boolean']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  widgetIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type DashboardTableType = {
  __typename: 'DashboardTableType';
  detail?: Maybe<Scalars['String']['output']>;
  exposed: Scalars['Boolean']['output'];
  kind: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  relation: Scalars['String']['output'];
};

/**
 * A persisted dashboard (W6.1): one spec object shared by AI,
 * builder and every surface (ADR-INT-005).
 */
export type DashboardType = {
  __typename: 'DashboardType';
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  canShare?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sharedWithTeamIds?: Maybe<Array<Scalars['ID']['output']>>;
  spec: Scalars['GenericScalar']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type DateRangeField = {
  __typename: 'DateRangeField';
  lower?: Maybe<Scalars['Date']['output']>;
  upper?: Maybe<Scalars['Date']['output']>;
};

/**
 * Time window: a sliding ``last_days``, an absolute ``start``/``end``
 * (ISO dates), OR a named calendar ``period`` (this_month / ytd / …),
 * mirroring plan_schema.DateRange. last_days is no longer required so an
 * absolute range (e.g. a "Q1 2026" saved tile) can round-trip through the
 * widget resolver — it used to be dropped here, so a calendar-period tile
 * silently ran with no window. ``period`` must likewise be a first-class
 * input field: without it, a period picked in Explore is dropped on the
 * GraphQL wire and the plan runs all-time (a fabricated, unlabelled
 * window). Provide exactly one form; ``_resolve_widget`` forwards
 * whichever is set and QueryPlan resolves ``period`` to concrete bounds.
 */
export type DateRangeInput = {
  end?: InputMaybe<Scalars['String']['input']>;
  lastDays?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Admin: hide a condition type from pickers via soft-delete. Never
 * hard-deletes the row (history rows PROTECT-reference it).
 */
export type DeactivateConditionType = {
  __typename: 'DeactivateConditionType';
  conditionType?: Maybe<ConditionTypeType>;
};

/**
 * Wave 2 Lane E S5: the batch rollback. Every LIVE flow whose
 * ACTIVATED audit row carries `batchLabel` is demoted LIVE -> SHADOW
 * (dry: it keeps watching, fires nothing) and its superseded source
 * rules resume automatically inside the same state transition
 * (`Flow.promote_to`'s centralized bookkeeping) -- so "switch the
 * afternoon off again" is one call and no transition is ever left
 * handled by neither side. SHADOW, not ARCHIVED, on purpose: archiving
 * is terminal, and a rollback is a pause for inspection, not a verdict.
 * Killed flows are reported and left alone (the kill already resumed
 * their rules); rows in any other state are named, never silently
 * skipped. Each demotion writes its own DEMOTED audit row carrying the
 * batch label.
 */
export type DeactivateConvertedFlows = {
  __typename: 'DeactivateConvertedFlows';
  deactivatedCount: Scalars['Int']['output'];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  results: Array<AutopilotEstateActivationResultType>;
  resumedRuleCount: Scalars['Int']['output'];
};

/**
 * Admin: hide a key type from pickers via soft-delete (PRO-367).
 *
 * Never hard-deletes — an issued ``PhysicalKey`` must always resolve its
 * type. Seeded kinds are the canonical library and stay read-only
 * (PRO-358 contract); only company-defined kinds can be deactivated.
 */
export type DeactivateKeyType = {
  __typename: 'DeactivateKeyType';
  keyType?: Maybe<KeyTypeType>;
};

/**
 * Admin: hide a part type from pickers via soft-delete. Never
 * hard-deletes the row.
 */
export type DeactivatePartType = {
  __typename: 'DeactivatePartType';
  partType?: Maybe<PartTypeType>;
};

/**
 * Soft-delete a company appliance-catalogue option (mirrors
 * deactivatePartType). Never hard-deletes, so surveys that already stored the
 * option name stay legible.
 */
export type DeactivateWasteWaterApplianceOption = {
  __typename: 'DeactivateWasteWaterApplianceOption';
  applianceOption?: Maybe<WasteWaterApplianceOptionDef>;
};

export type DebtorExportDef = Node & {
  __typename: 'DebtorExportDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  error: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: CrmDebtorExportStatusChoices;
};

export type DebtorExportDefConnection = {
  __typename: 'DebtorExportDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DebtorExportDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `DebtorExportDef` and its cursor. */
export type DebtorExportDefEdge = {
  __typename: 'DebtorExportDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DebtorExportDef>;
};

export type DecideApprovalPayload = {
  __typename: 'DecideApprovalPayload';
  approval: ApprovalDef;
};

/**
 * Approve or reject one paused, approval-required flow run (the
 * pause-for-approval runtime story).
 *
 * Mirrors `KillAutopilotFlow`'s auth + company scoping exactly: the same
 * `@login_required`, the same per-tenant flag gate, and the approval is
 * fetched *scoped to the caller's company* (`_get_tenant_pending_approval`)
 * so a caller can only ever decide their own tenant's approvals -- a
 * foreign approval is indistinguishable from a nonexistent one.
 *
 * APPROVE resumes the run at the paused step
 * (`autopilot.runtime.executor.resume_flow_run_after_approval`): the
 * action dispatches for real with `approved=True` and the run continues
 * from the snapshotted context. REJECT declines it
 * (`reject_flow_run_after_approval`): the action never runs and the run
 * fails. Both are idempotent -- deciding an already-decided approval is a
 * business error here (`ok=False`) rather than a second execution, and the
 * service functions themselves also no-op on a non-PENDING row as a second
 * line of defense.
 */
export type DecideAutopilotApproval = {
  __typename: 'DecideAutopilotApproval';
  approval?: Maybe<AutopilotPendingApprovalType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  flowRun?: Maybe<AutopilotFlowRunType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Office decision on a pending proposal: approve (optionally
 * adjusting the effective date) or reject with a note. Approval applies
 * the change in one transaction, from the effective date only.
 */
export type DecideRouteChange = {
  __typename: 'DecideRouteChange';
  proposal?: Maybe<ChangeProposalDef>;
};

/**
 * SBX-521: answer (or re-answer) the case's orienting question,
 * "What are you bringing in?", with one of the six import use
 * cases. The declaration tunes the manifest expectations (a
 * handover expects no vehicle file; a calendar update expects only
 * a calendar and goes straight to the diff); the go-live door is
 * physics and is never tuned by a declaration.
 */
export type DeclareImportCasePurposeMutation = {
  __typename: 'DeclareImportCasePurposeMutation';
  importCase?: Maybe<ImportCaseDef>;
};

/**
 * Run the RS-E22 grammar decode engine over a case (blueprint
 * stage C): route-calendar tables become evidence-cited
 * GrammarClaim rows, upserted by (kind, key). Deterministic first
 * and always; ``useFrontier`` opts below-threshold drafts into the
 * frontier assist (D54, model registry, degrade recorded). Human
 * confirmed or corrected claims are never silently changed:
 * divergences land in ``conflicts``.
 */
export type DecodeImportCaseMutation = {
  __typename: 'DecodeImportCaseMutation';
  anomalies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  claims?: Maybe<Array<Maybe<GrammarClaimDef>>>;
  conflicts?: Maybe<Scalars['GenericScalar']['output']>;
  createdCount?: Maybe<Scalars['Int']['output']>;
  importCase?: Maybe<ImportCaseDef>;
  retiredCount?: Maybe<Scalars['Int']['output']>;
  superseded?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  unchangedCount?: Maybe<Scalars['Int']['output']>;
  updatedCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * Retire N spare parts from this warehouse's count (A1, PRO-207):
 * terminal, irreversible, mandatory reason - the spare-part
 * counterpart of DecommissionStock. Ticketless; the audit lives in the
 * DECOMMISSION ledger row. A mistaken decommission is corrected by a
 * new adjustment (recount), never reinstated.
 */
export type DecommissionSpareParts = {
  __typename: 'DecommissionSpareParts';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Retire N anonymous units of an item type from this warehouse's
 * count (ADR-0005): terminal, irreversible, mandatory reason. A
 * mistaken decommission is corrected by a new adjustment (recount) -
 * there is deliberately no reinstate. Identity-level decommission of
 * a returning container happens at Confirm arrival (the scrap call),
 * never here.
 */
export type DecommissionStock = {
  __typename: 'DecommissionStock';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteAgreementTemplate = {
  __typename: 'DeleteAgreementTemplate';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteAlertRule = {
  __typename: 'DeleteAlertRule';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteArchivalRule = {
  __typename: 'DeleteArchivalRule';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Permanently delete ONE archived record — the one irreversible path
 * in the feature. Refuses non-archived rows, and refuses when a CASCADE
 * child of an archivable type is still ACTIVE (see
 * ``archiving.active_dependent_blocker_pks``): archive or delete the
 * dependents first. Archived dependents and truly-owned non-archivable
 * children (notes, link rows) cascade with the record by design.
 */
export type DeleteArchivedRecord = {
  __typename: 'DeleteArchivedRecord';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteArea = {
  __typename: 'DeleteArea';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * HARD-delete one never-activated draft flow (Builder V2 item 1(h)).
 *
 * Allowed ONLY when all of `_flow_delete_refusal`'s conditions hold:
 * `draft` state, no lifecycle history out of draft, zero `FlowRun`s, zero
 * pending approvals. Anything else refuses with one plain-words sentence
 * the FE renders verbatim (`ok=False` + `errors`, never a GraphQL
 * exception). RBAC `automation__edit` via the module's standard probe;
 * tenant-scoped lookup, so a foreign flow id is indistinguishable from a
 * missing one.
 *
 * Audit (investigated, reused, nothing invented): `FlowAuditLogEntry` is
 * the module's own audit table but its `flow` FK is CASCADE -- a
 * deletion row written there would die in the very cascade it documents
 * (verified, not guessed). The surviving record therefore goes through
 * the platform's append-only audit ledger `product.audit_logs`
 * (`emit_audit_row` -- the same D23/W6-P1 path
 * `schema_ticket_config.UpdateTicketTypeRequirements` uses), carrying
 * who/when/flow name plus the full definition snapshot in `diff`. Because
 * `emit_audit_row` is best-effort by contract (it never raises), and this
 * is the one write whose audit row is the only record left afterwards,
 * the row's existence is VERIFIED before the delete: no audit row, no
 * deletion. Same honest caveat as W6-P1: those rows are DB/forensic
 * audit; the System History UI does not currently render this category.
 *
 * Concurrency (review fix, BLOCKING): lookup, guards, snapshot and
 * delete all run INSIDE one `transaction.atomic()` on a
 * `select_for_update()` row -- the exact `ActivateConvertedFlows`
 * precedent (no `select_related`: Postgres refuses FOR UPDATE on the
 * nullable side of the `current_version` outer join). An unlocked
 * check-then-delete had three real failures: a promote committing in
 * the window deleted a TEST/LIVE flow (the collector does NOT raise
 * PROTECT for a protecting row that is itself in the deletion set --
 * `ImpactRecord.flow` is OneToOne CASCADE, only its `.flow_version` is
 * PROTECT -- and a LIVE legacy-origin flow would leave the customer's
 * rule suspended pointing at a dead pk, with a ledger row recording
 * state:"draft", a forensic lie); a run created in the window raised an
 * uncaught `ProtectedError` (raw 500); a double-click's loser raw-500'd
 * or no-op-deleted with ok:true plus a duplicate ledger row. Now the
 * guards read the locked row's committed truth, a repeat delete finds
 * the row gone (honest not-found), and `flow.delete()` is wrapped so a
 * `ProtectedError`/`IntegrityError` rolls the WHOLE transaction back --
 * including the just-written ledger row, so no "deleted" record ever
 * survives for a flow that lives -- and refuses in plain words.
 *
 * Cascade safety (verified against the models, not assumed):
 * `FlowVersion.flow`/`FlowAuditLogEntry.flow` are CASCADE (versions and
 * in-table audit die with the flow -- the bulk cascade path bypasses
 * `FlowVersion.delete()`'s immutability guard by documented design);
 * `SimulationRun` cascades via its version; `AutopilotSuggestion.
 * built_flow` is SET_NULL; `ImpactRecord.flow` is OneToOne CASCADE (its
 * `.flow_version` PROTECT does not fire when the record itself is being
 * collected, per above -- which is exactly why the state/history guards
 * must run under the lock); the remaining PROTECT edges (`FlowRun.flow`,
 * `FlowRun.flow_version`) are empty by the preconditions above and
 * backstopped by the ProtectedError catch; and the flow's own
 * `current_version` pointer (PROTECT) is cleared first so the collector
 * never has to reason about a protected reference from inside the
 * deletion set.
 */
export type DeleteAutopilotFlow = {
  __typename: 'DeleteAutopilotFlow';
  deletedFlowId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Office-only: soft-delete a bonus model (D7). */
export type DeleteBonusModel = {
  __typename: 'DeleteBonusModel';
  ok: Scalars['Boolean']['output'];
};

export type DeleteCard = {
  __typename: 'DeleteCard';
  billingInformation?: Maybe<BillingInformationType>;
};

export type DeleteCollectionCalendar = {
  __typename: 'DeleteCollectionCalendar';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCollectionCalendarDate = {
  __typename: 'DeleteCollectionCalendarDate';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCollectionCalendarDeviation = {
  __typename: 'DeleteCollectionCalendarDeviation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCollectionCalendarWeek = {
  __typename: 'DeleteCollectionCalendarWeek';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Delete a collection location of an SCP (NEXUS-538). */
export type DeleteCollectionLocation = {
  __typename: 'DeleteCollectionLocation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCompanyContainerMetaType = {
  __typename: 'DeleteCompanyContainerMetaType';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteCompanyEmailAccount = {
  __typename: 'DeleteCompanyEmailAccount';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteCompanyEmailAccountMessage = {
  __typename: 'DeleteCompanyEmailAccountMessage';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteCompanyEmailAccountRule = {
  __typename: 'DeleteCompanyEmailAccountRule';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Retire a holiday from the register.
 *
 * HSY-258: a soft-disable (``is_active = False``), never a row delete —
 * the register feeds route generation now, so the audit trail of what
 * used to be a non-working day must survive; the row can be re-enabled
 * through ``upsertCompanyHoliday(isActive: true)``. Office-only.
 */
export type DeleteCompanyHoliday = {
  __typename: 'DeleteCompanyHoliday';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCompanyMetaType = {
  __typename: 'DeleteCompanyMetaType';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteCompanyRole = {
  __typename: 'DeleteCompanyRole';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteComparisonSettingsMutation = {
  __typename: 'DeleteComparisonSettingsMutation';
  status?: Maybe<Scalars['String']['output']>;
};

/** Hard-delete a field. Refuses while another field is gated on it. */
export type DeleteCompostingNotificationField = {
  __typename: 'DeleteCompostingNotificationField';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Hard-delete one choice.
 *
 * Refuses to remove the last option of a choice field — a SELECT with no
 * options is unanswerable, and ``validate_field`` would flag the template as
 * broken on the very next read.
 */
export type DeleteCompostingNotificationFieldOption = {
  __typename: 'DeleteCompostingNotificationFieldOption';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Hard-delete a section and its fields.
 *
 * Refuses while any field OUTSIDE this section is gated on a field INSIDE
 * it — that gate would become a dangling reference and silently hide a
 * statutory question forever.
 */
export type DeleteCompostingNotificationSection = {
  __typename: 'DeleteCompostingNotificationSection';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Soft-delete the company's template, freeing the one-per-company slot. */
export type DeleteCompostingNotificationTemplate = {
  __typename: 'DeleteCompostingNotificationTemplate';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Soft-delete a row that should never have existed.
 *
 * NOT the way to record that composting stopped — that is ``End``, which
 * keeps the row and its history, which is what the statute expects. This is
 * for a data-entry mistake.
 *
 * Refuses to delete a row that has been renewed. ``predecessor`` is PROTECT
 * precisely so a statutory chain cannot be severed, and soft-deleting a
 * predecessor would sever it everywhere the UI looks even though the FK
 * survives.
 */
export type DeleteCompostingRegistryEntry = {
  __typename: 'DeleteCompostingRegistryEntry';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteContact = {
  __typename: 'DeleteContact';
  success: Scalars['Boolean']['output'];
};

export type DeleteContactAddress = {
  __typename: 'DeleteContactAddress';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteContactAuthorization = {
  __typename: 'DeleteContactAuthorization';
  contactAuthorization?: Maybe<ContactAuthorizationDef>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteContactFieldConfiguration = {
  __typename: 'DeleteContactFieldConfiguration';
  ok: Scalars['Boolean']['output'];
};

export type DeleteContactProperties = {
  __typename: 'DeleteContactProperties';
  contact?: Maybe<ContactDef>;
  numDeleted: Scalars['Int']['output'];
};

export type DeleteContainer = {
  __typename: 'DeleteContainer';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteContainerGroup = {
  __typename: 'DeleteContainerGroup';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteContainerNotification = {
  __typename: 'DeleteContainerNotification';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteContainerType = {
  __typename: 'DeleteContainerType';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Remove the rule for one pair - the pair is allowed again.
 * Idempotent: a pair without a rule is a no-op success.
 */
export type DeleteContainerTypeWasteFractionRule = {
  __typename: 'DeleteContainerTypeWasteFractionRule';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Office-only, audited: soft-remove a contract file (R2-S14). The row
 * survives (``deleted``/``deleted_by``) for the audit trail.
 */
export type DeleteContractAreaDocument = {
  __typename: 'DeleteContractAreaDocument';
  ok: Scalars['Boolean']['output'];
};

export type DeleteCostSettingsMutation = {
  __typename: 'DeleteCostSettingsMutation';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Remove one authority row; permits keep the authority name they
 * were recorded with.
 */
export type DeleteCouncilFeeEntry = {
  __typename: 'DeleteCouncilFeeEntry';
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteCustomerFunction = {
  __typename: 'DeleteCustomerFunction';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteCustomerNote = {
  __typename: 'DeleteCustomerNote';
  customerNote?: Maybe<CustomerNoteDef>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteDashboard = {
  __typename: 'DeleteDashboard';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteDashboardSubscription = {
  __typename: 'DeleteDashboardSubscription';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteDepot = {
  __typename: 'DeleteDepot';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteDocument = {
  __typename: 'DeleteDocument';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteDraftAutomationPayload = {
  __typename: 'DeleteDraftAutomationPayload';
  ok: Scalars['Boolean']['output'];
};

export type DeleteDriver = {
  __typename: 'DeleteDriver';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteExportTemplate = {
  __typename: 'DeleteExportTemplate';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteExternalMapLayer = {
  __typename: 'DeleteExternalMapLayer';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteFcmDevice = {
  __typename: 'DeleteFCMDevice';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteFeatureConfigRule = {
  __typename: 'DeleteFeatureConfigRule';
  batch?: Maybe<FeatureConfigBatchType>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteHauler = {
  __typename: 'DeleteHauler';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Office-only: soft-delete a compliance document (keeps the audit). */
export type DeleteHaulerComplianceDocument = {
  __typename: 'DeleteHaulerComplianceDocument';
  ok: Scalars['Boolean']['output'];
};

export type DeleteHaulerPrice = {
  __typename: 'DeleteHaulerPrice';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Soft-delete a price list (RD-46). Wraps
 * ``product.price_lists.service.delete_price_list``.
 */
export type DeleteHaulerPriceList = {
  __typename: 'DeleteHaulerPriceList';
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Soft-delete a price row (RD-46). Wraps
 * ``product.price_rows.service.delete_price_row`` — cascades any pending
 * schedule, preserves history.
 */
export type DeleteHaulerPriceRow = {
  __typename: 'DeleteHaulerPriceRow';
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteImportHistory = {
  __typename: 'DeleteImportHistory';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteInsightsAlert = {
  __typename: 'DeleteInsightsAlert';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteInsightsAnalysis = {
  __typename: 'DeleteInsightsAnalysis';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteInsightsBuilderDashboard = {
  __typename: 'DeleteInsightsBuilderDashboard';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteInsightsDashboard = {
  __typename: 'DeleteInsightsDashboard';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteInsightsExploration = {
  __typename: 'DeleteInsightsExploration';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteIntegrationGpsVehicle = {
  __typename: 'DeleteIntegrationGpsVehicle';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteKmdEasyPropertyTypeToKmdEasyStationCode = {
  __typename: 'DeleteKmdEasyPropertyTypeToKmdEasyStationCode';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteMeasurementSettings = {
  __typename: 'DeleteMeasurementSettings';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteMunicipality = {
  __typename: 'DeleteMunicipality';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteMyTemplatePayload = {
  __typename: 'DeleteMyTemplatePayload';
  ok: Scalars['Boolean']['output'];
};

export type DeleteNotificationSetting = {
  __typename: 'DeleteNotificationSetting';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Remove a permit record. A fee already billed at grant stays on
 * the customer's account (cancel the billable event separately).
 */
export type DeletePermit = {
  __typename: 'DeletePermit';
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DeletePickupSettingsMutation = {
  __typename: 'DeletePickupSettingsMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Deleting an area deletes its whole subtree (scenarios, plans,
 * baselines). SBX-537 P1-1 (wave D23): master-gated like every
 * other live-consequence door, refused by name while promotion
 * records exist under the area (they are audit history and their
 * plans are PROTECTed: pre-D23 this died as an unhandled 500), and
 * any other protected leaf refuses cleanly instead of crashing.
 */
export type DeletePlanningAreaMutation = {
  __typename: 'DeletePlanningAreaMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteProject = {
  __typename: 'DeleteProject';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteProperty = {
  __typename: 'DeleteProperty';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeletePropertyContact = {
  __typename: 'DeletePropertyContact';
  propertyContact?: Maybe<PropertyContactDef>;
};

export type DeletePropertyGroup = {
  __typename: 'DeletePropertyGroup';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Clear a property's explicit sync config; it reverts to the company /
 * payer-type default.
 *
 * Clears only the user-owned field (frequency) — the
 * task-owned watermarks (last_synced_*) are preserved so a previously-synced
 * property does NOT get treated as a first run and replay already-exported
 * invoices. Only rows that were never synced (no watermark) are hard-deleted.
 *
 * The default cadence is applied to the property's billing schedules and
 * recurring fees right away (``cadence_transition``), exactly like setting
 * it explicitly through ``UpsertPropertyInvoiceSyncConfig`` - the same
 * single writer, so the export gate and the fee generator never disagree
 * on the cadence.
 */
export type DeletePropertyInvoiceSyncConfig = {
  __typename: 'DeletePropertyInvoiceSyncConfig';
  /** Set when an explicit cadence was cleared and the effective default was applied to the property's schedules and fees (all zeros when no charge had to move); null when there was no explicit cadence to clear, and when the company has invoicing or product pricing switched off. */
  cadenceTransition?: Maybe<RecurringFeeCadenceTransitionDef>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  property?: Maybe<PropertyDef>;
};

export type DeletePropertyManagementCompany = {
  __typename: 'DeletePropertyManagementCompany';
  success: Scalars['Boolean']['output'];
};

export type DeletePropertyManagementCompanyAddress = {
  __typename: 'DeletePropertyManagementCompanyAddress';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePropertyNote = {
  __typename: 'DeletePropertyNote';
  propertyNote?: Maybe<PropertyNoteDef>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePropertyType = {
  __typename: 'DeletePropertyType';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Remove a recorded authority decision (NEXUS-704). Hard delete — the
 * statutory record lives with the authority; this row is a mirror.
 */
export type DeletePropertyWasteDecision = {
  __typename: 'DeletePropertyWasteDecision';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Office-only, audited: soft-delete a window (HSY 263) — the row stays
 * for the audit trail. Refused while the window's coverage touches a CLOSED
 * settlement period. ``deleted`` is False when it was already removed.
 */
export type DeleteReliabilityExclusionWindow = {
  __typename: 'DeleteReliabilityExclusionWindow';
  deleted: Scalars['Boolean']['output'];
};

export type DeleteReportTemplate = {
  __typename: 'DeleteReportTemplate';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/**
 * Scenarios are consequence-free; deleting one never touches a
 * live entity (PRD section 5). Promoted scenarios must be kept for
 * audit and are rejected.
 */
export type DeleteScenarioMutation = {
  __typename: 'DeleteScenarioMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Office-only: cancel a NOT-YET-EFFECTIVE scheduled change (PRO-467). An
 * effect already in force is part of the settlement history and cannot be
 * removed here.
 */
export type DeleteScheduledExceptionCompensationEffect = {
  __typename: 'DeleteScheduledExceptionCompensationEffect';
  ok: Scalars['Boolean']['output'];
};

export type DeleteScheduledExport = {
  __typename: 'DeleteScheduledExport';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteScheduledExtract = {
  __typename: 'DeleteScheduledExtract';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Delete a custom SCP role. System and in-use roles are protected. */
export type DeleteScpRoleDefinition = {
  __typename: 'DeleteScpRoleDefinition';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteService = {
  __typename: 'DeleteService';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteServiceResponsibility = {
  __typename: 'DeleteServiceResponsibility';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteSparePart = {
  __typename: 'DeleteSparePart';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Soft-delete dataset ``id``. ``error``: ``DATASET_IN_USE`` while a
 * builder dashboard (not deleted) reads it, with those dashboards in
 * ``usedOn``; ``DATASET_NOT_FOUND`` for an unknown or deleted id.
 */
export type DeleteSqlDataset = {
  __typename: 'DeleteSqlDataset';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  usedOn: Array<SqlDatasetAdminUseType>;
};

/**
 * 3.6.23: user-facing deletion of a task/emptying (PickUpOrder).
 *
 * Soft-deletes the stop (``deleted`` timestamp, hidden from every active
 * list via ``PickUpOrderQuerySet.active()``) and records it centrally in
 * the DeletionLog. The reason is MANDATORY — deleting an emptying carries
 * financial/contractual weight (the reklamaatio case).
 *
 * Billing: an emptying whose billable event is already INVOICED cannot be
 * deleted (corrections go through a credit note); pre-invoice events are
 * cancelled via the LEDGER-755 cancel-not-delete path, mirroring how an
 * uncompleted stop retracts its charge.
 */
export type DeleteTask = {
  __typename: 'DeleteTask';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteTeam = {
  __typename: 'DeleteTeam';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteTicketCategory = {
  __typename: 'DeleteTicketCategory';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteTicketCustomFieldMutation = {
  __typename: 'DeleteTicketCustomFieldMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTicketMessageTemplate = {
  __typename: 'DeleteTicketMessageTemplate';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteTicketType = {
  __typename: 'DeleteTicketType';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Remove an area rule; the type's own default applies again. */
export type DeleteTicketTypeAreaExecutionWindowMutation = {
  __typename: 'DeleteTicketTypeAreaExecutionWindowMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteUser = {
  __typename: 'DeleteUser';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteUserAbsence = {
  __typename: 'DeleteUserAbsence';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteUserFilterCollection = {
  __typename: 'DeleteUserFilterCollection';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteUserProject = {
  __typename: 'DeleteUserProject';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteVehicle = {
  __typename: 'DeleteVehicle';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteVehicleAbsence = {
  __typename: 'DeleteVehicleAbsence';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteVehicleType = {
  __typename: 'DeleteVehicleType';
  vehicleType?: Maybe<VehicleTypeType>;
};

export type DeleteWasteCollector = {
  __typename: 'DeleteWasteCollector';
  wasteCollector?: Maybe<WasteCollectorType>;
};

export type DeleteWasteFraction = {
  __typename: 'DeleteWasteFraction';
  status?: Maybe<Scalars['String']['output']>;
};

/** PRO-946: delete a version that is not yet locked. */
export type DeleteWasteFractionEnvironmentalFactor = {
  __typename: 'DeleteWasteFractionEnvironmentalFactor';
  ok: Scalars['Boolean']['output'];
};

export type DeleteWasteType = {
  __typename: 'DeleteWasteType';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeleteZone = {
  __typename: 'DeleteZone';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteZoneLabel = {
  __typename: 'DeleteZoneLabel';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * One DeletionLog row (req 3.6.23) — the central record of a
 * user-facing deletion, surfaced in Settings > System history (the
 * "Deleted" tab and the merged event log) and in per-record change logs.
 *
 * Deliberately FLAT: every column is a scalar denormalized at write time
 * (mirrors ProductManagementEventDef / pp_audit_logs). No relation fields
 * — the FE renders ``deletedByName`` etc. directly, so a page of rows is
 * a single table scan with no per-row resolution.
 */
export type DeletionEventDef = Node & {
  __typename: 'DeletionEventDef';
  action: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  deletedBy: Scalars['String']['output'];
  deletedByName?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['String']['output'];
  entityReference?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  reasonCategory?: Maybe<Scalars['String']['output']>;
  reasonText?: Maybe<Scalars['String']['output']>;
};

export type DeletionEventDefConnection = {
  __typename: 'DeletionEventDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DeletionEventDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `DeletionEventDef` and its cursor. */
export type DeletionEventDefEdge = {
  __typename: 'DeletionEventDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DeletionEventDef>;
};

/**
 * RS-1001/RS-1002 surface. ``status``: published (a forecast run
 * persisted rows, EV-FORECAST gated), priors_only (nothing
 * persisted; cold-start priors computed on the fly, D04: never gate
 * on missing telemetry), or no_stops.
 */
export type DemandForecastDef = {
  __typename: 'DemandForecastDef';
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  rows?: Maybe<Array<ForecastRowDef>>;
  status: Scalars['String']['output'];
};

export type DemoInvitation = {
  __typename: 'DemoInvitation';
  status?: Maybe<Scalars['String']['output']>;
};

/** Describes the Depot, has relation to :model:`core.Company` and to :model:`core.Location` */
export type DepotType = Node & {
  __typename: 'DepotType';
  /** Current stopping place */
  activeVehicles: VehicleTypeConnection;
  amountOfTrucks?: Maybe<Scalars['Int']['output']>;
  capacityOfTrucks?: Maybe<Scalars['Int']['output']>;
  /** End of working period */
  closingTime?: Maybe<Scalars['Time']['output']>;
  /** PRO-389: additional contractors with owner-scoped operational access to this depot, alongside the main owner (`ownedBy`). Empty for a single-owner or company-owned depot. */
  coOwners?: Maybe<Array<HaulerDef>>;
  /** Hex color code */
  color?: Maybe<Scalars['String']['output']>;
  /** Relation to the Comment */
  comments: CommentTypeConnection;
  /** Company of this Depot */
  company: CompanyType;
  /** Contact in this Depot */
  contactPerson?: Maybe<ContactPersonType>;
  containerSet: ContainerTypeConnection;
  /** PRO-282: contractors (haulers) this location is assigned to / can be used by. An ACCESS/assignment concept, independent of stock ownership (`ownedBy`) and owner-access (`coOwners`) — the three coexist. Applies to every depot type; empty means a company location. */
  contractors?: Maybe<Array<HaulerDef>>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  depotType?: Maybe<Scalars['String']['output']>;
  depots: PickUpOrderTypeConnection;
  /** Description of the depot */
  description?: Maybe<Scalars['String']['output']>;
  /** Depot as a end location */
  endLocation: DriverTypeConnection;
  /** Radius of geofence in meters */
  geofenceRadius?: Maybe<Scalars['Int']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Stock in transit on this warehouse's behalf (incoming plus outgoing). null for non-storage depots. */
  inTransitTotal?: Maybe<Scalars['Int']['output']>;
  /** When this warehouse last saw a stock movement, or null if it never has (or is not a storage depot). */
  lastMovementAt?: Maybe<Scalars['DateTime']['output']>;
  /** Location where Depot is situated */
  location: LocationWithContainerType;
  logo?: Maybe<Scalars['String']['output']>;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  /** Depot's naming */
  name: Scalars['String']['output'];
  /** Total stock on hand across all item types for a container-storage warehouse (the counted-stock ledger sum). null for non-storage depots. */
  onHandTotal?: Maybe<Scalars['Int']['output']>;
  /** Start of working period */
  openingTime?: Maybe<Scalars['Time']['output']>;
  /** Hauler that owns this depot's stock when it acts as a container-storage warehouse. Null means company-owned. */
  ownedBy?: Maybe<HaulerDef>;
  routeSettings: RouteSettingsTypeConnection;
  /** Depot as a start location */
  startLocation: DriverTypeConnection;
  /**
   *
   *             Indicates if the depot is open or closed. Not enough data is signified by the 'unknown' status.
   *             Can hold one of the following string values: 'open', 'closed', 'unknown'
   *
   */
  status?: Maybe<Scalars['String']['output']>;
  stockAlerts: Array<StockAlertEventDef>;
  /** Time to leave the facility */
  timeToLeaveTheFacility?: Maybe<Scalars['Time']['output']>;
  /** Time to unload truck */
  timeToUnloadTruck?: Maybe<Scalars['Time']['output']>;
  /** The waste station the load was tipped at; set at CLOSE */
  unloadedLoads: TruckloadTypeConnection;
  /** The waste station the load was really tipped at. */
  unloadedLoadsCorrected: TruckloadTypeConnection;
  unloadingRouteSchemes: RouteSchemeTypeConnection;
  unloadingRoutes: RouteTypeConnection;
  /** Stopping places */
  vehicles: VehicleTypeConnection;
  /** Relation to the WasteFraction */
  wasteFractions: WasteFractionTypeConnection;
  /** Resolved WasteHero unloading point, when known. */
  weighTickets: WeighTicketTypeConnection;
  workshopServiceDescription?: Maybe<Scalars['String']['output']>;
  workshopType?: Maybe<Scalars['String']['output']>;
};


/** Describes the Depot, has relation to :model:`core.Company` and to :model:`core.Location` */
export type DepotTypeActiveVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the Depot, has relation to :model:`core.Company` and to :model:`core.Location` */
export type DepotTypeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the Depot, has relation to :model:`core.Company` and to :model:`core.Location` */
export type DepotTypeContainerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the Depot, has relation to :model:`core.Company` and to :model:`core.Location` */
export type DepotTypeDepotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the Depot, has relation to :model:`core.Company` and to :model:`core.Location` */
export type DepotTypeEndLocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the Depot, has relation to :model:`core.Company` and to :model:`core.Location` */
export type DepotTypeRouteSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the Depot, has relation to :model:`core.Company` and to :model:`core.Location` */
export type DepotTypeStartLocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the Depot, has relation to :model:`core.Company` and to :model:`core.Location` */
export type DepotTypeUnloadedLoadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  openedAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the Depot, has relation to :model:`core.Company` and to :model:`core.Location` */
export type DepotTypeUnloadedLoadsCorrectedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  openedAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the Depot, has relation to :model:`core.Company` and to :model:`core.Location` */
export type DepotTypeUnloadingRouteSchemesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the Depot, has relation to :model:`core.Company` and to :model:`core.Location` */
export type DepotTypeUnloadingRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the Depot, has relation to :model:`core.Company` and to :model:`core.Location` */
export type DepotTypeVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the Depot, has relation to :model:`core.Company` and to :model:`core.Location` */
export type DepotTypeWasteFractionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the Depot, has relation to :model:`core.Company` and to :model:`core.Location` */
export type DepotTypeWeighTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DepotTypeConnection = {
  __typename: 'DepotTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DepotTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `DepotType` and its cursor. */
export type DepotTypeEdge = {
  __typename: 'DepotTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DepotType>;
};

export enum DescriptionActionEnum {
  APPEND = 'APPEND',
  REPLACE = 'REPLACE'
}

/**
 * Detach a container from an SCP (NEXUS-642): ends the attachment row;
 * the Container asset itself is never touched.
 */
export type DetachScpContainer = {
  __typename: 'DetachScpContainer';
  attachment?: Maybe<ScpContainerAttachmentDef>;
};

export type DetachSensorMutation = {
  __typename: 'DetachSensorMutation';
  status?: Maybe<Scalars['String']['output']>;
};

export type DeviationReasonCountType = {
  __typename: 'DeviationReasonCountType';
  count: Scalars['Int']['output'];
  /** A deviation-reason code, or 'unspecified'. */
  reason: Scalars['String']['output'];
};

/** An enumeration. */
export enum DeviceContainerBarcodeGenerationHistoryStatusChoices {
  /** Completed */
  COMPLETED = 'COMPLETED',
  /** Failed */
  FAILED = 'FAILED',
  /** In Progress */
  IN_PROGRESS = 'IN_PROGRESS'
}

/** An enumeration. */
export enum DeviceContainerConditionChoices {
  /** New */
  NEW = 'NEW',
  /** Used */
  USED = 'USED'
}

export enum DeviceContainerCustomEventTypesGraphene {
  PRINT_LABEL = 'PRINT_LABEL'
}

export enum DeviceContainerEventTypesGraphene {
  ARCHIVED_AT_CHANGE = 'ARCHIVED_AT_CHANGE',
  COLLECTION_CALENDAR_CHANGE = 'COLLECTION_CALENDAR_CHANGE',
  CONTAINER_ID_CHANGE = 'CONTAINER_ID_CHANGE',
  CONTAINER_TYPE_CHANGE = 'CONTAINER_TYPE_CHANGE',
  CUSTOM_FIELDS_CHANGE = 'CUSTOM_FIELDS_CHANGE',
  DESCRIPTION_CHANGE = 'DESCRIPTION_CHANGE',
  LOCATION_CHANGE = 'LOCATION_CHANGE',
  PICKUP_METHOD_CHANGE = 'PICKUP_METHOD_CHANGE',
  PICKUP_SETTING_CHANGE = 'PICKUP_SETTING_CHANGE',
  PROJECT_CHANGE = 'PROJECT_CHANGE',
  RFID_CHANGE = 'RFID_CHANGE',
  ROUTE_DESCRIPTION_CHANGE = 'ROUTE_DESCRIPTION_CHANGE',
  ROUTE_SCHEME_CHANGE = 'ROUTE_SCHEME_CHANGE',
  SENSOR_FILL_LEVEL_CHANGE = 'SENSOR_FILL_LEVEL_CHANGE',
  STATUS_CHANGE = 'STATUS_CHANGE',
  VEHICLE_CHANGE = 'VEHICLE_CHANGE',
  WASTE_FRACTION_CHANGE = 'WASTE_FRACTION_CHANGE'
}

/** An enumeration. */
export enum DeviceContainerIdGeneratorSettingsCompanyDisplayOptionChoices {
  /** First 2 Letters */
  FIRST_TWO = 'FIRST_TWO',
  /** Full */
  FULL = 'FULL',
  /** Slug */
  SLUG = 'SLUG'
}

/** An enumeration. */
export enum DeviceContainerIdGeneratorSettingsContainerTypeDisplayOptionChoices {
  /** First 2 Letters */
  FIRST_TWO = 'FIRST_TWO',
  /** Full */
  FULL = 'FULL',
  /** Slug */
  SLUG = 'SLUG'
}

/** An enumeration. */
export enum DeviceContainerIdGeneratorSettingsPickupSettingsDisplayOptionChoices {
  /** First 2 Letters */
  FIRST_TWO = 'FIRST_TWO',
  /** Full */
  FULL = 'FULL',
  /** Slug */
  SLUG = 'SLUG'
}

/** An enumeration. */
export enum DeviceContainerIdGeneratorSettingsWasteFractionDisplayOptionChoices {
  /** First 2 Letters */
  FIRST_TWO = 'FIRST_TWO',
  /** Full */
  FULL = 'FULL',
  /** Slug */
  SLUG = 'SLUG'
}

/** An enumeration. */
export enum DeviceContainerPickupMethodChoices {
  /** Dynamic */
  DYNAMIC = 'DYNAMIC',
  /** Disabled */
  NONE = 'NONE',
  /** Static */
  STATIC = 'STATIC'
}

/** An enumeration. */
export enum DeviceContainerStatusChoices {
  /** Available */
  AVAILABLE = 'AVAILABLE',
  /** Defect */
  DEFECT = 'DEFECT',
  /** Ended */
  ENDED = 'ENDED',
  /** Future */
  FUTURE = 'FUTURE',
  /** In storage */
  IN_STORAGE = 'IN_STORAGE',
  /** In transit */
  IN_TRANSIT = 'IN_TRANSIT',
  /** On hold */
  ON_HOLD = 'ON_HOLD'
}

/** An enumeration. */
export enum DeviceLorawanDeviceAntennaChoices {
  /** external */
  EXTERNAL = 'EXTERNAL',
  /** internal */
  INTERNAL = 'INTERNAL',
  /** undefined */
  UNDEFINED = 'UNDEFINED'
}

/** An enumeration. */
export enum DeviceMobileDeviceAntennaChoices {
  /** external */
  EXTERNAL = 'EXTERNAL',
  /** internal */
  INTERNAL = 'INTERNAL',
  /** undefined */
  UNDEFINED = 'UNDEFINED'
}

/** An enumeration. */
export enum DeviceSigFoxDeviceAntennaChoices {
  /** external */
  EXTERNAL = 'EXTERNAL',
  /** internal */
  INTERNAL = 'INTERNAL',
  /** undefined */
  UNDEFINED = 'UNDEFINED'
}

/** An enumeration. */
export enum DeviceTemporaryContainerLocationChangeTypeChoices {
  /** Location */
  LOCATION = 'LOCATION'
}

/** An enumeration. */
export enum DeviceTemporaryContainerLocationReasonChoices {
  /** Event */
  EVENT = 'EVENT',
  /** Poor road conditions (kelirikko) */
  KELIRIKKO = 'KELIRIKKO',
  /** Other */
  OTHER = 'OTHER',
  /** Roadworks */
  ROADWORKS = 'ROADWORKS'
}

export type DeviceToContainerInputObject = {
  customMeasurement?: InputMaybe<Scalars['Boolean']['input']>;
  deviceAngle?: InputMaybe<Scalars['Float']['input']>;
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  internalHeight?: InputMaybe<Scalars['Float']['input']>;
  lid?: InputMaybe<Scalars['String']['input']>;
  measurementId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};

export type DeviceToContainerType = Node & {
  __typename: 'DeviceToContainerType';
  container: ContainerType;
  device?: Maybe<BaseDeviceInterface>;
  deviceAngle?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  filllevelmeasurementSet?: Maybe<FillLevelMeasurementTypeConnection>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  internalHeight: Scalars['Float']['output'];
  measurementSettings?: Maybe<MeasurementSettingsType>;
  notificationSet: NotificationsTypeConnection;
  objectId: Scalars['Int']['output'];
  offset: Scalars['Float']['output'];
  sideLid: Scalars['Boolean']['output'];
  startDate: Scalars['DateTime']['output'];
  topLid: Scalars['Boolean']['output'];
};


export type DeviceToContainerTypeFilllevelmeasurementSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  fillLevelFromLastestMonth?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DeviceToContainerTypeNotificationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status_Iexact?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceToContainerTypeConnection = {
  __typename: 'DeviceToContainerTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DeviceToContainerTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DeviceToContainerType` and its cursor. */
export type DeviceToContainerTypeEdge = {
  __typename: 'DeviceToContainerTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DeviceToContainerType>;
};

export type DeviceTypeType = Node & {
  __typename: 'DeviceTypeType';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  lorawandeviceSet: LorawanDeviceTypeConnection;
  maxFillLevel: Scalars['Float']['output'];
  minFillLevel: Scalars['Float']['output'];
  mobiledeviceSet: MobileDeviceTypeConnection;
  name: Scalars['String']['output'];
  sigfoxdeviceSet: SigFoxDeviceTypeConnection;
};


export type DeviceTypeTypeLorawandeviceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  devId_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DeviceTypeTypeMobiledeviceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  devId_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DeviceTypeTypeSigfoxdeviceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  devId_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceTypeTypeConnection = {
  __typename: 'DeviceTypeTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DeviceTypeTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DeviceTypeType` and its cursor. */
export type DeviceTypeTypeEdge = {
  __typename: 'DeviceTypeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DeviceTypeType>;
};

export type DirectFileUploadInput = {
  /** The name of the file with an extension. */
  fileName: Scalars['String']['input'];
  /** The size of the file in bytes. */
  fileSize: Scalars['Int']['input'];
  /** The MIME type of the file. */
  mimeType: Scalars['String']['input'];
};

export type DirectFileUploadStartInput = {
  /** The list of files to upload. */
  attachments: Array<InputMaybe<DirectFileUploadInput>>;
  /** The type of the object to which the file will be attached. */
  objectToAttachType: DirectUploadObjectTypes;
};

export type DirectFileUploadUrlDef = {
  __typename: 'DirectFileUploadUrlDef';
  /** The S3 ACL that was signed into the presigned URL. The client MUST send this exact value as the x-amz-acl header on the PUT, or the signature will not match. */
  acl: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  fileId: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type DirectImportUploadStartInput = {
  /** The list of files to upload. */
  attachments: DirectFileUploadInput;
};

export enum DirectUploadObjectTypes {
  COMPANY_EMAIL_ACCOUNT_MESSAGE_ATTACHMENT = 'COMPANY_EMAIL_ACCOUNT_MESSAGE_ATTACHMENT',
  CONTAINER_ATTACHMENT = 'CONTAINER_ATTACHMENT',
  GENERIC_FILE_LOCATION = 'GENERIC_FILE_LOCATION',
  PORTAL_FONT_ATTACHMENT = 'PORTAL_FONT_ATTACHMENT',
  PORTAL_LOGO_ATTACHMENT = 'PORTAL_LOGO_ATTACHMENT',
  PORTAL_SECTION_BACKGROUND_ATTACHMENT = 'PORTAL_SECTION_BACKGROUND_ATTACHMENT',
  PROPERTY_NOTE_ATTACHMENT = 'PROPERTY_NOTE_ATTACHMENT',
  TICKET_ATTACHMENT = 'TICKET_ATTACHMENT',
  TICKET_COMMENT_ATTACHMENT = 'TICKET_COMMENT_ATTACHMENT',
  TICKET_MESSAGE_ATTACHMENT = 'TICKET_MESSAGE_ATTACHMENT'
}

export type DirectionMatrixType = {
  __typename: 'DirectionMatrixType';
  destination: LocationWithContainerType;
  /** Real distance in meters */
  distance: Scalars['Int']['output'];
  /** Real duration in seconds */
  duration: Scalars['Float']['output'];
  /** Math generated duration in seconds */
  hardDuration: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  origin: LocationWithContainerType;
};

export type DisableAutomationEnginePayload = {
  __typename: 'DisableAutomationEnginePayload';
  settings: AutomationSettingsDef;
};

/**
 * Mark a suggestion DISMISSED -- the wave-off half of the suggestion
 * lifecycle (`AcceptAutopilotSuggestion` above is the built half). A
 * dismissed row stops appearing on Pulse and survives regeneration as
 * lifecycle memory, suppressing a re-pitch of the same (kind, ticket
 * type). Tenant-scoped; idempotent (re-dismissing is a no-op). Dismissing
 * an already-ACCEPTED row is a no-op too: the `built_flow` audit link
 * from pitch to automation is never erased by a stray dismiss.
 *
 * ``undo: true`` moves a DISMISSED row back to NEW -- and only that
 * transition (an accepted row stays accepted, a new row stays new) -- so
 * the frontend can offer an undo toast after a dismiss without a second
 * bespoke mutation. An undone row rejoins the ephemeral NEW pool: the
 * next nightly run replaces or retires it with everything else NEW.
 *
 * Both branches write with a conditional queryset UPDATE (status in the
 * WHERE clause), never read-modify-write: the status check and the write
 * are one statement, so racing the accept mutation can never strand an
 * ACCEPTED row (live ``built_flow``) back to DISMISSED, and racing the
 * nightly regeneration's delete answers not-found instead of a silent
 * zero-row ``save()`` reported as ok.
 */
export type DismissAutopilotSuggestion = {
  __typename: 'DismissAutopilotSuggestion';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * RS-1203 dismiss with audit; dismissal is the EV-RECS negative
 * label, so every dismissal sharpens the precision gate.
 */
export type DismissRecommendationMutation = {
  __typename: 'DismissRecommendationMutation';
  recommendation?: Maybe<RecommendationDef>;
};

/** One dispatch action, as the FE lane reads it (names never raw ids). */
export type DispatchActionDef = {
  __typename: 'DispatchActionDef';
  actionType: Scalars['String']['output'];
  actorName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  notifyStatus?: Maybe<Scalars['String']['output']>;
  params?: Maybe<Scalars['GenericScalar']['output']>;
  result?: Maybe<Scalars['GenericScalar']['output']>;
  routeId?: Maybe<Scalars['ID']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  stopId?: Maybe<Scalars['ID']['output']>;
  toRouteId?: Maybe<Scalars['ID']['output']>;
  undoToken?: Maybe<Scalars['String']['output']>;
  undoneAt?: Maybe<Scalars['DateTime']['output']>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Move a holiday-colliding visit to a working day (HAUL-018 ops
 * half) — through the EXISTING stop-move machinery — and journal
 * the customer notice (STAGED, inert channel). Calling this IS the
 * confirmation: either the office pressed the button, or the
 * account's agreement pre-authorized the move (the journal row says
 * which).
 */
export type DisplaceHaulerVisit = {
  __typename: 'DisplaceHaulerVisit';
  notice?: Maybe<HaulerCustomerNoticeDef>;
  order?: Maybe<HaulerOrderDef>;
};

/** Debugging information for the current query. */
export type DjangoDebug = {
  __typename: 'DjangoDebug';
  /** Executed SQL queries for this API query. */
  sql?: Maybe<Array<Maybe<DjangoDebugSql>>>;
};

/** Represents a single database query made to a Django managed DB. */
export type DjangoDebugSql = {
  __typename: 'DjangoDebugSQL';
  /** The Django database alias (e.g. 'default'). */
  alias: Scalars['String']['output'];
  /** Duration of this database query in seconds. */
  duration: Scalars['Float']['output'];
  /** Postgres connection encoding if available. */
  encoding?: Maybe<Scalars['String']['output']>;
  /** Whether this database query was a SELECT. */
  isSelect: Scalars['Boolean']['output'];
  /** Whether this database query took more than 10 seconds. */
  isSlow: Scalars['Boolean']['output'];
  /** Postgres isolation level if available. */
  isoLevel?: Maybe<Scalars['String']['output']>;
  /** JSON encoded database query parameters. */
  params: Scalars['String']['output'];
  /** The raw SQL of this query, without params. */
  rawSql: Scalars['String']['output'];
  /** The actual SQL sent to this database. */
  sql?: Maybe<Scalars['String']['output']>;
  /** Start time of this database query. */
  startTime: Scalars['Float']['output'];
  /** Stop time of this database query. */
  stopTime: Scalars['Float']['output'];
  /** Postgres transaction ID if available. */
  transId?: Maybe<Scalars['String']['output']>;
  /** Postgres transaction status if available. */
  transStatus?: Maybe<Scalars['String']['output']>;
  /** The type of database being used (e.g. postrgesql, mysql, sqlite). */
  vendor: Scalars['String']['output'];
};

export type DocumentDef = Node & {
  __typename: 'DocumentDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  searchUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DocumentDefConnection = {
  __typename: 'DocumentDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DocumentDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `DocumentDef` and its cursor. */
export type DocumentDefEdge = {
  __typename: 'DocumentDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DocumentDef>;
};

/**
 * Bins per schedule bucket. The pair mirrors ``PickupSettings``:
 * (1, 1) weekly, (1, 2) every second week, (2, 1) twice a week; both
 * null = bins with no schedule.
 */
export type DrawnAreaFrequencyDef = {
  __typename: 'DrawnAreaFrequencyDef';
  binCount: Scalars['Int']['output'];
  /** Collections per week (null for unscheduled bins). */
  collectionsPerWeek?: Maybe<Scalars['Int']['output']>;
  /** Weeks between collections (null for unscheduled). */
  repeatPeriodWeeks?: Maybe<Scalars['Int']['output']>;
};

export type DrawnAreaQuantitiesDef = {
  __typename: 'DrawnAreaQuantitiesDef';
  /** ASSUMED volume for the requested dates: container volume x fill% per collection, times collections per week, scaled to the window. */
  assumedVolumeM3: Scalars['Float']['output'];
  /** ASSUMED weight for the requested dates: each bin's per-collection assumed weight (volume x fill% x per-fraction factor) times its scheme's collections per week, scaled to the window. A derivation, never a measurement. */
  assumedWeightKg: Scalars['Float']['output'];
  /** Containers inside the drawn area. */
  bins: Scalars['Int']['output'];
  /** COLLECTED weight for the requested dates: real scale weights on completed stops at the bins inside. Null while the window has not begun. */
  collectedWeightKg?: Maybe<Scalars['Float']['output']>;
  /** Distinct container locations inside the drawn area. */
  collectionPoints: Scalars['Int']['output'];
  /** Bins by collection frequency, read from the live pickup settings; the bucket counts sum to the bin count. */
  frequencies: Array<DrawnAreaFrequencyDef>;
  /** Active service agreements on the bins inside the drawn area. */
  wasteServices: Scalars['Int']['output'];
};

/** One route a vehicle drove — one ``RouteVehicleSession``. */
export type DrivenRouteEntryDef = {
  __typename: 'DrivenRouteEntryDef';
  /** Mean recorded speed over this route's breadcrumbs (device-reported units). Null when no breadcrumbs back it. */
  avgSpeed?: Maybe<Scalars['Float']['output']>;
  /** When the session ended (null = still open). */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Driven distance in km — RouteVehicleSession.real_distance, stored in metres, divided by 1000. */
  distanceKm: Scalars['Float']['output'];
  /** Highest speed recorded on this route's breadcrumbs (device-reported units, as stored on RouteLocationHistory.speed). Null when no breadcrumbs back it. */
  maxSpeed?: Maybe<Scalars['Float']['output']>;
  /** Number of GPS breadcrumbs (RouteLocationHistory rows) backing the speed stats — 0 means speeds are unknown, not zero. */
  positionCount: Scalars['Int']['output'];
  /** Relay id of the RouteType node. */
  routeId: Scalars['ID']['output'];
  /** The route's planned day (tenant-local). */
  scheduledDay?: Maybe<Scalars['Date']['output']>;
  /** When the driver started the session (may be null). */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * A ready-to-download report file (bytes inline, base64).
 *
 * Format is produced by the shared ``rows_to_file`` writer — the same one
 * ``RouteExport`` uses — so CSV/XLSX behaviour matches the rest of the
 * platform. Delivery is inline (bounded payload); async poll-download /
 * scheduled+emailed delivery is a follow-up (see module CONFESSION).
 */
export type DrivenRoutesReportExportDef = {
  __typename: 'DrivenRoutesReportExportDef';
  /** The file bytes, base64-encoded. */
  contentBase64: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type DriverCostInput = {
  costPerHour?: InputMaybe<Scalars['Decimal']['input']>;
  costPerHourForOvertime?: InputMaybe<Scalars['Decimal']['input']>;
  costPerInterval?: InputMaybe<Scalars['Decimal']['input']>;
  isFixedCost: Scalars['Boolean']['input'];
  paymentInterval?: InputMaybe<Scalars['String']['input']>;
};

/** Describes DriverCost model */
export type DriverCostType = Node & {
  __typename: 'DriverCostType';
  /** Driver cost per hour */
  costPerHour?: Maybe<Scalars['Decimal']['output']>;
  /** Driver cost per hour for overtime */
  costPerHourForOvertime?: Maybe<Scalars['Decimal']['output']>;
  /** Driver cost per time interval */
  costPerInterval?: Maybe<Scalars['Decimal']['output']>;
  driver?: Maybe<DriverType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** If False - driver has payment per hour, if True - fixed cost per month */
  isFixedCost: Scalars['Boolean']['output'];
  paymentInterval?: Maybe<Scalars['String']['output']>;
};

/**
 * Driver-initiated temporary relocation (3.2.28, PRO-236 child 2).
 *
 * REQ-315 only NOTIFIED drivers about relocations; this lets the person
 * who actually sees the washed-out road request one from the field. The
 * wall is server-enforced, not client-hidden:
 *
 * - the caller must have a linked Driver profile (``user.is_driver``);
 * - the container must be one of the driver's OWN accessible containers —
 *   on a stop of a route the driver is assigned to (``RouteVehicle``),
 *   within their company. Anything else in the company is denied and
 *   belongs to the office mutation.
 *
 * Downstream it is the ONE existing relocation path
 * (``create_relocation_request``): same ticket type, same scheduled ->
 * applied -> reverted lifecycle, same single-live-change invariant.
 */
export type DriverCreateTemporaryContainerLocation = {
  __typename: 'DriverCreateTemporaryContainerLocation';
  container?: Maybe<ContainerType>;
  temporaryLocationOverride?: Maybe<TemporaryContainerLocationType>;
};

export type DriverGeoJsonType = {
  __typename: 'DriverGeoJSONType';
  driver?: Maybe<DriverType>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  geoJson?: Maybe<GeoJsonType>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<VehicleType>;
};

/**
 * COMPASS-272: bundle the Navigator app downloads for offline use.
 *
 * Returns the authenticated driver's upcoming routes (within
 * ``days_ahead``) PLUS every active emergency route regardless of date.
 * Completed routes are excluded. The mobile client caches this payload
 * locally and operates from it while offline.
 */
export type DriverOfflinePackageType = {
  __typename: 'DriverOfflinePackageType';
  /** Server timestamp when the bundle was generated. */
  generatedAt: Scalars['DateTime']['output'];
  /** Routes scheduled in the window OR flagged as emergency. Emergency routes are always included regardless of date. Completed routes are excluded. */
  routes: Array<RouteType>;
};

export type DriverPushNotificationStatusType = Node & {
  __typename: 'DriverPushNotificationStatusType';
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  driver: DriverType;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  isReceived: Scalars['Boolean']['output'];
  notification: DriverPushNotificationType;
  /** Vehicle that the driver was in when the notification was sent */
  vehicle?: Maybe<VehicleType>;
};

export type DriverPushNotificationStatusTypeConnection = {
  __typename: 'DriverPushNotificationStatusTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DriverPushNotificationStatusTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `DriverPushNotificationStatusType` and its cursor. */
export type DriverPushNotificationStatusTypeEdge = {
  __typename: 'DriverPushNotificationStatusTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DriverPushNotificationStatusType>;
};

export type DriverPushNotificationType = Node & {
  __typename: 'DriverPushNotificationType';
  confirmedByMe?: Maybe<Scalars['Boolean']['output']>;
  confirmedCount?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  notificationStatuses?: Maybe<Array<Maybe<DriverPushNotificationStatusType>>>;
  notificationType: NotificationsDriverPushNotificationNotificationTypeChoices;
  payload?: Maybe<Scalars['JSONString']['output']>;
  pendingCount?: Maybe<Scalars['Int']['output']>;
  receiver: DriverTypeConnection;
  route?: Maybe<RouteType>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentBy?: Maybe<UserType>;
  sentStatus?: Maybe<Scalars['Boolean']['output']>;
  stops?: Maybe<Array<Maybe<PickUpOrderType>>>;
  title: Scalars['String']['output'];
};


export type DriverPushNotificationTypeReceiverArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DriverPushNotificationTypeConnection = {
  __typename: 'DriverPushNotificationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DriverPushNotificationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `DriverPushNotificationType` and its cursor. */
export type DriverPushNotificationTypeEdge = {
  __typename: 'DriverPushNotificationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DriverPushNotificationType>;
};

/** Stores information about GeoArea */
export type DriverServiceType = Node & {
  __typename: 'DriverServiceType';
  /** Relation to Service */
  drivers: DriverTypeConnection;
  geofenceArea: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};


/** Stores information about GeoArea */
export type DriverServiceTypeDriversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Stores relations between :model:`Driver` and :model:`Skill` */
export type DriverSkillType = Node & {
  __typename: 'DriverSkillType';
  /** Relation to Driver model */
  driver: DriverType;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Relation to Skill model */
  skill: SkillType;
  /** Valid from date */
  validFrom: Scalars['Date']['output'];
  /** Valid to date */
  validTo: Scalars['Date']['output'];
};

export type DriverSkillTypeConnection = {
  __typename: 'DriverSkillTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DriverSkillTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DriverSkillType` and its cursor. */
export type DriverSkillTypeEdge = {
  __typename: 'DriverSkillTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DriverSkillType>;
};

export type DriverSummaryCardType = {
  __typename: 'DriverSummaryCardType';
  drivenDistanceMtd?: Maybe<Scalars['Int']['output']>;
  drivenTimeMtd?: Maybe<Scalars['Int']['output']>;
  routesMtd?: Maybe<Scalars['Int']['output']>;
  ticketsCreated?: Maybe<Scalars['Int']['output']>;
  ticketsCreatedLast30Days?: Maybe<Scalars['Int']['output']>;
  ticketsCreatedToday?: Maybe<Scalars['Int']['output']>;
};

/** Stores information about Driver */
export type DriverType = Node & {
  __typename: 'DriverType';
  activeRouteVehicleSession?: Maybe<RouteVehicleSessionType>;
  /** Shows, how many hours Driver can work per day */
  allowedMaximumDailyHours?: Maybe<Scalars['Int']['output']>;
  /** Shows, how many hours Driver can work per week */
  allowedMaximumWeeklyHours?: Maybe<Scalars['Int']['output']>;
  /** Allowed maximum working days a month */
  allowedMaximumWorkingDaysAMonth?: Maybe<Scalars['Int']['output']>;
  allowedOvertime?: Maybe<Scalars['String']['output']>;
  breakDuration?: Maybe<Scalars['String']['output']>;
  /** Time, when driver have scheduled break */
  breakTimeEnd?: Maybe<Scalars['Time']['output']>;
  /** Time, when driver have scheduled break */
  breakTimeStart?: Maybe<Scalars['Time']['output']>;
  collectedBins?: Maybe<Scalars['Int']['output']>;
  /** Relation to the Comment */
  comments: CommentTypeConnection;
  /** Relation to Cost */
  cost?: Maybe<DriverCostType>;
  currentRoute?: Maybe<RouteType>;
  /** Driver can have many days available (add them comma-separated) */
  daysAvailable?: Maybe<Array<Scalars['String']['output']>>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** Relation to Driver model */
  driverSkills: DriverSkillTypeConnection;
  /** Driver speed */
  driverSpeed: FleetManagementDriverDriverSpeedChoices;
  driverType: FleetManagementDriverDriverTypeChoices;
  driverpushnotificationSet: DriverPushNotificationTypeConnection;
  /** External driver id */
  employeeNumber?: Maybe<Scalars['String']['output']>;
  /** Depot as a end location */
  endLocation?: Maybe<DepotType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Latest location of the driver */
  latestLocation?: Maybe<RouteLocationHistoryDef>;
  /** Relation to License */
  license?: Maybe<LicenseType>;
  /** Limit per route distance */
  limitPerRouteDistance?: Maybe<Scalars['Float']['output']>;
  /** The driver who really drove the load. */
  loadsDrivenCorrected: TruckloadTypeConnection;
  /** The driver of the session that opened the load. */
  loadsDrivenDerived: TruckloadTypeConnection;
  /** Relation to Mobile App */
  mobileApps: MobileAppTypeConnection;
  /** Navigation for user */
  navigationApplicationPreference?: Maybe<Scalars['String']['output']>;
  nextRoute?: Maybe<RouteType>;
  /** Primary vehicle for this driver */
  primaryVehicle?: Maybe<VehicleType>;
  pushNotifications: DriverPushNotificationStatusTypeConnection;
  reassignedFromLogs: RouteVehicleDriverReassignmentLogTypeConnection;
  reassignedToLogs: RouteVehicleDriverReassignmentLogTypeConnection;
  /** Drivers that drives the vehicle on the route */
  routeVehicle: RouteVehicleTypeConnection;
  /** Driver to whom the session belongs */
  routeVehicleSessions: RouteVehicleSessionTypeConnection;
  routelocationhistorySet: RouteLocationHistoryDefConnection;
  searchUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Relation to Service */
  service?: Maybe<DriverServiceType>;
  skills: SkillTypeConnection;
  /** Depot as a start location */
  startLocation?: Maybe<DepotType>;
  /**
   *
   *             Indicates if the driver is working or not. Not enough data is signified by the 'unknown' status.
   *             Can hold one of the following string values: 'unknown', 'working', 'not-working'
   *
   */
  status?: Maybe<Scalars['String']['output']>;
  ticketSet: TicketDefConnection;
  /** Relation to User */
  user: UserType;
  /** Vehicles a driver has access to. For assistant drivers this field can be empty. */
  vehicles: VehicleTypeConnection;
  /** Time, when driver ended to work */
  workTimeEnd?: Maybe<Scalars['Time']['output']>;
  /** Time, when driver started to work */
  workTimeStart?: Maybe<Scalars['Time']['output']>;
};


/** Stores information about Driver */
export type DriverTypeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Stores information about Driver */
export type DriverTypeDriverSkillsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Stores information about Driver */
export type DriverTypeDriverpushnotificationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Stores information about Driver */
export type DriverTypeLoadsDrivenCorrectedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  openedAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


/** Stores information about Driver */
export type DriverTypeLoadsDrivenDerivedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  openedAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


/** Stores information about Driver */
export type DriverTypeMobileAppsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Stores information about Driver */
export type DriverTypePushNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Stores information about Driver */
export type DriverTypeReassignedFromLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Stores information about Driver */
export type DriverTypeReassignedToLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Stores information about Driver */
export type DriverTypeRouteVehicleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Stores information about Driver */
export type DriverTypeRouteVehicleSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Stores information about Driver */
export type DriverTypeRoutelocationhistorySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Stores information about Driver */
export type DriverTypeSkillsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Stores information about Driver */
export type DriverTypeTicketSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Stores information about Driver */
export type DriverTypeVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DriverTypeConnection = {
  __typename: 'DriverTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DriverTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `DriverType` and its cursor. */
export type DriverTypeEdge = {
  __typename: 'DriverTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DriverType>;
};

/**
 * Transport integrity. The driver app recomputes this over the canonical
 * JSON of the whole document except ``checksum`` itself and refuses the
 * file when it disagrees (``CHECKSUM_MISMATCH``).
 */
export type DrivingListChecksumType = {
  __typename: 'DrivingListChecksumType';
  /** Always 'md5-canonical-json' for schemaVersion 1. */
  algorithm: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * COMPASS-875 / HSY REQ 11.
 *
 * A mutation rather than a query because the result is a timestamped,
 * signed artefact with a validity window — caching it, as clients do with
 * queries, would hand out an expired list.
 */
export type DrivingListExport = {
  __typename: 'DrivingListExport';
  drivingList?: Maybe<DrivingListExportType>;
};

/** A driving list ready to be written to the transfer medium. */
export type DrivingListExportType = {
  __typename: 'DrivingListExportType';
  checksum: DrivingListChecksumType;
  /** The app refuses the file after this instant (EXPIRED). Defaults to 14 days, matching the offline pre-fetch window. */
  expiresAt: Scalars['String']['output'];
  /** Suggested name, matching the app's own export naming so a shared stick stays legible: driving-list_<driverId>_<timestamp>.whdl.json */
  fileName: Scalars['String']['output'];
  format: Scalars['String']['output'];
  generatedAt: Scalars['String']['output'];
  issuedFor: DrivingListIdentityType;
  /** THE FILE. The complete driving-list document — write these bytes to the USB stick / local server unchanged. Re-encoding is safe (the checksum is computed over a canonical form, not over the literal bytes), but adding or removing any field is not: the app will refuse it. */
  payload: Scalars['JSONString']['output'];
  routesCount: Scalars['Int']['output'];
  schemaVersion: Scalars['Int']['output'];
  signature: DrivingListSignatureType;
  /** Byte length of the canonical UTF-8 serialisation. */
  sizeBytes: Scalars['Int']['output'];
  stopsCount: Scalars['Int']['output'];
};

/**
 * Who the document is addressed to. Lives INSIDE the hashed body, so a
 * list cannot be retargeted at another crew without breaking the checksum.
 * The app refuses WRONG_COMPANY / WRONG_DRIVER / WRONG_BACKEND.
 */
export type DrivingListIdentityType = {
  __typename: 'DrivingListIdentityType';
  /** Backend HOST the document was produced against (e.g. 'platform-api.wastehero.io'), so a production list cannot be imported on a staging handset. Empty when the caller opted out — the app then skips the environment check. */
  backendUrl?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  driverId: Scalars['String']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
};

/**
 * Provenance. HMAC-SHA256 over the same canonical body, with a key
 * derived per company from the platform secret, so the platform (or a
 * subscriber system holding the same secret) can prove a document that came
 * back on a stick was issued here. The handset holds no key and therefore
 * ignores this field — it is NOT an offline forgery proof.
 */
export type DrivingListSignatureType = {
  __typename: 'DrivingListSignatureType';
  algorithm: Scalars['String']['output'];
  keyId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DuplicateAutomationPayload = {
  __typename: 'DuplicateAutomationPayload';
  automation: AutomationDef;
};

/** The RS-1102 dispatch surface for one (area, day). */
export type DynamicDayDispatchDef = {
  __typename: 'DynamicDayDispatchDef';
  day: Scalars['Date']['output'];
  dayOfCycle: Scalars['Int']['output'];
  routes?: Maybe<Array<DynamicRouteDispatchDef>>;
};

/**
 * The per-area dynamic-day preview (RS-1101): selection plus
 * skip reasons, no engine involvement, nothing persisted.
 */
export type DynamicDayPreviewDef = {
  __typename: 'DynamicDayPreviewDef';
  day: Scalars['Date']['output'];
  dayOfCycle: Scalars['Int']['output'];
  horizonDays: Scalars['Int']['output'];
  routesToday?: Maybe<Array<Scalars['String']['output']>>;
  selected?: Maybe<Array<DynamicSelectionRowDef>>;
  skipped?: Maybe<Array<DynamicSkipRowDef>>;
  thresholdPct: Scalars['Float']['output'];
};

/**
 * Persisted dynamic day (RS-1101/RS-1102): preview rows are the
 * office day list; applied rows carry the interactive-tier
 * insertion and its engine evidence.
 */
export type DynamicDayRunDef = Node & {
  __typename: 'DynamicDayRunDef';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  day: Scalars['Date']['output'];
  engineEvidence: Scalars['JSONString']['output'];
  horizonDays: Scalars['Int']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  insertions: Scalars['JSONString']['output'];
  plan: PlanDef;
  planningArea: PlanningAreaDef;
  selection: Scalars['JSONString']['output'];
  skipped: Scalars['JSONString']['output'];
  status: RouteStudioDynamicDayRunStatusChoices;
  thresholdPct: Scalars['Float']['output'];
};

export type DynamicDayRunDefConnection = {
  __typename: 'DynamicDayRunDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DynamicDayRunDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `DynamicDayRunDef` and its cursor. */
export type DynamicDayRunDefEdge = {
  __typename: 'DynamicDayRunDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DynamicDayRunDef>;
};

/**
 * One route in the composed day list: the overlay-effective
 * sequence with the day's dynamic insertions layered on (RS-1102,
 * the in-cab read seam).
 */
export type DynamicRouteDispatchDef = {
  __typename: 'DynamicRouteDispatchDef';
  /** SBX-373 (D35): set when the route's mapped live vehicle or its driver is recorded absent for the day (reason, window, recorded replacement); null otherwise. */
  absence?: Maybe<Scalars['GenericScalar']['output']>;
  dynamicInserted?: Maybe<Array<Scalars['String']['output']>>;
  routeKey: Scalars['String']['output'];
  sequence?: Maybe<Array<Scalars['String']['output']>>;
  vehicle: Scalars['String']['output'];
};

/**
 * One need-based selection (RS-1101): the forecast evidence
 * rides with every selected subject; nothing is selected without a
 * sensor trajectory crossing the threshold within the horizon.
 */
export type DynamicSelectionRowDef = {
  __typename: 'DynamicSelectionRowDef';
  currentFillPct: Scalars['Float']['output'];
  daysToThreshold: Scalars['Float']['output'];
  fraction: Scalars['String']['output'];
  kgWeek: Scalars['Float']['output'];
  modelTag: Scalars['String']['output'];
  projectedFillPct: Scalars['Float']['output'];
  ratePctDay: Scalars['Float']['output'];
  subjectRef: Scalars['String']['output'];
  unitId: Scalars['String']['output'];
};

/**
 * Why a candidate kept its calendar (hygiene floor, sensor
 * floors, already dispatched); honesty rows, always rendered.
 */
export type DynamicSkipRowDef = {
  __typename: 'DynamicSkipRowDef';
  fraction: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  subjectRef: Scalars['String']['output'];
};

export type EdgeDef = {
  __typename: 'EdgeDef';
  branch: Scalars['String']['output'];
  fromNodeKey: Scalars['String']['output'];
  toNodeKey: Scalars['String']['output'];
};

export type EdgeInput = {
  branch: Scalars['String']['input'];
  fromNodeKey: Scalars['String']['input'];
  toNodeKey: Scalars['String']['input'];
};

export type EffectDef = {
  __typename: 'EffectDef';
  attempts: Scalars['Int']['output'];
  channel: Scalars['String']['output'];
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  providerRef?: Maybe<Scalars['String']['output']>;
  recipientLabel?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusText: Scalars['String']['output'];
  summary: Scalars['String']['output'];
};

/** The resolved holiday policy for one contract area (B2). */
export type EffectiveHolidayPolicyDef = {
  __typename: 'EffectiveHolidayPolicyDef';
  policy: Scalars['String']['output'];
  /** "company_default" or "contract_area". */
  source: Scalars['String']['output'];
  spreadDays: Scalars['Int']['output'];
};

export type EmailNotificationMethodDef = Node & {
  __typename: 'EmailNotificationMethodDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  migratedFromId?: Maybe<Scalars['String']['output']>;
  notificationmethodPtr: NotificationMethodDef;
};

export type EnableAutomationEnginePayload = {
  __typename: 'EnableAutomationEnginePayload';
  settings: AutomationSettingsDef;
};

/**
 * Record that composting at this row has stopped.
 *
 * Takes no date and no reason. The service owns both decisions: the date is
 * the server's, because when a statutory event was reported must not be
 * movable by whoever reports it, and a reason is written separately through
 * ``UpdateCompostingRegistryEntry(endReason:)`` so that ending cannot
 * half-succeed.
 */
export type EndCompostingRegistryEntry = {
  __typename: 'EndCompostingRegistryEntry';
  compostingRegistryEntry?: Maybe<CompostingRegistryEntryDef>;
};

export type EndContactAuthorization = {
  __typename: 'EndContactAuthorization';
  contactAuthorization?: Maybe<ContactAuthorizationDef>;
};

/**
 * Office ends a hire (collect): the placement's last billed day is set
 * and the hire stops. Wraps ``rental.end_rental`` — sets state only; the
 * clock finalizes billed-to on its next run. ``endDate`` is INCLUSIVE (the
 * last day the rental bills — the GS-3 convention). Idempotent.
 */
export type EndHaulerRental = {
  __typename: 'EndHaulerRental';
  /** False when the end date was already set to this value. */
  changed?: Maybe<Scalars['Boolean']['output']>;
  placement?: Maybe<HaulerRentalDef>;
};

/**
 * Asukasvaihdos — end EVERY SCP membership of a property at one date.
 *
 * A resident move-out is ONE action, not N End-membership dialogs: ends all
 * of the property's active memberships (across every SCP) in one
 * transaction, applies the operator's role hand-overs so each remaining pool
 * keeps its Contact Person / Payer, redistributes shares per SCP, and
 * recomputes the property's register basis (``NONE`` / "Ei liittynyt" when
 * nothing else keeps it connected). A forgotten hand-over surfaces as
 * ``SCP_MISSING_*`` and rolls the whole move-out back (NEXUS-665/667).
 */
export type EndPropertyScpMemberships = {
  __typename: 'EndPropertyScpMemberships';
  endedMemberships?: Maybe<Array<Maybe<ScpMembershipDef>>>;
  property?: Maybe<PropertyDef>;
  resultingRegisterBasis?: Maybe<Scalars['String']['output']>;
};

/**
 * End an ACTIVE scheduled change early: the window is truncated and
 * the displaced baseline restored (req 3.1.38).
 */
export type EndScheduledChangeNow = {
  __typename: 'EndScheduledChangeNow';
  scheduledChange?: Maybe<ScheduledChangeDef>;
};

/** End a company's SCP membership and re-balance the remaining members. */
export type EndScpCompanyMembership = {
  __typename: 'EndScpCompanyMembership';
  endedMembership?: Maybe<ScpCompanyMembershipDef>;
  memberships?: Maybe<Array<Maybe<ScpMembershipDef>>>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/**
 * End a property's SCP membership and re-balance the remaining members.
 *
 * The leaver's ``end_date`` is recorded and its share is redistributed so the
 * active members again sum to 100.00. By default the redistribution is
 * proportional to the remaining members' current shares (SRS 3.2.13); pass
 * ``shares`` (percent 0..100 for exactly the remaining members) to override it
 * with an edited vector. Rejects an edited vector that does not sum to 100.00
 * with a structured error (``SHARES_MUST_SUM_TO_100``).
 */
export type EndScpMembership = {
  __typename: 'EndScpMembership';
  endedMembership?: Maybe<ScpMembershipDef>;
  memberships?: Maybe<Array<Maybe<ScpMembershipDef>>>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** End an SCP membership-role assignment at an optional end date. */
export type EndScpMembershipRole = {
  __typename: 'EndScpMembershipRole';
  membershipRole?: Maybe<ScpMembershipRoleDef>;
};

/**
 * End a membership, first handing its required roles to successors.
 *
 * The single-mutation convenience behind the NEXUS-667 guard modal: ending
 * the sole Contact Person / Payer member is normally refused with
 * ``SCP_MISSING_*``; here the operator's chosen ``roleHandovers`` are applied
 * (assigning the role to another active member) and the membership is ended
 * in ONE transaction, so the invariant never transiently breaks and a failed
 * end rolls the hand-over back with it. ``shares`` optionally overrides the
 * proportional redistribution (percent for the remaining members).
 */
export type EndScpMembershipWithHandover = {
  __typename: 'EndScpMembershipWithHandover';
  scpMembership?: Maybe<ScpMembershipDef>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Another engine workflow doing the same (SBX-566). */
export type EngineOverlapDef = {
  __typename: 'EngineOverlapDef';
  level: Scalars['String']['output'];
  message: Scalars['String']['output'];
  other: AutomationDef;
  otherTriggerNodeKey: Scalars['String']['output'];
  severity: Scalars['String']['output'];
  sharedActions: Array<Scalars['String']['output']>;
  triggerNodeKey: Scalars['String']['output'];
};

/**
 * Create (idempotently) and prefill the transfer document of a stop.
 * Returns null when the stop is not eligible or the flag is off.
 */
export type EnsureTransferDocument = {
  __typename: 'EnsureTransferDocument';
  required?: Maybe<Scalars['Boolean']['output']>;
  transferDocument?: Maybe<TransferDocumentType>;
};

export type EnvironmentalAccountCollectionType = {
  __typename: 'EnvironmentalAccountCollectionType';
  co2eFactor?: Maybe<Scalars['Float']['output']>;
  co2eKg?: Maybe<Scalars['Float']['output']>;
  containerId?: Maybe<Scalars['ID']['output']>;
  date: Scalars['Date']['output'];
  densityKgM3?: Maybe<Scalars['Float']['output']>;
  equipment: Scalars['String']['output'];
  factorValidFrom?: Maybe<Scalars['Date']['output']>;
  factorVersionId?: Maybe<Scalars['ID']['output']>;
  fillBasis?: Maybe<Scalars['String']['output']>;
  fillPercentage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  recycledKg?: Maybe<Scalars['Float']['output']>;
  recyclingPercentage?: Maybe<Scalars['Float']['output']>;
  stopType: Scalars['String']['output'];
  wasteFractionId?: Maybe<Scalars['ID']['output']>;
  wasteFractionName: Scalars['String']['output'];
  weightBasis: Scalars['String']['output'];
  weightKg?: Maybe<Scalars['Float']['output']>;
  weightSource?: Maybe<Scalars['String']['output']>;
};

export type EnvironmentalAccountFactorUsageType = {
  __typename: 'EnvironmentalAccountFactorUsageType';
  assumedFillPercentage?: Maybe<Scalars['Float']['output']>;
  co2eFactor?: Maybe<Scalars['Float']['output']>;
  collections: Scalars['Int']['output'];
  densityKgM3?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  recyclingPercentage?: Maybe<Scalars['Float']['output']>;
  source: Scalars['String']['output'];
  validFrom: Scalars['Date']['output'];
};

export type EnvironmentalAccountFractionType = {
  __typename: 'EnvironmentalAccountFractionType';
  co2eCoveredWeightKg: Scalars['Float']['output'];
  co2eKg?: Maybe<Scalars['Float']['output']>;
  collections: Scalars['Int']['output'];
  energyRecovery?: Maybe<Scalars['Float']['output']>;
  estimatedWeightKg: Scalars['Float']['output'];
  factorVersions: Array<EnvironmentalAccountFactorUsageType>;
  materialRecovery?: Maybe<Scalars['Float']['output']>;
  measuredWeightKg: Scalars['Float']['output'];
  missingCo2eFactor: Scalars['Boolean']['output'];
  missingDensity: Scalars['Boolean']['output'];
  missingWeightCollections: Scalars['Int']['output'];
  recycledKg?: Maybe<Scalars['Float']['output']>;
  recyclingRatePct?: Maybe<Scalars['Float']['output']>;
  treatmentLocation: Scalars['String']['output'];
  treatmentMethod: Scalars['String']['output'];
  wasteFractionId?: Maybe<Scalars['ID']['output']>;
  wasteFractionName: Scalars['String']['output'];
  weighedCollections: Scalars['Int']['output'];
  weightKg: Scalars['Float']['output'];
};

export type EnvironmentalAccountTotalsType = {
  __typename: 'EnvironmentalAccountTotalsType';
  co2eCoveredSharePct?: Maybe<Scalars['Float']['output']>;
  co2eKg?: Maybe<Scalars['Float']['output']>;
  collections: Scalars['Int']['output'];
  estimatedWeightKg: Scalars['Float']['output'];
  measuredSharePct?: Maybe<Scalars['Float']['output']>;
  measuredWeightKg: Scalars['Float']['output'];
  missingWeightCollections: Scalars['Int']['output'];
  recycledKg?: Maybe<Scalars['Float']['output']>;
  recyclingRatePct?: Maybe<Scalars['Float']['output']>;
  weighedCollections: Scalars['Int']['output'];
  weightKg: Scalars['Float']['output'];
};

export type ErrorType = {
  __typename: 'ErrorType';
  field: Scalars['String']['output'];
  messages: Array<Scalars['String']['output']>;
};

export type EventCatalogDef = {
  __typename: 'EventCatalogDef';
  label: Scalars['String']['output'];
  payloadSchema: Scalars['JSONString']['output'];
  subjectType: Scalars['String']['output'];
  type: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** An actor for the System History "Changed by" filter (LEDGER-838). */
export type EventLogActorDef = {
  __typename: 'EventLogActorDef';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum EventTicketEventEventTypeChoices {
  /** Status changed */
  A_1 = 'A_1',
  /** Assignee changed */
  A_2 = 'A_2',
  /** Priority changed */
  A_3 = 'A_3',
  /** Assigned team changed */
  A_4 = 'A_4',
  /** Modified */
  A_10 = 'A_10',
  /** Scan barcode */
  A_11 = 'A_11',
  /** Print label */
  A_12 = 'A_12',
  /** Pair RFID */
  A_13 = 'A_13',
  /** Set container location */
  A_14 = 'A_14',
  /** Barcode scan skipped */
  A_15 = 'A_15',
  /** Associated message linked */
  A_20 = 'A_20',
  /** Associated message unlinked */
  A_21 = 'A_21',
  /** Visibility changed */
  A_22 = 'A_22',
  /** Service provider changed */
  A_23 = 'A_23'
}

/** An enumeration. */
export enum EventTicketEventFromPriorityChoices {
  /** None */
  A_0 = 'A_0',
  /** Log */
  A_1 = 'A_1',
  /** Medium */
  A_2 = 'A_2',
  /** High */
  A_3 = 'A_3',
  /** Critical */
  A_4 = 'A_4'
}

/** An enumeration. */
export enum EventTicketEventFromStatusChoices {
  /** Created */
  A_1 = 'A_1',
  /** Open */
  A_2 = 'A_2',
  /** Pending */
  A_3 = 'A_3',
  /** On hold */
  A_4 = 'A_4',
  /** In progress */
  A_5 = 'A_5',
  /** Completed */
  A_6 = 'A_6',
  /** Rejected */
  A_7 = 'A_7'
}

/** An enumeration. */
export enum EventTicketEventToPriorityChoices {
  /** None */
  A_0 = 'A_0',
  /** Log */
  A_1 = 'A_1',
  /** Medium */
  A_2 = 'A_2',
  /** High */
  A_3 = 'A_3',
  /** Critical */
  A_4 = 'A_4'
}

/** An enumeration. */
export enum EventTicketEventToStatusChoices {
  /** Created */
  A_1 = 'A_1',
  /** Open */
  A_2 = 'A_2',
  /** Pending */
  A_3 = 'A_3',
  /** On hold */
  A_4 = 'A_4',
  /** In progress */
  A_5 = 'A_5',
  /** Completed */
  A_6 = 'A_6',
  /** Rejected */
  A_7 = 'A_7'
}

/** An enumeration. */
export enum EvolutionContainerCollectionItemSnapshotExternalSyncStatusChoices {
  /** Failed */
  FAILED = 'FAILED',
  /** Not synced yet */
  NOT_SYNCED = 'NOT_SYNCED',
  /** Pending */
  PENDING = 'PENDING',
  /** Skipped */
  SKIPPED = 'SKIPPED',
  /** Success */
  SUCCESS = 'SUCCESS'
}

/** An enumeration. */
export enum EvolutionContainerItemSnapshotExternalSyncStatusChoices {
  /** Failed */
  FAILED = 'FAILED',
  /** Not synced yet */
  NOT_SYNCED = 'NOT_SYNCED',
  /** Pending */
  PENDING = 'PENDING',
  /** Skipped */
  SKIPPED = 'SKIPPED',
  /** Success */
  SUCCESS = 'SUCCESS'
}

/**
 * One row per (credentials, container) pair.
 *
 * Scope filter is `credentials__company_id = info.context.user.company_id`
 * — going through the credential FK keeps the link table from leaking
 * container ids across tenants.
 */
export type EvolutionContainerLinkDef = Node & {
  __typename: 'EvolutionContainerLinkDef';
  /** WasteHero container this link refers to. Cascades on delete so decommissioned containers don't leave dangling link rows. */
  container: ContainerType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** Evolution credentials that own this link. Cascades on delete so removing a credential cleans up all its scope and learned route data. */
  credentials: EvolutionSoapApiCredentialsDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** When True (default), this container flows to Botek through the hourly outbound coordinator. Flip to False to exclude a container without deleting the row — preserves the audit trail of route_id / route_name / last_seen_at. */
  inScope: Scalars['Boolean']['output'];
  /** Timestamp of the most recent GetCollections event that updated this row. NULL if the link was created manually before any collection event arrived. Useful for spotting stale rows (container moved to a different hauler, etc.). */
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  /** Botek-side RouteID for this container, as observed in the last GetCollections event. Sent verbatim as the `RouteID` parameter in outbound AddServiceV2 / AddSummoningV2 / StopService / StopSummoning calls. Empty string until Botek has reported its first collection on this container; while empty the container is excluded from outbound writes by the materialized views (no malformed SOAP call is possible). */
  routeId: Scalars['String']['output'];
  /** Human-readable Botek route name observed in the last GetCollections event. Stored for audit and admin display only; not sent outbound (the Botek contract uses RouteID, not name). */
  routeName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type EvolutionContainerLinkDefConnection = {
  __typename: 'EvolutionContainerLinkDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EvolutionContainerLinkDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `EvolutionContainerLinkDef` and its cursor. */
export type EvolutionContainerLinkDefEdge = {
  __typename: 'EvolutionContainerLinkDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EvolutionContainerLinkDef>;
};

/** An enumeration. */
export enum EvolutionCustomerItemSnapshotExternalSyncStatusChoices {
  /** Failed */
  FAILED = 'FAILED',
  /** Not synced yet */
  NOT_SYNCED = 'NOT_SYNCED',
  /** Pending */
  PENDING = 'PENDING',
  /** Skipped */
  SKIPPED = 'SKIPPED',
  /** Success */
  SUCCESS = 'SUCCESS'
}

/** Deviation code → WH TicketType lookup row. */
export type EvolutionDeviationCodeMappingDef = Node & {
  __typename: 'EvolutionDeviationCodeMappingDef';
  /** Evolution credentials this mapping applies to. Each credential owns its own mapping table — different tenants/haulers can map the same Botek deviation code to different WasteHero TicketTypes. */
  credentials: EvolutionSoapApiCredentialsDef;
  /** Botek deviation code as reported in CollectionExternal.Deviations. The rev4-4 PDF cited values 1–5 (the Category constraint on AddOrUpdateDeviationParameters used for outbound deviation creation), but the inbound test environment also returns codes 100, 101, 108, 111, 130, 135, 157, etc. — the catalogue is wider than the PDF documents. Stored as a PositiveSmallIntegerField (0–32767) to match the SOAP wire type and accommodate the full set. Operators configure one mapping row per code their tenant actually receives; unmapped codes log a warning and skip ticket creation. */
  deviationCode: Scalars['Int']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** WasteHero TicketType to instantiate when an inbound collection carries this deviation code. PROTECT prevents the TicketType from being deleted while a mapping references it — accidental deletion would silently break the mapping. */
  ticketType: TicketTypeDef;
};

export type EvolutionDeviationCodeMappingDefConnection = {
  __typename: 'EvolutionDeviationCodeMappingDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EvolutionDeviationCodeMappingDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `EvolutionDeviationCodeMappingDef` and its cursor. */
export type EvolutionDeviationCodeMappingDefEdge = {
  __typename: 'EvolutionDeviationCodeMappingDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EvolutionDeviationCodeMappingDef>;
};

/** An enumeration. */
export enum EvolutionEvolutionManualSyncRunModeChoices {
  /** Dry run (no SOAP calls) */
  DRY_RUN = 'DRY_RUN',
  /** Execute (real SOAP calls) */
  EXECUTE = 'EXECUTE'
}

/** An enumeration. */
export enum EvolutionEvolutionManualSyncRunStatusChoices {
  /** Completed */
  COMPLETED = 'COMPLETED',
  /** Failed */
  FAILED = 'FAILED',
  /** Started */
  STARTED = 'STARTED',
  /** Stopping (operator requested) */
  STOPPING = 'STOPPING'
}

/** An enumeration. */
export enum EvolutionEvolutionSoapApiCallHistoryActionChoices {
  /** Outbound — start/stop recurring pickup (batch) */
  ADDORSTOPSERVICE = 'ADDORSTOPSERVICE',
  /** Outbound — start/stop extra-emptying ticket (batch) */
  ADDORSTOPSUMMONING = 'ADDORSTOPSUMMONING',
  /** Outbound — push property as Botek customer */
  ADDORUPDATECUSTOMER = 'ADDORUPDATECUSTOMER',
  /** Outbound — start recurring pickup service for a container */
  ADDSERVICEV2 = 'ADDSERVICEV2',
  /** Outbound — start an extra-emptying ticket */
  ADDSUMMONINGV2 = 'ADDSUMMONINGV2',
  /** Inbound — fetch driver-completed collection events */
  GETCOLLECTIONS = 'GETCOLLECTIONS',
  /** Inbound — current truck status (unused; placeholder for future) */
  GETCURRENTTRUCKSTATUS = 'GETCURRENTTRUCKSTATUS',
  /** Diagnostic — list Botek route IDs (advisory only) */
  GETROUTES = 'GETROUTES',
  /** Outbound — push container as Botek product */
  INSERTORUPDATEPRODUCT = 'INSERTORUPDATEPRODUCT',
  /** Outbound — stop a previously started recurring pickup */
  STOPSERVICE = 'STOPSERVICE',
  /** Outbound — stop a previously started extra-emptying ticket */
  STOPSUMMONING = 'STOPSUMMONING',
  /** Health check — reach the Botek endpoint */
  TESTMETHOD = 'TESTMETHOD'
}

/** An enumeration. */
export enum EvolutionEvolutionSoapApiCredentialsAuthenticationTypeChoices {
  /** API Key */
  API_KEY = 'API_KEY',
  /** Bearer Token */
  BEARER_TOKEN = 'BEARER_TOKEN',
  /** Custom SOAP Header */
  CUSTOM_HEADER = 'CUSTOM_HEADER',
  /** HTTP Basic */
  HTTP_BASIC = 'HTTP_BASIC',
  /** No Authentication */
  NONE = 'NONE',
  /** WS-Security UsernameToken */
  WSSE = 'WSSE'
}

/**
 * Bookkeeping row for an operator-triggered manual sync run.
 *
 * ``status_display`` / ``mode_display`` give the FE the human-readable
 * label without re-shipping the choice map.
 */
export type EvolutionManualSyncRunDef = Node & {
  __typename: 'EvolutionManualSyncRunDef';
  /** Server timestamp when the manual sync run finished (completed / failed / stopped). NULL while running. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** Evolution credentials this manual sync run executes against. Cascades so deleting credentials removes the audit trail of their manual sync runs. */
  credentials: EvolutionSoapApiCredentialsDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Whether real SOAP calls are made or only their payloads are captured to the report file. Defaults to dry_run for safety. */
  mode: EvolutionEvolutionManualSyncRunModeChoices;
  modeDisplay?: Maybe<Scalars['String']['output']>;
  /** Operator-supplied filter parameters for this run: property types, container type pattern, ticket date range, included outbound services. Stored verbatim for auditability. */
  params: Scalars['JSONString']['output'];
  /** Local filesystem path to the JSONL report file containing one row per planned/executed SOAP call. Empty while the run is still preparing; populated as soon as the file is opened. */
  reportPath: Scalars['String']['output'];
  /** Stable identifier used to tag related rows in EvolutionSoapApiCallHistory and to name the local report file. Generated server-side; never accept from operator input. */
  runId: Scalars['UUID']['output'];
  /** Server timestamp when the manual sync run row was created. */
  startedAt: Scalars['DateTime']['output'];
  /** Lifecycle marker. The manual-sync service checks for `stopping` between SOAP calls so an operator can terminate cleanly via the admin action. */
  status: EvolutionEvolutionManualSyncRunStatusChoices;
  statusDisplay?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type EvolutionManualSyncRunDefConnection = {
  __typename: 'EvolutionManualSyncRunDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EvolutionManualSyncRunDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `EvolutionManualSyncRunDef` and its cursor. */
export type EvolutionManualSyncRunDefEdge = {
  __typename: 'EvolutionManualSyncRunDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EvolutionManualSyncRunDef>;
};

/** An enumeration. */
export enum EvolutionSnapshotBatchBatchTypeChoices {
  /** Container */
  CONTAINER = 'CONTAINER',
  /** Container Collection */
  CONTAINER_COLLECTION = 'CONTAINER_COLLECTION',
  /** Customer */
  CUSTOMER = 'CUSTOMER',
  /** Ticket */
  TICKET = 'TICKET'
}

/**
 * SOAP call audit row.
 *
 * ``duration_seconds`` is computed from ``completed_at - started_at`` —
 * the model exposes a property but graphene_django does not surface
 * properties automatically; declare it here so the FE can request it.
 * ``action_display`` returns the human-readable label for the choice.
 */
export type EvolutionSoapApiCallHistoryDef = Node & {
  __typename: 'EvolutionSoapApiCallHistoryDef';
  /** SOAP action/method called */
  action: EvolutionEvolutionSoapApiCallHistoryActionChoices;
  actionDisplay?: Maybe<Scalars['String']['output']>;
  company: CompanyType;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  credentials?: Maybe<EvolutionSoapApiCredentialsDef>;
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  endpoint: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  lastReceivedId?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  requestPayload: Scalars['String']['output'];
  responsePayload: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type EvolutionSoapApiCallHistoryDefConnection = {
  __typename: 'EvolutionSoapApiCallHistoryDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EvolutionSoapApiCallHistoryDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `EvolutionSoapApiCallHistoryDef` and its cursor. */
export type EvolutionSoapApiCallHistoryDefEdge = {
  __typename: 'EvolutionSoapApiCallHistoryDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EvolutionSoapApiCallHistoryDef>;
};

/**
 * Credentials with secrets stripped.
 *
 * The ``fields`` whitelist below intentionally OMITS ``password``,
 * ``api_key``, ``bearer_token``, ``custom_header``, ``additional_headers``
 * so they cannot leak through GraphQL even with a misconfigured
 * ``get_queryset``.
 */
export type EvolutionSoapApiCredentialsDef = Node & {
  __typename: 'EvolutionSoapApiCredentialsDef';
  /** Type of authentication to use */
  authenticationType: EvolutionEvolutionSoapApiCredentialsAuthenticationTypeChoices;
  /** SOAP API base URL */
  baseUrl: Scalars['String']['output'];
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  /** Master switch for this credential. When False, neither the inbound pull nor the outbound hourly chain fires, regardless of inbound_enabled / outbound_enabled. The operator-triggered Manual Sync feature does NOT read this flag — it runs against the selected credential regardless, by design. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Human readable name for the integration */
  name: Scalars['String']['output'];
  project: ProjectType;
  /** Synthetic WasteHero RouteScheme used as the parent for the dummy daily Routes that inbound GetCollections creates. Auto-populated on the first GetCollections call by EvolutionStaticDataGeneratorService. Pure inbound scaffolding — it is NOT used to scope outbound traffic and should NOT be referenced by any real Container.route_scheme. */
  routeScheme?: Maybe<RouteSchemeType>;
  /** Request timeout in seconds */
  timeout: Scalars['Int']['output'];
  /** Ticket type used when GetCollections returns a collection on an unknown container (ProductNumber starts with `Extra_`). When NULL, those collections are dropped and a warning is logged — operators should configure this before enabling production sync. */
  unmatchedContainerTicketType?: Maybe<TicketTypeDef>;
  updatedAt: Scalars['DateTime']['output'];
  /** Synthetic Vehicle assigned to the dummy inbound Routes. Auto-populated on the first GetCollections call. Pure inbound scaffolding. */
  vehicle?: Maybe<VehicleType>;
};

export type EvolutionSoapApiCredentialsDefConnection = {
  __typename: 'EvolutionSoapApiCredentialsDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EvolutionSoapApiCredentialsDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `EvolutionSoapApiCredentialsDef` and its cursor. */
export type EvolutionSoapApiCredentialsDefEdge = {
  __typename: 'EvolutionSoapApiCredentialsDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EvolutionSoapApiCredentialsDef>;
};

/** An enumeration. */
export enum EvolutionTicketItemSnapshotExternalSyncStatusChoices {
  /** Failed */
  FAILED = 'FAILED',
  /** Not synced yet */
  NOT_SYNCED = 'NOT_SYNCED',
  /** Pending */
  PENDING = 'PENDING',
  /** Skipped */
  SKIPPED = 'SKIPPED',
  /** Success */
  SUCCESS = 'SUCCESS'
}

/** One exception type: its current effect + scheduled changes + history. */
export type ExceptionEffectOverviewType = {
  __typename: 'ExceptionEffectOverviewType';
  /** Null when falling back to the day-one defaults. */
  currentEffectiveFrom?: Maybe<Scalars['Date']['output']>;
  currentPayEffect: Scalars['String']['output'];
  currentPayRateFactor?: Maybe<Scalars['Int']['output']>;
  currentReliabilityEffect: Scalars['String']['output'];
  exceptionName: Scalars['String']['output'];
  exceptionType: Scalars['String']['output'];
  hasScheduledChange: Scalars['Boolean']['output'];
  /** Newest-first dated history (current + scheduled + past). */
  rows: Array<ExceptionEffectRowType>;
};

/** One configured, effective-dated effect row (a change-log entry). */
export type ExceptionEffectRowType = {
  __typename: 'ExceptionEffectRowType';
  /** ISO datetime. */
  createdAt?: Maybe<Scalars['String']['output']>;
  createdById?: Maybe<Scalars['ID']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  effectiveFrom: Scalars['Date']['output'];
  exceptionName: Scalars['String']['output'];
  exceptionType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The effect in force as of the read. */
  isCurrent: Scalars['Boolean']['output'];
  /** Future-dated (not yet in force). */
  isScheduled: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** payable_in_full | not_payable | rate_factor */
  payEffect: Scalars['String']['output'];
  /** Percent 0-100; only set for a rate_factor pay effect. */
  payRateFactor?: Maybe<Scalars['Int']['output']>;
  /** counts_against | excused */
  reliabilityEffect: Scalars['String']['output'];
};

/**
 * How an exception's OPEN lifecycle ended (#17 backend alert lifecycle).
 *
 *     A miss, a go-back and a ticket all share ONE lifecycle row — acknowledged
 *     once, resolved once, with a recorded *reason it closed*. Every future
 *     source (vision overfill/contamination, telematics) plugs into the same
 *     state machine. Descriptive only — resolving an exception NEVER moves
 *     money (the Ledger boundary).
 *
 */
export enum ExceptionResolution {
  AUTO_CLEARED = 'AUTO_CLEARED',
  CONVERTED_TO_TICKET = 'CONVERTED_TO_TICKET',
  MANUAL_DISMISS = 'MANUAL_DISMISS',
  RECOLLECT_SCHEDULED = 'RECOLLECT_SCHEDULED'
}

/**
 * Office swaps the container on a hire (RD-16 exchange): the OLD
 * placement ends the day BEFORE the swap and a NEW placement starts ON the
 * swap date, so the Ledger clock resets with no double-billed day and no
 * gap. Composed of ``end_rental`` + ``begin_rental``; site/service/qty are
 * inherited from the old placement unless overridden.
 *
 * RD-16 safety: ``endDate`` billing is INCLUSIVE while the DB
 * container-overlap constraint is upper-EXCLUSIVE (``[start, end)``) — so
 * the constraint would NOT catch an inclusive-end overlap on the swap day.
 * This mutation therefore enforces the OLD-END + 1 pattern itself: old
 * last-billed day = ``exchangeDate - 1``, new start = ``exchangeDate``.
 * Wrapped in one transaction so a failed begin rolls back the end.
 */
export type ExchangeHaulerRental = {
  __typename: 'ExchangeHaulerRental';
  endedPlacement?: Maybe<HaulerRentalDef>;
  newPlacement?: Maybe<HaulerRentalDef>;
};

/**
 * Office-only (PRO-118): exclude an agreement from a contract area —
 * detaches it when attached and keeps it out of the Pending queue until
 * re-included. Change-logged, reversible.
 */
export type ExcludeAreaAgreement = {
  __typename: 'ExcludeAreaAgreement';
  area?: Maybe<AreaDef>;
};

/**
 * Materialize into live entities through the single F10 mutation
 * site (idempotent; emits promotion.materialized).
 */
export type ExecutePromotionMutation = {
  __typename: 'ExecutePromotionMutation';
  promotion?: Maybe<PromotionDef>;
};

/**
 * The per-plan explanation harness surface (RS-603, 05 §7):
 * binding constraints from the solve, cost decomposition narrative
 * data, the CO2e method document (RS-601) and the relaxation probes.
 * Every number here traces to plan_kpis or a probe; the Copilot
 * renders these and never invents numbers (grounding rule 3).
 */
export type ExplanationDef = {
  __typename: 'ExplanationDef';
  /** The named baseline every KPI delta refers to (D17). */
  baseline?: Maybe<BaselineDef>;
  /** Binding constraints from the solve: plain registry ids or {constraint, detail} objects as the engine recorded them; entries backed by a tenant brain rule carry the rule by name under 'brain_rule' (RS-1602, D39). */
  binding?: Maybe<Array<Maybe<Scalars['GenericScalar']['output']>>>;
  /** The D11 method document: per-vehicle emission factors and their provenance (RS-601 AC). */
  co2eMethod?: Maybe<Scalars['GenericScalar']['output']>;
  /** T1 (D67): the source currency of every money figure in this explanation (decomposition rows, probe headlines): the plan's scored currency. Null when the plan carries no scored KPIs; never a guessed or converted label. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Cost decomposition narrative rows: component, eur_year, share_pct, and baseline/delta where the baseline carries a decomposition. */
  decomposition?: Maybe<Scalars['GenericScalar']['output']>;
  /** Engine infeasibility reasons, when the plan is one. */
  infeasibility?: Maybe<Array<Scalars['String']['output']>>;
  plan: PlanDef;
  probes?: Maybe<Array<RelaxationProbeDef>>;
};

/**
 * One explored future: a real branched scenario with its
 * engine-scored KPI vector and frontier verdicts.
 */
export type ExplorationCandidateDef = Node & {
  __typename: 'ExplorationCandidateDef';
  createdAt: Scalars['DateTime']['output'];
  errorMessage: Scalars['String']['output'];
  hypothesis: Scalars['JSONString']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  interesting: Scalars['Boolean']['output'];
  kpis: Scalars['JSONString']['output'];
  onFrontier: Scalars['Boolean']['output'];
  plan?: Maybe<PlanDef>;
  rank?: Maybe<Scalars['Int']['output']>;
  run: ExplorationRunDef;
  scenario: ScenarioDef;
  solveSecondsGranted: Scalars['Float']['output'];
  status: RouteStudioExplorationCandidateStatusChoices;
};

export type ExplorationCandidateDefConnection = {
  __typename: 'ExplorationCandidateDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ExplorationCandidateDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ExplorationCandidateDef` and its cursor. */
export type ExplorationCandidateDefEdge = {
  __typename: 'ExplorationCandidateDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ExplorationCandidateDef>;
};

/**
 * RS-1501 nightly exploration run: budget ledger, hypothesis
 * audit, frontier and the morning digest (engine numbers only, LLM
 * narrative labeled).
 */
export type ExplorationRunDef = Node & {
  __typename: 'ExplorationRunDef';
  baseScenario?: Maybe<ScenarioDef>;
  budgetExhausted: Scalars['Boolean']['output'];
  candidates: ExplorationCandidateDefConnection;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  digest: Scalars['JSONString']['output'];
  errorMessage: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  frontier: Scalars['JSONString']['output'];
  hypotheses: Scalars['JSONString']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  maxScenarios: Scalars['Int']['output'];
  maxSolveSeconds: Scalars['Float']['output'];
  planningArea: PlanningAreaDef;
  scenariosCreated: Scalars['Int']['output'];
  solveSecondsGranted: Scalars['Float']['output'];
  solveSecondsSpent: Scalars['Float']['output'];
  status: RouteStudioExplorationRunStatusChoices;
};


/**
 * RS-1501 nightly exploration run: budget ledger, hypothesis
 * audit, frontier and the morning digest (engine numbers only, LLM
 * narrative labeled).
 */
export type ExplorationRunDefCandidatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ExplorationRunDefConnection = {
  __typename: 'ExplorationRunDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ExplorationRunDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ExplorationRunDef` and its cursor. */
export type ExplorationRunDefEdge = {
  __typename: 'ExplorationRunDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ExplorationRunDef>;
};

export type ExportBillingRunToNavision = {
  __typename: 'ExportBillingRunToNavision';
  billingRun?: Maybe<BillingRunDef>;
};

export type ExportConfigDef = {
  __typename: 'ExportConfigDef';
  allowedExports?: Maybe<Array<Maybe<ExportConfigExportDef>>>;
};

export type ExportConfigExportDef = {
  __typename: 'ExportConfigExportDef';
  allowFuture?: Maybe<Scalars['Boolean']['output']>;
  allowPast?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['Boolean']['output']>;
  exportType?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<ExportConfigExportFieldDef>>>;
  startDate?: Maybe<Scalars['Boolean']['output']>;
};

export type ExportConfigExportFieldDef = {
  __typename: 'ExportConfigExportFieldDef';
  helpText?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ExportDebtorData = {
  __typename: 'ExportDebtorData';
  export?: Maybe<DebtorExportDef>;
};

/**
 *
 *     Choices that represent the all filters for ExportTemplate (ExportField)
 *
 */
export enum ExportFieldOperatorsTypes {
  CONTAINS = 'CONTAINS',
  ENDS_WITH = 'ENDS_WITH',
  EQUAL = 'EQUAL',
  GREATER_EQUAL_THAN = 'GREATER_EQUAL_THAN',
  GREATER_THAN = 'GREATER_THAN',
  IN_LIST = 'IN_LIST',
  IS_EMPTY = 'IS_EMPTY',
  IS_NOT_EMPTY = 'IS_NOT_EMPTY',
  IS_NOT_NULL = 'IS_NOT_NULL',
  IS_NULL = 'IS_NULL',
  LESS_EQUAL_THAN = 'LESS_EQUAL_THAN',
  LESS_THAN = 'LESS_THAN',
  NOT_CONTAINS = 'NOT_CONTAINS',
  NOT_EQUAL = 'NOT_EQUAL',
  NOT_IN_LIST = 'NOT_IN_LIST',
  STARTS_WITH = 'STARTS_WITH'
}

/** Fields for export by export type */
export type ExportFieldType = {
  __typename: 'ExportFieldType';
  column: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  operators: Array<Maybe<ExportFieldOperatorsTypes>>;
  type: Scalars['String']['output'];
};

/** Filter for export */
export type ExportFilterType = {
  __typename: 'ExportFilterType';
  field: Scalars['String']['output'];
  operator: ExportFieldOperatorsTypes;
  value?: Maybe<Scalars['GenericScalar']['output']>;
};

/** Filter for export input type */
export type ExportFilterTypeInput = {
  field: Scalars['String']['input'];
  operator: ExportFieldOperatorsTypes;
  value?: InputMaybe<Scalars['GenericScalar']['input']>;
};

/** Filters for export by export type */
export type ExportFiltersSectionType = {
  __typename: 'ExportFiltersSectionType';
  /** Related export model */
  exportModel: AllExportTypes;
  /** Fields for filters */
  fields: Array<Maybe<ExportFieldType>>;
};

/**
 *
 *     Formats that can be used in ExportTemplate
 *
 */
export enum ExportFormats {
  CSV = 'CSV',
  PDF = 'PDF',
  XLSX = 'XLSX'
}

/** Export history */
export type ExportHistoryDef = Node & {
  __typename: 'ExportHistoryDef';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  export?: Maybe<ExportTemplateDef>;
  exportType?: Maybe<ExportTypes>;
  externalRecipients: Array<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  internalRecipients: UserTypeConnection;
  progress: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ExportImportExportHistoryStatusChoices;
  totalItems?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<UserType>;
};


/** Export history */
export type ExportHistoryDefInternalRecipientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ExportHistoryDefConnection = {
  __typename: 'ExportHistoryDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ExportHistoryDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ExportHistoryDef` and its cursor. */
export type ExportHistoryDefEdge = {
  __typename: 'ExportHistoryDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ExportHistoryDef>;
};

/**
 *
 *     Statuses that can be used in ExportHistory
 *
 */
export enum ExportHistoryStatuses {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NEW = 'NEW'
}

/** An enumeration. */
export enum ExportImportExportHistoryStatusChoices {
  /** Completed */
  COMPLETED = 'COMPLETED',
  /** Failed */
  FAILED = 'FAILED',
  /** In Progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** New */
  NEW = 'NEW'
}

/** An enumeration. */
export enum ExportImportImportHistoryFileDelimiterChoices {
  /** Comma */
  COMMA = 'COMMA',
  /** Pipe */
  PIPE = 'PIPE',
  /** Semicolon */
  SEMICOLON = 'SEMICOLON',
  /** Tab */
  TAB = 'TAB'
}

/**
 * W9.1: the audit trail as a CSV — same rows as the query (they
 * share insights.audit.audit_rows so they can never disagree).
 */
export type ExportInsightsAudit = {
  __typename: 'ExportInsightsAudit';
  contentBase64?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  mime?: Maybe<Scalars['String']['output']>;
};

export type ExportInsightsResult = {
  __typename: 'ExportInsightsResult';
  contentBase64?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  mime?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum ExportIntervalEnum {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY'
}

/**
 * SBX-366 (D32, D08): the RS-204 comparison as a downloadable
 * xlsx or pdf. Read-only (no master gate): the document is built
 * from recorded rows through the same scoring/rates helpers the
 * query surface uses, and the D32 claim-grade label plus baseline
 * caveats render in the file itself.
 */
export type ExportPlanComparisonMutation = {
  __typename: 'ExportPlanComparisonMutation';
  export?: Maybe<RouteStudioExportDef>;
};

/**
 * SBX-366 (D32, D08): one plan's recorded summary (KPIs,
 * decomposition, calendar impact, binding constraints) as a
 * downloadable xlsx or pdf, with the D32 basis block on the page.
 */
export type ExportPlanSummaryMutation = {
  __typename: 'ExportPlanSummaryMutation';
  export?: Maybe<RouteStudioExportDef>;
};

/**
 * SBX-366 (D32, D18): the promotion's RECORDED diff (the stored
 * shared-derivation summary, never a re-derivation) as a
 * downloadable xlsx or pdf. Counts are exact, entry lists capped
 * with truncation flags, and the D32 basis block renders on the
 * page.
 */
export type ExportPromotionDiffMutation = {
  __typename: 'ExportPromotionDiffMutation';
  export?: Maybe<RouteStudioExportDef>;
};

/**
 * W11.2: a generated statutory draft as CSV/XLSX — frozen fields
 * flattened for the officer's filing workflow.
 */
export type ExportStatutoryDraft = {
  __typename: 'ExportStatutoryDraft';
  contentBase64?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  mime?: Maybe<Scalars['String']['output']>;
};

/** Export template */
export type ExportTemplateDef = Node & {
  __typename: 'ExportTemplateDef';
  automaticallySendExportToExternalRecepients?: Maybe<Scalars['Boolean']['output']>;
  automaticallySendExportToInternalRecepients?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserType;
  /** Total items for export */
  currentTotalItems?: Maybe<Scalars['Int']['output']>;
  dailyIntervalStartTime?: Maybe<Scalars['Time']['output']>;
  dailyIntervalStartingFrom?: Maybe<Scalars['Date']['output']>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** External recipients */
  exportExternalRecipients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exportFormat: ExportFormats;
  /** Export history */
  exportHistory?: Maybe<ExportHistoryDefConnection>;
  /** Internal recipients */
  exportInternalRecipients?: Maybe<UserTypeConnection>;
  exportIntervalSettings?: Maybe<ExportIntervalEnum>;
  exportIntervalValue?: Maybe<Scalars['Int']['output']>;
  exportType: ExportTypes;
  /** External recipients */
  externalRecipients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Fields for export */
  fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Filters for export */
  filters?: Maybe<Array<Maybe<ExportFilterType>>>;
  frozen: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Internal recipients */
  internalRecipients?: Maybe<UserTypeConnection>;
  isNestedFields: Scalars['Boolean']['output'];
  /** Latest export count */
  latestExportCount?: Maybe<Scalars['Int']['output']>;
  /** Latest exported at */
  latestExportedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Latest exported by */
  latestExportedBy?: Maybe<UserType>;
  /** Latest progress */
  latestProgress?: Maybe<Scalars['Int']['output']>;
  /** Latest status */
  latestStatus?: Maybe<ExportHistoryStatuses>;
  /** Map segments for export */
  mapSegments?: Maybe<Scalars['GenericScalar']['output']>;
  monthlyIntervalSetting?: Maybe<MonthlyIntervalEnum>;
  name: Scalars['String']['output'];
  projects: ProjectTypeConnection;
  /** Flag for scheduled exports to send emails to external recipients */
  scheduleExportSendToExternalRecipients: Scalars['Boolean']['output'];
  /** Flag for scheduled exports to send emails to internal recipients */
  scheduleExportSendToInternalRecipients: Scalars['Boolean']['output'];
  scheduledExportExternalRecipients: Array<Scalars['String']['output']>;
  scheduledExportInternalRecipients: UserTypeConnection;
  updatedAt: Scalars['DateTime']['output'];
};


/** Export template */
export type ExportTemplateDefExportHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exportType?: InputMaybe<Array<InputMaybe<ExportTypes>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Array<InputMaybe<ExportHistoryStatuses>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


/** Export template */
export type ExportTemplateDefExportInternalRecipientsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstName_Icontains?: InputMaybe<Scalars['String']['input']>;
  hasDriverRole?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDriver?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastName_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


/** Export template */
export type ExportTemplateDefInternalRecipientsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstName_Icontains?: InputMaybe<Scalars['String']['input']>;
  hasDriverRole?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDriver?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastName_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


/** Export template */
export type ExportTemplateDefProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Export template */
export type ExportTemplateDefScheduledExportInternalRecipientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ExportTemplateDefConnection = {
  __typename: 'ExportTemplateDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ExportTemplateDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ExportTemplateDef` and its cursor. */
export type ExportTemplateDefEdge = {
  __typename: 'ExportTemplateDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ExportTemplateDef>;
};

export type ExportTemplateScheduleSettingsUpdate = {
  __typename: 'ExportTemplateScheduleSettingsUpdate';
  exportTemplate?: Maybe<ExportTemplateDef>;
};

/** Total items for export */
export type ExportTemplateTotalItems = {
  __typename: 'ExportTemplateTotalItems';
  totalItems: Scalars['Int']['output'];
};

export type ExportType = Node & {
  __typename: 'ExportType';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  excelFormat: Scalars['Boolean']['output'];
  exportType: CoreExportExportTypeChoices;
  file?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  progressPercent: Scalars['Int']['output'];
  status: CoreExportStatusChoices;
};

export type ExportTypeConnection = {
  __typename: 'ExportTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ExportTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ExportType` and its cursor. */
export type ExportTypeEdge = {
  __typename: 'ExportTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ExportType>;
};

/**
 *
 *     Types that can be used in ExportTemplate
 *     Database value should represent model name
 *
 */
export enum ExportTypes {
  AGREEMENT = 'AGREEMENT',
  COLLECTION_CALENDAR = 'COLLECTION_CALENDAR',
  COLLECTION_CALENDAR_DATE = 'COLLECTION_CALENDAR_DATE',
  CONTACT = 'CONTACT',
  CONTAINER = 'CONTAINER',
  CONTAINER_TYPE = 'CONTAINER_TYPE',
  HAULER_PRICE = 'HAULER_PRICE',
  PICKUP_ORDER = 'PICKUP_ORDER',
  PICKUP_SETTING = 'PICKUP_SETTING',
  PRODUCT = 'PRODUCT',
  PROPERTY = 'PROPERTY',
  PROPERTY_MANAGEMENT_COMPANY = 'PROPERTY_MANAGEMENT_COMPANY',
  ROUTE = 'ROUTE',
  ROUTE_DRIVING_EVENTS = 'ROUTE_DRIVING_EVENTS',
  SERVICE = 'SERVICE',
  TICKET = 'TICKET',
  TICKET_TYPE = 'TICKET_TYPE',
  VEHICLE = 'VEHICLE',
  WASTE_FRACTION = 'WASTE_FRACTION'
}

/** A computed column of a plan (plan_schema.ExpressionSpec). */
export type ExpressionInput = {
  formula: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/**
 * Move one rental unit's return date later (PRODUCT-452, BE-E1 - the
 * office list's Extend action). Writes the unit's ``period_end_date``
 * through ``inventory.services.rental_extend.extend_rental``: the hire
 * product's ``max_days`` rule is re-applied to the new period, the
 * STRICT availability gate is re-run for the unit's pool at the new end
 * (it refuses only a pool that is already short - under STRICT the
 * extension itself never changes the count), a later booking already
 * committed to the same physical unit refuses the extension, and on
 * success the rental-backed
 * agreement's end (``rental:<ticket pk>`` / started_by_ticket) and the
 * open return ticket's preferred date move along with it. Same shape and
 * company wall as ``issueRental`` / ``returnRental``; refusals name the
 * ``periodEndDate`` field.
 */
export type ExtendRental = {
  __typename: 'ExtendRental';
  periodEndDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  ticketId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Extend the duration of an active temporary location override.
 *
 * Updates the owning ticket's ``periodEndDate`` (the generic Include
 * period field, PRO-385) without changing the location itself.
 */
export type ExtendTemporaryContainerLocation = {
  __typename: 'ExtendTemporaryContainerLocation';
  container?: Maybe<ContainerType>;
  temporaryLocationOverride?: Maybe<TemporaryContainerLocationType>;
};

/**
 * An externally-sourced stop confirmation and what became of it.
 *
 * No ``fields``/``exclude`` in Meta (house convention), so a new column on
 * the model publishes itself; the model's ``help_text``/docstrings are the
 * user-facing documentation.
 */
export type ExternalCollectionEventDef = Node & {
  __typename: 'ExternalCollectionEventDef';
  appliedPickupOrder?: Maybe<PickUpOrderType>;
  company: CompanyType;
  container?: Maybe<ContainerType>;
  containerExternalId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deviationCode: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  fillLevel?: Maybe<Scalars['Float']['output']>;
  gpsAccuracyM?: Maybe<Scalars['Float']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** WGS84 latitude of the read. Null when the vendor sent no position — never inferred. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** WGS84 longitude of the read. Null when the vendor sent no position — never inferred. */
  longitude?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  /** The stop this event completed, or found already completed. Matches PickUpOrderType.orderId. */
  pickupOrderId?: Maybe<Scalars['String']['output']>;
  point?: Maybe<Scalars['GeoJSON']['output']>;
  raw: Scalars['JSONString']['output'];
  readAt: Scalars['DateTime']['output'];
  sourceSystem: Scalars['String']['output'];
  status: IntegrationsExternalCollectionEventStatusChoices;
  tagId: Scalars['String']['output'];
  tagType: IntegrationsExternalCollectionEventTagTypeChoices;
  updatedAt: Scalars['DateTime']['output'];
  vehicleRegistration: Scalars['String']['output'];
  weightKg?: Maybe<Scalars['Float']['output']>;
};

export type ExternalCollectionEventDefConnection = {
  __typename: 'ExternalCollectionEventDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ExternalCollectionEventDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ExternalCollectionEventDef` and its cursor. */
export type ExternalCollectionEventDefEdge = {
  __typename: 'ExternalCollectionEventDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ExternalCollectionEventDef>;
};

/**
 * Terminal disposition of one ingested confirmation.
 *
 *     Every ingested event ends in exactly one of these and the row is
 *     persisted either way — "reported, not raised" is the contract, so a bad
 *     event never rolls back its batch and never disappears.
 *
 */
export enum ExternalCollectionEventStatus {
  ALREADY_COMPLETED = 'ALREADY_COMPLETED',
  APPLIED = 'APPLIED',
  RECEIVED = 'RECEIVED',
  REJECTED = 'REJECTED',
  UNMATCHED = 'UNMATCHED'
}

export type ExternalConfirmationInput = {
  /** The vendor's container id, matched against Container.containerId when no tag matches. */
  containerExternalId?: InputMaybe<Scalars['String']['input']>;
  /** Vendor deviation/collection code, stored verbatim. NOT mapped to a Ticket in this release. */
  deviationCode?: InputMaybe<Scalars['String']['input']>;
  /** The vendor's own id for this read. THE idempotency key: re-sending it is a no-op. */
  externalId: Scalars['String']['input'];
  fillLevel?: InputMaybe<Scalars['Float']['input']>;
  gpsAccuracyM?: InputMaybe<Scalars['Float']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** The vendor payload as received, kept for disputes. */
  raw?: InputMaybe<Scalars['JSONString']['input']>;
  /** When the READER read the tag — becomes the stop's completedAt, not the time this call was made. */
  readAt: Scalars['DateTime']['input'];
  /** RFID/NFC tag as read. */
  tagId?: InputMaybe<Scalars['String']['input']>;
  /** RFID | NFC | OTHER. Drives the provenance the driver app renders (autoCompletedBy). Defaults to OTHER -> EXTERNAL rather than guessing RFID. */
  tagType?: InputMaybe<ExternalTagType>;
  vehicleRegistration?: InputMaybe<Scalars['String']['input']>;
  weightKg?: InputMaybe<Scalars['Float']['input']>;
};

export type ExternalConfirmationResultType = {
  __typename: 'ExternalConfirmationResultType';
  containerId?: Maybe<Scalars['ID']['output']>;
  /** True when this externalId was already stored — the event was NOT re-applied and the stored status is returned. */
  duplicate: Scalars['Boolean']['output'];
  eventId?: Maybe<Scalars['ID']['output']>;
  externalId: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  pickupOrderId?: Maybe<Scalars['String']['output']>;
  /** APPLIED = this event completed the stop. ALREADY_COMPLETED = a driver (or an earlier event) got there first and NOTHING was overwritten. UNMATCHED = no container/open stop — it is in the office queue. REJECTED = structurally invalid or refused by the completion funnel. */
  status: ExternalCollectionEventStatus;
};

/**
 * A registered external map layer (`routes.ExternalMapLayer` — 3.1.45 /
 * REQ-47). Platform Settings configuration: company-walled, contractors
 * denied (same rule as ZoneDef / ZoneLabelDef). ``layer_type`` is served as a
 * plain string so the FE owns the display labels.
 */
export type ExternalMapLayerDef = Node & {
  __typename: 'ExternalMapLayerDef';
  attribution: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  layerIdentifier: Scalars['String']['output'];
  layerType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ordering: Scalars['Int']['output'];
  refreshIntervalMinutes?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type ExternalMapLayerDefConnection = {
  __typename: 'ExternalMapLayerDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ExternalMapLayerDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ExternalMapLayerDef` and its cursor. */
export type ExternalMapLayerDefEdge = {
  __typename: 'ExternalMapLayerDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ExternalMapLayerDef>;
};

/**
 * Which reader family produced the read.
 *
 *     Drives the completion provenance the driver app renders: RFID -> RFID,
 *     NFC -> NFC, OTHER/absent -> EXTERNAL
 *     (``routes.choices.AutoCompletedByChoices``). A vendor that cannot say
 *     must not have its read mislabelled as UHF-RFID, which is why OTHER
 *     exists and is the default.
 *
 */
export enum ExternalTagType {
  NFC = 'NFC',
  OTHER = 'OTHER',
  RFID = 'RFID'
}

export type FcmDeviceType = Node & {
  __typename: 'FCMDeviceType';
  /** Inactive devices will not be sent notifications */
  active: Scalars['Boolean']['output'];
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** Unique device identifier */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  registrationId: Scalars['String']['output'];
  type: FcmDjangoFcmDeviceTypeChoices;
  user?: Maybe<UserType>;
};

export type FcmDeviceTypeConnection = {
  __typename: 'FCMDeviceTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FcmDeviceTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FCMDeviceType` and its cursor. */
export type FcmDeviceTypeEdge = {
  __typename: 'FCMDeviceTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FcmDeviceType>;
};

/** An enumeration. */
export enum FtpProtocolEnum {
  FTP = 'FTP',
  FTPS = 'FTPS',
  SFTP = 'SFTP'
}

export type Fu51007FileLineDef = Node & {
  __typename: 'FU51007FileLineDef';
  alternativePlaceIdField: Scalars['String']['output'];
  clientAddressField: Scalars['String']['output'];
  clientCityNameField: Scalars['String']['output'];
  clientCoNameField: Scalars['String']['output'];
  clientIdEntField: Scalars['String']['output'];
  clientIdField: Scalars['String']['output'];
  clientMovedInDateField?: Maybe<Scalars['Date']['output']>;
  clientMovedOutDateField?: Maybe<Scalars['Date']['output']>;
  clientNameField: Scalars['String']['output'];
  clientNumberField?: Maybe<Scalars['Int']['output']>;
  clientNumberOfAdultsField: Scalars['String']['output'];
  clientNumberOfChildrenField: Scalars['String']['output'];
  clientNumberOfYouthField: Scalars['String']['output'];
  clientPostalDistrictField: Scalars['String']['output'];
  consumptionPlaceIdEntField: Scalars['String']['output'];
  consumptionPlaceIdField: Scalars['String']['output'];
  consumptionPlaceXCoordinateField: Scalars['String']['output'];
  consumptionPlaceYCoordinateField: Scalars['String']['output'];
  consumptionStreetNameField: Scalars['String']['output'];
  contact?: Maybe<ContactDef>;
  createdAt: Scalars['DateTime']['output'];
  dropOffDistrictCodeField: Scalars['String']['output'];
  dropOffDistrictTextField: Scalars['String']['output'];
  emptyingAlternative: Scalars['String']['output'];
  emptyingFloorField: Scalars['String']['output'];
  emptyingHouseLetterField: Scalars['String']['output'];
  emptyingHouseNumberField: Scalars['String']['output'];
  emptyingMunicipalityCodeField: Scalars['String']['output'];
  emptyingRunningNumberField: Scalars['String']['output'];
  emptyingSideDoorNumberField: Scalars['String']['output'];
  emptyingStreetCodeField: Scalars['String']['output'];
  emptyingXCoordinateField: Scalars['String']['output'];
  emptyingYCoordinateField: Scalars['String']['output'];
  errorAt?: Maybe<Scalars['DateTime']['output']>;
  errors?: Maybe<Fu51007FileLineErrorDefConnection>;
  euroXCoordinateField: Scalars['String']['output'];
  euroYCoordinateField: Scalars['String']['output'];
  fileId?: Maybe<ImportedKmdEasyFileDef>;
  houseNumberField: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importFile: ImportedKmdEasyFileDef;
  installIdField: Scalars['String']['output'];
  kmdEasyFu51007FileLineErrors: Fu51007FileLineErrorDefConnection;
  kmdMunicipalityCodeField?: Maybe<Scalars['Int']['output']>;
  managementCompany?: Maybe<PropertyManagementCompanyDef>;
  postNumberField: Scalars['String']['output'];
  postalDistrictField: Scalars['String']['output'];
  property?: Maybe<PropertyDef>;
  propertyContact?: Maybe<PropertyContactDef>;
  propertyEdited?: Maybe<PropertyDef>;
  propertyNumberField: Scalars['String']['output'];
  readingDistrictNumberField: Scalars['String']['output'];
  routeNumberField: Scalars['String']['output'];
  rowNumber?: Maybe<Scalars['Int']['output']>;
  settlementGroupNumberField: Scalars['String']['output'];
  settlementGroupTypeCodeField: Scalars['String']['output'];
  settlementGroupTypeTextField: Scalars['String']['output'];
  typeField?: Maybe<KmdEasyFu51007FileLineTypeFieldChoices>;
};


export type Fu51007FileLineDefErrorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  errorField?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  fileLineId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type Fu51007FileLineDefKmdEasyFu51007FileLineErrorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Fu51007FileLineDefConnection = {
  __typename: 'FU51007FileLineDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<Fu51007FileLineDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `FU51007FileLineDef` and its cursor. */
export type Fu51007FileLineDefEdge = {
  __typename: 'FU51007FileLineDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Fu51007FileLineDef>;
};

export type Fu51008FileLineDef = Node & {
  __typename: 'FU51008FileLineDef';
  agreements: AgreementDefConnection;
  alternativePlaceIdField: Scalars['String']['output'];
  amountOfUnitsField: Scalars['String']['output'];
  consumptionCodeIdField: Scalars['String']['output'];
  consumptionPlaceIdField: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveredDateField: Scalars['String']['output'];
  emptyingDayField: Scalars['String']['output'];
  emptyingOrderDayFromField: Scalars['String']['output'];
  emptyingOrderDayToField: Scalars['String']['output'];
  emptyingOrderFrequencyField: Scalars['String']['output'];
  emptyingOrderIdField: Scalars['String']['output'];
  emptyingOrderNoteField: Scalars['String']['output'];
  emptyingOrderNumberField: Scalars['String']['output'];
  emptyingOrderTextField: Scalars['String']['output'];
  emptyingOrderTextLargeField: Scalars['String']['output'];
  emptyingRouteIdField: Scalars['String']['output'];
  errorAt?: Maybe<Scalars['DateTime']['output']>;
  errors?: Maybe<Fu51008FileLineErrorDefConnection>;
  externalContainerBrickNumberField: Scalars['String']['output'];
  externalContainerCode: Scalars['String']['output'];
  externalContainerIdEntField: Scalars['String']['output'];
  externalContainerIdField: Scalars['String']['output'];
  externalContainerNumberField: Scalars['String']['output'];
  externalContainerTypeIdField: Scalars['String']['output'];
  externalContainerTypeTextField: Scalars['String']['output'];
  extraInfoField: Scalars['String']['output'];
  fileId?: Maybe<ImportedKmdEasyFileDef>;
  frequencyTextField: Scalars['String']['output'];
  fromDateField: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importFile: ImportedKmdEasyFileDef;
  installAmountFactorField: Scalars['String']['output'];
  installAmountFractionField: Scalars['String']['output'];
  installAmountIdField: Scalars['String']['output'];
  installIdEntField: Scalars['String']['output'];
  installIdField: Scalars['String']['output'];
  installNumberField: Scalars['String']['output'];
  invoiceCodeField: Scalars['String']['output'];
  invoiceCodeGroupField: Scalars['String']['output'];
  kmdEasyFu51008FileLineErrors: Fu51008FileLineErrorDefConnection;
  measurementUnitField: Scalars['String']['output'];
  productNameField: Scalars['String']['output'];
  property?: Maybe<PropertyDef>;
  propertyEdited?: Maybe<PropertyDef>;
  removedDateField: Scalars['String']['output'];
  rowNumber?: Maybe<Scalars['Int']['output']>;
  toDateField: Scalars['String']['output'];
  typeField: Scalars['String']['output'];
};


export type Fu51008FileLineDefAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type Fu51008FileLineDefErrorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  errorField?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  fileLineId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type Fu51008FileLineDefKmdEasyFu51008FileLineErrorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Fu51008FileLineDefConnection = {
  __typename: 'FU51008FileLineDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<Fu51008FileLineDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `FU51008FileLineDef` and its cursor. */
export type Fu51008FileLineDefEdge = {
  __typename: 'FU51008FileLineDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Fu51008FileLineDef>;
};

/** An enumeration. */
export enum FcmDjangoFcmDeviceTypeChoices {
  /** android */
  ANDROID = 'ANDROID',
  /** ios */
  IOS = 'IOS',
  /** web */
  WEB = 'WEB'
}

export type FeatureConfigAuditType = {
  __typename: 'FeatureConfigAuditType';
  action: Scalars['String']['output'];
  actor?: Maybe<Scalars['String']['output']>;
  batchId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<FeatureConfigCompanyRefType>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  newValue?: Maybe<Scalars['GenericScalar']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['GenericScalar']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

export type FeatureConfigBatchType = {
  __typename: 'FeatureConfigBatchType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  done: Scalars['Int']['output'];
  errors?: Maybe<Scalars['GenericScalar']['output']>;
  failed: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FeatureConfigBulkEntryInput = {
  key: Scalars['String']['input'];
  value: Scalars['GenericScalar']['input'];
};

export type FeatureConfigBulkPreviewRowType = {
  __typename: 'FeatureConfigBulkPreviewRowType';
  companyId: Scalars['ID']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  currentValue?: Maybe<Scalars['GenericScalar']['output']>;
  drift: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  newValue?: Maybe<Scalars['GenericScalar']['output']>;
  protected: Scalars['Boolean']['output'];
  willChange: Scalars['Boolean']['output'];
};

export type FeatureConfigBulkPreviewType = {
  __typename: 'FeatureConfigBulkPreviewType';
  changes: Scalars['Int']['output'];
  protectedCount: Scalars['Int']['output'];
  rows?: Maybe<Array<Maybe<FeatureConfigBulkPreviewRowType>>>;
  total: Scalars['Int']['output'];
};

export type FeatureConfigBulkTargetInput = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mode: Scalars['String']['input'];
};

export type FeatureConfigCatalogEntryType = {
  __typename: 'FeatureConfigCatalogEntryType';
  area: Scalars['String']['output'];
  category: Scalars['String']['output'];
  countries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  default?: Maybe<Scalars['GenericScalar']['output']>;
  description: Scalars['String']['output'];
  enforcement?: Maybe<Scalars['String']['output']>;
  enumChoices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  group?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  legacyField?: Maybe<Scalars['String']['output']>;
  lifecycle: Scalars['String']['output'];
  module?: Maybe<Scalars['String']['output']>;
  programmes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requires?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  scope?: Maybe<Scalars['String']['output']>;
  sideEffects?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  surfaces?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  valueType: Scalars['String']['output'];
};

export type FeatureConfigCompanyRefType = {
  __typename: 'FeatureConfigCompanyRefType';
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type FeatureConfigLayerType = {
  __typename: 'FeatureConfigLayerType';
  hasRule: Scalars['Boolean']['output'];
  isWinner: Scalars['Boolean']['output'];
  ruleId?: Maybe<Scalars['ID']['output']>;
  scope: Scalars['String']['output'];
  value?: Maybe<Scalars['GenericScalar']['output']>;
};

export type FeatureConfigOverrideCountType = {
  __typename: 'FeatureConfigOverrideCountType';
  companyCount: Scalars['Int']['output'];
  countryCount: Scalars['Int']['output'];
  hasGlobal: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
};

export type FeatureConfigOverviewRowType = {
  __typename: 'FeatureConfigOverviewRowType';
  catalog: FeatureConfigCatalogEntryType;
  resolution: FeatureConfigResolutionType;
};

export type FeatureConfigResolutionType = {
  __typename: 'FeatureConfigResolutionType';
  drift: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  localValue?: Maybe<Scalars['GenericScalar']['output']>;
  source: Scalars['String']['output'];
  stack?: Maybe<Array<Maybe<FeatureConfigLayerType>>>;
  value?: Maybe<Scalars['GenericScalar']['output']>;
  winningRule?: Maybe<FeatureConfigRuleType>;
};

export type FeatureConfigRuleInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  overwriteDrift?: InputMaybe<Scalars['Boolean']['input']>;
  scope: Scalars['String']['input'];
  value: Scalars['GenericScalar']['input'];
};

export type FeatureConfigRuleType = {
  __typename: 'FeatureConfigRuleType';
  company?: Maybe<FeatureConfigCompanyRefType>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  scope: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['GenericScalar']['output']>;
};

/** An enumeration. */
export enum FieldTypeEnum {
  CUSTOM_TICKET_FIELD = 'CUSTOM_TICKET_FIELD',
  META_FIELD = 'META_FIELD',
  STATIC = 'STATIC'
}

export type FileListType = {
  __typename: 'FileListType';
  currentPath?: Maybe<Scalars['String']['output']>;
  dirs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  files?: Maybe<Array<Maybe<FileObjectType>>>;
};

export type FileObjectType = {
  __typename: 'FileObjectType';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FillLevelMeasurementType = Node & {
  __typename: 'FillLevelMeasurementType';
  batteryLevel?: Maybe<Scalars['Float']['output']>;
  batteryPercentage?: Maybe<Scalars['Float']['output']>;
  containerDevice?: Maybe<DeviceToContainerType>;
  createdAt: Scalars['DateTime']['output'];
  devId?: Maybe<Scalars['String']['output']>;
  /** m */
  fillLevel: Scalars['Float']['output'];
  /** % */
  fillPercentage: Scalars['Float']['output'];
  /** @deprecated No longer used */
  fillPercentageMasked?: Maybe<Scalars['Float']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  measurement?: Maybe<ContainerType>;
  /** m */
  rawMeasurements?: Maybe<Array<Scalars['Float']['output']>>;
  rawMeasurementsPercentage?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  rsi?: Maybe<Scalars['Float']['output']>;
  /** Temperature in degree celsius */
  temperature?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FillLevelMeasurementTypeConnection = {
  __typename: 'FillLevelMeasurementTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FillLevelMeasurementTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FillLevelMeasurementType` and its cursor. */
export type FillLevelMeasurementTypeEdge = {
  __typename: 'FillLevelMeasurementTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FillLevelMeasurementType>;
};

/**
 * A plan filter: one predicate on a filterable field (``field``,
 * ``op``, ``value``; mirrors plan_schema.FilterSpec), or an OR group
 * (``or``: filters of which any one must hold; plan_schema.FilterGroup).
 * ``not_null`` takes no value.
 */
export type FilterInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  op?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<FilterItemInput>>;
  value?: InputMaybe<Scalars['GenericScalar']['input']>;
};

/** One filter of an OR group (mirrors plan_schema.FilterSpec). */
export type FilterItemInput = {
  field: Scalars['String']['input'];
  op: Scalars['String']['input'];
  value?: InputMaybe<Scalars['GenericScalar']['input']>;
};

export type FinanceCreditNoteRowInput = {
  /** Credited amount (positive). */
  amount: Scalars['Decimal']['input'];
  /** The finance system's unique credit note number. */
  creditNoteNumber: Scalars['String']['input'];
  /** Credit note date. */
  date: Scalars['Date']['input'];
  /** The exported line reference (the billable event id). */
  lineReference: Scalars['String']['input'];
};

export type FinanceCreditNoteRowResultType = {
  __typename: 'FinanceCreditNoteRowResultType';
  /** Rejection code: unknown_line | missing_credit_note_number | invalid_amount | invalid_date | credit_note_conflict. */
  code?: Maybe<Scalars['String']['output']>;
  creditNoteNumber: Scalars['String']['output'];
  lineReference: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** imported | updated | unchanged | rejected */
  status: Scalars['String']['output'];
};

/**
 * One finance feeder export run: system, period, verdict, totals and
 * the signed download URL of the file (null for EMPTY / FAILED runs).
 */
export type FinanceFeederExportLogDef = {
  __typename: 'FinanceFeederExportLogDef';
  contentHash: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['Int']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  errorMessage: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  includeExported: Scalars['Boolean']['output'];
  lineCount: Scalars['Int']['output'];
  missingBpNumberCount: Scalars['Int']['output'];
  periodFrom: Scalars['Date']['output'];
  periodTo: Scalars['Date']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  system: Scalars['String']['output'];
  totalGross: Scalars['Decimal']['output'];
  totalNet: Scalars['Decimal']['output'];
  totalVat: Scalars['Decimal']['output'];
  warnings?: Maybe<Scalars['GenericScalar']['output']>;
};

/** One route's outcome in a bulk Apply. */
export type FixedRouteApplyToRouteResult = {
  __typename: 'FixedRouteApplyToRouteResult';
  applied?: Maybe<Scalars['Boolean']['output']>;
  frozenStops?: Maybe<Scalars['Int']['output']>;
  movedStops?: Maybe<Scalars['Int']['output']>;
  /** Why nothing was applied: no_active_template, route_completed, route_started (a driver has started it and includeStarted was not given), uncovered_stops (the template does not order every stop of the route - see uncoveredStops), no_route_scheme, or a permission refusal. Empty on success. */
  reason?: Maybe<Scalars['String']['output']>;
  route?: Maybe<RouteType>;
  /** The id the caller sent - the only handle left when the route could not be resolved (reason not_found) and route is null. */
  routeId?: Maybe<Scalars['ID']['output']>;
  routeStops?: Maybe<Scalars['Int']['output']>;
  /** With reason uncovered_stops: how many container stops of the route the template does not order. A bulk Apply never re-sequences such a route (Anton, 2026-09-23); open it and apply by hand, or confirm the branch the nightly pass made. */
  uncoveredStops?: Maybe<Scalars['Int']['output']>;
  unsequencedContainers?: Maybe<Scalars['Int']['output']>;
};

/**
 * An upcoming route whose fixed route template does not cover every
 * stop on it, as the ``event`` of a bell UserNotification (COMPASS-1770,
 * a member of the notifications event union). The row is the sweep's
 * ``attention_needed`` ``FixedRouteTemplateEvent``, which names the
 * route the card deep-links to (its Fixed route template tab, where the
 * unplaced stops sit at the bottom). ``unsequencedStops`` is measured
 * live, so a card read after the planner placed the stops says 0.
 *
 * Only reachable through the owner's own notifications — same exposure
 * as AreaExpiringEventDef. ``skip_registry`` because
 * ``FixedRouteTemplateEventType`` is the model's registered type; this
 * is a second, narrow view of it for the bell.
 */
export type FixedRouteAttentionEventDef = {
  __typename: 'FixedRouteAttentionEventDef';
  /** suggested / auto_adopted: share of the route's containers the template orders, 0..1, measured live. */
  coverage?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** attention_needed: a route carries stops its template never sequenced. suggested: another scheme's template (templateId) already orders most of this route (coverage). auto_adopted: that template covered the whole route and was installed and applied automatically. scheme_drift: the scheme's master data moved under its active template (newContainers / orphanEntries); routeId is null, use routeSchemeId. branched: a draft template was made for the route (the closest template plus the route's new stops, unreviewedStops of them placed by the machine) and waits for a planner's Confirm. */
  eventType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** scheme_drift: master-data containers the template has never seen, measured live. */
  newContainers?: Maybe<Scalars['Int']['output']>;
  /** scheme_drift: template entries whose container left the round, measured live. */
  orphanEntries?: Maybe<Scalars['Int']['output']>;
  routeId?: Maybe<Scalars['ID']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
  /** RouteSchemeType gid of the scheme the card is about. */
  routeSchemeId?: Maybe<Scalars['ID']['output']>;
  routeSchemeName?: Maybe<Scalars['String']['output']>;
  scheduledDay?: Maybe<Scalars['Date']['output']>;
  /** FixedRouteTemplateType gid: the suggested donor (suggested), the installed template (auto_adopted) or the drifting one. */
  templateId?: Maybe<Scalars['ID']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  /** attention_needed: stops a machine placed into the template that await a planner's look, measured live. */
  unreviewedStops?: Maybe<Scalars['Int']['output']>;
  unsequencedStops?: Maybe<Scalars['Int']['output']>;
};

/**
 * One route measured against its template, read-only
 * (``routes.services.fixed_routes_state.route_order_state``).
 */
export type FixedRouteOrderStateType = {
  __typename: 'FixedRouteOrderStateType';
  /** When a planner last applied a template to THIS route, from the audit trail. Null if never; the nightly generation does not count. */
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Library: this route is bound to the template shown - it drives it, or waits on it as a draft branch. */
  bound?: Maybe<Scalars['Boolean']['output']>;
  /** Stops the driver has collected or is heading for. */
  frozenStops?: Maybe<Scalars['Int']['output']>;
  /** The route's own auto-optimisation is ON: a planner switched it back after the template was applied, so the optimiser, not the template, drives this route until the next Apply. */
  optimizerOn?: Maybe<Scalars['Boolean']['output']>;
  /** Movable stops that would change slot if the template were applied now. */
  outOfOrderStops?: Maybe<Scalars['Int']['output']>;
  routeStops?: Maybe<Scalars['Int']['output']>;
  /** Library: how many routes are bound to this template. */
  sharedRoutes?: Maybe<Scalars['Int']['output']>;
  /** no_template | draft | ready | applied | diverged | needs_attention. 'diverged' means an active template governs the route but its stops are not in that order — the office re-optimised it, or the template changed since; re-Apply puts it back. 'needs_attention' means the route carries containers the template has never sequenced. */
  state?: Maybe<Scalars['String']['output']>;
  template?: Maybe<FixedRouteTemplateType>;
  /** Movable stops a machine placed into the template ('added') that no planner has reviewed yet. */
  unreviewedStops?: Maybe<Scalars['Int']['output']>;
  /** Movable stops the template has never sequenced. */
  unsequencedStops?: Maybe<Scalars['Int']['output']>;
};

/**
 * How complete a scheme's template is against the scheme's master
 * data — the number a planner reads to know whether the round still
 * needs their hand (``routes.services.fixed_routes_state``).
 */
export type FixedRouteSchemeSummaryType = {
  __typename: 'FixedRouteSchemeSummaryType';
  /** Containers the scheme collects per master data. */
  masterTotal?: Maybe<Scalars['Int']['output']>;
  /** Template entries whose container is no longer in the scheme's master data: moved to another round or deleted. Harmless to the order, but a sign the template has not been revisited. */
  orphanEntries?: Maybe<Scalars['Int']['output']>;
  /** Of those, how many the template already places. */
  sequenced?: Maybe<Scalars['Int']['output']>;
  /** 'none' when the scheme has no template, else the template's status: draft | ready | active. */
  status?: Maybe<Scalars['String']['output']>;
  template?: Maybe<FixedRouteTemplateType>;
  /** Master-data containers the template has never seen. Each one lands at the end of the next route it is due on, flagged, until a planner places it. */
  unsequencedMaster?: Maybe<Scalars['Int']['output']>;
};

/**
 * Mark every machine-placed ('added') entry of the template reviewed.
 *
 * The planner looked at where the machine put the new stops and agrees;
 * the entries become ``manual`` and stop counting as needing attention.
 * Dragging one already does this for that entry; this is the "all fine"
 * button for the rest.
 */
export type FixedRouteTemplateAcceptPlacements = {
  __typename: 'FixedRouteTemplateAcceptPlacements';
  accepted?: Maybe<Scalars['Int']['output']>;
  template?: Maybe<FixedRouteTemplateType>;
};

/**
 * Copy another scheme's template onto this route's scheme as a DRAFT.
 *
 * The reuse path: the planner sequenced this round once under another
 * scheme, or a suggestion (``RouteType.fixedRouteSuggestions``) found a
 * template that already orders most of this route. The order comes over
 * stamped ``inherited``, the rest of the scheme's master data is
 * appended, and the result is a DRAFT the planner confirms and applies
 * like any other — nothing is put into service by this call.
 */
export type FixedRouteTemplateAdopt = {
  __typename: 'FixedRouteTemplateAdopt';
  template?: Maybe<FixedRouteTemplateType>;
};

/**
 * Put the template into service and re-sequence ``route`` to it now.
 *
 * READY → ACTIVE, so every later generation the template governs is
 * re-sequenced too — every route of the SCHEME for the ordinary
 * scheme-wide template, or only the named truck's routes for a
 * vehicle-specific override — and the route the planner is looking at
 * is renumbered here rather than at the next nightly run, so they can
 * see what they just decided.
 *
 * ``auto_optimize`` is switched OFF on that route, and never back on: a
 * pinned order and a nightly re-optimisation are the same decision made
 * twice, so left on, the next optimisation would undo the order that
 * was just applied. Restoring it is a deliberate per-route action in
 * the office, not something this mutation reverses.
 *
 * A DRAFT template is refused: confirming it is the review step. An
 * already-ACTIVE one is not, so a planner can re-apply the order to the
 * next day's route without taking the template out of service first.
 * A COMPLETED route is refused outright, and a STARTED one is
 * re-sequenced only from the driver's next stop onward — the service
 * owns that rule so the nightly path inherits it too; refusing here as
 * well is so the planner is told, rather than watching Apply appear to
 * work on a round that is already driven.
 */
export type FixedRouteTemplateApply = {
  __typename: 'FixedRouteTemplateApply';
  /** True when the pass ran and found every movable stop already in template order, so nothing had to change. */
  alreadyInOrder?: Maybe<Scalars['Boolean']['output']>;
  /** When this Apply was recorded. */
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Containers the template had never seen that this Apply placed into it next to their nearest ordered neighbour (marked 'added', to be reviewed). */
  autoPlaced?: Maybe<Scalars['Int']['output']>;
  /** Other variants of this scheme that were ACTIVE and are now READY because this one took over. */
  deactivatedTemplates?: Maybe<Scalars['Int']['output']>;
  /** Container stops the template was not allowed to move: the driver has collected them or is heading for them. Zero on a route that has not started. */
  frozenStops?: Maybe<Scalars['Int']['output']>;
  /** Container stops whose stop number actually changed. Zero with alreadyInOrder true means the route already drove this order; zero with frozenStops equal to routeStops means the whole round was behind the driver. */
  movedStops?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<RouteType>;
  /** Container stops on the route this Apply looked at. */
  routeStops?: Maybe<Scalars['Int']['output']>;
  template?: Maybe<FixedRouteTemplateType>;
  /** How many containers on the route the template has never sequenced. They are driven last, in the order the solver gave them, so a new customer is always collected. */
  unsequencedContainers?: Maybe<Scalars['Int']['output']>;
};

/**
 * Put ``template`` into service and re-sequence EVERY upcoming route of
 * its scheme to it, in one gesture from the tab.
 *
 * The office Apply pins one route; this is the "and all the others" the
 * planner asks for right after, without a trip to the routes list. A
 * READY template is activated (demoting the previous active variant); a
 * DRAFT is refused. Routes already completed, or started unless
 * ``includeStarted``, are skipped and reported. Never fails the batch.
 */
export type FixedRouteTemplateApplyToScheme = {
  __typename: 'FixedRouteTemplateApplyToScheme';
  appliedCount?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<FixedRouteApplyToRouteResult>>;
  skippedCount?: Maybe<Scalars['Int']['output']>;
  template?: Maybe<FixedRouteTemplateType>;
};

/**
 * Mark a draft order correct: DRAFT → READY.
 *
 * Changes nothing about any route on its own. READY is the planner
 * saying the order is right; ``fixedRouteTemplateApply`` is the separate
 * decision to drive it.
 */
export type FixedRouteTemplateConfirm = {
  __typename: 'FixedRouteTemplateConfirm';
  /** Library: a draft the machine made for specific routes (a branch) drives them as soon as it is confirmed - how many bound upcoming routes were re-sequenced here. 0 for a draft no route is bound to; Apply is then the separate step. */
  appliedRoutes?: Maybe<Scalars['Int']['output']>;
  template?: Maybe<FixedRouteTemplateType>;
};

/**
 * Take an ACTIVE template out of service (-> READY).
 *
 * The routes bound to it are released and keep the order they drive
 * today; from the next generation on they are resolved afresh (another
 * ACTIVE template of the scheme that covers them, or the solver's
 * order). The scheme's other templates keep driving their own routes.
 * ``auto_optimize`` is left as it is - switching it back on is the
 * per-route office decision it always was.
 */
export type FixedRouteTemplateDeactivate = {
  __typename: 'FixedRouteTemplateDeactivate';
  template?: Maybe<FixedRouteTemplateType>;
};

/**
 * Delete a template variant that is not in service.
 *
 * An ACTIVE template is refused: it governs tonight's generation, and
 * taking a round back to the solver's order is a decision made by
 * applying another variant, not by deleting this one under it.
 */
export type FixedRouteTemplateDelete = {
  __typename: 'FixedRouteTemplateDelete';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * "Stop using for this route": release ONE route from the template
 * it drives. The template and its other routes are untouched.
 *
 * The route keeps the order it has and its ``auto_optimize`` as it is;
 * the nightly generation leaves it to the solver (no re-apply, no draft)
 * until the next explicit Apply on it, which is a newer decision. The
 * ``route_detached`` history row is what carries that decision.
 */
export type FixedRouteTemplateDetachRoute = {
  __typename: 'FixedRouteTemplateDetachRoute';
  route?: Maybe<RouteType>;
  template?: Maybe<FixedRouteTemplateType>;
};

/**
 * One entry in a template's history: who did what, when, and to what
 * order.
 */
export type FixedRouteTemplateEventType = Node & {
  __typename: 'FixedRouteTemplateEventType';
  createdAt: Scalars['DateTime']['output'];
  /** The planner who made the change. */
  createdBy?: Maybe<UserType>;
  eventType: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** The route an 'applied' event put the template into service on. Null on every other type: they are about the template alone. */
  route?: Maybe<RouteType>;
  /** The template's order as this event left it — the same list of {container, source} objects stopOrder carries, snapshotted, so an entry from six months ago still shows the round it produced. */
  stopOrder?: Maybe<Scalars['GenericScalar']['output']>;
};

export type FixedRouteTemplateEventTypeConnection = {
  __typename: 'FixedRouteTemplateEventTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FixedRouteTemplateEventTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FixedRouteTemplateEventType` and its cursor. */
export type FixedRouteTemplateEventTypeEdge = {
  __typename: 'FixedRouteTemplateEventTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FixedRouteTemplateEventType>;
};

/** Label a template variant. Changes no order and no status. */
export type FixedRouteTemplateRename = {
  __typename: 'FixedRouteTemplateRename';
  template?: Maybe<FixedRouteTemplateType>;
};

/**
 * Throw the planner's edits away and go back to the seeded order.
 *
 * Returns the template to DRAFT, like every other write to the order —
 * see ``revert_to_seeded``.
 */
export type FixedRouteTemplateRevertToSeeded = {
  __typename: 'FixedRouteTemplateRevertToSeeded';
  template?: Maybe<FixedRouteTemplateType>;
};

/**
 * Store the order the planner dragged the stops into.
 *
 * Merged into the template rather than replacing it — see
 * ``merge_stop_order``. Returns the template to DRAFT, so a changed
 * order has to be confirmed and applied again before any route is
 * generated against it.
 */
export type FixedRouteTemplateSaveOrder = {
  __typename: 'FixedRouteTemplateSaveOrder';
  template?: Maybe<FixedRouteTemplateType>;
};

/**
 * A DRAFT variant from the order the drivers actually drove.
 *
 * The cold start of fixed routes without dragging: the last completed
 * routes of the scheme, in the order their stops were confirmed, folded
 * into one consensus order (``fixed_routes_history``). ``agreement`` is
 * how consistently the days were driven (Kendall tau, 1.0 = identical);
 * the planner reads it before trusting the seed. Nothing is activated.
 */
export type FixedRouteTemplateSeedFromHistory = {
  __typename: 'FixedRouteTemplateSeedFromHistory';
  agreement?: Maybe<Scalars['Float']['output']>;
  containersOrdered?: Maybe<Scalars['Int']['output']>;
  routesUsed?: Maybe<Scalars['Int']['output']>;
  template?: Maybe<FixedRouteTemplateType>;
};

/**
 * Start (or restart) the scheme's template from a route's own order.
 *
 * Nobody sequences several hundred stops from nothing, so the planner
 * takes what the solver produced and corrects it. Re-seeding an existing
 * template deliberately discards its edits and returns it to DRAFT: this
 * is the "start again from the solver" action, not an update.
 *
 * The template is SCHEME-WIDE, and seeded with the scheme's whole master
 * data rather than one day's stops, so it is sequenced once and then
 * governs every route the scheme generates — see
 * ``seed_template_from_route``.
 */
export type FixedRouteTemplateSeedFromRoute = {
  __typename: 'FixedRouteTemplateSeedFromRoute';
  template?: Maybe<FixedRouteTemplateType>;
};

/**
 * A template of another scheme that already orders most of this
 * route — the reuse Khaled asked for, as a proposal the planner adopts
 * (``routes.services.fixed_routes_suggest``).
 */
export type FixedRouteTemplateSuggestionType = {
  __typename: 'FixedRouteTemplateSuggestionType';
  /** Share of this route's containers the template already orders, 0..1. */
  coverage?: Maybe<Scalars['Float']['output']>;
  routeContainers?: Maybe<Scalars['Int']['output']>;
  sharedContainers?: Maybe<Scalars['Int']['output']>;
  template?: Maybe<FixedRouteTemplateType>;
  /** Share of the template's addresses that are on this route, 0..1 - low means this route is a fragment of that round. */
  templateCoverage?: Maybe<Scalars['Float']['output']>;
};

/**
 * A route scheme's pinned stop order.
 *
 * Scheme-wide by default — it governs every route the scheme generates,
 * whatever truck the solver assigned — with an optional vehicle-specific
 * override for a scheme that wants a different order per truck.
 */
export type FixedRouteTemplateType = Node & {
  __typename: 'FixedRouteTemplateType';
  /** Library: how many routes drive this template (or wait on it as a draft). 0 = unused, 1 = one route's own, more = shared. */
  boundRoutesCount?: Maybe<Scalars['Int']['output']>;
  /** Who changed this template, when, and to what order — newest first. One entry per planner gesture (seeded, reordered, confirmed, applied, reverted); the nightly generation writes none, because it is not somebody's decision. */
  events?: Maybe<Array<FixedRouteTemplateEventType>>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** When a planner last applied this template to a route (from the audit trail). Null until the first Apply. */
  lastAppliedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Optional label for this variant of the round. A scheme may hold several templates; at most one per truck (or one scheme-wide) is active at a time. */
  name: Scalars['String']['output'];
  routeScheme: RouteSchemeType;
  seededFrom?: Maybe<RouteType>;
  /** The VRP order the template was seeded from, written once and never edited — the baseline revertToSeeded goes back to. */
  seededOrder?: Maybe<Scalars['GenericScalar']['output']>;
  status: Scalars['String']['output'];
  /** Entries in stopOrder. */
  stopCount?: Maybe<Scalars['Int']['output']>;
  /** The planner's order: a list of {container, source} objects, source being 'seeded' (straight from the VRP, never reviewed), 'manual' (a planner placed it) or 'inherited' (took a replaced container's position). A container absent from this list has never been sequenced, and is driven last in the order the solver gave it. */
  stopOrder?: Maybe<Scalars['GenericScalar']['output']>;
  /** The sequenced stops, in template order, with what a screen needs to render them: {container, address, containerType, source, weekdays}. Served from the TEMPLATE and not from a route, because a template covers every day the round runs — the bins collected on another weekday are on no route today and would otherwise be impossible to see or place. ``weekdays`` comes off the container's collection calendar and is empty when it has none. */
  templateStops?: Maybe<Scalars['GenericScalar']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  /** Where this template is still in use: the upcoming routes a planner applied it to, and (when active) how many upcoming routes of the scheme it governs. What the Delete confirmation shows. */
  usage?: Maybe<FixedRouteTemplateUsageType>;
  /** Fixed route templates written for this one truck. Normally there are none: a template is scheme-wide (no vehicle) and governs every route the scheme generates, whatever truck the solver assigned. A row that names a vehicle is an override for that truck alone, and wins over the scheme-wide row. */
  vehicle?: Maybe<VehicleType>;
};

export type FixedRouteTemplateTypeConnection = {
  __typename: 'FixedRouteTemplateTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FixedRouteTemplateTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `FixedRouteTemplateType` and its cursor. */
export type FixedRouteTemplateTypeEdge = {
  __typename: 'FixedRouteTemplateTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FixedRouteTemplateType>;
};

/** ``routes.services.fixed_routes_state.template_usage``. */
export type FixedRouteTemplateUsageType = {
  __typename: 'FixedRouteTemplateUsageType';
  /** Upcoming, not completed routes a planner applied this template to, in date order (at most 50). */
  appliedRoutes?: Maybe<Array<RouteType>>;
  appliedRoutesCount?: Maybe<Scalars['Int']['output']>;
  /** Upcoming routes of the scheme this template governs; 0 unless the template is active. */
  governsUpcomingCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * Re-sequence the SELECTED routes to their ACTIVE templates.
 *
 * The bulk action for the routes list: a planner selects routes and
 * asks for it explicitly, so nothing is re-sequenced by accident. Each
 * route is re-sequenced to the template that governs its own scheme —
 * there is no template argument, because a template governs a scheme
 * and the routes name their schemes. A route without an active
 * template, or already completed, is reported and skipped, never
 * failed; the mutation answers per route.
 *
 * ``auto_optimize`` goes off on every route re-sequenced, as with the
 * single Apply. ETAs are re-timed per moved route after the commit.
 */
export type FixedRouteTemplatesApplyToRoutes = {
  __typename: 'FixedRouteTemplatesApplyToRoutes';
  appliedCount?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<FixedRouteApplyToRouteResult>>;
  skippedCount?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum FleetManagementDriverDriverSpeedChoices {
  /** 2x faster */
  A_2_X_FASTER = 'A_2X_FASTER',
  /** 2x slower */
  A_2_X_SLOWER = 'A_2X_SLOWER',
  /** 3x faster */
  A_3_X_FASTER = 'A_3X_FASTER',
  /** 3x slower */
  A_3_X_SLOWER = 'A_3X_SLOWER',
  /** Normal */
  NORMAL = 'NORMAL'
}

/** An enumeration. */
export enum FleetManagementDriverDriverTypeChoices {
  /** Primary */
  PRIMARY = 'PRIMARY',
  /** Substitute */
  SUBSTITUTE = 'SUBSTITUTE'
}

/**
 * One vehicle's completed-work scorecard (REQ 3.6.25 "by fleet").
 *
 * "Equipment used" maps to the vehicle / vehicle-type here — there is no
 * separate equipment model, and none is invented.
 */
export type FleetVehiclePerformanceType = {
  __typename: 'FleetVehiclePerformanceType';
  /** kg per weighed stop; null when nothing was weighed. */
  avgWeightPerStop?: Maybe<Scalars['Float']['output']>;
  /** Vehicle weight capacity when configured, else null. */
  capacityKg?: Maybe<Scalars['Float']['output']>;
  /** Average unload load as a % of capacity; null unless both a capacity and weighed unloading events exist. */
  capacityUtilizationPct?: Maybe<Scalars['Float']['output']>;
  completed: Scalars['Int']['output'];
  /** Completed stops carrying a recorded deviation reason. */
  deviations: Scalars['Int']['output'];
  fuelType?: Maybe<Scalars['String']['output']>;
  /** The contractor whose routes did the work — lets the office-wide read (haulerId omitted, PRO-122) group rows per contractor. */
  haulerId?: Maybe<Scalars['ID']['output']>;
  haulerName?: Maybe<Scalars['String']['output']>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  /** Total collected weight (kg); null when nothing weighed. */
  totalWeight?: Maybe<Scalars['Float']['output']>;
  unloadCount: Scalars['Int']['output'];
  vehicleId?: Maybe<Scalars['ID']['output']>;
  vehicleName?: Maybe<Scalars['String']['output']>;
  vehicleTypeId?: Maybe<Scalars['ID']['output']>;
  vehicleTypeName?: Maybe<Scalars['String']['output']>;
  /** Stops with a weight — the avg denominator. */
  weighedStops: Scalars['Int']['output'];
};

/**
 * The acting user on one `FlowAuditLogEntry` row. Deliberately a small,
 * local projection of `IoUser` (id + name/email only) rather than reusing
 * `core.schema.UserType` -- that type pulls in a much larger graph
 * (projects, permissions, dashboards, ...) this read-only audit trail has
 * no use for.
 *
 * skip_registry: graphene-django keys AUTO-GENERATED related fields by
 * MODEL, so a second registered DjangoObjectType over IoUser silently
 * becomes the type of EVERY auto-derived user field in the whole schema
 * (broke 185 frontend GraphQL documents after deploy: notification feed,
 * property event log, the Live Operations timeline's DriverType.user, ...
 * all suddenly typed to this 4-field projection instead of core UserType).
 * Kept out of the registry; the audit entry binds it EXPLICITLY below.
 */
export type FlowAuditActorType = {
  __typename: 'FlowAuditActorType';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

/**
 * One `FlowAuditLogEntry` row (CLAUDE.md rule 5, "audit everything"),
 * exposed read-only so an admin can see -- not just prove after the fact
 * in the DB -- what happened to a Flow: every promotion, rollback, and
 * (safety backbone slice #1) kill/un-kill, with who did it, when, and why.
 *
 * `reason` is pulled out of `after` for the actions that carry one
 * (`KILLED`/`RESTORED` today, see `killAutopilotFlow`/
 * `unkillAutopilotFlow` below) so callers don't need to know the
 * per-action shape of `after` just to render the one field they always
 * want; `before`/`after` stay available in full for anything else.
 */
export type FlowAuditLogEntryType = {
  __typename: 'FlowAuditLogEntryType';
  action?: Maybe<Scalars['String']['output']>;
  actor?: Maybe<FlowAuditActorType>;
  after?: Maybe<Scalars['JSONString']['output']>;
  before?: Maybe<Scalars['JSONString']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

/**
 * One tenant's Flow. `state` is exposed as the raw stored string
 * (`draft`/`test`/`live`/`archived`), not an auto-derived enum, so the
 * builder UI and the API tests both see the same literal value the
 * lifecycle state machine (`autopilot.models.Flow.promote_to`) uses.
 *
 * `draftDefinition` and `hasUnsavedChanges` (AP-402) are the autosave
 * surface: the canvas UI polls/reads these to know whether the working
 * copy differs from the last committed, immutable `FlowVersion`.
 * `versions` is the full commit history, newest last (model `Meta.
 * ordering`), for a version browser / diff view.
 *
 * `killed` (safety backbone slice #1) is the per-flow kill switch --
 * independent of `state` and of the global `AUTOPILOT_KILL_ALL` switch,
 * see `autopilot.models.Flow.killed`. `auditLog` is the full lifecycle
 * trail (`FlowAuditLogEntry`, previously write-only), newest first, so an
 * admin can see who killed/promoted/rolled back this flow, when, and why.
 */
export type FlowType = {
  __typename: 'FlowType';
  auditLog: Array<FlowAuditLogEntryType>;
  createdAt: Scalars['DateTime']['output'];
  currentVersion?: Maybe<FlowVersionType>;
  draftDefinition?: Maybe<Scalars['JSONString']['output']>;
  hasUnsavedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Safety backbone slice #1 (per-flow kill): when True, this one flow must never fire, independent of Flow.state and of the global AUTOPILOT_KILL_ALL switch (autopilot.flags). Checked at the live chokepoint (autopilot.runtime.trigger_intake.match_live_flows) and, defense-in-depth, in promote_to below so a killed flow can never be promoted/activated back to life through the ordinary builder pipeline -- it must be explicitly un-killed first (see the killAutopilotFlow / unkillAutopilotFlow GraphQL mutations in autopilot.schema, and FlowAuditLogEntry.Action.KILLED/RESTORED for the audit trail). A plain admin list_editable toggle also flips this directly, on purpose: a live incident must not wait on the GraphQL/API path being reachable. */
  killed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  origin: Scalars['String']['output'];
  pendingApprovalCount: Scalars['Int']['output'];
  resumesSourceRuleOnStop: Scalars['Boolean']['output'];
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  versions: Array<FlowVersionType>;
};

/**
 * One immutable Flow definition version. Read-only: versions are
 * created only as a side effect of `UpdateAutopilotFlowDefinition`
 * below, never mutated directly.
 */
export type FlowVersionType = {
  __typename: 'FlowVersionType';
  createdAt: Scalars['DateTime']['output'];
  /** Validated against docs/autopilot-pack/contracts/flow.schema.json at save time. */
  definition: Scalars['JSONString']['output'];
  schemaVersion: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

/**
 * One subject-fraction demand forecast (RS-E10): the model tag
 * and confidence band ALWAYS ride with the number (06_AI_SPEC A1);
 * no consumer may strip them.
 */
export type ForecastRowDef = {
  __typename: 'ForecastRowDef';
  bandHighKgWeek: Scalars['Float']['output'];
  bandLowKgWeek: Scalars['Float']['output'];
  fraction: Scalars['String']['output'];
  horizonWeeks: Scalars['Int']['output'];
  kgWeek: Scalars['Float']['output'];
  /** prior_v1 / learned_v1 / sensor_v1. */
  modelTag: Scalars['String']['output'];
  /** Estimator inputs and the prior family's provenance note (engineering defaults pending product validation). */
  provenance?: Maybe<Scalars['GenericScalar']['output']>;
  subjectRef: Scalars['String']['output'];
  /** Observation weeks (learned) or trajectory windows (sensor) behind the estimate; 0 for priors. */
  supportN: Scalars['Int']['output'];
};

export type FormErrorMutation = {
  __typename: 'FormErrorMutation';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Fossil-free share of collections for one contractor (or the total
 * row: haulerId null), period-over-period.
 */
export type FossilFreeShareType = {
  __typename: 'FossilFreeShareType';
  completed: Scalars['Int']['output'];
  /** Fossil-free completed / completed, 1 dp; null when nothing was completed. Unknown fuel counts in the denominator, never as fossil-free. */
  completedSharePct?: Maybe<Scalars['Float']['output']>;
  fossilFreeCompleted: Scalars['Int']['output'];
  fossilFreeWeight?: Maybe<Scalars['Float']['output']>;
  /** Null on the company-total row. */
  haulerId?: Maybe<Scalars['ID']['output']>;
  haulerName: Scalars['String']['output'];
  /** The count share over the previous same-length window. */
  previousCompletedSharePct?: Maybe<Scalars['Float']['output']>;
  /** The weight share over the previous same-length window. */
  previousWeightSharePct?: Maybe<Scalars['Float']['output']>;
  totalWeight?: Maybe<Scalars['Float']['output']>;
  /** Fossil-free weighed kg / weighed kg, 1 dp; null when nothing was weighed. */
  weightSharePct?: Maybe<Scalars['Float']['output']>;
};

/**
 * RS-E26 (D57): one per-fraction service of one container or
 * address-level stop, with its own cadence (the client's route
 * identity). Client-visible identity only (D58): the client's
 * container keys, addresses, fraction codes and route numbers,
 * verbatim; the platform object refs (container, scheme, waste
 * fraction) stay internal until the RS-E28 cutover fills them.
 */
export type FractionServiceBindingDef = Node & {
  __typename: 'FractionServiceBindingDef';
  active: Scalars['Boolean']['output'];
  addressKey: Scalars['String']['output'];
  case?: Maybe<ImportCaseDef>;
  createdAt: Scalars['DateTime']['output'];
  externalContainerKey: Scalars['String']['output'];
  fractionCode: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  origin: RouteStudioFractionServiceBindingOriginChoices;
  routeIdentity: Scalars['String']['output'];
  sourceOrder?: Maybe<Scalars['Int']['output']>;
  sourceRefs: Scalars['JSONString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FractionServiceBindingDefConnection = {
  __typename: 'FractionServiceBindingDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FractionServiceBindingDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `FractionServiceBindingDef` and its cursor. */
export type FractionServiceBindingDefEdge = {
  __typename: 'FractionServiceBindingDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FractionServiceBindingDef>;
};

/** The most recent frequency change on a schedule (old → new / when / how). */
export type FrequencyChangeDetailType = {
  __typename: 'FrequencyChangeDetailType';
  changedAt?: Maybe<Scalars['DateTime']['output']>;
  effectiveFrom?: Maybe<Scalars['Date']['output']>;
  newFrequencyCode?: Maybe<Scalars['String']['output']>;
  newFrequencyLabel?: Maybe<Scalars['String']['output']>;
  oldFrequencyCode?: Maybe<Scalars['String']['output']>;
  oldFrequencyLabel?: Maybe<Scalars['String']['output']>;
  /** portal | office */
  source?: Maybe<Scalars['String']['output']>;
};

export type Fu51007FileLineErrorDef = Node & {
  __typename: 'Fu51007FileLineErrorDef';
  error?: Maybe<Scalars['String']['output']>;
  errorException?: Maybe<Scalars['String']['output']>;
  errorField?: Maybe<KmdEasyFu51007FileLineErrorErrorFieldChoices>;
  errorText: Scalars['String']['output'];
  fileLine: Fu51007FileLineDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

export type Fu51007FileLineErrorDefConnection = {
  __typename: 'Fu51007FileLineErrorDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<Fu51007FileLineErrorDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `Fu51007FileLineErrorDef` and its cursor. */
export type Fu51007FileLineErrorDefEdge = {
  __typename: 'Fu51007FileLineErrorDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Fu51007FileLineErrorDef>;
};

export type Fu51008FileLineErrorDef = Node & {
  __typename: 'Fu51008FileLineErrorDef';
  error?: Maybe<Scalars['String']['output']>;
  errorException?: Maybe<Scalars['String']['output']>;
  errorField?: Maybe<KmdEasyFu51008FileLineErrorErrorFieldChoices>;
  errorText: Scalars['String']['output'];
  fileLine: Fu51008FileLineDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

export type Fu51008FileLineErrorDefConnection = {
  __typename: 'Fu51008FileLineErrorDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<Fu51008FileLineErrorDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `Fu51008FileLineErrorDef` and its cursor. */
export type Fu51008FileLineErrorDefEdge = {
  __typename: 'Fu51008FileLineErrorDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Fu51008FileLineErrorDef>;
};

export type Fu63302FileLineErrorDef = Node & {
  __typename: 'Fu63302FileLineErrorDef';
  error?: Maybe<Scalars['String']['output']>;
  errorException?: Maybe<Scalars['String']['output']>;
  errorField?: Maybe<KmdEasyFu63302FileLineErrorErrorFieldChoices>;
  errorText: Scalars['String']['output'];
  fileLine: KmdEasyFileFu63302FileLineDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

export type Fu63302FileLineErrorDefConnection = {
  __typename: 'Fu63302FileLineErrorDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<Fu63302FileLineErrorDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `Fu63302FileLineErrorDef` and its cursor. */
export type Fu63302FileLineErrorDefEdge = {
  __typename: 'Fu63302FileLineErrorDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Fu63302FileLineErrorDef>;
};

export type Fu63303FileLineErrorDef = Node & {
  __typename: 'Fu63303FileLineErrorDef';
  errorException?: Maybe<Scalars['String']['output']>;
  errorField?: Maybe<KmdEasyFu63303FileLineErrorErrorFieldChoices>;
  errorText: Scalars['String']['output'];
  fileLine: KmdEasyFileFu63303FileLineDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

export type Fu63303FileLineErrorDefConnection = {
  __typename: 'Fu63303FileLineErrorDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<Fu63303FileLineErrorDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `Fu63303FileLineErrorDef` and its cursor. */
export type Fu63303FileLineErrorDefEdge = {
  __typename: 'Fu63303FileLineErrorDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Fu63303FileLineErrorDef>;
};

/**
 * One (contractor × fuel type) cell of the Fuel & emissions table.
 * CO2e lands later as an extra column here, not a rebuild.
 */
export type FuelEmissionsRowType = {
  __typename: 'FuelEmissionsRowType';
  /** Mean fuel usage/km over vehicles that set it, else null. */
  avgFuelUsagePerKm?: Maybe<Scalars['Float']['output']>;
  completed: Scalars['Int']['output'];
  /** Fuel type, or 'unspecified' when the vehicle set none. */
  fuelType?: Maybe<Scalars['String']['output']>;
  haulerId?: Maybe<Scalars['ID']['output']>;
  haulerName: Scalars['String']['output'];
  totalWeight?: Maybe<Scalars['Float']['output']>;
  vehicleCount: Scalars['Int']['output'];
  weighedStops: Scalars['Int']['output'];
};

/** Completed work by fuel type (REQ 3.6.25 "by fuel"). */
export type FuelSummaryType = {
  __typename: 'FuelSummaryType';
  /** Mean fuel usage/km over vehicles that set it, else null. */
  avgFuelUsagePerKm?: Maybe<Scalars['Float']['output']>;
  completed: Scalars['Int']['output'];
  /** Fuel type, or 'unspecified' when the vehicle set none. */
  fuelType?: Maybe<Scalars['String']['output']>;
  totalWeight?: Maybe<Scalars['Float']['output']>;
  vehicleCount: Scalars['Int']['output'];
  weighedStops: Scalars['Int']['output'];
};

/**
 * Item 1: for the caller's company, run the FULL pipeline in one chained
 * task — recurring fees -> billing run -> pp->crm bridge -> Visma export —
 * i.e. exactly the chain the nightly beat runs
 * (``invoicing.services.invoicing_pipeline``). Unlike ``triggerVismaExport``
 * (which only ships invoices that already exist), this GENERATES the
 * invoices first, then exports. The operator's bell job follows the chain
 * and closes when the export lands.
 */
export type GenerateAndRunVismaExport = {
  __typename: 'GenerateAndRunVismaExport';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  exportLogId?: Maybe<Scalars['ID']['output']>;
  logId?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateBarcodesForContainers = {
  __typename: 'GenerateBarcodesForContainers';
  linkToPdfFile?: Maybe<Scalars['Upload']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GenerateCollectionCalendarsPickupSettings = {
  __typename: 'GenerateCollectionCalendarsPickupSettings';
  pickupSetting?: Maybe<PickupSettingsType>;
};

export type GenerateDatesForCollectionCalendars = {
  __typename: 'GenerateDatesForCollectionCalendars';
  collectionCalendars?: Maybe<Array<Maybe<CollectionCalendarDef>>>;
};

/** Result of the generateInsightsDashboard mutation. */
export type GenerateInsightsDashboardResult = {
  __typename: 'GenerateInsightsDashboardResult';
  droppedWidgets: Array<Scalars['String']['output']>;
  refusalReason?: Maybe<Scalars['String']['output']>;
  spec?: Maybe<DashboardSpec>;
  warnings: Array<Scalars['String']['output']>;
};

/**
 * Item 6: generate an invoice for ONE property (its own billable events),
 * then mirror it into crm.Invoice so it shows on the property's legacy
 * invoices tab. Runs the normal billing engine scoped to the property
 * (EventScope.property_ids) via a task — the same engine the nightly run
 * uses, just narrowed. Mints money, so it takes the write gate.
 *
 * The bell job is opened HERE (not by the task) so its id can go back to
 * the UI in the same response: the invoices tab follows that one job
 * (``userJobNotification(id)``) to its completed/failed state instead of
 * polling the invoice list blind for a run that may produce nothing.
 */
export type GenerateInvoiceForPropertyMutation = {
  __typename: 'GenerateInvoiceForPropertyMutation';
  /** The bell background job following this run (a UserJobNotificationType id); its event carries the final status and note. */
  jobId?: Maybe<Scalars['ID']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateKmdEasyFile = {
  __typename: 'GenerateKmdEasyFile';
  fileTypeName?: Maybe<KmdEasyExportFileType>;
  kmdEasyDeltaFile?: Maybe<KmdEasyDeltaFileDef>;
};

/**
 * RS-1603 (D42): generate a template-framed, engine-grounded
 * draft. Every numeral is source-checked before the row exists; the
 * judge harness scores the draft with the D46-gated verdict; the
 * document stays DRAFT until a human approves it.
 */
export type GenerateNarrativeDocumentMutation = {
  __typename: 'GenerateNarrativeDocumentMutation';
  narrativeDocument?: Maybe<NarrativeDocumentDef>;
};

/**
 * Regenerate the RS-302 service units of a stop set.
 *
 * Dispatches the routing-matrix Celery task (ADR-0003 section 3);
 * the units land asynchronously and the visual QA layer
 * (allServiceUnits) shows them. ``profile`` names a truck profile
 * (D28); until the Q-005 profile servers exist the task degrades to
 * the default network and records the fallback on every unit.
 */
export type GenerateServiceUnitsMutation = {
  __typename: 'GenerateServiceUnitsMutation';
  queued?: Maybe<Scalars['Boolean']['output']>;
  stopSet?: Maybe<StopSetDef>;
};

/**
 * W11.1: deterministic statutory draft — engine fields frozen
 * with lineage, everything else surfaced in the missing-field
 * report. No AI touches this path.
 */
export type GenerateStatutoryDraft = {
  __typename: 'GenerateStatutoryDraft';
  draft?: Maybe<Scalars['GenericScalar']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

export enum GenericAddRemoveEventTypesGraphene {
  ADDED = 'ADDED',
  REMOVED = 'REMOVED'
}

export enum GenericMtmEventTypesGraphene {
  ADDED = 'ADDED',
  CHANGED = 'CHANGED',
  REMOVED = 'REMOVED'
}

export type GeoJsonFeaturesType = {
  __typename: 'GeoJSONFeaturesType';
  bbox?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  geometry?: Maybe<GeoJsonGeometryType>;
  properties?: Maybe<GeoJsonPropertiesType>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GeoJsonGeometryType = {
  __typename: 'GeoJSONGeometryType';
  coordinates?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GeoJsonPropertiesType = {
  __typename: 'GeoJSONPropertiesType';
  propertyNumber?: Maybe<Scalars['String']['output']>;
  segments?: Maybe<Array<Maybe<GeoJsonSegmentType>>>;
  stopNumber?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<GeoJsonSummaryType>;
  wayPoints?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type GeoJsonSegmentType = {
  __typename: 'GeoJSONSegmentType';
  distance?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  steps?: Maybe<Array<Maybe<GeoJsonStepType>>>;
};

export type GeoJsonStepType = {
  __typename: 'GeoJSONStepType';
  distance?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  wayPoints?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type GeoJsonSummaryType = {
  __typename: 'GeoJSONSummaryType';
  distance?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
};

export type GeoJsonType = {
  __typename: 'GeoJSONType';
  bbox?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  features?: Maybe<Array<Maybe<GeoJsonFeaturesType>>>;
  type?: Maybe<Scalars['String']['output']>;
};

/**
 * Run the RS-102 geocoding pass over confirmed rows, producing
 * the stop set, per-stop confidence and the fix queue.
 */
export type GeocodeImportBatchMutation = {
  __typename: 'GeocodeImportBatchMutation';
  importBatch?: Maybe<ImportBatchDef>;
  stopSet?: Maybe<StopSetDef>;
};

export type GoLiveAutomationPayload = {
  __typename: 'GoLiveAutomationPayload';
  automation: AutomationDef;
};

export type GoShadowAutomationPayload = {
  __typename: 'GoShadowAutomationPayload';
  automation: AutomationDef;
};

/**
 * One access-audit row: who viewed driver GPS, when, and in what scope.
 *
 * Describes the VIEWER (``actor_name``), never a driver metric.
 * ``subject_driver_id`` answers a DSAR ("whose trail was viewed") only.
 */
export type GpsAccessAuditDef = {
  __typename: 'GpsAccessAuditDef';
  accessType: Scalars['String']['output'];
  /** The person who viewed the GPS (name, never a raw id). */
  actorName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  scope?: Maybe<Scalars['GenericScalar']['output']>;
  /** Relay id of the driver whose trail was viewed (DSAR). */
  subjectDriverId?: Maybe<Scalars['ID']['output']>;
  subjectVehicleId?: Maybe<Scalars['ID']['output']>;
};

/**
 * RS-E20 (stage C models now, decode engine wave I2): one
 * checkable claim about the client's route grammar with evidence
 * citations.
 */
export type GrammarClaimDef = Node & {
  __typename: 'GrammarClaimDef';
  case: ImportCaseDef;
  confidence: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  evidence: Scalars['JSONString']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  payload: Scalars['JSONString']['output'];
  questions: CaseQuestionDefConnection;
  statement: Scalars['String']['output'];
  status: RouteStudioGrammarClaimStatusChoices;
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * RS-E20 (stage C models now, decode engine wave I2): one
 * checkable claim about the client's route grammar with evidence
 * citations.
 */
export type GrammarClaimDefQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GrammarClaimDefConnection = {
  __typename: 'GrammarClaimDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GrammarClaimDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `GrammarClaimDef` and its cursor. */
export type GrammarClaimDefEdge = {
  __typename: 'GrammarClaimDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GrammarClaimDef>;
};

export type GraphErrorDef = {
  __typename: 'GraphErrorDef';
  code: Scalars['String']['output'];
  details?: Maybe<Scalars['JSONString']['output']>;
  message: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
};

export type GroupType = Node & {
  __typename: 'GroupType';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: PermissionTypeConnection;
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  userSet: UserTypeConnection;
};


export type GroupTypePermissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type GroupTypeUserSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupTypeConnection = {
  __typename: 'GroupTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GroupType` and its cursor. */
export type GroupTypeEdge = {
  __typename: 'GroupTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GroupType>;
};

/**
 * The accountant AR export (R2-07 v1 — the AR loop's egress).
 *
 * A DOWNLOADABLE file for the operator to hand to their bookkeeper — NOT
 * an accounting integration (the founder ruled those out; this is an export
 * file, nothing is transmitted anywhere). ``reportCsvBase64`` is the AR
 * detail (one row per invoice); ``postingSummaryCsvBase64`` is the optional
 * per-VAT-rate posting summary. Honest counts: every number derives from
 * ``rows`` / ``postingSummary`` below, each of which traces to a real
 * ``Invoice`` / ``InvoicePayment`` / ``InvoiceLine``. Honest empty: no
 * invoices in the window → header-only CSVs, never a fabricated line.
 */
export type HaulerAccountantExportDef = {
  __typename: 'HaulerAccountantExportDef';
  /** The tenant's default legal-entity currency (W1 single-currency honesty — blank when none is set). */
  currency?: Maybe<Scalars['String']['output']>;
  dateFrom?: Maybe<Scalars['Date']['output']>;
  dateTo?: Maybe<Scalars['Date']['output']>;
  invoiceCount?: Maybe<Scalars['Int']['output']>;
  postingSummary?: Maybe<Array<Maybe<HaulerArPostingSummaryRowDef>>>;
  /** The per-VAT-rate posting summary as base64 CSV — a download, never transmitted anywhere. */
  postingSummaryCsvBase64?: Maybe<Scalars['String']['output']>;
  postingSummaryFilename?: Maybe<Scalars['String']['output']>;
  /** The AR detail as base64 CSV — a download for the operator's bookkeeper, never transmitted anywhere. */
  reportCsvBase64?: Maybe<Scalars['String']['output']>;
  reportFilename?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Array<Maybe<HaulerArInvoiceRowDef>>>;
};

/**
 * One invoice in the accountant AR export (R2-07 v1) — a thin
 * projection of a real ``Invoice`` + its registered payments. ``customer``
 * is the payer's NAME, never a raw id; every amount is frozen on the
 * invoice (net/vat/gross) or summed from real ``InvoicePayment`` rows
 * (paid), never recomputed here.
 */
export type HaulerArInvoiceRowDef = {
  __typename: 'HaulerArInvoiceRowDef';
  /** gross minus paid. */
  balance?: Maybe<Scalars['Decimal']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  /** The billed counterparty's name — never a raw id. */
  customerName?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  gross?: Maybe<Scalars['Decimal']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['Date']['output']>;
  net?: Maybe<Scalars['Decimal']['output']>;
  /** Sum of registered payments (S1-M5 manual half). */
  paid?: Maybe<Scalars['Decimal']['output']>;
  poRef?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * One VAT-rate bucket of the exported invoices' lines (R2-07 v1) — the
 * posting line a bookkeeper carries to the VAT return. Aggregated from real
 * ``InvoiceLine`` rows, never invented.
 */
export type HaulerArPostingSummaryRowDef = {
  __typename: 'HaulerArPostingSummaryRowDef';
  gross?: Maybe<Scalars['Decimal']['output']>;
  lineCount?: Maybe<Scalars['Int']['output']>;
  net?: Maybe<Scalars['Decimal']['output']>;
  vat?: Maybe<Scalars['Decimal']['output']>;
  vatPercentage?: Maybe<Scalars['Decimal']['output']>;
};

/** One area's reliability row for a contractor over a period (W8, D6). */
export type HaulerAreaReliabilityType = {
  __typename: 'HaulerAreaReliabilityType';
  area?: Maybe<AreaDef>;
  events?: Maybe<Array<ReliabilityEventType>>;
  excluded: Scalars['Int']['output'];
  late: Scalars['Int']['output'];
  missed: Scalars['Int']['output'];
  onTime: Scalars['Int']['output'];
  /** Not-yet-due stops (planned day today or later) — never a miss; they leave the reliability basis (PRO-119). Zero for any historical period. */
  pending: Scalars['Int']['output'];
  planned: Scalars['Int']['output'];
  /** onTime / (planned − excluded − pending), 1 dp. Null when there is no basis (denominator zero). */
  reliabilityPct?: Maybe<Scalars['Float']['output']>;
};

/**
 * The outcome of matching an uploaded bank statement against the
 * tenant's outstanding invoices (HAUL-919 v1 — bank-afstemning).
 *
 * ``applied=false`` is the dry-run PREVIEW (the query) — it changes
 * nothing. ``applied=true`` is what the mutation actually registered
 * through the S1-M5 payment service (invoices flip PAID when covered).
 * ``reportCsvBase64`` is the downloadable reconciliation report: an inert
 * artifact FOR THE OPERATOR — never sent to a bank or PSP (v2 open-banking
 * / camt.053 auto-feed is a staged founder spend). Honest counts: every
 * number is derived from ``lines`` below, every matched amount from a real
 * invoice.
 */
export type HaulerBankReconciliationDef = {
  __typename: 'HaulerBankReconciliationDef';
  ambiguousCount?: Maybe<Scalars['Int']['output']>;
  applied?: Maybe<Scalars['Boolean']['output']>;
  lines?: Maybe<Array<Maybe<HaulerBankReconciliationLineDef>>>;
  markedPaidCount?: Maybe<Scalars['Int']['output']>;
  matchedCount?: Maybe<Scalars['Int']['output']>;
  /** Lines that could not be read, in human words. */
  parseIssues?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The reconciliation report as base64 CSV — a download for the operator, never transmitted anywhere. */
  reportCsvBase64?: Maybe<Scalars['String']['output']>;
  reportFilename?: Maybe<Scalars['String']['output']>;
  skippedCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  unmatchedCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * One bank-statement line after matching (HAUL-919 v1). ``outcome`` is
 * a machine key (matched / unmatched / ambiguous / skipped); the screen
 * speaks ``reason``. ``invoiceNumber`` / ``customerName`` are the words a
 * screen shows — never a raw id.
 */
export type HaulerBankReconciliationLineDef = {
  __typename: 'HaulerBankReconciliationLineDef';
  amount?: Maybe<Scalars['Decimal']['output']>;
  /** Amount registered against the invoice (matched lines). */
  appliedAmount?: Maybe<Scalars['Decimal']['output']>;
  bankReference?: Maybe<Scalars['String']['output']>;
  counterparty?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  invoiceMarkedPaid?: Maybe<Scalars['Boolean']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** matched / unmatched / ambiguous / skipped. */
  outcome?: Maybe<Scalars['String']['output']>;
  /** Why, in human words. */
  reason?: Maybe<Scalars['String']['output']>;
  /** 1-based line number in the uploaded file. */
  row?: Maybe<Scalars['Int']['output']>;
  /** Value date as the bank supplied it (ISO), if any. */
  valueDate?: Maybe<Scalars['String']['output']>;
};

/**
 * What happened to ONE order in a bulk close (FIXIT2-O2,
 * REQ-090). Partial success is the design: every order answers for
 * itself — done, held with reasons, or refused with human words.
 */
export type HaulerBulkCompletionResultDef = {
  __typename: 'HaulerBulkCompletionResultDef';
  /** Human words for a FAILED order — why nothing changed. */
  message?: Maybe<Scalars['String']['output']>;
  /** Human-word reasons a PENDING order is held (HAUL-419). Empty unless outcome is 'pending'. */
  missingPaper?: Maybe<Array<Scalars['String']['output']>>;
  orderId?: Maybe<Scalars['ID']['output']>;
  /** The order's commercial status after the attempt. */
  orderStatus?: Maybe<Scalars['String']['output']>;
  /** completed | pending | failed. */
  outcome?: Maybe<Scalars['String']['output']>;
};

/** One area's KPI figures (REQ 3.5.57). Charts are FE later. */
export type HaulerClientKpiType = {
  __typename: 'HaulerClientKpiType';
  areaId?: Maybe<Scalars['ID']['output']>;
  areaName?: Maybe<Scalars['String']['output']>;
  /** lifts / (planned − excluded − pending), 1 dp — the PRO-119 metrics service's one formula. Null when there is no basis. */
  collectionEfficiencyPct?: Maybe<Scalars['Float']['output']>;
  complaintsByReason?: Maybe<Array<ComplaintReasonCountType>>;
  complaintsTotal: Scalars['Int']['output'];
  excluded: Scalars['Int']['output'];
  /** The contract area's contractor — lets the office-wide read (haulerId omitted, PRO-122) group rows per contractor. */
  haulerId?: Maybe<Scalars['ID']['output']>;
  haulerName?: Maybe<Scalars['String']['output']>;
  late: Scalars['Int']['output'];
  missed: Scalars['Int']['output'];
  onTime: Scalars['Int']['output'];
  /** Not-yet-due stops (PRO-119) — leave both KPI denominators; 0 for any historical period. */
  pending: Scalars['Int']['output'];
  planned: Scalars['Int']['output'];
  preventedEmptyings: Scalars['Int']['output'];
  /** Timeliness %. */
  reliabilityPct?: Maybe<Scalars['Float']['output']>;
};

/**
 * A complaint (a ticket of a complaint type), slimmed for the feedback
 * feed. Deliberately NOT the full ``TicketDef`` — a contractor sees the
 * feedback and its pay flag (D5) without the citizen/billing detail the
 * office ticket surfaces carry.
 */
export type HaulerComplaintType = {
  __typename: 'HaulerComplaintType';
  /** Office pay ruling; null = undecided (D5). */
  affectsPay?: Maybe<Scalars['Boolean']['output']>;
  area?: Maybe<AreaDef>;
  complaintReason?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['Int']['output']>;
  ticketTypeName?: Maybe<Scalars['String']['output']>;
};

/** One typed compliance document on a contractor (PRO-99). */
export type HaulerComplianceDocumentDef = Node & {
  __typename: 'HaulerComplianceDocumentDef';
  createdAt: Scalars['DateTime']['output'];
  /** Admin-extensible type (PRO-99 / 3.12.28). */
  documentType: HaulerComplianceDocumentTypeDef;
  /** valid | expiring_soon | expired — derived from valid_to on every read (the contract-area expiry governance pattern). */
  expiryStatus: Scalars['String']['output'];
  hauler: HaulerDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** Permit / policy / certificate number (office-entered). */
  reference?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  validFrom?: Maybe<Scalars['Date']['output']>;
  /** Expiry date. Required on write; drives the expiry status. */
  validTo?: Maybe<Scalars['Date']['output']>;
};

export type HaulerComplianceDocumentDefConnection = {
  __typename: 'HaulerComplianceDocumentDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HaulerComplianceDocumentDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `HaulerComplianceDocumentDef` and its cursor. */
export type HaulerComplianceDocumentDefEdge = {
  __typename: 'HaulerComplianceDocumentDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HaulerComplianceDocumentDef>;
};

/** An admin-extensible compliance-document type (PRO-99 / 3.12.28). */
export type HaulerComplianceDocumentTypeDef = Node & {
  __typename: 'HaulerComplianceDocumentTypeDef';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Type name shown in the register (office-entered). */
  name: Scalars['String']['output'];
};

export type HaulerComplianceDocumentTypeDefConnection = {
  __typename: 'HaulerComplianceDocumentTypeDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HaulerComplianceDocumentTypeDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `HaulerComplianceDocumentTypeDef` and its cursor. */
export type HaulerComplianceDocumentTypeDefEdge = {
  __typename: 'HaulerComplianceDocumentTypeDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HaulerComplianceDocumentTypeDef>;
};

/**
 * One journaled customer notice (S4-O3). STAGED means exactly
 * what it says: journaled, nothing transmitted — dispatch is
 * activated by WasteHero (W1 hard limit).
 */
export type HaulerCustomerNoticeDef = {
  __typename: 'HaulerCustomerNoticeDef';
  action?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

/**
 * Dagens kontroltal (HAUL-1302 BE half, FIXIT2-M2) — one day's
 * honest money summary, composed from billed truth (frozen engine
 * amounts, this lane's own futile records) and never averaged over
 * holes: orders whose margin cannot be computed are COUNTED, not
 * guessed.
 */
export type HaulerDailyControlsDef = {
  __typename: 'HaulerDailyControlsDef';
  /** Sum of the day's INVOICED charge amounts (order lines + futile fees) — frozen engine numbers, never recomputed. */
  billedSum?: Maybe<Scalars['Decimal']['output']>;
  /** Orders with at least one charge produced this day (closed through 'mark completed'). */
  completedOrders?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  /** Futile visits marked this day. */
  futileCount?: Maybe<Scalars['Int']['output']>;
  /** How many of the day's orders have a computable margin. */
  marginComputableOrders?: Maybe<Scalars['Int']['output']>;
  /** How many of the computable margins carry a cost-basis caveat (piece/hour lines with no cost side — FIXIT3-M2). Their margins ARE included in marginSum, so show this count next to the sum — never the bare green number. */
  marginPartialOrders?: Maybe<Scalars['Int']['output']>;
  /** Sum of gross margins over the day's completed orders WHERE computable (the FIXIT2-M2 honesty law). Null when no order's margin is computable — see marginUncomputableOrders. */
  marginSum?: Maybe<Scalars['Decimal']['output']>;
  /** How many of the day's orders have NO computable margin (unbilled lines or missing cost rates) — counted honestly, never averaged in. */
  marginUncomputableOrders?: Maybe<Scalars['Int']['output']>;
  /** Sum of the day's registered scale weights, in tons, where the line's unit honestly converts (kg/t). */
  weighedTons?: Maybe<Scalars['Decimal']['output']>;
};

export type HaulerDef = Node & {
  __typename: 'HaulerDef';
  areas?: Maybe<Array<AreaDef>>;
  /** PRO-282: contractors (haulers) this location is assigned to / can be used by. An ACCESS/assignment concept, independent of stock ownership (`owned_by`) and owner-access (`co_owners`) — the three coexist. Applies to every depot type; empty means a company location. */
  assignedDepots: DepotTypeConnection;
  /** Contractor this model defaults for across their areas (REQ 3.3.22/3.5.57). Set only for a contractor-wide model (area NULL); NULL together with area = the company default. */
  bonusModels: BonusModelTypeConnection;
  businessId?: Maybe<Scalars['String']['output']>;
  /** Contractor the targeted route belongs to. Stamped from the route at propose time; proposals exist only on contractor-linked routes (D15). */
  changeProposals: ChangeProposalDefConnection;
  /** PRO-389: additional contractors with owner-scoped operational access to this depot, alongside (or instead of) the single ``owned_by`` main owner. A hauler in either set may act on the depot; removing the last of both falls back to company-owned. */
  coOwnedDepots: DepotTypeConnection;
  company: CompanyType;
  complianceDocuments: HaulerComplianceDocumentDefConnection;
  contractAreas?: Maybe<Array<AreaDef>>;
  contractAreasInForce?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Settlement currency (free text, e.g. 'EUR'). */
  currency?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** 24/7 dispatch phone for operational escalation. */
  dispatchPhone?: Maybe<Scalars['String']['output']>;
  /** E-invoicing address. */
  eInvoicingAddress?: Maybe<Scalars['String']['output']>;
  /** E-invoicing operator ID. */
  eInvoicingOperator?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  haulerpriceSet: HaulerPriceDefConnection;
  haulerpricechangelogSet: HaulerPriceChangeLogDefConnection;
  /** Headquarters / operating location of the contractor (free-text address). */
  headquarters?: Maybe<Scalars['String']['output']>;
  /** Bank account / IBAN the settlement payable pays to. */
  iban?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** The contractor whose settlement the invoice is reconciled against. */
  invoiceReconciliations: PurchaseInvoiceReconciliationTypeConnection;
  /** Invoicing contact email (settlement counterpart). */
  invoicingContactEmail?: Maybe<Scalars['String']['output']>;
  /** Invoicing contact person (settlement counterpart). */
  invoicingContactName?: Maybe<Scalars['String']['output']>;
  legalAddress?: Maybe<Scalars['String']['output']>;
  /** Legal form of the company (free text, e.g. 'Oy'). */
  legalForm?: Maybe<Scalars['String']['output']>;
  loadsCorrected: TruckloadTypeConnection;
  /** Service provider, resolved from the member stops */
  loadsDerived: TruckloadTypeConnection;
  mainContact?: Maybe<Scalars['String']['output']>;
  /** The contractor the entry credits/deducts. */
  manualEntries: ContractorManualEntryTypeConnection;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Hauler that owns this depot's stock when it acts as a container-storage warehouse. Null means company-owned. */
  ownedDepots: DepotTypeConnection;
  /** Payment terms (free text, e.g. '30 days net'). */
  paymentTerms?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  /** The contractor this citizen conversation is addressed to (citizen->hauler messaging). NULL = the default citizen<->company conversation, whose behaviour is unchanged. Set at create time by auto-routing to property.area.hauler; the model stays open for a future specific-hauler pick. SET_NULL mirrors Area.hauler so a (soft-deletable) hauler removal never cascades a conversation away. */
  portalConversations: PortalConversationDefConnection;
  projects?: Maybe<Array<ProjectType>>;
  reassignedFrom: RouteHaulerReassignmentLogTypeConnection;
  reassignedTo: RouteHaulerReassignmentLogTypeConnection;
  routeSet: RouteTypeConnection;
  routeschemeSet: RouteSchemeTypeConnection;
  searchUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  settlementPeriods: SettlementPeriodTypeConnection;
  taskReassignedFrom: TaskHaulerReassignmentLogTypeConnection;
  taskReassignedTo: TaskHaulerReassignmentLogTypeConnection;
  /** Executing contractor, denormalised from route.hauler at creation and re-stamped when the stop moves to another hauler's route. */
  tasks: PickUpOrderTypeConnection;
  users?: Maybe<Array<UserType>>;
  /** VAT number, as printed on settlement documents. */
  vatNumber?: Maybe<Scalars['String']['output']>;
  vehicleCount?: Maybe<Scalars['Int']['output']>;
  /** Contractor that owns this vehicle. */
  vehicles: VehicleTypeConnection;
  /** The cleaning provider - a hauler reference defaulting from the area's contractor, overridable per §6.7 step 4. */
  washLists: WashListDefConnection;
  workTaskCorrectionsReceived: WorkTaskCorrectionTypeConnection;
};


export type HaulerDefAssignedDepotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefBonusModelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefChangeProposalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefCoOwnedDepotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefComplianceDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefHaulerpriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefHaulerpricechangelogSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefInvoiceReconciliationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefLoadsCorrectedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  openedAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefLoadsDerivedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  openedAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefManualEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefOwnedDepotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefPortalConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefReassignedFromArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefReassignedToArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefRouteSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefRouteschemeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefSettlementPeriodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefTaskReassignedFromArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefTaskReassignedToArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefWashListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HaulerDefWorkTaskCorrectionsReceivedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type HaulerDefConnection = {
  __typename: 'HaulerDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HaulerDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `HaulerDef` and its cursor. */
export type HaulerDefEdge = {
  __typename: 'HaulerDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HaulerDef>;
};

/**
 * FI-SELLABLE readiness for one invoice (G2S3-M2) — a thin projection
 * of ``services.finvoice_fi.fi_finvoice_readiness``. Honest by design:
 * ``is_fi=false`` for non-FI invoices, ``missing_mandatory`` names the
 * AVL 209 e § fields still empty in plain words, and ``channel_connected``
 * is always false in this build — the operator connection is staged spend
 * (the field motor is ready, the channel is not). Flag-gated hauler-mode
 * read, classified DENIED (the D-E16 precedent).
 */
export type HaulerFinvoiceReadinessDef = {
  __typename: 'HaulerFinvoiceReadinessDef';
  channelConnected?: Maybe<Scalars['Boolean']['output']>;
  channelFormat?: Maybe<Scalars['String']['output']>;
  channelReason?: Maybe<Scalars['String']['output']>;
  isFi?: Maybe<Scalars['Boolean']['output']>;
  missingMandatory?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reverseChargeMention?: Maybe<Scalars['String']['output']>;
  selfBillingMention?: Maybe<Scalars['String']['output']>;
  sellableGap?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sellerOvtIdentifier?: Maybe<Scalars['String']['output']>;
};

export type HaulerFuelEmissionsType = {
  __typename: 'HaulerFuelEmissionsType';
  rows?: Maybe<Array<FuelEmissionsRowType>>;
  /** One fossil-free share row per contractor. */
  shares?: Maybe<Array<FossilFreeShareType>>;
  /** The company-total fossil-free share row. */
  total: FossilFreeShareType;
};

/** One reused ticket attachment referenced as futile evidence. */
export type HaulerFutileEvidenceDef = {
  __typename: 'HaulerFutileEvidenceDef';
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

/** One futile (wasted) visit on an order line (HAUL-413, S4-O1). */
export type HaulerFutileVisitDef = {
  __typename: 'HaulerFutileVisitDef';
  confirmedFault?: Maybe<Scalars['String']['output']>;
  evidence?: Maybe<Array<Maybe<HaulerFutileEvidenceDef>>>;
  /** When the confirmed customer-fault fee was handed to billing. Null while unconfirmed, and always null for hauler/external faults (they never bill). */
  feeProducedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  markedAt?: Maybe<Scalars['DateTime']['output']>;
  markedByName?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reasonNote?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  suggestedFault?: Maybe<Scalars['String']['output']>;
};

/**
 * One planned visit sitting on a public holiday (HAUL-018) with
 * the proposed working day — a proposal, never an executed move.
 */
export type HaulerHolidayCollisionDef = {
  __typename: 'HaulerHolidayCollisionDef';
  accountName?: Maybe<Scalars['String']['output']>;
  /** True when the customer's agreement pre-authorizes the move (PMC.holidayAutoMove); False means the office must confirm. The move is journaled either way. */
  autoApproved?: Maybe<Scalars['Boolean']['output']>;
  holidayDate?: Maybe<Scalars['Date']['output']>;
  holidayName?: Maybe<Scalars['String']['output']>;
  lineId?: Maybe<Scalars['ID']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  proposedDate?: Maybe<Scalars['Date']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  siteAddress?: Maybe<Scalars['String']['output']>;
  stopId?: Maybe<Scalars['ID']['output']>;
};

export type HaulerInvoiceDef = {
  __typename: 'HaulerInvoiceDef';
  /** The Account this invoice bills, as the RAW PropertyManagementCompany pk (D-E16) — resolved through the AccountInvoiceContact bridge. Null when the payer contact is not a PMC bridge (person-billed invoices). */
  accountId?: Maybe<Scalars['ID']['output']>;
  /** gross_total minus registered payments. */
  balance?: Maybe<Scalars['Decimal']['output']>;
  /** The billed counterparty's name — never a raw id. */
  customerName?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  grossTotal?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  issueDate?: Maybe<Scalars['Date']['output']>;
  legalClass?: Maybe<Scalars['String']['output']>;
  lines?: Maybe<Array<Maybe<HaulerInvoiceLineDef>>>;
  netTotal?: Maybe<Scalars['Decimal']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  /** Sum of registered payments (S1-M5 manual half). */
  paidTotal?: Maybe<Scalars['Decimal']['output']>;
  paymentReference?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<Maybe<HaulerInvoicePaymentDef>>>;
  poRef?: Maybe<Scalars['String']['output']>;
  /** The send journal. In W1 'send' is STAGED: status + journal entry only — external dispatch is activated by WasteHero. */
  sendLog?: Maybe<Array<Maybe<HaulerInvoiceSendLogDef>>>;
  status?: Maybe<Scalars['String']['output']>;
  vatTotal?: Maybe<Scalars['Decimal']['output']>;
};

export type HaulerInvoiceLineDef = {
  __typename: 'HaulerInvoiceLineDef';
  description?: Maybe<Scalars['String']['output']>;
  gross?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  net?: Maybe<Scalars['Decimal']['output']>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  vat?: Maybe<Scalars['Decimal']['output']>;
  vatPercentage?: Maybe<Scalars['Decimal']['output']>;
};

export type HaulerInvoicePaymentDef = {
  __typename: 'HaulerInvoicePaymentDef';
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['Date']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type HaulerInvoiceSendLogDef = {
  __typename: 'HaulerInvoiceSendLogDef';
  action?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

/**
 * An office-entered measured quantity for a manual metered computation
 * (REQ 3.3.21/3.3.23): the period total (tonnes / hours / distance) the
 * settlement pays ``rate × quantity`` against for one contract area.
 */
export type HaulerManualMeteredQuantityType = Node & {
  __typename: 'HaulerManualMeteredQuantityType';
  /** Contract area the measured quantity was recorded for. */
  area: AreaDef;
  computation: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  month: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  /** Measured whole units of the computation (tonnes / hours / metres). Settlement pays rate × this quantity. */
  quantity: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  year: Scalars['Int']['output'];
};

export type HaulerManualMeteredQuantityTypeConnection = {
  __typename: 'HaulerManualMeteredQuantityTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HaulerManualMeteredQuantityTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `HaulerManualMeteredQuantityType` and its cursor. */
export type HaulerManualMeteredQuantityTypeEdge = {
  __typename: 'HaulerManualMeteredQuantityTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HaulerManualMeteredQuantityType>;
};

export type HaulerOrderDef = {
  __typename: 'HaulerOrderDef';
  accountName?: Maybe<Scalars['String']['output']>;
  /** Best available collection ETA: the stop's planned arrival when the route plan carries one, else Live Operations' cached route-finish estimate (an upper bound). Null when nothing is routed or no prediction is current — never a number nobody computed. */
  collectionEta?: Maybe<Scalars['DateTime']['output']>;
  /** Which machinery produced collectionEta: planned_arrival | route_finish_estimate. Null when collectionEta is null. */
  collectionEtaSource?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Journaled customer notices on this order (holiday moves, ...). STAGED-honest: journaled, never transmitted (W1). */
  customerNotices?: Maybe<Array<Maybe<HaulerCustomerNoticeDef>>>;
  /** Operational status derived from the linked tickets/stops (planned / dispatched / in_progress / done). Read-model only — the commercial `status` field is the owned state. */
  derivedStatus?: Maybe<Scalars['String']['output']>;
  execution?: Maybe<HaulerOrderExecutionDef>;
  /** Gross margin for this order: billed revenue minus disposal cost (registered weight × the gate-fee table's rate). Null with the reasons in marginReasons whenever any revenue line is unbilled or any weighed line lacks a cost rate — never a number missing its costs. A NON-null margin can still carry caveats: check marginIsPartial. */
  grossMargin?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** The invoice(s) this order's lines landed on — RAW invoice pks, derived read-only from the billing links (D-E16). Empty until billing produced an invoice. */
  invoiceIds?: Maybe<Array<Scalars['ID']['output']>>;
  lines?: Maybe<Array<Maybe<HaulerOrderLineDef>>>;
  /** True when grossMargin is a number but part of its revenue has NO cost side in the gate-fee table (piece/hour lines) — FIXIT3-M2. Show the marginReasons caveat next to the number; never present a partial margin as a bare green number. */
  marginIsPartial?: Maybe<Scalars['Boolean']['output']>;
  /** Human words (Danish — they go straight on the screen): why grossMargin is null when it is null, or the caveats on a computed margin (FIXIT3-M2: piece/hour lines with no cost basis, min-charge notes). Empty only when the margin is a number with full cost coverage. */
  marginReasons?: Maybe<Array<Scalars['String']['output']>>;
  /** Human-word reasons the paperwork gate (HAUL-419) is not met yet — why 'ready for invoice' would hold the order PENDING. Empty when the paperwork is complete. */
  missingPaper?: Maybe<Array<Scalars['String']['output']>>;
  poRef?: Maybe<Scalars['String']['output']>;
  priceListRef?: Maybe<Scalars['String']['output']>;
  requestedWindowEnd?: Maybe<Scalars['DateTime']['output']>;
  requestedWindowStart?: Maybe<Scalars['DateTime']['output']>;
  siteAddress?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** True when the work finished more than 36 hours ago and the order is still not verified (the HAUL-419 alarm condition, same derivation the sweep task uses). */
  verificationOverdue?: Maybe<Scalars['Boolean']['output']>;
};

export type HaulerOrderExecutionDef = {
  __typename: 'HaulerOrderExecutionDef';
  derivedStatus?: Maybe<Scalars['String']['output']>;
  linesCancelled?: Maybe<Scalars['Int']['output']>;
  linesTotal?: Maybe<Scalars['Int']['output']>;
  /** Lines voided after a confirmed futile visit (FIXIT3-O1) — resolved, never billed. Distinct from cancellations: the truck went and the visit failed. */
  linesVoided?: Maybe<Scalars['Int']['output']>;
  stopsCompleted?: Maybe<Scalars['Int']['output']>;
  stopsLinked?: Maybe<Scalars['Int']['output']>;
  stopsSkipped?: Maybe<Scalars['Int']['output']>;
  ticketsCompleted?: Maybe<Scalars['Int']['output']>;
  ticketsLinked?: Maybe<Scalars['Int']['output']>;
};

export type HaulerOrderLineDef = {
  __typename: 'HaulerOrderLineDef';
  /** Units completed so far — count-based completion (REQ-091, 'complete N of M') for lines with qty > 1. Null when the line isn't count-tracked. */
  completedCount?: Maybe<Scalars['Decimal']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  /** Futile (wasted) visits recorded on this line — office suggestions and confirmed attributions (HAUL-413). */
  futileVisits?: Maybe<Array<Maybe<HaulerFutileVisitDef>>>;
  id?: Maybe<Scalars['ID']['output']>;
  qty?: Maybe<Scalars['Decimal']['output']>;
  /** Office-recorded scale weight in the line's own unit (S4-O2, weight-sold lines only). Null until the slip is registered — never a number nobody weighed. */
  recordedWeight?: Maybe<Scalars['Decimal']['output']>;
  recordedWeightAt?: Maybe<Scalars['DateTime']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type HaulerOrderLineInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  qty?: InputMaybe<Scalars['Decimal']['input']>;
  service: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

/** One contractor's current-period score (best/worst callouts). */
export type HaulerOverviewContractorScoreType = {
  __typename: 'HaulerOverviewContractorScoreType';
  haulerId: Scalars['ID']['output'];
  haulerName: Scalars['String']['output'];
  lifts: Scalars['Int']['output'];
  missed: Scalars['Int']['output'];
  missedPer1000Lifts?: Maybe<Scalars['Float']['output']>;
  onTimePct?: Maybe<Scalars['Float']['output']>;
  planned: Scalars['Int']['output'];
};

/** The tile figures for one window (current or previous period). */
export type HaulerOverviewKpiSetType = {
  __typename: 'HaulerOverviewKpiSetType';
  /** lifts / (planned − excluded − pending); null with no basis. */
  collectionEfficiencyPct?: Maybe<Scalars['Float']['output']>;
  /** Complaints raised in the period, linked to contractor work (same linkage as settlement/W8; a complaint on several stops counts once). */
  complaintsCount: Scalars['Int']['output'];
  /** Deviations in the period — the same population as haulerDeviationsByReason, so the tile reconciles with the by-reason widget. */
  deviationsCount: Scalars['Int']['output'];
  excluded: Scalars['Int']['output'];
  fromDate: Scalars['Date']['output'];
  lifts: Scalars['Int']['output'];
  missed: Scalars['Int']['output'];
  /** Missed per 1,000 lifts; null when there were no lifts. */
  missedPer1000Lifts?: Maybe<Scalars['Float']['output']>;
  /** Reliability %: onTime / (planned − excluded − pending) — the PRO-119 metrics service's number. Null with no basis. */
  onTimePct?: Maybe<Scalars['Float']['output']>;
  pending: Scalars['Int']['output'];
  planned: Scalars['Int']['output'];
  toDate: Scalars['Date']['output'];
  /** Collected weight (kg) over completed, non-excused stops; null when nothing was weighed. */
  totalWeight?: Maybe<Scalars['Float']['output']>;
};

export type HaulerOverviewKpisType = {
  __typename: 'HaulerOverviewKpisType';
  /** Per-contractor current-period scores (same arithmetic as the tiles) for the best/worst contractor callouts. */
  contractors?: Maybe<Array<HaulerOverviewContractorScoreType>>;
  current: HaulerOverviewKpiSetType;
  /** The same-length window immediately before the requested period — the trend basis for every tile. */
  previous: HaulerOverviewKpiSetType;
};

/**
 * One Account pinned to a price list — raw PMC pk + display name
 * (the D-E16 id convention: raw pks for machine navigation, words for
 * screens).
 */
export type HaulerPinnedAccountDef = {
  __typename: 'HaulerPinnedAccountDef';
  accountId?: Maybe<Scalars['ID']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
};

/**
 * Audit row of one bulk update / index adjustment run (REQ 3.3.25):
 * kind, applied-to (base/current), percent or cents delta, author, date.
 */
export type HaulerPriceChangeLogDef = Node & {
  __typename: 'HaulerPriceChangeLogDef';
  affectedCount: Scalars['Int']['output'];
  appliedTo?: Maybe<CrmHaulerPriceChangeLogAppliedToChoices>;
  area?: Maybe<AreaDef>;
  author?: Maybe<UserType>;
  changeUnitValue?: Maybe<Scalars['Decimal']['output']>;
  changeValue: Scalars['Float']['output'];
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  effectiveDate: Scalars['Date']['output'];
  hauler: HaulerDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  kind: CrmHaulerPriceChangeLogKindChoices;
  note: Scalars['String']['output'];
  /** Set when the run was a temporary change: the last day the changed amounts applied before reverting to the pre-change prices. Null for permanent changes. */
  temporaryUntil?: Maybe<Scalars['Date']['output']>;
};

export type HaulerPriceChangeLogDefConnection = {
  __typename: 'HaulerPriceChangeLogDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HaulerPriceChangeLogDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `HaulerPriceChangeLogDef` and its cursor. */
export type HaulerPriceChangeLogDefEdge = {
  __typename: 'HaulerPriceChangeLogDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HaulerPriceChangeLogDef>;
};

/**
 * One named line of a contractor price (decision D3).
 *
 * ``value`` is cents for ``flat_cents`` components and hundredths of a
 * percent (350 = 3.50%) for ``percent`` components.
 */
export type HaulerPriceComponentDef = Node & {
  __typename: 'HaulerPriceComponentDef';
  createdAt: Scalars['DateTime']['output'];
  haulerPrice: HaulerPriceDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  kind: CrmHaulerPriceComponentKindChoices;
  label: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  /** A flat component's amount in currency at the tenant's price precision (HSY-235); null for a percent component. `value` stays its integer-cents mirror. */
  unitValue?: Maybe<Scalars['Decimal']['output']>;
  value: Scalars['Int']['output'];
};

/** One component row (replace-all semantics on write). */
export type HaulerPriceComponentInput = {
  /** flat_cents | percent */
  kind: Scalars['String']['input'];
  label: Scalars['String']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
  /** HSY-235: a flat_cents component's amount in currency at up to four decimals (rounded to the tenant's price precision). When given it wins and `value` is re-derived from it. Not allowed on a percent component. */
  unitValue?: InputMaybe<Scalars['Decimal']['input']>;
  /** Cents for flat_cents; hundredths of a percent for percent (350 = 3.50%). */
  value: Scalars['Int']['input'];
};

export type HaulerPriceDef = Node & {
  __typename: 'HaulerPriceDef';
  amount: Scalars['Int']['output'];
  area?: Maybe<AreaDef>;
  baseAmount?: Maybe<Scalars['Int']['output']>;
  /** The original contract price in currency at the tenant's price precision (HSY-235); `baseAmount` stays its cents mirror. */
  baseUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  company: CompanyType;
  components?: Maybe<Array<Maybe<HaulerPriceComponentDef>>>;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['Date']['output'];
  eventPay?: Maybe<Scalars['Int']['output']>;
  hauler: HaulerDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  /** Metered component lines (R2-S13): pay = rate × measured quantity from the settlement selectors — not included in eventPay. */
  meteredComponents?: Maybe<Array<Maybe<HaulerPriceMeteredComponentDef>>>;
  ppProduct?: Maybe<PpProductDef>;
  product?: Maybe<ProductDef>;
  /** Optional customer property this contractor price deviates for (REQ 3.3.21). NULL = area/company-scoped. */
  property?: Maybe<PropertyDef>;
  startDate: Scalars['Date']['output'];
  /** The contractor price in currency at the tenant's price precision (HSY-235: four decimals when four_decimal_prices_enabled, else the cent). `amount` stays its integer-cents mirror. */
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type HaulerPriceDefConnection = {
  __typename: 'HaulerPriceDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HaulerPriceDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `HaulerPriceDef` and its cursor. */
export type HaulerPriceDefEdge = {
  __typename: 'HaulerPriceDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HaulerPriceDef>;
};

export type HaulerPriceEventDef = Node & {
  __typename: 'HaulerPriceEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<HaulerPriceEventTypesGraphene>>>;
  fromAmount?: Maybe<Scalars['Int']['output']>;
  fromArea?: Maybe<AreaDef>;
  fromEndDate?: Maybe<Scalars['Date']['output']>;
  fromHauler?: Maybe<HaulerDef>;
  fromProduct?: Maybe<ProductDef>;
  fromStartDate?: Maybe<Scalars['Date']['output']>;
  /** The price before the change, in currency at the tenant's price precision (HSY-235). */
  fromUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  haulerPrice?: Maybe<HaulerPriceDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toAmount?: Maybe<Scalars['Int']['output']>;
  toArea?: Maybe<AreaDef>;
  toEndDate?: Maybe<Scalars['Date']['output']>;
  toHauler?: Maybe<HaulerDef>;
  toProduct?: Maybe<ProductDef>;
  toStartDate?: Maybe<Scalars['Date']['output']>;
  /** The price after the change, in currency at the tenant's price precision (HSY-235). */
  toUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  user?: Maybe<UserType>;
};

export enum HaulerPriceEventTypesGraphene {
  AMOUNT_CHANGE = 'AMOUNT_CHANGE',
  AREA_CHANGE = 'AREA_CHANGE',
  END_DATE_CHANGE = 'END_DATE_CHANGE',
  HAULER_CHANGE = 'HAULER_CHANGE',
  START_DATE_CHANGE = 'START_DATE_CHANGE'
}

/** Which amount the index percentage is computed from (REQ 3.3.25). */
export enum HaulerPriceIndexAppliedTo {
  BASE = 'BASE',
  CURRENT = 'CURRENT'
}

/**
 * Which level(s) of a contract area's carve-out hierarchy a mass change
 * targets (PRO-280 H3, decision 9 + answer 4).
 *
 * ``required`` on both mass mutations with NO default: the operator must
 * choose explicitly, so an omitted scope is rejected rather than silently
 * widened. Orthogonal to ``appliedTo`` (which picks the price BASIS —
 * base vs current — not a hierarchy level).
 *
 * * ``PARENT`` — the parent level only (anchored to ``areaId``: that area
 *   itself; hauler-wide: every top-level area plus the hauler-flat rows).
 * * ``CARVE_OUT`` — the carve-out level only (anchored: carve-outs nested
 *   under ``areaId`` at any depth; hauler-wide: every carve-out area).
 * * ``BOTH`` — parent and carve-out together.
 */
export enum HaulerPriceLevelScope {
  BOTH = 'BOTH',
  CARVE_OUT = 'CARVE_OUT',
  PARENT = 'PARENT'
}

/**
 * One price list header (G2S1-M1, HAUL-202/209) — a thin projection
 * of ``product.PriceList`` plus the hauler layer's facts (validity,
 * inheritance, minimum charge, pins).
 */
export type HaulerPriceListDef = {
  __typename: 'HaulerPriceListDef';
  id?: Maybe<Scalars['ID']['output']>;
  minimumCharge?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  parentName?: Maybe<Scalars['String']['output']>;
  /** Accounts whose orders price through this list (HAUL-203). */
  pinnedAccounts?: Maybe<Array<Maybe<HaulerPinnedAccountDef>>>;
  /** Live price rows in this list — honest emptiness beats a dead screen. */
  rowCount?: Maybe<Scalars['Int']['output']>;
  rowMinimumCharges?: Maybe<Array<Maybe<Scalars['Decimal']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['Date']['output']>;
  validTo?: Maybe<Scalars['Date']['output']>;
};

export type HaulerPriceMassChangePreviewType = {
  __typename: 'HaulerPriceMassChangePreviewType';
  areaId?: Maybe<Scalars['ID']['output']>;
  haulerPriceId?: Maybe<Scalars['ID']['output']>;
  newAmount?: Maybe<Scalars['Int']['output']>;
  /** The price after the change, in currency (HSY-235). */
  newUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  oldAmount?: Maybe<Scalars['Int']['output']>;
  /** The price before the change, in currency (HSY-235). */
  oldUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
};

/**
 * One metered line of a contractor price (R2-S13, decision R2-D18).
 *
 * ``rate`` is cents per measured unit; the pay is ``rate × measured
 * quantity``, resolved by the settlement selectors over the period
 * (``per_emptying`` = the row's priced stops, ``per_round`` = the
 * distinct rounds among them) — it is NOT part of the per-stop
 * ``eventPay``.
 */
export type HaulerPriceMeteredComponentDef = Node & {
  __typename: 'HaulerPriceMeteredComponentDef';
  /** per_round | per_emptying | per_tonne | per_hour | per_distance. */
  computation: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  haulerPrice: HaulerPriceDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** Cents per measured unit of the computation. */
  rate: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
  /** The rate per measured unit in currency at the tenant's price precision (HSY-235). `rate` stays its integer-cents mirror. */
  unitRate?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * One metered component row (replace-all semantics on write,
 * R2-S13).
 */
export type HaulerPriceMeteredComponentInput = {
  /** per_round | per_emptying | per_tonne | per_hour | per_distance — the last three are refused ('data feed not available', R2-D18) until their measured-data feeds land. */
  computation: Scalars['String']['input'];
  label: Scalars['String']['input'];
  /** Cents per measured unit. */
  rate: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
  /** HSY-235: the rate per measured unit in currency at up to four decimals (rounded to the tenant's price precision). When given it wins and `rate` is re-derived from it. */
  unitRate?: InputMaybe<Scalars['Decimal']['input']>;
};

/**
 * PRO-280 (C3/E) "test a point" — the resolver-explain read: a test
 * point resolved to the winning customer price row + the full zone
 * resolution chain. The test point is EXACTLY ONE of a raw coordinate
 * (``lat``/``lng``) or ``propertyId`` (the tenant's own property, whose
 * stored point is used); both modes converge on the same engine, so a
 * property previews byte-identically to its own coordinate.
 *
 * Read-only preview. ``chain`` is the F2 geometric resolver's ordered zones
 * (innermost→…→parent→…→default) whose boundary covers the point; it is the
 * raw geometry, always present regardless of the tenant's opt-in. The winner
 * (``winningPriceRow`` / ``price``) is resolved through the SAME chain-aware
 * selection real customer pricing uses (with the R1 tie-break), so the
 * preview matches what a live emptying at that point would be priced by —
 * including honouring the customer-zone opt-in (``zonePricingEnabled``): when
 * it is false the chain is informational only and the winner is the
 * zone-agnostic row, exactly as it bills today.
 */
export type HaulerPricePointPreviewDef = {
  __typename: 'HaulerPricePointPreviewDef';
  /** The zones covering the point as the F2 chain, innermost→…→parent→…→default (each a ZoneDef hierarchy node); empty when the point falls in no zone. */
  chain?: Maybe<Array<Maybe<ZoneDef>>>;
  /** The winning row's effective price on the preview date; NULL when no row matched. */
  price?: Maybe<Scalars['Decimal']['output']>;
  /** The price row that prices this point today, or NULL when no row matches (honest 'nothing prices this' — never a fake zero). */
  winningPriceRow?: Maybe<HaulerPriceRowDef>;
  /** Whether this company has opted into customer zone pricing (CompanySettings.customer_zone_pricing_enabled). When false the chain did NOT influence the winner — it is informational and the winner is the zone-agnostic row, matching live pricing. */
  zonePricingEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * One price row inside a list, for AUTHORING (RD-46). A thin
 * projection of ``product.PriceRow`` — ``unitPrice`` is the stored price
 * verbatim (no calculation), ``productName`` is the words a screen shows.
 * ``minimumCharge`` is the HAUL-209 per-row floor (NULL = none).
 */
export type HaulerPriceRowDef = {
  __typename: 'HaulerPriceRowDef';
  /** INDIVIDUAL | BUSINESS; NULL = all customer types. */
  customerType?: Maybe<Scalars['String']['output']>;
  /** Per-row invoice line name; NULL = fall back to product. */
  descriptor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoiceCode?: Maybe<Scalars['String']['output']>;
  /** HAUL-209 per-row minimum for a charge priced by this row; NULL = no row-level floor. */
  minimumCharge?: Maybe<Scalars['Decimal']['output']>;
  priceListId?: Maybe<Scalars['ID']['output']>;
  /** Raw Product pk this row prices (machine navigation). */
  productId?: Maybe<Scalars['ID']['output']>;
  /** The product's name — the words a screen shows. */
  productName?: Maybe<Scalars['String']['output']>;
  /** The row's stored price at the tenant's unit-price precision (two decimals, four for a company pricing at four decimals) — never computed here. */
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  vatRateId?: Maybe<Scalars['ID']['output']>;
  /** The row's pricing zone as the F1 hierarchy node (parent/children/depth); NULL when zone-agnostic or the id is not a live consolidated zone. */
  zone?: Maybe<ZoneDef>;
  /** Pricing-zone id this row is scoped to; NULL = all zones. */
  zoneId?: Maybe<Scalars['ID']['output']>;
  /** The row's pricing-zone name (display provenance); NULL when zone-agnostic or the id is not a live consolidated zone. */
  zoneName?: Maybe<Scalars['String']['output']>;
};

/**
 * The order form's price suggestion (G2S1-M2, G2S3-M1) — a thin
 * projection of ``services.price_resolution.resolve_order_price``.
 * ``source`` is a machine key (pinned_list / pinned_parent / zone_list /
 * standard_list / catalog / none); the screen speaks the words.
 * ``zone_id`` / ``zone_name`` name the site's zone that was consulted
 * (HAUL-204), present whenever a valid tenant zone was resolved.
 */
export type HaulerPriceSuggestionDef = {
  __typename: 'HaulerPriceSuggestionDef';
  accountId?: Maybe<Scalars['ID']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  minimumCharge?: Maybe<Scalars['Decimal']['output']>;
  priceListId?: Maybe<Scalars['ID']['output']>;
  priceListName?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  zoneId?: Maybe<Scalars['ID']['output']>;
  zoneName?: Maybe<Scalars['String']['output']>;
};

/**
 * One rental placement — a thin projection of
 * ``services.rental.list_rentals`` (S4-M1). Machine refs
 * (``site_ref``/``container_ref``/``agreement_id``) are raw pks for
 * navigation, never display words; the display words are ``service``
 * (the catalog product's name) and the period facts.
 */
export type HaulerRentalDef = {
  __typename: 'HaulerRentalDef';
  active?: Maybe<Scalars['Boolean']['output']>;
  agreementId?: Maybe<Scalars['ID']['output']>;
  billingFrequency?: Maybe<Scalars['String']['output']>;
  /** Raw Container pk, when a specific container is placed. */
  containerRef?: Maybe<Scalars['ID']['output']>;
  /** The placed container's model/type name (e.g. 'Vippecontainer 8 m³') — display words, null when no specific container is placed. */
  containerType?: Maybe<Scalars['String']['output']>;
  /** The placed container's size in m³ (from its type) — display only, null when no specific container is placed. */
  containerVolume?: Maybe<Scalars['Float']['output']>;
  /** Whether the CURRENT period's rent event exists in the engine's tables — read, never recomputed. */
  currentPeriodBilled?: Maybe<Scalars['Boolean']['output']>;
  currentPeriodKey?: Maybe<Scalars['String']['output']>;
  /** Last billed day (inclusive) — null while the clock runs. */
  endDate?: Maybe<Scalars['Date']['output']>;
  placementRef?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  /** The per-period hire RATE the Ledger rental clock (HAUL-504) bills — the placement product's effective price; the period is `billingFrequency`. Read-only: this is the modelled rate, NOT a computed charge (no proration is done here). Null when the product yields no price. */
  rate?: Maybe<Scalars['Decimal']['output']>;
  /** The rental catalog product's name — the words a screen shows. */
  service?: Maybe<Scalars['String']['output']>;
  /** Raw Property pk of the customer site (machine navigation). */
  siteRef?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

/**
 * One candidate target route for the stop-move modal (D-E18(b),
 * FIXIT2-O1) — just enough for a planner to pick a truck-day: who
 * drives it, which vehicle, how many stops it already carries.
 */
export type HaulerRouteOptionDef = {
  __typename: 'HaulerRouteOptionDef';
  driverName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  scheduledDay?: Maybe<Scalars['Date']['output']>;
  /** True when the driver is already out on it. */
  started?: Maybe<Scalars['Boolean']['output']>;
  stopsCount?: Maybe<Scalars['Int']['output']>;
  vehicleName?: Maybe<Scalars['String']['output']>;
};

/**
 * A computed day route plan over the tenant's own orders + fleet,
 * produced by REUSING the Route Studio solver seam (E6 slice 1). No
 * side effects — reading this field computes and returns a plan, it
 * persists nothing.
 */
export type HaulerRoutePlanDef = {
  __typename: 'HaulerRoutePlanDef';
  /** Solver engine that produced the plan. */
  engine?: Maybe<Scalars['String']['output']>;
  /** Orders placed on a route. */
  ordersPlanned?: Maybe<Scalars['Int']['output']>;
  planId?: Maybe<Scalars['String']['output']>;
  routes?: Maybe<Array<HaulerRoutePlanRouteDef>>;
  seed?: Maybe<Scalars['Int']['output']>;
  /** Order pks excluded before solving (e.g. no located site). */
  skippedOrderIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Solver wall-clock, milliseconds. */
  solveMs?: Maybe<Scalars['Int']['output']>;
  totalDistanceKm?: Maybe<Scalars['Float']['output']>;
  /** Order pks the solver could not fit (e.g. capacity). */
  unassignedOrders?: Maybe<Array<Scalars['ID']['output']>>;
  vehiclesUsed?: Maybe<Scalars['Int']['output']>;
};

/** One vehicle's planned route (E6 slice 1). */
export type HaulerRoutePlanRouteDef = {
  __typename: 'HaulerRoutePlanRouteDef';
  /** Straight-line (Euclidean) distance for the route, in km. A slice-1 approximation — real road-network distance needs the routing-matrix service (deferred). */
  distanceKm?: Maybe<Scalars['Float']['output']>;
  /** Number of stops served on this route. */
  lifts?: Maybe<Scalars['Int']['output']>;
  stops?: Maybe<Array<HaulerRoutePlanStopDef>>;
  /** Raw pk of the fleet vehicle. */
  vehicleId?: Maybe<Scalars['ID']['output']>;
  /** Vehicle license plate (human-readable), never a raw id. */
  vehicleLabel?: Maybe<Scalars['String']['output']>;
};

/** One stop in a planned vehicle route (E6 slice 1). */
export type HaulerRoutePlanStopDef = {
  __typename: 'HaulerRoutePlanStopDef';
  /** Modelled load for this stop, in kg (slice-1 single stream). */
  demandKg?: Maybe<Scalars['Float']['output']>;
  /** Raw pk of the hauler order at this stop. */
  orderId?: Maybe<Scalars['ID']['output']>;
  /** 0-based visit position within this vehicle's route. */
  sequenceIndex?: Maybe<Scalars['Int']['output']>;
  /** Human-readable site (address/name), never a raw id. */
  siteLabel?: Maybe<Scalars['String']['output']>;
};

/**
 * A filter on a plan's summarized result (plan_schema.HavingSpec):
 * ``values`` holds one number, two for ``between``.
 */
export type HavingInput = {
  op: Scalars['String']['input'];
  values: Array<Scalars['Float']['input']>;
};

export type HealthCheckSubscription = {
  __typename: 'HealthCheckSubscription';
  healthcheck?: Maybe<HealthCheckType>;
};

export type HealthCheckType = {
  __typename: 'HealthCheckType';
  currentDatetime?: Maybe<Scalars['DateTime']['output']>;
  mixpanel?: Maybe<Scalars['Boolean']['output']>;
  users?: Maybe<Scalars['Int']['output']>;
};

/**
 * Keep-alive (~60 s while the editor is active). ``expired`` means
 * the lease lapsed; ``lost`` means someone took over (their lease is
 * returned).
 */
export type HeartbeatRecordLease = {
  __typename: 'HeartbeatRecordLease';
  lease?: Maybe<RecordLeaseDef>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum HistoryObjectStateGraphene {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  SOFT_DELETED = 'SOFT_DELETED',
  UPDATED = 'UPDATED'
}

/** One selectable holiday-calendar country (B1.2). */
export type HolidayCalendarCountryDef = {
  __typename: 'HolidayCalendarCountryDef';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * Per-row outcome of ``bulkAcceptHolidayImpact``. ``outcome`` is
 * the string token ``applied | blocked | failed`` (never the old
 * ``ok`` boolean — acl.ts owns the label map); ``message`` carries
 * the backend's own human words — including why a row was BLOCKED
 * (e.g. "plan a route for this contractor on that day") or FAILED.
 */
export type HolidayImpactBulkResultDef = {
  __typename: 'HolidayImpactBulkResultDef';
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  newDate?: Maybe<Scalars['Date']['output']>;
  outcome: Scalars['String']['output'];
};

/** One backend-computed grouped count row — never FE-aggregated. */
export type HolidayImpactGroupCountDef = {
  __typename: 'HolidayImpactGroupCountDef';
  count: Scalars['Int']['output'];
  key: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

/**
 * One page of the holiday work-queue. Non-null empty collections
 * when the tenant has a calendar but nothing is impacted; the OUTER
 * ``holidayImpact`` result is null when no calendar is configured
 * yet — the two empty reasons the empty state must tell apart.
 */
export type HolidayImpactPageDef = {
  __typename: 'HolidayImpactPageDef';
  byContractArea: Array<HolidayImpactGroupCountDef>;
  byContractor: Array<HolidayImpactGroupCountDef>;
  rows: Array<HolidayImpactRowDef>;
  sensorVisibilityLagged: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

/**
 * One row of the holiday work-queue — a materialized stop, a
 * beyond-horizon projection, or an open ticket (never rolled up past
 * one row per subject+holiday — routing/CLAUDE.md's unit-of-account
 * guard rail). ``haulerId``/``haulerName``/``contractAreaId``/
 * ``contractAreaName`` are null for rows the read model cannot
 * attribute. ``proposedDate`` is null under policy ``none`` (no
 * change) or when no eligible target could be resolved.
 *
 * ``id`` is a synthetic, non-persisted token
 * (``stop:<uuid>``/``proj:<container_id>:<holiday>``/
 * ``ticket:<id>``) — never a raw database id rendered as visible
 * text; the mutations decode it back to the right subject.
 */
export type HolidayImpactRowDef = {
  __typename: 'HolidayImpactRowDef';
  contractAreaId?: Maybe<Scalars['ID']['output']>;
  contractAreaName?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  haulerId?: Maybe<Scalars['ID']['output']>;
  haulerName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** REGULAR | SENSOR | TICKET. */
  itemType: Scalars['String']['output'];
  originalDate: Scalars['Date']['output'];
  /** same_week | next_visit | spread | none | cancel. Under 'cancel' (HSY-258) proposedDate is null and the visit on the holiday is dropped rather than moved. */
  policyApplied: Scalars['String']['output'];
  /** company_default | contract_area. */
  policySource: Scalars['String']['output'];
  proposedDate?: Maybe<Scalars['Date']['output']>;
  siteAddress?: Maybe<Scalars['String']['output']>;
  /** PENDING | ACCEPTED | APPLIED | LOCKED | CANCELLED. CANCELLED (HSY-258): the office accepted a 'cancel' outcome — the materialised stop is soft-deleted, or the projection's live decision was consumed by generation. */
  status: Scalars['String']['output'];
  wasteFraction?: Maybe<Scalars['String']['output']>;
};

/**
 * RS-E26 (D58): one client-known identity on a case. The client
 * label is always present; the system-side external id and the raw
 * platform FKs are deliberately NOT exposed here (the client never
 * sees an identifier they did not give us); ``platformDepotName``
 * names a matched depot in human terms.
 */
export type IdentityMapDef = Node & {
  __typename: 'IdentityMapDef';
  case: ImportCaseDef;
  clientLabel: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  detail: Scalars['JSONString']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  kind: RouteStudioIdentityMapKindChoices;
  /** The matched platform depot's name (depot entries only); null while unresolved or acknowledged missing. */
  platformDepotName?: Maybe<Scalars['String']['output']>;
  resolution: RouteStudioIdentityMapResolutionChoices;
  sourceRefs: Scalars['JSONString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type IdentityMapDefConnection = {
  __typename: 'IdentityMapDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IdentityMapDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `IdentityMapDef` and its cursor. */
export type IdentityMapDefEdge = {
  __typename: 'IdentityMapDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<IdentityMapDef>;
};

export type Impersonate = {
  __typename: 'Impersonate';
  token?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum ImportActions {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE'
}

/**
 * Import a contract area's geographic boundary from an uploaded file.
 *
 * Requirement 3.5.54 / D25 (customer-confirmed): the office imports shape
 * files as contract zones. Accepts a zipped shapefile (.shp + .shx + .dbf +
 * optional .prj) or a GeoJSON file via the platform's standard multipart
 * ``Upload`` scalar (graphene-file-upload, same path as container photos).
 * The file is parsed with GDAL, every polygon is transformed to WGS84
 * (SRID 4326) and stored as a MultiPolygon on ``Area.boundary``.
 *
 * Office-only: contract-area geometry is office-managed (same rule as
 * ``UpdateOrCreateArea``); contractors are denied. The area is company-scoped
 * so a cross-tenant global id is a not-found, never a cross-tenant write.
 */
export type ImportAreaBoundary = {
  __typename: 'ImportAreaBoundary';
  area?: Maybe<AreaDef>;
};

export type ImportBatchDef = Node & {
  __typename: 'ImportBatchDef';
  auditLog: Scalars['JSONString']['output'];
  candidateTables: CandidateTableDefConnection;
  columns: Scalars['JSONString']['output'];
  confirmedMapping?: Maybe<Scalars['JSONString']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  extraction: Scalars['JSONString']['output'];
  file?: Maybe<Scalars['String']['output']>;
  fileFormat: Scalars['String']['output'];
  geocodeStats: Scalars['JSONString']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  issues: ImportIssueDefConnection;
  mappingDecisions: Scalars['JSONString']['output'];
  name: Scalars['String']['output'];
  project: ProjectType;
  proposedMapping?: Maybe<Scalars['JSONString']['output']>;
  qualityReport?: Maybe<ImportQualityReportDef>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  /** First rows only; the full parse stays server-side. */
  sampleRows?: Maybe<Scalars['GenericScalar']['output']>;
  sourceFileName: Scalars['String']['output'];
  status: RouteStudioImportBatchStatusChoices;
  stopSet?: Maybe<StopSetDef>;
};


export type ImportBatchDefCandidateTablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ImportBatchDefIssuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportBatchDefConnection = {
  __typename: 'ImportBatchDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ImportBatchDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ImportBatchDef` and its cursor. */
export type ImportBatchDefEdge = {
  __typename: 'ImportBatchDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ImportBatchDef>;
};

/**
 *
 *     Delimiters that can be used in ImportHistory and ImportConflict
 *
 */
export enum ImportCsvDelimiters {
  COMMA = 'COMMA',
  PIPE = 'PIPE',
  SEMICOLON = 'SEMICOLON',
  TAB = 'TAB'
}

/**
 * RS-E20: one onboarding case, the long-lived container for
 * files, candidate tables, claims, questions and the manifest
 * (D55, D62). The RS-E23 risk counts ride the payload: deferred
 * questions are visible open risks, never invisible defaults.
 */
export type ImportCaseDef = Node & {
  __typename: 'ImportCaseDef';
  claims: GrammarClaimDefConnection;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** Explicitly deferred questions: each one is a visible open risk on the case, never a silent default (D62). */
  deferredQuestionCount?: Maybe<Scalars['Int']['output']>;
  files: ImportFileDefConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  identityEntries: IdentityMapDefConnection;
  manifestNodes: ManifestNodeDefConnection;
  materializations: CaseMaterializationDefConnection;
  materializedRuns: MaterializedRunDefConnection;
  name: Scalars['String']['output'];
  /** Questions currently awaiting an answer. */
  openQuestionCount?: Maybe<Scalars['Int']['output']>;
  project: ProjectType;
  /** Grammar claims not yet reviewed (proposed); the decode engine re-derives from reviewed claims only. */
  proposedClaimCount?: Maybe<Scalars['Int']['output']>;
  /** SBX-521: the case's declared import purpose. Declared: {declared: true, use_case, label, sentence, expects, declared_at}. Undeclared: {declared: false, orienting_question, presets}, the six named use cases; the case asks instead of opening blank. */
  purpose?: Maybe<Scalars['GenericScalar']['output']>;
  questions: CaseQuestionDefConnection;
  serviceBindings: FractionServiceBindingDefConnection;
  sourceMetrics: SourceMetricDefConnection;
  /** Wave D1 (SBX-437, D62): materialized runs of the newest version dated beyond the last claimed red day; they assume no non-collection days because no calendar covers them. 0 when the newest materialization is fully covered or none exists. */
  staleCoverageRunCount?: Maybe<Scalars['Int']['output']>;
  status: RouteStudioImportCaseStatusChoices;
  updatedAt: Scalars['DateTime']['output'];
  validationVerdicts: ValidationVerdictDefConnection;
};


/**
 * RS-E20: one onboarding case, the long-lived container for
 * files, candidate tables, claims, questions and the manifest
 * (D55, D62). The RS-E23 risk counts ride the payload: deferred
 * questions are visible open risks, never invisible defaults.
 */
export type ImportCaseDefClaimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * RS-E20: one onboarding case, the long-lived container for
 * files, candidate tables, claims, questions and the manifest
 * (D55, D62). The RS-E23 risk counts ride the payload: deferred
 * questions are visible open risks, never invisible defaults.
 */
export type ImportCaseDefFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * RS-E20: one onboarding case, the long-lived container for
 * files, candidate tables, claims, questions and the manifest
 * (D55, D62). The RS-E23 risk counts ride the payload: deferred
 * questions are visible open risks, never invisible defaults.
 */
export type ImportCaseDefIdentityEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * RS-E20: one onboarding case, the long-lived container for
 * files, candidate tables, claims, questions and the manifest
 * (D55, D62). The RS-E23 risk counts ride the payload: deferred
 * questions are visible open risks, never invisible defaults.
 */
export type ImportCaseDefManifestNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * RS-E20: one onboarding case, the long-lived container for
 * files, candidate tables, claims, questions and the manifest
 * (D55, D62). The RS-E23 risk counts ride the payload: deferred
 * questions are visible open risks, never invisible defaults.
 */
export type ImportCaseDefMaterializationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * RS-E20: one onboarding case, the long-lived container for
 * files, candidate tables, claims, questions and the manifest
 * (D55, D62). The RS-E23 risk counts ride the payload: deferred
 * questions are visible open risks, never invisible defaults.
 */
export type ImportCaseDefMaterializedRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * RS-E20: one onboarding case, the long-lived container for
 * files, candidate tables, claims, questions and the manifest
 * (D55, D62). The RS-E23 risk counts ride the payload: deferred
 * questions are visible open risks, never invisible defaults.
 */
export type ImportCaseDefQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * RS-E20: one onboarding case, the long-lived container for
 * files, candidate tables, claims, questions and the manifest
 * (D55, D62). The RS-E23 risk counts ride the payload: deferred
 * questions are visible open risks, never invisible defaults.
 */
export type ImportCaseDefServiceBindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * RS-E20: one onboarding case, the long-lived container for
 * files, candidate tables, claims, questions and the manifest
 * (D55, D62). The RS-E23 risk counts ride the payload: deferred
 * questions are visible open risks, never invisible defaults.
 */
export type ImportCaseDefSourceMetricsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * RS-E20: one onboarding case, the long-lived container for
 * files, candidate tables, claims, questions and the manifest
 * (D55, D62). The RS-E23 risk counts ride the payload: deferred
 * questions are visible open risks, never invisible defaults.
 */
export type ImportCaseDefValidationVerdictsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportCaseDefConnection = {
  __typename: 'ImportCaseDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ImportCaseDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ImportCaseDef` and its cursor. */
export type ImportCaseDefEdge = {
  __typename: 'ImportCaseDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ImportCaseDef>;
};

/**
 *
 *     Choices that represent the all field types for Import (ImportField)
 *
 */
export enum ImportFieldTypes {
  ARRAY = 'ARRAY',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  GLOBAL_ID = 'GLOBAL_ID',
  M2_M = 'M2M',
  NUMBER = 'NUMBER',
  STRING = 'STRING',
  TIME = 'TIME'
}

/**
 * RS-E20: one uploaded file on a case (checksum, storage ref,
 * explosion status).
 */
export type ImportFileDef = Node & {
  __typename: 'ImportFileDef';
  candidateTables: CandidateTableDefConnection;
  case: ImportCaseDef;
  /** SHA-256 of the uploaded bytes. */
  checksum: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  file: Scalars['String']['output'];
  fileFormat: Scalars['String']['output'];
  /** SBX-410: resolved download URL for the original upload (the storage backend's URL; signed and temporary on S3 backends), so the UI files strip can offer 'open the original file'. Null when no file is stored. */
  fileUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** SBX-521: which route needs THIS upload satisfies or partially covers, from its own tables' classes: {satisfies: [{requirement, label}], partially_covers: [...], sentence}. Render the sentence verbatim on the files strip. */
  needs?: Maybe<Scalars['GenericScalar']['output']>;
  note: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
  status: RouteStudioImportFileStatusChoices;
  /** SBX-518 papercut P4 (wave D18): non-null when a newer non-failed upload with the same file name supersedes this row (the D56 newest-wins head the decoder reads): {file_id, file_name, uploaded_at, sentence}. Render the sentence verbatim on the superseded file row; null on the current head and on failed rows. */
  supersededBy?: Maybe<Scalars['GenericScalar']['output']>;
  uploadedBy?: Maybe<UserType>;
};


/**
 * RS-E20: one uploaded file on a case (checksum, storage ref,
 * explosion status).
 */
export type ImportFileDefCandidateTablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportFileDefConnection = {
  __typename: 'ImportFileDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ImportFileDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ImportFileDef` and its cursor. */
export type ImportFileDefEdge = {
  __typename: 'ImportFileDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ImportFileDef>;
};

/** Tips for import file */
export type ImportFileTooltips = {
  __typename: 'ImportFileTooltips';
  alternativeLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: ImportFieldTypes;
};

/**
 * Record the finance system's credit notes against exported lines
 * (idempotent per line + credit note number).
 */
export type ImportFinanceCreditNotesMutation = {
  __typename: 'ImportFinanceCreditNotesMutation';
  imported: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  results: Array<FinanceCreditNoteRowResultType>;
  unchanged: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

/**
 *
 *     Formats that can be used in ImportHistory and ImportConflict
 *
 */
export enum ImportFormats {
  CSV = 'CSV',
  XLSX = 'XLSX'
}

/** Import history */
export type ImportHistoryDef = Node & {
  __typename: 'ImportHistoryDef';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createItems?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  fileDelimiter?: Maybe<ExportImportImportHistoryFileDelimiterChoices>;
  fileFormat: ImportFormats;
  fileUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importAction: ImportActions;
  importFile?: Maybe<Scalars['String']['output']>;
  importType: ImportTypes;
  progress: Scalars['Int']['output'];
  project?: Maybe<ProjectType>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ImportHistoryStatuses;
  totalItems?: Maybe<Scalars['Int']['output']>;
  updateItems?: Maybe<Scalars['Int']['output']>;
  user: UserType;
};

export type ImportHistoryDefConnection = {
  __typename: 'ImportHistoryDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ImportHistoryDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ImportHistoryDef` and its cursor. */
export type ImportHistoryDefEdge = {
  __typename: 'ImportHistoryDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ImportHistoryDef>;
};

/**
 *
 *     Statuses that can be used in ImportHistory
 *
 */
export enum ImportHistoryStatuses {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NEW = 'NEW'
}

export type ImportIssueDef = Node & {
  __typename: 'ImportIssueDef';
  column: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importBatch: ImportBatchDef;
  issueType: RouteStudioImportIssueIssueTypeChoices;
  payload: Scalars['JSONString']['output'];
  resolution: RouteStudioImportIssueResolutionChoices;
  resolutionPayload?: Maybe<Scalars['JSONString']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<UserType>;
  rowIndex?: Maybe<Scalars['Int']['output']>;
  stop?: Maybe<StopDef>;
  verdict?: Maybe<RouteStudioImportIssueVerdictChoices>;
};

export type ImportIssueDefConnection = {
  __typename: 'ImportIssueDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ImportIssueDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ImportIssueDef` and its cursor. */
export type ImportIssueDefEdge = {
  __typename: 'ImportIssueDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ImportIssueDef>;
};

export type ImportKmdEasyFile = {
  __typename: 'ImportKmdEasyFile';
  importHistory?: Maybe<ImportedKmdEasyFileDef>;
};

/**
 * RS-104 data quality report, shaped for direct UI rendering.
 *
 * v2 (RS-E21): ``category_sentence`` leads the report; render it
 * FIRST, before any row-level finding.
 */
export type ImportQualityReportDef = {
  __typename: 'ImportQualityReportDef';
  /** The leading category-level sentence when the file does not look like a stop list ('this file looks like a route calendar, not a stop list'); empty for stop lists. Render before row-level findings. */
  categorySentence?: Maybe<Scalars['String']['output']>;
  /** RS-E21 stage B verdict over the parsed table: {doc_class, confidence, is_stop_list, signals, sentence}. Computed with deterministic heuristics, never a network call. */
  categoryVerdict?: Maybe<Scalars['GenericScalar']['output']>;
  deferredCount?: Maybe<Scalars['Int']['output']>;
  duplicateCount?: Maybe<Scalars['Int']['output']>;
  /** Only fatal classes block scenario creation (RS-104 AC). */
  fatal: Scalars['Boolean']['output'];
  fatalReasons?: Maybe<Array<Scalars['String']['output']>>;
  fractionCoveragePct?: Maybe<Scalars['Float']['output']>;
  frequencyCoveragePct?: Maybe<Scalars['Float']['output']>;
  geocodeStats?: Maybe<Scalars['GenericScalar']['output']>;
  geocoderOutageAdvice?: Maybe<Scalars['String']['output']>;
  /** Rows whose geocoding failed because the geocoder was unreachable (retry; not an address problem). */
  geocoderOutageCount?: Maybe<Scalars['Int']['output']>;
  invalidFrequencyCount?: Maybe<Scalars['Int']['output']>;
  openGeocoderOutageIssues?: Maybe<Scalars['Int']['output']>;
  openIssueCounts?: Maybe<Scalars['GenericScalar']['output']>;
  /** Share of stops currently green (EV-GEO gate). */
  resolvedPct?: Maybe<Scalars['Float']['output']>;
  rowCount: Scalars['Int']['output'];
  stopCount: Scalars['Int']['output'];
  unmappedColumns?: Maybe<Array<Scalars['String']['output']>>;
  /** Current green/amber/red counts over the stops. */
  verdictCounts?: Maybe<Scalars['GenericScalar']['output']>;
};

/** Generated import template file */
export type ImportTemplateResult = {
  __typename: 'ImportTemplateResult';
  fileBase64: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

/**
 *
 *     Types that can be used in ImportTemplate
 *
 */
export enum ImportTypes {
  COLLECTION_CALENDAR = 'COLLECTION_CALENDAR',
  COLLECTION_CALENDAR_DATE = 'COLLECTION_CALENDAR_DATE',
  CONTACT = 'CONTACT',
  CONTAINER = 'CONTAINER',
  CONTAINER_TYPE = 'CONTAINER_TYPE',
  PICKUP_SETTING = 'PICKUP_SETTING',
  PROPERTY = 'PROPERTY',
  TICKET = 'TICKET',
  VEHICLE = 'VEHICLE',
  WASTE_FRACTION = 'WASTE_FRACTION'
}

/**
 * Import a zone's geographic boundary from an uploaded file (DEV-TASK-1,
 * platform-level since T4).
 *
 * Clone of :class:`ImportAreaBoundary` for zones: accepts a zipped
 * shapefile (.shp + .shx + .dbf + optional .prj) or a GeoJSON file via the
 * standard multipart ``Upload`` scalar, parses with GDAL, transforms to
 * WGS84 and stores a MultiPolygon on ``Zone.boundary``. Office-only,
 * company-scoped; no module flag.
 */
export type ImportZoneBoundary = {
  __typename: 'ImportZoneBoundary';
  zone?: Maybe<ZoneDef>;
};

export type ImportedKmdEasyFileDef = Node & {
  __typename: 'ImportedKmdEasyFileDef';
  company: CompanyType;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  error: Scalars['String']['output'];
  errorRows?: Maybe<Scalars['Int']['output']>;
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  fileType: KmdEasyImportedKmdEasyFileFileTypeChoices;
  fileUrl?: Maybe<Scalars['String']['output']>;
  ftpDownloadedAt?: Maybe<Scalars['DateTime']['output']>;
  ftpDownloadedFromPath: Scalars['String']['output'];
  ftpSourceDeleted: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importedBy: UserType;
  isFtpDownloaded?: Maybe<Scalars['Boolean']['output']>;
  kmdEasyFu51008FileLines: Fu51008FileLineDefConnection;
  kmdEasyTotalFileFu51007FileLines: Fu51007FileLineDefConnection;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  project: ProjectType;
  status: KmdEasyImportedKmdEasyFileStatusChoices;
  totalRows?: Maybe<Scalars['Int']['output']>;
};


export type ImportedKmdEasyFileDefKmdEasyFu51008FileLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ImportedKmdEasyFileDefKmdEasyTotalFileFu51007FileLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportedKmdEasyFileDefConnection = {
  __typename: 'ImportedKmdEasyFileDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ImportedKmdEasyFileDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ImportedKmdEasyFileDef` and its cursor. */
export type ImportedKmdEasyFileDefEdge = {
  __typename: 'ImportedKmdEasyFileDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ImportedKmdEasyFileDef>;
};

/**
 * One row of the managed jttj/toiminta waste-activity catalogue (PD-50):
 * "Toiminta, jossa jäte on syntynyt" — the activity in which the waste
 * arises. Rows are seed-owned (no create/edit anywhere); tenants may only
 * deactivate codes.
 */
export type IndustryCodeDef = Node & {
  __typename: 'IndustryCodeDef';
  code: Scalars['String']['output'];
  company: CompanyType;
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  labelEn: Scalars['String']['output'];
  requiresSpecification: Scalars['Boolean']['output'];
  scheme: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type IndustryCodeDefConnection = {
  __typename: 'IndustryCodeDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IndustryCodeDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `IndustryCodeDef` and its cursor. */
export type IndustryCodeDefEdge = {
  __typename: 'IndustryCodeDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<IndustryCodeDef>;
};

export type IngestExternalConfirmationsInput = {
  events: Array<ExternalConfirmationInput>;
  /** Optional integrity echo: reject the batch unless it holds exactly this many events. */
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  /** Vendor key — "botek", "urbaser", "hsy-lift-reader". Scopes the idempotency key together with the company. */
  sourceSystem: Scalars['String']['input'];
};

/**
 * Counts partition the batch: ``receivedCount`` = duplicateCount +
 * appliedCount + alreadyCompletedCount + unmatchedCount + rejectedCount.
 * Duplicates are counted ONLY as duplicates — a replay performed no action,
 * so it must not inflate ``appliedCount``.
 */
export type IngestExternalConfirmationsPayload = {
  __typename: 'IngestExternalConfirmationsPayload';
  alreadyCompletedCount: Scalars['Int']['output'];
  appliedCount: Scalars['Int']['output'];
  duplicateCount: Scalars['Int']['output'];
  receivedCount: Scalars['Int']['output'];
  rejectedCount: Scalars['Int']['output'];
  results: Array<ExternalConfirmationResultType>;
  unmatchedCount: Scalars['Int']['output'];
};

/** Deliver ONE weighing. Idempotent on (system, externalId). */
export type IngestWeighTicket = {
  __typename: 'IngestWeighTicket';
  /** False when this externalId was already stored — the idempotent no-op. The stored ticket comes back unchanged. */
  created?: Maybe<Scalars['Boolean']['output']>;
  /** True when the weighing was attached to an open unloading stop and that stop's weight provenance was stamped. The stop is left PENDING either way — the driver confirms it. */
  matched?: Maybe<Scalars['Boolean']['output']>;
  /** Order id of the stop it attached to, when matched. */
  matchedOrderId?: Maybe<Scalars['String']['output']>;
  /** Machine-readable outcome: vehicle_session | explicit_order | manual | duplicate | no_identifier | no_vehicle_session | no_open_unloading_stop. */
  reason?: Maybe<Scalars['String']['output']>;
  weighTicket?: Maybe<WeighTicketType>;
};

/**
 * Deliver a BATCH of weighings — a nightly or reconnect catch-up.
 *
 * One savepoint per ticket, so a single malformed slip cannot roll back the
 * other 999. Per-ticket outcomes come back in ``results``, the same shape
 * ``syncOfflineOperations`` uses and for the same reason: a caller that
 * cannot tell which item failed has to retry the whole batch, and with an
 * idempotent key that is safe but wasteful.
 */
export type IngestWeighTickets = {
  __typename: 'IngestWeighTickets';
  acceptedCount?: Maybe<Scalars['Int']['output']>;
  matchedCount?: Maybe<Scalars['Int']['output']>;
  rejectedCount?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<WeighTicketResult>>;
};

export type InsightsAiStatusType = {
  __typename: 'InsightsAiStatusType';
  available: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type InsightsFilterValueType = {
  __typename: 'InsightsFilterValueType';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * Values for one dashboard-builder board filter. ``truncated`` is set
 * when more values matched than were returned (narrow with ``search``).
 */
export type InsightsFilterValuesResult = {
  __typename: 'InsightsFilterValuesResult';
  error?: Maybe<Scalars['String']['output']>;
  truncated: Scalars['Boolean']['output'];
  values: Array<InsightsFilterValueType>;
};

/**
 * Create a new draft Flow (and its version 1) from one starter-gallery
 * template (AP-404).
 *
 * Pre-binds the template's `ticket_type_ref` to this tenant's own
 * `TicketType` when a case-insensitive name match exists (`mappable=True`,
 * the rendered definition's trigger filter carries the tenant's exact
 * spelling); otherwise the filter keeps the catalog's canonical placeholder
 * name and `mappable=False` -- the flow still instantiates as a draft
 * either way (04_BACKLOG.md AP-404 AC: "pre-bound ... where mappable", not
 * "only where mappable").
 *
 * Runs the same registry-aware validator `UpdateAutopilotFlowDefinition`
 * does (`autopilot.builder.validator.validate_for_builder`) before writing
 * anything: an invalid rendered definition (a catalog authoring bug) creates
 * no `Flow` row at all. `warnings` carries the same non-fatal autonomy-class
 * advisories (money/mass_comms/bulk steps).
 */
export type InstantiateAutopilotPlaybook = {
  __typename: 'InstantiateAutopilotPlaybook';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  flow?: Maybe<FlowType>;
  mappable?: Maybe<Scalars['Boolean']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type IntegrationGpsType = Node & {
  __typename: 'IntegrationGpsType';
  active: Scalars['Boolean']['output'];
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  integrationgpsvehicleSet: IntegrationGpsVehicleTypeConnection;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  updateFrequency: Scalars['Int']['output'];
  username?: Maybe<Scalars['String']['output']>;
};


export type IntegrationGpsTypeIntegrationgpsvehicleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationGpsTypeConnection = {
  __typename: 'IntegrationGpsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IntegrationGpsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `IntegrationGpsType` and its cursor. */
export type IntegrationGpsTypeEdge = {
  __typename: 'IntegrationGpsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<IntegrationGpsType>;
};

export type IntegrationGpsVehicleType = Node & {
  __typename: 'IntegrationGpsVehicleType';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  integration: IntegrationGpsType;
  uniqueId: Scalars['String']['output'];
  vehicle: VehicleType;
};

export type IntegrationGpsVehicleTypeConnection = {
  __typename: 'IntegrationGpsVehicleTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IntegrationGpsVehicleTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `IntegrationGpsVehicleType` and its cursor. */
export type IntegrationGpsVehicleTypeEdge = {
  __typename: 'IntegrationGpsVehicleTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<IntegrationGpsVehicleType>;
};

export type IntegrationUrbaserAgreementsSyncDef = Node & {
  __typename: 'IntegrationUrbaserAgreementsSyncDef';
  completetAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  urbaserCredentials: UrbaserCredentialsDef;
};

export type IntegrationUrbaserAgreementsSyncDefConnection = {
  __typename: 'IntegrationUrbaserAgreementsSyncDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IntegrationUrbaserAgreementsSyncDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `IntegrationUrbaserAgreementsSyncDef` and its cursor. */
export type IntegrationUrbaserAgreementsSyncDefEdge = {
  __typename: 'IntegrationUrbaserAgreementsSyncDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<IntegrationUrbaserAgreementsSyncDef>;
};

export type IntegrationUrbaserCallResponseHistoryAgreementDef = Node & {
  __typename: 'IntegrationUrbaserCallResponseHistoryAgreementDef';
  agreement?: Maybe<AgreementDef>;
  data?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  integrationUrbaserCallResponseHistory: IntegrationUrbaserCallResponseHistoryDef;
};

export type IntegrationUrbaserCallResponseHistoryAgreementDefConnection = {
  __typename: 'IntegrationUrbaserCallResponseHistoryAgreementDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IntegrationUrbaserCallResponseHistoryAgreementDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `IntegrationUrbaserCallResponseHistoryAgreementDef` and its cursor. */
export type IntegrationUrbaserCallResponseHistoryAgreementDefEdge = {
  __typename: 'IntegrationUrbaserCallResponseHistoryAgreementDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<IntegrationUrbaserCallResponseHistoryAgreementDef>;
};

export type IntegrationUrbaserCallResponseHistoryDataDef = {
  __typename: 'IntegrationUrbaserCallResponseHistoryDataDef';
  body: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type IntegrationUrbaserCallResponseHistoryDef = Node & {
  __typename: 'IntegrationUrbaserCallResponseHistoryDef';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credentials: UrbaserCredentialsDef;
  data?: Maybe<IntegrationUrbaserCallResponseHistoryDataDef>;
  errorAt?: Maybe<Scalars['DateTime']['output']>;
  errors: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  integrationUrbaserCallResponseHistoryAgreements: IntegrationUrbaserCallResponseHistoryAgreementDefConnection;
  method: Scalars['String']['output'];
  processingErrors?: Maybe<Scalars['String']['output']>;
  processingErrorsAt?: Maybe<Scalars['DateTime']['output']>;
  response?: Maybe<IntegrationUrbaserCallResponseHistoryResponseDef>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};


export type IntegrationUrbaserCallResponseHistoryDefIntegrationUrbaserCallResponseHistoryAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationUrbaserCallResponseHistoryDefConnection = {
  __typename: 'IntegrationUrbaserCallResponseHistoryDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IntegrationUrbaserCallResponseHistoryDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `IntegrationUrbaserCallResponseHistoryDef` and its cursor. */
export type IntegrationUrbaserCallResponseHistoryDefEdge = {
  __typename: 'IntegrationUrbaserCallResponseHistoryDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<IntegrationUrbaserCallResponseHistoryDef>;
};

export type IntegrationUrbaserCallResponseHistoryResponseDef = {
  __typename: 'IntegrationUrbaserCallResponseHistoryResponseDef';
  body: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

/** An enumeration. */
export enum IntegrationsExternalCollectionEventStatusChoices {
  /** Already completed */
  ALREADY_COMPLETED = 'ALREADY_COMPLETED',
  /** Applied */
  APPLIED = 'APPLIED',
  /** Received */
  RECEIVED = 'RECEIVED',
  /** Rejected */
  REJECTED = 'REJECTED',
  /** Unmatched */
  UNMATCHED = 'UNMATCHED'
}

/** An enumeration. */
export enum IntegrationsExternalCollectionEventTagTypeChoices {
  /** NFC */
  NFC = 'NFC',
  /** Other / unstated */
  OTHER = 'OTHER',
  /** RFID */
  RFID = 'RFID'
}

/** An enumeration. */
export enum IntegrationsRfidVehicleConnectionProtocolChoices {
  /** FTP */
  FTP = 'FTP',
  /** MODBUS */
  MODBUS = 'MODBUS',
  /** SSH */
  SSH = 'SSH'
}

/** An enumeration. */
export enum IntegrationsRfidVehicleConnectionProviderChoices {
  /** Botek */
  BOTEK = 'BOTEK',
  /** Poultarp */
  POULTARP = 'POULTARP',
  /** Sweco */
  SWECO = 'SWECO'
}

export type InternalUpdateOrCreateSalesOfferInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  createdBy: Scalars['ID']['input'];
  currency: Scalars['String']['input'];
  endAt?: InputMaybe<Scalars['Date']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  introductionDescription: Scalars['String']['input'];
  introductionImage?: InputMaybe<Scalars['String']['input']>;
  introductionTitle: Scalars['String']['input'];
  language: Scalars['String']['input'];
  logoImage?: InputMaybe<Scalars['String']['input']>;
  pages?: InputMaybe<Array<InputMaybe<SalesOfferPageMultipleChoiceFieldInput>>>;
  planDescription: Scalars['String']['input'];
  planImage?: InputMaybe<Scalars['String']['input']>;
  planTitle: Scalars['String']['input'];
  products?: InputMaybe<Array<InputMaybe<SalesOfferProductMultipleChoiceFieldInput>>>;
  recipientName: Scalars['String']['input'];
  recipientTitle: Scalars['String']['input'];
  recurringInterval: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  services?: InputMaybe<Array<InputMaybe<SalesOfferServiceMultipleChoiceFieldInput>>>;
  showNotIncludedProducts?: InputMaybe<Scalars['Boolean']['input']>;
  showPrices?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
  termsDescription: Scalars['String']['input'];
  termsImage?: InputMaybe<Scalars['String']['input']>;
  termsTitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type InternalUpdateOrCreateSalesOfferPayload = {
  __typename: 'InternalUpdateOrCreateSalesOfferPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  salesOffer?: Maybe<SalesOfferType>;
};

/** An enumeration. */
export enum InventoryStockAlertLevelChoices {
  /** Log */
  LOW = 'LOW',
  /** Out of stock */
  OUT_OF_STOCK = 'OUT_OF_STOCK'
}

export type InviteUsers = {
  __typename: 'InviteUsers';
  users?: Maybe<Array<Maybe<UserType>>>;
};

export type InvoiceDef = Node & {
  __typename: 'InvoiceDef';
  accountAddress: Scalars['String']['output'];
  accountName: Scalars['String']['output'];
  accountTaxId: Scalars['String']['output'];
  agreement?: Maybe<AgreementDef>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  billingRun?: Maybe<BillingRunDef>;
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customerAddress: Scalars['String']['output'];
  customerEmail: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  /** Customer number of the payer (Contact.contact_number). Populated on vismaExportLog.invoices; null elsewhere or when no payer could be resolved. */
  customerNumber?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  invoiceItems: InvoiceItemDefConnection;
  invoiceNumber: Scalars['String']['output'];
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod?: Maybe<PaymentMethodDef>;
  periodEnd?: Maybe<Scalars['Date']['output']>;
  periodStart?: Maybe<Scalars['Date']['output']>;
  property?: Maybe<PropertyDef>;
  /** Invoicing frequency set on the invoice's property (MONTHLY / SEMI_ANNUALLY). Populated on vismaExportLog.invoices; null elsewhere or when the property has none. */
  propertySyncFrequency?: Maybe<Scalars['String']['output']>;
  propertyUser?: Maybe<PropertyUserDef>;
  status: CrmInvoiceStatusChoices;
  subtotal: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  ticket?: Maybe<TicketDef>;
  total: Scalars['Int']['output'];
  vismaExportError: Scalars['String']['output'];
  vismaExportLog?: Maybe<VismaExportLogType>;
  vismaExportedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type InvoiceDefInvoiceItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type InvoiceDefConnection = {
  __typename: 'InvoiceDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InvoiceDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `InvoiceDef` and its cursor. */
export type InvoiceDefEdge = {
  __typename: 'InvoiceDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<InvoiceDef>;
};

export type InvoiceItemDef = Node & {
  __typename: 'InvoiceItemDef';
  agreement?: Maybe<AgreementDef>;
  amount: Scalars['Int']['output'];
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  ignoreDuringBilling: Scalars['Boolean']['output'];
  invoice?: Maybe<InvoiceDef>;
  invoiceCode: Scalars['String']['output'];
  lineTotal: Scalars['Int']['output'];
  metaData: Scalars['JSONString']['output'];
  migratedFromId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  periodEnd?: Maybe<Scalars['Date']['output']>;
  periodStart?: Maybe<Scalars['Date']['output']>;
  property?: Maybe<PropertyDef>;
  quantity: Scalars['Float']['output'];
  taxAmount: Scalars['Int']['output'];
  ticket?: Maybe<TicketDef>;
  yearlyPrice?: Maybe<Scalars['Decimal']['output']>;
  yearlyPriceTaxAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type InvoiceItemDefConnection = {
  __typename: 'InvoiceItemDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InvoiceItemDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `InvoiceItemDef` and its cursor. */
export type InvoiceItemDefEdge = {
  __typename: 'InvoiceItemDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<InvoiceItemDef>;
};

/**
 * Cadence at which a property's invoices are pushed to the external
 *     accounting/ERP system (currently Visma).
 */
export enum InvoiceSyncFrequency {
  MONTHLY = 'MONTHLY',
  SEMI_ANNUALLY = 'SEMI_ANNUALLY',
  YEARLY = 'YEARLY'
}

/** An enumeration. */
export enum InvoicingBillingScheduleAnchorChoices {
  /** Agreement start */
  AGREEMENT_START = 'AGREEMENT_START',
  /** Calendar */
  CALENDAR = 'CALENDAR'
}

export type IoUserIsActiveType = {
  __typename: 'IoUserIsActiveType';
  hasCompany?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  useSso?: Maybe<Scalars['Boolean']['output']>;
};

export type IsDriverType = {
  __typename: 'IsDriverType';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

/**
 * Dispatch one rented unit (PRO-271): write the -1 ISSUE
 * serialization row against the container, moving the unit COMMITTED ->
 * DISPATCHED (``inventory.services.rental.issue_rental``). A scanned or
 * provided ``containerId`` names the physical unit; omit it to let the
 * service resurrect a dormant identity for the pool. Idempotent per
 * ticket. Returns the dispatched container's public id.
 */
export type IssueRental = {
  __typename: 'IssueRental';
  containerId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type JobNotificationEventUnion = BulkActionProgressDef | ContainerBarcodeGenerationHistoryDef | ExportHistoryDef | ImportHistoryDef;

export type JobTitleType = Node & {
  __typename: 'JobTitleType';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  pendingTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  user?: Maybe<UserType>;
};

/** Another table joined to a plan's (plan_schema.JoinSpec). */
export type JoinInput = {
  alias: Scalars['String']['input'];
  entity: Scalars['String']['input'];
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  on: Array<JoinKeyInput>;
  strategy?: InputMaybe<Scalars['String']['input']>;
};

/** A pair of columns a join matches (plan_schema.JoinKey). */
export type JoinKeyInput = {
  left: Scalars['String']['input'];
  right: Scalars['String']['input'];
};

/** A company's key-type library entry (mirrors SparePartType). */
export type KeyTypeType = Node & {
  __typename: 'KeyTypeType';
  active?: Maybe<Scalars['Boolean']['output']>;
  billable: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Whether keys of this type require a refundable deposit at handover. */
  deposit: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  instructions: Scalars['String']['output'];
  /** Part of the canonical, system-seeded library. */
  isSystemSeeded: Scalars['Boolean']['output'];
  /** Fee product for chargeable key types; its price is the handover fee billed by the key-order ticket. */
  linkedProduct?: Maybe<ProductDef>;
  name: Scalars['String']['output'];
};

export type KeyTypeTypeConnection = {
  __typename: 'KeyTypeTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<KeyTypeTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `KeyTypeType` and its cursor. */
export type KeyTypeTypeEdge = {
  __typename: 'KeyTypeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<KeyTypeType>;
};

/**
 * Safety backbone slice #1: stop one bad live flow, right now, without
 * touching every other tenant/flow the way the global `AUTOPILOT_KILL_ALL`
 * switch (`autopilot.flags`) does.
 *
 * Sets `Flow.killed = True` and writes a mandatory-reason
 * `FlowAuditLogEntry(action=KILLED)` (CLAUDE.md rule 5). `killed` is
 * checked at the live chokepoint
 * (`autopilot.runtime.trigger_intake.match_live_flows`) independent of
 * `state` -- a killed flow stops firing on its very next matching event,
 * regardless of whether it is currently `live` or `shadow` -- and,
 * defense-in-depth, `Flow.promote_to` refuses to promote/activate a
 * killed flow at all (see that method's docstring): the only way back is
 * the explicit, also-audited `unkillAutopilotFlow` below.
 *
 * `reason` is required (not merely encouraged): an operator killing a
 * live flow is a safety-critical action and the audit trail must always
 * say why, not rely on the actor remembering to fill it in.
 */
export type KillAutopilotFlow = {
  __typename: 'KillAutopilotFlow';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  flow?: Maybe<FlowType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type KmdEasyCompanySettingsDef = Node & {
  __typename: 'KmdEasyCompanySettingsDef';
  autoExportGenerationEnabled: Scalars['Boolean']['output'];
  autoGenerateFu63302cEnabled: Scalars['Boolean']['output'];
  autoGenerateFu63302cIntervalMinutes: Scalars['Int']['output'];
  autoGenerateFu63303cEnabled: Scalars['Boolean']['output'];
  autoGenerateFu63303cIntervalMinutes: Scalars['Int']['output'];
  company: CompanyType;
  consumptionCode: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultPropertyType?: Maybe<PropertyTypeDef>;
  emptyingAddressIdName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  ftpCleanupExportedFilesDays: Scalars['Int']['output'];
  ftpCleanupImportedFiles: Scalars['Boolean']['output'];
  ftpEnabled: Scalars['Boolean']['output'];
  ftpExportDirectory: Scalars['String']['output'];
  ftpExportEnabled: Scalars['Boolean']['output'];
  ftpHost: Scalars['String']['output'];
  ftpImportCheckIntervalMinutes: Scalars['Int']['output'];
  ftpImportDirectory: Scalars['String']['output'];
  ftpImportEnabled: Scalars['Boolean']['output'];
  ftpPassiveMode: Scalars['Boolean']['output'];
  ftpPassword: Scalars['String']['output'];
  ftpPort: Scalars['Int']['output'];
  /** SSH private key file for SFTP authentication */
  ftpPrivateKeyFile?: Maybe<Scalars['String']['output']>;
  ftpProtocol: KmdEasyKmdEasyCompanySettingsFtpProtocolChoices;
  ftpProtocolDisplay?: Maybe<Scalars['String']['output']>;
  ftpUseTls: Scalars['Boolean']['output'];
  ftpUsername: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  kmdEasyDeltaFiles: KmdEasyDeltaFileDefConnection;
  kmdEasyTotalFiles: KmdEasyTotalFileDefConnection;
  language: Scalars['String']['output'];
};


export type KmdEasyCompanySettingsDefKmdEasyDeltaFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type KmdEasyCompanySettingsDefKmdEasyTotalFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type KmdEasyCompanySettingsDefConnection = {
  __typename: 'KmdEasyCompanySettingsDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<KmdEasyCompanySettingsDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `KmdEasyCompanySettingsDef` and its cursor. */
export type KmdEasyCompanySettingsDefEdge = {
  __typename: 'KmdEasyCompanySettingsDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<KmdEasyCompanySettingsDef>;
};

export type KmdEasyDeltaFileDef = Node & {
  __typename: 'KmdEasyDeltaFileDef';
  company: CompanyType;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  fileType: KmdEasyKmdEasyDeltaFileFileTypeChoices;
  fileUrl?: Maybe<Scalars['String']['output']>;
  ftpUploadAttempts: Scalars['Int']['output'];
  ftpUploadError: Scalars['String']['output'];
  ftpUploadPath: Scalars['String']['output'];
  ftpUploadStatus: KmdEasyKmdEasyDeltaFileFtpUploadStatusChoices;
  ftpUploadStatusDisplay?: Maybe<Scalars['String']['output']>;
  ftpUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  generatedBy: UserType;
  generationMode: KmdEasyKmdEasyDeltaFileGenerationModeChoices;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  inProgressAt?: Maybe<Scalars['DateTime']['output']>;
  kmdEasyCompanySettings: KmdEasyCompanySettingsDef;
  kmdEasyDeltaFileFu63302FileLines: KmdEasyFileFu63302FileLineDefConnection;
  kmdEasyDeltaFileFu63303FileLines: KmdEasyFileFu63303FileLineDefConnection;
  kmdEasyNewTotalFile?: Maybe<KmdEasyTotalFileDef>;
  kmdEasyOldTotalFile?: Maybe<KmdEasyTotalFileDef>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  rowsContainingErrorsCount?: Maybe<Scalars['Int']['output']>;
  status: KmdEasyKmdEasyDeltaFileStatusChoices;
};


export type KmdEasyDeltaFileDefKmdEasyDeltaFileFu63302FileLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type KmdEasyDeltaFileDefKmdEasyDeltaFileFu63303FileLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type KmdEasyDeltaFileDefConnection = {
  __typename: 'KmdEasyDeltaFileDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<KmdEasyDeltaFileDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `KmdEasyDeltaFileDef` and its cursor. */
export type KmdEasyDeltaFileDefEdge = {
  __typename: 'KmdEasyDeltaFileDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<KmdEasyDeltaFileDef>;
};

/** An enumeration. */
export enum KmdEasyExportFileType {
  FU63302_C = 'FU63302C',
  FU63303_C = 'FU63303C',
  UNKNOWN = 'UNKNOWN'
}

/** An enumeration. */
export enum KmdEasyExportFileTypeEnum {
  FU63302_C = 'FU63302C',
  FU63303_C = 'FU63303C',
  UNKNOWN = 'UNKNOWN'
}

/** An enumeration. */
export enum KmdEasyFu51007FileLineTypeFieldChoices {
  /** R3 */
  R3 = 'R3'
}

export type KmdEasyFileFu63302FileLineDef = Node & {
  __typename: 'KmdEasyFileFu63302FileLineDef';
  billingDateField?: Maybe<Scalars['Date']['output']>;
  consumptionCodeField: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deltaFile?: Maybe<KmdEasyDeltaFileDef>;
  deltaFileId?: Maybe<KmdEasyDeltaFileDef>;
  descriptionField: Scalars['String']['output'];
  emptyingAddressIdField?: Maybe<Scalars['Int']['output']>;
  errorAt?: Maybe<Scalars['Date']['output']>;
  errors?: Maybe<Fu63302FileLineErrorDefConnection>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  invoiceCodeField?: Maybe<Scalars['Int']['output']>;
  jornalNumberField?: Maybe<Scalars['Int']['output']>;
  kmdEasyFu63302FileLineErrors: Fu63302FileLineErrorDefConnection;
  kmdMunicipalityCodeField?: Maybe<Scalars['Int']['output']>;
  pricePerUnitField?: Maybe<Scalars['Int']['output']>;
  quantityField?: Maybe<Scalars['Int']['output']>;
  rowNumberForDeltaFile?: Maybe<Scalars['Int']['output']>;
  rowNumberForTotalFile?: Maybe<Scalars['Int']['output']>;
  serviceBillingTypeField: Scalars['String']['output'];
  stationField?: Maybe<Scalars['Int']['output']>;
  ticket?: Maybe<TicketDef>;
  totalFile: KmdEasyTotalFileDef;
  totalFileId?: Maybe<KmdEasyTotalFileDef>;
  typeField: KmdEasyKmdEasyFileFu63302FileLineTypeFieldChoices;
  vatTypeField: Scalars['String']['output'];
};


export type KmdEasyFileFu63302FileLineDefErrorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deltaFileId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  errorField?: InputMaybe<Scalars['String']['input']>;
  fileLineId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type KmdEasyFileFu63302FileLineDefKmdEasyFu63302FileLineErrorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type KmdEasyFileFu63302FileLineDefConnection = {
  __typename: 'KmdEasyFileFu63302FileLineDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<KmdEasyFileFu63302FileLineDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `KmdEasyFileFu63302FileLineDef` and its cursor. */
export type KmdEasyFileFu63302FileLineDefEdge = {
  __typename: 'KmdEasyFileFu63302FileLineDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<KmdEasyFileFu63302FileLineDef>;
};

export type KmdEasyFileFu63303FileLineDef = Node & {
  __typename: 'KmdEasyFileFu63303FileLineDef';
  agreement?: Maybe<AgreementDef>;
  consumptionCodeField: Scalars['Int']['output'];
  containerIdField?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deltaFile?: Maybe<KmdEasyDeltaFileDef>;
  emptyingAddressIdField: Scalars['Int']['output'];
  endDateField?: Maybe<Scalars['Date']['output']>;
  errorAt?: Maybe<Scalars['DateTime']['output']>;
  errors?: Maybe<Fu63303FileLineErrorDefConnection>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  installationIdField?: Maybe<Scalars['Int']['output']>;
  invoiceCodeField?: Maybe<Scalars['Int']['output']>;
  kmdEasyFu63303FileLineErrors: Fu63303FileLineErrorDefConnection;
  kmdMunicipalityCodeField?: Maybe<Scalars['Int']['output']>;
  quantityField: Scalars['Int']['output'];
  rowNumberForDeltaFile?: Maybe<Scalars['Int']['output']>;
  rowNumberForTotalFile?: Maybe<Scalars['Int']['output']>;
  startDateField?: Maybe<Scalars['Date']['output']>;
  totalFile?: Maybe<KmdEasyTotalFileDef>;
  typeField: KmdEasyKmdEasyFileFu63303FileLineTypeFieldChoices;
};


export type KmdEasyFileFu63303FileLineDefErrorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deltaFileId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  errorField?: InputMaybe<Scalars['String']['input']>;
  fileLineId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type KmdEasyFileFu63303FileLineDefKmdEasyFu63303FileLineErrorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type KmdEasyFileFu63303FileLineDefConnection = {
  __typename: 'KmdEasyFileFu63303FileLineDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<KmdEasyFileFu63303FileLineDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `KmdEasyFileFu63303FileLineDef` and its cursor. */
export type KmdEasyFileFu63303FileLineDefEdge = {
  __typename: 'KmdEasyFileFu63303FileLineDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<KmdEasyFileFu63303FileLineDef>;
};

/** An enumeration. */
export enum KmdEasyFu51007FileLineErrorErrorFieldChoices {
  /** Account Number Error */
  ACCOUNT_NUMBER_ERROR = 'ACCOUNT_NUMBER_ERROR',
  /** Alternative Place Id Error */
  ALTERNATIVE_PLACE_ID = 'ALTERNATIVE_PLACE_ID',
  /** Amount Of Units Error */
  AMOUNT_OF_UNITS = 'AMOUNT_OF_UNITS',
  /** Billing Group Number Error */
  BILLING_GROUP_NUMBER_ERROR = 'BILLING_GROUP_NUMBER_ERROR',
  /** Billing Group Type Error */
  BILLING_GROUP_TYPE_ERROR = 'BILLING_GROUP_TYPE_ERROR',
  /** Billing Group Type Text Error */
  BILLING_GROUP_TYPE_TEXT_ERROR = 'BILLING_GROUP_TYPE_TEXT_ERROR',
  /** Client Address Error */
  CLIENT_ADDRESS_ERROR = 'CLIENT_ADDRESS_ERROR',
  /** Client City Name Error */
  CLIENT_CITY_NAME_ERROR = 'CLIENT_CITY_NAME_ERROR',
  /** Client Co Name Error */
  CLIENT_CO_NAME_ERROR = 'CLIENT_CO_NAME_ERROR',
  /** Client Id Ent Error */
  CLIENT_ID_ENT_ERROR = 'CLIENT_ID_ENT_ERROR',
  /** Client Id Error */
  CLIENT_ID_ERROR = 'CLIENT_ID_ERROR',
  /** Client Name Error */
  CLIENT_NAME_ERROR = 'CLIENT_NAME_ERROR',
  /** Client Number Error */
  CLIENT_NUMBER_ERROR = 'CLIENT_NUMBER_ERROR',
  /** Client Number Of Adults Error */
  CLIENT_NUMBER_OF_ADULTS_ERROR = 'CLIENT_NUMBER_OF_ADULTS_ERROR',
  /** Client Number Of Kids Error */
  CLIENT_NUMBER_OF_KIDS_ERROR = 'CLIENT_NUMBER_OF_KIDS_ERROR',
  /** Client Number Of Young Error */
  CLIENT_NUMBER_OF_YOUNG_ERROR = 'CLIENT_NUMBER_OF_YOUNG_ERROR',
  /** Client Postal District Error */
  CLIENT_POSTAL_DISTRICT_ERROR = 'CLIENT_POSTAL_DISTRICT_ERROR',
  /** Consumption Code Id Error */
  CONSUMPTION_CODE_ID = 'CONSUMPTION_CODE_ID',
  /** Consumption Place Id Error */
  CONSUMPTION_PLACE_ID = 'CONSUMPTION_PLACE_ID',
  /** Consumption Place Id Ent Error */
  CONSUMPTION_PLACE_ID_ENT_ERROR = 'CONSUMPTION_PLACE_ID_ENT_ERROR',
  /** Consumption Place Latitude Euro Error */
  CONSUMPTION_PLACE_LATITUDE_EURO_ERROR = 'CONSUMPTION_PLACE_LATITUDE_EURO_ERROR',
  /** Consumption Place Latitude Geo Error */
  CONSUMPTION_PLACE_LATITUDE_GEO_ERROR = 'CONSUMPTION_PLACE_LATITUDE_GEO_ERROR',
  /** Consumption Place Longitude Euro Error */
  CONSUMPTION_PLACE_LONGITUDE_EURO_ERROR = 'CONSUMPTION_PLACE_LONGITUDE_EURO_ERROR',
  /** Consumption Place Longitude Geo Error */
  CONSUMPTION_PLACE_LONGITUDE_GEO_ERROR = 'CONSUMPTION_PLACE_LONGITUDE_GEO_ERROR',
  /** Consumption Place Street Name Error */
  CONSUMPTION_PLACE_STREET_NAME_ERROR = 'CONSUMPTION_PLACE_STREET_NAME_ERROR',
  /** Delivered Date Error */
  DELIVERED_DATE = 'DELIVERED_DATE',
  /** Dumping District Deposition Code */
  DUMPING_DISTRICT_DEPOSITION_CODE = 'DUMPING_DISTRICT_DEPOSITION_CODE',
  /** Dumping District Deposition Code Error */
  DUMPING_DISTRICT_DEPOSITION_CODE_ERROR = 'DUMPING_DISTRICT_DEPOSITION_CODE_ERROR',
  /** Dumping District Deposition Text Error */
  DUMPING_DISTRICT_DEPOSITION_TEXT_ERROR = 'DUMPING_DISTRICT_DEPOSITION_TEXT_ERROR',
  /** Emptying Alternative Error */
  EMPTYING_ALTERNATIVE_ERROR = 'EMPTYING_ALTERNATIVE_ERROR',
  /** Emptying Day Error */
  EMPTYING_DAY = 'EMPTYING_DAY',
  /** Emptying Floor Error */
  EMPTYING_FLOOR_ERROR = 'EMPTYING_FLOOR_ERROR',
  /** Emptying House Letter Error */
  EMPTYING_HOUSE_LETTER_ERROR = 'EMPTYING_HOUSE_LETTER_ERROR',
  /** Emptying House Number Error */
  EMPTYING_HOUSE_NUMBER_ERROR = 'EMPTYING_HOUSE_NUMBER_ERROR',
  /** Emptying Latitude Error */
  EMPTYING_LATITUDE_ERROR = 'EMPTYING_LATITUDE_ERROR',
  /** Emptying Longitude Error */
  EMPTYING_LONGITUDE_ERROR = 'EMPTYING_LONGITUDE_ERROR',
  /** Emptying Municipality Number Error */
  EMPTYING_MUNICIPALITY_NUMBER_ERROR = 'EMPTYING_MUNICIPALITY_NUMBER_ERROR',
  /** Emptying Order Day From Error */
  EMPTYING_ORDER_DAY_FROM = 'EMPTYING_ORDER_DAY_FROM',
  /** Emptying Order Day To Error */
  EMPTYING_ORDER_DAY_TO = 'EMPTYING_ORDER_DAY_TO',
  /** Emptying Order Frequency Error */
  EMPTYING_ORDER_FREQUENCY = 'EMPTYING_ORDER_FREQUENCY',
  /** Emptying Order Id Error */
  EMPTYING_ORDER_ID = 'EMPTYING_ORDER_ID',
  /** Emptying Order Note Error */
  EMPTYING_ORDER_NOTE = 'EMPTYING_ORDER_NOTE',
  /** Emptying Order Number Error */
  EMPTYING_ORDER_NUMBER = 'EMPTYING_ORDER_NUMBER',
  /** Emptying Order Text Error */
  EMPTYING_ORDER_TEXT = 'EMPTYING_ORDER_TEXT',
  /** Emptying Order Text Large Error */
  EMPTYING_ORDER_TEXT_LARGE = 'EMPTYING_ORDER_TEXT_LARGE',
  /** Emptying Route Id Error */
  EMPTYING_ROUTE_ID = 'EMPTYING_ROUTE_ID',
  /** Emptying Running Number Error */
  EMPTYING_RUNNING_NUMBER_ERROR = 'EMPTYING_RUNNING_NUMBER_ERROR',
  /** Emptying Side Door Number Error */
  EMPTYING_SIDE_DOOR_NUMBER_ERROR = 'EMPTYING_SIDE_DOOR_NUMBER_ERROR',
  /** Emptying Street Name Error */
  EMPTYING_STREET_NAME_ERROR = 'EMPTYING_STREET_NAME_ERROR',
  /** External Container Brick Number Error */
  EXTERNAL_CONTAINER_BRICK_NUMBER = 'EXTERNAL_CONTAINER_BRICK_NUMBER',
  /** External Container Code Error */
  EXTERNAL_CONTAINER_CODE = 'EXTERNAL_CONTAINER_CODE',
  /** External Container Id Error */
  EXTERNAL_CONTAINER_ID = 'EXTERNAL_CONTAINER_ID',
  /** External Container Id Ent Error */
  EXTERNAL_CONTAINER_ID_ENT = 'EXTERNAL_CONTAINER_ID_ENT',
  /** External Container Number Error */
  EXTERNAL_CONTAINER_NUMBER = 'EXTERNAL_CONTAINER_NUMBER',
  /** External Container Type Id Error */
  EXTERNAL_CONTAINER_TYPE_ID = 'EXTERNAL_CONTAINER_TYPE_ID',
  /** External Container Type Id Text Error */
  EXTERNAL_CONTAINER_TYPE_ID_TEXT = 'EXTERNAL_CONTAINER_TYPE_ID_TEXT',
  /** Extra Info Error */
  EXTRA_INFO = 'EXTRA_INFO',
  /** Failed To Import Contact */
  FAILED_TO_IMPORT_CONTACT = 'FAILED_TO_IMPORT_CONTACT',
  /** Failed To Update Contact */
  FAILED_TO_UPDATE_CONTACT = 'FAILED_TO_UPDATE_CONTACT',
  /** Frequency Text Error */
  FREQUENCY_TEXT = 'FREQUENCY_TEXT',
  /** From Date Error */
  FROM_DATE = 'FROM_DATE',
  /** House Number Error */
  HOUSE_NUMBER_ERROR = 'HOUSE_NUMBER_ERROR',
  /** Install Amount Factor Error */
  INSTALL_AMOUNT_FACTOR = 'INSTALL_AMOUNT_FACTOR',
  /** Install Amount Fraction Error */
  INSTALL_AMOUNT_FRACTION = 'INSTALL_AMOUNT_FRACTION',
  /** Install Amount Id Error */
  INSTALL_AMOUNT_ID = 'INSTALL_AMOUNT_ID',
  /** Install Id Error */
  INSTALL_ID = 'INSTALL_ID',
  /** Install Id Ent Error */
  INSTALL_ID_ENT = 'INSTALL_ID_ENT',
  /** Install Number Error */
  INSTALL_NUMBER = 'INSTALL_NUMBER',
  /** Invoice Code Error */
  INVOICE_CODE = 'INVOICE_CODE',
  /** Invoice Code Group Error */
  INVOICE_CODE_GROUP = 'INVOICE_CODE_GROUP',
  /** Measurement Unit Error */
  MEASUREMENT_UNIT = 'MEASUREMENT_UNIT',
  /** More Than One Recurring Fee On Same Property */
  MORE_THAN_ONE_RECURRING_FEE_ON_SAME_PROPERTY = 'MORE_THAN_ONE_RECURRING_FEE_ON_SAME_PROPERTY',
  /** Move In Date Error */
  MOVE_IN_DATE_ERROR = 'MOVE_IN_DATE_ERROR',
  /** Move Out Date Error */
  MOVE_OUT_DATE = 'MOVE_OUT_DATE',
  /** Multiple Contacts With Same Client Id */
  MULTIPLE_CONTACTS_WITH_SAME_CLIENT_ID = 'MULTIPLE_CONTACTS_WITH_SAME_CLIENT_ID',
  /** Multiple Products With The Same Invoice Code */
  MULTIPLE_PRODUCTS_WITH_THE_SAME_INVOICE_CODE = 'MULTIPLE_PRODUCTS_WITH_THE_SAME_INVOICE_CODE',
  /** Multiple Property Agreements */
  MULTIPLE_PROPERTY_AGREEMENTS = 'MULTIPLE_PROPERTY_AGREEMENTS',
  /** Multiple Property With Same Consumption Place Id */
  MULTIPLE_PROPERTY_WITH_SAME_CONSUMPTION_CODE_ID = 'MULTIPLE_PROPERTY_WITH_SAME_CONSUMPTION_CODE_ID',
  /** Municipality Number Error */
  MUNICIPALITY_NUMBER_ERROR = 'MUNICIPALITY_NUMBER_ERROR',
  /** No Kmd Easy Settings Found For Company */
  NO_KMD_EASY_SETTINGS_FOUND_FOR_COMPANY = 'NO_KMD_EASY_SETTINGS_FOUND_FOR_COMPANY',
  /** No Product With The Given Invoice Code */
  NO_PRODUCT_WITH_THE_GIVEN_INVOICE_CODE = 'NO_PRODUCT_WITH_THE_GIVEN_INVOICE_CODE',
  /** No Property With Consumption Place Id */
  NO_PROPERTY_WITH_CONSUMPTION_PLACE_ID = 'NO_PROPERTY_WITH_CONSUMPTION_PLACE_ID',
  /** Post District Error */
  POST_DISTRICT_ERROR = 'POST_DISTRICT_ERROR',
  /** Post Number Error */
  POST_NUMBER_ERROR = 'POST_NUMBER_ERROR',
  /** Product Name Error */
  PRODUCT_NAME = 'PRODUCT_NAME',
  /** Property Agreement Missing */
  PROPERTY_AGREEMENT_MISSING = 'PROPERTY_AGREEMENT_MISSING',
  /** Property Number Error */
  PROPERTY_NUMBER_ERROR = 'PROPERTY_NUMBER_ERROR',
  /** Read District Number Error */
  READ_DISTRICT_NUMBER_ERROR = 'READ_DISTRICT_NUMBER_ERROR',
  /** Removed Date Error */
  REMOVED_DATE = 'REMOVED_DATE',
  /** Route Number Error */
  ROUTE_NUMBER_ERROR = 'ROUTE_NUMBER_ERROR',
  /** To Date Error */
  TO_DATE = 'TO_DATE',
  /** Type Error */
  TYPE = 'TYPE',
  /** Unable To Import Date From */
  UNABLE_TO_IMPORT_DATE_FROM = 'UNABLE_TO_IMPORT_DATE_FROM',
  /** Unable To Import Date To */
  UNABLE_TO_IMPORT_DATE_TO = 'UNABLE_TO_IMPORT_DATE_TO',
  /** Unknown Error */
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

/** An enumeration. */
export enum KmdEasyFu51008FileLineErrorErrorFieldChoices {
  /** Account Number Error */
  ACCOUNT_NUMBER_ERROR = 'ACCOUNT_NUMBER_ERROR',
  /** Alternative Place Id Error */
  ALTERNATIVE_PLACE_ID = 'ALTERNATIVE_PLACE_ID',
  /** Amount Of Units Error */
  AMOUNT_OF_UNITS = 'AMOUNT_OF_UNITS',
  /** Billing Group Number Error */
  BILLING_GROUP_NUMBER_ERROR = 'BILLING_GROUP_NUMBER_ERROR',
  /** Billing Group Type Error */
  BILLING_GROUP_TYPE_ERROR = 'BILLING_GROUP_TYPE_ERROR',
  /** Billing Group Type Text Error */
  BILLING_GROUP_TYPE_TEXT_ERROR = 'BILLING_GROUP_TYPE_TEXT_ERROR',
  /** Client Address Error */
  CLIENT_ADDRESS_ERROR = 'CLIENT_ADDRESS_ERROR',
  /** Client City Name Error */
  CLIENT_CITY_NAME_ERROR = 'CLIENT_CITY_NAME_ERROR',
  /** Client Co Name Error */
  CLIENT_CO_NAME_ERROR = 'CLIENT_CO_NAME_ERROR',
  /** Client Id Ent Error */
  CLIENT_ID_ENT_ERROR = 'CLIENT_ID_ENT_ERROR',
  /** Client Id Error */
  CLIENT_ID_ERROR = 'CLIENT_ID_ERROR',
  /** Client Name Error */
  CLIENT_NAME_ERROR = 'CLIENT_NAME_ERROR',
  /** Client Number Error */
  CLIENT_NUMBER_ERROR = 'CLIENT_NUMBER_ERROR',
  /** Client Number Of Adults Error */
  CLIENT_NUMBER_OF_ADULTS_ERROR = 'CLIENT_NUMBER_OF_ADULTS_ERROR',
  /** Client Number Of Kids Error */
  CLIENT_NUMBER_OF_KIDS_ERROR = 'CLIENT_NUMBER_OF_KIDS_ERROR',
  /** Client Number Of Young Error */
  CLIENT_NUMBER_OF_YOUNG_ERROR = 'CLIENT_NUMBER_OF_YOUNG_ERROR',
  /** Client Postal District Error */
  CLIENT_POSTAL_DISTRICT_ERROR = 'CLIENT_POSTAL_DISTRICT_ERROR',
  /** Consumption Code Id Error */
  CONSUMPTION_CODE_ID = 'CONSUMPTION_CODE_ID',
  /** Consumption Place Id Error */
  CONSUMPTION_PLACE_ID = 'CONSUMPTION_PLACE_ID',
  /** Consumption Place Id Ent Error */
  CONSUMPTION_PLACE_ID_ENT_ERROR = 'CONSUMPTION_PLACE_ID_ENT_ERROR',
  /** Consumption Place Latitude Euro Error */
  CONSUMPTION_PLACE_LATITUDE_EURO_ERROR = 'CONSUMPTION_PLACE_LATITUDE_EURO_ERROR',
  /** Consumption Place Latitude Geo Error */
  CONSUMPTION_PLACE_LATITUDE_GEO_ERROR = 'CONSUMPTION_PLACE_LATITUDE_GEO_ERROR',
  /** Consumption Place Longitude Euro Error */
  CONSUMPTION_PLACE_LONGITUDE_EURO_ERROR = 'CONSUMPTION_PLACE_LONGITUDE_EURO_ERROR',
  /** Consumption Place Longitude Geo Error */
  CONSUMPTION_PLACE_LONGITUDE_GEO_ERROR = 'CONSUMPTION_PLACE_LONGITUDE_GEO_ERROR',
  /** Consumption Place Street Name Error */
  CONSUMPTION_PLACE_STREET_NAME_ERROR = 'CONSUMPTION_PLACE_STREET_NAME_ERROR',
  /** Delivered Date Error */
  DELIVERED_DATE = 'DELIVERED_DATE',
  /** Dumping District Deposition Code */
  DUMPING_DISTRICT_DEPOSITION_CODE = 'DUMPING_DISTRICT_DEPOSITION_CODE',
  /** Dumping District Deposition Code Error */
  DUMPING_DISTRICT_DEPOSITION_CODE_ERROR = 'DUMPING_DISTRICT_DEPOSITION_CODE_ERROR',
  /** Dumping District Deposition Text Error */
  DUMPING_DISTRICT_DEPOSITION_TEXT_ERROR = 'DUMPING_DISTRICT_DEPOSITION_TEXT_ERROR',
  /** Emptying Alternative Error */
  EMPTYING_ALTERNATIVE_ERROR = 'EMPTYING_ALTERNATIVE_ERROR',
  /** Emptying Day Error */
  EMPTYING_DAY = 'EMPTYING_DAY',
  /** Emptying Floor Error */
  EMPTYING_FLOOR_ERROR = 'EMPTYING_FLOOR_ERROR',
  /** Emptying House Letter Error */
  EMPTYING_HOUSE_LETTER_ERROR = 'EMPTYING_HOUSE_LETTER_ERROR',
  /** Emptying House Number Error */
  EMPTYING_HOUSE_NUMBER_ERROR = 'EMPTYING_HOUSE_NUMBER_ERROR',
  /** Emptying Latitude Error */
  EMPTYING_LATITUDE_ERROR = 'EMPTYING_LATITUDE_ERROR',
  /** Emptying Longitude Error */
  EMPTYING_LONGITUDE_ERROR = 'EMPTYING_LONGITUDE_ERROR',
  /** Emptying Municipality Number Error */
  EMPTYING_MUNICIPALITY_NUMBER_ERROR = 'EMPTYING_MUNICIPALITY_NUMBER_ERROR',
  /** Emptying Order Day From Error */
  EMPTYING_ORDER_DAY_FROM = 'EMPTYING_ORDER_DAY_FROM',
  /** Emptying Order Day To Error */
  EMPTYING_ORDER_DAY_TO = 'EMPTYING_ORDER_DAY_TO',
  /** Emptying Order Frequency Error */
  EMPTYING_ORDER_FREQUENCY = 'EMPTYING_ORDER_FREQUENCY',
  /** Emptying Order Id Error */
  EMPTYING_ORDER_ID = 'EMPTYING_ORDER_ID',
  /** Emptying Order Note Error */
  EMPTYING_ORDER_NOTE = 'EMPTYING_ORDER_NOTE',
  /** Emptying Order Number Error */
  EMPTYING_ORDER_NUMBER = 'EMPTYING_ORDER_NUMBER',
  /** Emptying Order Text Error */
  EMPTYING_ORDER_TEXT = 'EMPTYING_ORDER_TEXT',
  /** Emptying Order Text Large Error */
  EMPTYING_ORDER_TEXT_LARGE = 'EMPTYING_ORDER_TEXT_LARGE',
  /** Emptying Route Id Error */
  EMPTYING_ROUTE_ID = 'EMPTYING_ROUTE_ID',
  /** Emptying Running Number Error */
  EMPTYING_RUNNING_NUMBER_ERROR = 'EMPTYING_RUNNING_NUMBER_ERROR',
  /** Emptying Side Door Number Error */
  EMPTYING_SIDE_DOOR_NUMBER_ERROR = 'EMPTYING_SIDE_DOOR_NUMBER_ERROR',
  /** Emptying Street Name Error */
  EMPTYING_STREET_NAME_ERROR = 'EMPTYING_STREET_NAME_ERROR',
  /** External Container Brick Number Error */
  EXTERNAL_CONTAINER_BRICK_NUMBER = 'EXTERNAL_CONTAINER_BRICK_NUMBER',
  /** External Container Code Error */
  EXTERNAL_CONTAINER_CODE = 'EXTERNAL_CONTAINER_CODE',
  /** External Container Id Error */
  EXTERNAL_CONTAINER_ID = 'EXTERNAL_CONTAINER_ID',
  /** External Container Id Ent Error */
  EXTERNAL_CONTAINER_ID_ENT = 'EXTERNAL_CONTAINER_ID_ENT',
  /** External Container Number Error */
  EXTERNAL_CONTAINER_NUMBER = 'EXTERNAL_CONTAINER_NUMBER',
  /** External Container Type Id Error */
  EXTERNAL_CONTAINER_TYPE_ID = 'EXTERNAL_CONTAINER_TYPE_ID',
  /** External Container Type Id Text Error */
  EXTERNAL_CONTAINER_TYPE_ID_TEXT = 'EXTERNAL_CONTAINER_TYPE_ID_TEXT',
  /** Extra Info Error */
  EXTRA_INFO = 'EXTRA_INFO',
  /** Failed To Import Contact */
  FAILED_TO_IMPORT_CONTACT = 'FAILED_TO_IMPORT_CONTACT',
  /** Failed To Update Contact */
  FAILED_TO_UPDATE_CONTACT = 'FAILED_TO_UPDATE_CONTACT',
  /** Frequency Text Error */
  FREQUENCY_TEXT = 'FREQUENCY_TEXT',
  /** From Date Error */
  FROM_DATE = 'FROM_DATE',
  /** House Number Error */
  HOUSE_NUMBER_ERROR = 'HOUSE_NUMBER_ERROR',
  /** Install Amount Factor Error */
  INSTALL_AMOUNT_FACTOR = 'INSTALL_AMOUNT_FACTOR',
  /** Install Amount Fraction Error */
  INSTALL_AMOUNT_FRACTION = 'INSTALL_AMOUNT_FRACTION',
  /** Install Amount Id Error */
  INSTALL_AMOUNT_ID = 'INSTALL_AMOUNT_ID',
  /** Install Id Error */
  INSTALL_ID = 'INSTALL_ID',
  /** Install Id Ent Error */
  INSTALL_ID_ENT = 'INSTALL_ID_ENT',
  /** Install Number Error */
  INSTALL_NUMBER = 'INSTALL_NUMBER',
  /** Invoice Code Error */
  INVOICE_CODE = 'INVOICE_CODE',
  /** Invoice Code Group Error */
  INVOICE_CODE_GROUP = 'INVOICE_CODE_GROUP',
  /** Measurement Unit Error */
  MEASUREMENT_UNIT = 'MEASUREMENT_UNIT',
  /** More Than One Recurring Fee On Same Property */
  MORE_THAN_ONE_RECURRING_FEE_ON_SAME_PROPERTY = 'MORE_THAN_ONE_RECURRING_FEE_ON_SAME_PROPERTY',
  /** Move In Date Error */
  MOVE_IN_DATE_ERROR = 'MOVE_IN_DATE_ERROR',
  /** Move Out Date Error */
  MOVE_OUT_DATE = 'MOVE_OUT_DATE',
  /** Multiple Contacts With Same Client Id */
  MULTIPLE_CONTACTS_WITH_SAME_CLIENT_ID = 'MULTIPLE_CONTACTS_WITH_SAME_CLIENT_ID',
  /** Multiple Products With The Same Invoice Code */
  MULTIPLE_PRODUCTS_WITH_THE_SAME_INVOICE_CODE = 'MULTIPLE_PRODUCTS_WITH_THE_SAME_INVOICE_CODE',
  /** Multiple Property Agreements */
  MULTIPLE_PROPERTY_AGREEMENTS = 'MULTIPLE_PROPERTY_AGREEMENTS',
  /** Multiple Property With Same Consumption Place Id */
  MULTIPLE_PROPERTY_WITH_SAME_CONSUMPTION_CODE_ID = 'MULTIPLE_PROPERTY_WITH_SAME_CONSUMPTION_CODE_ID',
  /** Municipality Number Error */
  MUNICIPALITY_NUMBER_ERROR = 'MUNICIPALITY_NUMBER_ERROR',
  /** No Kmd Easy Settings Found For Company */
  NO_KMD_EASY_SETTINGS_FOUND_FOR_COMPANY = 'NO_KMD_EASY_SETTINGS_FOUND_FOR_COMPANY',
  /** No Product With The Given Invoice Code */
  NO_PRODUCT_WITH_THE_GIVEN_INVOICE_CODE = 'NO_PRODUCT_WITH_THE_GIVEN_INVOICE_CODE',
  /** No Property With Consumption Place Id */
  NO_PROPERTY_WITH_CONSUMPTION_PLACE_ID = 'NO_PROPERTY_WITH_CONSUMPTION_PLACE_ID',
  /** Post District Error */
  POST_DISTRICT_ERROR = 'POST_DISTRICT_ERROR',
  /** Post Number Error */
  POST_NUMBER_ERROR = 'POST_NUMBER_ERROR',
  /** Product Name Error */
  PRODUCT_NAME = 'PRODUCT_NAME',
  /** Property Agreement Missing */
  PROPERTY_AGREEMENT_MISSING = 'PROPERTY_AGREEMENT_MISSING',
  /** Property Number Error */
  PROPERTY_NUMBER_ERROR = 'PROPERTY_NUMBER_ERROR',
  /** Read District Number Error */
  READ_DISTRICT_NUMBER_ERROR = 'READ_DISTRICT_NUMBER_ERROR',
  /** Removed Date Error */
  REMOVED_DATE = 'REMOVED_DATE',
  /** Route Number Error */
  ROUTE_NUMBER_ERROR = 'ROUTE_NUMBER_ERROR',
  /** To Date Error */
  TO_DATE = 'TO_DATE',
  /** Type Error */
  TYPE = 'TYPE',
  /** Unable To Import Date From */
  UNABLE_TO_IMPORT_DATE_FROM = 'UNABLE_TO_IMPORT_DATE_FROM',
  /** Unable To Import Date To */
  UNABLE_TO_IMPORT_DATE_TO = 'UNABLE_TO_IMPORT_DATE_TO',
  /** Unknown Error */
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

/** An enumeration. */
export enum KmdEasyFu63302FileLineErrorErrorFieldChoices {
  /** Billing Date */
  BILLING_DATE = 'BILLING_DATE',
  /** Consumption Code Validity */
  CONSUMPTION_CODE_VALIDITY = 'CONSUMPTION_CODE_VALIDITY',
  /** Emptying Address Id */
  EMPTYING_ADDRESS_ID = 'EMPTYING_ADDRESS_ID',
  /** Emptying Address Id Validity */
  EMPTYING_ADDRESS_ID_VALIDITY = 'EMPTYING_ADDRESS_ID_VALIDITY',
  /** End Date */
  END_DATE = 'END_DATE',
  /** Invoice Code */
  INVOICE_CODE = 'INVOICE_CODE',
  /** Invoice Code Validity */
  INVOICE_CODE_VALIDITY = 'INVOICE_CODE_VALIDITY',
  /** Journal Number */
  JOURNAL_NUMBER = 'JOURNAL_NUMBER',
  /** Journal Number Validity */
  JOURNAL_NUMBER_VALIDITY = 'JOURNAL_NUMBER_VALIDITY',
  /** Kmd Municipality Code */
  KMD_MUNICIPALITY_CODE = 'KMD_MUNICIPALITY_CODE',
  /** Kmd Municipality Code Validity */
  KMD_MUNICIPALITY_CODE_VALIDITY = 'KMD_MUNICIPALITY_CODE_VALIDITY',
  /** Product Count */
  PRODUCT_COUNT = 'PRODUCT_COUNT',
  /** Quantities */
  QUANTITIES = 'QUANTITIES',
  /** Quantities Validity */
  QUANTITIES_VALIDITY = 'QUANTITIES_VALIDITY',
  /** Start Date */
  START_DATE = 'START_DATE',
  /** Station Code */
  STATION_CODE = 'STATION_CODE',
  /** Station Code Validity */
  STATION_CODE_VALIDITY = 'STATION_CODE_VALIDITY',
  /** Unknown Error */
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

/** An enumeration. */
export enum KmdEasyFu63303FileLineErrorErrorFieldChoices {
  /** Billing Date */
  BILLING_DATE = 'BILLING_DATE',
  /** Consumption Code Validity */
  CONSUMPTION_CODE_VALIDITY = 'CONSUMPTION_CODE_VALIDITY',
  /** Emptying Address Id */
  EMPTYING_ADDRESS_ID = 'EMPTYING_ADDRESS_ID',
  /** Emptying Address Id Validity */
  EMPTYING_ADDRESS_ID_VALIDITY = 'EMPTYING_ADDRESS_ID_VALIDITY',
  /** End Date */
  END_DATE = 'END_DATE',
  /** Invoice Code */
  INVOICE_CODE = 'INVOICE_CODE',
  /** Invoice Code Validity */
  INVOICE_CODE_VALIDITY = 'INVOICE_CODE_VALIDITY',
  /** Journal Number */
  JOURNAL_NUMBER = 'JOURNAL_NUMBER',
  /** Journal Number Validity */
  JOURNAL_NUMBER_VALIDITY = 'JOURNAL_NUMBER_VALIDITY',
  /** Kmd Municipality Code */
  KMD_MUNICIPALITY_CODE = 'KMD_MUNICIPALITY_CODE',
  /** Kmd Municipality Code Validity */
  KMD_MUNICIPALITY_CODE_VALIDITY = 'KMD_MUNICIPALITY_CODE_VALIDITY',
  /** Product Count */
  PRODUCT_COUNT = 'PRODUCT_COUNT',
  /** Quantities */
  QUANTITIES = 'QUANTITIES',
  /** Quantities Validity */
  QUANTITIES_VALIDITY = 'QUANTITIES_VALIDITY',
  /** Start Date */
  START_DATE = 'START_DATE',
  /** Station Code */
  STATION_CODE = 'STATION_CODE',
  /** Station Code Validity */
  STATION_CODE_VALIDITY = 'STATION_CODE_VALIDITY',
  /** Unknown Error */
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

/** An enumeration. */
export enum KmdEasyImportFileTypeEnum {
  FU51007_C = 'FU51007C',
  FU51008_C = 'FU51008C',
  UNKNOWN = 'UNKNOWN'
}

/** An enumeration. */
export enum KmdEasyImportedKmdEasyFileFileTypeChoices {
  /** Fu51007C */
  FU51007_C = 'FU51007C',
  /** Fu51008C */
  FU51008_C = 'FU51008C',
  /** Unknown */
  UNKNOWN = 'UNKNOWN'
}

/** An enumeration. */
export enum KmdEasyImportedKmdEasyFileStatusChoices {
  /** Completed */
  COMPLETED = 'COMPLETED',
  /** Failed */
  FAILED = 'FAILED',
  /** Imported */
  IMPORTED = 'IMPORTED',
  /** Processing */
  PROCESSING = 'PROCESSING'
}

/** An enumeration. */
export enum KmdEasyKmdEasyCompanySettingsFtpProtocolChoices {
  /** FTP */
  FTP = 'FTP',
  /** FTPS (FTP over SSL/TLS) */
  FTPS = 'FTPS',
  /** SFTP (SSH File Transfer) */
  SFTP = 'SFTP'
}

/** An enumeration. */
export enum KmdEasyKmdEasyDeltaFileFileTypeChoices {
  /** Fu63302C */
  FU63302_C = 'FU63302C',
  /** Fu63303C */
  FU63303_C = 'FU63303C',
  /** Unknown */
  UNKNOWN = 'UNKNOWN'
}

/** An enumeration. */
export enum KmdEasyKmdEasyDeltaFileFtpUploadStatusChoices {
  /** Completed */
  COMPLETED = 'COMPLETED',
  /** Failed */
  FAILED = 'FAILED',
  /** In Progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Not Transferred */
  NOT_TRANSFERRED = 'NOT_TRANSFERRED',
  /** Pending */
  PENDING = 'PENDING'
}

/** An enumeration. */
export enum KmdEasyKmdEasyDeltaFileGenerationModeChoices {
  /** Automatic */
  AUTOMATIC = 'AUTOMATIC',
  /** Manual */
  MANUAL = 'MANUAL'
}

/** An enumeration. */
export enum KmdEasyKmdEasyDeltaFileStatusChoices {
  /** Completed */
  COMPLETED = 'COMPLETED',
  /** Created */
  CREATED = 'CREATED',
  /** Failed */
  FAILED = 'FAILED',
  /** In Progress */
  IN_PROGRESS = 'IN_PROGRESS'
}

/** An enumeration. */
export enum KmdEasyKmdEasyFileFu63302FileLineTypeFieldChoices {
  /** R3 */
  R3 = 'R3'
}

/** An enumeration. */
export enum KmdEasyKmdEasyFileFu63303FileLineTypeFieldChoices {
  /** R3 */
  R3 = 'R3'
}

/** An enumeration. */
export enum KmdEasyKmdEasyTotalFileFileTypeChoices {
  /** Fu63302C */
  FU63302_C = 'FU63302C',
  /** Fu63303C */
  FU63303_C = 'FU63303C',
  /** Unknown */
  UNKNOWN = 'UNKNOWN'
}

/** An enumeration. */
export enum KmdEasyKmdEasyTotalFileFtpUploadStatusChoices {
  /** Completed */
  COMPLETED = 'COMPLETED',
  /** Failed */
  FAILED = 'FAILED',
  /** In Progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Not Transferred */
  NOT_TRANSFERRED = 'NOT_TRANSFERRED',
  /** Pending */
  PENDING = 'PENDING'
}

/** An enumeration. */
export enum KmdEasyKmdEasyTotalFileStatusChoices {
  /** Completed */
  COMPLETED = 'COMPLETED',
  /** Created */
  CREATED = 'CREATED',
  /** Failed */
  FAILED = 'FAILED',
  /** In Progress */
  IN_PROGRESS = 'IN_PROGRESS'
}

export type KmdEasyTotalFileDef = Node & {
  __typename: 'KmdEasyTotalFileDef';
  company: CompanyType;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  fileType: KmdEasyKmdEasyTotalFileFileTypeChoices;
  fileUrl?: Maybe<Scalars['String']['output']>;
  ftpUploadAttempts: Scalars['Int']['output'];
  ftpUploadError: Scalars['String']['output'];
  ftpUploadPath: Scalars['String']['output'];
  ftpUploadStatus: KmdEasyKmdEasyTotalFileFtpUploadStatusChoices;
  ftpUploadStatusDisplay?: Maybe<Scalars['String']['output']>;
  ftpUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  generatedBy: UserType;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  inProgressAt?: Maybe<Scalars['DateTime']['output']>;
  kmdEasyCompanySettings: KmdEasyCompanySettingsDef;
  kmdEasyDeltaFileMadeInSameRequest: KmdEasyDeltaFileDefConnection;
  kmdEasyDeltaFileMadeInTheNextRequest: KmdEasyDeltaFileDefConnection;
  kmdEasyTotalFileFu63302FileLines: KmdEasyFileFu63302FileLineDefConnection;
  kmdEasyTotalFileFu63303FileLines: KmdEasyFileFu63303FileLineDefConnection;
  rowCount?: Maybe<Scalars['Int']['output']>;
  rowsContainingErrorsCount?: Maybe<Scalars['Int']['output']>;
  status: KmdEasyKmdEasyTotalFileStatusChoices;
};


export type KmdEasyTotalFileDefKmdEasyDeltaFileMadeInSameRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type KmdEasyTotalFileDefKmdEasyDeltaFileMadeInTheNextRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type KmdEasyTotalFileDefKmdEasyTotalFileFu63302FileLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type KmdEasyTotalFileDefKmdEasyTotalFileFu63303FileLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type KmdEasyTotalFileDefConnection = {
  __typename: 'KmdEasyTotalFileDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<KmdEasyTotalFileDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `KmdEasyTotalFileDef` and its cursor. */
export type KmdEasyTotalFileDefEdge = {
  __typename: 'KmdEasyTotalFileDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<KmdEasyTotalFileDef>;
};

/** Code printed on a container label */
export enum LabelCodeType {
  BARCODE = 'BARCODE',
  QR_CODE = 'QR_CODE'
}

/** A token and its words: a domain key, a template category key. */
export type LabelDef = {
  __typename: 'LabelDef';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** An enumeration. */
export enum LevelChoices {
  ALL = 'ALL',
  ONLY_CRM = 'ONLY_CRM',
  ONLY_TICKETS = 'ONLY_TICKETS'
}

export type LicenseInput = {
  licenseClass: Scalars['String']['input'];
  number: Scalars['String']['input'];
  region: Scalars['String']['input'];
  validFrom: Scalars['Date']['input'];
  validTo: Scalars['Date']['input'];
};

/** Describe Driver's License */
export type LicenseType = Node & {
  __typename: 'LicenseType';
  driver?: Maybe<DriverType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  licenseClass?: Maybe<Scalars['String']['output']>;
  /** License's identifier */
  number: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  validInRange?: Maybe<DateRangeField>;
};

/**
 * Office-only (PRO-120): record that ``successor`` succeeds
 * ``predecessor`` — the renewal link the wizard stores right after
 * creating a renewal area.
 */
export type LinkAreaSuccession = {
  __typename: 'LinkAreaSuccession';
  predecessor?: Maybe<AreaDef>;
  successor?: Maybe<AreaDef>;
};

export type LinkContactToProperty = {
  __typename: 'LinkContactToProperty';
  contactProperty?: Maybe<ContactPropertyDef>;
};

export type LinkContactToPropertyManagementCompany = {
  __typename: 'LinkContactToPropertyManagementCompany';
  propertyManagementCompany?: Maybe<PropertyManagementCompanyDef>;
};

export type LinkManagementCompanyToProperty = {
  __typename: 'LinkManagementCompanyToProperty';
  managementCompanyProperty?: Maybe<ManagementCompanyPropertyDef>;
};

/**
 * REQ-386 slice 5 (kimppakaivo): link a property as a member of another
 * property's shared waste-water tank. Reuses the SCP membership pattern —
 * a date-ranged, PROTECT-guarded membership row (mirrors CreateScpMembership).
 */
export type LinkSharedTankMember = {
  __typename: 'LinkSharedTankMember';
  membership?: Maybe<SharedTankMembershipDef>;
};

export type LiveOperationsDayTotalsDef = {
  __typename: 'LiveOperationsDayTotalsDef';
  completedContainerStops: Scalars['Int']['output'];
  completedRoutes: Scalars['Int']['output'];
  completedStops: Scalars['Int']['output'];
  completedTicketStops: Scalars['Int']['output'];
  containerStops: Scalars['Int']['output'];
  drivenDistanceMeters: Scalars['Float']['output'];
  drivenSeconds: Scalars['Int']['output'];
  estimatedDistanceMeters: Scalars['Float']['output'];
  plannedWorkingSeconds: Scalars['Int']['output'];
  ticketStops: Scalars['Int']['output'];
  totalRoutes: Scalars['Int']['output'];
  totalStops: Scalars['Int']['output'];
};

/**
 * One exception row. Field shape and ids match the feed's
 * ``exceptions`` delta byte-for-byte so the FE Apollo cache merges a
 * live delta onto an initial-load result without a refetch.
 */
export type LiveOperationsExceptionDef = {
  __typename: 'LiveOperationsExceptionDef';
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  detail?: Maybe<Scalars['GenericScalar']['output']>;
  /** Relay id (LiveOpsException) */
  id: Scalars['ID']['output'];
  resolution?: Maybe<Scalars['String']['output']>;
  resolved: Scalars['Boolean']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  routeId?: Maybe<Scalars['ID']['output']>;
  severity: Scalars['String']['output'];
  snoozedUntil?: Maybe<Scalars['DateTime']['output']>;
  stopId?: Maybe<Scalars['ID']['output']>;
  type: Scalars['String']['output'];
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

export type LiveOperationsRouteSummaryDef = {
  __typename: 'LiveOperationsRouteSummaryDef';
  completedContainerStops: Scalars['Int']['output'];
  completedStops: Scalars['Int']['output'];
  completedTicketStops: Scalars['Int']['output'];
  containerStops: Scalars['Int']['output'];
  drivenDistanceMeters: Scalars['Float']['output'];
  drivenSeconds: Scalars['Int']['output'];
  estimatedDistanceMeters: Scalars['Float']['output'];
  /** True while at least one vehicle session on the route is still open. */
  hasActiveSession: Scalars['Boolean']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isStarted: Scalars['Boolean']['output'];
  /** shiftStartedAt + the configured shift length (LIVE_OPS_OVERTIME_SHIFT_HOURS) — when the route's shift tips into overtime. A route/shift estimate; not a working-time or tachograph record. */
  overtimeAt?: Maybe<Scalars['DateTime']['output']>;
  /** over | late | at_risk | on_time — 'over' when the route is still active and now has reached overtimeAt; otherwise the predicted finish classified against overtimeAt (same classifier as predictedFinishStatus). NULL when the shift has not started or there is nothing to classify. */
  overtimeRiskStatus?: Maybe<Scalars['String']['output']>;
  /** The configured shift length in minutes (LIVE_OPS_OVERTIME_SHIFT_HOURS), echoed so clients never hardcode it. */
  overtimeThresholdMinutes?: Maybe<Scalars['Int']['output']>;
  plannedWorkingSeconds: Scalars['Int']['output'];
  /** Projected finish datetime for an ACTIVE route (OSRM remaining-travel + observed service time). An ESTIMATE — see predictedFinishConfidence; NULL when there is no current prediction. */
  predictedFinish?: Maybe<Scalars['DateTime']['output']>;
  /** When the sweep last computed this route's finish forecast. Kept after the forecast itself expires (the sweep fell behind), so the board can say how old the last one is; NULL when the route was not forecast in the last day and a half. */
  predictedFinishComputedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 0..1 confidence in the predicted finish. WIDENS early (few stops done / variable service) and NARROWS as the route completes. */
  predictedFinishConfidence?: Maybe<Scalars['Float']['output']>;
  /** ± minutes uncertainty around the predicted finish. */
  predictedFinishConfidenceBandMinutes?: Maybe<Scalars['Int']['output']>;
  /** Shift-end / disposal cutoff the status is measured against. */
  predictedFinishCutoff?: Maybe<Scalars['DateTime']['output']>;
  /** Always true — predicted finish is a forecast, not a fact. */
  predictedFinishIsEstimate?: Maybe<Scalars['Boolean']['output']>;
  /** Signed minutes of the predicted finish vs the cutoff (negative = ahead of the cutoff). An estimate. */
  predictedFinishMinutesLate?: Maybe<Scalars['Int']['output']>;
  /** on_time | at_risk | late — the predicted finish classified against the shift/disposal cutoff (not raw minutes). NULL when there is no current prediction. */
  predictedFinishStatus?: Maybe<Scalars['String']['output']>;
  /** Signed minutes of the predicted finish vs overtimeAt (negative = finishes inside the shift). An estimate; NULL without a current prediction. */
  predictedMinutesOverShift?: Maybe<Scalars['Int']['output']>;
  /** Relay id of the RouteType node */
  routeId: Scalars['ID']['output'];
  /** Wall-clock seconds since shiftStartedAt (to now while a session is open, else to the last session end). Includes breaks; deliberately NOT drivenSeconds, which sums session durations and double-counts parallel sessions. */
  shiftElapsedSeconds?: Maybe<Scalars['Int']['output']>;
  /** Wall-clock start of the route's shift — the earliest vehicle session start on the route. NULL before any session exists. */
  shiftStartedAt?: Maybe<Scalars['DateTime']['output']>;
  ticketStops: Scalars['Int']['output'];
  totalStops: Scalars['Int']['output'];
};

export type LiveOperationsSummaryDef = {
  __typename: 'LiveOperationsSummaryDef';
  generatedAt: Scalars['DateTime']['output'];
  routes: Array<LiveOperationsRouteSummaryDef>;
  totals: LiveOperationsDayTotalsDef;
  vehicles: Array<LiveOperationsVehicleSummaryDef>;
};

export type LiveOperationsVehicleSummaryDef = {
  __typename: 'LiveOperationsVehicleSummaryDef';
  completedContainerStops: Scalars['Int']['output'];
  completedTicketStops: Scalars['Int']['output'];
  drivenDistanceMeters: Scalars['Float']['output'];
  drivenSeconds: Scalars['Int']['output'];
  /** Relay id of the VehicleType node */
  vehicleId: Scalars['ID']['output'];
  vehicleName: Scalars['String']['output'];
};

/** Acknowledge an alert server-side (retires the localStorage ack). */
export type LiveOpsAcknowledgeException = {
  __typename: 'LiveOpsAcknowledgeException';
  exception?: Maybe<LiveOperationsExceptionDef>;
};

/**
 * Submission-readiness DISPLAY (BE-2) — derived from the SAME rows as
 * the report, so the two can never disagree. Gates nothing operational;
 * missing weights are warnings, not blockers (§0.2).
 */
export type LiveOpsAdsQualityGateDef = {
  __typename: 'LiveOpsAdsQualityGateDef';
  blockers: Array<LiveOpsAdsQualityGateItemDef>;
  /** True when there are no blockers. */
  ready: Scalars['Boolean']['output'];
  warnings: Array<LiveOpsAdsQualityGateItemDef>;
};

/** One blocker/warning line of the submission-readiness gate. */
export type LiveOpsAdsQualityGateItemDef = {
  __typename: 'LiveOpsAdsQualityGateItemDef';
  code: Scalars['String']['output'];
  count?: Maybe<Scalars['Int']['output']>;
  fractionName?: Maybe<Scalars['String']['output']>;
  /** Share of the fraction's collections affected (0-100). */
  pct?: Maybe<Scalars['Float']['output']>;
};

/** The per-fraction ADS report for one calendar month. */
export type LiveOpsAdsReportDef = {
  __typename: 'LiveOpsAdsReportDef';
  adsQualityGate: LiveOpsAdsQualityGateDef;
  month: Scalars['Int']['output'];
  rows: Array<LiveOpsAdsReportRowDef>;
  tipReconciliation: Array<LiveOpsAdsTipReconciliationDef>;
  year: Scalars['Int']['output'];
};

/**
 * A ready-to-download report file (bytes inline, base64) — byte-for-byte
 * the ``reports.py`` export shape, produced by the shared ``rows_to_file``
 * writer. NO money column.
 */
export type LiveOpsAdsReportExportDef = {
  __typename: 'LiveOpsAdsReportExportDef';
  /** The file bytes, base64-encoded. */
  contentBase64: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

/**
 * One (fraction, hauler, contract-area) bucket of completed collections.
 *
 * ``total_weight_kg`` sums MEASURED weights only. Weight-less stops are
 * counted in ``collections_without_weight`` and contribute NOTHING to the
 * measured sum; their volume-derived estimate (volume x the fraction's
 * kg/m³ ``weight_factor``) sits in the SEPARATE ``estimated_weight_kg``
 * column. No column ever mixes the two.
 */
export type LiveOpsAdsReportRowDef = {
  __typename: 'LiveOpsAdsReportRowDef';
  /** The Danish ADS affaldsfraktionskode (H../E..), or '' until the customer supplies the mapping (warning — never guessed). */
  adsCode: Scalars['String']['output'];
  /** Completed container stops in the bucket. */
  collections: Scalars['Int']['output'];
  /** How many weight-less stops back the estimate column. */
  collectionsEstimatedFromVolume: Scalars['Int']['output'];
  /** How many of them carry a measured (driver-fed) weight. */
  collectionsWithWeight: Scalars['Int']['output'];
  /** Completed stops with NO weight recorded — honest counted rows, never summed as zeros. */
  collectionsWithoutWeight: Scalars['Int']['output'];
  /** Contract area, or 'Unattributed' when unstamped. */
  contractAreaName: Scalars['String']['output'];
  /** The fraction's EAK/EWC code, or the loud 'UNMAPPED' bucket when the fraction has none (blocker — never a guessed code). */
  eakCode: Scalars['String']['output'];
  /** Volume-derived estimate (volume x fraction weight_factor, kg/m³) for weight-less stops that DO carry a volume. Kept strictly apart from the measured column; 0 when no volume backs it (honest, not an error). */
  estimatedWeightKg: Scalars['Float']['output'];
  /** unmapped_eak / missing_ads_code / has_missing_weights / no_fraction_recorded. */
  flags: Array<Scalars['String']['output']>;
  fractionName: Scalars['String']['output'];
  /** Executing contractor, or 'Unattributed' when unstamped. */
  haulerName: Scalars['String']['output'];
  /** Null on the fraction-less row (honestly unknown). */
  hazardous?: Maybe<Scalars['Boolean']['output']>;
  /** Sum of MEASURED weights (kg) only — weight-less stops contribute nothing here, ever. */
  totalWeightKg: Scalars['Float']['output'];
};

/**
 * Route-level depot/tip reconciliation (honest, secondary).
 *
 * A depot stop carries NO fraction by DB constraint, so its weights are
 * NEVER attributed to a fraction — this block is labelled route-level +
 * fraction-UNATTRIBUTED, full stop. (Single-fraction-route attribution is
 * a confessed deferral.)
 */
export type LiveOpsAdsTipReconciliationDef = {
  __typename: 'LiveOpsAdsTipReconciliationDef';
  /** Always 'route_level_unattributed'. */
  attribution: Scalars['String']['output'];
  /** The route's planned fractions (context only — the tip weight is NOT split across them). */
  routeFractions: Array<Scalars['String']['output']>;
  /** Relay id of the RouteType node. */
  routeId: Scalars['ID']['output'];
  /** The route's planned day (tenant-local). */
  scheduledDay?: Maybe<Scalars['Date']['output']>;
  /** Completed depot/tip stops on the route. */
  tipStops: Scalars['Int']['output'];
  tipStopsWithWeight: Scalars['Int']['output'];
  /** Honest count — never summed as zeros. */
  tipStopsWithoutWeight: Scalars['Int']['output'];
  /** Sum of MEASURED tip weights (kg) only. */
  tipWeightKg: Scalars['Float']['output'];
};

/** A fraction/equipment-compatible reassign target (FE sorts by nearest). */
export type LiveOpsCompatibleTargetDef = {
  __typename: 'LiveOpsCompatibleTargetDef';
  driverName?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  routeId: Scalars['ID']['output'];
  vehicleId: Scalars['ID']['output'];
};

/**
 * A single operational exception opened or resolved live (Phase B).
 *
 * Ids are relay global ids (``exceptionId`` = ``LiveOpsException``,
 * plus ``RouteType`` / ``VehicleType`` / ``PickUpOrderType``).
 * ``resolved`` tells the FE whether to show or clear it; ``event`` is
 * ``created`` | ``resolved`` (a convenience mirror of ``resolved``).
 */
export type LiveOpsExceptionDelta = {
  __typename: 'LiveOpsExceptionDelta';
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  detail?: Maybe<Scalars['GenericScalar']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  exceptionId?: Maybe<Scalars['ID']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  routeId?: Maybe<Scalars['ID']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  snoozedUntil?: Maybe<Scalars['DateTime']['output']>;
  stopId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

export type LiveOpsFeedSubscription = {
  __typename: 'LiveOpsFeedSubscription';
  exceptions?: Maybe<Array<Maybe<LiveOpsExceptionDelta>>>;
  positions?: Maybe<Array<Maybe<LiveOpsPositionDelta>>>;
  routes?: Maybe<Array<Maybe<LiveOpsRouteDelta>>>;
  serverTime?: Maybe<Scalars['DateTime']['output']>;
  stops?: Maybe<Array<Maybe<LiveOpsStopDelta>>>;
};

/**
 * One labelled finish estimate. Nullable throughout — a side that
 * cannot be estimated carries ``reason`` in plain words instead of a
 * fabricated number.
 */
export type LiveOpsFinishEstimateDef = {
  __typename: 'LiveOpsFinishEstimateDef';
  /** ± minutes around the estimate. */
  confidenceBandMinutes?: Maybe<Scalars['Int']['output']>;
  /** Always true — a forecast, never a fact. */
  isEstimate: Scalars['Boolean']['output'];
  /** Signed minutes vs the cutoff (negative = ahead). */
  minutesVsCutoff?: Maybe<Scalars['Int']['output']>;
  /** Estimated finish (~). Null when unknowable. */
  predictedFinish?: Maybe<Scalars['DateTime']['output']>;
  /** Plain-words reason when the estimate is unavailable (e.g. 'No current prediction.'). */
  reason?: Maybe<Scalars['String']['output']>;
  /** on_time | at_risk | late | unknown vs the route's own cutoff. */
  status?: Maybe<Scalars['String']['output']>;
  /** osrm | fallback_coarse — how travel was estimated. */
  travelSource?: Maybe<Scalars['String']['output']>;
};

/** Log a 'Call driver' event (client tel: link) — no send (A3). */
export type LiveOpsLogCall = {
  __typename: 'LiveOpsLogCall';
  dispatchAction?: Maybe<DispatchActionDef>;
};

/** Mark a stop skipped with a required reason code (A2). */
export type LiveOpsMarkStopSkipped = {
  __typename: 'LiveOpsMarkStopSkipped';
  dispatchAction?: Maybe<DispatchActionDef>;
  undoToken?: Maybe<Scalars['String']['output']>;
};

/** Message a route's driver — persisted, timestamped, INERT (A3). */
export type LiveOpsMessageDriver = {
  __typename: 'LiveOpsMessageDriver';
  dispatchAction?: Maybe<DispatchActionDef>;
};

export type LiveOpsOvertimeImpactDef = {
  __typename: 'LiveOpsOvertimeImpactDef';
  /** Donor route's overtime status AFTER the move (over | late | at_risk | on_time), null when unknowable. */
  fromStatusAfter?: Maybe<Scalars['String']['output']>;
  /** Target route's overtime status AFTER the move. */
  toStatusAfter?: Maybe<Scalars['String']['output']>;
};

export type LiveOpsPositionDelta = {
  __typename: 'LiveOpsPositionDelta';
  driverId?: Maybe<Scalars['ID']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  recordedAt?: Maybe<Scalars['DateTime']['output']>;
  routeId?: Maybe<Scalars['ID']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

/**
 * The proof bundle for ONE stop — field-for-field the dict shape of
 * :func:`assemble_proof_bundle`. The resolver constructs it via
 * ``LiveOpsProofBundleDef(**bundle)``, so the wire shape can never drift
 * from the assembler (no new derivation, per the follow-on brief).
 */
export type LiveOpsProofBundleDef = {
  __typename: 'LiveOpsProofBundleDef';
  /** Completing driver's name. */
  driver?: Maybe<Scalars['String']['output']>;
  /** Descriptive fault-party (misses) — never money. */
  faultParty?: Maybe<Scalars['String']['output']>;
  fillLevel?: Maybe<Scalars['Float']['output']>;
  fraction?: Maybe<Scalars['String']['output']>;
  /** Geofence evidence {distance_m, threshold_m, within_range, source, label} with honest provenance. */
  geofence?: Maybe<Scalars['GenericScalar']['output']>;
  hasPhoto: Scalars['Boolean']['output'];
  isEstimate: Scalars['Boolean']['output'];
  photoStatus?: Maybe<Scalars['String']['output']>;
  photos?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Non-collection reason (misses). */
  reasonCode?: Maybe<Scalars['String']['output']>;
  serviced: Scalars['Boolean']['output'];
  /** When it was serviced (if it was). */
  servicedAt?: Maybe<Scalars['DateTime']['output']>;
  vehicle?: Maybe<Scalars['String']['output']>;
  vehiclePlate?: Maybe<Scalars['String']['output']>;
  verificationMethod?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/**
 * One container's proof-of-service for the looked-up day.
 *
 * Human-readable throughout — a name/plate/label, never a raw internal id
 * (the container's relay id is exposed only as ``container_id`` for linking).
 */
export type LiveOpsProofOfServiceDef = {
  __typename: 'LiveOpsProofOfServiceDef';
  /** Completing driver's name. */
  byWhom?: Maybe<Scalars['String']['output']>;
  /** Relay ContainerType id. */
  containerId?: Maybe<Scalars['ID']['output']>;
  /** Human container label. */
  containerLabel?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  /** Descriptive fault-party (misses) — never money. */
  faultParty?: Maybe<Scalars['String']['output']>;
  fillLevel?: Maybe<Scalars['Float']['output']>;
  fraction?: Maybe<Scalars['String']['output']>;
  hasPhoto: Scalars['Boolean']['output'];
  /** Geofence evidence {distance_m, threshold_m, within_range}. */
  howClose?: Maybe<Scalars['GenericScalar']['output']>;
  isEstimate: Scalars['Boolean']['output'];
  photoStatus?: Maybe<Scalars['String']['output']>;
  photos?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Non-collection reason (misses). */
  reasonCode?: Maybe<Scalars['String']['output']>;
  /** Collection-log status for the day. */
  status?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<Scalars['String']['output']>;
  vehiclePlate?: Maybe<Scalars['String']['output']>;
  verificationMethod?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
  wasServiced: Scalars['Boolean']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
  /** When it was serviced (if it was). */
  when?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * A pre-assembled reassign proposal. Applying it is ALWAYS the
 * human-clicked ``liveOpsReassignStops`` mutation — this object carries
 * exactly the arguments that mutation takes.
 */
export type LiveOpsReassignPlanDef = {
  __typename: 'LiveOpsReassignPlanDef';
  /** Great-circle meters from the target vehicle to the subset centroid (null if unknown). */
  distanceM?: Maybe<Scalars['Float']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  /** Donor route before/after (both estimates). */
  from?: Maybe<LiveOpsRouteImpactDef>;
  /** The stops to move (PickUpOrder.orderId values) — pass straight to liveOpsReassignStops.orderIds. */
  orderIds: Array<Scalars['ID']['output']>;
  /** Shift-overtime effect of the move, per route. */
  overtime?: Maybe<LiveOpsOvertimeImpactDef>;
  /** Plan positions of the moved stops on the source route (FE joins labels from its stop context). */
  stopNumbers: Array<Scalars['Int']['output']>;
  /** Target route before/after (both estimates). */
  to?: Maybe<LiveOpsRouteImpactDef>;
  toRouteId: Scalars['ID']['output'];
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

/** Reassign a route's remaining stops to another vehicle (A1). */
export type LiveOpsReassignStops = {
  __typename: 'LiveOpsReassignStops';
  dispatchAction?: Maybe<DispatchActionDef>;
  undoToken?: Maybe<Scalars['String']['output']>;
};

/**
 * The suggestion envelope. ``plan`` null ⇒ ``reason`` says why in
 * plain words (honest empty, never a dead screen).
 */
export type LiveOpsReassignSuggestionDef = {
  __typename: 'LiveOpsReassignSuggestionDef';
  /** Up to 2 runner-up targets (coarse estimates). */
  alternatives: Array<LiveOpsReassignPlanDef>;
  exceptionId: Scalars['ID']['output'];
  fromRouteId?: Maybe<Scalars['ID']['output']>;
  generatedAt: Scalars['DateTime']['output'];
  isEstimate: Scalars['Boolean']['output'];
  plan?: Maybe<LiveOpsReassignPlanDef>;
  /** Plain-words reason when no plan is offered. */
  reason?: Maybe<Scalars['String']['output']>;
};

/** A ranked in-area re-collect target (nearest first). */
export type LiveOpsRecollectCandidateDef = {
  __typename: 'LiveOpsRecollectCandidateDef';
  /** Great-circle meters from the bin to the route's nearest remaining stop (null if unknown). */
  distanceM?: Maybe<Scalars['Float']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  routeId: Scalars['ID']['output'];
  vehicleId: Scalars['ID']['output'];
};

/** Resolve an alert with a descriptive reason (never a monetary decision). */
export type LiveOpsResolveException = {
  __typename: 'LiveOpsResolveException';
  exception?: Maybe<LiveOperationsExceptionDef>;
};

export type LiveOpsRouteDelta = {
  __typename: 'LiveOpsRouteDelta';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  routeId?: Maybe<Scalars['ID']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LiveOpsRouteImpactDef = {
  __typename: 'LiveOpsRouteImpactDef';
  after?: Maybe<LiveOpsFinishEstimateDef>;
  before?: Maybe<LiveOpsFinishEstimateDef>;
};

/** Close a missed collection: place a go-back stop, or fall back to a ticket. */
export type LiveOpsScheduleRecollect = {
  __typename: 'LiveOpsScheduleRecollect';
  dispatchAction?: Maybe<DispatchActionDef>;
  exception?: Maybe<LiveOperationsExceptionDef>;
  resolution?: Maybe<Scalars['String']['output']>;
  undoToken?: Maybe<Scalars['String']['output']>;
};

export type LiveOpsSlaCockpitDef = {
  __typename: 'LiveOpsSlaCockpitDef';
  contractors: Array<CockpitContractorRowDef>;
  generatedAt: Scalars['DateTime']['output'];
  /** Day activity attributable to NO contractor (unowned routes/stops). Office callers only — a contractor caller always gets NULL. NULL when everything is attributed. */
  unattributed?: Maybe<CockpitBucketDef>;
};

/** Snooze an alert for a number of minutes (server-side). */
export type LiveOpsSnoozeException = {
  __typename: 'LiveOpsSnoozeException';
  exception?: Maybe<LiveOperationsExceptionDef>;
};

export type LiveOpsStopDelta = {
  __typename: 'LiveOpsStopDelta';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** COMPASS-973: the stable number the driver quotes to the office (PickUpOrderType.displayNumber). Unlike stopNumber it does not move when the route is re-optimised. */
  displayNumber?: Maybe<Scalars['Int']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  routeId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stopId?: Maybe<Scalars['ID']['output']>;
  stopNumber?: Maybe<Scalars['Int']['output']>;
};

/**
 * Un-acknowledge an alert (the inverse of acknowledge): move it back to
 * the active worklist. Also clears any snooze — see
 * :func:`unacknowledge_exception`.
 */
export type LiveOpsUnacknowledgeException = {
  __typename: 'LiveOpsUnacknowledgeException';
  exception?: Maybe<LiveOperationsExceptionDef>;
};

/** Reverse the last undoable action from its before-state. */
export type LiveOpsUndo = {
  __typename: 'LiveOpsUndo';
  dispatchAction?: Maybe<DispatchActionDef>;
};

/** A single vehicle's last-known fix at-or-before the scrubbed moment. */
export type LivePlaybackPositionDef = {
  __typename: 'LivePlaybackPositionDef';
  /** Relay id of the DriverType node (may be null) */
  driverId?: Maybe<Scalars['ID']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  /** Relay id of the RouteType node */
  routeId: Scalars['ID']['output'];
  speed: Scalars['Float']['output'];
  /** created_at of the fix that is 'as of' asOf */
  timestamp: Scalars['DateTime']['output'];
  /** Relay id of the VehicleType node */
  vehicleId: Scalars['ID']['output'];
  vehicleName: Scalars['String']['output'];
};

/** A route's lifecycle + stop-completion rollup as of the moment. */
export type LivePlaybackRouteStateDef = {
  __typename: 'LivePlaybackRouteStateDef';
  /** Only when <= asOf. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedStopsAsOf: Scalars['Int']['output'];
  isCompletedAsOf: Scalars['Boolean']['output'];
  isStartedAsOf: Scalars['Boolean']['output'];
  routeId: Scalars['ID']['output'];
  /** Only when <= asOf. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  stops: Array<LivePlaybackStopStateDef>;
  totalStops: Scalars['Int']['output'];
};

/** A stop's status *as of* the scrubbed moment. */
export type LivePlaybackStopStateDef = {
  __typename: 'LivePlaybackStopStateDef';
  /** Real completion time, only when <= asOf (else null). */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  isCompletedAsOf: Scalars['Boolean']['output'];
  /** Raw PickUpOrder uuid */
  orderId: Scalars['ID']['output'];
  routeId: Scalars['ID']['output'];
  /** 'completed' / 'skipped' if the stop was acted on at or before asOf, else 'pending' (not-yet at that moment). */
  statusAsOf: Scalars['String']['output'];
  /** Relay id of the PickUpOrderType node */
  stopId: Scalars['ID']['output'];
  stopNumber: Scalars['Int']['output'];
};

/** A per-vehicle breadcrumb polyline for the replay layer. */
export type LivePlaybackTrackDef = {
  __typename: 'LivePlaybackTrackDef';
  /** True when raw_point_count exceeded the cap. */
  downsampled: Scalars['Boolean']['output'];
  /** Fixes actually returned (after cap). */
  pointCount: Scalars['Int']['output'];
  points: Array<LivePlaybackTrackPointDef>;
  /** Fixes matched before downsampling. */
  rawPointCount: Scalars['Int']['output'];
  /** Relay id of the route the track's newest fix is on. */
  routeId?: Maybe<Scalars['ID']['output']>;
  vehicleId: Scalars['ID']['output'];
  vehicleName: Scalars['String']['output'];
};

export type LivePlaybackTrackPointDef = {
  __typename: 'LivePlaybackTrackPointDef';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  speed: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
};

/** Declared vs verified waste fraction of one completed movement. */
export type LoadClassificationDef = Node & {
  __typename: 'LoadClassificationDef';
  classifiedAt?: Maybe<Scalars['DateTime']['output']>;
  classifiedBy?: Maybe<UserType>;
  completedAt: Scalars['DateTime']['output'];
  containerLabel?: Maybe<Scalars['String']['output']>;
  declaredFraction?: Maybe<WasteFractionType>;
  evidence?: Maybe<TicketAttachmentDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isReclassified: Scalars['Boolean']['output'];
  movementType: Scalars['String']['output'];
  pickupOrder?: Maybe<PickUpOrderType>;
  reasonCode?: Maybe<LoadReasonCode>;
  rentalTicket?: Maybe<TicketDef>;
  /** The reclassification surcharge billable event (REST v4 id), null until a reclassification posted one. */
  surchargeEventId?: Maybe<Scalars['ID']['output']>;
  ticket?: Maybe<TicketDef>;
  verifiedFraction?: Maybe<WasteFractionType>;
  wasteTransferNote?: Maybe<WasteTransferNoteDef>;
};

export type LoadClassificationDefConnection = {
  __typename: 'LoadClassificationDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LoadClassificationDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LoadClassificationDef` and its cursor. */
export type LoadClassificationDefEdge = {
  __typename: 'LoadClassificationDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LoadClassificationDef>;
};

export enum LoadEventTypesGraphene {
  DRIVER_CORRECTION = 'DRIVER_CORRECTION',
  HAULER_CORRECTION = 'HAULER_CORRECTION',
  KM_CORRECTION = 'KM_CORRECTION',
  NOTE_CHANGE = 'NOTE_CHANGE',
  NUMBER_CORRECTION = 'NUMBER_CORRECTION',
  STATUS_CHANGE = 'STATUS_CHANGE',
  TIME_CORRECTION = 'TIME_CORRECTION',
  UNLOADING_LOCATION_CHANGE = 'UNLOADING_LOCATION_CHANGE',
  VEHICLE_CORRECTION = 'VEHICLE_CORRECTION',
  WASTE_TYPE_CORRECTION = 'WASTE_TYPE_CORRECTION',
  WEIGHT_CORRECTION = 'WEIGHT_CORRECTION'
}

/** Why the load was reclassified at the tip (declared != verified). */
export enum LoadReasonCode {
  CONTAMINATION = 'CONTAMINATION',
  MISDECLARED = 'MISDECLARED',
  MIXED = 'MIXED',
  OTHER = 'OTHER'
}

/** One contract area's load figures (REQ 3.6.25 "by load"). */
export type LoadSummaryType = {
  __typename: 'LoadSummaryType';
  area?: Maybe<AreaDef>;
  areaId?: Maybe<Scalars['ID']['output']>;
  areaName?: Maybe<Scalars['String']['output']>;
  /** Office-excused events (an active reliability exclusion) — a non-hauler-fault miss removed by the office. NOT counted in missed, computed by the SAME metrics service as the Reliability tab (PRO-119), so planned == lifts + missed + pending + excluded. */
  excluded: Scalars['Int']['output'];
  /** Completed collections — the missed-rate denominator. */
  lifts: Scalars['Int']['output'];
  missed: Scalars['Int']['output'];
  /** Missed collections per 1,000 lifts (excused misses removed); null when there were no lifts (no basis). */
  missedRatePer1000?: Maybe<Scalars['Float']['output']>;
  /** Not-yet-due stops (planned day today or later) — never a miss (PRO-119); 0 for any historical period. */
  pending: Scalars['Int']['output'];
  planned: Scalars['Int']['output'];
  totalWeight?: Maybe<Scalars['Float']['output']>;
  vehicles?: Maybe<Array<LoadVehicleBreakdownType>>;
  /** Weighed stops as a % of completed stops (PRO-114) — the data quality behind per-tonne pay. Null when there were no lifts (no basis). */
  weighedStopCoveragePct?: Maybe<Scalars['Float']['output']>;
  weighedStops: Scalars['Int']['output'];
};

/**
 * Abandon an in-progress chain (the compactor was inaccessible, a
 * mis-tap, the wrong task).
 *
 * RELEASES the anchor task: it is left open, uncompleted and unskipped,
 * and a fresh chain may be started on it. Cancelling is a resolution of
 * the LOAD, never a verdict on the task — closing the task is
 * ``routeStopComplete``'s job, with a COMPASS-883 deviation reason when
 * the work did not happen.
 */
export type LoadUnitJobCancel = {
  __typename: 'LoadUnitJobCancel';
  loadUnitJob?: Maybe<LoadUnitJobType>;
};

/**
 * Second confirmation: the unit was emptied at the disposal site.
 *
 * The anchor task stays open and stays PENDING — the empty unit still has
 * to go back. Records the depot (or a free-text site), the net weight and
 * where the emptying happened.
 */
export type LoadUnitJobMarkEmptied = {
  __typename: 'LoadUnitJobMarkEmptied';
  loadUnitJob?: Maybe<LoadUnitJobType>;
};

/**
 * Third confirmation: the empty unit is back on the ground.
 *
 * THIS is the one that completes the anchor task, through
 * ``Route.action_complete_stops`` — so invoicing, live-ops, the
 * extra-emptying chain and the Autopilot emitters fire exactly once, at
 * the moment the service is genuinely finished.
 *
 * If the task can no longer be completed (the office closed the route
 * while the driver was offline, the task was deleted, a scheme rule now
 * refuses it) the chain still reaches ``unloaded`` and the reason is
 * reported on ``stopCompleted`` / ``stopCompletionError`` rather than
 * raised. Refusing the unload would leave the load pending forever and
 * make the queued operation retry until the driver clears their outbox.
 */
export type LoadUnitJobMarkUnloaded = {
  __typename: 'LoadUnitJobMarkUnloaded';
  loadUnitJob?: Maybe<LoadUnitJobType>;
};

/**
 * First confirmation: the driver marks a pallet/compactor LOADED.
 *
 * The anchor task is deliberately left OPEN — it is completed at the
 * third confirmation, when the service is genuinely finished — and from
 * here on it reads as PENDING everywhere
 * (``PickUpOrderType.pendingLoadUnitJob``).
 *
 * Idempotent on ``loadId``: replaying the same queued operation returns
 * the same job instead of erroring, so a driver's outbox always drains.
 */
export type LoadUnitJobStart = {
  __typename: 'LoadUnitJobStart';
  loadUnitJob?: Maybe<LoadUnitJobType>;
};

/**
 * One load unit's chained confirmation.
 *
 * No ``fields``/``exclude`` in Meta (house convention): adding a column to
 * the model publishes it here automatically, and each column's
 * ``help_text`` is its user-facing documentation.
 */
export type LoadUnitJobType = Node & {
  __typename: 'LoadUnitJobType';
  /** Why an in-progress chain was abandoned (the compactor was inaccessible, wrong stop, mis-tap). Free text: the tender names no vocabulary, and inventing one would force drivers into a wrong code. Cancelling RELEASES the anchor stop — it does not complete or skip it. */
  cancelReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<UserType>;
  /** Tenant wall. load_id is unique WITHIN a company, not globally: a globally-unique client-minted string would let one tenant collide with — or probe the existence of — another tenant's load. */
  company: CompanyType;
  container?: Maybe<ContainerType>;
  /** Set when the unit belongs to a container group — the group case the driver app already records. */
  containerGroup?: Maybe<ContainerGroupDef>;
  createdAt: Scalars['DateTime']['output'];
  /** Where the unit was emptied. Same depot set the unloading surface (routes/schema/unloading.py) uses. */
  disposalDepot?: Maybe<DepotType>;
  /** Free-text site name the driver recorded at the emptying, when the site is not a WasteHero depot. */
  disposalSiteName: Scalars['String']['output'];
  emptiedAt?: Maybe<Scalars['DateTime']['output']>;
  emptiedBy?: Maybe<UserType>;
  emptiedPoint?: Maybe<Scalars['GeoJSON']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Client-minted load identifier ('load identifier for tracking to disposal site', PD-225). The driver app mints it at the 'loaded' confirmation and sends it with every later one, which is what makes each write idempotent and an offline replay order-independent. */
  loadId: Scalars['String']['output'];
  loadedAt?: Maybe<Scalars['DateTime']['output']>;
  loadedBy?: Maybe<UserType>;
  loadedPoint?: Maybe<Scalars['GeoJSON']['output']>;
  /** Net weight measured at the disposal site. Carried into the anchor stop's completion at 'unloaded' — it is the only real measurement in the chain. NULL when nothing was weighed. */
  netWeight?: Maybe<Scalars['Float']['output']>;
  /** REQ 264's 'displayed as pending': the unit is on the truck — loaded, or emptied but not yet put back — so the task is neither done nor missed. DERIVED from status, so the badge and the stored state can never disagree. */
  pending: Scalars['Boolean']['output'];
  /** The confirmation this chain is waiting for ('emptied' or 'unloaded'), or null once it is unloaded or cancelled. This is the 'task carried out between loading and unloading' the requirement asks to be shown. */
  pendingStep?: Maybe<Scalars['String']['output']>;
  /** The anchor collection task. Completed once, at 'unloaded'. SET_NULL rather than CASCADE so deleting a task never silently erases the record that a unit is on a truck. */
  pickupOrder?: Maybe<PickUpOrderType>;
  /** The route the load was picked up on. */
  route: RouteType;
  /** loaded -> emptied -> unloaded, or cancelled from either of the first two. 'loaded' and 'emptied' READ AS PENDING. */
  status: RoutesLoadUnitJobStatusChoices;
  /** True once the 'unloaded' confirmation actually completed the anchor stop through Route.action_complete_stops. */
  stopCompleted: Scalars['Boolean']['output'];
  /** Why the final confirmation could NOT complete the anchor stop. NULL means no attempt has failed. A non-null value on an 'unloaded' job is an office work item: the load is off the truck but the task is still open. */
  stopCompletionError?: Maybe<Scalars['String']['output']>;
  /** What the driver sees for this unit (usually the container type name). Empty when the client sent none. */
  unitLabel: Scalars['String']['output'];
  /** Pallet / compactor / skip / other. Descriptive only — the state machine does not branch on it. */
  unitType: RoutesLoadUnitJobUnitTypeChoices;
  unloadedAt?: Maybe<Scalars['DateTime']['output']>;
  unloadedBy?: Maybe<UserType>;
  unloadedPoint?: Maybe<Scalars['GeoJSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** The driver session that STARTED the chain. Later steps may belong to a different session (shift change) — see the per-step *_by columns. */
  vehicleSession?: Maybe<RouteVehicleSessionType>;
};

export type LoadUnitJobTypeConnection = {
  __typename: 'LoadUnitJobTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LoadUnitJobTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `LoadUnitJobType` and its cursor. */
export type LoadUnitJobTypeEdge = {
  __typename: 'LoadUnitJobTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LoadUnitJobType>;
};

export type LoadVehicleBreakdownType = {
  __typename: 'LoadVehicleBreakdownType';
  capacityKg?: Maybe<Scalars['Float']['output']>;
  capacityUtilizationPct?: Maybe<Scalars['Float']['output']>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  lifts: Scalars['Int']['output'];
  totalWeight?: Maybe<Scalars['Float']['output']>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
  vehicleName?: Maybe<Scalars['String']['output']>;
  weighedStops: Scalars['Int']['output'];
};

/**
 * The unit a scanned / typed identity resolved to, whatever the
 * verdict - the app shows its label and type beside the refusal.
 */
export type LoadedIdentityContainerDef = {
  __typename: 'LoadedIdentityContainerDef';
  /** The label, as printed on the skip. */
  containerId?: Maybe<Scalars['String']['output']>;
  containerTypeName?: Maybe<Scalars['String']['output']>;
  /** The container's relay id. */
  id: Scalars['ID']['output'];
  /** Where the skip is out on hire today - the property's register number, else its address - read off the rental ledger, then the active agreement; null when it is in the yard. */
  onHireAt?: Maybe<Scalars['String']['output']>;
  /** The container's stored status (in_storage, available, ended, ...). */
  status?: Maybe<Scalars['String']['output']>;
};

export type LoadedIdentityVerdictDef = {
  __typename: 'LoadedIdentityVerdictDef';
  /** The unit the identity resolved to; null for an unknown label. */
  container?: Maybe<LoadedIdentityContainerDef>;
  /** Whether this skip may be loaded for this stop. */
  ok: Scalars['Boolean']['output'];
  /** The refusal, as the completion would word it; null when ok. */
  reason?: Maybe<Scalars['String']['output']>;
};

export type LocationInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  municipalityCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeName?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

export type LocationInputObject = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};

export type LocationMutation = {
  __typename: 'LocationMutation';
  location?: Maybe<LocationType>;
};

export type LocationType = Node & {
  __typename: 'LocationType';
  /** Snapshot of container's location before the change */
  asOriginalLocation: TemporaryContainerLocationTypeConnection;
  /** The temporary location applied to the container */
  asTemporaryLocation: TemporaryContainerLocationTypeConnection;
  companySet: CompanyTypeConnection;
  contactAddresses: CollectionInquiryTypeConnection;
  containerSet: ContainerTypeConnection;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Location where Depot is situated */
  depots: DepotTypeConnection;
  destinations: Array<DirectionMatrixType>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  inquiries: CollectionInquiryTypeConnection;
  internalTickets: TicketDefConnection;
  latitude?: Maybe<Scalars['Float']['output']>;
  localArea?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  municipalityCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  origins: Array<DirectionMatrixType>;
  placeId?: Maybe<Scalars['String']['output']>;
  /** User selected location on Google Maps */
  point: Scalars['GeoJSON']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  postalCodeName?: Maybe<Scalars['String']['output']>;
  propertySet: PropertyDefConnection;
  routelocationhistorySet: RouteLocationHistoryDefConnection;
  settingsSet: SettingsTypeConnection;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  vehicleSet: VehicleTypeConnection;
};


export type LocationTypeAsOriginalLocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationTypeAsTemporaryLocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationTypeCompanySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationTypeContactAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationTypeContainerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationTypeDepotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationTypeInquiriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationTypeInternalTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationTypePropertySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationTypeRoutelocationhistorySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationTypeSettingsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationTypeVehicleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationTypeConnection = {
  __typename: 'LocationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LocationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `LocationType` and its cursor. */
export type LocationTypeEdge = {
  __typename: 'LocationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LocationType>;
};

export type LocationWithContainerType = Node & {
  __typename: 'LocationWithContainerType';
  /** Snapshot of container's location before the change */
  asOriginalLocation: TemporaryContainerLocationTypeConnection;
  /** The temporary location applied to the container */
  asTemporaryLocation: TemporaryContainerLocationTypeConnection;
  companySet: CompanyTypeConnection;
  contactAddresses: CollectionInquiryTypeConnection;
  containerSet: ContainerTypeConnection;
  containers?: Maybe<ContainerTypeConnection>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Location where Depot is situated */
  depots: DepotTypeConnection;
  destinations: Array<DirectionMatrixType>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  inquiries: CollectionInquiryTypeConnection;
  internalTickets: TicketDefConnection;
  latitude?: Maybe<Scalars['Float']['output']>;
  localArea?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  municipalityCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  origins: Array<DirectionMatrixType>;
  placeId?: Maybe<Scalars['String']['output']>;
  /** User selected location on Google Maps */
  point: Scalars['GeoJSON']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  postalCodeName?: Maybe<Scalars['String']['output']>;
  propertySet: PropertyDefConnection;
  routelocationhistorySet: RouteLocationHistoryDefConnection;
  settingsSet: SettingsTypeConnection;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  vehicleSet: VehicleTypeConnection;
};


export type LocationWithContainerTypeAsOriginalLocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationWithContainerTypeAsTemporaryLocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationWithContainerTypeCompanySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationWithContainerTypeContactAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationWithContainerTypeContainerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationWithContainerTypeContainersArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  allowedForRoute?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  area_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionCalendar_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  collectionCalendars?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerId?: InputMaybe<Scalars['String']['input']>;
  containerType_Name_Iexact?: InputMaybe<Scalars['String']['input']>;
  containerType_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  containerTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  device_IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCollectionCalendars?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRouteSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  measurement_FillPercentage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noProperty?: InputMaybe<Scalars['Boolean']['input']>;
  noRouteOnDay?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyNumber?: InputMaybe<Scalars['String']['input']>;
  propertyTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  q?: InputMaybe<Scalars['String']['input']>;
  rfid?: InputMaybe<Scalars['String']['input']>;
  routeIdsNotCompletedStops?: InputMaybe<Scalars['String']['input']>;
  routeScheme_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scpAttachable?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchContact?: InputMaybe<Scalars['String']['input']>;
  sensor_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  storedAtDepot?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  temporarilyRelocated?: InputMaybe<Scalars['Boolean']['input']>;
  vehicle_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFractionIds?: InputMaybe<Scalars['String']['input']>;
  wasteFraction_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  wasteFraction_WasteTypes_Name_Iexact?: InputMaybe<Scalars['String']['input']>;
  wasteFraction_WasteTypes_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wasteTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  withDevices?: InputMaybe<Scalars['Boolean']['input']>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zone_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LocationWithContainerTypeDepotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationWithContainerTypeInquiriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationWithContainerTypeInternalTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationWithContainerTypePropertySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationWithContainerTypeRoutelocationhistorySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationWithContainerTypeSettingsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationWithContainerTypeVehicleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationWithContainerTypeConnection = {
  __typename: 'LocationWithContainerTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LocationWithContainerTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `LocationWithContainerType` and its cursor. */
export type LocationWithContainerTypeEdge = {
  __typename: 'LocationWithContainerTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LocationWithContainerType>;
};

export type LogViewPropertyEvent = {
  __typename: 'LogViewPropertyEvent';
  success: Scalars['Boolean']['output'];
};

export type LogViewTicketEvent = {
  __typename: 'LogViewTicketEvent';
  success: Scalars['Boolean']['output'];
};

export type LorawanDeviceType = BaseDeviceInterface & Node & {
  __typename: 'LorawanDeviceType';
  antenna: DeviceLorawanDeviceAntennaChoices;
  appKey?: Maybe<Scalars['String']['output']>;
  batch: Scalars['String']['output'];
  bootloaderFwVersion: Scalars['String']['output'];
  company?: Maybe<CompanyType>;
  connectionType?: Maybe<Scalars['String']['output']>;
  containerDevice?: Maybe<DeviceToContainerTypeConnection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  devId?: Maybe<Scalars['String']['output']>;
  deviceEui?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<DeviceTypeType>;
  hwVersion?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isContainer?: Maybe<Scalars['Boolean']['output']>;
  isGps?: Maybe<Scalars['Boolean']['output']>;
  measurements?: Maybe<FillLevelMeasurementTypeConnection>;
  modemFwVersion: Scalars['String']['output'];
  productNo: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  whsFwVersion: Scalars['String']['output'];
};


export type LorawanDeviceTypeContainerDeviceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LorawanDeviceTypeMeasurementsArgs = {
  From?: InputMaybe<Scalars['DateTime']['input']>;
  To?: InputMaybe<Scalars['DateTime']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LorawanDeviceTypeConnection = {
  __typename: 'LorawanDeviceTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LorawanDeviceTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LorawanDeviceType` and its cursor. */
export type LorawanDeviceTypeEdge = {
  __typename: 'LorawanDeviceTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LorawanDeviceType>;
};

export type ManageContainerTicketDef = Node & {
  __typename: 'ManageContainerTicketDef';
  /** When the abortive visit was reported. */
  abortiveAt?: Maybe<Scalars['DateTime']['output']>;
  /** The photo the driver attached to the last abortive visit. */
  abortiveAttachment?: Maybe<TicketAttachmentDef>;
  /** Driver's note on the abortive visit. */
  abortiveNote: Scalars['String']['output'];
  /** Why the last visit for this ticket could not be carried out (driver-reported); the ticket was re-opened for rescheduling. */
  abortiveReason?: Maybe<TicketTicketAbortiveReasonChoices>;
  affectsPay?: Maybe<Scalars['Boolean']['output']>;
  affectsPaySetAt?: Maybe<Scalars['DateTime']['output']>;
  affectsPaySetBy?: Maybe<UserType>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<UserType>;
  archivedByRule?: Maybe<ArchivalRuleDef>;
  assignedTeam?: Maybe<TeamType>;
  assignee?: Maybe<UserType>;
  collectionCalendar?: Maybe<CollectionCalendarDef>;
  company: CompanyType;
  companyCopy: CompanyType;
  container?: Maybe<ContainerType>;
  containerDestination?: Maybe<ContainerStorageLocationDef>;
  containerNotifications?: Maybe<Array<Maybe<ContainerNotificationMethodUnion>>>;
  containerProduct?: Maybe<ProductDef>;
  containerSource?: Maybe<ContainerStorageLocationDef>;
  containerToAdd?: Maybe<ContainerType>;
  containerToReturn?: Maybe<ContainerType>;
  containerType?: Maybe<ContainerTypeType>;
  createdAt: Scalars['DateTime']['output'];
  customFields: Scalars['JSONString']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  deadlineArea?: Maybe<AreaDef>;
  deadlineSource?: Maybe<TicketTicketDeadlineSourceChoices>;
  description: Scalars['String']['output'];
  exchangeRentalTickets: ManageContainerTicketDefConnection;
  exchangeTicket?: Maybe<ManageContainerTicketDef>;
  expectedLoadKg?: Maybe<Scalars['Int']['output']>;
  externalReference?: Maybe<Scalars['String']['output']>;
  externalSource?: Maybe<Scalars['String']['output']>;
  generatedReturnTickets: ManageContainerTicketDefConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  ignoreServiceFee: Scalars['Boolean']['output'];
  lastView?: Maybe<TicketViewEventDef>;
  location?: Maybe<LocationWithContainerType>;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  newContainerId?: Maybe<Scalars['String']['output']>;
  oldCollectionCalendar?: Maybe<CollectionCalendarDef>;
  oldContainerType?: Maybe<ContainerTypeType>;
  oldPickupSetting?: Maybe<PickupSettingsType>;
  oldRouteScheme?: Maybe<RouteSchemeType>;
  onPublicRoad: Scalars['Boolean']['output'];
  payerContact?: Maybe<ContactDef>;
  payloadWarning: Scalars['Boolean']['output'];
  periodEndDate?: Maybe<Scalars['Date']['output']>;
  periodStartDate?: Maybe<Scalars['Date']['output']>;
  pickupSetting?: Maybe<PickupSettingsType>;
  possibleContainerId: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  postalCodeName?: Maybe<Scalars['String']['output']>;
  ppContainerProduct?: Maybe<PpProductDef>;
  ppOriginalPrice?: Maybe<Scalars['Decimal']['output']>;
  ppOriginalWeight?: Maybe<Scalars['Decimal']['output']>;
  ppPrice?: Maybe<Scalars['Decimal']['output']>;
  ppPriceOverridden: Scalars['Boolean']['output'];
  ppServiceOriginalPrice?: Maybe<Scalars['Decimal']['output']>;
  ppServicePrice?: Maybe<Scalars['Decimal']['output']>;
  ppServicePriceOverridden: Scalars['Boolean']['output'];
  ppServiceProduct?: Maybe<PpProductDef>;
  ppWeight?: Maybe<Scalars['Decimal']['output']>;
  ppWeightOverridden: Scalars['Boolean']['output'];
  preferredDate?: Maybe<Scalars['Date']['output']>;
  priority: TicketTicketPriorityChoices;
  property?: Maybe<PropertyDef>;
  quantity?: Maybe<Scalars['Int']['output']>;
  receiveCondition?: Maybe<TicketManageContainerTicketReceiveConditionChoices>;
  rentalContainer?: Maybe<ContainerType>;
  /** Billing basis of the collected weight: weighbridge, onboard_legal, onboard_indicative or estimate. */
  rentalWeightBasis?: Maybe<Scalars['String']['output']>;
  /** Net kilograms collected off the rental's skip. */
  rentalWeightNetKg?: Maybe<Scalars['Float']['output']>;
  /** When the collected weight was measured / recorded. */
  rentalWeightRecordedAt?: Maybe<Scalars['DateTime']['output']>;
  /** How the collected weight was captured: weighbridge, vehicle_scale, manual or import. */
  rentalWeightSource?: Maybe<Scalars['String']['output']>;
  /** Reported accuracy radius of that fix, metres. */
  reportedGpsAccuracyM?: Maybe<Scalars['Float']['output']>;
  /** When the device took that fix (not the sync time). */
  reportedGpsCapturedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Device position when the ticket was filed. NULL = not recorded. */
  reportedPoint?: Maybe<Scalars['GeoJSON']['output']>;
  reporter?: Maybe<UserType>;
  reporterDriver?: Maybe<DriverType>;
  requestedBy?: Maybe<PropertyUserDef>;
  requestedByContact?: Maybe<ContactDef>;
  requestedByOther?: Maybe<Scalars['String']['output']>;
  returnOfTicket?: Maybe<ManageContainerTicketDef>;
  rfid: Scalars['String']['output'];
  routeDescription: Scalars['String']['output'];
  routeScheme?: Maybe<RouteSchemeType>;
  searchUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  serviceFeeQuantity: Scalars['Int']['output'];
  serviceProvider?: Maybe<HaulerDef>;
  showOnPortal?: Maybe<Scalars['Boolean']['output']>;
  sparePart?: Maybe<SparePartType>;
  status: TicketTicketStatusChoices;
  /** The user who changed the status */
  statusChangedBy?: Maybe<UserType>;
  /** The reason for the status change */
  statusChangedReason?: Maybe<TicketTicketStatusChangedReasonChoices>;
  /** The platform where the status was changed */
  statusChangedVia?: Maybe<TicketTicketStatusChangedViaChoices>;
  statusCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  statusCopy: TicketManageContainerTicketStatusCopyChoices;
  statusInProgressAt?: Maybe<Scalars['DateTime']['output']>;
  statusOnHoldAt?: Maybe<Scalars['DateTime']['output']>;
  statusOpenAt?: Maybe<Scalars['DateTime']['output']>;
  statusPendingAt?: Maybe<Scalars['DateTime']['output']>;
  statusRejectedAt?: Maybe<Scalars['DateTime']['output']>;
  ticketPtr: TicketDef;
  ticketType: TicketTypeDef;
  /** in minutes */
  timeSpent?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
  viaPortal: Scalars['Boolean']['output'];
  visibilityOverridden: Scalars['Boolean']['output'];
  visibilityScope: TicketTicketVisibilityScopeChoices;
  washingReturnOf?: Maybe<TicketDef>;
  wasteFraction?: Maybe<WasteFractionType>;
  wasteFractions?: Maybe<Array<Maybe<WasteFractionType>>>;
  wasteVolumeEstimate?: Maybe<Scalars['Float']['output']>;
  wasteWeightEstimate?: Maybe<Scalars['Float']['output']>;
};


export type ManageContainerTicketDefExchangeRentalTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ManageContainerTicketDefGeneratedReturnTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ManageContainerTicketDefConnection = {
  __typename: 'ManageContainerTicketDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ManageContainerTicketDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ManageContainerTicketDef` and its cursor. */
export type ManageContainerTicketDefEdge = {
  __typename: 'ManageContainerTicketDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ManageContainerTicketDef>;
};

export type ManageFilesMutation = {
  __typename: 'ManageFilesMutation';
  status?: Maybe<Scalars['String']['output']>;
  uploadFiles?: Maybe<Array<Maybe<FileObjectType>>>;
};

export type ManagementCompanyPropertyDef = Node & {
  __typename: 'ManagementCompanyPropertyDef';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  externalPropertyContactId: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  managementCompany: PropertyManagementCompanyDef;
  matrikkelRegistrationDate?: Maybe<Scalars['Date']['output']>;
  matrikkelRole: Scalars['String']['output'];
  property: PropertyDef;
  role: CrmManagementCompanyPropertyRoleChoices;
  startDate: Scalars['DateTime']['output'];
};

export type ManagementCompanyPropertyDefConnection = {
  __typename: 'ManagementCompanyPropertyDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ManagementCompanyPropertyDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ManagementCompanyPropertyDef` and its cursor. */
export type ManagementCompanyPropertyDefEdge = {
  __typename: 'ManagementCompanyPropertyDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ManagementCompanyPropertyDef>;
};

/**
 * RS-E24 (stage E): one requirement node of the completeness
 * manifest, with its transparent gap prompt (D62).
 */
export type ManifestNodeDef = Node & {
  __typename: 'ManifestNodeDef';
  /** Whether this node blocks materialization (wave I2); optional and owned gaps never block. */
  blocking?: Maybe<Scalars['Boolean']['output']>;
  case: ImportCaseDef;
  /** The D62 prompt: what we have, what is missing, upload or mark unavailable; empty for satisfied nodes. */
  gapPrompt?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  /** SBX-520: can the platform satisfy this need here and now: {available, count, preview_sentence}. Honest zeros; a need without a pull path answers with what the platform lacks. Render preview_sentence verbatim. */
  platformSource?: Maybe<Scalars['GenericScalar']['output']>;
  questions: CaseQuestionDefConnection;
  requirement: RouteStudioManifestNodeRequirementChoices;
  satisfiedBy: Scalars['JSONString']['output'];
  status: RouteStudioManifestNodeStatusChoices;
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * RS-E24 (stage E): one requirement node of the completeness
 * manifest, with its transparent gap prompt (D62).
 */
export type ManifestNodeDefQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ManifestNodeDefConnection = {
  __typename: 'ManifestNodeDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ManifestNodeDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ManifestNodeDef` and its cursor. */
export type ManifestNodeDefEdge = {
  __typename: 'ManifestNodeDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ManifestNodeDef>;
};

/**
 * One approved manual contractor entry as a labelled settlement line
 * (PRO-465).
 *
 * Served from live rows while the period is OPEN and from the frozen
 * snapshot once closed — identical shape either way. ``amountCents`` is the
 * SIGNED contribution to Total payable (deduction negative, credit
 * positive).
 */
export type ManualEntryLineType = {
  __typename: 'ManualEntryLineType';
  /** Signed cents: a deduction is negative, a credit positive — the line's contribution to Total payable. */
  amountCents: Scalars['Int']['output'];
  approvedByName?: Maybe<Scalars['String']['output']>;
  /** ISO datetime the entry was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  /** deduction | credit */
  entryType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  /** approved | settled */
  status: Scalars['String']['output'];
};

/**
 * One toggleable entry of the unified map-layer catalog (3.1.41 /
 * PRO-279 "Maplayers"). The map view's single layer selector lists these so
 * the view is *filterable by selecting layers*, and every entry is one of the
 * two origins the requirement names:
 *
 * * ``origin = "PUBLIC"``  — a registered external service
 *   (``routes.ExternalMapLayer``, 3.1.45); ``kind`` is its protocol
 *   (WMS/WFS/WMTS/XYZ/RASTER) and ``url``/``layerIdentifier``/``attribution``
 *   tell the client how to fetch it. Geometry fields are null.
 * * ``origin = "COMPANY"`` — a waste-company-edited zone boundary
 *   (``routes.Zone``, 3.1.43); ``kind = "ZONE"`` and ``boundaryGeojson`` is
 *   the geometry (WGS84) the client renders directly. Service fields are null.
 *
 * Not a Django model type: it unions two models into the one flat shape the
 * map client renders + toggles, built once in
 * ``routes.services.map_layer_catalog`` so the API and its tests share a
 * single computation site. Company-walled and office-only at the resolver
 * (same rule as ``allZones`` / ``allExternalMapLayers``).
 */
export type MapLayerCatalogEntryDef = {
  __typename: 'MapLayerCatalogEntryDef';
  attribution?: Maybe<Scalars['String']['output']>;
  boundaryGeojson?: Maybe<Scalars['JSONString']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  defaultVisible: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  layerIdentifier?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  origin: Scalars['String']['output'];
  refreshIntervalMinutes?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  zOrder: Scalars['Int']['output'];
};

/**
 * Stamp every not-yet-seen background-job notification of the current
 * user ``date_seen`` at once — what opening the "Background jobs" tab
 * does, the job twin of ``MarkAllUserNotificationsSeen``.
 *
 * Seen is NOT read here: ``allUserJobNotifications`` hides a job by
 * ``read_by`` (the per-card dismiss, ``MarkUserJobNotificationRead``),
 * so touching ``date_read``/``read_by`` from the tab would empty the
 * list the operator just opened. Only the bell badge
 * (``allUserJobNotifications(unseen: true)``) is meant to drop to zero.
 */
export type MarkAllUserJobNotificationsSeen = {
  __typename: 'MarkAllUserJobNotificationsSeen';
  /** How many job notifications were unseen and are now seen. */
  marked?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type MarkAllUserNotificationsRead = {
  __typename: 'MarkAllUserNotificationsRead';
  status?: Maybe<Scalars['String']['output']>;
};

export type MarkAllUserNotificationsSeen = {
  __typename: 'MarkAllUserNotificationsSeen';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Upsert the current operator's read marker for a general conversation.
 *
 * Drives the back-office unread badge. Scoped and gated exactly like the reply
 * mutation, so an operator can only mark their own company's general
 * conversations read; a foreign / hauler / ticket id resolves to the clean
 * "not found" denial.
 */
export type MarkCompanyPortalConversationRead = {
  __typename: 'MarkCompanyPortalConversationRead';
  conversation?: Maybe<PortalConversationDef>;
};

/**
 * Record a futile (wasted) visit on one order line (HAUL-413,
 * S4-O1 office path). Reason speaks the execution layer's deviation
 * vocabulary; photo evidence references EXISTING ticket attachments
 * on the line's linked work order. The result is a fault SUGGESTION
 * — no fee is produced here, ever.
 */
export type MarkHaulerLineFutile = {
  __typename: 'MarkHaulerLineFutile';
  futileVisit?: Maybe<HaulerFutileVisitDef>;
};

/**
 * Close an order commercially (S3-O1, HAUL-409/419): recompute
 * the rollup, require DONE, run the paper gate — VERIFIED and billed
 * through the money lane's plain-data contract, or held PENDING with
 * the reasons in ``missingPaper``. Flag-gated and contractor-denied
 * like every hauler-mode surface (D-E10 DENIED stance — the sweep
 * classifies root Query fields; this mutation rides the same
 * ``_require_company`` gate, proven by tests).
 */
export type MarkHaulerOrderCompleted = {
  __typename: 'MarkHaulerOrderCompleted';
  /** Why the order was held PENDING — empty when it went through to VERIFIED/INVOICED. */
  missingPaper?: Maybe<Array<Scalars['String']['output']>>;
  order?: Maybe<HaulerOrderDef>;
};

/**
 * Bulk close (FIXIT2-O2, NID REQ-090): mark MANY orders completed
 * in one call — one transaction per order, partial success reported
 * per order (done / pending-with-reasons / failed-with-human-words).
 * The 300-WO/day office closes the day in a few clicks instead of
 * 300. Rides the same gate as every hauler-mode surface.
 */
export type MarkHaulerOrdersCompleted = {
  __typename: 'MarkHaulerOrdersCompleted';
  completedCount?: Maybe<Scalars['Int']['output']>;
  failedCount?: Maybe<Scalars['Int']['output']>;
  pendingCount?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<HaulerBulkCompletionResultDef>>>;
};

/**
 * UNSENT → SENT + journal entry. STAGED honesty: nothing is
 * transmitted — external dispatch (e-mail/NemHandel) is a founder-staged
 * action in W1 (hard limit).
 */
export type MarkInvoiceSent = {
  __typename: 'MarkInvoiceSent';
  invoice?: Maybe<HaulerInvoiceDef>;
};

/**
 * The explicit human act that gives a manifest gap an owner
 * (RS-E24, D62): the data is unavailable, the documented fallback
 * applies, the node stops blocking. ``unavailable: false`` clears
 * the mark and the node recomputes from the uploads.
 */
export type MarkManifestNodeUnavailableMutation = {
  __typename: 'MarkManifestNodeUnavailableMutation';
  manifestNode?: Maybe<ManifestNodeDef>;
};

export type MarkUserJobNotificationRead = {
  __typename: 'MarkUserJobNotificationRead';
  userJobNotification?: Maybe<UserJobNotificationType>;
};

export type MarkUserNotificationRead = {
  __typename: 'MarkUserNotificationRead';
  userNotification?: Maybe<UserNotificationType>;
};

export type MarkUserNotificationSeen = {
  __typename: 'MarkUserNotificationSeen';
  userNotification?: Maybe<UserNotificationType>;
};

export type MasterDataSyncDef = Node & {
  __typename: 'MasterDataSyncDef';
  company: CompanyType;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isDryRun: Scalars['Boolean']['output'];
  numMasterObjects: Scalars['Int']['output'];
  numPropertiesFailed: Scalars['Int']['output'];
  numPropertiesSynced: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: CrmMasterDataSyncStatusChoices;
  type: CrmMasterDataSyncTypeChoices;
};

export type MasterDataSyncDefConnection = {
  __typename: 'MasterDataSyncDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MasterDataSyncDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `MasterDataSyncDef` and its cursor. */
export type MasterDataSyncDefEdge = {
  __typename: 'MasterDataSyncDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MasterDataSyncDef>;
};

/** Office manual match — the queue that stops anything being dropped. */
export type MatchWeighTicket = {
  __typename: 'MatchWeighTicket';
  weighTicket?: Maybe<WeighTicketType>;
};

/**
 * Materialize a case's CONFIRMED grammar claims into dated
 * route-runs 12 to 18 months ahead (RS-E25, stage F, D56). Runs
 * are versioned staging objects, never live routes or calendars;
 * re-materializing stores a diff (added/removed/moved/changed)
 * against the previous version, never a duplicate world. Refuses
 * while the completeness manifest has blocking requirements (D62).
 * ``anchorDate`` defaults to today HERE, in the view; the library
 * itself always takes it explicitly.
 */
export type MaterializeImportCaseMutation = {
  __typename: 'MaterializeImportCaseMutation';
  materialization?: Maybe<CaseMaterializationDef>;
  runCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * RS-E25: one dated route-run (staging, D56): the client's own
 * route identity (D58), the service date as data, the fraction
 * set, and the claims it derives from.
 */
export type MaterializedRunDef = Node & {
  __typename: 'MaterializedRunDef';
  binCount?: Maybe<Scalars['Int']['output']>;
  case: ImportCaseDef;
  detail: Scalars['JSONString']['output'];
  fractionSet: Scalars['JSONString']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  materialization: CaseMaterializationDef;
  occurrence: Scalars['Int']['output'];
  routeIdentity: Scalars['String']['output'];
  runKind: RouteStudioMaterializedRunRunKindChoices;
  sequenceLocked: Scalars['Boolean']['output'];
  serviceDate: Scalars['Date']['output'];
  sourceClaimRefs: Scalars['JSONString']['output'];
  stopCount?: Maybe<Scalars['Int']['output']>;
  stopSequence: Scalars['JSONString']['output'];
  /** The materialization version this run belongs to. */
  version?: Maybe<Scalars['Int']['output']>;
};

export type MaterializedRunDefConnection = {
  __typename: 'MaterializedRunDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MaterializedRunDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `MaterializedRunDef` and its cursor. */
export type MaterializedRunDefEdge = {
  __typename: 'MaterializedRunDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MaterializedRunDef>;
};

export type MatrikkelConfigDef = Node & {
  __typename: 'MatrikkelConfigDef';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Municipality codes (kommunenummer) to scan for new properties, e.g. 3446, 3234, 3236 */
  municipalityCodes: Array<Scalars['String']['output']>;
  syncEnabled: Scalars['Boolean']['output'];
  /** Ticket type to create when a property mismatch or new property is detected */
  ticketType?: Maybe<TicketTypeDef>;
};

/** A single aggregate measure to compute (mirrors plan_schema.MeasureSpec). */
export type MeasureInput = {
  agg: Scalars['String']['input'];
  field?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MeasurementSettingsType = Node & {
  __typename: 'MeasurementSettingsType';
  custom: Scalars['Boolean']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  deviceToContainerSet: DeviceToContainerTypeConnection;
  excludeDays?: Maybe<Array<Scalars['String']['output']>>;
  excludePeriodEnd?: Maybe<Scalars['Date']['output']>;
  excludePeriodEveryYear: Scalars['Boolean']['output'];
  excludePeriodStart?: Maybe<Scalars['Date']['output']>;
  hours?: Maybe<Array<Scalars['Int']['output']>>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  measureAt: Scalars['Int']['output'];
  measurementExcludeDays?: Maybe<Array<Scalars['String']['output']>>;
  measurementHours?: Maybe<Array<Scalars['Int']['output']>>;
  measurementMeasurementsPerHour?: Maybe<Scalars['Int']['output']>;
  measurementsPerHour: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  project: ProjectType;
};


export type MeasurementSettingsTypeDeviceToContainerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MeasurementSettingsTypeConnection = {
  __typename: 'MeasurementSettingsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MeasurementSettingsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MeasurementSettingsType` and its cursor. */
export type MeasurementSettingsTypeEdge = {
  __typename: 'MeasurementSettingsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MeasurementSettingsType>;
};

export enum MediaContentEnumType {
  DOCS = 'DOCS',
  PHOTO = 'PHOTO'
}

/** An enumeration. */
export enum MetaTypeDisplayOnType {
  AGREEMENT_TABLE = 'AGREEMENT_TABLE',
  CONTAINER_TABLE = 'CONTAINER_TABLE',
  NAVIGATION_APP = 'NAVIGATION_APP',
  PROPERTY_CARD = 'PROPERTY_CARD',
  PROPERTY_TABLE = 'PROPERTY_TABLE'
}

/** An enumeration. */
export enum MetaTypeEntity {
  CONTAINER = 'CONTAINER',
  CONTAINER_TYPE = 'CONTAINER_TYPE',
  PROPERTY = 'PROPERTY',
  PROPERTY_GROUP = 'PROPERTY_GROUP',
  SPARE_PART = 'SPARE_PART'
}

/**
 * One entry of the metered computation menu (R2-S13): the FE renders
 * unavailable entries disabled, annotated with the reason.
 */
export type MeteredComputationOptionType = {
  __typename: 'MeteredComputationOptionType';
  available: Scalars['Boolean']['output'];
  computation: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** Why the computation cannot be activated; null when available. */
  unavailableReason?: Maybe<Scalars['String']['output']>;
};

export type MetricDefinitionType = {
  __typename: 'MetricDefinitionType';
  additive: Scalars['Boolean']['output'];
  blendable: Scalars['Boolean']['output'];
  certified: Scalars['Boolean']['output'];
  compatibleVizzes: Array<Scalars['String']['output']>;
  defaultViz: Scalars['String']['output'];
  description: Scalars['String']['output'];
  dimensions: Array<Scalars['String']['output']>;
  drill?: Maybe<Scalars['GenericScalar']['output']>;
  goodDirection?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  metricId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supportsTimeSeries: Scalars['Boolean']['output'];
  synonyms?: Maybe<Array<Scalars['String']['output']>>;
  unit: Scalars['String']['output'];
};

/** Model for connection to the mobile application */
export type MobileAppType = Node & {
  __typename: 'MobileAppType';
  brand: Scalars['String']['output'];
  build: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  deviceUid: Scalars['String']['output'];
  /** Relation to Mobile App */
  drivers: DriverTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  os: Scalars['String']['output'];
  systemVersion: Scalars['String']['output'];
  token?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
};


/** Model for connection to the mobile application */
export type MobileAppTypeDriversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MobileAppTypeConnection = {
  __typename: 'MobileAppTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MobileAppTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MobileAppType` and its cursor. */
export type MobileAppTypeEdge = {
  __typename: 'MobileAppTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MobileAppType>;
};

export type MobileDeviceType = BaseDeviceInterface & Node & {
  __typename: 'MobileDeviceType';
  antenna: DeviceMobileDeviceAntennaChoices;
  batch: Scalars['String']['output'];
  bootloaderFwVersion: Scalars['String']['output'];
  company?: Maybe<CompanyType>;
  connectionType?: Maybe<Scalars['String']['output']>;
  containerDevice?: Maybe<DeviceToContainerTypeConnection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  devId?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<DeviceTypeType>;
  hwVersion?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imei?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isContainer?: Maybe<Scalars['Boolean']['output']>;
  isGps?: Maybe<Scalars['Boolean']['output']>;
  measurements?: Maybe<FillLevelMeasurementTypeConnection>;
  modemFwVersion: Scalars['String']['output'];
  productNo: Scalars['String']['output'];
  simcard?: Maybe<SimCardType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  whsFwVersion: Scalars['String']['output'];
};


export type MobileDeviceTypeContainerDeviceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type MobileDeviceTypeMeasurementsArgs = {
  From?: InputMaybe<Scalars['DateTime']['input']>;
  To?: InputMaybe<Scalars['DateTime']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MobileDeviceTypeConnection = {
  __typename: 'MobileDeviceTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MobileDeviceTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MobileDeviceType` and its cursor. */
export type MobileDeviceTypeEdge = {
  __typename: 'MobileDeviceTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MobileDeviceType>;
};

/**
 * 'Monitor this' straight from a metric a user is looking at — a
 * deterministic alert with no NL compiler and no AI gate: the metric,
 * threshold and direction are explicit, validated against the governed
 * engine (validate_rule), and the subscription starts PENDING so the
 * confirmation gate (Behavior 7) still holds before anything fires.
 */
export type MonitorInsightsMetric = {
  __typename: 'MonitorInsightsMetric';
  alert?: Maybe<Scalars['GenericScalar']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** The live driver-GPS monitoring register (no driver data — by design). */
export type MonitoringRegisterDef = {
  __typename: 'MonitoringRegisterDef';
  accessAuditEnabled: Scalars['Boolean']['output'];
  accessAuditLast30dCount: Scalars['Int']['output'];
  accessComplianceRoles: Scalars['Int']['output'];
  accessViewRoles: Scalars['Int']['output'];
  auditDedupSeconds: Scalars['Int']['output'];
  collectedFields: Array<Scalars['String']['output']>;
  companyId: Scalars['ID']['output'];
  dpiaCompletedAt?: Maybe<Scalars['Date']['output']>;
  dpiaReference?: Maybe<Scalars['String']['output']>;
  /** Explicit statement that GPS never scores a driver. */
  driverScoringStatement: Scalars['String']['output'];
  fullResolutionDays: Scalars['Int']['output'];
  generatedAt: Scalars['DateTime']['output'];
  minuteResolutionDays: Scalars['Int']['output'];
  monitoringNoticeGivenAt?: Maybe<Scalars['Date']['output']>;
  offShiftGateEnabled: Scalars['Boolean']['output'];
  onShiftDefinition: Scalars['String']['output'];
  proofBundleRetention: Scalars['String']['output'];
  purpose: Scalars['String']['output'];
  rawRetentionDays: Scalars['Int']['output'];
  rlhPruneEnabled: Scalars['Boolean']['output'];
  shiftStartGraceMinutes: Scalars['Int']['output'];
  worksCouncilApprovedAt?: Maybe<Scalars['Date']['output']>;
};

/** A ready-to-download register file (bytes inline, base64). */
export type MonitoringRegisterExportDef = {
  __typename: 'MonitoringRegisterExportDef';
  /** The file bytes, base64-encoded. */
  contentBase64: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

/** An enumeration. */
export enum MonthlyIntervalEnum {
  AT_THE_END_OF_THE_MONTH = 'at_the_end_of_the_month',
  AT_THE_START_OF_THE_MONTH = 'at_the_start_of_the_month'
}

/**
 * Move stops between routes — the D-E18(b) modal's backend
 * (FIXIT2-O1, mode-1 F1/F2/F8). DELEGATES to the existing
 * ``Route.action_stops_move`` through ``services.stop_moves`` (never
 * a second mover); the whole move is one transaction, every source
 * route gets a ``DispatchAction`` audit row, and a routing-engine
 * outage answers with ONE human sentence — nothing moved, no raw
 * infra text. Flag-gated and contractor-denied like every
 * hauler-mode surface (D-E10 DENIED stance).
 */
export type MoveHaulerStops = {
  __typename: 'MoveHaulerStops';
  /** The pks of the stops now on the target route. */
  movedStopIds?: Maybe<Array<Scalars['ID']['output']>>;
  targetRouteId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Move a member property to another Shared Collection Point.
 *
 * Ends the source membership at ``moveDate`` (redistributing its share over
 * the remaining members — proportionally, or via ``sourceShares``) and joins
 * the target SCP at the same date with the carried-over share (or ``share``,
 * percent), attributes and active roles; the target pool is re-balanced.
 * When warnings exist (property outside the target's default radius, active
 * agreements following the move) the caller must re-submit with
 * ``confirm=True``; the first call returns ``requiresConfirmation=True`` and
 * ``warnings`` without mutating anything.
 */
export type MoveScpMembership = {
  __typename: 'MoveScpMembership';
  requiresConfirmation?: Maybe<Scalars['Boolean']['output']>;
  scpMembership?: Maybe<ScpMembershipDef>;
  seasonalConflict?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MunicipalityDef = Node & {
  __typename: 'MunicipalityDef';
  /** May year-round and summer dwellings share one shared residential service (kimppa) in this municipality? */
  allowKimppaUsageMixing: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  company: CompanyType;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Maximum member count of a shared residential service (kimppa) in this municipality; empty = unrestricted */
  maxKimppaMembers?: Maybe<Scalars['Int']['output']>;
  /** Lower member cap applying when the kimppa serves a biowaste fraction; empty = unrestricted */
  maxKimppaMembersBio?: Maybe<Scalars['Int']['output']>;
  /** Permanent-dwelling base fee in euros per year; a kimppa share implying a smaller yearly amount draws an advisory warning. Empty = no floor. */
  minAnnualFeeEur?: Maybe<Scalars['Decimal']['output']>;
  name: Scalars['String']['output'];
  /** Default SCP compliance radius in metres */
  scpDefaultRadiusM?: Maybe<Scalars['Int']['output']>;
  /** Municipality whose compliance radius applies to this SCP */
  scpProfiles: ScpProfileDefConnection;
};


export type MunicipalityDefScpProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MunicipalityDefConnection = {
  __typename: 'MunicipalityDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MunicipalityDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `MunicipalityDef` and its cursor. */
export type MunicipalityDefEdge = {
  __typename: 'MunicipalityDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MunicipalityDef>;
};

export type Mutations = {
  __typename: 'Mutations';
  /**
   * Mark a suggestion ACCEPTED and link the Flow built from it — the
   * suggestion-lifecycle write the builder calls after creating a draft
   * from a Pulse suggestion, so the pitch stops re-appearing as a "top
   * thing to automate" once it has been built (founder-reported gap).
   * Tenant-scoped on both rows; idempotent (re-accepting is a no-op).
   */
  acceptAutopilotSuggestion?: Maybe<AcceptAutopilotSuggestion>;
  /**
   * Convert a customer request into a customer, a property and a rental
   * in one step (PRODUCT-484). ``contactId`` / ``propertyId`` override the
   * automatic match the preview showed.
   */
  acceptCustomerRequest?: Maybe<AcceptCustomerRequest>;
  /**
   * RS-1203 accept with audit: acted_by/acted_at on the row plus
   * the route_studio.recommendation.accepted event; acceptance is the
   * EV-RECS positive label.
   */
  acceptRecommendation?: Maybe<AcceptRecommendationMutation>;
  /**
   * Called by the frontend after a successful SSO login that originated from
   * an invite link.  Activates the invited IoUser once the SSO identity has
   * been verified (email of the logged-in SSO user must match the invite).
   */
  acceptSsoInvite?: Maybe<AcceptSsoInvite>;
  acknowledgeInsightCard: AcknowledgeInsightCard;
  /**
   * Acquire an edit-lease on entering edit mode (idempotent for the
   * same user). Also returns the entity's currentVersion so the client
   * skips a separate version fetch (API contract).
   */
  acquireRecordLease?: Maybe<AcquireRecordLease>;
  /**
   * Promote a `test`-state Flow to `live` (AP-703: the activation gate).
   *
   * The one gated path to `live` in this schema -- see the module
   * docstring's "AP-703/Activation gate" paragraph and
   * `autopilot.runtime.activation_gate`'s own docstring for the full
   * contract. Deny by default: `gate_kind` must be `simulation` (an AP-701
   * replay already recorded for the exact `FlowVersion` being activated,
   * see `autopilot.runtime.activation_gate.record_simulation_run`) or
   * `override` (a non-blank `gate_reason`); anything else -- including
   * omitting `gate_reason` for an override -- is refused as a business
   * error (`ok=False` + `errors`), never a silent default and never a
   * GraphQL exception. All the real gate logic and the audit write live in
   * `activate_flow` itself, not here, so a direct Python caller (tests,
   * future internal callers) gets the exact same enforcement and the exact
   * same `FlowAuditLogEntry` this mutation does. `activate_flow` also
   * re-runs `validate_for_builder` against the target version (review fix);
   * a registry-drift violation comes back as a per-field `errors` entry,
   * the same shape `PromoteAutopilotFlow`/`RollbackAutopilotFlow` use.
   *
   * Story-fidelity note (updated, Wave 2 Lane E): `gate_kind='simulation'`
   * is reachable end-to-end -- record a `SimulationRun` first via
   * `RecordAutopilotSimulation` (one flow) or
   * `RecordAutopilotEstateSimulations` (every estate candidate at once),
   * then activate through this gate or through `ActivateConvertedFlows`.
   */
  activateAutopilotFlow?: Maybe<ActivateAutopilotFlow>;
  /**
   * AP-704's one-click "promote to live" action, the one edge
   * `AutopilotFlowPromotableState` deliberately does not expose through
   * the generic `PromoteAutopilotFlow`: `shadow` -> `live`, and only from
   * `shadow`.
   *
   * The accrued shadow report *is* this path's activation gate --
   * `04_BACKLOG.md`'s AC is "one-click promote to live carrying the
   * shadow evidence forward", not a second approval step -- so this
   * mutation does not ask for a reason or a confirmation beyond the flow
   * already having been watching live events. Separate from, and does not
   * call, `ActivateAutopilotFlow`/`autopilot.runtime.activation_gate
   * .activate_flow` (AP-703's general activation gate: "a simulation
   * record on file, or an explicit reasoned override"): that gate covers
   * every *other* route to `live`; this is the one dedicated route AP-704
   * adds on top of it, gated on its own evidence instead. What IS enforced
   * here, because the docstring above claims the report itself is the
   * gate: `report.run_count` must be nonzero. A flow can be promoted
   * straight from `test` to `shadow` and this mutation called in the very
   * next request, before a single live event has ever reached it; an empty
   * report is not evidence of anything and must not be accepted as this
   * path's gate. This is a floor, not AP-703's real activation gate
   * (a minimum run count is not "the flow behaves correctly"), and is
   * deliberately conservative alongside that gate, not a replacement for
   * it.
   *
   * Also refuses when `flow.has_unsaved_changes()`, the same guard
   * `PromoteAutopilotFlow` enforces before promoting into `test` or
   * `shadow`: an autosaved-but-uncommitted draft edit must not be able to
   * one-click activate the older committed version while the canvas shows
   * different logic, on this, the highest-stakes transition of all.
   *
   * "Carrying the shadow evidence forward" means literally: the report is
   * computed once, before the state changes, and written into the
   * `FlowAuditLogEntry.after` payload (`Action.PROMOTED_FROM_SHADOW`) so
   * it is preserved permanently in the audit trail, not merely
   * reconstructable for as long as the flow happens to still have shadow
   * `FlowRun` rows and someone remembers to look. The same report is also
   * returned on the mutation's response, for the confirmation screen.
   *
   * Review fix (AP-704 shadow-mode v2 hostile review, finding 2): also
   * freezes an `ImpactRecord` via `autopilot.impact_ledger
   * .freeze_impact_record`, the same "every route to live gets one" rule
   * `activate_flow` enforces for AP-703's routes -- this mutation not
   * calling `activate_flow` (see above) does not mean it gets to skip
   * that freeze too; without it a shadow-promoted flow was invisible in
   * the tenant Impact Ledger, could never accrue a `MeasuredOutcome`, and
   * was unrecognized by `rollback_flow`'s own gated check. Gated with
   * `gate_kind=ImpactRecord.GateKind.SHADOW` (AP-704) rather than
   * `OVERRIDE`: the accrued shadow report is neither a `SimulationRun`
   * nor a reasoned override, and mislabeling it as one would misrepresent
   * the audit trail (the Amir principle: never fabricate). `projected_
   * impact` is the same "unavailable" sentinel `activate_flow` defaults
   * to when AP-602's calculator has no real numbers to hand it (true here
   * too, as of this task). The promotion, the audit row, and the freeze
   * rise or fall together inside one `transaction.atomic()` block, the
   * same shape `activate_flow` already uses, for the same reason: a
   * failure freezing the ledger must not leave a Flow live-and-audited
   * with no frozen projection behind it.
   *
   * Wave 2 Lane D S3: this route now carries the same supersession
   * conflict gate as `ActivateAutopilotFlow` (it was the one ungated door
   * to LIVE for a converted flow): a still-firing non-GREEN source rule,
   * or a current trigger that has drifted away from the rule's
   * transition, is refused as a `sourceRuleConflict` error unless the
   * operator confirms via `disable_source_rule` -- confirming the former
   * force-suspends the rule atomically with the promotion, confirming the
   * latter goes live without touching the rule (see
   * `autopilot.services.legacy_rule_migration.SupersessionConflict`).
   * S5: the response also carries the same non-fatal legacy-origin
   * honesty `warnings` (`_legacy_origin_activation_warnings`).
   */
  activateAutopilotFlowFromShadow?: Maybe<ActivateAutopilotFlowFromShadow>;
  /**
   * Wave 2 Lane E S5: the wizard's "turn on" step -- evidence-gated
   * batch activation of converted flows. Each row goes through ONE atomic
   * `activate_flow(gate_kind='simulation')` (a DRAFT row is promoted to
   * TEST inside the same per-row transaction first), so every row gets
   * the full gate: a recorded `SimulationRun` for the exact current
   * version (record it with `RecordAutopilotEstateSimulations` first; a
   * row without one is `skipped_no_evidence`, NEVER silently downgraded
   * to an override), registry re-validation, the supersession conflict
   * gate, the frozen impact record, and the ACTIVATED audit row -- which
   * this mutation stamps with `batchLabel` so the whole batch can be
   * found and rolled back as one unit (`DeactivateConvertedFlows`).
   *
   * Refusals are per row and honest, never batch-fatal: a
   * `SourceRuleConflictError` comes back as `skipped_needs_confirm` for
   * THAT rule's own one-click confirm on the single-flow route -- this
   * mutation NEVER passes `disable_source_rule`, because a blanket
   * batch-wide rule-kill confirmation would hide exactly the decision the
   * conflict gate exists to force. Approval-class flows (an
   * approval-required step in the definition) are refused unless
   * explicitly listed in `approvalOptIn`, with the pause forecast priced
   * from the recorded simulation's own fired count, because the rule they
   * replace acted immediately and a flow that pauses ~N times a month is
   * a real behavioural change to opt into, not a default.
   */
  activateConvertedFlows?: Maybe<ActivateConvertedFlows>;
  addAssociatedTicketsToCompanyEmailAccountMessage?: Maybe<AddAssociatedTicketsToCompanyEmailAccountMessage>;
  addCard?: Maybe<AddCard>;
  /**
   * Office-only (B1.3): add one custom non-driving day. Idempotent
   * per (company, date) — re-adding an already-active date just
   * refreshes its name rather than erroring or duplicating.
   */
  addCompanyHolidayDay?: Maybe<AddCompanyHolidayDay>;
  addContactToProperties?: Maybe<AddContactToProperties>;
  /**
   * Office-only, audited: exclude one event from reliability with a
   * reason (D6). The event stays visible, flagged; it leaves the
   * denominator. Idempotent — re-adding refreshes the reason.
   */
  addReliabilityExclusion?: Maybe<AddReliabilityExclusion>;
  /**
   * Office-only, audited (R2-S12, R2-D19): book a manual one-off ± line
   * on a settlement period, with a mandatory reason. OPEN periods only —
   * the line flows into the settlement totals and freezes into the
   * snapshot when the period closes.
   */
  addSettlementAdjustment?: Maybe<AddSettlementAdjustment>;
  /** Correct a spare-part count at a warehouse (+/-N, reason, A1). */
  adjustSpareParts?: Maybe<AdjustSpareParts>;
  /**
   * Correct the count of an item type at a warehouse (ADR-0005):
   * one anonymous reason-coded ledger row, +N or -N. The recount tool
   * and the only non-ticket write path for warehouse counts; never
   * blocked by the current count - a disagreeing correction takes it
   * negative, and the negative renders red.
   */
  adjustStock?: Maybe<AdjustStock>;
  /**
   * RS-1501 one-click adoption: a normal draft scenario the
   * planner OWNS is branched from the exploration candidate. Adoption
   * is manual, never autonomous; nothing is solved or promoted here
   * (D37, D35).
   */
  adoptExplorationCandidate?: Maybe<AdoptExplorationCandidateMutation>;
  adoptFeatureConfigDrift?: Maybe<AdoptFeatureConfigDrift>;
  /**
   * Answer or explicitly defer a case question (stage D): a
   * deferred question is a visible open risk, never an invisible
   * default (D62, D63).
   */
  answerCaseQuestion?: Maybe<AnswerCaseQuestionMutation>;
  applyAutomationTemplate: ApplyTemplatePayload;
  /**
   * RS-1101/RS-1102 + RS-E11 (wave 2): apply the day's need-based
   * selection. The interactive tier sequences the selected units into
   * today's slack route (overlay, unchanged), and the accepted
   * insertions are materialized as real stops
   * (``created_from=dynamic``) on TODAY's live route through
   * ``services.live_dispatch``, so the driver app sees them today.
   * D35 gates, all hard: explicit human apply only, L3 (Guarded
   * Autopilot) areas only, audited
   * (``route_studio.dynamic_day.applied``). SBX-537 P1-1 (wave D23):
   * the explicit human is a MASTER; materializing stops onto today's
   * live route is the sharpest live-operations act on the surface
   * (RS-2009), and combined with the ungated autonomy dial any
   * assigned user could previously self-escalate an area to L3 and
   * inject stops the driver app saw the same day. Hygiene-bound
   * fractions were never selected (calendar keeps, by construction);
   * the plan artifact, its calendar entries and every container
   * calendar stay byte-identical.
   */
  applyDynamicDay?: Maybe<ApplyDynamicDayMutation>;
  /**
   * Match an uploaded bank statement against outstanding invoices and
   * REGISTER the confident matches through the S1-M5 payment service
   * (``register_invoice_payment``) — invoices flip PAID exactly when
   * covered. HAUL-919 v1's apply half.
   *
   * Nothing is transmitted: the file came from the operator and the only
   * output is the inert reconciliation report. Each line is independent and
   * the service guards the running total, so re-uploading the same statement
   * lands matched lines on "already paid" / "exceeds outstanding" — never a
   * double charge. No second payment path exists (INV-B): this is a matcher
   * on top of the one payment service.
   */
  applyHaulerBankReconciliation?: Maybe<ApplyHaulerBankReconciliation>;
  /**
   * REQ 3.3.25: apply an index (CPI/fuel) percentage to a hauler's active
   * prices — computed from the ORIGINAL contract price (``appliedTo: BASE``)
   * or the CURRENT amount (``appliedTo: CURRENT``), the user's choice.
   * Superseding rows carry ``base_amount`` forward; it is never mutated.
   * ``dryRun: true`` previews without writing.
   */
  applyHaulerPriceIndexAdjustment?: Maybe<ApplyHaulerPriceIndexAdjustment>;
  /**
   * 3.9.23 decision 7 (bulk-migrate): stamp a type's CURRENT visibility
   * scope onto its existing tickets. Overridden tickets (3.9.6) survive.
   *
   * Payload is a bare ``ok`` — progress surfaces through the existing
   * ``UserJobsNotification`` jobs feed (``BulkActionProgress`` is created
   * INSIDE the celery task); no progress handle exists at this layer.
   */
  applyTicketTypeVisibilityToTickets?: Maybe<ApplyTicketTypeVisibilityToTickets>;
  /**
   * Office-only, FOUR-EYES (PRO-465): a SECOND permission holder approves a
   * draft entry so it lands in settlement. The creator can NEVER approve their
   * own entry — refused at the API level, not just hidden in the client.
   */
  approveContractorManualEntry?: Maybe<ApproveContractorManualEntry>;
  /**
   * The D42 gate: a human approves every document before it leaves
   * the system. Draft to approved, stamped, one way.
   */
  approveNarrativeDocument?: Maybe<ApproveNarrativeDocumentMutation>;
  /**
   * The D18 approval step; blocked without a notification plan
   * (F11: promotion cannot complete with notifications unresolved).
   * SBX-370: when the diff's cross-area conflict count is nonzero,
   * approval additionally requires the explicit
   * ``acknowledgeConflicts`` flag; taking over another area's
   * containers is a human call (D18/D32), never a side effect.
   * SBX-376: when the stop-set churn exceeds the warn threshold
   * (snapshot age + containers added/removed/moved since), approval
   * requires the explicit ``acknowledgeChurn`` flag, same pattern.
   * SBX-368: with the company's optional two-step chain ON
   * (``CompanySettings.route_studio_two_step_approval``), a
   * non-designated user's call records a PROPOSAL (state
   * ``proposed``, audited event) and a designated approver
   * (``access.is_designated_approver``: master for now, the
   * CompanyRolePermission seam) must call again for the final
   * approval; execute always requires that final approval.
   */
  approvePromotion?: Maybe<ApprovePromotionMutation>;
  /**
   * REQ-267 approval: creates the previewed follow-up tickets.
   * Idempotent — a second approval creates nothing new.
   */
  approveTicketBatch: ApproveTicketBatch;
  archiveAutomation: ArchiveAutomationPayload;
  archiveBillingRun?: Maybe<ArchiveBillingRun>;
  archiveProduct?: Maybe<ArchiveProduct>;
  /**
   * Manually archive (``archive: true``) or restore (``archive: false``)
   * one record. The generic counterpart of ``archiveProduct`` — restoring
   * just clears the archive metadata, so the record returns to its exact
   * pre-archiving state.
   */
  archiveRecord?: Maybe<ArchiveRecord>;
  archiveScenario?: Maybe<ArchiveScenarioMutation>;
  /**
   * Manually trigger an ACOS archive POST for a ticket + document_type.
   *
   * Validates that the caller is permitted to edit tickets in the company
   * and that an `AcosTicketTypeMapping` exists for the (ticket_type,
   * document_type) pair. Schedules `archive_ticket_to_acos.delay(...)` via
   * `transaction.on_commit` and returns the freshly-created log row.
   */
  archiveTicketToAcos?: Maybe<ArchiveTicketToAcos>;
  /**
   * Behavior 1 — conversational analytics through the agent loop.
   *
   * The model reasons and narrates; every number comes from a W5.1
   * tool result. Gated like all AI surfaces on insights_enabled +
   * insights_ai_enabled.
   */
  askInsightsAnalyst: AnalystAnswerResult;
  /**
   * SBX-361 / RS-2013 item (b), the human door (D35, D18): bulk
   * assign needs-assignment containers (see the nightly report on the
   * promotion's ``materializationLog.needs_assignment``) into the
   * LIVE promotion's scheme, each onto the scheme's nearest-cohort
   * collection calendar, through the platform's own setters. Per-row
   * honest skips ride the returned report; nothing is ever assigned
   * without this explicit call.
   */
  assignContainersToPromotedScheme?: Maybe<AssignContainersToPromotedSchemeMutation>;
  assignCustomerFunctionsToContact?: Maybe<AssignCustomerFunctionsToContact>;
  /** Update a key's customer refs / handover fields (AC1/AC4). */
  assignKey?: Maybe<AssignKey>;
  /** Assign a role to an SCP membership from an optional start date. */
  assignScpMembershipRole?: Maybe<AssignScpMembershipRole>;
  assignTicket?: Maybe<AssignTicket>;
  /**
   * PRO-824 (HSY req 147): hand a ticket to a third-party contractor.
   *
   * Omitting ``hauler_id`` (or passing null) takes the hand-over back, and
   * the ticket returns to the derived contract-area attribution.
   *
   * This is a SHARING action, not just a label: ``service_provider`` is a
   * disjunct of ``hauler_ticket_scope_q``, so the named contractor gains
   * the ticket in their own list. Two things bound that grant — the hauler
   * must belong to the ticket's company (checked in
   * ``Ticket.set_service_provider``), and ``Ticket.visible_to`` still
   * composes BEFORE the hauler scope on every read path, so handing over a
   * visibility-restricted ticket does not by itself expose it.
   *
   * Authorization mirrors ``AssignTicket`` / ``SetTicketDeadline``
   * (login + company scope + visibility scope + the 3.12.5 edit lease),
   * plus the office wall: a contractor account must not be able to pass
   * work to another contractor. ``assert_office_user`` is explicitly only
   * half a gate (see its docstring) — the other half here is that the
   * fetch is already narrowed to tickets this caller can see.
   */
  assignTicketServiceProvider?: Maybe<AssignTicketServiceProvider>;
  assignTicketToTeam?: Maybe<AssignTicketToTeam>;
  assignUserCompanyRole?: Maybe<AssignUserCompanyRole>;
  /**
   * Office-only (PRO-118): attach ONE agreement from the Pending queue
   * (an office decision, change-logged as an attach).
   */
  attachAreaAgreement?: Maybe<AttachAreaAgreement>;
  attachDeviceToContainer?: Maybe<AttachDeviceToContainer>;
  /**
   * The F11/D09 comms gate artifact: audiences, languages, lead
   * time, per-language copy ({lang: {subject, body[,
   * rollback_subject, rollback_body]}}).
   */
  attachNotificationPlan?: Maybe<AttachNotificationPlanMutation>;
  /**
   * Attach existing Container assets to a Block/Regional SCP (NEXUS-642).
   *
   * ADR-0003: the containers stay the SAME ``device.Container`` assets, so
   * every container workflow (pickup, cleaning, replacement tickets, routing)
   * keeps working untouched. Kind-gated: Shared Residential points derive
   * containers from member agreements and cannot attach. Blocked on a
   * terminated SCP.
   */
  attachScpContainers?: Maybe<AttachScpContainers>;
  /**
   * Persist the canvas UI's in-progress edit as the mutable working copy
   * (`Flow.draft_definition`), unconditionally (AP-402).
   *
   * Unlike `UpdateAutopilotFlowDefinition`, this never blocks on validation
   * and never creates a `FlowVersion`: autosave exists precisely so an
   * incomplete, mid-edit canvas is never lost. Validation still runs, its
   * result comes back as `validationErrors`/`validationWarnings` -- data for
   * the UI to render inline, never a reason to refuse the write. `errors`
   * (and `ok`) only ever reflect structural problems with the request itself
   * (tenant disabled, flow not found or not this tenant's, flow not in
   * `draft` state): the same three guards `UpdateAutopilotFlowDefinition`
   * enforces, because autosave is still bounded to "editing a draft flow"
   * (a `test`/`live` flow must be demoted first, same as a full commit).
   */
  autosaveAutopilotFlowDraft?: Maybe<AutosaveAutopilotFlowDraft>;
  /**
   * Branch a scenario: a fresh draft copying the full config with
   * lineage kept via ``parent`` (RS-202 AC).
   */
  branchScenario?: Maybe<BranchScenarioMutation>;
  /**
   * Build Baseline Zero from an imported stop set when no history
   * exists (RS-602). Clearly labeled kind='reconstruction' and never
   * claim-grade (D32).
   */
  buildReconstructionBaseline?: Maybe<BuildReconstructionBaselineMutation>;
  /**
   * Build the digital-twin replay baseline from the RS-303 replay
   * observations in a window (RS-602, D17, 05_ENGINE_SPEC section 9).
   * Naming is mandatory: every KPI delta names its baseline.
   */
  buildReplayBaseline?: Maybe<BuildReplayBaselineMutation>;
  /**
   * Office-only: accepts the policy-computed outcome for the given
   * rows on one holiday. Per-row atomic, partial success — never
   * all-or-nothing. ``preview: true`` dry-runs every row (no writes) —
   * an additional optional backend argument beyond the FE/BE contract
   * (F6), harmless to clients that never pass it.
   */
  bulkAcceptHolidayImpact?: Maybe<BulkAcceptHolidayImpact>;
  /**
   * SBX-518 (F1): confirm N same-class candidate tables in one
   * call with per-row outcomes {ref, label, outcome, reason_code,
   * reason} (snake_case wire, D74). Rows whose classifier verdict
   * already reads ``docClass`` are confirmed; every ambiguous or
   * conflicting row is refused BY NAME with its reason, never
   * bulk-swept (D62; the single confirm stays the override surface).
   * Whole-request refusals ride the D6 transport.
   */
  bulkConfirmCandidateTableClass?: Maybe<BulkConfirmCandidateTableClassMutation>;
  /**
   * SBX-518 (F6): confirm N grammar claims in one call with
   * per-row outcomes {ref, label, outcome, reason_code, reason}
   * (snake_case wire, D74); the sibling of the validation room's
   * batch verdicts (SBX-473) at the claims stage. Every row that
   * needs a HUMAN decision (below-threshold engine claims, claims a
   * newer upload disagrees with, undated calendar claims, pending
   * questions, recorded corrections or rejections) is refused BY
   * NAME with its reason, never bulk-swept (D62). Whole-request
   * refusals ride the D6 transport.
   */
  bulkConfirmGrammarClaims?: Maybe<BulkConfirmGrammarClaimsMutation>;
  bulkCreateBulkWastePickupTicket?: Maybe<BulkCreateBulkWastePickupTicket>;
  bulkCreateContainerNotification?: Maybe<BulkCreateContainerNotificationPayload>;
  bulkCreateManageContainerTicket?: Maybe<BulkCreateManageContainerTicket>;
  bulkCreateTicket?: Maybe<BulkCreateTicket>;
  /**
   * Permanently delete the company's archived records of one data type,
   * optionally only those archived more than ``archivedForDays`` days ago.
   * Records referenced by protected data, and records whose deletion would
   * cascade to still-ACTIVE archivable dependents, are skipped and
   * counted.
   */
  bulkDeleteArchived?: Maybe<BulkDeleteArchived>;
  /**
   * Import real containers into a warehouse from a parsed file (Anders
   * C): materializes individual ``in_storage`` Container identities on the
   * shelf (visible in the In-storage tab) AND writes the matching receive
   * ledger rows so the counted Balances stays in sync. All-or-nothing.
   */
  bulkImportContainers?: Maybe<BulkImportContainers>;
  /**
   * Handles operations related to bulk pairing of containers with RFID tags.
   *
   * This class is a GraphQL mutation that provides functionality for bulk pairing
   * containers with RFID tags. It ensures that multiple mappings can be created in
   * a single operation, optimizing efficiency and reducing manual errors. The
   * mutation performs validation, processes input, and returns an appropriate
   * response.
   *
   * Attributes:
   *     Input (graphene.InputObjectType): Defines the input type required for the
   *         mutation. This contains all necessary fields that the mutation needs to
   *         perform its operation.
   *     Output (graphene.ObjectType): Specifies the structure of the mutation's
   *         output. It holds the results of the mutation and any additional
   *         information, such as errors or success messages.
   */
  bulkPairContainerRfid?: Maybe<BulkPairContainerRfid>;
  /**
   * Receive many item types into one warehouse in a single action
   * (B6, Anders): the bulk counterpart of ReceiveStock for a large
   * purchase / delivery. All rows land in one transaction - a bad row
   * rolls the whole batch back, so the count never lands half-applied.
   */
  bulkReceiveStock?: Maybe<BulkReceiveStock>;
  bulkSetFeatureConfig?: Maybe<BulkSetFeatureConfig>;
  bulkSetTicketRoutes?: Maybe<BulkSetTicketRoute>;
  /**
   * This mutation is preferred over UpdateAgreement when updating multiple agreements
   * at once to update common fields for all agreements (recurring and non-recurring).
   * This mutation will update the container status if needed.
   */
  bulkUpdateAgreement?: Maybe<BulkUpdateAgreement>;
  bulkUpdateCompanyEmailAccountMessage?: Maybe<BulkUpdateCompanyEmailAccountMessage>;
  bulkUpdateContainer?: Maybe<BulkUpdateContainer>;
  /**
   * REQ 3.3.24: apply a bulk price correction (a percentage or a fixed
   * additive cents delta) to all/selected products of a hauler, optionally
   * narrowed to one area. ``preview: true`` returns the impact — per-product
   * old/new amounts and the affected-unpaid-event count — without writing
   * anything.
   */
  bulkUpdateHaulerPrices?: Maybe<BulkUpdateHaulerPrices>;
  bulkUpdateTicket?: Maybe<BulkUpdateTicket>;
  /**
   * COMPASS-1773: cancel a live suspension. The window stops applying
   * at once (future dates are collected again by the next generation run)
   * and the stops it released are put back where the world has not moved
   * on since — a stop whose route has started, completed or vanished, or
   * whose day has been re-planned, is reported in ``skipped`` instead of
   * forced.
   */
  cancelAgreementSuspension?: Maybe<CancelAgreementSuspension>;
  /** Abandon a promotion any time before materialization. */
  cancelPromotion?: Maybe<CancelPromotionMutation>;
  /** Close an open purchase order; received quantities stay. */
  cancelPurchaseOrder?: Maybe<CancelPurchaseOrder>;
  /**
   * Group-cancel a planned relocation before its moving date — every
   * composed write reversed through its own mechanism (req 3.1.38).
   */
  cancelRelocation?: Maybe<CancelRelocation>;
  /** Cancel a PENDING scheduled customer-data change (req 3.1.38). */
  cancelScheduledChange?: Maybe<CancelScheduledChange>;
  /**
   * Session 4 CI-1 (SBX-493/SBX-502): cancel is truthful. A run
   * still queued, building its matrix or solving is TRULY canceled:
   * the row flips under a lock and the worker checks it at every
   * stage boundary and again inside the plan-record transaction, so
   * an accepted cancel means no plan will arrive. A run past the
   * point of no return (scoring or explaining, or already done)
   * REFUSES the cancel through the D6 transport (run_just_finished)
   * instead of accepting and delivering a plan anyway, which is
   * exactly the lie the walk caught.
   */
  cancelSimulationJob?: Maybe<CancelSimulationJobMutation>;
  cancelTransferDocument?: Maybe<CancelTransferDocument>;
  /**
   * Change a container's structured condition (PRO-391, 3.12.28).
   *
   * Writes are gated exactly like a container edit
   * (``CompanyRolePermission.check_edit``), mirroring
   * ``RecordContainerMaintenance``. Every change is logged in
   * ``condition_history`` (previous + new condition, who, when, an
   * optional note). ``raise_repair_ticket`` is honoured only when the NEW
   * condition type is itself configured to allow it
   * (``ConditionType.raises_repair_ticket``) - an admin decides which
   * conditions may raise a ticket, the caller only opts in per change.
   */
  changeContainerCondition?: Maybe<ChangeContainerCondition>;
  /**
   * Change the owner of a property (omistajanvaihto, REQ-499 / HSY req 86).
   *
   * Ends every currently open OWNER link on the property — individual and
   * company alike — at the effective instant and starts the new owner's link
   * at that same instant, in one transaction. The outgoing owner's row is kept
   * with its end date (history stays traceable); a previously scheduled owner
   * that never took effect is removed. If the new owner already holds
   * CO_OWNER on the property that link is ended too.
   *
   * ``effectiveDate`` is a calendar date. Today means "now"; any other day
   * means local midnight of that day. A future date schedules the hand-over:
   * the current owner stays active until then and the new owner shows as a
   * future link. A past date is accepted as a correction as long as it is
   * after the current owner's start date — billing already issued is not
   * re-resolved.
   *
   * ``transferPayerRole`` also moves PAYER to the new owner at the same
   * instant, but only when the outgoing owner is the payer. Invoices resolve
   * PAYER before OWNER, so this is what redirects billing when the two roles
   * sit on the same party; a property without a payer link is billed to its
   * owner and needs nothing extra.
   *
   * Requires create permission on the new link and delete permission on every
   * link that is ended.
   */
  changePropertyOwner?: Maybe<ChangePropertyOwner>;
  checkDeviceId?: Maybe<CheckDeviceId>;
  /**
   * Record what the yard verified at the tip for one load. A verified
   * fraction that differs from the declared one needs a ``reasonCode``,
   * posts the reclassification surcharge event once
   * (``load-reclass:<classification pk>``) and re-issues the Waste
   * Transfer Note as a new revision; confirming the declared fraction
   * posts nothing. Office users and the company's own drivers; contractor
   * (hauler) logins are refused.
   */
  classifyLoad?: Maybe<ClassifyLoad>;
  /**
   * Office-only, audited: freeze a period's numbers (D9).
   *
   * Validation gate (R2-S11, decision R2-D17): when any settlement-relevant
   * event of the period cannot be priced, nothing is closed and the payload
   * carries ``blocked: true`` plus the blocking list — the GraphQL analogue
   * of a REST 409 + list. There is deliberately no ``force_close``: the
   * office fixes the listed events and closes again.
   */
  closeSettlementPeriod?: Maybe<CloseSettlementPeriod>;
  completeAlert?: Maybe<CompleteAlert>;
  /**
   * Complete a skip exchange from the office (PRODUCT-471, BE-P2-1):
   * the Exchange ticket's completion modal, Issue-modal style - the office
   * picks the skip that was delivered (``deliveredContainerId``) and the
   * old skip comes back to stock, its hire ending the day before, while
   * the new skip goes out on its own hire from today
   * (``inventory.services.rental_exchange.complete_exchange``). Without
   * ``deliveredContainerId`` the old skip is returned and the new hire is
   * booked; the office then dispatches it through the Issue modal
   * (``issueRental``). ``warehouseId`` names the warehouse the old skip
   * goes back to (default: the hire's return warehouse). Same company
   * wall as the other rental mutations (checked before anything about the
   * ticket is revealed); a wrong pick is refused naming
   * ``deliveredIdentity``. Idempotent. ``deliveredContainerId`` in the
   * payload is the delivered skip's Container gid - the same value space
   * as the argument, so it round-trips; ``deliveredContainerLabel`` is
   * its human label (``container_id``).
   */
  completeExchange?: Maybe<CompleteExchange>;
  completeTicketDraft?: Maybe<CompleteTicketDraft>;
  /**
   * Diff the plan against live: affected households (exact, RS-E5
   * semantics), route counts, detected frequency changes (D30).
   * Import promotions (RS-E28) diff their materialization + bindings
   * against live schemes per client route identity instead.
   */
  computePromotionDiff?: Maybe<ComputePromotionDiffMutation>;
  /**
   * Confirm inbound in-transit containers at this warehouse and
   * make the usable-vs-scrap call per container (ADR-0005): usable is
   * +1 on the count and the identity goes dormant (labels kept, ready
   * to resurrect at a later deployment scan); scrap never enters the
   * count - a terminal decommission at the door.
   */
  confirmArrival?: Maybe<ConfirmArrival>;
  /**
   * The human confirmation that makes a rule real (D39): assigns
   * the BR-<id> constraint identity; the rule binds the next run.
   */
  confirmBrainRule?: Maybe<ConfirmBrainRuleMutation>;
  /**
   * Operator confirm/override of a candidate table's document
   * class (RS-E21 stage B): the human word beats the classifier and
   * is recorded as such. Also answers the table's open
   * class_confirmation question.
   */
  confirmCandidateTableClass?: Maybe<ConfirmCandidateTableClassMutation>;
  /**
   * Applies a legacy-rule-to-flow conversion: creates a new `draft`
   * Flow + its first FlowVersion from the rule's *current* actions
   * (recomputed here, never trusting a client-echoed definition -- the
   * same defense the rest of this schema applies to derived state).
   *
   * The legacy `Rule` row (and its actions) are never written to by this
   * mutation -- it keeps running exactly as it did before, per
   * 06_DECISIONS_RISKS.md ("legacy rules untouched by default... conversion
   * is... reversible"). The new Flow starts in `draft` and does not
   * self-promote; `PromoteAutopilotFlow` (a separate, explicit step) is
   * still required before it can ever run live.
   *
   * Wave 2 Lane D S3 (dedupe guard): at most ONE non-archived flow per
   * `origin=legacy_rule:N`. A second confirm for the same rule is refused
   * with the EXISTING flow returned on the (ok=False) response envelope, so
   * the estate view can link straight to it instead of minting a
   * doppelgänger whose activation would fight the first one over the same
   * source rule (whichever activated last would own `superseded_by_flow_id`
   * while both fired). Serialized per rule with a `select_for_update` on
   * the Rule row, so two concurrent confirms cannot both pass the check.
   * An ARCHIVED converted flow does not block re-conversion: archiving is
   * the one terminal state, and re-converting is the supported way to
   * start over.
   */
  confirmConvertLegacyRuleToFlow?: Maybe<ConfirmConvertLegacyRuleToFlow>;
  confirmDriverPushNotification?: Maybe<ConfirmDriverPushNotification>;
  /**
   * The office's attribution ruling on a futile visit. Only a
   * confirmed CUSTOMER fault produces a fee (through the money lane's
   * plain-data producer); hauler/external faults are recorded and
   * never bill; an unclear fault cannot be confirmed at all — doubt
   * never bills.
   *
   * FIXIT3-O1 (D-E22): confirming ANY fault also VOIDS the service
   * line (status ``futile_voided``, terminal) — the visit was futile,
   * so the service is never billed at order close; only the confirmed
   * customer-fault FEE bills. The void path IS this mutation (D-E22's
   * "fold into confirmFutileFault" option): a separate
   * voidHaulerOrderLine would be a second writer of the same ruling.
   * The returned ``order`` carries the voided line and the refreshed
   * execution rollup. Office-only like every hauler-order surface
   * (DENIED stance, D-E10): ``_require_company`` denies contractor
   * logins and unflagged tenants before any data is touched.
   */
  confirmHaulerFutileFault?: Maybe<ConfirmHaulerFutileFault>;
  /**
   * DRAFT → CONFIRMED, and the order becomes real work (HAUL-409 +
   * S2-O2 bridge: one ticket per line via existing primitives).
   */
  confirmHaulerOrder?: Maybe<ConfirmHaulerOrder>;
  /** The human-confirm step (F1): no mapping applies without it. */
  confirmImportMapping?: Maybe<ConfirmImportMappingMutation>;
  confirmInsightsAlert: ConfirmInsightsAlert;
  /**
   * Confirm the stops for N simultaneously-read tags in ONE call.
   *
   * REQ 42's use case: a lift reader reads two containers at once (or two
   * readers each read one), and the system receives BOTH. Each confirmation
   * keeps its own provenance — which tag, which reader, when — so two
   * containers emptied in one lift stay distinguishable afterwards.
   *
   * Never all-or-nothing: every read gets its own status. A repeated tag is
   * a DUPLICATE, an already-completed stop is ALREADY_COMPLETED, and a stop
   * the funnel refuses is REJECTED with its sentence — none of which
   * prevents the stop beside it from being confirmed.
   */
  confirmStopsByTags?: Maybe<ConfirmStopsByTags>;
  /**
   * Wave 2 Lane E S3: draft a converted flow for EVERY GREEN legacy rule
   * in the tenant at once -- the wizard's "convert all N safe steps" click.
   * Exactly `ConfirmConvertLegacyRuleToFlow`'s contract applied per rule
   * (see `autopilot.services.estate_migration.convert_all_green_legacy_
   * rules` for the full semantics): GREEN only, per-rule dedupe under the
   * same row lock, definitions recomputed and validator-checked, every
   * created flow a DRAFT that never self-promotes, one audit row per
   * creation. Idempotent: a second call drafts nothing and reports
   * `already_converted` per row. `results` is the batch's complete
   * per-rule ledger; `draftedCount` is the number actually created by
   * THIS call.
   */
  convertAllGreenLegacyRules?: Maybe<ConvertAllGreenLegacyRules>;
  /**
   * Correct a completed work task to undone and decide, in the same step,
   * whether it is handed to the service provider for rerouting (HSY req
   * 253). Office-only; the hand-over branch is a hauler-module surface.
   */
  correctTaskToUndone?: Maybe<CorrectTaskToUndone>;
  /**
   * Correct a load's data (HSY req 202, Annex 3.1 §8.4).
   *
   * Writes ONLY authored slots: the platform's derived values survive
   * untouched, so a later membership reset re-derives without destroying
   * the correction. Naming a field in ``clear`` clears that correction and
   * falls back to the derived value; an omitted field is left alone.
   *
   * A weighed-weight correction is also spread over the load's completed
   * member tasks (proportionally to what they weighed) so the work tasks
   * show the corrected figure too, with `manual` provenance.
   */
  correctTruckload?: Maybe<CorrectTruckload>;
  /**
   * Re-attribute one member emptying to the collection point it really
   * happened at (req 202's "and in the work tasks").
   *
   * WasteHero holds a task's collection point through its container, so
   * this repoints ``PickUpOrder.container``. **Billing-affecting**: shared
   * collection points (*kimppa*) carry billing modes, and Annex 3.1 §8.3's
   * note that a correction "will generate a new billing line" applies.
   */
  correctTruckloadCollectionPoint?: Maybe<CorrectTruckloadCollectionPoint>;
  /**
   * Office-only (PRO-465): book an append-only counter-entry that reverses
   * an approved/settled entry (opposite kind, same magnitude), instead of
   * editing it. The counter is a new DRAFT needing its own four-eyes
   * approval; it lands in the next open period by default.
   */
  counterContractorManualEntry?: Maybe<CounterContractorManualEntry>;
  createAgreement?: Maybe<CreateAgreementPayload>;
  createArchivalRule?: Maybe<CreateArchivalRule>;
  createAutomation: CreateAutomationPayload;
  /**
   * Create a new, empty draft Flow (no version yet). The canvas UI's
   * first save is `UpdateAutopilotFlowDefinition`, which creates version 1.
   *
   * `sourceSuggestionId` (optional, Builder V2 item 1(i)) stamps the new
   * flow with the Pulse suggestion the drawer was opened from, into
   * `Flow.source_suggestion_id` -- a separate field, deliberately NOT the
   * `origin` convention (`legacy_rule:`/`playbook:`/`suggestion:` prefixes):
   * the FE builder relaxes its explicit-choice target guard for ANY
   * non-manual origin (`BuildAutomationDrawer`'s `groundedOrigin` -- "every
   * target value came from a real source"), which is true for the grounded
   * `CreateFlowFromSuggestion` path but false for an empty drawer draft that
   * was merely STARTED from a suggestion, so an origin stamp here would
   * reopen the unconfirmed-default laundering hole item 2 closed. The
   * linkage is what lets `AutopilotSuggestionType.draftFlow` render "Draft
   * started -- resume it" cross-session; the suggestion's lifecycle status
   * is deliberately untouched here (`acceptAutopilotSuggestion` stays the
   * explicit accept, called at activate/explicit-keep).
   *
   * A `sourceSuggestionId` that does not resolve within the caller's tenant
   * (nonexistent, or another tenant's -- indistinguishable by design) refuses
   * and creates nothing: silently minting an unlinked draft would make the
   * Pulse card lie about there being no draft.
   */
  createAutopilotFlow?: Maybe<CreateAutopilotFlow>;
  /**
   * SBX-339 perturbation seeding: move an explicit cohort (live
   * container ids or selected stop ids) to another weekday.
   * Consequence-free draft (D18, D35).
   */
  createBatchMoveScenario?: Maybe<CreateBatchMoveScenarioMutation>;
  createBillingRun?: Maybe<CreateBillingRun>;
  /**
   * Office-only: create a bonus model in one of three scopes
   * (REQ 3.3.22/3.5.57, D7). Give ``areaId`` for a per-area model,
   * ``haulerId`` (no ``areaId``) for a per-contractor default, or neither
   * for a company-wide default. Settlement resolves most-specific-wins.
   *
   * Additive sibling of ``createBonusModel`` (which stays area-required for
   * non-breaking master compatibility): the frontend targets this variant for
   * the company/contractor/area scoping UI.
   */
  createBonusModelScoped?: Maybe<CreateBonusModelScoped>;
  createBulkWastePickupTicket?: Maybe<CreateBulkWastePickupTicketPayload>;
  /** Manual question entry (stage D): ask, never assume (D62). */
  createCaseQuestion?: Maybe<CreateCaseQuestionMutation>;
  createCompanyEmailAccountMessage?: Maybe<CreateCompanyEmailAccountMessagePayload>;
  createComparisonSettings?: Maybe<CreateComparisonSettingsMutationPayload>;
  /**
   * Admin: add a company-defined condition type to the structured
   * condition library (PRO-391, 3.12.28).
   */
  createConditionType?: Maybe<CreateConditionType>;
  createContact?: Maybe<CreateContact>;
  createContactAddress?: Maybe<CreateContactAddress>;
  createContactAuthorization?: Maybe<CreateContactAuthorizationPayload>;
  createContainer?: Maybe<CreateContainer>;
  createContainerImport?: Maybe<CreateContainerImport>;
  createContainerMobile?: Maybe<CreateContainerMobile>;
  createContainerPrice?: Maybe<CreateContainerPricePayload>;
  createContainerType?: Maybe<CreateContainerType>;
  createContainerWeightImport?: Maybe<CreateContainerWeightImport>;
  /**
   * Office-only, four-eyes (PRO-465): book a DRAFT manual contractor
   * credit/receivable entry. Requires the compensation-manage permission (the
   * office + hauler-module gate); a SECOND permission holder must approve it
   * (``approveContractorManualEntry``) before it affects any settlement
   * figure. A draft is visible but excluded from settlement totals.
   *
   * ``amountCents`` is a POSITIVE magnitude — the sign of the settlement
   * effect comes from ``entryType`` (deduction subtracts, credit adds). Omit
   * ``areaId`` for a contractor-level entry; omit the target period to default
   * to the next open period.
   */
  createContractorManualEntry?: Maybe<CreateContractorManualEntry>;
  /**
   * Create a tenant cost model, optionally seeded from a regional
   * default set (RS-205, D10). Explicit values win over defaults.
   *
   * SBX-362 (D32/D45): master-gated (rates are money truth for every
   * plan and baseline of the tenant). A row created purely from
   * defaults is labeled ``engineering_default``; explicit rate values
   * label it ``tenant_set`` with updated_by/updated_at recorded, and
   * the write is audited via route_studio.cost_model.updated.
   */
  createCostModel?: Maybe<CreateCostModelMutation>;
  createCostSettings?: Maybe<CreateCostSettingsMutationPayload>;
  createCustomerNote?: Maybe<CreateCustomerNotePayload>;
  /**
   * SBX-339 perturbation seeding: "what if everything moves off
   * Monday". Seeds a normal draft scenario FROM live platform objects
   * (container calendars are the cohort truth); consequence-free
   * (D18), so no master role is required, and nothing runs until a
   * human runs it (D35).
   */
  createDayMoveScenario?: Maybe<CreateDayMoveScenarioMutation>;
  createDriverPushNotification?: Maybe<CreateDriverPushNotificationPayload>;
  createExport?: Maybe<CreateExport>;
  createFillLevelDeviceMobile?: Maybe<CreateFillLevelDeviceMobile>;
  /**
   * SBX-339 perturbation seeding: add or remove trucks against the
   * LIVE fleet (fleet_management project vehicles). Consequence-free
   * draft (D18, D35).
   */
  createFleetChangeScenario?: Maybe<CreateFleetChangeScenarioMutation>;
  /**
   * AP-601c: create a new draft Flow + its version 1 from one
   * `AutopilotSuggestion`, grounded in the tenant's own real per-type
   * automation (`autopilot.services.suggestion_grounded_draft.
   * build_grounded_draft_for_suggestion` -- see that module's docstring for
   * the resolution order and why it is never Gateway-composed).
   *
   * Same "build -> validate -> create draft -> commit version 1" path
   * `InstantiateAutopilotPlaybook` uses: the definition is re-derived here
   * (never trusting a client-echoed one -- the same discipline
   * `ConfirmConvertLegacyRuleToFlow` applies to legacy rules) and run
   * through the same registry-aware `validate_for_builder` before anything
   * is written, so an invalid draft (a stale suggestion whose ticket type
   * was since renamed or deleted, say) creates no `Flow` row at all.
   * `hasRules=False` on the underlying draft is not itself an error: it
   * still produces a valid placeholder flow, per that module's own
   * "always something to commit" contract; `warnings` says why.
   *
   * Deny-by-default and tenant-scoped like every sibling mutation here: a
   * disabled tenant, or a suggestion that does not exist / belongs to
   * another tenant, both refuse with an honest error and write nothing.
   */
  createFlowFromSuggestion?: Maybe<CreateFlowFromSuggestion>;
  /**
   * Claims-ledger CRUD (RS-E20; the decode engine that generates
   * claims is RS-E22). Evidence citations reference case storage,
   * never committed artifacts.
   */
  createGrammarClaim?: Maybe<CreateGrammarClaimMutation>;
  /** Office-only: add a compliance document to a contractor (PRO-99). */
  createHaulerComplianceDocument?: Maybe<CreateHaulerComplianceDocument>;
  /** Office-only: add a compliance-document type (PRO-99 / 3.12.28). */
  createHaulerComplianceDocumentType?: Maybe<CreateHaulerComplianceDocumentType>;
  /** Create a draft hauler order with N service lines (HAUL-401/424). */
  createHaulerOrder?: Maybe<CreateHaulerOrder>;
  /**
   * Create a price list (RD-46). Wraps
   * ``product.price_lists.service.create_price_list`` for name/description
   * (reusing its status state machine). The hauler LAYER's additive plain
   * fields the product service does not write — status, the validity window
   * (validFrom/validTo), inheritance (parentId) and minimumCharge (HAUL-
   * 202/209) — are set as a company-scoped plain-data patch afterward. No
   * currency input: the model carries no currency column (the G2 valuta-gap
   * decision); one tenant, one currency, resolved elsewhere.
   */
  createHaulerPriceList?: Maybe<CreateHaulerPriceList>;
  /**
   * Add a price row to one of the tenant's price lists (RD-46).
   *
   * Wraps ``product.price_rows.service.create_price_row`` — the ONE engine
   * validates the product/zone/tuple uniqueness/VAT rules; this seam adds
   * no calculation. ``unitPrice`` is stored verbatim. ``minimumCharge``
   * (HAUL-209) is the additive per-row floor the product service does not
   * itself write, set as a plain-data patch after the row persists.
   */
  createHaulerPriceRow?: Maybe<CreateHaulerPriceRow>;
  /**
   * Upload and parse a stop-list file (RS-101, RS-1601). CSV and
   * XLSX take the deterministic parser; PDF, PNG and JPG documents
   * take the vision extraction seam (D38: same pipeline, same human
   * confirm downstream).
   */
  createImportBatch?: Maybe<CreateImportBatchMutation>;
  /**
   * Open an onboarding case (RS-E20, blueprint stage A): the
   * long-lived container files upload into across sessions (D62).
   * ``useCase`` answers the orienting question in the same act
   * (SBX-521: case creation asks "What are you bringing in?" instead
   * of opening blank); omitted, the case serves the question on its
   * purpose payload until one is declared.
   */
  createImportCase?: Maybe<CreateImportCaseMutation>;
  /**
   * RS-E28 (D61): open the SAME F10 gated flow for a VALIDATED
   * import case. The payload is the case's newest materialization
   * plus its per-fraction service bindings; every downstream gate is
   * the existing promotion machinery in the existing order (diff,
   * comms gate, approval, schedule, execute, one-action rollback,
   * D18/D09). ``fractionMap`` is the human-confirmed mapping from the
   * client's own fraction codes to this project's waste fractions
   * (id or exact name); it must cover every active binding code,
   * never guessed (D62). Refuses while the case is not validated on
   * its newest version (the client sentence 'yes, this is my routes'
   * comes first, D61).
   */
  createImportPromotion?: Maybe<CreateImportPromotionMutation>;
  /**
   * W8.3: compile an NL prompt into an inspectable rule. The result
   * is PENDING — the echoed rule must be confirmed before anything can
   * fire (Behavior 7's confirmation gate).
   */
  createInsightsAlert: CreateInsightsAlert;
  /**
   * Admin: add a company-defined key type to the catalogue (PRO-367).
   *
   * Mirrors ``device.CreatePartType``, gated like every key write
   * (module ON + ``Manage keys``). A chargeable type must carry its fee
   * product — that link is the entry point into the standard billing
   * chain, so ``billable`` without ``linked_product_id`` is rejected.
   */
  createKeyType?: Maybe<CreateKeyType>;
  createManageContainerTicket?: Maybe<CreateManageContainerTicketPayload>;
  createMeasurementSettings?: Maybe<CreateMeasurementSettings>;
  createMobileDevice?: Maybe<CreateMobileDevice>;
  createNotificationSetting?: Maybe<CreateNotificationSetting>;
  /**
   * Create or update a declared emptying location of an SCP (NEXUS-538).
   *
   * ``id`` present → update; absent → create (``property_group_id`` required).
   * The point is mandatory on the model, so latitude+longitude are required on
   * create. Blocked on a terminated SCP.
   */
  createOrUpdateCollectionLocation?: Maybe<CreateOrUpdateCollectionLocation>;
  createOrUpdateContainerIdGenerator?: Maybe<UpdateOrCreateContainerIdGeneratorPayload>;
  createOrUpdateDkdpCompanyCredentials?: Maybe<DkdpCompanyCredentialsMutationPayload>;
  createOrUpdateExportTemplate?: Maybe<CreateOrUpdateExportTemplate>;
  /**
   * Record or edit an authority decision on a property (NEXUS-704).
   *
   * The operator RECORDS the jätehuoltoviranomainen's decision (keskeytys /
   * pidennys / käyttöoikeus) — reference, validity, note — it is never
   * granted here. Create requires ``propertyId``, ``kind`` and ``validFrom``;
   * update patches only the provided fields (``clearValidTo`` empties the
   * end, a null variable being indistinguishable from an omitted one). A
   * KESKEYTYS must be bounded, at most 4 years.
   */
  createOrUpdatePropertyWasteDecision?: Maybe<CreateOrUpdatePropertyWasteDecision>;
  createOrUpdateRfidVehicleConnection?: Maybe<RfidVehicleConnectionMutationPayload>;
  /**
   * Create a custom SCP role, or rename/re-describe an existing one.
   *
   * System roles cannot be created here, nor renamed/re-keyed; only their
   * ``description`` may be edited. Custom roles are immediately assignable
   * (NEXUS-544).
   */
  createOrUpdateScpRoleDefinition?: Maybe<CreateOrUpdateScpRoleDefinition>;
  createOrUpdateStopListCardConfig?: Maybe<CreateOrUpdateStopListCardConfig>;
  createOrUpdateUrbaserCompanyCredentials?: Maybe<UrbaserCredentialsMutationPayload>;
  /** Admin: add a company-defined part type to the picker library. */
  createPartType?: Maybe<CreatePartType>;
  /**
   * Record a council permit for a placement: on a property (applied
   * for ahead of the booking) and/or on the rental unit ticket it covers.
   * ``status: GRANTED`` grants it in the same call.
   */
  createPermit?: Maybe<CreatePermit>;
  createPlanningArea?: Maybe<CreatePlanningAreaMutation>;
  createPrice?: Maybe<CreatePricePayload>;
  /**
   * Open the F10 door for a plan (D18). ``hauler_proposal`` is a
   * defined channel but raises until the hauler module ships
   * (ADR-0002).
   */
  createPromotion?: Maybe<CreatePromotionMutation>;
  createPropertyManagementCompanyAddress?: Maybe<CreatePropertyManagementCompanyAddress>;
  createPropertyNote?: Maybe<CreatePropertyNotePayload>;
  /** Order stock from a supplier for one warehouse. */
  createPurchaseOrder?: Maybe<CreatePurchaseOrder>;
  createRecurringPrice?: Maybe<CreateRecurringPricePayload>;
  /**
   * Office-only, audited: create a period-scoped reliability exclusion
   * window (HSY 263). Scope is allAreas OR ≥ 1 areaIds; reason mandatory;
   * refused when the coverage touches a CLOSED settlement period.
   */
  createReliabilityExclusionWindow?: Maybe<CreateReliabilityExclusionWindow>;
  /**
   * Book ``quantity`` units of an item type over ``[startDate, endDate]``
   * (PRO-271). A null ``endDate`` is a SALE - a permanent issue with no
   * return leg. PRO-383 (spec decision C9): the dispatch warehouse is NOT a
   * user input - it is auto-selected (the container-storage warehouse with
   * the most projected availability across the window, nearest to the
   * served property on a tie). The booking hard-refuses (a clean error) if
   * the peak concurrent commitment over the window would exceed the chosen
   * pool, evaluated STRICT under the per-pool advisory lock
   * (``inventory.services.rental.create_rental``); on success it fans out
   * to ``quantity`` individual quantity-1 tickets, each returned as a relay
   * ticket id. ``propertyId`` is REQUIRED (PRODUCT-431): RENT_STOCK is
   * property-level (PRODUCT-430), so every unit is booked FOR the customer
   * property it serves - there is no property-less pool rental any more -
   * and the property steers the nearest-warehouse tie-break. An
   * optional ``payerContactId`` (PRODUCT-436) names the customer who pays
   * for the rental when that is not the property's payer-role chain; it is
   * stamped on every unit as ``Ticket.payer_contact``.
   *
   * PRODUCT-439 (BE-B4, customer-first booking): ``propertyId`` OR
   * (exactly one of ``contactId`` / ``managementCompanyId`` AND
   * ``newPropertyAddress``) is required - the same trio
   * ``createManageContainerTicket`` takes. With a contact the property
   * (existing or created from the address, an existing property of the
   * company at the same address reused) gets a PAYER link for the customer
   * when it has none, ``payerContactId`` defaults to the contact, and
   * ``createdProperty`` names the property this call created (null when an
   * existing one was used). With a management company (the Company
   * cockpit - a ``PropertyManagementCompany`` has no contact) the property
   * gets a ``ManagementCompanyProperty`` PAYER link when it has no payer
   * and ``payerContactId`` stays null, so the management-company payer
   * chain bills. Property, role link and booking share one transaction: a
   * refused booking leaves no property behind.
   */
  createRental?: Maybe<CreateRental>;
  createRoute?: Maybe<CreateRouteMutation>;
  /**
   * Create a scenario from a template (RS-202, PRD F5). Template
   * prefills seed the config; explicit arguments win.
   */
  createScenario?: Maybe<CreateScenarioMutation>;
  createScheduledExportRun?: Maybe<CreateScheduledExportRun>;
  /**
   * W12.3: schedule a governed bulk extract. Destination is a
   * signed URL by default; SFTP config is opaque JSON.
   */
  createScheduledExtract: CreateScheduledExtract;
  /**
   * Add a management company as an SCP member (phase 2, feature 7).
   *
   * Company members share the sum-to-100 pool with property members: the pool
   * is re-balanced proportionally to make room for the newcomer's share.
   * They carry no roles and no property-specific attributes.
   */
  createScpCompanyMembership?: Maybe<CreateScpCompanyMembership>;
  /**
   * Add a property to an SCP (a PropertyGroup) with an initial share.
   *
   * The pool is re-balanced to sum to 100.00 in the same transaction: the
   * pre-existing members are scaled down proportionally to make room for the
   * newcomer's share, or the caller supplies ``shares`` — an explicit vector
   * for the EXISTING members (the newcomer's share comes from ``share``) — and
   * the combined vector must sum to 100.00. The first member keeps whatever
   * share it was created with (the FE sends 100.00).
   */
  createScpMembership?: Maybe<CreateScpMembership>;
  createSensor?: Maybe<CreateSensor>;
  createServicePrice?: Maybe<CreateServicePricePayload>;
  createSparePart?: Maybe<CreateSparePart>;
  /**
   * Build a StopSet from live entities or a drawn boundary
   * (RS-103, D04). Project-scoped; contract-area semantics arrive
   * with the hauler module, not here (ADR-0002).
   */
  createStopSetFromEntities?: Maybe<CreateStopSetFromEntitiesMutation>;
  /**
   * SBX-336: the map polygon selection's backend half. Keep or
   * exclude a selection of stops into a NEW immutable stop set in the
   * same project; the source set is never modified (stop sets are
   * immutable snapshots), and service units are regenerated for the
   * new set, never copied.
   */
  createStopSetSubset?: Maybe<CreateStopSetSubsetMutation>;
  /**
   * Request a temporary location change for a waste bin (REQ-315 kelirikko).
   *
   * Creates a TEMPORARY_CONTAINER_CHANGE ticket (container-level only, PRO-385
   * - no property/customer re-entry) plus a scheduled location change bound to
   * it. The window is the ticket's generic Include period (``periodStartDate``
   * / ``periodEndDate``, the ONE mechanism PRO-379 introduced), not a
   * bespoke pair of args. The change is NOT applied immediately: it is
   * scheduled for its window and the celery sweep applies it once
   * ``periodStartDate`` arrives and reverts it once ``periodEndDate`` has
   * passed. Cancelling the ticket stops it.
   */
  createTemporaryContainerLocation?: Maybe<CreateTemporaryContainerLocation>;
  createTicket?: Maybe<CreateTicketPayload>;
  createTicketComment?: Maybe<CreateTicketCommentPayload>;
  createTicketCustomField?: Maybe<CreateTicketCustomFieldMutationPayload>;
  createTicketDraftEmail?: Maybe<CreateTicketDraftEmailPayload>;
  createTicketMessage?: Maybe<CreateTicketMessagePayload>;
  /**
   * Move a quantity of an item type between warehouses via a
   * transfer ticket (ADR-0005): creating the ticket reserves the
   * quantity at the source; it goes in transit when the ticket
   * starts, and lands at the destination when the receiving side
   * completes the ticket through the existing ticket UI. Rejecting
   * before then releases the reservation (or brings the in-transit
   * quantity home).
   */
  createTransfer?: Maybe<CreateTransfer>;
  createUnconfirmedUser?: Maybe<CreateUnconfirmedUser>;
  createUser?: Maybe<CreateUser>;
  createWasteCollector?: Maybe<CreateWasteCollector>;
  createWasteFraction?: Maybe<CreateWasteFraction>;
  /** PRO-946: add a dated factor version to a waste fraction. */
  createWasteFractionEnvironmentalFactor?: Maybe<CreateWasteFractionEnvironmentalFactor>;
  /** Add a company appliance-catalogue option (mirrors createPartType). */
  createWasteWaterApplianceOption?: Maybe<CreateWasteWaterApplianceOption>;
  /**
   * Admin: hide a condition type from pickers via soft-delete. Never
   * hard-deletes the row (history rows PROTECT-reference it).
   */
  deactivateConditionType?: Maybe<DeactivateConditionType>;
  /**
   * Wave 2 Lane E S5: the batch rollback. Every LIVE flow whose
   * ACTIVATED audit row carries `batchLabel` is demoted LIVE -> SHADOW
   * (dry: it keeps watching, fires nothing) and its superseded source
   * rules resume automatically inside the same state transition
   * (`Flow.promote_to`'s centralized bookkeeping) -- so "switch the
   * afternoon off again" is one call and no transition is ever left
   * handled by neither side. SHADOW, not ARCHIVED, on purpose: archiving
   * is terminal, and a rollback is a pause for inspection, not a verdict.
   * Killed flows are reported and left alone (the kill already resumed
   * their rules); rows in any other state are named, never silently
   * skipped. Each demotion writes its own DEMOTED audit row carrying the
   * batch label.
   */
  deactivateConvertedFlows?: Maybe<DeactivateConvertedFlows>;
  /**
   * Admin: hide a key type from pickers via soft-delete (PRO-367).
   *
   * Never hard-deletes — an issued ``PhysicalKey`` must always resolve its
   * type. Seeded kinds are the canonical library and stay read-only
   * (PRO-358 contract); only company-defined kinds can be deactivated.
   */
  deactivateKeyType?: Maybe<DeactivateKeyType>;
  /**
   * Admin: hide a part type from pickers via soft-delete. Never
   * hard-deletes the row.
   */
  deactivatePartType?: Maybe<DeactivatePartType>;
  /**
   * Soft-delete a company appliance-catalogue option (mirrors
   * deactivatePartType). Never hard-deletes, so surveys that already stored the
   * option name stay legible.
   */
  deactivateWasteWaterApplianceOption?: Maybe<DeactivateWasteWaterApplianceOption>;
  decideAutomationApproval: DecideApprovalPayload;
  /**
   * Approve or reject one paused, approval-required flow run (the
   * pause-for-approval runtime story).
   *
   * Mirrors `KillAutopilotFlow`'s auth + company scoping exactly: the same
   * `@login_required`, the same per-tenant flag gate, and the approval is
   * fetched *scoped to the caller's company* (`_get_tenant_pending_approval`)
   * so a caller can only ever decide their own tenant's approvals -- a
   * foreign approval is indistinguishable from a nonexistent one.
   *
   * APPROVE resumes the run at the paused step
   * (`autopilot.runtime.executor.resume_flow_run_after_approval`): the
   * action dispatches for real with `approved=True` and the run continues
   * from the snapshotted context. REJECT declines it
   * (`reject_flow_run_after_approval`): the action never runs and the run
   * fails. Both are idempotent -- deciding an already-decided approval is a
   * business error here (`ok=False`) rather than a second execution, and the
   * service functions themselves also no-op on a non-PENDING row as a second
   * line of defense.
   */
  decideAutopilotApproval?: Maybe<DecideAutopilotApproval>;
  /**
   * Office decision on a pending proposal: approve (optionally
   * adjusting the effective date) or reject with a note. Approval applies
   * the change in one transaction, from the effective date only.
   */
  decideRouteChange?: Maybe<DecideRouteChange>;
  /**
   * SBX-521: answer (or re-answer) the case's orienting question,
   * "What are you bringing in?", with one of the six import use
   * cases. The declaration tunes the manifest expectations (a
   * handover expects no vehicle file; a calendar update expects only
   * a calendar and goes straight to the diff); the go-live door is
   * physics and is never tuned by a declaration.
   */
  declareImportCasePurpose?: Maybe<DeclareImportCasePurposeMutation>;
  /**
   * Run the RS-E22 grammar decode engine over a case (blueprint
   * stage C): route-calendar tables become evidence-cited
   * GrammarClaim rows, upserted by (kind, key). Deterministic first
   * and always; ``useFrontier`` opts below-threshold drafts into the
   * frontier assist (D54, model registry, degrade recorded). Human
   * confirmed or corrected claims are never silently changed:
   * divergences land in ``conflicts``.
   */
  decodeImportCase?: Maybe<DecodeImportCaseMutation>;
  /**
   * Retire N spare parts from this warehouse's count (A1, PRO-207):
   * terminal, irreversible, mandatory reason - the spare-part
   * counterpart of DecommissionStock. Ticketless; the audit lives in the
   * DECOMMISSION ledger row. A mistaken decommission is corrected by a
   * new adjustment (recount), never reinstated.
   */
  decommissionSpareParts?: Maybe<DecommissionSpareParts>;
  /**
   * Retire N anonymous units of an item type from this warehouse's
   * count (ADR-0005): terminal, irreversible, mandatory reason. A
   * mistaken decommission is corrected by a new adjustment (recount) -
   * there is deliberately no reinstate. Identity-level decommission of
   * a returning container happens at Confirm arrival (the scrap call),
   * never here.
   */
  decommissionStock?: Maybe<DecommissionStock>;
  deleteAgreementTemplate?: Maybe<DeleteAgreementTemplate>;
  deleteAlertRule?: Maybe<DeleteAlertRule>;
  deleteArchivalRule?: Maybe<DeleteArchivalRule>;
  /**
   * Permanently delete ONE archived record — the one irreversible path
   * in the feature. Refuses non-archived rows, and refuses when a CASCADE
   * child of an archivable type is still ACTIVE (see
   * ``archiving.active_dependent_blocker_pks``): archive or delete the
   * dependents first. Archived dependents and truly-owned non-archivable
   * children (notes, link rows) cascade with the record by design.
   */
  deleteArchivedRecord?: Maybe<DeleteArchivedRecord>;
  deleteArea?: Maybe<DeleteArea>;
  /**
   * HARD-delete one never-activated draft flow (Builder V2 item 1(h)).
   *
   * Allowed ONLY when all of `_flow_delete_refusal`'s conditions hold:
   * `draft` state, no lifecycle history out of draft, zero `FlowRun`s, zero
   * pending approvals. Anything else refuses with one plain-words sentence
   * the FE renders verbatim (`ok=False` + `errors`, never a GraphQL
   * exception). RBAC `automation__edit` via the module's standard probe;
   * tenant-scoped lookup, so a foreign flow id is indistinguishable from a
   * missing one.
   *
   * Audit (investigated, reused, nothing invented): `FlowAuditLogEntry` is
   * the module's own audit table but its `flow` FK is CASCADE -- a
   * deletion row written there would die in the very cascade it documents
   * (verified, not guessed). The surviving record therefore goes through
   * the platform's append-only audit ledger `product.audit_logs`
   * (`emit_audit_row` -- the same D23/W6-P1 path
   * `schema_ticket_config.UpdateTicketTypeRequirements` uses), carrying
   * who/when/flow name plus the full definition snapshot in `diff`. Because
   * `emit_audit_row` is best-effort by contract (it never raises), and this
   * is the one write whose audit row is the only record left afterwards,
   * the row's existence is VERIFIED before the delete: no audit row, no
   * deletion. Same honest caveat as W6-P1: those rows are DB/forensic
   * audit; the System History UI does not currently render this category.
   *
   * Concurrency (review fix, BLOCKING): lookup, guards, snapshot and
   * delete all run INSIDE one `transaction.atomic()` on a
   * `select_for_update()` row -- the exact `ActivateConvertedFlows`
   * precedent (no `select_related`: Postgres refuses FOR UPDATE on the
   * nullable side of the `current_version` outer join). An unlocked
   * check-then-delete had three real failures: a promote committing in
   * the window deleted a TEST/LIVE flow (the collector does NOT raise
   * PROTECT for a protecting row that is itself in the deletion set --
   * `ImpactRecord.flow` is OneToOne CASCADE, only its `.flow_version` is
   * PROTECT -- and a LIVE legacy-origin flow would leave the customer's
   * rule suspended pointing at a dead pk, with a ledger row recording
   * state:"draft", a forensic lie); a run created in the window raised an
   * uncaught `ProtectedError` (raw 500); a double-click's loser raw-500'd
   * or no-op-deleted with ok:true plus a duplicate ledger row. Now the
   * guards read the locked row's committed truth, a repeat delete finds
   * the row gone (honest not-found), and `flow.delete()` is wrapped so a
   * `ProtectedError`/`IntegrityError` rolls the WHOLE transaction back --
   * including the just-written ledger row, so no "deleted" record ever
   * survives for a flow that lives -- and refuses in plain words.
   *
   * Cascade safety (verified against the models, not assumed):
   * `FlowVersion.flow`/`FlowAuditLogEntry.flow` are CASCADE (versions and
   * in-table audit die with the flow -- the bulk cascade path bypasses
   * `FlowVersion.delete()`'s immutability guard by documented design);
   * `SimulationRun` cascades via its version; `AutopilotSuggestion.
   * built_flow` is SET_NULL; `ImpactRecord.flow` is OneToOne CASCADE (its
   * `.flow_version` PROTECT does not fire when the record itself is being
   * collected, per above -- which is exactly why the state/history guards
   * must run under the lock); the remaining PROTECT edges (`FlowRun.flow`,
   * `FlowRun.flow_version`) are empty by the preconditions above and
   * backstopped by the ProtectedError catch; and the flow's own
   * `current_version` pointer (PROTECT) is cleared first so the collector
   * never has to reason about a protected reference from inside the
   * deletion set.
   */
  deleteAutopilotFlow?: Maybe<DeleteAutopilotFlow>;
  /** Office-only: soft-delete a bonus model (D7). */
  deleteBonusModel?: Maybe<DeleteBonusModel>;
  deleteCard?: Maybe<DeleteCard>;
  deleteCollectionCalendar?: Maybe<DeleteCollectionCalendar>;
  deleteCollectionCalendarDate?: Maybe<DeleteCollectionCalendarDate>;
  deleteCollectionCalendarDeviation?: Maybe<DeleteCollectionCalendarDeviation>;
  deleteCollectionCalendarWeek?: Maybe<DeleteCollectionCalendarWeek>;
  /** Delete a collection location of an SCP (NEXUS-538). */
  deleteCollectionLocation?: Maybe<DeleteCollectionLocation>;
  deleteCompanyContainerMetaType?: Maybe<DeleteCompanyContainerMetaType>;
  deleteCompanyEmailAccount?: Maybe<DeleteCompanyEmailAccount>;
  deleteCompanyEmailAccountMessage?: Maybe<DeleteCompanyEmailAccountMessage>;
  deleteCompanyEmailAccountRule?: Maybe<DeleteCompanyEmailAccountRule>;
  /**
   * Retire a holiday from the register.
   *
   * HSY-258: a soft-disable (``is_active = False``), never a row delete —
   * the register feeds route generation now, so the audit trail of what
   * used to be a non-working day must survive; the row can be re-enabled
   * through ``upsertCompanyHoliday(isActive: true)``. Office-only.
   */
  deleteCompanyHoliday?: Maybe<DeleteCompanyHoliday>;
  deleteCompanyMetaType?: Maybe<DeleteCompanyMetaType>;
  deleteCompanyRole?: Maybe<DeleteCompanyRole>;
  deleteComparisonSettings?: Maybe<DeleteComparisonSettingsMutation>;
  /** Hard-delete a field. Refuses while another field is gated on it. */
  deleteCompostingNotificationField?: Maybe<DeleteCompostingNotificationField>;
  /**
   * Hard-delete one choice.
   *
   * Refuses to remove the last option of a choice field — a SELECT with no
   * options is unanswerable, and ``validate_field`` would flag the template as
   * broken on the very next read.
   */
  deleteCompostingNotificationFieldOption?: Maybe<DeleteCompostingNotificationFieldOption>;
  /**
   * Hard-delete a section and its fields.
   *
   * Refuses while any field OUTSIDE this section is gated on a field INSIDE
   * it — that gate would become a dangling reference and silently hide a
   * statutory question forever.
   */
  deleteCompostingNotificationSection?: Maybe<DeleteCompostingNotificationSection>;
  /** Soft-delete the company's template, freeing the one-per-company slot. */
  deleteCompostingNotificationTemplate?: Maybe<DeleteCompostingNotificationTemplate>;
  /**
   * Soft-delete a row that should never have existed.
   *
   * NOT the way to record that composting stopped — that is ``End``, which
   * keeps the row and its history, which is what the statute expects. This is
   * for a data-entry mistake.
   *
   * Refuses to delete a row that has been renewed. ``predecessor`` is PROTECT
   * precisely so a statutory chain cannot be severed, and soft-deleting a
   * predecessor would sever it everywhere the UI looks even though the FK
   * survives.
   */
  deleteCompostingRegistryEntry?: Maybe<DeleteCompostingRegistryEntry>;
  deleteContact?: Maybe<DeleteContact>;
  deleteContactAddress?: Maybe<DeleteContactAddress>;
  deleteContactAuthorization?: Maybe<DeleteContactAuthorization>;
  deleteContactFieldConfiguration?: Maybe<DeleteContactFieldConfiguration>;
  deleteContactProperties?: Maybe<DeleteContactProperties>;
  deleteContainer?: Maybe<DeleteContainer>;
  deleteContainerGroup?: Maybe<DeleteContainerGroup>;
  deleteContainerNotification?: Maybe<DeleteContainerNotification>;
  deleteContainerType?: Maybe<DeleteContainerType>;
  /**
   * Remove the rule for one pair - the pair is allowed again.
   * Idempotent: a pair without a rule is a no-op success.
   */
  deleteContainerTypeWasteFractionRule?: Maybe<DeleteContainerTypeWasteFractionRule>;
  /**
   * Office-only, audited: soft-remove a contract file (R2-S14). The row
   * survives (``deleted``/``deleted_by``) for the audit trail.
   */
  deleteContractAreaDocument?: Maybe<DeleteContractAreaDocument>;
  deleteCostSettings?: Maybe<DeleteCostSettingsMutation>;
  /**
   * Remove one authority row; permits keep the authority name they
   * were recorded with.
   */
  deleteCouncilFeeEntry?: Maybe<DeleteCouncilFeeEntry>;
  deleteCustomerFunction?: Maybe<DeleteCustomerFunction>;
  deleteCustomerNote?: Maybe<DeleteCustomerNote>;
  deleteDashboard?: Maybe<DeleteDashboard>;
  deleteDashboardSubscription: DeleteDashboardSubscription;
  deleteDepot?: Maybe<DeleteDepot>;
  deleteDocument?: Maybe<DeleteDocument>;
  deleteDraftAutomation: DeleteDraftAutomationPayload;
  deleteDriver?: Maybe<DeleteDriver>;
  deleteExportTemplate?: Maybe<DeleteExportTemplate>;
  deleteExternalMapLayer?: Maybe<DeleteExternalMapLayer>;
  deleteFcmDevice?: Maybe<DeleteFcmDevice>;
  deleteFeatureConfigRule?: Maybe<DeleteFeatureConfigRule>;
  deleteHauler?: Maybe<DeleteHauler>;
  /** Office-only: soft-delete a compliance document (keeps the audit). */
  deleteHaulerComplianceDocument?: Maybe<DeleteHaulerComplianceDocument>;
  deleteHaulerPrice?: Maybe<DeleteHaulerPrice>;
  /**
   * Soft-delete a price list (RD-46). Wraps
   * ``product.price_lists.service.delete_price_list``.
   */
  deleteHaulerPriceList?: Maybe<DeleteHaulerPriceList>;
  /**
   * Soft-delete a price row (RD-46). Wraps
   * ``product.price_rows.service.delete_price_row`` — cascades any pending
   * schedule, preserves history.
   */
  deleteHaulerPriceRow?: Maybe<DeleteHaulerPriceRow>;
  deleteImportHistory?: Maybe<DeleteImportHistory>;
  deleteInsightsAlert: DeleteInsightsAlert;
  deleteInsightsAnalysis: DeleteInsightsAnalysis;
  deleteInsightsBuilderDashboard: DeleteInsightsBuilderDashboard;
  deleteInsightsDashboard: DeleteInsightsDashboard;
  deleteInsightsExploration: DeleteInsightsExploration;
  deleteIntegrationGpsVehicle?: Maybe<DeleteIntegrationGpsVehicle>;
  deleteKmdEasyPropertyTypeToKmdEasyStationCode?: Maybe<DeleteKmdEasyPropertyTypeToKmdEasyStationCode>;
  deleteMeasurementSettings?: Maybe<DeleteMeasurementSettings>;
  deleteMunicipality?: Maybe<DeleteMunicipality>;
  deleteMyTemplate: DeleteMyTemplatePayload;
  deleteNotificationSetting?: Maybe<DeleteNotificationSetting>;
  /**
   * Remove a permit record. A fee already billed at grant stays on
   * the customer's account (cancel the billable event separately).
   */
  deletePermit?: Maybe<DeletePermit>;
  deletePickupSettings?: Maybe<DeletePickupSettingsMutation>;
  /**
   * Deleting an area deletes its whole subtree (scenarios, plans,
   * baselines). SBX-537 P1-1 (wave D23): master-gated like every
   * other live-consequence door, refused by name while promotion
   * records exist under the area (they are audit history and their
   * plans are PROTECTed: pre-D23 this died as an unhandled 500), and
   * any other protected leaf refuses cleanly instead of crashing.
   */
  deletePlanningArea?: Maybe<DeletePlanningAreaMutation>;
  deleteProject?: Maybe<DeleteProject>;
  deleteProperty?: Maybe<DeleteProperty>;
  deletePropertyContact?: Maybe<DeletePropertyContact>;
  deletePropertyGroup?: Maybe<DeletePropertyGroup>;
  /**
   * Clear a property's explicit sync config; it reverts to the company /
   * payer-type default.
   *
   * Clears only the user-owned field (frequency) — the
   * task-owned watermarks (last_synced_*) are preserved so a previously-synced
   * property does NOT get treated as a first run and replay already-exported
   * invoices. Only rows that were never synced (no watermark) are hard-deleted.
   *
   * The default cadence is applied to the property's billing schedules and
   * recurring fees right away (``cadence_transition``), exactly like setting
   * it explicitly through ``UpsertPropertyInvoiceSyncConfig`` - the same
   * single writer, so the export gate and the fee generator never disagree
   * on the cadence.
   */
  deletePropertyInvoiceSyncConfig?: Maybe<DeletePropertyInvoiceSyncConfig>;
  deletePropertyManagementCompany?: Maybe<DeletePropertyManagementCompany>;
  deletePropertyManagementCompanyAddress?: Maybe<DeletePropertyManagementCompanyAddress>;
  deletePropertyNote?: Maybe<DeletePropertyNote>;
  deletePropertyType?: Maybe<DeletePropertyType>;
  /**
   * Remove a recorded authority decision (NEXUS-704). Hard delete — the
   * statutory record lives with the authority; this row is a mirror.
   */
  deletePropertyWasteDecision?: Maybe<DeletePropertyWasteDecision>;
  /**
   * Office-only, audited: soft-delete a window (HSY 263) — the row stays
   * for the audit trail. Refused while the window's coverage touches a CLOSED
   * settlement period. ``deleted`` is False when it was already removed.
   */
  deleteReliabilityExclusionWindow?: Maybe<DeleteReliabilityExclusionWindow>;
  deleteReportTemplate: DeleteReportTemplate;
  /**
   * Scenarios are consequence-free; deleting one never touches a
   * live entity (PRD section 5). Promoted scenarios must be kept for
   * audit and are rejected.
   */
  deleteScenario?: Maybe<DeleteScenarioMutation>;
  /**
   * Office-only: cancel a NOT-YET-EFFECTIVE scheduled change (PRO-467). An
   * effect already in force is part of the settlement history and cannot be
   * removed here.
   */
  deleteScheduledExceptionCompensationEffect?: Maybe<DeleteScheduledExceptionCompensationEffect>;
  deleteScheduledExport?: Maybe<DeleteScheduledExport>;
  deleteScheduledExtract: DeleteScheduledExtract;
  /** Delete a custom SCP role. System and in-use roles are protected. */
  deleteScpRoleDefinition?: Maybe<DeleteScpRoleDefinition>;
  deleteService?: Maybe<DeleteService>;
  deleteServiceResponsibility?: Maybe<DeleteServiceResponsibility>;
  deleteSparePart?: Maybe<DeleteSparePart>;
  /**
   * Soft-delete dataset ``id``. ``error``: ``DATASET_IN_USE`` while a
   * builder dashboard (not deleted) reads it, with those dashboards in
   * ``usedOn``; ``DATASET_NOT_FOUND`` for an unknown or deleted id.
   */
  deleteSqlDataset?: Maybe<DeleteSqlDataset>;
  /**
   * 3.6.23: user-facing deletion of a task/emptying (PickUpOrder).
   *
   * Soft-deletes the stop (``deleted`` timestamp, hidden from every active
   * list via ``PickUpOrderQuerySet.active()``) and records it centrally in
   * the DeletionLog. The reason is MANDATORY — deleting an emptying carries
   * financial/contractual weight (the reklamaatio case).
   *
   * Billing: an emptying whose billable event is already INVOICED cannot be
   * deleted (corrections go through a credit note); pre-invoice events are
   * cancelled via the LEDGER-755 cancel-not-delete path, mirroring how an
   * uncompleted stop retracts its charge.
   */
  deleteTask?: Maybe<DeleteTask>;
  deleteTeam?: Maybe<DeleteTeam>;
  deleteTicketCategory?: Maybe<DeleteTicketCategory>;
  deleteTicketCustomField?: Maybe<DeleteTicketCustomFieldMutation>;
  deleteTicketMessageTemplate?: Maybe<DeleteTicketMessageTemplate>;
  deleteTicketType?: Maybe<DeleteTicketType>;
  /** Remove an area rule; the type's own default applies again. */
  deleteTicketTypeAreaExecutionWindow?: Maybe<DeleteTicketTypeAreaExecutionWindowMutation>;
  deleteUser?: Maybe<DeleteUser>;
  deleteUserAbsence?: Maybe<DeleteUserAbsence>;
  deleteUserFilterCollection?: Maybe<DeleteUserFilterCollection>;
  deleteUserProject?: Maybe<DeleteUserProject>;
  deleteVehicle?: Maybe<DeleteVehicle>;
  deleteVehicleAbsence?: Maybe<DeleteVehicleAbsence>;
  deleteVehicleType?: Maybe<DeleteVehicleType>;
  deleteWasteCollector?: Maybe<DeleteWasteCollector>;
  deleteWasteFraction?: Maybe<DeleteWasteFraction>;
  /** PRO-946: delete a version that is not yet locked. */
  deleteWasteFractionEnvironmentalFactor?: Maybe<DeleteWasteFractionEnvironmentalFactor>;
  deleteWasteType?: Maybe<DeleteWasteType>;
  deleteZone?: Maybe<DeleteZone>;
  deleteZoneLabel?: Maybe<DeleteZoneLabel>;
  demoInvitation?: Maybe<DemoInvitation>;
  /**
   * Detach a container from an SCP (NEXUS-642): ends the attachment row;
   * the Container asset itself is never touched.
   */
  detachScpContainer?: Maybe<DetachScpContainer>;
  detachSensor?: Maybe<DetachSensorMutation>;
  disableAutomationEngine: DisableAutomationEnginePayload;
  /**
   * Mark a suggestion DISMISSED -- the wave-off half of the suggestion
   * lifecycle (`AcceptAutopilotSuggestion` above is the built half). A
   * dismissed row stops appearing on Pulse and survives regeneration as
   * lifecycle memory, suppressing a re-pitch of the same (kind, ticket
   * type). Tenant-scoped; idempotent (re-dismissing is a no-op). Dismissing
   * an already-ACCEPTED row is a no-op too: the `built_flow` audit link
   * from pitch to automation is never erased by a stray dismiss.
   *
   * ``undo: true`` moves a DISMISSED row back to NEW -- and only that
   * transition (an accepted row stays accepted, a new row stays new) -- so
   * the frontend can offer an undo toast after a dismiss without a second
   * bespoke mutation. An undone row rejoins the ephemeral NEW pool: the
   * next nightly run replaces or retires it with everything else NEW.
   *
   * Both branches write with a conditional queryset UPDATE (status in the
   * WHERE clause), never read-modify-write: the status check and the write
   * are one statement, so racing the accept mutation can never strand an
   * ACCEPTED row (live ``built_flow``) back to DISMISSED, and racing the
   * nightly regeneration's delete answers not-found instead of a silent
   * zero-row ``save()`` reported as ok.
   */
  dismissAutopilotSuggestion?: Maybe<DismissAutopilotSuggestion>;
  /**
   * RS-1203 dismiss with audit; dismissal is the EV-RECS negative
   * label, so every dismissal sharpens the precision gate.
   */
  dismissRecommendation?: Maybe<DismissRecommendationMutation>;
  /**
   * Move a holiday-colliding visit to a working day (HAUL-018 ops
   * half) — through the EXISTING stop-move machinery — and journal
   * the customer notice (STAGED, inert channel). Calling this IS the
   * confirmation: either the office pressed the button, or the
   * account's agreement pre-authorized the move (the journal row says
   * which).
   */
  displaceHaulerVisit?: Maybe<DisplaceHaulerVisit>;
  /**
   * Driver-initiated temporary relocation (3.2.28, PRO-236 child 2).
   *
   * REQ-315 only NOTIFIED drivers about relocations; this lets the person
   * who actually sees the washed-out road request one from the field. The
   * wall is server-enforced, not client-hidden:
   *
   * - the caller must have a linked Driver profile (``user.is_driver``);
   * - the container must be one of the driver's OWN accessible containers —
   *   on a stop of a route the driver is assigned to (``RouteVehicle``),
   *   within their company. Anything else in the company is denied and
   *   belongs to the office mutation.
   *
   * Downstream it is the ONE existing relocation path
   * (``create_relocation_request``): same ticket type, same scheduled ->
   * applied -> reverted lifecycle, same single-live-change invariant.
   */
  driverCreateTemporaryContainerLocation?: Maybe<DriverCreateTemporaryContainerLocation>;
  /** COMPASS-875 / HSY REQ 11: produce a driving list that can be carried to the driver app on a USB stick, a LAN share or a local server. Versioned, checksummed, signed, addressed to one company + driver and valid for a bounded window; the app refuses anything that is not provably its own. */
  drivingListExport?: Maybe<DrivingListExport>;
  duplicateAutomation: DuplicateAutomationPayload;
  /**
   * Behavior 2 delta — prompt-edit of a dashboard spec.
   *
   * Spec in + instruction -> full edited spec out, through the exact
   * normalisation funnel generateInsightsDashboard uses, so AI edits
   * can never produce widgets a hand-built dashboard couldn't.
   * Persistence lands with W6; this is spec-in/spec-out.
   */
  editInsightsDashboard: GenerateInsightsDashboardResult;
  enableAutomationEngine: EnableAutomationEnginePayload;
  /**
   * Record that composting at this row has stopped.
   *
   * Takes no date and no reason. The service owns both decisions: the date is
   * the server's, because when a statutory event was reported must not be
   * movable by whoever reports it, and a reason is written separately through
   * ``UpdateCompostingRegistryEntry(endReason:)`` so that ending cannot
   * half-succeed.
   */
  endCompostingRegistryEntry?: Maybe<EndCompostingRegistryEntry>;
  endContactAuthorization?: Maybe<EndContactAuthorization>;
  /**
   * Office ends a hire (collect): the placement's last billed day is set
   * and the hire stops. Wraps ``rental.end_rental`` — sets state only; the
   * clock finalizes billed-to on its next run. ``endDate`` is INCLUSIVE (the
   * last day the rental bills — the GS-3 convention). Idempotent.
   */
  endHaulerRental?: Maybe<EndHaulerRental>;
  /**
   * Asukasvaihdos — end EVERY SCP membership of a property at one date.
   *
   * A resident move-out is ONE action, not N End-membership dialogs: ends all
   * of the property's active memberships (across every SCP) in one
   * transaction, applies the operator's role hand-overs so each remaining pool
   * keeps its Contact Person / Payer, redistributes shares per SCP, and
   * recomputes the property's register basis (``NONE`` / "Ei liittynyt" when
   * nothing else keeps it connected). A forgotten hand-over surfaces as
   * ``SCP_MISSING_*`` and rolls the whole move-out back (NEXUS-665/667).
   */
  endPropertyScpMemberships?: Maybe<EndPropertyScpMemberships>;
  /**
   * End an ACTIVE scheduled change early: the window is truncated and
   * the displaced baseline restored (req 3.1.38).
   */
  endScheduledChangeNow?: Maybe<EndScheduledChangeNow>;
  /** End a company's SCP membership and re-balance the remaining members. */
  endScpCompanyMembership?: Maybe<EndScpCompanyMembership>;
  /**
   * End a property's SCP membership and re-balance the remaining members.
   *
   * The leaver's ``end_date`` is recorded and its share is redistributed so the
   * active members again sum to 100.00. By default the redistribution is
   * proportional to the remaining members' current shares (SRS 3.2.13); pass
   * ``shares`` (percent 0..100 for exactly the remaining members) to override it
   * with an edited vector. Rejects an edited vector that does not sum to 100.00
   * with a structured error (``SHARES_MUST_SUM_TO_100``).
   */
  endScpMembership?: Maybe<EndScpMembership>;
  /** End an SCP membership-role assignment at an optional end date. */
  endScpMembershipRole?: Maybe<EndScpMembershipRole>;
  /**
   * End a membership, first handing its required roles to successors.
   *
   * The single-mutation convenience behind the NEXUS-667 guard modal: ending
   * the sole Contact Person / Payer member is normally refused with
   * ``SCP_MISSING_*``; here the operator's chosen ``roleHandovers`` are applied
   * (assigning the role to another active member) and the membership is ended
   * in ONE transaction, so the invariant never transiently breaks and a failed
   * end rolls the hand-over back with it. ``shares`` optionally overrides the
   * proportional redistribution (percent for the remaining members).
   */
  endScpMembershipWithHandover?: Maybe<EndScpMembershipWithHandover>;
  /**
   * Create (idempotently) and prefill the transfer document of a stop.
   * Returns null when the stop is not eligible or the flag is off.
   */
  ensureTransferDocument?: Maybe<EnsureTransferDocument>;
  /**
   * Office swaps the container on a hire (RD-16 exchange): the OLD
   * placement ends the day BEFORE the swap and a NEW placement starts ON the
   * swap date, so the Ledger clock resets with no double-billed day and no
   * gap. Composed of ``end_rental`` + ``begin_rental``; site/service/qty are
   * inherited from the old placement unless overridden.
   *
   * RD-16 safety: ``endDate`` billing is INCLUSIVE while the DB
   * container-overlap constraint is upper-EXCLUSIVE (``[start, end)``) — so
   * the constraint would NOT catch an inclusive-end overlap on the swap day.
   * This mutation therefore enforces the OLD-END + 1 pattern itself: old
   * last-billed day = ``exchangeDate - 1``, new start = ``exchangeDate``.
   * Wrapped in one transaction so a failed begin rolls back the end.
   */
  exchangeHaulerRental?: Maybe<ExchangeHaulerRental>;
  /**
   * Office-only (PRO-118): exclude an agreement from a contract area —
   * detaches it when attached and keeps it out of the Pending queue until
   * re-included. Change-logged, reversible.
   */
  excludeAreaAgreement?: Maybe<ExcludeAreaAgreement>;
  /**
   * Materialize into live entities through the single F10 mutation
   * site (idempotent; emits promotion.materialized).
   */
  executePromotion?: Maybe<ExecutePromotionMutation>;
  exportBillingRunToNavision?: Maybe<ExportBillingRunToNavision>;
  exportDebtorData?: Maybe<ExportDebtorData>;
  /**
   * W7.1: CSV/XLSX straight from the query engine (ADR-INT-006) —
   * exported numbers are the widget numbers by construction.
   */
  exportInsights: ExportInsightsResult;
  /**
   * W9.1: the audit trail as a CSV — same rows as the query (they
   * share insights.audit.audit_rows so they can never disagree).
   */
  exportInsightsAudit: ExportInsightsAudit;
  /**
   * SBX-366 (D32, D08): the RS-204 comparison as a downloadable
   * xlsx or pdf. Read-only (no master gate): the document is built
   * from recorded rows through the same scoring/rates helpers the
   * query surface uses, and the D32 claim-grade label plus baseline
   * caveats render in the file itself.
   */
  exportPlanComparison?: Maybe<ExportPlanComparisonMutation>;
  /**
   * SBX-366 (D32, D08): one plan's recorded summary (KPIs,
   * decomposition, calendar impact, binding constraints) as a
   * downloadable xlsx or pdf, with the D32 basis block on the page.
   */
  exportPlanSummary?: Maybe<ExportPlanSummaryMutation>;
  /**
   * SBX-366 (D32, D18): the promotion's RECORDED diff (the stored
   * shared-derivation summary, never a re-derivation) as a
   * downloadable xlsx or pdf. Counts are exact, entry lists capped
   * with truncation flags, and the D32 basis block renders on the
   * page.
   */
  exportPromotionDiff?: Maybe<ExportPromotionDiffMutation>;
  /**
   * W11.2: a generated statutory draft as CSV/XLSX — frozen fields
   * flattened for the officer's filing workflow.
   */
  exportStatutoryDraft: ExportStatutoryDraft;
  exportTemplateScheduleSettingsUpdate?: Maybe<ExportTemplateScheduleSettingsUpdate>;
  /**
   * Move one rental unit's return date later (PRODUCT-452, BE-E1 - the
   * office list's Extend action). Writes the unit's ``period_end_date``
   * through ``inventory.services.rental_extend.extend_rental``: the hire
   * product's ``max_days`` rule is re-applied to the new period, the
   * STRICT availability gate is re-run for the unit's pool at the new end
   * (it refuses only a pool that is already short - under STRICT the
   * extension itself never changes the count), a later booking already
   * committed to the same physical unit refuses the extension, and on
   * success the rental-backed
   * agreement's end (``rental:<ticket pk>`` / started_by_ticket) and the
   * open return ticket's preferred date move along with it. Same shape and
   * company wall as ``issueRental`` / ``returnRental``; refusals name the
   * ``periodEndDate`` field.
   */
  extendRental?: Maybe<ExtendRental>;
  /**
   * Extend the duration of an active temporary location override.
   *
   * Updates the owning ticket's ``periodEndDate`` (the generic Include
   * period field, PRO-385) without changing the location itself.
   */
  extendTemporaryContainerLocation?: Maybe<ExtendTemporaryContainerLocation>;
  /**
   * Mark every machine-placed ('added') entry of the template reviewed.
   *
   * The planner looked at where the machine put the new stops and agrees;
   * the entries become ``manual`` and stop counting as needing attention.
   * Dragging one already does this for that entry; this is the "all fine"
   * button for the rest.
   */
  fixedRouteTemplateAcceptPlacements?: Maybe<FixedRouteTemplateAcceptPlacements>;
  /**
   * Copy another scheme's template onto this route's scheme as a DRAFT.
   *
   * The reuse path: the planner sequenced this round once under another
   * scheme, or a suggestion (``RouteType.fixedRouteSuggestions``) found a
   * template that already orders most of this route. The order comes over
   * stamped ``inherited``, the rest of the scheme's master data is
   * appended, and the result is a DRAFT the planner confirms and applies
   * like any other — nothing is put into service by this call.
   */
  fixedRouteTemplateAdopt?: Maybe<FixedRouteTemplateAdopt>;
  /**
   * Put the template into service and re-sequence ``route`` to it now.
   *
   * READY → ACTIVE, so every later generation the template governs is
   * re-sequenced too — every route of the SCHEME for the ordinary
   * scheme-wide template, or only the named truck's routes for a
   * vehicle-specific override — and the route the planner is looking at
   * is renumbered here rather than at the next nightly run, so they can
   * see what they just decided.
   *
   * ``auto_optimize`` is switched OFF on that route, and never back on: a
   * pinned order and a nightly re-optimisation are the same decision made
   * twice, so left on, the next optimisation would undo the order that
   * was just applied. Restoring it is a deliberate per-route action in
   * the office, not something this mutation reverses.
   *
   * A DRAFT template is refused: confirming it is the review step. An
   * already-ACTIVE one is not, so a planner can re-apply the order to the
   * next day's route without taking the template out of service first.
   * A COMPLETED route is refused outright, and a STARTED one is
   * re-sequenced only from the driver's next stop onward — the service
   * owns that rule so the nightly path inherits it too; refusing here as
   * well is so the planner is told, rather than watching Apply appear to
   * work on a round that is already driven.
   */
  fixedRouteTemplateApply?: Maybe<FixedRouteTemplateApply>;
  /**
   * Put ``template`` into service and re-sequence EVERY upcoming route of
   * its scheme to it, in one gesture from the tab.
   *
   * The office Apply pins one route; this is the "and all the others" the
   * planner asks for right after, without a trip to the routes list. A
   * READY template is activated (demoting the previous active variant); a
   * DRAFT is refused. Routes already completed, or started unless
   * ``includeStarted``, are skipped and reported. Never fails the batch.
   */
  fixedRouteTemplateApplyToScheme?: Maybe<FixedRouteTemplateApplyToScheme>;
  /**
   * Mark a draft order correct: DRAFT → READY.
   *
   * Changes nothing about any route on its own. READY is the planner
   * saying the order is right; ``fixedRouteTemplateApply`` is the separate
   * decision to drive it.
   */
  fixedRouteTemplateConfirm?: Maybe<FixedRouteTemplateConfirm>;
  /**
   * Take an ACTIVE template out of service (-> READY).
   *
   * The routes bound to it are released and keep the order they drive
   * today; from the next generation on they are resolved afresh (another
   * ACTIVE template of the scheme that covers them, or the solver's
   * order). The scheme's other templates keep driving their own routes.
   * ``auto_optimize`` is left as it is - switching it back on is the
   * per-route office decision it always was.
   */
  fixedRouteTemplateDeactivate?: Maybe<FixedRouteTemplateDeactivate>;
  /**
   * Delete a template variant that is not in service.
   *
   * An ACTIVE template is refused: it governs tonight's generation, and
   * taking a round back to the solver's order is a decision made by
   * applying another variant, not by deleting this one under it.
   */
  fixedRouteTemplateDelete?: Maybe<FixedRouteTemplateDelete>;
  /**
   * "Stop using for this route": release ONE route from the template
   * it drives. The template and its other routes are untouched.
   *
   * The route keeps the order it has and its ``auto_optimize`` as it is;
   * the nightly generation leaves it to the solver (no re-apply, no draft)
   * until the next explicit Apply on it, which is a newer decision. The
   * ``route_detached`` history row is what carries that decision.
   */
  fixedRouteTemplateDetachRoute?: Maybe<FixedRouteTemplateDetachRoute>;
  /** Label a template variant. Changes no order and no status. */
  fixedRouteTemplateRename?: Maybe<FixedRouteTemplateRename>;
  /**
   * Throw the planner's edits away and go back to the seeded order.
   *
   * Returns the template to DRAFT, like every other write to the order —
   * see ``revert_to_seeded``.
   */
  fixedRouteTemplateRevertToSeeded?: Maybe<FixedRouteTemplateRevertToSeeded>;
  /**
   * Store the order the planner dragged the stops into.
   *
   * Merged into the template rather than replacing it — see
   * ``merge_stop_order``. Returns the template to DRAFT, so a changed
   * order has to be confirmed and applied again before any route is
   * generated against it.
   */
  fixedRouteTemplateSaveOrder?: Maybe<FixedRouteTemplateSaveOrder>;
  /**
   * A DRAFT variant from the order the drivers actually drove.
   *
   * The cold start of fixed routes without dragging: the last completed
   * routes of the scheme, in the order their stops were confirmed, folded
   * into one consensus order (``fixed_routes_history``). ``agreement`` is
   * how consistently the days were driven (Kendall tau, 1.0 = identical);
   * the planner reads it before trusting the seed. Nothing is activated.
   */
  fixedRouteTemplateSeedFromHistory?: Maybe<FixedRouteTemplateSeedFromHistory>;
  /**
   * Start (or restart) the scheme's template from a route's own order.
   *
   * Nobody sequences several hundred stops from nothing, so the planner
   * takes what the solver produced and corrects it. Re-seeding an existing
   * template deliberately discards its edits and returns it to DRAFT: this
   * is the "start again from the solver" action, not an update.
   *
   * The template is SCHEME-WIDE, and seeded with the scheme's whole master
   * data rather than one day's stops, so it is sequenced once and then
   * governs every route the scheme generates — see
   * ``seed_template_from_route``.
   */
  fixedRouteTemplateSeedFromRoute?: Maybe<FixedRouteTemplateSeedFromRoute>;
  /**
   * Re-sequence the SELECTED routes to their ACTIVE templates.
   *
   * The bulk action for the routes list: a planner selects routes and
   * asks for it explicitly, so nothing is re-sequenced by accident. Each
   * route is re-sequenced to the template that governs its own scheme —
   * there is no template argument, because a template governs a scheme
   * and the routes name their schemes. A route without an active
   * template, or already completed, is reported and skipped, never
   * failed; the mutation answers per route.
   *
   * ``auto_optimize`` goes off on every route re-sequenced, as with the
   * single Apply. ETAs are re-timed per moved route after the commit.
   */
  fixedRouteTemplatesApplyToRoutes?: Maybe<FixedRouteTemplatesApplyToRoutes>;
  formError?: Maybe<FormErrorMutation>;
  /**
   * Item 1: for the caller's company, run the FULL pipeline in one chained
   * task — recurring fees -> billing run -> pp->crm bridge -> Visma export —
   * i.e. exactly the chain the nightly beat runs
   * (``invoicing.services.invoicing_pipeline``). Unlike ``triggerVismaExport``
   * (which only ships invoices that already exist), this GENERATES the
   * invoices first, then exports. The operator's bell job follows the chain
   * and closes when the export lands.
   */
  generateAndRunVismaExport?: Maybe<GenerateAndRunVismaExport>;
  generateBarcodesForContainers?: Maybe<GenerateBarcodesForContainers>;
  generateCollectionCalendarsPickupSettings?: Maybe<GenerateCollectionCalendarsPickupSettings>;
  /**
   * W7.4 Behavior 10: engine-frozen figures + formal-register
   * connective prose (top model tier via the router).
   */
  generateCommitteePack: CommitteePackResult;
  generateDatesForCollectionCalendars?: Maybe<GenerateDatesForCollectionCalendars>;
  /**
   * Generate a dashboard spec from a natural-language prompt with AI.
   *
   * Gated by insights_enabled + insights_ai_enabled (both must be True).
   *
   * Routes widgets to the plan funnel (_normalize_ai_plan_widget) when the
   * widget dict contains a "plan" key, and to the legacy metric funnel
   * (_normalize_ai_widget) otherwise. This preserves back-compat with
   * existing metric-mode AI output.
   */
  generateInsightsDashboard: GenerateInsightsDashboardResult;
  /**
   * Item 6: generate an invoice for ONE property (its own billable events),
   * then mirror it into crm.Invoice so it shows on the property's legacy
   * invoices tab. Runs the normal billing engine scoped to the property
   * (EventScope.property_ids) via a task — the same engine the nightly run
   * uses, just narrowed. Mints money, so it takes the write gate.
   *
   * The bell job is opened HERE (not by the task) so its id can go back to
   * the UI in the same response: the invoices tab follows that one job
   * (``userJobNotification(id)``) to its completed/failed state instead of
   * polling the invoice list blind for a run that may produce nothing.
   */
  generateInvoiceForProperty?: Maybe<GenerateInvoiceForPropertyMutation>;
  generateKmdEasyFile?: Maybe<GenerateKmdEasyFile>;
  /**
   * RS-1603 (D42): generate a template-framed, engine-grounded
   * draft. Every numeral is source-checked before the row exists; the
   * judge harness scores the draft with the D46-gated verdict; the
   * document stays DRAFT until a human approves it.
   */
  generateNarrativeDocument?: Maybe<GenerateNarrativeDocumentMutation>;
  /**
   * Regenerate the RS-302 service units of a stop set.
   *
   * Dispatches the routing-matrix Celery task (ADR-0003 section 3);
   * the units land asynchronously and the visual QA layer
   * (allServiceUnits) shows them. ``profile`` names a truck profile
   * (D28); until the Q-005 profile servers exist the task degrades to
   * the default network and records the fallback on every unit.
   */
  generateServiceUnits?: Maybe<GenerateServiceUnitsMutation>;
  /**
   * W11.1: deterministic statutory draft — engine fields frozen
   * with lineage, everything else surfaced in the missing-field
   * report. No AI touches this path.
   */
  generateStatutoryDraft: GenerateStatutoryDraft;
  /**
   * Run the RS-102 geocoding pass over confirmed rows, producing
   * the stop set, per-stop confidence and the fix queue.
   */
  geocodeImportBatch?: Maybe<GeocodeImportBatchMutation>;
  goLiveAutomation: GoLiveAutomationPayload;
  goShadowAutomation: GoShadowAutomationPayload;
  /**
   * Keep-alive (~60 s while the editor is active). ``expired`` means
   * the lease lapsed; ``lost`` means someone took over (their lease is
   * returned).
   */
  heartbeatRecordLease?: Maybe<HeartbeatRecordLease>;
  impersonate?: Maybe<Impersonate>;
  /**
   * Import a contract area's geographic boundary from an uploaded file.
   *
   * Requirement 3.5.54 / D25 (customer-confirmed): the office imports shape
   * files as contract zones. Accepts a zipped shapefile (.shp + .shx + .dbf +
   * optional .prj) or a GeoJSON file via the platform's standard multipart
   * ``Upload`` scalar (graphene-file-upload, same path as container photos).
   * The file is parsed with GDAL, every polygon is transformed to WGS84
   * (SRID 4326) and stored as a MultiPolygon on ``Area.boundary``.
   *
   * Office-only: contract-area geometry is office-managed (same rule as
   * ``UpdateOrCreateArea``); contractors are denied. The area is company-scoped
   * so a cross-tenant global id is a not-found, never a cross-tenant write.
   */
  importAreaBoundary?: Maybe<ImportAreaBoundary>;
  /**
   * Record the finance system's credit notes against exported lines
   * (idempotent per line + credit note number).
   */
  importFinanceCreditNotes?: Maybe<ImportFinanceCreditNotesMutation>;
  importKmdEasyFile?: Maybe<ImportKmdEasyFile>;
  /**
   * Import a zone's geographic boundary from an uploaded file (DEV-TASK-1,
   * platform-level since T4).
   *
   * Clone of :class:`ImportAreaBoundary` for zones: accepts a zipped
   * shapefile (.shp + .shx + .dbf + optional .prj) or a GeoJSON file via the
   * standard multipart ``Upload`` scalar, parses with GDAL, transforms to
   * WGS84 and stores a MultiPolygon on ``Zone.boundary``. Office-only,
   * company-scoped; no module flag.
   */
  importZoneBoundary?: Maybe<ImportZoneBoundary>;
  /**
   * COMPASS-885 / HSY REQ 43 — apply externally-sourced stop confirmations.
   *
   * One entry point for every reader vendor. Per-event savepoints, per-event
   * status back to the caller, idempotent on
   * ``(company, sourceSystem, externalId)``.
   */
  ingestExternalConfirmations?: Maybe<IngestExternalConfirmationsPayload>;
  /** Deliver ONE weighing. Idempotent on (system, externalId). */
  ingestWeighTicket?: Maybe<IngestWeighTicket>;
  /**
   * Deliver a BATCH of weighings — a nightly or reconnect catch-up.
   *
   * One savepoint per ticket, so a single malformed slip cannot roll back the
   * other 999. Per-ticket outcomes come back in ``results``, the same shape
   * ``syncOfflineOperations`` uses and for the same reason: a caller that
   * cannot tell which item failed has to retry the whole batch, and with an
   * idempotent key that is safe but wasteful.
   */
  ingestWeighTickets?: Maybe<IngestWeighTickets>;
  /**
   * Create a new draft Flow (and its version 1) from one starter-gallery
   * template (AP-404).
   *
   * Pre-binds the template's `ticket_type_ref` to this tenant's own
   * `TicketType` when a case-insensitive name match exists (`mappable=True`,
   * the rendered definition's trigger filter carries the tenant's exact
   * spelling); otherwise the filter keeps the catalog's canonical placeholder
   * name and `mappable=False` -- the flow still instantiates as a draft
   * either way (04_BACKLOG.md AP-404 AC: "pre-bound ... where mappable", not
   * "only where mappable").
   *
   * Runs the same registry-aware validator `UpdateAutopilotFlowDefinition`
   * does (`autopilot.builder.validator.validate_for_builder`) before writing
   * anything: an invalid rendered definition (a catalog authoring bug) creates
   * no `Flow` row at all. `warnings` carries the same non-fatal autonomy-class
   * advisories (money/mass_comms/bulk steps).
   */
  instantiateAutopilotPlaybook?: Maybe<InstantiateAutopilotPlaybook>;
  internalUpdateOrCreateSalesOffer?: Maybe<InternalUpdateOrCreateSalesOfferPayload>;
  inviteUsers?: Maybe<InviteUsers>;
  /**
   * Dispatch one rented unit (PRO-271): write the -1 ISSUE
   * serialization row against the container, moving the unit COMMITTED ->
   * DISPATCHED (``inventory.services.rental.issue_rental``). A scanned or
   * provided ``containerId`` names the physical unit; omit it to let the
   * service resurrect a dormant identity for the pool. Idempotent per
   * ticket. Returns the dispatched container's public id.
   */
  issueRental?: Maybe<IssueRental>;
  /**
   * Safety backbone slice #1: stop one bad live flow, right now, without
   * touching every other tenant/flow the way the global `AUTOPILOT_KILL_ALL`
   * switch (`autopilot.flags`) does.
   *
   * Sets `Flow.killed = True` and writes a mandatory-reason
   * `FlowAuditLogEntry(action=KILLED)` (CLAUDE.md rule 5). `killed` is
   * checked at the live chokepoint
   * (`autopilot.runtime.trigger_intake.match_live_flows`) independent of
   * `state` -- a killed flow stops firing on its very next matching event,
   * regardless of whether it is currently `live` or `shadow` -- and,
   * defense-in-depth, `Flow.promote_to` refuses to promote/activate a
   * killed flow at all (see that method's docstring): the only way back is
   * the explicit, also-audited `unkillAutopilotFlow` below.
   *
   * `reason` is required (not merely encouraged): an operator killing a
   * live flow is a safety-critical action and the audit trail must always
   * say why, not rely on the actor remembering to fill it in.
   */
  killAutopilotFlow?: Maybe<KillAutopilotFlow>;
  /**
   * Office-only (PRO-120): record that ``successor`` succeeds
   * ``predecessor`` — the renewal link the wizard stores right after
   * creating a renewal area.
   */
  linkAreaSuccession?: Maybe<LinkAreaSuccession>;
  linkContactToProperty?: Maybe<LinkContactToProperty>;
  linkContactToPropertyManagementCompany?: Maybe<LinkContactToPropertyManagementCompany>;
  linkManagementCompanyToProperty?: Maybe<LinkManagementCompanyToProperty>;
  /**
   * REQ-386 slice 5 (kimppakaivo): link a property as a member of another
   * property's shared waste-water tank. Reuses the SCP membership pattern —
   * a date-ranged, PROTECT-guarded membership row (mirrors CreateScpMembership).
   */
  linkSharedTankMember?: Maybe<LinkSharedTankMember>;
  /** Acknowledge an alert server-side (retires the localStorage ack). */
  liveOpsAcknowledgeException?: Maybe<LiveOpsAcknowledgeException>;
  /** Log a 'Call driver' event (client tel: link) — no send (A3). */
  liveOpsLogCall?: Maybe<LiveOpsLogCall>;
  /** Mark a stop skipped with a required reason code (A2). */
  liveOpsMarkStopSkipped?: Maybe<LiveOpsMarkStopSkipped>;
  /** Message a route's driver — persisted, timestamped, INERT (A3). */
  liveOpsMessageDriver?: Maybe<LiveOpsMessageDriver>;
  /** Reassign a route's remaining stops to another vehicle (A1). */
  liveOpsReassignStops?: Maybe<LiveOpsReassignStops>;
  /** Resolve an alert with a descriptive reason (never a monetary decision). */
  liveOpsResolveException?: Maybe<LiveOpsResolveException>;
  /** Close a missed collection: place a go-back stop, or fall back to a ticket. */
  liveOpsScheduleRecollect?: Maybe<LiveOpsScheduleRecollect>;
  /** Snooze an alert for a number of minutes (server-side). */
  liveOpsSnoozeException?: Maybe<LiveOpsSnoozeException>;
  /**
   * Un-acknowledge an alert (the inverse of acknowledge): move it back to
   * the active worklist. Also clears any snooze — see
   * :func:`unacknowledge_exception`.
   */
  liveOpsUnacknowledgeException?: Maybe<LiveOpsUnacknowledgeException>;
  /** Reverse the last undoable action from its before-state. */
  liveOpsUndo?: Maybe<LiveOpsUndo>;
  /**
   * Abandon an in-progress chain (the compactor was inaccessible, a
   * mis-tap, the wrong task).
   *
   * RELEASES the anchor task: it is left open, uncompleted and unskipped,
   * and a fresh chain may be started on it. Cancelling is a resolution of
   * the LOAD, never a verdict on the task — closing the task is
   * ``routeStopComplete``'s job, with a COMPASS-883 deviation reason when
   * the work did not happen.
   */
  loadUnitJobCancel?: Maybe<LoadUnitJobCancel>;
  /**
   * Second confirmation: the unit was emptied at the disposal site.
   *
   * The anchor task stays open and stays PENDING — the empty unit still has
   * to go back. Records the depot (or a free-text site), the net weight and
   * where the emptying happened.
   */
  loadUnitJobMarkEmptied?: Maybe<LoadUnitJobMarkEmptied>;
  /**
   * Third confirmation: the empty unit is back on the ground.
   *
   * THIS is the one that completes the anchor task, through
   * ``Route.action_complete_stops`` — so invoicing, live-ops, the
   * extra-emptying chain and the Autopilot emitters fire exactly once, at
   * the moment the service is genuinely finished.
   *
   * If the task can no longer be completed (the office closed the route
   * while the driver was offline, the task was deleted, a scheme rule now
   * refuses it) the chain still reaches ``unloaded`` and the reason is
   * reported on ``stopCompleted`` / ``stopCompletionError`` rather than
   * raised. Refusing the unload would leave the load pending forever and
   * make the queued operation retry until the driver clears their outbox.
   */
  loadUnitJobMarkUnloaded?: Maybe<LoadUnitJobMarkUnloaded>;
  /**
   * First confirmation: the driver marks a pallet/compactor LOADED.
   *
   * The anchor task is deliberately left OPEN — it is completed at the
   * third confirmation, when the service is genuinely finished — and from
   * here on it reads as PENDING everywhere
   * (``PickUpOrderType.pendingLoadUnitJob``).
   *
   * Idempotent on ``loadId``: replaying the same queued operation returns
   * the same job instead of erroring, so a driver's outbox always drains.
   */
  loadUnitJobStart?: Maybe<LoadUnitJobStart>;
  location?: Maybe<LocationMutation>;
  logViewPropertyEvent?: Maybe<LogViewPropertyEvent>;
  logViewTicketEvent?: Maybe<LogViewTicketEvent>;
  manageFiles?: Maybe<ManageFilesMutation>;
  /**
   * Stamp every not-yet-seen background-job notification of the current
   * user ``date_seen`` at once — what opening the "Background jobs" tab
   * does, the job twin of ``MarkAllUserNotificationsSeen``.
   *
   * Seen is NOT read here: ``allUserJobNotifications`` hides a job by
   * ``read_by`` (the per-card dismiss, ``MarkUserJobNotificationRead``),
   * so touching ``date_read``/``read_by`` from the tab would empty the
   * list the operator just opened. Only the bell badge
   * (``allUserJobNotifications(unseen: true)``) is meant to drop to zero.
   */
  markAllUserJobNotificationsSeen?: Maybe<MarkAllUserJobNotificationsSeen>;
  markAllUserNotificationsRead?: Maybe<MarkAllUserNotificationsRead>;
  markAllUserNotificationsSeen?: Maybe<MarkAllUserNotificationsSeen>;
  /**
   * Upsert the current operator's read marker for a general conversation.
   *
   * Drives the back-office unread badge. Scoped and gated exactly like the reply
   * mutation, so an operator can only mark their own company's general
   * conversations read; a foreign / hauler / ticket id resolves to the clean
   * "not found" denial.
   */
  markCompanyPortalConversationRead?: Maybe<MarkCompanyPortalConversationRead>;
  /**
   * Record a futile (wasted) visit on one order line (HAUL-413,
   * S4-O1 office path). Reason speaks the execution layer's deviation
   * vocabulary; photo evidence references EXISTING ticket attachments
   * on the line's linked work order. The result is a fault SUGGESTION
   * — no fee is produced here, ever.
   */
  markHaulerLineFutile?: Maybe<MarkHaulerLineFutile>;
  /**
   * Close an order commercially (S3-O1, HAUL-409/419): recompute
   * the rollup, require DONE, run the paper gate — VERIFIED and billed
   * through the money lane's plain-data contract, or held PENDING with
   * the reasons in ``missingPaper``. Flag-gated and contractor-denied
   * like every hauler-mode surface (D-E10 DENIED stance — the sweep
   * classifies root Query fields; this mutation rides the same
   * ``_require_company`` gate, proven by tests).
   */
  markHaulerOrderCompleted?: Maybe<MarkHaulerOrderCompleted>;
  /**
   * Bulk close (FIXIT2-O2, NID REQ-090): mark MANY orders completed
   * in one call — one transaction per order, partial success reported
   * per order (done / pending-with-reasons / failed-with-human-words).
   * The 300-WO/day office closes the day in a few clicks instead of
   * 300. Rides the same gate as every hauler-mode surface.
   */
  markHaulerOrdersCompleted?: Maybe<MarkHaulerOrdersCompleted>;
  /**
   * UNSENT → SENT + journal entry. STAGED honesty: nothing is
   * transmitted — external dispatch (e-mail/NemHandel) is a founder-staged
   * action in W1 (hard limit).
   */
  markInvoiceSent?: Maybe<MarkInvoiceSent>;
  /**
   * The explicit human act that gives a manifest gap an owner
   * (RS-E24, D62): the data is unavailable, the documented fallback
   * applies, the node stops blocking. ``unavailable: false`` clears
   * the mark and the node recomputes from the uploads.
   */
  markManifestNodeUnavailable?: Maybe<MarkManifestNodeUnavailableMutation>;
  markUserJobNotificationRead?: Maybe<MarkUserJobNotificationRead>;
  markUserNotificationRead?: Maybe<MarkUserNotificationRead>;
  markUserNotificationSeen?: Maybe<MarkUserNotificationSeen>;
  /** Office manual match — the queue that stops anything being dropped. */
  matchWeighTicket?: Maybe<MatchWeighTicket>;
  /**
   * Materialize a case's CONFIRMED grammar claims into dated
   * route-runs 12 to 18 months ahead (RS-E25, stage F, D56). Runs
   * are versioned staging objects, never live routes or calendars;
   * re-materializing stores a diff (added/removed/moved/changed)
   * against the previous version, never a duplicate world. Refuses
   * while the completeness manifest has blocking requirements (D62).
   * ``anchorDate`` defaults to today HERE, in the view; the library
   * itself always takes it explicitly.
   */
  materializeImportCase?: Maybe<MaterializeImportCaseMutation>;
  /**
   * 'Monitor this' straight from a metric a user is looking at — a
   * deterministic alert with no NL compiler and no AI gate: the metric,
   * threshold and direction are explicit, validated against the governed
   * engine (validate_rule), and the subscription starts PENDING so the
   * confirmation gate (Behavior 7) still holds before anything fires.
   */
  monitorInsightsMetric: MonitorInsightsMetric;
  /**
   * Move stops between routes — the D-E18(b) modal's backend
   * (FIXIT2-O1, mode-1 F1/F2/F8). DELEGATES to the existing
   * ``Route.action_stops_move`` through ``services.stop_moves`` (never
   * a second mover); the whole move is one transaction, every source
   * route gets a ``DispatchAction`` audit row, and a routing-engine
   * outage answers with ONE human sentence — nothing moved, no raw
   * infra text. Flag-gated and contractor-denied like every
   * hauler-mode surface (D-E10 DENIED stance).
   */
  moveHaulerStops?: Maybe<MoveHaulerStops>;
  /**
   * Move a member property to another Shared Collection Point.
   *
   * Ends the source membership at ``moveDate`` (redistributing its share over
   * the remaining members — proportionally, or via ``sourceShares``) and joins
   * the target SCP at the same date with the carried-over share (or ``share``,
   * percent), attributes and active roles; the target pool is re-balanced.
   * When warnings exist (property outside the target's default radius, active
   * agreements following the move) the caller must re-submit with
   * ``confirm=True``; the first call returns ``requiresConfirmation=True`` and
   * ``warnings`` without mutating anything.
   */
  moveScpMembership?: Maybe<MoveScpMembership>;
  /**
   * Provide a presigned URL and authentication data for uploading attachments directly to S3.
   * The URL has the expiration time, defined in settings by AWS_PRESIGNED_URL_EXPIRY.
   */
  obtainAttachmentsDirectUploadUrl?: Maybe<ObtainAttachmentsDirectUploadUrl>;
  /**
   * Provide a presigned URL and authentication data for uploading attachments directly to S3.
   * The URL has the expiration time, defined in settings by AWS_PRESIGNED_URL_EXPIRY.
   */
  obtainImportDirectUploadUrl?: Maybe<ObtainImportDirectUploadUrl>;
  offlineMode?: Maybe<OfflineModeUpdateData>;
  /**
   * Order a key for a customer (AC1/AC2): creates a KEY_ORDER ticket and
   * its PhysicalKey and sends it to the locksmith. Returns the key + the
   * order ticket's global id.
   */
  orderKey?: Maybe<OrderKey>;
  /**
   * Order a spare part for a customer's container (PRO-256).
   *
   * Creates an inventory-internal order-spare-part ticket carrying the
   * container context and the ordered part / quantity / fulfilling
   * warehouse. Completing that ticket issues the part out of the warehouse
   * (a -N spare-part ledger row stamped with the ticket). The ticket is the
   * audit + workflow record the portal / driver drives to completion.
   */
  orderSparePart?: Maybe<OrderSparePart>;
  orderSubscriptionQuote?: Maybe<OrderSubscriptionQuote>;
  /**
   * Office-only, audited (D7): replace a period's computed bonus
   * coefficient with an explicit value, with a mandatory reason. OPEN
   * periods only; the override participates in the live compute and
   * freezes into the snapshot when the period closes. Pass ``clear: true``
   * (and no coefficient) to remove an override.
   */
  overrideSettlementCoefficient?: Maybe<OverrideSettlementCoefficient>;
  /**
   * Pair, re-pair, or clear the physical labels of a container.
   *
   * Labels are not identity (decided): container_id never changes
   * here. Passing an empty string clears a label (an emptied form
   * field); omitting an argument leaves that label untouched. A label
   * already on another container is rejected - clear it there first -
   * so a label can never silently move between containers.
   */
  pairContainerLabels?: Maybe<PairContainerLabels>;
  partialUpdateCompanySettings?: Maybe<PartialUpdateCompanySettingsPayload>;
  passwordChange?: Maybe<PasswordChange>;
  passwordReset?: Maybe<PasswordReset>;
  pauseAutomationEngine: PauseAutomationEnginePayload;
  /**
   * Pause / resume a scheduled report WITHOUT losing its cadence — so a
   * user can stop deliveries for a while instead of deleting and rebuilding.
   *
   * Honest by construction: the beat sweep (``tasks.run_due_reports``) selects
   * ``interval_days__isnull=False, next_run_at__lte=now``. Pausing clears
   * ``next_run_at`` (keeping ``interval_days`` as the remembered cadence) so a
   * paused report can never match the sweep — the control actually stops
   * delivery, it isn't cosmetic. Resume recomputes ``next_run_at`` from the
   * remembered cadence, exactly as SaveReportTemplate does. A report with no
   * cadence (``interval_days is None``) isn't scheduled, so there is nothing
   * to pause/resume — NOT_SCHEDULED.
   */
  pauseReportTemplate: ReportTemplateResult;
  pickupOrderApprovalCollectionAddApprovals?: Maybe<PickUpOrderApprovalCollectionAddApprovals>;
  pickupOrderApprovalCollectionDeleteApprovals?: Maybe<PickUpOrderApprovalCollectionDeleteApprovals>;
  pickupOrderApprovalCollectionUpdateApprovals?: Maybe<PickUpOrderApprovalCollectionUpdateApprovals>;
  /**
   * Pin a price list to an Account (G2S1-M2, HAUL-203): the Account's
   * order lines price through this list first (its inheritance chain,
   * child before parent), falling back honestly. Replaces any previous
   * pin, keeping the trail (soft delete).
   */
  pinAccountPriceList?: Maybe<PinAccountPriceList>;
  /**
   * Diff preview for converting one legacy `Rule` into a draft Flow:
   * pure computation, zero database writes (the legacy rule and every
   * other row are left exactly as they were). Recomputed from the rule's
   * live actions on every call, so the preview always matches what
   * `ConfirmConvertLegacyRuleToFlow` would create if confirmed right now.
   *
   * `definition` is the would-be Flow definition (already run through the
   * same structural + registry-aware validator the builder itself uses,
   * per `autopilot.builder.validator.validate_for_builder`, so a preview
   * is never a promise `confirm` can't keep). `warnings` calls out real
   * seam gaps (e.g. a status-transition trigger that cannot be scoped to
   * one ticket type with the current event contract). `unsupportedActions`
   * lists every legacy action this rule has that could not be converted;
   * `ok=False` with no `definition` means nothing convertible was left.
   */
  previewConvertLegacyRuleToFlow?: Maybe<PreviewConvertLegacyRuleToFlow>;
  /**
   * Run ``sql`` for ``companyId`` as a saved dataset of that company
   * would run, without saving anything: the first ``limit`` rows (at most
   * 50). ``sampleValues`` (``{tag: value}``) and ``sampleWindow`` (a board
   * date window, ``{start, end}``) give the declared tags values exactly as
   * a dashboard's filters do when a tile runs (``sample_values``).
   * ``error``: what ``run`` returns (``SQL_REFUSED:<reason>``,
   * ``INVALID_DATASET:parameters``, ``QUERY_TIMEOUT``,
   * ``EXECUTION_FAILED:<error class>``) or ``COMPANY_NOT_FOUND``;
   * ``errorDetail`` names the tag or word of a refusal.
   */
  previewSqlDataset?: Maybe<PreviewSqlDataset>;
  /**
   * Advance a Flow's lifecycle state (draft -> test, test -> shadow, or
   * test -> draft for another edit pass). `target_state` is
   * `AutopilotFlowPromotableState`, so `live` is not a value this argument
   * can ever hold (see that enum's docstring for the two dedicated
   * routes to `live`, `ActivateAutopilotFlow` and
   * `ActivateAutopilotFlowFromShadow`).
   *
   * Promoting into `test` or `shadow` (AP-402, AP-704) carries two guards
   * beyond the bare state machine in `Flow.promote_to`:
   *
   * - Refuses when `flow.has_unsaved_changes()`: an autosaved draft that was
   *   never committed as a `FlowVersion` must not silently become "the"
   *   version that goes to test or shadow. Commit it
   *   (`UpdateAutopilotFlowDefinition`) first.
   * - Re-runs the registry-aware validator (`validate_for_builder`) against
   *   `current_version.definition` before activating it: the definition was
   *   valid when the version was created, but `autopilot_registry_sync` can
   *   deactivate an action afterwards (registry drift), and promotion is the
   *   last save-time gate before a flow starts actually being exercised in
   *   `test` or watching real live events in `shadow`.
   *
   * Demoting back to `draft` resyncs `draft_definition` to
   * `current_version.definition`: "another edit pass" (the model's own
   * docstring) starts clean from the last committed version rather than
   * from whatever was mid-edit the last time this flow was in `draft`.
   */
  promoteAutopilotFlow?: Maybe<PromoteAutopilotFlow>;
  /**
   * A1: vouch for a question -> governed-query mapping so future
   * matching questions are served from the verified library (no LLM).
   * Governance action — back-office only; upserts on (company,
   * normalised question).
   */
  promoteInsightsVerifiedQuery: PromoteInsightsVerifiedQuery;
  /**
   * Run a column-mapping proposer over the batch (RS-101, D23).
   *
   * ``use_copilot`` defaults to true; the Copilot seam degrades
   * gracefully to the deterministic heuristic when the SDK or key is
   * unavailable (Q-008), and the degradation is recorded on the batch.
   */
  proposeImportMapping?: Maybe<ProposeImportMappingMutation>;
  /**
   * Ask for a route-day / emptying-interval change on a route's
   * series. NOTHING is applied until the office approves.
   */
  proposeRouteChange?: Maybe<ProposeRouteChange>;
  publicSaveTransferDocumentData?: Maybe<PublicSaveTransferDocumentData>;
  publicSignTransferDocument?: Maybe<PublicSignTransferDocument>;
  publicTransferDocumentPdfUrl?: Maybe<PublicTransferDocumentPdfUrl>;
  publicUpdateUnconfirmedUser?: Maybe<PublicUpdateUnconfirmedUser>;
  /**
   * W6.2: freeze one governed result for the public transparency
   * page. Runs the spec ONCE through the engine at publish time; the
   * public path serves only this frozen payload. Refresh=re-publish.
   */
  publishInsight: PublishInsightResult;
  /**
   * SOTA A5 — human-in-the-loop feedback on an analyst answer. Captures
   * a thumb up/down (+ optional note) so answer quality can be measured
   * and curated. Capture-only; scoped to the tenant + user.
   */
  rateInsightsAnalystAnswer: RateInsightsAnalystAnswer;
  /**
   * Reactivate a terminated Shared Collection Point (QA-99 / D11).
   *
   * Founder ruling D11: reactivation of a terminated shared service IS
   * possible — the period end clears and the profile returns to ACTIVE.
   * Memberships and fee agreements are NOT auto-restored (history stays
   * ended; the operator re-adds members). Guards mirror terminateScp:
   * feature flag, company scoping, plus the pure-driver wall.
   */
  reactivateScp?: Maybe<ReactivateScp>;
  /** Book goods-in for (part of) a purchase order. */
  receivePurchaseOrder?: Maybe<ReceivePurchaseOrder>;
  /** Receive N spare parts into a warehouse (+N counted stock, A1). */
  receiveSpareParts?: Maybe<ReceiveSpareParts>;
  /**
   * Quantity-based receive: creates an auto-completing receive
   * ticket whose completion writes +N on the count (ADR-0005). PRO-391
   * (3.5.69) lifts the "no identities" rule at intake: ``identities``
   * optionally carries per-unit identity for SOME of the received units,
   * which become serialized Container rows immediately; the remaining
   * quantity stays anonymous count, exactly as before. The ticket exists
   * for the audit trail, not as a workflow step (decided).
   */
  receiveStock?: Maybe<ReceiveStock>;
  /**
   * Wave 2 Lane E S5, the wizard's "check against your history" step:
   * run the whole-estate preview (`autopilotEstatePreview`'s exact
   * computation) AND persist one `SimulationRun` per candidate from the
   * very replays the preview ran -- one replay per flow, total (see
   * `autopilot.services.estate_migration.record_estate_simulations`).
   * A mutation, not a query, precisely because it writes the evidence
   * rows `ActivateConvertedFlows`' simulation gate checks; the read-only
   * `autopilotEstatePreview` query re-renders the same picture without
   * writing. Same caps as the query (candidates and window), same
   * `notCompared` honesty for ids that cannot be replayed (they get no
   * evidence row, so activating them later refuses instead of passing on
   * fake proof).
   */
  recordAutopilotEstateSimulations?: Maybe<RecordAutopilotEstateSimulations>;
  /**
   * Run a real AP-701 replay for a flow's CURRENT version and persist it
   * as a `SimulationRun` -- the product path to the evidence both the AP-703
   * activation gate (`gate_kind='simulation'`) and the Opportunity-Cost
   * Ledger (frontier #49) check. Closes the story-fidelity gap noted on
   * `ActivateAutopilotFlow`: until this mutation, `record_simulation_run`
   * was reachable only from Python, so no GraphQL caller could ever satisfy
   * the simulation gate (or price a parked flow) end-to-end.
   *
   * The replay itself is SIMULATE-mode-only by construction (see
   * `autopilot.runtime.replay`): no `FlowRun`/`StepRun` is ever created;
   * the one write is the `SimulationRun` row, attributed to the caller via
   * `ran_by`. `projectedHours` in the payload is priced by the gate's own
   * helper, so what this returns is exactly what the flow would promise at
   * go-live -- and exactly what the Opportunity-Cost row will now show.
   * Bounded window (1..365 days): a replay is corpus work, and an unbounded
   * caller-supplied window is a self-inflicted AP-702 perf incident.
   */
  recordAutopilotSimulation?: Maybe<RecordAutopilotSimulation>;
  /**
   * Record the outcome of an inspection of the composter.
   *
   * One inspection per row: the columns are singular, so recording a second
   * overwrites the first. That matches the register's own shape — a renewal
   * starts a NEW row, and its inspection history begins empty.
   */
  recordCompostingInspection?: Maybe<RecordCompostingInspection>;
  /**
   * Record one maintenance event on a container (PRO-213).
   *
   * Writes are gated exactly like a container edit
   * (``CompanyRolePermission.check_edit``): a user outside the container's
   * company is denied. ``next_due`` is optional — the value passed becomes
   * the container's current next-maintenance date (it is the latest event's
   * ``next_due``); recording a later event with ``next_due`` omitted clears
   * it.
   */
  recordContainerMaintenance?: Maybe<RecordContainerMaintenance>;
  /**
   * Record the customer picking the key up (AC2): completes the order
   * ticket, issuing the key.
   */
  recordKeyPickup?: Maybe<RecordKeyPickup>;
  /**
   * Enter / update the manually entered purchase-invoice reference + total
   * for a (contractor, period) — PRO-468. Append-only: when the current row is
   * MATCHED (locked), a NEW correction row is created. Office-only + the
   * reconcile right (a read-only reporting role is refused).
   */
  recordPurchaseInvoice?: Maybe<RecordPurchaseInvoice>;
  /**
   * Record a kimppailmoitus filing with the waste authority (NEXUS-681).
   *
   * Captures the SCP's current statutory snapshot at filing time so a later
   * "changes since last filing" check (``muutoksia ilmoitettavaksi``) can flag
   * drift. ``kind`` is the filing kind (NEW / CHANGE / TERMINATION);
   * ``authorityReference`` is optional — the diaarinumero often arrives after
   * the notification is filed.
   */
  recordScpNotificationFiling?: Maybe<RecordScpNotificationFiling>;
  /**
   * PRODUCT-523: record a collected skip's weight - the module
   * docstring's contract. ``rental`` / ``netKg`` / ``basis`` /
   * ``overageEvent`` describe the (first) skip; ``shares`` every skip of a
   * mixed load.
   */
  recordSkipWeight?: Maybe<RecordSkipWeight>;
  /**
   * Office-only: manual re-date for exactly one row, overriding the
   * policy outcome for that row only (audit-logged via
   * ``HolidayShiftDecision``). Validations (target not a holiday,
   * within the allowed window, no eligible target route) are enforced
   * server-side and come back as an honest ``errors`` entry rather than
   * a raised exception — this is a business refusal, not a client bug.
   */
  redateHolidayImpactRow?: Maybe<RedateHolidayImpactRow>;
  /**
   * Recompute the caller's company due list now.
   *
   * The due list is a persisted cache rebuilt by a nightly beat, which is the
   * right design at PJH volumes but leaves the screen stale whenever something
   * moves a schedule outside the write paths that keep it in step (a data
   * import, a backdated agreement, a migration). This is the operator's way to
   * say "make it right now" without a Django shell.
   *
   * It is deliberately CHEAP TO REFUSE: the service throttles on the
   * ``last_computed`` watermark and takes a NOWAIT row lock, so a held-down
   * button costs one SELECT, never a queue of company-wide recomputes.
   * ``status`` says which of the three things happened.
   */
  refreshBillingDueList?: Maybe<RefreshBillingDueListMutation>;
  refreshToken?: Maybe<Refresh>;
  refuseToken?: Maybe<RefuseToken>;
  registerFcmDevice?: Maybe<RegisterFcmDevicePayload>;
  /**
   * Count-based completion (FIXIT2-O2, NID REQ-091): record that N
   * of the line's M units are done. 20 of 35 recorded leaves 15 open —
   * the rollup reads IN_PROGRESS and the order refuses to close until
   * the count reaches the ordered quantity. A single-unit line takes
   * "1 of 1" — the office's "work done" action for a line that never
   * materialized a ticket (G2S2-O1, RD-33). Same gate as every
   * hauler-mode surface.
   */
  registerHaulerLineCompletedCount?: Maybe<RegisterHaulerLineCompletedCount>;
  /**
   * Record the scale weight for one weight-sold line (S4-O2,
   * HAUL-419 capture path). Makes the PENDING reason "no weight was
   * recorded" actionable: register the slip's weight, then retry
   * ``markHaulerOrderCompleted`` — the existing paper gate reads it.
   */
  registerHaulerLineWeight?: Maybe<RegisterHaulerLineWeight>;
  /**
   * Register a payment received OUTSIDE the platform (bank transfer,
   * MobilePay, cash) against a SENT invoice — the S1-M5 service on the
   * wire. Partial payments accumulate; over-payment is a loud error; the
   * invoice flips PAID exactly when covered.
   */
  registerInvoicePayment?: Maybe<RegisterInvoicePayment>;
  /**
   * Office-only (PRO-118): reverse an exclusion; attaches the agreement
   * right away unless ``attach: false``. Change-logged.
   */
  reincludeAreaAgreement?: Maybe<ReincludeAreaAgreement>;
  /**
   * Reject a customer request with a reason the requester reads in the
   * portal thread (PRODUCT-484).
   */
  rejectCustomerRequest?: Maybe<RejectCustomerRequest>;
  rejectTicketBatch: RejectTicketBatch;
  /**
   * Release on save/cancel/exit. Expired or already-taken-over leases
   * release as a no-op (``expired`` / ``lost``), never an error.
   */
  releaseRecordLease?: Maybe<ReleaseRecordLease>;
  removeAssociatedTicketsFromCompanyEmailAccountMessage?: Maybe<RemoveAssociatedTicketsFromCompanyEmailAccountMessage>;
  /**
   * Office-only (B1.3): soft-delete one CUSTOM day. National rows
   * are never reachable here — there is no id-space for them on this
   * mutation, so "national not deletable" needs no separate check.
   */
  removeCompanyHolidayDay?: Maybe<RemoveCompanyHolidayDay>;
  removeCustomerFunctionFromContact?: Maybe<RemoveCustomerFunctionFromContact>;
  /**
   * Office-only, audited: re-include an event (soft-deletes the active
   * exclusion, keeping the audit trail). ``removed`` is False when there was
   * no active exclusion.
   */
  removeReliabilityExclusion?: Maybe<RemoveReliabilityExclusion>;
  /** Unlink a route scheme from its warehouse. Idempotent. */
  removeRouteSchemeWarehouseLink?: Maybe<RemoveRouteSchemeWarehouseLink>;
  /**
   * Office-only, audited (R2-S12): soft-remove a manual adjustment line
   * while its period is still OPEN. The row survives (deleted/deleted_by)
   * for the audit trail; a closed period's adjustments are locked.
   */
  removeSettlementAdjustment?: Maybe<RemoveSettlementAdjustment>;
  /** Office-only, audited: reopen a closed period for live recompute (D9). */
  reopenSettlementPeriod?: Maybe<ReopenSettlementPeriod>;
  reopenTransferDocument?: Maybe<ReopenTransferDocument>;
  /**
   * Replace a lost key (AC4): orders a fresh key of the same type for the
   * same customer via a KEY_REPLACE ticket. Returns the new key.
   */
  replaceKey?: Maybe<ReplaceKey>;
  /**
   * A company operator replies to a general citizen<->company conversation.
   *
   * The company-scoped mirror of ``ReplyToHaulerPortalConversation``. Server-
   * enforced isolation: the conversation is fetched through the SAME company +
   * general-thread (``hauler IS NULL`` AND ``ticket IS NULL``) filter as the read
   * side, so an operator replying to another company's conversation — or to a
   * hauler/ticket-bridged thread — gets the clean "not found" denial, never a
   * write onto a foreign thread. The reply is an outbound-to-citizen CEAM
   * attributed as the company (``author='company'``) and pings the citizen via
   * ``dispatch_portal_new_message``. Gated on ``crm_enable_messaging``.
   */
  replyToCompanyPortalConversation?: Maybe<ReplyToCompanyPortalConversation>;
  /**
   * PRO-1012: write to the requester WITHOUT deciding the request - a
   * question, a heads-up. The message lands on the thread the portal shows
   * and is e-mailed to the requester; the request stays open.
   */
  replyToCustomerRequest?: Maybe<ReplyToCustomerRequest>;
  /**
   * A hauler user replies to a citizen->hauler portal conversation (D3/D4).
   *
   * Server-enforced isolation: the conversation is fetched through the SAME
   * company + ``apply_hauler_scope`` filter as the read side, so a contractor
   * replying to another hauler's conversation gets the clean "not found" denial
   * — never a write onto a foreign thread (mirrors the read node's 404 guard).
   * The reply is an outbound-to-citizen CEAM attributed as the hauler (D4) and
   * reuses the citizen ping (D5). Gated on D6.
   */
  replyToHaulerPortalConversation?: Maybe<ReplyToHaulerPortalConversation>;
  /** Mark a key lost (AC4). */
  reportKeyLost?: Maybe<ReportKeyLost>;
  /** Execute one 'report relocation' wizard run (req 3.1.38). */
  reportRelocation?: Maybe<ReportRelocation>;
  /**
   * Request one budgeted relaxation probe for a plan (RS-603).
   *
   * Bounded to 5 probes per plan (05_ENGINE_SPEC section 7); the
   * re-solve runs async on the optimization-engine queue and the
   * probe walks queued -> running -> done/failed. Idempotent per
   * (plan, relaxation).
   */
  requestRelaxationProbe?: Maybe<RequestRelaxationProbeMutation>;
  resendInvitation?: Maybe<ResendInvitation>;
  /**
   * Re-send the code for a live challenge. Neutral response — cooldown and
   * max-resends are enforced silently inside the engine; the status never
   * reveals whether a new code was actually issued.
   */
  resendMfaCode?: Maybe<ResendMfaCode>;
  resetCompanyColorSettings?: Maybe<ResetCompanyColorSettings>;
  resetFeatureConfigDrift?: Maybe<ResetFeatureConfigDrift>;
  resetStopListCardConfig?: Maybe<ResetStopListCardConfig>;
  /**
   * Office resolution of an UNMATCHED read: attach the right container and
   * apply it, or reject it with a reason. APPLIED/ALREADY_COMPLETED events are
   * history and are refused — that is the one path that could double-complete
   * a stop.
   */
  resolveExternalCollectionEvent?: Maybe<ExternalConfirmationResultType>;
  /**
   * Fix-queue resolution (RS-102): accept the suggestion, place
   * manual coordinates (audited), defer a red explicitly, or dismiss
   * a non-geocode issue.
   */
  resolveImportIssue?: Maybe<ResolveImportIssueMutation>;
  /**
   * A deleted New dashboard of a client back as it was (its tiles and who
   * sees it).
   */
  restoreBuilderDashboardAsStaff?: Maybe<RestoreBuilderDashboardAsStaff>;
  /**
   * Bring a deleted builder dashboard back ("Deleted dashboards"), as it
   * was when deleted: tiles, filters and who sees it. Needs what deleting
   * needs: the owner or ``analytics_dashboard__delete``. A dashboard the
   * caller would not see by its audience is NOT_FOUND, as when it was
   * there.
   */
  restoreInsightsBuilderDashboard: BuilderDashboardResult;
  /**
   * Put an earlier state of a builder dashboard back (its History): the
   * name and spec of one of its versions, checked again as any save is, so
   * a tile on a SQL dataset the editor may no longer read is dropped and
   * named in ``droppedWidgets``. Who sees the dashboard stays as it is. The
   * state it replaces stays in the History, so a restore is undone the same
   * way. Needs the owner or ``analytics_dashboard__edit``;
   * ``expectedUpdatedAt`` turns a restore over someone else's newer save
   * into STALE, as for an update.
   */
  restoreInsightsBuilderDashboardVersion: BuilderDashboardResult;
  /**
   * Office: re-run the register hand-off for a SIGNED document (after a
   * rejection was corrected via reopen + re-sign, or a transient failure).
   */
  resubmitTransferDocument?: Maybe<ResubmitTransferDocument>;
  resumeAutomationEngine: ResumeAutomationEnginePayload;
  /** Retire a rule; history and provenance stay (auditable brain). */
  retireBrainRule?: Maybe<RetireBrainRuleMutation>;
  /**
   * A1: withdraw a vouched query so it stops short-circuiting the
   * analyst — the un-vouch counterpart to promote, so the verified
   * library is governable (a stale/wrong entry can be removed). The
   * audit trail keeps the record of both the promote and the retire.
   * Back-office only; company-scoped.
   */
  retireInsightsVerifiedQuery: RetireInsightsVerifiedQuery;
  retractInsight: RetractInsight;
  /**
   * Record a key being returned (AC4): creates + completes a KEY_RETURN
   * ticket, marking the key returned.
   */
  returnKey?: Maybe<ReturnKey>;
  /**
   * Bring one rented unit home (PRO-271): the +1 RETURN serialization
   * row via the confirm-arrival landing engine
   * (``inventory.services.rental.return_rental``), so the unit rejoins the
   * count and stays individually visible in storage. Defaults the
   * destination to the ticket's return warehouse; ``warehouseId`` overrides
   * it. A SALE has no return leg and is refused cleanly.
   */
  returnRental?: Maybe<ReturnRental>;
  reverseSearchLocation?: Maybe<SearchLocationReverse>;
  /**
   * Manually revert a temporary location override back to the original location.
   *
   * Restores the container to its original location immediately.
   */
  revertTemporaryContainerLocation?: Maybe<RevertTemporaryContainerLocation>;
  revokeTransferDocumentSignLink?: Maybe<RevokeTransferDocumentSignLink>;
  /**
   * RS-1502 universal rollback: one action reverts one applied
   * autopilot adjustment; the dispatch overlay returns exactly to the
   * prior state (D35).
   *
   * SBX-537 P1-1 (wave D23): master-gated. Reverting a live dispatch
   * overlay is a live-operations act (RS-2009).
   */
  rollbackAutopilotAction?: Maybe<RollbackAutopilotActionMutation>;
  /**
   * Reactivate an older, already-validated `FlowVersion` of a `live` flow
   * by switching `current_version` (AP-402), exposing
   * `autopilot.runtime.activation_gate.rollback_flow`.
   *
   * Pack `03` §2: "Rollback = re-activate prior version." No new
   * `FlowVersion` is created and `state` does not change; only the pointer
   * the executor reads moves.
   *
   * Re-runs the same registry-aware validator (`validate_for_builder`)
   * `PromoteAutopilotFlow` enforces, against the *target* version's
   * definition, before switching the pointer: the version was valid when it
   * was committed, but `autopilot_registry_sync` can deactivate an action
   * any time afterwards, and rollback re-points a LIVE flow's executor --
   * the same "last save-time gate before it runs for real" story as
   * promotion, just entered from an older version instead of the newest one.
   * Without this, a save-time refusal (`validate_for_builder` would reject
   * this exact definition) turns into a live-flow run failure instead.
   *
   * Review fix (AP-703): also runs the same activation gate a fresh
   * test -> live promotion requires, via `rollback_flow`, whenever the
   * target version was never itself the subject of a gated activation (see
   * that function's own docstring) -- `gate_kind`/`gate_reason` are
   * optional here (unlike `ActivateAutopilotFlow`) because they are only
   * needed for that case; rolling back to the one version this flow's
   * `ImpactRecord` already proves was gated needs neither and keeps
   * working exactly as before, no new required argument for the common
   * case.
   */
  rollbackAutopilotFlow?: Maybe<RollbackAutopilotFlow>;
  /**
   * PRO-773: undo what a deviation did, without deleting it.
   *
   * A SEPARATE mutation rather than a ``rollback`` argument on the delete:
   * SDL ``extend`` cannot add an argument to an existing field, so an argument
   * could not be stubbed for the frontend's codegen ahead of the backend
   * deploy — the same constraint that kept the route-creation warning a query.
   * A new Mutation FIELD stubs cleanly, and an explicit rollback is the better
   * surface anyway: an operator may want to put the routes back WITHOUT
   * throwing the deviation away.
   *
   * Idempotent: a change already rolled back is not rolled back twice.
   */
  rollbackCollectionCalendarDeviation?: Maybe<RollbackCollectionCalendarDeviation>;
  /**
   * One action: restore the pre-promotion snapshot exactly and
   * queue the follow-up messaging (RS-703).
   */
  rollbackPromotion?: Maybe<RollbackPromotionMutation>;
  /**
   * Add vehicles to ``Route.vehicles_from_route_scheme`` for mid-day
   * collaboration. Each vehicle must belong to the route's hauler. Office-
   * user only.
   */
  routeAddCollaborationVehicles?: Maybe<RouteAddCollaborationVehicles>;
  /**
   * Wizard reroute (RS-E20): send one candidate table into the
   * legacy stop-list import pipeline (mapping, geocoding, fix queue,
   * quality report). The case wraps the existing wizard, it does not
   * duplicate it.
   */
  routeCandidateTableToImport?: Maybe<RouteCandidateTableToImportMutation>;
  /** This mutation is obsolete and has been deprecated. Use `RouteChangePrimaryVehicleGeneric` instead. */
  routeChangePrimaryVehicle?: Maybe<RouteChangePrimaryVehicle>;
  /** This mutation is obsolete and has been deprecated. Use `RouteChangePrimaryVehicleGeneric` instead. */
  routeChangePrimaryVehicleFromMobile?: Maybe<RouteChangePrimaryVehicleMobile>;
  /** Change primary vehicle for route for mobile app */
  routeChangePrimaryVehicleGeneric?: Maybe<RouteChangePrimaryVehicleGeneric>;
  routeComplete?: Maybe<RouteComplete>;
  routeDelete?: Maybe<RouteDelete>;
  routeExport?: Maybe<RouteExportMutation>;
  /** This mutation is obsolete and has been deprecated. Use `RouteStartGeneric` instead. */
  routeJoinDifferentVehicle?: Maybe<RouteJoinDifferentVehicle>;
  /** This mutation is obsolete and has been deprecated. Use `RouteStartGeneric` instead. */
  routeJoinSameVehicle?: Maybe<RouteJoinSameVehicle>;
  routeOptimize?: Maybe<RouteOptimize>;
  /**
   * Reassign the primary driver on a route within the same hauler.
   *
   * Wraps ``routes.services.route_reassignment.reassign_route_driver`` so the
   * same validation (office-user, no-completed-stops, hauler membership) is
   * enforced for both REST and GraphQL callers, and so every change appends
   * a ``RouteVehicleDriverReassignmentLog`` entry.
   */
  routeReassignDriver?: Maybe<RouteReassignDriver>;
  /**
   * Reassign ``Route.hauler`` cross-hauler (COMPASS-334).
   *
   * Wraps ``routes.services.route_hauler_reassignment.reassign_route_hauler``
   * so the same validation (office-user, hauler within same company,
   * idempotent same-hauler) is enforced for REST + GraphQL callers, and so
   * every change appends a ``RouteHaulerReassignmentLog``.
   */
  routeReassignHauler?: Maybe<RouteReassignHauler>;
  routeReset?: Maybe<RouteReset>;
  routeSchemeDelete?: Maybe<RouteSchemeDelete>;
  routeSchemeOptimize?: Maybe<RouteSchemeOptimize>;
  routeSchemeOptimizeNew?: Maybe<RouteSchemeOptimizeNew>;
  routeSchemePreview?: Maybe<RouteSchemePreview>;
  /**
   * Office-only replace-all write of a scheme's eligible unloading
   * stations (order = list order). Affects FUTURE route generation;
   * already-generated routes keep their own sets.
   */
  routeSchemeSetUnloadingStations?: Maybe<RouteSchemeSetUnloadingStations>;
  /**
   * Office-only replace-all write of one route's eligible unloading
   * stations (order = list order). An empty list clears the config —
   * the route reverts to its scheme's set, else legacy behaviour.
   */
  routeSetUnloadingStations?: Maybe<RouteSetUnloadingStations>;
  /** This mutation is obsolete and has been deprecated. Use `RouteStartGeneric` instead. */
  routeStart?: Maybe<RouteStart>;
  /** This mutation is obsolete and has been deprecated. Use `RouteStartGeneric` instead. */
  routeStartFromMobile?: Maybe<RouteStartMobileApp>;
  routeStartGeneric?: Maybe<RouteStartGeneric>;
  routeStopComplete?: Maybe<RouteStopComplete>;
  routeStopSetNext?: Maybe<RouteStopSetNext>;
  routeStopSetNextDepot?: Maybe<RouteStopSetNextDepot>;
  routeStopsAdd?: Maybe<RouteStopsAdd>;
  routeStopsComplete?: Maybe<RouteStopsComplete>;
  routeStopsMove?: Maybe<RouteStopsMove>;
  routeStopsOrder?: Maybe<RouteStopsOrder>;
  routeStopsUpdate?: Maybe<RouteStopsUpdate>;
  /**
   * The driver-app stop transfer, in both assistance directions.
   *
   * Reuses the office stop-move body (``_move_stops_between_routes``) but
   * authorizes a driver the way every other driver-app route mutation is
   * authorized — by what they are actually working, not by an office
   * permission string.
   *
   * COMPASS-1592: this used to call ``RouteStopsMove().mutate()``, which
   * enforces ``route__edit``. That is an OFFICE permission;
   * ``CONTRACTOR_DRIVER_PERMISSIONS`` is empty by design and a pure driver
   * account has no role at all, so ``check_permission`` denied EVERY driver
   * here — the scheme flag was checked, passed, and then the role check
   * killed the move one frame later. Both Request Assistance and Assist
   * Driver failed for real drivers no matter what the route scheme said.
   * Same shape as COMPASS-1046 on ``routeStopsOrder`` (see the comment in
   * ``RouteStopsOrder.mutate``).
   *
   * Non-driver callers keep the legacy path verbatim — the target scheme's
   * ``allow_driver_to_take_stops`` plus ``route__edit`` — so nothing that
   * could reach this mutation before loses access.
   */
  routeTakeStops?: Maybe<RouteTakeStops>;
  routeUnComplete?: Maybe<RouteUnComplete>;
  /**
   * Turn automatic confirmation on/off for a route (COMPASS-880 / REQ 31).
   *
   * The driver-facing half of REQ 31's automatic confirmation: the server-side
   * gate is ``route.auto_complete and <the breadcrumb's auto_complete flag>``
   * (``fleet_management/schema.py``), and this mutation is the ONLY way to set
   * the first operand. Without it a driver can switch "Auto-complete" on in
   * the app, watch it light up, and have nothing happen — forever, silently —
   * on any route whose scheme left ``default_auto_complete`` False.
   *
   * Deliberately driver-callable: ``@login_required`` plus the caller's
   * company scope, and NOT ``assert_office_user`` — the setting belongs to the
   * person in the truck. It is registered as ``SET_AUTO_COMPLETE`` in
   * ``routes/schema/offline_sync.py`` so the toggle survives a dead spot.
   */
  routeUpdateAutoComplete?: Maybe<RouteUpdateAutoComplete>;
  routeUpdateAutoCompleteNextStop?: Maybe<RouteUpdateAutoCompleteNextStop>;
  routeUpdateAutoOptimize?: Maybe<RouteUpdateAutoOptimize>;
  routeUpdateContainerGroupLocation?: Maybe<RouteUpdateContainerGroupLocation>;
  routeUpdateContainerLocation?: Maybe<RouteUpdateContainerLocation>;
  /**
   * COMPASS-272: flag a route as emergency / exception.
   *
   * Intended for dispatcher / back-office users; drivers cannot promote
   * their own routes (enforced via ``CompanyRolePermission.check_edit``).
   */
  routeUpdateEmergency?: Maybe<RouteUpdateEmergency>;
  routeUpdateLocked?: Maybe<RouteUpdateLocked>;
  routeUpdateLockedStart?: Maybe<RouteUpdateLockedStart>;
  /** This mutation is obsolete and has been deprecated. Use `RouteUpdateRouteVehicleGeneric` instead. */
  routeUpdateRouteVehicle?: Maybe<RouteUpdateRouteVehicle>;
  routeUpdateRouteVehicleDriver?: Maybe<RouteUpdateRouteVehicleDriver>;
  routeUpdateRouteVehicleGeneric?: Maybe<RouteUpdateRouteVehicleGeneric>;
  /** This mutation is obsolete and has been deprecated. Use `RouteUpdateRouteVehicleGeneric` instead. */
  routeUpdateRouteVehicleMobile?: Maybe<RouteUpdateRouteVehicleMobileApp>;
  routeUpdateRouteVehicleTrailer?: Maybe<RouteUpdateRouteVehicleTrailer>;
  /** Complete route vehicle sessions in bulk */
  routeVehicleSessionsComplete?: Maybe<RouteVehicleSessionsComplete>;
  /** Complete all active route vehicle sessions in bulk for a driver */
  routeVehicleSessionsCompleteForDriver?: Maybe<RouteVehicleSessionsCompleteForDriver>;
  routesStopsComplete?: Maybe<RoutesStopsComplete>;
  routesStopsMove?: Maybe<RoutesStopsMove>;
  routesStopsUpdate?: Maybe<RoutesStopsUpdate>;
  /**
   * Office-only (PRO-118): attach every pending (matching, not
   * excluded) agreement now. Each attachment is change-logged
   * "Attached automatically — matched scope".
   */
  runAreaAutoAttach?: Maybe<RunAreaAutoAttach>;
  /**
   * Process the due list for a cycle/selection into invoices.
   *
   * Reuses the existing invoicing pipeline for invoice creation (law-class
   * split, delivery routing, VAT, pricing at execution time). Records the
   * per-agreement-period billed-state guard, advances the schedules, and clears
   * the processed due rows. Provide a ``frequency_code`` (process that cadence's
   * due rows) and/or explicit ``schedule_ids``.
   *
   * The payload answers "what did my click actually do?" — the question the
   * original four counters could not (D1/D3): a run that invoiced nothing
   * looked exactly like a run that invoiced everything. ``outcome`` is the
   * run-level verdict and ``entries`` carries the per-schedule reason, both
   * straight off ``BillingScheduleRunResult``. Outcome codes ship as plain
   * strings, matching every other vocabulary on this schema
   * (``BillingDueListRowType.contact_type``,
   * ``FrequencyChangeDetailType.source``, this module's ``anchor``/``source``
   * inputs) — and additively, so a new code never breaks a client's build.
   */
  runBillingBySchedule?: Maybe<RunBillingByScheduleMutation>;
  /**
   * Export the caller's company's validated billable events for
   * ``[from, to]`` to a feeder file in the configured finance system's
   * format and return the export log.
   */
  runFinanceFeederExport?: Maybe<RunFinanceFeederExportMutation>;
  /** Force one delivery (also the UI's 'send test report'). */
  runReportNow: RunReportNow;
  /**
   * Queue a simulation job for a scenario (RS-201 simulation_job).
   *
   * Sync API, async work (RS-405, ADR-0003 §2): the mutation persists
   * the queued job, flips the scenario to ``computing`` and returns
   * immediately; the solve itself is dispatched on commit to the
   * ``optimization-engine`` Celery queue
   * (``route_studio.solver.tasks.run_simulation_job``).
   */
  runScenario?: Maybe<RunScenarioMutation>;
  /**
   * Run every setup step for a company (the management command's
   * default) and return one report per step.
   */
  runSkipHireSetup?: Maybe<RunSkipHireSetup>;
  /**
   * Run ONE setup step for a company and return its report.
   *
   * ``input`` is the step's tenant-specific input as a JSON object (the
   * same keys a demo profile carries, e.g. ``{"skips": [...]}``); ``demo``
   * picks a built-in profile. Steps the step depends on must be done -
   * they are checked against the company (and the demo profile, if any),
   * never against ``input``, which only the step itself reads
   * (PRODUCT-555).
   */
  runSkipHireSetupStep?: Maybe<RunSkipHireSetupStep>;
  /**
   * Re-run RS-E27 stage G verification for a case (default: the
   * newest materialization version). Verification also auto-runs on
   * every materialization; this mutation refreshes the verdicts after
   * new uploads (membership tables, actuals logs) without
   * re-materializing. Refusals explain at category level (D62).
   */
  runVerification?: Maybe<RunVerificationMutation>;
  /**
   * SBX-520 (wave D15): "use my WasteHero data" as a first-class
   * gap action. Materializes what the platform already knows (the
   * project fleet, the company depots, the live containers) into
   * the case exactly like an upload: a deterministic CSV through
   * the same door (duplicate wall, supersession, explosion), then
   * the tables confirmed as the class the pull knows they are.
   * Refuses honestly where the platform holds nothing, with the D6
   * code and a plain naming what is lacking; a re-pull with
   * unchanged platform data hits the byte-identical duplicate wall
   * (nothing is doubled).
   */
  satisfyNeedFromPlatform?: Maybe<SatisfyNeedFromPlatformMutation>;
  saveAutomationAsTemplate: SaveAsTemplatePayload;
  /**
   * NEXUS-791: rewrite the manual display order of one (company, entity)
   * group of custom-field definitions.
   *
   * Full-list contract: the submitted ID set must be *exactly* the caller's
   * complete set for that entity. This catches the real race — admin A opens
   * the tab, admin B creates a field, admin A drags and saves — by rejecting
   * A's now-stale list so the UI can refetch and ask A to redo the drag, rather
   * than letting the new field land arbitrarily while A believes they set the
   * order. The reorder is written dense 0..n-1 via bulk_update in a
   * transaction, keeping "dense and gap-free" an invariant held by exactly one
   * code path.
   */
  saveCompanyMetaTypeOrder?: Maybe<SaveCompanyMetaTypeOrder>;
  /**
   * Create or change a board's e-mail subscription. ``id`` omitted
   * creates one; present changes it (and takes it over, like a report, so
   * its data is always read with the editor's rights). The schedule is
   * armed at once: ``nextRunAt`` is the next moment on its grid.
   */
  saveDashboardSubscription: DashboardSubscriptionResult;
  saveDraftGraph: SaveDraftGraphPayload;
  /**
   * Save a personal analysis (one governed widget) the user can revisit
   * and update — their own "previous look-ups", not a shared dashboard.
   */
  saveInsightsAnalysis: SavedAnalysisResult;
  /**
   * Create a builder dashboard (the "Create dashboard" form: name and
   * who sees it; tiles may come later from the editor). It is "Only me"
   * unless ``audience`` (or, for older callers, ``rolesCanView``) says
   * otherwise, so nothing is shown to others before its author chose to.
   */
  saveInsightsBuilderDashboard: BuilderDashboardResult;
  /**
   * Persist a dashboard spec. This mutation is the ONLY way a
   * dashboard reaches the database — the analyst's save_dashboard tool
   * returns a proposal and the UI confirms by calling this
   * (save-behind-confirmation, Behavior 2).
   */
  saveInsightsDashboard: DashboardResult;
  /**
   * Frontier #15: persist an Explore builder state as a shareable,
   * permalinkable object (token + private/team/company visibility). Pass
   * ``token`` to update one the caller owns; omit to create. The state
   * re-resolves LIVE on open — a shared exploration is never a frozen number.
   */
  saveInsightsExploration: Scalars['GenericScalar']['output'];
  saveNodeLayout: SaveNodeLayoutPayload;
  /**
   * W7.2: create/update a report template (REQ-218/219). Specs pass
   * the same validation funnel as dashboards; scheduling arms when
   * interval_days is set (sweep-task architecture, mirroring
   * export_import).
   *
   * ``dashboardId`` names a New dashboards board the caller can see: the
   * report is that board's (its spec through the builder's funnel, so SQL
   * tiles, plans on SQL datasets and the board's filters stay; the board in
   * ``params.builder_dashboard``), it is read as the board reads its tiles,
   * and it goes only to people who can see the board
   * (``droppedRecipients`` lists the others).
   */
  saveReportTemplate: ReportTemplateResult;
  /**
   * Create a dataset for ``companyId``, or update dataset ``id``, through
   * ``save_dataset``. ``error`` on a refusal: ``SQL_REFUSED:<reason>`` or
   * ``INVALID_DATASET:<reason>`` as ``save_dataset`` raised it
   * (``errorDetail`` names the tag or word), ``DATASET_NOT_FOUND`` (unknown
   * or deleted id) or ``COMPANY_NOT_FOUND``. An update keeps the dataset's
   * company, author and ``source``.
   */
  saveSqlDataset?: Maybe<SaveSqlDataset>;
  /**
   * Persist one staged batch of Settings-tab threshold edits.
   * Visibility only (ADR-0001): no notifications, no recipients.
   */
  saveStockThresholds?: Maybe<SaveStockThresholds>;
  saveTicketTypeOrder?: Maybe<SaveTicketTypeOrder>;
  saveTicketTypeOrderSettings?: Maybe<SaveTicketTypeOrderSettings>;
  saveTransferDocumentData?: Maybe<SaveTransferDocumentData>;
  /**
   * Cutover date (validated against the plan's lead time), full or
   * phased rollout, and the plan-vehicle -> live-fleet mapping
   * ({vehicle_ref: {vehicle_id, trailer_id[, driver_id]}};
   * ``driver_id`` is a per-vehicle driver PREFERENCE, resolved per
   * route date through the platform's absence/substitute machinery at
   * materialization, SBX-375/D35). ``handoverDelayDays`` (SBX-361,
   * default 0) is the stabilization window before the promotion
   * scheme is handed to the platform's nightly generation; 0 hands
   * over at execute. SBX-379 item 2: double-booking a vehicle+weekday
   * already claimed by ANOTHER area's live scheme or scheduled
   * promotion (the shared-fleet ledger) refuses unless the explicit
   * ``acknowledgeFleetConflicts`` flag is passed, the same acknowledge
   * pattern as cross-area container conflicts; the acknowledged set
   * is recorded on the approval record.
   */
  schedulePromotion?: Maybe<SchedulePromotionMutation>;
  scheduleSmsByPhone?: Maybe<ScheduleSmsByPhone>;
  searchLocation?: Maybe<SearchLocation>;
  /**
   * Create the company's template from the standard composting definition.
   *
   * Backs the manager UI's "Create from standard template" button and shares
   * its implementation with ``manage.py
   * seed_composting_notification_template``, so a template created from the UI
   * and one created by a deploy are identical by construction.
   *
   * Idempotent: a company that already has a template gets it back untouched.
   * ``force`` soft-deletes the current template and rebuilds from standard —
   * a deliberate "reset to standard" that keeps the old definition addressable
   * rather than destroying it.
   */
  seedCompostingNotificationTemplate?: Maybe<SeedCompostingNotificationTemplate>;
  selfPasswordChange?: Maybe<SelfPasswordChange>;
  /**
   * One Copilot turn (RS-802): records the user message, runs the
   * agentic loop through the frozen RS-801 registry, verifies the
   * outbound text (RS-803), and returns the assistant reply with its
   * full tool-call trace.
   */
  sendCopilotMessage?: Maybe<SendCopilotMessageMutation>;
  /**
   * The panel's "Send e-mail now": mail the chosen tiles once to the
   * given recipients, without saving a subscription.
   */
  sendDashboardEmailOnce: SendDashboardEmailOnce;
  /** Deliver one subscription at once — the panel's "Send e-mail nu". */
  sendDashboardSubscriptionNow: SendDashboardSubscriptionNow;
  sendMqttMessage?: Maybe<SendMqttMessage>;
  sendSmsByAddress?: Maybe<SendSmsByAddress>;
  /**
   * Manually create + queue a SvarUt dispatch for a ticket.
   *
   * Permissions: any authenticated user with access to the ticket's
   * company. The mutation is idempotent: the external_reference is derived
   * deterministically from (ticket, use_case), so if a dispatch for that
   * pair already exists, dispatch_create returns the existing row instead
   * of creating a second one.
   */
  sendSvarutDispatchManually?: Maybe<SendSvarUtDispatchManually>;
  /** Office: (re)send the holder their signing link. Revokes any live one. */
  sendTransferDocumentSignLink?: Maybe<SendTransferDocumentSignLink>;
  /**
   * Set/override the per-agreement shares of a shared property (3.2.11).
   *
   * Legacy groups keep their FK-based semantics unchanged. NEXUS-625: when the
   * agreement's property carries no legacy ``property_group`` FK (SCP flows
   * never set it), the pool is resolved from the property's sole active
   * ``SCPMembership`` and the vector must cover exactly the SCP's active
   * member properties. NEXUS-741: a property carrying BOTH the FK and a sole
   * active membership (migrated kimppas) resolves membership-first when the
   * FK group is SCP-profiled, so per-container overrides stay reachable.
   */
  setAgreementShares?: Maybe<SetAgreementShares>;
  /**
   * Office-only (PRO-118): turn the area's auto-attach rule on/off.
   * The flip itself lands in the change log via the save-path diff.
   */
  setAreaAutoAttach?: Maybe<SetAreaAutoAttach>;
  /**
   * Office-only (PRO-91): the Governance advanced setting — how many
   * months before the end date the area counts as Expiring. Null resets to
   * the platform default (12). The change lands in the change log via the
   * save-path diff.
   */
  setAreaExpiryLeadTime?: Maybe<SetAreaExpiryLeadTime>;
  /**
   * Office-only (B1.4): the contract area's holiday-policy override.
   * ``policy: null`` resets to "inherit the company default". Change
   * lands in the area's change log via the existing save-path diff
   * (``Area.CHANGE_LOG_FIELDS``) — no separate logging call needed.
   */
  setAreaHolidayPolicy?: Maybe<SetAreaHolidayPolicy>;
  /**
   * HSY-258, office-only: the contract area's permitted operating
   * weekdays override (``routes.Area.operating_weekdays``, lowercase
   * mon..sun). An empty list or null resets to "inherit the company's
   * permitted days" (``CompanySettings.operating_weekdays``). Same
   * change-log path as the holiday policy override.
   */
  setAreaOperatingWeekdays?: Maybe<SetAreaOperatingWeekdays>;
  setAutomationChannelPolicy: SetAutomationChannelPolicyPayload;
  setAutomationDefaultFireCap: SetAutomationDefaultFireCapPayload;
  setAutomationPolicy: SetAutomationPolicyPayload;
  /**
   * RS-1502: the per-area autonomy setting (D35, default L2).
   *
   * L4 is rejected here, at the model save AND at the database
   * constraint: it is not authorized and does not exist.
   *
   * SBX-537 P1-1 (wave D23): master-gated. Raising an area to L3
   * Guarded Autopilot changes what runs against live routes without
   * a human in the loop; any-assigned-user reach broke the module's
   * own RS-2009 doctrine.
   */
  setAutonomyLevel?: Maybe<SetAutonomyLevelMutation>;
  /**
   * W10 legal sweep: a tenant back-office user toggles benchmark
   * participation and acknowledges the notice. Opting OUT purges the
   * tenant's already-ingested observations — participation withdrawal
   * retracts data, it does not merely stop future ingest.
   */
  setBenchmarkParticipation: SetBenchmarkParticipation;
  /**
   * Create or update the billing schedule for an agreement.
   *
   * Creating sets the frequency + computes ``next_billing_date``. Changing the
   * frequency on an existing schedule applies the no-proration rule
   * (``change_frequency``): the change takes effect from the start of the next
   * unbilled period, appends to the frequency-change log, and sets
   * ``frequency_changed_since_last_run``.
   */
  setBillingSchedule?: Maybe<SetBillingScheduleMutation>;
  /**
   * Who sees one of a client's New dashboards: "only_me" (its owner),
   * "everyone" in its company, or "roles" with at least one live role of
   * that company (``rolesCanView``, Relay or plain ids). Masters, staff and
   * superusers see every one either way.
   */
  setBuilderDashboardAudienceAsStaff?: Maybe<SetBuilderDashboardAudienceAsStaff>;
  /**
   * Staff-only: toggle one or more feature flags on an ARBITRARY company.
   *
   * Unlike ``PartialUpdateCompanySettings`` (tenant self-update of the caller's
   * own company), this is an internal WasteHero-staff tool that acts on any
   * company by id — impersonation-style. Gated to ``is_staff`` only (NOT master,
   * NOT tenant admins) via ``login_is_staff_required``.
   *
   * Flip-on side-effects are routed through the model, never bypassed:
   * ``metabase_enabled`` lazily provisions the Metabase user/collection via
   * ``CompanySettings.metabase_enable`` (mirrors the tenant mutation), and
   * ``hauler_b2b_enabled`` provisions the tenant's default LegalEntity exactly
   * as ``CompanySettingsAdmin.save_model`` does (idempotent, failure-tolerant).
   * ``special_price_terms_enabled`` (HSY-244) folds the company's pre-HSY-244
   * special prices into the row's own terms on the OFF → ON flip (see
   * ``feature_config.legacy_writer``).
   */
  setCompanyFeatureFlags?: Maybe<SetCompanyFeatureFlags>;
  /**
   * Replace the granted capability-key set for one portal role of the
   * calling user's company (PRO-317).
   *
   * The company-scoped counterpart of ``SetPortalRoleCapabilities`` above:
   * same whole-row-replace semantics (the supplied keys BECOME the role's
   * complete grant — the honest shape for the checkbox grid) and the same
   * loud rejection of unknown roles/keys, but writing the tenant's own
   * ``(company, role)`` row, so it is delegable via ``CompanyRolePermission``
   * (the "Portal role rights" Settings permission) and works under
   * impersonation like every other tenant surface.
   */
  setCompanyPortalRoleCapabilities?: Maybe<SetCompanyPortalRoleCapabilities>;
  /**
   * Office-only: rule whether a complaint ticket affects the contractor's
   * pay (D5). Audited (who/when) on the ticket. Contractors are refused.
   *
   * A null ruling clears it back to "Not yet assessed" and removes the audit
   * stamps (PRODUCT-230) — the service always supported the reset; the arg
   * was ``Boolean!`` so no client could reach it.
   */
  setComplaintAffectsPay?: Maybe<SetComplaintAffectsPay>;
  setContactAddressPrimary?: Maybe<SetContactAddressPrimary>;
  /**
   * PRO-755: create/update a subject's per-property auto-subscribe rule and
   * immediately reconcile subscriptions (toggle-on backfills every current
   * container + registers the standing rule; toggle-off freezes). Exactly one of
   * ``contact_id`` / ``management_company_id`` must be given.
   */
  setContactPropertyNotificationRule?: Maybe<SetContactPropertyNotificationRule>;
  setContainerGroup?: Maybe<SetContainerGroup>;
  setContainerStorageDepot?: Maybe<SetContainerStorageDepot>;
  /**
   * Put a table on New dashboards' list under ``label`` (its name in
   * the tile editor), or take it off (``exposed`` false).
   */
  setDashboardTable?: Maybe<SetDashboardTable>;
  setDefaultCard?: Maybe<SetDefaultCard>;
  setDefaultUserFilterCollection?: Maybe<SetDefaultUserFilterCollection>;
  /**
   * Office-only: schedule an exception type's pay + reliability effect from
   * a forward date (PRO-467). Re-setting the same type on the same date
   * updates that scheduled row; effective dates in the past are refused.
   */
  setExceptionCompensationEffect?: Maybe<SetExceptionCompensationEffect>;
  /**
   * REQ 3.3.21/3.3.23: office-enter (upsert) the measured quantity for a
   * MANUAL metered computation (per_tonne / per_hour / per_distance /
   * per_reversing_distance) in a contract-area month. Settlement then pays
   * ``rate × quantity`` for every metered component of that computation on
   * the area's price rows. ``quantity`` is whole measured units (>= 0);
   * entering it (even 0) also clears the ``unpriced_metered_data`` close
   * block for that computation.
   */
  setHaulerManualMeteredQuantity?: Maybe<SetHaulerManualMeteredQuantity>;
  /**
   * R2-S13 (decision R2-D18): replace the METERED component stack of one
   * contractor price (replace-all; an empty list clears it). Metered pay =
   * rate × measured quantity, resolved by the settlement selectors over
   * each period (per_emptying = the row's priced stops, per_round = the
   * distinct rounds among them) — it never joins the per-stop eventPay.
   * Computations whose measured-data feed is not available (per_tonne /
   * per_hour / per_distance) are refused: 'data feed not available'.
   */
  setHaulerPriceMeteredComponents?: Maybe<SetHaulerPriceMeteredComponents>;
  /**
   * Deactivate / reactivate one industry-catalogue code (PD-50).
   *
   * The ONLY write surface the catalogue has: rows are seed-owned
   * (``crm.services.industry_catalogue``), so no create/update/delete
   * mutations exist by design. Deactivation hides the code from pickers
   * (``allIndustryCodes(isActive: true)``) while existing assignments and
   * billable-event snapshots keep rendering — the row is never removed.
   * Gated by ``industry_catalogue__edit`` and audit-logged (locked
   * decision 10; ``crm_contact``-style temporal versioning does not cover
   * ``core`` catalogue tables, so the audit row is the change log).
   */
  setIndustryCodeActive?: Maybe<SetIndustryCodeActive>;
  /**
   * I7 (SBX-450) + I1: configure an alert's delivery — which whole
   * teams it notifies (in addition to the subscriber) and whether it
   * also emails recipients. The subscriber owns the alert; team ids are
   * intersected with the company's own core.Teams so a caller can never
   * target another tenant's team. Empty team list clears team targeting
   * (alert reverts to notifying just the subscriber).
   */
  setInsightsAlertTeams: SetInsightsAlertTeams;
  /**
   * I3 (SBX-446): pin (or clear) the caller's personal default
   * dashboard. A null/omitted id clears it → the Overview is the home.
   * The dashboard must be visible to the caller (NOT_FOUND otherwise);
   * never leaks a foreign tenant's existence.
   */
  setInsightsDefaultDashboard: SetInsightsDefaultDashboard;
  /**
   * Replace the granted capability-key set for one global portal role.
   *
   * Whole-row write: the supplied keys BECOME the role's complete grant (the
   * honest shape for the checkbox grid), not a per-key add/remove delta.
   *
   * The matrix is global/product-wide - one row per role, NO company scoping
   * (see ``crm/models/portal_capabilities.py``). It is therefore gated on
   * ``login_is_staff_required`` (``is_staff``): historically it was retunable
   * only through the ``is_staff`` Django admin, and a wrong write widens what
   * every citizen of every tenant may do, so it must NOT be delegable to
   * per-tenant company roles (``CompanyRolePermission`` would enforce tenant
   * isolation against a company-scoped object this global row does not have).
   *
   * Unknown roles and unknown capability keys are rejected loudly rather than
   * stored: an unrecognised key would silently become a right the frontend
   * never checks for.
   */
  setPortalRoleCapabilities?: Maybe<SetPortalRoleCapabilities>;
  setPropertiesInPropertyGroup?: Maybe<SetPropertiesInPropertyGroup>;
  setPropertyManagementCompanyAddressPrimary?: Maybe<SetPropertyManagementCompanyAddressPrimary>;
  /**
   * Set a reconciliation row's status (unreconciled | matched | disputed) —
   * PRO-468. MATCHED is terminal (locks the row). DISPUTED may link the PRO-465
   * credit/deduction entry that resolves it; resolving is an EXPLICIT matched
   * transition (this mutation), never a side effect of the entry's approval.
   * Office-only + the reconcile right.
   */
  setReconciliationStatus?: Maybe<SetReconciliationStatus>;
  /**
   * B1.1 (ADR-0006): link a route scheme to the warehouse it draws
   * from. Upsert per scheme - re-setting replaces the previous
   * warehouse.
   */
  setRouteSchemeWarehouseLink?: Maybe<SetRouteSchemeWarehouseLink>;
  /**
   * Office-only: record (or clear) a stop's deviation reason (REQ 3.6.25).
   *
   * A contractor is refused (server-side deny). Pass ``reason: null`` to
   * clear. The reason must be one of the taxonomy values.
   */
  setStopDeviationReason?: Maybe<SetStopDeviationReason>;
  /**
   * PRO-378 (3.12.23): the ONE sanctioned write path for changing the
   * deadline of an EXISTING ticket. A reason is mandatory — see
   * ``Ticket.set_deadline``, which audit-logs the change as a
   * ``TicketEventType.MODIFIED`` row. The Manual-mode CREATION-time
   * deadline is a normal ``createTicket``/etc. input, not this mutation.
   */
  setTicketDeadline?: Maybe<SetTicketDeadline>;
  setTicketPriority?: Maybe<SetTicketPriority>;
  setTicketRoute?: Maybe<SetTicketRoute>;
  /**
   * HSY-256 — define or adjust a task type's window in one contract area.
   *
   * UPSERT on (ticket_type, area) rather than create-or-409: the operator's
   * intent is "in this area, this type gets this window", and re-stating it
   * should adjust the rule rather than fail. The unique constraint is what
   * makes the upsert safe under concurrency.
   */
  setTicketTypeAreaExecutionWindow?: Maybe<SetTicketTypeAreaExecutionWindowMutationPayload>;
  /**
   * Replace a warehouse's designated low-stock alert recipients. An
   * empty list sends the alerts back to the company admins' bell.
   */
  setWarehouseAlertRecipients?: Maybe<SetWarehouseAlertRecipients>;
  /**
   * Mark a zone (whole, or fraction slices) as served by the own fleet.
   *
   * Replace semantics for the zone's ACTIVE marking; withdrawn marks are
   * stamped removed (never deleted) so the history stays answerable.
   * Office-only; no contractor, no prices, no settlement attach (8B).
   */
  setZoneOwnFleet?: Maybe<SetZoneOwnFleet>;
  setupRoute?: Maybe<SetupRouteMutation>;
  /**
   * Tap-to-sign. A driver signs ``driver``; with ``onDevice: true`` and a
   * typed ``signerName`` the driver records a ``waste_holder`` or
   * ``receiver`` confirmation taken in person on their device.
   */
  signTransferDocument?: Maybe<SignTransferDocument>;
  simulateAutomation: SimulateAutomationPayload;
  /**
   * Open a Copilot session bound to a project (RS-802, A4 session
   * scope). The Copilot never sees beyond this scope.
   */
  startCopilotConversation?: Maybe<StartCopilotConversationMutation>;
  /**
   * Office starts a container hire (HAUL-501/503): place a container at a
   * customer site → an on-hire placement. Wraps ``rental.begin_rental`` —
   * this only creates the placement (the ``crm.Agreement`` the clock bills);
   * it computes no charge. Idempotent by ``placementRef`` (a replay returns
   * the existing placement, ``created=false``).
   */
  startHaulerRental?: Maybe<StartHaulerRental>;
  startManualRun: StartManualRunPayload;
  /**
   * Freeze a statutory draft as an IMMUTABLE as-submitted record —
   * who / to-which-authority / when / external reference + a
   * tamper-evident seal (sha256 of the canonical payload). The
   * accountable sign-off the draft flow was missing; turns the module
   * from draft-helper into system-of-record for the obligation.
   */
  submitStatutoryDraft: SubmitStatutoryDraft;
  /**
   * RS-E28 stage H (D61): batch confirm / flag-with-note on the
   * validation room's route identities. Each entry is
   * {routeIdentity, verdict: confirmed|flagged[, note,
   * acceptanceLabel]}; flags REQUIRE a note. Verdicts bind to one
   * materialization version (default: the newest); re-materializing
   * starts a fresh sign-off. Refuses while the stage G gate keeps
   * the room closed (D62).
   */
  submitValidationVerdicts?: Maybe<SubmitValidationVerdictsMutation>;
  /**
   * W8.2: opt in to (or retune) the personal digest. Opt-out is
   * the default — subscribing is always an explicit user action.
   */
  subscribeInsightsDigest: SubscribeInsightsDigest;
  /**
   * Subscribe a property to an access-fee SCP (NEXUS-556).
   *
   * Creates the membership (with its required role) and marks the property's
   * register basis ``ACCESS_BASED``. NEXUS-627: on a SUBSCRIPTION-billed SCP
   * (ADR-0002) the fee args capture the recurring ``ACCESS_FEE`` agreement
   * atomically with the membership — the tariff/fee product's active price
   * supplies the amount unless ``feeAmount`` overrides it; ``feeInterval``
   * defaults to ANNUAL.
   */
  subscribePropertyToScp?: Maybe<SubscribePropertyToScp>;
  /**
   * RS-1602 capture (D39): folklore lands as a SUGGESTED rule with
   * provenance. This mutation is the ONLY capture path: the frozen
   * Copilot registry (D20) has no brain tool by design; the Copilot
   * can only point users here.
   */
  suggestBrainRule?: Maybe<SuggestBrainRuleMutation>;
  /**
   * COMPASS-1773 (HSY 86/54): pause an agreement's collections for
   * ``[startDate, endDate]`` (both inclusive) — a keskeytys. The agreement
   * and its base fee keep running; route generation skips the container's
   * dates inside the window, already-planned undriven stops in it are
   * released (``releasedStops``) and put back if the suspension is
   * cancelled. Refused unless the company has agreement suspension
   * enabled, and when the window is inverted, outside the agreement's
   * life, longer than the keskeytys cap or overlapping another live
   * suspension.
   */
  suspendAgreement?: Maybe<SuspendAgreement>;
  switchOffAutomation: SwitchOffAutomationPayload;
  syncCustomFieldsWithTicketType?: Maybe<SyncCustomFieldsWithTicketTypeMutation>;
  syncOfflineOperations?: Maybe<SyncOfflineOperationsResult>;
  /**
   * Item 6: export ONE property's UNSENT invoices to Visma.
   *
   * Narrows the normal export to this property (bypassing the per-property
   * cadence gate — it's a deliberate manual sync). The run appears in the
   * general Visma export log with a distinct key, and the invoices' status
   * flips on success (Item 5). It does NOT advance the company cursor.
   */
  syncPropertyToVisma?: Maybe<SyncPropertyToVisma>;
  /**
   * Explicit 'Take over': steals the lease, writes the TAKEN_OVER
   * audit event and notifies the displaced holder (websocket push).
   */
  takeOverRecordLease?: Maybe<TakeOverRecordLease>;
  /**
   * Move a single task to a route of a DIFFERENT contractor
   * (binding 3.5.41, assumption A3). Office-only — contractor accounts are
   * refused server-side. Reuses ``Route.action_stops_move`` semantics and
   * writes a ``TaskHaulerReassignmentLog`` audit row on every
   * hauler-crossing move.
   */
  taskReassignHauler?: Maybe<TaskReassignHauler>;
  /**
   * Office-only, audited (PRO-120): end a contract at a termination date
   * (its last effective day) with a mandatory reason and internal comment.
   *
   * Consequences (shown in the FE before confirming): from the day after
   * the date, the area is no longer in force — new work stops being
   * attributed to it and its agreements stop governing new collections.
   * History is never rewritten: attached agreements and settlement runs up
   * to the date remain.
   *
   * PRO-280 (H4 / decision 11): if the area has carve-outs, the mutation does
   * NOT terminate silently — it returns ``requiresCarveOutDecision: true`` with
   * the affected ``carveOuts`` so the FE can ask whether they end with the area
   * (``TERMINATE_WITH``) or become standalone (``PROMOTE_TO_STANDALONE``). Re-run
   * the mutation with ``carveOutDisposition`` set to commit the choice.
   */
  terminateContractArea?: Maybe<TerminateContractArea>;
  /**
   * Terminate a Shared Collection Point (NEXUS-536 / NEX-SS-104).
   *
   * Ends the SCP's member properties' access agreements at ``end_date``,
   * detaches the memberships and flips the profile to TERMINATED. When active or
   * future-dated access agreements exist the caller must re-submit with
   * ``confirm=True``; the first call returns ``requires_confirmation=True`` and
   * ``warnings`` without mutating anything.
   */
  terminateScp?: Maybe<TerminateScp>;
  /** Test FTP connection for KMD Easy integration */
  testKmdEasyFtpConnection?: Maybe<TestKmdEasyFtpConnection>;
  tokenAuth?: Maybe<ObtainJsonWebToken>;
  /**
   * Office-only, audited (D10): end a contract area at a cutoff date and
   * hand it over to a successor.
   *
   * Cutoff semantics (documented decision): ``cutoffDate`` is the LAST day
   * the outgoing contractor works — it becomes the old area's ``validTo``;
   * the successor takes over from the DAY AFTER (``validFrom = cutoff + 1``
   * for a created successor; an existing successor must already be valid on
   * that day). From the cutoff, newly generated tasks stamp the successor
   * area, and already-generated future routes of the outgoing contractor
   * are re-pointed to the successor's contractor (each move writes its own
   * RouteHaulerReassignmentLog). History is never rewritten.
   */
  transferContractArea?: Maybe<TransferContractArea>;
  /**
   * Move N spare parts between warehouses (A1). Lands immediately -
   * spare parts have no in-transit identity.
   */
  transferSpareParts?: Maybe<TransferSpareParts>;
  triggerExport?: Maybe<TriggerExport>;
  triggerImport?: Maybe<TriggerImport>;
  /**
   * Async quick export (PRO-665 / PRO-689).
   *
   * The synchronous ``quickExport`` query built the whole XLSX in the request
   * and returned it base64-inline, which 504s at production volume. This
   * mutation instead persists a template-less ``ExportHistory`` carrying the
   * ad-hoc filters, dispatches it onto the same Celery Jobs pipeline the
   * scheduled/template exports use, and returns the job node — the file is
   * delivered via the in-app Jobs notification + email + download URL.
   *
   * Accepts every quick-export type (``QUICK_EXPORT_TYPES``: Property,
   * Container, Contact, Property-Management-Company); each reads its own
   * filter argument, mirroring the sync ``quickExport`` query. The remaining
   * export types run on the templated path.
   */
  triggerQuickExport?: Maybe<TriggerQuickExport>;
  /** Enqueue a manual full rebuild. Master/staff only (an ops lever). */
  triggerSearchReindex?: Maybe<TriggerSearchReindex>;
  /** Manually trigger a Visma EDI export for the authenticated user's company. */
  triggerVismaExport?: Maybe<TriggerVismaExport>;
  /**
   * Reverse `KillAutopilotFlow`: clears `Flow.killed`, restoring this
   * flow's eligibility to be matched/fired (if `live`) and to be promoted
   * or activated again -- writes a mandatory-reason
   * `FlowAuditLogEntry(action=RESTORED)` (CLAUDE.md rule 5) so the audit
   * trail shows who un-killed it, when, and why, exactly as it does for the
   * kill itself.
   *
   * Wave 2 Lane D S3: un-killing a LIVE flow is a re-entry to firing, so it
   * carries the same supersession conflict gate as the two activation
   * routes. Kill resumed the source rule; if that rule is not GREEN, or the
   * flow's current trigger has drifted since (a new version committed or a
   * rollback while killed), the GREEN-only re-suspend below would silently
   * leave the rule AND the flow both firing (BOTH-fire) -- refused unless
   * the operator confirms via `disable_source_rule`, exactly like
   * `ActivateAutopilotFlow`. The refusal leaves the flow KILLED (nothing is
   * written).
   */
  unkillAutopilotFlow?: Maybe<UnkillAutopilotFlow>;
  unlinkContactFromProperty?: Maybe<UnlinkContactFromProperty>;
  unlinkContactFromPropertyManagementCompany?: Maybe<UnlinkContactFromPropertyManagementCompany>;
  unlinkManagementCompanyFromProperty?: Maybe<UnlinkManagementCompanyFromProperty>;
  /**
   * Clear ``parent_property`` on a property (NEXUS-262).
   *
   * Mirrors asset-services ``DELETE /v1/properties/{id}/parent``: a
   * dedicated mutation because ``UpdateOrCreateProperty`` cannot distinguish
   * "field omitted" from "field set to null" in the form input.
   */
  unlinkParentProperty?: Maybe<UnlinkParentProperty>;
  /**
   * Unlink a shared-tank member. Non-destructive: ends the membership row
   * (status ENDED + end_date) — never deletes it or the property/survey
   * (mirrors EndScpMembership).
   */
  unlinkSharedTankMember?: Maybe<UnlinkSharedTankMember>;
  unpairFillLevelDevice?: Maybe<UnpairFillLevelDevice>;
  /**
   * Remove an Account's price-list pin — its orders fall back to the
   * standard pool/catalog resolution. Idempotent: unpinning a pin-less
   * account simply answers unpinned=false.
   */
  unpinAccountPriceList?: Maybe<UnpinAccountPriceList>;
  unsubscribeInsightsDigest: UnsubscribeInsightsDigest;
  /**
   * Unsubscribe a property from an access-fee SCP (NEXUS-556).
   *
   * Ends the membership (delegating to the shared end + redistribution service)
   * and recomputes the property's register basis (``NONE``/non-compliant when no
   * other active membership remains).
   */
  unsubscribePropertyFromScp?: Maybe<UnsubscribePropertyFromScp>;
  updateActiveProjects?: Maybe<UpdateActiveProjects>;
  updateAgreement?: Maybe<UpdateAgreementPayload>;
  /**
   * ``data_type`` is deliberately immutable: rows the rule already
   * archived carry ``archived_by_rule=rule`` in the OLD type's table, and a
   * type change would silently orphan them from the retention sweep
   * (``retention_expired_queryset`` only looks at the current type). A type
   * change is delete + recreate.
   */
  updateArchivalRule?: Maybe<UpdateArchivalRule>;
  updateAutomationMeta: UpdateAutomationMetaPayload;
  /**
   * Edit the tenant's assumption set by creating a NEW version --
   * history is never mutated, so frozen projections keep the exact rows
   * they pinned. RBAC: ``automation__edit`` via the same
   * ``CompanyRolePermission.check_permission`` contract every autopilot
   * write uses. Audited by construction: the created row is immutable and
   * records actor + timestamp, and the previous version's row IS the
   * before-state.
   */
  updateAutopilotAssumptions?: Maybe<UpdateAutopilotAssumptions>;
  /**
   * Validate and save the next definition for a draft Flow.
   *
   * Runs the registry-aware validator (`autopilot.builder.validator`, which
   * itself runs the AP-301 structural validator first) before writing
   * anything: an invalid definition creates no `FlowVersion` row at all, and
   * every violation found (structural and registry) comes back as one
   * `errors` entry per violation, each carrying its JSON-path location
   * (`FlowSchemaViolation.render()`) so the builder can point at the exact
   * step. Non-fatal autonomy-class advisories (money/mass_comms/bulk steps)
   * come back in `warnings` and never block the save.
   *
   * Only a `draft`-state flow may be edited this way; a `test` or `live`
   * flow must be demoted back to `draft` first (a separate concern from
   * this mutation, see `PromoteAutopilotFlow`).
   */
  updateAutopilotFlowDefinition?: Maybe<UpdateAutopilotFlowDefinition>;
  updateBillingInformation?: Maybe<UpdateBillingInformation>;
  /**
   * Office-only: edit a bonus model (D7). ``areaId`` / ``haulerId``
   * re-scope it (REQ 3.3.22/3.5.57): send ``areaId: null`` to drop the area
   * scope, ``haulerId`` for a contractor default, both null for
   * company-wide; omit an axis to leave it unchanged.
   *
   * Additive sibling of ``updateBonusModel`` (which stays scope-free for
   * non-breaking master compatibility).
   */
  updateBonusModelScoped?: Maybe<UpdateBonusModelScoped>;
  updateBulkWastePickupTicket?: Maybe<UpdateBulkWastePickupTicketPayload>;
  /** Edit the caller's company include-list. Gated by ``company_settings__edit``. */
  updateCompanySearchSettings?: Maybe<UpdateCompanySearchSettings>;
  updateComparisonSettings?: Maybe<UpdateComparisonSettingsMutationPayload>;
  /** Edit the template's own attributes (not its sections or fields). */
  updateCompostingNotificationTemplate?: Maybe<UpdateCompostingNotificationTemplate>;
  /**
   * Correct the maintainable fields of a register row.
   *
   * Only the fields the office owns. ``notification_date`` is not among them:
   * it anchors the five-year statutory clock and is the server's record of when
   * the authority received the notification. Neither is ``inspection_*`` (that
   * is ``RecordCompostingInspection``) nor ``end_date`` (that is
   * ``EndCompostingRegistryEntry``, which is server-dated).
   *
   * Partial update: an argument that was not sent is left alone, which is why
   * the body reads ``kwargs`` rather than defaulting everything to ``None``.
   * Clearing ``notes`` by sending ``""`` and not touching it at all are
   * different requests.
   */
  updateCompostingRegistryEntry?: Maybe<UpdateCompostingRegistryEntry>;
  updateContact?: Maybe<UpdateContact>;
  updateContactAddress?: Maybe<UpdateContactAddress>;
  updateContactAuthorization?: Maybe<UpdateContactAuthorizationPayload>;
  /**
   * Staff dual-write of a Contact's comms-channel preferences.
   *
   * Writes the SAME store as the portal REST ``PATCH comms/channels`` by
   * delegating to ``crm.services.portal_comms`` — one store, two surfaces.
   */
  updateContactCommsChannels?: Maybe<UpdateContactCommsChannels>;
  updateContactFieldConfiguration?: Maybe<UpdateContactFieldConfiguration>;
  /** Update the Client ID on an existing contact-property link. */
  updateContactProperty?: Maybe<UpdateContactProperty>;
  updateContainer?: Maybe<UpdateContainer>;
  updateContainerMobile?: Maybe<UpdateContainerMobile>;
  /**
   * PRO-755: the missing Edit action on a subscription row — change
   * Days-before (any row) and the phone/email (manual rows, or overriding a
   * single auto row). Editing the value of a row whose method is SHARED with
   * other rows clones the method first, so siblings are untouched.
   */
  updateContainerNotification?: Maybe<UpdateContainerNotification>;
  updateContainerPrice?: Maybe<UpdateContainerPricePayload>;
  updateContainerType?: Maybe<UpdateContainerType>;
  /**
   * Edit a cost model. KPI recompute on change is explicit (a new
   * plan run); existing plans are never mutated (RS-205 AC): their
   * kpis keep the SBX-371 stamp of the book they were priced with,
   * only NEW solves resolve the changed rates.
   *
   * SBX-362 (D32/D45): master-gated, tenant-scoped; a rate edit flips
   * the source label to ``tenant_set`` with updated_by/updated_at and
   * emits route_studio.cost_model.updated with old and new values per
   * changed field (temporal versioning keeps the full row history).
   */
  updateCostModel?: Maybe<UpdateCostModelMutation>;
  updateCostSettings?: Maybe<UpdateCostSettingsMutationPayload>;
  updateCurrentDriverLocation?: Maybe<UpdateCurrentDriverLocation>;
  updateCustomerNote?: Maybe<UpdateCustomerNotePayload>;
  /**
   * Review a claim: confirm, correct, or reject (stage C).
   * Corrections re-derive downstream artifacts, never retrain
   * silently.
   */
  updateGrammarClaim?: Maybe<UpdateGrammarClaimMutation>;
  /** Office-only: edit a compliance document (PRO-99). */
  updateHaulerComplianceDocument?: Maybe<UpdateHaulerComplianceDocument>;
  /** A contractor manager edits their own hauler's contact fields (D17). */
  updateHaulerContact?: Maybe<UpdateHaulerContact>;
  /**
   * Patch a price list (RD-46). Wraps
   * ``product.price_lists.service.update_price_list`` for
   * name/description/status (reusing its status validation), then patches
   * the hauler layer's validity window, inheritance and minimumCharge as
   * plain data. Only the supplied fields change.
   */
  updateHaulerPriceList?: Maybe<UpdateHaulerPriceList>;
  /**
   * Patch a price row (RD-46). Wraps
   * ``product.price_rows.service.update_price_row`` — a price change writes
   * the engine's history snapshot; tuple-field changes re-run its
   * uniqueness check. ``minimumCharge`` is patched as plain data. Only the
   * supplied fields change (true PATCH).
   */
  updateHaulerPriceRow?: Maybe<UpdateHaulerPriceRow>;
  /** Case lifecycle (RS-E20): rename, complete, archive, reopen. */
  updateImportCase?: Maybe<UpdateImportCaseMutation>;
  /** Rename or re-point a saved analysis — the "I can update it" half. */
  updateInsightsAnalysis: SavedAnalysisResult;
  /**
   * Rename, re-lay-out or re-scope a builder dashboard. Any change needs
   * the owner or ``analytics_dashboard__edit``; ``expectedUpdatedAt`` turns
   * a save over someone else's newer one into STALE. ``audience`` (or
   * ``rolesCanView`` alone, for older callers) changes who sees it; sent
   * with neither, it stays as it is.
   */
  updateInsightsBuilderDashboard: BuilderDashboardResult;
  updateInsightsDashboard: DashboardResult;
  /** Update automatic export generation settings for KMD Easy integration */
  updateKmdEasyAutoExportSettings?: Maybe<UpdateKmdEasyAutoExportSettings>;
  /** Update all KMD Easy configuration settings for a company */
  updateKmdEasySettings?: Maybe<UpdateKmdEasySettings>;
  updateManageContainerTicket?: Maybe<UpdateManageContainerTicketPayload>;
  /** Update the Client ID on an existing company-property link. */
  updateManagementCompanyProperty?: Maybe<UpdateManagementCompanyProperty>;
  updateMeasurementSettings?: Maybe<UpdateMeasurementSettings>;
  updateNotificationSetting?: Maybe<UpdateNotificationSetting>;
  updateOrCreateAgreementExport?: Maybe<UpdateOrCreateCreateAgreementExportPayload>;
  updateOrCreateAgreementTemplate?: Maybe<UpdateOrCreateAgreementTemplatePayload>;
  updateOrCreateAlertRule?: Maybe<UpdateOrCreateAlertRulePayload>;
  updateOrCreateArea?: Maybe<UpdateOrCreateAreaPayload>;
  updateOrCreateBulkProperty?: Maybe<PropertyBulkUpdateCreateMutation>;
  updateOrCreateBulkTicket?: Maybe<TicketBulkUpdateCreateMutation>;
  updateOrCreateCollectionCalendar?: Maybe<UpdateOrCreateCollectionCalendarPayload>;
  updateOrCreateCollectionCalendarDate?: Maybe<UpdateOrCreateCollectionCalendarDatePayload>;
  updateOrCreateCollectionCalendarDeviation?: Maybe<UpdateOrCreateCollectionCalendarDeviationPayload>;
  updateOrCreateCollectionCalendarWeek?: Maybe<UpdateOrCreateCollectionCalendarWeekPayload>;
  /** target_id: ID of Route, Depot, Driver, Vehicle or Container */
  updateOrCreateComment?: Maybe<UpdateOrCreateComment>;
  updateOrCreateCompany?: Maybe<UpdateOrCreateCompanyPayload>;
  updateOrCreateCompanyContainerMetaType?: Maybe<UpdateOrCreateCompanyContainerMetaType>;
  updateOrCreateCompanyEmailAccount?: Maybe<UpdateOrCreateCompanyEmailAccountPayload>;
  updateOrCreateCompanyEmailAccountRule?: Maybe<UpdateOrCreateCompanyEmailAccountRulePayload>;
  updateOrCreateCompanyMainSettings?: Maybe<UpdateOrCreateCompanyMainSettingsPayload>;
  updateOrCreateCompanyMetaType?: Maybe<UpdateOrCreateCompanyMetaTypePayload>;
  updateOrCreateCompanyRole?: Maybe<UpdateOrCreateCompanyRole>;
  /**
   * Create a field in a section, or edit one by id.
   *
   * ``key`` is immutable once set (see the section mutation). The
   * source/binding coherence rules and the visibleWhen grammar are enforced by
   * ``crm.services.composting.validate_field`` inside the transaction, so an
   * invalid edit rolls back instead of going live.
   */
  updateOrCreateCompostingNotificationField?: Maybe<UpdateOrCreateCompostingNotificationField>;
  /** Create or edit one choice of a SELECT / MULTI_SELECT field. */
  updateOrCreateCompostingNotificationFieldOption?: Maybe<UpdateOrCreateCompostingNotificationFieldOption>;
  /**
   * Create a section on a template, or edit one by id.
   *
   * ``key`` is immutable once set: it is what ``visibleWhen`` conditions and
   * (later) stored answers reference, so renaming it would silently break every
   * gate pointing at a field inside this section.
   */
  updateOrCreateCompostingNotificationSection?: Maybe<UpdateOrCreateCompostingNotificationSection>;
  updateOrCreateContact?: Maybe<UpdateOrCreateContactPayload>;
  /** Use UpdateOrCreateContainerNew instead of UpdateOrCreateContainer */
  updateOrCreateContainer?: Maybe<UpdateOrCreateContainer>;
  updateOrCreateContainerBulk?: Maybe<UpdateOrCreateBulkContainerMutation>;
  updateOrCreateContainerGroup?: Maybe<UpdateOrCreateContainerGroupPayload>;
  updateOrCreateContainerNew?: Maybe<UpdateOrCreateContainerNewPayload>;
  updateOrCreateContainerProduct?: Maybe<UpdateOrCreateContainerProductPayload>;
  updateOrCreateContainerType?: Maybe<UpdateOrCreateContainerTypePayload>;
  updateOrCreateCriiptoApplication?: Maybe<UpdateOrCreateCreateCriiptoApplicationPayload>;
  updateOrCreateCustomerFunction?: Maybe<UpdateOrCreateCustomerFunctionPayload>;
  updateOrCreateDashboard?: Maybe<UpdateOrCreateDashboardPayload>;
  updateOrCreateDepot?: Maybe<UpdateOrCreateDepot>;
  updateOrCreateDocument?: Maybe<UpdateOrCreateCreateDocumentPayload>;
  updateOrCreateDriver?: Maybe<UpdateOrCreateDriverPayload>;
  /**
   * Create or edit a registered external map layer (3.1.45 / REQ-47).
   *
   * External layers are platform Settings configuration: office-only
   * (contractors denied — same rule as the Zone mutations) and company-scoped;
   * no module flag. Stores only the layer *definition* (WMS/WFS/WMTS/XYZ/raster
   * URL + identifier) — the map client renders it live from the URL.
   */
  updateOrCreateExternalMapLayer?: Maybe<UpdateOrCreateExternalMapLayerPayload>;
  updateOrCreateHauler?: Maybe<UpdateOrCreateHaulerPayload>;
  updateOrCreateHaulerPrice?: Maybe<UpdateOrCreateHaulerPricePayload>;
  updateOrCreateIntegrationGps?: Maybe<UpdateOrCreateIntegrationGps>;
  updateOrCreateIntegrationGpsVehicle?: Maybe<UpdateOrCreateIntegrationGpsVehicle>;
  updateOrCreateKmdEasyPropertyTypeToKmdEasyStationCode?: Maybe<UpdateOrCreateKmdEasyPropertyTypeToKmdEasyStationCodePayload>;
  updateOrCreateMeasurementSettings?: Maybe<UpdateOrCreateMeasurementSettingsPayload>;
  updateOrCreateMunicipality?: Maybe<UpdateOrCreateMunicipalityPayload>;
  updateOrCreatePickupOrderApprovalCollection?: Maybe<UpdateOrCreatePickUpOrderApprovalCollectionPayload>;
  updateOrCreatePickupSettings?: Maybe<UpdateOrCreatePickupSettingsPayload>;
  updateOrCreateProject?: Maybe<UpdateOrCreateProjectPayload>;
  updateOrCreateProjectSettings?: Maybe<UpdateOrCreateProjectSettingsPayload>;
  updateOrCreateProperty?: Maybe<UpdateOrCreatePropertyPayload>;
  updateOrCreatePropertyContact?: Maybe<UpdateOrCreatePropertyContactPayload>;
  updateOrCreatePropertyGroup?: Maybe<UpdateOrCreatePropertyGroupPayload>;
  updateOrCreatePropertyManagementCompany?: Maybe<UpdateOrCreatePropertyManagementCompanyPayload>;
  updateOrCreatePropertyType?: Maybe<UpdateOrCreatePropertyTypePayload>;
  updateOrCreatePropertyUser?: Maybe<UpdateOrCreatePropertyUserPayload>;
  updateOrCreateRecurringProduct?: Maybe<UpdateOrCreateRecurringProductPayload>;
  updateOrCreateRouteScheme?: Maybe<UpdateOrCreateRouteSchemePayload>;
  updateOrCreateScheduledExport?: Maybe<UpdateOrCreateCreateScheduledExportPayload>;
  /**
   * Create or update the SCP profile on a ``PropertyGroup`` (NEXUS-530).
   *
   * Keyed by the 1:1 ``property_group``. Termination is out of scope
   * (NEX-SS-104), so the input never exposes status/termination fields and
   * profiles are always written as ACTIVE. Every change is audited by the
   * ``crm_scpprofile`` temporal-table trigger.
   */
  updateOrCreateScpProfile?: Maybe<UpdateOrCreateScpProfile>;
  updateOrCreateService?: Maybe<UpdateOrCreateServicePayload>;
  updateOrCreateServiceProduct?: Maybe<UpdateOrCreateServiceProductPayload>;
  updateOrCreateServiceResponsibility?: Maybe<UpdateOrCreateServiceResponsibility>;
  updateOrCreateSkill?: Maybe<UpdateOrCreateSkill>;
  updateOrCreateSubscriptionQuote?: Maybe<UpdateOrCreateSubscriptionQuote>;
  updateOrCreateTeam?: Maybe<UpdateOrCreateTeamPayload>;
  updateOrCreateTicketCategory?: Maybe<UpdateOrCreateTicketCategoryPayload>;
  updateOrCreateTicketMessageTemplate?: Maybe<UpdateOrCreateTicketMessageTemplatePayload>;
  updateOrCreateTicketType?: Maybe<UpdateOrCreateTicketTypePayload>;
  updateOrCreateUserAbsence?: Maybe<UpdateOrCreateUserAbsence>;
  updateOrCreateUserFilterCollection?: Maybe<UpdateOrCreateUserFilterCollection>;
  updateOrCreateUserProject?: Maybe<UpdateOrCreateUserProjectPayload>;
  updateOrCreateVehicle?: Maybe<UpdateOrCreateVehiclePayload>;
  updateOrCreateVehicleAbsence?: Maybe<UpdateOrCreateVehicleAbsence>;
  updateOrCreateVehicleType?: Maybe<UpdateOrCreateVehicleTypePayload>;
  updateOrCreateWasteFraction?: Maybe<UpdateOrCreateWasteFraction>;
  updateOrCreateWasteFractionNew?: Maybe<UpdateOrCreateWasteFractionNewPayload>;
  /**
   * Create or edit a geographic zone (DEV-TASK-1, platform-level since
   * T4 "Map layers & zones").
   *
   * Zones are platform Settings configuration: office-only (contractors
   * denied — same rule as the Area mutations) and company-scoped; no module
   * flag — every module consumes the same zones. ``boundaryGeojson``
   * (optional) is the free-drawing path; shapefile uploads go through
   * ``importZoneBoundary``. T4 additions: ``labelId`` (admin-maintained
   * list; explicit null clears) and ``attributes`` (free key-value object).
   */
  updateOrCreateZone?: Maybe<UpdateOrCreateZonePayload>;
  /**
   * Create or rename a zone label (T4): one entry of the company's
   * admin-maintained label/type list. Office-only, company-scoped — same
   * rules as the zone mutations.
   */
  updateOrCreateZoneLabel?: Maybe<UpdateOrCreateZoneLabelPayload>;
  /**
   * Change a permit's details or move it to granted / refused. Only the
   * arguments sent change; moving to GRANTED (or re-dating a granted
   * permit) re-validates the window against the hire and bills the fee
   * once.
   */
  updatePermit?: Maybe<UpdatePermit>;
  updatePlanningArea?: Maybe<UpdatePlanningAreaMutation>;
  updatePrice?: Maybe<UpdatePricePayload>;
  updatePropertyManagementCompanyAddress?: Maybe<UpdatePropertyManagementCompanyAddress>;
  updatePropertyNote?: Maybe<UpdatePropertyNotePayload>;
  /**
   * Add and/or remove files on a property note (REQ-919).
   *
   * The office front end reuses its ticket-attachment upload flow verbatim:
   * ``obtainAttachmentsDirectUploadUrl`` with
   * ``objectToAttachType: PropertyNoteAttachment`` for the presigned POSTs,
   * then this mutation to attach them (which is also what a pasted clipboard
   * photo goes through — it is an ordinary upload by the time it gets here).
   *
   * Separate from ``updatePropertyNote`` for the same reason
   * ``updateTicketAttachments`` is separate from ``updateTicket``: attaching
   * a file is not a content edit, and the front end fires it on its own.
   *
   * Gate: the note's own ``crm_property_note__edit`` permission, via the same
   * ``CompanyRolePermission.check_permission`` call ``UpdatePropertyNote``
   * makes — which also refuses a note belonging to another company.
   */
  updatePropertyNoteAttachments?: Maybe<UpdatePropertyNoteAttachments>;
  updateRecurringPrice?: Maybe<UpdateRecurringPricePayload>;
  /**
   * Office-only, audited: edit a window's dates, scope, reason or active
   * switch (HSY 263). Omitted arguments keep their value. Both the old and
   * the new coverage must be clear of CLOSED settlement periods.
   */
  updateReliabilityExclusionWindow?: Maybe<UpdateReliabilityExclusionWindow>;
  /**
   * Edit a scenario's named configuration; each edit bumps the
   * version (F5: named, versioned scenarios).
   *
   * SBX-379 item 4 (D45): optimistic locking. Pass
   * ``expectedVersion`` (the version the client loaded) and the
   * update refuses with the honest current-version error when the
   * scenario changed under the client since; the row is locked for
   * the check-and-bump (``select_for_update``), so two concurrent
   * updates can never both pass the same expected version. Omitting
   * the argument keeps last-write-wins for clients that have not
   * adopted it yet (the frontend can adopt later).
   */
  updateScenario?: Maybe<UpdateScenarioMutation>;
  /**
   * Edit an SCP member: attributes, contact and/or its active role set.
   *
   * ``roleDefinitionIds`` (when provided) is the desired ACTIVE role set —
   * missing roles are assigned and surplus assignments ended, preserving the
   * NEXUS-546 invariants (min one role, Contact Person + Payer per SCP, deputy
   * promotion). Omitted fields stay untouched; pass ``clearContact: true`` to
   * remove the contact (a null variable is indistinguishable from an omitted
   * one). Shares are edited via ``updateScpShares``.
   *
   * NEXUS-717: a ``usageProfile`` edit re-runs the NEXUS-684 usage-mixing
   * rule (an edit can create the same restricted mix a join can), with the
   * edited member excluded from the pool comparison; ``overrideUsageMixing``
   * converts the block into a payload warning, mirroring the join paths.
   */
  updateScpMembership?: Maybe<UpdateScpMembership>;
  /**
   * Atomically re-balance the shares of an SCP's active members.
   *
   * Rejects any batch whose active shares do not sum to 100.00 with a
   * structured error (``SHARES_MUST_SUM_TO_100``).
   */
  updateScpShares?: Maybe<UpdateScpShares>;
  updateServicePrice?: Maybe<UpdateServicePricePayload>;
  updateShippingInformation?: Maybe<UpdateShippingInformation>;
  /**
   * Office (transfer_document__edit / master) or staff: carrier identity
   * and the eligible fraction list. Does NOT flip the flag — that is staff-only
   * through the feature-flag surface.
   */
  updateSiirtoCompanySettings?: Maybe<UpdateSiirtoCompanySettings>;
  updateSparePart?: Maybe<UpdateSparePart>;
  updateTicket?: Maybe<UpdateTicketPayload>;
  updateTicketAttachments?: Maybe<UpdateTicketAttachments>;
  updateTicketCustomField?: Maybe<UpdateTicketCustomFieldMutationPayload>;
  updateTicketDraft?: Maybe<UpdateTicketDraftPayload>;
  updateTicketFollowers?: Maybe<UpdateTicketFollowers>;
  updateTicketStatus?: Maybe<UpdateTicketStatus>;
  updateTicketTypeOrder?: Maybe<UpdateTicketTypeOrder>;
  /**
   * Narrow write of the citizen-facing COPY on one ticket type: the 12
   * pure display strings the self-service portal shows a citizen --
   * description (rich text), the date/note/dropdown labels and help
   * texts, the contact-step next-button label, the confirmation page's
   * title and subtitle, and the bulk-waste item-limit label and help
   * text. Absent (or null) inputs are untouched; an explicit empty
   * string clears the text (the portal then falls back to its built-in
   * wording), so the "Citizen page" panel never needs the full-payload
   * ``UpdateOrCreateTicketType`` and its lost-update behavior.
   *
   * Field split (every portal field has exactly ONE narrow home): this
   * mutation owns the pure display STRINGS listed in ``_COPY_FIELDS``
   * and nothing else. The FLOW-SHAPING fields -- shown/required toggles,
   * dropdown options, the contact-information step's toggles
   * (``portal_require_contact_information`` and the three
   * ``portal_contact_information_*_required`` flags), the zero-price
   * display switch ``portal_price_show_zero``, and the bulk-waste limit
   * and pickup window -- belong to ``UpdateTicketTypePortalIntake``
   * above and are not accepted here (unknown-argument error at the
   * GraphQL layer, no silent drop). The contact step's next-button LABEL
   * stays here: it is display copy, not flow shape. The audience flag
   * ``enable_on_portal`` belongs to ``UpdateTicketTypeSurfaces``.
   *
   * Validation mirrors the Settings save of the same fields
   * (``TicketTypeForm`` is a plain ModelForm) and invents nothing
   * stricter for copy: values are stripped of leading/trailing
   * whitespace (Django's ``forms.CharField(strip=True)`` default), the
   * 11 ``CharField`` columns cap at their model ``max_length`` of 255,
   * and ``portal_description`` (``TextField``, authored by Settings'
   * rich-text editor) is uncapped. Newlines and quotes are legal
   * everywhere -- the Settings form refuses neither, and this is display
   * copy, not the name field the rename guard polices. Service-type
   * boundaries mirror the intake mutation's: dropdown copy is refused
   * for managed service types (their citizen dropdown is force-hidden,
   * the text could never show) and bulk-waste copy is refused for
   * non-bulk-waste types (the citizen form never shows those fields
   * there).
   *
   * Audited by the platform's ``ticket_tickettype`` temporal trigger
   * exactly like a Settings-page save (module docstring) -- these are
   * plain ORM column writes, so ``emit_audit_row`` (the Rule-table gap
   * filler) is deliberately NOT used: it would double-audit. A noop
   * resend of the stored values writes nothing and leaves no history
   * row.
   */
  updateTicketTypePortalCopy?: Maybe<UpdateTicketTypePortalCopy>;
  /**
   * Narrow write of the flow-shaping citizen-form fields on one ticket
   * type ("what the citizen fills in"): date/note/dropdown shown+required,
   * the dropdown's options, the contact-information step's toggles, the
   * zero-price display switch, and the bulk-waste item limit / pickup
   * window.
   *
   * Field split (every portal field has exactly ONE narrow home): this
   * mutation owns the FLOW-SHAPING fields -- ``portal_date_hidden`` /
   * ``portal_date_required`` / ``portal_note_hidden`` /
   * ``portal_note_required`` / ``portal_dropdown_hidden`` /
   * ``portal_dropdown_required`` / ``portal_dropdown_options`` /
   * ``portal_require_contact_information`` /
   * ``portal_contact_information_name_required`` /
   * ``portal_contact_information_phone_number_required`` /
   * ``portal_contact_information_email_required`` /
   * ``portal_price_show_zero`` /
   * ``portal_service_type_bulk_waste_limit`` /
   * ``portal_date_min_days_in_future_for_bulk_waste`` /
   * ``portal_date_max_days_in_future_for_bulk_waste``. Every pure display
   * STRING the citizen reads (description, labels, help texts, confirm
   * title/subtitle, next-button label) belongs to
   * ``UpdateTicketTypePortalCopy`` below and is deliberately not
   * accepted here.
   *
   * The five citizen-page toggles ([PC-d2], W6-P2 intake extension) are
   * written verbatim onto their same-named model columns, independent
   * booleans exactly as everywhere else in the platform: the Settings
   * ModelForm (``TicketTypeForm``) declares no coupling between
   * ``portal_require_contact_information`` and the three
   * ``portal_contact_information_*_required`` flags, the Settings FE
   * renders the three require-checkboxes unconditionally (it does not
   * render -- or even send -- ``portal_require_contact_information`` at
   * all), and the citizen portal API scheme
   * (``crm/api/v1/schemes/company.py``) relays all five to the portal
   * client unconditionally. Whether a ``*_required`` flag has a visible
   * effect while the contact step is off is the citizen portal client's
   * rendering decision; no server-side dependency exists in the Settings
   * save, so none is invented here (the Autopilot FE panel owns any
   * disable/indent rendering logic).
   *
   * ``show_*`` inputs are the FE's positive spelling; stored inverted on
   * the real hidden columns exactly like FormTicketType's uiToApiValues
   * (show_portal_date -> portal_date_hidden = !value, note and dropdown
   * alike). Bulk-waste fields map to
   * ``portal_service_type_bulk_waste_limit`` /
   * ``portal_date_min_days_in_future_for_bulk_waste`` /
   * ``portal_date_max_days_in_future_for_bulk_waste`` and are refused for
   * non-bulk-waste service types (the citizen form never shows them
   * there). The managed-service rule the FE enforces client-side is
   * enforced server-side here: a managed type's dropdown can never be
   * shown, required or given options (``MANAGED_TICKET_SERVICE_TYPES``).
   *
   * Absent (or null) inputs are untouched. Audited by the platform's
   * ticket_tickettype temporal trigger like every Settings save.
   */
  updateTicketTypePortalIntake?: Maybe<UpdateTicketTypePortalIntake>;
  /**
   * Narrow write of one transition's RED-tier requirements: the
   * container gates (label printed / barcode scan / RFID pairing / bin
   * location) and the manual schedule-on-route veto. Writes ONLY
   * ``ContainerAction`` / ``ScheduleOnRouteAction(manual=True)`` rows on
   * that transition's ``Rule`` (created with the same get_or_create shape
   * ``UpdateOrCreateTicketType`` uses when the transition has none) --
   * never any other action kind, never the delete sweep.
   *
   * Semantics per control:
   *
   * * gates: absent keys untouched; the gates row exists iff any gate is
   *   true (an all-false merge deletes the canonical row -- no dead no-op
   *   rows dressed up as requirements).
   * * schedule_manual=true creates the manual veto unless the transition
   *   already schedules AUTOMATICALLY (a GREEN action this module must
   *   not silently flip; refused in plain words). schedule_manual=false
   *   removes manual veto rows only -- automatic scheduling rows are
   *   GREEN machinery and are never touched.
   * * superseded transition: skip-or-refuse (module docstring) -- equal
   *   target state is silently skipped, a differing one is refused with
   *   the platform's planner message.
   *
   * Audits one ``product.audit_logs`` row per effective change (module
   * docstring: the Rule tables have no temporal twin).
   */
  updateTicketTypeRequirements?: Maybe<UpdateTicketTypeRequirements>;
  /**
   * Narrow write of the audience/surface flags on one ticket type:
   * ``enable_on_portal`` / ``enable_on_platform`` /
   * ``enable_on_navigation_app`` plus the driver attachment requirement
   * ``navigation_app_require_attachment``. Absent (or null) input flags
   * are untouched. Returns the flags as stored after the write, so the
   * builder's audience line can render from the response while
   * GET_AUTOPILOT_BUILD_TICKET_TYPES refetches.
   */
  updateTicketTypeSurfaces?: Maybe<UpdateTicketTypeSurfaces>;
  /**
   * Narrow write of one transition's permission list: which company
   * roles may move a ticket of this type through the ``from_status ->
   * to_status`` step (the "Permission" multi-select the Settings
   * transition editor shows; stored as ``ticket.models.rule.Restriction``
   * roles, enforced by ``Ticket.can_set_status``). An EMPTY list means
   * the step is open to everyone -- exactly what a cleared Settings
   * select saves; an absent (or null) ``role_ids`` writes nothing and
   * just echoes the stored state.
   *
   * RBAC (decision, documented for the wave report): ``ticket_type__edit``
   * only -- the exact permission the Settings mutation requires for the
   * same write. Deliberately NOT ``automation__edit`` on top: a
   * Restriction gates which HUMANS may perform a manual status change; it
   * is not a row of the automation engine (that extra gate belongs to
   * ``UpdateTicketTypeRequirements``, which writes Rule/RuleAction rows).
   *
   * Supersession: NOT refused here, matching the Settings save exactly --
   * its transitions loop writes the Restriction BEFORE the supersession
   * skip/refusal, because a flow supersedes a transition's automated
   * ACTIONS, never who is allowed to move the ticket by hand.
   *
   * Audit: ``ticket_restriction`` has no temporal twin (the deploy
   * trigger list registers ticket_tickettype but no Rule/Restriction
   * tables), and Settings writes it unaudited today -- so like
   * ``UpdateTicketTypeRequirements`` this fills the gap with one
   * append-only ``product.audit_logs`` row per effective change,
   * entity_type ``autopilot.ticket_type_transition_roles``. A resend of
   * the stored role set writes nothing and leaves no row.
   */
  updateTicketTypeTransitionRoles?: Maybe<UpdateTicketTypeTransitionRoles>;
  /**
   * 3.9.6 per-ticket override: tighten/loosen ONE ticket's visibility
   * snapshot. Sets ``visibility_overridden=True`` (the bulk re-apply
   * action skips such rows) and writes a ``VISIBILITY_CHANGED``
   * ``TicketEvent`` for the ticket's history.
   */
  updateTicketVisibility?: Maybe<UpdateTicketVisibility>;
  updateUnconfirmedUser?: Maybe<UpdateUnconfirmedUser>;
  updateUser?: Maybe<UpdateUser>;
  /**
   * Sets every role a user holds in the caller's company. Roles not listed
   * in roleIds are removed from the user.
   */
  updateUserCompanyRoles?: Maybe<UpdateUserCompanyRoles>;
  updateUserContacts?: Maybe<UpdateUserContacts>;
  updateUserLayoutConfig?: Maybe<UpdateUserLayoutConfig>;
  /** Set the interface theme for the current user (PRODUCT-154). */
  updateUserThemePreference?: Maybe<UpdateUserThemePreference>;
  updateUsername?: Maybe<UpdateUsername>;
  /**
   * Edit the client-facing switches on the caller's company's Visma
   * settings (Company settings -> Visma).
   *
   * Only the arguments actually passed are written; an omitted argument
   * leaves the stored value alone, so the FE can send one switch at a time.
   * Today that is just ``pricesIncludeVat``; the argument list is the place
   * to add the next client-editable switch. Secrets (bearer token, service
   * URL) and the HWM cursor are deliberately NOT reachable here.
   */
  updateVismaCompanySettings?: Maybe<UpdateVismaCompanySettings>;
  updateWasteCollector?: Maybe<UpdateWasteCollector>;
  updateWasteFraction?: Maybe<UpdateWasteFraction>;
  /** PRO-946: replace the values of a version that is not yet locked. */
  updateWasteFractionEnvironmentalFactor?: Maybe<UpdateWasteFractionEnvironmentalFactor>;
  updateWasteType?: Maybe<UpdateWasteType>;
  /**
   * Upload any file into a case (stage A): workbooks and csvs
   * explode into candidate tables; nothing is rejected for shape,
   * wrong shape is information on the case. ``useFrontier`` opts the
   * stage B classification into the frontier-model pass for
   * ambiguous tabs (D54); the default is deterministic heuristics
   * only, no network.
   */
  uploadCaseFile?: Maybe<UploadCaseFileMutation>;
  /**
   * Office-only: attach a contract file to a contract area (R2-D20).
   *
   * Multipart ``Upload`` scalar (the ``importAreaBoundary`` path). The file
   * lands on private storage; 10 MB cap and an extension allowlist are
   * enforced in the write service.
   */
  uploadContractAreaDocument?: Maybe<UploadContractAreaDocument>;
  /**
   * HSY-258 — enter or adjust one company holiday.
   *
   * UPSERT on (company, date, name) rather than create-or-conflict:
   * re-entering the same holiday adjusts it instead of stacking a duplicate
   * that would fire its own collision for the same day.
   */
  upsertCompanyHoliday?: Maybe<UpsertCompanyHolidayPayload>;
  /**
   * PRODUCT-475 (BE-P2-5): allow or deny a waste fraction on a
   * container type (skip hire compatibility matrix). One row per pair -
   * re-setting the pair replaces its ``allowed`` value. ``allowed: false``
   * is the hard stop at booking; deleting the row (or never creating one)
   * means "allowed".
   */
  upsertContainerTypeWasteFractionRule?: Maybe<UpsertContainerTypeWasteFractionRule>;
  /**
   * Create or update one authority row of the council fee table. With
   * ``id`` the row is updated; without it the row named
   * ``authorityName`` is created, or updated when it already exists.
   */
  upsertCouncilFeeEntry?: Maybe<UpsertCouncilFeeEntry>;
  upsertFeatureConfigRule?: Maybe<UpsertFeatureConfigRule>;
  /**
   * Create or update a property's invoice sync cadence config.
   *
   * Only the user-owned config field (frequency) is written; the
   * last_synced_* watermarks are advanced by the export task and never
   * touched here. A changed frequency is applied to the property's
   * recurring fees on the fly (``cadence_transition``), not only at the
   * nightly recurring-fee run.
   *
   * ``startPeriodOverride`` is retired (visma design decision 0005, removed
   * from the UI 2026-09). The argument is kept so already-deployed clients
   * keep validating against the schema, but its value is ignored - graphene 2
   * cannot mark an argument deprecated, so the description carries the notice
   * instead.
   */
  upsertPropertyInvoiceSyncConfig?: Maybe<UpsertPropertyInvoiceSyncConfig>;
  /**
   * Create or update a property's waste-water treatment survey (S6).
   *
   * The form submits the full desired state on every save: optional fields
   * that are not sent are cleared to their empty defaults. When the property
   * is connected to the sewage network the connection flag alone is
   * sufficient — the FE hides the survey fields in that case.
   */
  upsertPropertyWasteWaterTreatment?: Maybe<UpsertPropertyWasteWaterTreatment>;
  validateAutomation: ValidateAutomationPayload;
  /**
   * Dry-run: returns all blocking issues (addressed to fields) without
   * creating anything, so the wizard can flag gaps before the user commits.
   */
  validateRouteSetup?: Maybe<ValidateRouteSetupMutation>;
  /** COMPASS-880 / HSY REQ 31: accept one confirmation signal a vehicle emitted (a completed bin-lift cycle, or an on-board weighing) and confirm the stop it resolves to. Idempotent on clientId. */
  vehicleSignalIngest?: Maybe<VehicleSignalIngestPayload>;
  /**
   * Second step of an MFA login: exchange a valid code for the JWT.
   *
   * On success this is where the session is actually created — mint the token,
   * pin ``active_token`` (single-active-session), stamp ``last_login`` and fire
   * the ``user:login`` Segment event, mirroring the SSO out-of-band issuance
   * (``sso_auth/views.py``) and the ``@set_jwt_cookie`` decorator. Every
   * failure mode surfaces as the same uniform error.
   */
  verifyMfaCode?: Maybe<VerifyMfaCode>;
  verifyToken?: Maybe<Verify>;
  /**
   * RS-E28 stage H (D61/D62): explicitly waive flagged routes so
   * the sign-off can complete with the flags on record. The waiver
   * note is mandatory and recorded (who, when, why), never silent;
   * only flagged routes can be waived.
   */
  waiveValidationFlags?: Maybe<WaiveValidationFlagsMutation>;
  /**
   * The hard approval gate: only the designated approver (see
   * WashListDef.canApprove) approves; anybody else is refused typed
   * (NOT_DESIGNATED) with nothing written.
   */
  washListApprove?: Maybe<WashListApprove>;
  /**
   * §6.7 steps 1-4: create a DRAFT wash list - bins scoped to the
   * (service area, waste category), refinable; the washing ticket type
   * named or the company's first; window pre-filled from the
   * per-(ticket type, area) table when omitted; provider defaulting from
   * the area's contractor.
   */
  washListCreate?: Maybe<WashListCreate>;
  washListForward?: Maybe<WashListForward>;
  washListRecall?: Maybe<WashListRecall>;
  washListReject?: Maybe<WashListReject>;
  /**
   * Mint one container ticket per bin of the approved plan; with
   * ``routeId`` the tickets are put straight on that route.
   */
  washListSendToProduction?: Maybe<WashListSendToProduction>;
  /**
   * Edit under the corrections ruling: awaiting-approval edits re-enter
   * draft, approved edits void the approval (re-approval required),
   * produced lists are immutable history.
   */
  washListUpdate?: Maybe<WashListUpdate>;
};


export type MutationsAcceptAutopilotSuggestionArgs = {
  flowId?: InputMaybe<Scalars['ID']['input']>;
  suggestionId: Scalars['ID']['input'];
};


export type MutationsAcceptCustomerRequestArgs = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  ticketId: Scalars['ID']['input'];
};


export type MutationsAcceptRecommendationArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsAcceptSsoInviteArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationsAcknowledgeInsightCardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsAcquireRecordLeaseArgs = {
  entityId: Scalars['ID']['input'];
  entityType: RecordLeaseEntityType;
};


export type MutationsActivateAutopilotFlowArgs = {
  disableSourceRule?: InputMaybe<Scalars['Boolean']['input']>;
  flowId: Scalars['ID']['input'];
  gateKind: AutopilotActivationGateKind;
  gateReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsActivateAutopilotFlowFromShadowArgs = {
  disableSourceRule?: InputMaybe<Scalars['Boolean']['input']>;
  flowId: Scalars['ID']['input'];
};


export type MutationsActivateConvertedFlowsArgs = {
  approvalOptIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  batchLabel: Scalars['String']['input'];
  flowIds: Array<Scalars['ID']['input']>;
};


export type MutationsAddAssociatedTicketsToCompanyEmailAccountMessageArgs = {
  selfId: Scalars['ID']['input'];
  ticketIds: Array<Scalars['ID']['input']>;
};


export type MutationsAddCardArgs = {
  billingInformationId: Scalars['ID']['input'];
  default: Scalars['Boolean']['input'];
  source: Scalars['String']['input'];
};


export type MutationsAddCompanyHolidayDayArgs = {
  date: Scalars['Date']['input'];
  name: Scalars['String']['input'];
};


export type MutationsAddContactToPropertiesArgs = {
  addContactToProperties?: InputMaybe<Array<InputMaybe<AddContactToPropertyInput>>>;
  contactId: Scalars['ID']['input'];
};


export type MutationsAddReliabilityExclusionArgs = {
  pickupOrderId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationsAddSettlementAdjustmentArgs = {
  amountCents: Scalars['Int']['input'];
  areaId: Scalars['ID']['input'];
  month: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


export type MutationsAdjustSparePartsArgs = {
  direction: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  sparePartId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type MutationsAdjustStockArgs = {
  confirmNegative?: InputMaybe<Scalars['Boolean']['input']>;
  containerTypeId: Scalars['ID']['input'];
  direction: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type MutationsAdoptExplorationCandidateArgs = {
  candidateId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsAdoptFeatureConfigDriftArgs = {
  companyId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
};


export type MutationsAnswerCaseQuestionArgs = {
  answer?: InputMaybe<Scalars['GenericScalar']['input']>;
  defer?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationsApplyAutomationTemplateArgs = {
  acknowledgeOverlaps?: InputMaybe<Scalars['Boolean']['input']>;
  allowDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  mode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  overrideReason?: InputMaybe<Scalars['String']['input']>;
  parameters: Scalars['JSONString']['input'];
};


export type MutationsApplyDynamicDayArgs = {
  day: Scalars['Date']['input'];
  forceAbsent?: InputMaybe<Scalars['Boolean']['input']>;
  planningAreaId: Scalars['ID']['input'];
};


export type MutationsApplyHaulerBankReconciliationArgs = {
  companyId: Scalars['ID']['input'];
  fileBase64: Scalars['String']['input'];
  filename?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsApplyHaulerPriceIndexAdjustmentArgs = {
  appliedTo: HaulerPriceIndexAppliedTo;
  areaId?: InputMaybe<Scalars['ID']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDate: Scalars['Date']['input'];
  haulerId: Scalars['ID']['input'];
  levelScope?: InputMaybe<HaulerPriceLevelScope>;
  note?: InputMaybe<Scalars['String']['input']>;
  percent: Scalars['Float']['input'];
  ppProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  temporaryUntil?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationsApplyTicketTypeVisibilityToTicketsArgs = {
  ticketTypeId: Scalars['ID']['input'];
};


export type MutationsApproveContractorManualEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsApproveNarrativeDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsApprovePromotionArgs = {
  acknowledgeChurn?: InputMaybe<Scalars['Boolean']['input']>;
  acknowledgeConflicts?: InputMaybe<Scalars['Boolean']['input']>;
  arithmeticOverrideReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  overrideReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsApproveTicketBatchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsArchiveAutomationArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsArchiveBillingRunArgs = {
  archive: Scalars['Boolean']['input'];
  billingRun: Scalars['ID']['input'];
};


export type MutationsArchiveProductArgs = {
  archive: Scalars['Boolean']['input'];
  product: Scalars['ID']['input'];
};


export type MutationsArchiveRecordArgs = {
  archive: Scalars['Boolean']['input'];
  dataType: ArchivableDataType;
  recordId: Scalars['ID']['input'];
};


export type MutationsArchiveScenarioArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsArchiveTicketToAcosArgs = {
  documentType: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};


export type MutationsAskInsightsAnalystArgs = {
  context?: InputMaybe<Scalars['GenericScalar']['input']>;
  history?: InputMaybe<Scalars['GenericScalar']['input']>;
  question: Scalars['String']['input'];
  session?: InputMaybe<Scalars['GenericScalar']['input']>;
};


export type MutationsAssignContainersToPromotedSchemeArgs = {
  containerIds: Array<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationsAssignCustomerFunctionsToContactArgs = {
  contactId: Scalars['ID']['input'];
  customerFunctionIds: Array<Scalars['ID']['input']>;
};


export type MutationsAssignKeyArgs = {
  collectionLocationId?: InputMaybe<Scalars['ID']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  fee?: InputMaybe<Scalars['Decimal']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  keyId: Scalars['ID']['input'];
  propertyId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsAssignScpMembershipRoleArgs = {
  membershipId: Scalars['ID']['input'];
  roleDefinitionId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationsAssignTicketArgs = {
  ticketId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsAssignTicketServiceProviderArgs = {
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  ticketId: Scalars['ID']['input'];
};


export type MutationsAssignTicketToTeamArgs = {
  teamId?: InputMaybe<Scalars['ID']['input']>;
  ticketId: Scalars['ID']['input'];
};


export type MutationsAssignUserCompanyRoleArgs = {
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationsAttachAreaAgreementArgs = {
  areaId: Scalars['ID']['input'];
  productId: Scalars['String']['input'];
};


export type MutationsAttachDeviceToContainerArgs = {
  containerId: Scalars['ID']['input'];
  customMeasurement: Scalars['Boolean']['input'];
  deviceAngle?: InputMaybe<Scalars['Float']['input']>;
  deviceId: Scalars['String']['input'];
  internalHeight: Scalars['Float']['input'];
  lid: Scalars['String']['input'];
  measurementSettingsId: Scalars['ID']['input'];
  offset: Scalars['Float']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationsAttachNotificationPlanArgs = {
  audiences: Array<InputMaybe<Scalars['String']['input']>>;
  channels?: InputMaybe<Scalars['GenericScalar']['input']>;
  id: Scalars['ID']['input'];
  languages: Array<InputMaybe<Scalars['String']['input']>>;
  leadTimeDays: Scalars['Int']['input'];
  messages: Scalars['GenericScalar']['input'];
};


export type MutationsAttachScpContainersArgs = {
  containerIds: Array<Scalars['ID']['input']>;
  propertyGroupId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationsAutosaveAutopilotFlowDraftArgs = {
  definition: Scalars['JSONString']['input'];
  flowId: Scalars['ID']['input'];
};


export type MutationsBranchScenarioArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsBuildReconstructionBaselineArgs = {
  name: Scalars['String']['input'];
  planningAreaId: Scalars['ID']['input'];
  stopSetId: Scalars['ID']['input'];
};


export type MutationsBuildReplayBaselineArgs = {
  name: Scalars['String']['input'];
  planningAreaId: Scalars['ID']['input'];
  windowEnd: Scalars['Date']['input'];
  windowStart: Scalars['Date']['input'];
};


export type MutationsBulkAcceptHolidayImpactArgs = {
  holidayDate: Scalars['Date']['input'];
  ids: Array<Scalars['ID']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsBulkConfirmCandidateTableClassArgs = {
  caseId: Scalars['ID']['input'];
  docClass: Scalars['String']['input'];
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationsBulkConfirmGrammarClaimsArgs = {
  caseId: Scalars['ID']['input'];
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationsBulkCreateBulkWastePickupTicketArgs = {
  input: Array<CreateBulkWastePickupTicketInput>;
};


export type MutationsBulkCreateContainerNotificationArgs = {
  input: BulkCreateContainerNotificationInput;
};


export type MutationsBulkCreateManageContainerTicketArgs = {
  input: Array<CreateManageContainerTicketInput>;
};


export type MutationsBulkCreateTicketArgs = {
  input: Array<CreateTicketInput>;
};


export type MutationsBulkDeleteArchivedArgs = {
  archivedForDays?: InputMaybe<Scalars['Int']['input']>;
  dataType: ArchivableDataType;
};


export type MutationsBulkImportContainersArgs = {
  rows: Array<ContainerImportRowInput>;
  warehouseId: Scalars['ID']['input'];
};


export type MutationsBulkPairContainerRfidArgs = {
  input?: InputMaybe<Array<PairContainerRfidInput>>;
};


export type MutationsBulkReceiveStockArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  rows: Array<BulkReceiveRowInput>;
  warehouseId: Scalars['ID']['input'];
};


export type MutationsBulkSetFeatureConfigArgs = {
  entries: Array<FeatureConfigBulkEntryInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  overwriteDrift?: InputMaybe<Scalars['Boolean']['input']>;
  target: FeatureConfigBulkTargetInput;
};


export type MutationsBulkSetTicketRoutesArgs = {
  newRoutes?: InputMaybe<Array<BulkSetTicketRouteInput>>;
};


export type MutationsBulkUpdateAgreementArgs = {
  updateAgreements?: InputMaybe<Array<BulkAgreementUpdateInput>>;
};


export type MutationsBulkUpdateCompanyEmailAccountMessageArgs = {
  input: BulkUpdateCompanyEmailAccountMessageInput;
  selfIds: Array<Scalars['ID']['input']>;
};


export type MutationsBulkUpdateContainerArgs = {
  input: BulkUpdateContainerInput;
};


export type MutationsBulkUpdateHaulerPricesArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  changeType: Scalars['String']['input'];
  changeValue: Scalars['Float']['input'];
  effectiveDate: Scalars['Date']['input'];
  haulerId: Scalars['ID']['input'];
  levelScope?: InputMaybe<HaulerPriceLevelScope>;
  note?: InputMaybe<Scalars['String']['input']>;
  ppProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  temporaryUntil?: InputMaybe<Scalars['Date']['input']>;
  unitChangeValue?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationsBulkUpdateTicketArgs = {
  input: BulkUpdateTicketInput;
};


export type MutationsCancelAgreementSuspensionArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationsCancelPromotionArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCancelPurchaseOrderArgs = {
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationsCancelRelocationArgs = {
  reference: Scalars['UUID']['input'];
};


export type MutationsCancelScheduledChangeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsCancelSimulationJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsCancelTransferDocumentArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsChangeContainerConditionArgs = {
  conditionTypeId: Scalars['ID']['input'];
  containerId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  raiseRepairTicket?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsChangePropertyOwnerArgs = {
  effectiveDate: Scalars['Date']['input'];
  newContactId?: InputMaybe<Scalars['ID']['input']>;
  newManagementCompanyId?: InputMaybe<Scalars['ID']['input']>;
  propertyId: Scalars['ID']['input'];
  transferPayerRole?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsCheckDeviceIdArgs = {
  deviceId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationsClassifyLoadArgs = {
  evidenceAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  reasonCode?: InputMaybe<LoadReasonCode>;
  ticketId: Scalars['ID']['input'];
  verifiedFractionId: Scalars['ID']['input'];
};


export type MutationsCloseSettlementPeriodArgs = {
  areaId: Scalars['ID']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type MutationsCompleteAlertArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsCompleteExchangeArgs = {
  deliveredContainerId?: InputMaybe<Scalars['ID']['input']>;
  ticketId: Scalars['ID']['input'];
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsCompleteTicketDraftArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsComputePromotionDiffArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsConfirmArrivalArgs = {
  containerIds: Array<Scalars['ID']['input']>;
  scrapContainerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseId: Scalars['ID']['input'];
};


export type MutationsConfirmBrainRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsConfirmCandidateTableClassArgs = {
  docClass: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationsConfirmConvertLegacyRuleToFlowArgs = {
  ruleId: Scalars['ID']['input'];
};


export type MutationsConfirmDriverPushNotificationArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsConfirmHaulerFutileFaultArgs = {
  fault: Scalars['String']['input'];
  futileVisitId: Scalars['ID']['input'];
};


export type MutationsConfirmHaulerOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationsConfirmImportMappingArgs = {
  id: Scalars['ID']['input'];
  mapping: Scalars['GenericScalar']['input'];
};


export type MutationsConfirmInsightsAlertArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsConfirmStopsByTagsArgs = {
  input: ConfirmStopsByTagsInput;
};


export type MutationsCorrectTaskToUndoneArgs = {
  handoverToHauler: Scalars['Boolean']['input'];
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  pickupOrderId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  toRouteId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsCorrectTruckloadArgs = {
  clear?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  closedAt?: InputMaybe<Scalars['DateTime']['input']>;
  driverId?: InputMaybe<Scalars['ID']['input']>;
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  km?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  openedAt?: InputMaybe<Scalars['DateTime']['input']>;
  unloadingLocationId?: InputMaybe<Scalars['ID']['input']>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
  wasteTypeId?: InputMaybe<Scalars['ID']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationsCorrectTruckloadCollectionPointArgs = {
  containerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type MutationsCounterContractorManualEntryArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  targetMonth?: InputMaybe<Scalars['Int']['input']>;
  targetYear?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsCreateAgreementArgs = {
  input: CreateAgreementInput;
};


export type MutationsCreateArchivalRuleArgs = {
  dataType: ArchivableDataType;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  olderThanDays: Scalars['Int']['input'];
  retentionDays?: InputMaybe<Scalars['Int']['input']>;
  timestampField: Scalars['String']['input'];
};


export type MutationsCreateAutomationArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
  name: Scalars['String']['input'];
  templateKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreateAutopilotFlowArgs = {
  name: Scalars['String']['input'];
  sourceSuggestionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsCreateBatchMoveScenarioArgs = {
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  planningAreaId: Scalars['ID']['input'];
  stopIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  toWeekday: Scalars['String']['input'];
};


export type MutationsCreateBillingRunArgs = {
  billingCutoffDateInclusive: Scalars['Date']['input'];
  exportAfterCreation?: InputMaybe<Scalars['Boolean']['input']>;
  externalPropertyNumber?: InputMaybe<Scalars['String']['input']>;
  includeBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  municipalityCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationsCreateBonusModelScopedArgs = {
  activeFrom: Scalars['Date']['input'];
  activeTo?: InputMaybe<Scalars['Date']['input']>;
  areaId?: InputMaybe<Scalars['ID']['input']>;
  basis?: InputMaybe<Scalars['String']['input']>;
  coefficientA?: InputMaybe<Scalars['Float']['input']>;
  coefficientB?: InputMaybe<Scalars['Float']['input']>;
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  maxAdjustmentPct?: InputMaybe<Scalars['Float']['input']>;
  meteredComponentId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reliabilityTargetPct?: InputMaybe<Scalars['Float']['input']>;
  structure: Scalars['String']['input'];
  taskType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreateBulkWastePickupTicketArgs = {
  input: CreateBulkWastePickupTicketInput;
};


export type MutationsCreateCaseQuestionArgs = {
  caseId: Scalars['ID']['input'];
  claimId?: InputMaybe<Scalars['ID']['input']>;
  options?: InputMaybe<Scalars['GenericScalar']['input']>;
  question: Scalars['String']['input'];
};


export type MutationsCreateCompanyEmailAccountMessageArgs = {
  input: CreateCompanyEmailAccountMessageInput;
};


export type MutationsCreateComparisonSettingsArgs = {
  input: CreateComparisonSettingsMutationInput;
};


export type MutationsCreateConditionTypeArgs = {
  name: Scalars['String']['input'];
  raisesRepairTicket?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationsCreateContactAddressArgs = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressType: Scalars['String']['input'];
  coName?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['ID']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreateContactAuthorizationArgs = {
  input: CreateContactAuthorizationInput;
};


export type MutationsCreateContainerArgs = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  containerId: Scalars['String']['input'];
  containerTypeId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  deviceToContainers?: InputMaybe<Array<InputMaybe<DeviceToContainerInputObject>>>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  overflowingSettings?: InputMaybe<OverflowingSettingsObject>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  pickupSettingsId?: InputMaybe<Scalars['ID']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  showOnRoute?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  wasteCollectorId?: InputMaybe<Scalars['ID']['input']>;
  wasteFractionId: Scalars['ID']['input'];
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationsCreateContainerImportArgs = {
  delimiter?: InputMaybe<Scalars['String']['input']>;
  importFile: Scalars['Upload']['input'];
  projectId: Scalars['ID']['input'];
  shouldCreate?: InputMaybe<Scalars['Boolean']['input']>;
  shouldUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  shouldUpdateGeocodeLocation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsCreateContainerMobileArgs = {
  containerId: Scalars['String']['input'];
  containerTypeId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  deviceToContainers?: InputMaybe<Scalars['JSONString']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  photo?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  showOnRoute?: InputMaybe<Scalars['Boolean']['input']>;
  wasteCollectorId?: InputMaybe<Scalars['ID']['input']>;
  wasteFractionId: Scalars['ID']['input'];
};


export type MutationsCreateContainerPriceArgs = {
  input: CreateContainerPriceInput;
};


export type MutationsCreateContainerTypeArgs = {
  colour?: InputMaybe<Scalars['String']['input']>;
  containerAccess?: InputMaybe<Scalars['String']['input']>;
  diameter?: InputMaybe<Scalars['Float']['input']>;
  emplacement: Scalars['String']['input'];
  emptyingTime?: InputMaybe<Scalars['Int']['input']>;
  height: Scalars['Float']['input'];
  isCylindrical?: InputMaybe<Scalars['Boolean']['input']>;
  isRentable?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  lidType?: InputMaybe<Scalars['String']['input']>;
  lifecycleStatus?: InputMaybe<Scalars['String']['input']>;
  loadUnitType?: InputMaybe<Scalars['String']['input']>;
  loadingMethod?: InputMaybe<Scalars['String']['input']>;
  maxPayloadKg?: InputMaybe<Scalars['Int']['input']>;
  metaData?: InputMaybe<Scalars['JSONString']['input']>;
  mobility?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  overflowingSettings?: InputMaybe<OverflowingSettingsObject>;
  photo?: InputMaybe<Scalars['String']['input']>;
  pickupSettingsId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  vehicleCoupling: Array<InputMaybe<Scalars['String']['input']>>;
  volume: Scalars['Float']['input'];
  warrantyMonths?: InputMaybe<Scalars['Int']['input']>;
  wasteTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  width?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationsCreateContainerWeightImportArgs = {
  delimiter?: InputMaybe<Scalars['String']['input']>;
  importFile: Scalars['Upload']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationsCreateContractorManualEntryArgs = {
  amountCents: Scalars['Int']['input'];
  areaId?: InputMaybe<Scalars['ID']['input']>;
  entryType: Scalars['String']['input'];
  haulerId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  targetMonth?: InputMaybe<Scalars['Int']['input']>;
  targetYear?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsCreateCostModelArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  disposalPerTon?: InputMaybe<Scalars['GenericScalar']['input']>;
  fixedPerVehicleYear?: InputMaybe<Scalars['Decimal']['input']>;
  name: Scalars['String']['input'];
  perHour?: InputMaybe<Scalars['Decimal']['input']>;
  perKm?: InputMaybe<Scalars['Decimal']['input']>;
  perLift?: InputMaybe<Scalars['Decimal']['input']>;
  premiumWindows?: InputMaybe<Scalars['GenericScalar']['input']>;
  projectId: Scalars['ID']['input'];
  regionPack?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreateCostSettingsArgs = {
  input: CreateCostSettingsMutationInput;
};


export type MutationsCreateCustomerNoteArgs = {
  input: CreateCustomerNoteInput;
};


export type MutationsCreateDayMoveScenarioArgs = {
  fromWeekday: Scalars['String']['input'];
  planningAreaId: Scalars['ID']['input'];
  toWeekday: Scalars['String']['input'];
};


export type MutationsCreateDriverPushNotificationArgs = {
  input: CreateDriverPushNotificationInput;
};


export type MutationsCreateExportArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excelFormat?: InputMaybe<Scalars['Boolean']['input']>;
  exportType: Scalars['String']['input'];
  fields: Array<InputMaybe<Scalars['String']['input']>>;
  projectId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationsCreateFillLevelDeviceMobileArgs = {
  devId: Scalars['String']['input'];
};


export type MutationsCreateFleetChangeScenarioArgs = {
  addVehicles?: InputMaybe<Scalars['GenericScalar']['input']>;
  planningAreaId: Scalars['ID']['input'];
  removeVehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationsCreateFlowFromSuggestionArgs = {
  suggestionId: Scalars['ID']['input'];
};


export type MutationsCreateGrammarClaimArgs = {
  caseId: Scalars['ID']['input'];
  confidence?: InputMaybe<Scalars['Float']['input']>;
  evidence?: InputMaybe<Scalars['GenericScalar']['input']>;
  kind: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['GenericScalar']['input']>;
  statement: Scalars['String']['input'];
};


export type MutationsCreateHaulerComplianceDocumentArgs = {
  documentTypeId: Scalars['ID']['input'];
  haulerId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo: Scalars['Date']['input'];
};


export type MutationsCreateHaulerComplianceDocumentTypeArgs = {
  name: Scalars['String']['input'];
};


export type MutationsCreateHaulerOrderArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  companyId: Scalars['ID']['input'];
  lines: Array<HaulerOrderLineInput>;
  poRef?: InputMaybe<Scalars['String']['input']>;
  priceListRef?: InputMaybe<Scalars['String']['input']>;
  requestedWindowEnd?: InputMaybe<Scalars['DateTime']['input']>;
  requestedWindowStart?: InputMaybe<Scalars['DateTime']['input']>;
  siteId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  suggestPrices?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsCreateHaulerPriceListArgs = {
  companyId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Decimal']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationsCreateHaulerPriceRowArgs = {
  companyId: Scalars['ID']['input'];
  customerType?: InputMaybe<Scalars['String']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  invoiceCode?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Decimal']['input']>;
  priceListId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  serviceResponsibilityId?: InputMaybe<Scalars['Int']['input']>;
  unitPrice: Scalars['Decimal']['input'];
  vatRateId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsCreateImportBatchArgs = {
  file: Scalars['Upload']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationsCreateImportCaseArgs = {
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  useCase?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreateImportPromotionArgs = {
  approvalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  caseId: Scalars['ID']['input'];
  fractionMap: Scalars['GenericScalar']['input'];
};


export type MutationsCreateInsightsAlertArgs = {
  prompt: Scalars['String']['input'];
};


export type MutationsCreateKeyTypeArgs = {
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  deposit?: InputMaybe<Scalars['Boolean']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  linkedProductId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};


export type MutationsCreateManageContainerTicketArgs = {
  input: CreateManageContainerTicketInput;
};


export type MutationsCreateMeasurementSettingsArgs = {
  excludeDays?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludePeriodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  excludePeriodEveryYear?: InputMaybe<Scalars['Boolean']['input']>;
  excludePeriodStart?: InputMaybe<Scalars['DateTime']['input']>;
  hours?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  measureAt?: InputMaybe<Scalars['Int']['input']>;
  measurementsPerHour?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationsCreateMobileDeviceArgs = {
  devId: Scalars['String']['input'];
  deviceTypeId: Scalars['ID']['input'];
};


export type MutationsCreateNotificationSettingArgs = {
  condition: Scalars['String']['input'];
  containerId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  threshold: Scalars['Float']['input'];
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationsCreateOrUpdateCollectionLocationArgs = {
  containerId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  lockInstructions?: InputMaybe<Scalars['String']['input']>;
  lockKeyTypeId?: InputMaybe<Scalars['ID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  propertyGroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsCreateOrUpdateContainerIdGeneratorArgs = {
  input: UpdateOrCreateContainerIdGeneratorInput;
};


export type MutationsCreateOrUpdateDkdpCompanyCredentialsArgs = {
  input: DkdpCompanyCredentialsMutationInput;
};


export type MutationsCreateOrUpdateExportTemplateArgs = {
  automaticallySendExportToExternalRecepients?: InputMaybe<Scalars['Boolean']['input']>;
  automaticallySendExportToInternalRecepients?: InputMaybe<Scalars['Boolean']['input']>;
  dailyIntervalStartTime?: InputMaybe<Scalars['Time']['input']>;
  dailyIntervalStartingFrom?: InputMaybe<Scalars['Date']['input']>;
  exportFormat: ExportFormats;
  exportIntervalSettings?: InputMaybe<ExportIntervalEnum>;
  exportIntervalValue?: InputMaybe<Scalars['Int']['input']>;
  exportType: ExportTypes;
  externalRecipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filters?: InputMaybe<Array<InputMaybe<ExportFilterTypeInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalRecipients?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isNestedFields?: InputMaybe<Scalars['Boolean']['input']>;
  mapSegments?: InputMaybe<Scalars['GenericScalar']['input']>;
  monthlyIntervalSetting?: InputMaybe<MonthlyIntervalEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  projects: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationsCreateOrUpdatePropertyWasteDecisionArgs = {
  authorityReference?: InputMaybe<Scalars['String']['input']>;
  clearValidTo?: InputMaybe<Scalars['Boolean']['input']>;
  decidedDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationsCreateOrUpdateRfidVehicleConnectionArgs = {
  input: RfidVehicleConnectionMutationInput;
};


export type MutationsCreateOrUpdateScpRoleDefinitionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreateOrUpdateStopListCardConfigArgs = {
  cardTypeConfig: CardConfigOptions;
  fields: Array<InputMaybe<Scalars['String']['input']>>;
  showWhoCompleted: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};


export type MutationsCreateOrUpdateUrbaserCompanyCredentialsArgs = {
  input: UrbaserCredentialsMutationInput;
};


export type MutationsCreatePartTypeArgs = {
  name: Scalars['String']['input'];
};


export type MutationsCreatePermitArgs = {
  alertDays?: InputMaybe<Scalars['Int']['input']>;
  authorityEntryId?: InputMaybe<Scalars['ID']['input']>;
  authorityName?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  feeProductId?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PermitStatus>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationsCreatePlanningAreaArgs = {
  costModelId?: InputMaybe<Scalars['ID']['input']>;
  cycleWeeks?: InputMaybe<Scalars['Int']['input']>;
  holidayCalendar?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parityAnchorDate?: InputMaybe<Scalars['Date']['input']>;
  projectId: Scalars['ID']['input'];
  regionName?: InputMaybe<Scalars['String']['input']>;
  regionPack?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreatePriceArgs = {
  input: CreatePriceInput;
};


export type MutationsCreatePromotionArgs = {
  approvalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
};


export type MutationsCreatePropertyManagementCompanyAddressArgs = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressType: Scalars['String']['input'];
  coName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  managementCompanyId: Scalars['ID']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreatePropertyNoteArgs = {
  input: CreatePropertyNoteInput;
};


export type MutationsCreatePurchaseOrderArgs = {
  expectedDate?: InputMaybe<Scalars['Date']['input']>;
  lines: Array<PurchaseOrderLineInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  supplier: Scalars['String']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type MutationsCreateRecurringPriceArgs = {
  input: CreateRecurringPriceInput;
};


export type MutationsCreateReliabilityExclusionWindowArgs = {
  allAreas?: InputMaybe<Scalars['Boolean']['input']>;
  areaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
};


export type MutationsCreateRentalArgs = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  containerTypeId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  managementCompanyId?: InputMaybe<Scalars['ID']['input']>;
  newPropertyAddress?: InputMaybe<NewPropertyAddressInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  payerContactId?: InputMaybe<Scalars['ID']['input']>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  requestedByContactId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
};


export type MutationsCreateRouteArgs = {
  driverId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  routeSchemeId: Scalars['ID']['input'];
  scheduledDate: Scalars['Date']['input'];
  vehicleId: Scalars['ID']['input'];
  vehicleTrailerId: Scalars['ID']['input'];
};


export type MutationsCreateScenarioArgs = {
  constraintOverrides?: InputMaybe<Scalars['GenericScalar']['input']>;
  demandModel?: InputMaybe<Scalars['String']['input']>;
  fleet?: InputMaybe<Scalars['GenericScalar']['input']>;
  name: Scalars['String']['input'];
  network?: InputMaybe<Scalars['GenericScalar']['input']>;
  objectiveProfile?: InputMaybe<Scalars['String']['input']>;
  parameterSetId?: InputMaybe<Scalars['ID']['input']>;
  planningAreaId: Scalars['ID']['input'];
  seed?: InputMaybe<Scalars['Int']['input']>;
  serviceCatalogOverrides?: InputMaybe<Scalars['GenericScalar']['input']>;
  stopSetId?: InputMaybe<Scalars['ID']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreateScheduledExportRunArgs = {
  fromDate: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  toDate: Scalars['DateTime']['input'];
};


export type MutationsCreateScheduledExtractArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  destination?: InputMaybe<Scalars['GenericScalar']['input']>;
  dimension?: InputMaybe<Scalars['String']['input']>;
  fmt?: InputMaybe<Scalars['String']['input']>;
  intervalDays?: InputMaybe<Scalars['Int']['input']>;
  metric: Scalars['String']['input'];
};


export type MutationsCreateScpCompanyMembershipArgs = {
  managementCompanyId: Scalars['ID']['input'];
  scpId: Scalars['ID']['input'];
  share: Scalars['Decimal']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationsCreateScpMembershipArgs = {
  apartments?: InputMaybe<Scalars['Int']['input']>;
  consentDate?: InputMaybe<Scalars['Date']['input']>;
  consentGiven?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  disclosureRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  intakeChannel?: InputMaybe<Scalars['String']['input']>;
  intakeRequestedBy?: InputMaybe<Scalars['String']['input']>;
  invoicingAddressId?: InputMaybe<Scalars['ID']['input']>;
  overrideUsageMixing?: InputMaybe<Scalars['Boolean']['input']>;
  propertyId: Scalars['ID']['input'];
  roleDefinitionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scpId: Scalars['ID']['input'];
  share: Scalars['Decimal']['input'];
  shares?: InputMaybe<Array<ScpShareInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  usageProfile?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreateSensorArgs = {
  antenna?: InputMaybe<Scalars['String']['input']>;
  apn?: InputMaybe<Scalars['String']['input']>;
  appKey?: InputMaybe<Scalars['String']['input']>;
  batch?: InputMaybe<Scalars['String']['input']>;
  connectionSubtype?: InputMaybe<Scalars['String']['input']>;
  connectionType: Scalars['String']['input'];
  devEui?: InputMaybe<Scalars['String']['input']>;
  devId: Scalars['String']['input'];
  deviceTypeName: Scalars['String']['input'];
  hwVersion?: InputMaybe<Scalars['Int']['input']>;
  iccid?: InputMaybe<Scalars['String']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  imsi?: InputMaybe<Scalars['String']['input']>;
  isGps?: InputMaybe<Scalars['Boolean']['input']>;
  modemFwVersion?: InputMaybe<Scalars['String']['input']>;
  pac?: InputMaybe<Scalars['String']['input']>;
  productNo?: InputMaybe<Scalars['String']['input']>;
  whsFwVersion?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreateServicePriceArgs = {
  input: CreateServicePriceInput;
};


export type MutationsCreateSparePartArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  fitsContainerTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name: Scalars['String']['input'];
  partTypeId: Scalars['ID']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreateStopSetFromEntitiesArgs = {
  boundary?: InputMaybe<Scalars['GenericScalar']['input']>;
  includeContainers?: InputMaybe<Scalars['Boolean']['input']>;
  includeOutOfBoundary?: InputMaybe<Scalars['Boolean']['input']>;
  includeProperties?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationsCreateStopSetSubsetArgs = {
  mode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stopIds: Array<InputMaybe<Scalars['ID']['input']>>;
  stopSetId: Scalars['ID']['input'];
};


export type MutationsCreateTemporaryContainerLocationArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  containerId: Scalars['ID']['input'];
  locationLatitude?: InputMaybe<Scalars['Float']['input']>;
  locationLongitude?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  periodEndDate: Scalars['Date']['input'];
  periodStartDate?: InputMaybe<Scalars['Date']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsCreateTicketArgs = {
  input: CreateTicketInput;
};


export type MutationsCreateTicketCommentArgs = {
  input: CreateTicketCommentInput;
};


export type MutationsCreateTicketCustomFieldArgs = {
  input: CreateTicketCustomFieldMutationInput;
};


export type MutationsCreateTicketDraftEmailArgs = {
  input: CreateTicketDraftEmailInput;
};


export type MutationsCreateTicketMessageArgs = {
  input: CreateTicketMessageInput;
};


export type MutationsCreateTransferArgs = {
  containerTypeId: Scalars['ID']['input'];
  fromWarehouseId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  toWarehouseId: Scalars['ID']['input'];
};


export type MutationsCreateUnconfirmedUserArgs = {
  email: Scalars['String']['input'];
  fullName?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Scalars['JSONString']['input']>;
};


export type MutationsCreateUserArgs = {
  fullName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  repeatPassword: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationsCreateWasteCollectorArgs = {
  companyName: Scalars['String']['input'];
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationsCreateWasteFractionArgs = {
  adsFractionCode?: InputMaybe<Scalars['String']['input']>;
  emptyingIntervalMax?: InputMaybe<Scalars['Int']['input']>;
  emptyingIntervalMin?: InputMaybe<Scalars['Int']['input']>;
  energyRecovery?: InputMaybe<Scalars['Decimal']['input']>;
  ewcCode?: InputMaybe<Scalars['String']['input']>;
  hazardous?: InputMaybe<Scalars['Boolean']['input']>;
  materialRecovery?: InputMaybe<Scalars['Decimal']['input']>;
  mustIncludeVat?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
  rdCode?: InputMaybe<Scalars['String']['input']>;
  recyclable?: InputMaybe<Scalars['Boolean']['input']>;
  recyclingPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  status?: InputMaybe<Status>;
  treatmentLocation?: InputMaybe<Scalars['String']['input']>;
  treatmentMethod?: InputMaybe<Scalars['String']['input']>;
  wasteCategory: Scalars['String']['input'];
  wasteType: Array<InputMaybe<Scalars['ID']['input']>>;
  weightFactor?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationsCreateWasteFractionEnvironmentalFactorArgs = {
  assumedFillPercentage?: InputMaybe<Scalars['Float']['input']>;
  co2eFactor?: InputMaybe<Scalars['Float']['input']>;
  densityKgM3?: InputMaybe<Scalars['Float']['input']>;
  recyclingPercentage?: InputMaybe<Scalars['Float']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  validFrom: Scalars['Date']['input'];
  wasteFractionId: Scalars['ID']['input'];
};


export type MutationsCreateWasteWaterApplianceOptionArgs = {
  name: Scalars['String']['input'];
};


export type MutationsDeactivateConditionTypeArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeactivateConvertedFlowsArgs = {
  batchLabel: Scalars['String']['input'];
};


export type MutationsDeactivateKeyTypeArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeactivatePartTypeArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeactivateWasteWaterApplianceOptionArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDecideAutomationApprovalArgs = {
  decision: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  previewHash: Scalars['String']['input'];
};


export type MutationsDecideAutopilotApprovalArgs = {
  approvalId: Scalars['ID']['input'];
  decision: AutopilotApprovalDecision;
  expectedPreviewDigest?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsDecideRouteChangeArgs = {
  decision: Scalars['String']['input'];
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  officeNote?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsDeclareImportCasePurposeArgs = {
  caseId: Scalars['ID']['input'];
  useCase: Scalars['String']['input'];
};


export type MutationsDecodeImportCaseArgs = {
  caseId: Scalars['ID']['input'];
  useFrontier?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsDecommissionSparePartsArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  sparePartId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type MutationsDecommissionStockArgs = {
  containerTypeId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type MutationsDeleteAgreementTemplateArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteAlertRuleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsDeleteArchivalRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteArchivedRecordArgs = {
  dataType: ArchivableDataType;
  recordId: Scalars['ID']['input'];
};


export type MutationsDeleteAreaArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteAutopilotFlowArgs = {
  flowId: Scalars['ID']['input'];
};


export type MutationsDeleteBonusModelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteCardArgs = {
  billingInformationId: Scalars['ID']['input'];
  cardId: Scalars['String']['input'];
};


export type MutationsDeleteCollectionCalendarArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteCollectionCalendarDateArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteCollectionCalendarDeviationArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteCollectionCalendarWeekArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteCollectionLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteCompanyContainerMetaTypeArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteCompanyEmailAccountArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteCompanyEmailAccountMessageArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteCompanyEmailAccountRuleArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteCompanyHolidayArgs = {
  holidayId: Scalars['ID']['input'];
};


export type MutationsDeleteCompanyMetaTypeArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteCompanyRoleArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteComparisonSettingsArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteCompostingNotificationFieldArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteCompostingNotificationFieldOptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteCompostingNotificationSectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteCompostingNotificationTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteCompostingRegistryEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteContactAddressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteContactAuthorizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteContactFieldConfigurationArgs = {
  fieldName: Scalars['String']['input'];
};


export type MutationsDeleteContactPropertiesArgs = {
  contactId: Scalars['ID']['input'];
  contactPropertyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationsDeleteContainerArgs = {
  containerId: Scalars['ID']['input'];
  reasonCategory?: InputMaybe<Scalars['String']['input']>;
  reasonText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsDeleteContainerGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteContainerNotificationArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteContainerTypeArgs = {
  reasonCategory?: InputMaybe<Scalars['String']['input']>;
  reasonText?: InputMaybe<Scalars['String']['input']>;
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteContainerTypeWasteFractionRuleArgs = {
  containerTypeId: Scalars['ID']['input'];
  wasteFractionId: Scalars['ID']['input'];
};


export type MutationsDeleteContractAreaDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteCostSettingsArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteCouncilFeeEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteCustomerFunctionArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteCustomerNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteDashboardArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteDashboardSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteDepotArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteDraftAutomationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteDriverArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteExportTemplateArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteExternalMapLayerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteFcmDeviceArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsDeleteFeatureConfigRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteHaulerArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteHaulerComplianceDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteHaulerPriceArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteHaulerPriceListArgs = {
  companyId: Scalars['ID']['input'];
  priceListId: Scalars['ID']['input'];
};


export type MutationsDeleteHaulerPriceRowArgs = {
  companyId: Scalars['ID']['input'];
  priceListId: Scalars['ID']['input'];
  priceRowId: Scalars['ID']['input'];
};


export type MutationsDeleteImportHistoryArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteInsightsAlertArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteInsightsAnalysisArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteInsightsBuilderDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteInsightsDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteInsightsExplorationArgs = {
  token: Scalars['String']['input'];
};


export type MutationsDeleteIntegrationGpsVehicleArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteKmdEasyPropertyTypeToKmdEasyStationCodeArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteMeasurementSettingsArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteMunicipalityArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteMyTemplateArgs = {
  key: Scalars['String']['input'];
};


export type MutationsDeleteNotificationSettingArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeletePermitArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeletePickupSettingsArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeletePlanningAreaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteProjectArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationsDeletePropertyArgs = {
  reasonCategory?: InputMaybe<Scalars['String']['input']>;
  reasonText?: InputMaybe<Scalars['String']['input']>;
  selfId: Scalars['ID']['input'];
};


export type MutationsDeletePropertyContactArgs = {
  propertyContact: Scalars['ID']['input'];
};


export type MutationsDeletePropertyGroupArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeletePropertyInvoiceSyncConfigArgs = {
  propertyId: Scalars['ID']['input'];
};


export type MutationsDeletePropertyManagementCompanyArgs = {
  id: Scalars['ID']['input'];
  reasonCategory?: InputMaybe<Scalars['String']['input']>;
  reasonText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsDeletePropertyManagementCompanyAddressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeletePropertyNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeletePropertyTypeArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeletePropertyWasteDecisionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteReliabilityExclusionWindowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteReportTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteScenarioArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteScheduledExceptionCompensationEffectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteScheduledExportArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteScheduledExtractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteScpRoleDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteServiceArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteServiceResponsibilityArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteSparePartArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteSqlDatasetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteTaskArgs = {
  reasonCategory?: InputMaybe<Scalars['String']['input']>;
  reasonText?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
};


export type MutationsDeleteTeamArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteTicketCategoryArgs = {
  reasonCategory?: InputMaybe<Scalars['String']['input']>;
  reasonText?: InputMaybe<Scalars['String']['input']>;
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteTicketCustomFieldArgs = {
  customFieldId: Scalars['ID']['input'];
};


export type MutationsDeleteTicketMessageTemplateArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteTicketTypeArgs = {
  id: Scalars['ID']['input'];
  reasonCategory?: InputMaybe<Scalars['String']['input']>;
  reasonText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsDeleteTicketTypeAreaExecutionWindowArgs = {
  windowId: Scalars['ID']['input'];
};


export type MutationsDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteUserAbsenceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsDeleteUserFilterCollectionArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteUserProjectArgs = {
  userProjectId: Scalars['ID']['input'];
};


export type MutationsDeleteVehicleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteVehicleAbsenceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsDeleteVehicleTypeArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteWasteCollectorArgs = {
  projectId: Scalars['ID']['input'];
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteWasteFractionArgs = {
  reasonCategory?: InputMaybe<Scalars['String']['input']>;
  reasonText?: InputMaybe<Scalars['String']['input']>;
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteWasteFractionEnvironmentalFactorArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteWasteTypeArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsDeleteZoneArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDeleteZoneLabelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsDemoInvitationArgs = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  demoPeriod?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  projects: Array<InputMaybe<ProjectsInputObject>>;
};


export type MutationsDetachScpContainerArgs = {
  containerId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  propertyGroupId: Scalars['ID']['input'];
};


export type MutationsDetachSensorArgs = {
  deviceId: Scalars['ID']['input'];
};


export type MutationsDisableAutomationEngineArgs = {
  reason: Scalars['String']['input'];
};


export type MutationsDismissAutopilotSuggestionArgs = {
  suggestionId: Scalars['ID']['input'];
  undo?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsDismissRecommendationArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsDisplaceHaulerVisitArgs = {
  lineId: Scalars['ID']['input'];
  proposedDate?: InputMaybe<Scalars['Date']['input']>;
  stopId: Scalars['ID']['input'];
};


export type MutationsDriverCreateTemporaryContainerLocationArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  containerId: Scalars['ID']['input'];
  locationLatitude?: InputMaybe<Scalars['Float']['input']>;
  locationLongitude?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  periodEndDate: Scalars['Date']['input'];
  periodStartDate?: InputMaybe<Scalars['Date']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsDrivingListExportArgs = {
  backendUrl?: InputMaybe<Scalars['String']['input']>;
  daysAhead?: InputMaybe<Scalars['Int']['input']>;
  driverId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  validityDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsDuplicateAutomationArgs = {
  id: Scalars['ID']['input'];
  intent: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsEditInsightsDashboardArgs = {
  instruction: Scalars['String']['input'];
  spec: Scalars['GenericScalar']['input'];
};


export type MutationsEndCompostingRegistryEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsEndContactAuthorizationArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationsEndHaulerRentalArgs = {
  companyId: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  placementRef: Scalars['String']['input'];
};


export type MutationsEndPropertyScpMembershipsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  propertyId: Scalars['ID']['input'];
  roleHandovers?: InputMaybe<Array<ScpRoleHandoverInput>>;
};


export type MutationsEndScheduledChangeNowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsEndScpCompanyMembershipArgs = {
  companyShares?: InputMaybe<Array<ScpShareInput>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  membershipId: Scalars['ID']['input'];
  shares?: InputMaybe<Array<ScpShareInput>>;
};


export type MutationsEndScpMembershipArgs = {
  companyShares?: InputMaybe<Array<ScpShareInput>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  membershipId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  shares?: InputMaybe<Array<ScpShareInput>>;
};


export type MutationsEndScpMembershipRoleArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  membershipRoleId: Scalars['ID']['input'];
};


export type MutationsEndScpMembershipWithHandoverArgs = {
  companyShares?: InputMaybe<Array<ScpShareInput>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  membershipId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  roleHandovers?: InputMaybe<Array<ScpRoleHandoverInput>>;
  shares?: InputMaybe<Array<ScpShareInput>>;
};


export type MutationsEnsureTransferDocumentArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationsExchangeHaulerRentalArgs = {
  companyId: Scalars['ID']['input'];
  exchangeDate: Scalars['Date']['input'];
  newContainerRef?: InputMaybe<Scalars['ID']['input']>;
  newPlacementRef: Scalars['String']['input'];
  placementRef: Scalars['String']['input'];
  qty?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsExcludeAreaAgreementArgs = {
  areaId: Scalars['ID']['input'];
  productId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsExecutePromotionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsExportBillingRunToNavisionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsExportInsightsArgs = {
  dashboardId?: InputMaybe<Scalars['ID']['input']>;
  spec?: InputMaybe<Scalars['GenericScalar']['input']>;
  target: Scalars['String']['input'];
};


export type MutationsExportInsightsAuditArgs = {
  kind?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsExportPlanComparisonArgs = {
  baselineId?: InputMaybe<Scalars['ID']['input']>;
  fileFormat: Scalars['String']['input'];
  planIds: Array<Scalars['ID']['input']>;
};


export type MutationsExportPlanSummaryArgs = {
  fileFormat: Scalars['String']['input'];
  planId: Scalars['ID']['input'];
};


export type MutationsExportPromotionDiffArgs = {
  fileFormat: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationsExportStatutoryDraftArgs = {
  id: Scalars['ID']['input'];
  target?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsExportTemplateScheduleSettingsUpdateArgs = {
  automaticallySendExportToExternalRecepients?: InputMaybe<Scalars['Boolean']['input']>;
  automaticallySendExportToInternalRecepients?: InputMaybe<Scalars['Boolean']['input']>;
  dailyIntervalStartTime?: InputMaybe<Scalars['Time']['input']>;
  dailyIntervalStartingFrom?: InputMaybe<Scalars['Date']['input']>;
  exportIntervalSettings?: InputMaybe<ExportIntervalEnum>;
  exportIntervalValue?: InputMaybe<Scalars['Int']['input']>;
  externalRecipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['ID']['input'];
  internalRecipients?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  monthlyIntervalSetting?: InputMaybe<MonthlyIntervalEnum>;
};


export type MutationsExtendRentalArgs = {
  periodEndDate: Scalars['Date']['input'];
  ticketId: Scalars['ID']['input'];
};


export type MutationsExtendTemporaryContainerLocationArgs = {
  containerId: Scalars['ID']['input'];
  newPeriodEndDate: Scalars['Date']['input'];
};


export type MutationsFixedRouteTemplateAcceptPlacementsArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationsFixedRouteTemplateAdoptArgs = {
  routeId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationsFixedRouteTemplateApplyArgs = {
  confirmStarted?: InputMaybe<Scalars['Boolean']['input']>;
  routeId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationsFixedRouteTemplateApplyToSchemeArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  includeStarted?: InputMaybe<Scalars['Boolean']['input']>;
  routeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  templateId: Scalars['ID']['input'];
};


export type MutationsFixedRouteTemplateConfirmArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationsFixedRouteTemplateDeactivateArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationsFixedRouteTemplateDeleteArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationsFixedRouteTemplateDetachRouteArgs = {
  routeId: Scalars['ID']['input'];
};


export type MutationsFixedRouteTemplateRenameArgs = {
  name: Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationsFixedRouteTemplateRevertToSeededArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationsFixedRouteTemplateSaveOrderArgs = {
  containerIds: Array<Scalars['Int']['input']>;
  expectedUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  renderedContainerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  templateId: Scalars['ID']['input'];
};


export type MutationsFixedRouteTemplateSeedFromHistoryArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  minRoutes?: InputMaybe<Scalars['Int']['input']>;
  minStops?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  routeSchemeId: Scalars['ID']['input'];
};


export type MutationsFixedRouteTemplateSeedFromRouteArgs = {
  createNew?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  routeId: Scalars['ID']['input'];
};


export type MutationsFixedRouteTemplatesApplyToRoutesArgs = {
  includeStarted?: InputMaybe<Scalars['Boolean']['input']>;
  routeIds: Array<Scalars['ID']['input']>;
};


export type MutationsFormErrorArgs = {
  errorType: Scalars['String']['input'];
};


export type MutationsGenerateBarcodesForContainersArgs = {
  barcodeGenerationInputList: Array<BarcodeGenerationInput>;
};


export type MutationsGenerateCollectionCalendarsPickupSettingsArgs = {
  selfId: Scalars['ID']['input'];
  weekdays: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationsGenerateCommitteePackArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  prompt: Scalars['String']['input'];
};


export type MutationsGenerateDatesForCollectionCalendarsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  periodEnd: Scalars['Date']['input'];
};


export type MutationsGenerateInsightsDashboardArgs = {
  prompt: Scalars['String']['input'];
};


export type MutationsGenerateInvoiceForPropertyArgs = {
  propertyId: Scalars['ID']['input'];
};


export type MutationsGenerateKmdEasyFileArgs = {
  fileTypeToGenerate: KmdEasyExportFileType;
};


export type MutationsGenerateNarrativeDocumentArgs = {
  kind: Scalars['String']['input'];
  planId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGenerateServiceUnitsArgs = {
  profile?: InputMaybe<Scalars['String']['input']>;
  stopSetId: Scalars['ID']['input'];
};


export type MutationsGenerateStatutoryDraftArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};


export type MutationsGeocodeImportBatchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsGoLiveAutomationArgs = {
  acknowledgeOverlaps?: InputMaybe<Scalars['Boolean']['input']>;
  allowDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  duplicateReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  overrideReason?: InputMaybe<Scalars['String']['input']>;
  replaceRuns?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsGoShadowAutomationArgs = {
  acknowledgeOverlaps?: InputMaybe<Scalars['Boolean']['input']>;
  allowDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  duplicateReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsHeartbeatRecordLeaseArgs = {
  leaseId: Scalars['String']['input'];
};


export type MutationsImpersonateArgs = {
  impersonatedId: Scalars['ID']['input'];
};


export type MutationsImportAreaBoundaryArgs = {
  areaId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationsImportFinanceCreditNotesArgs = {
  rows: Array<FinanceCreditNoteRowInput>;
};


export type MutationsImportKmdEasyFileArgs = {
  importFile: Scalars['String']['input'];
  importType: KmdEasyImportFileTypeEnum;
  projectId: Scalars['ID']['input'];
};


export type MutationsImportZoneBoundaryArgs = {
  file: Scalars['Upload']['input'];
  zoneId: Scalars['ID']['input'];
};


export type MutationsIngestExternalConfirmationsArgs = {
  input: IngestExternalConfirmationsInput;
};


export type MutationsIngestWeighTicketArgs = {
  input: WeighTicketInput;
};


export type MutationsIngestWeighTicketsArgs = {
  inputs: Array<WeighTicketInput>;
};


export type MutationsInstantiateAutopilotPlaybookArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  playbookKey: Scalars['String']['input'];
};


export type MutationsInternalUpdateOrCreateSalesOfferArgs = {
  input: InternalUpdateOrCreateSalesOfferInput;
};


export type MutationsInviteUsersArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  emails: Array<Scalars['String']['input']>;
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  isMaster: Scalars['Boolean']['input'];
  isSuper: Scalars['Boolean']['input'];
  projectIds: Array<Scalars['ID']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  useSso?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsIssueRentalArgs = {
  containerId?: InputMaybe<Scalars['ID']['input']>;
  rentalTicketId: Scalars['ID']['input'];
};


export type MutationsKillAutopilotFlowArgs = {
  flowId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationsLinkAreaSuccessionArgs = {
  predecessorId: Scalars['ID']['input'];
  successorId: Scalars['ID']['input'];
};


export type MutationsLinkContactToPropertyArgs = {
  contactId: Scalars['ID']['input'];
  debtorNumber?: InputMaybe<Scalars['String']['input']>;
  externalPropertyContactId?: InputMaybe<Scalars['String']['input']>;
  propertyId: Scalars['ID']['input'];
  role: ContactRole;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationsLinkContactToPropertyManagementCompanyArgs = {
  contactId: Scalars['ID']['input'];
  propertyManagementCompanyId: Scalars['ID']['input'];
};


export type MutationsLinkManagementCompanyToPropertyArgs = {
  externalPropertyContactId?: InputMaybe<Scalars['String']['input']>;
  managementCompanyId: Scalars['ID']['input'];
  propertyId: Scalars['ID']['input'];
  role: ContactRole;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationsLinkSharedTankMemberArgs = {
  homePropertyId: Scalars['ID']['input'];
  memberPropertyId: Scalars['ID']['input'];
  share?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationsLiveOpsAcknowledgeExceptionArgs = {
  exceptionId: Scalars['ID']['input'];
};


export type MutationsLiveOpsLogCallArgs = {
  routeId: Scalars['ID']['input'];
};


export type MutationsLiveOpsMarkStopSkippedArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  reasonCode: NonCollectionReason;
  routeId: Scalars['ID']['input'];
};


export type MutationsLiveOpsMessageDriverArgs = {
  message: Scalars['String']['input'];
  routeId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsLiveOpsReassignStopsArgs = {
  fromRouteId: Scalars['ID']['input'];
  orderIds: Array<InputMaybe<Scalars['ID']['input']>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  toRouteId: Scalars['ID']['input'];
};


export type MutationsLiveOpsResolveExceptionArgs = {
  exceptionId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  resolution: ExceptionResolution;
};


export type MutationsLiveOpsScheduleRecollectArgs = {
  stopId: Scalars['ID']['input'];
  targetRouteId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsLiveOpsSnoozeExceptionArgs = {
  exceptionId: Scalars['ID']['input'];
  minutes: Scalars['Int']['input'];
};


export type MutationsLiveOpsUnacknowledgeExceptionArgs = {
  exceptionId: Scalars['ID']['input'];
};


export type MutationsLiveOpsUndoArgs = {
  undoToken: Scalars['String']['input'];
};


export type MutationsLoadUnitJobCancelArgs = {
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  loadId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsLoadUnitJobMarkEmptiedArgs = {
  depotId?: InputMaybe<Scalars['ID']['input']>;
  emptiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  loadId: Scalars['String']['input'];
  longitude?: InputMaybe<Scalars['Float']['input']>;
  netWeight?: InputMaybe<Scalars['Float']['input']>;
  siteName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsLoadUnitJobMarkUnloadedArgs = {
  completeStop?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  loadId: Scalars['String']['input'];
  longitude?: InputMaybe<Scalars['Float']['input']>;
  unloadedAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationsLoadUnitJobStartArgs = {
  containerGroupId?: InputMaybe<Scalars['ID']['input']>;
  containerId?: InputMaybe<Scalars['ID']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  loadId: Scalars['String']['input'];
  loadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  orderId: Scalars['String']['input'];
  routeId: Scalars['ID']['input'];
  unitLabel?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsLocationArgs = {
  input: LocationInput;
};


export type MutationsLogViewPropertyEventArgs = {
  propertyId: Scalars['ID']['input'];
};


export type MutationsLogViewTicketEventArgs = {
  ticketId: Scalars['ID']['input'];
};


export type MutationsManageFilesArgs = {
  contentType?: InputMaybe<MediaContentEnumType>;
  deletedFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objId: Scalars['ID']['input'];
  toDir?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsMarkAllUserNotificationsReadArgs = {
  directOnly?: InputMaybe<Scalars['Boolean']['input']>;
  followingOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsMarkAllUserNotificationsSeenArgs = {
  directOnly?: InputMaybe<Scalars['Boolean']['input']>;
  followingOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsMarkCompanyPortalConversationReadArgs = {
  conversationId: Scalars['ID']['input'];
};


export type MutationsMarkHaulerLineFutileArgs = {
  evidenceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  lineId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsMarkHaulerOrderCompletedArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationsMarkHaulerOrdersCompletedArgs = {
  companyId: Scalars['ID']['input'];
  orderIds: Array<Scalars['ID']['input']>;
};


export type MutationsMarkInvoiceSentArgs = {
  companyId: Scalars['ID']['input'];
  invoiceId: Scalars['ID']['input'];
};


export type MutationsMarkManifestNodeUnavailableArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  unavailable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsMarkUserJobNotificationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsMarkUserNotificationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsMarkUserNotificationSeenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsMatchWeighTicketArgs = {
  orderId: Scalars['String']['input'];
  weighTicketId: Scalars['ID']['input'];
};


export type MutationsMaterializeImportCaseArgs = {
  anchorDate?: InputMaybe<Scalars['Date']['input']>;
  caseId: Scalars['ID']['input'];
  horizonMonths?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsMonitorInsightsMetricArgs = {
  direction: Scalars['String']['input'];
  metric: Scalars['String']['input'];
  threshold: Scalars['Float']['input'];
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsMoveHaulerStopsArgs = {
  companyId: Scalars['ID']['input'];
  lineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  stopIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  targetRouteId: Scalars['ID']['input'];
};


export type MutationsMoveScpMembershipArgs = {
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  membershipId: Scalars['ID']['input'];
  moveDate?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  share?: InputMaybe<Scalars['Decimal']['input']>;
  sourceCompanyShares?: InputMaybe<Array<ScpShareInput>>;
  sourceShares?: InputMaybe<Array<ScpShareInput>>;
  targetScpId: Scalars['ID']['input'];
};


export type MutationsObtainAttachmentsDirectUploadUrlArgs = {
  inputData?: InputMaybe<DirectFileUploadStartInput>;
};


export type MutationsObtainImportDirectUploadUrlArgs = {
  inputData?: InputMaybe<DirectImportUploadStartInput>;
};


export type MutationsOfflineModeArgs = {
  createTickets?: InputMaybe<Array<InputMaybe<OfflineCreateTicketInput>>>;
  routeId: Scalars['ID']['input'];
  routeStopsComplete?: InputMaybe<Array<InputMaybe<OfflineRouteStopCompleteInput>>>;
};


export type MutationsOrderKeyArgs = {
  collectionLocationId?: InputMaybe<Scalars['ID']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  fee?: InputMaybe<Scalars['Decimal']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  keyId: Scalars['String']['input'];
  keyTypeId: Scalars['ID']['input'];
  propertyId: Scalars['ID']['input'];
};


export type MutationsOrderSparePartArgs = {
  containerId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  sparePartId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type MutationsOrderSubscriptionQuoteArgs = {
  billingInformationId: Scalars['ID']['input'];
  storeType: Scalars['String']['input'];
  stripeId: Scalars['String']['input'];
};


export type MutationsOverrideSettlementCoefficientArgs = {
  areaId: Scalars['ID']['input'];
  clear?: InputMaybe<Scalars['Boolean']['input']>;
  coefficient?: InputMaybe<Scalars['Float']['input']>;
  month: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


export type MutationsPairContainerLabelsArgs = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  containerId: Scalars['ID']['input'];
  reassignRfid?: InputMaybe<Scalars['Boolean']['input']>;
  rfid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsPartialUpdateCompanySettingsArgs = {
  input: PartialUpdateCompanySettingsInput;
};


export type MutationsPasswordChangeArgs = {
  newPassword: Scalars['String']['input'];
  repeatPassword: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  uidb64?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationsPauseAutomationEngineArgs = {
  reason: Scalars['String']['input'];
};


export type MutationsPauseReportTemplateArgs = {
  id: Scalars['ID']['input'];
  paused: Scalars['Boolean']['input'];
};


export type MutationsPickupOrderApprovalCollectionAddApprovalsArgs = {
  collectionId: Scalars['ID']['input'];
  pickupOrderIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationsPickupOrderApprovalCollectionDeleteApprovalsArgs = {
  collectionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsPickupOrderApprovalCollectionUpdateApprovalsArgs = {
  collectionId: Scalars['ID']['input'];
  completeCollection: Scalars['Boolean']['input'];
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  remove: Scalars['Boolean']['input'];
};


export type MutationsPinAccountPriceListArgs = {
  accountId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  priceListId: Scalars['ID']['input'];
};


export type MutationsPreviewConvertLegacyRuleToFlowArgs = {
  ruleId: Scalars['ID']['input'];
};


export type MutationsPreviewSqlDatasetArgs = {
  companyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  parameters?: InputMaybe<Scalars['GenericScalar']['input']>;
  sampleValues?: InputMaybe<Scalars['GenericScalar']['input']>;
  sampleWindow?: InputMaybe<Scalars['GenericScalar']['input']>;
  sql: Scalars['String']['input'];
};


export type MutationsPromoteAutopilotFlowArgs = {
  flowId: Scalars['ID']['input'];
  targetState: AutopilotFlowPromotableState;
};


export type MutationsPromoteInsightsVerifiedQueryArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  specs: Scalars['GenericScalar']['input'];
};


export type MutationsProposeImportMappingArgs = {
  id: Scalars['ID']['input'];
  useCopilot?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsProposeRouteChangeArgs = {
  changeType: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  proposedStartDate: Scalars['Date']['input'];
  proposedValue: Scalars['String']['input'];
  routeId: Scalars['ID']['input'];
};


export type MutationsPublicSaveTransferDocumentDataArgs = {
  data: Scalars['GenericScalar']['input'];
  token: Scalars['String']['input'];
};


export type MutationsPublicSignTransferDocumentArgs = {
  signerName: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationsPublicTransferDocumentPdfUrlArgs = {
  token: Scalars['String']['input'];
};


export type MutationsPublicUpdateUnconfirmedUserArgs = {
  createUser?: InputMaybe<Scalars['Boolean']['input']>;
  createUserPassword?: InputMaybe<Scalars['String']['input']>;
  createUserPasswordRepeat?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  inviteUsers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaCompanyName?: InputMaybe<Scalars['String']['input']>;
  metaCountry?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaFullName?: InputMaybe<Scalars['String']['input']>;
  metaHowDidYouHearAboutUs?: InputMaybe<Array<InputMaybe<PublicUpdateUnconfirmedUserHowDidYouHearAboutUs>>>;
  metaInterestedHardware?: InputMaybe<Array<InputMaybe<PublicUpdateUnconfirmedUserInterestedHardware>>>;
  metaInterestedSoftware?: InputMaybe<Array<InputMaybe<PublicUpdateUnconfirmedUserInterestedSoftware>>>;
  metaJobTitle?: InputMaybe<PublicUpdateUnconfirmedUserJobTitle>;
  metaNumberOfEmployees?: InputMaybe<PublicUpdateUnconfirmedUserNumberOfEmployees>;
  metaPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  metaSegment?: InputMaybe<PublicUpdateUnconfirmedUserSegment>;
  selfId: Scalars['ID']['input'];
};


export type MutationsPublishInsightArgs = {
  chartSpec: Scalars['GenericScalar']['input'];
  title: Scalars['String']['input'];
};


export type MutationsRateInsightsAnalystAnswerArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['String']['input'];
};


export type MutationsReactivateScpArgs = {
  propertyGroupId: Scalars['ID']['input'];
};


export type MutationsReceivePurchaseOrderArgs = {
  condition?: InputMaybe<Scalars['String']['input']>;
  lines: Array<PurchaseOrderReceiptLineInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationsReceiveSparePartsArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  sparePartId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type MutationsReceiveStockArgs = {
  condition?: InputMaybe<Scalars['String']['input']>;
  containerTypeId: Scalars['ID']['input'];
  identities?: InputMaybe<Array<InputMaybe<ReceiveIdentityInput>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type MutationsRecordAutopilotEstateSimulationsArgs = {
  flowIds: Array<Scalars['ID']['input']>;
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsRecordAutopilotSimulationArgs = {
  flowId: Scalars['ID']['input'];
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsRecordCompostingInspectionArgs = {
  id: Scalars['ID']['input'];
  inspectionDate: Scalars['Date']['input'];
  inspectionNotes?: InputMaybe<Scalars['String']['input']>;
  inspectionResult: Scalars['String']['input'];
};


export type MutationsRecordContainerMaintenanceArgs = {
  containerId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  maintenanceType?: InputMaybe<Scalars['String']['input']>;
  nextDue?: InputMaybe<Scalars['Date']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  performedAt?: InputMaybe<Scalars['Date']['input']>;
  performedBy?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsRecordKeyPickupArgs = {
  keyId: Scalars['ID']['input'];
};


export type MutationsRecordPurchaseInvoiceArgs = {
  haulerId: Scalars['ID']['input'];
  month: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  totalCents: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type MutationsRecordScpNotificationFilingArgs = {
  authorityReference?: InputMaybe<Scalars['String']['input']>;
  filedDate: Scalars['Date']['input'];
  kind: ScpNotificationKind;
  note?: InputMaybe<Scalars['String']['input']>;
  scpId: Scalars['ID']['input'];
};


export type MutationsRecordSkipWeightArgs = {
  input: RecordSkipWeightInput;
};


export type MutationsRedateHolidayImpactRowArgs = {
  id: Scalars['ID']['input'];
  newDate: Scalars['Date']['input'];
};


export type MutationsRefreshTokenArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsRegisterFcmDeviceArgs = {
  input: RegisterFcmDeviceInput;
};


export type MutationsRegisterHaulerLineCompletedCountArgs = {
  count: Scalars['Decimal']['input'];
  lineId: Scalars['ID']['input'];
};


export type MutationsRegisterHaulerLineWeightArgs = {
  lineId: Scalars['ID']['input'];
  weight: Scalars['Decimal']['input'];
};


export type MutationsRegisterInvoicePaymentArgs = {
  amount: Scalars['Decimal']['input'];
  companyId: Scalars['ID']['input'];
  invoiceId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  paidAt?: InputMaybe<Scalars['Date']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsReincludeAreaAgreementArgs = {
  areaId: Scalars['ID']['input'];
  attach?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['String']['input'];
};


export type MutationsRejectCustomerRequestArgs = {
  reason: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};


export type MutationsRejectTicketBatchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsReleaseRecordLeaseArgs = {
  leaseId: Scalars['String']['input'];
};


export type MutationsRemoveAssociatedTicketsFromCompanyEmailAccountMessageArgs = {
  selfId: Scalars['ID']['input'];
  ticketIds: Array<Scalars['ID']['input']>;
};


export type MutationsRemoveCompanyHolidayDayArgs = {
  rowId: Scalars['ID']['input'];
};


export type MutationsRemoveCustomerFunctionFromContactArgs = {
  contactId: Scalars['ID']['input'];
  customerFunctionId: Scalars['ID']['input'];
};


export type MutationsRemoveReliabilityExclusionArgs = {
  pickupOrderId: Scalars['ID']['input'];
};


export type MutationsRemoveRouteSchemeWarehouseLinkArgs = {
  routeSchemeId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type MutationsRemoveSettlementAdjustmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsReopenSettlementPeriodArgs = {
  areaId: Scalars['ID']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type MutationsReopenTransferDocumentArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationsReplaceKeyArgs = {
  keyId: Scalars['ID']['input'];
  newKeyId: Scalars['String']['input'];
};


export type MutationsReplyToCompanyPortalConversationArgs = {
  body: Scalars['String']['input'];
  conversationId: Scalars['ID']['input'];
};


export type MutationsReplyToCustomerRequestArgs = {
  message: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};


export type MutationsReplyToHaulerPortalConversationArgs = {
  body: Scalars['String']['input'];
  conversationId: Scalars['ID']['input'];
};


export type MutationsReportKeyLostArgs = {
  keyId: Scalars['ID']['input'];
};


export type MutationsReportRelocationArgs = {
  input: ReportRelocationInput;
};


export type MutationsRequestRelaxationProbeArgs = {
  planId: Scalars['ID']['input'];
  relax: Scalars['String']['input'];
};


export type MutationsResendInvitationArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationsResendMfaCodeArgs = {
  challengeId: Scalars['String']['input'];
};


export type MutationsResetFeatureConfigDriftArgs = {
  companyId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
};


export type MutationsResolveExternalCollectionEventArgs = {
  containerId?: InputMaybe<Scalars['ID']['input']>;
  eventId: Scalars['ID']['input'];
  rejectReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsResolveImportIssueArgs = {
  action: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationsRestoreBuilderDashboardAsStaffArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsRestoreInsightsBuilderDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsRestoreInsightsBuilderDashboardVersionArgs = {
  expectedUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
};


export type MutationsResubmitTransferDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsRetireBrainRuleArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsRetireInsightsVerifiedQueryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsRetractInsightArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsReturnKeyArgs = {
  keyId: Scalars['ID']['input'];
};


export type MutationsReturnRentalArgs = {
  containerId: Scalars['ID']['input'];
  rentalTicketId: Scalars['ID']['input'];
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReverseSearchLocationArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};


export type MutationsRevertTemporaryContainerLocationArgs = {
  containerId: Scalars['ID']['input'];
};


export type MutationsRevokeTransferDocumentSignLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsRollbackAutopilotActionArgs = {
  actionId: Scalars['ID']['input'];
};


export type MutationsRollbackAutopilotFlowArgs = {
  flowId: Scalars['ID']['input'];
  gateKind?: InputMaybe<AutopilotActivationGateKind>;
  gateReason?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Int']['input'];
};


export type MutationsRollbackCollectionCalendarDeviationArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsRollbackPromotionArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsRouteAddCollaborationVehiclesArgs = {
  routeId: Scalars['ID']['input'];
  vehicleIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationsRouteCandidateTableToImportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsRouteChangePrimaryVehicleArgs = {
  routeVehicleId: Scalars['ID']['input'];
};


export type MutationsRouteChangePrimaryVehicleFromMobileArgs = {
  routeVehicleId: Scalars['ID']['input'];
};


export type MutationsRouteChangePrimaryVehicleGenericArgs = {
  routeVehicleId: Scalars['ID']['input'];
};


export type MutationsRouteCompleteArgs = {
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteDeleteArgs = {
  reasonCategory?: InputMaybe<Scalars['String']['input']>;
  reasonText?: InputMaybe<Scalars['String']['input']>;
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteExportArgs = {
  excelFormat: Scalars['Boolean']['input'];
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteJoinDifferentVehicleArgs = {
  routeId?: InputMaybe<Scalars['ID']['input']>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsRouteJoinSameVehicleArgs = {
  routeVehicleId: Scalars['ID']['input'];
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsRouteOptimizeArgs = {
  forceOptimize?: InputMaybe<Scalars['Boolean']['input']>;
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteReassignDriverArgs = {
  driverId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteReassignHaulerArgs = {
  haulerId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteResetArgs = {
  bypassRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  removeCreatedTickets?: InputMaybe<Scalars['Boolean']['input']>;
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteSchemeDeleteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsRouteSchemeOptimizeArgs = {
  daysInAdvance: Scalars['Int']['input'];
  selfId: Scalars['ID']['input'];
};


export type MutationsRouteSchemeOptimizeNewArgs = {
  periodEnd: Scalars['Date']['input'];
  periodStart: Scalars['Date']['input'];
  selfId: Scalars['ID']['input'];
};


export type MutationsRouteSchemePreviewArgs = {
  routeSchemeInput: RouteSchemeInput;
};


export type MutationsRouteSchemeSetUnloadingStationsArgs = {
  depotIds: Array<InputMaybe<Scalars['ID']['input']>>;
  routeSchemeId: Scalars['ID']['input'];
};


export type MutationsRouteSetUnloadingStationsArgs = {
  depotIds: Array<InputMaybe<Scalars['ID']['input']>>;
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteStartArgs = {
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteStartFromMobileArgs = {
  routeId: Scalars['ID']['input'];
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsRouteStartGenericArgs = {
  routeId: Scalars['ID']['input'];
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsRouteStopCompleteArgs = {
  abortiveNote?: InputMaybe<Scalars['String']['input']>;
  abortivePhotoId?: InputMaybe<Scalars['ID']['input']>;
  abortiveReason?: InputMaybe<AbortiveReason>;
  autoCompletedBy?: InputMaybe<Scalars['String']['input']>;
  autoConfirmReadAt?: InputMaybe<Scalars['DateTime']['input']>;
  autoConfirmReaderId?: InputMaybe<Scalars['String']['input']>;
  autoConfirmTag?: InputMaybe<Scalars['String']['input']>;
  clientOperationId?: InputMaybe<Scalars['String']['input']>;
  collectedIdentity?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completionDistanceM?: InputMaybe<Scalars['Float']['input']>;
  completionRadiusM?: InputMaybe<Scalars['Float']['input']>;
  createdTicketsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deliveredIdentity?: InputMaybe<Scalars['String']['input']>;
  displayNumber?: InputMaybe<Scalars['Int']['input']>;
  distanceVerificationNote?: InputMaybe<Scalars['String']['input']>;
  distanceVerificationReason?: InputMaybe<Scalars['String']['input']>;
  distanceVerificationTrigger?: InputMaybe<Scalars['String']['input']>;
  fillLevel?: InputMaybe<Scalars['Float']['input']>;
  gpsAccuracy?: InputMaybe<Scalars['Float']['input']>;
  gpsCapturedAt?: InputMaybe<Scalars['DateTime']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  loadedContainerIdentity?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  orderId: Scalars['String']['input'];
  qrCode?: InputMaybe<Scalars['String']['input']>;
  rfidAutoComplete?: InputMaybe<Scalars['Boolean']['input']>;
  routeId: Scalars['ID']['input'];
  skipReason?: InputMaybe<Scalars['String']['input']>;
  stopIdentity?: InputMaybe<StopIdentityInput>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
  ticketIdStopCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  transferDocument?: InputMaybe<Scalars['GenericScalar']['input']>;
  transferDocumentOverrideReason?: InputMaybe<Scalars['String']['input']>;
  waitingEndedAt?: InputMaybe<Scalars['DateTime']['input']>;
  waitingStartedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weighTicketId?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightGross?: InputMaybe<Scalars['Float']['input']>;
  weightMeasuredAt?: InputMaybe<Scalars['DateTime']['input']>;
  weightNet?: InputMaybe<Scalars['Float']['input']>;
  weightSource?: InputMaybe<Scalars['String']['input']>;
  weightSystem?: InputMaybe<Scalars['String']['input']>;
  weightTare?: InputMaybe<Scalars['Float']['input']>;
  weightTicketNumber?: InputMaybe<Scalars['String']['input']>;
  weightUnit?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsRouteStopSetNextArgs = {
  orderId: Scalars['String']['input'];
  routeId: Scalars['ID']['input'];
  useGroup?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsRouteStopSetNextDepotArgs = {
  depotId?: InputMaybe<Scalars['ID']['input']>;
  depotType: Scalars['String']['input'];
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteStopsAddArgs = {
  completeStops?: InputMaybe<Scalars['Boolean']['input']>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  routeId: Scalars['ID']['input'];
  ticketIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationsRouteStopsCompleteArgs = {
  routeId: Scalars['ID']['input'];
  stops: Array<InputMaybe<RouteStop>>;
};


export type MutationsRouteStopsMoveArgs = {
  orderIds: Array<InputMaybe<Scalars['String']['input']>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  routeId: Scalars['ID']['input'];
  toRouteId: Scalars['ID']['input'];
};


export type MutationsRouteStopsOrderArgs = {
  orderIds: Array<InputMaybe<Scalars['String']['input']>>;
  routeId: Scalars['ID']['input'];
  startStopNumber: Scalars['Int']['input'];
};


export type MutationsRouteStopsUpdateArgs = {
  bypassRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  createdTicketsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  delete: Scalars['Boolean']['input'];
  fillLevel?: InputMaybe<Scalars['Float']['input']>;
  optimize?: InputMaybe<Scalars['Boolean']['input']>;
  orderIds: Array<InputMaybe<Scalars['String']['input']>>;
  reset: Scalars['Boolean']['input'];
  resetCreatedTicket?: InputMaybe<Scalars['Boolean']['input']>;
  resetCreatedTickets?: InputMaybe<Scalars['Boolean']['input']>;
  resetWillReturn?: InputMaybe<Scalars['Boolean']['input']>;
  routeId: Scalars['ID']['input'];
  ticketId?: InputMaybe<Scalars['ID']['input']>;
  ticketIdStopCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationsRouteTakeStopsArgs = {
  orderIds: Array<InputMaybe<Scalars['String']['input']>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  routeId: Scalars['ID']['input'];
  toRouteId: Scalars['ID']['input'];
};


export type MutationsRouteUnCompleteArgs = {
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteUpdateAutoCompleteArgs = {
  autoComplete: Scalars['Boolean']['input'];
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteUpdateAutoCompleteNextStopArgs = {
  autoCompleteNextStop: Scalars['Boolean']['input'];
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteUpdateAutoOptimizeArgs = {
  autoOptimize: Scalars['Boolean']['input'];
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteUpdateContainerGroupLocationArgs = {
  containerGroupId: Scalars['ID']['input'];
  locationLatitude: Scalars['Float']['input'];
  locationLongitude: Scalars['Float']['input'];
};


export type MutationsRouteUpdateContainerLocationArgs = {
  containerId: Scalars['ID']['input'];
  locationLatitude: Scalars['Float']['input'];
  locationLongitude: Scalars['Float']['input'];
};


export type MutationsRouteUpdateEmergencyArgs = {
  exceptionReason?: InputMaybe<Scalars['String']['input']>;
  isEmergency: Scalars['Boolean']['input'];
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteUpdateLockedArgs = {
  locked: Scalars['Boolean']['input'];
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteUpdateLockedStartArgs = {
  lockedStart: Scalars['Boolean']['input'];
  routeId: Scalars['ID']['input'];
};


export type MutationsRouteUpdateRouteVehicleArgs = {
  routeId: Scalars['ID']['input'];
  routeVehicleId: Scalars['ID']['input'];
  vehicleId: Scalars['ID']['input'];
};


export type MutationsRouteUpdateRouteVehicleDriverArgs = {
  driverId: Scalars['ID']['input'];
  routeId: Scalars['ID']['input'];
  routeVehicleId: Scalars['ID']['input'];
};


export type MutationsRouteUpdateRouteVehicleGenericArgs = {
  routeId: Scalars['ID']['input'];
  routeVehicleId: Scalars['ID']['input'];
  vehicleId: Scalars['ID']['input'];
};


export type MutationsRouteUpdateRouteVehicleMobileArgs = {
  routeId: Scalars['ID']['input'];
  routeVehicleId: Scalars['ID']['input'];
  vehicleId: Scalars['ID']['input'];
};


export type MutationsRouteUpdateRouteVehicleTrailerArgs = {
  routeId: Scalars['ID']['input'];
  routeVehicleId: Scalars['ID']['input'];
  vehicleTrailerId: Scalars['ID']['input'];
};


export type MutationsRouteVehicleSessionsCompleteArgs = {
  routeVehicleSessionIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationsRouteVehicleSessionsCompleteForDriverArgs = {
  driverId: Scalars['ID']['input'];
};


export type MutationsRoutesStopsCompleteArgs = {
  stopsData: Array<InputMaybe<RoutesStopsCompleteInputType>>;
};


export type MutationsRoutesStopsMoveArgs = {
  routesAndOrders: Array<InputMaybe<RoutesStopsMoveInputType>>;
};


export type MutationsRoutesStopsUpdateArgs = {
  delete: Scalars['Boolean']['input'];
  fillLevel?: InputMaybe<Scalars['Float']['input']>;
  optimize?: InputMaybe<Scalars['Boolean']['input']>;
  reset: Scalars['Boolean']['input'];
  routes: Array<InputMaybe<RouteStopsInputType>>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationsRunAreaAutoAttachArgs = {
  areaId: Scalars['ID']['input'];
};


export type MutationsRunBillingByScheduleArgs = {
  frequencyCode?: InputMaybe<Scalars['String']['input']>;
  scheduleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationsRunFinanceFeederExportArgs = {
  from: Scalars['Date']['input'];
  includeExported?: InputMaybe<Scalars['Boolean']['input']>;
  to: Scalars['Date']['input'];
};


export type MutationsRunReportNowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsRunScenarioArgs = {
  id: Scalars['ID']['input'];
  requestedOutputs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationsRunSkipHireSetupArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  demo?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsRunSkipHireSetupStepArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  demo?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<Scalars['GenericScalar']['input']>;
  step: Scalars['String']['input'];
};


export type MutationsRunVerificationArgs = {
  caseId: Scalars['ID']['input'];
  materializationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsSatisfyNeedFromPlatformArgs = {
  caseId: Scalars['ID']['input'];
  requirement: Scalars['String']['input'];
};


export type MutationsSaveAutomationAsTemplateArgs = {
  automationId: Scalars['ID']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationsSaveCompanyMetaTypeOrderArgs = {
  entity: MetaTypeEntity;
  metaTypeIds: Array<Scalars['ID']['input']>;
};


export type MutationsSaveDashboardSubscriptionArgs = {
  attachFormat?: InputMaybe<Scalars['String']['input']>;
  cadence: Scalars['String']['input'];
  dashboardId: Scalars['ID']['input'];
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sendHour?: InputMaybe<Scalars['Int']['input']>;
  sendMinute?: InputMaybe<Scalars['Int']['input']>;
  skipIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  widgetIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationsSaveDraftGraphArgs = {
  automationId: Scalars['ID']['input'];
  edges: Array<EdgeInput>;
  expectedVersion: Scalars['Int']['input'];
  nodes: Array<NodeInput>;
};


export type MutationsSaveInsightsAnalysisArgs = {
  name: Scalars['String']['input'];
  question?: InputMaybe<Scalars['String']['input']>;
  spec: Scalars['GenericScalar']['input'];
};


export type MutationsSaveInsightsBuilderDashboardArgs = {
  audience?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rolesCanView?: InputMaybe<Array<Scalars['ID']['input']>>;
  spec?: InputMaybe<Scalars['GenericScalar']['input']>;
};


export type MutationsSaveInsightsDashboardArgs = {
  name: Scalars['String']['input'];
  sharedWithTeamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  spec: Scalars['GenericScalar']['input'];
  visibility?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSaveInsightsExplorationArgs = {
  name: Scalars['String']['input'];
  sharedWithTeamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  state: Scalars['GenericScalar']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSaveNodeLayoutArgs = {
  id: Scalars['ID']['input'];
  nodes: Array<NodeLayoutInput>;
};


export type MutationsSaveReportTemplateArgs = {
  dashboardId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  intervalDays?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  params?: InputMaybe<Scalars['GenericScalar']['input']>;
  recipients?: InputMaybe<Scalars['GenericScalar']['input']>;
  spec: Scalars['GenericScalar']['input'];
  target?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSaveSqlDatasetArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['GenericScalar']['input']>;
  sql: Scalars['String']['input'];
};


export type MutationsSaveStockThresholdsArgs = {
  thresholds: Array<StockThresholdInput>;
  warehouseId: Scalars['ID']['input'];
};


export type MutationsSaveTicketTypeOrderArgs = {
  platform?: InputMaybe<PlatformChoices>;
  routeScheme?: InputMaybe<Scalars['ID']['input']>;
  ticketTypeIds: Array<Scalars['ID']['input']>;
};


export type MutationsSaveTicketTypeOrderSettingsArgs = {
  ticketTypeCategoriseBy?: InputMaybe<TicketTypeOrderCategoriseBy>;
  ticketTypeNavAppOrderType?: InputMaybe<OrderTypeChoices>;
  ticketTypePlatformOrderType?: InputMaybe<OrderTypeChoices>;
  ticketTypePortalOrderType?: InputMaybe<OrderTypeChoices>;
};


export type MutationsSaveTransferDocumentDataArgs = {
  data: Scalars['GenericScalar']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSchedulePromotionArgs = {
  acknowledgeFleetConflicts?: InputMaybe<Scalars['Boolean']['input']>;
  cutoverDate: Scalars['Date']['input'];
  handoverDelayDays?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  routeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleMap: Scalars['GenericScalar']['input'];
};


export type MutationsScheduleSmsByPhoneArgs = {
  recipients: Array<ScheduledSmsRecipientInput>;
  scheduledAt: Scalars['String']['input'];
  senderName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSearchLocationArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  includePlaces?: InputMaybe<Scalars['Boolean']['input']>;
  search: Scalars['String']['input'];
};


export type MutationsSeedCompostingNotificationTemplateArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsSelfPasswordChangeArgs = {
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
  repeatPassword: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsSendCopilotMessageArgs = {
  conversationId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type MutationsSendDashboardEmailOnceArgs = {
  attachFormat?: InputMaybe<Scalars['String']['input']>;
  dashboardId: Scalars['ID']['input'];
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  skipIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  widgetIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationsSendDashboardSubscriptionNowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsSendMqttMessageArgs = {
  connectionType: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  strMessage?: InputMaybe<Scalars['String']['input']>;
  topic: Scalars['String']['input'];
};


export type MutationsSendSmsByAddressArgs = {
  door?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  kvhx?: InputMaybe<Scalars['String']['input']>;
  letter?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  sendToOwner?: InputMaybe<Scalars['Boolean']['input']>;
  sendToResident?: InputMaybe<Scalars['Boolean']['input']>;
  senderName?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsSendSvarutDispatchManuallyArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  ticketId: Scalars['ID']['input'];
  useCase?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSendTransferDocumentSignLinkArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  recipient?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSetAgreementSharesArgs = {
  agreementId: Scalars['ID']['input'];
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  shares?: InputMaybe<Array<AgreementShareInput>>;
  splitEvenly?: InputMaybe<Scalars['Boolean']['input']>;
  usePoolDefaults?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsSetAreaAutoAttachArgs = {
  areaId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationsSetAreaExpiryLeadTimeArgs = {
  areaId: Scalars['ID']['input'];
  months?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsSetAreaHolidayPolicyArgs = {
  areaId: Scalars['ID']['input'];
  policy?: InputMaybe<Scalars['String']['input']>;
  spreadDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsSetAreaOperatingWeekdaysArgs = {
  areaId: Scalars['ID']['input'];
  weekdays?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationsSetAutomationChannelPolicyArgs = {
  channel: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  perRecipientDailyCap?: InputMaybe<Scalars['Int']['input']>;
  quietEnd?: InputMaybe<Scalars['Time']['input']>;
  quietStart?: InputMaybe<Scalars['Time']['input']>;
};


export type MutationsSetAutomationDefaultFireCapArgs = {
  cap: Scalars['Int']['input'];
};


export type MutationsSetAutomationPolicyArgs = {
  actionKind: Scalars['String']['input'];
  approvalTtlSeconds?: InputMaybe<Scalars['Int']['input']>;
  approverTeamId?: InputMaybe<Scalars['ID']['input']>;
  mode: Scalars['String']['input'];
  reminderAfterSeconds?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsSetAutonomyLevelArgs = {
  level: Scalars['Int']['input'];
  planningAreaId: Scalars['ID']['input'];
};


export type MutationsSetBenchmarkParticipationArgs = {
  noticeAck?: InputMaybe<Scalars['Boolean']['input']>;
  optIn: Scalars['Boolean']['input'];
};


export type MutationsSetBillingScheduleArgs = {
  agreementId: Scalars['ID']['input'];
  anchor?: InputMaybe<Scalars['String']['input']>;
  frequencyCode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSetBuilderDashboardAudienceAsStaffArgs = {
  audience: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  rolesCanView?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationsSetCompanyFeatureFlagsArgs = {
  companyId: Scalars['ID']['input'];
  flags: Array<CompanyFeatureFlagInput>;
};


export type MutationsSetCompanyPortalRoleCapabilitiesArgs = {
  capabilities: Array<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};


export type MutationsSetComplaintAffectsPayArgs = {
  affectsPay?: InputMaybe<Scalars['Boolean']['input']>;
  ticketId: Scalars['ID']['input'];
};


export type MutationsSetContactAddressPrimaryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsSetContactPropertyNotificationRuleArgs = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  emailAuto?: InputMaybe<Scalars['Boolean']['input']>;
  emailDaysBefore?: InputMaybe<Scalars['Int']['input']>;
  managementCompanyId?: InputMaybe<Scalars['ID']['input']>;
  propertyId: Scalars['ID']['input'];
  smsAuto?: InputMaybe<Scalars['Boolean']['input']>;
  smsDaysBefore?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsSetContainerGroupArgs = {
  containerGroupId?: InputMaybe<Scalars['ID']['input']>;
  containerIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationsSetContainerStorageDepotArgs = {
  containerIds: Array<Scalars['ID']['input']>;
  depotId?: InputMaybe<Scalars['ID']['input']>;
  newStatus?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSetDashboardTableArgs = {
  companyId: Scalars['ID']['input'];
  exposed: Scalars['Boolean']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  relation: Scalars['String']['input'];
};


export type MutationsSetDefaultCardArgs = {
  billingInformationId: Scalars['ID']['input'];
  cardId: Scalars['String']['input'];
};


export type MutationsSetDefaultUserFilterCollectionArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsSetExceptionCompensationEffectArgs = {
  effectiveFrom: Scalars['Date']['input'];
  exceptionType: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  payEffect: Scalars['String']['input'];
  payRateFactor?: InputMaybe<Scalars['Int']['input']>;
  reliabilityEffect: Scalars['String']['input'];
};


export type MutationsSetHaulerManualMeteredQuantityArgs = {
  areaId: Scalars['ID']['input'];
  computation: Scalars['String']['input'];
  month: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type MutationsSetHaulerPriceMeteredComponentsArgs = {
  components: Array<InputMaybe<HaulerPriceMeteredComponentInput>>;
  haulerPriceId: Scalars['ID']['input'];
};


export type MutationsSetIndustryCodeActiveArgs = {
  isActive: Scalars['Boolean']['input'];
  selfId: Scalars['ID']['input'];
};


export type MutationsSetInsightsAlertTeamsArgs = {
  id: Scalars['ID']['input'];
  notifyEmail?: InputMaybe<Scalars['Boolean']['input']>;
  teamIds: Array<Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationsSetInsightsDefaultDashboardArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsSetPortalRoleCapabilitiesArgs = {
  capabilities: Array<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};


export type MutationsSetPropertiesInPropertyGroupArgs = {
  propertyGroupId: Scalars['ID']['input'];
  propertyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationsSetPropertyManagementCompanyAddressPrimaryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsSetReconciliationStatusArgs = {
  id: Scalars['ID']['input'];
  manualEntryId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
};


export type MutationsSetRouteSchemeWarehouseLinkArgs = {
  routeSchemeId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type MutationsSetStopDeviationReasonArgs = {
  pickupOrderId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSetTicketDeadlineArgs = {
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  reason: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};


export type MutationsSetTicketPriorityArgs = {
  priority: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};


export type MutationsSetTicketRouteArgs = {
  removeFromRoute?: InputMaybe<Scalars['Boolean']['input']>;
  routeId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};


export type MutationsSetTicketTypeAreaExecutionWindowArgs = {
  input: SetTicketTypeAreaExecutionWindowMutationInput;
};


export type MutationsSetWarehouseAlertRecipientsArgs = {
  userIds: Array<Scalars['ID']['input']>;
  warehouseId: Scalars['ID']['input'];
};


export type MutationsSetZoneOwnFleetArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  wasteFractionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  wholeZone?: InputMaybe<Scalars['Boolean']['input']>;
  zoneId: Scalars['ID']['input'];
};


export type MutationsSetupRouteArgs = {
  input: SetupRouteInput;
};


export type MutationsSignTransferDocumentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  onDevice?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSimulateAutomationArgs = {
  id: Scalars['ID']['input'];
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsStartCopilotConversationArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsStartHaulerRentalArgs = {
  companyId: Scalars['ID']['input'];
  containerRef?: InputMaybe<Scalars['ID']['input']>;
  placementRef: Scalars['String']['input'];
  qty?: InputMaybe<Scalars['Int']['input']>;
  service: Scalars['String']['input'];
  siteRef: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
};


export type MutationsStartManualRunArgs = {
  confirmedCount: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  subjectIds: Array<Scalars['ID']['input']>;
  subjectType: Scalars['String']['input'];
};


export type MutationsSubmitStatutoryDraftArgs = {
  authority: Scalars['String']['input'];
  draftId: Scalars['ID']['input'];
  externalReference?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSubmitValidationVerdictsArgs = {
  caseId: Scalars['ID']['input'];
  materializationId?: InputMaybe<Scalars['ID']['input']>;
  verdicts: Scalars['GenericScalar']['input'];
};


export type MutationsSubscribeInsightsDigestArgs = {
  cadence?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSubscribePropertyToScpArgs = {
  apartments?: InputMaybe<Scalars['Int']['input']>;
  consentDate?: InputMaybe<Scalars['Date']['input']>;
  consentGiven?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  disclosureRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  feeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  feeInterval?: InputMaybe<Scalars['String']['input']>;
  feeProductId?: InputMaybe<Scalars['ID']['input']>;
  intakeChannel?: InputMaybe<Scalars['String']['input']>;
  intakeRequestedBy?: InputMaybe<Scalars['String']['input']>;
  invoicingAddressId?: InputMaybe<Scalars['ID']['input']>;
  overrideUsageMixing?: InputMaybe<Scalars['Boolean']['input']>;
  ppFeeProductId?: InputMaybe<Scalars['ID']['input']>;
  propertyId: Scalars['ID']['input'];
  roleDefinitionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scpId: Scalars['ID']['input'];
  share: Scalars['Decimal']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  usageProfile?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsSuggestBrainRuleArgs = {
  interpretation: Scalars['GenericScalar']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  provenance?: InputMaybe<Scalars['GenericScalar']['input']>;
  statement: Scalars['String']['input'];
};


export type MutationsSuspendAgreementArgs = {
  agreementId: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
};


export type MutationsSwitchOffAutomationArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationsSyncCustomFieldsWithTicketTypeArgs = {
  customFields: Array<InputMaybe<CustomFieldTicketTypeInput>>;
  ticketTypeId: Scalars['ID']['input'];
};


export type MutationsSyncOfflineOperationsArgs = {
  input: SyncOfflineOperationsInput;
};


export type MutationsSyncPropertyToVismaArgs = {
  propertyId: Scalars['ID']['input'];
};


export type MutationsTakeOverRecordLeaseArgs = {
  entityId: Scalars['ID']['input'];
  entityType: RecordLeaseEntityType;
};


export type MutationsTaskReassignHaulerArgs = {
  pickupOrderId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  toRouteId: Scalars['ID']['input'];
};


export type MutationsTerminateContractAreaArgs = {
  areaId: Scalars['ID']['input'];
  carveOutDisposition?: InputMaybe<CarveOutTerminationDisposition>;
  comment: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  terminationDate: Scalars['Date']['input'];
};


export type MutationsTerminateScpArgs = {
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  endDate: Scalars['Date']['input'];
  propertyGroupId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationsTestKmdEasyFtpConnectionArgs = {
  ftpHost: Scalars['String']['input'];
  ftpPassiveMode?: InputMaybe<Scalars['Boolean']['input']>;
  ftpPassword?: InputMaybe<Scalars['String']['input']>;
  ftpPort?: InputMaybe<Scalars['Int']['input']>;
  ftpProtocol: FtpProtocolEnum;
  ftpUseTls?: InputMaybe<Scalars['Boolean']['input']>;
  ftpUsername?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsTokenAuthArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationsTransferContractAreaArgs = {
  areaId: Scalars['ID']['input'];
  cutoffDate: Scalars['Date']['input'];
  newAreaName?: InputMaybe<Scalars['String']['input']>;
  newHaulerId?: InputMaybe<Scalars['ID']['input']>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  successorAreaId?: InputMaybe<Scalars['ID']['input']>;
  zones?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationsTransferSparePartsArgs = {
  fromWarehouseId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  sparePartId: Scalars['ID']['input'];
  toWarehouseId: Scalars['ID']['input'];
};


export type MutationsTriggerExportArgs = {
  exportTemplateId: Scalars['ID']['input'];
  externalRecipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalRecipients?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationsTriggerImportArgs = {
  importAction: ImportActions;
  importFile: Scalars['String']['input'];
  importFileDelimiter?: InputMaybe<ImportCsvDelimiters>;
  importFileFormat: ImportFormats;
  importType: ImportTypes;
  project: Scalars['ID']['input'];
};


export type MutationsTriggerQuickExportArgs = {
  companyFilters?: InputMaybe<Scalars['GenericScalar']['input']>;
  contactFilters?: InputMaybe<Scalars['GenericScalar']['input']>;
  containerFilters?: InputMaybe<Scalars['GenericScalar']['input']>;
  exportType: ExportTypes;
  propertyFilters?: InputMaybe<Scalars['GenericScalar']['input']>;
  selectedIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationsTriggerSearchReindexArgs = {
  entityType?: InputMaybe<OmniSearchEntityType>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsTriggerVismaExportArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  upperDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationsUnkillAutopilotFlowArgs = {
  disableSourceRule?: InputMaybe<Scalars['Boolean']['input']>;
  flowId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationsUnlinkContactFromPropertyArgs = {
  contactPropertyId: Scalars['ID']['input'];
};


export type MutationsUnlinkContactFromPropertyManagementCompanyArgs = {
  contactId: Scalars['ID']['input'];
  propertyManagementCompanyId: Scalars['ID']['input'];
};


export type MutationsUnlinkManagementCompanyFromPropertyArgs = {
  managementCompanyPropertyId: Scalars['ID']['input'];
};


export type MutationsUnlinkParentPropertyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsUnlinkSharedTankMemberArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationsUnpairFillLevelDeviceArgs = {
  selfId: Scalars['ID']['input'];
};


export type MutationsUnpinAccountPriceListArgs = {
  accountId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
};


export type MutationsUnsubscribePropertyFromScpArgs = {
  companyShares?: InputMaybe<Array<ScpShareInput>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  membershipId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  shares?: InputMaybe<Array<ScpShareInput>>;
};


export type MutationsUpdateActiveProjectsArgs = {
  activeProjects: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationsUpdateAgreementArgs = {
  input: UpdateAgreementInput;
};


export type MutationsUpdateArchivalRuleArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  olderThanDays?: InputMaybe<Scalars['Int']['input']>;
  retentionDays?: InputMaybe<Scalars['Int']['input']>;
  timestampField?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateAutomationMetaArgs = {
  clearDailyFireCap?: InputMaybe<Scalars['Boolean']['input']>;
  dailyFireCap?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsUpdateAutopilotAssumptionsArgs = {
  actionMinutes?: InputMaybe<Array<AutopilotActionMinutesInput>>;
  adminCostPerHour?: InputMaybe<Scalars['Float']['input']>;
  approvalTouchMinutes?: InputMaybe<Scalars['Float']['input']>;
  callMinutes?: InputMaybe<Scalars['Float']['input']>;
  contextSwitchMinutes?: InputMaybe<Scalars['Float']['input']>;
  minutesPerManualTouch?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationsUpdateAutopilotFlowDefinitionArgs = {
  definition: Scalars['JSONString']['input'];
  flowId: Scalars['ID']['input'];
};


export type MutationsUpdateBillingInformationArgs = {
  address: Scalars['String']['input'];
  address2: Scalars['String']['input'];
  city: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  country: Scalars['String']['input'];
  invoiceEmail: Scalars['String']['input'];
  invoicePhone: Scalars['String']['input'];
  name: Scalars['String']['input'];
  vatNumber: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};


export type MutationsUpdateBonusModelScopedArgs = {
  activeFrom?: InputMaybe<Scalars['Date']['input']>;
  activeTo?: InputMaybe<Scalars['Date']['input']>;
  areaId?: InputMaybe<Scalars['ID']['input']>;
  basis?: InputMaybe<Scalars['String']['input']>;
  coefficientA?: InputMaybe<Scalars['Float']['input']>;
  coefficientB?: InputMaybe<Scalars['Float']['input']>;
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  maxAdjustmentPct?: InputMaybe<Scalars['Float']['input']>;
  meteredComponentId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reliabilityTargetPct?: InputMaybe<Scalars['Float']['input']>;
  structure?: InputMaybe<Scalars['String']['input']>;
  taskType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateBulkWastePickupTicketArgs = {
  input: UpdateBulkWastePickupTicketInput;
};


export type MutationsUpdateCompanySearchSettingsArgs = {
  enabledEntityTypes: Array<OmniSearchEntityType>;
};


export type MutationsUpdateComparisonSettingsArgs = {
  input: UpdateComparisonSettingsMutationInput;
};


export type MutationsUpdateCompostingNotificationTemplateArgs = {
  authorityName?: InputMaybe<Scalars['String']['input']>;
  authorityReturnAddress?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  legalReferences?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateCompostingRegistryEntryArgs = {
  apartmentDesignation?: InputMaybe<Scalars['String']['input']>;
  apartmentIdentifier?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  endReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  sizeLitres?: InputMaybe<Scalars['Int']['input']>;
  usageMonths?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationsUpdateContactArgs = {
  id: Scalars['ID']['input'];
  input: UpdateContactInput;
};


export type MutationsUpdateContactAddressArgs = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressType?: InputMaybe<Scalars['String']['input']>;
  coName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateContactAuthorizationArgs = {
  input: UpdateContactAuthorizationInput;
};


export type MutationsUpdateContactCommsChannelsArgs = {
  channels?: InputMaybe<Array<CommsChannelInput>>;
  id: Scalars['ID']['input'];
  primaryChannel?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateContactFieldConfigurationArgs = {
  customLabel?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  fieldGroup?: InputMaybe<Scalars['String']['input']>;
  fieldName: Scalars['String']['input'];
  isRequired: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
};


export type MutationsUpdateContactPropertyArgs = {
  contactPropertyId: Scalars['ID']['input'];
  externalPropertyContactId: Scalars['String']['input'];
};


export type MutationsUpdateContainerArgs = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  containerId: Scalars['String']['input'];
  containerTypeId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  deviceToContainers?: InputMaybe<Array<InputMaybe<DeviceToContainerInputObject>>>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  overflowingSettings?: InputMaybe<OverflowingSettingsObject>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  pickupSettingsId?: InputMaybe<Scalars['ID']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  selfId: Scalars['ID']['input'];
  showOnRoute?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  wasteCollectorId?: InputMaybe<Scalars['ID']['input']>;
  wasteFractionId: Scalars['ID']['input'];
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationsUpdateContainerMobileArgs = {
  containerId: Scalars['String']['input'];
  containerTypeId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  deviceToContainers?: InputMaybe<Scalars['JSONString']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  photo?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  selfId: Scalars['ID']['input'];
  showOnRoute?: InputMaybe<Scalars['Boolean']['input']>;
  wasteCollectorId?: InputMaybe<Scalars['ID']['input']>;
  wasteFractionId: Scalars['ID']['input'];
};


export type MutationsUpdateContainerNotificationArgs = {
  daysBefore?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  selfId: Scalars['ID']['input'];
};


export type MutationsUpdateContainerPriceArgs = {
  input: UpdateContainerPriceInput;
};


export type MutationsUpdateContainerTypeArgs = {
  colour?: InputMaybe<Scalars['String']['input']>;
  containerAccess?: InputMaybe<Scalars['String']['input']>;
  diameter?: InputMaybe<Scalars['Float']['input']>;
  emplacement: Scalars['String']['input'];
  emptyingTime?: InputMaybe<Scalars['Int']['input']>;
  height: Scalars['Float']['input'];
  isCylindrical?: InputMaybe<Scalars['Boolean']['input']>;
  isRentable?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  lidType?: InputMaybe<Scalars['String']['input']>;
  lifecycleStatus?: InputMaybe<Scalars['String']['input']>;
  loadUnitType?: InputMaybe<Scalars['String']['input']>;
  loadingMethod?: InputMaybe<Scalars['String']['input']>;
  maxPayloadKg?: InputMaybe<Scalars['Int']['input']>;
  metaData?: InputMaybe<Scalars['JSONString']['input']>;
  mobility?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  overflowingSettings?: InputMaybe<OverflowingSettingsObject>;
  photo?: InputMaybe<Scalars['String']['input']>;
  pickupSettingsId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  selfId: Scalars['ID']['input'];
  vehicleCoupling?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume: Scalars['Float']['input'];
  warrantyMonths?: InputMaybe<Scalars['Int']['input']>;
  wasteTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  width?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationsUpdateCostModelArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  disposalPerTon?: InputMaybe<Scalars['GenericScalar']['input']>;
  fixedPerVehicleYear?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  perHour?: InputMaybe<Scalars['Decimal']['input']>;
  perKm?: InputMaybe<Scalars['Decimal']['input']>;
  perLift?: InputMaybe<Scalars['Decimal']['input']>;
  premiumWindows?: InputMaybe<Scalars['GenericScalar']['input']>;
};


export type MutationsUpdateCostSettingsArgs = {
  input: UpdateCostSettingsMutationInput;
};


export type MutationsUpdateCurrentDriverLocationArgs = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  autoComplete?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['Float']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  placeId?: InputMaybe<Scalars['String']['input']>;
  routeId: Scalars['ID']['input'];
  speed?: InputMaybe<Scalars['Float']['input']>;
  vehicleId: Scalars['ID']['input'];
};


export type MutationsUpdateCustomerNoteArgs = {
  input: UpdateCustomerNoteInput;
};


export type MutationsUpdateGrammarClaimArgs = {
  confidence?: InputMaybe<Scalars['Float']['input']>;
  evidence?: InputMaybe<Scalars['GenericScalar']['input']>;
  id: Scalars['ID']['input'];
  payload?: InputMaybe<Scalars['GenericScalar']['input']>;
  statement?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateHaulerComplianceDocumentArgs = {
  documentTypeId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationsUpdateHaulerContactArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  legalAddress?: InputMaybe<Scalars['String']['input']>;
  mainContact?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateHaulerPriceListArgs = {
  companyId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  priceListId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationsUpdateHaulerPriceRowArgs = {
  companyId: Scalars['ID']['input'];
  customerType?: InputMaybe<Scalars['String']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  invoiceCode?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Decimal']['input']>;
  priceListId: Scalars['ID']['input'];
  priceRowId: Scalars['ID']['input'];
  serviceResponsibilityId?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  vatRateId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsUpdateImportCaseArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateInsightsAnalysisArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  spec?: InputMaybe<Scalars['GenericScalar']['input']>;
};


export type MutationsUpdateInsightsBuilderDashboardArgs = {
  audience?: InputMaybe<Scalars['String']['input']>;
  expectedUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  rolesCanView?: InputMaybe<Array<Scalars['ID']['input']>>;
  spec?: InputMaybe<Scalars['GenericScalar']['input']>;
};


export type MutationsUpdateInsightsDashboardArgs = {
  expectedUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sharedWithTeamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  spec?: InputMaybe<Scalars['GenericScalar']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateKmdEasyAutoExportSettingsArgs = {
  autoExportGenerationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoGenerateFu63302cEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoGenerateFu63302cIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  autoGenerateFu63303cEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoGenerateFu63303cIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsUpdateKmdEasySettingsArgs = {
  autoExportGenerationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoGenerateFu63302cEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoGenerateFu63302cIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  autoGenerateFu63303cEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoGenerateFu63303cIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  consumptionCode?: InputMaybe<Scalars['Int']['input']>;
  defaultPropertyType?: InputMaybe<Scalars['ID']['input']>;
  emptyingAddressIdName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  ftpCleanupExportedFilesDays?: InputMaybe<Scalars['Int']['input']>;
  ftpCleanupImportedFiles?: InputMaybe<Scalars['Boolean']['input']>;
  ftpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ftpExportDirectory?: InputMaybe<Scalars['String']['input']>;
  ftpExportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ftpHost?: InputMaybe<Scalars['String']['input']>;
  ftpImportCheckIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  ftpImportDirectory?: InputMaybe<Scalars['String']['input']>;
  ftpImportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ftpPassiveMode?: InputMaybe<Scalars['Boolean']['input']>;
  ftpPassword?: InputMaybe<Scalars['String']['input']>;
  ftpPort?: InputMaybe<Scalars['Int']['input']>;
  ftpProtocol?: InputMaybe<FtpProtocolEnum>;
  ftpUseTls?: InputMaybe<Scalars['Boolean']['input']>;
  ftpUsername?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateManageContainerTicketArgs = {
  input: UpdateManageContainerTicketInput;
};


export type MutationsUpdateManagementCompanyPropertyArgs = {
  externalPropertyContactId: Scalars['String']['input'];
  managementCompanyPropertyId: Scalars['ID']['input'];
};


export type MutationsUpdateMeasurementSettingsArgs = {
  excludeDays?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludePeriodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  excludePeriodEveryYear?: InputMaybe<Scalars['Boolean']['input']>;
  excludePeriodStart?: InputMaybe<Scalars['DateTime']['input']>;
  hours?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  measureAt?: InputMaybe<Scalars['Int']['input']>;
  measurementsPerHour?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  selfId: Scalars['ID']['input'];
};


export type MutationsUpdateNotificationSettingArgs = {
  condition: Scalars['String']['input'];
  containerId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selfId: Scalars['ID']['input'];
  threshold: Scalars['Float']['input'];
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationsUpdateOrCreateAgreementExportArgs = {
  input: UpdateOrCreateCreateAgreementExportInput;
};


export type MutationsUpdateOrCreateAgreementTemplateArgs = {
  input: UpdateOrCreateAgreementTemplateInput;
};


export type MutationsUpdateOrCreateAlertRuleArgs = {
  input: UpdateOrCreateAlertRuleInput;
};


export type MutationsUpdateOrCreateAreaArgs = {
  input: UpdateOrCreateAreaInput;
};


export type MutationsUpdateOrCreateBulkPropertyArgs = {
  data?: InputMaybe<PropertyBulkUpdateCreateData>;
  input?: InputMaybe<Array<InputMaybe<PropertyBulkUpdateCreateInput>>>;
};


export type MutationsUpdateOrCreateBulkTicketArgs = {
  data?: InputMaybe<TicketBulkUpdateCreateData>;
  input?: InputMaybe<Array<InputMaybe<TicketBulkUpdateCreateInput>>>;
};


export type MutationsUpdateOrCreateCollectionCalendarArgs = {
  input: UpdateOrCreateCollectionCalendarInput;
};


export type MutationsUpdateOrCreateCollectionCalendarDateArgs = {
  input: UpdateOrCreateCollectionCalendarDateInput;
};


export type MutationsUpdateOrCreateCollectionCalendarDeviationArgs = {
  input: UpdateOrCreateCollectionCalendarDeviationInput;
};


export type MutationsUpdateOrCreateCollectionCalendarWeekArgs = {
  input: UpdateOrCreateCollectionCalendarWeekInput;
};


export type MutationsUpdateOrCreateCommentArgs = {
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  selfId?: InputMaybe<Scalars['ID']['input']>;
  targetId: Scalars['ID']['input'];
  terms?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateOrCreateCompanyArgs = {
  input: UpdateOrCreateCompanyInput;
};


export type MutationsUpdateOrCreateCompanyContainerMetaTypeArgs = {
  companyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  selfId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsUpdateOrCreateCompanyEmailAccountArgs = {
  input: UpdateOrCreateCompanyEmailAccountInput;
};


export type MutationsUpdateOrCreateCompanyEmailAccountRuleArgs = {
  input: UpdateOrCreateCompanyEmailAccountRuleInput;
};


export type MutationsUpdateOrCreateCompanyMainSettingsArgs = {
  input: UpdateOrCreateCompanyMainSettingsInput;
};


export type MutationsUpdateOrCreateCompanyMetaTypeArgs = {
  input: UpdateOrCreateCompanyMetaTypeInput;
};


export type MutationsUpdateOrCreateCompanyRoleArgs = {
  name: Scalars['String']['input'];
  permissions: Array<PermissionChoices>;
  selfId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsUpdateOrCreateCompostingNotificationFieldArgs = {
  defaultValue?: InputMaybe<Scalars['GenericScalar']['input']>;
  helpText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inputType?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  sectionId?: InputMaybe<Scalars['ID']['input']>;
  systemBinding?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  validation?: InputMaybe<Scalars['GenericScalar']['input']>;
  valueSource?: InputMaybe<Scalars['String']['input']>;
  visibleWhen?: InputMaybe<Scalars['GenericScalar']['input']>;
};


export type MutationsUpdateOrCreateCompostingNotificationFieldOptionArgs = {
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  requiresSpecification?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsUpdateOrCreateCompostingNotificationSectionArgs = {
  helpText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  visibleWhen?: InputMaybe<Scalars['GenericScalar']['input']>;
};


export type MutationsUpdateOrCreateContactArgs = {
  input: UpdateOrCreateContactInput;
};


export type MutationsUpdateOrCreateContainerArgs = {
  allowedHoursEnd?: InputMaybe<Scalars['String']['input']>;
  allowedHoursStart?: InputMaybe<Scalars['String']['input']>;
  containerId: Scalars['String']['input'];
  containerMetaValues?: InputMaybe<Array<InputMaybe<ContainerMetaValueInputObject>>>;
  containerTypeId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  devicesToContainer?: InputMaybe<Array<InputMaybe<SensorInputObject>>>;
  locationLatitude: Scalars['Float']['input'];
  locationLongitude: Scalars['Float']['input'];
  locationName: Scalars['String']['input'];
  overflowingSettings?: InputMaybe<OverflowingSettingsObject>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  pickupMethod: Scalars['String']['input'];
  pickupSettingId?: InputMaybe<Scalars['ID']['input']>;
  prioritizeInStartOfRoute?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
  selfId?: InputMaybe<Scalars['ID']['input']>;
  sensorFillLevel?: InputMaybe<Scalars['Int']['input']>;
  sensorFillLevelPeriodHours?: InputMaybe<Scalars['Int']['input']>;
  showOnRoute?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  wasteCollectorId?: InputMaybe<Scalars['ID']['input']>;
  wasteFractionId: Scalars['ID']['input'];
};


export type MutationsUpdateOrCreateContainerBulkArgs = {
  data?: InputMaybe<UpdateOrCreateBulkContainerData>;
  input?: InputMaybe<Array<InputMaybe<UpdateOrCreateBulkContainerInput>>>;
};


export type MutationsUpdateOrCreateContainerGroupArgs = {
  input: UpdateOrCreateContainerGroupInput;
};


export type MutationsUpdateOrCreateContainerNewArgs = {
  input: UpdateOrCreateContainerNewInput;
};


export type MutationsUpdateOrCreateContainerProductArgs = {
  input: UpdateOrCreateContainerProductInput;
};


export type MutationsUpdateOrCreateContainerTypeArgs = {
  input: UpdateOrCreateContainerTypeInput;
};


export type MutationsUpdateOrCreateCriiptoApplicationArgs = {
  input: UpdateOrCreateCreateCriiptoApplicationInput;
};


export type MutationsUpdateOrCreateCustomerFunctionArgs = {
  input: UpdateOrCreateCustomerFunctionInput;
};


export type MutationsUpdateOrCreateDashboardArgs = {
  input: UpdateOrCreateDashboardInput;
};


export type MutationsUpdateOrCreateDepotArgs = {
  closingTime?: InputMaybe<Scalars['Time']['input']>;
  coOwners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  color?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  contactPerson?: InputMaybe<ContactPersonInputObject>;
  contractors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  depotType: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  geofenceRadius?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationInput>;
  locationLatitude?: InputMaybe<Scalars['Float']['input']>;
  locationLongitude?: InputMaybe<Scalars['Float']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  openingTime?: InputMaybe<Scalars['Time']['input']>;
  ownedBy?: InputMaybe<Scalars['ID']['input']>;
  removeLogo?: InputMaybe<Scalars['Boolean']['input']>;
  selfId?: InputMaybe<Scalars['ID']['input']>;
  timeToLeaveTheFacility?: InputMaybe<Scalars['Time']['input']>;
  timeToUnloadTruck?: InputMaybe<Scalars['Time']['input']>;
  wasteFractions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationsUpdateOrCreateDocumentArgs = {
  input: UpdateOrCreateCreateDocumentInput;
};


export type MutationsUpdateOrCreateDriverArgs = {
  input: UpdateOrCreateDriverInput;
};


export type MutationsUpdateOrCreateExternalMapLayerArgs = {
  input: UpdateOrCreateExternalMapLayerInput;
};


export type MutationsUpdateOrCreateHaulerArgs = {
  input: UpdateOrCreateHaulerInput;
};


export type MutationsUpdateOrCreateHaulerPriceArgs = {
  input: UpdateOrCreateHaulerPriceInput;
};


export type MutationsUpdateOrCreateIntegrationGpsArgs = {
  active: Scalars['Boolean']['input'];
  companyId: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  selfId?: InputMaybe<Scalars['ID']['input']>;
  username: Scalars['String']['input'];
};


export type MutationsUpdateOrCreateIntegrationGpsVehicleArgs = {
  integrationId: Scalars['ID']['input'];
  selfId?: InputMaybe<Scalars['ID']['input']>;
  uniqueId: Scalars['String']['input'];
  vehicleId: Scalars['ID']['input'];
};


export type MutationsUpdateOrCreateKmdEasyPropertyTypeToKmdEasyStationCodeArgs = {
  input: UpdateOrCreateKmdEasyPropertyTypeToKmdEasyStationCodeInput;
};


export type MutationsUpdateOrCreateMeasurementSettingsArgs = {
  input: UpdateOrCreateMeasurementSettingsInput;
};


export type MutationsUpdateOrCreateMunicipalityArgs = {
  input: UpdateOrCreateMunicipalityInput;
};


export type MutationsUpdateOrCreatePickupOrderApprovalCollectionArgs = {
  input: UpdateOrCreatePickUpOrderApprovalCollectionInput;
};


export type MutationsUpdateOrCreatePickupSettingsArgs = {
  input: UpdateOrCreatePickupSettingsInput;
};


export type MutationsUpdateOrCreateProjectArgs = {
  input: UpdateOrCreateProjectInput;
};


export type MutationsUpdateOrCreateProjectSettingsArgs = {
  input: UpdateOrCreateProjectSettingsInput;
};


export type MutationsUpdateOrCreatePropertyArgs = {
  input: UpdateOrCreatePropertyInput;
};


export type MutationsUpdateOrCreatePropertyContactArgs = {
  input: UpdateOrCreatePropertyContactInput;
};


export type MutationsUpdateOrCreatePropertyGroupArgs = {
  input: UpdateOrCreatePropertyGroupInput;
};


export type MutationsUpdateOrCreatePropertyManagementCompanyArgs = {
  input: UpdateOrCreatePropertyManagementCompanyInput;
};


export type MutationsUpdateOrCreatePropertyTypeArgs = {
  input: UpdateOrCreatePropertyTypeInput;
};


export type MutationsUpdateOrCreatePropertyUserArgs = {
  input: UpdateOrCreatePropertyUserInput;
};


export type MutationsUpdateOrCreateRecurringProductArgs = {
  input: UpdateOrCreateRecurringProductInput;
};


export type MutationsUpdateOrCreateRouteSchemeArgs = {
  input: UpdateOrCreateRouteSchemeInput;
};


export type MutationsUpdateOrCreateScheduledExportArgs = {
  input: UpdateOrCreateCreateScheduledExportInput;
};


export type MutationsUpdateOrCreateScpProfileArgs = {
  input: UpdateOrCreateScpProfileInput;
};


export type MutationsUpdateOrCreateServiceArgs = {
  input: UpdateOrCreateServiceInput;
};


export type MutationsUpdateOrCreateServiceProductArgs = {
  input: UpdateOrCreateServiceProductInput;
};


export type MutationsUpdateOrCreateServiceResponsibilityArgs = {
  legalClass?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  selfId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsUpdateOrCreateSkillArgs = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  selfId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsUpdateOrCreateSubscriptionQuoteArgs = {
  billingInformationId: Scalars['ID']['input'];
  features: Array<InputMaybe<BillingSubscriptionQuoteFeatureInput>>;
  storeType: Scalars['String']['input'];
  stripeId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateOrCreateTeamArgs = {
  input: UpdateOrCreateTeamInput;
};


export type MutationsUpdateOrCreateTicketCategoryArgs = {
  input: UpdateOrCreateTicketCategoryInput;
};


export type MutationsUpdateOrCreateTicketMessageTemplateArgs = {
  input: UpdateOrCreateTicketMessageTemplateInput;
};


export type MutationsUpdateOrCreateTicketTypeArgs = {
  input: UpdateOrCreateTicketTypeInput;
};


export type MutationsUpdateOrCreateUserAbsenceArgs = {
  absenceType: Scalars['String']['input'];
  end: Scalars['Date']['input'];
  projectId: Scalars['ID']['input'];
  replacementUserId: Scalars['String']['input'];
  selfId?: InputMaybe<Scalars['ID']['input']>;
  start: Scalars['Date']['input'];
  userId: Scalars['String']['input'];
};


export type MutationsUpdateOrCreateUserFilterCollectionArgs = {
  filters: Scalars['JSONString']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  selfId?: InputMaybe<Scalars['ID']['input']>;
  tableKey: Scalars['String']['input'];
};


export type MutationsUpdateOrCreateUserProjectArgs = {
  input: UpdateOrCreateUserProjectInput;
};


export type MutationsUpdateOrCreateVehicleArgs = {
  input: UpdateOrCreateVehicleInput;
};


export type MutationsUpdateOrCreateVehicleAbsenceArgs = {
  absenceType: Scalars['String']['input'];
  end: Scalars['Date']['input'];
  projectId: Scalars['ID']['input'];
  replacementVehicleId: Scalars['String']['input'];
  selfId?: InputMaybe<Scalars['ID']['input']>;
  start: Scalars['Date']['input'];
  vehicleId: Scalars['String']['input'];
};


export type MutationsUpdateOrCreateVehicleTypeArgs = {
  input: UpdateOrCreateVehicleTypeInput;
};


export type MutationsUpdateOrCreateWasteFractionArgs = {
  adsFractionCode?: InputMaybe<Scalars['String']['input']>;
  emptyingIntervalMax?: InputMaybe<Scalars['Int']['input']>;
  emptyingIntervalMin?: InputMaybe<Scalars['Int']['input']>;
  energyRecovery?: InputMaybe<Scalars['Decimal']['input']>;
  ewcCode?: InputMaybe<Scalars['String']['input']>;
  hazardous?: InputMaybe<Scalars['Boolean']['input']>;
  materialRecovery?: InputMaybe<Scalars['Decimal']['input']>;
  mustIncludeVat?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  rdCode?: InputMaybe<Scalars['String']['input']>;
  recyclable?: InputMaybe<Scalars['Boolean']['input']>;
  recyclingPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  selfId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Status>;
  treatmentLocation?: InputMaybe<Scalars['String']['input']>;
  treatmentMethod?: InputMaybe<Scalars['String']['input']>;
  wasteCategory: Scalars['String']['input'];
  wasteSubstance: Scalars['String']['input'];
  wasteType?: InputMaybe<Scalars['String']['input']>;
  weightFactor?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationsUpdateOrCreateWasteFractionNewArgs = {
  input: UpdateOrCreateWasteFractionNewInput;
};


export type MutationsUpdateOrCreateZoneArgs = {
  input: UpdateOrCreateZoneInput;
};


export type MutationsUpdateOrCreateZoneLabelArgs = {
  input: UpdateOrCreateZoneLabelInput;
};


export type MutationsUpdatePermitArgs = {
  alertDays?: InputMaybe<Scalars['Int']['input']>;
  authorityEntryId?: InputMaybe<Scalars['ID']['input']>;
  authorityName?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  feeProductId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PermitStatus>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationsUpdatePlanningAreaArgs = {
  costModelId?: InputMaybe<Scalars['ID']['input']>;
  cycleWeeks?: InputMaybe<Scalars['Int']['input']>;
  holidayCalendar?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parityAnchorDate?: InputMaybe<Scalars['Date']['input']>;
  regionName?: InputMaybe<Scalars['String']['input']>;
  regionPack?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdatePriceArgs = {
  input: UpdatePriceInput;
};


export type MutationsUpdatePropertyManagementCompanyAddressArgs = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressType?: InputMaybe<Scalars['String']['input']>;
  coName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdatePropertyNoteArgs = {
  input: UpdatePropertyNoteInput;
};


export type MutationsUpdatePropertyNoteAttachmentsArgs = {
  input: UpdatePropertyNoteAttachmentsInput;
};


export type MutationsUpdateRecurringPriceArgs = {
  input: UpdateRecurringPriceInput;
};


export type MutationsUpdateReliabilityExclusionWindowArgs = {
  allAreas?: InputMaybe<Scalars['Boolean']['input']>;
  areaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateScenarioArgs = {
  constraintOverrides?: InputMaybe<Scalars['GenericScalar']['input']>;
  demandModel?: InputMaybe<Scalars['String']['input']>;
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  fleet?: InputMaybe<Scalars['GenericScalar']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<Scalars['GenericScalar']['input']>;
  objectiveProfile?: InputMaybe<Scalars['String']['input']>;
  parameterSetId?: InputMaybe<Scalars['ID']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  serviceCatalogOverrides?: InputMaybe<Scalars['GenericScalar']['input']>;
  stopSetId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsUpdateScpMembershipArgs = {
  apartments?: InputMaybe<Scalars['Int']['input']>;
  clearContact?: InputMaybe<Scalars['Boolean']['input']>;
  clearInvoicingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  consentDate?: InputMaybe<Scalars['Date']['input']>;
  consentGiven?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  disclosureRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  intakeChannel?: InputMaybe<Scalars['String']['input']>;
  intakeRequestedBy?: InputMaybe<Scalars['String']['input']>;
  invoicingAddressId?: InputMaybe<Scalars['ID']['input']>;
  membershipId: Scalars['ID']['input'];
  overrideUsageMixing?: InputMaybe<Scalars['Boolean']['input']>;
  roleDefinitionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  usageProfile?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateScpSharesArgs = {
  companyShares?: InputMaybe<Array<ScpShareInput>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  scpId: Scalars['ID']['input'];
  shares: Array<ScpShareInput>;
};


export type MutationsUpdateServicePriceArgs = {
  input: UpdateServicePriceInput;
};


export type MutationsUpdateShippingInformationArgs = {
  companyId: Scalars['ID']['input'];
  shippingAddress: Scalars['String']['input'];
  shippingAddress2: Scalars['String']['input'];
  shippingCity: Scalars['String']['input'];
  shippingCountry: Scalars['String']['input'];
  shippingName: Scalars['String']['input'];
  shippingZipCode: Scalars['String']['input'];
};


export type MutationsUpdateSiirtoCompanySettingsArgs = {
  carrierBusinessId?: InputMaybe<Scalars['String']['input']>;
  carrierContactEmail?: InputMaybe<Scalars['String']['input']>;
  carrierContactName?: InputMaybe<Scalars['String']['input']>;
  carrierContactPhone?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationsUpdateSparePartArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  fitsContainerTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name: Scalars['String']['input'];
  partTypeId: Scalars['ID']['input'];
  selfId: Scalars['ID']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateTicketArgs = {
  input: UpdateTicketInput;
};


export type MutationsUpdateTicketAttachmentsArgs = {
  addAttachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  ignoreServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  removeAttachmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationsUpdateTicketCustomFieldArgs = {
  input: UpdateTicketCustomFieldMutationInput;
};


export type MutationsUpdateTicketDraftArgs = {
  input: UpdateTicketDraftInput;
};


export type MutationsUpdateTicketFollowersArgs = {
  followerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ticketId: Scalars['ID']['input'];
};


export type MutationsUpdateTicketStatusArgs = {
  barcodeSkipReason?: InputMaybe<Scalars['String']['input']>;
  bypassRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  containerLatitude?: InputMaybe<Scalars['Float']['input']>;
  containerLongitude?: InputMaybe<Scalars['Float']['input']>;
  rfid?: InputMaybe<Scalars['String']['input']>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
  status: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};


export type MutationsUpdateTicketTypeOrderArgs = {
  insertAfterTicketTypeId?: InputMaybe<Scalars['ID']['input']>;
  ticketTypeId: Scalars['ID']['input'];
};


export type MutationsUpdateTicketTypePortalCopyArgs = {
  portalConfirmSubtitle?: InputMaybe<Scalars['String']['input']>;
  portalConfirmTitle?: InputMaybe<Scalars['String']['input']>;
  portalContactInformationNextButtonLabel?: InputMaybe<Scalars['String']['input']>;
  portalDateHelpText?: InputMaybe<Scalars['String']['input']>;
  portalDateLabel?: InputMaybe<Scalars['String']['input']>;
  portalDescription?: InputMaybe<Scalars['String']['input']>;
  portalDropdownHelpText?: InputMaybe<Scalars['String']['input']>;
  portalDropdownLabel?: InputMaybe<Scalars['String']['input']>;
  portalNoteHelpText?: InputMaybe<Scalars['String']['input']>;
  portalNoteLabel?: InputMaybe<Scalars['String']['input']>;
  portalServiceTypeBulkWasteLimitHelpText?: InputMaybe<Scalars['String']['input']>;
  portalServiceTypeBulkWasteLimitLabel?: InputMaybe<Scalars['String']['input']>;
  ticketTypeId: Scalars['ID']['input'];
};


export type MutationsUpdateTicketTypePortalIntakeArgs = {
  bulkWasteLimit?: InputMaybe<Scalars['Int']['input']>;
  bulkWasteMaxDays?: InputMaybe<Scalars['Int']['input']>;
  bulkWasteMinDays?: InputMaybe<Scalars['Int']['input']>;
  portalContactInformationEmailRequired?: InputMaybe<Scalars['Boolean']['input']>;
  portalContactInformationNameRequired?: InputMaybe<Scalars['Boolean']['input']>;
  portalContactInformationPhoneNumberRequired?: InputMaybe<Scalars['Boolean']['input']>;
  portalDateRequired?: InputMaybe<Scalars['Boolean']['input']>;
  portalDropdownOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  portalDropdownRequired?: InputMaybe<Scalars['Boolean']['input']>;
  portalNoteRequired?: InputMaybe<Scalars['Boolean']['input']>;
  portalPriceShowZero?: InputMaybe<Scalars['Boolean']['input']>;
  portalRequireContactInformation?: InputMaybe<Scalars['Boolean']['input']>;
  showPortalDate?: InputMaybe<Scalars['Boolean']['input']>;
  showPortalDropdown?: InputMaybe<Scalars['Boolean']['input']>;
  showPortalNote?: InputMaybe<Scalars['Boolean']['input']>;
  ticketTypeId: Scalars['ID']['input'];
};


export type MutationsUpdateTicketTypeRequirementsArgs = {
  containerGates?: InputMaybe<TicketTypeContainerGatesInput>;
  fromStatus?: InputMaybe<Scalars['Int']['input']>;
  scheduleManual?: InputMaybe<Scalars['Boolean']['input']>;
  ticketTypeId: Scalars['ID']['input'];
  toStatus: Scalars['Int']['input'];
};


export type MutationsUpdateTicketTypeSurfacesArgs = {
  enableOnNavigationApp?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnPortal?: InputMaybe<Scalars['Boolean']['input']>;
  navigationAppRequireAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  ticketTypeId: Scalars['ID']['input'];
};


export type MutationsUpdateTicketTypeTransitionRolesArgs = {
  fromStatus?: InputMaybe<Scalars['Int']['input']>;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ticketTypeId: Scalars['ID']['input'];
  toStatus: Scalars['Int']['input'];
};


export type MutationsUpdateTicketVisibilityArgs = {
  ticketId: Scalars['ID']['input'];
  visibilityHaulerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  visibilityScope: Scalars['String']['input'];
  visibilityTeamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  visibilityUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationsUpdateUnconfirmedUserArgs = {
  createUser?: InputMaybe<Scalars['Boolean']['input']>;
  selfId: Scalars['ID']['input'];
};


export type MutationsUpdateUserArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  datetimeFormatLocale?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  isMaster?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  selfId: Scalars['ID']['input'];
  themePreference?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateUserCompanyRolesArgs = {
  roleIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationsUpdateUserContactsArgs = {
  contacts: Array<ContactEntryInput>;
  selfId: Scalars['ID']['input'];
};


export type MutationsUpdateUserLayoutConfigArgs = {
  collectionContainersDisabledColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  collectionContainersOrder?: InputMaybe<Scalars['String']['input']>;
  collectionContainersOrderBy?: InputMaybe<Scalars['String']['input']>;
  collectionContainersPageSize?: InputMaybe<Scalars['String']['input']>;
  commentsDisabledColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  commentsOrder?: InputMaybe<Scalars['String']['input']>;
  commentsOrderBy?: InputMaybe<Scalars['String']['input']>;
  commentsPageSize?: InputMaybe<Scalars['Int']['input']>;
  containersDisabledColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  containersOrder?: InputMaybe<Scalars['String']['input']>;
  containersOrderBy?: InputMaybe<Scalars['String']['input']>;
  containersPageSize?: InputMaybe<Scalars['Int']['input']>;
  driverDisabledColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverIconsSize?: InputMaybe<Scalars['String']['input']>;
  driverOrder?: InputMaybe<Scalars['String']['input']>;
  driverOrderBy?: InputMaybe<Scalars['String']['input']>;
  driverPageSize?: InputMaybe<Scalars['Int']['input']>;
  inquiryDisabledColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inquiryOrder?: InputMaybe<Scalars['String']['input']>;
  inquiryOrderBy?: InputMaybe<Scalars['String']['input']>;
  inquiryPageSize?: InputMaybe<Scalars['Int']['input']>;
  locationsDisabledColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationsIconsSize?: InputMaybe<Scalars['String']['input']>;
  locationsOrder?: InputMaybe<Scalars['String']['input']>;
  locationsOrderBy?: InputMaybe<Scalars['String']['input']>;
  locationsPageSize?: InputMaybe<Scalars['Int']['input']>;
  notificationsDisabledColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notificationsOrder?: InputMaybe<Scalars['String']['input']>;
  notificationsOrderBy?: InputMaybe<Scalars['String']['input']>;
  notificationsPageSize?: InputMaybe<Scalars['Int']['input']>;
  pickupOrdersDisabledColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pickupOrdersOrder?: InputMaybe<Scalars['String']['input']>;
  pickupOrdersOrderBy?: InputMaybe<Scalars['String']['input']>;
  pickupOrdersPageSize?: InputMaybe<Scalars['Int']['input']>;
  routeDisabledColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  routeOrder?: InputMaybe<Scalars['String']['input']>;
  routeOrderBy?: InputMaybe<Scalars['String']['input']>;
  routePageSize?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
  vehicleDisabledColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIconsSize?: InputMaybe<Scalars['String']['input']>;
  vehicleOrder?: InputMaybe<Scalars['String']['input']>;
  vehicleOrderBy?: InputMaybe<Scalars['String']['input']>;
  vehiclePageSize?: InputMaybe<Scalars['Int']['input']>;
  vehicleTypesDisabledColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleTypesOrder?: InputMaybe<Scalars['String']['input']>;
  vehicleTypesOrderBy?: InputMaybe<Scalars['String']['input']>;
  vehicleTypesPageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsUpdateUserThemePreferenceArgs = {
  themePreference: Scalars['String']['input'];
};


export type MutationsUpdateUsernameArgs = {
  email: Scalars['String']['input'];
  selfId: Scalars['ID']['input'];
};


export type MutationsUpdateVismaCompanySettingsArgs = {
  pricesIncludeVat?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsUpdateWasteCollectorArgs = {
  companyName: Scalars['String']['input'];
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  selfId: Scalars['ID']['input'];
};


export type MutationsUpdateWasteFractionArgs = {
  adsFractionCode?: InputMaybe<Scalars['String']['input']>;
  emptyingIntervalMax?: InputMaybe<Scalars['Int']['input']>;
  emptyingIntervalMin?: InputMaybe<Scalars['Int']['input']>;
  energyRecovery?: InputMaybe<Scalars['Decimal']['input']>;
  ewcCode?: InputMaybe<Scalars['String']['input']>;
  hazardous?: InputMaybe<Scalars['Boolean']['input']>;
  materialRecovery?: InputMaybe<Scalars['Decimal']['input']>;
  mustIncludeVat?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
  rdCode?: InputMaybe<Scalars['String']['input']>;
  recyclable?: InputMaybe<Scalars['Boolean']['input']>;
  recyclingPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  selfId: Scalars['ID']['input'];
  status?: InputMaybe<Status>;
  treatmentLocation?: InputMaybe<Scalars['String']['input']>;
  treatmentMethod?: InputMaybe<Scalars['String']['input']>;
  wasteCategory: Scalars['String']['input'];
  wasteType: Array<InputMaybe<Scalars['ID']['input']>>;
  weightFactor?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationsUpdateWasteFractionEnvironmentalFactorArgs = {
  assumedFillPercentage?: InputMaybe<Scalars['Float']['input']>;
  co2eFactor?: InputMaybe<Scalars['Float']['input']>;
  densityKgM3?: InputMaybe<Scalars['Float']['input']>;
  recyclingPercentage?: InputMaybe<Scalars['Float']['input']>;
  selfId: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  validFrom: Scalars['Date']['input'];
};


export type MutationsUpdateWasteTypeArgs = {
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  selfId: Scalars['ID']['input'];
  weightFactor?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationsUploadCaseFileArgs = {
  caseId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
  useFrontier?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsUploadContractAreaDocumentArgs = {
  areaId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpsertCompanyHolidayArgs = {
  input: UpsertCompanyHolidayInput;
};


export type MutationsUpsertContainerTypeWasteFractionRuleArgs = {
  allowed: Scalars['Boolean']['input'];
  containerTypeId: Scalars['ID']['input'];
  wasteFractionId: Scalars['ID']['input'];
};


export type MutationsUpsertCouncilFeeEntryArgs = {
  authorityName: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['ID']['input']>;
  feeProductId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  leadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  standardDurationDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationsUpsertFeatureConfigRuleArgs = {
  input: FeatureConfigRuleInput;
};


export type MutationsUpsertPropertyInvoiceSyncConfigArgs = {
  frequency?: InputMaybe<InvoiceSyncFrequency>;
  propertyId: Scalars['ID']['input'];
  startPeriodOverride?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationsUpsertPropertyWasteWaterTreatmentArgs = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  appliances?: InputMaybe<Array<Scalars['String']['input']>>;
  connectedToSewageNetwork: Scalars['Boolean']['input'];
  emptyingProblems?: InputMaybe<Scalars['String']['input']>;
  lastEmptiedDate?: InputMaybe<Scalars['Date']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  propertyId: Scalars['ID']['input'];
  sharedTank?: InputMaybe<Scalars['Boolean']['input']>;
  sludgeTankType?: InputMaybe<SludgeTankType>;
  tankVolumeM3?: InputMaybe<Scalars['Decimal']['input']>;
  toiletType?: InputMaybe<ToiletType>;
  treatmentPlantModel?: InputMaybe<Scalars['String']['input']>;
  wasteWaterTypes?: InputMaybe<WasteWaterTypes>;
};


export type MutationsValidateAutomationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsValidateRouteSetupArgs = {
  input: SetupRouteInput;
};


export type MutationsVehicleSignalIngestArgs = {
  input: VehicleSignalInput;
};


export type MutationsVerifyMfaCodeArgs = {
  challengeId: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type MutationsVerifyTokenArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsWaiveValidationFlagsArgs = {
  caseId: Scalars['ID']['input'];
  materializationId?: InputMaybe<Scalars['ID']['input']>;
  note: Scalars['String']['input'];
  routeIdentities: Array<Scalars['String']['input']>;
};


export type MutationsWashListApproveArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsWashListCreateArgs = {
  areaId: Scalars['ID']['input'];
  binIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  executionEnd?: InputMaybe<Scalars['Date']['input']>;
  executionStart?: InputMaybe<Scalars['Date']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  ticketTypeId?: InputMaybe<Scalars['ID']['input']>;
  wasteFractionId: Scalars['ID']['input'];
};


export type MutationsWashListForwardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsWashListRecallArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsWashListRejectArgs = {
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};


export type MutationsWashListSendToProductionArgs = {
  id: Scalars['ID']['input'];
  routeId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsWashListUpdateArgs = {
  binIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  executionEnd?: InputMaybe<Scalars['Date']['input']>;
  executionStart?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  providerId?: InputMaybe<Scalars['ID']['input']>;
  ticketTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export type MyFeatureConfigEntryType = {
  __typename: 'MyFeatureConfigEntryType';
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  value?: Maybe<Scalars['GenericScalar']['output']>;
  valueType: Scalars['String']['output'];
};

/**
 * RS-1603 narrative document (D42): grounded body, numeral-check
 * verdict, D46-gated judge payload, draft/approved lifecycle.
 * ``judge_internal`` (the ungated team-facing score) is structurally
 * excluded: it has no GraphQL surface.
 */
export type NarrativeDocumentDef = Node & {
  __typename: 'NarrativeDocumentDef';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<UserType>;
  body: Scalars['String']['output'];
  context: Scalars['JSONString']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  judge: Scalars['JSONString']['output'];
  kind: RouteStudioNarrativeDocumentKindChoices;
  llm: Scalars['JSONString']['output'];
  numeralCheck: Scalars['JSONString']['output'];
  project: ProjectType;
  sourceRefs: Scalars['JSONString']['output'];
  status: RouteStudioNarrativeDocumentStatusChoices;
  title: Scalars['String']['output'];
};

export type NarrativeDocumentDefConnection = {
  __typename: 'NarrativeDocumentDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NarrativeDocumentDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `NarrativeDocumentDef` and its cursor. */
export type NarrativeDocumentDefEdge = {
  __typename: 'NarrativeDocumentDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NarrativeDocumentDef>;
};

export type NavigationAppVersionType = Node & {
  __typename: 'NavigationAppVersionType';
  buildNumber: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  disabled: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * An SCP (PropertyGroup) paired with its straight-line distance from a
 * property. Returned by the ``nearest_scps`` query (NEXUS-554); card data is
 * served through ``scp.scp_profile`` (SCPProfileDef).
 */
export type NearestScpDef = {
  __typename: 'NearestScpDef';
  /** Primary collection address display string of the point (ADR-0005); null when unset. */
  collectionAddress?: Maybe<Scalars['String']['output']>;
  /** Straight-line distance in metres */
  distance: Scalars['Float']['output'];
  scp: PropertyGroupDef;
};

export type NeedsAttentionDef = {
  __typename: 'NeedsAttentionDef';
  breakerTripped: Array<AutomationDef>;
  failedRuns: Scalars['Int']['output'];
  items: Array<AttentionItemDef>;
  overdueApprovals: Scalars['Int']['output'];
  pausedTenant: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
  unknownEffects: Scalars['Int']['output'];
};


export type NeedsAttentionDefItemsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Routing dataset metadata (RS-301): version tag, profile and
 * coverage of the network a matrix or service unit was computed
 * against. Shared infrastructure metadata, no tenant data, so no
 * project narrowing; it is reachable only through tenant-scoped
 * parents (service units, plans), never as a root query. Wave
 * D28-6: routed through the flag-gated selector like the other
 * Defs, so a flag-off company reads these rows as nonexistent too
 * (D01/D33).
 */
export type NetworkVersionDef = Node & {
  __typename: 'NetworkVersionDef';
  coverage: Scalars['JSONString']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  profile: Scalars['String']['output'];
  serviceUnits: ServiceUnitDefConnection;
  version: Scalars['String']['output'];
};


/**
 * Routing dataset metadata (RS-301): version tag, profile and
 * coverage of the network a matrix or service unit was computed
 * against. Shared infrastructure metadata, no tenant data, so no
 * project narrowing; it is reachable only through tenant-scoped
 * parents (service units, plans), never as a root query. Wave
 * D28-6: routed through the flag-gated selector like the other
 * Defs, so a flag-off company reads these rows as nonexistent too
 * (D01/D33).
 */
export type NetworkVersionDefServiceUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * An address the office picked from the cockpit's address search for
 * a customer with no registered property yet (PRODUCT-439). ``address``
 * is the display / lookup line; ``latitude`` / ``longitude`` are passed
 * when the lookup returned them (otherwise the backend geocodes the
 * line); ``externalId`` is the register identifier when the lookup source
 * has one. An existing property of the company at the same address is
 * reused instead of duplicated.
 */
export type NewPropertyAddressInput = {
  /** The address line as the address search returned it. */
  address: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 alpha-2; defaults to the company's map country. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Register identifier of the address (becomes the property's external property number); also used to find an existing property. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type NextCollectionType = {
  __typename: 'NextCollectionType';
  containerId: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  propertyId: Scalars['ID']['output'];
};

/** An object with an ID */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

export type NodeChangeDef = {
  __typename: 'NodeChangeDef';
  after?: Maybe<NodeDef>;
  before?: Maybe<NodeDef>;
  changedFields: Array<Scalars['String']['output']>;
  nodeKey: Scalars['String']['output'];
};

export type NodeDef = {
  __typename: 'NodeDef';
  actionKey?: Maybe<Scalars['String']['output']>;
  awaitsResult: Scalars['Boolean']['output'];
  blockKey?: Maybe<Scalars['String']['output']>;
  config: Scalars['JSONString']['output'];
  kind: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  nodeKey: Scalars['String']['output'];
  positionX: Scalars['Int']['output'];
  positionY: Scalars['Int']['output'];
};

export type NodeInput = {
  actionKey?: InputMaybe<Scalars['String']['input']>;
  awaitsResult?: InputMaybe<Scalars['Boolean']['input']>;
  config: Scalars['JSONString']['input'];
  kind: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  nodeKey: Scalars['String']['input'];
  positionX: Scalars['Int']['input'];
  positionY: Scalars['Int']['input'];
};

export type NodeKindDef = {
  __typename: 'NodeKindDef';
  branches: Array<Scalars['String']['output']>;
  configSchema: Scalars['JSONString']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** One node's place and name; an omitted field keeps its value. */
export type NodeLayoutInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  nodeKey: Scalars['String']['input'];
  positionX?: InputMaybe<Scalars['Int']['input']>;
  positionY?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Why a stop was NOT collected (LOOP #7 A2; feeds the #14 missed
 *     worklist). Net-new on this base — the pre-#7 skip path was a bare
 *     boolean with no reason.
 *
 *     RECONCILED with the hauler module's deviation taxonomy at the
 *     integration merge (2026-07-20): the two enums now carry the SAME
 *     union of codes, and every shared code has the identical value, so a
 *     live-ops skip reason and an office deviation annotation
 *     (``routes.choices.DeviationReason``, ``PickUpOrder.skip_reason``)
 *     speak one vocabulary. ADDITIVE both ways — every pre-existing member
 *     of each enum kept its exact value; the merge added the hauler build's
 *     ``wrong_orientation`` / ``too_far_from_road`` / ``frozen_jammed``
 *     here and live-ops' seven extra codes there. No data rewriting.
 *
 *     Extended to the research §2 set for #14 (ADDITIVE — every pre-existing
 *     member keeps its exact value, so no data ever needs rewriting). The
 *     derived :data:`FAULT_PARTY` map turns each reason into a descriptive
 *     fault-party tag; it NEVER becomes money (the Ledger boundary).
 *
 */
export enum NonCollectionReason {
  ACCESS_BLOCKED = 'ACCESS_BLOCKED',
  BIN_DAMAGED = 'BIN_DAMAGED',
  CONTAMINATED = 'CONTAMINATED',
  CREW_ERROR = 'CREW_ERROR',
  FROZEN_JAMMED = 'FROZEN_JAMMED',
  NOT_PRESENTED = 'NOT_PRESENTED',
  OTHER = 'OTHER',
  OVERFILLED = 'OVERFILLED',
  ROADWORKS = 'ROADWORKS',
  SAFETY = 'SAFETY',
  TOO_FAR_FROM_ROAD = 'TOO_FAR_FROM_ROAD',
  TOO_HEAVY = 'TOO_HEAVY',
  VEHICLE_BREAKDOWN = 'VEHICLE_BREAKDOWN',
  WEATHER = 'WEATHER',
  WRONG_ORIENTATION = 'WRONG_ORIENTATION'
}

/**
 * A validated AI-generated widget after the normalisation funnel.
 *
 * ``metric`` is Optional (None for plan widgets); ``plan`` carries the
 * pydantic-clamped plan dict for plan-mode widgets.
 */
export type NormalizedWidget = {
  __typename: 'NormalizedWidget';
  blend?: Maybe<Scalars['GenericScalar']['output']>;
  days?: Maybe<Scalars['Int']['output']>;
  dimension?: Maybe<Scalars['String']['output']>;
  metric?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Scalars['GenericScalar']['output']>;
  viz?: Maybe<Scalars['String']['output']>;
};

/**
 *
 *     Universal visibility levels for notes across all WasteHero applications.
 *
 */
export enum NoteVisibility {
  CRM_PORTAL = 'CRM_PORTAL',
  PLATFORM = 'PLATFORM',
  WH_NAVIGATION_APP = 'WH_NAVIGATION_APP'
}

export type NotificationMessageDef = Node & {
  __typename: 'NotificationMessageDef';
  brokerType?: Maybe<Scalars['String']['output']>;
  company: CompanyType;
  companyEmailAccountMessage?: Maybe<CompanyEmailAccountMessageDef>;
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  errorAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  notificationType: CrmNotificationMessageNotificationTypeChoices;
  providerId?: Maybe<Scalars['String']['output']>;
  reciever: Scalars['String']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  ticketMessage?: Maybe<TicketMessageDef>;
};

export type NotificationMessageDefConnection = {
  __typename: 'NotificationMessageDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NotificationMessageDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `NotificationMessageDef` and its cursor. */
export type NotificationMessageDefEdge = {
  __typename: 'NotificationMessageDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NotificationMessageDef>;
};

export type NotificationMethodDef = Node & {
  __typename: 'NotificationMethodDef';
  company: CompanyType;
  containerNotifications: ContainerNotificationDefConnection;
  createdAt: Scalars['DateTime']['output'];
  emailnotificationmethod?: Maybe<EmailNotificationMethodDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  migratedFromId?: Maybe<Scalars['String']['output']>;
  smsnotificationmethod?: Maybe<SmsNotificationMethodDef>;
};


export type NotificationMethodDefContainerNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationMethodDefConnection = {
  __typename: 'NotificationMethodDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NotificationMethodDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `NotificationMethodDef` and its cursor. */
export type NotificationMethodDefEdge = {
  __typename: 'NotificationMethodDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NotificationMethodDef>;
};

/** The D09/F11 comms-gate artifact attached to a promotion. */
export type NotificationPlanDef = Node & {
  __typename: 'NotificationPlanDef';
  audiences: Scalars['JSONString']['output'];
  channels: Scalars['JSONString']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** SBX-374 (D09): per-message delivery readback from the platform's own NotificationMessage lifecycle: exact sent/failed/pending/unknown counts, a capped failed list (message id, channel, error, owning property) with an honest truncation flag, the customers channel order and the digital_post configured/eligibility record incl. the documented send requirement. */
  delivery?: Maybe<Scalars['GenericScalar']['output']>;
  draftMessageIds: Scalars['JSONString']['output'];
  draftSummary: Scalars['JSONString']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  languages: Scalars['JSONString']['output'];
  leadTimeDays: Scalars['Int']['output'];
  messages: Scalars['JSONString']['output'];
  /** Follow-ups mini-wave (SBX-374, D09): the chosen recipient's notice rendered COMPLETE (subject, body, merge context incl. the real property_address and day lists from the recipient index), so the comms preview shows a real message instead of raw tokens. Honest empty state (available: false + reason) before drafts exist or for a property outside the index. Read-only. */
  preview?: Maybe<Scalars['GenericScalar']['output']>;
  promotion: PromotionDef;
  state: RouteStudioNotificationPlanStateChoices;
};


/** The D09/F11 comms-gate artifact attached to a promotion. */
export type NotificationPlanDefPreviewArgs = {
  propertyId?: InputMaybe<Scalars['ID']['input']>;
};

export type NotificationSettingsType = Node & {
  __typename: 'NotificationSettingsType';
  condition?: Maybe<Scalars['String']['output']>;
  container?: Maybe<ContainerType>;
  description: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  recipients?: Maybe<Array<Scalars['String']['output']>>;
  /** % */
  threshold: Scalars['Float']['output'];
  users: UserTypeConnection;
};


export type NotificationSettingsTypeUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationSettingsTypeConnection = {
  __typename: 'NotificationSettingsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NotificationSettingsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `NotificationSettingsType` and its cursor. */
export type NotificationSettingsTypeEdge = {
  __typename: 'NotificationSettingsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NotificationSettingsType>;
};

/**
 * Per-user notification stream over ``ws/graphql/`` (``onNotification``).
 *
 * Same data as the legacy ``ws/notifications/<user_id>/`` path (the
 * ``send_device_added_notification`` fan-out broadcasts to both), so it
 * carries the same W2a rule: an authenticated user may subscribe only
 * to their OWN notification group.
 */
export type NotificationSubscription = {
  __typename: 'NotificationSubscription';
  notification?: Maybe<NotificationsType>;
};

/** An enumeration. */
export enum NotificationsDriverPushNotificationNotificationTypeChoices {
  /** Container Relocated */
  CONTAINER_RELOCATED = 'CONTAINER_RELOCATED',
  /** Integration Error */
  INTEGRATION_ERROR = 'INTEGRATION_ERROR',
  /** Offline Mode Conflict */
  OFFLINE_MODE_CONFLICT = 'OFFLINE_MODE_CONFLICT',
  /** Stop Added */
  STOP_ADDED = 'STOP_ADDED',
  /** Stop Removed */
  STOP_REMOVED = 'STOP_REMOVED',
  /** Stop Ticket Created */
  STOP_TICKET_CREATED = 'STOP_TICKET_CREATED',
  /** Unknown */
  UNKNOWN = 'UNKNOWN'
}

/** An enumeration. */
export enum NotificationsNotificationStatusChoices {
  /** DEBUG */
  DEBUG = 'DEBUG',
  /** ERROR */
  ERROR = 'ERROR',
  /** INFO */
  INFO = 'INFO',
  /** SUCCESS */
  SUCCESS = 'SUCCESS',
  /** WARNING */
  WARNING = 'WARNING'
}

export type NotificationsType = Node & {
  __typename: 'NotificationsType';
  containerDevice?: Maybe<DeviceToContainerType>;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isRead: UserTypeConnection;
  message: Scalars['String']['output'];
  messageDa?: Maybe<Scalars['String']['output']>;
  messageEl?: Maybe<Scalars['String']['output']>;
  messageEn?: Maybe<Scalars['String']['output']>;
  messageFi?: Maybe<Scalars['String']['output']>;
  messageNo?: Maybe<Scalars['String']['output']>;
  messageSv?: Maybe<Scalars['String']['output']>;
  status: NotificationsNotificationStatusChoices;
  title: Scalars['String']['output'];
  titleDa?: Maybe<Scalars['String']['output']>;
  titleEl?: Maybe<Scalars['String']['output']>;
  titleEn?: Maybe<Scalars['String']['output']>;
  titleFi?: Maybe<Scalars['String']['output']>;
  titleNo?: Maybe<Scalars['String']['output']>;
  titleSv?: Maybe<Scalars['String']['output']>;
};


export type NotificationsTypeIsReadArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationsTypeConnection = {
  __typename: 'NotificationsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NotificationsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `NotificationsType` and its cursor. */
export type NotificationsTypeEdge = {
  __typename: 'NotificationsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NotificationsType>;
};

export type ObjectAnalyticsHeatMapType = {
  __typename: 'ObjectAnalyticsHeatMapType';
  amount?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type ObjectAnalyticsTimeSeriesType = {
  __typename: 'ObjectAnalyticsTimeSeriesType';
  amount?: Maybe<Scalars['Float']['output']>;
  timestamp?: Maybe<Scalars['Int']['output']>;
};

/**
 * Provide a presigned URL and authentication data for uploading attachments directly to S3.
 * The URL has the expiration time, defined in settings by AWS_PRESIGNED_URL_EXPIRY.
 */
export type ObtainAttachmentsDirectUploadUrl = {
  __typename: 'ObtainAttachmentsDirectUploadUrl';
  presignedData?: Maybe<Array<Maybe<DirectFileUploadUrlDef>>>;
};

/**
 * Provide a presigned URL and authentication data for uploading attachments directly to S3.
 * The URL has the expiration time, defined in settings by AWS_PRESIGNED_URL_EXPIRY.
 */
export type ObtainImportDirectUploadUrl = {
  __typename: 'ObtainImportDirectUploadUrl';
  presignedData?: Maybe<Array<Maybe<DirectFileUploadUrlDef>>>;
};

export type ObtainJsonWebToken = {
  __typename: 'ObtainJSONWebToken';
  mfaChallengeId?: Maybe<Scalars['String']['output']>;
  mfaCodeTtlSeconds?: Maybe<Scalars['Int']['output']>;
  mfaRequired?: Maybe<Scalars['Boolean']['output']>;
  payload: Scalars['GenericScalar']['output'];
  refreshExpiresIn: Scalars['Int']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type OfflineCreateTicketInput = {
  /** If true, the user creating the ticket will be added to the followers */
  addToFollowers?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTeam?: InputMaybe<Scalars['ID']['input']>;
  assignee?: InputMaybe<Scalars['ID']['input']>;
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  container?: InputMaybe<Scalars['ID']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<TicketCustomFieldValueInput>>>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Accuracy radius of that fix, metres. */
  gpsAccuracy?: InputMaybe<Scalars['Float']['input']>;
  /** When the device took that fix. */
  gpsCapturedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ignoreServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Device latitude when the ticket was filed (HSY req 34). */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  /** Device longitude when the ticket was filed (HSY req 34). */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  overridePeriodStartInPast?: InputMaybe<Scalars['Boolean']['input']>;
  periodEndDate?: InputMaybe<Scalars['Date']['input']>;
  periodStartDate?: InputMaybe<Scalars['Date']['input']>;
  ppServiceOriginalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  ppServicePrice?: InputMaybe<Scalars['Decimal']['input']>;
  ppServiceProductId?: InputMaybe<Scalars['String']['input']>;
  preferredDate?: InputMaybe<Scalars['Date']['input']>;
  /** If true, do not create the ticket, but preview what it would look like if created - e.g. to get the prices. */
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  priority: Scalars['String']['input'];
  property?: InputMaybe<Scalars['ID']['input']>;
  reporter?: InputMaybe<Scalars['ID']['input']>;
  reporterDriver?: InputMaybe<Scalars['ID']['input']>;
  requestedBy?: InputMaybe<Scalars['ID']['input']>;
  requestedByOther?: InputMaybe<Scalars['String']['input']>;
  routeDescription?: InputMaybe<Scalars['String']['input']>;
  sendSummary?: InputMaybe<SendTicketSummaryInput>;
  serviceProducts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  serviceProvider?: InputMaybe<Scalars['ID']['input']>;
  stop: Scalars['ID']['input'];
  ticketType: Scalars['ID']['input'];
};

export type OfflineModeUpdateData = {
  __typename: 'OfflineModeUpdateData';
  conflictNotifications?: Maybe<Array<Maybe<DriverPushNotificationType>>>;
};

export type OfflineOperationInput = {
  /** UUID generated by the mobile — correlates the result. */
  clientId: Scalars['String']['input'];
  /** When the action was taken offline — used for conflict detection and ordering. */
  clientTimestamp: Scalars['DateTime']['input'];
  /** JSON arguments matching the delegated mutation's input. */
  payload: Scalars['JSONString']['input'];
  /** How many times the mobile retried this action. */
  retryCount?: InputMaybe<Scalars['Int']['input']>;
  type: OfflineOperationType;
};

/**
 * COMPASS-1286 — the outcome of ONE item of a bulk-payload operation.
 *
 * Mirrors what the delegated resolver answered for that item so the mobile
 * can reuse the handling it already has for the direct mutation. For the
 * RFID pairing ops the fields mirror ``PairContainerRFIDOutput`` one-to-one
 * (``status`` / ``message`` / ``barcode`` / ``rfid`` / ``metaData`` /
 * ``conflictingContainerIds``); the batch ticket ops fill ``status`` and
 * ``serverId`` only.
 */
export type OfflineOperationItemResult = {
  __typename: 'OfflineOperationItemResult';
  /** RFID ops only — the barcode / container id submitted. */
  barcode?: Maybe<Scalars['String']['output']>;
  /** RFID ops only — container ids that already hold this RFID. Set (with status = false) when the pair is awaiting force-pair confirmation; empty when it was applied. */
  conflictingContainerIds?: Maybe<Array<Scalars['String']['output']>>;
  /** 0-based position of the item in the operation's payload list (0 for PAIR_RFID's single object payload). The stable key for matching a result back to the queued item — barcode / rfid are echoed for convenience but may repeat within one batch. */
  index: Scalars['Int']['output'];
  /** The resolver's message for this item (for RFID ops the per-pair message of bulkPairContainerRfid). */
  message?: Maybe<Scalars['String']['output']>;
  /** RFID ops only — echoed from the submitted pair. */
  metaData?: Maybe<Scalars['String']['output']>;
  /** RFID ops only — the RFID submitted. */
  rfid?: Maybe<Scalars['String']['output']>;
  /** Global id of the entity this item created or affected (the ticket for BULK_CREATE_TICKET / UPDATE_OR_CREATE_BULK_TICKET, the container for PAIR_RFID / BULK_PAIR_RFID). */
  serverId?: Maybe<Scalars['String']['output']>;
  /** True when this item was applied. Mirrors bulkPairContainerRfid's per-pair status: an RFID pairing with status = false AND conflictingContainerIds set did not fail — it is awaiting force-pair confirmation (resubmit that item with forcePair: true). */
  status: Scalars['Boolean']['output'];
};

export type OfflineOperationResult = {
  __typename: 'OfflineOperationResult';
  clientId: Scalars['String']['output'];
  /** Populated when status = CONFLICT. */
  conflicts?: Maybe<Array<ConflictField>>;
  /** COMPASS-1695 — machine-readable reason when status = REJECTED, when the resolver gave one: for COMPLETE_STOP / SKIP_STOP one of STOP_REMOVED, STOP_NOT_FOUND, AMBIGUOUS_TARGET, ROUTE_CLOSED, ROUTE_NOT_STARTED, REJECTED, RETRY_LATER (the same `extensions.code` routeStopComplete raises). Null for a rejection that carries no code. */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Populated when status = REJECTED. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** COMPASS-1286 — per-item outcome for bulk-payload operations (PAIR_RFID, BULK_PAIR_RFID, BULK_CREATE_TICKET, UPDATE_OR_CREATE_BULK_TICKET), in payload order. Null for single-entity operations and for REJECTED operations (nothing was applied). An RFID op in which some pairs need force-pair confirmation stays status = CONFLICT with `conflicts` populated as before, but the other pairs ARE applied and reported here with status = true — match them back by `index`. */
  itemResults?: Maybe<Array<OfflineOperationItemResult>>;
  /** Global id of the entity created by the operation (e.g. CREATE_TICKET). Mobile uses it to resolve temp ids. */
  serverId?: Maybe<Scalars['String']['output']>;
  status: OfflineOperationStatus;
};

export enum OfflineOperationStatus {
  ACCEPTED = 'ACCEPTED',
  CONFLICT = 'CONFLICT',
  REJECTED = 'REJECTED',
  SKIPPED = 'SKIPPED'
}

export enum OfflineOperationType {
  ADD_STOP = 'ADD_STOP',
  ADD_STOPS = 'ADD_STOPS',
  ADD_TICKET_COMMENT = 'ADD_TICKET_COMMENT',
  BULK_CREATE_TICKET = 'BULK_CREATE_TICKET',
  BULK_PAIR_RFID = 'BULK_PAIR_RFID',
  CHANGE_PRIMARY_VEHICLE = 'CHANGE_PRIMARY_VEHICLE',
  COMPLETE_ROUTE = 'COMPLETE_ROUTE',
  COMPLETE_STOP = 'COMPLETE_STOP',
  COMPLETE_TICKET = 'COMPLETE_TICKET',
  CONFIRM_NOTIFICATION = 'CONFIRM_NOTIFICATION',
  CONFIRM_STOPS_BY_TAGS = 'CONFIRM_STOPS_BY_TAGS',
  CREATE_TICKET = 'CREATE_TICKET',
  FINISH_VEHICLE_SESSION = 'FINISH_VEHICLE_SESSION',
  LOAD_UNIT_CANCEL = 'LOAD_UNIT_CANCEL',
  LOAD_UNIT_EMPTIED = 'LOAD_UNIT_EMPTIED',
  LOAD_UNIT_START = 'LOAD_UNIT_START',
  LOAD_UNIT_UNLOADED = 'LOAD_UNIT_UNLOADED',
  MOVE_STOP = 'MOVE_STOP',
  PAIR_RFID = 'PAIR_RFID',
  RECORD_SKIP_WEIGHT = 'RECORD_SKIP_WEIGHT',
  REJECT_TICKET = 'REJECT_TICKET',
  REMOVE_STOP = 'REMOVE_STOP',
  REORDER_STOP = 'REORDER_STOP',
  RESET_STOP = 'RESET_STOP',
  SET_AUTO_COMPLETE = 'SET_AUTO_COMPLETE',
  SET_UNLOADING_STATION = 'SET_UNLOADING_STATION',
  SKIP_STOP = 'SKIP_STOP',
  START_ROUTE = 'START_ROUTE',
  TAKE_STOPS = 'TAKE_STOPS',
  TRANSFER_DOCUMENT_SAVE = 'TRANSFER_DOCUMENT_SAVE',
  TRANSFER_DOCUMENT_SIGN = 'TRANSFER_DOCUMENT_SIGN',
  UPDATE_CONTAINER = 'UPDATE_CONTAINER',
  UPDATE_CONTAINER_LOCATION = 'UPDATE_CONTAINER_LOCATION',
  UPDATE_CONTAINER_PHOTO = 'UPDATE_CONTAINER_PHOTO',
  UPDATE_OR_CREATE_BULK_TICKET = 'UPDATE_OR_CREATE_BULK_TICKET',
  UPDATE_PROFILE = 'UPDATE_PROFILE',
  UPDATE_STOP = 'UPDATE_STOP',
  UPDATE_TICKET = 'UPDATE_TICKET',
  UPDATE_TICKET_PRIORITY = 'UPDATE_TICKET_PRIORITY',
  UPDATE_TICKET_STATUS = 'UPDATE_TICKET_STATUS',
  UPDATE_VEHICLE = 'UPDATE_VEHICLE',
  VEHICLE_SIGNAL = 'VEHICLE_SIGNAL'
}

export type OfflineRouteStopCompleteInput = {
  /** PRODUCT-472: the driver's note on the abortive visit. */
  abortiveNote?: InputMaybe<Scalars['String']['input']>;
  /** PRODUCT-472: id of the uploaded ticket attachment (photo) documenting the abortive visit. */
  abortivePhotoId?: InputMaybe<Scalars['ID']['input']>;
  /** PRODUCT-472: the visit could NOT be carried out - why. The stop is recorded as skipped, the ticket goes Rejected with this reason and back to Open for rescheduling, and the wasted-journey fee is billed. */
  abortiveReason?: InputMaybe<AbortiveReason>;
  /** Which signal confirmed this stop: MANUAL, RADIUS, RFID, NFC, LIFT or SCALE. Omit and the legacy rfidAutoComplete boolean decides (true -> RFID, otherwise MANUAL). */
  autoCompletedBy?: InputMaybe<Scalars['String']['input']>;
  /** COMPASS-884: when the tag was read — distinct from completedAt. */
  autoConfirmReadAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** COMPASS-884: which reader reported the tag (two readers may identify two containers at the same moment). */
  autoConfirmReaderId?: InputMaybe<Scalars['String']['input']>;
  /** COMPASS-884: the RFID/NFC tag id that confirmed this stop. */
  autoConfirmTag?: InputMaybe<Scalars['String']['input']>;
  /** COMPASS-1695: the client's own id for this completion (the offline queue entry), echoed in server logs. */
  clientOperationId?: InputMaybe<Scalars['String']['input']>;
  /** PRODUCT-477 (exchange): identity of the OLD unit taken away. */
  collectedIdentity?: InputMaybe<Scalars['String']['input']>;
  /** When the driver confirmed, on the device. Trusted backwards only: a value in the future is clamped to now. Omitted or null -> now (the sync time, for an offline replay). */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** COMPASS-882: metres the DEVICE measured between itself and this stop at the moment of confirmation. The server re-measures whenever it has a position of its own and that value wins; this one survives only when nothing could be re-measured (the offline, no-breadcrumb case), and completionDistanceSource then reads 'client_reported'. */
  completionDistanceM?: InputMaybe<Scalars['Float']['input']>;
  /** COMPASS-882: the completion radius the device applied when it decided to demand a verification — i.e. the number the driver was shown. Recorded as-is so the office can see it even if the server resolves a different radius today. */
  completionRadiusM?: InputMaybe<Scalars['Float']['input']>;
  createdTicketsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** PRODUCT-477 (exchange): identity of the NEW unit put down. */
  deliveredIdentity?: InputMaybe<Scalars['String']['input']>;
  /** COMPASS-1695: the stop number the driver was shown when they confirmed; breaks a tie when the identity matches more than one open stop. */
  displayNumber?: InputMaybe<Scalars['Int']['input']>;
  /** COMPASS-882: optional free text the driver added to the verification. */
  distanceVerificationNote?: InputMaybe<Scalars['String']['input']>;
  /** COMPASS-882: the driver's explanation — 'gps_unavailable', 'gps_interference', 'collected_from_another_point', 'no_safe_access' or 'other'. This is the 'additional verification from the driver' the requirement asks for, and it is what lets an out-of-range completion through instead of being refused. Anything outside the list is rejected. Distinct from skipReason, which says why the waste was not collected, not why the driver was far away. */
  distanceVerificationReason?: InputMaybe<Scalars['String']['input']>;
  /** COMPASS-882: which check demanded the extra verification — 'out_of_range' (measured farther than the radius), 'no_position' (no GPS fix at all) or 'stale_position' (the fix was too old to trust). Machine-determined. Required whenever distanceVerificationReason is sent: a confirmation with no fix must not pass a check that could not run. */
  distanceVerificationTrigger?: InputMaybe<Scalars['String']['input']>;
  fillLevel?: InputMaybe<Scalars['Float']['input']>;
  /** COMPASS-883: horizontal accuracy of that fix in meters, when the device reports one. */
  gpsAccuracy?: InputMaybe<Scalars['Float']['input']>;
  /** COMPASS-883: when the GPS FIX was taken — distinct from completedAt and from the sync time. An offline confirmation can reach the server days later. */
  gpsCapturedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** COMPASS-883: WGS84 latitude of the driver at the moment of confirmation, captured on the device. Must be sent together with longitude. */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** PRODUCT-477: label / barcode / RFID text of the skip the driver loaded for this rental delivery, as scanned. Dispatches the rental at completion; a scan of the wrong container type is refused. */
  loadedContainerIdentity?: InputMaybe<Scalars['String']['input']>;
  /** COMPASS-883: WGS84 longitude of the driver at the moment of confirmation, captured on the device. */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  orderId: Scalars['String']['input'];
  qrCode?: InputMaybe<Scalars['String']['input']>;
  rfidAutoComplete?: InputMaybe<Scalars['Boolean']['input']>;
  routeId: Scalars['ID']['input'];
  /** COMPASS-883: a deviation-reason code reported BY THE DRIVER with this confirmation (overfilled, access_blocked, wrong_orientation, too_far_from_road, contaminated, frozen_jammed, not_presented, roadworks, too_heavy, bin_damaged, vehicle_breakdown, weather, safety, crew_error, other). Same column and same vocabulary as the office-only setStopDeviationReason. Omitting it leaves any existing reason untouched. */
  skipReason?: InputMaybe<Scalars['String']['input']>;
  /** COMPASS-1695: the physical stop, used when orderId no longer names a live stop of the route. */
  stopIdentity?: InputMaybe<StopIdentityInput>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
  ticketIdStopCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** SIIRTO: the driver's transfer-document work bundled with the completion so an offline completion replays in ONE call: {data: {field_key: value}, driver_signature: {signed_at?}}. Applied (saveTransferDocumentData + signTransferDocument as the driver) BEFORE the completion is validated; a rule violation refuses the completion with its message. */
  transferDocument?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** SIIRTO: office-only escape hatch — complete an eligible stop WITHOUT a driver-signed transfer document, recording why. Logged on the document. */
  transferDocumentOverrideReason?: InputMaybe<Scalars['String']['input']>;
  /** PRODUCT-472 (wait-and-load): when the truck stopped waiting. Minutes beyond the fee product's free window bill per block. */
  waitingEndedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** PRODUCT-472 (wait-and-load): when the truck started waiting on site. */
  waitingStartedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** COMPASS-877: the weighing system's own id for the measurement being confirmed — the audit link back to the ingested WeighTicket. */
  weighTicketId?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  /** COMPASS-877: laden weight, in weightUnit. */
  weightGross?: InputMaybe<Scalars['Float']['input']>;
  /** COMPASS-877: when the SCALE measured — not when the stop was confirmed and not when this synced. */
  weightMeasuredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** COMPASS-877: net load weight, in weightUnit. An explicit net wins over gross minus tare. */
  weightNet?: InputMaybe<Scalars['Float']['input']>;
  /** COMPASS-877: where this weight came from — weighbridge (the unloading site's certified scale), vehicle_scale (on-board mScales / Once), manual (REQ 18's fallback: the driver typed it), import, unknown. Omitting it records NO provenance, which is honestly weaker than 'unknown'. */
  weightSource?: InputMaybe<Scalars['String']['input']>;
  /** COMPASS-877: vendor key of the weighing system ('mscales', 'once', a site's own key). */
  weightSystem?: InputMaybe<Scalars['String']['input']>;
  /** COMPASS-877: empty-vehicle weight, in weightUnit. */
  weightTare?: InputMaybe<Scalars['Float']['input']>;
  /** COMPASS-877: the weighing-slip number printed at the site. */
  weightTicketNumber?: InputMaybe<Scalars['String']['input']>;
  /** COMPASS-877: unit the figures below are expressed in — kg | t | lb. Omitted means kg, which is what `weight` has always meant. Stored numbers are converted to kilograms; the unit is remembered so the office can reconcile against the site's own slip. */
  weightUnit?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum OmniSearchEntityType {
  AGREEMENT = 'AGREEMENT',
  CONTACT = 'CONTACT',
  CONTAINER = 'CONTAINER',
  DOCUMENT = 'DOCUMENT',
  DRIVER = 'DRIVER',
  HAULER = 'HAULER',
  INVOICE = 'INVOICE',
  MANAGEMENT_COMPANY = 'MANAGEMENT_COMPANY',
  ORDER = 'ORDER',
  PHYSICAL_KEY = 'PHYSICAL_KEY',
  PROJECT = 'PROJECT',
  PROPERTY = 'PROPERTY',
  PROPERTY_USER = 'PROPERTY_USER',
  ROUTE = 'ROUTE',
  TICKET = 'TICKET',
  VEHICLE = 'VEHICLE'
}

/** Typed, non-fatal failure of a search (search degrades on its own). */
export enum OmniSearchErrorCode {
  FORBIDDEN = 'FORBIDDEN',
  SEARCH_UNAVAILABLE = 'SEARCH_UNAVAILABLE'
}

export type OmniSearchGroup = {
  __typename: 'OmniSearchGroup';
  entityType: OmniSearchEntityType;
  /** Total matches for this entity (approximate for NDR-split contact). */
  found: Scalars['Int']['output'];
  hits: Array<OmniSearchHit>;
};

export type OmniSearchHit = {
  __typename: 'OmniSearchHit';
  entityType: OmniSearchEntityType;
  /** Entity primary key; the FE registry resolves the route at click time. */
  id: Scalars['ID']['output'];
  /** Typesense text_match score (group ordering). */
  score?: Maybe<Scalars['Float']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type OmniSearchResults = {
  __typename: 'OmniSearchResults';
  /** Set when the search could not run; groups is then empty. */
  error?: Maybe<OmniSearchErrorCode>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  groups: Array<OmniSearchGroup>;
};

/**
 * Per-record lease state pushes: acquire / refresh / release /
 * take-over (``lease`` is null when the record became free).
 */
export type OnRecordLeaseChanged = {
  __typename: 'OnRecordLeaseChanged';
  entityId?: Maybe<Scalars['ID']['output']>;
  entityType?: Maybe<RecordLeaseEntityType>;
  lease?: Maybe<RecordLeaseDef>;
};

/**
 * RS-1605 guided-flow state machine surface: the current step,
 * what is missing, and the next action as a deep link, all derived
 * from real tenant state (no LLM).
 */
export type OnboardingStatusDef = {
  __typename: 'OnboardingStatusDef';
  complete: Scalars['Boolean']['output'];
  /** Deferral note: the full from-nothing-to-promoted-plan agent is the documented deep mode; this state machine is its skeleton. */
  deepMode?: Maybe<Scalars['String']['output']>;
  missing?: Maybe<Scalars['String']['output']>;
  /** {label, deep_link} for the current step. */
  nextAction?: Maybe<Scalars['GenericScalar']['output']>;
  step: Scalars['String']['output'];
  /** Ordered [{key, done}] entries for the flow rail. */
  steps?: Maybe<Scalars['GenericScalar']['output']>;
  timeToFirstPlanSeconds?: Maybe<Scalars['Float']['output']>;
  timeToFirstPromotionSeconds?: Maybe<Scalars['Float']['output']>;
};

export type OperationManagementType = {
  __typename: 'OperationManagementType';
  driversStatuses?: Maybe<Array<Maybe<AnalyticsCount>>>;
  vehiclesStatuses?: Maybe<Array<Maybe<AnalyticsCount>>>;
};

/**
 * Order a key for a customer (AC1/AC2): creates a KEY_ORDER ticket and
 * its PhysicalKey and sends it to the locksmith. Returns the key + the
 * order ticket's global id.
 */
export type OrderKey = {
  __typename: 'OrderKey';
  physicalKey?: Maybe<PhysicalKeyType>;
  ticketId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Order a spare part for a customer's container (PRO-256).
 *
 * Creates an inventory-internal order-spare-part ticket carrying the
 * container context and the ordered part / quantity / fulfilling
 * warehouse. Completing that ticket issues the part out of the warehouse
 * (a -N spare-part ledger row stamped with the ticket). The ticket is the
 * audit + workflow record the portal / driver drives to completion.
 */
export type OrderSparePart = {
  __typename: 'OrderSparePart';
  status?: Maybe<Scalars['String']['output']>;
  ticketId?: Maybe<Scalars['ID']['output']>;
};

export type OrderSubscriptionQuote = {
  __typename: 'OrderSubscriptionQuote';
  subscription?: Maybe<BillingSubscription>;
};

/** An enumeration. */
export enum OrderTypeChoices {
  FREQUENCY = 'FREQUENCY',
  MANUALLY = 'MANUALLY'
}

export type OverflowingSettingsObject = {
  duration?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
};

export type OverflowingSettingsType = Node & {
  __typename: 'OverflowingSettingsType';
  container?: Maybe<ContainerType>;
  containerType?: Maybe<ContainerTypeType>;
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  percentage: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A legacy ticket rule doing the same (SBX-561). */
export type OverlapWarningDef = {
  __typename: 'OverlapWarningDef';
  message: Scalars['String']['output'];
  ruleId: Scalars['ID']['output'];
  ruleName: Scalars['String']['output'];
  severity: Scalars['String']['output'];
  sharedActions: Array<Scalars['String']['output']>;
  ticketTypeId: Scalars['ID']['output'];
  triggerNodeKey: Scalars['String']['output'];
};

/**
 * Office-only, audited (D7): replace a period's computed bonus
 * coefficient with an explicit value, with a mandatory reason. OPEN
 * periods only; the override participates in the live compute and
 * freezes into the snapshot when the period closes. Pass ``clear: true``
 * (and no coefficient) to remove an override.
 */
export type OverrideSettlementCoefficient = {
  __typename: 'OverrideSettlementCoefficient';
  period?: Maybe<SettlementPeriodType>;
  report?: Maybe<SettlementReportType>;
};

/**
 * Minimal read view of the P&P product.Category.
 *
 * Same shape rationale as PPProductDef above: Category has a 26-char ULID
 * PK and is not a registered GraphQL node, so ``id`` is the raw ULID the
 * FE's pp REST hooks already use — not a base64 global id.
 */
export type PpCategoryDef = {
  __typename: 'PPCategoryDef';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/**
 * Minimal read view of the P&P catalog product.Product (LEDGER-676).
 *
 * NOT a relay Node: product.Product has a 26-char ULID PK and is not a
 * registered GraphQL node, so we expose ``id`` as the raw ULID the FE already
 * uses (rather than a base64 global id). Only the fields the agreements view
 * needs are surfaced.
 */
export type PpProductDef = {
  __typename: 'PPProductDef';
  /** Wait-and-load: length in minutes of one billed waiting block (PRODUCT-472). Every started block beyond free_minutes bills one unit of waiting_block_product. NULL = 15. */
  blockMinutes?: Maybe<Scalars['Int']['output']>;
  categoryType?: Maybe<Scalars['String']['output']>;
  containerTypeName?: Maybe<Scalars['String']['output']>;
  extraDayProductId?: Maybe<Scalars['String']['output']>;
  extraDayProductName?: Maybe<Scalars['String']['output']>;
  /** Wait-and-load: waiting minutes covered by this job fee (PRODUCT-472). NULL = no free window is defined (0). */
  freeMinutes?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  /** Hire days covered by the hire price (PRODUCT-456). Days beyond this allowance bill the extra-day product. NULL = no allowance is defined. */
  includedDays?: Maybe<Scalars['Int']['output']>;
  /** Tonnes covered by the hire price (PRODUCT-475). Weight beyond this allowance at collection bills the overage product per tonne. NULL = no weight allowance is defined. */
  includedTonnes?: Maybe<Scalars['Decimal']['output']>;
  /** Longest hire period a booking of this product may have, in days (PRODUCT-456). A booking or period edit beyond it is refused. NULL = no upper bound. */
  maxDays?: Maybe<Scalars['Int']['output']>;
  overageProductId?: Maybe<Scalars['String']['output']>;
  overageProductName?: Maybe<Scalars['String']['output']>;
  pickupSettingName?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
  waitingBlockProductId?: Maybe<Scalars['String']['output']>;
  waitingBlockProductName?: Maybe<Scalars['String']['output']>;
  wasteFractionName?: Maybe<Scalars['String']['output']>;
  wasteFractionNames?: Maybe<Scalars['String']['output']>;
  wasteFractions?: Maybe<Array<Maybe<WasteFractionType>>>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * Pair, re-pair, or clear the physical labels of a container.
 *
 * Labels are not identity (decided): container_id never changes
 * here. Passing an empty string clears a label (an emptied form
 * field); omitting an argument leaves that label untouched. A label
 * already on another container is rejected - clear it there first -
 * so a label can never silently move between containers.
 */
export type PairContainerLabels = {
  __typename: 'PairContainerLabels';
  barcode?: Maybe<Scalars['String']['output']>;
  rfid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PairContainerRfidInput = {
  barcode: Scalars['String']['input'];
  forcePair?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional client-generated idempotency key (a UUID). A later call with the same key from the same user returns the entity the first call created instead of creating another one — re-send safely after a lost response. Keys are remembered for 30 days by default (CLIENT_IDEMPOTENCY_KEY_RETENTION_DAYS). */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  rfid: Scalars['String']['input'];
};

export type PairContainerRfidOutput = {
  __typename: 'PairContainerRFIDOutput';
  barcode?: Maybe<Scalars['String']['output']>;
  /** Container ids that already hold this RFID. A pair with status=false and this list set did not fail — it is awaiting confirmation; resubmit it with forcePair: true to move the RFID (same signal the container form gates its Force pair action on, NEXUS-748/750). */
  conflictingContainerIds?: Maybe<Array<Scalars['String']['output']>>;
  container?: Maybe<ContainerType>;
  /** Designates whether given RFID should be forcibly paired with the barcode. */
  fromBeToFeWithLove?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metaData?: Maybe<Scalars['String']['output']>;
  rfid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * One version transition of the tenant's learned parameters
 * (RS-901 changelog): which classes moved.
 */
export type ParameterSetChangeDef = {
  __typename: 'ParameterSetChangeDef';
  classesChanged?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fromVersion?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  toVersion: Scalars['Int']['output'];
};

export type ParameterSetDef = Node & {
  __typename: 'ParameterSetDef';
  company: CompanyType;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  payload: Scalars['JSONString']['output'];
  plans: PlanDefConnection;
  publishedAt: Scalars['DateTime']['output'];
  scenarios: ScenarioDefConnection;
  supersededBySet: ParameterSetDefConnection;
  supersedes?: Maybe<ParameterSetDef>;
  version: Scalars['Int']['output'];
};


export type ParameterSetDefPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ParameterSetDefScenariosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ParameterSetDefSupersededBySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ParameterSetDefConnection = {
  __typename: 'ParameterSetDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ParameterSetDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ParameterSetDef` and its cursor. */
export type ParameterSetDefEdge = {
  __typename: 'ParameterSetDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ParameterSetDef>;
};

/** A Part-type: a category in the company's spare-part picker library. */
export type PartTypeType = Node & {
  __typename: 'PartTypeType';
  /** Company that owns this part-type library entry. */
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Part of the canonical, system-seeded library. */
  isSystemSeeded: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  spareParts: SparePartTypeConnection;
};


/** A Part-type: a category in the company's spare-part picker library. */
export type PartTypeTypeSparePartsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PartTypeTypeConnection = {
  __typename: 'PartTypeTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PartTypeTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PartTypeType` and its cursor. */
export type PartTypeTypeEdge = {
  __typename: 'PartTypeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PartTypeType>;
};

export type PartialUpdateCompanySettingsInput = {
  backgroundImageForHomePage?: InputMaybe<Scalars['String']['input']>;
  backgroundImageForLoginPage?: InputMaybe<Scalars['String']['input']>;
  barcodeTemplate?: InputMaybe<Scalars['String']['input']>;
  binSizeCoefficientRules?: InputMaybe<Scalars['JSONString']['input']>;
  borderRadius?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  colorClosestStop?: InputMaybe<Scalars['String']['input']>;
  colorEmptiedStop?: InputMaybe<Scalars['String']['input']>;
  colorEmptiedWithTicketStop?: InputMaybe<Scalars['String']['input']>;
  colorNextStop?: InputMaybe<Scalars['String']['input']>;
  colorNotEmptiedWithTicketStop?: InputMaybe<Scalars['String']['input']>;
  colorPendingStop?: InputMaybe<Scalars['String']['input']>;
  colorSkippedStop?: InputMaybe<Scalars['String']['input']>;
  colorWillReturnStop?: InputMaybe<Scalars['String']['input']>;
  containerWashingApproverRole?: InputMaybe<Scalars['ID']['input']>;
  crmCompanyName?: InputMaybe<Scalars['String']['input']>;
  crmContactsAssignUniqueId?: InputMaybe<Scalars['String']['input']>;
  crmContactsMaskIndividualTaxId?: InputMaybe<Scalars['Boolean']['input']>;
  crmCountry?: InputMaybe<Scalars['String']['input']>;
  crmCustomTextHome?: InputMaybe<Scalars['String']['input']>;
  crmCustomTextHomeTitle?: InputMaybe<Scalars['String']['input']>;
  crmCustomTextLogin?: InputMaybe<Scalars['String']['input']>;
  crmCustomTextLoginTitle?: InputMaybe<Scalars['String']['input']>;
  crmDefaultLanguage?: InputMaybe<Scalars['String']['input']>;
  crmEmailSender?: InputMaybe<Scalars['ID']['input']>;
  /** Show the account overview section (Min konto) in the citizen portal. No backend yet — frontend visibility only. */
  crmEnableAccountOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the authority forms section (Myndighedsskemaer) in the citizen portal. No backend yet — frontend visibility only. */
  crmEnableAuthorityForms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the communication preferences section (Kommunikation), where the citizen picks their primary contact channel. */
  crmEnableCommsPreferences?: InputMaybe<Scalars['Boolean']['input']>;
  crmEnableContainerNotificationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Customer-service-request (CSR) admin surface: staff-facing review of citizen registration requests. No backend yet - frontend visibility only. */
  crmEnableCsrAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Let customers end their own container agreements in the citizen portal (Agreements, a container's menu, End agreement), effective the same day. Off = the portal hides the action and the portal API refuses it (403), so agreements are only ended through the office. */
  crmEnableEndAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable the messages section (Beskeder) in the citizen portal. This is the single switch for messaging: it both shows the section and routes company->citizen ticket messages into it as portal conversations instead of full-body email/SMS. Off by default until the portal conversations backend ships to production. */
  crmEnableMessaging?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the property pools section (Kimppa) in the citizen portal. */
  crmEnablePools?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the products section in the citizen portal. No backend yet — frontend visibility only. */
  crmEnableProducts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the self-registration flow in the citizen portal. No backend yet — frontend visibility only. */
  crmEnableRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the waste report section, where the citizen builds private and business reports aggregating emptying and delivery events with weights and cost, and saves report presets. The YLVA report kind is gated separately by 'crm enable ylva reports'. */
  crmEnableReports?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the services section in the citizen portal. No backend yet — frontend visibility only. */
  crmEnableServices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the YLVA reporting section in the citizen portal (Finnish waste-reporting flow). */
  crmEnableYlvaReports?: InputMaybe<Scalars['Boolean']['input']>;
  crmHostname?: InputMaybe<Scalars['String']['input']>;
  crmLoginLogo?: InputMaybe<Scalars['Upload']['input']>;
  crmLoginMethod?: InputMaybe<Scalars['String']['input']>;
  crmLoginMethodUser?: InputMaybe<Scalars['String']['input']>;
  crmLoginMethodUserIsAdministrator?: InputMaybe<Scalars['Boolean']['input']>;
  crmLoginMethodUserIsCoOwner?: InputMaybe<Scalars['Boolean']['input']>;
  crmLoginMethodUserIsContact?: InputMaybe<Scalars['Boolean']['input']>;
  crmLoginMethodUserIsOwner?: InputMaybe<Scalars['Boolean']['input']>;
  crmLoginMethodUserIsPayer?: InputMaybe<Scalars['Boolean']['input']>;
  crmLogo?: InputMaybe<Scalars['Upload']['input']>;
  crmPdfFooter?: InputMaybe<Scalars['String']['input']>;
  crmPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  crmPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Show the climate footprint (kg CO2e) on the customers' waste report, computed from the dated environmental factors set per waste fraction. Needs the environmental account. */
  crmReportsShowCo2?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show prices on the customers' waste report (total price card, price columns and export). */
  crmReportsShowPrice?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the recycling rate on the customers' waste report (summary card, columns and export). */
  crmReportsShowRecycling?: InputMaybe<Scalars['Boolean']['input']>;
  crmSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  crmSmsSender?: InputMaybe<Scalars['String']['input']>;
  crmSmsSenderSignature?: InputMaybe<Scalars['String']['input']>;
  crmSyncPropertiesFromMasterData?: InputMaybe<Scalars['Boolean']['input']>;
  crmSyncPropertyContactsFromMasterData?: InputMaybe<Scalars['Boolean']['input']>;
  defaultBillingFrequency?: InputMaybe<Scalars['ID']['input']>;
  /** Distance (meters) a driver must be within to mark a stop done manually, on routes not governed by a contract area. Empty = no distance limit. */
  defaultCompletionRadiusMeters?: InputMaybe<Scalars['Int']['input']>;
  dkdpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Which external finance system invoices this company's validated billable events. NONE keeps invoicing in WasteHero. Any other value stops the billing run from bundling events into WasteHero invoices; the finance feeder export writes them to a file in that system's format instead, and credit-note numbers issued there are imported back onto the events. */
  externalFinanceSystem?: InputMaybe<Scalars['String']['input']>;
  fileTemplateAgreementExport?: InputMaybe<Scalars['String']['input']>;
  fileTemplateCoreScheduledExport?: InputMaybe<Scalars['String']['input']>;
  fileTemplateWasteheroRouteExport?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 alpha-2 code of the tenant's public-holiday calendar. Empty = no holiday machinery anywhere (fail-closed). */
  holidayCalendarCountry?: InputMaybe<Scalars['String']['input']>;
  /** Template of the customer notice sent for a cancelled holiday collection. Placeholders: {date}, {holiday}, {address}. */
  holidayCancellationMessage?: InputMaybe<Scalars['String']['input']>;
  /** When on, accepting a 'cancel' holiday outcome in the holiday impact view queues an SMS/e-mail notice to the payer/contact of every affected property. */
  holidayCancellationNotifyCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Company-default policy for collections that fall on a public holiday. Only takes effect once holiday_calendar_country is set; a contract area may override it (routes.Area.holiday_policy). */
  holidayCollectionPolicy?: InputMaybe<Scalars['String']['input']>;
  /** Only meaningful when holiday_collection_policy='spread': how many days forward the round-robin spread walks (1-7). */
  holidaySpreadDays?: InputMaybe<Scalars['Int']['input']>;
  invoicingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  locksmithEmail?: InputMaybe<Scalars['String']['input']>;
  mainPortalFont?: InputMaybe<Scalars['String']['input']>;
  mainPortalFontFamily?: InputMaybe<Scalars['String']['input']>;
  mapCountry?: InputMaybe<Scalars['String']['input']>;
  metabaseEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Require an emailed one-time code as a second step on platform-web logins for this company's office/admin users. Drivers are never challenged. */
  mfaEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Also require the email code on SSO logins. Off = SSO stays single-step (the identity provider owns the second factor); only applies while Email MFA is on. */
  mfaEmailIncludeSso?: InputMaybe<Scalars['Boolean']['input']>;
  operatingWeekdays?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  portalColorSettings?: InputMaybe<Scalars['String']['input']>;
  portalPageSettings?: InputMaybe<PortalPageSettingsInputObject>;
  productPricingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  removeCrmLoginLogo?: InputMaybe<Scalars['Boolean']['input']>;
  removeCrmLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Who may run this company's routes. 'Vehicles on the route scheme' keeps the scheme's vehicle list enforced. 'Any driver, any vehicle' lets any driver in the company run any route with any company vehicle — for operations that rotate drivers and trucks daily. 'Only the route's planned vehicle' is the strictest. */
  routeVehiclePolicy?: InputMaybe<Scalars['String']['input']>;
  /** Default radius (km) around a Shared Collection Point; members outside it are flagged */
  scpDefaultRadiusKm?: InputMaybe<Scalars['Float']['input']>;
  /** How far the sum of member shares may deviate from 100 when the tolerance is enabled (0.05 = 99.95–100.05 accepted). Percentage points, two decimals. */
  scpShareSumTolerancePct?: InputMaybe<Scalars['Float']['input']>;
  secondaryPortalFont?: InputMaybe<Scalars['String']['input']>;
  secondaryPortalFontFamily?: InputMaybe<Scalars['String']['input']>;
  showCountryInAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** At the waste-station stop the driver app asks for the weigh-in (gross) and weigh-out (tare) - or a net - read off the site's bridge, slip number optional. Source 'weighbridge' typed by the driver. */
  skipWeightDriverAtTipEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** With several skips on board: 'equal' splits one load weight equally over them (remainder on the first); 'per_skip' requires every skip to be weighed on its own. */
  skipWeightMixedLoadSplit?: InputMaybe<Scalars['String']['input']>;
  /** The office (or the bridge operator with an office login) adds or corrects the weight on the rental's collection, at any time - including after the return - or matches an imported weigh ticket to the skip. */
  skipWeightOfficeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Skip weights may come off the truck's chassis scale (the driver reads the on-board display; supports the tare-after-tip pattern). Source 'vehicle_scale'. */
  skipWeightTruckScaleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ssoEmailDomains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  suomifiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  supportedLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The day the licence expires. Blank = not entered. */
  wasteCarrierLicenceExpiry?: InputMaybe<Scalars['Date']['input']>;
  /** Who issued the licence (e.g. Environment Agency). */
  wasteCarrierLicenceIssuer?: InputMaybe<Scalars['String']['input']>;
  /** The carrier registration number quoted on customer movement messages (e.g. CBDU123456). Blank = not entered. */
  wasteCarrierLicenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PartialUpdateCompanySettingsPayload = {
  __typename: 'PartialUpdateCompanySettingsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companySettings?: Maybe<CompanySettingsType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  portalPageSettings?: Maybe<Array<Maybe<PortalPageDescriptionSettingType>>>;
};

export type PasswordChange = {
  __typename: 'PasswordChange';
  status?: Maybe<Scalars['String']['output']>;
};

export type PasswordReset = {
  __typename: 'PasswordReset';
  status?: Maybe<Scalars['String']['output']>;
};

export type PasswordResetVerify = {
  __typename: 'PasswordResetVerify';
  status?: Maybe<Scalars['String']['output']>;
};

export type PauseAutomationEnginePayload = {
  __typename: 'PauseAutomationEnginePayload';
  settings: AutomationSettingsDef;
};

export type PayloadType = {
  __typename: 'PayloadType';
  exp?: Maybe<Scalars['Int']['output']>;
  origIat?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodDef = Node & {
  __typename: 'PaymentMethodDef';
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<CardPaymentMethodDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

export type PaymentMethodDefConnection = {
  __typename: 'PaymentMethodDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentMethodDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PaymentMethodDef` and its cursor. */
export type PaymentMethodDefEdge = {
  __typename: 'PaymentMethodDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PaymentMethodDef>;
};

/**
 * The reconciliation view for ONE (contractor, settlement period): system
 * payable vs invoice total, the difference, the per-area breakdown, and the
 * append-only reconciliation records for the period.
 */
export type PeriodReconciliationType = {
  __typename: 'PeriodReconciliationType';
  /** Per-area payable breakdown to locate the difference. */
  areaRows: Array<ReconciliationAreaRowType>;
  /** The current (most recent) reconciliation row, or null. */
  current?: Maybe<PurchaseInvoiceReconciliationType>;
  /** invoiceTotalCents - systemPayableCents (positive = the invoice exceeds the system payable); null when no invoice is recorded. */
  differenceCents?: Maybe<Scalars['Int']['output']>;
  haulerId: Scalars['ID']['output'];
  haulerName?: Maybe<Scalars['String']['output']>;
  invoiceReference: Scalars['String']['output'];
  /** The current row's manually entered invoice total, or null. */
  invoiceTotalCents?: Maybe<Scalars['Int']['output']>;
  month: Scalars['Int']['output'];
  /** Append-only reconciliation rows for the period, newest first. */
  records: Array<PurchaseInvoiceReconciliationType>;
  status: Scalars['String']['output'];
  /** The period's system payable: the SUM of its per-area settlement sections, read from the wave-2 report (never re-derived). */
  systemPayableCents: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

/**
 *
 *     make sure to also add to:
 *     - get_permissions_from_obj_type
 *     - permission_choices_mapping
 *
 */
export enum PermissionChoices {
  AGREEMENT_SUSPENSION_EDIT = 'agreement_suspension__edit',
  AGREEMENT_TEMPLATE_CREATE = 'agreement_template__create',
  AGREEMENT_TEMPLATE_DELETE = 'agreement_template__delete',
  AGREEMENT_TEMPLATE_EDIT = 'agreement_template__edit',
  ALERT_CREATE = 'alert__create',
  ALERT_DELETE = 'alert__delete',
  ALERT_EDIT = 'alert__edit',
  ALERT_RULE_CREATE = 'alert_rule__create',
  ALERT_RULE_DELETE = 'alert_rule__delete',
  ALERT_RULE_EDIT = 'alert_rule__edit',
  ANALYTICS_DASHBOARD_CREATE = 'analytics_dashboard__create',
  ANALYTICS_DASHBOARD_DELETE = 'analytics_dashboard__delete',
  ANALYTICS_DASHBOARD_EDIT = 'analytics_dashboard__edit',
  APPROVAL_COLLECTION_CREATE = 'approval_collection__create',
  APPROVAL_COLLECTION_DELETE = 'approval_collection__delete',
  APPROVAL_COLLECTION_EDIT = 'approval_collection__edit',
  ARCHIVED_DATA_MANAGE = 'archived_data__manage',
  ARCHIVED_DATA_VIEW = 'archived_data__view',
  AUTOMATION_CREATE = 'automation__create',
  AUTOMATION_DELETE = 'automation__delete',
  AUTOMATION_EDIT = 'automation__edit',
  BILLABLE_EVENT_OVERRIDE_LEGAL_CLASS = 'billable_event__override_legal_class',
  BILLING_INFORMATION_CREATE = 'billing_information__create',
  BILLING_INFORMATION_EDIT = 'billing_information__edit',
  BILLING_RUN_CREATE = 'billing_run__create',
  BILLING_RUN_DELETE = 'billing_run__delete',
  BILLING_RUN_EXPORT_CREATE = 'billing_run_export__create',
  COLLECTION_CALENDAR_CREATE = 'collection_calendar__create',
  COLLECTION_CALENDAR_DELETE = 'collection_calendar__delete',
  COLLECTION_CALENDAR_EDIT = 'collection_calendar__edit',
  COLLECTION_CALENDAR_DATE_CREATE = 'collection_calendar_date__create',
  COLLECTION_CALENDAR_DATE_DELETE = 'collection_calendar_date__delete',
  COLLECTION_CALENDAR_DATE_EDIT = 'collection_calendar_date__edit',
  COLLECTION_CALENDAR_DEVIATION_CREATE = 'collection_calendar_deviation__create',
  COLLECTION_CALENDAR_DEVIATION_DELETE = 'collection_calendar_deviation__delete',
  COLLECTION_CALENDAR_DEVIATION_EDIT = 'collection_calendar_deviation__edit',
  COLLECTION_WEEK_CREATE = 'collection_week__create',
  COLLECTION_WEEK_DELETE = 'collection_week__delete',
  COLLECTION_WEEK_EDIT = 'collection_week__edit',
  COMPANY_EDIT = 'company__edit',
  COMPANY_EMAIL_ACCOUNT_CREATE = 'company_email_account__create',
  COMPANY_EMAIL_ACCOUNT_DELETE = 'company_email_account__delete',
  COMPANY_EMAIL_ACCOUNT_EDIT = 'company_email_account__edit',
  COMPANY_EMAIL_ACCOUNT_MESSAGE_DELETE = 'company_email_account_message__delete',
  COMPANY_EMAIL_ACCOUNT_MESSAGE_EDIT = 'company_email_account_message__edit',
  COMPANY_SETTINGS_EDIT = 'company_settings__edit',
  CONTACT_CREATE = 'contact__create',
  CONTACT_DELETE = 'contact__delete',
  CONTACT_EDIT = 'contact__edit',
  CONTACT_FIELD_CONFIGURATION_EDIT = 'contact_field_configuration__edit',
  CONTACT_NDR_EDIT = 'contact_ndr__edit',
  CONTACT_NDR_VIEW = 'contact_ndr__view',
  CONTACT_PIC_EDIT = 'contact_pic__edit',
  CONTACT_PIC_VIEW = 'contact_pic__view',
  CONTACT_PROPERTY_CREATE = 'contact_property__create',
  CONTACT_PROPERTY_DELETE = 'contact_property__delete',
  CONTAINER_CREATE = 'container__create',
  CONTAINER_DELETE = 'container__delete',
  CONTAINER_EDIT = 'container__edit',
  CONTAINER_GROUP_CREATE = 'container_group__create',
  CONTAINER_GROUP_DELETE = 'container_group__delete',
  CONTAINER_GROUP_EDIT = 'container_group__edit',
  CONTAINER_TYPE_CREATE = 'container_type__create',
  CONTAINER_TYPE_DELETE = 'container_type__delete',
  CONTAINER_TYPE_EDIT = 'container_type__edit',
  CONTRACTOR_REPORTING_RECONCILE = 'contractor_reporting__reconcile',
  CONTRACTOR_REPORTING_VIEW = 'contractor_reporting__view',
  CRIIPTO_APPLICATION_CREATE = 'criipto_application__create',
  CRIIPTO_APPLICATION_DELETE = 'criipto_application__delete',
  CRIIPTO_APPLICATION_EDIT = 'criipto_application__edit',
  CRM_COMPOSTING_REGISTRY_CREATE = 'crm_composting_registry__create',
  CRM_COMPOSTING_REGISTRY_DELETE = 'crm_composting_registry__delete',
  CRM_COMPOSTING_REGISTRY_EDIT = 'crm_composting_registry__edit',
  CRM_COMPOSTING_REGISTRY_VIEW = 'crm_composting_registry__view',
  CRM_COMPOSTING_TEMPLATE_MANAGE = 'crm_composting_template__manage',
  CRM_CUSTOMER_FUNCTION_CREATE = 'crm_customer_function__create',
  CRM_CUSTOMER_FUNCTION_DELETE = 'crm_customer_function__delete',
  CRM_CUSTOMER_FUNCTION_EDIT = 'crm_customer_function__edit',
  CRM_CUSTOMER_NOTE_CREATE = 'crm_customer_note__create',
  CRM_CUSTOMER_NOTE_DELETE = 'crm_customer_note__delete',
  CRM_CUSTOMER_NOTE_EDIT = 'crm_customer_note__edit',
  CRM_CUSTOMER_NOTE_VIEW = 'crm_customer_note__view',
  CRM_MUNICIPALITY_CREATE = 'crm_municipality__create',
  CRM_MUNICIPALITY_DELETE = 'crm_municipality__delete',
  CRM_MUNICIPALITY_EDIT = 'crm_municipality__edit',
  CRM_PRICING_CREATE = 'crm_pricing__create',
  CRM_PRICING_DELETE = 'crm_pricing__delete',
  CRM_PRICING_EDIT = 'crm_pricing__edit',
  CRM_PROPERTY_CREATE = 'crm_property__create',
  CRM_PROPERTY_DELETE = 'crm_property__delete',
  CRM_PROPERTY_EDIT = 'crm_property__edit',
  CRM_PROPERTY_GROUP_CREATE = 'crm_property_group__create',
  CRM_PROPERTY_GROUP_DELETE = 'crm_property_group__delete',
  CRM_PROPERTY_GROUP_EDIT = 'crm_property_group__edit',
  CRM_PROPERTY_NOTE_CREATE = 'crm_property_note__create',
  CRM_PROPERTY_NOTE_DELETE = 'crm_property_note__delete',
  CRM_PROPERTY_NOTE_EDIT = 'crm_property_note__edit',
  CRM_PROPERTY_NOTE_VIEW = 'crm_property_note__view',
  CRM_PROPERTY_TYPE_CREATE = 'crm_property_type__create',
  CRM_PROPERTY_TYPE_DELETE = 'crm_property_type__delete',
  CRM_PROPERTY_TYPE_EDIT = 'crm_property_type__edit',
  CRM_SERVICE_CREATE = 'crm_service__create',
  CRM_SERVICE_DELETE = 'crm_service__delete',
  CRM_SERVICE_EDIT = 'crm_service__edit',
  DEBTOR_EXPORT_CREATE = 'debtor_export__create',
  DEPOT_CREATE = 'depot__create',
  DEPOT_DELETE = 'depot__delete',
  DEPOT_EDIT = 'depot__edit',
  DKDP_COMPANY_CREDENTIALS_CREATE = 'dkdp_company_credentials__create',
  DKDP_COMPANY_CREDENTIALS_DELETE = 'dkdp_company_credentials__delete',
  DKDP_COMPANY_CREDENTIALS_EDIT = 'dkdp_company_credentials__edit',
  DOCUMENT_CREATE = 'document__create',
  DOCUMENT_DELETE = 'document__delete',
  DOCUMENT_EDIT = 'document__edit',
  DRIVER_CREATE = 'driver__create',
  DRIVER_DELETE = 'driver__delete',
  DRIVER_EDIT = 'driver__edit',
  EXPORT_TEMPLATE_CREATE = 'export_template__create',
  EXPORT_TEMPLATE_DELETE = 'export_template__delete',
  EXPORT_TEMPLATE_EDIT = 'export_template__edit',
  HAULER_CREATE = 'hauler__create',
  HAULER_DELETE = 'hauler__delete',
  HAULER_EDIT = 'hauler__edit',
  HAULER_VIEW = 'hauler__view',
  HAULER_PRICE_CREATE = 'hauler_price__create',
  HAULER_PRICE_DELETE = 'hauler_price__delete',
  HAULER_PRICE_EDIT = 'hauler_price__edit',
  HAULER_PRICE_VIEW = 'hauler_price__view',
  IMPORT_HISTORY_CREATE = 'import_history__create',
  IMPORT_HISTORY_DELETE = 'import_history__delete',
  IMPORT_HISTORY_EDIT = 'import_history__edit',
  INDUSTRY_CATALOGUE_EDIT = 'industry_catalogue__edit',
  KEY_MANAGE = 'key__manage',
  KEY_VIEW = 'key__view',
  KMD_EASY_FILE_EXPORT_CREATE = 'kmd_easy_file_export__create',
  KMD_EASY_FILE_IMPORT_CREATE = 'kmd_easy_file_import__create',
  KMD_EASY_SETTINGS_EDIT = 'kmd_easy_settings__edit',
  KMD_EASY_STATION_CODE_MAPPING_CREATE = 'kmd_easy_station_code_mapping__create',
  KMD_EASY_STATION_CODE_MAPPING_DELETE = 'kmd_easy_station_code_mapping__delete',
  KMD_EASY_STATION_CODE_MAPPING_EDIT = 'kmd_easy_station_code_mapping__edit',
  LIVE_OPERATIONS_COMPLIANCE_ADMIN = 'live_operations__compliance_admin',
  LIVE_OPERATIONS_VIEW = 'live_operations__view',
  MANAGEMENT_COMPANY_PROPERTY_CREATE = 'management_company_property__create',
  MANAGEMENT_COMPANY_PROPERTY_DELETE = 'management_company_property__delete',
  MEASUREMENT_SETTINGS_CREATE = 'measurement_settings__create',
  MEASUREMENT_SETTINGS_DELETE = 'measurement_settings__delete',
  MEASUREMENT_SETTINGS_EDIT = 'measurement_settings__edit',
  PICKUP_ORDER_CREATE = 'pickup_order__create',
  PICKUP_ORDER_DELETE = 'pickup_order__delete',
  PICKUP_ORDER_EDIT = 'pickup_order__edit',
  PICKUP_SETTINGS_CREATE = 'pickup_settings__create',
  PICKUP_SETTINGS_DELETE = 'pickup_settings__delete',
  PICKUP_SETTINGS_EDIT = 'pickup_settings__edit',
  PORTAL_ROLE_CAPABILITIES_EDIT = 'portal_role_capabilities__edit',
  PORTAL_ROLE_CAPABILITIES_VIEW = 'portal_role_capabilities__view',
  PROJECT_CREATE = 'project__create',
  PROJECT_DELETE = 'project__delete',
  PROJECT_EDIT = 'project__edit',
  PROPERTY_MANAGEMENT_COMPANY_CREATE = 'property_management_company__create',
  PROPERTY_MANAGEMENT_COMPANY_DELETE = 'property_management_company__delete',
  PROPERTY_MANAGEMENT_COMPANY_EDIT = 'property_management_company__edit',
  RFID_VEHICLE_CONNECTION_CREATE = 'rfid_vehicle_connection__create',
  RFID_VEHICLE_CONNECTION_DELETE = 'rfid_vehicle_connection__delete',
  RFID_VEHICLE_CONNECTION_EDIT = 'rfid_vehicle_connection__edit',
  ROLE_CREATE = 'role__create',
  ROLE_DELETE = 'role__delete',
  ROLE_EDIT = 'role__edit',
  ROUTE_CREATE = 'route__create',
  ROUTE_DELETE = 'route__delete',
  ROUTE_EDIT = 'route__edit',
  ROUTE_SCHEME_CREATE = 'route_scheme__create',
  ROUTE_SCHEME_DELETE = 'route_scheme__delete',
  ROUTE_SCHEME_EDIT = 'route_scheme__edit',
  ROUTE_VEHICLE_EDIT = 'route_vehicle__edit',
  SCHEDULED_CHANGE_CANCEL_OTHERS = 'scheduled_change__cancel_others',
  SERVICE_RESPONSIBILITY_CREATE = 'service_responsibility__create',
  SERVICE_RESPONSIBILITY_DELETE = 'service_responsibility__delete',
  SERVICE_RESPONSIBILITY_EDIT = 'service_responsibility__edit',
  SPARE_PART_CREATE = 'spare_part__create',
  SPARE_PART_DELETE = 'spare_part__delete',
  SPARE_PART_EDIT = 'spare_part__edit',
  STOP_LIST_CUSTOMISATION_CONFIG_EDIT = 'stop_list_customisation_config__edit',
  TAX_SETTINGS_MANAGE = 'tax_settings__manage',
  TEAM_CREATE = 'team__create',
  TEAM_DELETE = 'team__delete',
  TEAM_EDIT = 'team__edit',
  TICKET_CATEGORY_CREATE = 'ticket_category__create',
  TICKET_CATEGORY_DELETE = 'ticket_category__delete',
  TICKET_CATEGORY_EDIT = 'ticket_category__edit',
  TICKET_CUSTOM_FIELD_CREATE = 'ticket_custom_field__create',
  TICKET_CUSTOM_FIELD_DELETE = 'ticket_custom_field__delete',
  TICKET_CUSTOM_FIELD_EDIT = 'ticket_custom_field__edit',
  TICKET_CUSTOM_FIELD_VIEW = 'ticket_custom_field__view',
  TICKET_MESSAGE_TEMPLATE_CREATE = 'ticket_message_template__create',
  TICKET_MESSAGE_TEMPLATE_DELETE = 'ticket_message_template__delete',
  TICKET_MESSAGE_TEMPLATE_EDIT = 'ticket_message_template__edit',
  TICKET_TYPE_CREATE = 'ticket_type__create',
  TICKET_TYPE_DELETE = 'ticket_type__delete',
  TICKET_TYPE_EDIT = 'ticket_type__edit',
  TICKET_VISIBILITY_EDIT = 'ticket_visibility__edit',
  TRANSFER_DOCUMENT_EDIT = 'transfer_document__edit',
  TRANSFER_DOCUMENT_VIEW = 'transfer_document__view',
  USER_CREATE = 'user__create',
  USER_DELETE = 'user__delete',
  USER_EDIT = 'user__edit',
  USER_ABSENCE_CREATE = 'user_absence__create',
  USER_ABSENCE_DELETE = 'user_absence__delete',
  USER_ABSENCE_EDIT = 'user_absence__edit',
  USER_PROJECT_CREATE = 'user_project__create',
  USER_PROJECT_DELETE = 'user_project__delete',
  USER_PROJECT_EDIT = 'user_project__edit',
  VEHICLE_CREATE = 'vehicle__create',
  VEHICLE_DELETE = 'vehicle__delete',
  VEHICLE_EDIT = 'vehicle__edit',
  VEHICLE_ABSENCE_CREATE = 'vehicle_absence__create',
  VEHICLE_ABSENCE_DELETE = 'vehicle_absence__delete',
  VEHICLE_ABSENCE_EDIT = 'vehicle_absence__edit',
  VEHICLE_TYPE_CREATE = 'vehicle_type__create',
  VEHICLE_TYPE_DELETE = 'vehicle_type__delete',
  VEHICLE_TYPE_EDIT = 'vehicle_type__edit',
  WASTE_FRACTION_CREATE = 'waste_fraction__create',
  WASTE_FRACTION_DELETE = 'waste_fraction__delete',
  WASTE_FRACTION_EDIT = 'waste_fraction__edit'
}

export type PermissionType = Node & {
  __typename: 'PermissionType';
  codename: Scalars['String']['output'];
  groupSet: GroupTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Specific permissions for this user. */
  userSet: UserTypeConnection;
};


export type PermissionTypeGroupSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PermissionTypeUserSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PermissionTypeConnection = {
  __typename: 'PermissionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PermissionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PermissionType` and its cursor. */
export type PermissionTypeEdge = {
  __typename: 'PermissionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PermissionType>;
};

/**
 * A council permit on a placement. ``status`` is the DERIVED
 * lifecycle status (a granted permit reads active / expiring / expired
 * from its window); ``storedStatus`` is what the office set.
 */
export type PermitDef = Node & {
  __typename: 'PermitDef';
  alertDays: Scalars['Int']['output'];
  authorityEntry?: Maybe<CouncilFeeTableEntryDef>;
  authorityName: Scalars['String']['output'];
  company: CompanyType;
  conditions: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  document?: Maybe<TicketAttachmentDef>;
  /** The permit-fee billable event posted at grant (null until granted, or when no fee product applies). */
  feeEventId?: Maybe<Scalars['ID']['output']>;
  feeProduct?: Maybe<PpProductDef>;
  grantedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  property: PropertyDef;
  reference: Scalars['String']['output'];
  requestedBy?: Maybe<UserType>;
  status: PermitStatus;
  storedStatus: PermitStatus;
  ticket?: Maybe<TicketDef>;
  validFrom?: Maybe<Scalars['Date']['output']>;
  validTo?: Maybe<Scalars['Date']['output']>;
};

export type PermitDefConnection = {
  __typename: 'PermitDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PermitDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PermitDef` and its cursor. */
export type PermitDefEdge = {
  __typename: 'PermitDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PermitDef>;
};

/**
 * The permit lifecycle; ACTIVE / EXPIRING / EXPIRED are derived from
 * a granted permit's window and cannot be sent as input.
 */
export enum PermitStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  EXPIRING = 'EXPIRING',
  GRANTED = 'GRANTED',
  REFUSED = 'REFUSED',
  REQUESTED = 'REQUESTED'
}

/**
 * The permit chip on a rentals row: derived status, expiry and the
 * council reference (``RentalRowType.permit``).
 */
export type PermitSummaryType = {
  __typename: 'PermitSummaryType';
  authorityName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  status: PermitStatus;
  validFrom?: Maybe<Scalars['Date']['output']>;
  validTo?: Maybe<Scalars['Date']['output']>;
};

/** A physical key / remote / tag tracked as a company asset. */
export type PhysicalKeyType = Node & {
  __typename: 'PhysicalKeyType';
  collectionLocation?: Maybe<CollectionLocationDef>;
  contact?: Maybe<PropertyContactDef>;
  createdAt: Scalars['DateTime']['output'];
  feeSnapshot?: Maybe<Scalars['Decimal']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  instructions: Scalars['String']['output'];
  isFree: Scalars['Boolean']['output'];
  issuedByTicketId?: Maybe<Scalars['ID']['output']>;
  keyId: Scalars['String']['output'];
  keyType: KeyTypeType;
  pickupDatetime?: Maybe<Scalars['DateTime']['output']>;
  property?: Maybe<PropertyDef>;
  replacedById?: Maybe<Scalars['ID']['output']>;
  returnedByTicketId?: Maybe<Scalars['ID']['output']>;
  status: CrmPhysicalKeyStatusChoices;
};

export type PhysicalKeyTypeConnection = {
  __typename: 'PhysicalKeyTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PhysicalKeyTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PhysicalKeyType` and its cursor. */
export type PhysicalKeyTypeEdge = {
  __typename: 'PhysicalKeyTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PhysicalKeyType>;
};

export type PickUpOrderApprovalCollectionAddApprovals = {
  __typename: 'PickUpOrderApprovalCollectionAddApprovals';
  approvalCollection?: Maybe<PickUpOrderApprovalCollectionDef>;
};

export type PickUpOrderApprovalCollectionDef = Node & {
  __typename: 'PickUpOrderApprovalCollectionDef';
  averageWeightDeviation?: Maybe<Scalars['Float']['output']>;
  company: CompanyType;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<UserType>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pickuporderapprovalSet: PickUpOrderApprovalDefConnection;
  properties?: Maybe<Scalars['Int']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  totalWeight?: Maybe<Scalars['Float']['output']>;
  wasteFractions?: Maybe<Array<Maybe<WasteFractionType>>>;
};


export type PickUpOrderApprovalCollectionDefPickuporderapprovalSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PickUpOrderApprovalCollectionDefConnection = {
  __typename: 'PickUpOrderApprovalCollectionDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PickUpOrderApprovalCollectionDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PickUpOrderApprovalCollectionDef` and its cursor. */
export type PickUpOrderApprovalCollectionDefEdge = {
  __typename: 'PickUpOrderApprovalCollectionDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PickUpOrderApprovalCollectionDef>;
};

export type PickUpOrderApprovalCollectionDeleteApprovals = {
  __typename: 'PickUpOrderApprovalCollectionDeleteApprovals';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PickUpOrderApprovalCollectionUpdateApprovals = {
  __typename: 'PickUpOrderApprovalCollectionUpdateApprovals';
  approvalCollection?: Maybe<PickUpOrderApprovalCollectionDef>;
};

export type PickUpOrderApprovalDef = Node & {
  __typename: 'PickUpOrderApprovalDef';
  approvalCollection: PickUpOrderApprovalCollectionDef;
  company: CompanyType;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<UserType>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  pickupOrder: PickUpOrderType;
  weightDeviation?: Maybe<Scalars['Int']['output']>;
};

export type PickUpOrderApprovalDefConnection = {
  __typename: 'PickUpOrderApprovalDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PickUpOrderApprovalDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PickUpOrderApprovalDef` and its cursor. */
export type PickUpOrderApprovalDefEdge = {
  __typename: 'PickUpOrderApprovalDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PickUpOrderApprovalDef>;
};

export type PickUpOrderEventDef = Node & {
  __typename: 'PickUpOrderEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<PickUpOrderEventTypesGraphene>>>;
  fromCompletedDate?: Maybe<Scalars['DateTime']['output']>;
  fromStatus?: Maybe<Scalars['String']['output']>;
  fromWeight?: Maybe<Scalars['Float']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  pickuporder?: Maybe<PickUpOrderType>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toCompletedDate?: Maybe<Scalars['DateTime']['output']>;
  toStatus?: Maybe<Scalars['String']['output']>;
  toWeight?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<UserType>;
};

export enum PickUpOrderEventTypesGraphene {
  COMPLETED_DATE_CHANGE = 'COMPLETED_DATE_CHANGE',
  CONTAINER_CHANGE = 'CONTAINER_CHANGE',
  LOAD_CHANGE = 'LOAD_CHANGE',
  STATUS_CHANGE = 'STATUS_CHANGE',
  WEIGHT_CHANGE = 'WEIGHT_CHANGE'
}

export type PickUpOrderEventsWrapper = {
  __typename: 'PickUpOrderEventsWrapper';
  edges?: Maybe<Array<Maybe<PickUpOrderEventDef>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * Output for the ``pickupOrderHaulerTraceability`` query.
 *
 * Uses lazy string references for cross-module types
 * (``fleet_management.schema.RouteVehicleType``) to avoid an import cycle
 * with this module.
 */
export type PickUpOrderHaulerTraceabilityType = {
  __typename: 'PickUpOrderHaulerTraceabilityType';
  hauler?: Maybe<HaulerDef>;
  haulerReassignmentLogs: Array<Maybe<RouteHaulerReassignmentLogType>>;
  pickupOrderId: Scalars['String']['output'];
  reassignmentLogs: Array<Maybe<RouteVehicleDriverReassignmentLogType>>;
  route?: Maybe<RouteType>;
  routeVehicles: Array<Maybe<RouteVehicleType>>;
  scheduledDay?: Maybe<Scalars['Date']['output']>;
};

/**
 * PRO-261/353 (3.2.39): a physical key the driver must bring for a locked
 * collection point.
 *
 * A ``PhysicalKey`` attaches to the locked point through
 * ``PhysicalKey.collection_location`` (``crm.CollectionLocation``); the
 * collection location carries the ``device.Container`` serviced at the
 * stop, so a stop surfaces the key(s) registered against its container's
 * collection location.
 *
 * PRO-353: the driver/contractor feed exposes only the key kind (type
 * label) + effective instructions. The human ``key_id`` is routed through
 * the single masking policy point (``crm.policies.keys.mask_key_identifier``)
 * and is ``""`` (empty string) for every driver/contractor viewer — they
 * never receive an identifier. The field is kept (masked to "") rather than
 * dropped so the decision stays owned by the one policy, not an ad-hoc field
 * removal. Masking to "" (not null) keeps the field a non-null ``String!``.
 */
export type PickUpOrderKeyInfo = {
  __typename: 'PickUpOrderKeyInfo';
  /** Handover instructions — the PhysicalKey override when set, otherwise the KeyType default. */
  instructions: Scalars['String']['output'];
  /** Human-facing key identifier — masked to "" (empty string) on the driver/contractor feed via the masking policy (PRO-353). */
  keyId: Scalars['String']['output'];
  /** Name of the key's KeyType. */
  keyType: Scalars['String']['output'];
};

export type PickUpOrderToBringItem = PickUpOrderKeyInfo | ToBringContainerDef;

export type PickUpOrderType = Node & {
  __typename: 'PickUpOrderType';
  /** Driver's free-text note on an abortive visit. */
  abortiveNote?: Maybe<Scalars['String']['output']>;
  /** The visit could not be carried out (wasted journey): why. The stop is recorded as skipped and the ticket re-opened for rescheduling. */
  abortiveReason?: Maybe<RoutesPickUpOrderAbortiveReasonChoices>;
  /** Current agreement linked through the stop's container. Null for ticket stops (no container) and for container stops that have no agreement on record. */
  agreement?: Maybe<AgreementDef>;
  area?: Maybe<AreaDef>;
  /** Which signal confirmed this stop: MANUAL (the driver tapped), RADIUS (geofence), RFID / NFC (tag read), LIFT (vehicle reported a bin-lift cycle) or SCALE (vehicle's on-board weighing). Null means genuinely unknown — the stop predates the column or holds an unrecognised value — never 'manual'. */
  autoCompletedBy?: Maybe<RoutesPickUpOrderAutoCompletedByChoices>;
  /** When the tag was READ. Distinct from completed_at, which the app may normalise across a correlation window so a simultaneous read lands as one collection instant. */
  autoConfirmReadAt?: Maybe<Scalars['DateTime']['output']>;
  /** Which reader reported the tag (REQ 42 allows two readers to identify two containers at the same moment). NULL when the reader did not identify itself. */
  autoConfirmReaderId?: Maybe<Scalars['String']['output']>;
  /** The RFID/NFC tag id that automatically confirmed this stop. NULL for manual completions and for every row completed before the reader integration existed. */
  autoConfirmTag?: Maybe<Scalars['String']['output']>;
  canBeReset?: Maybe<Scalars['Boolean']['output']>;
  /** The confirmed station stop that closed this load (HSY req 34). The station stop is not a member of the load — it is where the load ended — so the link lives here, not on PickUpOrder.load. NULL for a load closed without a station stop. */
  closedLoads: TruckloadTypeConnection;
  /** Exchange: identity of the OLD unit taken away. */
  collectedIdentity?: Maybe<Scalars['String']['output']>;
  /** Real time when driver finish pickup */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who completed the stop manually */
  completedManualBy?: Maybe<UserType>;
  /** Meters between the bin and the driver's GPS at completion (proof-of-service 'how close'). NULL if no field GPS. */
  completionDistanceM?: Maybe<Scalars['Float']['output']>;
  /** Provenance of completion_distance_m: 'breadcrumb' (server GPS stream, always preferred), 'client' (device-reported position, re-measured server-side) or 'client_reported' (a distance the device computed, kept only when nothing could be re-measured). NULL on rows stamped before this field existed. */
  completionDistanceSource?: Maybe<RoutesPickUpOrderCompletionDistanceSourceChoices>;
  /** Horizontal accuracy of completion_point in meters, as reported by the device. NULL when unknown. */
  completionGpsAccuracyM?: Maybe<Scalars['Float']['output']>;
  /** When the GPS fix behind completion_point was taken — NOT when the completion reached the server. An offline completion syncs days later; the fix time is what makes the position evidence. */
  completionGpsCapturedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Where the driver was when they confirmed this stop, as reported by their device (x=longitude, y=latitude). NULL when no position was captured. */
  completionPoint?: Maybe<Scalars['GeoJSON']['output']>;
  /** The completion radius the DEVICE applied when it decided whether to demand a verification, in meters. Recorded as the driver saw it: if it disagrees with the radius the server resolves today, the office can see that it did. */
  completionRadiusM?: Maybe<Scalars['Float']['output']>;
  /** Stop this signal confirmed. NULL when unmatched. */
  confirmationSignals: VehicleConfirmationSignalTypeConnection;
  container?: Maybe<ContainerType>;
  containerLevelTicketStopCount?: Maybe<Scalars['Int']['output']>;
  /** Contract area this task belongs to (the tender contract link). Stamped at creation from the container's agreement/property evidence and kept for historical billing. */
  contractArea?: Maybe<AreaDef>;
  createdAt: Scalars['DateTime']['output'];
  createdFrom: RoutesPickUpOrderCreatedFromChoices;
  createdFromManualBy?: Maybe<UserType>;
  createdInquiry?: Maybe<CollectionInquiryType>;
  createdTicket?: Maybe<TicketDef>;
  createdTickets: TicketDefConnection;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** Exchange: identity of the NEW unit put down. */
  deliveredIdentity?: Maybe<Scalars['String']['output']>;
  depot?: Maybe<DepotType>;
  description?: Maybe<Scalars['String']['output']>;
  /** When a route re-optimisation took this pending stop off its route. Empty for stops on a route and for stops removed any other way. */
  detachedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Why the re-optimisation took this stop off its route. */
  detachedReason?: Maybe<RoutesPickUpOrderDetachedReasonChoices>;
  /** THE number to show the driver and to quote to the office. Stable for the life of the route: it does not change when the route is re-optimised, when stops are completed, reset, moved or reordered, and a number is never reused for a different address. Use this for the stop-card badge — `stopNumber` is the driving sequence and is rewritten on a live route (COMPASS-973). Always safe to read: it falls back to `stopNumber` on routes generated before this field existed, and on tenants outside the STABLE_STOP_NUMBER_PROJECT_IDS rollout (where it is exactly `stopNumber`, i.e. the pre-COMPASS-973 behaviour). */
  displayNumber?: Maybe<Scalars['Int']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  /** When the server ACCEPTED the override. Distinct from completed_at and from completion_gps_captured_at: an offline override is accepted when it syncs, not when it was made. */
  distanceVerificationAt?: Maybe<Scalars['DateTime']['output']>;
  /** WHO overrode the completion-radius guard. The actor of the completion mutation, stamped server-side — never taken from the client payload. */
  distanceVerificationBy?: Maybe<UserType>;
  /** Free-text the driver added to the verification. Optional even when a reason is given. */
  distanceVerificationNote?: Maybe<Scalars['String']['output']>;
  /** The driver's explanation for confirming anyway (gps_unavailable, gps_interference, collected_from_another_point, no_safe_access, other). This is what satisfies the completion-radius guard; without it an out-of-range completion is still refused. */
  distanceVerificationReason?: Maybe<RoutesPickUpOrderDistanceVerificationReasonChoices>;
  /** Which check demanded the extra verification: 'out_of_range' (measured farther than the radius), 'no_position' (no GPS fix at all) or 'stale_position' (the fix was too old to trust). Machine-determined, never driver-chosen. */
  distanceVerificationTrigger?: Maybe<RoutesPickUpOrderDistanceVerificationTriggerChoices>;
  driverpushnotificationSet: DriverPushNotificationTypeConnection;
  estimatedFillPercentage?: Maybe<Scalars['Float']['output']>;
  estimatedWeight?: Maybe<Scalars['Float']['output']>;
  eventLog?: Maybe<PickUpOrderEventsWrapper>;
  /** The other leg of a skip exchange this stop belongs to (collection <-> delivery of the replacement). Empty on every other stop. */
  exchangePair?: Maybe<PickUpOrderType>;
  externalCollectionEvents: ExternalCollectionEventDefConnection;
  /** The weighing system's own id for this measurement — the idempotency key a re-sent WeighTicket is matched on, and the audit link back to it. Indexed because the ingest looks stops up by it. */
  externalWeighingId?: Maybe<Scalars['String']['output']>;
  fillLevel?: Maybe<Scalars['Float']['output']>;
  fillPercentage?: Maybe<Scalars['Float']['output']>;
  /** Executing contractor, denormalised from route.hauler at creation and re-stamped when the stop moves to another hauler's route. */
  hauler?: Maybe<HaulerDef>;
  haulerReassignmentLogs: TaskHaulerReassignmentLogTypeConnection;
  /** Original planned date before a public-holiday policy moved this stop. Null = never shifted. route.scheduledDay already holds the (possibly shifted) day this stop is actually on. */
  holidayShiftedFrom?: Maybe<Scalars['Date']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** True when this stop is the first task of a NEW waste service (HSY req 7 / COMPASS-1648): the container has an active agreement that was started through a WasteHero ticket and no stop on it has been completed since that agreement started. The driver app alerts the driver to locate and check the collection point. Always false for depot and ticket stops. */
  isFirstTaskOfNewService: Scalars['Boolean']['output'];
  /** When this stop's container was last COMPLETED on any route before this stop (skipped stops do not count). Null when the container was never collected in WasteHero. */
  lastCollectionDate?: Maybe<Scalars['DateTime']['output']>;
  /** The load (kuorma) this container was emptied into, stored at task confirmation. Null for a stop that entered no load (a skip, a depot stop, a stop confirmed before the feature), and always null for a company without truckload tracking. */
  load?: Maybe<TruckloadType>;
  /** The anchor collection task. Completed once, at 'unloaded'. SET_NULL rather than CASCADE so deleting a task never silently erases the record that a unit is on a truck. */
  loadUnitJobs: LoadUnitJobTypeConnection;
  /** pallet | compactor | skip when this task's container is a load unit and the driver app must confirm it in three steps (loaded, emptied, unloaded — HSY REQ 249); null otherwise. Configuration first (ContainerType.loadUnitType), then the container-type / loading-method name heuristic the app has used since mobile PR #306. */
  loadUnitType?: Maybe<Scalars['String']['output']>;
  /** Label / barcode / RFID text of the skip the driver loaded for this rental delivery, as scanned. Dispatches the rental at completion; a wrong-type scan is refused before anything is written. */
  loadedContainerIdentity?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LocationType>;
  measurementCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  measurementFillLevel?: Maybe<Scalars['Float']['output']>;
  measurementFillPercentage?: Maybe<Scalars['Float']['output']>;
  navigationLocation?: Maybe<LocationType>;
  orderId: Scalars['UUID']['output'];
  orderType?: Maybe<Scalars['String']['output']>;
  /** The chained pallet/compactor confirmation currently OPEN on this task (loaded, or emptied but not yet unloaded), or null. Non-null means the task is PENDING: the unit is on a truck, so the task is neither done nor missed. Deliberately not a fourth PickUpOrderStatus — that enum is consumed by reporting, invoicing, settlement, reliability and live-ops. */
  pendingLoadUnitJob?: Maybe<LoadUnitJobType>;
  pickuporderapproval?: Maybe<PickUpOrderApprovalDef>;
  propertyLevelTicketStopCount?: Maybe<Scalars['Int']['output']>;
  propertyNumber?: Maybe<Scalars['String']['output']>;
  /** on_time | late | missed | pending | excluded — THE classification the reliability %, settlement and the scorecards count (PRO-119, one metrics service). A 'missed' pill on the Activities → Tasks table is exactly the Missed reliability counts; 'pending' = not yet due; 'excluded' = office-excused (leaves the counts, stays visible). Null for stops outside the reliability population (depot/unloading stops, administratively skipped stops, stops without an area, routes without a contractor). */
  reliabilityClassification?: Maybe<Scalars['String']['output']>;
  reliabilityExclusions: ReliabilityExclusionTypeConnection;
  rentalRelocations: Array<RentalRelocationDef>;
  resetWillReturn: Scalars['Boolean']['output'];
  route?: Maybe<RouteType>;
  routeinformationSet: RouteInformationTypeConnection;
  /** Scheduled driver arrival to pickup location */
  scheduledDriverArrival?: Maybe<Scalars['Time']['output']>;
  /** Why this stop deviated (overfilled, access blocked, not presented, ...). Office-set; historical rows are unspecified. */
  skipReason?: Maybe<RoutesPickUpOrderSkipReasonChoices>;
  sludgeTankInfo?: Maybe<SludgeTankStopInfo>;
  /** PickUp order status. Null when the stored value is not a recognised status — the row still renders (with an em-dash status) instead of failing the whole list. */
  status?: Maybe<RoutesPickUpOrderStatusChoices>;
  stopNumber: Scalars['Int']['output'];
  /** The temporary relocation that puts this task's container at a TEMPORARY coordinate on the TASK'S date (its route's scheduledDay; today for an unrouted task), or null. Same half-open window convention as route generation (PRO-250): the container is back home starting the morning of periodEndDate. originalLocation on the result is where the container usually lives. */
  temporaryRelocation?: Maybe<TemporaryContainerLocationType>;
  ticket?: Maybe<TicketDef>;
  ticketLevelStopsCount?: Maybe<Scalars['Int']['output']>;
  toBring: Array<PickUpOrderToBringItem>;
  /** The live SIIRTO transfer document of this stop, or null. Non-null only for eligible stops of a company with siirto_enabled once the driver (or ensureTransferDocument) opened it. */
  transferDocument?: Maybe<TransferDocumentType>;
  /** Whether this stop needs a SIIRTO transfer document before it can be completed (company flag on + eligible container). */
  transferDocumentRequired?: Maybe<Scalars['Boolean']['output']>;
  undoneCorrections: WorkTaskCorrectionTypeConnection;
  updatedAt: Scalars['DateTime']['output'];
  useGroup: Scalars['Boolean']['output'];
  /** Vehicle session when the stop was added by a driver */
  vehicleSessionAdded?: Maybe<RouteVehicleSessionType>;
  /** Vehicle session when the stop was completed by a driver */
  vehicleSessionCompleted?: Maybe<RouteVehicleSessionType>;
  versions: PickUpOrderTypeConnection;
  volume?: Maybe<Scalars['Float']['output']>;
  /** Wait-and-load: when the truck stopped waiting. Minutes beyond the fee product's free window bill per block. */
  waitingEndedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Wait-and-load: when the truck started waiting on site. */
  waitingStartedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unloading stop this weighing was attached to. */
  weighTickets: WeighTicketTypeConnection;
  weight?: Maybe<Scalars['Float']['output']>;
  weightAmount?: Maybe<Scalars['Int']['output']>;
  weightDeviation?: Maybe<Scalars['Int']['output']>;
  /** Gross (laden) weight in kilograms as measured. NULL when the source reported only a net figure. */
  weightGrossKg?: Maybe<Scalars['Float']['output']>;
  /** When the SCALE measured — not when the row was written and not when the stop was completed. An offline confirmation reaches the server hours later; the measurement time is what makes the weight evidence. */
  weightMeasuredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Net weight of the load in kilograms — the number `weight` mirrors. Explicit net wins over gross minus tare. */
  weightNetKg?: Maybe<Scalars['Float']['output']>;
  /** Where this weight came from: weighbridge (the site's certified scale, via ingestWeighTicket), vehicle_scale (on-board mScales / Once), manual (the driver typed it — REQ 18's fallback), import, or unknown. NULL means no provenance was ever recorded — a weaker statement than 'unknown'. */
  weightSource?: Maybe<RoutesPickUpOrderWeightSourceChoices>;
  /** Vendor key of the weighing system ('mscales', 'once', a site's own key). Free-form on purpose: the vendor list is the customer's, not ours. */
  weightSystem?: Maybe<Scalars['String']['output']>;
  /** Tare (empty vehicle) weight in kilograms. NULL when the source reported only a net figure. */
  weightTareKg?: Maybe<Scalars['Float']['output']>;
  /** The weighing-slip number printed at the site. What a driver, an auditor or the receiving facility quotes. */
  weightTicketNumber?: Maybe<Scalars['String']['output']>;
  /** The unit the SOURCE reported this weighing in (kg / t / lb). The stored numbers are always kilograms; this records what the site's slip said so the office can reconcile without re-deriving the rounding. NULL when never stated. */
  weightUnit?: Maybe<RoutesPickUpOrderWeightUnitChoices>;
};


export type PickUpOrderTypeClosedLoadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  openedAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type PickUpOrderTypeConfirmationSignalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PickUpOrderTypeCreatedTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PickUpOrderTypeDriverpushnotificationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PickUpOrderTypeEventLogArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pickupOrderEventTypes?: InputMaybe<Array<InputMaybe<PickUpOrderEventTypesGraphene>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type PickUpOrderTypeExternalCollectionEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PickUpOrderTypeHaulerReassignmentLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PickUpOrderTypeLoadUnitJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PickUpOrderTypeReliabilityExclusionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PickUpOrderTypeRouteinformationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PickUpOrderTypeUndoneCorrectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PickUpOrderTypeVersionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PickUpOrderTypeWeighTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PickUpOrderTypeConnection = {
  __typename: 'PickUpOrderTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PickUpOrderTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PickUpOrderType` and its cursor. */
export type PickUpOrderTypeEdge = {
  __typename: 'PickUpOrderTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PickUpOrderType>;
};

export type PickupDayType = Node & {
  __typename: 'PickupDayType';
  containerSet: ContainerTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pickupSettings?: Maybe<PickupSettingsType>;
  timeFrom: Scalars['Time']['output'];
  timeTo: Scalars['Time']['output'];
  weekday?: Maybe<Scalars['String']['output']>;
};


export type PickupDayTypeContainerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupDayTypeConnection = {
  __typename: 'PickupDayTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PickupDayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PickupDayType` and its cursor. */
export type PickupDayTypeEdge = {
  __typename: 'PickupDayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PickupDayType>;
};

export type PickupSettingsEventDef = Node & {
  __typename: 'PickupSettingsEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<PickupSettingsEventTypesGraphene>>>;
  fromAllowedHoursFrom?: Maybe<Scalars['Time']['output']>;
  fromAllowedHoursTo?: Maybe<Scalars['Time']['output']>;
  fromAmountDaysBetweenPickups?: Maybe<Scalars['Int']['output']>;
  fromCollectionPerWeek?: Maybe<Scalars['Int']['output']>;
  fromEmptyingIntervalFrom?: Maybe<Scalars['Int']['output']>;
  fromEmptyingIntervalTo?: Maybe<Scalars['Int']['output']>;
  fromExcludeDays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fromFirstCollection?: Maybe<Scalars['Date']['output']>;
  fromFixedPickupsPeriod?: Maybe<Scalars['String']['output']>;
  fromMinimumDaysBetweenPickup?: Maybe<Scalars['Int']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  fromPickupInterval?: Maybe<Scalars['String']['output']>;
  fromPickupRepeatPeriod?: Maybe<Scalars['Int']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  pickupSettings?: Maybe<PickupSettingsType>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toAllowedHoursFrom?: Maybe<Scalars['Time']['output']>;
  toAllowedHoursTo?: Maybe<Scalars['Time']['output']>;
  toAmountDaysBetweenPickups?: Maybe<Scalars['Int']['output']>;
  toCollectionPerWeek?: Maybe<Scalars['Int']['output']>;
  toEmptyingIntervalFrom?: Maybe<Scalars['Int']['output']>;
  toEmptyingIntervalTo?: Maybe<Scalars['Int']['output']>;
  toExcludeDays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  toFirstCollection?: Maybe<Scalars['Date']['output']>;
  toFixedPickupsPeriod?: Maybe<Scalars['String']['output']>;
  toMinimumDaysBetweenPickup?: Maybe<Scalars['Int']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
  toPickupInterval?: Maybe<Scalars['String']['output']>;
  toPickupRepeatPeriod?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<UserType>;
};

export enum PickupSettingsEventTypesGraphene {
  COLLECTION_PER_WEEK_CHANGE = 'COLLECTION_PER_WEEK_CHANGE',
  MINIMUM_DAYS_BETWEEN_PICKUP_CHANGE = 'MINIMUM_DAYS_BETWEEN_PICKUP_CHANGE',
  NAME_CHANGE = 'NAME_CHANGE',
  PICKUP_REPEAT_PERIOD_CHANGE = 'PICKUP_REPEAT_PERIOD_CHANGE'
}

export type PickupSettingsType = Node & {
  __typename: 'PickupSettingsType';
  allowedHoursFrom?: Maybe<Scalars['Time']['output']>;
  allowedHoursTo?: Maybe<Scalars['Time']['output']>;
  amountDaysBetweenPickups?: Maybe<Scalars['Int']['output']>;
  collectionPerWeek?: Maybe<Scalars['Int']['output']>;
  collectioncalendarSet: CollectionCalendarDefConnection;
  collectionsInAYear?: Maybe<Scalars['Int']['output']>;
  container?: Maybe<ContainerType>;
  containerTypes: ContainerTypeTypeConnection;
  containersCount?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  emptyingIntervalFrom?: Maybe<Scalars['Time']['output']>;
  emptyingIntervalTo?: Maybe<Scalars['Time']['output']>;
  excludeDays?: Maybe<Array<Scalars['String']['output']>>;
  firstCollection?: Maybe<Scalars['Date']['output']>;
  fixedPickupsPeriod?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  latestCollectionCalendarDate?: Maybe<Scalars['Date']['output']>;
  minimumDaysBetweenPickup?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pickupDay: PickupDayTypeConnection;
  pickupInterval?: Maybe<Scalars['String']['output']>;
  pickupRepeatPeriod?: Maybe<Scalars['Int']['output']>;
  pickupSetting: ContainerTypeConnection;
  project?: Maybe<ProjectType>;
  scheduledexportSet: ScheduledExportDefConnection;
  scheduledexportrunSet: ScheduledExportRunDefConnection;
};


export type PickupSettingsTypeCollectioncalendarSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PickupSettingsTypeContainerTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PickupSettingsTypePickupDayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PickupSettingsTypePickupSettingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PickupSettingsTypeScheduledexportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PickupSettingsTypeScheduledexportrunSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupSettingsTypeConnection = {
  __typename: 'PickupSettingsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PickupSettingsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PickupSettingsType` and its cursor. */
export type PickupSettingsTypeEdge = {
  __typename: 'PickupSettingsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PickupSettingsType>;
};

/**
 * Pin a price list to an Account (G2S1-M2, HAUL-203): the Account's
 * order lines price through this list first (its inheritance chain,
 * child before parent), falling back honestly. Replaces any previous
 * pin, keeping the trail (soft delete).
 */
export type PinAccountPriceList = {
  __typename: 'PinAccountPriceList';
  priceList?: Maybe<HaulerPriceListDef>;
};

/**
 * RS-504: the exact affected-household diff vs the reference
 * calendar (Norddal semantics: a household is affected when any of
 * its fraction-day assignments changed).
 *
 * SBX-491 (rewalk finding 1): the household figures are PROPERTY
 * figures and are nullable: when the plan's rows do not map to real
 * properties (or there are no rows) they serve null and
 * ``propertyMapping`` carries the machine reason
 * (``property_mapping_missing``) plus a planner sentence, never a
 * confident zero. ``unit`` states what the figures count.
 *
 * D7b (same doctrine, the change axis): the CHANGE figures
 * (``affectedHouseholds``, ``disruptionPct``, ``changedEntries``,
 * ``changedByFraction``) are nullable too: when the plan's solve
 * saw no reference calendar the flags they would count were never
 * stamped, so they serve null and ``changeBasis`` carries the
 * machine reason (``reference_calendar_missing``) plus a planner
 * sentence, never a zero the same plan's day structure
 * contradicts.
 */
export type PlanCalendarDiffDef = {
  __typename: 'PlanCalendarDiffDef';
  affectedHouseholds?: Maybe<Scalars['Int']['output']>;
  /** D7b: {supported, reason, text}. reason='reference_calendar_missing' plus a planner sentence when the change figures are refused because the plan's solve carried no reference calendar (the area had no live master plan); the frontend keys on the reason, never on the text. */
  changeBasis?: Maybe<Scalars['GenericScalar']['output']>;
  /** Changed calendar rows per fraction; null when the change figures are refused (changeBasis says why). */
  changedByFraction?: Maybe<Scalars['GenericScalar']['output']>;
  /** D7b: exact changed-row count; null when the change figures are refused because the solve saw no reference calendar (changeBasis says why). */
  changedEntries?: Maybe<Scalars['Int']['output']>;
  /** SBX-325 (D32): the explicit stops-vs-households note when the two denominators differ (several bins sharing one property is real; the surface says it); null when they agree. */
  denominatorNote?: Maybe<Scalars['String']['output']>;
  disruptionPct?: Maybe<Scalars['Float']['output']>;
  plan: PlanDef;
  /** SBX-491: {supported, property_refs, stop_stand_in_refs, reason, text}. reason='property_mapping_missing' plus a planner sentence when the property figures are refused. */
  propertyMapping?: Maybe<Scalars['GenericScalar']['output']>;
  /** SBX-325 (D32): the snapshot's stop count beside the household denominator; null when the scenario carries no stop set. */
  stopCount?: Maybe<Scalars['Int']['output']>;
  totalHouseholds?: Maybe<Scalars['Int']['output']>;
  /** SBX-491: the unit of the household figures ('properties'); null when the figures are refused. */
  unit?: Maybe<Scalars['String']['output']>;
};

export type PlanCalendarEntryDef = Node & {
  __typename: 'PlanCalendarEntryDef';
  changedVsReference: Scalars['Boolean']['output'];
  fraction: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** RS-504 date projection: this entry's collection dates in [fromDate, toDate], week parity anchored on the planning area's parity_anchor_date (survives ISO week 53), with the region pack's C-012 holiday displacement applied. Each item is {date, scheduled, displaced}. */
  occurrences?: Maybe<Scalars['GenericScalar']['output']>;
  plan: PlanDef;
  propertyRef: Scalars['String']['output'];
  weekday: Scalars['Int']['output'];
  weeks: Scalars['JSONString']['output'];
};


export type PlanCalendarEntryDefOccurrencesArgs = {
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};

export type PlanCalendarEntryDefConnection = {
  __typename: 'PlanCalendarEntryDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlanCalendarEntryDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PlanCalendarEntryDef` and its cursor. */
export type PlanCalendarEntryDefEdge = {
  __typename: 'PlanCalendarEntryDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PlanCalendarEntryDef>;
};

/** One plan column in the RS-204 comparison. */
export type PlanComparisonColumnDef = {
  __typename: 'PlanComparisonColumnDef';
  /** SBX-498: the EUR/yr annualization behind this column's yearly money, {applies, cycle_weeks, weeks_per_year, factor, note}. */
  annualization?: Maybe<Scalars['GenericScalar']['output']>;
  /** T2 (D69, D32): the comparability grade of this column's deltas against the comparison's column-zero baseline: {at_grade, grade, missing: [{key, label}]}. Below grade the frontend renders 'Not comparable yet' with the named missing pieces and demotes actions; derived conservatively from recorded stamps and caveats (services.comparability). */
  comparability?: Maybe<Scalars['GenericScalar']['output']>;
  /** SBX-531 (D82): the what-is-behind-this-number block for this column's EUR/yr figures, the same shape PlanDef serves ({currency, rates, disposal, distance, annualization, sentences}); render the sentences verbatim beside the column's price. */
  costBasis?: Maybe<Scalars['GenericScalar']['output']>;
  /** T1 (D67): True when this plan's money and the baseline's PROVABLY carry different currency labels (only reachable when a side predates rate-set stamping: stamped books hash their currency). The cost delta is refused (currency_mismatch: true rides deltaAnnotations too, D78): a delta between two currencies is not a number, and client-side conversion is forbidden (D67). Missing labels never read as a mismatch. */
  currencyMismatch?: Maybe<Scalars['Boolean']['output']>;
  /** D78 (adversarial-review-D4 finding 3): the non-numeric annotations of deltasVsBaseline: currency (the shared label when both books agree), currency_mismatch, rate_set_mismatch, service_time_mismatch, disposal_source_mismatch. Mirrors the column's boolean fields; consumers read one object instead of scraping flags out of the delta numbers. */
  deltaAnnotations?: Maybe<Scalars['GenericScalar']['output']>;
  /** Server-computed deltas against the comparison baseline (column zero), absolute per KPI plus *_pct where the baseline total is nonzero. NUMBERS ONLY (D78): on a rate-set or currency mismatch the cost delta entries are absent; the refusal flags and the currency label ride deltaAnnotations and the first-class column booleans, never inside this map. */
  deltasVsBaseline?: Maybe<Scalars['GenericScalar']['output']>;
  /** True when this plan's disposal was PROVABLY priced from a different source than the baseline's rate book (rate_set.disposal_source: explicit facility gate fees, or a scenario without offload facilities, vs the effective rate set both baselines price; SBX-371 follow-up, D32). FLAGGED, not stripped: explicit facility fees are legitimate modeling, so the deltas stay visible with the provenance warning (disposal_source_mismatch: true rides deltaAnnotations too, D78). Missing entries (pre-stamp artifacts) never read as a mismatch. */
  disposalSourceMismatch?: Maybe<Scalars['Boolean']['output']>;
  /** SBX-498 (finding 9's label half): {vehicles, live_matched, substituted, note}; a substituted fleet profile is labeled as such, never silent. */
  fleetBasis?: Maybe<Scalars['GenericScalar']['output']>;
  kpis?: Maybe<PlanKpisDef>;
  /** The scenario's objective profile (D10). */
  objectiveProfile?: Maybe<Scalars['String']['output']>;
  plan: PlanDef;
  /** The rate-set stamp this plan's money was priced with (cost model id + content hash + source label, SBX-371); null on plans recorded before stamping existed. */
  rateSet?: Maybe<Scalars['GenericScalar']['output']>;
  /** True when this plan's rate-set hash provably differs from the baseline's: the cost delta is refused because it would measure price-book disagreement, not route quality (SBX-371, D32). Physical deltas stay. */
  rateSetMismatch?: Maybe<Scalars['Boolean']['output']>;
  /** True when this plan's modeled service-time source (rate_set.service_time, the SBX-371 extension) provably differs from the baseline's. FLAGGED, not stripped: hours and cost deltas stay visible but carry the provenance warning (service_time_mismatch: true rides deltaAnnotations too, D78), the exact scoring-side semantics (D32). Missing entries (pre-stamp artifacts, replay baselines whose hours are observed rather than modeled) never read as a mismatch. */
  serviceTimeMismatch?: Maybe<Scalars['Boolean']['output']>;
  /** SBX-498 (rewalk finding 11): the travel-model basis of this column's km/hours/distance money, {basis: road|haversine_fallback|null, profile, note}; chip every distance/time figure with it. */
  travelBasis?: Maybe<Scalars['GenericScalar']['output']>;
};

/** Up to four plans against a named baseline (RS-204, D17). */
export type PlanComparisonDef = {
  __typename: 'PlanComparisonDef';
  /** Column zero: the named baseline (D17). */
  baseline: BaselineDef;
  baselineTotals?: Maybe<Scalars['GenericScalar']['output']>;
  columns: Array<PlanComparisonColumnDef>;
};

export type PlanDef = Node & {
  __typename: 'PlanDef';
  /** SBX-498: the EUR/yr annualization stated where it applies: {applies, cycle_weeks, weeks_per_year, factor, note}; yearly money figures scale the cycle by 52 over the cycle length. */
  annualization?: Maybe<Scalars['GenericScalar']['output']>;
  /** SBX-504 (D72, D85): the day-one arithmetic rail, the five checks a customer does by hand (vehicles vs routes, double bookings, near-empty routes, fraction fit, capacity sanity): {computed_at, context, basis, verdict, summary_sentence, checks: [{check, verdict, planner_sentence, counts}]}. Verdicts are pass, fail or cannot_check; a cannot_check states why, never a silent skip. Computed on read from rows the plan already carries. */
  arithmeticChecks?: Maybe<Scalars['GenericScalar']['output']>;
  autopilotActions: AutopilotActionDefConnection;
  calendarEntries: PlanCalendarEntryDefConnection;
  /** T2 (D69, D32): the comparability grade of this plan's deltas against its OWN named baseline (kpis.baseline): {at_grade, grade, missing: [{key, label}]}. Below grade the frontend renders 'Not comparable yet' with the named missing pieces and demotes actions; the pieces are derived conservatively from recorded stamps and caveats (services.comparability), never recomputed client-side. */
  comparability?: Maybe<Scalars['GenericScalar']['output']>;
  /** SBX-531 (D82): the what-is-behind-this-number block for every plan-level EUR/yr figure: {currency, rates {source, cost_model_id, name, region_pack, text}, disposal {included, source, text}, distance (the travelBasis shape plus text), annualization (the annualization shape plus text), sentences [4]}. Every component is a recorded truth with a planner sentence; render sentences verbatim beside the price. Absent records serve honest unstated sentences, never guesses. */
  costBasis?: Maybe<Scalars['GenericScalar']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** SBX-497 (rewalk finding 8): the plan narrates its own day structure: per-weekday run/stop counts vs the baseline week (source named), vanished days ('Tuesday has no collections in this plan'), NEW working days flagged loudly with the overtime/permission caveat where the day is outside the area's stated working days, and the stops-per-week vs total arithmetic with the cycle length. Derived from data the plan already carries; no new solving. */
  dayStructure?: Maybe<Scalars['GenericScalar']['output']>;
  /** Session 4 CI-5 (A2, D08): true when the solve recorded a degenerate_solution honesty event naming this plan (the all-lifts-on-one-Monday class), so the loud warning keys on a field, never event-log archaeology. Additive; a sane plan serves false. */
  degenerate?: Maybe<Scalars['Boolean']['output']>;
  /** Session 4 CI-5: the planner sentence of the degenerate confession (treat this as a failed run, not a plan); null on a sane plan. */
  degenerateNote?: Maybe<Scalars['String']['output']>;
  dynamicDayRuns: DynamicDayRunDefConnection;
  engine: Scalars['String']['output'];
  /** Session 4 B4 (SBX-487, D74): the planner face of the engine tag (pyvrp_hgs@0.11.3 reads PyVRP hybrid genetic search, build 0.11.3); the machine tag stays on engine, byte-unchanged. */
  engineLabel?: Maybe<Scalars['String']['output']>;
  /** SBX-498 (rewalk finding 9's label half): whether this plan's fleet is the tenant's recorded fleet, {vehicles, live_matched, substituted, note}; substituted plans carry the planner note naming the stand-in profile. */
  fleetBasis?: Maybe<Scalars['GenericScalar']['output']>;
  /** SBX-536 W0: the borrow record stamped into the stored artifact at record time from a fresh company-ledger read: {computed_at, area_project_id, note, entries: [{vehicle_ref, vehicle_name, project_id, project_name, ledger_claims: [{weekday, kind, project_id, project_name, owner, foreign, ...}], sentence}]}. One entry per staged vehicle whose home project differs from this scenario's area project; render each entry's sentence and the note verbatim (the plan says whose trucks it rides and what each borrow assumes). Empty entries means no borrowed trucks; null means the plan predates this record. */
  fleetBorrows?: Maybe<Scalars['GenericScalar']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  kpis?: Maybe<PlanKpisDef>;
  parameterSet?: Maybe<ParameterSetDef>;
  planJson?: Maybe<Scalars['JSONString']['output']>;
  promotions: PromotionDefConnection;
  relaxationProbes: RelaxationProbeDefConnection;
  routes: PlanRouteDefConnection;
  scenario: ScenarioDef;
  seed: Scalars['Int']['output'];
  solveStats: Scalars['JSONString']['output'];
  /** SBX-498 (rewalk finding 11): the travel-model basis of this plan's km/hours/distance money, {basis: road|haversine_fallback|null, profile, note}, from the artifact's matrix_ref.profile; null basis means the artifact predates the echo. Chip every distance/time figure with it. */
  travelBasis?: Maybe<Scalars['GenericScalar']['output']>;
};


export type PlanDefAutopilotActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PlanDefCalendarEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PlanDefDynamicDayRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PlanDefPromotionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PlanDefRelaxationProbesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PlanDefRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PlanDefConnection = {
  __typename: 'PlanDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlanDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PlanDef` and its cursor. */
export type PlanDefEdge = {
  __typename: 'PlanDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PlanDef>;
};

/**
 * Graphene input mirror of plan_schema.QueryPlan.
 *
 * All validation (cap enforcement, clamping) is delegated to
 * ``QueryPlan.model_validate`` inside ``_resolve_widget``; per-widget
 * ValidationError surfaces as ``INVALID_PLAN:<message>`` in the widget
 * error field rather than as a top-level GraphQL error.
 */
export type PlanInput = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  entity: Scalars['String']['input'];
  expressions?: InputMaybe<Array<ExpressionInput>>;
  filters?: InputMaybe<Array<FilterInput>>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  having?: InputMaybe<Array<HavingInput>>;
  joins?: InputMaybe<Array<JoinInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measures: Array<MeasureInput>;
  mode: Scalars['String']['input'];
  relationJoins?: InputMaybe<Array<RelationJoinInput>>;
  sort?: InputMaybe<SortInput>;
  timeBucket?: InputMaybe<Scalars['String']['input']>;
  timeField?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Int']['input'];
};

/**
 * Plan scoring row. D78 (adversarial-review-D4 finding 3): the
 * wire serves ONE canonical shape regardless of row age: ``deltas``
 * is numbers only and every non-numeric annotation (mismatch flags,
 * the currency label) rides ``deltaAnnotations``; legacy rows whose
 * persisted deltas carry drifted annotations are split at read time
 * through the shared accessor, never rewritten.
 */
export type PlanKpisDef = Node & {
  __typename: 'PlanKpisDef';
  balanceIndex?: Maybe<Scalars['Float']['output']>;
  baseline: BaselineDef;
  co2eMethod: Scalars['String']['output'];
  co2eTYear: Scalars['Float']['output'];
  costYear: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  decomposition: Scalars['JSONString']['output'];
  /** D78: the non-numeric delta annotations (currency label on agreeing books, currency_mismatch, rate_set_mismatch, service_time_mismatch, disposal_source_mismatch), from the plan artifact's sibling kpis.delta_annotations merged over anything a legacy row still carries inside its deltas map. */
  deltaAnnotations?: Maybe<Scalars['GenericScalar']['output']>;
  /** Numeric KPI deltas against the row's named baseline (D17), numbers only per the frozen contract typing (D78). Non-numeric annotations that legacy rows carry in-map are served under deltaAnnotations instead. */
  deltas?: Maybe<Scalars['GenericScalar']['output']>;
  /** SBX-491 (rewalk finding 1): the basis of disruptionPct: {unit, supported, reason, text}. When the plan's rows do not map to real properties, disruptionPct serves null and reason='property_mapping_missing' with a planner sentence rides here; a property-based zero is never printed off an unsupported mapping. */
  disruptionBasis?: Maybe<Scalars['GenericScalar']['output']>;
  disruptionPct?: Maybe<Scalars['Float']['output']>;
  hoursCycle: Scalars['Float']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  kmCycle: Scalars['Float']['output'];
  lifts?: Maybe<Scalars['Int']['output']>;
  plan: PlanDef;
  vehicles: Scalars['Int']['output'];
};

export type PlanKpisDefConnection = {
  __typename: 'PlanKpisDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlanKpisDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PlanKpisDef` and its cursor. */
export type PlanKpisDefEdge = {
  __typename: 'PlanKpisDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PlanKpisDef>;
};

export type PlanRouteDef = Node & {
  __typename: 'PlanRouteDef';
  dayOfCycle: Scalars['Int']['output'];
  geometryRef: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  kpis: Scalars['JSONString']['output'];
  loadTrajectory: Scalars['JSONString']['output'];
  offloads: Scalars['JSONString']['output'];
  plan: PlanDef;
  routeKey: Scalars['String']['output'];
  stops: PlanStopDefConnection;
  vehicleRef: Scalars['String']['output'];
};


export type PlanRouteDefStopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PlanRouteDefConnection = {
  __typename: 'PlanRouteDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlanRouteDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PlanRouteDef` and its cursor. */
export type PlanRouteDefEdge = {
  __typename: 'PlanRouteDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PlanRouteDef>;
};

export type PlanStopDef = Node & {
  __typename: 'PlanStopDef';
  etaBand?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  planRoute: PlanRouteDef;
  sequence: Scalars['Int']['output'];
  serviceUnitRef: Scalars['String']['output'];
};

export type PlanStopDefConnection = {
  __typename: 'PlanStopDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlanStopDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PlanStopDef` and its cursor. */
export type PlanStopDefEdge = {
  __typename: 'PlanStopDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PlanStopDef>;
};

export type PlanningAreaDef = Node & {
  __typename: 'PlanningAreaDef';
  activeParameterSet?: Maybe<ParameterSetDef>;
  /** D35 autonomy ladder level for this area: 0 manual, 1 copilot, 2 analyst (default), 3 guarded autopilot. L4 does not exist. */
  autonomyLevel?: Maybe<Scalars['Int']['output']>;
  autopilotActions: AutopilotActionDefConnection;
  baselines: BaselineDefConnection;
  boundary?: Maybe<Scalars['GeoJSON']['output']>;
  costModel?: Maybe<CostModelDef>;
  createdAt: Scalars['DateTime']['output'];
  cycleWeeks: Scalars['Int']['output'];
  dynamicDayRuns: DynamicDayRunDefConnection;
  /** SBX-362/SBX-371: the effective tenant rate set this area's money prices through (area cost model, else the project's newest, else labeled engineering defaults): rate components, currency, disposal fee book, source label and the identity stamp (cost model id + content hash). */
  effectiveRateSet?: Maybe<Scalars['GenericScalar']['output']>;
  explorationRuns: ExplorationRunDefConnection;
  holidayCalendar: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  liveMasterPlan?: Maybe<PlanDef>;
  name: Scalars['String']['output'];
  parityAnchorDate?: Maybe<Scalars['Date']['output']>;
  project: ProjectType;
  recommendations: RecommendationDefConnection;
  regionName: Scalars['String']['output'];
  regionPack: RouteStudioPlanningAreaRegionPackChoices;
  /** SBX-345 replay coverage honesty (D08): which of the last N route-days (GPS-bearing days) have replay ingested, with explicit missing lists, never fabricated zeros. Default window 14 days ending yesterday. */
  replayCoverage?: Maybe<Scalars['GenericScalar']['output']>;
  scenarios: ScenarioDefConnection;
  /** SBX-372 (D08): missed-collection / service-level statistics from the platform's REAL PickUpOrder outcomes: per period (last 7/30 days, plus since-cutover while a live promotion exists) completion rate, skip counts by recorded ticket reason, repeat-miss locations (capped, with truncation flags) and trend buckets, for the area and the promoted scheme. Read-only; windows end yesterday. */
  serviceLevels?: Maybe<Scalars['GenericScalar']['output']>;
};


export type PlanningAreaDefAutopilotActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PlanningAreaDefBaselinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PlanningAreaDefDynamicDayRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PlanningAreaDefExplorationRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PlanningAreaDefRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PlanningAreaDefReplayCoverageArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type PlanningAreaDefScenariosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PlanningAreaDefConnection = {
  __typename: 'PlanningAreaDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlanningAreaDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PlanningAreaDef` and its cursor. */
export type PlanningAreaDefEdge = {
  __typename: 'PlanningAreaDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PlanningAreaDef>;
};

/** An enumeration. */
export enum PlatformChoices {
  NAV_APP = 'NAV_APP',
  PLATFORM = 'PLATFORM',
  PORTAL = 'PORTAL'
}

/**
 * PRO-578: count + top-N of the PMC's linked individuals, for the
 * Individuals card folded into the company cockpit overview (the company
 * equivalent of the Individual cockpit's relations affordances).
 */
export type PmcIndividualsSummaryDef = {
  __typename: 'PmcIndividualsSummaryDef';
  contacts: Array<ContactDef>;
  totalCount: Scalars['Int']['output'];
};

export type PolicyCatalogDef = {
  __typename: 'PolicyCatalogDef';
  actionKind: Scalars['String']['output'];
  approverTeamId?: Maybe<Scalars['ID']['output']>;
  approverTeamName?: Maybe<Scalars['String']['output']>;
  mode: Scalars['String']['output'];
};

export type PolicyDef = {
  __typename: 'PolicyDef';
  actionKind: Scalars['String']['output'];
  approvalTtlSeconds?: Maybe<Scalars['Int']['output']>;
  approverTeam?: Maybe<TeamType>;
  mode: Scalars['String']['output'];
  reminderAfterSeconds?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type PolygonInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>>>;
};

/**
 * A citizen<->hauler portal conversation, server-side hauler-scoped (D3).
 *
 * The hauler Messages surface reads through this type. ``get_queryset`` is the
 * single isolation choke point (mirrors ``TicketDef.get_queryset``): it scopes
 * to the caller's company and then, for a contractor user, to that user's own
 * hauler via ``apply_hauler_scope`` — so BOTH the list resolver and a direct
 * global-id node fetch deny another hauler's conversation (a guessed id
 * resolves to ``None`` = a 404). Office/admin callers are left unscoped (they
 * may supervise), exactly as tickets already behave. The isolation lives on
 * the server; it never leans on the un-flipped front-end hauler redaction.
 */
export type PortalConversationDef = Node & {
  __typename: 'PortalConversationDef';
  citizenName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The portal user who started the conversation (audit). */
  createdBy?: Maybe<PropertyUserDef>;
  hauler?: Maybe<HaulerDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Timestamp of the newest message in the thread. */
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  messages?: Maybe<Array<Maybe<PortalConversationMessageDef>>>;
  /** When the current back-office operator last read this conversation (null = never read). */
  operatorLastReadAt?: Maybe<Scalars['DateTime']['output']>;
  /** True when the newest message post-dates the current operator's read marker (drives the back-office unread badge). */
  operatorUnread?: Maybe<Scalars['Boolean']['output']>;
  /** The citizen (legal entity) the conversation belongs to. */
  participantContact?: Maybe<ContactDef>;
  property: PropertyDef;
  subject?: Maybe<Scalars['String']['output']>;
  /** Mirror of the synthetic thread_id on the thread's messages. */
  threadId: Scalars['String']['output'];
  /** The first CompanyEmailAccountMessage of the thread. */
  threadStarter: CompanyEmailAccountMessageDef;
  /** Set when the conversation was originated by a ticket-system message (the ticket->portal bridge); one conversation per (ticket, participant_contact). */
  ticket?: Maybe<TicketDef>;
};

export type PortalConversationDefConnection = {
  __typename: 'PortalConversationDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PortalConversationDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PortalConversationDef` and its cursor. */
export type PortalConversationDefEdge = {
  __typename: 'PortalConversationDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PortalConversationDef>;
};

/**
 * One message inside a hauler-facing portal conversation.
 *
 * Projects a portal ``CompanyEmailAccountMessage`` with the four-way author
 * facet (``customer`` / ``company`` / ``hauler`` / ``authority``) shared with
 * the citizen FastAPI facade via ``portal_message_author`` — one source of
 * truth for who a portal message reads as. ``authority`` (req 3.12.7) is a
 * specialization of the company face: a company-side message whose mirrored
 * ``TicketMessage`` was captured with ``authority_entry=True``. Deliberately
 * a plain ``ObjectType`` (not a Node): a message is only ever read nested
 * under an already-scoped conversation, so it inherits that conversation's
 * isolation and needs no id-addressable node of its own that could be
 * fetched cross-hauler.
 */
export type PortalConversationMessageDef = {
  __typename: 'PortalConversationMessageDef';
  attachments?: Maybe<Array<Maybe<CompanyEmailAccountMessageAttachmentDef>>>;
  author: Scalars['String']['output'];
  authorName: Scalars['String']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

/** An enumeration. */
export enum PortalPageChoices {
  HOME = 'HOME',
  LOGIN = 'LOGIN'
}

export type PortalPageDescriptionSettingType = Node & {
  __typename: 'PortalPageDescriptionSettingType';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  page?: Maybe<PortalPageChoices>;
  sections?: Maybe<Array<Maybe<PortalPageSectionSettingType>>>;
  title: Scalars['String']['output'];
};

export type PortalPageDescriptionSettingTypeConnection = {
  __typename: 'PortalPageDescriptionSettingTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PortalPageDescriptionSettingTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PortalPageDescriptionSettingType` and its cursor. */
export type PortalPageDescriptionSettingTypeEdge = {
  __typename: 'PortalPageDescriptionSettingTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PortalPageDescriptionSettingType>;
};

export type PortalPageSectionSettingInputObject = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  linkLabel?: InputMaybe<Scalars['String']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PortalPageSectionSettingType = Node & {
  __typename: 'PortalPageSectionSettingType';
  backgroundImage: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  linkLabel: Scalars['String']['output'];
  linkUrl: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PortalPageSettingsInputObject = {
  page?: InputMaybe<PortalPageChoices>;
  sections?: InputMaybe<Array<InputMaybe<PortalPageSectionSettingInputObject>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Per-company citizen-portal role→rights matrix audit rows (PRO-317)
 * — seeded-row creation, tenant retunes, and (admin-only) deletes.
 */
export type PortalRoleCapabilitiesEventDef = Node & {
  __typename: 'PortalRoleCapabilitiesEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<PortalRoleCapabilitiesEventTypesGraphene>>>;
  fromCapabilities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  role?: Maybe<Scalars['String']['output']>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toCapabilities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  user?: Maybe<UserType>;
};

export enum PortalRoleCapabilitiesEventTypesGraphene {
  PORTAL_ROLE_GRANT_CHANGED = 'PORTAL_ROLE_GRANT_CHANGED',
  PORTAL_ROLE_GRANT_CREATED = 'PORTAL_ROLE_GRANT_CREATED',
  PORTAL_ROLE_GRANT_DELETED = 'PORTAL_ROLE_GRANT_DELETED'
}

/**
 * One role row of the global citizen-portal role->rights matrix.
 *
 * ``role`` is a ``PORTAL_GRANT_ROLE_CHOICES`` value (every ``ContactRole``
 * plus the ``EMAIL_OTP_DEFAULT`` sentinel). ``capabilities`` is the set of
 * granted ``PortalCapability`` keys for that role (``[]`` when the role has
 * no grant row, i.e. it grants nothing). See
 * ``crm/models/portal_capabilities.py``.
 */
export type PortalRoleCapabilityGrantDef = {
  __typename: 'PortalRoleCapabilityGrantDef';
  capabilities: Array<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * The whole global citizen-portal role->rights matrix + vocabularies.
 *
 * ``roles`` carries one entry per role in ``PORTAL_GRANT_ROLE_CHOICES`` (not
 * only roles that already have a grant row), so the back-office front end can
 * render a complete grid. ``available_capabilities`` is the frozen
 * ``PortalCapability`` key vocabulary (grid columns); ``available_roles`` is
 * the role vocabulary (grid rows).
 */
export type PortalRoleCapabilityMatrixDef = {
  __typename: 'PortalRoleCapabilityMatrixDef';
  availableCapabilities: Array<Scalars['String']['output']>;
  availableRoles: Array<Scalars['String']['output']>;
  roles: Array<PortalRoleCapabilityGrantDef>;
};

/**
 * One size / pickup setting a Products & Prices tenant's office may
 * move a container to (PRO-695): the combination, the product it lands
 * on and that product's rental for it.
 *
 * The P&P twin of ``ContainerPriceOptionDef`` / ``AgreementPricesChange*Def``,
 * whose ``product`` / ``price`` are legacy ``crm`` rows a P&P tenant does
 * not have — which is why those lists come back empty for it and the office
 * could not change a bin's size at all. Built from a
 * ``crm.services.portal_pricing.PortalOffer``. ``amount`` is the rental in
 * minor units (the wire the legacy option carries and the fee-summary box
 * reads); ``rental_price`` is the same figure as the engine's ``Decimal``
 * at the tenant's precision.
 */
export type PpContainerOfferDef = {
  __typename: 'PpContainerOfferDef';
  amount: Scalars['Int']['output'];
  containerType: ContainerTypeType;
  id: Scalars['ID']['output'];
  pickupSetting: PickupSettingsType;
  ppProduct: PpProductDef;
  recurringInterval: Scalars['Int']['output'];
  rentalPrice: Scalars['Decimal']['output'];
  wasteFraction: WasteFractionType;
};

/**
 * Diff preview for converting one legacy `Rule` into a draft Flow:
 * pure computation, zero database writes (the legacy rule and every
 * other row are left exactly as they were). Recomputed from the rule's
 * live actions on every call, so the preview always matches what
 * `ConfirmConvertLegacyRuleToFlow` would create if confirmed right now.
 *
 * `definition` is the would-be Flow definition (already run through the
 * same structural + registry-aware validator the builder itself uses,
 * per `autopilot.builder.validator.validate_for_builder`, so a preview
 * is never a promise `confirm` can't keep). `warnings` calls out real
 * seam gaps (e.g. a status-transition trigger that cannot be scoped to
 * one ticket type with the current event contract). `unsupportedActions`
 * lists every legacy action this rule has that could not be converted;
 * `ok=False` with no `definition` means nothing convertible was left.
 */
export type PreviewConvertLegacyRuleToFlow = {
  __typename: 'PreviewConvertLegacyRuleToFlow';
  definition?: Maybe<Scalars['JSONString']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  unsupportedActions?: Maybe<Array<Scalars['String']['output']>>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * Run ``sql`` for ``companyId`` as a saved dataset of that company
 * would run, without saving anything: the first ``limit`` rows (at most
 * 50). ``sampleValues`` (``{tag: value}``) and ``sampleWindow`` (a board
 * date window, ``{start, end}``) give the declared tags values exactly as
 * a dashboard's filters do when a tile runs (``sample_values``).
 * ``error``: what ``run`` returns (``SQL_REFUSED:<reason>``,
 * ``INVALID_DATASET:parameters``, ``QUERY_TIMEOUT``,
 * ``EXECUTION_FAILED:<error class>``) or ``COMPANY_NOT_FOUND``;
 * ``errorDetail`` names the tag or word of a refusal.
 */
export type PreviewSqlDataset = {
  __typename: 'PreviewSqlDataset';
  columns: Array<SqlDatasetPreviewColumnType>;
  elapsedMs?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorDetail?: Maybe<Scalars['String']['output']>;
  rows: Scalars['GenericScalar']['output'];
  truncated: Scalars['Boolean']['output'];
};

export type PriceDef = Node & {
  __typename: 'PriceDef';
  amount: Scalars['Int']['output'];
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['Date']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  product: ProductDef;
  recurringInterval: CrmPriceRecurringIntervalChoices;
  startDate: Scalars['Date']['output'];
  weightAmount: Scalars['Int']['output'];
};

export type PriceDefConnection = {
  __typename: 'PriceDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PriceDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PriceDef` and its cursor. */
export type PriceDefEdge = {
  __typename: 'PriceDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PriceDef>;
};

export type PriceEventDef = Node & {
  __typename: 'PriceEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<PriceEventTypesGraphene>>>;
  fromAmount?: Maybe<Scalars['Int']['output']>;
  fromEndDate?: Maybe<Scalars['Date']['output']>;
  fromRecurringInterval?: Maybe<Scalars['String']['output']>;
  fromStartDate?: Maybe<Scalars['Date']['output']>;
  fromWeightAmount?: Maybe<Scalars['Int']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  price?: Maybe<PriceDef>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toAmount?: Maybe<Scalars['Int']['output']>;
  toEndDate?: Maybe<Scalars['Date']['output']>;
  toRecurringInterval?: Maybe<Scalars['String']['output']>;
  toStartDate?: Maybe<Scalars['Date']['output']>;
  toWeightAmount?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<UserType>;
};

export enum PriceEventTypesGraphene {
  AMOUNT_CHANGE = 'AMOUNT_CHANGE',
  END_DATE_CHANGE = 'END_DATE_CHANGE',
  RECURRING_INTERVAL_CHANGE = 'RECURRING_INTERVAL_CHANGE',
  START_DATE_CHANGE = 'START_DATE_CHANGE',
  WEIGHT_AMOUNT_CHANGE = 'WEIGHT_AMOUNT_CHANGE'
}

export type ProductDef = Node & {
  __typename: 'ProductDef';
  activePrice?: Maybe<ActivePriceDef>;
  agreementSet: AgreementDefConnection;
  agreementtemplateproductSet: AgreementTemplateProductDefConnection;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Reserved: area this fee product will be restricted to (post-July area-restriction feature) */
  areaRef?: Maybe<AreaDef>;
  /** Reserved: area-restriction mode (post-July area-restriction feature) */
  areaRestriction: CrmProductAreaRestrictionChoices;
  company: CompanyType;
  containerType?: Maybe<ContainerTypeType>;
  createdAt: Scalars['DateTime']['output'];
  enableOnPortal: Scalars['Boolean']['output'];
  externalInvoiceCode: Scalars['String']['output'];
  haulerpriceSet: HaulerPriceDefConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  includeOnInvoicesIfFree: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  migratedFromId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nameOnInvoice: Scalars['String']['output'];
  pickupSetting?: Maybe<PickupSettingsType>;
  prices: PriceDefConnection;
  productType: CrmProductProductTypeChoices;
  propertyType?: Maybe<PropertyTypeDef>;
  service?: Maybe<ServiceDef>;
  updatedAt: Scalars['DateTime']['output'];
  wasteFraction?: Maybe<WasteFractionType>;
};


export type ProductDefAgreementSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductDefAgreementtemplateproductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductDefHaulerpriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductDefPricesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductDefConnection = {
  __typename: 'ProductDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ProductDef` and its cursor. */
export type ProductDefEdge = {
  __typename: 'ProductDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProductDef>;
};

export type ProductEventDef = Node & {
  __typename: 'ProductEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<ProductEventTypesGraphene>>>;
  fromArchivedAt?: Maybe<Scalars['DateTime']['output']>;
  fromContainerType?: Maybe<ContainerTypeType>;
  fromEnableOnPortal?: Maybe<Scalars['Boolean']['output']>;
  fromExternalInvoiceCode?: Maybe<Scalars['String']['output']>;
  fromIncludeOnInvoicesIfFree?: Maybe<Scalars['Boolean']['output']>;
  fromIsDefault?: Maybe<Scalars['Boolean']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  fromNameOnInvoice?: Maybe<Scalars['String']['output']>;
  fromPickupSetting?: Maybe<PickupSettingsType>;
  fromProductType?: Maybe<Scalars['String']['output']>;
  fromPropertyType?: Maybe<PropertyTypeType>;
  fromService?: Maybe<ServiceDef>;
  fromWasteFraction?: Maybe<WasteFractionType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  product?: Maybe<ProductDef>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toArchivedAt?: Maybe<Scalars['DateTime']['output']>;
  toContainerType?: Maybe<ContainerTypeType>;
  toEnableOnPortal?: Maybe<Scalars['Boolean']['output']>;
  toExternalInvoiceCode?: Maybe<Scalars['String']['output']>;
  toIncludeOnInvoicesIfFree?: Maybe<Scalars['Boolean']['output']>;
  toIsDefault?: Maybe<Scalars['Boolean']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
  toNameOnInvoice?: Maybe<Scalars['String']['output']>;
  toPickupSetting?: Maybe<PickupSettingsType>;
  toProductType?: Maybe<Scalars['String']['output']>;
  toPropertyType?: Maybe<PropertyTypeType>;
  toService?: Maybe<ServiceDef>;
  toWasteFraction?: Maybe<WasteFractionType>;
  user?: Maybe<UserType>;
};

export enum ProductEventTypesGraphene {
  ARCHIVED_AT_CHANGE = 'ARCHIVED_AT_CHANGE',
  CONTAINER_TYPE_CHANGE = 'CONTAINER_TYPE_CHANGE',
  ENABLE_ON_PORTAL_CHANGE = 'ENABLE_ON_PORTAL_CHANGE',
  EXTERNAL_INVOICE_CODE_CHANGE = 'EXTERNAL_INVOICE_CODE_CHANGE',
  INCLUDE_ON_INVOICES_IF_FREE_CHANGE = 'INCLUDE_ON_INVOICES_IF_FREE_CHANGE',
  IS_DEFAULT_CHANGE = 'IS_DEFAULT_CHANGE',
  NAME_CHANGE = 'NAME_CHANGE',
  NAME_ON_INVOICE_CHANGE = 'NAME_ON_INVOICE_CHANGE',
  PICKUP_SETTING_CHANGE = 'PICKUP_SETTING_CHANGE',
  PROPERTY_TYPE_CHANGE = 'PROPERTY_TYPE_CHANGE',
  SERVICE_CHANGE = 'SERVICE_CHANGE',
  WASTE_FRACTION_CHANGE = 'WASTE_FRACTION_CHANGE'
}

/**
 * One pp_audit_logs row surfaced in Settings > System History
 * (LEDGER-838).
 *
 * ``entity_type`` / ``action`` are deliberately plain strings — unknown
 * future values written to the append-only log must never break
 * serialization. ``diff`` is declared as GenericScalar so the FE gets a
 * real JSON object (the default JSONField mapping would double-encode it
 * as JSONString).
 */
export type ProductManagementEventDef = Node & {
  __typename: 'ProductManagementEventDef';
  action?: Maybe<Scalars['String']['output']>;
  changedBy: Scalars['String']['output'];
  changedByName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  diff?: Maybe<Scalars['GenericScalar']['output']>;
  entityId: Scalars['String']['output'];
  entityName?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  user?: Maybe<UserType>;
};

export type ProjectType = Node & {
  __typename: 'ProjectType';
  collectioninquirytypingSet: CollectionInquiryTypingTypeConnection;
  /** Hex color code */
  color?: Maybe<Scalars['String']['output']>;
  company: CompanyType;
  companyemailaccountruleSet: CompanyEmailAccountRuleDefConnection;
  containerSet: ContainerTypeConnection;
  containerTypes: ContainerTypeTypeConnection;
  containergroupSet: ContainerGroupDefConnection;
  containerimportSet: ContainerImportTypeConnection;
  containertypeSet: ContainerTypeTypeConnection;
  containerweightimportSet: ContainerWeightImportTypeConnection;
  copilotConversations: CopilotConversationDefConnection;
  costmodelSet: CostModelDefConnection;
  creatingDemoData: Scalars['Boolean']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exportSet: ExportTypeConnection;
  exporttemplateSet: ExportTemplateDefConnection;
  fractionservicebindingSet: FractionServiceBindingDefConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importHistory: ImportHistoryDefConnection;
  importbatchSet: ImportBatchDefConnection;
  importcaseSet: ImportCaseDefConnection;
  inquiries: CollectionInquiryTypeConnection;
  kmdEasyImportedFiles: ImportedKmdEasyFileDefConnection;
  logo?: Maybe<Scalars['String']['output']>;
  measurementsettingsSet: MeasurementSettingsTypeConnection;
  myJobTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pickupsettingsSet: PickupSettingsTypeConnection;
  planningareaSet: PlanningAreaDefConnection;
  routeSettings: RouteSettingsTypeConnection;
  routeStudioBrainRules: BrainRuleDefConnection;
  routeStudioNarratives: NarrativeDocumentDefConnection;
  routes: RouteTypeConnection;
  routeschemeSet: RouteSchemeTypeConnection;
  searchUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  settings?: Maybe<SettingsType>;
  stopsetSet: StopSetDefConnection;
  ticketdraftSet: TicketDraftDefConnection;
  userAccessLevel?: Maybe<Scalars['String']['output']>;
  userabsenceSet: UserAbsenceTypeConnection;
  userprojectSet: UserProjectTypeConnection;
  vehicleSet: VehicleTypeConnection;
  vehicleabsenceSet: VehicleAbsenceTypeConnection;
  wasteFractions: WasteFractionTypeConnection;
  wastefractionSet: WasteFractionTypeConnection;
  wastetypeSet: WasteTypeTypeConnection;
};


export type ProjectTypeCollectioninquirytypingSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeCompanyemailaccountruleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeContainerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeContainerTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeContainergroupSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeContainerimportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeContainertypeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeContainerweightimportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeCopilotConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeCostmodelSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeExportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeExporttemplateSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeFractionservicebindingSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeImportHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeImportbatchSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeImportcaseSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeInquiriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeKmdEasyImportedFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeMeasurementsettingsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypePickupsettingsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypePlanningareaSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeRouteSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeRouteStudioBrainRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeRouteStudioNarrativesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeRouteschemeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeStopsetSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeTicketdraftSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeUserabsenceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeUserprojectSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeVehicleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeVehicleabsenceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeWasteFractionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeWastefractionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectTypeWastetypeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectTypeConnection = {
  __typename: 'ProjectTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProjectTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ProjectType` and its cursor. */
export type ProjectTypeEdge = {
  __typename: 'ProjectTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProjectType>;
};

export type ProjectsInputObject = {
  amountOfUsers?: InputMaybe<Scalars['Int']['input']>;
  centerLocation?: InputMaybe<LocationInputObject>;
  collectionInquiries?: InputMaybe<Scalars['Int']['input']>;
  containerDevicePercentage?: InputMaybe<Scalars['Int']['input']>;
  containerTypes?: InputMaybe<Scalars['Int']['input']>;
  containers?: InputMaybe<Scalars['Int']['input']>;
  demoPeriod?: InputMaybe<Scalars['Int']['input']>;
  depots?: InputMaybe<Scalars['Int']['input']>;
  drivers?: InputMaybe<Scalars['Int']['input']>;
  fillLevelHistoryDays?: InputMaybe<Scalars['Int']['input']>;
  fillLevelHistoryEmpties?: InputMaybe<Scalars['Int']['input']>;
  fillLevelHistoryMeasurementsPerDay?: InputMaybe<Scalars['Int']['input']>;
  fillLevelHistorySpikesPercentage?: InputMaybe<Scalars['Int']['input']>;
  forceContainerRoadLocations?: InputMaybe<Scalars['Boolean']['input']>;
  maxLocationRetries?: InputMaybe<Scalars['Int']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['Int']['input']>;
  vehicleTypes?: InputMaybe<Scalars['Int']['input']>;
  vehicles?: InputMaybe<Scalars['Int']['input']>;
  wasteFractions?: InputMaybe<Scalars['Int']['input']>;
  wasteStations?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Advance a Flow's lifecycle state (draft -> test, test -> shadow, or
 * test -> draft for another edit pass). `target_state` is
 * `AutopilotFlowPromotableState`, so `live` is not a value this argument
 * can ever hold (see that enum's docstring for the two dedicated
 * routes to `live`, `ActivateAutopilotFlow` and
 * `ActivateAutopilotFlowFromShadow`).
 *
 * Promoting into `test` or `shadow` (AP-402, AP-704) carries two guards
 * beyond the bare state machine in `Flow.promote_to`:
 *
 * - Refuses when `flow.has_unsaved_changes()`: an autosaved draft that was
 *   never committed as a `FlowVersion` must not silently become "the"
 *   version that goes to test or shadow. Commit it
 *   (`UpdateAutopilotFlowDefinition`) first.
 * - Re-runs the registry-aware validator (`validate_for_builder`) against
 *   `current_version.definition` before activating it: the definition was
 *   valid when the version was created, but `autopilot_registry_sync` can
 *   deactivate an action afterwards (registry drift), and promotion is the
 *   last save-time gate before a flow starts actually being exercised in
 *   `test` or watching real live events in `shadow`.
 *
 * Demoting back to `draft` resyncs `draft_definition` to
 * `current_version.definition`: "another edit pass" (the model's own
 * docstring) starts clean from the last committed version rather than
 * from whatever was mid-edit the last time this flow was in `draft`.
 */
export type PromoteAutopilotFlow = {
  __typename: 'PromoteAutopilotFlow';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  flow?: Maybe<FlowType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A1: vouch for a question -> governed-query mapping so future
 * matching questions are served from the verified library (no LLM).
 * Governance action — back-office only; upserts on (company,
 * normalised question).
 */
export type PromoteInsightsVerifiedQuery = {
  __typename: 'PromoteInsightsVerifiedQuery';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/**
 * The F10 gated flow instance (RS-E7, D18). The materialization
 * snapshot is internal live-entity state and never crosses GraphQL;
 * the opaque rollback token plus the audit trail do.
 */
export type PromotionDef = Node & {
  __typename: 'PromotionDef';
  affectedHouseholds?: Maybe<Scalars['Int']['output']>;
  approvalRecord?: Maybe<Scalars['JSONString']['output']>;
  approvalRequired: Scalars['Boolean']['output'];
  /** SBX-504 (D72, D85): the day-one arithmetic rail in the go-live door's context, computed LIVE on read (never a stale render): the plan's five checks for a plan promotion, the import-shaped checks (computable ones computed, the rest stating why not) for an import promotion. A failing rail refuses approval without the typed arithmeticOverrideReason (the D72 doctrine); the copy the approve gate froze lives in diffSummary.arithmetic_checks and approvalRecord.arithmetic_checks. Wave D22 (SBX-537, the Q-028 follow-up): the rail is served on SINGLE-promotion reads only; list-shaped reads (relay connections such as allPromotions) serve null and the client presence-gates, exactly as it presence-gates commsGate. */
  arithmeticChecks?: Maybe<Scalars['GenericScalar']['output']>;
  channel: RouteStudioPromotionChannelChoices;
  /** SBX-376 (D32): snapshot age plus churn summary for the promoted plan's stop set (containers added/removed/moved since the snapshot, churn percent, warn threshold). Computed on read; the approve gate records what the approver acknowledged in approvalRecord.churn. Wave D22 (SBX-537, the Q-028 follow-up): the live-cohort pass is served on SINGLE-promotion reads only; list-shaped reads (relay connections such as allPromotions) serve null and the client presence-gates, exactly as it presence-gates commsGate. */
  churn?: Maybe<Scalars['GenericScalar']['output']>;
  /** Session 5 F2 (SBX-491, D09): the Communications step's ONE completeness truth, computed LIVE on read. state is complete ONLY when the exact affected-property count is computed AND the attached plan passes today's named gates; blocked (reason property_mapping_missing, null count) when movers cannot be mapped to households; incomplete with a named reason otherwise; recorded once execution began (stored approval-time figures). Every pre-execute payload serves the count's basis: mapped and unmapped moving containers plus the lead-time floor. The frontend keys the step's checkmark on THIS state, never on notification-plan attachment. Wave D21 (SBX-537): the pass is served on SINGLE-promotion reads only; list-shaped reads (relay connections such as allPromotions) serve null and the client presence-gates the step, exactly as it presence-gates absent fields. */
  commsGate?: Maybe<Scalars['GenericScalar']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  cutoverDate?: Maybe<Scalars['Date']['output']>;
  diffSummary?: Maybe<Scalars['JSONString']['output']>;
  /** SBX-376 (D18/D08): the pre-execute dry run on the shared diff/execute derivation: resolution rate, per-reason skip counts (container_not_live, cohort_exceeds_cadence, no_cadence_truth, ...) and the cross-area conflict count (SBX-370). Refreshed at diff, approve and schedule; readable any time before execute. Execute emits the same shape, derived from the actual materialization, as the promotion.execution_accounting event. */
  dryRun?: Maybe<Scalars['GenericScalar']['output']>;
  /** SBX-361 (D18): the living-network handover state: done (with the mapped vehicle-days and generation controls) or pending (with the due date), from the materialization log. */
  handover?: Maybe<Scalars['GenericScalar']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importConfig?: Maybe<Scalars['JSONString']['output']>;
  importMaterialization?: Maybe<CaseMaterializationDef>;
  materializationLog?: Maybe<Scalars['JSONString']['output']>;
  /** SBX-361 (D35/D32): the nightly NEEDS-ASSIGNMENT report: containers that entered the promoted area's cohort after cutover with no route scheme (exact count, capped id list, honest notes). Report only; assignment is the explicit assignContainersToPromotedScheme mutation. */
  needsAssignment?: Maybe<Scalars['GenericScalar']['output']>;
  notificationPlan?: Maybe<NotificationPlanDef>;
  notificationPlanState: Scalars['String']['output'];
  /** SBX-461 (D72, D08): present exactly when the execution landed PARTIALLY LIVE (it skipped more than the configured share of the affected route stops): landed/skipped stop counts, per-reason skip payload, the threshold that fired and the explicit rollback offer. Null on fully live executions. */
  partial?: Maybe<Scalars['GenericScalar']['output']>;
  plan?: Maybe<PlanDef>;
  rollbackToken: Scalars['String']['output'];
  rolloutMode?: Maybe<Scalars['JSONString']['output']>;
  savingsWeeks: PromotionSavingsWeekDefConnection;
  state: RouteStudioPromotionStateChoices;
  supersededBy?: Maybe<PromotionDef>;
  supersedes: PromotionDefConnection;
  /** SBX-514 A8 (session 3): the hour (UTC) of the nightly beat that executes human-approved SCHEDULED promotions whose cutover date arrived, read from the actual beat schedule source so the approval screen's 'goes live automatically at ...' sentence can never silently lie when the beat moves. Null when the beat entry is missing or not one fixed daily time. */
  sweepHourUtc?: Maybe<Scalars['Int']['output']>;
  /** SBX-514 A8: the minute (UTC) of the auto-fire sweep, beside sweepHourUtc; null under the same conditions. */
  sweepMinuteUtc?: Maybe<Scalars['Int']['output']>;
  transitions: Scalars['JSONString']['output'];
};


/**
 * The F10 gated flow instance (RS-E7, D18). The materialization
 * snapshot is internal live-entity state and never crosses GraphQL;
 * the opaque rollback token plus the audit trail do.
 */
export type PromotionDefSavingsWeeksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * The F10 gated flow instance (RS-E7, D18). The materialization
 * snapshot is internal live-entity state and never crosses GraphQL;
 * the opaque rollback token plus the audit trail do.
 */
export type PromotionDefSupersedesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PromotionDefConnection = {
  __typename: 'PromotionDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PromotionDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PromotionDef` and its cursor. */
export type PromotionDefEdge = {
  __typename: 'PromotionDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PromotionDef>;
};

/**
 * One promised-vs-realized week (RS-705), honest states
 * included (realized / partial / insufficient_data).
 */
export type PromotionSavingsWeekDef = Node & {
  __typename: 'PromotionSavingsWeekDef';
  caveats: Scalars['JSONString']['output'];
  computedAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  promised: Scalars['JSONString']['output'];
  promotion: PromotionDef;
  realized: Scalars['JSONString']['output'];
  status: RouteStudioPromotionSavingsWeekStatusChoices;
  weekStart: Scalars['Date']['output'];
};

export type PromotionSavingsWeekDefConnection = {
  __typename: 'PromotionSavingsWeekDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PromotionSavingsWeekDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PromotionSavingsWeekDef` and its cursor. */
export type PromotionSavingsWeekDefEdge = {
  __typename: 'PromotionSavingsWeekDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PromotionSavingsWeekDef>;
};

export type PropertyBulkUpdateCreateData = {
  area?: InputMaybe<Scalars['ID']['input']>;
  emergencyPriority?: InputMaybe<Scalars['String']['input']>;
  externalPropertyNumber?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInput>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parentProperty?: InputMaybe<Scalars['ID']['input']>;
  registerBasis?: InputMaybe<Scalars['String']['input']>;
  runInBackground?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['ID']['input'];
};

export type PropertyBulkUpdateCreateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PropertyBulkUpdateCreateMutation = {
  __typename: 'PropertyBulkUpdateCreateMutation';
  propertyList?: Maybe<Array<Maybe<PropertyDef>>>;
};

export type PropertyClusterDef = {
  __typename: 'PropertyClusterDef';
  duplicatedPoints?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  pointsOnTheSameLocation: Scalars['Boolean']['output'];
  propertyTypes?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  totalCount: Scalars['Int']['output'];
};

export type PropertyCollectionLogDef = {
  __typename: 'PropertyCollectionLogDef';
  agreement?: Maybe<AgreementDef>;
  date?: Maybe<Scalars['Date']['output']>;
  isUnplanned?: Maybe<Scalars['Boolean']['output']>;
  pickupOrder?: Maybe<PickUpOrderType>;
  status?: Maybe<PropertyCollectionLogStatus>;
};

/** An enumeration. */
export enum PropertyCollectionLogStatus {
  COMPLETE = 'COMPLETE',
  COMPLETE_NOT_EMPTIED = 'COMPLETE_NOT_EMPTIED',
  MISSED = 'MISSED',
  PENDING = 'PENDING',
  SCHEDULED = 'SCHEDULED'
}

export type PropertyContactDef = Node & {
  __typename: 'PropertyContactDef';
  /** @deprecated Use address fields instead */
  address: Scalars['String']['output'];
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  coName: Scalars['String']['output'];
  company: CompanyType;
  companyType: Scalars['String']['output'];
  contactType: CrmPropertyContactContactTypeChoices;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  ean: Scalars['String']['output'];
  email: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  endedBySync?: Maybe<MasterDataSyncDef>;
  externalContactId: Scalars['String']['output'];
  externalPropertyContactId: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isAdministrator: Scalars['Boolean']['output'];
  isCoOwner: Scalars['Boolean']['output'];
  isContact: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  isPayer: Scalars['Boolean']['output'];
  isTenant: Scalars['Boolean']['output'];
  kmdEasyFu51007FileLine: Fu51007FileLineDefConnection;
  masterDataUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  otherPhoneNumbers: Array<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  physicalKeys: PhysicalKeyTypeConnection;
  postalCode: Scalars['String']['output'];
  postalCodeName: Scalars['String']['output'];
  property: PropertyDef;
  propertyUsers?: Maybe<Array<Maybe<PropertyUserDef>>>;
  startDate: Scalars['DateTime']['output'];
  startedBySync?: Maybe<MasterDataSyncDef>;
  taxId?: Maybe<Scalars['String']['output']>;
  taxSubId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type PropertyContactDefKmdEasyFu51007FileLineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyContactDefPhysicalKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PropertyContactDefConnection = {
  __typename: 'PropertyContactDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PropertyContactDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PropertyContactDef` and its cursor. */
export type PropertyContactDefEdge = {
  __typename: 'PropertyContactDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PropertyContactDef>;
};

export type PropertyDef = Node & {
  __typename: 'PropertyDef';
  activeAgreementsCount?: Maybe<Scalars['Int']['output']>;
  agreements?: Maybe<AgreementDefConnection>;
  agreementshareSet: AgreementShareDefConnection;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<UserType>;
  archivedByRule?: Maybe<ArchivalRuleDef>;
  area?: Maybe<AreaDef>;
  automationActivity: Array<RecordActivityDef>;
  /** True while a wizard-created property awaits its register identity (external property number) from the master-data sync merge. Hidden (null) for contractor logins. */
  awaitingRegisterSync?: Maybe<Scalars['Boolean']['output']>;
  childProperties?: Maybe<PropertyDefConnection>;
  /** Limit the deviation to these properties. */
  collectionDeviations: CollectionCalendarDeviationDefConnection;
  collectionLog?: Maybe<Array<Maybe<PropertyCollectionLogDef>>>;
  company: CompanyType;
  compostingFormSubmissions: Array<CompostingFiledEventDef>;
  compostingRegistryEntries?: Maybe<CompostingRegistryEntryDefConnection>;
  contactProperties: ContactPropertyDefConnection;
  contacts: PropertyContactDefConnection;
  containernotificationSet: ContainerNotificationDefConnection;
  createdAt: Scalars['DateTime']['output'];
  createdByPropertySync?: Maybe<MasterDataSyncDef>;
  crmPortalToken?: Maybe<Scalars['String']['output']>;
  decodedId?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  effectiveInvoiceSyncFrequency: InvoiceSyncFrequency;
  emergencyPriority?: Maybe<CrmPropertyEmergencyPriorityChoices>;
  eventLog?: Maybe<PropertyEventLogEventWrapper>;
  /** Properties that keep collecting during the period. */
  excludedFromCollectionDeviations: CollectionCalendarDeviationDefConnection;
  externalPropertyNumber: Scalars['String']['output'];
  hasChildren?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  invoiceItems: InvoiceItemDefConnection;
  invoiceSet: InvoiceDefConnection;
  invoiceSyncConfig?: Maybe<PropertyInvoiceSyncConfigDef>;
  isPropertySyncDraft: Scalars['Boolean']['output'];
  kmdEasyFu51007FileLine: Fu51007FileLineDefConnection;
  kmdEasyFu51008FileLine: Fu51008FileLineDefConnection;
  lastView?: Maybe<PropertyViewEventDef>;
  location: LocationWithContainerType;
  managementCompanyProperties: ManagementCompanyPropertyDefConnection;
  metaData?: Maybe<Scalars['JSONString']['output']>;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  note: Scalars['String']['output'];
  notes: PropertyNoteDefConnection;
  notificationRules: ContactPropertyNotificationRuleDefConnection;
  /** @deprecated Legacy PropertyContact owner (NEXUS-604); its detail route is retired. Use ownerContactLink / ownerManagementCompanyLink. */
  owner?: Maybe<PropertyContactDef>;
  ownerContactLink?: Maybe<ContactPropertyDef>;
  ownerManagementCompanyLink?: Maybe<ManagementCompanyPropertyDef>;
  parentProperty?: Maybe<PropertyDef>;
  payerContactLink?: Maybe<ContactPropertyDef>;
  payerManagementCompanyLink?: Maybe<ManagementCompanyPropertyDef>;
  permits: PermitDefConnection;
  physicalKeys: PhysicalKeyTypeConnection;
  /** PLANNED relocations touching this property, each with the ids of the agreement/container/ticket rows it carries here — the read path that lets property views show a reported move before its tickets complete. Cancelled/completed groups never surface. Empty for contractor logins. */
  plannedRelocations: Array<PropertyPlannedRelocationDef>;
  portalConversations: PortalConversationDefConnection;
  propertyGroup?: Maybe<PropertyGroupDef>;
  propertyNotes?: Maybe<PropertyNoteDefConnection>;
  propertyuserSet: PropertyUserDefConnection;
  recurringPricing?: Maybe<Array<PriceDef>>;
  registerBasis: CrmPropertyRegisterBasisChoices;
  rentalRelocationsIn: Array<RentalRelocationDef>;
  rentalRelocationsOut: Array<RentalRelocationDef>;
  routeStudioStops: StopDefConnection;
  scpMemberships?: Maybe<Array<Maybe<ScpMembershipDef>>>;
  searchVectorUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  sharedTankMembership?: Maybe<SharedTankMembershipDef>;
  /** A property sharing the home property's tank. */
  sharedTankMemberships: SharedTankMembershipDefConnection;
  ticketdraftSet: TicketDraftDefConnection;
  tickets: TicketDefConnection;
  totalFees?: Maybe<Scalars['Int']['output']>;
  type: PropertyTypeDef;
  updatedAt: Scalars['DateTime']['output'];
  viewEvents: PropertyViewEventDefConnection;
  wasteDecisions: PropertyWasteDecisionDefConnection;
  wasteWaterTreatment?: Maybe<PropertyWasteWaterTreatmentDef>;
};


export type PropertyDefAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  container?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRentalBacked?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hauler?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['Float']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveOrFuture?: InputMaybe<Scalars['Boolean']['input']>;
  isContainerAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  isFuture?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  municipality?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  property?: InputMaybe<Scalars['ID']['input']>;
  propertyGroup?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wasteFraction?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type PropertyDefAgreementshareSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefChildPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  area_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  connectedToSewageNetwork?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludePropertyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRouteSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBlankAddress?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  invoiceSyncFrequency?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastViewedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  municipality?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  noRouteOnDay?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentProperty?: InputMaybe<Scalars['ID']['input']>;
  ppContainerProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ppRecurringProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ppServiceProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  propertyContactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroup?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  registerBasis?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  registerBasisDrift?: InputMaybe<Scalars['Boolean']['input']>;
  rootOnly?: InputMaybe<Scalars['Boolean']['input']>;
  routeScheme_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchContact?: InputMaybe<Scalars['String']['input']>;
  searchContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  searchExternalPropertyNumber?: InputMaybe<Scalars['String']['input']>;
  searchLocation?: InputMaybe<Scalars['String']['input']>;
  searchOwner?: InputMaybe<Scalars['String']['input']>;
  sharedTank?: InputMaybe<Scalars['Boolean']['input']>;
  sludgeTankType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zone_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyDefCollectionDeviationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefCollectionLogArgs = {
  collectionStatus?: InputMaybe<Scalars['String']['input']>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['Date']['input'];
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PropertyDefCompostingRegistryEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  apartmentIdentifier?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasReportedStop?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  inspectionResult?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isInspected?: InputMaybe<Scalars['Boolean']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationDateFrom?: InputMaybe<Scalars['Date']['input']>;
  notificationDateTo?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  property?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageMonths?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validOn?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};


export type PropertyDefContactPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefContainernotificationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefEventLogArgs = {
  addAgreementEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addDeletionEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addPickupOrdersEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addPropertyEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addRelatedHistory?: InputMaybe<Scalars['Boolean']['input']>;
  addTicketComments?: InputMaybe<Scalars['Boolean']['input']>;
  addTicketEvents?: InputMaybe<Scalars['Boolean']['input']>;
  agreementEventTypes?: InputMaybe<Array<InputMaybe<AgreementEventTypesGraphene>>>;
  authorAuthority?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  isTicketMessageInbound?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pickupOrderEventTypes?: InputMaybe<Array<InputMaybe<PickUpOrderEventTypesGraphene>>>;
  propertyEventTypes?: InputMaybe<Array<InputMaybe<PropertyEventTypesGraphene>>>;
  relatedHistoryTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  ticketEventTypes?: InputMaybe<Scalars['TicketEventTypeValuesList']['input']>;
  ticketMessageVia?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketTypes?: InputMaybe<Scalars['FromGlobalIDValuesList']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type PropertyDefExcludedFromCollectionDeviationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefInvoiceItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefInvoiceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefKmdEasyFu51007FileLineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefKmdEasyFu51008FileLineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefManagementCompanyPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefNotificationRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefPermitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefPhysicalKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefPortalConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefPropertyNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['ID']['input']>;
  authorAuthority?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  dateRangeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  dateRangeStart?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noteType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  visibilityLevels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PropertyDefPropertyuserSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefRouteStudioStopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefScpMembershipsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyDefSharedTankMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefTicketdraftSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefViewEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyDefWasteDecisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PropertyDefConnection = {
  __typename: 'PropertyDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PropertyDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PropertyDef` and its cursor. */
export type PropertyDefEdge = {
  __typename: 'PropertyDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PropertyDef>;
};

export type PropertyDefFilterInput = {
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  area_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  connectedToSewageNetwork?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludePropertyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRouteSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hasBlankAddress?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  invoiceSyncFrequency?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastViewedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  municipality?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  noRouteOnDay?: InputMaybe<Scalars['Date']['input']>;
  parentProperty?: InputMaybe<Scalars['ID']['input']>;
  ppContainerProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ppRecurringProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ppServiceProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  propertyContactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroup?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  registerBasis?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  registerBasisDrift?: InputMaybe<Scalars['Boolean']['input']>;
  rootOnly?: InputMaybe<Scalars['Boolean']['input']>;
  routeScheme_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchContact?: InputMaybe<Scalars['String']['input']>;
  searchContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  searchExternalPropertyNumber?: InputMaybe<Scalars['String']['input']>;
  searchLocation?: InputMaybe<Scalars['String']['input']>;
  searchOwner?: InputMaybe<Scalars['String']['input']>;
  sharedTank?: InputMaybe<Scalars['Boolean']['input']>;
  sludgeTankType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zone_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyEnvironmentalAccountType = {
  __typename: 'PropertyEnvironmentalAccountType';
  collections: Array<EnvironmentalAccountCollectionType>;
  endDate: Scalars['Date']['output'];
  fractions: Array<EnvironmentalAccountFractionType>;
  method: Scalars['String']['output'];
  missingCo2eFactorFractions: Array<Scalars['String']['output']>;
  missingDensityFractions: Array<Scalars['String']['output']>;
  startDate: Scalars['Date']['output'];
  totals: EnvironmentalAccountTotalsType;
};

export type PropertyEventDef = Node & {
  __typename: 'PropertyEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<PropertyEventTypesGraphene>>>;
  fromDescription?: Maybe<Scalars['String']['output']>;
  fromLocation?: Maybe<LocationType>;
  fromMetaData?: Maybe<Scalars['JSONString']['output']>;
  fromPropertyGroup?: Maybe<PropertyGroupDef>;
  fromPropertyNumber?: Maybe<Scalars['String']['output']>;
  fromPropertyType?: Maybe<PropertyTypeType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  property?: Maybe<PropertyDef>;
  propertyGroup?: Maybe<PropertyGroupDef>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toDescription?: Maybe<Scalars['String']['output']>;
  toLocation?: Maybe<LocationType>;
  toMetaData?: Maybe<Scalars['JSONString']['output']>;
  toPropertyGroup?: Maybe<PropertyGroupDef>;
  toPropertyNumber?: Maybe<Scalars['String']['output']>;
  toPropertyType?: Maybe<PropertyTypeType>;
  user?: Maybe<UserType>;
};

export type PropertyEventLogEvent = AgreementEventDef | AgreementShareEventDef | AgreementSuspensionEventDef | CollectionLocationEventDef | DeletionEventDef | PickUpOrderEventDef | ProductManagementEventDef | PropertyEventDef | PropertyNoteEventDef | PropertyWasteDecisionEventDef | ScpCompanyMembershipEventDef | ScpContainerAttachmentEventDef | ScpMembershipEventDef | ScpMembershipRoleEventDef | ScpNotificationRecordDef | ScpProfileEventDef | ScpRoleDefinitionEventDef | SystemHistoryEntryDef | TicketCommentDef | TicketEventDef | TicketMessageDef;

export type PropertyEventLogEventWrapper = {
  __typename: 'PropertyEventLogEventWrapper';
  edges?: Maybe<Array<Maybe<PropertyEventLogEvent>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum PropertyEventTypesGraphene {
  ARCHIVED_AT_CHANGE = 'ARCHIVED_AT_CHANGE',
  DESCRIPTION_CHANGE = 'DESCRIPTION_CHANGE',
  LOCATION_CHANGE = 'LOCATION_CHANGE',
  META_DATA_CHANGE = 'META_DATA_CHANGE',
  PROPERTY_GROUP_CHANGE = 'PROPERTY_GROUP_CHANGE',
  PROPERTY_NUMBER_CHANGE = 'PROPERTY_NUMBER_CHANGE',
  PROPERTY_TYPE_CHANGE = 'PROPERTY_TYPE_CHANGE'
}

export type PropertyGroupDef = Node & {
  __typename: 'PropertyGroupDef';
  canBeDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Limit the deviation to these property groups. */
  collectionDeviations: CollectionCalendarDeviationDefConnection;
  collectionLocations?: Maybe<Array<Maybe<CollectionLocationDef>>>;
  company: CompanyType;
  containers?: Maybe<Array<Maybe<ContainerType>>>;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  eventLog?: Maybe<PropertyEventLogEventWrapper>;
  /** Property groups that keep collecting during the period. */
  excludedFromCollectionDeviations: CollectionCalendarDeviationDefConnection;
  groupType: CrmPropertyGroupGroupTypeChoices;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  membersCount: Scalars['Int']['output'];
  metaData?: Maybe<Scalars['JSONString']['output']>;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  properties: PropertyDefConnection;
  scpCompanyMemberships?: Maybe<Array<Maybe<ScpCompanyMembershipDef>>>;
  scpContainerAttachments: ScpContainerAttachmentDefConnection;
  scpMemberships?: Maybe<Array<Maybe<ScpMembershipDef>>>;
  scpNotificationRecords: ScpNotificationRecordDefConnection;
  scpProfile?: Maybe<ScpProfileDef>;
  singleAddress: Scalars['String']['output'];
  singleCity: Scalars['String']['output'];
  singleCountry: Scalars['String']['output'];
  singleInvoiceEmail: Scalars['String']['output'];
  singlePhone: Scalars['String']['output'];
  singleTaxId: Scalars['String']['output'];
  singleZipCode: Scalars['String']['output'];
  totalContainers: Scalars['Int']['output'];
  usageProfileBreakdown: ScpMembershipUsageBreakdownDef;
};


export type PropertyGroupDefCollectionDeviationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyGroupDefEventLogArgs = {
  addPickupOrders?: InputMaybe<Scalars['Boolean']['input']>;
  addPropertyEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addScpEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addTicketComments?: InputMaybe<Scalars['Boolean']['input']>;
  addTicketEvents?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  isTicketMessageInbound?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  scpMemberPropertyId?: InputMaybe<Scalars['ID']['input']>;
  ticketEventTypes?: InputMaybe<Scalars['TicketEventTypeValuesList']['input']>;
  ticketMessageVia?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type PropertyGroupDefExcludedFromCollectionDeviationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyGroupDefPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyGroupDefScpCompanyMembershipsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyGroupDefScpContainerAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyGroupDefScpMembershipsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyGroupDefScpNotificationRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PropertyGroupDefConnection = {
  __typename: 'PropertyGroupDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PropertyGroupDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PropertyGroupDef` and its cursor. */
export type PropertyGroupDefEdge = {
  __typename: 'PropertyGroupDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PropertyGroupDef>;
};

/** Per-property invoice sync cadence config + last-sync tracking. */
export type PropertyInvoiceSyncConfigDef = Node & {
  __typename: 'PropertyInvoiceSyncConfigDef';
  createdAt: Scalars['DateTime']['output'];
  effectiveFrequency: InvoiceSyncFrequency;
  frequency?: Maybe<InvoiceSyncFrequency>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Wall-clock of the last successful export that included this property. The cadence clock: the next window is due at the end of the month in which (last_synced_at + interval) falls. */
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Exclusive lower bound on Invoice.issued_at for this property's next window. Advances to the run's upper bound on success. */
  lastSyncedIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  property: PropertyDef;
  /** @deprecated No longer used; removed from the UI 2026-09. */
  startPeriodOverride?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Union of ContactProperty and ManagementCompanyProperty for the unified
 * property links list (NEXUS-494).
 */
export type PropertyLinkDef = ContactPropertyDef | ManagementCompanyPropertyDef;

export type PropertyLinksWrapper = {
  __typename: 'PropertyLinksWrapper';
  edges?: Maybe<Array<Maybe<PropertyLinkDef>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PropertyManagementCompanyAddressDef = Node & {
  __typename: 'PropertyManagementCompanyAddressDef';
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  addressType: CrmPropertyManagementCompanyAddressAddressTypeChoices;
  coName: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fullAddress: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  managementCompany: PropertyManagementCompanyDef;
  postalCode: Scalars['String']['output'];
  postalCodeName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PropertyManagementCompanyAddressDefConnection = {
  __typename: 'PropertyManagementCompanyAddressDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PropertyManagementCompanyAddressDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PropertyManagementCompanyAddressDef` and its cursor. */
export type PropertyManagementCompanyAddressDefEdge = {
  __typename: 'PropertyManagementCompanyAddressDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PropertyManagementCompanyAddressDef>;
};

export type PropertyManagementCompanyAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressType?: InputMaybe<Scalars['String']['input']>;
  coName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeName?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyManagementCompanyDef = Node & {
  __typename: 'PropertyManagementCompanyDef';
  /** The company's currently-active agreements across its linked properties — the list behind activeContainerCount / activeRecurringFeeCount. Empty for contractor (hauler) logins. */
  activeAgreements: Array<AgreementDef>;
  activeContainerCount: Scalars['Int']['output'];
  activeRecurringFeeCount: Scalars['Int']['output'];
  additionalServicesSalesBan?: Maybe<Scalars['Boolean']['output']>;
  additionalServicesSalesBanReason: Scalars['String']['output'];
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  addresses?: Maybe<PropertyManagementCompanyAddressDefConnection>;
  authorityFeeDecision: Scalars['String']['output'];
  authorityFeeDecisionDate?: Maybe<Scalars['Date']['output']>;
  /** Per-customer invoice bundling override (canonical invoicing BundlingStrategy value), or null when inheriting the company default. */
  bundling?: Maybe<Scalars['String']['output']>;
  coName: Scalars['String']['output'];
  company: CompanyType;
  companyType: Scalars['String']['output'];
  contactId: Scalars['String']['output'];
  contacts?: Maybe<Array<ContactDef>>;
  country?: Maybe<CrmPropertyManagementCompanyCountryChoices>;
  createdAt: Scalars['DateTime']['output'];
  /** Manually placed credit hold. Read by hauler-order flows as a stop signal; never set automatically in wave 1. */
  creditHold: Scalars['Boolean']['output'];
  /** Credit limit in the tenant's currency. Master data only — nothing in this app computes or enforces balances (money lane, ADR-E3 gate). */
  creditLimit?: Maybe<Scalars['Decimal']['output']>;
  customerFunctions?: Maybe<Array<CustomerFunctionDef>>;
  /** Code of this company's default billing cadence (invoicing.BillingFrequency.code), or null if unset. */
  defaultBillingFrequencyCode?: Maybe<Scalars['String']['output']>;
  /** This company's default industry classification (inherited onto the customer's services), or null when unclassified. Stored on the PMC's underlying contact(s). */
  defaultIndustry?: Maybe<IndustryCodeDef>;
  /** Companion free text for the "Other — specify" industry code, or null when the company has no linked contact. */
  defaultIndustrySpecify?: Maybe<Scalars['String']['output']>;
  /** Reference to the account's default price list. A plain reference string in wave 1 — the price core is money-lane territory (mirrors hauler_orders.Order.price_list_ref). */
  defaultPriceListRef: Scalars['String']['output'];
  /** This company's default service responsibility (inherited onto new billable events), or null if unset. Stored on the PMC's underlying contact(s). */
  defaultServiceResponsibility?: Maybe<ServiceResponsibilityDef>;
  /** This company's e-invoice details, or null when none are set. Sync (autofill from the registry) is gated separately on businessRegistryConfig.eInvoiceEnabled; display is gated on the E_INVOICE ContactFieldConfiguration. */
  eInvoice?: Maybe<PropertyManagementCompanyEInvoiceDef>;
  ean: Scalars['String']['output'];
  /** The generic e-invoicing delivery email, independent of any business registry. Distinct from e_invoice_address above (BRIDGE-499/505: the FI YTJ registry's OVT-tunnus). */
  einvoiceAddress: Scalars['String']['output'];
  emails: Array<Scalars['String']['output']>;
  eventLog?: Maybe<PropertyEventLogEventWrapper>;
  externalContactId: Scalars['String']['output'];
  fullAddress: Scalars['String']['output'];
  /** HAUL-018 (hauler mode): the customer's agreement pre-authorizes moving a visit that lands on a public holiday to the next working day. False = every holiday move needs the office's explicit confirmation. Never a silent auto-move: the move is journaled either way. */
  holidayAutoMove: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Count + top-N of the individuals linked to this company, for the Individuals card folded into the cockpit overview. */
  individualsSummary: PmcIndividualsSummaryDef;
  invoiceDeliveryMethod: CrmPropertyManagementCompanyInvoiceDeliveryMethodChoices;
  invoiceLanguage: CrmPropertyManagementCompanyInvoiceLanguageChoices;
  invoiceReference: Scalars['String']['output'];
  invoiceTemplateCode: Scalars['String']['output'];
  managementCompanyProperties?: Maybe<ManagementCompanyPropertyDefConnection>;
  marketingOptOut?: Maybe<Scalars['Boolean']['output']>;
  marketingOptOutSetAt?: Maybe<Scalars['DateTime']['output']>;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nextCollection?: Maybe<NextCollectionType>;
  notificationRules: ContactPropertyNotificationRuleDefConnection;
  openExceptionCount: Scalars['Int']['output'];
  overdueAmount: Scalars['Decimal']['output'];
  overdueInvoiceCount: Scalars['Int']['output'];
  /** The seller/owner responsible for this account (hauler mode). */
  ownerUser?: Maybe<UserType>;
  /** Agreed payment terms in days (e.g. 14, 30). Null = the tenant's default terms apply. */
  paymentTermsDays?: Maybe<Scalars['Int']['output']>;
  phoneNumbers: Array<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  postalCodeName: Scalars['String']['output'];
  pricingMode: CrmPropertyManagementCompanyPricingModeChoices;
  recentExceptions?: Maybe<Array<Maybe<TicketDef>>>;
  recentInvoices?: Maybe<Array<Maybe<InvoiceDef>>>;
  reverseChargeVat: Scalars['Boolean']['output'];
  scheduledChanges: Array<ScheduledChangeDef>;
  scpMemberships: ScpCompanyMembershipDefConnection;
  searchUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Commercial segment of the account (hauler mode). Blank = not segmented. */
  segment?: Maybe<CrmPropertyManagementCompanySegmentChoices>;
  taxId: Scalars['String']['output'];
  taxSubId: Scalars['String']['output'];
  totalActiveAgreementAmount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vatEnabled: Scalars['Boolean']['output'];
};


export type PropertyManagementCompanyDefAddressesArgs = {
  addressType?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyManagementCompanyDefEventLogArgs = {
  addPickupOrders?: InputMaybe<Scalars['Boolean']['input']>;
  addPropertyEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addTicketComments?: InputMaybe<Scalars['Boolean']['input']>;
  addTicketEvents?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  isTicketMessageInbound?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ticketEventTypes?: InputMaybe<Scalars['TicketEventTypeValuesList']['input']>;
  ticketMessageVia?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type PropertyManagementCompanyDefIndividualsSummaryArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyManagementCompanyDefManagementCompanyPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  managementCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchManagementCompanies?: InputMaybe<Scalars['String']['input']>;
};


export type PropertyManagementCompanyDefNotificationRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyManagementCompanyDefRecentExceptionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyManagementCompanyDefRecentInvoicesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyManagementCompanyDefScheduledChangesArgs = {
  includeFinished?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyManagementCompanyDefScpMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PropertyManagementCompanyDefConnection = {
  __typename: 'PropertyManagementCompanyDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PropertyManagementCompanyDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PropertyManagementCompanyDef` and its cursor. */
export type PropertyManagementCompanyDefEdge = {
  __typename: 'PropertyManagementCompanyDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PropertyManagementCompanyDef>;
};

export type PropertyManagementCompanyEInvoiceDef = {
  __typename: 'PropertyManagementCompanyEInvoiceDef';
  address?: Maybe<Scalars['String']['output']>;
  operatorIdentifier?: Maybe<Scalars['String']['output']>;
  operatorName?: Maybe<Scalars['String']['output']>;
};

/**
 * A file hung off a property note (REQ-919).
 *
 * The field shape is ``TicketAttachmentDef`` minus its event log, so the
 * office front end renders note attachments with the component it already
 * has for ticket attachments. ``only_fields`` keeps the contract to exactly
 * what the front end was built against — no ``deleted`` flag and no
 * back-reference to the note.
 */
export type PropertyNoteAttachmentDef = Node & {
  __typename: 'PropertyNoteAttachmentDef';
  createdAt: Scalars['DateTime']['output'];
  file: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  originalFileName?: Maybe<Scalars['String']['output']>;
};

export type PropertyNoteDef = Node & {
  __typename: 'PropertyNoteDef';
  attachments?: Maybe<Array<Maybe<PropertyNoteAttachmentDef>>>;
  /** User who created this note */
  author?: Maybe<UserType>;
  authorName?: Maybe<Scalars['String']['output']>;
  authorityEntry: Scalars['Boolean']['output'];
  /** The note content */
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** End of visibility period (required for scheduled notes) */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  excerpt?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  noteType?: Maybe<PropertyNoteType>;
  property: PropertyDef;
  /** Start of visibility period (required for scheduled notes) */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** User who last updated this note */
  updatedBy?: Maybe<UserType>;
  visibilityLevels?: Maybe<Array<Maybe<NoteVisibility>>>;
};

export type PropertyNoteDefConnection = {
  __typename: 'PropertyNoteDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PropertyNoteDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PropertyNoteDef` and its cursor. */
export type PropertyNoteDefEdge = {
  __typename: 'PropertyNoteDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PropertyNoteDef>;
};

export type PropertyNoteEventDef = Node & {
  __typename: 'PropertyNoteEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<PropertyNoteEventTypesGraphene>>>;
  fromContent?: Maybe<Scalars['String']['output']>;
  fromEndDate?: Maybe<Scalars['DateTime']['output']>;
  fromNoteType?: Maybe<PropertyNoteType>;
  fromStartDate?: Maybe<Scalars['DateTime']['output']>;
  fromVisibilityLevels?: Maybe<Array<Maybe<NoteVisibility>>>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  propertyNote?: Maybe<PropertyNoteDef>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toContent?: Maybe<Scalars['String']['output']>;
  toEndDate?: Maybe<Scalars['DateTime']['output']>;
  toNoteType?: Maybe<PropertyNoteType>;
  toStartDate?: Maybe<Scalars['DateTime']['output']>;
  toVisibilityLevels?: Maybe<Array<Maybe<NoteVisibility>>>;
  user?: Maybe<UserType>;
};

export enum PropertyNoteEventTypesGraphene {
  NOTE_CONTENT_CHANGE = 'NOTE_CONTENT_CHANGE',
  NOTE_CREATED = 'NOTE_CREATED',
  NOTE_DELETED = 'NOTE_DELETED',
  NOTE_VISIBILITY_CHANGE = 'NOTE_VISIBILITY_CHANGE'
}

/**
 * Type of a PropertyNote.
 *
 *     - PERMANENT: always visible; date fields ignored at visibility time.
 *     - SCHEDULED: visible only between start_date and end_date (inclusive).
 *
 */
export enum PropertyNoteType {
  PERMANENT = 'PERMANENT',
  SCHEDULED = 'SCHEDULED'
}

/**
 * One PLANNED relocation touching the queried property (PRO-350),
 * partitioned to that property's side. Read-only projection of the
 * Relocation record + its RelocationItem inventory — no domain state is
 * re-derived here.
 */
export type PropertyPlannedRelocationDef = {
  __typename: 'PropertyPlannedRelocationDef';
  /** AgreementDef relay ids of this property's agreements the group end-dates directly (stay-mode / container-less rows). */
  agreementIds: Array<Scalars['ID']['output']>;
  /** ContainerType relay ids carried by the group's tickets at this property — the match key for move-mode origin rows, whose agreements are ended by ticket completion and have no inventory row of their own. */
  containerIds: Array<Scalars['ID']['output']>;
  /** Address of the relocation's destination property (Location.name), or null when it has none. */
  destinationAddress?: Maybe<Scalars['String']['output']>;
  /** PropertyDef relay id of the relocation's destination property. */
  destinationPropertyId?: Maybe<Scalars['ID']['output']>;
  direction: Scalars['String']['output'];
  movingDate: Scalars['Date']['output'];
  /** Address of the relocation's origin property (Location.name), or null when it has none. */
  originAddress?: Maybe<Scalars['String']['output']>;
  /** PropertyDef relay id of the relocation's origin property. */
  originPropertyId?: Maybe<Scalars['ID']['output']>;
  reference: Scalars['UUID']['output'];
  tickets: Array<PropertyPlannedRelocationTicketDef>;
};

/**
 * One composed container ticket of a planned relocation AT the queried
 * property (PRO-350). The destination's delivery ticket carries the
 * planned dims (names) so the FE can label the otherwise-anonymous
 * pending row; the origin's pickup ticket references an existing
 * container and typically carries none.
 */
export type PropertyPlannedRelocationTicketDef = {
  __typename: 'PropertyPlannedRelocationTicketDef';
  containerTypeName?: Maybe<Scalars['String']['output']>;
  /** TicketDef relay id of the composed ticket. */
  id: Scalars['ID']['output'];
  wasteFractionName?: Maybe<Scalars['String']['output']>;
};

export type PropertyPointMapDef = {
  __typename: 'PropertyPointMapDef';
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  propertyType?: Maybe<Scalars['ID']['output']>;
  routeScheme?: Maybe<Scalars['ID']['output']>;
};

export type PropertyTypeDef = Node & {
  __typename: 'PropertyTypeDef';
  agreementtemplateSet: AgreementTemplateDefConnection;
  code?: Maybe<Scalars['String']['output']>;
  company: CompanyType;
  containerpriceSet: ContainerPriceDefConnection;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  kmdEasyDefaultPropertyType: KmdEasyCompanySettingsDefConnection;
  kmdEasyPropertyTypeToKmdEasyStationCodeMap: PropertyTypeToKmdEasyStationCodeMapDefConnection;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  propertySet: PropertyDefConnection;
  recurringpriceSet: RecurringPriceDefConnection;
  scheduledexportSet: ScheduledExportDefConnection;
  scheduledexportrunSet: ScheduledExportRunDefConnection;
  servicepriceSet: ServicePriceDefConnection;
};


export type PropertyTypeDefAgreementtemplateSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeDefContainerpriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeDefKmdEasyDefaultPropertyTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeDefKmdEasyPropertyTypeToKmdEasyStationCodeMapArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeDefPropertySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeDefRecurringpriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeDefScheduledexportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeDefScheduledexportrunSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeDefServicepriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PropertyTypeDefConnection = {
  __typename: 'PropertyTypeDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PropertyTypeDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PropertyTypeDef` and its cursor. */
export type PropertyTypeDefEdge = {
  __typename: 'PropertyTypeDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PropertyTypeDef>;
};

export type PropertyTypeToKmdEasyStationCodeMapDef = Node & {
  __typename: 'PropertyTypeToKmdEasyStationCodeMapDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserType;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<UserType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  kmdEasyStationCode: Scalars['Int']['output'];
  propertyType: PropertyTypeDef;
};

export type PropertyTypeToKmdEasyStationCodeMapDefConnection = {
  __typename: 'PropertyTypeToKmdEasyStationCodeMapDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PropertyTypeToKmdEasyStationCodeMapDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PropertyTypeToKmdEasyStationCodeMapDef` and its cursor. */
export type PropertyTypeToKmdEasyStationCodeMapDefEdge = {
  __typename: 'PropertyTypeToKmdEasyStationCodeMapDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PropertyTypeToKmdEasyStationCodeMapDef>;
};

export type PropertyTypeType = Node & {
  __typename: 'PropertyTypeType';
  agreementtemplateSet: AgreementTemplateDefConnection;
  code?: Maybe<Scalars['String']['output']>;
  company: CompanyType;
  containerpriceSet: ContainerPriceDefConnection;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  kmdEasyDefaultPropertyType: KmdEasyCompanySettingsDefConnection;
  kmdEasyPropertyTypeToKmdEasyStationCodeMap: PropertyTypeToKmdEasyStationCodeMapDefConnection;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  propertySet: PropertyDefConnection;
  recurringpriceSet: RecurringPriceDefConnection;
  scheduledexportSet: ScheduledExportDefConnection;
  scheduledexportrunSet: ScheduledExportRunDefConnection;
  servicepriceSet: ServicePriceDefConnection;
};


export type PropertyTypeTypeAgreementtemplateSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeTypeContainerpriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeTypeKmdEasyDefaultPropertyTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeTypeKmdEasyPropertyTypeToKmdEasyStationCodeMapArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeTypePropertySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeTypeRecurringpriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeTypeScheduledexportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeTypeScheduledexportrunSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyTypeTypeServicepriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PropertyUserDef = Node & {
  __typename: 'PropertyUserDef';
  anonymous: Scalars['Boolean']['output'];
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  language: CrmPropertyUserLanguageChoices;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  properties: PropertyDefConnection;
  token: Scalars['UUID']['output'];
  username: Scalars['String']['output'];
};


export type PropertyUserDefPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PropertyUserDefConnection = {
  __typename: 'PropertyUserDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PropertyUserDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PropertyUserDef` and its cursor. */
export type PropertyUserDefEdge = {
  __typename: 'PropertyUserDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PropertyUserDef>;
};

export type PropertyViewEventDef = Node & {
  __typename: 'PropertyViewEventDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  createdByAction: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  property: PropertyDef;
  viewedBy?: Maybe<UserType>;
};

export type PropertyViewEventDefConnection = {
  __typename: 'PropertyViewEventDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PropertyViewEventDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PropertyViewEventDef` and its cursor. */
export type PropertyViewEventDefEdge = {
  __typename: 'PropertyViewEventDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PropertyViewEventDef>;
};

/**
 * An authority decision recorded against a property (NEXUS-704).
 *
 * Keskeytys / pidennys / käyttöoikeus with the authority's reference and
 * the validity period. ``isActive`` saves every consumer re-deriving the
 * inclusive-``validTo`` window; the 60-day expiry amber is an FE concern
 * (pure date arithmetic on ``validTo``).
 */
export type PropertyWasteDecisionDef = Node & {
  __typename: 'PropertyWasteDecisionDef';
  authorityEntry: Scalars['Boolean']['output'];
  /** The authority's reference / diaarinumero for the decision */
  authorityReference: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** Date the authority made the decision */
  decidedDate?: Maybe<Scalars['Date']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Valid today: validFrom has passed and validTo (inclusive) has not. */
  isActive: Scalars['Boolean']['output'];
  kind: CrmPropertyWasteDecisionKindChoices;
  note: Scalars['String']['output'];
  property: PropertyDef;
  validFrom: Scalars['Date']['output'];
  validTo?: Maybe<Scalars['Date']['output']>;
};

export type PropertyWasteDecisionDefConnection = {
  __typename: 'PropertyWasteDecisionDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PropertyWasteDecisionDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PropertyWasteDecisionDef` and its cursor. */
export type PropertyWasteDecisionDefEdge = {
  __typename: 'PropertyWasteDecisionDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PropertyWasteDecisionDef>;
};

/**
 * Waste-decision record/change/removal audit rows (QA-104 /
 * NEXUS-726 — the delete finally leaves a trace).
 */
export type PropertyWasteDecisionEventDef = Node & {
  __typename: 'PropertyWasteDecisionEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<PropertyWasteDecisionEventTypesGraphene>>>;
  fromAuthorityReference?: Maybe<Scalars['String']['output']>;
  fromDecidedDate?: Maybe<Scalars['Date']['output']>;
  fromKind?: Maybe<Scalars['String']['output']>;
  fromNote?: Maybe<Scalars['String']['output']>;
  fromValidFrom?: Maybe<Scalars['Date']['output']>;
  fromValidTo?: Maybe<Scalars['Date']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  property?: Maybe<PropertyDef>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toAuthorityReference?: Maybe<Scalars['String']['output']>;
  toDecidedDate?: Maybe<Scalars['Date']['output']>;
  toKind?: Maybe<Scalars['String']['output']>;
  toNote?: Maybe<Scalars['String']['output']>;
  toValidFrom?: Maybe<Scalars['Date']['output']>;
  toValidTo?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<UserType>;
  wasteDecision?: Maybe<PropertyWasteDecisionDef>;
};

export enum PropertyWasteDecisionEventTypesGraphene {
  DECISION_CHANGED = 'DECISION_CHANGED',
  DECISION_RECORDED = 'DECISION_RECORDED',
  DECISION_REMOVED = 'DECISION_REMOVED'
}

/**
 * Per-property waste-water treatment survey (fixes-round S6).
 *
 * The physical sludge tank is a normal Container (its ContainerType is
 * flagged ``is_sludge_tank``); this record carries only the survey data
 * plus the tank's own map pin.
 */
export type PropertyWasteWaterTreatmentDef = Node & {
  __typename: 'PropertyWasteWaterTreatmentDef';
  additionalInformation: Scalars['String']['output'];
  appliances: Array<Scalars['String']['output']>;
  company: CompanyType;
  /** When True the connection info alone is sufficient and the survey fields below are not shown in the UI. */
  connectedToSewageNetwork: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** E.g. cannot be emptied during the winter. */
  emptyingProblems: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  lastEmptiedDate?: Maybe<Scalars['Date']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  property: PropertyDef;
  /** Tank shared by multiple properties (joint well). */
  sharedTank?: Maybe<Scalars['Boolean']['output']>;
  sharedTankMembers: Array<Maybe<SharedTankMembershipDef>>;
  sharedWithCount: Scalars['Int']['output'];
  sludgeTankType?: Maybe<SludgeTankType>;
  tankVolumeM3?: Maybe<Scalars['Decimal']['output']>;
  toiletType?: Maybe<ToiletType>;
  /** Model, when the tank is a small treatment plant. */
  treatmentPlantModel: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wasteWaterTypes?: Maybe<WasteWaterTypes>;
};

export type PropertyWasteWaterTreatmentDefConnection = {
  __typename: 'PropertyWasteWaterTreatmentDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PropertyWasteWaterTreatmentDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PropertyWasteWaterTreatmentDef` and its cursor. */
export type PropertyWasteWaterTreatmentDefEdge = {
  __typename: 'PropertyWasteWaterTreatmentDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PropertyWasteWaterTreatmentDef>;
};

/**
 * Run a column-mapping proposer over the batch (RS-101, D23).
 *
 * ``use_copilot`` defaults to true; the Copilot seam degrades
 * gracefully to the deterministic heuristic when the SDK or key is
 * unavailable (Q-008), and the degradation is recorded on the batch.
 */
export type ProposeImportMappingMutation = {
  __typename: 'ProposeImportMappingMutation';
  importBatch?: Maybe<ImportBatchDef>;
  proposal?: Maybe<Scalars['GenericScalar']['output']>;
};

/**
 * Ask for a route-day / emptying-interval change on a route's
 * series. NOTHING is applied until the office approves.
 */
export type ProposeRouteChange = {
  __typename: 'ProposeRouteChange';
  proposal?: Maybe<ChangeProposalDef>;
};

export type PublicSaveTransferDocumentData = {
  __typename: 'PublicSaveTransferDocumentData';
  transferDocument?: Maybe<TransferDocumentType>;
};

export type PublicSignTransferDocument = {
  __typename: 'PublicSignTransferDocument';
  pdfUrl?: Maybe<Scalars['String']['output']>;
  transferDocument?: Maybe<TransferDocumentType>;
};

export type PublicTransferDocumentPdfUrl = {
  __typename: 'PublicTransferDocumentPdfUrl';
  pdfUrl?: Maybe<Scalars['String']['output']>;
};

export type PublicUpdateUnconfirmedUser = {
  __typename: 'PublicUpdateUnconfirmedUser';
  unconfirmedUser?: Maybe<UnconfirmedUserType>;
};

/** An enumeration. */
export enum PublicUpdateUnconfirmedUserHowDidYouHearAboutUs {
  EMAIL = 'EMAIL',
  FACEBOOK_ADS = 'FACEBOOK_ADS',
  GOOGLE_ADS = 'GOOGLE_ADS',
  LINKEDIN_ADS = 'LINKEDIN_ADS',
  SEARCH_ENGINE = 'SEARCH_ENGINE',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  WORD_OF_MOUTH = 'WORD_OF_MOUTH',
  YOUTUBE_ADS = 'YOUTUBE_ADS'
}

/** An enumeration. */
export enum PublicUpdateUnconfirmedUserInterestedHardware {
  AXLE_WEIGHT_LOADER = 'AXLE_WEIGHT_LOADER',
  FILL_LEVEL_SENSOR = 'FILL_LEVEL_SENSOR',
  QR_CODE_STICKERS = 'QR_CODE_STICKERS',
  RFID_TAGES_AND_READERS = 'RFID_TAGES_AND_READERS',
  WEIGHT_BRIDGE = 'WEIGHT_BRIDGE'
}

/** An enumeration. */
export enum PublicUpdateUnconfirmedUserInterestedSoftware {
  ASSET_MANAGEMENT = 'ASSET_MANAGEMENT',
  CITIZEN_MANAGEMENT = 'CITIZEN_MANAGEMENT',
  DRIVER_NAVIGATION = 'DRIVER_NAVIGATION',
  FLEET_MANAGEMENT = 'FLEET_MANAGEMENT',
  OPERATION_MANAGEMENT = 'OPERATION_MANAGEMENT'
}

/** An enumeration. */
export enum PublicUpdateUnconfirmedUserJobTitle {
  BACK_OFFICE_EMPLOYEE = 'BACK_OFFICE_EMPLOYEE',
  INNOVATION_LEADER = 'INNOVATION_LEADER',
  OPERATIONS_LEADER = 'OPERATIONS_LEADER',
  OTHER = 'OTHER',
  PARTNER = 'PARTNER',
  POLITICIAN = 'POLITICIAN',
  ROUTE_PLANNER = 'ROUTE_PLANNER',
  SERVICE_EMPLOYEE = 'SERVICE_EMPLOYEE',
  SYSTEMS_INTEGRATOR = 'SYSTEMS_INTEGRATOR',
  TRANSFORMATION_LEADER = 'TRANSFORMATION_LEADER',
  WASTE_OPERATIONS_MANAGER = 'WASTE_OPERATIONS_MANAGER'
}

/** An enumeration. */
export enum PublicUpdateUnconfirmedUserNumberOfEmployees {
  FROM_2_5 = 'FROM_2_5',
  FROM_6_10 = 'FROM_6_10',
  FROM_11_25 = 'FROM_11_25',
  FROM_26_50 = 'FROM_26_50',
  FROM_51_200 = 'FROM_51_200',
  FROM_201_500 = 'FROM_201_500',
  FROM_501 = 'FROM_501',
  JUST_ME = 'JUST_ME'
}

/** An enumeration. */
export enum PublicUpdateUnconfirmedUserSegment {
  LOCAL_AUTHORITY = 'LOCAL_AUTHORITY',
  ORGANIZATION = 'ORGANIZATION',
  OTHER = 'OTHER',
  PARTNER = 'PARTNER',
  WASTE_COLLECTOR = 'WASTE_COLLECTOR'
}

export type PublishInsightResult = {
  __typename: 'PublishInsightResult';
  error?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['GenericScalar']['output']>;
};

/**
 * One reconciliation row: a manually entered purchase-invoice ref/total
 * with a status (Unreconciled/Matched/Disputed). Append-only — a matched row
 * is locked and corrections are a new row (PRO-468).
 */
export type PurchaseInvoiceReconciliationType = Node & {
  __typename: 'PurchaseInvoiceReconciliationType';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** The contractor whose settlement the invoice is reconciled against. */
  hauler: HaulerDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Manually entered purchase-invoice reference (PJH ERP). */
  invoiceReference: Scalars['String']['output'];
  /** Manually entered purchase-invoice total in integer cents (matches settlement money). */
  invoiceTotalCents: Scalars['Int']['output'];
  /** True when the row is MATCHED: its reference/total are locked and its status is terminal (corrections are a new row). */
  isLocked: Scalars['Boolean']['output'];
  /** Optional PRO-465 credit/deduction entry that resolves a dispute. */
  manualEntry?: Maybe<ContractorManualEntryType>;
  month: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  /** unreconciled | matched | disputed. */
  status: Scalars['String']['output'];
  /**
   * Append-only status-transition audit
   * ({from,to,at,by,note,manual_entry_id} dicts).
   */
  statusLog: Array<Maybe<Scalars['GenericScalar']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
  year: Scalars['Int']['output'];
};

export type PurchaseInvoiceReconciliationTypeConnection = {
  __typename: 'PurchaseInvoiceReconciliationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PurchaseInvoiceReconciliationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PurchaseInvoiceReconciliationType` and its cursor. */
export type PurchaseInvoiceReconciliationTypeEdge = {
  __typename: 'PurchaseInvoiceReconciliationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PurchaseInvoiceReconciliationType>;
};

/** One item to order: a ContainerTypeType or SparePartType gid. */
export type PurchaseOrderLineInput = {
  itemTypeId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

/**
 * One ordered item. ``item_type_id`` is the same kind-encoded gid
 * the Balances rows carry (ContainerTypeType or SparePartType).
 */
export type PurchaseOrderLineType = {
  __typename: 'PurchaseOrderLineType';
  id: Scalars['ID']['output'];
  /** container_type | spare_part */
  itemKind: Scalars['String']['output'];
  /** ContainerTypeType:<pk> or SparePartType:<pk> relay id (like a balance row). */
  itemTypeId: Scalars['ID']['output'];
  itemTypeName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  quantityOutstanding: Scalars['Int']['output'];
  quantityReceived: Scalars['Int']['output'];
};

export type PurchaseOrderReceiptLineInput = {
  lineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

/**
 * A purchase order to a supplier. ``status`` is ordered,
 * partially_received, received or cancelled.
 */
export type PurchaseOrderType = {
  __typename: 'PurchaseOrderType';
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  expectedDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  lines: Array<PurchaseOrderLineType>;
  note: Scalars['String']['output'];
  /** "PO-<n>", a per-company counter. */
  number: Scalars['String']['output'];
  quantityOrdered: Scalars['Int']['output'];
  quantityReceived: Scalars['Int']['output'];
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  reference: Scalars['String']['output'];
  /** ordered | partially_received | received | cancelled */
  status: Scalars['String']['output'];
  supplier: Scalars['String']['output'];
  warehouseId: Scalars['ID']['output'];
  warehouseName: Scalars['String']['output'];
};

export type PurchaseOrdersPage = {
  __typename: 'PurchaseOrdersPage';
  rows: Array<PurchaseOrderType>;
  totalCount: Scalars['Int']['output'];
};

/** An enumeration. */
export enum PushNotificationTypes {
  CONTAINER_RELOCATED = 'CONTAINER_RELOCATED',
  INTEGRATION_ERROR = 'INTEGRATION_ERROR',
  OFFLINE_MODE_CONFLICT = 'OFFLINE_MODE_CONFLICT',
  STOP_ADDED = 'STOP_ADDED',
  STOP_REMOVED = 'STOP_REMOVED',
  STOP_TICKET_CREATED = 'STOP_TICKET_CREATED',
  UNKNOWN = 'UNKNOWN'
}

export type Query = {
  __typename: 'Query';
  _debug?: Maybe<DjangoDebug>;
  /** The ID of the object */
  acosArchiveLog?: Maybe<AcosArchiveLogType>;
  /** The ID of the object */
  agreement?: Maybe<AgreementDef>;
  /** The ID of the object */
  agreementTemplates?: Maybe<AgreementTemplateDef>;
  /** The ID of the object */
  alert?: Maybe<AlertDef>;
  /** The ID of the object */
  alertEvent?: Maybe<AlertEventDef>;
  /** The ID of the object */
  alertRecipient?: Maybe<AlertRuleDef>;
  /** The ID of the object */
  alertRule?: Maybe<AlertRuleDef>;
  allAcosArchiveLogs?: Maybe<AcosArchiveLogTypeConnection>;
  allAgreementExports?: Maybe<AgreementExportDefConnection>;
  allAgreementTemplates?: Maybe<AgreementTemplateDefConnection>;
  allAgreements?: Maybe<AgreementDefConnection>;
  allAlertEvents?: Maybe<AlertEventDefConnection>;
  allAlertRules?: Maybe<AlertRuleDefConnection>;
  allAlerts?: Maybe<AlertDefConnection>;
  allArchivalRules: Array<ArchivalRuleDef>;
  allAreas?: Maybe<AreaDefConnection>;
  allAuthorizationMethods?: Maybe<Array<AuthorizationMethodDef>>;
  allAuthorizationTypes?: Maybe<Array<AuthorizationTypeDef>>;
  /** RS-1502 audit trail: every applied, refused and rolled-back L3 action. */
  allAutopilotActions?: Maybe<AutopilotActionDefConnection>;
  allBaselines?: Maybe<BaselineDefConnection>;
  allBillingRuns?: Maybe<BillingRunDefConnection>;
  /** Every bonus/penalty model for the company (REQ 3.3.22/3.5.57) — company-wide, per-contractor and per-area scopes. The only read that surfaces company/contractor models, which hang off no area (area-scoped ones also appear under allAreas.bonusModels). Office-only + hauler-module gated; the FE filters by scope. */
  allBonusModels?: Maybe<Array<BonusModelType>>;
  /** RS-1602 (D39): the tenant brain, exportable: every suggested, confirmed and retired rule with provenance and history. */
  allBrainRules?: Maybe<BrainRuleDefConnection>;
  allBulkWasteFractions?: Maybe<WasteFractionTypeConnection>;
  /** RS-E21 candidate tables with their document-class verdicts; filter by case, file, docClass or needsConfirmation. */
  allCandidateTables?: Maybe<CandidateTableDefConnection>;
  /** RS-E25 materialization versions of a case, each with its stored run diff against the previous version (D56). */
  allCaseMaterializations?: Maybe<CaseMaterializationDefConnection>;
  allCaseQuestions?: Maybe<CaseQuestionDefConnection>;
  /** Change proposals of the company. Office: all, filterable by status / hauler / type / route / contract area, sortable on every column. Contractors: own hauler's only (server-enforced). */
  allChangeProposals?: Maybe<ChangeProposalDefConnection>;
  allCollectionCalendar?: Maybe<CollectionCalendarDefConnection>;
  allCollectionCalendarDates?: Maybe<CollectionCalendarDateDefConnection>;
  allCollectionCalendarDeviation?: Maybe<CollectionCalendarDeviationDefConnection>;
  allCollectionCalendarWeek?: Maybe<CollectionCalendarWeekDefConnection>;
  allCommentTerms?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  allCompanies?: Maybe<CompanyTypeConnection>;
  allCompanyContainerMetaTypes?: Maybe<CompanyContainerMetaTypeTypeConnection>;
  allCompanyEmailAccountMessages?: Maybe<CompanyEmailAccountMessageDefConnection>;
  allCompanyEmailAccountRules?: Maybe<CompanyEmailAccountRuleDefConnection>;
  allCompanyEmailAccounts?: Maybe<CompanyEmailAccountDefConnection>;
  allCompanyHolidays?: Maybe<Array<Maybe<CompanyHolidayDef>>>;
  allCompanyMetaTypes?: Maybe<CompanyMetaTypeDefConnection>;
  allCompanyRoles?: Maybe<CompanyRoleDefConnection>;
  allComparisonSettings?: Maybe<ComparisonSettingsTypeConnection>;
  /** Complaint feed (REQ 3.5.58, D5): tickets of a complaint type. Office sees all (optionally filtered by haulerId); a contractor sees only complaints linked to their own stops — whoever raised them — with the affectsPay flag. */
  allComplaints?: Maybe<Array<HaulerComplaintType>>;
  allCompostingRegistryEntries?: Maybe<CompostingRegistryEntryDefConnection>;
  allContactAuthorizations?: Maybe<ContactAuthorizationDefConnection>;
  /** Effective visibility/required config for all 16 Contact form fields. Returns defaults for fields without an explicit company override. */
  allContactFieldConfigurations: Array<ContactFieldConfigurationDef>;
  allContactProperties?: Maybe<ContactPropertyDefConnection>;
  allContactPropertyNotificationRules?: Maybe<Array<ContactPropertyNotificationRuleDef>>;
  /** List all available contact types. */
  allContactTypes?: Maybe<Array<ContactTypeType>>;
  allContacts?: Maybe<ContactDefConnection>;
  allContainerGroups?: Maybe<ContainerGroupDefConnection>;
  allContainerImports?: Maybe<ContainerImportTypeConnection>;
  allContainerNotifications?: Maybe<ContainerNotificationDefConnection>;
  /** @deprecated Use allProducts */
  allContainerPrices?: Maybe<ContainerPriceDefConnection>;
  allContainerTypes?: Maybe<ContainerTypeTypeConnection>;
  allContainerWeightImports?: Maybe<ContainerWeightImportTypeConnection>;
  allContainers?: Maybe<ContainerTypeConnection>;
  /** RS-802 Copilot sessions with full per-message action traces; tenant-scoped like every other surface. */
  allCopilotConversations?: Maybe<CopilotConversationDefConnection>;
  allCostModels?: Maybe<CostModelDefConnection>;
  allCostSettings?: Maybe<CostSettingsTypeConnection>;
  allCriiptoApplication?: Maybe<CriiptoApplicationDefConnection>;
  allCustomerFunctions?: Maybe<CustomerFunctionDefConnection>;
  allDashboards?: Maybe<DashboardDefConnection>;
  allDebtorExports?: Maybe<DebtorExportDefConnection>;
  /** List of all depots */
  allDepots?: Maybe<DepotTypeConnection>;
  allDeviceTypes?: Maybe<DeviceTypeTypeConnection>;
  allDocuments?: Maybe<DocumentDefConnection>;
  allDriverNotifications?: Maybe<DriverPushNotificationTypeConnection>;
  /** List of all drivers */
  allDrivers?: Maybe<DriverTypeConnection>;
  allEvolutionContainerCollectionItemSnapshot?: Maybe<ContainerCollectionItemSnapshotDefConnection>;
  allEvolutionContainerItemSnapshot?: Maybe<ContainerItemSnapshotDefConnection>;
  allEvolutionContainerLink?: Maybe<EvolutionContainerLinkDefConnection>;
  allEvolutionCustomerItemSnapshot?: Maybe<CustomerItemSnapshotDefConnection>;
  allEvolutionDeviationCodeMapping?: Maybe<EvolutionDeviationCodeMappingDefConnection>;
  allEvolutionManualSync?: Maybe<EvolutionManualSyncRunDefConnection>;
  allEvolutionSnapshotBatch?: Maybe<SnapshotBatchDefConnection>;
  allEvolutionSoapApiCallHistory?: Maybe<EvolutionSoapApiCallHistoryDefConnection>;
  allEvolutionSoapApiCredentials?: Maybe<EvolutionSoapApiCredentialsDefConnection>;
  allEvolutionTicketItemSnapshot?: Maybe<TicketItemSnapshotDefConnection>;
  /** RS-1501 nightly exploration runs: budget ledger, hypothesis audit, Pareto frontier and digest. */
  allExplorationRuns?: Maybe<ExplorationRunDefConnection>;
  allExportTemplates?: Maybe<ExportTemplateDefConnection>;
  allExports?: Maybe<ExportTypeConnection>;
  /** COMPASS-885 / HSY REQ 43: the office's view of every externally-sourced confirmation, including the UNMATCHED queue. Always scoped to the caller's company. Office-only: contractor (hauler) logins read an empty list, matching the assert_office_user wall on the two ingest mutations. */
  allExternalCollectionEvents: Array<ExternalCollectionEventDef>;
  /** 3.1.45 / REQ-47: the company's registered external map layers (WMS/WFS/WMTS/XYZ/raster). Office-only, company-scoped. */
  allExternalMapLayers?: Maybe<Array<Maybe<ExternalMapLayerDef>>>;
  allExternalPropertyNumbers?: Maybe<Array<Scalars['String']['output']>>;
  allFillLevelMeasurements?: Maybe<FillLevelMeasurementTypeConnection>;
  /** Fixed route templates of the company (Fixed Routes module); empty for a company without the module. */
  allFixedRouteTemplates?: Maybe<FixedRouteTemplateTypeConnection>;
  /** RS-E26 per-fraction service bindings (D57): one row per fraction service per container or stop, with its own cadence; filter by case, route identity, fraction or active. */
  allFractionServiceBindings?: Maybe<FractionServiceBindingDefConnection>;
  allGrammarClaims?: Maybe<GrammarClaimDefConnection>;
  /** Operation-level audit of bulk updates / index adjustments: kind, applied-to (base/current), percent or cents delta, author and date. Company-scoped; contractors see their own hauler's rows only. */
  allHaulerPriceChangeLogs?: Maybe<Array<Maybe<HaulerPriceChangeLogDef>>>;
  allHaulerPrices?: Maybe<HaulerPriceDefConnection>;
  allHaulers?: Maybe<HaulerDefConnection>;
  /** RS-E26 identity map (D58): the client-known identities of a case with their platform resolution state; system ids stay internal. */
  allIdentityMapEntries?: Maybe<IdentityMapDefConnection>;
  allImportBatches?: Maybe<ImportBatchDefConnection>;
  /** RS-E20 onboarding cases: long-lived containers for files, candidate tables, claims and questions (D62). */
  allImportCases?: Maybe<ImportCaseDefConnection>;
  allImportFiles?: Maybe<ImportFileDefConnection>;
  allImportHistory?: Maybe<ImportHistoryDefConnection>;
  allImportIssues?: Maybe<ImportIssueDefConnection>;
  allImportedKmdEasyFile?: Maybe<ImportedKmdEasyFileDefConnection>;
  allIndustryCodes: Array<IndustryCodeDef>;
  allInquiries?: Maybe<CollectionInquiryTypeConnection>;
  allInquiryTypings?: Maybe<CollectionInquiryTypingTypeConnection>;
  allIntegrationGps?: Maybe<IntegrationGpsTypeConnection>;
  allIntegrationGpsVehicle?: Maybe<IntegrationGpsVehicleTypeConnection>;
  allIntegrationUrbaserCallResponseHistory?: Maybe<IntegrationUrbaserCallResponseHistoryDefConnection>;
  allIntegrationUrbaserCallResponseHistoryAgreement?: Maybe<IntegrationUrbaserCallResponseHistoryAgreementDefConnection>;
  allIntegrationsUrbaserAgreementsSync?: Maybe<IntegrationUrbaserAgreementsSyncDefConnection>;
  allInvoiceItems?: Maybe<InvoiceItemDefConnection>;
  allInvoices?: Maybe<InvoiceDefConnection>;
  allKeyTypes?: Maybe<KeyTypeTypeConnection>;
  allKmdEasyDeltaFiles?: Maybe<KmdEasyDeltaFileDefConnection>;
  allKmdEasyFileFu51007FileLine?: Maybe<Fu51007FileLineDefConnection>;
  allKmdEasyFileFu51008FileLine?: Maybe<Fu51008FileLineDefConnection>;
  allKmdEasyFileFu63302FileLine?: Maybe<KmdEasyFileFu63302FileLineDefConnection>;
  allKmdEasyFileFu63303FileLine?: Maybe<KmdEasyFileFu63303FileLineDefConnection>;
  allKmdEasyTotalFiles?: Maybe<KmdEasyTotalFileDefConnection>;
  /** COMPASS-886 / HSY REQ 264: the chained pallet/compactor confirmations. Filter by route, by status (loaded|emptied|unloaded|cancelled) or by pending=true (the loads currently ON A TRUCK). Company-scoped; a contractor sees their own routes' loads only. A plain list, not a connection: a route carries a handful of load units and the office feed is filtered by route or by pending. */
  allLoadUnitJobs?: Maybe<Array<LoadUnitJobType>>;
  allLocations?: Maybe<LocationTypeConnection>;
  allLorawanDevices?: Maybe<LorawanDeviceTypeConnection>;
  allManagementCompanyProperties?: Maybe<ManagementCompanyPropertyDefConnection>;
  allMasterDataSyncs?: Maybe<MasterDataSyncDefConnection>;
  /** RS-E25 dated route-runs (staging, never live objects): filter by case, version, route identity or date range. */
  allMaterializedRuns?: Maybe<MaterializedRunDefConnection>;
  allMeasurementSettings?: Maybe<MeasurementSettingsTypeConnection>;
  allMobileDevices?: Maybe<MobileDeviceTypeConnection>;
  allMunicipalities?: Maybe<MunicipalityDefConnection>;
  allMunicipalityCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** RS-1603 (D42): narrative factory documents, draft and approved. */
  allNarrativeDocuments?: Maybe<NarrativeDocumentDefConnection>;
  allNotificationMessages?: Maybe<NotificationMessageDefConnection>;
  allNotificationSettings?: Maybe<NotificationSettingsTypeConnection>;
  allNotifications?: Maybe<NotificationsTypeConnection>;
  allParameterSets?: Maybe<ParameterSetDefConnection>;
  allPermissions?: Maybe<PermissionTypeConnection>;
  allPhysicalKeys?: Maybe<PhysicalKeyTypeConnection>;
  allPickupOrderApprovalCollections?: Maybe<PickUpOrderApprovalCollectionDefConnection>;
  allPickupOrderApprovals?: Maybe<PickUpOrderApprovalDefConnection>;
  allPickupOrders?: Maybe<PickUpOrderTypeConnection>;
  allPickupSettings?: Maybe<PickupSettingsTypeConnection>;
  /** RS-504: the plan's customer-facing calendar projection, one row per property-fraction, filterable to the changed subset that feeds F11 notifications. */
  allPlanCalendarEntries?: Maybe<PlanCalendarEntryDefConnection>;
  allPlanningAreas?: Maybe<PlanningAreaDefConnection>;
  allPlans?: Maybe<PlanDefConnection>;
  allPrices?: Maybe<PriceDefConnection>;
  allProducts?: Maybe<ProductDefConnection>;
  allProjects?: Maybe<ProjectTypeConnection>;
  /** RS-E7 gated promotions (F10, D18): the audit spine of every attempt to change live operations. */
  allPromotions?: Maybe<PromotionDefConnection>;
  allProperties?: Maybe<PropertyDefConnection>;
  /** @deprecated Use allContacts/allContactProperties */
  allPropertyContacts?: Maybe<PropertyContactDefConnection>;
  allPropertyGroups?: Maybe<PropertyGroupDefConnection>;
  allPropertyLinks?: Maybe<PropertyLinksWrapper>;
  allPropertyManagementCompanies?: Maybe<PropertyManagementCompanyDefConnection>;
  allPropertyTypeToKmdEasyStationCode?: Maybe<PropertyTypeToKmdEasyStationCodeMapDefConnection>;
  allPropertyTypes?: Maybe<PropertyTypeDefConnection>;
  allPropertyUsers?: Maybe<PropertyUserDefConnection>;
  allRecommendations?: Maybe<RecommendationDefConnection>;
  /** @deprecated Use allProducts */
  allRecurringPrices?: Maybe<RecurringPriceDefConnection>;
  /** HSY 263: the company's period-scoped reliability exclusion windows, newest period first. areaId keeps windows covering that area (all-areas windows always match); fromDate/toDate keep windows overlapping that range; includeInactive=false hides deactivated windows. Office-only, hauler-module gated. */
  allReliabilityExclusionWindows?: Maybe<Array<ReliabilityExclusionWindowType>>;
  allRouteProblemErrors?: Maybe<RouteProblemErrorDefConnection>;
  allRouteProblems?: Maybe<RouteProblemDefConnection>;
  /** List of all Route Schemes */
  allRouteSchemes?: Maybe<RouteSchemeTypeConnection>;
  /** List of all Route Settings */
  allRouteSettings?: Maybe<RouteSettingsTypeConnection>;
  /** SBX-380 (D08/D45): the activity stream. Every route_studio.* domain event the module writes, newest first: type, timestamp, actor (user or system source) and the redacted payload summary. Filterable by event type(s), source, time range, planning area (payload-reference matching) and promotion; company-scoped, flag-gated, page size capped at 100. */
  allRouteStudioEvents?: Maybe<RouteStudioEventDefConnection>;
  allRouteVehicleSessions?: Maybe<RouteVehicleSessionTypeConnection>;
  allRoutes?: Maybe<RouteTypeConnection>;
  allScenarios?: Maybe<ScenarioDefConnection>;
  allScheduledExport?: Maybe<ScheduledExportDefConnection>;
  allScheduledExportRun?: Maybe<ScheduledExportRunDefConnection>;
  allScpMemberships?: Maybe<Array<Maybe<ScpMembershipDef>>>;
  allScpRoleDefinitions?: Maybe<Array<Maybe<ScpRoleDefinitionDef>>>;
  /** @deprecated Use allProducts */
  allServicePrices?: Maybe<ServicePriceDefConnection>;
  allServiceResponsibilities?: Maybe<ServiceResponsibilityDefConnection>;
  /** RS-302 visual QA layer: street-segment service units with member stops, side of street and map-matched geometry, filterable per stop set. */
  allServiceUnits?: Maybe<ServiceUnitDefConnection>;
  allServices?: Maybe<ServiceDefConnection>;
  allSettings?: Maybe<SettingsTypeConnection>;
  allSigFoxDevices?: Maybe<SigFoxDeviceTypeConnection>;
  allSimulationJobs?: Maybe<SimulationJobDefConnection>;
  /** List of all skills */
  allSkills?: Maybe<SkillTypeConnection>;
  /** RS-E27 verification rows: source vs computed per scope key, itemized, never netted; filter by case, materialization, metric or verdict. */
  allSourceMetrics?: Maybe<SourceMetricDefConnection>;
  allSpareParts?: Maybe<SparePartTypeConnection>;
  allStopListFieldOptions?: Maybe<Array<Maybe<StopListFieldDef>>>;
  allStopSets?: Maybe<StopSetDefConnection>;
  allSvarutDispatches?: Maybe<SvarUtDispatchTypeConnection>;
  /** Task-level hauler reassignment audit (who moved which task between which contractors, when and why). Company-scoped; contractors see only logs involving their own hauler, with the counterparty masked. */
  allTaskHaulerReassignmentLogs?: Maybe<Array<Maybe<TaskHaulerReassignmentLogType>>>;
  allTeams?: Maybe<TeamTypeConnection>;
  allTicketCategories?: Maybe<TicketCategoryDefConnection>;
  allTicketDrafts?: Maybe<TicketDraftDefConnection>;
  allTicketMessageTemplates?: Maybe<TicketMessageTemplateDefConnection>;
  allTicketTypeAreaExecutionWindows?: Maybe<Array<Maybe<TicketTypeAreaExecutionWindowDef>>>;
  allTicketTypes?: Maybe<TicketTypeDefConnection>;
  allTickets?: Maybe<TicketDefConnection>;
  allTransferDocuments?: Maybe<TransferDocumentTypeConnection>;
  /** The load (kuorma) table, Annex 3.1 §8.4. One row per load with its identifier (number + year), vehicle, service provider, open/close times, kilometres, weighed weight and unloading location; `memberStops` gives the containers emptied into it and when (requirement 220). Searchable by load date, service provider, vehicle and identifier. Company-scoped; a contractor sees only its own loads, the office sees the tenant. Weight and kilometres are null when not recorded, never 0. */
  allTruckloads?: Maybe<TruckloadTypeConnection>;
  /** Unloading report feed (REQ 3.5.47): completed depot stops at waste stations. Station, route, hauler, driver session, vehicle, weight and completed time resolve through the standard stop type. Hauler-scoped: contractors see their own routes' events only; office sees the whole company. Weight is empty when the driver weight prompt was off. */
  allUnloadingEvents?: Maybe<PickUpOrderTypeConnection>;
  allUserAbsences?: Maybe<UserAbsenceTypeConnection>;
  allUserEventsNotifications?: Maybe<UserNotificationsEventsWrapper>;
  allUserFilterCollections?: Maybe<UserFilterCollectionTypeConnection>;
  allUserJobNotifications?: Maybe<UserJobNotificationTypeConnection>;
  allUserNotifications?: Maybe<UserNotificationTypeConnection>;
  allUsers?: Maybe<UserTypeConnection>;
  /** RS-E28 validation verdicts (D61): one client verdict per route identity per materialization version; filter by case, materialization, verdict or waived. */
  allValidationVerdicts?: Maybe<ValidationVerdictDefConnection>;
  allVehicleAbsences?: Maybe<VehicleAbsenceTypeConnection>;
  /** COMPASS-880 / HSY REQ 31: every vehicle confirmation signal this company received, applied or not. Unmatched signals are the point — a reader event that vanished into a log line would be invisible exactly when someone disputes the collection it was meant to confirm. */
  allVehicleSignals?: Maybe<VehicleConfirmationSignalTypeConnection>;
  /** List of all vehicle sizes */
  allVehicleSizes?: Maybe<VehicleSizeDefConnection>;
  /** List of all vehicle types */
  allVehicleTypes?: Maybe<VehicleTypeTypeConnection>;
  /** List of all vehicles */
  allVehicles?: Maybe<VehicleTypeConnection>;
  allVismaExportLogs?: Maybe<VismaExportLogTypeConnection>;
  allWasteFractions?: Maybe<WasteFractionTypeConnection>;
  allWasteTypes?: Maybe<WasteTypeTypeConnection>;
  /** COMPASS-877 / HSY REQ 18: weighings delivered by the unloading sites' weighing systems. Filter status: "unmatched" for the office manual-match queue. Office-only, company-scoped. */
  allWeighTickets?: Maybe<WeighTicketTypeConnection>;
  /** Corrections of completed work tasks back to undone, with the hand-over decision (HSY req 253). Company-scoped; contractors see only corrections handed to their own hauler. */
  allWorkTaskCorrections?: Maybe<Array<Maybe<WorkTaskCorrectionType>>>;
  /** T4: the company's admin-maintained zone label/type list. Office-only, company-scoped. */
  allZoneLabels?: Maybe<Array<Maybe<ZoneLabelDef>>>;
  /** The zones home (platform Settings since T4). Office-only, company-scoped. */
  allZones?: Maybe<ZoneDefConnection>;
  analytics?: Maybe<AnalyticsType>;
  archivableDataTypes: Array<ArchivableDataTypeDef>;
  /** Dry-run: how many records the given condition would archive right now. Use before saving a rule — automatic archiving is destructive-adjacent. */
  archivalRulePreview: Scalars['Int']['output'];
  archivedRecords: ArchivedRecordsPageDef;
  /** The ID of the object */
  area?: Maybe<AreaDef>;
  /** The ID of the object */
  authorizationMethod?: Maybe<AuthorizationMethodDef>;
  /** The ID of the object */
  authorizationType?: Maybe<AuthorizationTypeDef>;
  automation?: Maybe<AutomationDef>;
  automationApproval?: Maybe<ApprovalDef>;
  automationApprovalCounts: ApprovalCountsDef;
  automationApprovals: ApprovalDefConnection;
  automationAuditLog: AuditLogDefConnection;
  automationBootstrap: AutomationBootstrap;
  automationCatalog: AutomationCatalog;
  automationDiff: AutomationDiffDef;
  automationForSubject: Array<RecordActivityDef>;
  automationNeedsAttention: NeedsAttentionDef;
  automationRun?: Maybe<RunTraceDef>;
  automationRuns: RunDefConnection;
  automationSettings: AutomationSettingsDef;
  automationTemplate?: Maybe<TemplateDef>;
  automationTemplates: Array<TemplateDef>;
  automations: AutomationDefConnection;
  /** The D35 autonomy ladder in plain words (L0..L3, as data). L4 has no entry because L4 does not exist. */
  autonomyLevels?: Maybe<Scalars['GenericScalar']['output']>;
  /** The ID of the object */
  autopilotAction?: Maybe<AutopilotActionDef>;
  autopilotAssumptions?: Maybe<AutopilotAssumptionSetType>;
  autopilotContextHealth: Array<AutopilotContextLayerHealthType>;
  autopilotEnabled: Scalars['Boolean']['output'];
  autopilotEntryPointContext?: Maybe<AutopilotEntryPointContextType>;
  autopilotEstatePreview?: Maybe<AutopilotEstatePreviewType>;
  autopilotFlow?: Maybe<FlowType>;
  autopilotFlowRun?: Maybe<AutopilotFlowRunType>;
  autopilotFlowRuns: AutopilotFlowRunListType;
  autopilotFlows?: Maybe<Array<FlowType>>;
  autopilotFlowsPage: AutopilotFlowListType;
  autopilotImpactLedger: Array<AutopilotImpactLedgerEntryType>;
  autopilotLegacyRules?: Maybe<Array<AutopilotLegacyRuleType>>;
  autopilotLegacyRulesPage: AutopilotLegacyRuleListType;
  autopilotMigrationProgress?: Maybe<AutopilotMigrationProgressType>;
  autopilotOpportunityCost: Array<AutopilotOpportunityCostRowType>;
  autopilotPendingApprovals: Array<AutopilotPendingApprovalType>;
  autopilotPortfolioCollisions?: Maybe<AutopilotPortfolioPreviewType>;
  autopilotRegisteredActions?: Maybe<Array<RegisteredActionType>>;
  autopilotRetroSavings?: Maybe<AutopilotRetroSavingsType>;
  autopilotShadowReport?: Maybe<AutopilotShadowReportType>;
  autopilotSimulateFlow?: Maybe<AutopilotSimulateReportType>;
  autopilotStarterGallery?: Maybe<Array<AutopilotPlaybookType>>;
  autopilotSuggestionDraft?: Maybe<AutopilotSuggestionDraftType>;
  autopilotSuggestions: Array<AutopilotSuggestionType>;
  autopilotTicketStudioEnabled: Scalars['Boolean']['output'];
  autopilotValidateFlowDefinition: AutopilotFlowValidationResultType;
  autopilotWatchtowerAlerts: Array<AutopilotWatchtowerAlertType>;
  autopilotWatchtowerDigest?: Maybe<AutopilotWatchtowerDigestType>;
  /** The ID of the object */
  baseline?: Maybe<BaselineDef>;
  /** The standing billing due list for the caller's company: per-frequency cycle summaries, the due rows, and the last_computed watermark (refreshed nightly). */
  billingDueList?: Maybe<BillingDueListType>;
  /** The admin-maintained billing cadences (for pickers). */
  billingFrequencies?: Maybe<Array<Maybe<BillingFrequencyDef>>>;
  /** The ID of the object */
  billingRun?: Maybe<BillingRunDef>;
  /** The ID of the object */
  brainRule?: Maybe<BrainRuleDef>;
  brregCompanyInfo?: Maybe<BrregCompanyInfoType>;
  /** Staff only: one company's New dashboards, its switch and datasets, and its Metabase dashboards beside their copies. */
  builderDashboardsAdmin?: Maybe<BuilderDashboardsAdminType>;
  businessAnalytics?: Maybe<BusinessAnalyticsType>;
  businessRegistryConfig?: Maybe<BusinessRegistryConfigDef>;
  /** SBX-360: per-weekday aggregation of the LIVE container collection calendars (the platform's weekday truth, Container.collection_calendar): exact bin counts with per-fraction and per-scheme splits, plus up to stopCap (default 500, hard max 2000) map dots per weekday with an honest truncation flag. Read-only (D18). SBX-377 adds the season dimension (incl. the named active periods), SBX-363 the optional deviation-week view. */
  calendarBoard?: Maybe<CalendarBoardDef>;
  /** The ID of the object */
  candidateTable?: Maybe<CandidateTableDef>;
  /** RS-E24 completeness manifest: requirement nodes, D62 gap prompts, blocking set; refreshed on read. */
  caseManifest?: Maybe<CaseManifestDef>;
  /** The ID of the object */
  caseMaterialization?: Maybe<CaseMaterializationDef>;
  /** RS-E29 narrator (D63): the importer's plain-language readback, deterministic server-side composition: what you uploaded, what we understood, have vs missing, the verdict sentence, the next step. */
  caseNarration?: Maybe<CaseNarrationDef>;
  /** Quality report v2 at case level: category verdicts first, then claims/questions state, then verification verdicts; machine-readable and human-readable. */
  caseQualityReport?: Maybe<CaseQualityReportDef>;
  /** The ID of the object */
  caseQuestion?: Maybe<CaseQuestionDef>;
  /** RS-E28 stage H validation room (D61): per-route side-by-side of source vs computed values with discrepancy verdicts and the current human verdict, plus sign-off progress. state=not_ready (with reasons) while the stage G gate blocks the room; an import that cannot be verified never reaches validation (D62). */
  caseValidation?: Maybe<CaseValidationDef>;
  /** RS-E27 stage G verification state of a materialization version (default: the newest); rows via allSourceMetrics. */
  caseVerification?: Maybe<CaseVerificationDef>;
  /** PRODUCT-522: may this skip be loaded for this stop? The same verdict, in the same words, the stop completion refuses with - wrong type, unknown label, on hire at another address, decommissioned, not the unit issued on the order, no dispatch warehouse. Read-only. Refused for a company without the Skip hire module; a stop the caller may not see does not exist. */
  checkLoadedIdentity?: Maybe<LoadedIdentityVerdictDef>;
  /** The ID of the object */
  collectionCalendar?: Maybe<CollectionCalendarDef>;
  /** The ID of the object */
  collectionCalendarDate?: Maybe<CollectionCalendarDateDef>;
  /** The ID of the object */
  collectionCalendarDeviation?: Maybe<CollectionCalendarDeviationDef>;
  /** The ID of the object */
  collectionCalendarWeek?: Maybe<CollectionCalendarWeekDef>;
  collectionDeviationImpact?: Maybe<CollectionDeviationImpactDef>;
  /** The ID of the object */
  company?: Maybe<CompanyType>;
  /** The ID of the object */
  companyContainerMetaType?: Maybe<CompanyContainerMetaTypeType>;
  /** The ID of the object */
  companyEmailAccount?: Maybe<CompanyEmailAccountDef>;
  /** The ID of the object */
  companyEmailAccountMessage?: Maybe<CompanyEmailAccountMessageDef>;
  /** The ID of the object */
  companyEmailAccountRule?: Maybe<CompanyEmailAccountRuleDef>;
  /** Staff-only: the labelled boolean feature toggles for a company by id (impersonation-style read for the staff feature-flags admin). */
  companyFeatureFlags?: Maybe<Array<Maybe<CompanyFeatureFlagType>>>;
  /** The merged national+custom holiday calendar for the given year (display/management query). */
  companyHolidayCalendar?: Maybe<Array<CompanyHolidayCalendarEntryDef>>;
  companyInfo?: Maybe<CompanyInfoType>;
  companyInventoryTotals?: Maybe<CompanyInventoryTotalsType>;
  /** The ID of the object */
  companyMetaType?: Maybe<CompanyMetaTypeDef>;
  /** One general citizen<->company portal conversation by global id. Resolves to null for a conversation belonging to another company or to the hauler/ticket surfaces (server-enforced 404). */
  companyPortalConversation?: Maybe<PortalConversationDef>;
  /** General citizen<->company portal conversations (hauler NULL, ticket NULL), scoped server-side to the caller's company. Gated on crm_enable_messaging. */
  companyPortalConversations?: Maybe<Array<PortalConversationDef>>;
  /** The calling user's company's citizen-portal role->rights matrix (PRO-317): every role with its granted capability keys, plus the full capability-key and role vocabularies so a complete grid can be rendered. Company-scoped, so it works under impersonation exactly like every other tenant surface. */
  companyPortalRoleCapabilityMatrix: PortalRoleCapabilityMatrixDef;
  /** The ID of the object */
  companyRole?: Maybe<CompanyRoleDef>;
  companyRolesConfig?: Maybe<Array<Maybe<CompanyRoleConfigDef>>>;
  /** Per-company omnisearch include-list (every entity + enabled flag). */
  companySearchSettings: Array<CompanySearchEntitySetting>;
  companySettings?: Maybe<CompanySettingsType>;
  companyStockMatrix?: Maybe<CompanyStockMatrixType>;
  companyStockMovements?: Maybe<WarehouseMovementsPage>;
  companyTicketTypeCustomFields?: Maybe<TicketCustomFieldDefConnection>;
  /** The ID of the object */
  comparisonSettings?: Maybe<ComparisonSettingsType>;
  compatibleSparePartsForContainer?: Maybe<Array<Maybe<SparePartType>>>;
  /** lane-E (PRO-103, REQ 3.3.22): the settlement effect behind one complaint's affectsPay flag — which settlement run (area + month, open/closed) and what amount, read straight from the W9 settlement machinery. Office: any company complaint; a contractor only their own (linked via their stops); contractor foremen are refused (settlement figures). */
  complaintPayEffect?: Maybe<ComplaintPayEffectType>;
  compostingNotificationTemplate?: Maybe<CompostingNotificationTemplateDef>;
  /** The ID of the object */
  compostingRegistryEntry?: Maybe<CompostingRegistryEntryDef>;
  /**
   * The structured condition-type picker (PRO-391), company-scoped, lazily
   * seeded.
   */
  conditionTypes?: Maybe<Array<Maybe<ConditionTypeType>>>;
  /** The ID of the object */
  contact?: Maybe<ContactDef>;
  /** The ID of the object */
  contactAuthorization?: Maybe<ContactAuthorizationDef>;
  /** The canonical migrated twin (crm.Contact) of one legacy PropertyContact row, resolved through the platform's canonical selector — NOT by migratedFromId, which tax_id-deduped rows only stamp on the FIRST row. Null when the row is unmigrated, company-type, foreign-tenant, or the caller is a contractor. */
  contactForPropertyContact?: Maybe<ContactDef>;
  contactMap: CustomerMapDef;
  /** Company-scoped NDR (turvakielto) protected-data access audit log — who VIEWED a restricted contact's protected fields, newest first (NEXUS-770, 4.1.23). Requires contact_ndr__view (master bypasses). */
  contactNdrAccessAudit: Array<ContactNdrAccessAuditDef>;
  /** The ID of the object */
  contactProperty?: Maybe<ContactPropertyDef>;
  /** The ID of the object */
  contactPropertyNotificationRule?: Maybe<ContactPropertyNotificationRuleDef>;
  container?: Maybe<ContainerType>;
  containerActivityHistory: Array<Maybe<WarehouseMovementRowType>>;
  /** COMPASS-884 / HSY REQ 42: the container carrying this RFID/NFC tag, scoped to your company. Null when no container carries it — and also null when more than one does, because guessing which bin a mis-paired tag means would confirm the wrong stop. Driver-callable. */
  containerByRfid?: Maybe<ContainerType>;
  containerEventLog?: Maybe<ContainerEventLogEvent>;
  /** The ID of the object */
  containerGroup?: Maybe<ContainerGroupDef>;
  containerIdGeneratorSettings?: Maybe<ContainerIdGeneratorSettingsDef>;
  containerImport?: Maybe<ContainerImportType>;
  containerMap: ClusteredContainerMapDef;
  /** The ID of the object */
  containerNotification?: Maybe<ContainerNotificationDef>;
  /** The ID of the object */
  containerType?: Maybe<ContainerTypeType>;
  containerTypeWasteFractionRules: Array<ContainerTypeWasteFractionRuleType>;
  containerWeightImport?: Maybe<ContainerWeightImportType>;
  containersGroupedByLocation?: Maybe<LocationWithContainerTypeConnection>;
  /** PRO-325: the contract-area card's completed-collections figure from the ONE metrics service — eligible stops on the awarded contractor's routes within the award's validity window, with the applied window returned for drill-through. Office: any company area; a contractor only their own. */
  contractAreaCollections?: Maybe<ContractAreaCollectionsType>;
  /** THE server-side conflict check (PRO-104): every existing contract area colliding on zone x waste fraction x container type x service x overlapping validity — regardless of contractor. A warning surface, never a block. */
  contractAreaConflicts?: Maybe<Array<ContractAreaConflictDef>>;
  /** The contract-file register of one contract area (R2-S14). Office-only. */
  contractAreaDocuments?: Maybe<Array<ContractAreaDocumentDef>>;
  /** The coverage matrix (PRO-121): zone × waste fraction → Contracted / Own fleet / Uncovered, computed on read from in-force contract areas and own-fleet marks. Office-only. */
  contractCoverage?: Maybe<ContractCoverageDef>;
  /** DEV-TASK-1 D-4: products serving the selected container types AND waste fractions (LEDGER-802 wildcard semantics — an unconstrained product serves any value). The contract-area wizard's step 3 preview. Flag-gated, office-only. */
  contractScopeProducts?: Maybe<Array<ContractScopeProductDef>>;
  /** Purchase-invoice reconciliation over a period (PRO-468): per (contractor, settlement month) the system payable (from the wave-2 settlement report — never re-derived), the manually entered invoice total, the difference and the per-area breakdown to locate it, plus the append-only reconciliation records and a base64 CSV export. Office-only in wave 1: a fully-permissioned compensation user or a contractor-reporting role; contractors and foremen are refused. Name a haulerId for one contractor, or omit it (office) for the across-contractors export. */
  contractorInvoiceReconciliation?: Maybe<ContractorInvoiceReconciliationReportType>;
  /** Manual contractor credit/receivable entries (PRO-465), hauler-scoped. The office sees every entry for the company (any status) and may filter by hauler/area/status/target period; a contractor sees ONLY the APPROVED/SETTLED entries affecting their OWN settlement (with the reason) — never a draft, never another contractor's. Contractor foremen are refused (settlement figures). */
  contractorManualEntries?: Maybe<Array<ContractorManualEntryType>>;
  /** Contractor settlement report over an arbitrary period (PRO-466): a contractor header, one section per contract area per settlement month in range (each with tasks performed, compensation base, coefficient, bonus/penalty, the PRO-465 credit/deduction lines, total payable and the inputs→formula→euro bonus breakdown), and a grand total that equals the sum of the underlying period settlements exactly. Closed periods read from their frozen snapshots; open ones compute live; sections are labelled Closed/Open and a mixed range is marked. Whole calendar months are the settlement unit — the range selects every month it overlaps and includes each in full. Hauler-scoped exactly like haulerSettlementByArea: the office names a hauler, a contractor MANAGER is forced onto their own organisation (contractor B invisible), and a contractor foreman is refused. */
  contractorSettlementReport?: Maybe<ContractorSettlementReportType>;
  /** RS-1604 (D44): read-only question answering over the tenant's own Route Studio artifacts. Session-scoped, evidence-linked, numeral source-checked; no write is reachable through this surface. */
  conversationalAnalytics?: Maybe<AnalyticsAnswerDef>;
  /** The ID of the object */
  copilotConversation?: Maybe<CopilotConversationDef>;
  /** The ID of the object */
  costModel?: Maybe<CostModelDef>;
  /** The ID of the object */
  costSettings?: Maybe<CostSettingsType>;
  /** The company's council fee table: authority -> permit fee product, standard duration, expiry lead time. */
  councilFeeTable: Array<CouncilFeeTableEntryDef>;
  /** The ID of the object */
  criiptoApplication?: Maybe<CriiptoApplicationDef>;
  /** The ID of the object */
  customerFunction?: Maybe<CustomerFunctionDef>;
  /** The ID of the object */
  customerNote?: Maybe<CustomerNoteDef>;
  /** PRODUCT-484: the conversion preview of a customer request - matching contacts, address validation, the property it would reuse, availability and the indicative price. */
  customerRequestPreview?: Maybe<CustomerRequestPreviewDef>;
  /** DK CVR registry lookup for the account create form (HAUL-201). Flag-gated like every hauler_orders field — the Brreg twin (brregCompanyInfo) serves the contractor module instead. Null when the number is unknown. */
  cvrCompanyInfo?: Maybe<CvrCompanyInfoDef>;
  /** The ID of the object */
  dashboard?: Maybe<DashboardDef>;
  /** The recent sends of one subscription. */
  dashboardSubscriptionDeliveries: Array<SubscriptionDeliveryType>;
  /** A board's e-mail subscriptions (the caller's company). */
  dashboardSubscriptions: Array<DashboardSubscriptionType>;
  /** Staff only: every table of the database, how New dashboards would keep it to one company, and the ones on this company's list. */
  dashboardTables: Array<DashboardTableType>;
  /** SBX-535 (wave D19): the live weekday collection profile the day-move What-if modal renders BEFORE the planner picks a from-day, derived from the SAME cohort queryset the createDayMoveScenario mutation reads, so a weekday serves zero here exactly when the mutation would refuse it; the two can never disagree. snake_case payload (D74): project_id, cycle_weeks, days (always 7 rows, Monday..Sunday, each {weekday, containers, share}; containers is the movable cohort for that day, share is containers over movable_containers rounded to 4 decimals, so shares can sum past 1.0 when a calendar names several days), movable_containers (distinct containers whose live calendar names at least one weekday), multi_week_containers (of those, recorded pickup_repeat_period above 1), unmovable_calendared_containers (live calendars naming no fixed weekday: seasonal or combined shells), sentence and basis (byte-pinned planner sentences; worlds with multi-week rhythms lead with 'Collection days across the cycle:' and never claim one week's workload), unmovable_note (null unless unmovable containers exist). Zero days serve zero honestly. Read-only (D18). */
  dayMoveProfile?: Maybe<Scalars['GenericScalar']['output']>;
  /** The ID of the object */
  debtorExport?: Maybe<DebtorExportDef>;
  /** RS-E10: per subject-fraction weekly-kg demand forecasts with model tag and confidence band always attached (prior_v1 cold-start priors, learned_v1 hierarchical shrinkage gated by EV-FORECAST, sensor_v1 fill trajectories). Zero-history tenants get priors, never a gate (D04). */
  demandForecast?: Maybe<DemandForecastDef>;
  /** The ID of the object */
  depot?: Maybe<DepotType>;
  /** Wizard step 3: for each active origin agreement with a container, the product candidates at the DESTINATION's property type for the origin's operational dims (fraction/container-type/pickup-setting). An origin service with zero candidates is absent — not offered there. */
  destinationServiceProposal?: Maybe<RelocationServiceProposalDef>;
  /** The ID of the object */
  deviceToContainerSet?: Maybe<DeviceToContainerType>;
  /** The ID of the object */
  deviceType?: Maybe<DeviceTypeType>;
  dkdpCompanyCredentials?: Maybe<DkdpCompanyCredentialsDef>;
  dkdpEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the object */
  document?: Maybe<DocumentDef>;
  /** Quantities for the containers inside drawn polygons over a date window (Map Planning's Selected-area panel): waste services, collection points, bins, frequencies, and the window's assumed weight/volume beside its collected weight. Office-only; nothing is persisted. */
  drawnAreaQuantities: DrawnAreaQuantitiesDef;
  /** The ID of the object */
  driver?: Maybe<DriverType>;
  driverNotificationById?: Maybe<DriverPushNotificationType>;
  driverNotificationsList?: Maybe<DriverPushNotificationTypeConnection>;
  /** COMPASS-272: routes + emergency routes the authenticated driver needs to operate offline. Caller must be linked to a Driver profile. */
  driverOfflinePackage?: Maybe<DriverOfflinePackageType>;
  driverSummaryCard?: Maybe<DriverSummaryCardType>;
  /** RS-1102: the composed dispatch day list, the overlay read seam in-cab propagation consumes: today's routes with applied dynamic insertions layered over the live plan's effective sequences. */
  dynamicDayDispatch?: Maybe<DynamicDayDispatchDef>;
  /** RS-1101 (P6): the need-based selection for one area and day: fill-tolerant subjects whose forecast trajectory crosses the threshold within the horizon, plus the reason every other candidate keeps its calendar (hygiene floors always win). Computed live, persists nothing, never touches a calendar. */
  dynamicDayPreview?: Maybe<DynamicDayPreviewDef>;
  /** The resolved holiday policy for one contract area: the area's override, else the company default. */
  effectiveHolidayPolicy?: Maybe<EffectiveHolidayPolicyDef>;
  /** The ID of the object */
  evolutionContainerLink?: Maybe<EvolutionContainerLinkDef>;
  /** The ID of the object */
  evolutionDeviationCodeMapping?: Maybe<EvolutionDeviationCodeMappingDef>;
  /** The ID of the object */
  evolutionManualSync?: Maybe<EvolutionManualSyncRunDef>;
  /** The ID of the object */
  evolutionSnapshotBatch?: Maybe<SnapshotBatchDef>;
  /** The ID of the object */
  evolutionSoapApiCallHistory?: Maybe<EvolutionSoapApiCallHistoryDef>;
  /** The ID of the object */
  evolutionSoapApiCredentials?: Maybe<EvolutionSoapApiCredentialsDef>;
  /** PRO-467: every exception type with its current pay + reliability effect (day-one defaults where nothing is configured), future-scheduled effects, and dated history. Office-only + hauler-module gated. Optional asOf date picks the 'current' effect as of that day (default today). */
  exceptionCompensationEffects?: Maybe<Array<ExceptionEffectOverviewType>>;
  explainInsightsChange: Scalars['GenericScalar']['output'];
  /** RS-603 explanation harness per plan: binding constraints from the solve, cost decomposition narrative data, the CO2e method document and up to 5 relaxation probes. The Copilot narrates these; it never invents numbers. */
  explanation?: Maybe<ExplanationDef>;
  /** The ID of the object */
  explorationCandidate?: Maybe<ExplorationCandidateDef>;
  /** RS-1501 morning digest: the newest completed exploration run's digest record for the area. Engine numbers only; LLM rationale is labeled llm_narrative and numeral checked. Null when no run has completed (honest empty state). */
  explorationDigest?: Maybe<Scalars['GenericScalar']['output']>;
  /** The ID of the object */
  explorationRun?: Maybe<ExplorationRunDef>;
  /** The ID of the object */
  export?: Maybe<ExportType>;
  exportConfig?: Maybe<ExportConfigDef>;
  /** The ID of the object */
  exportHistory?: Maybe<ExportHistoryDef>;
  /** List of available fields for export model */
  exportModelFields?: Maybe<Array<Maybe<ExportFieldType>>>;
  /** List of available filters for export model */
  exportModelFilters?: Maybe<Array<Maybe<ExportFiltersSectionType>>>;
  /** List of Export model that allowed to use segments */
  exportModelSegments?: Maybe<Array<Maybe<ExportTypes>>>;
  /** The ID of the object */
  exportTemplate?: Maybe<ExportTemplateDef>;
  /** Returns current total items for export template */
  exportTemplateTotalItems?: Maybe<ExportTemplateTotalItems>;
  featureConfigAudit?: Maybe<Array<Maybe<FeatureConfigAuditType>>>;
  featureConfigBatch?: Maybe<FeatureConfigBatchType>;
  featureConfigBulkPreview?: Maybe<FeatureConfigBulkPreviewType>;
  featureConfigCatalog?: Maybe<Array<Maybe<FeatureConfigCatalogEntryType>>>;
  featureConfigCompanies?: Maybe<Array<Maybe<FeatureConfigCompanyRefType>>>;
  featureConfigCompanyOverview?: Maybe<Array<Maybe<FeatureConfigOverviewRowType>>>;
  featureConfigOverrideCounts?: Maybe<Array<Maybe<FeatureConfigOverrideCountType>>>;
  featureConfigResolve?: Maybe<FeatureConfigResolutionType>;
  featureConfigRules?: Maybe<Array<Maybe<FeatureConfigRuleType>>>;
  fileList?: Maybe<FileListType>;
  fillLevelDevice?: Maybe<BaseDeviceInterface>;
  /** The ID of the object */
  fillLevelMeasurements?: Maybe<FillLevelMeasurementType>;
  /** One finance feeder export run of the caller's company. */
  financeFeederExportLog?: Maybe<FinanceFeederExportLogDef>;
  /** The caller's company's finance feeder export runs, newest first (default and maximum 250). */
  financeFeederExportLogs?: Maybe<Array<FinanceFeederExportLogDef>>;
  /** SBX-379 item 2 (D18/D32): the company-wide shared-fleet vehicle-commitment ledger: which live schemes and which scheduled promotions claim which vehicle on which weekday (RouteSchemeVehicleDay rows plus scheduled rollouts' recorded vehicle maps), double-booked cells flagged with the same same-area-succession exemption the schedule gate enforces. Read-only; exact counts, entry lists capped with truncation flags. */
  fleetLedger?: Maybe<Scalars['GenericScalar']['output']>;
  /** RS-1202 (F14, C-015): per-route EV feasibility for summer and winter (or one season), the which-routes-break-in-January list with named reasons, and the five-year TCO comparison with labeled inputs. The deep E-VRP mode is deferred and stated as such in the document. */
  fleetTransitionCase?: Maybe<Scalars['GenericScalar']['output']>;
  /** The ID of the object */
  fractionServiceBinding?: Maybe<FractionServiceBindingDef>;
  ftpProtocolTypes?: Maybe<Array<Maybe<FtpProtocolEnum>>>;
  getHistoryLocation?: Maybe<RouteLocationHistoryDef>;
  /** The ID of the object */
  grammarClaim?: Maybe<GrammarClaimDef>;
  /** The ID of the object */
  hauler?: Maybe<HaulerDef>;
  /** Accountant AR export (R2-07 v1): a DOWNLOADABLE bookkeeper file of the tenant's invoices + registered payments over an optional issue-date window — invoice number, dates, customer NAME, PO ref, net/VAT/gross, paid, balance, status, currency — plus an optional per-VAT-rate posting summary. This is an EXPORT FILE, NOT an accounting integration (nothing is transmitted anywhere; the founder ruled integrations out). Honest empty (header-only) when no invoices. Flag-gated hauler-mode read, classified DENIED (the D-E10 stance). */
  haulerAccountantExport?: Maybe<HaulerAccountantExportDef>;
  /** DRY-RUN preview (HAUL-919 v1 bank-afstemning): match an uploaded bank-statement CSV against the tenant's outstanding invoices by the reference already on the invoice (FI viitenumero / PJH invoice number) + amount. Changes NOTHING — shows what applyHaulerBankReconciliation would register, the unmatched queue, and a downloadable reconciliation report. Flag-gated hauler-mode read, classified DENIED (D-E10). */
  haulerBankReconciliation?: Maybe<HaulerBankReconciliationDef>;
  /** Client KPI table (REQ 3.5.57): timeliness, collection efficiency, feedback by reason, prevented emptyings — reusing W8's reliability selector. Hauler-scoped: the office may omit haulerId to read every contractor's areas in ONE call (the Overview Performance tab, PRO-122 — rows carry haulerId/haulerName for grouping); a contractor always gets their own, whatever haulerId is sent. */
  haulerClientKpis?: Maybe<Array<HaulerClientKpiType>>;
  /** The contractor's bonus & penalty event feed (PRO-109): a read-only projection of the settlement engine, newest first. */
  haulerCompensationEvents?: Maybe<Array<CompensationEventType>>;
  /** The company's compliance-document types (PRO-99): admin-extensible data, never hard-coded. */
  haulerComplianceDocumentTypes?: Maybe<Array<HaulerComplianceDocumentTypeDef>>;
  /** One contractor's compliance-document register (PRO-99). Office names a hauler; a contractor always gets their own. */
  haulerComplianceDocuments?: Maybe<Array<HaulerComplianceDocumentDef>>;
  /** One day's control numbers (HAUL-1302): completed orders, billed sum, weighed tons, margin-where-computable + the honest uncomputable count, futile visits. Defaults to today. Flag-gated and contractor-denied like every hauler-mode field (classified DENIED). */
  haulerDailyControls?: Maybe<HaulerDailyControlsDef>;
  /** Deviations grouped by recorded reason (REQ 3.6.25). Reasons not recorded count as 'unspecified'. The office may omit haulerId to read across every contractor (the Overview Dashboard's deviations widget, PRO-97); a contractor always gets their own. */
  haulerDeviationsByReason?: Maybe<Array<DeviationReasonCountType>>;
  /** FI Finvoice field-motor readiness for one invoice (G2S3-M2): the AVL 209 e § mandatory fields present/missing + statutory special mentions (KLADDE). The operator channel is staged spend — channelConnected is always false. Flag-gated hauler-mode read, classified DENIED (the D-E16 precedent). */
  haulerFinvoiceReadiness?: Maybe<HaulerFinvoiceReadinessDef>;
  /** Per-vehicle completed-work scorecard (REQ 3.6.25, by fleet). Hauler-scoped: the office may omit haulerId to read every contractor's fleet in ONE call (the Overview Fleet tab, PRO-122 — rows carry haulerId/haulerName for grouping); a contractor always gets their own, whatever haulerId is sent. */
  haulerFleetPerformance?: Maybe<Array<FleetVehiclePerformanceType>>;
  /** Fuel & emissions tab (PRO-112): fuel type × contractor table + fossil-free share of collections (count and weight) per contractor and total, period-over-period. Office reads every contractor unless haulerId narrows; a contractor always gets their own. */
  haulerFuelEmissions?: Maybe<HaulerFuelEmissionsType>;
  /** Completed work rolled up by fuel type (REQ 3.6.25). */
  haulerFuelSummary?: Maybe<Array<FuelSummaryType>>;
  /** Planned hauler-order visits that sit on a public holiday within the horizon (default 30 days), with the proposed working day (HAUL-018). Proposals only — moving is a separate, confirmed mutation. Flag-gated and contractor-denied like every hauler-mode field. */
  haulerHolidayCollisions?: Maybe<Array<Maybe<HaulerHolidayCollisionDef>>>;
  /** One invoice with lines, payments and send journal. */
  haulerInvoice?: Maybe<HaulerInvoiceDef>;
  /** The invoice document as base64 PDF (the platform's pdfkit machinery — a render of the frozen rows, nothing recomputed). */
  haulerInvoicePdf?: Maybe<Scalars['String']['output']>;
  /** The tenant's invoices (newest first). Flag-gated hauler-mode read of the LEDGER engine's rows. */
  haulerInvoices?: Maybe<Array<Maybe<HaulerInvoiceDef>>>;
  /** Per-contract-area load + missed-rate per 1,000 lifts (REQ 3.6.25, by load), with a per-vehicle tonnage split and weighed-stop coverage (PRO-114). The office may omit haulerId to read every contract area across contractors (the Overview Loads tab); a contractor always gets their own. */
  haulerLoadSummary?: Maybe<Array<LoadSummaryType>>;
  /** Office-entered manual metered quantities (REQ 3.3.21/3.3.23) for a contract-area month: the per_tonne / per_hour / per_distance / per_reversing_distance totals settlement pays rate × quantity against. Company-scoped + hauler-scoped by the area's contractor. */
  haulerManualMeteredQuantities?: Maybe<Array<HaulerManualMeteredQuantityType>>;
  /** The metered computation menu (R2-S13): every declared computation with its availability. per_round / per_emptying are backed by settlement-selector data; per_tonne / per_hour / per_distance are blocked ('data feed not available', R2-D18) until their feeds land — render them disabled with the reason. The classic flat_cents / percent kinds live on the non-metered components input. */
  haulerMeteredComputationOptions?: Maybe<Array<MeteredComputationOptionType>>;
  /** Overview Dashboard KPI tiles (PRO-97): on-time %, missed per 1,000 lifts, collection efficiency %, complaints, deviations and total weight — current + previous period (trends), plus per-contractor scores. Office reads every contractor unless haulerId narrows; a contractor always gets their own. */
  haulerOverviewKpis?: Maybe<HaulerOverviewKpisType>;
  /** One hauler portal conversation by global id. Resolves to null for a conversation belonging to another hauler (server-enforced 404). */
  haulerPortalConversation?: Maybe<PortalConversationDef>;
  /** Portal conversations addressed to a hauler, scoped server-side to the caller's own hauler (office callers see all of the company's). Gated on crm_enable_messaging && hauler_module_enabled. */
  haulerPortalConversations?: Maybe<Array<PortalConversationDef>>;
  /** The ID of the object */
  haulerPrice?: Maybe<HaulerPriceDef>;
  /** Temporal-table change history of one hauler price (every amount/date/hauler/area change with author and period). Company-scoped; contractors can read their own prices only. */
  haulerPriceEvents?: Maybe<Array<Maybe<HaulerPriceEventDef>>>;
  /** The price rows inside one of the tenant's price lists, for AUTHORING (RD-46) — the list projection only counts them (rowCount). unitPrice is each row's stored price verbatim; nothing is recomputed. Read-only catalog read that also feeds the shared Price Check trace's product picker, so it is NOT gated on the hauler-mode flag (PRO-280); contractor logins stay denied (classified DENIED — the D-E10 stance: customer prices are exactly what the contractor wall exists to hide). The paired authoring mutations remain hauler_b2b-gated. */
  haulerPriceListRows?: Maybe<Array<Maybe<HaulerPriceRowDef>>>;
  /** The tenant's price lists with the hauler layer's facts (validity, inheritance, minimum charge, account pins) — G2S1-M1/M2. Read-only catalog read that also feeds the shared Price Check trace's product picker, so it is NOT gated on the hauler-mode flag (PRO-280: non-Erhverv tenants read their CUSTOMER pricing catalog through it too); contractor logins stay denied (classified DENIED — the D-E16 precedent). The authoring writes remain hauler_b2b-gated. */
  haulerPriceLists?: Maybe<Array<Maybe<HaulerPriceListDef>>>;
  /** PRO-280 (C3/E) 'test a point' — the resolver-explain read: resolve a test point to the winning customer price row for `product_id` PLUS the full zone resolution chain (innermost→…→default). The test point is EXACTLY ONE of a raw coordinate (lat AND lng) or `propertyId` (the tenant's own property; its stored point is used) — both or neither is an error. Both modes converge on the SAME engine: the F2 geometric resolver + the chain-aware best-match selection real pricing uses (R1 tie-break), so the preview equals what a live emptying at that point would be priced by — honouring the customer-zone opt-in. The condition args mirror the price-determination request. Strictly read-only. NOT gated on the hauler-mode flag (it prices CUSTOMER zone pricing, not B2B — non-Erhverv tenants use it too); contractor logins stay denied (customer prices are exactly what the contractor wall hides — the D-E10 stance). */
  haulerPricePointPreview?: Maybe<HaulerPricePointPreviewDef>;
  /** What one order line for `service` costs today, resolved through the price lists (pinned first — HAUL-203 — then the site's zone price — HAUL-204 — then the company standard, honest catalog fallback). Never guesses: resolved=false with reasons beats a fake zero. */
  haulerPriceSuggestion?: Maybe<HaulerPriceSuggestionDef>;
  /** Per-area collection reliability for a contractor over a period (REQ 3.5.58, D6): planned / onTime / late / missed / excluded, the reliability %, and the per-event breakdown. Hauler-scoped: office names a hauler (haulerId required); a contractor always gets their own, whatever haulerId is sent. areaId optionally narrows to one area. */
  haulerReliabilityByArea?: Maybe<Array<HaulerAreaReliabilityType>>;
  /** The tenant's container-rental placements (S4-M1 clock) with honest billing facts for the current period. Flag-gated hauler-mode read; classified DENIED (the D-E16 precedent). */
  haulerRentals?: Maybe<Array<Maybe<HaulerRentalDef>>>;
  /** E6 slice 1: optimise a day's routes over the tenant's own orders and fleet by REUSING the Route Studio solver seam (get_engine(...).solve over a v1 problem_json). Selection: order_ids, else a date, else the tenant's confirmed orders; vehicle_ids optional (default = the tenant's fleet). Consequence-free — it computes and returns a plan, persists nothing. Flag-gated and contractor-denied like every hauler-mode field (D-E10 DENIED stance). */
  haulerRoutePlan?: Maybe<HaulerRoutePlanDef>;
  /** Open (not completed) routes planned on one day — the target picker for the stop-move modal (D-E18(b), FIXIT2-O1). Flag-gated and contractor-denied like every hauler-mode field (D-E10 DENIED stance). */
  haulerRoutesForDate?: Maybe<Array<Maybe<HaulerRouteOptionDef>>>;
  /** Per-contract-area settlement for a month (REQ 3.6.26, D8/D9): one report per area (a contractor with N areas gets N). Live compute for open periods; the frozen snapshot for closed ones. Hauler-scoped: office names a hauler (haulerId required), a contractor always gets only their own areas. */
  haulerSettlementByArea?: Maybe<Array<SettlementReportType>>;
  /** Per-contract-area settlement grouped by carve-out (PRO-280 S1, decision 10): each parent area carries its same-hauler carve-out(s) as separate lines plus a combined roll-up. A hauler with no carve-outs gets one single-member group per area (rollup null) — the same figures as haulerSettlementByArea. Hauler-scoped exactly like haulerSettlementByArea. */
  haulerSettlementGroups?: Maybe<Array<SettlementGroupType>>;
  /** Settlement period records (open/closed + close/reopen audit). Hauler-scoped by the area's contractor. */
  haulerSettlementPeriods?: Maybe<Array<SettlementPeriodType>>;
  healthcheck?: Maybe<HealthCheckType>;
  /** Country packs with a seeded public-holiday calendar available to select as holiday_calendar_country. */
  holidayCalendarCountries?: Maybe<Array<HolidayCalendarCountryDef>>;
  /** The full work-queue for one holiday date: materialized stops + beyond-horizon projections + open tickets, hauler-scoped server-side for contractor logins. Null when the tenant has not configured a holiday calendar. */
  holidayImpact?: Maybe<HolidayImpactPageDef>;
  /** SBX-363 (D34/D08): the holiday-week what-if, a READ-ONLY projection of the plan's calendar onto a real week with the recorded deviation days (platform deviation windows + scenario holidays) displaced per the region pack's C-012 convention: per-day loads before and after, moved entries (capped, exact counts), the deviations in play. NOT a re-solve; the engine consumes patterns.deviation_day_shifts at solve time. */
  holidayWeekPreview?: Maybe<Scalars['GenericScalar']['output']>;
  /** The ID of the object */
  identityMapEntry?: Maybe<IdentityMapDef>;
  /** The ID of the object */
  importBatch?: Maybe<ImportBatchDef>;
  /** The ID of the object */
  importCase?: Maybe<ImportCaseDef>;
  /** The ID of the object */
  importFile?: Maybe<ImportFileDef>;
  importFileTooltips?: Maybe<Array<Maybe<ImportFileTooltips>>>;
  /** The ID of the object */
  importHistory?: Maybe<ImportHistoryDef>;
  /** The ID of the object */
  importIssue?: Maybe<ImportIssueDef>;
  /** SBX-521: the import landing wire: the one-sentence purpose, the orienting question, what the import is not, and the six named use-case presets (each tuning the manifest expectations). */
  importPurposeLanding?: Maybe<Scalars['GenericScalar']['output']>;
  /** RS-104 per-batch data quality report; blocks scenario creation only on fatal classes. */
  importQualityReport?: Maybe<ImportQualityReportDef>;
  /** Generated import template for any import type — headers come from the same import-model definition that powers importFileTooltips, so the file always matches what the importer accepts */
  importTemplate?: Maybe<ImportTemplateResult>;
  /** The ID of the object */
  industryCode?: Maybe<IndustryCodeDef>;
  /** The ID of the object */
  inquiry?: Maybe<CollectionInquiryType>;
  /** The ID of the object */
  inquiryTyping?: Maybe<CollectionInquiryTypingType>;
  insightsActionBundles: Scalars['GenericScalar']['output'];
  insightsAiStatus: InsightsAiStatusType;
  insightsAnswerFeedback: Scalars['GenericScalar']['output'];
  insightsAuditEvents: Scalars['GenericScalar']['output'];
  insightsBenchmark: Scalars['GenericScalar']['output'];
  insightsBlend: Scalars['GenericScalar']['output'];
  insightsBlendableDimensions: Scalars['GenericScalar']['output'];
  insightsBriefing: Scalars['GenericScalar']['output'];
  insightsBuilderDashboard?: Maybe<BuilderDashboardType>;
  insightsBuilderDashboardVersions: Array<BuilderDashboardVersionType>;
  insightsBuilderDashboards: Array<BuilderDashboardType>;
  insightsBuilderDeletedDashboards: Array<BuilderDeletedDashboardType>;
  insightsCards: Scalars['GenericScalar']['output'];
  insightsCatalog: Array<MetricDefinitionType>;
  insightsCommitteePacks: Scalars['GenericScalar']['output'];
  insightsCompanyShares: Scalars['GenericScalar']['output'];
  insightsDashboard?: Maybe<DashboardType>;
  insightsDashboards: Array<DashboardType>;
  insightsDatasetChoices: Array<Scalars['GenericScalar']['output']>;
  insightsDefaultDashboard?: Maybe<DashboardType>;
  insightsEntities: Scalars['GenericScalar']['output'];
  insightsExploration: Scalars['GenericScalar']['output'];
  insightsFieldValues: InsightsFilterValuesResult;
  insightsFilterValues: InsightsFilterValuesResult;
  insightsForecast: Scalars['GenericScalar']['output'];
  insightsNotablePatterns: Scalars['GenericScalar']['output'];
  insightsPlanEntity?: Maybe<Scalars['GenericScalar']['output']>;
  insightsPreviewAction: Scalars['GenericScalar']['output'];
  insightsPublishedInsights: Scalars['GenericScalar']['output'];
  insightsReplayAnswer: Scalars['GenericScalar']['output'];
  insightsReportDeliveries: Scalars['GenericScalar']['output'];
  insightsReportTemplates: Array<ReportTemplateType>;
  insightsScheduledExtracts: Scalars['GenericScalar']['output'];
  insightsStatutoryDrafts: Scalars['GenericScalar']['output'];
  insightsStatutorySubmissions: Scalars['GenericScalar']['output'];
  insightsStatutoryTemplates: Scalars['GenericScalar']['output'];
  insightsTicketProposals: Scalars['GenericScalar']['output'];
  insightsVerifiedQueries: Scalars['GenericScalar']['output'];
  insightsWhatif: Scalars['GenericScalar']['output'];
  /** The ID of the object */
  integrationGps?: Maybe<IntegrationGpsType>;
  /** The ID of the object */
  integrationGpsVehicle?: Maybe<IntegrationGpsVehicleType>;
  /** The ID of the object */
  integrationUrbaserCallResponseHistory?: Maybe<IntegrationUrbaserCallResponseHistoryDef>;
  /** The ID of the object */
  integrationUrbaserCallResponseHistoryAgreement?: Maybe<IntegrationUrbaserCallResponseHistoryAgreementDef>;
  /** The ID of the object */
  integrationsUrbaserAgreementsSync?: Maybe<IntegrationUrbaserAgreementsSyncDef>;
  internalAllCompanies?: Maybe<CompanyTypeConnection>;
  /** The ID of the object */
  internalAllSalesOffer?: Maybe<SalesOfferType>;
  internalAllSalesOffers?: Maybe<SalesOfferTypeConnection>;
  internalAllSalesOffersFeatures?: Maybe<BillingFeatureTypeConnection>;
  internalAllUnconfirmedUsers?: Maybe<UnconfirmedUserTypeConnection>;
  internalAutopilotContextHealth: Array<AutopilotTenantContextHealthType>;
  /** The ID of the object */
  internalCompany?: Maybe<CompanyType>;
  /** The ID of the object */
  internalUnconfirmedUser?: Maybe<UnconfirmedUserType>;
  /** The ID of the object */
  invoice?: Maybe<InvoiceDef>;
  /** The ID of the object */
  invoiceItem?: Maybe<InvoiceItemDef>;
  isDriver?: Maybe<IsDriverType>;
  isDriverEditable?: Maybe<CheckDriverEditableType>;
  isKmdEasyEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the object */
  keyType?: Maybe<KeyTypeType>;
  kmdEasyCompanySettings?: Maybe<KmdEasyCompanySettingsDef>;
  /** The ID of the object */
  kmdEasyDeltaFiles?: Maybe<KmdEasyDeltaFileDef>;
  kmdEasyExportFileTypes?: Maybe<Array<Maybe<KmdEasyExportFileTypeEnum>>>;
  /** The ID of the object */
  kmdEasyFileFu51007FileLine?: Maybe<Fu51007FileLineDef>;
  /** The ID of the object */
  kmdEasyFileFu51008FileLine?: Maybe<Fu51008FileLineDef>;
  /** The ID of the object */
  kmdEasyFileFu63302FileLine?: Maybe<KmdEasyFileFu63302FileLineDef>;
  /** The ID of the object */
  kmdEasyFileFu63303FileLine?: Maybe<KmdEasyFileFu63303FileLineDef>;
  kmdEasyImportFileTypes?: Maybe<Array<Maybe<KmdEasyImportFileTypeEnum>>>;
  /** The ID of the object */
  kmdEasyTotalFiles?: Maybe<KmdEasyTotalFileDef>;
  /** Per-fraction collected-weight report for one calendar month (Route.scheduled_day), mapped to EAK/ADS codes, with the submission-readiness quality gate. Measured weights and volume-derived estimates in SEPARATE columns; weight-less stops are honest counts; unmapped fractions land in an explicit UNMAPPED bucket. Office-only (403 for contractor accounts), company-scoped. NO pricing — ever. */
  liveOperationsAdsReport: LiveOpsAdsReportDef;
  /** The same ADS report rendered to a downloadable CSV/XLSX file (base64 inline) for the manual Affaldsdatasystemet upload, via the platform's shared file writer. NO money column. */
  liveOperationsAdsReportExport: LiveOpsAdsReportExportDef;
  /** Per-vehicle driven-routes report over a date range: driven distance (km), the routes driven with timestamps and speed stats, and inactive days. Operational data only — NO price / bonus / penalty (Ledger owns pricing). Company-scoped. */
  liveOperationsDrivenRoutesReport: Array<VehicleDrivenRoutesReportDef>;
  /** The same driven-routes report rendered to a downloadable CSV/XLSX file (base64 inline), using the platform's shared file writer. NO price fields. */
  liveOperationsDrivenRoutesReportExport: DrivenRoutesReportExportDef;
  /** Bounded, company-scoped list of a day's Live Operations exceptions (newest first) for the initial page load. The onLiveOperationsFeed subscription then keeps it live. */
  liveOperationsExceptions: Array<LiveOperationsExceptionDef>;
  /** Company-scoped GPS access-audit log (who VIEWED driver GPS), newest-first, for a data-subject-access request. Describes viewers, NEVER a per-driver performance metric. Requires the live_operations__compliance_admin permission. */
  liveOperationsGpsAccessAudit: Array<GpsAccessAuditDef>;
  /** The live driver-GPS monitoring register: what is collected, the purpose, the off-shift control, retention, who can access, access-audit status and DPIA/works-council evidence. Generated from live config so it is always truthful. Requires the live_operations__compliance_admin permission. */
  liveOperationsMonitoringRegister: MonitoringRegisterDef;
  /** The same monitoring register rendered to a downloadable CSV/XLSX file (base64 inline), using the platform's shared file writer. Requires the live_operations__compliance_admin permission. */
  liveOperationsMonitoringRegisterExport: MonitoringRegisterExportDef;
  /** Each vehicle's last-known position AT OR BEFORE asOf (created_at <= asOf, latest per vehicle) for the routes scheduled on the given day. The correct 'as of' the old Route.historicLocations(endTime) resolver got backwards. */
  liveOperationsPositionsAsOf?: Maybe<Array<LivePlaybackPositionDef>>;
  /** COMPASS-1188 / HSY req 34: the positions recorded when tasks were confirmed, deviations reported and loads unloaded on the routes of a day (optionally one route), for the Driven-routes map layer. Bounded by construction; scoped like the replay track; reads take part in the GPS access register on a best-effort, de-duplicated basis. */
  liveOperationsRecordedPositions?: Maybe<Array<RecordedPositionEventDef>>;
  /** Per-vehicle breadcrumb polyline (ordered {lat,lon,ts,speed}) over RouteLocationHistory.created_at for the scrubber's driven-path layer, downsampled to a bounded cap. MUST be bounded: pass either routeId (single-route replay), routeIds (up to 200 of the day's routes in one request; one track per route and vehicle) OR both fromTs and asOf (a window <= 26h). An unbounded call is rejected. */
  liveOperationsReplayTrack?: Maybe<Array<LivePlaybackTrackDef>>;
  /** Route lifecycle + per-stop status AS OF asOf: a stop completed after asOf reads 'pending', one completed before reads 'completed'/'skipped'; route started/completed honoured only when <= asOf. Server-side truth (real timestamps), not the client illusion of nulling completedAt. */
  liveOperationsRouteStatesAsOf?: Maybe<Array<LivePlaybackRouteStateDef>>;
  /** Per-day / per-route / per-vehicle rollups for the Live Operations page, computed server-side in a fixed number of queries. Accepts the same route filters as allRoutes and the same stop filters as RouteType.stops so the summary always agrees with the timeline. */
  liveOperationsSummary?: Maybe<LiveOperationsSummaryDef>;
  /** Fraction/equipment-compatible routes a reassign can target. FE sorts by nearest using the W4 live feed positions. */
  liveOpsCompatibleTargets: Array<LiveOpsCompatibleTargetDef>;
  /** Proof-of-service for ONE stop, same bundle as the office dispute lookup, for inline display on the identity card. Gated + company-scoped; office-or-owning-hauler rail. Read-only and INERT (sends nothing); no pricing anywhere. */
  liveOpsProofBundle: LiveOpsProofBundleDef;
  /** Office-only proof-of-service lookup: per-container evidence that a property's bins were (or were not) serviced on a date — the one-lookup dispute-settler. Read-only and INERT (sends nothing); no pricing anywhere. */
  liveOpsProofOfService: Array<LiveOpsProofOfServiceDef>;
  /** Pre-assembled reassign proposal for an idle/delay exception — estimates only, NOTHING is applied until the office clicks liveOpsReassignStops. Cached 60s per exception. */
  liveOpsReassignSuggestion: LiveOpsReassignSuggestionDef;
  /** In-area, compatible re-collect targets for a missed bin, ranked nearest-first. Empty ⇒ the FE falls back to Create ticket. */
  liveOpsRecollectCandidates: Array<LiveOpsRecollectCandidateDef>;
  /** Per-contractor / per-contract-area SLA cockpit for one day: scheduled/completed stops, missed collections split by descriptive fault party, missed-per-1000, route on-time vs plan, open-exception and miss-SLA response state. OPERATIONAL triage only — no price / bonus / penalty anywhere (Ledger owns money; settlement is measured per contract area in Settlement, not from this view). Company-scoped; a contractor caller sees exactly their own row. */
  liveOpsSlaCockpit: LiveOpsSlaCockpitDef;
  /** Current live GPS position of every vehicle on the given route. Mobile clients should call this on connect and on reconnect to seed the map. */
  liveVehicleLocations?: Maybe<Array<Maybe<VehicleLocationType>>>;
  /** The per-load classification of a completed movement ticket (or of the movement that returned the given rental ticket). */
  loadClassification?: Maybe<LoadClassificationDef>;
  /** The ID of the object */
  managementCompanyProperty?: Maybe<ManagementCompanyPropertyDef>;
  /** 3.1.41 / PRO-279: the unified, filterable map-layer catalog for the map view's single layer selector. Unions the two origins the requirement names — PUBLIC external services (as allExternalMapLayers) and COMPANY-edited zone boundaries (the zones from allZones that carry geometry) — into one ordered list. Office-only, company-scoped (contractors denied, same wall as allZones / allExternalMapLayers). */
  mapLayerCatalog?: Maybe<Array<MapLayerCatalogEntryDef>>;
  /** The ID of the object */
  masterDataSync?: Maybe<MasterDataSyncDef>;
  /** The ID of the object */
  materializedRun?: Maybe<MaterializedRunDef>;
  matrikkelConfig?: Maybe<MatrikkelConfigDef>;
  me?: Maybe<UserType>;
  /** The ID of the object */
  measurementSettings?: Maybe<MeasurementSettingsType>;
  /** The ID of the object */
  mobileDeviceType?: Maybe<MobileDeviceType>;
  /** The ID of the object */
  municipality?: Maybe<MunicipalityDef>;
  myFeatureConfig?: Maybe<Array<Maybe<MyFeatureConfigEntryType>>>;
  /** Wave-1 order list for one company. Flag-gated: answers only when hauler mode is enabled for the tenant. */
  myHaulerOrders?: Maybe<Array<Maybe<HaulerOrderDef>>>;
  myInsightsAlerts: Scalars['GenericScalar']['output'];
  myInsightsDigest: Scalars['GenericScalar']['output'];
  myInsightsExplorations: Scalars['GenericScalar']['output'];
  mySavedInsightsAnalyses: Array<SavedAnalysisType>;
  /** The ID of the object */
  narrativeDocument?: Maybe<NarrativeDocumentDef>;
  navigationAppVersion?: Maybe<NavigationAppVersionType>;
  nearestScps?: Maybe<Array<NearestScpDef>>;
  /** Federated cross-entity search over the omnisearch index. Results are grouped by entity and ranked within each group by text relevance; a single entityTypes value enables page/first pagination on that entity. */
  omniSearch?: Maybe<OmniSearchResults>;
  /** RS-1605 (D47): the guided onboarding state machine, derived from real tenant state: current step, what is missing, next action deep link, and the time-to-first-plan / time-to-first-promotion KPIs. */
  onboardingStatus?: Maybe<OnboardingStatusDef>;
  operationManagementStatuses?: Maybe<OperationManagementType>;
  /** The ID of the object */
  parameterSet?: Maybe<ParameterSetDef>;
  /** RS-901: which parameter classes moved between the tenant's parameter set versions, newest first. */
  parameterSetChangelog?: Maybe<Array<ParameterSetChangeDef>>;
  partTypes?: Maybe<Array<Maybe<PartTypeType>>>;
  passwordResetVerify?: Maybe<PasswordResetVerify>;
  /** Council permits of the caller's companies, newest first - narrowed to a property and/or a rental ticket; status filters on the DERIVED status (active / expiring / expired included). */
  permits: Array<PermitDef>;
  /** The ID of the object */
  physicalKey?: Maybe<PhysicalKeyType>;
  /** The ID of the object */
  pickupOrder?: Maybe<PickUpOrderType>;
  /** The ID of the object */
  pickupOrderApproval?: Maybe<PickUpOrderApprovalDef>;
  /** The ID of the object */
  pickupOrderApprovalCollection?: Maybe<PickUpOrderApprovalCollectionDef>;
  /** Hauler responsible for a stop (derived via Stop → Route → Hauler) plus driver-assignment history. */
  pickupOrderHaulerTraceability?: Maybe<PickUpOrderHaulerTraceabilityType>;
  /** The ID of the object */
  pickupSetting?: Maybe<PickupSettingsType>;
  /** The ID of the object */
  plan?: Maybe<PlanDef>;
  /** RS-504: exact affected-household diff vs the reference calendar (a household counts as affected when any of its fraction-day assignments changed, D09/Norddal semantics). */
  planCalendarDiff?: Maybe<PlanCalendarDiffDef>;
  /** The ID of the object */
  planCalendarEntry?: Maybe<PlanCalendarEntryDef>;
  /** Compare up to four plans against a baseline shown as column zero (RS-204, D10, D17). The baseline defaults to the one the first plan's KPIs reference. */
  planComparison?: Maybe<PlanComparisonDef>;
  /** The ID of the object */
  planningArea?: Maybe<PlanningAreaDef>;
  /** SBX-511 (session 3 A1): the one-click 'Load my fleet' payload, served ready to run: contract-shaped vehicle entries (per-fraction compartments from the platform's recorded capacities, costs, energy, real crews, veh_<pk> ids so fleet_basis live-matching works), scoped by default to the vehicles serving THIS area today (scope 'area', from the route schemes of the area's stops) with the whole company fleet as the explicit secondary (scope 'company': every active vehicle across ALL of the company's projects, each row carrying project_id/project_name provenance and the summary stating the project spread; SBX-526). SBX-536 W0: company-scope rows (explicit or fallback) also carry ledger_claims ([{weekday, kind, project_id, project_name, owner, foreign, ...}], the vehicle's claimed weekdays and each claim's owner in planner words from one company-ledger read per load) and, on rows claimed by another project, the pinned borrow_sentence to render verbatim; area rows carry neither key. Carries summary and guidance sentences in planner words, per-vehicle unit-sanity flags for visibly nonsense recorded capacities (staged as recorded, said out loud; the T17 cheap half), and the loader's honesty notes. Read-only (D18). */
  platformFleetLoad?: Maybe<Scalars['GenericScalar']['output']>;
  /** The global citizen-portal role->rights matrix: every role with its granted capability keys, plus the full capability-key and role vocabularies so a complete grid can be rendered. Staff only. */
  portalRoleCapabilityMatrix: PortalRoleCapabilityMatrixDef;
  /** The ID of the object */
  price?: Maybe<PriceDef>;
  /** The ID of the object */
  product?: Maybe<ProductDef>;
  /** The ID of the object */
  project?: Maybe<ProjectType>;
  /** The ID of the object */
  promotion?: Maybe<PromotionDef>;
  /** The ID of the object */
  property?: Maybe<PropertyDef>;
  /** The ID of the object */
  propertyContact?: Maybe<PropertyContactDef>;
  /** PRO-946: a property's environmental account (collected kg and CO2e per waste fraction) for a period. Null for contractor users and pure drivers. */
  propertyEnvironmentalAccount?: Maybe<PropertyEnvironmentalAccountType>;
  propertyEventLog?: Maybe<PropertyEventLogEvent>;
  /** The ID of the object */
  propertyGroup?: Maybe<PropertyGroupDef>;
  /** The ID of the object */
  propertyManagementCompany?: Maybe<PropertyManagementCompanyDef>;
  propertyManagementCompanyMap: CustomerMapDef;
  propertyMap: ClusteredPropertyMapDef;
  /** The ID of the object */
  propertyNote?: Maybe<PropertyNoteDef>;
  /** The ID of the object */
  propertyType?: Maybe<PropertyTypeDef>;
  /** The ID of the object */
  propertyTypeToKmdEasyStationCode?: Maybe<PropertyTypeToKmdEasyStationCodeMapDef>;
  /** The ID of the object */
  propertyUser?: Maybe<PropertyUserDef>;
  propertyWasteDecisions?: Maybe<Array<PropertyWasteDecisionDef>>;
  /** The holder's view through a signing link. Null for any invalid link. */
  publicTransferDocument?: Maybe<TransferDocumentType>;
  publicUnconfirmedUser?: Maybe<UnconfirmedUserType>;
  /** Purchase orders, newest first: one warehouse's, or every warehouse of the caller's companies. */
  purchaseOrders?: Maybe<PurchaseOrdersPage>;
  quickExport?: Maybe<QuickExportResult>;
  /** RS-705: promised vs realized per week for a live promotion, with honest realized / partial / insufficient_data states. */
  realizedSavings?: Maybe<Array<PromotionSavingsWeekDef>>;
  /** The ID of the object */
  recommendation?: Maybe<RecommendationDef>;
  /** T12 (D73): the non-overlapping suggestion aggregate: open money cards grouped by root cause, ONE bound per group (bound_year, the largest member impact; overlapping cards never sum), the constance materiality floor applied with the filtered tail counted, and total_bound_year stated as a bound with its currency. Money honesty (D67): a mixed-currency group refuses its bound (currency_mismatch true, bound_year null, member labels listed); the total serves null with a per-label breakdown (total_by_label) whenever any open money group disagrees with the area book label, is mixed, or is unlabeled legacy. Keys are currency neutral: the old *_eur_* names asserted a currency the numbers do not necessarily carry. */
  recommendationEconomics?: Maybe<Scalars['GenericScalar']['output']>;
  /** RS-1203 (EV-RECS): per-detector precision over the tenant's accept/dismiss telemetry, with the gate constants (precision >= 0.7 over >= 10 labeled) and the current default-on flags. The calibration surface for flipping detectors default-on. */
  recommendationPrecision?: Maybe<Scalars['GenericScalar']['output']>;
  /** Current edit-lease on a record, or null when it is free (or leases are disabled). */
  recordLease?: Maybe<RecordLeaseDef>;
  /** Wizard step 1 for 'report relocation': the contact's ACTIVE property links, each with active agreements and container ownership (the FE's default-logistics signal). */
  relocationContext?: Maybe<RelocationContextDef>;
  /** PRODUCT-522: the company's rentable units in stock (label, container type, depot), ordered by label, at most 2000 - the list the driver app caches to validate a scan offline. Refused for a company without the Skip hire module. */
  rentableStockLabels?: Maybe<Array<RentableStockLabelDef>>;
  rentalAtRiskReport?: Maybe<RentalAtRiskReportType>;
  rentals: Array<RentalRowType>;
  rentalsPage: RentalsPageType;
  reservedBreakdown?: Maybe<Array<Maybe<ReservedTicketRowType>>>;
  resolveInsightsWidgets: WidgetResolutionResult;
  rfidVehicleConnection?: Maybe<RfidVehicleConnectionDef>;
  /** The ID of the object */
  route?: Maybe<RouteType>;
  routeDeviationWarning?: Maybe<Scalars['String']['output']>;
  routeDriversGeojsonById?: Maybe<Array<Maybe<DriverGeoJsonType>>>;
  routeDriversGeojsons?: Maybe<Array<Maybe<DriverGeoJsonType>>>;
  /** Driving-events chronological stream for one completed route (REQ-74). Includes depot arrivals/departures and stop completions with timestamps, locations, weight, and fill level for material-flow traceability and CSV export. Company-scoped; contractors see their own routes only. */
  routeDrivingEvents?: Maybe<Array<Maybe<RouteDrivingEventType>>>;
  /** The ID of the object */
  routeExport?: Maybe<RouteExportType>;
  routeGeojson?: Maybe<GeoJsonType>;
  /** The ID of the object */
  routeProblem?: Maybe<RouteProblemDef>;
  /** The ID of the object */
  routeScheme?: Maybe<RouteSchemeType>;
  /** Route codes for the schemes whose name holds no code their containers share (RouteSchemeType.routeCodeFromContainers: the Glass+Plast merges). For each, the code of the nearest container on it that has one, measured from the new container (its coordinates, else the container's or the property's address), and every code it carries. Other schemes are left out. Read-only. */
  routeSchemeRouteCodes?: Maybe<Array<RouteSchemeRouteCodesType>>;
  /** Route schemes suggested for a container from its neighbours (same property, then same street within 50 m, then within 1 km), best first. Read-only. */
  routeSchemeSuggestions?: Maybe<Array<RouteSchemeSuggestionType>>;
  /** The scheme's configured eligible unloading stations in order. Contractors can read their own schemes only. */
  routeSchemeUnloadingStations?: Maybe<Array<Maybe<DepotType>>>;
  /** The ID of the object */
  routeSettings?: Maybe<RouteSettingsType>;
  /** COMPASS-884 / HSY REQ 42: resolve N simultaneously-read tags to the stops they identify on one route, in ONE round trip. Read-only — nothing is confirmed. Repeated tags come back DUPLICATE, unknown tags UNKNOWN_TAG; the list is never partial and never raises for a bad tag. */
  routeStopsByTags: Array<TagReadResultType>;
  /** The ID of the object */
  routeStudioEvent?: Maybe<RouteStudioEventDef>;
  /** COMPASS-877 / HSY REQ 18: the DRIVER's view of one route's unloading events — including the ones a site's weighing system has already weighed but nobody has confirmed yet. Reading weightNetKg / weightSource / weightMeasuredAt on these nodes tells the app whether a weight was transferred automatically (and by what) or has to be asked for by hand. Unlike allUnloadingEvents this is NOT hauler-module gated — a contractor driver whose company has the module off must still be able to confirm their own unloading — but it IS hauler-scoped and company-walled, and it is narrowed to one route the caller can already see. */
  routeUnloadingEvents?: Maybe<PickUpOrderTypeConnection>;
  /** The route's effective eligible unloading stations in the office-configured order (the route's own set, else its scheme's). Empty = not configured (legacy first-match planning). Contractors can read their own routes only. */
  routeUnloadingStations?: Maybe<Array<Maybe<DepotType>>>;
  routesGeojson?: Maybe<Array<Maybe<GeoJsonType>>>;
  ryhtiConfig?: Maybe<RyhtiConfigDef>;
  /** The ID of the object */
  scenario?: Maybe<ScenarioDef>;
  /** The ID of the object */
  scheduledExport?: Maybe<ScheduledExportDef>;
  /** The ID of the object */
  scheduledExportRun?: Maybe<ScheduledExportRunDef>;
  scpLedgerFeed?: Maybe<Scalars['GenericScalar']['output']>;
  scpLedgerFeeds?: Maybe<Scalars['GenericScalar']['output']>;
  scpMemberSummary?: Maybe<ScpMemberSummaryPayloadDef>;
  scpMembersOutsideRadius?: Maybe<Array<ScpMemberOutsideRadiusDef>>;
  /** The ID of the object */
  scpMembership?: Maybe<ScpMembershipDef>;
  scpMembershipCandidateCheck?: Maybe<ScpMembershipCandidateCheckDef>;
  scpMembershipEndPreview?: Maybe<ScpMembershipEndPreviewDef>;
  scpNotificationDocument?: Maybe<ScpNotificationDocumentDef>;
  scpPropertyMoveOutPreview?: Maybe<ScpPropertyMoveOutPreviewDef>;
  /** The ID of the object */
  scpRoleDefinition?: Maybe<ScpRoleDefinitionDef>;
  scpShareSumBreaches?: Maybe<Array<ScpShareSumBreachDef>>;
  /** Omnisearch sync-state health per (entity, locale). Master/staff only. */
  searchSyncHealth: Array<SearchSyncHealthRow>;
  /** RS-1201 (D22): the sensorization business case for a sensorization-template scenario: lifts avoided, km/hours saved via the documented estimator, sensor costs, payback months; every assumption labeled (assumption vs learned vs input vs engine). */
  sensorizationBusinessCase?: Maybe<Scalars['GenericScalar']['output']>;
  /** The ID of the object */
  service?: Maybe<ServiceDef>;
  /** The ID of the object */
  serviceResponsibility?: Maybe<ServiceResponsibilityDef>;
  /** The ID of the object */
  serviceUnit?: Maybe<ServiceUnitDef>;
  /** The ID of the object */
  settings?: Maybe<SettingsType>;
  siirtoCompanySettings?: Maybe<SiirtoCompanySettingsType>;
  /** RS-903 (D08): per-area predicted vs realized km/hours per route-day, worst first, with honest insufficient-data states and the learning-loop changelog. The honesty page's data source. */
  simToActual?: Maybe<SimToActualDef>;
  /** The ID of the object */
  simulationJob?: Maybe<SimulationJobDef>;
  simulations: Array<SimulationDef>;
  /** The state of every skip-hire setup step for a company, without writing: exists / not_done / needs_input. */
  skipHireSetupState?: Maybe<SkipHireSetupStateType>;
  /** The setup step keys, in execution order. */
  skipHireSetupSteps: Array<Scalars['String']['output']>;
  /** PRODUCT-523: the skips collected on this route since its last completed tipping (waste-station) stop - the RETURN_RENTAL / on-call / exchange collect legs completed on the route, in stop order - each with its collection stop and any weight already recorded. The driver app's Weigh step. Refused for a company without the Skip hire module; a route the caller may not see does not exist. */
  skipsOnBoard?: Maybe<Array<SkipOnBoardDef>>;
  /** The ID of the object */
  sourceMetric?: Maybe<SourceMetricDef>;
  /** The ID of the object */
  sparePart?: Maybe<SparePartType>;
  /** Staff only: one SQL dataset, also a deleted one. */
  sqlDataset?: Maybe<SqlDatasetAdminType>;
  /** Staff only: the SQL datasets of one company, or of every company without companyId. */
  sqlDatasets: Array<SqlDatasetAdminType>;
  /** The users who may be designated as alert recipients. */
  stockAlertRecipientCandidates?: Maybe<Array<WarehouseAlertRecipientType>>;
  stopListFieldsOptions?: Maybe<Array<Maybe<StopListFieldOptionDef>>>;
  /** The ID of the object */
  stopSet?: Maybe<StopSetDef>;
  stripeQuote?: Maybe<BillingSubscriptionQuote>;
  /** The ID of the object */
  svarutDispatch?: Maybe<SvarUtDispatchType>;
  /** The ID of the object */
  team?: Maybe<TeamType>;
  /** The ID of the object */
  ticket?: Maybe<TicketDef>;
  /** The ID of the object */
  ticketCategory?: Maybe<TicketCategoryDef>;
  ticketCustomField?: Maybe<TicketCustomFieldDef>;
  /** The ID of the object */
  ticketDraft?: Maybe<TicketDraftDef>;
  ticketEventLog?: Maybe<TicketEventLogEvent>;
  ticketMap?: Maybe<ClusteredTicketMapDef>;
  /** The ID of the object */
  ticketMessageTemplate?: Maybe<TicketMessageTemplateDef>;
  ticketPricing: TicketPricing;
  /** The ID of the object */
  ticketType?: Maybe<TicketTypeDef>;
  ticketTypeCounts?: Maybe<Array<Maybe<TicketTypeCountDef>>>;
  transferDocument?: Maybe<TransferDocumentType>;
  transferDocumentFieldDefinitions?: Maybe<Scalars['GenericScalar']['output']>;
  /** The live transfer document of a stop (by PickUpOrder.orderId), or null. */
  transferDocumentForStop?: Maybe<TransferDocumentType>;
  /** Whether this stop needs a transfer document (flag on + eligible). */
  transferDocumentRequiredForStop?: Maybe<Scalars['Boolean']['output']>;
  /** Upcoming holidays within horizonDays (backend default of 90 days applies when omitted) with per-holiday impacted-item counts. Empty (never an error) when no calendar is configured. */
  upcomingCompanyHolidays?: Maybe<Array<UpcomingHolidayDef>>;
  urbaserCompanyCredentials?: Maybe<UrbaserCredentialsDef>;
  /** The ID of the object */
  user?: Maybe<UserType>;
  /** The ID of the object */
  userAbsence?: Maybe<UserAbsenceType>;
  userConfig?: Maybe<UserTypeConfigType>;
  userFilterCollection?: Maybe<UserFilterCollectionType>;
  userIsActive?: Maybe<IoUserIsActiveType>;
  /** One of the viewer's own background-job notifications by id — what a mutation that returns a job id (e.g. generateInvoiceForProperty.jobId) is followed with. */
  userJobNotification?: Maybe<UserJobNotificationType>;
  /** The ID of the object */
  userLayoutConfig?: Maybe<UserLayoutConfigType>;
  /** Get the total count of user notifications (with granular counts) */
  userNotificationsCounter?: Maybe<UserNotificationsCounterType>;
  userProject?: Maybe<UserProjectType>;
  /** The ID of the object */
  validationVerdict?: Maybe<ValidationVerdictDef>;
  /** The ID of the object */
  vehicle?: Maybe<VehicleType>;
  /** The ID of the object */
  vehicleAbsence?: Maybe<VehicleAbsenceType>;
  /** The ID of the object */
  vehicleSize?: Maybe<VehicleSizeDef>;
  /** The ID of the object */
  vehicleType?: Maybe<VehicleTypeType>;
  vismaCompanySettings?: Maybe<VismaCompanySettingsType>;
  /** The ID of the object */
  vismaExportLog?: Maybe<VismaExportLogType>;
  vismaExportPreview?: Maybe<VismaExportPreviewType>;
  /** The users designated for this warehouse's low-stock alerts. Empty means the alerts go to the company admins' bell. */
  warehouseAlertRecipients?: Maybe<Array<WarehouseAlertRecipientType>>;
  warehouseAvailabilityOn: Array<RentalAvailabilityRowType>;
  warehouseBalances?: Maybe<Array<Maybe<WarehouseBalanceRowType>>>;
  warehouseContainers?: Maybe<Array<Maybe<WarehouseContainerRowType>>>;
  warehouseMovementActors?: Maybe<Array<Maybe<WarehouseMovementActorType>>>;
  warehouseMovements?: Maybe<WarehouseMovementsPage>;
  warehousePlannedMovements: Array<WarehousePlannedMovementRowType>;
  warehouseRouteSchemeLinks?: Maybe<Array<Maybe<RouteSchemeLinkType>>>;
  /**
   * Widened with `conditionTypeId` (PRO-391), additive to the legacy
   * `condition` filter.
   */
  warehouseStoredContainers?: Maybe<WarehouseStoredContainersPage>;
  warehouseTransitSummary?: Maybe<WarehouseTransitSummaryType>;
  washList?: Maybe<WashListDef>;
  washListPrefill?: Maybe<WashListPrefillDef>;
  /** The company's wash lists, newest first. Empty for a company without container washing enabled. */
  washLists?: Maybe<Array<WashListDef>>;
  /** The ID of the object */
  wasteCollector?: Maybe<WasteCollectorType>;
  /** The ID of the object */
  wasteFraction?: Maybe<WasteFractionType>;
  /** The archived Duty of Care Waste Transfer Note of a completed movement ticket (or of the given rental ticket's return). */
  wasteTransferNote?: Maybe<WasteTransferNoteDef>;
  wasteWaterApplianceOptions?: Maybe<Array<Maybe<WasteWaterApplianceOptionDef>>>;
  /** The ID of the object */
  zone?: Maybe<ZoneDef>;
  /** PRO-280 'area within area' authoring: which EXISTING zone would fully contain the given draft GeoJSON Polygon/MultiPolygon geometry — the innermost one, or null when no zone contains it. Same parse as the zone save's boundaryGeojson and the same containment predicate the hierarchy uses, so the draw/import-time 'Create as a zone inside {parent}' offer always matches what saving would compute. Office-only, company-scoped. */
  zoneContainmentPreview?: Maybe<ZoneDef>;
};


export type QueryAcosArchiveLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgreementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgreementTemplatesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAlertArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAlertEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAlertRecipientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAlertRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAllAcosArchiveLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticket?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllAgreementExportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllAgreementTemplatesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllAgreementsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  container?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRentalBacked?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hauler?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['Float']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveOrFuture?: InputMaybe<Scalars['Boolean']['input']>;
  isContainerAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  isFuture?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  municipality?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  property?: InputMaybe<Scalars['ID']['input']>;
  propertyGroup?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wasteFraction?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllAlertEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alert?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  alertRecipient?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllAlertRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alerts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllAlertsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alertRule?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  closedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  container?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllAreasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hauler?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllAutopilotActionsArgs = {
  actionDate?: InputMaybe<Scalars['Date']['input']>;
  actionType?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  planningArea?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllBaselinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  baselineType?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  planningArea?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllBillingRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAllBrainRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllBulkWasteFractionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  vehicles?: InputMaybe<Scalars['String']['input']>;
  wasteCategory?: InputMaybe<Scalars['String']['input']>;
  wasteSubstance?: InputMaybe<Scalars['String']['input']>;
  wasteType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllCandidateTablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  case?: InputMaybe<Scalars['ID']['input']>;
  docClass?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  needsConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllCaseMaterializationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  case?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAllCaseQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  case?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllChangeProposalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contractArea?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hauler?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  routeScheme?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllCollectionCalendarArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  allowUsageInCombinedCalendarsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionCalendarWeek?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  determinePeriodBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isCombined?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pickupSettings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  weekdays?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAllCollectionCalendarDatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionCalendarWeeks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  collectionCalendars?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  collectionDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  collectionDate_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  collectionDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pickupSettings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllCollectionCalendarDeviationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionCalendars?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  endDate_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  endDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  startDate_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  startDate_Lte?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAllCollectionCalendarWeekArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllCompanyContainerMetaTypesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllCompanyEmailAccountMessagesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTeam?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignee?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isPortal?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  receiverEmail?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  senderEmail?: InputMaybe<Scalars['String']['input']>;
  sentAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  sentAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  threadStartersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  ticketType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllCompanyEmailAccountRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyEmailAccount?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllCompanyEmailAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSynced?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllCompanyHolidaysArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllCompanyMetaTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllCompanyRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllComparisonSettingsArgs = {
  activeProjects: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllComplaintsArgs = {
  affectsPay?: InputMaybe<Scalars['Boolean']['input']>;
  haulerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllCompostingRegistryEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  apartmentIdentifier?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasReportedStop?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  inspectionResult?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isInspected?: InputMaybe<Scalars['Boolean']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationDateFrom?: InputMaybe<Scalars['Date']['input']>;
  notificationDateTo?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  property?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageMonths?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validOn?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAllContactAuthorizationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorizationMethod?: InputMaybe<Scalars['ID']['input']>;
  authorizationType?: InputMaybe<Scalars['ID']['input']>;
  authorizedContact?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  principalContact?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllContactPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  filterProperty?: InputMaybe<PropertyDefFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchContacts?: InputMaybe<Scalars['String']['input']>;
  searchProperties?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllContactPropertyNotificationRulesArgs = {
  contact?: InputMaybe<Scalars['ID']['input']>;
  managementCompany?: InputMaybe<Scalars['ID']['input']>;
  property?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactTags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contactType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  externalPropertyNumber?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndustry?: InputMaybe<Scalars['Boolean']['input']>;
  hasPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaxId?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  marketingOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyManagementCompanyId?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllContainerGroupsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  containerTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pickupSettings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  wasteFractions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllContainerImportsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllContainerNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  containers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyContactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  uniqueReceiversOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllContainerPricesArgs = {
  From?: InputMaybe<Scalars['Date']['input']>;
  To?: InputMaybe<Scalars['Date']['input']>;
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  containerType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  wasteFraction?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllContainerTypesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isRentable?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllContainerWeightImportsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllContainersArgs = {
  From?: InputMaybe<Scalars['DateTime']['input']>;
  To?: InputMaybe<Scalars['DateTime']['input']>;
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  allowedForRoute?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  area_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  bbox?: InputMaybe<BBoxInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  clusterId?: InputMaybe<Scalars['String']['input']>;
  collectionCalendar_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  collectionCalendars?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerId?: InputMaybe<Scalars['String']['input']>;
  containerType_Name_Iexact?: InputMaybe<Scalars['String']['input']>;
  containerType_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  containerTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  customFieldFilters?: InputMaybe<Array<CustomFieldFilterInput>>;
  device_IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCollectionCalendars?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRouteSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  filterCostSettings?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  measurement_FillPercentage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noProperty?: InputMaybe<Scalars['Boolean']['input']>;
  noRouteOnDay?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  polygons?: InputMaybe<Array<InputMaybe<PolygonInput>>>;
  propertyGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyNumber?: InputMaybe<Scalars['String']['input']>;
  propertyTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  q?: InputMaybe<Scalars['String']['input']>;
  rfid?: InputMaybe<Scalars['String']['input']>;
  routeIdsNotCompletedStops?: InputMaybe<Scalars['String']['input']>;
  routeScheme_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scpAttachable?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchContact?: InputMaybe<Scalars['String']['input']>;
  sensor_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  storedAtDepot?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  temporarilyRelocated?: InputMaybe<Scalars['Boolean']['input']>;
  vehicle_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFractionIds?: InputMaybe<Scalars['String']['input']>;
  wasteFraction_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  wasteFraction_WasteTypes_Name_Iexact?: InputMaybe<Scalars['String']['input']>;
  wasteFraction_WasteTypes_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wasteTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zone_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllCopilotConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllCostModelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllCostSettingsArgs = {
  activeProjects: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllCriiptoApplicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllCustomerFunctionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllDashboardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllDebtorExportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAllDepotsArgs = {
  activeCompanies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coOwners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  companyOwned?: InputMaybe<Scalars['Boolean']['input']>;
  contractors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  depotType_Iexact?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownedBy?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  wasteFractions?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllDeviceTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllDocumentsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllDriverNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  receiver?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
  sender?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sentAt?: InputMaybe<Scalars['String']['input']>;
  stopIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllDriversArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  havingVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  primaryVehicle?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status_Iexact?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllEvolutionContainerCollectionItemSnapshotArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  batch?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  containerId?: InputMaybe<Scalars['Float']['input']>;
  createdAtFrom?: InputMaybe<Scalars['Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  externalSyncStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllEvolutionContainerItemSnapshotArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  batch?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  containerId?: InputMaybe<Scalars['Float']['input']>;
  createdAtFrom?: InputMaybe<Scalars['Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  externalSyncStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAllEvolutionContainerLinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  container?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIdExact?: InputMaybe<Scalars['Float']['input']>;
  credentials?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inScope?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastSeenAtFrom?: InputMaybe<Scalars['Date']['input']>;
  lastSeenAtTo?: InputMaybe<Scalars['Date']['input']>;
  neverSeen?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  routeId?: InputMaybe<Scalars['String']['input']>;
  routeIdIcontains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllEvolutionCustomerItemSnapshotArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  batch?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  customerId?: InputMaybe<Scalars['Float']['input']>;
  externalSyncStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllEvolutionDeviationCodeMappingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  credentials?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deviationCode?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllEvolutionManualSyncArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  credentials?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  modes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  runId?: InputMaybe<Scalars['UUID']['input']>;
  startedAtFrom?: InputMaybe<Scalars['Date']['input']>;
  startedAtTo?: InputMaybe<Scalars['Date']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAllEvolutionSnapshotBatchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  batchTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllEvolutionSoapApiCallHistoryArgs = {
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  credentials?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageIcontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  startedAtFrom?: InputMaybe<Scalars['Date']['input']>;
  startedAtTo?: InputMaybe<Scalars['Date']['input']>;
  statusCode?: InputMaybe<Scalars['Float']['input']>;
  succeeded?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllEvolutionSoapApiCredentialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllEvolutionTicketItemSnapshotArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  batch?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  containerId?: InputMaybe<Scalars['Float']['input']>;
  createdAtFrom?: InputMaybe<Scalars['Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  externalSyncStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  scheduledDayFrom?: InputMaybe<Scalars['Date']['input']>;
  scheduledDayTo?: InputMaybe<Scalars['Date']['input']>;
  ticketId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAllExplorationRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  planningArea?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllExportTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exportType?: InputMaybe<Array<InputMaybe<ExportTypes>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  frozen?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAllExportsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excelFormat?: InputMaybe<Scalars['Boolean']['input']>;
  exportType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllExternalCollectionEventsArgs = {
  containerId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ExternalCollectionEventStatus>;
};


export type QueryAllExternalPropertyNumbersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllFillLevelMeasurementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllFixedRouteTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  routeScheme?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAllFractionServiceBindingsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  case?: InputMaybe<Scalars['ID']['input']>;
  externalContainerKey?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fractionCode?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  routeIdentity?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllGrammarClaimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  case?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllHaulerPriceChangeLogsArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  haulerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllHaulerPricesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hauler?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ppProduct?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllHaulersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  areas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllIdentityMapEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  case?: InputMaybe<Scalars['ID']['input']>;
  clientLabel?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllImportBatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllImportCasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllImportFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  case?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllImportHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importType?: InputMaybe<Array<InputMaybe<ImportTypes>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllImportIssuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importBatch?: InputMaybe<Scalars['ID']['input']>;
  issueType?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  verdict?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllImportedKmdEasyFileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ftpDownloadedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  ftpDownloadedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  ftpSourceDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  importedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isFtpDownloaded?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAllIndustryCodesArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllInquiriesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  containers?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  deadline_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  deadline_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inquiryTypes?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  priorities?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllInquiryTypingsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllIntegrationGpsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllIntegrationGpsVehicleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  integration?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  vehicle?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllIntegrationUrbaserCallResponseHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllIntegrationUrbaserCallResponseHistoryAgreementArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  agreementContainers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  agreements?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  integrationUrbaserCallResponseHistory?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllIntegrationsUrbaserAgreementsSyncArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllInvoiceItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  agreement?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingRun?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoice?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  periodEndFrom?: InputMaybe<Scalars['Date']['input']>;
  periodEndTo?: InputMaybe<Scalars['Date']['input']>;
  periodStartFrom?: InputMaybe<Scalars['Date']['input']>;
  periodStartTo?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  ticket?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllInvoicesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroup?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticket?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllKeyTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllKmdEasyDeltaFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ftpUploadStatus?: InputMaybe<Scalars['String']['input']>;
  ftpUploadedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  ftpUploadedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  generatedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hasFtpUploadError?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAllKmdEasyFileFu51007FileLineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  errorAtStatus?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  rowNumber?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllKmdEasyFileFu51008FileLineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  errorAtStatus?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  rowNumber?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllKmdEasyFileFu63302FileLineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  errorAtStatus?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  rowNumberForDeltaFile?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllKmdEasyFileFu63303FileLineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  errorAtStatus?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  rowNumberForDeltaFile?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllKmdEasyTotalFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ftpUploadStatus?: InputMaybe<Scalars['String']['input']>;
  ftpUploadedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  ftpUploadedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  generatedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hasFtpUploadError?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAllLoadUnitJobsArgs = {
  pending?: InputMaybe<Scalars['Boolean']['input']>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllLocationsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllLorawanDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllManagementCompanyPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  managementCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchManagementCompanies?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllMasterDataSyncsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  startedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  startedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAllMaterializedRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  case?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  materialization?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  routeIdentity?: InputMaybe<Scalars['String']['input']>;
  runKind?: InputMaybe<Scalars['String']['input']>;
  serviceDateAfter?: InputMaybe<Scalars['Date']['input']>;
  serviceDateBefore?: InputMaybe<Scalars['Date']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAllMeasurementSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllMobileDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllMunicipalitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllMunicipalityCodesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllNarrativeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllNotificationMessagesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAtFrom?: InputMaybe<Scalars['Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAllNotificationSettingsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  containerId?: InputMaybe<Scalars['ID']['input']>;
  containerType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  wasteFraction?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllNotificationsArgs = {
  From?: InputMaybe<Scalars['DateTime']['input']>;
  To?: InputMaybe<Scalars['DateTime']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_Iexact?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllParameterSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAllPermissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllPhysicalKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionLocation?: InputMaybe<Scalars['ID']['input']>;
  contact?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  keyType?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  property?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPickupOrderApprovalCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAllPickupOrderApprovalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approvalCollection?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pickupOrder?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPickupOrdersArgs = {
  acknowledgementType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  approvalCollection?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionCalendarIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  completeApproval?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  container?: InputMaybe<Scalars['ID']['input']>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerPickupSettings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  container_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  container_PickupMethod?: InputMaybe<Scalars['String']['input']>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdInquiry?: InputMaybe<Scalars['ID']['input']>;
  createdInquiry_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdInquiry_Status?: InputMaybe<Scalars['String']['input']>;
  createdTicketsTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  depotIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeOrderTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalPropertyNumber?: InputMaybe<Scalars['String']['input']>;
  fillLevel_Gte?: InputMaybe<Scalars['Float']['input']>;
  fillLevel_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  fillLevel_Lte?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isUnloading?: InputMaybe<Scalars['Boolean']['input']>;
  isUnloadingPending?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lifecycleIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  noApproval?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderType_Icontains?: InputMaybe<Scalars['String']['input']>;
  pendingApproval?: InputMaybe<Scalars['Boolean']['input']>;
  propertyGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  route?: InputMaybe<Scalars['ID']['input']>;
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routeScheduledDayGte?: InputMaybe<Scalars['Date']['input']>;
  routeScheduledDayLte?: InputMaybe<Scalars['Date']['input']>;
  route_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stopStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketAssigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketAssigneeTeams?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketCreatedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketOrContainerIsnull?: InputMaybe<Scalars['Boolean']['input']>;
  ticketPriority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketReportedByPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  ticketReporterByDriver?: InputMaybe<Scalars['Boolean']['input']>;
  ticketRequestedByPortal?: InputMaybe<Scalars['Boolean']['input']>;
  ticketStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticket_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllPickupSettingsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  container_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  project_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPlanCalendarEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  changedVsReference?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fraction?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  plan?: InputMaybe<Scalars['ID']['input']>;
  propertyRef?: InputMaybe<Scalars['String']['input']>;
  weekday?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAllPlanningAreasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  regionPack?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  planningArea?: InputMaybe<Scalars['ID']['input']>;
  scenario?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllPricesArgs = {
  From?: InputMaybe<Scalars['Date']['input']>;
  To?: InputMaybe<Scalars['Date']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  containerType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActivePrice?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  propertyType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFraction?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPromotionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  plan?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPropertiesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  area_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  bbox?: InputMaybe<BBoxInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  clusterId?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  connectedToSewageNetwork?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  customFieldFilters?: InputMaybe<Array<CustomFieldFilterInput>>;
  excludePropertyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRouteSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBlankAddress?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  invoiceSyncFrequency?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastViewedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  municipality?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  noRouteOnDay?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentProperty?: InputMaybe<Scalars['ID']['input']>;
  polygons?: InputMaybe<Array<InputMaybe<PolygonInput>>>;
  ppContainerProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ppRecurringProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ppServiceProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  propertyContactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroup?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  registerBasis?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  registerBasisDrift?: InputMaybe<Scalars['Boolean']['input']>;
  rootOnly?: InputMaybe<Scalars['Boolean']['input']>;
  routeScheme_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchContact?: InputMaybe<Scalars['String']['input']>;
  searchContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  searchExternalPropertyNumber?: InputMaybe<Scalars['String']['input']>;
  searchLocation?: InputMaybe<Scalars['String']['input']>;
  searchOwner?: InputMaybe<Scalars['String']['input']>;
  sharedTank?: InputMaybe<Scalars['Boolean']['input']>;
  sludgeTankType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zone_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllPropertyContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmailNotification?: InputMaybe<Scalars['Boolean']['input']>;
  hasPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  hasSmsNotification?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaxId?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPropertyGroupsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  availability?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingMode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  company?: InputMaybe<Scalars['ID']['input']>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fraction?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  groupType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasScpProfile?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  scpType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAllPropertyLinksArgs = {
  contactTags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeFuture?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  propertyId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPropertyManagementCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  contactTags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndustry?: InputMaybe<Scalars['Boolean']['input']>;
  hasPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  industries?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdExact?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPropertyTypeToKmdEasyStationCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPropertyTypesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPropertyUsersArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  hasPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  defaultOn?: InputMaybe<Scalars['Boolean']['input']>;
  detector?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  planningArea?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllRecurringPricesArgs = {
  From?: InputMaybe<Scalars['Date']['input']>;
  To?: InputMaybe<Scalars['Date']['input']>;
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAllReliabilityExclusionWindowsArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAllRouteProblemErrorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  routeProblems?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllRouteProblemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cancelledAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  cancelledAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  cancelledAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  endedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  errorAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  errorAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  errorAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  solvedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  solvedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  solvedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  startedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAllRouteSchemesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fixedRouteNightly?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllRouteSettingsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllRouteStudioEventsArgs = {
  actorKind?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  eventTypes?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  planningArea?: InputMaybe<Scalars['ID']['input']>;
  promotion?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllRouteVehicleSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  completedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  drivers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['ID']['input']>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllRoutesArgs = {
  Type?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  applicableVehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  completedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  containers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  drivers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRoutes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  filterByDay?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fixedRoute?: InputMaybe<Scalars['Boolean']['input']>;
  hauler?: InputMaybe<Scalars['ID']['input']>;
  haulers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isEmergency?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  plannedDrivers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  plannedVehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scheduledDay?: InputMaybe<Scalars['Date']['input']>;
  scheduledDay_Gte?: InputMaybe<Scalars['Date']['input']>;
  scheduledDay_Lte?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFractions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllScenariosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  planningArea?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllScheduledExportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllScheduledExportRunArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  newAgreements?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  removedAgreements?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledExport?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tickets?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAllScpMembershipsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  scpId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllServicePricesArgs = {
  From?: InputMaybe<Scalars['Date']['input']>;
  To?: InputMaybe<Scalars['Date']['input']>;
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  containerType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  wasteFraction?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllServiceResponsibilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllServiceUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  segmentRef?: InputMaybe<Scalars['String']['input']>;
  side?: InputMaybe<Scalars['String']['input']>;
  stopSet?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllServicesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceType_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  serviceTypes?: InputMaybe<Array<InputMaybe<ServiceType>>>;
};


export type QueryAllSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllSigFoxDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllSimulationJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  scenario?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllSkillsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code_Iexact?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllSourceMetricsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  case?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  materialization?: InputMaybe<Scalars['ID']['input']>;
  metric?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  scopeKey?: InputMaybe<Scalars['String']['input']>;
  verdict?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllSparePartsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllStopSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllSvarutDispatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticket?: InputMaybe<Scalars['ID']['input']>;
  useCase?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTaskHaulerReassignmentLogsArgs = {
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  pickupOrderId?: InputMaybe<Scalars['ID']['input']>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTicketCategoriesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  ticketType?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllTicketDraftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTicketMessageTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTicketTypeAreaExecutionWindowsArgs = {
  area?: InputMaybe<Scalars['ID']['input']>;
  ticketType?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllTicketTypesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  creatableFromCustomerPage?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnNavigationApp?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnPortal?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forCreation?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isContainerLevel?: InputMaybe<Scalars['Boolean']['input']>;
  isPropertyLevel?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderTicketType?: InputMaybe<TicketTypeOrderingObject>;
  search?: InputMaybe<Scalars['String']['input']>;
  sendsSmsOrEmailToProperty?: InputMaybe<Scalars['Boolean']['input']>;
  service?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  serviceServiceType?: InputMaybe<Scalars['String']['input']>;
  strictSearch?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTicketsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  affectsPay?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  allowedForRoute?: InputMaybe<Scalars['ID']['input']>;
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignedTeam?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignee?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  bbox?: InputMaybe<BBoxInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  clusterId?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerBarcode?: InputMaybe<Scalars['String']['input']>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  createdByKinds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdBySearch?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['String']['input']>;
  excludeStatuses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeTicketTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isComplaint?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastViewedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  managementCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  needToPairRfid?: InputMaybe<Scalars['Boolean']['input']>;
  needToScanBarcode?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  polygonSelection?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>>>>>;
  postalAreaSearch?: InputMaybe<Scalars['String']['input']>;
  postalCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['ID']['input']>;
  propertyContactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroup?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reportedByPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  reporter?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reporterByDriver?: InputMaybe<Scalars['Boolean']['input']>;
  reporterDriver?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  requestedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  requestedByPortal?: InputMaybe<Scalars['Boolean']['input']>;
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusCompletedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusCompletedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusInProgressAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusInProgressAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusOnHoldAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusOnHoldAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusOpenAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusOpenAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusPendingAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusPendingAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusRejectedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusRejectedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  syncJob?: InputMaybe<Scalars['Boolean']['input']>;
  ticketType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketTypeCategory?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketTypeService?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketTypeServiceServiceType?: InputMaybe<Scalars['String']['input']>;
  ticketType_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
  wasteFraction?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllTransferDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  awaitingHolder?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  rejected?: InputMaybe<Scalars['Boolean']['input']>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<TransferDocumentStatus>>>;
};


export type QueryAllTruckloadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  openedAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllUnloadingEventsArgs = {
  acknowledgementType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  approvalCollection?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionCalendarIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  completeApproval?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  container?: InputMaybe<Scalars['ID']['input']>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerPickupSettings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  container_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  container_PickupMethod?: InputMaybe<Scalars['String']['input']>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdInquiry?: InputMaybe<Scalars['ID']['input']>;
  createdInquiry_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdInquiry_Status?: InputMaybe<Scalars['String']['input']>;
  createdTicketsTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  depotIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeOrderTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalPropertyNumber?: InputMaybe<Scalars['String']['input']>;
  fillLevel_Gte?: InputMaybe<Scalars['Float']['input']>;
  fillLevel_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  fillLevel_Lte?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isUnloading?: InputMaybe<Scalars['Boolean']['input']>;
  isUnloadingPending?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lifecycleIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  noApproval?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderType_Icontains?: InputMaybe<Scalars['String']['input']>;
  pendingApproval?: InputMaybe<Scalars['Boolean']['input']>;
  propertyGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  route?: InputMaybe<Scalars['ID']['input']>;
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routeScheduledDayGte?: InputMaybe<Scalars['Date']['input']>;
  routeScheduledDayLte?: InputMaybe<Scalars['Date']['input']>;
  route_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stopStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketAssigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketAssigneeTeams?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketCreatedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketOrContainerIsnull?: InputMaybe<Scalars['Boolean']['input']>;
  ticketPriority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketReportedByPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  ticketReporterByDriver?: InputMaybe<Scalars['Boolean']['input']>;
  ticketRequestedByPortal?: InputMaybe<Scalars['Boolean']['input']>;
  ticketStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticket_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllUserAbsencesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  end_Gte?: InputMaybe<Scalars['Date']['input']>;
  end_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  start_Gte?: InputMaybe<Scalars['Date']['input']>;
  start_Lte?: InputMaybe<Scalars['Date']['input']>;
  users?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllUserEventsNotificationsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  directOnly?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  followingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  unseen?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllUserFilterCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  tableKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllUserJobNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  unseen?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllUserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  directOnly?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  followingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  unseen?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllUsersArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstName_Icontains?: InputMaybe<Scalars['String']['input']>;
  hasDriverRole?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDriver?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastName_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllValidationVerdictsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  case?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  materialization?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  routeIdentity?: InputMaybe<Scalars['String']['input']>;
  verdict?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
  waived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllVehicleAbsencesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  end_Gte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start_Lte?: InputMaybe<Scalars['Date']['input']>;
  vehicle?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllVehicleSignalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllVehicleSizesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Istartswith?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllVehicleTypesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Istartswith?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllVehiclesArgs = {
  Type?: InputMaybe<Scalars['String']['input']>;
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  drivers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasHauler?: InputMaybe<Scalars['Boolean']['input']>;
  hasPrimaryDriver?: InputMaybe<Scalars['Boolean']['input']>;
  hauler?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  primaryDriver?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status_Iexact?: InputMaybe<Scalars['String']['input']>;
  vehicleTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAllVismaExportLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  triggeredBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  triggeredBySystem?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllWasteFractionsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  vehicles?: InputMaybe<Scalars['String']['input']>;
  wasteCategory?: InputMaybe<Scalars['String']['input']>;
  wasteSubstance?: InputMaybe<Scalars['String']['input']>;
  wasteType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllWasteTypesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllWeighTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  depotIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isMatched?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  measuredAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  measuredAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  system?: InputMaybe<Scalars['String']['input']>;
  vehicleRegistration?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllWorkTaskCorrectionsArgs = {
  pickupOrderId?: InputMaybe<Scalars['ID']['input']>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllZonesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArchivalRulePreviewArgs = {
  dataType: ArchivableDataType;
  olderThanDays: Scalars['Int']['input'];
  timestampField: Scalars['String']['input'];
};


export type QueryArchivedRecordsArgs = {
  dataType: ArchivableDataType;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAreaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuthorizationMethodArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuthorizationTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAutomationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAutomationApprovalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAutomationApprovalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedToMe?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAutomationAuditLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  automationId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAutomationCatalogArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAutomationDiffArgs = {
  id: Scalars['ID']['input'];
  otherId: Scalars['ID']['input'];
};


export type QueryAutomationForSubjectArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  subjectId: Scalars['ID']['input'];
  subjectType: Scalars['String']['input'];
};


export type QueryAutomationRunArgs = {
  id: Scalars['ID']['input'];
  triggeredAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAutomationRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  automationId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAutomationTemplateArgs = {
  key: Scalars['String']['input'];
};


export type QueryAutomationTemplatesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  includeMine?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAutomationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAutopilotActionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAutopilotEntryPointContextArgs = {
  source: AutopilotEntryPointSource;
  status?: InputMaybe<Scalars['String']['input']>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
  ticketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ticketTypeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAutopilotEstatePreviewArgs = {
  flowIds: Array<Scalars['ID']['input']>;
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAutopilotFlowArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAutopilotFlowRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAutopilotFlowRunsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAutopilotFlowsArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAutopilotFlowsPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAutopilotLegacyRulesPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<AutopilotLegacyRuleEligibilityTier>;
  trigger?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAutopilotPendingApprovalsArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAutopilotPortfolioCollisionsArgs = {
  flowId: Scalars['ID']['input'];
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAutopilotRetroSavingsArgs = {
  months?: InputMaybe<Scalars['Int']['input']>;
  ratePerHour?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAutopilotShadowReportArgs = {
  flowId: Scalars['ID']['input'];
};


export type QueryAutopilotSimulateFlowArgs = {
  flowId: Scalars['ID']['input'];
  sampleLimit?: InputMaybe<Scalars['Int']['input']>;
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAutopilotStarterGalleryArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAutopilotSuggestionDraftArgs = {
  suggestionId: Scalars['ID']['input'];
};


export type QueryAutopilotValidateFlowDefinitionArgs = {
  definition: Scalars['JSONString']['input'];
};


export type QueryBaselineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBillingRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrainRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrregCompanyInfoArgs = {
  orgnr: Scalars['String']['input'];
};


export type QueryBuilderDashboardsAdminArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryBusinessAnalyticsArgs = {
  From: Scalars['DateTime']['input'];
  To: Scalars['DateTime']['input'];
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  comparisonFrom: Scalars['DateTime']['input'];
  comparisonTo: Scalars['DateTime']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
  periodType: Scalars['String']['input'];
  selectedCombinations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryCalendarBoardArgs = {
  planningAreaId: Scalars['ID']['input'];
  stopCap?: InputMaybe<Scalars['Int']['input']>;
  week?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryCandidateTableArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCaseManifestArgs = {
  caseId: Scalars['ID']['input'];
};


export type QueryCaseMaterializationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCaseNarrationArgs = {
  caseId: Scalars['ID']['input'];
  polish?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCaseQualityReportArgs = {
  caseId: Scalars['ID']['input'];
};


export type QueryCaseQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCaseValidationArgs = {
  caseId: Scalars['ID']['input'];
  materializationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCaseVerificationArgs = {
  caseId: Scalars['ID']['input'];
  materializationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCheckLoadedIdentityArgs = {
  identity: Scalars['String']['input'];
  routeStopId: Scalars['ID']['input'];
};


export type QueryCollectionCalendarArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCollectionCalendarDateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCollectionCalendarDeviationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCollectionCalendarWeekArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCollectionDeviationImpactArgs = {
  input: CollectionDeviationImpactInput;
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyContainerMetaTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyEmailAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyEmailAccountMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyEmailAccountRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyFeatureFlagsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCompanyHolidayCalendarArgs = {
  year: Scalars['Int']['input'];
};


export type QueryCompanyInfoArgs = {
  orgNumber: Scalars['String']['input'];
};


export type QueryCompanyMetaTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyPortalConversationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanySettingsArgs = {
  dns?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyStockMatrixArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<StockMatrixKind>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyStockMovementsArgs = {
  actorId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  itemTypeId?: InputMaybe<Scalars['ID']['input']>;
  movementType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sourceKind?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCompanyTicketTypeCustomFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inputType?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ticketTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryComparisonSettingsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompatibleSparePartsForContainerArgs = {
  containerId?: InputMaybe<Scalars['ID']['input']>;
  containerTypeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryComplaintPayEffectArgs = {
  ticketId: Scalars['ID']['input'];
};


export type QueryCompostingNotificationTemplateArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCompostingRegistryEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactAuthorizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactForPropertyContactArgs = {
  propertyContactId: Scalars['ID']['input'];
};


export type QueryContactMapArgs = {
  contactTags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contactType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  externalPropertyNumber?: InputMaybe<Scalars['String']['input']>;
  hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndustry?: InputMaybe<Scalars['Boolean']['input']>;
  hasPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaxId?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  marketingOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyManagementCompanyId?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContactNdrAccessAuditArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContactPropertyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactPropertyNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContainerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  prefetchPickupOrders?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContainerActivityHistoryArgs = {
  containerId: Scalars['ID']['input'];
};


export type QueryContainerByRfidArgs = {
  rfid: Scalars['String']['input'];
};


export type QueryContainerEventLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContainerGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContainerImportArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContainerMapArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  allowedForRoute?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  area_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  bbox: BBoxInput;
  collectionCalendar_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  collectionCalendars?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerId?: InputMaybe<Scalars['String']['input']>;
  containerType_Name_Iexact?: InputMaybe<Scalars['String']['input']>;
  containerType_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  containerTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  device_IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCollectionCalendars?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRouteSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  measurement_FillPercentage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noProperty?: InputMaybe<Scalars['Boolean']['input']>;
  noRouteOnDay?: InputMaybe<Scalars['Date']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyNumber?: InputMaybe<Scalars['String']['input']>;
  propertyTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  q?: InputMaybe<Scalars['String']['input']>;
  rfid?: InputMaybe<Scalars['String']['input']>;
  routeIdsNotCompletedStops?: InputMaybe<Scalars['String']['input']>;
  routeScheme_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scpAttachable?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchContact?: InputMaybe<Scalars['String']['input']>;
  sensor_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  storedAtDepot?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  temporarilyRelocated?: InputMaybe<Scalars['Boolean']['input']>;
  vehicle_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFractionIds?: InputMaybe<Scalars['String']['input']>;
  wasteFraction_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  wasteFraction_WasteTypes_Name_Iexact?: InputMaybe<Scalars['String']['input']>;
  wasteFraction_WasteTypes_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wasteTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zone_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  zoomLevel: Scalars['Int']['input'];
};


export type QueryContainerNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContainerTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContainerTypeWasteFractionRulesArgs = {
  containerTypeId?: InputMaybe<Scalars['ID']['input']>;
  wasteFractionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContainerWeightImportArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContainersGroupedByLocationArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  withDevices?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContractAreaCollectionsArgs = {
  areaId: Scalars['ID']['input'];
};


export type QueryContractAreaConflictsArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  containerTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
  excludeAreaId?: InputMaybe<Scalars['ID']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
  wasteFractions?: InputMaybe<Array<Scalars['Int']['input']>>;
  zones?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryContractAreaDocumentsArgs = {
  areaId: Scalars['ID']['input'];
};


export type QueryContractScopeProductsArgs = {
  containerTypeIds: Array<Scalars['ID']['input']>;
  propertyTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFractionIds: Array<Scalars['ID']['input']>;
};


export type QueryContractorInvoiceReconciliationArgs = {
  fromDate: Scalars['Date']['input'];
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QueryContractorManualEntriesArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  targetMonth?: InputMaybe<Scalars['Int']['input']>;
  targetYear?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContractorSettlementReportArgs = {
  fromDate: Scalars['Date']['input'];
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QueryConversationalAnalyticsArgs = {
  projectId: Scalars['ID']['input'];
  question: Scalars['String']['input'];
};


export type QueryCopilotConversationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCostModelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCostSettingsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCouncilFeeTableArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCriiptoApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerFunctionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerRequestPreviewArgs = {
  ticketId: Scalars['ID']['input'];
};


export type QueryCvrCompanyInfoArgs = {
  companyId: Scalars['ID']['input'];
  cvr: Scalars['String']['input'];
};


export type QueryDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDashboardSubscriptionDeliveriesArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type QueryDashboardSubscriptionsArgs = {
  dashboardId: Scalars['ID']['input'];
};


export type QueryDashboardTablesArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryDayMoveProfileArgs = {
  planningAreaId: Scalars['ID']['input'];
};


export type QueryDebtorExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDemandForecastArgs = {
  planningAreaId: Scalars['ID']['input'];
};


export type QueryDepotArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDestinationServiceProposalArgs = {
  destinationPropertyId: Scalars['ID']['input'];
  originPropertyId: Scalars['ID']['input'];
};


export type QueryDeviceToContainerSetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeviceTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDrawnAreaQuantitiesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  allowedForRoute?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  area_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  collectionCalendar_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  collectionCalendars?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerId?: InputMaybe<Scalars['String']['input']>;
  containerType_Name_Iexact?: InputMaybe<Scalars['String']['input']>;
  containerType_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  containerTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  device_IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCollectionCalendars?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRouteSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  fromDate: Scalars['Date']['input'];
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  measurement_FillPercentage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noProperty?: InputMaybe<Scalars['Boolean']['input']>;
  noRouteOnDay?: InputMaybe<Scalars['Date']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  polygons: Array<InputMaybe<PolygonInput>>;
  propertyGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyNumber?: InputMaybe<Scalars['String']['input']>;
  propertyTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  q?: InputMaybe<Scalars['String']['input']>;
  rfid?: InputMaybe<Scalars['String']['input']>;
  routeIdsNotCompletedStops?: InputMaybe<Scalars['String']['input']>;
  routeScheme_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scpAttachable?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchContact?: InputMaybe<Scalars['String']['input']>;
  sensor_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  storedAtDepot?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  temporarilyRelocated?: InputMaybe<Scalars['Boolean']['input']>;
  toDate: Scalars['Date']['input'];
  vehicle_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFractionIds?: InputMaybe<Scalars['String']['input']>;
  wasteFraction_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  wasteFraction_WasteTypes_Name_Iexact?: InputMaybe<Scalars['String']['input']>;
  wasteFraction_WasteTypes_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wasteTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zone_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDriverArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDriverNotificationByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDriverNotificationsListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  receiver?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
  sender?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sentAt?: InputMaybe<Scalars['String']['input']>;
  stopIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryDriverOfflinePackageArgs = {
  daysAhead?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDynamicDayDispatchArgs = {
  day: Scalars['Date']['input'];
  planningAreaId: Scalars['ID']['input'];
};


export type QueryDynamicDayPreviewArgs = {
  day: Scalars['Date']['input'];
  planningAreaId: Scalars['ID']['input'];
};


export type QueryEffectiveHolidayPolicyArgs = {
  areaId: Scalars['ID']['input'];
};


export type QueryEvolutionContainerLinkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEvolutionDeviationCodeMappingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEvolutionManualSyncArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEvolutionSnapshotBatchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEvolutionSoapApiCallHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEvolutionSoapApiCredentialsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExceptionCompensationEffectsArgs = {
  asOf?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryExplainInsightsChangeArgs = {
  asOf?: InputMaybe<Scalars['String']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  dimsToScan?: InputMaybe<Array<Scalars['String']['input']>>;
  metric: Scalars['String']['input'];
};


export type QueryExplanationArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryExplorationCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExplorationDigestArgs = {
  planningAreaId: Scalars['ID']['input'];
};


export type QueryExplorationRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportModelFieldsArgs = {
  exportType: ExportTypes;
};


export type QueryExportModelFiltersArgs = {
  exportType: ExportTypes;
};


export type QueryExportTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportTemplateTotalItemsArgs = {
  exportType: ExportTypes;
  filters?: InputMaybe<Array<InputMaybe<ExportFilterTypeInput>>>;
  mapSegments?: InputMaybe<Scalars['GenericScalar']['input']>;
  projects: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryFeatureConfigAuditArgs = {
  batchId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeatureConfigBatchArgs = {
  batchId: Scalars['String']['input'];
};


export type QueryFeatureConfigBulkPreviewArgs = {
  entries: Array<FeatureConfigBulkEntryInput>;
  overwriteDrift?: InputMaybe<Scalars['Boolean']['input']>;
  target: FeatureConfigBulkTargetInput;
};


export type QueryFeatureConfigCompaniesArgs = {
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFeatureConfigCompanyOverviewArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryFeatureConfigResolveArgs = {
  companyId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
};


export type QueryFeatureConfigRulesArgs = {
  key: Scalars['String']['input'];
};


export type QueryFileListArgs = {
  contentType?: InputMaybe<MediaContentEnumType>;
  objId: Scalars['ID']['input'];
  relativePath: Scalars['String']['input'];
};


export type QueryFillLevelDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFillLevelMeasurementsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFinanceFeederExportLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFinanceFeederExportLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFleetTransitionCaseArgs = {
  scenarioId: Scalars['ID']['input'];
  season?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFractionServiceBindingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetHistoryLocationArgs = {
  datetime: Scalars['DateTime']['input'];
};


export type QueryGrammarClaimArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHaulerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHaulerAccountantExportArgs = {
  companyId: Scalars['ID']['input'];
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryHaulerBankReconciliationArgs = {
  companyId: Scalars['ID']['input'];
  fileBase64: Scalars['String']['input'];
  filename?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHaulerClientKpisArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  fromDate: Scalars['Date']['input'];
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QueryHaulerCompensationEventsArgs = {
  haulerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHaulerComplianceDocumentsArgs = {
  haulerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHaulerDailyControlsArgs = {
  companyId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryHaulerDeviationsByReasonArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  fromDate: Scalars['Date']['input'];
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QueryHaulerFinvoiceReadinessArgs = {
  companyId: Scalars['ID']['input'];
  invoiceId: Scalars['ID']['input'];
};


export type QueryHaulerFleetPerformanceArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  fromDate: Scalars['Date']['input'];
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QueryHaulerFuelEmissionsArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  fromDate: Scalars['Date']['input'];
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QueryHaulerFuelSummaryArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  fromDate: Scalars['Date']['input'];
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QueryHaulerHolidayCollisionsArgs = {
  companyId: Scalars['ID']['input'];
  horizonDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHaulerInvoiceArgs = {
  companyId: Scalars['ID']['input'];
  invoiceId: Scalars['ID']['input'];
};


export type QueryHaulerInvoicePdfArgs = {
  companyId: Scalars['ID']['input'];
  invoiceId: Scalars['ID']['input'];
};


export type QueryHaulerInvoicesArgs = {
  companyId: Scalars['ID']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHaulerLoadSummaryArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  fromDate: Scalars['Date']['input'];
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QueryHaulerManualMeteredQuantitiesArgs = {
  areaId: Scalars['ID']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryHaulerOverviewKpisArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  fromDate: Scalars['Date']['input'];
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QueryHaulerPortalConversationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHaulerPriceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHaulerPriceEventsArgs = {
  haulerPriceId: Scalars['ID']['input'];
};


export type QueryHaulerPriceListRowsArgs = {
  companyId: Scalars['ID']['input'];
  priceListId: Scalars['ID']['input'];
};


export type QueryHaulerPriceListsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryHaulerPricePointPreviewArgs = {
  asOf?: InputMaybe<Scalars['Date']['input']>;
  companyId: Scalars['ID']['input'];
  containerTypeId?: InputMaybe<Scalars['Int']['input']>;
  customerType?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  pickupSettingId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['ID']['input'];
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  propertyTypeId?: InputMaybe<Scalars['Int']['input']>;
  serviceResponsibilityId?: InputMaybe<Scalars['Int']['input']>;
  wasteFractionId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHaulerPriceSuggestionArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  asOf?: InputMaybe<Scalars['Date']['input']>;
  companyId: Scalars['ID']['input'];
  service: Scalars['String']['input'];
  siteRef?: InputMaybe<Scalars['ID']['input']>;
  zoneRef?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHaulerReliabilityByAreaArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  fromDate: Scalars['Date']['input'];
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QueryHaulerRentalsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['ID']['input'];
};


export type QueryHaulerRoutePlanArgs = {
  budgetSeconds?: InputMaybe<Scalars['Float']['input']>;
  companyId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryHaulerRoutesForDateArgs = {
  companyId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
};


export type QueryHaulerSettlementByAreaArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryHaulerSettlementGroupsArgs = {
  haulerId?: InputMaybe<Scalars['ID']['input']>;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryHaulerSettlementPeriodsArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  haulerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHolidayImpactArgs = {
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  holidayDate: Scalars['Date']['input'];
  itemTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryHolidayWeekPreviewArgs = {
  planId: Scalars['ID']['input'];
  week: Scalars['Date']['input'];
};


export type QueryIdentityMapEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImportBatchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImportCaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImportFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImportFileTooltipsArgs = {
  importType: ImportTypes;
};


export type QueryImportHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImportIssueArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImportQualityReportArgs = {
  importBatchId: Scalars['ID']['input'];
};


export type QueryImportTemplateArgs = {
  fileFormat?: InputMaybe<ImportFormats>;
  importType: ImportTypes;
  includeExample?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryIndustryCodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInquiryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInquiryTypingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInsightsAnswerFeedbackArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInsightsAuditEventsArgs = {
  kind?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInsightsBenchmarkArgs = {
  cohort?: InputMaybe<Scalars['String']['input']>;
  metric: Scalars['String']['input'];
};


export type QueryInsightsBlendArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  dimension: Scalars['String']['input'];
  metricIds: Array<Scalars['String']['input']>;
};


export type QueryInsightsBuilderDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInsightsBuilderDashboardVersionsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInsightsCatalogArgs = {
  surface?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInsightsDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInsightsDashboardsArgs = {
  kind?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInsightsDatasetChoicesArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInsightsEntitiesArgs = {
  surface?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInsightsExplorationArgs = {
  token: Scalars['String']['input'];
};


export type QueryInsightsFieldValuesArgs = {
  entity: Scalars['String']['input'];
  field: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInsightsFilterValuesArgs = {
  field: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInsightsForecastArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  horizonDays?: InputMaybe<Scalars['Int']['input']>;
  metric: Scalars['String']['input'];
};


export type QueryInsightsPlanEntityArgs = {
  plan: PlanInput;
};


export type QueryInsightsPreviewActionArgs = {
  actionType: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['GenericScalar']['input']>;
};


export type QueryInsightsReplayAnswerArgs = {
  token: Scalars['String']['input'];
};


export type QueryInsightsReportDeliveriesArgs = {
  templateId: Scalars['ID']['input'];
};


export type QueryInsightsWhatifArgs = {
  changePct: Scalars['Float']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
  metric: Scalars['String']['input'];
};


export type QueryIntegrationGpsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIntegrationGpsVehicleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIntegrationUrbaserCallResponseHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIntegrationUrbaserCallResponseHistoryAgreementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIntegrationsUrbaserAgreementsSyncArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInternalAllCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInternalAllSalesOfferArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInternalAllSalesOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInternalAllSalesOffersFeaturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInternalAllUnconfirmedUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdUser_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInternalCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInternalUnconfirmedUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoiceItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIsDriverArgs = {
  driverId: Scalars['ID']['input'];
};


export type QueryKeyTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKmdEasyDeltaFilesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKmdEasyFileFu51007FileLineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKmdEasyFileFu51008FileLineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKmdEasyFileFu63302FileLineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKmdEasyFileFu63303FileLineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKmdEasyTotalFilesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLiveOperationsAdsReportArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryLiveOperationsAdsReportExportArgs = {
  excelFormat?: InputMaybe<Scalars['Boolean']['input']>;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryLiveOperationsDrivenRoutesReportArgs = {
  endDay: Scalars['Date']['input'];
  startDay: Scalars['Date']['input'];
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryLiveOperationsDrivenRoutesReportExportArgs = {
  endDay: Scalars['Date']['input'];
  excelFormat?: InputMaybe<Scalars['Boolean']['input']>;
  startDay: Scalars['Date']['input'];
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryLiveOperationsExceptionsArgs = {
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledDay: Scalars['Date']['input'];
};


export type QueryLiveOperationsGpsAccessAuditArgs = {
  accessType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLiveOperationsMonitoringRegisterExportArgs = {
  excelFormat?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLiveOperationsPositionsAsOfArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  asOf: Scalars['DateTime']['input'];
  scheduledDay: Scalars['Date']['input'];
};


export type QueryLiveOperationsRecordedPositionsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
  scheduledDay: Scalars['Date']['input'];
};


export type QueryLiveOperationsReplayTrackArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  fromTs?: InputMaybe<Scalars['DateTime']['input']>;
  maxPoints?: InputMaybe<Scalars['Int']['input']>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scheduledDay: Scalars['Date']['input'];
};


export type QueryLiveOperationsRouteStatesAsOfArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  asOf: Scalars['DateTime']['input'];
  scheduledDay: Scalars['Date']['input'];
};


export type QueryLiveOperationsSummaryArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  collectionCalendarIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIsnull?: InputMaybe<Scalars['Boolean']['input']>;
  containerPickupSettings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  drivers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scheduledDay: Scalars['Date']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  stopStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketAssigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketAssigneeTeams?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketCreatedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketIsnull?: InputMaybe<Scalars['Boolean']['input']>;
  ticketPriority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketReportedByPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  ticketReporterByDriver?: InputMaybe<Scalars['Boolean']['input']>;
  ticketRequestedByPortal?: InputMaybe<Scalars['Boolean']['input']>;
  ticketStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryLiveOpsCompatibleTargetsArgs = {
  routeId: Scalars['ID']['input'];
};


export type QueryLiveOpsProofBundleArgs = {
  stopId: Scalars['ID']['input'];
};


export type QueryLiveOpsProofOfServiceArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  propertyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLiveOpsReassignSuggestionArgs = {
  exceptionId: Scalars['ID']['input'];
};


export type QueryLiveOpsRecollectCandidatesArgs = {
  stopId: Scalars['ID']['input'];
};


export type QueryLiveOpsSlaCockpitArgs = {
  scheduledDay: Scalars['Date']['input'];
};


export type QueryLiveVehicleLocationsArgs = {
  routeId: Scalars['ID']['input'];
};


export type QueryLoadClassificationArgs = {
  ticketId: Scalars['ID']['input'];
};


export type QueryManagementCompanyPropertyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMasterDataSyncArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMaterializedRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMeasurementSettingsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMobileDeviceTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMunicipalityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyHaulerOrdersArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryNarrativeDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNavigationAppVersionArgs = {
  buildNumber: Scalars['Int']['input'];
};


export type QueryNearestScpsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  availability?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fraction?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyId: Scalars['ID']['input'];
  radiusKm?: InputMaybe<Scalars['Float']['input']>;
  scpType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOmniSearchArgs = {
  entityTypes?: InputMaybe<Array<OmniSearchEntityType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryOnboardingStatusArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryOperationManagementStatusesArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
};


export type QueryParameterSetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryParameterSetChangelogArgs = {
  planningAreaId: Scalars['ID']['input'];
};


export type QueryPasswordResetVerifyArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
  uidb64?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPermitsArgs = {
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<PermitStatus>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPhysicalKeyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPickupOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPickupOrderApprovalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPickupOrderApprovalCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPickupOrderHaulerTraceabilityArgs = {
  pickupOrderId: Scalars['ID']['input'];
};


export type QueryPickupSettingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlanCalendarDiffArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryPlanCalendarEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlanComparisonArgs = {
  baselineId?: InputMaybe<Scalars['ID']['input']>;
  planIds: Array<Scalars['ID']['input']>;
};


export type QueryPlanningAreaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlatformFleetLoadArgs = {
  planningAreaId: Scalars['ID']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPriceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPromotionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPropertyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPropertyContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPropertyEnvironmentalAccountArgs = {
  endDate: Scalars['Date']['input'];
  propertyId: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryPropertyEventLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPropertyGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPropertyManagementCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPropertyManagementCompanyMapArgs = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  contactTags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndustry?: InputMaybe<Scalars['Boolean']['input']>;
  hasPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  industries?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdExact?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPropertyMapArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  area_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  bbox: BBoxInput;
  company?: InputMaybe<Scalars['ID']['input']>;
  connectedToSewageNetwork?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludePropertyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRouteSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hasBlankAddress?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  invoiceSyncFrequency?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastViewedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  municipality?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  noRouteOnDay?: InputMaybe<Scalars['Date']['input']>;
  parentProperty?: InputMaybe<Scalars['ID']['input']>;
  ppContainerProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ppRecurringProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ppServiceProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  propertyContactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroup?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  registerBasis?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  registerBasisDrift?: InputMaybe<Scalars['Boolean']['input']>;
  rootOnly?: InputMaybe<Scalars['Boolean']['input']>;
  routeScheme_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchContact?: InputMaybe<Scalars['String']['input']>;
  searchContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  searchExternalPropertyNumber?: InputMaybe<Scalars['String']['input']>;
  searchLocation?: InputMaybe<Scalars['String']['input']>;
  searchOwner?: InputMaybe<Scalars['String']['input']>;
  sharedTank?: InputMaybe<Scalars['Boolean']['input']>;
  sludgeTankType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zone_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  zoomLevel: Scalars['Int']['input'];
};


export type QueryPropertyNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPropertyTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPropertyTypeToKmdEasyStationCodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPropertyUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPropertyWasteDecisionsArgs = {
  propertyId: Scalars['ID']['input'];
};


export type QueryPublicTransferDocumentArgs = {
  token: Scalars['String']['input'];
};


export type QueryPublicUnconfirmedUserArgs = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type QueryPurchaseOrdersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQuickExportArgs = {
  companyFilters?: InputMaybe<Scalars['GenericScalar']['input']>;
  contactFilters?: InputMaybe<Scalars['GenericScalar']['input']>;
  containerFilters?: InputMaybe<Scalars['GenericScalar']['input']>;
  exportType: ExportTypes;
  propertyFilters?: InputMaybe<Scalars['GenericScalar']['input']>;
  selectedIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryRealizedSavingsArgs = {
  promotionId: Scalars['ID']['input'];
};


export type QueryRecommendationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecommendationEconomicsArgs = {
  planningAreaId: Scalars['ID']['input'];
};


export type QueryRecommendationPrecisionArgs = {
  planningAreaId: Scalars['ID']['input'];
};


export type QueryRecordLeaseArgs = {
  entityId: Scalars['ID']['input'];
  entityType: RecordLeaseEntityType;
};


export type QueryRelocationContextArgs = {
  contactId: Scalars['ID']['input'];
};


export type QueryRentableStockLabelsArgs = {
  depotId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRentalsArgs = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  containerTypeId?: InputMaybe<Scalars['ID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  includeHistory?: InputMaybe<Scalars['Boolean']['input']>;
  managementCompanyId?: InputMaybe<Scalars['ID']['input']>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRentalsPageArgs = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  containerTypeId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  includeHistory?: InputMaybe<Scalars['Boolean']['input']>;
  managementCompanyId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  rentalStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryReservedBreakdownArgs = {
  itemTypeId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryResolveInsightsWidgetsArgs = {
  spec: WidgetSpecInput;
};


export type QueryRfidVehicleConnectionArgs = {
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRouteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRouteDeviationWarningArgs = {
  routeSchemeId: Scalars['ID']['input'];
  scheduledDate: Scalars['Date']['input'];
};


export type QueryRouteDriversGeojsonByIdArgs = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  maxPoints?: InputMaybe<Scalars['Int']['input']>;
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryRouteDriversGeojsonsArgs = {
  routeId: Scalars['ID']['input'];
};


export type QueryRouteDrivingEventsArgs = {
  routeId: Scalars['ID']['input'];
};


export type QueryRouteExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRouteGeojsonArgs = {
  fromOrderId?: InputMaybe<Scalars['String']['input']>;
  routeId: Scalars['ID']['input'];
  toOrderId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRouteProblemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRouteSchemeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRouteSchemeRouteCodesArgs = {
  container?: InputMaybe<Scalars['ID']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  property?: InputMaybe<Scalars['ID']['input']>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryRouteSchemeSuggestionsArgs = {
  container?: InputMaybe<Scalars['ID']['input']>;
  containers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  pickupSetting?: InputMaybe<Scalars['ID']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  property?: InputMaybe<Scalars['ID']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  wasteFractions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryRouteSchemeUnloadingStationsArgs = {
  routeSchemeId: Scalars['ID']['input'];
};


export type QueryRouteSettingsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRouteStopsByTagsArgs = {
  routeId: Scalars['ID']['input'];
  tagIds: Array<Scalars['String']['input']>;
};


export type QueryRouteStudioEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRouteUnloadingEventsArgs = {
  acknowledgementType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  approvalCollection?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionCalendarIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  completeApproval?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  container?: InputMaybe<Scalars['ID']['input']>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerPickupSettings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  container_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  container_PickupMethod?: InputMaybe<Scalars['String']['input']>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdInquiry?: InputMaybe<Scalars['ID']['input']>;
  createdInquiry_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdInquiry_Status?: InputMaybe<Scalars['String']['input']>;
  createdTicketsTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  depotIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeOrderTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalPropertyNumber?: InputMaybe<Scalars['String']['input']>;
  fillLevel_Gte?: InputMaybe<Scalars['Float']['input']>;
  fillLevel_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  fillLevel_Lte?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isUnloading?: InputMaybe<Scalars['Boolean']['input']>;
  isUnloadingPending?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lifecycleIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  noApproval?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderType_Icontains?: InputMaybe<Scalars['String']['input']>;
  pending?: InputMaybe<Scalars['Boolean']['input']>;
  pendingApproval?: InputMaybe<Scalars['Boolean']['input']>;
  propertyGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  route?: InputMaybe<Scalars['ID']['input']>;
  routeId: Scalars['ID']['input'];
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routeScheduledDayGte?: InputMaybe<Scalars['Date']['input']>;
  routeScheduledDayLte?: InputMaybe<Scalars['Date']['input']>;
  route_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stopStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketAssigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketAssigneeTeams?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketCreatedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketOrContainerIsnull?: InputMaybe<Scalars['Boolean']['input']>;
  ticketPriority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketReportedByPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  ticketReporterByDriver?: InputMaybe<Scalars['Boolean']['input']>;
  ticketRequestedByPortal?: InputMaybe<Scalars['Boolean']['input']>;
  ticketStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticket_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryRouteUnloadingStationsArgs = {
  routeId: Scalars['ID']['input'];
};


export type QueryRoutesGeojsonArgs = {
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryScenarioArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScheduledExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScheduledExportRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScpLedgerFeedArgs = {
  periodFrom: Scalars['Date']['input'];
  periodTo: Scalars['Date']['input'];
  scpId: Scalars['ID']['input'];
};


export type QueryScpLedgerFeedsArgs = {
  periodFrom: Scalars['Date']['input'];
  periodTo: Scalars['Date']['input'];
};


export type QueryScpMemberSummaryArgs = {
  scpId: Scalars['ID']['input'];
};


export type QueryScpMembersOutsideRadiusArgs = {
  municipalityId?: InputMaybe<Scalars['ID']['input']>;
  scpId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryScpMembershipArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScpMembershipCandidateCheckArgs = {
  propertyId: Scalars['ID']['input'];
  scpId: Scalars['ID']['input'];
  usageProfile?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScpMembershipEndPreviewArgs = {
  membershipId: Scalars['ID']['input'];
};


export type QueryScpNotificationDocumentArgs = {
  scpId: Scalars['ID']['input'];
};


export type QueryScpPropertyMoveOutPreviewArgs = {
  propertyId: Scalars['ID']['input'];
};


export type QueryScpRoleDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySensorizationBusinessCaseArgs = {
  scenarioId: Scalars['ID']['input'];
};


export type QueryServiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceResponsibilityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceUnitArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySettingsArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySiirtoCompanySettingsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySimToActualArgs = {
  planningAreaId: Scalars['ID']['input'];
  windowEnd?: InputMaybe<Scalars['Date']['input']>;
  windowStart?: InputMaybe<Scalars['Date']['input']>;
};


export type QuerySimulationJobArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySimulationsArgs = {
  automationId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySkipHireSetupStateArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  demo?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySkipHireSetupStepsArgs = {
  demo?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySkipsOnBoardArgs = {
  routeId: Scalars['ID']['input'];
};


export type QuerySourceMetricArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySparePartArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySqlDatasetArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySqlDatasetsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryStockAlertRecipientCandidatesArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryStopListFieldsOptionsArgs = {
  cardTypeConfig: CardConfigOptions;
};


export type QueryStopSetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStripeQuoteArgs = {
  id: Scalars['String']['input'];
};


export type QuerySvarutDispatchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTicketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTicketCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTicketCustomFieldArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTicketDraftArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTicketEventLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTicketMapArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  affectsPay?: InputMaybe<Scalars['Boolean']['input']>;
  allowedForRoute?: InputMaybe<Scalars['ID']['input']>;
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignedTeam?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignee?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  bbox: BBoxInput;
  company?: InputMaybe<Scalars['ID']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerBarcode?: InputMaybe<Scalars['String']['input']>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  createdByKinds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdBySearch?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['String']['input']>;
  excludeStatuses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeTicketTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isComplaint?: InputMaybe<Scalars['Boolean']['input']>;
  lastViewedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  managementCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  needToPairRfid?: InputMaybe<Scalars['Boolean']['input']>;
  needToScanBarcode?: InputMaybe<Scalars['Boolean']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  polygonSelection?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>>>>>;
  postalAreaSearch?: InputMaybe<Scalars['String']['input']>;
  postalCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['ID']['input']>;
  propertyContactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroup?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reportedByPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  reporter?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reporterByDriver?: InputMaybe<Scalars['Boolean']['input']>;
  reporterDriver?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  requestedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  requestedByPortal?: InputMaybe<Scalars['Boolean']['input']>;
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusCompletedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusCompletedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusInProgressAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusInProgressAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusOnHoldAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusOnHoldAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusOpenAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusOpenAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusPendingAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusPendingAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusRejectedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusRejectedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  syncJob?: InputMaybe<Scalars['Boolean']['input']>;
  ticketType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketTypeCategory?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketTypeService?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketTypeServiceServiceType?: InputMaybe<Scalars['String']['input']>;
  ticketType_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
  wasteFraction?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
  zoomLevel: Scalars['Int']['input'];
};


export type QueryTicketMessageTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTicketTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTicketTypeCountsArgs = {
  filterTicket?: InputMaybe<TicketDefFilterInput>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTransferDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransferDocumentForStopArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryTransferDocumentRequiredForStopArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryUpcomingCompanyHolidaysArgs = {
  horizonDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserAbsenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserFilterCollectionArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  selfId?: InputMaybe<Scalars['ID']['input']>;
  tableKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserIsActiveArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserJobNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserLayoutConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserNotificationsCounterArgs = {
  daysInThePast?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserProjectArgs = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryValidationVerdictArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVehicleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVehicleAbsenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVehicleSizeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVehicleTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVismaExportLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWarehouseAlertRecipientsArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseAvailabilityOnArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseBalancesArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseContainersArgs = {
  condition?: InputMaybe<Scalars['String']['input']>;
  itemTypeId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseMovementActorsArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseMovementsArgs = {
  actorId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  itemTypeId?: InputMaybe<Scalars['ID']['input']>;
  movementType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehousePlannedMovementsArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseRouteSchemeLinksArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseStoredContainersArgs = {
  condition?: InputMaybe<Scalars['String']['input']>;
  conditionTypeId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemTypeId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryWarehouseTransitSummaryArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryWashListArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWashListPrefillArgs = {
  areaId: Scalars['ID']['input'];
  ticketTypeId?: InputMaybe<Scalars['ID']['input']>;
  wasteFractionId: Scalars['ID']['input'];
};


export type QueryWashListsArgs = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWasteCollectorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWasteFractionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWasteTransferNoteArgs = {
  ticketId: Scalars['ID']['input'];
};


export type QueryZoneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryZoneContainmentPreviewArgs = {
  boundaryGeojson: Scalars['String']['input'];
  excludeZoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuickExportResult = {
  __typename: 'QuickExportResult';
  file: Scalars['String']['output'];
};

export type RfidVehicleConnectionDef = Node & {
  __typename: 'RFIDVehicleConnectionDef';
  communication: Scalars['String']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  enabled: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  ip: Scalars['String']['output'];
  password: Scalars['String']['output'];
  pathToFiles: Scalars['String']['output'];
  protocol: IntegrationsRfidVehicleConnectionProtocolChoices;
  provider: IntegrationsRfidVehicleConnectionProviderChoices;
  syncInterval: Scalars['Int']['output'];
  username: Scalars['String']['output'];
  vehicle: VehicleType;
};

export type RfidVehicleConnectionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  communication?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pathToFiles?: InputMaybe<Scalars['String']['input']>;
  protocol?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  syncInterval?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  vehicle: Scalars['ID']['input'];
};

export type RfidVehicleConnectionMutationPayload = {
  __typename: 'RFIDVehicleConnectionMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  rFIDVehicleConnection?: Maybe<RfidVehicleConnectionDef>;
  rfidVehicleConnection?: Maybe<RfidVehicleConnectionDef>;
};

/**
 * SOTA A5 — human-in-the-loop feedback on an analyst answer. Captures
 * a thumb up/down (+ optional note) so answer quality can be measured
 * and curated. Capture-only; scoped to the tenant + user.
 */
export type RateInsightsAnalystAnswer = {
  __typename: 'RateInsightsAnalystAnswer';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/**
 * Reactivate a terminated Shared Collection Point (QA-99 / D11).
 *
 * Founder ruling D11: reactivation of a terminated shared service IS
 * possible — the period end clears and the profile returns to ACTIVE.
 * Memberships and fee agreements are NOT auto-restored (history stays
 * ended; the operator re-adds members). Guards mirror terminateScp:
 * feature flag, company scoping, plus the pure-driver wall.
 */
export type ReactivateScp = {
  __typename: 'ReactivateSCP';
  scpProfile?: Maybe<ScpProfileDef>;
};

/**
 * Optional per-unit identity for a receive (PRO-391, 3.5.69): the
 * identical shape to ``ContainerImportIdentityInput`` plus a structured
 * condition. Assignable (not forced) at intake - a unit carrying one of
 * these becomes a serialized row immediately.
 */
export type ReceiveIdentityInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  conditionTypeId?: InputMaybe<Scalars['ID']['input']>;
  containerId?: InputMaybe<Scalars['String']['input']>;
  rfid?: InputMaybe<Scalars['String']['input']>;
  warrantyEnd?: InputMaybe<Scalars['Date']['input']>;
  warrantyStart?: InputMaybe<Scalars['Date']['input']>;
};

/** Book goods-in for (part of) a purchase order. */
export type ReceivePurchaseOrder = {
  __typename: 'ReceivePurchaseOrder';
  purchaseOrder?: Maybe<PurchaseOrderType>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Receive N spare parts into a warehouse (+N counted stock, A1). */
export type ReceiveSpareParts = {
  __typename: 'ReceiveSpareParts';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Quantity-based receive: creates an auto-completing receive
 * ticket whose completion writes +N on the count (ADR-0005). PRO-391
 * (3.5.69) lifts the "no identities" rule at intake: ``identities``
 * optionally carries per-unit identity for SOME of the received units,
 * which become serialized Container rows immediately; the remaining
 * quantity stays anonymous count, exactly as before. The ticket exists
 * for the audit trail, not as a workflow step (decided).
 */
export type ReceiveStock = {
  __typename: 'ReceiveStock';
  /**
   * How many serialized rows this receive materialized (PRO-391) — 0 for
   * a purely anonymous-quantity receive.
   */
  createdContainers?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  ticketId?: Maybe<Scalars['ID']['output']>;
};

/**
 * RS-1203 detector finding: evidence, impact and confidence are
 * the detector's recorded numbers (cost-substrate arithmetic, never
 * invented); ``default_on`` is the EV-RECS surface gate, resolved
 * from config at read time so a calibration flip applies to the
 * whole stream at once (08_UAT_EVALS: precision >= 0.7 before
 * default-on).
 */
export type RecommendationDef = Node & {
  __typename: 'RecommendationDef';
  actedAt?: Maybe<Scalars['DateTime']['output']>;
  actedBy?: Maybe<UserType>;
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** EV-RECS: True only when this detector has passed the precision gate and been flipped on in config; detectors emit regardless, surfaces default to gated streams. */
  defaultOn?: Maybe<Scalars['Boolean']['output']>;
  detector: Scalars['String']['output'];
  evidence?: Maybe<Scalars['GenericScalar']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  impact?: Maybe<Scalars['GenericScalar']['output']>;
  /** T1 (D67): the source currency of impact.eur_year, the cost model label the detector's arithmetic actually used, stamped at detection time. Null on money-less findings (a complaint card carries no money) and on rows raised before currency tagging; never a guessed or converted label. One admitted exception (D5 finding 7): R-06 sensor cases mix tenant-book lift savings with EUR-engineering-default sensor hardware; those rows carry impact.mixed_basis true and a planner-worded impact.basis_note naming the two substrates, and the label follows the savings substrate. */
  impactCurrency?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['GenericScalar']['output']>;
  planningArea: PlanningAreaDef;
  /** T12 (D73): the economics grouping key stamped at detection: cards sharing it claim the SAME money and the aggregate takes one bound per group, never a sum of overlaps. Null on money-less cards and rows raised before grouping (those ride as singletons). */
  rootCause?: Maybe<Scalars['String']['output']>;
  scenario?: Maybe<ScenarioDef>;
  state: RouteStudioRecommendationStateChoices;
  /** T12 (D73): the planner-worded subject of this card (recorded vehicle names, fraction names); the raw subject_ref is machinery, not a name. */
  subjectLabel?: Maybe<Scalars['String']['output']>;
  subjectRef: Scalars['String']['output'];
};

export type RecommendationDefConnection = {
  __typename: 'RecommendationDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RecommendationDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RecommendationDef` and its cursor. */
export type RecommendationDefEdge = {
  __typename: 'RecommendationDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RecommendationDef>;
};

/**
 * One contract area's payable within a period — the per-area breakdown
 * that locates a difference (read from the settlement report).
 */
export type ReconciliationAreaRowType = {
  __typename: 'ReconciliationAreaRowType';
  areaId?: Maybe<Scalars['ID']['output']>;
  areaName: Scalars['String']['output'];
  payableCents: Scalars['Int']['output'];
};

export type RecordActivityDef = {
  __typename: 'RecordActivityDef';
  at: Scalars['DateTime']['output'];
  explanation: Scalars['String']['output'];
  nodeKey?: Maybe<Scalars['String']['output']>;
  relation: Scalars['String']['output'];
  run?: Maybe<RunDef>;
  stageNo?: Maybe<Scalars['Int']['output']>;
};

/**
 * Wave 2 Lane E S5, the wizard's "check against your history" step:
 * run the whole-estate preview (`autopilotEstatePreview`'s exact
 * computation) AND persist one `SimulationRun` per candidate from the
 * very replays the preview ran -- one replay per flow, total (see
 * `autopilot.services.estate_migration.record_estate_simulations`).
 * A mutation, not a query, precisely because it writes the evidence
 * rows `ActivateConvertedFlows`' simulation gate checks; the read-only
 * `autopilotEstatePreview` query re-renders the same picture without
 * writing. Same caps as the query (candidates and window), same
 * `notCompared` honesty for ids that cannot be replayed (they get no
 * evidence row, so activating them later refuses instead of passing on
 * fake proof).
 */
export type RecordAutopilotEstateSimulations = {
  __typename: 'RecordAutopilotEstateSimulations';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  preview?: Maybe<AutopilotEstatePreviewType>;
  recorded: Array<AutopilotEstateSimulationRecordType>;
};

/**
 * Run a real AP-701 replay for a flow's CURRENT version and persist it
 * as a `SimulationRun` -- the product path to the evidence both the AP-703
 * activation gate (`gate_kind='simulation'`) and the Opportunity-Cost
 * Ledger (frontier #49) check. Closes the story-fidelity gap noted on
 * `ActivateAutopilotFlow`: until this mutation, `record_simulation_run`
 * was reachable only from Python, so no GraphQL caller could ever satisfy
 * the simulation gate (or price a parked flow) end-to-end.
 *
 * The replay itself is SIMULATE-mode-only by construction (see
 * `autopilot.runtime.replay`): no `FlowRun`/`StepRun` is ever created;
 * the one write is the `SimulationRun` row, attributed to the caller via
 * `ran_by`. `projectedHours` in the payload is priced by the gate's own
 * helper, so what this returns is exactly what the flow would promise at
 * go-live -- and exactly what the Opportunity-Cost row will now show.
 * Bounded window (1..365 days): a replay is corpus work, and an unbounded
 * caller-supplied window is a self-inflicted AP-702 perf incident.
 */
export type RecordAutopilotSimulation = {
  __typename: 'RecordAutopilotSimulation';
  corpusSize?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  firedCount?: Maybe<Scalars['Int']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  projectedHours?: Maybe<Scalars['Float']['output']>;
  simulationRunId?: Maybe<Scalars['ID']['output']>;
  windowDays?: Maybe<Scalars['Int']['output']>;
};

/**
 * Record the outcome of an inspection of the composter.
 *
 * One inspection per row: the columns are singular, so recording a second
 * overwrites the first. That matches the register's own shape — a renewal
 * starts a NEW row, and its inspection history begins empty.
 */
export type RecordCompostingInspection = {
  __typename: 'RecordCompostingInspection';
  compostingRegistryEntry?: Maybe<CompostingRegistryEntryDef>;
};

/**
 * Record one maintenance event on a container (PRO-213).
 *
 * Writes are gated exactly like a container edit
 * (``CompanyRolePermission.check_edit``): a user outside the container's
 * company is denied. ``next_due`` is optional — the value passed becomes
 * the container's current next-maintenance date (it is the latest event's
 * ``next_due``); recording a later event with ``next_due`` omitted clears
 * it.
 */
export type RecordContainerMaintenance = {
  __typename: 'RecordContainerMaintenance';
  container?: Maybe<ContainerType>;
  maintenanceEvent?: Maybe<ContainerMaintenanceType>;
};

/**
 * Record the customer picking the key up (AC2): completes the order
 * ticket, issuing the key.
 */
export type RecordKeyPickup = {
  __typename: 'RecordKeyPickup';
  physicalKey?: Maybe<PhysicalKeyType>;
};

export type RecordLeaseDef = {
  __typename: 'RecordLeaseDef';
  acquiredAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  holder?: Maybe<RecordLeaseHolderDef>;
  leaseId?: Maybe<Scalars['String']['output']>;
};

export enum RecordLeaseEntityType {
  AGREEMENT = 'AGREEMENT',
  AGREEMENT_TEMPLATE = 'AGREEMENT_TEMPLATE',
  BILLABLE_EVENT = 'BILLABLE_EVENT',
  TICKET = 'TICKET'
}

/**
 * A lease take-over in a record's unified event log (REQ 3.12.5,
 * plan B8): ``created_by`` displaced ``previous_holder`` on
 * (``entity_type``, ``entity_id``).
 */
export type RecordLeaseEventDef = Node & {
  __typename: 'RecordLeaseEventDef';
  action?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  previousHolder?: Maybe<UserType>;
};

export type RecordLeaseHolderDef = {
  __typename: 'RecordLeaseHolderDef';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RecordLinkDef = {
  __typename: 'RecordLinkDef';
  nodeKey: Scalars['String']['output'];
  relation: Scalars['String']['output'];
  stageNo: Scalars['Int']['output'];
  subjectId: Scalars['ID']['output'];
  subjectLabel?: Maybe<Scalars['String']['output']>;
  subjectLinkPath?: Maybe<Scalars['String']['output']>;
  subjectType: Scalars['String']['output'];
};

/**
 * Enter / update the manually entered purchase-invoice reference + total
 * for a (contractor, period) — PRO-468. Append-only: when the current row is
 * MATCHED (locked), a NEW correction row is created. Office-only + the
 * reconcile right (a read-only reporting role is refused).
 */
export type RecordPurchaseInvoice = {
  __typename: 'RecordPurchaseInvoice';
  reconciliation?: Maybe<PurchaseInvoiceReconciliationType>;
};

/**
 * Record a kimppailmoitus filing with the waste authority (NEXUS-681).
 *
 * Captures the SCP's current statutory snapshot at filing time so a later
 * "changes since last filing" check (``muutoksia ilmoitettavaksi``) can flag
 * drift. ``kind`` is the filing kind (NEW / CHANGE / TERMINATION);
 * ``authorityReference`` is optional — the diaarinumero often arrives after
 * the notification is filed.
 */
export type RecordScpNotificationFiling = {
  __typename: 'RecordScpNotificationFiling';
  record?: Maybe<ScpNotificationRecordDef>;
  state?: Maybe<ScpNotificationStateDef>;
};

/**
 * PRODUCT-523: record a collected skip's weight - the module
 * docstring's contract. ``rental`` / ``netKg`` / ``basis`` /
 * ``overageEvent`` describe the (first) skip; ``shares`` every skip of a
 * mixed load.
 */
export type RecordSkipWeight = {
  __typename: 'RecordSkipWeight';
  /** Billing basis carried onto the overage line: weighbridge / onboard_legal / estimate. */
  basis?: Maybe<Scalars['String']['output']>;
  netKg?: Maybe<Scalars['Float']['output']>;
  overageEvent?: Maybe<BillableEventDef>;
  rental?: Maybe<RentalRowType>;
  shares?: Maybe<Array<SkipWeightShareDef>>;
};

/**
 * One weighing. Exactly one of ``rentalTicketId`` / ``routeStopId`` /
 * ``containerId`` names the skip (a driver names the stop); or
 * ``rentalTicketIds`` names several skips tipped on ONE weighing (split
 * per the company's mixed-load setting). ``netKg`` wins over
 * ``grossKg - tareKg``; figures are in ``unit`` (kg | t | lb, default
 * kg).
 */
export type RecordSkipWeightInput = {
  /** The skip's ContainerType id (its current / last hire). */
  containerId?: InputMaybe<Scalars['ID']['input']>;
  /** Weigh-in: skip loaded, in `unit`. */
  grossKg?: InputMaybe<Scalars['Float']['input']>;
  /** When the scale measured (else: now). */
  measuredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Net load weight, in `unit`. */
  netKg?: InputMaybe<Scalars['Float']['input']>;
  /** A remark, noted on the rental's history. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The rental (RentalRowType.ticketId / TicketDef id). */
  rentalTicketId?: InputMaybe<Scalars['ID']['input']>;
  /** Several rentals weighed on ONE load weight (a mixed load): split equally to the kilogram, remainder on the first, when the company's setting is 'equal'; refused under 'per_skip'. */
  rentalTicketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The collection stop's PickUpOrderType id - what the driver app sends from the tipping stop; the rental is resolved from it. Beside rentalTicketId it names the stop the weight is written on. */
  routeStopId?: InputMaybe<Scalars['ID']['input']>;
  /** The bridge's slip / ticket number, when there is one. */
  slipNumber?: InputMaybe<Scalars['String']['input']>;
  source: SkipWeightSource;
  /** Weigh-out: skip empty, in `unit`. */
  tareKg?: InputMaybe<Scalars['Float']['input']>;
  /** kg | t | lb. Defaults to kg. */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Vendor key of the weighing system ('mscales', ...). */
  weighingSystem?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One recorded position on a route: where a task was confirmed, a
 * deviation reported or a load unloaded (HSY req 34). Explains a ROUTE,
 * never a person — deliberately no driver field; the stop node is
 * reachable through ``stopId`` for anyone with the rights to read it.
 */
export type RecordedPositionEventDef = {
  __typename: 'RecordedPositionEventDef';
  /** Reported fix accuracy, metres. */
  accuracyM?: Maybe<Scalars['Float']['output']>;
  deviationReason?: Maybe<Scalars['String']['output']>;
  /** Distance from the container at confirmation, metres. */
  distanceM?: Maybe<Scalars['Float']['output']>;
  /** Where the distance figure came from (breadcrumb/client). */
  distanceSource?: Maybe<Scalars['String']['output']>;
  eventType: RecordedPositionEventTypeEnum;
  /** When the device took the fix; null when not reported. */
  fixCapturedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Container id, or the station name for an unloading. */
  label?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  /** TruckloadType relay id, when the stop entered a load. */
  loadId?: Maybe<Scalars['ID']['output']>;
  longitude: Scalars['Float']['output'];
  /** When the event was confirmed (server time). */
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  routeId?: Maybe<Scalars['ID']['output']>;
  /** PickUpOrderType relay id, if a stop. */
  stopId?: Maybe<Scalars['ID']['output']>;
  stopNumber?: Maybe<Scalars['Int']['output']>;
  /** TicketDef relay id, if a ticket. */
  ticketId?: Maybe<Scalars['ID']['output']>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

/**
 * COMPASS-1188 / HSY req 34: what a recorded position is the position
 * OF. Vocabulary owned by ``routes.selectors.recorded_positions``.
 */
export enum RecordedPositionEventTypeEnum {
  CONFIRMATION = 'CONFIRMATION',
  DEVIATION = 'DEVIATION',
  UNLOADING = 'UNLOADING'
}

/**
 * What applying a property's new billing cadence to its recurring fees
 * did, right away (COMPASS-1697 / PR #2177): how many open charges of the
 * old cadence were retracted or shortened, how many charges of the new
 * cadence were created, and — when an already-invoiced finer charge
 * (e.g. a monthly one) freezes the new coarser cadence — the last day of
 * that frozen period; the old cadence keeps billing until then.
 */
export type RecurringFeeCadenceTransitionDef = {
  __typename: 'RecurringFeeCadenceTransitionDef';
  /** Charges created under the new cadence. */
  created: Scalars['Int']['output'];
  /** Agreements whose fee pass raised and were skipped; the schedule change itself is saved and the nightly recurring-fee run retries them. */
  failed: Scalars['Int']['output'];
  /** Last day of a period the new (coarser) cadence cannot bill yet because a finer charge inside it is already invoiced; the finer cadence keeps billing until then. Null when nothing is frozen. */
  frozenUntil?: Maybe<Scalars['Date']['output']>;
  /** Last day already covered by invoiced charges when the new (finer) cadence therefore has nothing to bill in the current period; the new cadence starts the day after. Null otherwise. */
  invoicedUntil?: Maybe<Scalars['Date']['output']>;
  /** Existing charges of the new cadence brought in step. */
  reconciled: Scalars['Int']['output'];
  /** Open charges of the previous cadence retracted or shortened because the new cadence now bills their days. */
  retracted: Scalars['Int']['output'];
  /** 1 when the company has no active billing frequency matching the new cadence: the cadence is stored but no schedule or fee was touched, so billing stays on the previous cadence until one is seeded. 0 otherwise. */
  skippedNoBillingFrequency: Scalars['Int']['output'];
};

export type RecurringPriceDef = Node & {
  __typename: 'RecurringPriceDef';
  amount: Scalars['Int']['output'];
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['Date']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  invoiceName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  propertyType?: Maybe<PropertyTypeDef>;
  recurringInterval: Scalars['Int']['output'];
  startDate: Scalars['Date']['output'];
};

export type RecurringPriceDefConnection = {
  __typename: 'RecurringPriceDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RecurringPriceDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RecurringPriceDef` and its cursor. */
export type RecurringPriceDefEdge = {
  __typename: 'RecurringPriceDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RecurringPriceDef>;
};

/**
 * Office-only: manual re-date for exactly one row, overriding the
 * policy outcome for that row only (audit-logged via
 * ``HolidayShiftDecision``). Validations (target not a holiday,
 * within the allowed window, no eligible target route) are enforced
 * server-side and come back as an honest ``errors`` entry rather than
 * a raised exception — this is a business refusal, not a client bug.
 */
export type RedateHolidayImpactRow = {
  __typename: 'RedateHolidayImpactRow';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  row?: Maybe<HolidayImpactRowDef>;
};

export type Refresh = {
  __typename: 'Refresh';
  payload?: Maybe<PayloadType>;
  refreshExpiresIn: Scalars['Int']['output'];
  token: Scalars['String']['output'];
};

/**
 * Recompute the caller's company due list now.
 *
 * The due list is a persisted cache rebuilt by a nightly beat, which is the
 * right design at PJH volumes but leaves the screen stale whenever something
 * moves a schedule outside the write paths that keep it in step (a data
 * import, a backdated agreement, a migration). This is the operator's way to
 * say "make it right now" without a Django shell.
 *
 * It is deliberately CHEAP TO REFUSE: the service throttles on the
 * ``last_computed`` watermark and takes a NOWAIT row lock, so a held-down
 * button costs one SELECT, never a queue of company-wide recomputes.
 * ``status`` says which of the three things happened.
 */
export type RefreshBillingDueListMutation = {
  __typename: 'RefreshBillingDueListMutation';
  /** Due rows after the recompute; null when it did not run. */
  dueCount?: Maybe<Scalars['Int']['output']>;
  /** The due list's watermark after this call. */
  lastComputed?: Maybe<Scalars['DateTime']['output']>;
  /** True only when this call actually recomputed. */
  refreshed?: Maybe<Scalars['Boolean']['output']>;
  /** Seconds until a refresh would do work again. */
  retryAfterSeconds?: Maybe<Scalars['Int']['output']>;
  /** refreshed | throttled | already_running — 'throttled' and 'already_running' both mean the list you have is current enough and no work was redone. */
  status?: Maybe<Scalars['String']['output']>;
};

export type RefuseToken = {
  __typename: 'RefuseToken';
  token?: Maybe<Scalars['String']['output']>;
};

export type RegisterFcmDeviceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Unique device identifier */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  registrationId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type RegisterFcmDevicePayload = {
  __typename: 'RegisterFCMDevicePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  fCMDevice?: Maybe<FcmDeviceType>;
  fcmDevice?: Maybe<FcmDeviceType>;
};

/**
 * Count-based completion (FIXIT2-O2, NID REQ-091): record that N
 * of the line's M units are done. 20 of 35 recorded leaves 15 open —
 * the rollup reads IN_PROGRESS and the order refuses to close until
 * the count reaches the ordered quantity. A single-unit line takes
 * "1 of 1" — the office's "work done" action for a line that never
 * materialized a ticket (G2S2-O1, RD-33). Same gate as every
 * hauler-mode surface.
 */
export type RegisterHaulerLineCompletedCount = {
  __typename: 'RegisterHaulerLineCompletedCount';
  completedCount?: Maybe<Scalars['Decimal']['output']>;
  lineId?: Maybe<Scalars['ID']['output']>;
  order?: Maybe<HaulerOrderDef>;
};

/**
 * Record the scale weight for one weight-sold line (S4-O2,
 * HAUL-419 capture path). Makes the PENDING reason "no weight was
 * recorded" actionable: register the slip's weight, then retry
 * ``markHaulerOrderCompleted`` — the existing paper gate reads it.
 */
export type RegisterHaulerLineWeight = {
  __typename: 'RegisterHaulerLineWeight';
  /** What (if anything) STILL holds the order after this weight landed — empty means a retry of 'mark completed' will go through the paper gate. */
  missingPaper?: Maybe<Array<Scalars['String']['output']>>;
  order?: Maybe<HaulerOrderDef>;
};

/**
 * Register a payment received OUTSIDE the platform (bank transfer,
 * MobilePay, cash) against a SENT invoice — the S1-M5 service on the
 * wire. Partial payments accumulate; over-payment is a loud error; the
 * invoice flips PAID exactly when covered.
 */
export type RegisterInvoicePayment = {
  __typename: 'RegisterInvoicePayment';
  invoice?: Maybe<HaulerInvoiceDef>;
  payment?: Maybe<HaulerInvoicePaymentDef>;
};

/** One Action Registry row. Read-only: no resolver here ever writes. */
export type RegisteredActionType = {
  __typename: 'RegisteredActionType';
  /** Autonomy class; the dial (A-D6) applies per class. */
  actionClass: AutopilotRegisteredActionActionClassChoices;
  /** False when the contract no longer declares this key. Set by autopilot_registry_sync; rows are never deleted. */
  active: Scalars['Boolean']['output'];
  /** Money actions are always approval-required (A-D10). */
  approvalRequired: Scalars['Boolean']['output'];
  /** True when this build carries a real execution binding for the key — computed live from the same EXECUTION_BINDINGS dispatch table execute_action() uses, never stored, so it cannot drift (W5-V slice 4). False means simulate-only: mode="execute" refuses with ExecutionNotImplementedError. The FE builder should read this instead of hardcoding a connected set (actionCatalog.ts CONNECTED_ACTIONS debt). */
  executionBound?: Maybe<Scalars['Boolean']['output']>;
  /** Contract action id, e.g. 'ticket.create' (domain.action). */
  key: Scalars['String']['output'];
  requiredInputs?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * Office-only (PRO-118): reverse an exclusion; attaches the agreement
 * right away unless ``attach: false``. Change-logged.
 */
export type ReincludeAreaAgreement = {
  __typename: 'ReincludeAreaAgreement';
  area?: Maybe<AreaDef>;
  attached: Scalars['Boolean']['output'];
};

/**
 * Reject a customer request with a reason the requester reads in the
 * portal thread (PRODUCT-484).
 */
export type RejectCustomerRequest = {
  __typename: 'RejectCustomerRequest';
  ticket?: Maybe<TicketDef>;
};

export type RejectTicketBatch = {
  __typename: 'RejectTicketBatch';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/**
 * A declared relation of the dataset joined to a plan
 * (plan_schema.RelationJoin).
 */
export type RelationJoinInput = {
  alias: Scalars['String']['input'];
  relation: Scalars['String']['input'];
};

/**
 * One budgeted relaxation probe (RS-603). ``status`` is exposed
 * as the frozen plan_json ``explain.probes[].status`` enum values
 * (queued/running/done/failed), not an uppercased GraphQL enum, so
 * the UI and the Copilot see the contract vocabulary.
 */
export type RelaxationProbeDef = Node & {
  __typename: 'RelaxationProbeDef';
  createdAt: Scalars['DateTime']['output'];
  /** T1 (D67), tri-state per D5 finding 2: the recorded source currency of headline_delta_eur_year and the relaxed KPI money, the book the probe re-solve was scored with (result.relaxed_kpis.currency, stamped at run time). Null with currencyMismatch false when the probe recorded no label (unrecorded; render the money currency unstated, never the plan's own label). Null with currencyMismatch true on a provable plan-vs-probe book conflict (the headline is suppressed too). Never converted. */
  currency?: Maybe<Scalars['String']['output']>;
  /** D5 (adversarial-review-D4 finding 2, D67): True when the plan's scored currency and the probe result's recorded currency PROVABLY differ (a book change between solve and probe). headlineDeltaEurYear serves null in that state: a delta between two currencies is not a number, exactly the scoring and comparison refusal. False when either label is missing (absence of proof is not proof of disagreement). */
  currencyMismatch?: Maybe<Scalars['Boolean']['output']>;
  errorMessage: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  headlineDeltaEurYear?: Maybe<Scalars['Float']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  plan: PlanDef;
  relax: Scalars['String']['output'];
  requestedBy?: Maybe<UserType>;
  result: Scalars['JSONString']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Frozen probe status: queued, running, done or failed; queued/running are the estimate-pending states. */
  status?: Maybe<Scalars['String']['output']>;
};

export type RelaxationProbeDefConnection = {
  __typename: 'RelaxationProbeDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RelaxationProbeDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RelaxationProbeDef` and its cursor. */
export type RelaxationProbeDefEdge = {
  __typename: 'RelaxationProbeDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RelaxationProbeDef>;
};

/**
 * Release on save/cancel/exit. Expired or already-taken-over leases
 * release as a no-op (``expired`` / ``lost``), never an error.
 */
export type ReleaseRecordLease = {
  __typename: 'ReleaseRecordLease';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * One eligible stop in the reliability breakdown (D6 transparency).
 *
 * ``excluded`` events stay visible here, flagged, even though they leave the
 * reliability denominator; ``classification`` is on_time / late / missed.
 */
export type ReliabilityEventType = {
  __typename: 'ReliabilityEventType';
  /** on_time | late | missed | pending (not yet due) */
  classification: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  excluded: Scalars['Boolean']['output'];
  exclusionReason?: Maybe<Scalars['String']['output']>;
  /** HSY 263: WHY the event is excluded — manual (a per-stop exclusion the office can re-include) | exception_type (a PRO-467 excused exception type) | window (a period-scoped reliability exclusion window). Null when not excluded. */
  exclusionSource?: Maybe<Scalars['String']['output']>;
  /** The excusing window's id when exclusionSource is window. */
  exclusionWindowId?: Maybe<Scalars['ID']['output']>;
  pickupOrder?: Maybe<PickUpOrderType>;
  /** The planned collection day (holiday-shifted already). */
  scheduledDay?: Maybe<Scalars['Date']['output']>;
};

export type ReliabilityExclusionType = Node & {
  __typename: 'ReliabilityExclusionType';
  excludedAt: Scalars['DateTime']['output'];
  excludedBy?: Maybe<UserType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  pickupOrder: PickUpOrderType;
  reason: Scalars['String']['output'];
};

export type ReliabilityExclusionTypeConnection = {
  __typename: 'ReliabilityExclusionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReliabilityExclusionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReliabilityExclusionType` and its cursor. */
export type ReliabilityExclusionTypeEdge = {
  __typename: 'ReliabilityExclusionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReliabilityExclusionType>;
};

/** One period-scoped reliability exclusion window (HSY 263). */
export type ReliabilityExclusionWindowType = Node & {
  __typename: 'ReliabilityExclusionWindowType';
  /** Cover every contract area of the company; when false the explicit areas set applies. */
  allAreas: Scalars['Boolean']['output'];
  /** Covered contract areas; empty when allAreas is true. */
  areas: Array<AreaDef>;
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  dateFrom: Scalars['Date']['output'];
  /** Inclusive last day of the window. */
  dateTo: Scalars['Date']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Mandatory audit reason. */
  reason: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** One active origin service with the FE's default-logistics signal. */
export type RelocationAgreementContextDef = {
  __typename: 'RelocationAgreementContextDef';
  agreement: AgreementDef;
  /** device Container.ownership of the agreement's container ('company'/'customer'; empty when unrecorded, null when the agreement has no container). Customer-owned containers default the wizard to 'move_with_customer'. */
  containerOwnership?: Maybe<Scalars['String']['output']>;
};

/** Wizard step 1: the contact's current occupancy + services. */
export type RelocationContextDef = {
  __typename: 'RelocationContextDef';
  contact: ContactDef;
  properties: Array<RelocationPropertyContextDef>;
};

/** One reported relocation (crm.Relocation) — the wizard's receipt. */
export type RelocationDef = Node & {
  __typename: 'RelocationDef';
  containerLogistics: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  movingDate: Scalars['Date']['output'];
  reference: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
};

export type RelocationDefConnection = {
  __typename: 'RelocationDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RelocationDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RelocationDef` and its cursor. */
export type RelocationDefEdge = {
  __typename: 'RelocationDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RelocationDef>;
};

/**
 * One destination service (wizard step 3), echoing the dims of the
 * ``destinationServiceProposal`` entry it came from.
 */
export type RelocationDestinationServiceInput = {
  /** Legacy crm.Product id, for non-P&P tenants. */
  containerProductId?: InputMaybe<Scalars['ID']['input']>;
  containerTypeId: Scalars['ID']['input'];
  pickupSettingId: Scalars['ID']['input'];
  /** P&P catalog product id (raw ULID or global id). */
  ppProductId?: InputMaybe<Scalars['ID']['input']>;
  wasteFractionIds: Array<Scalars['ID']['input']>;
};

/**
 * Inline destination-property create (wizard step 2) — the existing
 * ``PropertyForm`` path, exactly like ``UpdateOrCreateProperty``.
 */
export type RelocationNewPropertyInput = {
  /** Register identity (KT/PRT). Leave empty when the register does not know the property yet — the property is then flagged awaiting_register_sync for the register-lag merge. */
  externalPropertyNumber?: InputMaybe<Scalars['String']['input']>;
  location: LocationInput;
  note?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['ID']['input'];
};

/**
 * One product resolvable at the destination for an origin service
 * (the product-options core's candidate shape).
 */
export type RelocationProductCandidateDef = {
  __typename: 'RelocationProductCandidateDef';
  id: Scalars['String']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  productName: Scalars['String']['output'];
  weight?: Maybe<Scalars['Decimal']['output']>;
};

/** One property the contact actively occupies, with its services. */
export type RelocationPropertyContextDef = {
  __typename: 'RelocationPropertyContextDef';
  agreements: Array<RelocationAgreementContextDef>;
  property: PropertyDef;
  /** The contact's active occupancy roles on the property. */
  roles: Array<Scalars['String']['output']>;
};

/**
 * One customer-data change taking effect on the moving date (routed
 * through the Part A scheduling engine).
 */
export type RelocationScheduledChangeInput = {
  fieldKey: Scalars['String']['input'];
  newValue?: InputMaybe<Scalars['GenericScalar']['input']>;
};

/**
 * Wizard step 3: origin services offered at the destination. An
 * origin fraction with zero candidate products at the destination's
 * property type is absent.
 */
export type RelocationServiceProposalDef = {
  __typename: 'RelocationServiceProposalDef';
  services: Array<RelocationServiceProposalEntryDef>;
};

/**
 * One origin service that IS offered at the destination, with the
 * operational dims the wizard echoes back into
 * ``reportRelocation.destinationServices``.
 */
export type RelocationServiceProposalEntryDef = {
  __typename: 'RelocationServiceProposalEntryDef';
  agreement: AgreementDef;
  candidates: Array<RelocationProductCandidateDef>;
  containerTypeId: Scalars['Int']['output'];
  pickupSettingId: Scalars['Int']['output'];
  wasteFractionIds: Array<Scalars['Int']['output']>;
};

export type RemoveAssociatedTicketsFromCompanyEmailAccountMessage = {
  __typename: 'RemoveAssociatedTicketsFromCompanyEmailAccountMessage';
  companyEmailAccountMessage?: Maybe<CompanyEmailAccountMessageDef>;
};

/**
 * Office-only (B1.3): soft-delete one CUSTOM day. National rows
 * are never reachable here — there is no id-space for them on this
 * mutation, so "national not deletable" needs no separate check.
 */
export type RemoveCompanyHolidayDay = {
  __typename: 'RemoveCompanyHolidayDay';
  ok: Scalars['Boolean']['output'];
};

export type RemoveCustomerFunctionFromContact = {
  __typename: 'RemoveCustomerFunctionFromContact';
  contact?: Maybe<ContactDef>;
};

/**
 * Office-only, audited: re-include an event (soft-deletes the active
 * exclusion, keeping the audit trail). ``removed`` is False when there was
 * no active exclusion.
 */
export type RemoveReliabilityExclusion = {
  __typename: 'RemoveReliabilityExclusion';
  pickupOrder?: Maybe<PickUpOrderType>;
  removed: Scalars['Boolean']['output'];
};

/** Unlink a route scheme from its warehouse. Idempotent. */
export type RemoveRouteSchemeWarehouseLink = {
  __typename: 'RemoveRouteSchemeWarehouseLink';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Office-only, audited (R2-S12): soft-remove a manual adjustment line
 * while its period is still OPEN. The row survives (deleted/deleted_by)
 * for the audit trail; a closed period's adjustments are locked.
 */
export type RemoveSettlementAdjustment = {
  __typename: 'RemoveSettlementAdjustment';
  ok: Scalars['Boolean']['output'];
  report?: Maybe<SettlementReportType>;
};

export type RentableStockLabelDef = {
  __typename: 'RentableStockLabelDef';
  /** The unit's barcode, when it carries one - a scan of it names the same unit as the label. */
  barcode?: Maybe<Scalars['String']['output']>;
  /** ContainerType relay id. */
  containerTypeId: Scalars['ID']['output'];
  containerTypeName: Scalars['String']['output'];
  depotName?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  /** The unit's RFID tag, when set. */
  rfid?: Maybe<Scalars['String']['output']>;
};

/**
 * The office rental risk board (PRO-271): units overdue to dispatch,
 * units overdue back, and over-committed pools. All read-only, derived
 * from the open rental tickets and the ledger.
 */
export type RentalAtRiskReportType = {
  __typename: 'RentalAtRiskReportType';
  overdueDispatch: Array<RentalOverdueRowType>;
  overdueReturn: Array<RentalOverdueRowType>;
  poolShortfalls: Array<RentalPoolShortfallRowType>;
};

/**
 * One item type's projected free units at a warehouse on a date
 * (PRO-271). ``projected`` credits dispatched units due back inside the
 * window - the quoting view; ``strict`` is the booking gate's own view
 * that never trusts a projected return. Both come from
 * ``inventory.selectors.projection.available_on`` (the flag).
 */
export type RentalAvailabilityRowType = {
  __typename: 'RentalAvailabilityRowType';
  containerTypeId: Scalars['ID']['output'];
  itemTypeName?: Maybe<Scalars['String']['output']>;
  projected: Scalars['Int']['output'];
  strict: Scalars['Int']['output'];
};

/**
 * An overdue rental unit: committed-but-not-dispatched past its start
 * (overdue to send out) or dispatched-but-not-returned past its end
 * (overdue back). Visibility only - the ledger never auto-resolves it.
 */
export type RentalOverdueRowType = {
  __typename: 'RentalOverdueRowType';
  daysOverdue: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  itemTypeName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  ticketId: Scalars['ID']['output'];
  warehouseId?: Maybe<Scalars['ID']['output']>;
  warehouseName?: Maybe<Scalars['String']['output']>;
};

/**
 * A (warehouse, item type, date) window where a rental pool has
 * committed out more units than it can cover - STRICT availability is
 * negative. ``shortfall`` is how many units short on that date.
 */
export type RentalPoolShortfallRowType = {
  __typename: 'RentalPoolShortfallRowType';
  containerTypeId: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  itemTypeName?: Maybe<Scalars['String']['output']>;
  shortfall: Scalars['Int']['output'];
  warehouseId: Scalars['ID']['output'];
  warehouseName?: Maybe<Scalars['String']['output']>;
};

/**
 * PRODUCT-473 (skip hire, BE-P2-3): the payload of a "Relocate to
 * another address" ticket, read through ``TicketDef.rentalRelocation``.
 *
 * The relocate ticket and its MOVE stop sit at the skip's CURRENT
 * address (``fromProperty`` - the pickup point, what the stop geolocates
 * to); ``targetProperty`` is where the driver takes it - the destination
 * is also stamped on the ticket's ``routeDescription``. ``moveOrder`` is
 * the one MOVE route leg (unrouted until the office plans it; null once
 * the stop row is gone). ``completedAt`` = the hire has moved;
 * ``cancelledAt`` = the office rejected the ticket before the move and
 * the leg was released; ``isOpen`` = neither.
 */
export type RentalRelocationDef = {
  __typename: 'RentalRelocationDef';
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  container: ContainerType;
  created: Scalars['DateTime']['output'];
  fromProperty: PropertyDef;
  id: Scalars['ID']['output'];
  /** Neither completed nor cancelled - still to be driven */
  isOpen: Scalars['Boolean']['output'];
  moveOrder?: Maybe<PickUpOrderType>;
  rentalTicket: TicketDef;
  targetProperty: PropertyDef;
  ticket: TicketDef;
};

/**
 * PRODUCT-452 (BE-E1): the derived lifecycle status of one rental
 * unit in the office list - from the ticket status, the ISSUE/RETURN
 * ledger rows, route-stop membership and the period end
 * (``inventory.selectors.rentals.derive_rental_status``). Never null.
 *
 * BOOKED = open, not issued, no planned route stop; ON_ROUTE = the
 * delivery sits on a planned route stop, not issued; ON_HIRE = issued,
 * not returned, period end today or later (or a sale); OVERDUE =
 * issued, not returned, period end passed; RETURNED = returned or
 * completed; CANCELLED = rejected (only reachable with
 * ``includeHistory``).
 */
export enum RentalRowStatus {
  BOOKED = 'BOOKED',
  CANCELLED = 'CANCELLED',
  ON_HIRE = 'ON_HIRE',
  ON_ROUTE = 'ON_ROUTE',
  OVERDUE = 'OVERDUE',
  RETURNED = 'RETURNED'
}

/**
 * One rental unit in the office list (PRO-278): a RENT_STOCK ticket,
 * row-per-unit. ``issued_container_id`` is the dispatched unit (null
 * until issued - the Issue affordance); once a fixed-term unit is out
 * it is the Return affordance's target, and ``returned_container_id``
 * fills in when it is brought back. Both are relay ``ContainerType``
 * node gids (the physical-container convention, matching the
 * issue/return mutations).
 *
 * PRODUCT-452 (BE-E1): ``rental_status`` is the derived lifecycle
 * status (:class:`RentalRowStatus`, never null); ``next_collection_date``
 * the dispatched unit's next planned collection, today or later (its
 * pickup setting / calendar planning, else the next open collection
 * ticket on it) - only while the unit is actually out (ON_HIRE /
 * OVERDUE), so a RETURNED row never shows the collection of the hire
 * its skip has since gone out on, and an OVERDUE unit whose pickup is
 * still dated in the past reads null until it is re-planned;
 * ``ticket`` the rental ticket the row is built from, so the delivery
 * address, payer, item type, fraction(s) and pickup setting are read
 * THROUGH it rather than duplicated here; ``issued_container`` the
 * dispatched physical unit itself (the skip identity column).
 */
export type RentalRowType = {
  __typename: 'RentalRowType';
  endDate?: Maybe<Scalars['Date']['output']>;
  expectedLoadKg?: Maybe<Scalars['Int']['output']>;
  issuedContainer?: Maybe<ContainerType>;
  issuedContainerId?: Maybe<Scalars['ID']['output']>;
  itemTypeName?: Maybe<Scalars['String']['output']>;
  nextCollectionDate?: Maybe<Scalars['Date']['output']>;
  payloadWarning: Scalars['Boolean']['output'];
  permit?: Maybe<PermitSummaryType>;
  rentalStatus: RentalRowStatus;
  returnedContainerId?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  ticket: TicketDef;
  ticketId: Scalars['ID']['output'];
  warehouseId?: Maybe<Scalars['ID']['output']>;
  warehouseName?: Maybe<Scalars['String']['output']>;
  weightBasis?: Maybe<Scalars['String']['output']>;
  weightNetKg?: Maybe<Scalars['Float']['output']>;
  weightRecordedAt?: Maybe<Scalars['DateTime']['output']>;
  weightSource?: Maybe<Scalars['String']['output']>;
};

/**
 * One rented unit's own delivery / return window inside a booking
 * (PRODUCT-448). Either date may be omitted to inherit the order-level
 * ``periodStartDate`` / ``periodEndDate``; a unit's return may never
 * precede its delivery.
 */
export type RentalUnitInput = {
  /** Return date of this unit; defaults to the order's periodEndDate. */
  periodEndDate?: InputMaybe<Scalars['Date']['input']>;
  /** Delivery date of this unit; defaults to the order's periodStartDate. */
  periodStartDate?: InputMaybe<Scalars['Date']['input']>;
};

/** PRO-1013: one page of the office rentals list. */
export type RentalsPageType = {
  __typename: 'RentalsPageType';
  rows: Array<RentalRowType>;
  totalCount: Scalars['Int']['output'];
};

/** Office-only, audited: reopen a closed period for live recompute (D9). */
export type ReopenSettlementPeriod = {
  __typename: 'ReopenSettlementPeriod';
  period?: Maybe<SettlementPeriodType>;
};

export type ReopenTransferDocument = {
  __typename: 'ReopenTransferDocument';
  transferDocument?: Maybe<TransferDocumentType>;
};

/**
 * Replace a lost key (AC4): orders a fresh key of the same type for the
 * same customer via a KEY_REPLACE ticket. Returns the new key.
 */
export type ReplaceKey = {
  __typename: 'ReplaceKey';
  physicalKey?: Maybe<PhysicalKeyType>;
  ticketId?: Maybe<Scalars['ID']['output']>;
};

/**
 * A company operator replies to a general citizen<->company conversation.
 *
 * The company-scoped mirror of ``ReplyToHaulerPortalConversation``. Server-
 * enforced isolation: the conversation is fetched through the SAME company +
 * general-thread (``hauler IS NULL`` AND ``ticket IS NULL``) filter as the read
 * side, so an operator replying to another company's conversation — or to a
 * hauler/ticket-bridged thread — gets the clean "not found" denial, never a
 * write onto a foreign thread. The reply is an outbound-to-citizen CEAM
 * attributed as the company (``author='company'``) and pings the citizen via
 * ``dispatch_portal_new_message``. Gated on ``crm_enable_messaging``.
 */
export type ReplyToCompanyPortalConversation = {
  __typename: 'ReplyToCompanyPortalConversation';
  conversation?: Maybe<PortalConversationDef>;
  message?: Maybe<PortalConversationMessageDef>;
};

/**
 * PRO-1012: write to the requester WITHOUT deciding the request - a
 * question, a heads-up. The message lands on the thread the portal shows
 * and is e-mailed to the requester; the request stays open.
 */
export type ReplyToCustomerRequest = {
  __typename: 'ReplyToCustomerRequest';
  message?: Maybe<TicketMessageDef>;
  ticket?: Maybe<TicketDef>;
};

/**
 * A hauler user replies to a citizen->hauler portal conversation (D3/D4).
 *
 * Server-enforced isolation: the conversation is fetched through the SAME
 * company + ``apply_hauler_scope`` filter as the read side, so a contractor
 * replying to another hauler's conversation gets the clean "not found" denial
 * — never a write onto a foreign thread (mirrors the read node's 404 guard).
 * The reply is an outbound-to-citizen CEAM attributed as the hauler (D4) and
 * reuses the citizen ping (D5). Gated on D6.
 */
export type ReplyToHaulerPortalConversation = {
  __typename: 'ReplyToHaulerPortalConversation';
  conversation?: Maybe<PortalConversationDef>;
  message?: Maybe<PortalConversationMessageDef>;
};

/** Mark a key lost (AC4). */
export type ReportKeyLost = {
  __typename: 'ReportKeyLost';
  physicalKey?: Maybe<PhysicalKeyType>;
};

/** Execute one 'report relocation' wizard run (req 3.1.38). */
export type ReportRelocation = {
  __typename: 'ReportRelocation';
  relocation?: Maybe<RelocationDef>;
};

export type ReportRelocationInput = {
  contactId: Scalars['ID']['input'];
  /** 'stay' or 'move_with_customer'. */
  containerLogistics: Scalars['String']['input'];
  /** Exactly one of destinationPropertyId / newProperty. */
  destinationPropertyId?: InputMaybe<Scalars['ID']['input']>;
  destinationServices?: InputMaybe<Array<RelocationDestinationServiceInput>>;
  endingAgreementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  movingDate: Scalars['Date']['input'];
  /** Exactly one of destinationPropertyId / newProperty. */
  newProperty?: InputMaybe<RelocationNewPropertyInput>;
  originPropertyId: Scalars['ID']['input'];
  scheduledChanges?: InputMaybe<Array<RelocationScheduledChangeInput>>;
};

export type ReportTemplateResult = {
  __typename: 'ReportTemplateResult';
  droppedRecipients?: Maybe<Array<Scalars['String']['output']>>;
  error?: Maybe<Scalars['String']['output']>;
  template?: Maybe<ReportTemplateType>;
};

export type ReportTemplateType = {
  __typename: 'ReportTemplateType';
  id: Scalars['ID']['output'];
  intervalDays?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nextRunAt?: Maybe<Scalars['String']['output']>;
  params?: Maybe<Scalars['GenericScalar']['output']>;
  recipients?: Maybe<Scalars['GenericScalar']['output']>;
  spec: Scalars['GenericScalar']['output'];
  target?: Maybe<Scalars['String']['output']>;
};

export type ReportedFromDef = {
  __typename: 'ReportedFromDef';
  reporterDriverId?: Maybe<Scalars['ID']['output']>;
  reporterId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Request one budgeted relaxation probe for a plan (RS-603).
 *
 * Bounded to 5 probes per plan (05_ENGINE_SPEC section 7); the
 * re-solve runs async on the optimization-engine queue and the
 * probe walks queued -> running -> done/failed. Idempotent per
 * (plan, relaxation).
 */
export type RequestRelaxationProbeMutation = {
  __typename: 'RequestRelaxationProbeMutation';
  probe?: Maybe<RelaxationProbeDef>;
};

export type ResendInvitation = {
  __typename: 'ResendInvitation';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Re-send the code for a live challenge. Neutral response — cooldown and
 * max-resends are enforced silently inside the engine; the status never
 * reveals whether a new code was actually issued.
 */
export type ResendMfaCode = {
  __typename: 'ResendMfaCode';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * One popover row: an open ticket holding reserved units of an
 * item type at a warehouse. Age is derived client-side from
 * created_at; staleness (>14 days) is a fixed display rule, not a
 * setting.
 */
export type ReservedTicketRowType = {
  __typename: 'ReservedTicketRowType';
  address?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  ticketId?: Maybe<Scalars['ID']['output']>;
  ticketNumber?: Maybe<Scalars['Int']['output']>;
};

export type ResetCompanyColorSettings = {
  __typename: 'ResetCompanyColorSettings';
  companySettings?: Maybe<CompanySettingsType>;
};

export type ResetFeatureConfigDrift = {
  __typename: 'ResetFeatureConfigDrift';
  resolution?: Maybe<FeatureConfigResolutionType>;
};

export type ResetStopListCardConfig = {
  __typename: 'ResetStopListCardConfig';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Fix-queue resolution (RS-102): accept the suggestion, place
 * manual coordinates (audited), defer a red explicitly, or dismiss
 * a non-geocode issue.
 */
export type ResolveImportIssueMutation = {
  __typename: 'ResolveImportIssueMutation';
  importIssue?: Maybe<ImportIssueDef>;
};

export type ResolvedWidget = {
  __typename: 'ResolvedWidget';
  blend?: Maybe<Scalars['GenericScalar']['output']>;
  data?: Maybe<Scalars['GenericScalar']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  filterStatus?: Maybe<Scalars['GenericScalar']['output']>;
  lineage?: Maybe<Scalars['GenericScalar']['output']>;
  previousSeries?: Maybe<Scalars['GenericScalar']['output']>;
  previousValue?: Maybe<Scalars['Float']['output']>;
  truncated?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A deleted New dashboard of a client back as it was (its tiles and who
 * sees it).
 */
export type RestoreBuilderDashboardAsStaff = {
  __typename: 'RestoreBuilderDashboardAsStaff';
  dashboard?: Maybe<BuilderAdminDashboardType>;
  error?: Maybe<Scalars['String']['output']>;
};

/**
 * Office: re-run the register hand-off for a SIGNED document (after a
 * rejection was corrected via reopen + re-sign, or a transient failure).
 */
export type ResubmitTransferDocument = {
  __typename: 'ResubmitTransferDocument';
  scheduled?: Maybe<Scalars['Boolean']['output']>;
  transferDocument?: Maybe<TransferDocumentType>;
};

export type ResumeAutomationEnginePayload = {
  __typename: 'ResumeAutomationEnginePayload';
  settings: AutomationSettingsDef;
};

/** Retire a rule; history and provenance stay (auditable brain). */
export type RetireBrainRuleMutation = {
  __typename: 'RetireBrainRuleMutation';
  brainRule?: Maybe<BrainRuleDef>;
};

/**
 * A1: withdraw a vouched query so it stops short-circuiting the
 * analyst — the un-vouch counterpart to promote, so the verified
 * library is governable (a stale/wrong entry can be removed). The
 * audit trail keeps the record of both the promote and the retire.
 * Back-office only; company-scoped.
 */
export type RetireInsightsVerifiedQuery = {
  __typename: 'RetireInsightsVerifiedQuery';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RetractInsight = {
  __typename: 'RetractInsight';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/**
 * Record a key being returned (AC4): creates + completes a KEY_RETURN
 * ticket, marking the key returned.
 */
export type ReturnKey = {
  __typename: 'ReturnKey';
  physicalKey?: Maybe<PhysicalKeyType>;
  ticketId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Bring one rented unit home (PRO-271): the +1 RETURN serialization
 * row via the confirm-arrival landing engine
 * (``inventory.services.rental.return_rental``), so the unit rejoins the
 * count and stays individually visible in storage. Defaults the
 * destination to the ticket's return warehouse; ``warehouseId`` overrides
 * it. A SALE has no return leg and is refused cleanly.
 */
export type ReturnRental = {
  __typename: 'ReturnRental';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Manually revert a temporary location override back to the original location.
 *
 * Restores the container to its original location immediately.
 */
export type RevertTemporaryContainerLocation = {
  __typename: 'RevertTemporaryContainerLocation';
  container?: Maybe<ContainerType>;
  temporaryLocationOverride?: Maybe<TemporaryContainerLocationType>;
};

export type RevokeTransferDocumentSignLink = {
  __typename: 'RevokeTransferDocumentSignLink';
  revoked?: Maybe<Scalars['Int']['output']>;
  transferDocument?: Maybe<TransferDocumentType>;
};

/**
 * RS-1502 universal rollback: one action reverts one applied
 * autopilot adjustment; the dispatch overlay returns exactly to the
 * prior state (D35).
 *
 * SBX-537 P1-1 (wave D23): master-gated. Reverting a live dispatch
 * overlay is a live-operations act (RS-2009).
 */
export type RollbackAutopilotActionMutation = {
  __typename: 'RollbackAutopilotActionMutation';
  action?: Maybe<AutopilotActionDef>;
};

/**
 * Reactivate an older, already-validated `FlowVersion` of a `live` flow
 * by switching `current_version` (AP-402), exposing
 * `autopilot.runtime.activation_gate.rollback_flow`.
 *
 * Pack `03` §2: "Rollback = re-activate prior version." No new
 * `FlowVersion` is created and `state` does not change; only the pointer
 * the executor reads moves.
 *
 * Re-runs the same registry-aware validator (`validate_for_builder`)
 * `PromoteAutopilotFlow` enforces, against the *target* version's
 * definition, before switching the pointer: the version was valid when it
 * was committed, but `autopilot_registry_sync` can deactivate an action
 * any time afterwards, and rollback re-points a LIVE flow's executor --
 * the same "last save-time gate before it runs for real" story as
 * promotion, just entered from an older version instead of the newest one.
 * Without this, a save-time refusal (`validate_for_builder` would reject
 * this exact definition) turns into a live-flow run failure instead.
 *
 * Review fix (AP-703): also runs the same activation gate a fresh
 * test -> live promotion requires, via `rollback_flow`, whenever the
 * target version was never itself the subject of a gated activation (see
 * that function's own docstring) -- `gate_kind`/`gate_reason` are
 * optional here (unlike `ActivateAutopilotFlow`) because they are only
 * needed for that case; rolling back to the one version this flow's
 * `ImpactRecord` already proves was gated needs neither and keeps
 * working exactly as before, no new required argument for the common
 * case.
 */
export type RollbackAutopilotFlow = {
  __typename: 'RollbackAutopilotFlow';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  flow?: Maybe<FlowType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * PRO-773: undo what a deviation did, without deleting it.
 *
 * A SEPARATE mutation rather than a ``rollback`` argument on the delete:
 * SDL ``extend`` cannot add an argument to an existing field, so an argument
 * could not be stubbed for the frontend's codegen ahead of the backend
 * deploy — the same constraint that kept the route-creation warning a query.
 * A new Mutation FIELD stubs cleanly, and an explicit rollback is the better
 * surface anyway: an operator may want to put the routes back WITHOUT
 * throwing the deviation away.
 *
 * Idempotent: a change already rolled back is not rolled back twice.
 */
export type RollbackCollectionCalendarDeviation = {
  __typename: 'RollbackCollectionCalendarDeviation';
  restoredRoutes?: Maybe<Scalars['Int']['output']>;
  restoredStops?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * One action: restore the pre-promotion snapshot exactly and
 * queue the follow-up messaging (RS-703).
 */
export type RollbackPromotionMutation = {
  __typename: 'RollbackPromotionMutation';
  promotion?: Maybe<PromotionDef>;
};

/**
 * Add vehicles to ``Route.vehicles_from_route_scheme`` for mid-day
 * collaboration. Each vehicle must belong to the route's hauler. Office-
 * user only.
 */
export type RouteAddCollaborationVehicles = {
  __typename: 'RouteAddCollaborationVehicles';
  addedVehicleIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  route?: Maybe<RouteType>;
};

export type RouteAnalyticsType = {
  __typename: 'RouteAnalyticsType';
  objects?: Maybe<RouteTypeConnection>;
  objects_Count?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};


export type RouteAnalyticsTypeObjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteAvailableContainersSubscription = {
  __typename: 'RouteAvailableContainersSubscription';
  addedContainers?: Maybe<Array<Maybe<ContainerType>>>;
  removedContainers?: Maybe<Array<Maybe<ContainerType>>>;
};

/**
 * Wizard reroute (RS-E20): send one candidate table into the
 * legacy stop-list import pipeline (mapping, geocoding, fix queue,
 * quality report). The case wraps the existing wizard, it does not
 * duplicate it.
 */
export type RouteCandidateTableToImportMutation = {
  __typename: 'RouteCandidateTableToImportMutation';
  candidateTable?: Maybe<CandidateTableDef>;
  importBatch?: Maybe<ImportBatchDef>;
};

/** This mutation is obsolete and has been deprecated. Use `RouteChangePrimaryVehicleGeneric` instead. */
export type RouteChangePrimaryVehicle = {
  __typename: 'RouteChangePrimaryVehicle';
  route?: Maybe<RouteType>;
};

/** Change primary vehicle for route for mobile app */
export type RouteChangePrimaryVehicleGeneric = {
  __typename: 'RouteChangePrimaryVehicleGeneric';
  route?: Maybe<RouteType>;
};

/** This mutation is obsolete and has been deprecated. Use `RouteChangePrimaryVehicleGeneric` instead. */
export type RouteChangePrimaryVehicleMobile = {
  __typename: 'RouteChangePrimaryVehicleMobile';
  route?: Maybe<RouteType>;
};

export type RouteComplete = {
  __typename: 'RouteComplete';
  route?: Maybe<RouteType>;
};

export type RouteDelete = {
  __typename: 'RouteDelete';
  route?: Maybe<RouteType>;
};

/**
 * A single event in the driving-events chronological stream.
 *
 * Mixes depot (arrival/departure) and stop events. Fields are nullable
 * to handle sparse data per event type:
 * - Depot events: event, depotId, depotName, timestamp, weight (the
 *   unload weight given at the station, COMPASS-1188)
 * - Stop events: event ("stop_completed", or "deviation_reported" when
 *   the driver gave a deviation reason), stopId, stopNumber, weight,
 *   fillLevel, deviationReason, timestamp
 * - Every event: latitude / longitude / gpsAccuracyM — where the device
 *   was when the event was confirmed (COMPASS-1188 / HSY req 34), NULL
 *   when no fix was recorded.
 */
export type RouteDrivingEventType = {
  __typename: 'RouteDrivingEventType';
  /** Global ID of the depot (depot events only) */
  depotId?: Maybe<Scalars['ID']['output']>;
  /** Name of the depot (depot events only) */
  depotName?: Maybe<Scalars['String']['output']>;
  /** The driver's deviation reason code (deviation_reported events) */
  deviationReason?: Maybe<Scalars['String']['output']>;
  /** Event type */
  event: Scalars['String']['output'];
  /** Container fill level (%, stop completion events only) */
  fillLevel?: Maybe<Scalars['Float']['output']>;
  /** Reported accuracy radius of that fix, metres */
  gpsAccuracyM?: Maybe<Scalars['Float']['output']>;
  /** WGS84 latitude of the device when the event was confirmed */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** WGS84 longitude of the device when the event was confirmed */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Stop order ID (stop completion events only) */
  stopId?: Maybe<Scalars['String']['output']>;
  /** Stop sequence number (stop completion events only) */
  stopNumber?: Maybe<Scalars['Int']['output']>;
  /** ISO 8601 timestamp when event occurred */
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Weight collected (kg, stop completion events only) */
  weight?: Maybe<Scalars['Float']['output']>;
};

export type RouteEventDef = Node & {
  __typename: 'RouteEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<RouteEventTypesGraphene>>>;
  fromAutoComplete?: Maybe<Scalars['Boolean']['output']>;
  fromAutoCompleteNextStop?: Maybe<Scalars['Boolean']['output']>;
  fromCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  fromLocked?: Maybe<Scalars['Boolean']['output']>;
  fromLockedStart?: Maybe<Scalars['Boolean']['output']>;
  fromStartedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  route?: Maybe<RouteType>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toAutoComplete?: Maybe<Scalars['Boolean']['output']>;
  toAutoCompleteNextStop?: Maybe<Scalars['Boolean']['output']>;
  toCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  toLocked?: Maybe<Scalars['Boolean']['output']>;
  toLockedStart?: Maybe<Scalars['Boolean']['output']>;
  toStartedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UserType>;
};

export type RouteEventLogEvent = PickUpOrderEventDef | RouteEventDef | RouteVehicleEventDef;

export type RouteEventLogEventWrapper = {
  __typename: 'RouteEventLogEventWrapper';
  edges?: Maybe<Array<Maybe<RouteEventLogEvent>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum RouteEventTypesGraphene {
  ARCHIVED_AT_CHANGE = 'ARCHIVED_AT_CHANGE',
  AUTO_COMPLETE_CHANGE = 'AUTO_COMPLETE_CHANGE',
  AUTO_COMPLETE_NEXT_STOP_CHANGE = 'AUTO_COMPLETE_NEXT_STOP_CHANGE',
  COMPLETED_AT_CHANGE = 'COMPLETED_AT_CHANGE',
  LOCKED_CHANGE = 'LOCKED_CHANGE',
  LOCKED_START_CHANGE = 'LOCKED_START_CHANGE',
  STARTED_AT_CHANGE = 'STARTED_AT_CHANGE'
}

export type RouteExportMutation = {
  __typename: 'RouteExportMutation';
  routeExport?: Maybe<RouteExportType>;
};

export type RouteExportType = Node & {
  __typename: 'RouteExportType';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserType;
  excelFormat: Scalars['Boolean']['output'];
  file?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

export type RouteExportTypeConnection = {
  __typename: 'RouteExportTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteExportTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RouteExportType` and its cursor. */
export type RouteExportTypeEdge = {
  __typename: 'RouteExportTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteExportType>;
};

export type RouteHaulerReassignmentLogType = Node & {
  __typename: 'RouteHaulerReassignmentLogType';
  fromHauler?: Maybe<HaulerDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  reassignedAt: Scalars['DateTime']['output'];
  reassignedBy?: Maybe<UserType>;
  route: RouteType;
  toHauler?: Maybe<HaulerDef>;
};

export type RouteHaulerReassignmentLogTypeConnection = {
  __typename: 'RouteHaulerReassignmentLogTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteHaulerReassignmentLogTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RouteHaulerReassignmentLogType` and its cursor. */
export type RouteHaulerReassignmentLogTypeEdge = {
  __typename: 'RouteHaulerReassignmentLogTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteHaulerReassignmentLogType>;
};

export type RouteInformationType = Node & {
  __typename: 'RouteInformationType';
  completedCollections?: Maybe<Scalars['Int']['output']>;
  completedDistance?: Maybe<Scalars['Float']['output']>;
  completedOffloads?: Maybe<Scalars['Int']['output']>;
  completedWeight?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endTime?: Maybe<Scalars['Time']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  routeSet: RouteTypeConnection;
  startTime?: Maybe<Scalars['Time']['output']>;
  stops: PickUpOrderTypeConnection;
  totalCollections?: Maybe<Scalars['Int']['output']>;
  totalDistance?: Maybe<Scalars['Float']['output']>;
  totalOffloads?: Maybe<Scalars['Int']['output']>;
  totalWeight?: Maybe<Scalars['Int']['output']>;
  version: Scalars['Int']['output'];
};


export type RouteInformationTypeRouteSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteInformationTypeStopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteInformationTypeConnection = {
  __typename: 'RouteInformationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteInformationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RouteInformationType` and its cursor. */
export type RouteInformationTypeEdge = {
  __typename: 'RouteInformationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteInformationType>;
};

/** This mutation is obsolete and has been deprecated. Use `RouteStartGeneric` instead. */
export type RouteJoinDifferentVehicle = {
  __typename: 'RouteJoinDifferentVehicle';
  route?: Maybe<RouteType>;
};

/** This mutation is obsolete and has been deprecated. Use `RouteStartGeneric` instead. */
export type RouteJoinSameVehicle = {
  __typename: 'RouteJoinSameVehicle';
  route?: Maybe<RouteType>;
};

export type RouteLocationHistoryDef = Node & {
  __typename: 'RouteLocationHistoryDef';
  appVersion?: Maybe<Scalars['String']['output']>;
  autoComplete: Scalars['Boolean']['output'];
  autoCompleteDistance?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  driver?: Maybe<DriverType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  location: LocationWithContainerType;
  route: RouteType;
  speed: Scalars['Float']['output'];
  token?: Maybe<Scalars['String']['output']>;
  /** Vehicle driver was in on the route */
  vehicle?: Maybe<VehicleType>;
};

export type RouteLocationHistoryDefConnection = {
  __typename: 'RouteLocationHistoryDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteLocationHistoryDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RouteLocationHistoryDef` and its cursor. */
export type RouteLocationHistoryDefEdge = {
  __typename: 'RouteLocationHistoryDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteLocationHistoryDef>;
};

export type RouteOptimize = {
  __typename: 'RouteOptimize';
  route?: Maybe<RouteType>;
};

export type RouteProblemDef = Node & {
  __typename: 'RouteProblemDef';
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<RouteProblemDef>;
  checkInterval: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdFrom?: Maybe<RoutesRouteProblemCreatedFromChoices>;
  /** Wall-clock seconds the solver ran: started_at -> solved_at (or ended_at). Null while a run has not started or not finished. */
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  errorAt?: Maybe<Scalars['DateTime']['output']>;
  holidayShiftMap?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  jobId?: Maybe<Scalars['String']['output']>;
  lbCookie?: Maybe<Scalars['String']['output']>;
  maxTime: Scalars['Int']['output'];
  /** The solver time budget for this run, in seconds. */
  maxTimeSeconds?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<RouteProblemDef>;
  periodEnd?: Maybe<Scalars['Date']['output']>;
  periodStart?: Maybe<Scalars['Date']['output']>;
  problemFile?: Maybe<Scalars['String']['output']>;
  /** Human-readable explanation, in the reader's language, of what happened on this run -- the failure reason for an error, or why a run did not land a plan (superseded, still running). Null only for a run that solved cleanly. */
  reason?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<RouteType>;
  routeScheme?: Maybe<RouteSchemeType>;
  routeproblemSet: RouteProblemDefConnection;
  solutionFile?: Maybe<Scalars['String']['output']>;
  solvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Human-readable label for what triggered this run (office Optimize, driver set-next, nightly generation, ...), in the reader's language. Null for a run with no recorded source. */
  source?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** One of: solved, error, cancelled, running, pending. Derived from the run's lifecycle timestamps. */
  status?: Maybe<Scalars['String']['output']>;
};


export type RouteProblemDefRouteproblemSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteProblemDefConnection = {
  __typename: 'RouteProblemDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteProblemDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RouteProblemDef` and its cursor. */
export type RouteProblemDefEdge = {
  __typename: 'RouteProblemDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteProblemDef>;
};

export type RouteProblemErrorDef = Node & {
  __typename: 'RouteProblemErrorDef';
  createdAt: Scalars['DateTime']['output'];
  exception: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  routeProblem: RouteProblemDef;
  shouldEnd: Scalars['Boolean']['output'];
  shouldRaise: Scalars['Boolean']['output'];
};

export type RouteProblemErrorDefConnection = {
  __typename: 'RouteProblemErrorDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteProblemErrorDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RouteProblemErrorDef` and its cursor. */
export type RouteProblemErrorDefEdge = {
  __typename: 'RouteProblemErrorDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteProblemErrorDef>;
};

/**
 * Reassign the primary driver on a route within the same hauler.
 *
 * Wraps ``routes.services.route_reassignment.reassign_route_driver`` so the
 * same validation (office-user, no-completed-stops, hauler membership) is
 * enforced for both REST and GraphQL callers, and so every change appends
 * a ``RouteVehicleDriverReassignmentLog`` entry.
 */
export type RouteReassignDriver = {
  __typename: 'RouteReassignDriver';
  log?: Maybe<RouteVehicleDriverReassignmentLogType>;
  route?: Maybe<RouteType>;
};

/**
 * Reassign ``Route.hauler`` cross-hauler (COMPASS-334).
 *
 * Wraps ``routes.services.route_hauler_reassignment.reassign_route_hauler``
 * so the same validation (office-user, hauler within same company,
 * idempotent same-hauler) is enforced for REST + GraphQL callers, and so
 * every change appends a ``RouteHaulerReassignmentLog``.
 */
export type RouteReassignHauler = {
  __typename: 'RouteReassignHauler';
  log?: Maybe<RouteHaulerReassignmentLogType>;
  route?: Maybe<RouteType>;
};

export type RouteReset = {
  __typename: 'RouteReset';
  route?: Maybe<RouteType>;
};

export type RouteSchemeDelete = {
  __typename: 'RouteSchemeDelete';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RouteSchemeEventDef = Node & {
  __typename: 'RouteSchemeEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<RouteSchemeEventTypesGraphene>>>;
  fromAllowDriverToAddStops?: Maybe<Scalars['Boolean']['output']>;
  fromAllowDriverToEditContainers?: Maybe<Scalars['Boolean']['output']>;
  fromAllowDriverToMoveStops?: Maybe<Scalars['Boolean']['output']>;
  fromAllowDriverToOnlyCompleteNextStop?: Maybe<Scalars['Boolean']['output']>;
  fromAllowDriverToTakeStops?: Maybe<Scalars['Boolean']['output']>;
  fromCollectionMethod?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  fromObjectives?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fromPromptDriverForFillLevelOnContainer?: Maybe<Scalars['Boolean']['output']>;
  fromPromptDriverForQrCodeOnContainer?: Maybe<Scalars['Boolean']['output']>;
  fromPromptDriverForWeightOnContainer?: Maybe<Scalars['Boolean']['output']>;
  fromPromptDriverForWeightOnWasteStation?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  routeScheme?: Maybe<RouteSchemeType>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toAllowDriverToAddStops?: Maybe<Scalars['Boolean']['output']>;
  toAllowDriverToEditContainers?: Maybe<Scalars['Boolean']['output']>;
  toAllowDriverToMoveStops?: Maybe<Scalars['Boolean']['output']>;
  toAllowDriverToOnlyCompleteNextStop?: Maybe<Scalars['Boolean']['output']>;
  toAllowDriverToTakeStops?: Maybe<Scalars['Boolean']['output']>;
  toCollectionMethod?: Maybe<Scalars['String']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
  toObjectives?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  toPromptDriverForFillLevelOnContainer?: Maybe<Scalars['Boolean']['output']>;
  toPromptDriverForQrCodeOnContainer?: Maybe<Scalars['Boolean']['output']>;
  toPromptDriverForWeightOnContainer?: Maybe<Scalars['Boolean']['output']>;
  toPromptDriverForWeightOnWasteStation?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<UserType>;
};

export type RouteSchemeEventLogEvent = RouteSchemeEventDef;

export type RouteSchemeEventLogEventWrapper = {
  __typename: 'RouteSchemeEventLogEventWrapper';
  edges?: Maybe<Array<Maybe<RouteSchemeEventLogEvent>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum RouteSchemeEventTypesGraphene {
  COLLECTION_METHOD_CHANGE = 'COLLECTION_METHOD_CHANGE',
  NAME_CHANGE = 'NAME_CHANGE',
  NAV_APP_CONFIGURATION_CHANGE = 'NAV_APP_CONFIGURATION_CHANGE',
  OBJECTIVES_CHANGE = 'OBJECTIVES_CHANGE'
}

export type RouteSchemeInput = {
  allowDriverToAddStops: Scalars['Boolean']['input'];
  allowDriverToEditContainers: Scalars['Boolean']['input'];
  allowDriverToMoveStops: Scalars['Boolean']['input'];
  allowDriverToOnlyCompleteNextStop: Scalars['Boolean']['input'];
  allowDriverToTakeStops: Scalars['Boolean']['input'];
  autoCompleteDistance?: InputMaybe<Scalars['Int']['input']>;
  autoCompleteDuration?: InputMaybe<Scalars['Int']['input']>;
  autoCompleteRfid?: InputMaybe<Scalars['Boolean']['input']>;
  collectionMethod: Scalars['String']['input'];
  defaultAutoComplete?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAutoCompleteNextStop?: InputMaybe<Scalars['Boolean']['input']>;
  defaultRouteLockedStart: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  promptDriverForFillLevelOnContainer: Scalars['Boolean']['input'];
  promptDriverForQrCodeOnContainer: Scalars['Boolean']['input'];
  promptDriverForWeightOnContainer: Scalars['Boolean']['input'];
  promptDriverForWeightOnWasteStation: Scalars['Boolean']['input'];
  vehicles: Array<InputMaybe<RouteSchemeVehicleInput>>;
  wasteFractionFillLevelSets: Array<InputMaybe<RouteSchemeWasteFractionFillLevelInput>>;
};

/** B1.1 (ADR-0006): a scheme drawing from this warehouse. */
export type RouteSchemeLinkType = {
  __typename: 'RouteSchemeLinkType';
  routeSchemeId?: Maybe<Scalars['ID']['output']>;
  routeSchemeName?: Maybe<Scalars['String']['output']>;
};

export type RouteSchemeOptimize = {
  __typename: 'RouteSchemeOptimize';
  routeScheme?: Maybe<RouteSchemeType>;
};

export type RouteSchemeOptimizeNew = {
  __typename: 'RouteSchemeOptimizeNew';
  routeScheme?: Maybe<RouteSchemeType>;
};

export type RouteSchemePreview = {
  __typename: 'RouteSchemePreview';
  routeSchemePreview?: Maybe<RouteSchemePreviewType>;
};

export type RouteSchemePreviewRouteType = {
  __typename: 'RouteSchemePreviewRouteType';
  distance?: Maybe<Scalars['Int']['output']>;
  driver?: Maybe<DriverType>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  stops?: Maybe<Scalars['Int']['output']>;
  vehicle?: Maybe<VehicleType>;
  wasteFraction?: Maybe<WasteFractionType>;
};

export type RouteSchemePreviewTotalsDayType = {
  __typename: 'RouteSchemePreviewTotalsDayType';
  date?: Maybe<Scalars['Date']['output']>;
  distance?: Maybe<Scalars['Int']['output']>;
  stops?: Maybe<Scalars['Int']['output']>;
  vehicles?: Maybe<Scalars['Int']['output']>;
  workingHours?: Maybe<Scalars['Int']['output']>;
};

export type RouteSchemePreviewTotalsType = {
  __typename: 'RouteSchemePreviewTotalsType';
  days?: Maybe<Array<Maybe<RouteSchemePreviewTotalsDayType>>>;
  distance?: Maybe<Scalars['Int']['output']>;
  distanceCompare?: Maybe<Scalars['Int']['output']>;
  stops?: Maybe<Scalars['Int']['output']>;
  stopsCompare?: Maybe<Scalars['Int']['output']>;
  vehicles?: Maybe<Scalars['Int']['output']>;
  workingHours?: Maybe<Scalars['Int']['output']>;
  workingHoursCompare?: Maybe<Scalars['Int']['output']>;
};

export type RouteSchemePreviewType = {
  __typename: 'RouteSchemePreviewType';
  routes?: Maybe<Array<Maybe<RouteSchemePreviewRouteType>>>;
  totals?: Maybe<RouteSchemePreviewTotalsType>;
};

/** The route code a new container would carry on a joint-code scheme. */
export type RouteSchemeRouteCodesType = {
  __typename: 'RouteSchemeRouteCodesType';
  /** Every route code the scheme's containers carry, most common first. */
  codes: Array<Scalars['String']['output']>;
  /** Distance to that container, in metres. */
  distanceMeters?: Maybe<Scalars['Float']['output']>;
  /** The code of the nearest container on this scheme that has one, at any distance from the new container. Null when the new container's spot is unknown or no container on the scheme has a code. */
  routeCode?: Maybe<Scalars['String']['output']>;
  routeScheme: RouteSchemeType;
  /** The number of the container the code was read from. */
  sourceContainerNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * Office-only replace-all write of a scheme's eligible unloading
 * stations (order = list order). Affects FUTURE route generation;
 * already-generated routes keep their own sets.
 */
export type RouteSchemeSetUnloadingStations = {
  __typename: 'RouteSchemeSetUnloadingStations';
  unloadingStations?: Maybe<Array<Maybe<DepotType>>>;
};

/** A route scheme proposed for a new or moved container, with the reason. */
export type RouteSchemeSuggestionType = {
  __typename: 'RouteSchemeSuggestionType';
  /** Distance to the neighbour container, in metres. */
  distanceMeters?: Maybe<Scalars['Float']['output']>;
  /** Address of the neighbour container. */
  donorAddress?: Maybe<Scalars['String']['output']>;
  /** The neighbour container's number. */
  donorContainerNumber?: Maybe<Scalars['String']['output']>;
  /** Why it is suggested: SAME_PROPERTY (a container on the same property), SAME_STREET (same street within 50 m), NEARBY (within 1 km) or SELECTION (bulk: best match for part of the selection). */
  match: Scalars['String']['output'];
  /** The route code the container would carry on this scheme: the scheme's own code (RouteSchemeType.routeCode), or, for a scheme whose name holds no code its containers share (the Glass+Plast merges, see RouteSchemeType.routeCodeFromContainers), the code of the neighbour container that suggested it. Bulk: given only when every item this scheme fits would carry the same code. */
  routeCode?: Maybe<Scalars['String']['output']>;
  routeScheme: RouteSchemeType;
  samePickupSetting: Scalars['Boolean']['output'];
  sameWasteFraction: Scalars['Boolean']['output'];
  /** Bulk: how many selected items this scheme fits best. */
  supportCount?: Maybe<Scalars['Int']['output']>;
  /** Bulk: how many selected items were looked at. */
  targetCount?: Maybe<Scalars['Int']['output']>;
};

export type RouteSchemeType = Node & {
  __typename: 'RouteSchemeType';
  /** If this is enabled, drivers will be able to collaborate on routes */
  allowCollaborationOnRoute: Scalars['Boolean']['output'];
  allowDriverToAddStops: Scalars['Boolean']['output'];
  allowDriverToEditContainers: Scalars['Boolean']['output'];
  allowDriverToMoveStops: Scalars['Boolean']['output'];
  allowDriverToOnlyCompleteNextStop: Scalars['Boolean']['output'];
  /** If this is enabled, drivers will be able to start routes before the scheduled date */
  allowDriverToStartRouteBeforeScheduledDate: Scalars['Boolean']['output'];
  allowDriverToTakeStops: Scalars['Boolean']['output'];
  /** If this is enabled, drivers which have allowed vehicles that intersect with the vehicles from route scheme will be able to view routes generated by this route scheme */
  allowDriverWithRouteSchemeVehiclesAccessToViewRoutes: Scalars['Boolean']['output'];
  autoCompleteDistance: Scalars['Int']['output'];
  autoCompleteDuration: Scalars['Int']['output'];
  autoCompletePlannedContainers: Scalars['Boolean']['output'];
  autoCompleteRfid: Scalars['Boolean']['output'];
  availableDates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  byPassDriverWorkTimeEnd: Scalars['Boolean']['output'];
  /** The scheme that generates the route's series — the object the approval actually mutates (vehicle days / calendars). Resolved and validated at propose time. */
  changeProposals: ChangeProposalDefConnection;
  /** Limit the deviation to these route schemes. */
  collectionDeviations: CollectionCalendarDeviationDefConnection;
  collectionMethod: Scalars['String']['output'];
  collectionMethodSemiDynamicUsePrediction: Scalars['Boolean']['output'];
  collectionMethodTicketsCollectionCalender?: Maybe<CollectionCalendarDef>;
  collectioncalendardeviationtoperiodSet: CollectionCalendarDeviationToPeriodDefConnection;
  /** Distance (meters) a driver must be within to mark a stop done manually on this scheme's routes. Empty = use the company default. A contract area's own radius always wins. */
  completionRadiusMeters?: Maybe<Scalars['Int']['output']>;
  containerSet: ContainerTypeConnection;
  containersCount?: Maybe<Scalars['Int']['output']>;
  defaultAutoComplete: Scalars['Boolean']['output'];
  defaultAutoCompleteNextStop: Scalars['Boolean']['output'];
  defaultRouteAutoOptimize: Scalars['Boolean']['output'];
  defaultRouteLockedStart: Scalars['Boolean']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  enforceSingleRoutePerDay: Scalars['Boolean']['output'];
  eventLog?: Maybe<RouteSchemeEventLogEventWrapper>;
  firstAvailableDate?: Maybe<Scalars['Date']['output']>;
  /** When on, every route this scheme generates is re-sequenced to the fixed route template that covers it, and a route the templates do not cover gets a draft for the planner to confirm. Off (default) = templates are applied only by hand. */
  fixedRouteNightlyEnabled: Scalars['Boolean']['output'];
  /** COMPASS-1765: how much of this scheme's master data its template already orders, and how many containers still wait to be placed. Null with Fixed Routes off. */
  fixedRouteSummary?: Maybe<FixedRouteSchemeSummaryType>;
  /** COMPASS-1765: this scheme's scheme-wide fixed route template (the one every route it generates is re-sequenced to). Null when there is none or Fixed Routes is off for the company. */
  fixedRouteTemplate?: Maybe<FixedRouteTemplateType>;
  /** COMPASS-1765: every fixed route template held for this scheme — the scheme-wide one plus any per-truck override. Empty with Fixed Routes off. */
  fixedRouteTemplates?: Maybe<Array<FixedRouteTemplateType>>;
  fractionServiceBindings: FractionServiceBindingDefConnection;
  generateRoutes: Scalars['Boolean']['output'];
  generateRoutesDays: Scalars['Int']['output'];
  hauler?: Maybe<HaulerDef>;
  haulerSwitchOn?: Maybe<Scalars['Date']['output']>;
  haulerSwitchTo?: Maybe<HaulerDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  keepManuallyAddedStops: Scalars['Boolean']['output'];
  managecontainerticketSet: ManageContainerTicketDefConnection;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  objectives: Array<Scalars['String']['output']>;
  project: ProjectType;
  promptDriverForFillLevelOnContainer: Scalars['Boolean']['output'];
  promptDriverForQrCodeOnContainer: Scalars['Boolean']['output'];
  promptDriverForWeightOnContainer: Scalars['Boolean']['output'];
  promptDriverForWeightOnWasteStation: Scalars['Boolean']['output'];
  /** If this is enabled, drivers will not be able to modify turn by turn navigation in the mobile app */
  restrictTurnByTurnUsage: Scalars['Boolean']['output'];
  /** The operational code drivers identify this route by, parsed out of the scheme name — e.g. 'Rute 1946 Tor — 104' -> '104', 'Glass+Plast — Rute 1&2' -> '1&2'. Null when the name holds no code. This is the driver app's primary route label; it used to be parsed on the device, so the app and the office UI each derived it separately. Distinct from RouteType.subRouteCodes, which lists the containers' master-system codes and is a different code family for the næring/extra-route schemes. */
  routeCode?: Maybe<Scalars['String']['output']>;
  /** True when the scheme's name holds no route code its containers share: the Glass+Plast merges, named after a crew line ('1&2', '7') whose bins each keep their own area's code, or a name with no code at all. routeCode is then not a code any container carries; a container's code comes from its neighbours on the scheme (RouteSchemeSuggestionType.routeCode). */
  routeCodeFromContainers: Scalars['Boolean']['output'];
  routeProblemDefaultMaxTime: Scalars['Int']['output'];
  routeproblemSet: RouteProblemDefConnection;
  routesGenerated: RouteTypeConnection;
  routesGeneratedBy: Scalars['Time']['output'];
  scheduledexportSet: ScheduledExportDefConnection;
  scheduledexportrunSet: ScheduledExportRunDefConnection;
  scheduleonrouteactionSet: ScheduleOnRouteActionDefConnection;
  suppressEmptyRoutes: Scalars['Boolean']['output'];
  /** If this is enabled, turn by turn navigation will be enabled by default in the mobile app */
  turnByTurnIsOn: Scalars['Boolean']['output'];
  unloadingStations: DepotTypeConnection;
  vehicleDays: RouteSchemeVehicleDayTypeConnection;
  vehicleTrailerCapacityMode: Scalars['String']['output'];
  vehicles: VehicleTypeConnection;
  vehiclesCount?: Maybe<Scalars['Int']['output']>;
  /** If this is enabled, every driver in the scheme's company can view AND operate routes generated by this route scheme, regardless of which vehicles they are assigned to — and any driver added later gets the same access automatically. Used by the guided route-setup wizard. */
  visibleToAllDrivers: Scalars['Boolean']['output'];
  wasteFractionsFillLevelSets: RouteSchemeWasteFractionFillLevelSetTypeConnection;
};


export type RouteSchemeTypeAvailableDatesArgs = {
  periodEnd?: InputMaybe<Scalars['Date']['input']>;
  periodStart?: InputMaybe<Scalars['Date']['input']>;
};


export type RouteSchemeTypeChangeProposalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteSchemeTypeCollectionDeviationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteSchemeTypeCollectioncalendardeviationtoperiodSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteSchemeTypeContainerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteSchemeTypeEventLogArgs = {
  addRouteSchemeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  routeSchemeEventTypes?: InputMaybe<Array<InputMaybe<RouteSchemeEventTypesGraphene>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type RouteSchemeTypeFirstAvailableDateArgs = {
  periodEnd?: InputMaybe<Scalars['Date']['input']>;
  periodStart?: InputMaybe<Scalars['Date']['input']>;
};


export type RouteSchemeTypeFractionServiceBindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteSchemeTypeManagecontainerticketSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteSchemeTypeRouteproblemSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteSchemeTypeRoutesGeneratedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type RouteSchemeTypeScheduledexportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteSchemeTypeScheduledexportrunSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteSchemeTypeScheduleonrouteactionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteSchemeTypeUnloadingStationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteSchemeTypeVehicleDaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteSchemeTypeVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteSchemeTypeWasteFractionsFillLevelSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteSchemeTypeConnection = {
  __typename: 'RouteSchemeTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteSchemeTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RouteSchemeType` and its cursor. */
export type RouteSchemeTypeEdge = {
  __typename: 'RouteSchemeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteSchemeType>;
};

export type RouteSchemeVehicleDayMultipleChoiceFieldInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  vehicle: Scalars['ID']['input'];
  vehicleTrailer: Scalars['ID']['input'];
  weekday: Scalars['String']['input'];
};

export type RouteSchemeVehicleDayType = Node & {
  __typename: 'RouteSchemeVehicleDayType';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  routeschemeSet: RouteSchemeTypeConnection;
  vehicle: VehicleType;
  vehicleTrailer: VehicleTrailerType;
  weekday: Scalars['String']['output'];
};


export type RouteSchemeVehicleDayTypeRouteschemeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteSchemeVehicleDayTypeConnection = {
  __typename: 'RouteSchemeVehicleDayTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteSchemeVehicleDayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RouteSchemeVehicleDayType` and its cursor. */
export type RouteSchemeVehicleDayTypeEdge = {
  __typename: 'RouteSchemeVehicleDayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteSchemeVehicleDayType>;
};

export type RouteSchemeVehicleInput = {
  vehicleId: Scalars['ID']['input'];
};

export type RouteSchemeWasteFractionFillLevelInput = {
  fillLevelEnd: Scalars['Int']['input'];
  fillLevelStart: Scalars['Int']['input'];
  wasteFractionId: Scalars['ID']['input'];
};

export type RouteSchemeWasteFractionFillLevelSetMultipleChoiceFieldInput = {
  fillLevelEnd: Scalars['Int']['input'];
  fillLevelStart: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  wasteFraction: Scalars['ID']['input'];
};

export type RouteSchemeWasteFractionFillLevelSetType = Node & {
  __typename: 'RouteSchemeWasteFractionFillLevelSetType';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  routeschemeSet: RouteSchemeTypeConnection;
  sensorFillLevel: Scalars['Int']['output'];
  sensorFillLevelEnd: Scalars['Int']['output'];
  sensorFillLevelPeriodHours: Scalars['Int']['output'];
  wasteFraction: WasteFractionType;
};


export type RouteSchemeWasteFractionFillLevelSetTypeRouteschemeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteSchemeWasteFractionFillLevelSetTypeConnection = {
  __typename: 'RouteSchemeWasteFractionFillLevelSetTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteSchemeWasteFractionFillLevelSetTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RouteSchemeWasteFractionFillLevelSetType` and its cursor. */
export type RouteSchemeWasteFractionFillLevelSetTypeEdge = {
  __typename: 'RouteSchemeWasteFractionFillLevelSetTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteSchemeWasteFractionFillLevelSetType>;
};

/**
 * Office-only replace-all write of one route's eligible unloading
 * stations (order = list order). An empty list clears the config —
 * the route reverts to its scheme's set, else legacy behaviour.
 */
export type RouteSetUnloadingStations = {
  __typename: 'RouteSetUnloadingStations';
  unloadingStations?: Maybe<Array<Maybe<DepotType>>>;
};

export type RouteSettingsType = Node & {
  __typename: 'RouteSettingsType';
  containerType: ContainerTypeTypeConnection;
  depot: DepotTypeConnection;
  /** Measurement are in percent */
  emptyAt?: Maybe<Scalars['String']['output']>;
  /** Be extra aware of overflowing bins */
  extraAware: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  optimizeBy: Scalars['String']['output'];
  project: ProjectType;
  scheduleAhead?: Maybe<Scalars['Int']['output']>;
  vehicleType: VehicleTypeTypeConnection;
  wasteFraction: WasteFractionType;
};


export type RouteSettingsTypeContainerTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteSettingsTypeDepotArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteSettingsTypeVehicleTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteSettingsTypeConnection = {
  __typename: 'RouteSettingsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteSettingsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RouteSettingsType` and its cursor. */
export type RouteSettingsTypeEdge = {
  __typename: 'RouteSettingsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteSettingsType>;
};

export type RouteSetupContainerInput = {
  containerId?: InputMaybe<Scalars['String']['input']>;
  containerTypeId?: InputMaybe<Scalars['ID']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type RouteSetupDepotInput = {
  existingId?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<RouteSetupLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type RouteSetupDriverInput = {
  existingId: Scalars['ID']['input'];
};

export type RouteSetupIssueType = {
  __typename: 'RouteSetupIssueType';
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
};

export type RouteSetupLocationInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RouteSetupTrailerInput = {
  containerTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  existingId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  wasteHolds?: InputMaybe<Array<InputMaybe<RouteSetupWasteHoldInput>>>;
};

export type RouteSetupVehicleInput = {
  existingId?: InputMaybe<Scalars['ID']['input']>;
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  licensePlateNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  vehicleSizeId?: InputMaybe<Scalars['ID']['input']>;
  vehicleTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export type RouteSetupWasteHoldInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  wasteFractionId: Scalars['ID']['input'];
};

/** This mutation is obsolete and has been deprecated. Use `RouteStartGeneric` instead. */
export type RouteStart = {
  __typename: 'RouteStart';
  route?: Maybe<RouteType>;
};

export type RouteStartGeneric = {
  __typename: 'RouteStartGeneric';
  route?: Maybe<RouteType>;
};

/** This mutation is obsolete and has been deprecated. Use `RouteStartGeneric` instead. */
export type RouteStartMobileApp = {
  __typename: 'RouteStartMobileApp';
  route?: Maybe<RouteType>;
};

export type RouteStop = {
  /** PRODUCT-472: the driver's note on the abortive visit. */
  abortiveNote?: InputMaybe<Scalars['String']['input']>;
  /** PRODUCT-472: id of the uploaded ticket attachment (photo) documenting the abortive visit. */
  abortivePhotoId?: InputMaybe<Scalars['ID']['input']>;
  /** PRODUCT-472: the visit could NOT be carried out - why. The stop is recorded as skipped, the ticket goes Rejected with this reason and back to Open for rescheduling, and the wasted-journey fee is billed. */
  abortiveReason?: InputMaybe<AbortiveReason>;
  /** COMPASS-884: when the tag was read — distinct from completedAt, which may be normalised across the read window. */
  autoConfirmReadAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** COMPASS-884: which reader reported the tag (REQ 42 allows two readers firing at the same moment). */
  autoConfirmReaderId?: InputMaybe<Scalars['String']['input']>;
  /** COMPASS-884: the tag id that confirmed this stop. Stored on the stop so two containers read at once stay distinguishable. */
  autoConfirmTag?: InputMaybe<Scalars['String']['input']>;
  /** PRODUCT-477 (exchange): identity of the OLD unit taken away. */
  collectedIdentity?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdTicketsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** PRODUCT-477 (exchange): identity of the NEW unit put down. */
  deliveredIdentity?: InputMaybe<Scalars['String']['input']>;
  fillLevel?: InputMaybe<Scalars['Float']['input']>;
  /** PRODUCT-477: label / barcode / RFID text of the skip the driver loaded for this rental delivery, as scanned. Dispatches the rental at completion; a scan of the wrong container type is refused. */
  loadedContainerIdentity?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  qrCode?: InputMaybe<Scalars['String']['input']>;
  /** COMPASS-884: this stop was auto-confirmed by an RFID/NFC read — stamps auto_completed_by=RFID for THIS stop only. */
  rfidAutoComplete?: InputMaybe<Scalars['Boolean']['input']>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
  ticketIdStopCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  transferDocument?: InputMaybe<Scalars['GenericScalar']['input']>;
  transferDocumentOverrideReason?: InputMaybe<Scalars['String']['input']>;
  /** PRODUCT-472 (wait-and-load): when the truck stopped waiting. Minutes beyond the fee product's free window bill per block. */
  waitingEndedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** PRODUCT-472 (wait-and-load): when the truck started waiting on site. */
  waitingStartedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type RouteStopComplete = {
  __typename: 'RouteStopComplete';
  /** COMPASS-1695: APPLIED when this call recorded the completion; ALREADY_COMPLETED when the stop was already done and nothing was written (an idempotent success). */
  outcome?: Maybe<StopCompletionOutcome>;
  /** COMPASS-1695: ORDER_ID when the order id sent named the live stop; STOP_IDENTITY when the server matched the physical stop instead (the order id was re-issued by a re-plan or unknown) - the client should re-key its local state onto `stop.orderId`. */
  resolvedBy?: Maybe<StopCompletionResolvedBy>;
  route?: Maybe<RouteType>;
  /** COMPASS-1695: the live stop the completion applied to (or found already done). */
  stop?: Maybe<PickUpOrderType>;
};

export type RouteStopSetNext = {
  __typename: 'RouteStopSetNext';
  route?: Maybe<RouteType>;
};

export type RouteStopSetNextDepot = {
  __typename: 'RouteStopSetNextDepot';
  route?: Maybe<RouteType>;
};

export type RouteStopsAdd = {
  __typename: 'RouteStopsAdd';
  /** Why the route could not be re-optimized after these stops were added; null when it was, or when the route does not auto-optimize. */
  optimizationError?: Maybe<Scalars['String']['output']>;
  route?: Maybe<RouteType>;
};

export type RouteStopsComplete = {
  __typename: 'RouteStopsComplete';
  errors?: Maybe<Array<Maybe<RouteStopsCompleteError>>>;
  route?: Maybe<RouteType>;
};

export type RouteStopsCompleteError = {
  __typename: 'RouteStopsCompleteError';
  error?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
};

export type RouteStopsInputType = {
  routeId: Scalars['ID']['input'];
  stops: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type RouteStopsMove = {
  __typename: 'RouteStopsMove';
  route?: Maybe<RouteType>;
};

export type RouteStopsOrder = {
  __typename: 'RouteStopsOrder';
  route?: Maybe<RouteType>;
};

export type RouteStopsSubscription = {
  __typename: 'RouteStopsSubscription';
  addedStops?: Maybe<Array<Maybe<PickUpOrderType>>>;
  removedStops?: Maybe<Array<Maybe<PickUpOrderType>>>;
  updatedStops?: Maybe<Array<Maybe<PickUpOrderType>>>;
};

export type RouteStopsUpdate = {
  __typename: 'RouteStopsUpdate';
  route?: Maybe<RouteType>;
};

/** An enumeration. */
export enum RouteStudioAutopilotActionStatusChoices {
  /** Applied */
  APPLIED = 'APPLIED',
  /** Refused */
  REFUSED = 'REFUSED',
  /** Rolled back */
  ROLLED_BACK = 'ROLLED_BACK'
}

/** An enumeration. */
export enum RouteStudioBaselineBaselineTypeChoices {
  /** Reconstruction */
  RECONSTRUCTION = 'RECONSTRUCTION',
  /** Replay */
  REPLAY = 'REPLAY'
}

/** An enumeration. */
export enum RouteStudioBrainRuleStatusChoices {
  /** Confirmed */
  CONFIRMED = 'CONFIRMED',
  /** Retired */
  RETIRED = 'RETIRED',
  /** Suggested */
  SUGGESTED = 'SUGGESTED'
}

/** An enumeration. */
export enum RouteStudioCandidateTableConfirmedClassChoices {
  /** Actuals log */
  ACTUALS_LOG = 'ACTUALS_LOG',
  /** Container list */
  CONTAINER_LIST = 'CONTAINER_LIST',
  /** Depot list */
  DEPOT_LIST = 'DEPOT_LIST',
  /** Holiday list */
  HOLIDAY_LIST = 'HOLIDAY_LIST',
  /** Id mapping */
  ID_MAPPING = 'ID_MAPPING',
  /** Route calendar */
  ROUTE_CALENDAR = 'ROUTE_CALENDAR',
  /** Route-vehicle assignment */
  ROUTE_VEHICLE_ASSIGNMENT = 'ROUTE_VEHICLE_ASSIGNMENT',
  /** Stop list */
  STOP_LIST = 'STOP_LIST',
  /** Unknown */
  UNKNOWN = 'UNKNOWN',
  /** Vehicle list */
  VEHICLE_LIST = 'VEHICLE_LIST',
  /** Year operations calendar */
  YEAR_OPERATIONS_CALENDAR = 'YEAR_OPERATIONS_CALENDAR'
}

/** An enumeration. */
export enum RouteStudioCandidateTableDocClassChoices {
  /** Actuals log */
  ACTUALS_LOG = 'ACTUALS_LOG',
  /** Container list */
  CONTAINER_LIST = 'CONTAINER_LIST',
  /** Depot list */
  DEPOT_LIST = 'DEPOT_LIST',
  /** Holiday list */
  HOLIDAY_LIST = 'HOLIDAY_LIST',
  /** Id mapping */
  ID_MAPPING = 'ID_MAPPING',
  /** Route calendar */
  ROUTE_CALENDAR = 'ROUTE_CALENDAR',
  /** Route-vehicle assignment */
  ROUTE_VEHICLE_ASSIGNMENT = 'ROUTE_VEHICLE_ASSIGNMENT',
  /** Stop list */
  STOP_LIST = 'STOP_LIST',
  /** Unknown */
  UNKNOWN = 'UNKNOWN',
  /** Vehicle list */
  VEHICLE_LIST = 'VEHICLE_LIST',
  /** Year operations calendar */
  YEAR_OPERATIONS_CALENDAR = 'YEAR_OPERATIONS_CALENDAR'
}

/** An enumeration. */
export enum RouteStudioCaseQuestionStatusChoices {
  /** Answered */
  ANSWERED = 'ANSWERED',
  /** Deferred */
  DEFERRED = 'DEFERRED',
  /** Open */
  OPEN = 'OPEN'
}

/** An enumeration. */
export enum RouteStudioCopilotMessageRoleChoices {
  /** Assistant */
  ASSISTANT = 'ASSISTANT',
  /** User */
  USER = 'USER'
}

/** An enumeration. */
export enum RouteStudioCopilotMessageStatusChoices {
  /** Blocked by numeral source-check */
  BLOCKED = 'BLOCKED',
  /** Budget reached */
  BUDGET_REACHED = 'BUDGET_REACHED',
  /** Ok */
  OK = 'OK',
  /** AI unavailable */
  UNAVAILABLE = 'UNAVAILABLE'
}

/** An enumeration. */
export enum RouteStudioCostModelRegionPackChoices {
  /** EU */
  EU = 'EU',
  /** Generic */
  GENERIC = 'GENERIC',
  /** Middle East */
  MIDDLE_EAST = 'MIDDLE_EAST',
  /** Nordic */
  NORDIC = 'NORDIC'
}

/** An enumeration. */
export enum RouteStudioCostModelSourceChoices {
  /** Engineering default */
  ENGINEERING_DEFAULT = 'ENGINEERING_DEFAULT',
  /** Tenant set */
  TENANT_SET = 'TENANT_SET'
}

/** An enumeration. */
export enum RouteStudioDynamicDayRunStatusChoices {
  /** Applied */
  APPLIED = 'APPLIED',
  /** Preview */
  PREVIEW = 'PREVIEW'
}

/**
 * SBX-380 (D08/D45): the activity surface. RouteStudioEvent rows
 * are written by every flow (promotions, sweeps, rates, dynamic
 * days); this Def makes them READABLE: timestamp, type, actor and
 * a defensively redacted payload summary. The raw payload column is
 * excluded; the summary is the only payload view that crosses
 * GraphQL.
 */
export type RouteStudioEventDef = Node & {
  __typename: 'RouteStudioEventDef';
  /** Who caused the event: {kind: 'user', user_id, name, by_action} for human actions, {kind: 'system', source} for beat/sweep-fired events (D35: system actions are attributable, never anonymous). */
  actor?: Maybe<Scalars['GenericScalar']['output']>;
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  createdByAction: Scalars['Boolean']['output'];
  /** The registered route_studio.* event name, exactly as emitted (RouteStudioEventType). */
  eventType: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** The event payload with sensitive-looking keys masked (defense in depth; payloads carry ids and audit facts, never secrets or personal data). */
  payloadSummary?: Maybe<Scalars['GenericScalar']['output']>;
  /** SBX-422 item 4 (wave D1): the planning area the event's payload references (payload planning_area_id), so activity rows can show their area, not only filter by it. Tenant-scoped: null when the payload names no area or names an area outside the event's own company. */
  planningArea?: Maybe<PlanningAreaDef>;
  source: Scalars['String']['output'];
};

export type RouteStudioEventDefConnection = {
  __typename: 'RouteStudioEventDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteStudioEventDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RouteStudioEventDef` and its cursor. */
export type RouteStudioEventDefEdge = {
  __typename: 'RouteStudioEventDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteStudioEventDef>;
};

/** An enumeration. */
export enum RouteStudioExplorationCandidateStatusChoices {
  /** Failed */
  FAILED = 'FAILED',
  /** Solved */
  SOLVED = 'SOLVED'
}

/** An enumeration. */
export enum RouteStudioExplorationRunStatusChoices {
  /** Complete */
  COMPLETE = 'COMPLETE',
  /** Failed */
  FAILED = 'FAILED',
  /** Running */
  RUNNING = 'RUNNING'
}

/**
 * SBX-366 (D32): a rendered, stored export document. The url is
 * the whole lifecycle (synchronous render onto the default file
 * storage, the export_import convention); the D32 claim-grade
 * labels and baseline caveats render IN the file itself.
 */
export type RouteStudioExportDef = {
  __typename: 'RouteStudioExportDef';
  /** xlsx | pdf. */
  fileFormat?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  /** Download url on the platform's file storage. */
  fileUrl?: Maybe<Scalars['String']['output']>;
  /** comparison | plan_summary | promotion_diff. */
  kind?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum RouteStudioFractionServiceBindingOriginChoices {
  /** Manual */
  MANUAL = 'MANUAL',
  /** Platform */
  PLATFORM = 'PLATFORM',
  /** Derived from case tables */
  TABLE_DERIVE = 'TABLE_DERIVE'
}

/** An enumeration. */
export enum RouteStudioGrammarClaimStatusChoices {
  /** Confirmed */
  CONFIRMED = 'CONFIRMED',
  /** Corrected */
  CORRECTED = 'CORRECTED',
  /** Proposed */
  PROPOSED = 'PROPOSED',
  /** Rejected */
  REJECTED = 'REJECTED'
}

/** An enumeration. */
export enum RouteStudioIdentityMapKindChoices {
  /** Container */
  CONTAINER = 'CONTAINER',
  /** Depot or facility */
  DEPOT = 'DEPOT',
  /** Route */
  ROUTE = 'ROUTE',
  /** Vehicle */
  VEHICLE = 'VEHICLE'
}

/** An enumeration. */
export enum RouteStudioIdentityMapResolutionChoices {
  /** Acknowledged missing on platform */
  ACKNOWLEDGED_MISSING = 'ACKNOWLEDGED_MISSING',
  /** Matched manually */
  MANUAL = 'MANUAL',
  /** Matched by geocode */
  MATCHED_GEOCODE = 'MATCHED_GEOCODE',
  /** Matched by name */
  MATCHED_NAME = 'MATCHED_NAME',
  /** Unresolved */
  UNRESOLVED = 'UNRESOLVED'
}

/** An enumeration. */
export enum RouteStudioImportBatchStatusChoices {
  /** Failed */
  FAILED = 'FAILED',
  /** Geocoded */
  GEOCODED = 'GEOCODED',
  /** Mapping confirmed */
  MAPPING_CONFIRMED = 'MAPPING_CONFIRMED',
  /** Mapping proposed */
  MAPPING_PROPOSED = 'MAPPING_PROPOSED',
  /** Parsed */
  PARSED = 'PARSED'
}

/** An enumeration. */
export enum RouteStudioImportCaseStatusChoices {
  /** Archived */
  ARCHIVED = 'ARCHIVED',
  /** Complete */
  COMPLETE = 'COMPLETE',
  /** Open */
  OPEN = 'OPEN'
}

/** An enumeration. */
export enum RouteStudioImportFileStatusChoices {
  /** Exploded */
  EXPLODED = 'EXPLODED',
  /** Failed */
  FAILED = 'FAILED',
  /** Received */
  RECEIVED = 'RECEIVED'
}

/** An enumeration. */
export enum RouteStudioImportIssueIssueTypeChoices {
  /** Duplicate */
  DUPLICATE = 'DUPLICATE',
  /** Extraction low confidence */
  EXTRACTION_LOW_CONFIDENCE = 'EXTRACTION_LOW_CONFIDENCE',
  /** Geocode low confidence */
  GEOCODE_LOW_CONFIDENCE = 'GEOCODE_LOW_CONFIDENCE',
  /** Invalid frequency */
  INVALID_FREQUENCY = 'INVALID_FREQUENCY',
  /** Unmapped column */
  UNMAPPED_COLUMN = 'UNMAPPED_COLUMN'
}

/** An enumeration. */
export enum RouteStudioImportIssueResolutionChoices {
  /** Accepted suggestion */
  ACCEPTED_SUGGESTION = 'ACCEPTED_SUGGESTION',
  /** Explicitly deferred */
  DEFERRED = 'DEFERRED',
  /** Dismissed */
  DISMISSED = 'DISMISSED',
  /** Manually corrected */
  MANUAL = 'MANUAL',
  /** Open */
  OPEN = 'OPEN'
}

/** An enumeration. */
export enum RouteStudioImportIssueVerdictChoices {
  /** Amber */
  AMBER = 'AMBER',
  /** Green */
  GREEN = 'GREEN',
  /** Red */
  RED = 'RED'
}

/** An enumeration. */
export enum RouteStudioManifestNodeRequirementChoices {
  /** Actuals (optional) */
  ACTUALS_OPTIONAL = 'ACTUALS_OPTIONAL',
  /** Route-vehicle assignments */
  ASSIGNMENTS = 'ASSIGNMENTS',
  /** Calendar or cadence */
  CALENDAR_CADENCE = 'CALENDAR_CADENCE',
  /** Containers with fractions */
  CONTAINERS_FRACTIONS = 'CONTAINERS_FRACTIONS',
  /** Depots and facilities */
  DEPOTS = 'DEPOTS',
  /** Route identities */
  ROUTE_IDENTITIES = 'ROUTE_IDENTITIES',
  /** Stops with locations */
  STOPS_LOCATIONS = 'STOPS_LOCATIONS',
  /** Vehicles */
  VEHICLES = 'VEHICLES'
}

/** An enumeration. */
export enum RouteStudioManifestNodeStatusChoices {
  /** Missing */
  MISSING = 'MISSING',
  /** Partially satisfied */
  PARTIAL = 'PARTIAL',
  /** Satisfied */
  SATISFIED = 'SATISFIED',
  /** Marked unavailable */
  UNAVAILABLE = 'UNAVAILABLE'
}

/** An enumeration. */
export enum RouteStudioMaterializedRunRunKindChoices {
  /** Coupled extra */
  COUPLED_EXTRA = 'COUPLED_EXTRA',
  /** Cycle run */
  CYCLE = 'CYCLE',
  /** Fixed-day run */
  FIXED_DAY = 'FIXED_DAY',
  /** Seasonal extra */
  SEASONAL_EXTRA = 'SEASONAL_EXTRA'
}

/** An enumeration. */
export enum RouteStudioNarrativeDocumentKindChoices {
  /** Board pack one-pager */
  BOARD_ONE_PAGER = 'BOARD_ONE_PAGER',
  /** Decision memo */
  DECISION_MEMO = 'DECISION_MEMO',
  /** Sensorization one-pager */
  SENSORIZATION_ONE_PAGER = 'SENSORIZATION_ONE_PAGER'
}

/** An enumeration. */
export enum RouteStudioNarrativeDocumentStatusChoices {
  /** Approved */
  APPROVED = 'APPROVED',
  /** Draft */
  DRAFT = 'DRAFT'
}

/** An enumeration. */
export enum RouteStudioNotificationPlanStateChoices {
  /** Drafted */
  DRAFTED = 'DRAFTED',
  /** Follow-up queued */
  FOLLOW_UP = 'FOLLOW_UP',
  /** Queued */
  QUEUED = 'QUEUED'
}

/** An enumeration. */
export enum RouteStudioPlanningAreaRegionPackChoices {
  /** EU */
  EU = 'EU',
  /** Generic */
  GENERIC = 'GENERIC',
  /** Middle East */
  MIDDLE_EAST = 'MIDDLE_EAST',
  /** Nordic */
  NORDIC = 'NORDIC'
}

/** An enumeration. */
export enum RouteStudioPromotionChannelChoices {
  /** Hauler change proposals */
  HAULER_PROPOSAL = 'HAULER_PROPOSAL',
  /** Office direct */
  OFFICE_DIRECT = 'OFFICE_DIRECT'
}

/** An enumeration. */
export enum RouteStudioPromotionSavingsWeekStatusChoices {
  /** Insufficient data */
  INSUFFICIENT_DATA = 'INSUFFICIENT_DATA',
  /** Partial data */
  PARTIAL = 'PARTIAL',
  /** Realized */
  REALIZED = 'REALIZED'
}

/** An enumeration. */
export enum RouteStudioPromotionStateChoices {
  /** Approved */
  APPROVED = 'APPROVED',
  /** Awaiting approval */
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  /** Cancelled */
  CANCELLED = 'CANCELLED',
  /** Diff ready */
  DIFF_READY = 'DIFF_READY',
  /** Draft */
  DRAFT = 'DRAFT',
  /** Live */
  LIVE = 'LIVE',
  /** Materializing */
  MATERIALIZING = 'MATERIALIZING',
  /** Partially live */
  PARTIALLY_LIVE = 'PARTIALLY_LIVE',
  /** Proposed */
  PROPOSED = 'PROPOSED',
  /** Rolled back */
  ROLLED_BACK = 'ROLLED_BACK',
  /** Scheduled */
  SCHEDULED = 'SCHEDULED',
  /** Superseded */
  SUPERSEDED = 'SUPERSEDED'
}

/** An enumeration. */
export enum RouteStudioRecommendationStateChoices {
  /** Accepted */
  ACCEPTED = 'ACCEPTED',
  /** Dismissed */
  DISMISSED = 'DISMISSED',
  /** New */
  NEW = 'NEW',
  /** Opened */
  OPENED = 'OPENED'
}

/** An enumeration. */
export enum RouteStudioScenarioObjectiveProfileChoices {
  /** Balanced crews */
  BALANCED_CREWS = 'BALANCED_CREWS',
  /** Custom */
  CUSTOM = 'CUSTOM',
  /** Fewest vehicles */
  FEWEST_VEHICLES = 'FEWEST_VEHICLES',
  /** Lowest CO2 */
  LOWEST_CO2 = 'LOWEST_CO2',
  /** Lowest cost */
  LOWEST_COST = 'LOWEST_COST',
  /** Minimal disruption */
  MINIMAL_DISRUPTION = 'MINIMAL_DISRUPTION'
}

/** An enumeration. */
export enum RouteStudioScenarioStatusChoices {
  /** Archived */
  ARCHIVED = 'ARCHIVED',
  /** Computed */
  COMPUTED = 'COMPUTED',
  /** Computing */
  COMPUTING = 'COMPUTING',
  /** Draft */
  DRAFT = 'DRAFT',
  /** Promoted */
  PROMOTED = 'PROMOTED'
}

/** An enumeration. */
export enum RouteStudioScenarioTemplateChoices {
  /** Depot or facility change */
  DEPOT_CHANGE = 'DEPOT_CHANGE',
  /** District merge/split */
  DISTRICT_MERGE_SPLIT = 'DISTRICT_MERGE_SPLIT',
  /** Electrification case */
  ELECTRIFICATION = 'ELECTRIFICATION',
  /** Fleet change */
  FLEET_CHANGE = 'FLEET_CHANGE',
  /** Free-form */
  FREE_FORM = 'FREE_FORM',
  /** Frequency change */
  FREQUENCY_CHANGE = 'FREQUENCY_CHANGE',
  /** Master plan */
  MASTER_PLAN = 'MASTER_PLAN',
  /** New contract absorption */
  NEW_CONTRACT = 'NEW_CONTRACT',
  /** New development absorption */
  NEW_DEVELOPMENT = 'NEW_DEVELOPMENT',
  /** Operating hours change */
  OPERATING_HOURS_CHANGE = 'OPERATING_HOURS_CHANGE',
  /** Seasonal plan */
  SEASONAL_PLAN = 'SEASONAL_PLAN',
  /** Sensorization case */
  SENSORIZATION = 'SENSORIZATION',
  /** Vehicle type switch */
  VEHICLE_TYPE_SWITCH = 'VEHICLE_TYPE_SWITCH'
}

/** An enumeration. */
export enum RouteStudioServiceUnitSideChoices {
  /** Both */
  BOTH = 'BOTH',
  /** Left */
  LEFT = 'LEFT',
  /** Right */
  RIGHT = 'RIGHT'
}

/** An enumeration. */
export enum RouteStudioSimulationJobStateChoices {
  /** Canceled */
  CANCELED = 'CANCELED',
  /** Done */
  DONE = 'DONE',
  /** Explaining */
  EXPLAINING = 'EXPLAINING',
  /** Failed */
  FAILED = 'FAILED',
  /** Matrix */
  MATRIX = 'MATRIX',
  /** Queued */
  QUEUED = 'QUEUED',
  /** Scoring */
  SCORING = 'SCORING',
  /** Solving */
  SOLVING = 'SOLVING'
}

/** An enumeration. */
export enum RouteStudioSourceMetricVerdictChoices {
  /** Discrepant */
  DISCREPANT = 'DISCREPANT',
  /** Match */
  MATCH = 'MATCH',
  /** Observation */
  OBSERVATION = 'OBSERVATION'
}

/** An enumeration. */
export enum RouteStudioStopSetSourceChoices {
  /** Drawn boundary */
  DRAWN = 'DRAWN',
  /** Import batch */
  IMPORT = 'IMPORT',
  /** Live entities */
  LIVE_ENTITIES = 'LIVE_ENTITIES'
}

/** An enumeration. */
export enum RouteStudioValidationVerdictVerdictChoices {
  /** Confirmed */
  CONFIRMED = 'CONFIRMED',
  /** Flagged */
  FLAGGED = 'FLAGGED'
}

export type RouteSubscription = {
  __typename: 'RouteSubscription';
  event?: Maybe<Scalars['String']['output']>;
  route?: Maybe<RouteType>;
};

/**
 * The driver-app stop transfer, in both assistance directions.
 *
 * Reuses the office stop-move body (``_move_stops_between_routes``) but
 * authorizes a driver the way every other driver-app route mutation is
 * authorized — by what they are actually working, not by an office
 * permission string.
 *
 * COMPASS-1592: this used to call ``RouteStopsMove().mutate()``, which
 * enforces ``route__edit``. That is an OFFICE permission;
 * ``CONTRACTOR_DRIVER_PERMISSIONS`` is empty by design and a pure driver
 * account has no role at all, so ``check_permission`` denied EVERY driver
 * here — the scheme flag was checked, passed, and then the role check
 * killed the move one frame later. Both Request Assistance and Assist
 * Driver failed for real drivers no matter what the route scheme said.
 * Same shape as COMPASS-1046 on ``routeStopsOrder`` (see the comment in
 * ``RouteStopsOrder.mutate``).
 *
 * Non-driver callers keep the legacy path verbatim — the target scheme's
 * ``allow_driver_to_take_stops`` plus ``route__edit`` — so nothing that
 * could reach this mutation before loses access.
 */
export type RouteTakeStops = {
  __typename: 'RouteTakeStops';
  route?: Maybe<RouteType>;
};

export type RouteTrip = {
  __typename: 'RouteTrip';
  current?: Maybe<Scalars['Boolean']['output']>;
  stops?: Maybe<Array<Maybe<PickUpOrderType>>>;
};

export type RouteType = Node & {
  __typename: 'RouteType';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<UserType>;
  archivedByRule?: Maybe<ArchivalRuleDef>;
  autoComplete: Scalars['Boolean']['output'];
  autoCompleteNextStop: Scalars['Boolean']['output'];
  autoOptimize: Scalars['Boolean']['output'];
  availableAutoCompleteContainers?: Maybe<Array<Maybe<ContainerType>>>;
  canBeReset?: Maybe<Scalars['Boolean']['output']>;
  /** The generated route (driving list) whose series the change targets. PROTECT keeps the audit trail intact — routes are soft-deleted in practice. */
  changeProposals: ChangeProposalDefConnection;
  comment?: Maybe<CommentType>;
  /** DateTime on which this route was finished by driver */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedStopsCount?: Maybe<Scalars['Int']['output']>;
  /** Route the signal was resolved against. NULL when no active route could be found — the signal is still recorded. */
  confirmationSignals: VehicleConfirmationSignalTypeConnection;
  /** COMPASS-1287: offline-reuse change marker — the most recent of this route's own updatedAt and the updatedAt of any of its stops (soft-deleted stops included, so the marker is monotonic). Unlike updatedAt it bumps on count-preserving dispatcher edits (stop reorder, address swap, instruction edit), so the app can replace count-only equality with an exact comparison and safely skip genuinely-unchanged routes on the full re-download. NULL only for a route with no saved timestamp at all. List surfaces (driverOfflinePackage, allRoutes) annotate the page so this stays one query; a single-route read falls back to one cheap indexed aggregate. */
  contentUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The contract areas this route serves, derived from its stops (the W6 contract_area FK where stamped, legacy area FK fallback) — same rule as the allRoutes contractAreas filter, including that filter's treatment of soft-deleted stops. Ordered by code then name. Empty when the route has no stops or its stops carry no area link. One query per route: a list surface must annotate the page before selecting it. */
  contractAreas: Array<AreaDef>;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** SBX-496: non-null when this route fires inside a standing collection-calendar deviation window naming its scheme's container calendars (kind 'deviation_window', with the recorded destination dates), or on a day receiving those moved collections (kind 'receiving_window'). Carries a planner sentence with explicit dates; derived from the one deviation derivation the calendar surfaces consume, so this listing and the calendar can never disagree. */
  deviation?: Maybe<Scalars['GenericScalar']['output']>;
  driverpushnotificationSet: DriverPushNotificationTypeConnection;
  /** COMPASS-882 / HSY REQ 37 — the 'separately defined number of metres' in force for this route's stops, already RESOLVED: the single in-force contract area's completionRadiusMeters when there is exactly one, otherwise null so the caller falls back to the scheme's autoCompleteDistance and then to the 50 m platform default (the same chain the server itself applies in routes.services.gps_range_exception). Exposed because AreaDef.completionRadiusMeters is deliberately hidden from hauler users — a resolved integer leaks no contract configuration, and without it an offline device cannot know which radius to hold a driver to. Computed per call (one stops query + one areas query): select it on a route detail, not on a long listing. */
  effectiveCompletionRadius?: Maybe<Scalars['Int']['output']>;
  efficiency?: Maybe<Scalars['Float']['output']>;
  /** SBX-529 item 8: non-null exactly when this generated run holds no stops: {code, text, containers} naming the honest recorded reason (scheme_missing, planned_containers_mode, ticket_collection_mode, scheme_has_no_containers, stops_on_sibling_runs, stop_list_never_built) with a planner sentence. Serves the why beside every counted empty run, so 'the platform did not say why' never renders again. */
  emptyReason?: Maybe<Scalars['GenericScalar']['output']>;
  /** Approximated time on which this route will be finished by driver */
  endTime?: Maybe<Scalars['Time']['output']>;
  eventLog?: Maybe<RouteEventLogEventWrapper>;
  exceptionReason: Scalars['String']['output'];
  /** The container codes this route also sweeps, shown alongside routeCode, in order — subRouteCodes minus the one already shown as routeCode, and only for routes HRA allows to be multi-code (the 1701–1710 / 1801–1810 crew lines, the 50000–70000 ekstra/spesial series and the Glass+Plast merges — COMPASS-1379). A multi-code route (e.g. the 50008 papp-ekstra route collecting bins coded 808 and 408) lists them all; a route labelled by its own dominant code drops that code so it is not printed twice; an ordinary district route gets an empty list however its containers are coded. Computed server-side; the app renders it verbatim. */
  extraRouteCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** COMPASS-1765: where this route stands against its template — applied, diverged (re-optimised or template edited since), or needing attention (stops the template never sequenced). Reads the route's stops, so it is for the route detail page, not a list column. Null with Fixed Routes off. */
  fixedRouteState?: Maybe<FixedRouteOrderStateType>;
  /** COMPASS-1765: templates of OTHER schemes that already order most of this route, for a scheme that has no template yet — adopt one with fixedRouteTemplateAdopt instead of sequencing the round again. Empty when the scheme already has a template or Fixed Routes is off. */
  fixedRouteSuggestions?: Maybe<Array<FixedRouteTemplateSuggestionType>>;
  /** COMPASS-1765: the pinned stop order governing this route — the template held for its route scheme. Normally one scheme-wide row covering every route the scheme generates, whatever truck the solver assigned; a row made for this exact truck wins over it. Null when the company has Fixed Routes switched off, when the route belongs to no scheme, or when nobody has made a template for that scheme yet. */
  fixedRouteTemplate?: Maybe<FixedRouteTemplateType>;
  /** COMPASS-1765: cheap list-column status of the template this route is BOUND to: none | draft | ready | active. One lookup, no stop reads; use fixedRouteState for the measured order state on a detail page. Null with Fixed Routes off. */
  fixedRouteTemplateStatus?: Maybe<Scalars['String']['output']>;
  /** COMPASS-1765: every template variant held for this route's scheme, active first, then by last edit. Empty with Fixed Routes off or no scheme. */
  fixedRouteTemplates?: Maybe<Array<FixedRouteTemplateType>>;
  /** COMPASS-1765 library: how many container stops of this route the template does NOT order - the given variant, or the one that governs the route. 0 = the template covers the route and a bulk Apply will re-sequence it; > 0 = a bulk Apply skips it. Null with Fixed Routes off, no scheme or no template. */
  fixedRouteUncoveredStops?: Maybe<Scalars['Int']['output']>;
  hauler?: Maybe<HaulerDef>;
  haulerReassignmentLogs: RouteHaulerReassignmentLogTypeConnection;
  historicLocations?: Maybe<Array<Maybe<RouteLocationHistoryDef>>>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  informations?: Maybe<RouteInformationTypeConnection>;
  isEmergency: Scalars['Boolean']['output'];
  /** Chained pallet/compactor confirmations on this route (COMPASS-886). Pass pending: true for the loads currently ON THE TRUCK — loaded or emptied but not yet unloaded — which is the set REQ 264 asks to be displayed as pending. */
  loadUnitJobs?: Maybe<Array<LoadUnitJobType>>;
  locked: Scalars['Boolean']['output'];
  lockedStart: Scalars['Boolean']['output'];
  migratedFromId?: Maybe<Scalars['String']['output']>;
  nextStop?: Maybe<PickUpOrderType>;
  project: ProjectType;
  rating?: Maybe<Scalars['Int']['output']>;
  /** Real distance (m) */
  realDistance: Scalars['Float']['output'];
  /** True while a re-optimisation of this route is still running (any trigger: driver set-next, office Optimize, stop changes). The stop order read while this is true will still change; the driver app keeps its 'Updating route' bar up until it is false. */
  recalculationPending?: Maybe<Scalars['Boolean']['output']>;
  /** The single code a driver identifies this route by — the label the driver app shows. Computed server-side (routes.route_code.pick_route_code): a whitelist route (1701–1710 / 1801–1810 / 50000–70000 series) is labelled by its own route number; every other route by its dominant subRouteCode, i.e. the day code of a combined Glass+Plast scheme. The app renders this verbatim and carries no route-code logic of its own. */
  routeCode?: Maybe<Scalars['String']['output']>;
  routeScheme?: Maybe<RouteSchemeType>;
  /** Route on which driver drives the vehicle */
  routeVehicles: RouteVehicleTypeConnection;
  routeexportSet: RouteExportTypeConnection;
  routelocationhistorySet: RouteLocationHistoryDefConnection;
  routeproblemSet: RouteProblemDefConnection;
  routeschemeSet: RouteSchemeTypeConnection;
  /** Date on which this route is planned */
  scheduledDay?: Maybe<Scalars['Date']['output']>;
  searchUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Approximated time on which this route will be started by driver */
  startTime?: Maybe<Scalars['Time']['output']>;
  /** DateTime on which this route was started by driver */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *             Indicates the current status of the route. Not enough data is signified by the 'unknown' status.
   *             Can hold one of the following string values: 'pending', 'completed', 'working', 'not-working', 'unknown'
   *
   */
  status?: Maybe<Scalars['String']['output']>;
  stops?: Maybe<PickUpOrderTypeConnection>;
  stopsCount?: Maybe<Scalars['Int']['output']>;
  /** Distinct external route codes (Container.external_route_code) of the containers planned on this route, most frequent first — e.g. HRA's day code '104' identifying which half of a combined scheme fires that day. */
  subRouteCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  taskHaulerReassignmentsFrom: TaskHaulerReassignmentLogTypeConnection;
  taskHaulerReassignmentsTo: TaskHaulerReassignmentLogTypeConnection;
  totalCollectedWeight?: Maybe<Scalars['Float']['output']>;
  /** Approximated distance (m) */
  totalDistance?: Maybe<Scalars['Float']['output']>;
  totalDuration?: Maybe<Scalars['Int']['output']>;
  /** Approximated traveled distance (m) */
  totalTraveledDistance?: Maybe<Scalars['Float']['output']>;
  totalTraveledDuration?: Maybe<Scalars['Int']['output']>;
  totalVolume?: Maybe<Scalars['Float']['output']>;
  trips?: Maybe<Array<Maybe<RouteTrip>>>;
  unloadingStations: DepotTypeConnection;
  updatedAt: Scalars['DateTime']['output'];
  useTurnByTurn?: Maybe<Scalars['Boolean']['output']>;
  /** Vehicles that can be used in the route and is defined in the route scheme. Used to keep track of the vehicles that can be used in the route. Which in its turn is used to know which drivers can be assigned to the route depending on vehicles they can drive. */
  vehiclesFromRouteScheme: VehicleTypeConnection;
  wasteFractions?: Maybe<Array<Maybe<WasteFractionType>>>;
  workTaskCorrectionsFrom: WorkTaskCorrectionTypeConnection;
  workTaskCorrectionsTo: WorkTaskCorrectionTypeConnection;
};


export type RouteTypeAvailableAutoCompleteContainersArgs = {
  bbox?: InputMaybe<BBoxInput>;
};


export type RouteTypeChangeProposalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteTypeConfirmationSignalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteTypeDriverpushnotificationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteTypeEventLogArgs = {
  addPickupOrdersEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addRouteEvents?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pickupOrderEventTypes?: InputMaybe<Array<InputMaybe<PickUpOrderEventTypesGraphene>>>;
  routeEventTypes?: InputMaybe<Array<InputMaybe<RouteEventTypesGraphene>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type RouteTypeFixedRouteSuggestionsArgs = {
  minCoverage?: InputMaybe<Scalars['Float']['input']>;
};


export type RouteTypeFixedRouteTemplateArgs = {
  templateId?: InputMaybe<Scalars['ID']['input']>;
};


export type RouteTypeFixedRouteUncoveredStopsArgs = {
  templateId?: InputMaybe<Scalars['ID']['input']>;
};


export type RouteTypeHaulerReassignmentLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteTypeHistoricLocationsArgs = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  latestOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RouteTypeInformationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteTypeLoadUnitJobsArgs = {
  pending?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RouteTypeRouteVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteTypeRouteexportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteTypeRoutelocationhistorySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteTypeRouteproblemSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteTypeRouteschemeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteTypeStopsArgs = {
  acknowledgementType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  approvalCollection?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  bbox?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionCalendarIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  completeApproval?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  container?: InputMaybe<Scalars['ID']['input']>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerPickupSettings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  container_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  container_PickupMethod?: InputMaybe<Scalars['String']['input']>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdInquiry?: InputMaybe<Scalars['ID']['input']>;
  createdInquiry_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdInquiry_Status?: InputMaybe<Scalars['String']['input']>;
  createdTicketsTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  depotIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeOrderTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalPropertyNumber?: InputMaybe<Scalars['String']['input']>;
  fillLevel_Gte?: InputMaybe<Scalars['Float']['input']>;
  fillLevel_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  fillLevel_Lte?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isUnloading?: InputMaybe<Scalars['Boolean']['input']>;
  isUnloadingPending?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lifecycleIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  noApproval?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderType_Icontains?: InputMaybe<Scalars['String']['input']>;
  pendingApproval?: InputMaybe<Scalars['Boolean']['input']>;
  polygonSelection?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>>>>>;
  propertyGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  route?: InputMaybe<Scalars['ID']['input']>;
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routeScheduledDayGte?: InputMaybe<Scalars['Date']['input']>;
  routeScheduledDayLte?: InputMaybe<Scalars['Date']['input']>;
  route_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stopStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketAssigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketAssigneeTeams?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketCreatedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketOrContainerIsnull?: InputMaybe<Scalars['Boolean']['input']>;
  ticketPriority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketReportedByPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  ticketReporterByDriver?: InputMaybe<Scalars['Boolean']['input']>;
  ticketRequestedByPortal?: InputMaybe<Scalars['Boolean']['input']>;
  ticketStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticket_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RouteTypeTaskHaulerReassignmentsFromArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteTypeTaskHaulerReassignmentsToArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteTypeUnloadingStationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteTypeVehiclesFromRouteSchemeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteTypeWorkTaskCorrectionsFromArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteTypeWorkTaskCorrectionsToArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteTypeConnection = {
  __typename: 'RouteTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RouteType` and its cursor. */
export type RouteTypeEdge = {
  __typename: 'RouteTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteType>;
};

export type RouteUnComplete = {
  __typename: 'RouteUnComplete';
  route?: Maybe<RouteType>;
};

/**
 * Turn automatic confirmation on/off for a route (COMPASS-880 / REQ 31).
 *
 * The driver-facing half of REQ 31's automatic confirmation: the server-side
 * gate is ``route.auto_complete and <the breadcrumb's auto_complete flag>``
 * (``fleet_management/schema.py``), and this mutation is the ONLY way to set
 * the first operand. Without it a driver can switch "Auto-complete" on in
 * the app, watch it light up, and have nothing happen — forever, silently —
 * on any route whose scheme left ``default_auto_complete`` False.
 *
 * Deliberately driver-callable: ``@login_required`` plus the caller's
 * company scope, and NOT ``assert_office_user`` — the setting belongs to the
 * person in the truck. It is registered as ``SET_AUTO_COMPLETE`` in
 * ``routes/schema/offline_sync.py`` so the toggle survives a dead spot.
 */
export type RouteUpdateAutoComplete = {
  __typename: 'RouteUpdateAutoComplete';
  route?: Maybe<RouteType>;
};

export type RouteUpdateAutoCompleteNextStop = {
  __typename: 'RouteUpdateAutoCompleteNextStop';
  route?: Maybe<RouteType>;
};

export type RouteUpdateAutoOptimize = {
  __typename: 'RouteUpdateAutoOptimize';
  route?: Maybe<RouteType>;
};

export type RouteUpdateContainerGroupLocation = {
  __typename: 'RouteUpdateContainerGroupLocation';
  containerGroup?: Maybe<ContainerGroupDef>;
};

export type RouteUpdateContainerLocation = {
  __typename: 'RouteUpdateContainerLocation';
  container?: Maybe<ContainerType>;
};

/**
 * COMPASS-272: flag a route as emergency / exception.
 *
 * Intended for dispatcher / back-office users; drivers cannot promote
 * their own routes (enforced via ``CompanyRolePermission.check_edit``).
 */
export type RouteUpdateEmergency = {
  __typename: 'RouteUpdateEmergency';
  route?: Maybe<RouteType>;
};

export type RouteUpdateLocked = {
  __typename: 'RouteUpdateLocked';
  route?: Maybe<RouteType>;
};

export type RouteUpdateLockedStart = {
  __typename: 'RouteUpdateLockedStart';
  route?: Maybe<RouteType>;
};

/** This mutation is obsolete and has been deprecated. Use `RouteUpdateRouteVehicleGeneric` instead. */
export type RouteUpdateRouteVehicle = {
  __typename: 'RouteUpdateRouteVehicle';
  route?: Maybe<RouteType>;
};

export type RouteUpdateRouteVehicleDriver = {
  __typename: 'RouteUpdateRouteVehicleDriver';
  route?: Maybe<RouteType>;
};

export type RouteUpdateRouteVehicleGeneric = {
  __typename: 'RouteUpdateRouteVehicleGeneric';
  route?: Maybe<RouteType>;
};

/** This mutation is obsolete and has been deprecated. Use `RouteUpdateRouteVehicleGeneric` instead. */
export type RouteUpdateRouteVehicleMobileApp = {
  __typename: 'RouteUpdateRouteVehicleMobileApp';
  route?: Maybe<RouteType>;
};

export type RouteUpdateRouteVehicleTrailer = {
  __typename: 'RouteUpdateRouteVehicleTrailer';
  route?: Maybe<RouteType>;
};

export type RouteVehicleDriverReassignmentLogType = Node & {
  __typename: 'RouteVehicleDriverReassignmentLogType';
  fromDriver: DriverType;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  reassignedAt: Scalars['DateTime']['output'];
  reassignedBy: UserType;
  routeVehicle: RouteVehicleType;
  toDriver: DriverType;
};

export type RouteVehicleDriverReassignmentLogTypeConnection = {
  __typename: 'RouteVehicleDriverReassignmentLogTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteVehicleDriverReassignmentLogTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RouteVehicleDriverReassignmentLogType` and its cursor. */
export type RouteVehicleDriverReassignmentLogTypeEdge = {
  __typename: 'RouteVehicleDriverReassignmentLogTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteVehicleDriverReassignmentLogType>;
};

export type RouteVehicleEventDef = Node & {
  __typename: 'RouteVehicleEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fromDriver?: Maybe<DriverType>;
  fromIsPrimary?: Maybe<Scalars['Boolean']['output']>;
  fromVehicle?: Maybe<VehicleType>;
  fromVehicleTrailer?: Maybe<VehicleTrailerType>;
  fromVehicleTrailerCapacityMode?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  routeVehicle?: Maybe<RouteVehicleType>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toDriver?: Maybe<DriverType>;
  toIsPrimary?: Maybe<Scalars['Boolean']['output']>;
  toVehicle?: Maybe<VehicleType>;
  toVehicleTrailer?: Maybe<VehicleTrailerType>;
  toVehicleTrailerCapacityMode?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
};

export type RouteVehicleEventLogEvent = RouteVehicleEventDef;

export type RouteVehicleEventLogEventWrapper = {
  __typename: 'RouteVehicleEventLogEventWrapper';
  edges?: Maybe<Array<Maybe<RouteVehicleEventLogEvent>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum RouteVehicleEventTypesGraphene {
  DRIVER_CHANGE = 'DRIVER_CHANGE',
  IS_PRIMARY_CHANGE = 'IS_PRIMARY_CHANGE',
  VEHICLE_CHANGE = 'VEHICLE_CHANGE',
  VEHICLE_TRAILER_CAPACITY_MODE_CHANGE = 'VEHICLE_TRAILER_CAPACITY_MODE_CHANGE',
  VEHICLE_TRAILER_CHANGE = 'VEHICLE_TRAILER_CHANGE'
}

export type RouteVehicleSessionType = Node & {
  __typename: 'RouteVehicleSessionType';
  /** Vehicle on which driver actually was during the session */
  actualVehicle?: Maybe<VehicleType>;
  /** Date and time on which driver stopped driving the vehicle on the route */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** Arbitrary description of the vehicle session */
  description?: Maybe<Scalars['String']['output']>;
  /** Driver to whom the session belongs */
  driver: DriverType;
  /** Vehicle session when the stop was completed by a driver */
  endedStops: PickUpOrderTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastActive?: Maybe<Scalars['DateTime']['output']>;
  /** Real distance for the session (m) */
  realDistance: Scalars['Float']['output'];
  /** Vehicle that is used in the route */
  routeVehicle: RouteVehicleType;
  /** Date and time on which driver started driving the vehicle on the route. Can be considered as creation time of the session (i.e. used for ordering) */
  startedAt: Scalars['DateTime']['output'];
  /** Vehicle session when the stop was added by a driver */
  startedStops: PickUpOrderTypeConnection;
};


export type RouteVehicleSessionTypeEndedStopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RouteVehicleSessionTypeStartedStopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteVehicleSessionTypeConnection = {
  __typename: 'RouteVehicleSessionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteVehicleSessionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RouteVehicleSessionType` and its cursor. */
export type RouteVehicleSessionTypeEdge = {
  __typename: 'RouteVehicleSessionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteVehicleSessionType>;
};

/** Complete route vehicle sessions in bulk */
export type RouteVehicleSessionsComplete = {
  __typename: 'RouteVehicleSessionsComplete';
  route?: Maybe<RouteType>;
  routeVehicleSessions?: Maybe<Array<Maybe<RouteVehicleSessionType>>>;
};

/** Complete all active route vehicle sessions in bulk for a driver */
export type RouteVehicleSessionsCompleteForDriver = {
  __typename: 'RouteVehicleSessionsCompleteForDriver';
  driver?: Maybe<DriverType>;
};

export type RouteVehicleType = Node & {
  __typename: 'RouteVehicleType';
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** Drivers that drives the vehicle on the route */
  driver: DriverType;
  eventLog?: Maybe<RouteVehicleEventLogEventWrapper>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Is set to True if it is the only vehicle on the route or if it was added to the route first when generating the route */
  isPrimary: Scalars['Boolean']['output'];
  reassignmentLogs: RouteVehicleDriverReassignmentLogTypeConnection;
  /** Route on which driver drives the vehicle */
  route: RouteType;
  routeVehicleSessions?: Maybe<Array<Maybe<RouteVehicleSessionType>>>;
  updatedAt: Scalars['DateTime']['output'];
  /** Vehicle that is used in the route */
  vehicle: VehicleType;
  vehicleTrailer?: Maybe<VehicleTrailerType>;
  vehicleTrailerCapacityMode: RoutesRouteVehicleVehicleTrailerCapacityModeChoices;
};


export type RouteVehicleTypeEventLogArgs = {
  addRouteVehicleEvents?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  routeVehicleEventTypes?: InputMaybe<Array<InputMaybe<RouteVehicleEventTypesGraphene>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type RouteVehicleTypeReassignmentLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteVehicleTypeConnection = {
  __typename: 'RouteVehicleTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteVehicleTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RouteVehicleType` and its cursor. */
export type RouteVehicleTypeEdge = {
  __typename: 'RouteVehicleTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteVehicleType>;
};

/** An enumeration. */
export enum RoutesBonusModelBasisChoices {
  /** Complaints per emptying */
  COMPLAINTS_PER_EMPTYINGS = 'COMPLAINTS_PER_EMPTYINGS',
  /** Custom metered metric */
  CUSTOM_METERED = 'CUSTOM_METERED',
  /** Reliability % */
  RELIABILITY = 'RELIABILITY'
}

/** An enumeration. */
export enum RoutesBonusModelStructureChoices {
  /** Bonus only */
  BONUS_ONLY = 'BONUS_ONLY',
  /** Bonus and penalty */
  BONUS_PENALTY = 'BONUS_PENALTY',
  /** Penalty only */
  PENALTY_ONLY = 'PENALTY_ONLY'
}

/** An enumeration. */
export enum RoutesBonusModelTaskTypeChoices {
  /** Break */
  BREAK = 'BREAK',
  /** Depot */
  DEPOT = 'DEPOT',
  /** Move container */
  MOVE = 'MOVE',
  /** Return container */
  RETURN = 'RETURN',
  /** Task */
  TASK = 'TASK',
  /** Ticket */
  TICKET = 'TICKET'
}

/** An enumeration. */
export enum RoutesCollectionCalendarDeterminePeriodByChoices {
  /** Month and date */
  MONTH_AND_DATE = 'MONTH_AND_DATE',
  /** Week number */
  WEEK_NUMBER = 'WEEK_NUMBER'
}

/** An enumeration. */
export enum RoutesCollectionInquiryIssueTypeChoices {
  /** Bulky waste */
  BULKY_WASTE = 'BULKY_WASTE',
  /** Damaged */
  DAMAGED = 'DAMAGED',
  /** Mis-sorted waste */
  MISSORTED = 'MISSORTED',
  /** Others */
  OTHERS = 'OTHERS',
  /** Overflowing */
  OVERFLOWING = 'OVERFLOWING'
}

/** An enumeration. */
export enum RoutesCollectionInquiryTypingStatusChoices {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Disabled */
  DISABLED = 'DISABLED'
}

/** An enumeration. */
export enum RoutesLoadStatusChoices {
  /** Cancelled */
  CANCELLED = 'CANCELLED',
  /** Closed */
  CLOSED = 'CLOSED',
  /** Open */
  OPEN = 'OPEN'
}

/** An enumeration. */
export enum RoutesLoadUnitJobStatusChoices {
  /** Cancelled */
  CANCELLED = 'CANCELLED',
  /** Emptied */
  EMPTIED = 'EMPTIED',
  /** Loaded */
  LOADED = 'LOADED',
  /** Unloaded */
  UNLOADED = 'UNLOADED'
}

/** An enumeration. */
export enum RoutesLoadUnitJobUnitTypeChoices {
  /** Compactor */
  COMPACTOR = 'COMPACTOR',
  /** Other load unit */
  OTHER = 'OTHER',
  /** Pallet */
  PALLET = 'PALLET',
  /** Skip / roll-off container */
  SKIP = 'SKIP'
}

/** An enumeration. */
export enum RoutesPickUpOrderAbortiveReasonChoices {
  /** Access blocked */
  ACCESS_BLOCKED = 'ACCESS_BLOCKED',
  /** Customer absent */
  CUSTOMER_ABSENT = 'CUSTOMER_ABSENT',
  /** Other */
  OTHER = 'OTHER',
  /** Overloaded */
  OVERLOADED = 'OVERLOADED',
  /** Permit missing */
  PERMIT_MISSING = 'PERMIT_MISSING',
  /** Prohibited items */
  PROHIBITED_ITEMS = 'PROHIBITED_ITEMS'
}

/** An enumeration. */
export enum RoutesPickUpOrderAutoCompletedByChoices {
  /** external */
  EXTERNAL = 'EXTERNAL',
  /** lift */
  LIFT = 'LIFT',
  /** manual */
  MANUAL = 'MANUAL',
  /** nfc */
  NFC = 'NFC',
  /** radius */
  RADIUS = 'RADIUS',
  /** rfid */
  RFID = 'RFID',
  /** scale */
  SCALE = 'SCALE'
}

/** An enumeration. */
export enum RoutesPickUpOrderCompletionDistanceSourceChoices {
  /** Server GPS breadcrumb */
  BREADCRUMB = 'BREADCRUMB',
  /** Client-reported position */
  CLIENT = 'CLIENT',
  /** Client-reported distance */
  CLIENT_REPORTED = 'CLIENT_REPORTED'
}

/** An enumeration. */
export enum RoutesPickUpOrderCreatedFromChoices {
  /** Dynamic */
  DYNAMIC = 'DYNAMIC',
  /** Manual */
  MANUAL = 'MANUAL',
  /** Semi-dynamic */
  SEMI_DYNAMIC = 'SEMI_DYNAMIC',
  /** Sensor */
  SENSOR = 'SENSOR',
  /** static */
  STATIC = 'STATIC'
}

/** An enumeration. */
export enum RoutesPickUpOrderDetachedReasonChoices {
  /** Re-plan replaced this depot visit */
  SOLVER_DEPOT_LEG = 'SOLVER_DEPOT_LEG',
  /** Re-plan did not assign this stop to the route */
  SOLVER_UNPLANNED = 'SOLVER_UNPLANNED'
}

/** An enumeration. */
export enum RoutesPickUpOrderDistanceVerificationReasonChoices {
  /** Collected from another point */
  COLLECTED_FROM_ANOTHER_POINT = 'COLLECTED_FROM_ANOTHER_POINT',
  /** GPS interference */
  GPS_INTERFERENCE = 'GPS_INTERFERENCE',
  /** GPS unavailable */
  GPS_UNAVAILABLE = 'GPS_UNAVAILABLE',
  /** No safe access */
  NO_SAFE_ACCESS = 'NO_SAFE_ACCESS',
  /** Other */
  OTHER = 'OTHER'
}

/** An enumeration. */
export enum RoutesPickUpOrderDistanceVerificationTriggerChoices {
  /** No position available */
  NO_POSITION = 'NO_POSITION',
  /** Outside the completion radius */
  OUT_OF_RANGE = 'OUT_OF_RANGE',
  /** Position too old to trust */
  STALE_POSITION = 'STALE_POSITION'
}

/** An enumeration. */
export enum RoutesPickUpOrderSkipReasonChoices {
  /** Access blocked */
  ACCESS_BLOCKED = 'ACCESS_BLOCKED',
  /** Bin damaged */
  BIN_DAMAGED = 'BIN_DAMAGED',
  /** Contaminated */
  CONTAMINATED = 'CONTAMINATED',
  /** Crew error */
  CREW_ERROR = 'CREW_ERROR',
  /** Frozen / jammed */
  FROZEN_JAMMED = 'FROZEN_JAMMED',
  /** Cancelled — public holiday */
  HOLIDAY_CANCELLED = 'HOLIDAY_CANCELLED',
  /** Not presented */
  NOT_PRESENTED = 'NOT_PRESENTED',
  /** Other */
  OTHER = 'OTHER',
  /** Overfilled */
  OVERFILLED = 'OVERFILLED',
  /** Roadworks / road closed */
  ROADWORKS = 'ROADWORKS',
  /** Safety concern */
  SAFETY = 'SAFETY',
  /** Too far from road */
  TOO_FAR_FROM_ROAD = 'TOO_FAR_FROM_ROAD',
  /** Too heavy */
  TOO_HEAVY = 'TOO_HEAVY',
  /** Vehicle breakdown */
  VEHICLE_BREAKDOWN = 'VEHICLE_BREAKDOWN',
  /** Weather */
  WEATHER = 'WEATHER',
  /** Wrong orientation */
  WRONG_ORIENTATION = 'WRONG_ORIENTATION'
}

/** An enumeration. */
export enum RoutesPickUpOrderStatusChoices {
  /** Completed */
  COMPLETED = 'COMPLETED',
  /** Connected to route */
  CONNECTED_TO_ROUTE = 'CONNECTED_TO_ROUTE',
  /** Skipped */
  SKIPPED = 'SKIPPED'
}

/** An enumeration. */
export enum RoutesPickUpOrderWeightSourceChoices {
  /** Imported */
  IMPORT = 'IMPORT',
  /** Entered by driver */
  MANUAL = 'MANUAL',
  /** Unknown */
  UNKNOWN = 'UNKNOWN',
  /** Vehicle scale */
  VEHICLE_SCALE = 'VEHICLE_SCALE',
  /** Site weighbridge */
  WEIGHBRIDGE = 'WEIGHBRIDGE'
}

/** An enumeration. */
export enum RoutesPickUpOrderWeightUnitChoices {
  /** Kilogram */
  KG = 'KG',
  /** Pound */
  LB = 'LB',
  /** Tonne */
  T = 'T'
}

/** An enumeration. */
export enum RoutesRouteProblemCreatedFromChoices {
  /** Driver - stop completed */
  DRIVER_COMPLETE = 'DRIVER_COMPLETE',
  /** Driver - set next stop */
  DRIVER_SET_NEXT = 'DRIVER_SET_NEXT',
  /** Driver - stops changed */
  DRIVER_STOPS_CHANGE = 'DRIVER_STOPS_CHANGE',
  /** Nightly generation */
  NIGHTLY_SCHEME = 'NIGHTLY_SCHEME',
  /** Office - Optimize route */
  OFFICE_OPTIMIZE = 'OFFICE_OPTIMIZE',
  /** Office - stops changed */
  OFFICE_STOPS_CHANGE = 'OFFICE_STOPS_CHANGE',
  /** Other */
  OTHER = 'OTHER'
}

/** An enumeration. */
export enum RoutesRouteVehicleVehicleTrailerCapacityModeChoices {
  /** Industry */
  INDUSTRY = 'INDUSTRY',
  /** Normal */
  NORMAL = 'NORMAL',
  /** Switch */
  SWITCH = 'SWITCH'
}

/** An enumeration. */
export enum RoutesSettlementPeriodStatusChoices {
  /** Closed */
  CLOSED = 'CLOSED',
  /** Open */
  OPEN = 'OPEN'
}

export type RoutesStopsComplete = {
  __typename: 'RoutesStopsComplete';
  errors?: Maybe<Array<Maybe<RouteStopsCompleteError>>>;
  routes?: Maybe<Array<Maybe<RouteType>>>;
};

export type RoutesStopsCompleteInputType = {
  /** PRODUCT-472: the driver's note on the abortive visit. */
  abortiveNote?: InputMaybe<Scalars['String']['input']>;
  /** PRODUCT-472: id of the uploaded ticket attachment (photo) documenting the abortive visit. */
  abortivePhotoId?: InputMaybe<Scalars['ID']['input']>;
  /** PRODUCT-472: the visit could NOT be carried out - why. The stop is recorded as skipped, the ticket goes Rejected with this reason and back to Open for rescheduling, and the wasted-journey fee is billed. */
  abortiveReason?: InputMaybe<AbortiveReason>;
  /** COMPASS-884: when the tag was read. */
  autoConfirmReadAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** COMPASS-884: which reader reported the tag. */
  autoConfirmReaderId?: InputMaybe<Scalars['String']['input']>;
  /** COMPASS-884: the tag id that confirmed this stop. */
  autoConfirmTag?: InputMaybe<Scalars['String']['input']>;
  /** PRODUCT-477 (exchange): identity of the OLD unit taken away. */
  collectedIdentity?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdTicketsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** PRODUCT-477 (exchange): identity of the NEW unit put down. */
  deliveredIdentity?: InputMaybe<Scalars['String']['input']>;
  fillLevel?: InputMaybe<Scalars['Float']['input']>;
  /** PRODUCT-477: label / barcode / RFID text of the skip the driver loaded for this rental delivery, as scanned. Dispatches the rental at completion; a scan of the wrong container type is refused. */
  loadedContainerIdentity?: InputMaybe<Scalars['String']['input']>;
  qrCode?: InputMaybe<Scalars['String']['input']>;
  /** COMPASS-884: this stop was auto-confirmed by an RFID/NFC read — stamps auto_completed_by=RFID for THIS stop only. */
  rfidAutoComplete?: InputMaybe<Scalars['Boolean']['input']>;
  routeId: Scalars['ID']['input'];
  stopId: Scalars['ID']['input'];
  ticketId?: InputMaybe<Scalars['ID']['input']>;
  ticketIdStopCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** PRODUCT-472 (wait-and-load): when the truck stopped waiting. Minutes beyond the fee product's free window bill per block. */
  waitingEndedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** PRODUCT-472 (wait-and-load): when the truck started waiting on site. */
  waitingStartedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type RoutesStopsMove = {
  __typename: 'RoutesStopsMove';
  routes?: Maybe<Array<Maybe<RouteType>>>;
};

export type RoutesStopsMoveInputType = {
  fromRouteId: Scalars['ID']['input'];
  orderIds: Array<InputMaybe<Scalars['ID']['input']>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  toRouteId: Scalars['ID']['input'];
};

export type RoutesStopsUpdate = {
  __typename: 'RoutesStopsUpdate';
  route?: Maybe<Array<Maybe<RouteType>>>;
};

/** An enumeration. */
export enum RoutesVehicleConfirmationSignalKindChoices {
  /** Bin-lift cycle completed */
  LIFT_CYCLE = 'LIFT_CYCLE',
  /** On-board weighing completed */
  WEIGH_COMPLETE = 'WEIGH_COMPLETE'
}

/** An enumeration. */
export enum RoutesVehicleConfirmationSignalStatusChoices {
  /** Applied to a stop */
  APPLIED = 'APPLIED',
  /** Not applied */
  REJECTED = 'REJECTED'
}

/** An enumeration. */
export enum RoutesWeighTicketStatusChoices {
  /** Matched */
  MATCHED = 'MATCHED',
  /** Received */
  RECEIVED = 'RECEIVED',
  /** Rejected */
  REJECTED = 'REJECTED',
  /** Unmatched */
  UNMATCHED = 'UNMATCHED'
}

/** An enumeration. */
export enum RoutesWeighTicketUnitChoices {
  /** Kilogram */
  KG = 'KG',
  /** Pound */
  LB = 'LB',
  /** Tonne */
  T = 'T'
}

/** An enumeration. */
export enum RoutesWorkTaskCorrectionHandoverChoices {
  /** Not handed over */
  NONE = 'NONE',
  /** Handed over to the provider as a rerouting ticket (the undone task stays recorded on its closed route) */
  QUEUE = 'QUEUE',
  /** Handed over onto a provider route */
  ROUTE = 'ROUTE'
}

export type RuleActionUnionDef = AssignToTeamActionDef | AssignToUserActionDef | ChangePriorityActionDef | ChangeStatusActionDef | ContainerActionDef | CreatePropertyActionDef | CreateTicketActionDef | ScheduleOnRouteActionDef | SendEmailActionDef | SendMessageToPropertyContactActionDef | SendMessageToPropertyUserActionDef;

/** The ticket date a DATE-triggered rule is anchored to (PRODUCT-461). */
export enum RuleDateField {
  DEADLINE = 'DEADLINE',
  PERIOD_END_DATE = 'PERIOD_END_DATE',
  PERIOD_START_DATE = 'PERIOD_START_DATE',
  PERMIT_VALID_TO = 'PERMIT_VALID_TO',
  PREFERRED_DATE = 'PREFERRED_DATE'
}

/** What starts a ticket-type automation rule (PRODUCT-461). */
export enum RuleTriggerKind {
  DATE = 'DATE',
  STATUS = 'STATUS'
}

/**
 * Office-only (PRO-118): attach every pending (matching, not
 * excluded) agreement now. Each attachment is change-logged
 * "Attached automatically — matched scope".
 */
export type RunAreaAutoAttach = {
  __typename: 'RunAreaAutoAttach';
  area?: Maybe<AreaDef>;
  attachedCount: Scalars['Int']['output'];
};

/**
 * Process the due list for a cycle/selection into invoices.
 *
 * Reuses the existing invoicing pipeline for invoice creation (law-class
 * split, delivery routing, VAT, pricing at execution time). Records the
 * per-agreement-period billed-state guard, advances the schedules, and clears
 * the processed due rows. Provide a ``frequency_code`` (process that cadence's
 * due rows) and/or explicit ``schedule_ids``.
 *
 * The payload answers "what did my click actually do?" — the question the
 * original four counters could not (D1/D3): a run that invoiced nothing
 * looked exactly like a run that invoiced everything. ``outcome`` is the
 * run-level verdict and ``entries`` carries the per-schedule reason, both
 * straight off ``BillingScheduleRunResult``. Outcome codes ship as plain
 * strings, matching every other vocabulary on this schema
 * (``BillingDueListRowType.contact_type``,
 * ``FrequencyChangeDetailType.source``, this module's ``anchor``/``source``
 * inputs) — and additively, so a new code never breaks a client's build.
 */
export type RunBillingByScheduleMutation = {
  __typename: 'RunBillingByScheduleMutation';
  /** Entries fully billed (period consumed, card cleared). */
  billedCount?: Maybe<Scalars['Int']['output']>;
  billingRunId?: Maybe<Scalars['ID']['output']>;
  /** Entries whose document fell under the minimum-amount gate. No invoice, but the period IS consumed on purpose — the charges roll into the next period. */
  deferredUnderMinimumCount?: Maybe<Scalars['Int']['output']>;
  /** Entries deferred under the minimum-amount gate that ALSO still carry billable work (outcome under_minimum_deferred_work_left). The roll-over only carries the deferred charges, so the period is NOT consumed and the card stays: advancing would strand the leftover in a period no later run visits. */
  deferredWorkLeftCount?: Maybe<Scalars['Int']['output']>;
  /** Per-entry verdicts, ordered attention-first: entries that did NOT advance (the ones an operator must act on) come before the ones that did. CAPPED at 250 rows — a whole-cadence run can cover many thousands of schedules and this is a mutation response, not a paged list. Read entry_count / entries_truncated before treating this as the complete set; the counters above always describe the WHOLE run. */
  entries?: Maybe<Array<Maybe<BillingRunEntryOutcomeType>>>;
  /** True when the run classified more than 250 entries and ``entries`` therefore holds only the first (attention-first) page of them. */
  entriesTruncated?: Maybe<Scalars['Boolean']['output']>;
  /** Total entries this run classified, whether or not they fit in ``entries``. */
  entryCount?: Maybe<Scalars['Int']['output']>;
  /** Recurring-fee events this run had to generate for the periods being billed; 0 when the nightly beat had already made them. */
  eventsGenerated?: Maybe<Scalars['Int']['output']>;
  invoicesCreated?: Maybe<Scalars['Int']['output']>;
  /** Documents this run withheld under the minimum gate. */
  invoicesSkippedUnderMinimum?: Maybe<Scalars['Int']['output']>;
  /** Run-level verdict: no_entries | all_already_billed | billed | partially_billed | under_minimum_deferred | nothing_billed. Mirrors the RUN_* codes in invoicing.services.billing_schedule. */
  outcome?: Maybe<Scalars['String']['output']>;
  /** Entries where PART of the period reached an invoice but billable work was left behind (outcome partially_billed_work_left). The period is deliberately NOT consumed: the card stays so the office can fix the charge and run it again. */
  partiallyBilledCount?: Maybe<Scalars['Int']['output']>;
  processedCount?: Maybe<Scalars['Int']['output']>;
  skippedAlreadyBilledCount?: Maybe<Scalars['Int']['output']>;
  /** Entries left billable, so their cards remain. Includes the partially-billed and deferred-with-work-left ones (their period is still open). */
  unbilledCount?: Maybe<Scalars['Int']['output']>;
};

/** One run: its row plus the words the screens show (SBX-558). */
export type RunDef = {
  __typename: 'RunDef';
  automation: AutomationDef;
  failedStageNo?: Maybe<Scalars['Int']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  mode: Scalars['String']['output'];
  skipReason?: Maybe<Scalars['String']['output']>;
  skipReasonText?: Maybe<Scalars['String']['output']>;
  stageCount: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  subjectId?: Maybe<Scalars['ID']['output']>;
  subjectLabel?: Maybe<Scalars['String']['output']>;
  subjectLinkPath?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  triggerKey: Scalars['String']['output'];
  triggerKind: Scalars['String']['output'];
  triggerLabel: Scalars['String']['output'];
  triggerNodeKey: Scalars['String']['output'];
  triggeredAt: Scalars['DateTime']['output'];
  waitingNodeKey?: Maybe<Scalars['String']['output']>;
  waitingNodeLabel?: Maybe<Scalars['String']['output']>;
  waitingOn?: Maybe<Scalars['String']['output']>;
  waitingUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type RunDefConnection = {
  __typename: 'RunDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RunDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RunDef` and its cursor. */
export type RunDefEdge = {
  __typename: 'RunDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RunDef>;
};

/**
 * Export the caller's company's validated billable events for
 * ``[from, to]`` to a feeder file in the configured finance system's
 * format and return the export log.
 */
export type RunFinanceFeederExportMutation = {
  __typename: 'RunFinanceFeederExportMutation';
  exportLog?: Maybe<FinanceFeederExportLogDef>;
};

/** Force one delivery (also the UI's 'send test report'). */
export type RunReportNow = {
  __typename: 'RunReportNow';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/**
 * Queue a simulation job for a scenario (RS-201 simulation_job).
 *
 * Sync API, async work (RS-405, ADR-0003 §2): the mutation persists
 * the queued job, flips the scenario to ``computing`` and returns
 * immediately; the solve itself is dispatched on commit to the
 * ``optimization-engine`` Celery queue
 * (``route_studio.solver.tasks.run_simulation_job``).
 */
export type RunScenarioMutation = {
  __typename: 'RunScenarioMutation';
  simulationJob?: Maybe<SimulationJobDef>;
};

/**
 * Run every setup step for a company (the management command's
 * default) and return one report per step.
 */
export type RunSkipHireSetup = {
  __typename: 'RunSkipHireSetup';
  steps: Array<SkipHireSetupStepReportType>;
};

/**
 * Run ONE setup step for a company and return its report.
 *
 * ``input`` is the step's tenant-specific input as a JSON object (the
 * same keys a demo profile carries, e.g. ``{"skips": [...]}``); ``demo``
 * picks a built-in profile. Steps the step depends on must be done -
 * they are checked against the company (and the demo profile, if any),
 * never against ``input``, which only the step itself reads
 * (PRODUCT-555).
 */
export type RunSkipHireSetupStep = {
  __typename: 'RunSkipHireSetupStep';
  report: SkipHireSetupStepReportType;
};

export type RunTraceDef = {
  __typename: 'RunTraceDef';
  approvals: Array<ApprovalDef>;
  recordLinks: Array<RecordLinkDef>;
  run: RunDef;
  stages: Array<StageDef>;
  timers: Array<TimerDef>;
};

/**
 * Re-run RS-E27 stage G verification for a case (default: the
 * newest materialization version). Verification also auto-runs on
 * every materialization; this mutation refreshes the verdicts after
 * new uploads (membership tables, actuals logs) without
 * re-materializing. Refusals explain at category level (D62).
 */
export type RunVerificationMutation = {
  __typename: 'RunVerificationMutation';
  importCase?: Maybe<ImportCaseDef>;
  materialization?: Maybe<CaseMaterializationDef>;
  summary?: Maybe<Scalars['GenericScalar']['output']>;
};

export type RyhtiConfigDef = Node & {
  __typename: 'RyhtiConfigDef';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Municipality codes (kuntanumero) to scan for new buildings, e.g. 091, 700 */
  municipalityCodes: Array<Scalars['String']['output']>;
  syncEnabled: Scalars['Boolean']['output'];
  /** Ticket type to create when a building mismatch or new building is detected */
  ticketType?: Maybe<TicketTypeDef>;
};

/** A management company's membership of an SCP (phase 2, feature 7). */
export type ScpCompanyMembershipDef = Node & {
  __typename: 'SCPCompanyMembershipDef';
  createdAt: Scalars['DateTime']['output'];
  defaultShare: Scalars['Decimal']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  managementCompany: PropertyManagementCompanyDef;
  scp: PropertyGroupDef;
  startDate: Scalars['DateTime']['output'];
  status: CrmScpCompanyMembershipStatusChoices;
};

export type ScpCompanyMembershipDefConnection = {
  __typename: 'SCPCompanyMembershipDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScpCompanyMembershipDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SCPCompanyMembershipDef` and its cursor. */
export type ScpCompanyMembershipDefEdge = {
  __typename: 'SCPCompanyMembershipDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScpCompanyMembershipDef>;
};

/** Company-membership lifecycle audit rows (QA-104). */
export type ScpCompanyMembershipEventDef = Node & {
  __typename: 'SCPCompanyMembershipEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<ScpCompanyMembershipEventTypesGraphene>>>;
  fromDefaultShare?: Maybe<Scalars['Float']['output']>;
  fromEndDate?: Maybe<Scalars['Date']['output']>;
  fromStartDate?: Maybe<Scalars['Date']['output']>;
  fromStatus?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  scpCompanyMembership?: Maybe<ScpCompanyMembershipDef>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toDefaultShare?: Maybe<Scalars['Float']['output']>;
  toEndDate?: Maybe<Scalars['Date']['output']>;
  toStartDate?: Maybe<Scalars['Date']['output']>;
  toStatus?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
};

export enum ScpCompanyMembershipEventTypesGraphene {
  COMPANY_MEMBERSHIP_STATUS_CHANGE = 'COMPANY_MEMBERSHIP_STATUS_CHANGE',
  COMPANY_SHARE_CHANGE = 'COMPANY_SHARE_CHANGE'
}

/**
 * A date-ranged attachment of a Container asset to a true SCP
 * (NEXUS-642, ADR-0003).
 */
export type ScpContainerAttachmentDef = Node & {
  __typename: 'SCPContainerAttachmentDef';
  container: ContainerType;
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  propertyGroup: PropertyGroupDef;
  startDate: Scalars['DateTime']['output'];
};

export type ScpContainerAttachmentDefConnection = {
  __typename: 'SCPContainerAttachmentDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScpContainerAttachmentDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SCPContainerAttachmentDef` and its cursor. */
export type ScpContainerAttachmentDefEdge = {
  __typename: 'SCPContainerAttachmentDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScpContainerAttachmentDef>;
};

/** Attach/detach audit rows for SCP container attachments (NEXUS-642). */
export type ScpContainerAttachmentEventDef = Node & {
  __typename: 'SCPContainerAttachmentEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<ScpContainerAttachmentEventTypesGraphene>>>;
  fromContainer?: Maybe<ContainerType>;
  fromEndDate?: Maybe<Scalars['Date']['output']>;
  fromStartDate?: Maybe<Scalars['Date']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  scpContainerAttachment?: Maybe<ScpContainerAttachmentDef>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toContainer?: Maybe<ContainerType>;
  toEndDate?: Maybe<Scalars['Date']['output']>;
  toStartDate?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<UserType>;
};

export enum ScpContainerAttachmentEventTypesGraphene {
  CONTAINER_ATTACHED = 'CONTAINER_ATTACHED',
  CONTAINER_DETACHED = 'CONTAINER_DETACHED'
}

/** A role held by a member on the printable summary (NEXUS-561). */
export type ScpMemberRoleDef = {
  __typename: 'SCPMemberRoleDef';
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * One service line for a member: a waste fraction and its pickup interval
 * (NEXUS-561 / NEX-SS-502).
 */
export type ScpMemberServiceDef = {
  __typename: 'SCPMemberServiceDef';
  pickupInterval?: Maybe<Scalars['String']['output']>;
  wasteFraction?: Maybe<Scalars['String']['output']>;
};

/**
 * One member row of the printable SCP summary (NEXUS-561 / NEX-SS-502).
 *
 * ``customer_name`` and ``address`` are pre-masked by the resolver when the
 * membership is ``disclosure_restricted`` (name → ``"***"``, address → ``""``);
 * no other contact details are ever included.
 */
export type ScpMemberSummaryDef = {
  __typename: 'SCPMemberSummaryDef';
  address?: Maybe<Scalars['String']['output']>;
  apartments?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  disclosureRestricted: Scalars['Boolean']['output'];
  invoicingAddress?: Maybe<Scalars['String']['output']>;
  propertyId: Scalars['ID']['output'];
  roles: Array<ScpMemberRoleDef>;
  services: Array<ScpMemberServiceDef>;
  share: Scalars['Decimal']['output'];
  usageProfile?: Maybe<ScpUsageProfile>;
};

/** Printable member summary for an SCP (NEXUS-561 / NEX-SS-502). */
export type ScpMemberSummaryPayloadDef = {
  __typename: 'SCPMemberSummaryPayloadDef';
  members: Array<ScpMemberSummaryDef>;
  scpName: Scalars['String']['output'];
  scpProfile?: Maybe<ScpProfileDef>;
};

/** A property's membership of a Shared Collection Point (NEXUS-540). */
export type ScpMembershipDef = Node & {
  __typename: 'SCPMembershipDef';
  accessFeeAgreement?: Maybe<AgreementDef>;
  accessFeeAgreements: AgreementDefConnection;
  apartments?: Maybe<Scalars['Int']['output']>;
  changeReason?: Maybe<Scalars['String']['output']>;
  consentDate?: Maybe<Scalars['Date']['output']>;
  /** Contact person's consent to this member joining; null = not recorded */
  consentGiven?: Maybe<Scalars['Boolean']['output']>;
  contact?: Maybe<ContactDef>;
  containers?: Maybe<Array<Maybe<ContainerType>>>;
  createdAt: Scalars['DateTime']['output'];
  defaultShare: Scalars['Decimal']['output'];
  disclosureRestricted: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  intakeChannel?: Maybe<CrmScpMembershipIntakeChannelChoices>;
  /** Who requested this membership (caller / form sender) */
  intakeRequestedBy: Scalars['String']['output'];
  invoicingAddress?: Maybe<ContactAddressDef>;
  property: PropertyDef;
  roles?: Maybe<Array<Maybe<ScpMembershipRoleDef>>>;
  scp: PropertyGroupDef;
  /** Year-round member on a summer-only point (REQ-313); always false for ended memberships. */
  seasonalConflict: Scalars['Boolean']['output'];
  startDate: Scalars['DateTime']['output'];
  status: CrmScpMembershipStatusChoices;
  usageProfile?: Maybe<CrmScpMembershipUsageProfileChoices>;
};


/** A property's membership of a Shared Collection Point (NEXUS-540). */
export type ScpMembershipDefAccessFeeAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A property's membership of a Shared Collection Point (NEXUS-540). */
export type ScpMembershipDefRolesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScpMembershipDefConnection = {
  __typename: 'SCPMembershipDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScpMembershipDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SCPMembershipDef` and its cursor. */
export type ScpMembershipDefEdge = {
  __typename: 'SCPMembershipDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScpMembershipDef>;
};

export type ScpMembershipEventDef = Node & {
  __typename: 'SCPMembershipEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<ScpMembershipEventTypesGraphene>>>;
  fromApartments?: Maybe<Scalars['Int']['output']>;
  fromChangeReason?: Maybe<Scalars['String']['output']>;
  fromConsentDate?: Maybe<Scalars['Date']['output']>;
  fromConsentGiven?: Maybe<Scalars['Boolean']['output']>;
  fromContact?: Maybe<ContactDef>;
  fromDefaultShare?: Maybe<Scalars['Float']['output']>;
  fromDisclosureRestricted?: Maybe<Scalars['Boolean']['output']>;
  fromEndDate?: Maybe<Scalars['Date']['output']>;
  fromIntakeChannel?: Maybe<Scalars['String']['output']>;
  fromIntakeRequestedBy?: Maybe<Scalars['String']['output']>;
  fromStartDate?: Maybe<Scalars['Date']['output']>;
  fromStatus?: Maybe<Scalars['String']['output']>;
  fromUsageProfile?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  scpMembership?: Maybe<ScpMembershipDef>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toApartments?: Maybe<Scalars['Int']['output']>;
  toChangeReason?: Maybe<Scalars['String']['output']>;
  toConsentDate?: Maybe<Scalars['Date']['output']>;
  toConsentGiven?: Maybe<Scalars['Boolean']['output']>;
  toContact?: Maybe<ContactDef>;
  toDefaultShare?: Maybe<Scalars['Float']['output']>;
  toDisclosureRestricted?: Maybe<Scalars['Boolean']['output']>;
  toEndDate?: Maybe<Scalars['Date']['output']>;
  toIntakeChannel?: Maybe<Scalars['String']['output']>;
  toIntakeRequestedBy?: Maybe<Scalars['String']['output']>;
  toStartDate?: Maybe<Scalars['Date']['output']>;
  toStatus?: Maybe<Scalars['String']['output']>;
  toUsageProfile?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
};

export enum ScpMembershipEventTypesGraphene {
  APARTMENTS_CHANGE = 'APARTMENTS_CHANGE',
  CONSENT_CHANGE = 'CONSENT_CHANGE',
  CONTACT_CHANGE = 'CONTACT_CHANGE',
  DISCLOSURE_CHANGE = 'DISCLOSURE_CHANGE',
  INTAKE_CHANGE = 'INTAKE_CHANGE',
  MEMBERSHIP_STATUS_CHANGE = 'MEMBERSHIP_STATUS_CHANGE',
  SHARE_CHANGE = 'SHARE_CHANGE',
  USAGE_PROFILE_CHANGE = 'USAGE_PROFILE_CHANGE'
}

/** A date-ranged role held by an SCP membership (NEXUS-544). */
export type ScpMembershipRoleDef = Node & {
  __typename: 'SCPMembershipRoleDef';
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  membership: ScpMembershipDef;
  roleDefinition: ScpRoleDefinitionDef;
  startDate: Scalars['DateTime']['output'];
};

export type ScpMembershipRoleDefConnection = {
  __typename: 'SCPMembershipRoleDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScpMembershipRoleDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SCPMembershipRoleDef` and its cursor. */
export type ScpMembershipRoleDefEdge = {
  __typename: 'SCPMembershipRoleDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScpMembershipRoleDef>;
};

export type ScpMembershipRoleEventDef = Node & {
  __typename: 'SCPMembershipRoleEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<ScpMembershipRoleEventTypesGraphene>>>;
  fromEndDate?: Maybe<Scalars['Date']['output']>;
  fromRoleDefinition?: Maybe<ScpRoleDefinitionDef>;
  fromStartDate?: Maybe<Scalars['Date']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  membershipRole?: Maybe<ScpMembershipRoleDef>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toEndDate?: Maybe<Scalars['Date']['output']>;
  toRoleDefinition?: Maybe<ScpRoleDefinitionDef>;
  toStartDate?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<UserType>;
};

export enum ScpMembershipRoleEventTypesGraphene {
  ROLE_ASSIGNMENT_CHANGE = 'ROLE_ASSIGNMENT_CHANGE'
}

/**
 * Active-membership counts on an SCP, split by usage profile (NEX-SS-501).
 *
 * ``total`` counts all active members (validity dates respected); every
 * ``ScpUsageProfile`` value always appears in ``by_usage_profile`` (0 when
 * absent), plus a trailing ``usage_profile=null`` bucket when active members
 * have no profile set, so the buckets sum to ``total``.
 */
export type ScpMembershipUsageBreakdownDef = {
  __typename: 'SCPMembershipUsageBreakdownDef';
  byUsageProfile: Array<ScpUsageProfileCountDef>;
  total: Scalars['Int']['output'];
};

/**
 * One management-company member + payment share on the kimppailmoitus
 * (NEXUS-714). Company members share the sum-to-100 pool with property
 * members; the statutory share columns are incomplete without them.
 */
export type ScpNotificationCompanyMemberDef = {
  __typename: 'SCPNotificationCompanyMemberDef';
  managementCompanyId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  share: Scalars['Decimal']['output'];
};

/** The responsible person's contact block on the kimppailmoitus. */
export type ScpNotificationContactDef = {
  __typename: 'SCPNotificationContactDef';
  email?: Maybe<Scalars['String']['output']>;
  isRestricted: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  roleKey?: Maybe<Scalars['String']['output']>;
};

/** One container's location + size + fraction on the kimppailmoitus. */
export type ScpNotificationContainerDef = {
  __typename: 'SCPNotificationContainerDef';
  label?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  sizeLitres?: Maybe<Scalars['Int']['output']>;
  sizeM3?: Maybe<Scalars['Float']['output']>;
  wasteFraction?: Maybe<Scalars['String']['output']>;
};

/**
 * The rendered kimppailmoitus document + its filing state (NEXUS-681).
 *
 * Carries every statutory field (responsible person + contacts, container
 * locations + sizes, waste fractions, member properties, payment shares) so
 * the operator can print/fill any municipality's form, plus the filing
 * lifecycle state so the SCP can show "ilmoitettu / muutoksia
 * ilmoitettavaksi".
 */
export type ScpNotificationDocumentDef = {
  __typename: 'SCPNotificationDocumentDef';
  availabilityText?: Maybe<Scalars['String']['output']>;
  collectionAddress?: Maybe<Scalars['String']['output']>;
  companyMembers: Array<ScpNotificationCompanyMemberDef>;
  containers: Array<ScpNotificationContainerDef>;
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  kind?: Maybe<ScpKind>;
  members: Array<ScpNotificationMemberDef>;
  responsible?: Maybe<ScpNotificationContactDef>;
  scpId: Scalars['ID']['output'];
  scpName: Scalars['String']['output'];
  scpType?: Maybe<ScpType>;
  state: ScpNotificationStateDef;
  wasteFractions: Array<Scalars['String']['output']>;
};

/** One member property + payment share on the kimppailmoitus. */
export type ScpNotificationMemberDef = {
  __typename: 'SCPNotificationMemberDef';
  address?: Maybe<Scalars['String']['output']>;
  consentDate?: Maybe<Scalars['Date']['output']>;
  consentGiven?: Maybe<Scalars['Boolean']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  propertyId: Scalars['ID']['output'];
  share: Scalars['Decimal']['output'];
};

/**
 * A recorded filing of the kimppailmoitus (NEXUS-681).
 *
 * QA-104: also a member of ``PropertyEventLogEvent`` — the append-only
 * rows themselves are the audit trail, so they join the History tab as
 * a created_at-annotated custom event source (TicketEvent pattern),
 * which is why the class is defined ahead of the union.
 */
export type ScpNotificationRecordDef = Node & {
  __typename: 'SCPNotificationRecordDef';
  /** The authority's reference / diaarinumero for this filing; null until the authority responds with one */
  authorityReference?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  filedBy?: Maybe<UserType>;
  /** Date the notification was filed with the waste authority (jätehuoltoviranomainen) */
  filedDate: Scalars['Date']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  kind: ScpNotificationKind;
  note: Scalars['String']['output'];
};

export type ScpNotificationRecordDefConnection = {
  __typename: 'SCPNotificationRecordDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScpNotificationRecordDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SCPNotificationRecordDef` and its cursor. */
export type ScpNotificationRecordDefEdge = {
  __typename: 'SCPNotificationRecordDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScpNotificationRecordDef>;
};

/**
 * Filing lifecycle state for an SCP (NEXUS-681).
 *
 * ``lastRecord`` is null when the SCP has never been notified.
 * ``hasChangesSinceFiling`` is true only when a filing exists AND the live
 * state has drifted from what was last filed ("muutoksia ilmoitettavaksi");
 * ``changedSections`` names the drifted sections.
 */
export type ScpNotificationStateDef = {
  __typename: 'SCPNotificationStateDef';
  changedSections: Array<Scalars['String']['output']>;
  hasChangesSinceFiling: Scalars['Boolean']['output'];
  lastRecord?: Maybe<ScpNotificationRecordDef>;
};

/** PRO-58: one structured opening-hours row ("HH:MM" from-to). */
export type ScpOpeningHoursRangeDef = {
  __typename: 'SCPOpeningHoursRangeDef';
  closes: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  opens: Scalars['String']['output'];
};

/** Shared Collection Point profile layered on a PropertyGroup (NEXUS-524). */
export type ScpProfileDef = Node & {
  __typename: 'SCPProfileDef';
  accessInfo: Scalars['String']['output'];
  /** Reserved: area this SCP will be restricted to (post-July area-restriction feature) */
  areaRef?: Maybe<AreaDef>;
  /** Reserved: area-restriction mode (post-July area-restriction feature) */
  areaRestriction: CrmScpProfileAreaRestrictionChoices;
  availability: CrmScpProfileAvailabilityChoices;
  /** Human-readable availability, e.g. season window. */
  availabilityText?: Maybe<Scalars['String']['output']>;
  /** How costs are charged to members (ADR-0002): a fixed yearly subscription per member, or a share-split over the member pool. Defaults from the SCP type; Shared Residential is share-split by definition. */
  billingMode: CrmScpProfileBillingModeChoices;
  /** Declared capacity in litres */
  capacity?: Maybe<Scalars['Int']['output']>;
  /** Primary collection address as a display string (ADR-0005): street line, postal code and postal-code name. Null when unset. */
  collectionAddress?: Maybe<Scalars['String']['output']>;
  /** Effective compliance radius in metres: municipality per-type override → municipality default → tenant default; null when nothing is configured. */
  complianceRadiusM?: Maybe<Scalars['Float']['output']>;
  /** Per-point compliance radius override in metres; wins over the municipality and tenant defaults when set (PRO-64). */
  complianceRadiusMOverride?: Maybe<Scalars['Float']['output']>;
  /** Active year-round members on a summer-only point (REQ-313); 0 when the point is available year-round. */
  conflictedMembersCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Declared container-type scope (PRO-56); pre-filters the container attach step. */
  declaredContainerTypes?: Maybe<Array<Maybe<ContainerTypeType>>>;
  declaredWasteFractions: WasteFractionTypeConnection;
  /** Recurring interval of the default fee product's active price (e.g. YEARLY); null when unset or unpriced. */
  defaultFeeInterval?: Maybe<Scalars['String']['output']>;
  /** Active price of the default fee product as a decimal amount in the tenant currency (NEXUS-666); null when unset or unpriced. QA-105: when the point carries a pp default instead, this is its effective price (ACTIVE price-list row, else catalog). */
  defaultFeePrice?: Maybe<Scalars['Decimal']['output']>;
  /** Default subscription/tariff product for this point; its active price is the quote shown on nearby-point cards and pre-selected in the subscribe drawer (NEXUS-666). */
  defaultFeeProduct?: Maybe<ProductDef>;
  /** Default Products & Pricing fee product of the point (QA-105); mutually exclusive with defaultFeeProduct. */
  defaultPpFeeProduct?: Maybe<PpProductDef>;
  /** Date the shared service ended; mirrors terminated_at and is cleared on reactivation (D11 period) */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** Overrides the company invoicing interval for this SCP when set */
  exceptionalInvoicingIntervalMonths?: Maybe<Scalars['Int']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  /** Derived grouping over the SCP type (ADR-0004): SHARED_RESIDENTIAL → RESIDENTIAL, BLOCK / REGIONAL → COLLECTION_POINT. Never stored. */
  kind?: Maybe<ScpKind>;
  locationDescription: Scalars['String']['output'];
  /** Municipality cap on kimppa member count; null when the municipality is unset or leaves it unrestricted. */
  maxKimppaMembers?: Maybe<Scalars['Int']['output']>;
  /** Municipality member cap applying when the kimppa serves a biowaste fraction; null when unset or unrestricted. */
  maxKimppaMembersBio?: Maybe<Scalars['Int']['output']>;
  memberships?: Maybe<Array<Maybe<ScpMembershipDef>>>;
  /** Municipality permanent-dwelling base fee in EUR/year (NEXUS-683 min-fee advisory); null when the municipality is unset or configures no floor. */
  minAnnualFeeEur?: Maybe<Scalars['Decimal']['output']>;
  /** Municipality whose compliance radius applies to this SCP */
  municipality?: Maybe<MunicipalityDef>;
  openingHours: Scalars['String']['output'];
  /** Structured opening hours (PRO-58): from-to "HH:MM" ranges with an optional row label. */
  openingHoursStructured: Array<ScpOpeningHoursRangeDef>;
  point?: Maybe<Scalars['GeoJSON']['output']>;
  propertyGroup: PropertyGroupDef;
  scpType: CrmScpProfileScpTypeChoices;
  seasonEndMonth?: Maybe<Scalars['Int']['output']>;
  seasonStartMonth?: Maybe<Scalars['Int']['output']>;
  /** Seasonal availability windows (PRO-58); empty when year-round. The legacy seasonStartMonth/seasonEndMonth pair mirrors the first interval. */
  seasonalIntervals: Array<ScpSeasonalIntervalDef>;
  /** Overrides the company maximum member share (%) for this SCP when set */
  shareMaxPct?: Maybe<Scalars['Int']['output']>;
  /** Overrides the company minimum member share (%) for this SCP when set */
  shareMinPct?: Maybe<Scalars['Int']['output']>;
  /** Date the shared service starts/started (D11 period) */
  startDate: Scalars['Date']['output'];
  status: CrmScpProfileStatusChoices;
  terminatedAt?: Maybe<Scalars['Date']['output']>;
  terminationReason: Scalars['String']['output'];
  wasteFractions?: Maybe<Array<Maybe<WasteFractionType>>>;
};


/** Shared Collection Point profile layered on a PropertyGroup (NEXUS-524). */
export type ScpProfileDefDeclaredWasteFractionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Shared Collection Point profile layered on a PropertyGroup (NEXUS-524). */
export type ScpProfileDefMembershipsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScpProfileDefConnection = {
  __typename: 'SCPProfileDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScpProfileDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SCPProfileDef` and its cursor. */
export type ScpProfileDefEdge = {
  __typename: 'SCPProfileDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScpProfileDef>;
};

export type ScpProfileEventDef = Node & {
  __typename: 'SCPProfileEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<ScpProfileEventTypesGraphene>>>;
  fromAccessInfo?: Maybe<Scalars['String']['output']>;
  fromAvailability?: Maybe<Scalars['String']['output']>;
  fromCapacity?: Maybe<Scalars['Int']['output']>;
  fromExceptionalInvoicingIntervalMonths?: Maybe<Scalars['Int']['output']>;
  fromIsLocked?: Maybe<Scalars['Boolean']['output']>;
  fromLocationDescription?: Maybe<Scalars['String']['output']>;
  fromOpeningHours?: Maybe<Scalars['String']['output']>;
  fromPoint?: Maybe<Scalars['String']['output']>;
  fromRestrictions?: Maybe<Scalars['String']['output']>;
  fromScpType?: Maybe<Scalars['String']['output']>;
  fromSeasonEndMonth?: Maybe<Scalars['Int']['output']>;
  fromSeasonStartMonth?: Maybe<Scalars['Int']['output']>;
  fromStatus?: Maybe<Scalars['String']['output']>;
  fromTerminatedAt?: Maybe<Scalars['Date']['output']>;
  fromTerminationReason?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  scpProfile?: Maybe<ScpProfileDef>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toAccessInfo?: Maybe<Scalars['String']['output']>;
  toAvailability?: Maybe<Scalars['String']['output']>;
  toCapacity?: Maybe<Scalars['Int']['output']>;
  toExceptionalInvoicingIntervalMonths?: Maybe<Scalars['Int']['output']>;
  toIsLocked?: Maybe<Scalars['Boolean']['output']>;
  toLocationDescription?: Maybe<Scalars['String']['output']>;
  toOpeningHours?: Maybe<Scalars['String']['output']>;
  toPoint?: Maybe<Scalars['String']['output']>;
  toRestrictions?: Maybe<Scalars['String']['output']>;
  toScpType?: Maybe<Scalars['String']['output']>;
  toSeasonEndMonth?: Maybe<Scalars['Int']['output']>;
  toSeasonStartMonth?: Maybe<Scalars['Int']['output']>;
  toStatus?: Maybe<Scalars['String']['output']>;
  toTerminatedAt?: Maybe<Scalars['Date']['output']>;
  toTerminationReason?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
};

export enum ScpProfileEventTypesGraphene {
  ACCESS_CHANGE = 'ACCESS_CHANGE',
  AVAILABILITY_CHANGE = 'AVAILABILITY_CHANGE',
  CAPACITY_CHANGE = 'CAPACITY_CHANGE',
  INVOICING_INTERVAL_CHANGE = 'INVOICING_INTERVAL_CHANGE',
  LOCATION_CHANGE = 'LOCATION_CHANGE',
  RESTRICTIONS_CHANGE = 'RESTRICTIONS_CHANGE',
  SCP_TYPE_CHANGE = 'SCP_TYPE_CHANGE',
  STATUS_CHANGE = 'STATUS_CHANGE'
}

/** A tenant-configurable SCP membership role (NEXUS-544). */
export type ScpRoleDefinitionDef = Node & {
  __typename: 'SCPRoleDefinitionDef';
  assignments: ScpMembershipRoleDefConnection;
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isSystem: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};


/** A tenant-configurable SCP membership role (NEXUS-544). */
export type ScpRoleDefinitionDefAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ScpRoleDefinitionDefConnection = {
  __typename: 'SCPRoleDefinitionDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScpRoleDefinitionDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SCPRoleDefinitionDef` and its cursor. */
export type ScpRoleDefinitionDefEdge = {
  __typename: 'SCPRoleDefinitionDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScpRoleDefinitionDef>;
};

/**
 * Role-definition CRUD audit rows (QA-104) — incl. the hard-delete
 * trace of a custom role.
 */
export type ScpRoleDefinitionEventDef = Node & {
  __typename: 'SCPRoleDefinitionEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<ScpRoleDefinitionEventTypesGraphene>>>;
  fromDescription?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  roleDefinition?: Maybe<ScpRoleDefinitionDef>;
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toDescription?: Maybe<Scalars['String']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
};

export enum ScpRoleDefinitionEventTypesGraphene {
  ROLE_DEFINITION_CHANGED = 'ROLE_DEFINITION_CHANGED',
  ROLE_DEFINITION_CREATED = 'ROLE_DEFINITION_CREATED',
  ROLE_DEFINITION_DELETED = 'ROLE_DEFINITION_DELETED'
}

/** PRO-58: one seasonal availability window (months 1-12). */
export type ScpSeasonalIntervalDef = {
  __typename: 'SCPSeasonalIntervalDef';
  endMonth: Scalars['Int']['output'];
  startMonth: Scalars['Int']['output'];
};

/** One contact person / responsible on the ticket SCP card. */
export type ScpTicketCardContactDef = {
  __typename: 'SCPTicketCardContactDef';
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  roleKey?: Maybe<Scalars['String']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
};

/**
 * The SCP contact card rendered in a ticket panel (NEXUS-668).
 *
 * ``scpId`` is the global id of the underlying PropertyGroup — the target of
 * the "Näytä yhteinen jätepalvelu" link. ``isLocked`` + ``accessInfo`` answer
 * "who has the key" together with the contacts' phones.
 */
export type ScpTicketCardDef = {
  __typename: 'SCPTicketCardDef';
  accessInfo?: Maybe<Scalars['String']['output']>;
  collectionAddress?: Maybe<Scalars['String']['output']>;
  contacts: Array<ScpTicketCardContactDef>;
  isLocked: Scalars['Boolean']['output'];
  kind?: Maybe<ScpKind>;
  scpId: Scalars['ID']['output'];
  scpName: Scalars['String']['output'];
  scpType?: Maybe<ScpType>;
};

/** One bucket of the SCP usage-profile breakdown (NEXUS-559). */
export type ScpUsageProfileCountDef = {
  __typename: 'SCPUsageProfileCountDef';
  count: Scalars['Int']['output'];
  usageProfile?: Maybe<ScpUsageProfile>;
};

export type SmsNotificationMethodDef = Node & {
  __typename: 'SMSNotificationMethodDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  migratedFromId?: Maybe<Scalars['String']['output']>;
  notificationmethodPtr: NotificationMethodDef;
  phoneNumber: Scalars['String']['output'];
};

export type SalesOfferPageMultipleChoiceFieldInput = {
  description: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type SalesOfferPageType = Node & {
  __typename: 'SalesOfferPageType';
  description: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  salesOffer: SalesOfferType;
  title: Scalars['String']['output'];
};

export type SalesOfferPageTypeConnection = {
  __typename: 'SalesOfferPageTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesOfferPageTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SalesOfferPageType` and its cursor. */
export type SalesOfferPageTypeEdge = {
  __typename: 'SalesOfferPageTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SalesOfferPageType>;
};

export type SalesOfferProductMultipleChoiceFieldInput = {
  billingFeature: Scalars['ID']['input'];
  discount: Scalars['Int']['input'];
  grossTotalAmountOverwrite?: InputMaybe<Scalars['Int']['input']>;
  prices: Array<InputMaybe<SalesOfferProductPriceInput>>;
};

export type SalesOfferProductPriceInput = {
  price: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type SalesOfferProductPriceType = Node & {
  __typename: 'SalesOfferProductPriceType';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  price: BillingFeatureProductPriceType;
  quantity: Scalars['Int']['output'];
  salesOfferProduct: SalesOfferProductType;
};

export type SalesOfferProductPriceTypeConnection = {
  __typename: 'SalesOfferProductPriceTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesOfferProductPriceTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SalesOfferProductPriceType` and its cursor. */
export type SalesOfferProductPriceTypeEdge = {
  __typename: 'SalesOfferProductPriceTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SalesOfferProductPriceType>;
};

export type SalesOfferProductType = Node & {
  __typename: 'SalesOfferProductType';
  billingFeature: BillingFeatureType;
  discount: Scalars['Int']['output'];
  grossTotalAmountOverwrite?: Maybe<Scalars['Int']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  prices?: Maybe<Array<Maybe<SalesOfferProductPriceType>>>;
  salesOffer: SalesOfferType;
  salesofferproductpriceSet: SalesOfferProductPriceTypeConnection;
};


export type SalesOfferProductTypeSalesofferproductpriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SalesOfferProductTypeConnection = {
  __typename: 'SalesOfferProductTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesOfferProductTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SalesOfferProductType` and its cursor. */
export type SalesOfferProductTypeEdge = {
  __typename: 'SalesOfferProductTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SalesOfferProductType>;
};

export type SalesOfferServiceMultipleChoiceFieldInput = {
  discount: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  unitAmount: Scalars['Int']['input'];
};

export type SalesOfferServiceType = Node & {
  __typename: 'SalesOfferServiceType';
  discount: Scalars['Int']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  salesOffer: SalesOfferType;
  title: Scalars['String']['output'];
  unitAmount: Scalars['Int']['output'];
};

export type SalesOfferServiceTypeConnection = {
  __typename: 'SalesOfferServiceTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesOfferServiceTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SalesOfferServiceType` and its cursor. */
export type SalesOfferServiceTypeEdge = {
  __typename: 'SalesOfferServiceTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SalesOfferServiceType>;
};

export type SalesOfferType = Node & {
  __typename: 'SalesOfferType';
  company?: Maybe<CompanyType>;
  companyName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserType;
  currency: Scalars['String']['output'];
  endAt?: Maybe<Scalars['Date']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  introductionDescription: Scalars['String']['output'];
  introductionImage?: Maybe<Scalars['String']['output']>;
  introductionTitle: Scalars['String']['output'];
  language: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  logoImage?: Maybe<Scalars['String']['output']>;
  planDescription: Scalars['String']['output'];
  planImage?: Maybe<Scalars['String']['output']>;
  planTitle: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  recipientTitle: Scalars['String']['output'];
  recurringInterval: Scalars['String']['output'];
  recurringIntervalCount: Scalars['Int']['output'];
  salesofferpageSet: SalesOfferPageTypeConnection;
  salesofferproductSet: SalesOfferProductTypeConnection;
  salesofferserviceSet: SalesOfferServiceTypeConnection;
  scope: Scalars['String']['output'];
  showNotIncludedProducts: Scalars['Boolean']['output'];
  showPrices: Scalars['Boolean']['output'];
  startAt?: Maybe<Scalars['Date']['output']>;
  termsDescription: Scalars['String']['output'];
  termsImage?: Maybe<Scalars['String']['output']>;
  termsTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type SalesOfferTypeSalesofferpageSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type SalesOfferTypeSalesofferproductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type SalesOfferTypeSalesofferserviceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SalesOfferTypeConnection = {
  __typename: 'SalesOfferTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesOfferTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SalesOfferType` and its cursor. */
export type SalesOfferTypeEdge = {
  __typename: 'SalesOfferTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SalesOfferType>;
};

/**
 * SBX-520 (wave D15): "use my WasteHero data" as a first-class
 * gap action. Materializes what the platform already knows (the
 * project fleet, the company depots, the live containers) into
 * the case exactly like an upload: a deterministic CSV through
 * the same door (duplicate wall, supersession, explosion), then
 * the tables confirmed as the class the pull knows they are.
 * Refuses honestly where the platform holds nothing, with the D6
 * code and a plain naming what is lacking; a re-pull with
 * unchanged platform data hits the byte-identical duplicate wall
 * (nothing is doubled).
 */
export type SatisfyNeedFromPlatformMutation = {
  __typename: 'SatisfyNeedFromPlatformMutation';
  importCase?: Maybe<ImportCaseDef>;
  importFile?: Maybe<ImportFileDef>;
  /** snake_case wire (D74): {requirement, label, source: 'platform', count, file_name, node_status, sentence}. Render sentence verbatim. */
  pull?: Maybe<Scalars['GenericScalar']['output']>;
};

export type SaveAsTemplatePayload = {
  __typename: 'SaveAsTemplatePayload';
  template: TemplateDef;
};

/**
 * NEXUS-791: rewrite the manual display order of one (company, entity)
 * group of custom-field definitions.
 *
 * Full-list contract: the submitted ID set must be *exactly* the caller's
 * complete set for that entity. This catches the real race — admin A opens
 * the tab, admin B creates a field, admin A drags and saves — by rejecting
 * A's now-stale list so the UI can refetch and ask A to redo the drag, rather
 * than letting the new field land arbitrarily while A believes they set the
 * order. The reorder is written dense 0..n-1 via bulk_update in a
 * transaction, keeping "dense and gap-free" an invariant held by exactly one
 * code path.
 */
export type SaveCompanyMetaTypeOrder = {
  __typename: 'SaveCompanyMetaTypeOrder';
  companyMetaTypes: Array<CompanyMetaTypeDef>;
};

export type SaveDraftGraphPayload = {
  __typename: 'SaveDraftGraphPayload';
  automation: AutomationDef;
  version: Scalars['Int']['output'];
};

export type SaveNodeLayoutPayload = {
  __typename: 'SaveNodeLayoutPayload';
  automation: AutomationDef;
};

/**
 * Create a dataset for ``companyId``, or update dataset ``id``, through
 * ``save_dataset``. ``error`` on a refusal: ``SQL_REFUSED:<reason>`` or
 * ``INVALID_DATASET:<reason>`` as ``save_dataset`` raised it
 * (``errorDetail`` names the tag or word), ``DATASET_NOT_FOUND`` (unknown
 * or deleted id) or ``COMPANY_NOT_FOUND``. An update keeps the dataset's
 * company, author and ``source``.
 */
export type SaveSqlDataset = {
  __typename: 'SaveSqlDataset';
  dataset?: Maybe<SqlDatasetAdminType>;
  error?: Maybe<Scalars['String']['output']>;
  errorDetail?: Maybe<Scalars['String']['output']>;
};

/**
 * Persist one staged batch of Settings-tab threshold edits.
 * Visibility only (ADR-0001): no notifications, no recipients.
 */
export type SaveStockThresholds = {
  __typename: 'SaveStockThresholds';
  status?: Maybe<Scalars['String']['output']>;
};

export type SaveTicketTypeOrder = {
  __typename: 'SaveTicketTypeOrder';
  ticketTypes: Array<TicketTypeDef>;
};

export type SaveTicketTypeOrderSettings = {
  __typename: 'SaveTicketTypeOrderSettings';
  companySettings?: Maybe<CompanySettingsType>;
};

export type SaveTransferDocumentData = {
  __typename: 'SaveTransferDocumentData';
  transferDocument?: Maybe<TransferDocumentType>;
};

export type SavedAnalysisResult = {
  __typename: 'SavedAnalysisResult';
  error?: Maybe<Scalars['String']['output']>;
  savedAnalysis?: Maybe<SavedAnalysisType>;
};

/** A personal, revisitable analysis (the operator's "my look-ups"). */
export type SavedAnalysisType = {
  __typename: 'SavedAnalysisType';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  question?: Maybe<Scalars['String']['output']>;
  spec: Scalars['GenericScalar']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ScenarioDef = Node & {
  __typename: 'ScenarioDef';
  branches: ScenarioDefConnection;
  /** SBX-376 (D32): snapshot age plus churn summary, the live container cohort against the stop-set snapshot's provenance: containers added/removed/moved since, churn percent and the warn threshold. Computed on read; honest notes when the snapshot carries no container provenance. */
  churn?: Maybe<Scalars['GenericScalar']['output']>;
  /** Per-constraint overrides as stored. Detail-page payload: list-shaped reads serve null (BE1.2). */
  constraintOverrides?: Maybe<Scalars['JSONString']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  demandModel: Scalars['String']['output'];
  /** Session 4 B4 (SBX-487, D74): the planner face of demandModel (regional_priors reads Regional priors); the machine token stays beside it, byte-unchanged. */
  demandModelLabel?: Maybe<Scalars['String']['output']>;
  /** Region-pack constraint defaults merged with this scenario's overrides; overrides win per constraint id (PRD F7). Objective profiles are the only objective surface, raw solver weights are never exposed (D10). Detail-page payload: list-shaped reads serve null (BE1.2). */
  effectiveConstraints?: Maybe<Scalars['GenericScalar']['output']>;
  explorationRuns: ExplorationRunDefConnection;
  /** The scenario's staged fleet document. Detail-page payload: list-shaped reads serve null (BE1.2). */
  fleet?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Depot/facility network rows with display names resolved at read (D74). Detail-page payload: list-shaped reads serve null (BE1.2). */
  network?: Maybe<Scalars['JSONString']['output']>;
  objectiveProfile: RouteStudioScenarioObjectiveProfileChoices;
  /** Session 4 B4 (SBX-487, D74): the planner face of objectiveProfile, from the model's own choice labels (minimal_disruption reads Minimal disruption). */
  objectiveProfileLabel?: Maybe<Scalars['String']['output']>;
  parameterSet?: Maybe<ParameterSetDef>;
  parent?: Maybe<ScenarioDef>;
  planningArea: PlanningAreaDef;
  plans: PlanDefConnection;
  prefilledFromRecommendations: RecommendationDefConnection;
  seed: Scalars['Int']['output'];
  /** Perturbation descriptor with planner-worded notes (SBX-487 B9). Detail-page payload: list-shaped reads serve null (BE1.2). */
  serviceCatalogOverrides?: Maybe<Scalars['JSONString']['output']>;
  simulationJobs: SimulationJobDefConnection;
  status: RouteStudioScenarioStatusChoices;
  stopSet?: Maybe<StopSetDef>;
  template: RouteStudioScenarioTemplateChoices;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};


export type ScenarioDefBranchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScenarioDefExplorationRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScenarioDefPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScenarioDefPrefilledFromRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScenarioDefSimulationJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioDefConnection = {
  __typename: 'ScenarioDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScenarioDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ScenarioDef` and its cursor. */
export type ScenarioDefEdge = {
  __typename: 'ScenarioDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScenarioDef>;
};

export type ScheduleOnRouteActionDef = Node & {
  __typename: 'ScheduleOnRouteActionDef';
  area?: Maybe<AreaDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  manual: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  routeScheme?: Maybe<RouteSchemeType>;
  rule: AutopilotLegacyRuleType;
};

export type ScheduleOnRouteActionDefConnection = {
  __typename: 'ScheduleOnRouteActionDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScheduleOnRouteActionDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ScheduleOnRouteActionDef` and its cursor. */
export type ScheduleOnRouteActionDefEdge = {
  __typename: 'ScheduleOnRouteActionDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScheduleOnRouteActionDef>;
};

export type ScheduleOnRouteActionMutationInput = {
  area?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  manual?: InputMaybe<Scalars['Boolean']['input']>;
  routeScheme?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Cutover date (validated against the plan's lead time), full or
 * phased rollout, and the plan-vehicle -> live-fleet mapping
 * ({vehicle_ref: {vehicle_id, trailer_id[, driver_id]}};
 * ``driver_id`` is a per-vehicle driver PREFERENCE, resolved per
 * route date through the platform's absence/substitute machinery at
 * materialization, SBX-375/D35). ``handoverDelayDays`` (SBX-361,
 * default 0) is the stabilization window before the promotion
 * scheme is handed to the platform's nightly generation; 0 hands
 * over at execute. SBX-379 item 2: double-booking a vehicle+weekday
 * already claimed by ANOTHER area's live scheme or scheduled
 * promotion (the shared-fleet ledger) refuses unless the explicit
 * ``acknowledgeFleetConflicts`` flag is passed, the same acknowledge
 * pattern as cross-area container conflicts; the acknowledged set
 * is recorded on the approval record.
 */
export type SchedulePromotionMutation = {
  __typename: 'SchedulePromotionMutation';
  promotion?: Maybe<PromotionDef>;
};

export type ScheduleSmsByPhone = {
  __typename: 'ScheduleSmsByPhone';
  jobId?: Maybe<Scalars['String']['output']>;
  recipientCount?: Maybe<Scalars['Int']['output']>;
  scheduledAt?: Maybe<Scalars['String']['output']>;
};

/** One live scheduled customer-data change (req 3.1.38). */
export type ScheduledChangeDef = Node & {
  __typename: 'ScheduledChangeDef';
  createdAt: Scalars['DateTime']['output'];
  /** Display name of the user who created the entry. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Business key from the crm.scheduling registry. */
  fieldKey: Scalars['String']['output'];
  /** Human-readable label of the scheduled business field. */
  fieldLabel: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** The scheduled value (shape depends on the field kind). */
  newValue?: Maybe<Scalars['GenericScalar']['output']>;
  /** COMPUTED, never stored: for a pending entry the current baseline (registry spec read); for an active entry the value a revert would restore (displaced baseline unless the base was edited mid-window). */
  oldValue?: Maybe<Scalars['GenericScalar']['output']>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  validFrom: Scalars['Date']['output'];
  validTo?: Maybe<Scalars['Date']['output']>;
};

export type ScheduledExportDef = Node & {
  __typename: 'ScheduledExportDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  excelFormat: Scalars['Boolean']['output'];
  exportAgreementEnd: Scalars['Boolean']['output'];
  exportAgreementNew: Scalars['Boolean']['output'];
  exportAgreementRemoved: Scalars['Boolean']['output'];
  exportAgreementStart: Scalars['Boolean']['output'];
  exportContainerCollectionCalendar: Scalars['Boolean']['output'];
  exportContainerCollectionCalendarFromDate: Scalars['Boolean']['output'];
  exportContainerCollectionCalendarWeek: Scalars['Boolean']['output'];
  exportContainerDescription: Scalars['Boolean']['output'];
  exportContainerId: Scalars['Boolean']['output'];
  exportContainerLocation: Scalars['Boolean']['output'];
  exportContainerMetaTypes?: Maybe<Array<Maybe<CompanyMetaTypeDef>>>;
  exportContainerPickupSetting: Scalars['Boolean']['output'];
  exportContainerRouteDescription: Scalars['Boolean']['output'];
  exportContainerRouteScheme: Scalars['Boolean']['output'];
  exportContainerType: Scalars['Boolean']['output'];
  exportContainerWasteFraction: Scalars['Boolean']['output'];
  exportPropertyArea: Scalars['Boolean']['output'];
  exportPropertyId: Scalars['Boolean']['output'];
  exportPropertyLocation: Scalars['Boolean']['output'];
  exportPropertyMetaTypes?: Maybe<Array<Maybe<CompanyMetaTypeDef>>>;
  exportPropertyType: Scalars['Boolean']['output'];
  exportTicketBulkWasteItems: Scalars['Boolean']['output'];
  exportTicketDescription: Scalars['Boolean']['output'];
  exportTicketPreferredDate: Scalars['Boolean']['output'];
  exportTicketType: Scalars['Boolean']['output'];
  filterContainerMetaTypes?: Maybe<Array<Maybe<ScheduledExportMetaTypeDef>>>;
  filterContainerPickupSettings?: Maybe<Array<Maybe<PickupSettingsType>>>;
  filterContainerRouteSchemes?: Maybe<Array<Maybe<RouteSchemeType>>>;
  filterContainerTypes?: Maybe<Array<Maybe<ContainerTypeType>>>;
  filterContainerWasteFractions?: Maybe<Array<Maybe<WasteFractionType>>>;
  filterPropertyMetaTypes?: Maybe<Array<Maybe<ScheduledExportMetaTypeDef>>>;
  filterPropertyTypes?: Maybe<Array<Maybe<PropertyTypeDef>>>;
  filterTicketDate: CrmScheduledExportFilterTicketDateChoices;
  filterTicketStatus: Array<Scalars['Int']['output']>;
  filterTicketTypes?: Maybe<Array<Maybe<TicketTypeDef>>>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  includeAgreements: Scalars['Boolean']['output'];
  includeTickets: Scalars['Boolean']['output'];
  interval: Scalars['Int']['output'];
  intervalDayHour?: Maybe<Scalars['Int']['output']>;
  intervalFuture: Scalars['Boolean']['output'];
  intervalMonthDay?: Maybe<Scalars['Int']['output']>;
  intervalStart: Scalars['DateTime']['output'];
  intervalType: CrmScheduledExportIntervalTypeChoices;
  intervalWeekIsoweekday?: Maybe<Scalars['Int']['output']>;
  language: CrmScheduledExportLanguageChoices;
  name: Scalars['String']['output'];
  nextFromDate?: Maybe<Scalars['DateTime']['output']>;
  nextRunDatetime?: Maybe<Scalars['DateTime']['output']>;
  nextToDate?: Maybe<Scalars['DateTime']['output']>;
  recipients: Array<Scalars['String']['output']>;
  scheduledexportrunSet: ScheduledExportRunDefConnection;
};


export type ScheduledExportDefScheduledexportrunSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ScheduledExportDefConnection = {
  __typename: 'ScheduledExportDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScheduledExportDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ScheduledExportDef` and its cursor. */
export type ScheduledExportDefEdge = {
  __typename: 'ScheduledExportDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScheduledExportDef>;
};

export type ScheduledExportMetaTypeDef = Node & {
  __typename: 'ScheduledExportMetaTypeDef';
  companyMetaValue: CompanyMetaTypeDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type ScheduledExportMetaTypeDefConnection = {
  __typename: 'ScheduledExportMetaTypeDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScheduledExportMetaTypeDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ScheduledExportMetaTypeDef` and its cursor. */
export type ScheduledExportMetaTypeDefEdge = {
  __typename: 'ScheduledExportMetaTypeDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScheduledExportMetaTypeDef>;
};

export type ScheduledExportMetaTypeInput = {
  companyMetaValue?: InputMaybe<Scalars['ID']['input']>;
  value: Scalars['String']['input'];
};

export type ScheduledExportRunDef = Node & {
  __typename: 'ScheduledExportRunDef';
  company: CompanyType;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  excelFormat: Scalars['Boolean']['output'];
  exportAgreementEnd: Scalars['Boolean']['output'];
  exportAgreementNew: Scalars['Boolean']['output'];
  exportAgreementRemoved: Scalars['Boolean']['output'];
  exportAgreementStart: Scalars['Boolean']['output'];
  exportContainerCollectionCalendar: Scalars['Boolean']['output'];
  exportContainerCollectionCalendarFromDate: Scalars['Boolean']['output'];
  exportContainerCollectionCalendarWeek: Scalars['Boolean']['output'];
  exportContainerDescription: Scalars['Boolean']['output'];
  exportContainerId: Scalars['Boolean']['output'];
  exportContainerLocation: Scalars['Boolean']['output'];
  exportContainerMetaTypes: CompanyMetaTypeDefConnection;
  exportContainerPickupSetting: Scalars['Boolean']['output'];
  exportContainerRouteDescription: Scalars['Boolean']['output'];
  exportContainerRouteScheme: Scalars['Boolean']['output'];
  exportContainerType: Scalars['Boolean']['output'];
  exportContainerWasteFraction: Scalars['Boolean']['output'];
  exportFile?: Maybe<Scalars['String']['output']>;
  exportPropertyArea: Scalars['Boolean']['output'];
  exportPropertyId: Scalars['Boolean']['output'];
  exportPropertyLocation: Scalars['Boolean']['output'];
  exportPropertyMetaTypes: CompanyMetaTypeDefConnection;
  exportPropertyType: Scalars['Boolean']['output'];
  exportTicketBulkWasteItems: Scalars['Boolean']['output'];
  exportTicketDescription: Scalars['Boolean']['output'];
  exportTicketPreferredDate: Scalars['Boolean']['output'];
  exportTicketType: Scalars['Boolean']['output'];
  filterContainerMetaTypes: ScheduledExportMetaTypeDefConnection;
  filterContainerPickupSettings: PickupSettingsTypeConnection;
  filterContainerRouteSchemes: RouteSchemeTypeConnection;
  filterContainerTypes: ContainerTypeTypeConnection;
  filterContainerWasteFractions: WasteFractionTypeConnection;
  filterPropertyMetaTypes: ScheduledExportMetaTypeDefConnection;
  filterPropertyTypes: PropertyTypeDefConnection;
  filterTicketDate: CrmScheduledExportRunFilterTicketDateChoices;
  filterTicketStatus: Array<Scalars['Int']['output']>;
  filterTicketTypes: TicketTypeDefConnection;
  fromDate: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  includeAgreements: Scalars['Boolean']['output'];
  includeTickets: Scalars['Boolean']['output'];
  language: CrmScheduledExportRunLanguageChoices;
  newAgreements?: Maybe<AgreementDefConnection>;
  newAgreementsCount?: Maybe<Scalars['Int']['output']>;
  properties: PropertyDefConnection;
  recipients: Array<Scalars['String']['output']>;
  removedAgreements?: Maybe<AgreementDefConnection>;
  removedAgreementsCount?: Maybe<Scalars['Int']['output']>;
  scheduled: Scalars['Boolean']['output'];
  scheduledExport: ScheduledExportDef;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  tickets?: Maybe<TicketDefConnection>;
  ticketsCount?: Maybe<Scalars['Int']['output']>;
  toDate: Scalars['DateTime']['output'];
};


export type ScheduledExportRunDefExportContainerMetaTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduledExportRunDefExportPropertyMetaTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduledExportRunDefFilterContainerMetaTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduledExportRunDefFilterContainerPickupSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduledExportRunDefFilterContainerRouteSchemesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduledExportRunDefFilterContainerTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduledExportRunDefFilterContainerWasteFractionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduledExportRunDefFilterPropertyMetaTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduledExportRunDefFilterPropertyTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduledExportRunDefFilterTicketTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduledExportRunDefNewAgreementsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  container?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRentalBacked?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hauler?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['Float']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveOrFuture?: InputMaybe<Scalars['Boolean']['input']>;
  isContainerAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  isFuture?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  municipality?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  property?: InputMaybe<Scalars['ID']['input']>;
  propertyGroup?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wasteFraction?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type ScheduledExportRunDefPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduledExportRunDefRemovedAgreementsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  container?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRentalBacked?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hauler?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['Float']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveOrFuture?: InputMaybe<Scalars['Boolean']['input']>;
  isContainerAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  isFuture?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  municipality?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  property?: InputMaybe<Scalars['ID']['input']>;
  propertyGroup?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wasteFraction?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type ScheduledExportRunDefTicketsArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  affectsPay?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  allowedForRoute?: InputMaybe<Scalars['ID']['input']>;
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignedTeam?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignee?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerBarcode?: InputMaybe<Scalars['String']['input']>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  createdByKinds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdBySearch?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['String']['input']>;
  excludeStatuses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeTicketTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isComplaint?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastViewedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  managementCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  needToPairRfid?: InputMaybe<Scalars['Boolean']['input']>;
  needToScanBarcode?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  postalAreaSearch?: InputMaybe<Scalars['String']['input']>;
  postalCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['ID']['input']>;
  propertyContactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroup?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reportedByPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  reporter?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reporterByDriver?: InputMaybe<Scalars['Boolean']['input']>;
  reporterDriver?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  requestedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  requestedByPortal?: InputMaybe<Scalars['Boolean']['input']>;
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusCompletedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusCompletedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusInProgressAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusInProgressAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusOnHoldAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusOnHoldAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusOpenAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusOpenAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusPendingAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusPendingAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusRejectedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusRejectedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  syncJob?: InputMaybe<Scalars['Boolean']['input']>;
  ticketType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketTypeCategory?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketTypeService?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketTypeServiceServiceType?: InputMaybe<Scalars['String']['input']>;
  ticketType_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
  wasteFraction?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ScheduledExportRunDefConnection = {
  __typename: 'ScheduledExportRunDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScheduledExportRunDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ScheduledExportRunDef` and its cursor. */
export type ScheduledExportRunDefEdge = {
  __typename: 'ScheduledExportRunDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScheduledExportRunDef>;
};

export type ScheduledSmsRecipientInput = {
  message: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

/** An enumeration. */
export enum ScpAvailability {
  SEASONAL = 'SEASONAL',
  YEAR_ROUND = 'YEAR_ROUND'
}

/**
 * How an SCP's costs are charged to its members (ADR-0002).
 *
 *     ``SUBSCRIPTION``: each member pays a fixed yearly euro amount (the
 *     aluekeräyspiste pattern) — no shares, no redistribution.
 *     ``SHARE_SPLIT``: costs divide between the named members by shares summing
 *     to 100 (the existing share engine).
 *
 */
export enum ScpBillingMode {
  SHARE_SPLIT = 'SHARE_SPLIT',
  SUBSCRIPTION = 'SUBSCRIPTION'
}

/**
 * Derived grouping over ``ScpType`` (ADR-0004) — NEVER stored.
 *
 *     ``SHARED_RESIDENTIAL`` is the kimppa/split residential service (containers
 *     via member properties); ``BLOCK`` and ``REGIONAL`` are both true Shared
 *     Collection Points (company-owned containers). ``kind`` collapses the
 *     ownership axis so callers (container attachment, fraction derivation,
 *     billing defaults) can branch on it without re-deriving the mapping.
 *
 */
export enum ScpKind {
  COLLECTION_POINT = 'COLLECTION_POINT',
  RESIDENTIAL = 'RESIDENTIAL'
}

/**
 * An active SCP membership whose member property lies beyond the point's
 * compliance radius (NEXUS-664 / G25).
 *
 * Powers the tenant-wide compliance-review list ("every member outside its
 * point's radius"). Each row carries the offending ``membership``, the
 * ``property`` (link target for the Jätehuoltokortti — the fix surface) and
 * the ``scp``, plus the server-computed ``distanceM`` / ``radiusM`` behind
 * the verdict.
 */
export type ScpMemberOutsideRadiusDef = {
  __typename: 'ScpMemberOutsideRadiusDef';
  /** Straight-line distance property→point, in metres */
  distanceM: Scalars['Float']['output'];
  membership: ScpMembershipDef;
  property: PropertyDef;
  /** The SCP's effective compliance radius, in metres */
  radiusM: Scalars['Float']['output'];
  scp: PropertyGroupDef;
};

/**
 * Distance verdict for a property vs an SCP's radius (NEX-SS-301).
 *
 * Consumed before membership creation: the FE warns when ``withinRadius`` is
 * false and offers ``nearestAlternatives``. All three verdict fields are null
 * when they cannot be computed (SCP without a point, property without a
 * location, or no tenant default radius configured).
 */
export type ScpMembershipCandidateCheckDef = {
  __typename: 'ScpMembershipCandidateCheckDef';
  /** Straight-line distance in metres */
  distanceM?: Maybe<Scalars['Float']['output']>;
  nearestAlternatives?: Maybe<Array<NearestScpDef>>;
  /** The tenant default SCP radius, in metres */
  radiusM?: Maybe<Scalars['Float']['output']>;
  /** Would a member with the given usage profile need another point for winter (REQ-313)? Null when usageProfile was not provided. */
  seasonalConflict?: Maybe<Scalars['Boolean']['output']>;
  /** Would a member with the given usage profile mix year-round and summer dwellings against the municipality's rule (NEXUS-684)? Null when usageProfile was not provided. */
  usageMixingConflict?: Maybe<Scalars['Boolean']['output']>;
  withinRadius?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Pre-check for ending ONE membership (NEXUS-667 guard modal).
 *
 * ``handoverNeeds`` is non-empty exactly when the plain unsubscribe would be
 * refused with ``SCP_MISSING_CONTACT_PERSON`` / ``SCP_MISSING_PAYER``; the FE
 * opens the successor picker before ever hitting the dead-end.
 */
export type ScpMembershipEndPreviewDef = {
  __typename: 'ScpMembershipEndPreviewDef';
  handoverNeeds?: Maybe<Array<ScpRoleHandoverNeedDef>>;
  membership: ScpMembershipDef;
  willEmptyScp: Scalars['Boolean']['output'];
};

/** One Shared Collection Point a moving-out property will leave. */
export type ScpMoveOutEntryDef = {
  __typename: 'ScpMoveOutEntryDef';
  handoverNeeds?: Maybe<Array<ScpRoleHandoverNeedDef>>;
  membership: ScpMembershipDef;
  scp: PropertyGroupDef;
  willEmptyScp: Scalars['Boolean']['output'];
};

/**
 * The kind of authority notification (kimppailmoitus) being filed.
 *
 *     Models the Finnish kimppa notification duty (Jätelaki 646/2011;
 *     DOMAIN-NOTES "Kimppa notification duty"): the founding notification
 *     (``NEW``), any membership / share / container change that re-triggers the
 *     duty (``CHANGE`` — PJH runs a dedicated *muutoslomake* for this), and the
 *     termination notice (``TERMINATION``).
 *
 */
export enum ScpNotificationKind {
  CHANGE = 'CHANGE',
  NEW = 'NEW',
  TERMINATION = 'TERMINATION'
}

/** PRO-58: one structured opening-hours row ("HH:MM" from-to). */
export type ScpOpeningHoursRangeInput = {
  closes: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  opens: Scalars['String']['input'];
};

/**
 * Preview of the Asukasvaihdos — every membership that ends, the role
 * hand-overs required, and the register basis the property lands on
 * (NEXUS-665). ``resultingRegisterBasis`` is the RegisterBasis enum value;
 * ``NONE`` renders as "Ei liittynyt" and warns the operator.
 */
export type ScpPropertyMoveOutPreviewDef = {
  __typename: 'ScpPropertyMoveOutPreviewDef';
  anyHandoverRequired: Scalars['Boolean']['output'];
  entries?: Maybe<Array<ScpMoveOutEntryDef>>;
  resultingRegisterBasis: Scalars['String']['output'];
};

/**
 * Give a required role to a successor member before an end/move-out.
 *
 * ``successorMembershipId`` uniquely identifies the target SCP (the
 * successor is one of its members), so no separate scp id is needed even in
 * the multi-SCP move-out (NEXUS-667/665).
 */
export type ScpRoleHandoverInput = {
  roleDefinitionId: Scalars['ID']['input'];
  successorMembershipId: Scalars['ID']['input'];
};

/**
 * A required role (Contact Person / Payer) that a move would orphan.
 *
 * Drives the guard modal (NEXUS-667) and the Asukasvaihdos modal
 * (NEXUS-665): ``eligibleSuccessors`` are the SCP's remaining active
 * property members, any of which can receive the role before the outgoing
 * member leaves. The list is empty only when no property member remains to
 * take it (company-only pool) — the FE then guides to termination instead.
 */
export type ScpRoleHandoverNeedDef = {
  __typename: 'ScpRoleHandoverNeedDef';
  eligibleSuccessors?: Maybe<Array<ScpMembershipDef>>;
  roleDefinition: ScpRoleDefinitionDef;
  roleKey: Scalars['String']['output'];
  scp: PropertyGroupDef;
};

/** PRO-58: one seasonal availability window (months 1-12). */
export type ScpSeasonalIntervalInput = {
  endMonth: Scalars['Int']['input'];
  startMonth: Scalars['Int']['input'];
};

export type ScpShareInput = {
  membershipId: Scalars['ID']['input'];
  share: Scalars['Decimal']['input'];
};

/**
 * An SCP whose ACTIVE pool no longer sums to 100.00% (NEXUS-720).
 *
 * The compliance-queue cause for the bounded-membership lapse: a scheduled
 * end that passes drops the member out of the active pool with no
 * redistribution, draining the sum below 100 with only the ledger-feed
 * warning as detector before this row. ``lapsedMemberCount`` counts the
 * ACTIVE-status rows whose end already lapsed — the usual cause the
 * operator must resolve (re-balance via the shares editor).
 */
export type ScpShareSumBreachDef = {
  __typename: 'ScpShareSumBreachDef';
  /** Active members (property + company) in the pool */
  activeMemberCount: Scalars['Int']['output'];
  /** ACTIVE-status memberships whose scheduled end has lapsed */
  lapsedMemberCount: Scalars['Int']['output'];
  scp: PropertyGroupDef;
  /** Active members' combined share, percent */
  shareSumPct: Scalars['Decimal']['output'];
};

/** An enumeration. */
export enum ScpType {
  BLOCK = 'BLOCK',
  REGIONAL = 'REGIONAL',
  SHARED_RESIDENTIAL = 'SHARED_RESIDENTIAL'
}

/**
 * Membership usage profile (ADR-0006 / NEXUS-647).
 *
 *     ``YEAR_ROUND | SUMMER`` replaces the NEXUS-541 placeholder
 *     PERMANENT/SEASONAL/OCCASIONAL. SSoT REQ-307 (3.2.14) speaks of "summer
 *     and winter times": YEAR_ROUND covers winter usage (a year-round user is
 *     present in winter), SUMMER is the holiday-cottage user. Extensible if a
 *     distinct winter-only case ever appears. Existing rows were migrated
 *     PERMANENT → YEAR_ROUND, SEASONAL/OCCASIONAL → SUMMER (crm/0323).
 *
 */
export enum ScpUsageProfile {
  SUMMER = 'SUMMER',
  YEAR_ROUND = 'YEAR_ROUND'
}

export type SearchLocation = {
  __typename: 'SearchLocation';
  locations?: Maybe<Array<Maybe<SearchLocationDef>>>;
};

export type SearchLocationDef = {
  __typename: 'SearchLocationDef';
  isPlace?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  municipalityCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  postalCodeName?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
};

export type SearchLocationReverse = {
  __typename: 'SearchLocationReverse';
  locations?: Maybe<Array<Maybe<SearchLocationDef>>>;
};

export type SearchSyncHealthRow = {
  __typename: 'SearchSyncHealthRow';
  activeVersion: Scalars['Int']['output'];
  baselineEstablished: Scalars['Boolean']['output'];
  cursorLagSeconds?: Maybe<Scalars['Int']['output']>;
  cursorUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  dirtyDepth: Scalars['Int']['output'];
  docCount: Scalars['Int']['output'];
  entityType: Scalars['String']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  lastFullRebuildAt?: Maybe<Scalars['DateTime']['output']>;
  lastReconcileAt?: Maybe<Scalars['DateTime']['output']>;
  lastReconcileResult?: Maybe<Scalars['JSONString']['output']>;
  locale: Scalars['String']['output'];
};

/**
 * Create the company's template from the standard composting definition.
 *
 * Backs the manager UI's "Create from standard template" button and shares
 * its implementation with ``manage.py
 * seed_composting_notification_template``, so a template created from the UI
 * and one created by a deploy are identical by construction.
 *
 * Idempotent: a company that already has a template gets it back untouched.
 * ``force`` soft-deletes the current template and rebuilds from standard —
 * a deliberate "reset to standard" that keeps the old definition addressable
 * rather than destroying it.
 */
export type SeedCompostingNotificationTemplate = {
  __typename: 'SeedCompostingNotificationTemplate';
  compostingNotificationTemplate?: Maybe<CompostingNotificationTemplateDef>;
};

export type SelfPasswordChange = {
  __typename: 'SelfPasswordChange';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * One Copilot turn (RS-802): records the user message, runs the
 * agentic loop through the frozen RS-801 registry, verifies the
 * outbound text (RS-803), and returns the assistant reply with its
 * full tool-call trace.
 */
export type SendCopilotMessageMutation = {
  __typename: 'SendCopilotMessageMutation';
  conversation?: Maybe<CopilotConversationDef>;
  message?: Maybe<CopilotMessageDef>;
};

/**
 * The panel's "Send e-mail now": mail the chosen tiles once to the
 * given recipients, without saving a subscription.
 */
export type SendDashboardEmailOnce = {
  __typename: 'SendDashboardEmailOnce';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Deliver one subscription at once — the panel's "Send e-mail nu". */
export type SendDashboardSubscriptionNow = {
  __typename: 'SendDashboardSubscriptionNow';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SendEmailActionDef = Node & {
  __typename: 'SendEmailActionDef';
  body: Scalars['String']['output'];
  companyEmailAccount: CompanyEmailAccountDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  rule: AutopilotLegacyRuleType;
  subject: Scalars['String']['output'];
  toEmail: Scalars['String']['output'];
  toName: Scalars['String']['output'];
};

export type SendEmailActionMutationInput = {
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyEmailAccount: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
  toEmail: Scalars['String']['input'];
  toName?: InputMaybe<Scalars['String']['input']>;
};

export type SendMessageToPropertyContactActionDef = Node & {
  __typename: 'SendMessageToPropertyContactActionDef';
  companyEmailAccount?: Maybe<CompanyEmailAccountDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  role?: Maybe<ContactRole>;
  rule: AutopilotLegacyRuleType;
  subject: Scalars['String']['output'];
  via: TicketSendMessageToPropertyContactActionViaChoices;
};

export type SendMessageToPropertyContactActionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyEmailAccount?: InputMaybe<Scalars['ID']['input']>;
  message: Scalars['String']['input'];
  role: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  via: Scalars['String']['input'];
};

export type SendMessageToPropertyUserActionDef = Node & {
  __typename: 'SendMessageToPropertyUserActionDef';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  rule: AutopilotLegacyRuleType;
  via?: Maybe<TicketSendMessageToPropertyUserActionViaChoices>;
};

export type SendMessageToPropertyUserActionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  via?: InputMaybe<Scalars['String']['input']>;
};

export type SendMqttMessage = {
  __typename: 'SendMqttMessage';
  status?: Maybe<Scalars['String']['output']>;
};

export type SendSmsByAddress = {
  __typename: 'SendSmsByAddress';
  messageId?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
};

/**
 * Manually create + queue a SvarUt dispatch for a ticket.
 *
 * Permissions: any authenticated user with access to the ticket's
 * company. The mutation is idempotent: the external_reference is derived
 * deterministically from (ticket, use_case), so if a dispatch for that
 * pair already exists, dispatch_create returns the existing row instead
 * of creating a second one.
 */
export type SendSvarUtDispatchManually = {
  __typename: 'SendSvarUtDispatchManually';
  dispatch?: Maybe<SvarUtDispatchType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  /** What the send actually did, so the UI can distinguish a re-send from a first send. One of SvarUtSendOutcome: `created` (new dispatch queued), `already_sent` (a live/delivered dispatch already existed — nothing resent), `retried` (a prior failed dispatch was re-attempted). Null when the send was skipped or errored. */
  outcome?: Maybe<Scalars['String']['output']>;
};

export type SendTicketSummaryInput = {
  toUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  via: Scalars['String']['input'];
};

/** Office: (re)send the holder their signing link. Revokes any live one. */
export type SendTransferDocumentSignLink = {
  __typename: 'SendTransferDocumentSignLink';
  sent?: Maybe<Scalars['Boolean']['output']>;
  transferDocument?: Maybe<TransferDocumentType>;
};

export type SensorInputObject = {
  deviceAngle?: InputMaybe<Scalars['Float']['input']>;
  internalHeight: Scalars['Float']['input'];
  lid: Scalars['String']['input'];
  measurementSettingId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Float']['input']>;
  sensorId: Scalars['String']['input'];
};

export type ServiceDef = Node & {
  __typename: 'ServiceDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  migratedFromId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ppAdditionalServiceCategories?: Maybe<Array<Maybe<PpCategoryDef>>>;
  ppAllAdditionalServiceCategories: Scalars['Boolean']['output'];
  ppServiceProduct?: Maybe<PpProductDef>;
  productSet: ProductDefConnection;
  routeDescription: Scalars['String']['output'];
  serviceType?: Maybe<ServiceType>;
  servicepriceSet: ServicePriceDefConnection;
  tickettypeSet: TicketTypeDefConnection;
};


export type ServiceDefProductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ServiceDefServicepriceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ServiceDefTickettypeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceDefConnection = {
  __typename: 'ServiceDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ServiceDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ServiceDef` and its cursor. */
export type ServiceDefEdge = {
  __typename: 'ServiceDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ServiceDef>;
};

export type ServicePriceDef = Node & {
  __typename: 'ServicePriceDef';
  amount: Scalars['Int']['output'];
  company: CompanyType;
  containerType?: Maybe<ContainerTypeType>;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['Date']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  invoiceName: Scalars['String']['output'];
  keyType?: Maybe<KeyTypeType>;
  name: Scalars['String']['output'];
  propertyType?: Maybe<PropertyTypeDef>;
  service: ServiceDef;
  startDate: Scalars['Date']['output'];
  wasteFraction?: Maybe<WasteFractionType>;
};

export type ServicePriceDefConnection = {
  __typename: 'ServicePriceDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ServicePriceDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ServicePriceDef` and its cursor. */
export type ServicePriceDefEdge = {
  __typename: 'ServicePriceDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ServicePriceDef>;
};

export type ServiceResponsibilityDef = Node & {
  __typename: 'ServiceResponsibilityDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  legalClass?: Maybe<CoreServiceResponsibilityLegalClassChoices>;
  name: Scalars['String']['output'];
};

export type ServiceResponsibilityDefConnection = {
  __typename: 'ServiceResponsibilityDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ServiceResponsibilityDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ServiceResponsibilityDef` and its cursor. */
export type ServiceResponsibilityDefEdge = {
  __typename: 'ServiceResponsibilityDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ServiceResponsibilityDef>;
};

/** An enumeration. */
export enum ServiceType {
  ADD_CONTAINER = 'ADD_CONTAINER',
  BULK_WASTE_PICKUP = 'BULK_WASTE_PICKUP',
  CHANGE_CONTAINER_COLLECTION_CALENDAR = 'CHANGE_CONTAINER_COLLECTION_CALENDAR',
  CHANGE_CONTAINER_PICKUP_SETTING = 'CHANGE_CONTAINER_PICKUP_SETTING',
  CHANGE_CONTAINER_ROUTE_SCHEME = 'CHANGE_CONTAINER_ROUTE_SCHEME',
  CHANGE_CONTAINER_TYPE = 'CHANGE_CONTAINER_TYPE',
  CONTACT_SYNC = 'CONTACT_SYNC',
  CONTAINER_REPAIR = 'CONTAINER_REPAIR',
  CONTAINER_WASHING = 'CONTAINER_WASHING',
  CUSTOMER_REQUEST = 'CUSTOMER_REQUEST',
  EXCHANGE_RENTAL = 'EXCHANGE_RENTAL',
  EXTRA_EMPTYING = 'EXTRA_EMPTYING',
  KEY_ORDER = 'KEY_ORDER',
  KEY_REPLACE = 'KEY_REPLACE',
  KEY_RETURN = 'KEY_RETURN',
  MISSING_COLLECTION = 'MISSING_COLLECTION',
  NEW_PROPERTY = 'NEW_PROPERTY',
  ORDER_SPARE_PART = 'ORDER_SPARE_PART',
  RECEIVE_STOCK = 'RECEIVE_STOCK',
  RELOCATE_RENTAL = 'RELOCATE_RENTAL',
  REMOVE_CONTAINER = 'REMOVE_CONTAINER',
  RENT_STOCK = 'RENT_STOCK',
  REPOSITION_RENTAL = 'REPOSITION_RENTAL',
  RETURN_RENTAL = 'RETURN_RENTAL',
  RFID_PAIRING = 'RFID_PAIRING',
  SCP_TERMINATION = 'SCP_TERMINATION',
  SCP_WITHDRAWAL = 'SCP_WITHDRAWAL',
  TEMPORARY_CONTAINER_CHANGE = 'TEMPORARY_CONTAINER_CHANGE',
  TRANSFER_STOCK = 'TRANSFER_STOCK',
  WAIT_AND_LOAD = 'WAIT_AND_LOAD'
}

export type ServiceUnitDef = Node & {
  __typename: 'ServiceUnitDef';
  aggregateDemand: Scalars['JSONString']['output'];
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  geometry?: Maybe<Scalars['GeoJSON']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  networkVersion?: Maybe<NetworkVersionDef>;
  segmentRef: Scalars['String']['output'];
  serviceSeconds?: Maybe<Scalars['Float']['output']>;
  serviceTimeInputs: Scalars['JSONString']['output'];
  side: RouteStudioServiceUnitSideChoices;
  stopSet: StopSetDef;
  stops: StopDefConnection;
};


export type ServiceUnitDefStopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceUnitDefConnection = {
  __typename: 'ServiceUnitDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ServiceUnitDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ServiceUnitDef` and its cursor. */
export type ServiceUnitDefEdge = {
  __typename: 'ServiceUnitDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ServiceUnitDef>;
};

/**
 * Set/override the per-agreement shares of a shared property (3.2.11).
 *
 * Legacy groups keep their FK-based semantics unchanged. NEXUS-625: when the
 * agreement's property carries no legacy ``property_group`` FK (SCP flows
 * never set it), the pool is resolved from the property's sole active
 * ``SCPMembership`` and the vector must cover exactly the SCP's active
 * member properties. NEXUS-741: a property carrying BOTH the FK and a sole
 * active membership (migrated kimppas) resolves membership-first when the
 * FK group is SCP-profiled, so per-container overrides stay reachable.
 */
export type SetAgreementShares = {
  __typename: 'SetAgreementShares';
  agreement?: Maybe<AgreementDef>;
};

/**
 * Office-only (PRO-118): turn the area's auto-attach rule on/off.
 * The flip itself lands in the change log via the save-path diff.
 */
export type SetAreaAutoAttach = {
  __typename: 'SetAreaAutoAttach';
  area?: Maybe<AreaDef>;
};

/**
 * Office-only (PRO-91): the Governance advanced setting — how many
 * months before the end date the area counts as Expiring. Null resets to
 * the platform default (12). The change lands in the change log via the
 * save-path diff.
 */
export type SetAreaExpiryLeadTime = {
  __typename: 'SetAreaExpiryLeadTime';
  area?: Maybe<AreaDef>;
};

/**
 * Office-only (B1.4): the contract area's holiday-policy override.
 * ``policy: null`` resets to "inherit the company default". Change
 * lands in the area's change log via the existing save-path diff
 * (``Area.CHANGE_LOG_FIELDS``) — no separate logging call needed.
 */
export type SetAreaHolidayPolicy = {
  __typename: 'SetAreaHolidayPolicy';
  area?: Maybe<AreaDef>;
};

/**
 * HSY-258, office-only: the contract area's permitted operating
 * weekdays override (``routes.Area.operating_weekdays``, lowercase
 * mon..sun). An empty list or null resets to "inherit the company's
 * permitted days" (``CompanySettings.operating_weekdays``). Same
 * change-log path as the holiday policy override.
 */
export type SetAreaOperatingWeekdays = {
  __typename: 'SetAreaOperatingWeekdays';
  area?: Maybe<AreaDef>;
};

export type SetAutomationChannelPolicyPayload = {
  __typename: 'SetAutomationChannelPolicyPayload';
  channelPolicy: ChannelPolicyDef;
};

export type SetAutomationDefaultFireCapPayload = {
  __typename: 'SetAutomationDefaultFireCapPayload';
  settings: AutomationSettingsDef;
};

export type SetAutomationPolicyPayload = {
  __typename: 'SetAutomationPolicyPayload';
  policy: PolicyDef;
};

/**
 * RS-1502: the per-area autonomy setting (D35, default L2).
 *
 * L4 is rejected here, at the model save AND at the database
 * constraint: it is not authorized and does not exist.
 *
 * SBX-537 P1-1 (wave D23): master-gated. Raising an area to L3
 * Guarded Autopilot changes what runs against live routes without
 * a human in the loop; any-assigned-user reach broke the module's
 * own RS-2009 doctrine.
 */
export type SetAutonomyLevelMutation = {
  __typename: 'SetAutonomyLevelMutation';
  planningArea?: Maybe<PlanningAreaDef>;
};

/**
 * W10 legal sweep: a tenant back-office user toggles benchmark
 * participation and acknowledges the notice. Opting OUT purges the
 * tenant's already-ingested observations — participation withdrawal
 * retracts data, it does not merely stop future ingest.
 */
export type SetBenchmarkParticipation = {
  __typename: 'SetBenchmarkParticipation';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  purged?: Maybe<Scalars['Int']['output']>;
};

/**
 * Create or update the billing schedule for an agreement.
 *
 * Creating sets the frequency + computes ``next_billing_date``. Changing the
 * frequency on an existing schedule applies the no-proration rule
 * (``change_frequency``): the change takes effect from the start of the next
 * unbilled period, appends to the frequency-change log, and sets
 * ``frequency_changed_since_last_run``.
 */
export type SetBillingScheduleMutation = {
  __typename: 'SetBillingScheduleMutation';
  schedule?: Maybe<BillingScheduleDef>;
};

/**
 * Who sees one of a client's New dashboards: "only_me" (its owner),
 * "everyone" in its company, or "roles" with at least one live role of
 * that company (``rolesCanView``, Relay or plain ids). Masters, staff and
 * superusers see every one either way.
 */
export type SetBuilderDashboardAudienceAsStaff = {
  __typename: 'SetBuilderDashboardAudienceAsStaff';
  dashboard?: Maybe<BuilderAdminDashboardType>;
  error?: Maybe<Scalars['String']['output']>;
};

/**
 * Staff-only: toggle one or more feature flags on an ARBITRARY company.
 *
 * Unlike ``PartialUpdateCompanySettings`` (tenant self-update of the caller's
 * own company), this is an internal WasteHero-staff tool that acts on any
 * company by id — impersonation-style. Gated to ``is_staff`` only (NOT master,
 * NOT tenant admins) via ``login_is_staff_required``.
 *
 * Flip-on side-effects are routed through the model, never bypassed:
 * ``metabase_enabled`` lazily provisions the Metabase user/collection via
 * ``CompanySettings.metabase_enable`` (mirrors the tenant mutation), and
 * ``hauler_b2b_enabled`` provisions the tenant's default LegalEntity exactly
 * as ``CompanySettingsAdmin.save_model`` does (idempotent, failure-tolerant).
 * ``special_price_terms_enabled`` (HSY-244) folds the company's pre-HSY-244
 * special prices into the row's own terms on the OFF → ON flip (see
 * ``feature_config.legacy_writer``).
 */
export type SetCompanyFeatureFlags = {
  __typename: 'SetCompanyFeatureFlags';
  companySettings?: Maybe<CompanySettingsType>;
  featureFlags?: Maybe<Array<Maybe<CompanyFeatureFlagType>>>;
};

/**
 * Replace the granted capability-key set for one portal role of the
 * calling user's company (PRO-317).
 *
 * The company-scoped counterpart of ``SetPortalRoleCapabilities`` above:
 * same whole-row-replace semantics (the supplied keys BECOME the role's
 * complete grant — the honest shape for the checkbox grid) and the same
 * loud rejection of unknown roles/keys, but writing the tenant's own
 * ``(company, role)`` row, so it is delegable via ``CompanyRolePermission``
 * (the "Portal role rights" Settings permission) and works under
 * impersonation like every other tenant surface.
 */
export type SetCompanyPortalRoleCapabilities = {
  __typename: 'SetCompanyPortalRoleCapabilities';
  portalRoleCapability?: Maybe<PortalRoleCapabilityGrantDef>;
};

/**
 * Office-only: rule whether a complaint ticket affects the contractor's
 * pay (D5). Audited (who/when) on the ticket. Contractors are refused.
 *
 * A null ruling clears it back to "Not yet assessed" and removes the audit
 * stamps (PRODUCT-230) — the service always supported the reset; the arg
 * was ``Boolean!`` so no client could reach it.
 */
export type SetComplaintAffectsPay = {
  __typename: 'SetComplaintAffectsPay';
  complaint?: Maybe<HaulerComplaintType>;
};

export type SetContactAddressPrimary = {
  __typename: 'SetContactAddressPrimary';
  address?: Maybe<ContactAddressDef>;
};

/**
 * PRO-755: create/update a subject's per-property auto-subscribe rule and
 * immediately reconcile subscriptions (toggle-on backfills every current
 * container + registers the standing rule; toggle-off freezes). Exactly one of
 * ``contact_id`` / ``management_company_id`` must be given.
 */
export type SetContactPropertyNotificationRule = {
  __typename: 'SetContactPropertyNotificationRule';
  contactPropertyNotificationRule?: Maybe<ContactPropertyNotificationRuleDef>;
};

export type SetContainerGroup = {
  __typename: 'SetContainerGroup';
  containers?: Maybe<Array<Maybe<ContainerType>>>;
};

export type SetContainerStorageDepot = {
  __typename: 'SetContainerStorageDepot';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Put a table on New dashboards' list under ``label`` (its name in
 * the tile editor), or take it off (``exposed`` false).
 */
export type SetDashboardTable = {
  __typename: 'SetDashboardTable';
  error?: Maybe<Scalars['String']['output']>;
  table?: Maybe<DashboardTableType>;
};

export type SetDefaultCard = {
  __typename: 'SetDefaultCard';
  billingInformation?: Maybe<BillingInformationType>;
};

export type SetDefaultUserFilterCollection = {
  __typename: 'SetDefaultUserFilterCollection';
  userFilterCollection?: Maybe<UserFilterCollectionType>;
};

/**
 * Office-only: schedule an exception type's pay + reliability effect from
 * a forward date (PRO-467). Re-setting the same type on the same date
 * updates that scheduled row; effective dates in the past are refused.
 */
export type SetExceptionCompensationEffect = {
  __typename: 'SetExceptionCompensationEffect';
  overview?: Maybe<ExceptionEffectOverviewType>;
  row?: Maybe<ExceptionEffectRowType>;
};

/**
 * REQ 3.3.21/3.3.23: office-enter (upsert) the measured quantity for a
 * MANUAL metered computation (per_tonne / per_hour / per_distance /
 * per_reversing_distance) in a contract-area month. Settlement then pays
 * ``rate × quantity`` for every metered component of that computation on
 * the area's price rows. ``quantity`` is whole measured units (>= 0);
 * entering it (even 0) also clears the ``unpriced_metered_data`` close
 * block for that computation.
 */
export type SetHaulerManualMeteredQuantity = {
  __typename: 'SetHaulerManualMeteredQuantity';
  manualQuantity?: Maybe<HaulerManualMeteredQuantityType>;
};

/**
 * R2-S13 (decision R2-D18): replace the METERED component stack of one
 * contractor price (replace-all; an empty list clears it). Metered pay =
 * rate × measured quantity, resolved by the settlement selectors over
 * each period (per_emptying = the row's priced stops, per_round = the
 * distinct rounds among them) — it never joins the per-stop eventPay.
 * Computations whose measured-data feed is not available (per_tonne /
 * per_hour / per_distance) are refused: 'data feed not available'.
 */
export type SetHaulerPriceMeteredComponents = {
  __typename: 'SetHaulerPriceMeteredComponents';
  haulerPrice?: Maybe<HaulerPriceDef>;
  meteredComponents?: Maybe<Array<Maybe<HaulerPriceMeteredComponentDef>>>;
};

/**
 * Deactivate / reactivate one industry-catalogue code (PD-50).
 *
 * The ONLY write surface the catalogue has: rows are seed-owned
 * (``crm.services.industry_catalogue``), so no create/update/delete
 * mutations exist by design. Deactivation hides the code from pickers
 * (``allIndustryCodes(isActive: true)``) while existing assignments and
 * billable-event snapshots keep rendering — the row is never removed.
 * Gated by ``industry_catalogue__edit`` and audit-logged (locked
 * decision 10; ``crm_contact``-style temporal versioning does not cover
 * ``core`` catalogue tables, so the audit row is the change log).
 */
export type SetIndustryCodeActive = {
  __typename: 'SetIndustryCodeActive';
  industryCode?: Maybe<IndustryCodeDef>;
};

/**
 * I7 (SBX-450) + I1: configure an alert's delivery — which whole
 * teams it notifies (in addition to the subscriber) and whether it
 * also emails recipients. The subscriber owns the alert; team ids are
 * intersected with the company's own core.Teams so a caller can never
 * target another tenant's team. Empty team list clears team targeting
 * (alert reverts to notifying just the subscriber).
 */
export type SetInsightsAlertTeams = {
  __typename: 'SetInsightsAlertTeams';
  error?: Maybe<Scalars['String']['output']>;
  notifyEmail?: Maybe<Scalars['Boolean']['output']>;
  ok: Scalars['Boolean']['output'];
  teamIds?: Maybe<Array<Scalars['ID']['output']>>;
  userIds?: Maybe<Array<Scalars['ID']['output']>>;
};

/**
 * I3 (SBX-446): pin (or clear) the caller's personal default
 * dashboard. A null/omitted id clears it → the Overview is the home.
 * The dashboard must be visible to the caller (NOT_FOUND otherwise);
 * never leaks a foreign tenant's existence.
 */
export type SetInsightsDefaultDashboard = {
  __typename: 'SetInsightsDefaultDashboard';
  dashboard?: Maybe<DashboardType>;
  error?: Maybe<Scalars['String']['output']>;
};

/**
 * Replace the granted capability-key set for one global portal role.
 *
 * Whole-row write: the supplied keys BECOME the role's complete grant (the
 * honest shape for the checkbox grid), not a per-key add/remove delta.
 *
 * The matrix is global/product-wide - one row per role, NO company scoping
 * (see ``crm/models/portal_capabilities.py``). It is therefore gated on
 * ``login_is_staff_required`` (``is_staff``): historically it was retunable
 * only through the ``is_staff`` Django admin, and a wrong write widens what
 * every citizen of every tenant may do, so it must NOT be delegable to
 * per-tenant company roles (``CompanyRolePermission`` would enforce tenant
 * isolation against a company-scoped object this global row does not have).
 *
 * Unknown roles and unknown capability keys are rejected loudly rather than
 * stored: an unrecognised key would silently become a right the frontend
 * never checks for.
 */
export type SetPortalRoleCapabilities = {
  __typename: 'SetPortalRoleCapabilities';
  portalRoleCapability?: Maybe<PortalRoleCapabilityGrantDef>;
};

export type SetPropertiesInPropertyGroup = {
  __typename: 'SetPropertiesInPropertyGroup';
  propertyGroup?: Maybe<PropertyGroupDef>;
};

export type SetPropertyManagementCompanyAddressPrimary = {
  __typename: 'SetPropertyManagementCompanyAddressPrimary';
  address?: Maybe<PropertyManagementCompanyAddressDef>;
};

/**
 * Set a reconciliation row's status (unreconciled | matched | disputed) —
 * PRO-468. MATCHED is terminal (locks the row). DISPUTED may link the PRO-465
 * credit/deduction entry that resolves it; resolving is an EXPLICIT matched
 * transition (this mutation), never a side effect of the entry's approval.
 * Office-only + the reconcile right.
 */
export type SetReconciliationStatus = {
  __typename: 'SetReconciliationStatus';
  reconciliation?: Maybe<PurchaseInvoiceReconciliationType>;
};

/**
 * B1.1 (ADR-0006): link a route scheme to the warehouse it draws
 * from. Upsert per scheme - re-setting replaces the previous
 * warehouse.
 */
export type SetRouteSchemeWarehouseLink = {
  __typename: 'SetRouteSchemeWarehouseLink';
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Office-only: record (or clear) a stop's deviation reason (REQ 3.6.25).
 *
 * A contractor is refused (server-side deny). Pass ``reason: null`` to
 * clear. The reason must be one of the taxonomy values.
 */
export type SetStopDeviationReason = {
  __typename: 'SetStopDeviationReason';
  pickupOrder?: Maybe<PickUpOrderType>;
  skipReason?: Maybe<Scalars['String']['output']>;
};

/**
 * PRO-378 (3.12.23): the ONE sanctioned write path for changing the
 * deadline of an EXISTING ticket. A reason is mandatory — see
 * ``Ticket.set_deadline``, which audit-logs the change as a
 * ``TicketEventType.MODIFIED`` row. The Manual-mode CREATION-time
 * deadline is a normal ``createTicket``/etc. input, not this mutation.
 */
export type SetTicketDeadline = {
  __typename: 'SetTicketDeadline';
  ticket?: Maybe<TicketDef>;
};

export type SetTicketPriority = {
  __typename: 'SetTicketPriority';
  ticket?: Maybe<TicketDef>;
};

export type SetTicketRoute = {
  __typename: 'SetTicketRoute';
  /** Why the route could not be re-optimized after this ticket was scheduled on it; null when it was, or when the route does not auto-optimize. */
  optimizationError?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<TicketDef>;
};

export type SetTicketTypeAreaExecutionWindowMutationInput = {
  area: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional context, e.g. the contract clause behind it. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** How long a task of this type may take in this area. 0 means it must be executed on its scheduled day. */
  offsetNumber: Scalars['Int']['input'];
  offsetUnit: Scalars['String']['input'];
  ticketType: Scalars['ID']['input'];
};

/**
 * HSY-256 — define or adjust a task type's window in one contract area.
 *
 * UPSERT on (ticket_type, area) rather than create-or-409: the operator's
 * intent is "in this area, this type gets this window", and re-stating it
 * should adjust the rule rather than fail. The unique constraint is what
 * makes the upsert safe under concurrency.
 */
export type SetTicketTypeAreaExecutionWindowMutationPayload = {
  __typename: 'SetTicketTypeAreaExecutionWindowMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ticketTypeAreaExecutionWindow?: Maybe<TicketTypeAreaExecutionWindowDef>;
};

/**
 * Replace a warehouse's designated low-stock alert recipients. An
 * empty list sends the alerts back to the company admins' bell.
 */
export type SetWarehouseAlertRecipients = {
  __typename: 'SetWarehouseAlertRecipients';
  recipients?: Maybe<Array<WarehouseAlertRecipientType>>;
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Mark a zone (whole, or fraction slices) as served by the own fleet.
 *
 * Replace semantics for the zone's ACTIVE marking; withdrawn marks are
 * stamped removed (never deleted) so the history stays answerable.
 * Office-only; no contractor, no prices, no settlement attach (8B).
 */
export type SetZoneOwnFleet = {
  __typename: 'SetZoneOwnFleet';
  status: Scalars['String']['output'];
};

export type SettingsType = Node & {
  __typename: 'SettingsType';
  /** 12-hour clock? */
  clockFormat12: Scalars['Boolean']['output'];
  cluster: Scalars['Boolean']['output'];
  company?: Maybe<CompanyType>;
  country: Scalars['String']['output'];
  crmEnabled: Scalars['Boolean']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  dashboardLocation?: Maybe<LocationWithContainerType>;
  drivingDistance?: Maybe<Scalars['String']['output']>;
  emptyingMethod?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  measuringDistance?: Maybe<Scalars['String']['output']>;
  /** mins */
  pickupTime: Scalars['Int']['output'];
  taxMode?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
  volume?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type SettingsTypeConnection = {
  __typename: 'SettingsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SettingsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SettingsType` and its cursor. */
export type SettingsTypeEdge = {
  __typename: 'SettingsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SettingsType>;
};

/**
 * One manual audited ± adjustment line on a period (R2-S12, R2-D19).
 *
 * Served from live rows while the period is OPEN and from the frozen
 * snapshot once it is closed — identical shape either way.
 */
export type SettlementAdjustmentLineType = {
  __typename: 'SettlementAdjustmentLineType';
  /** Signed cents: positive = extra pay to the contractor, negative = deduction. */
  amountCents: Scalars['Int']['output'];
  /** ISO datetime the adjustment was booked. */
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

/** A manual audited ± line on a settlement period (R2-S12, R2-D19). */
export type SettlementAdjustmentType = Node & {
  __typename: 'SettlementAdjustmentType';
  /** Signed integer cents: positive = extra pay to the contractor, negative = deduction. */
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  period: SettlementPeriodType;
  /** Mandatory audit reason (R2-D19). */
  reason: Scalars['String']['output'];
};

/**
 * One broken settlement-relevant event blocking a period close
 * (R2-S11, decision R2-D17).
 */
export type SettlementBlockingIssueType = {
  __typename: 'SettlementBlockingIssueType';
  /** ISO datetime the stop was completed. */
  completedAt?: Maybe<Scalars['String']['output']>;
  containerId?: Maybe<Scalars['ID']['output']>;
  detail: Scalars['String']['output'];
  /** App-relative link to the stop's route detail page, for the fix-it drawer. */
  link?: Maybe<Scalars['String']['output']>;
  pickupOrderId: Scalars['ID']['output'];
  /** Problem code: no_container | missing_product | missing_price_row | unpriced_metered_data. */
  problem: Scalars['String']['output'];
  routeId?: Maybe<Scalars['ID']['output']>;
  stopNumber?: Maybe<Scalars['Int']['output']>;
};

/**
 * One completed collection whose pay was changed by its exception type
 * (PRO-467 drill-through, REQ per-performance name + factor).
 *
 * Present only for a performance whose exception effect actually moved the
 * money; empty under the day-one defaults. Served live for open periods and
 * from the frozen snapshot once closed.
 */
export type SettlementExceptionLineType = {
  __typename: 'SettlementExceptionLineType';
  /** Event pay after the effect, cents. */
  adjustedAmount: Scalars['Int']['output'];
  /** Human name of the exception type. */
  exceptionName: Scalars['String']['output'];
  /** The DeviationReason code applied. */
  exceptionType: Scalars['String']['output'];
  /** Applied pay multiplier (0.0 = not payable, 0.5 = half). */
  factor: Scalars['Float']['output'];
  /** Event pay before the effect, cents. */
  originalAmount: Scalars['Int']['output'];
  pickupOrderId: Scalars['ID']['output'];
  productId?: Maybe<Scalars['ID']['output']>;
  stopNumber?: Maybe<Scalars['Int']['output']>;
};

/**
 * A parent contract area, its same-hauler carve-out(s), and a roll-up
 * (PRO-280 S1, decision 10).
 *
 * ``parent`` and each ``carveOuts`` entry are ordinary per-area settlement
 * reports, kept separate so a carve-out pocket priced on different terms
 * reconciles on its own line. ``rollup`` combines them into the parent
 * area's full-footprint figure and is ``null`` when the area has no
 * same-hauler carve-out (a plain area — nothing to roll up).
 */
export type SettlementGroupType = {
  __typename: 'SettlementGroupType';
  /** One settlement line per same-hauler carve-out area, each settled independently. Empty for a plain area. */
  carveOuts: Array<SettlementReportType>;
  /** The parent contract area's settlement line. */
  parent: SettlementReportType;
  /** Parent + carve-outs combined into one line; null when there are no carve-outs. */
  rollup?: Maybe<SettlementReportType>;
};

export type SettlementLineType = {
  __typename: 'SettlementLineType';
  /** Compensation in integer cents. */
  compensation: Scalars['Int']['output'];
  productId?: Maybe<Scalars['ID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
};

/**
 * One metered component's pay in a period (R2-S13, decision R2-D18):
 * amount = rate × measured quantity from THIS report's stop population.
 * Included in the product line's compensation and in totalCompensation;
 * itemised here so the office can explain the figure. Served from live
 * rows while the period is open and from the frozen snapshot once
 * closed.
 */
export type SettlementMeteredLineType = {
  __typename: 'SettlementMeteredLineType';
  /** rate × quantity, integer cents. */
  amount: Scalars['Int']['output'];
  /** per_round | per_emptying | ... */
  computation: Scalars['String']['output'];
  haulerPriceId?: Maybe<Scalars['ID']['output']>;
  label: Scalars['String']['output'];
  productId?: Maybe<Scalars['ID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  /** The measured quantity (rounds / emptyings) of the period. */
  quantity: Scalars['Int']['output'];
  /** Cents per measured unit. */
  rate: Scalars['Int']['output'];
  /** The rate per measured unit in currency at the tenant's price precision (HSY-235: four decimals for a four-decimal tenant). `amount` is unit_rate × quantity rounded once to the cent. */
  unitRate?: Maybe<Scalars['Decimal']['output']>;
};

export type SettlementPeriodType = Node & {
  __typename: 'SettlementPeriodType';
  area: AreaDef;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  closedBy?: Maybe<UserType>;
  createdAt: Scalars['DateTime']['output'];
  hauler?: Maybe<HaulerDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  month: Scalars['Int']['output'];
  /** Office-set coefficient replacing the computed Bc for this period. NULL = no override. */
  overrideCoefficient?: Maybe<Scalars['Float']['output']>;
  /** The effective coefficient at the moment the override was set (audit: the 'old' value). */
  overridePreviousCoefficient?: Maybe<Scalars['Float']['output']>;
  /** Mandatory reason recorded with the override (D7). */
  overrideReason?: Maybe<Scalars['String']['output']>;
  overrideSetAt?: Maybe<Scalars['DateTime']['output']>;
  overrideSetBy?: Maybe<UserType>;
  reopenedAt?: Maybe<Scalars['DateTime']['output']>;
  reopenedBy?: Maybe<UserType>;
  status: RoutesSettlementPeriodStatusChoices;
  updatedAt: Scalars['DateTime']['output'];
  year: Scalars['Int']['output'];
};

export type SettlementPeriodTypeConnection = {
  __typename: 'SettlementPeriodTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SettlementPeriodTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SettlementPeriodType` and its cursor. */
export type SettlementPeriodTypeEdge = {
  __typename: 'SettlementPeriodTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SettlementPeriodType>;
};

/**
 * One period-scoped reliability exclusion window (HSY 263) that excused
 * stops this period — the drill-through's "Reliability window: <reason>
 * (<dates>)" note. Present only when the window actually excused at least
 * one stop; served live for open periods and from the frozen snapshot once
 * closed.
 */
export type SettlementReliabilityWindowLineType = {
  __typename: 'SettlementReliabilityWindowLineType';
  dateFrom: Scalars['Date']['output'];
  /** Inclusive. */
  dateTo: Scalars['Date']['output'];
  /** Stops of this period the window excused. */
  excludedStops: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  windowId: Scalars['ID']['output'];
};

/** One contract area's running settlement for a month (D8/D9). */
export type SettlementReportType = {
  __typename: 'SettlementReportType';
  /** Manual audited ± adjustment lines (R2-S12): live rows while the period is open, the frozen snapshot once closed. */
  adjustments: Array<SettlementAdjustmentLineType>;
  /** Signed cents: the sum of the manual adjustment lines. */
  adjustmentsTotal: Scalars['Int']['output'];
  /** PRO-467 drill-through: per-performance exception pay effects (name + factor) that reduced compensation this period. Empty under the day-one defaults (every type payable in full). */
  appliedExceptions: Array<SettlementExceptionLineType>;
  /** HSY 263 drill-through: the period-scoped reliability exclusion windows that excused stops this period (reason, dates, count). Empty when no window applied, and always empty for a company without the reliability-exclusion-windows staff flag. */
  appliedReliabilityWindows: Array<SettlementReliabilityWindowLineType>;
  areaId?: Maybe<Scalars['ID']['output']>;
  areaName?: Maybe<Scalars['String']['output']>;
  /** Bonus column, cents (>= 0): the positive part of the coefficient adjustment. */
  bonusAmount: Scalars['Int']['output'];
  bonusModelId?: Maybe<Scalars['ID']['output']>;
  /** Signed cents: compensation * (Bc - 1). */
  bonusPenaltyAmount: Scalars['Int']['output'];
  /** Bonus coefficient Bc; null when no model applies. */
  coefficient?: Maybe<Scalars['Float']['output']>;
  /** True when an office override (D7) replaced the computed coefficient for this period. */
  coefficientOverridden: Scalars['Boolean']['output'];
  /** The mandatory reason recorded with the override. */
  coefficientOverrideReason?: Maybe<Scalars['String']['output']>;
  complaintShare: Scalars['Float']['output'];
  complaintsAffectingPay: Scalars['Int']['output'];
  complaintsTotal: Scalars['Int']['output'];
  computedAt?: Maybe<Scalars['String']['output']>;
  /** Signed cents carried in from corrections to earlier closed periods (open periods only; 0 for a frozen closed period). */
  correctionsCarryover: Scalars['Int']['output'];
  excluded: Scalars['Int']['output'];
  /** compensation + bonus/penalty + adjustments + manual entries + carry-over, cents. */
  finalAmount: Scalars['Int']['output'];
  haulerId?: Maybe<Scalars['ID']['output']>;
  haulerName?: Maybe<Scalars['String']['output']>;
  late: Scalars['Int']['output'];
  lines?: Maybe<Array<SettlementLineType>>;
  /** Approved manual contractor credit/receivable entries (PRO-465) targeting this period as labelled lines: live rows while open, the frozen snapshot once closed. Draft entries are excluded. */
  manualEntries: Array<ManualEntryLineType>;
  /** Signed cents: the sum of the approved manual-entry lines (deductions negative, credits positive). */
  manualEntriesTotal: Scalars['Int']['output'];
  /** Itemised metered component pay (R2-S13): rate × measured quantity per price row. The amounts are already included in lines/totalCompensation. */
  meteredLines: Array<SettlementMeteredLineType>;
  /** Cents: the sum of meteredLines (included in totalCompensation). */
  meteredTotal: Scalars['Int']['output'];
  missed: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  onTime: Scalars['Int']['output'];
  /** Penalty column, cents (>= 0): the magnitude of a negative coefficient adjustment. */
  penaltyAmount: Scalars['Int']['output'];
  /** Not-yet-due stops (PRO-119) — nonzero only on an open period read that includes today or later; they leave the reliability basis. 0 on frozen periods. */
  pending: Scalars['Int']['output'];
  periodEnd?: Maybe<Scalars['String']['output']>;
  periodStart?: Maybe<Scalars['String']['output']>;
  planned: Scalars['Int']['output'];
  /** contract_breach | damage_claim | agreed_adjustment | other. */
  reason: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  reliabilityPct?: Maybe<Scalars['Float']['output']>;
  /** SIGNED cents: deduction negative, credit positive. */
  signedAmountCents: Scalars['Int']['output'];
  /** open | closed */
  status: Scalars['String']['output'];
  targetMonth: Scalars['Int']['output'];
  targetYear: Scalars['Int']['output'];
  /** SUM of event pay (W1) + metered component pay (R2-S13), integer cents — the bonus coefficient applies to the whole. */
  totalCompensation: Scalars['Int']['output'];
  totalQuantity: Scalars['Int']['output'];
  /** PRO-280: performed stops that resolved to NO price at any level — the UI shows a labelled error line, never a silent 0. */
  unpricedStops: Scalars['Int']['output'];
  /** PRO-280: true when a carve-out with no rate of its own settled at its parent area's rate — the UI shows a 'using parent rates' marker so the fallback is never silent. */
  usedParentRate: Scalars['Boolean']['output'];
  year: Scalars['Int']['output'];
};

export type SetupRouteInput = {
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  depot: RouteSetupDepotInput;
  driver: RouteSetupDriverInput;
  newContainers?: InputMaybe<Array<InputMaybe<RouteSetupContainerInput>>>;
  projectId: Scalars['ID']['input'];
  scheduledDate: Scalars['Date']['input'];
  schemeName?: InputMaybe<Scalars['String']['input']>;
  trailer?: InputMaybe<RouteSetupTrailerInput>;
  vehicle: RouteSetupVehicleInput;
  wasteStation: RouteSetupDepotInput;
};

export type SetupRouteMutation = {
  __typename: 'SetupRouteMutation';
  route?: Maybe<RouteType>;
};

/**
 * REQ-386 slice 5: one property's date-ranged membership of a shared
 * waste-water tank (mirrors SCPMembershipDef).
 */
export type SharedTankMembershipDef = Node & {
  __typename: 'SharedTankMembershipDef';
  changeReason: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The home property's survey that owns the shared tank. */
  homeTreatment: PropertyWasteWaterTreatmentDef;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** A property sharing the home property's tank. */
  memberProperty: PropertyDef;
  share?: Maybe<Scalars['Decimal']['output']>;
  startDate: Scalars['DateTime']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type SharedTankMembershipDefConnection = {
  __typename: 'SharedTankMembershipDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SharedTankMembershipDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SharedTankMembershipDef` and its cursor. */
export type SharedTankMembershipDefEdge = {
  __typename: 'SharedTankMembershipDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SharedTankMembershipDef>;
};

export type SigFoxDeviceType = BaseDeviceInterface & Node & {
  __typename: 'SigFoxDeviceType';
  antenna: DeviceSigFoxDeviceAntennaChoices;
  batch: Scalars['String']['output'];
  bootloaderFwVersion: Scalars['String']['output'];
  company?: Maybe<CompanyType>;
  connectionType?: Maybe<Scalars['String']['output']>;
  containerDevice?: Maybe<DeviceToContainerTypeConnection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  devId?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<DeviceTypeType>;
  hwVersion?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isContainer?: Maybe<Scalars['Boolean']['output']>;
  isGps?: Maybe<Scalars['Boolean']['output']>;
  measurements?: Maybe<FillLevelMeasurementTypeConnection>;
  modemFwVersion: Scalars['String']['output'];
  pac?: Maybe<SigFoxPacType>;
  productNo: Scalars['String']['output'];
  sigFoxPac?: Maybe<SigFoxPacType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  whsFwVersion: Scalars['String']['output'];
};


export type SigFoxDeviceTypeContainerDeviceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type SigFoxDeviceTypeMeasurementsArgs = {
  From?: InputMaybe<Scalars['DateTime']['input']>;
  To?: InputMaybe<Scalars['DateTime']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SigFoxDeviceTypeConnection = {
  __typename: 'SigFoxDeviceTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SigFoxDeviceTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SigFoxDeviceType` and its cursor. */
export type SigFoxDeviceTypeEdge = {
  __typename: 'SigFoxDeviceTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SigFoxDeviceType>;
};

export type SigFoxPacType = Node & {
  __typename: 'SigFoxPacType';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  pac?: Maybe<Scalars['String']['output']>;
  sigfoxdevice?: Maybe<SigFoxDeviceType>;
};

/**
 * Tap-to-sign. A driver signs ``driver``; with ``onDevice: true`` and a
 * typed ``signerName`` the driver records a ``waste_holder`` or
 * ``receiver`` confirmation taken in person on their device.
 */
export type SignTransferDocument = {
  __typename: 'SignTransferDocument';
  signature?: Maybe<TransferDocumentSignatureType>;
  transferDocument?: Maybe<TransferDocumentType>;
};

export type SiirtoCompanySettingsType = Node & {
  __typename: 'SiirtoCompanySettingsType';
  carrierBusinessId: Scalars['String']['output'];
  carrierContactEmail: Scalars['String']['output'];
  carrierContactName: Scalars['String']['output'];
  carrierContactPhone: Scalars['String']['output'];
  /** Mirror of CompanySettings.siirto_enabled (staff-set). */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wasteFractionIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  wasteFractions: WasteFractionTypeConnection;
};


export type SiirtoCompanySettingsTypeWasteFractionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SiirtoCompanySettingsTypeConnection = {
  __typename: 'SiirtoCompanySettingsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SiirtoCompanySettingsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SiirtoCompanySettingsType` and its cursor. */
export type SiirtoCompanySettingsTypeEdge = {
  __typename: 'SiirtoCompanySettingsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SiirtoCompanySettingsType>;
};

export type SiirtoRegistrySubmissionType = Node & {
  __typename: 'SiirtoRegistrySubmissionType';
  attempts: Scalars['Int']['output'];
  error?: Maybe<Scalars['GenericScalar']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  registryId: Scalars['String']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  signingRound: Scalars['Int']['output'];
  status: CrmSiirtoRegistrySubmissionStatusChoices;
  updatedAt: Scalars['DateTime']['output'];
};

export type SimCardType = Node & {
  __typename: 'SimCardType';
  apn: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  iccid: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  imsi: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  mobiledevice?: Maybe<MobileDeviceType>;
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * RS-903: the honest per-area sim-to-actual surface. ``status``
 * is ok / no_live_plan / no_parity_anchor / no_replay_data; only ok
 * carries rows (insufficient data is said, never zero-filled).
 */
export type SimToActualDef = {
  __typename: 'SimToActualDef';
  /** SBX-365 (D17/D32/D08): the per-day disposal reconciliation: planned tons (live plan's modeled load) vs collected tons (task completions, weighbridge history preferred) vs facility offloads (driver captures at waste-station gates), with per-source counts, gap percentages, caveats and honest empty states; source_notes name every column's provenance. */
  disposal?: Maybe<Scalars['GenericScalar']['output']>;
  /** What the learning loop changed between parameter set versions (newest transition first). */
  parameterChanges?: Maybe<Array<ParameterSetChangeDef>>;
  /** Route-day gaps, worst hours gap first. */
  rows?: Maybe<Array<SimToActualRowDef>>;
  status: Scalars['String']['output'];
  /** Planned days in the window replay never saw. */
  unobservedPlannedDays?: Maybe<Scalars['Int']['output']>;
  windowEnd?: Maybe<Scalars['Date']['output']>;
  windowStart?: Maybe<Scalars['Date']['output']>;
};

/**
 * One route-day gap row (RS-903, D08): predicted vs realized,
 * with the data-quality caveats riding along.
 */
export type SimToActualRowDef = {
  __typename: 'SimToActualRowDef';
  caveats?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  day: Scalars['Date']['output'];
  dayOfCycle: Scalars['Int']['output'];
  gapHoursPct?: Maybe<Scalars['Float']['output']>;
  /** (observed - predicted) / predicted, percent; null when the plan predicts nothing for the day. */
  gapKmPct?: Maybe<Scalars['Float']['output']>;
  observedHours?: Maybe<Scalars['Float']['output']>;
  observedKm?: Maybe<Scalars['Float']['output']>;
  predictedHours?: Maybe<Scalars['Float']['output']>;
  predictedKm?: Maybe<Scalars['Float']['output']>;
};

/**
 * For some reason, without class like this with the CompanyEmailAccountMessage
 * the CreateCompanyEmailAccountMessage mutation experiences this:
 *     "Exception: No type registered for model: CompanyEmailAccountMessage"
 */
export type SimpleCompanyEmailAccountMessageDef = Node & {
  __typename: 'SimpleCompanyEmailAccountMessageDef';
  assignedTeam?: Maybe<TeamType>;
  assignee?: Maybe<UserType>;
  /** Tickets associated with the message */
  associatedTickets: TicketDefConnection;
  attachments: CompanyEmailAccountMessageAttachmentDefConnection;
  body: Scalars['String']['output'];
  companyEmailAccount: CompanyEmailAccountDef;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorAt?: Maybe<Scalars['DateTime']['output']>;
  fromEmail: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  notificationmessageSet: NotificationMessageDefConnection;
  portalConversation?: Maybe<PortalConversationDef>;
  providerId?: Maybe<Scalars['String']['output']>;
  sendAt?: Maybe<Scalars['DateTime']['output']>;
  snippet: Scalars['String']['output'];
  status: CoreCompanyEmailAccountMessageStatusChoices;
  subject?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  threadMessages: CompanyEmailAccountMessageDefConnection;
  threadStarter?: Maybe<CompanyEmailAccountMessageDef>;
  ticketMessage?: Maybe<TicketMessageDef>;
  ticketdraftSet: TicketDraftDefConnection;
  toEmail?: Maybe<Scalars['String']['output']>;
  toEmailName?: Maybe<Scalars['String']['output']>;
  userNotifications: UserNotificationTypeConnection;
};


/**
 * For some reason, without class like this with the CompanyEmailAccountMessage
 * the CreateCompanyEmailAccountMessage mutation experiences this:
 *     "Exception: No type registered for model: CompanyEmailAccountMessage"
 */
export type SimpleCompanyEmailAccountMessageDefAssociatedTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * For some reason, without class like this with the CompanyEmailAccountMessage
 * the CreateCompanyEmailAccountMessage mutation experiences this:
 *     "Exception: No type registered for model: CompanyEmailAccountMessage"
 */
export type SimpleCompanyEmailAccountMessageDefAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * For some reason, without class like this with the CompanyEmailAccountMessage
 * the CreateCompanyEmailAccountMessage mutation experiences this:
 *     "Exception: No type registered for model: CompanyEmailAccountMessage"
 */
export type SimpleCompanyEmailAccountMessageDefNotificationmessageSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * For some reason, without class like this with the CompanyEmailAccountMessage
 * the CreateCompanyEmailAccountMessage mutation experiences this:
 *     "Exception: No type registered for model: CompanyEmailAccountMessage"
 */
export type SimpleCompanyEmailAccountMessageDefThreadMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * For some reason, without class like this with the CompanyEmailAccountMessage
 * the CreateCompanyEmailAccountMessage mutation experiences this:
 *     "Exception: No type registered for model: CompanyEmailAccountMessage"
 */
export type SimpleCompanyEmailAccountMessageDefTicketdraftSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * For some reason, without class like this with the CompanyEmailAccountMessage
 * the CreateCompanyEmailAccountMessage mutation experiences this:
 *     "Exception: No type registered for model: CompanyEmailAccountMessage"
 */
export type SimpleCompanyEmailAccountMessageDefUserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SimulateAutomationPayload = {
  __typename: 'SimulateAutomationPayload';
  simulation: SimulationDef;
};

export type SimulationDef = {
  __typename: 'SimulationDef';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  definitionChecksum: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  eventsScanned: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  matchesCurrentGraph: Scalars['Boolean']['output'];
  sample: Array<SimulationSampleDef>;
  status: Scalars['String']['output'];
  windowEnd: Scalars['DateTime']['output'];
  windowStart: Scalars['DateTime']['output'];
  wouldAct: Scalars['Int']['output'];
  wouldRun: Scalars['Int']['output'];
};

export type SimulationJobDef = Node & {
  __typename: 'SimulationJobDef';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  errorMessage: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  progress: Scalars['Float']['output'];
  requestedOutputs: Scalars['JSONString']['output'];
  scenario: ScenarioDef;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  state: RouteStudioSimulationJobStateChoices;
  timings: Scalars['JSONString']['output'];
  workerId: Scalars['String']['output'];
};

export type SimulationJobDefConnection = {
  __typename: 'SimulationJobDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SimulationJobDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SimulationJobDef` and its cursor. */
export type SimulationJobDefEdge = {
  __typename: 'SimulationJobDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SimulationJobDef>;
};

export type SimulationSampleDef = {
  __typename: 'SimulationSampleDef';
  eventType: Scalars['String']['output'];
  occurredAt: Scalars['DateTime']['output'];
  subjectId: Scalars['ID']['output'];
  subjectLabel?: Maybe<Scalars['String']['output']>;
  subjectLinkPath?: Maybe<Scalars['String']['output']>;
  subjectType: Scalars['String']['output'];
  triggerLabel: Scalars['String']['output'];
  wouldDo: Scalars['String']['output'];
  wouldRequireApproval: Scalars['Boolean']['output'];
};

/** Describes Driver's skills */
export type SkillType = Node & {
  __typename: 'SkillType';
  /** Code of skill */
  code: Scalars['String']['output'];
  /** Company, which skill related to */
  company: CompanyType;
  /** Skill description */
  description: Scalars['String']['output'];
  driverSet: DriverTypeConnection;
  /** Relation to Skill model */
  driverSkills: DriverSkillTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Skill naming */
  name: Scalars['String']['output'];
};


/** Describes Driver's skills */
export type SkillTypeDriverSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Driver's skills */
export type SkillTypeDriverSkillsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SkillTypeConnection = {
  __typename: 'SkillTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SkillTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SkillType` and its cursor. */
export type SkillTypeEdge = {
  __typename: 'SkillTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SkillType>;
};

export type SkipHireSetupStateType = {
  __typename: 'SkipHireSetupStateType';
  companyId: Scalars['ID']['output'];
  demo?: Maybe<Scalars['String']['output']>;
  steps: Array<SkipHireSetupStepReportType>;
};

/**
 * One step's report: ``result`` is ``exists`` / ``created`` /
 * ``needs_input`` / ``error`` (PRO-1012: a server problem, not the
 * office's input) - ``not_done`` from the state query only.
 */
export type SkipHireSetupStepReportType = {
  __typename: 'SkipHireSetupStepReportType';
  details?: Maybe<Scalars['GenericScalar']['output']>;
  message: Scalars['String']['output'];
  result: Scalars['String']['output'];
  step: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** A skip collected on the route since its last tip. */
export type SkipOnBoardDef = {
  __typename: 'SkipOnBoardDef';
  containerLabel: Scalars['String']['output'];
  containerTypeName: Scalars['String']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  propertyLabel?: Maybe<Scalars['String']['output']>;
  rentalTicketId: Scalars['ID']['output'];
  /** The collection stop (PickUpOrderType). */
  routeStopId: Scalars['ID']['output'];
  weightBasis?: Maybe<Scalars['String']['output']>;
  /** A weight already recorded for this skip, kg. */
  weightNetKg?: Maybe<Scalars['Float']['output']>;
};

/** One rental's share of a recording (one entry for a single skip). */
export type SkipWeightShareDef = {
  __typename: 'SkipWeightShareDef';
  basis: Scalars['String']['output'];
  netKg: Scalars['Float']['output'];
  /** created | unchanged | corrected | correction_posted | credit_note_needed | within_allowance | nothing_to_bill; null when invoicing did not run. */
  overageAction?: Maybe<Scalars['String']['output']>;
  overageEvent?: Maybe<BillableEventDef>;
  /** False when this weighing was already on record. */
  recorded: Scalars['Boolean']['output'];
  rentalTicketId: Scalars['ID']['output'];
  source: Scalars['String']['output'];
};

/**
 * Where a recorded skip weight came from (``routes.choices
 * .WeightSource`` minus ``unknown``): the site's certified bridge, the
 * truck's on-board scale, a typed figure, an imported slip.
 */
export enum SkipWeightSource {
  IMPORT = 'IMPORT',
  MANUAL = 'MANUAL',
  VEHICLE_SCALE = 'VEHICLE_SCALE',
  WEIGHBRIDGE = 'WEIGHBRIDGE'
}

/**
 * REQ-386 (3.1.49) slice 6: the waste-water sludge-tank details a driver
 * needs at the stop, read off the stop container's property survey. Only
 * populated for a wastewater-tank container; null otherwise.
 */
export type SludgeTankStopInfo = {
  __typename: 'SludgeTankStopInfo';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  emptyingProblems?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  sludgeTankType?: Maybe<Scalars['String']['output']>;
  tankVolumeM3?: Maybe<Scalars['Decimal']['output']>;
};

/** An enumeration. */
export enum SludgeTankType {
  HOLDING_TANK = 'HOLDING_TANK',
  SEPTIC_TANK = 'SEPTIC_TANK',
  SMALL_TREATMENT_PLANT = 'SMALL_TREATMENT_PLANT'
}

/**
 * One snapshot batch row.
 *
 * ``batch_type_display`` exposes the human-readable label.
 */
export type SnapshotBatchDef = Node & {
  __typename: 'SnapshotBatchDef';
  /** Type of snapshot batch */
  batchType: EvolutionSnapshotBatchBatchTypeChoices;
  batchTypeDisplay?: Maybe<Scalars['String']['output']>;
  company: CompanyType;
  containercollectionitemsnapshot: ContainerCollectionItemSnapshotDefConnection;
  containeritemsnapshot: ContainerItemSnapshotDefConnection;
  createdAt: Scalars['DateTime']['output'];
  customeritemsnapshot: CustomerItemSnapshotDefConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  ticketitemsnapshot: TicketItemSnapshotDefConnection;
};


/**
 * One snapshot batch row.
 *
 * ``batch_type_display`` exposes the human-readable label.
 */
export type SnapshotBatchDefContainercollectionitemsnapshotArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * One snapshot batch row.
 *
 * ``batch_type_display`` exposes the human-readable label.
 */
export type SnapshotBatchDefContaineritemsnapshotArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * One snapshot batch row.
 *
 * ``batch_type_display`` exposes the human-readable label.
 */
export type SnapshotBatchDefCustomeritemsnapshotArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * One snapshot batch row.
 *
 * ``batch_type_display`` exposes the human-readable label.
 */
export type SnapshotBatchDefTicketitemsnapshotArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SnapshotBatchDefConnection = {
  __typename: 'SnapshotBatchDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SnapshotBatchDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SnapshotBatchDef` and its cursor. */
export type SnapshotBatchDefEdge = {
  __typename: 'SnapshotBatchDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SnapshotBatchDef>;
};

/** Sort directive for a groupable field or aggregate column (mirrors plan_schema.SortSpec). */
export type SortInput = {
  dir: Scalars['String']['input'];
  field: Scalars['String']['input'];
};

/**
 * RS-E27 (stage G): one (metric, scope key) verification row:
 * the source documents' number vs the materialization+bindings
 * number, itemized per scope key, never netted. Scope keys speak
 * client identifiers only (D58).
 */
export type SourceMetricDef = Node & {
  __typename: 'SourceMetricDef';
  case: ImportCaseDef;
  computedValue?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['JSONString']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  materialization: CaseMaterializationDef;
  metric: Scalars['String']['output'];
  scopeKey: Scalars['String']['output'];
  sourceValue?: Maybe<Scalars['Float']['output']>;
  verdict: RouteStudioSourceMetricVerdictChoices;
};

export type SourceMetricDefConnection = {
  __typename: 'SourceMetricDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SourceMetricDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SourceMetricDef` and its cursor. */
export type SourceMetricDefEdge = {
  __typename: 'SourceMetricDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SourceMetricDef>;
};

/** GraphQL type for SparePart with compatibility to container types. */
export type SparePartType = Node & {
  __typename: 'SparePartType';
  colour: Scalars['String']['output'];
  /** Company that owns this spare-part catalogue entry. */
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fitsContainerTypes?: Maybe<ContainerTypeTypeConnection>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** e.g. active, discontinued */
  lifecycleStatus: Scalars['String']['output'];
  metaData: Scalars['JSONString']['output'];
  name: Scalars['String']['output'];
  partType?: Maybe<PartTypeType>;
  sku?: Maybe<Scalars['String']['output']>;
  stockAlerts: Array<StockAlertEventDef>;
  warrantyMonths?: Maybe<Scalars['Int']['output']>;
};


/** GraphQL type for SparePart with compatibility to container types. */
export type SparePartTypeFitsContainerTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SparePartTypeConnection = {
  __typename: 'SparePartTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SparePartTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SparePartType` and its cursor. */
export type SparePartTypeEdge = {
  __typename: 'SparePartTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SparePartType>;
};

export type SqlDatasetAdminCompanyType = {
  __typename: 'SqlDatasetAdminCompanyType';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SqlDatasetAdminType = {
  __typename: 'SqlDatasetAdminType';
  company: SqlDatasetAdminCompanyType;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parameters?: Maybe<Scalars['GenericScalar']['output']>;
  source?: Maybe<Scalars['GenericScalar']['output']>;
  sql: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usedOn: Array<SqlDatasetAdminUseType>;
  versions: Array<SqlDatasetAdminVersionType>;
};

/** A builder dashboard whose tiles read the dataset. */
export type SqlDatasetAdminUseType = {
  __typename: 'SqlDatasetAdminUseType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SqlDatasetAdminVersionType = {
  __typename: 'SqlDatasetAdminVersionType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parameters?: Maybe<Scalars['GenericScalar']['output']>;
  savedAt: Scalars['DateTime']['output'];
  savedBy?: Maybe<Scalars['String']['output']>;
  sql: Scalars['String']['output'];
};

export type SqlDatasetPreviewColumnType = {
  __typename: 'SqlDatasetPreviewColumnType';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/**
 * A New dashboards SQL tile: the SQL dataset it reads (its id) and how
 * the tile draws it (``viz``: table, kpi, bar, line, area, pie or
 * waterfall; a table when absent or unknown), which decides the shape of
 * its data. ``params`` (the tile's saved ``sql.params``) says which of the
 * dataset's template tags take the board's date or filters
 * (``{tag: "board_date" | "board_date_end" | "project" | "area" |
 * "waste_fraction"}``); absent, insights.sql_entities.auto_bindings
 * decides.
 */
export type SqlTileInput = {
  chart?: InputMaybe<Scalars['GenericScalar']['input']>;
  dataset: Scalars['ID']['input'];
  params?: InputMaybe<Scalars['GenericScalar']['input']>;
  viz?: InputMaybe<Scalars['String']['input']>;
};

export type StageDef = {
  __typename: 'StageDef';
  attempts: Scalars['Int']['output'];
  errors: Array<StageErrorDef>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  queuedAt: Scalars['DateTime']['output'];
  stageNo: Scalars['Int']['output'];
  startBranch?: Maybe<Scalars['String']['output']>;
  startNodeKey: Scalars['String']['output'];
  startedBy: Scalars['String']['output'];
  startedByText: Scalars['String']['output'];
  status: Scalars['String']['output'];
  steps: Array<StepDef>;
};

export type StageErrorDef = {
  __typename: 'StageErrorDef';
  at: Scalars['DateTime']['output'];
  attempt: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  failedNodeKey: Scalars['String']['output'];
  failedNodeLabel?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  nodesReached: Array<Scalars['String']['output']>;
};

/**
 * Open a Copilot session bound to a project (RS-802, A4 session
 * scope). The Copilot never sees beyond this scope.
 */
export type StartCopilotConversationMutation = {
  __typename: 'StartCopilotConversationMutation';
  conversation?: Maybe<CopilotConversationDef>;
};

/**
 * Office starts a container hire (HAUL-501/503): place a container at a
 * customer site → an on-hire placement. Wraps ``rental.begin_rental`` —
 * this only creates the placement (the ``crm.Agreement`` the clock bills);
 * it computes no charge. Idempotent by ``placementRef`` (a replay returns
 * the existing placement, ``created=false``).
 */
export type StartHaulerRental = {
  __typename: 'StartHaulerRental';
  /** False when placementRef already existed (idempotent replay). */
  created?: Maybe<Scalars['Boolean']['output']>;
  placement?: Maybe<HaulerRentalDef>;
};

export type StartManualRunPayload = {
  __typename: 'StartManualRunPayload';
  queued: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type StatsType = {
  __typename: 'StatsType';
  containerLogs?: Maybe<Array<Maybe<ContainerLogDaysType>>>;
  containers?: Maybe<ContainerTypeConnection>;
};


export type StatsTypeContainerLogsArgs = {
  From?: InputMaybe<Scalars['DateTime']['input']>;
  To?: InputMaybe<Scalars['DateTime']['input']>;
};


export type StatsTypeContainersArgs = {
  From?: InputMaybe<Scalars['DateTime']['input']>;
  To?: InputMaybe<Scalars['DateTime']['input']>;
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  allowedForRoute?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  area_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionCalendar_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  collectionCalendars?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerId?: InputMaybe<Scalars['String']['input']>;
  containerType_Name_Iexact?: InputMaybe<Scalars['String']['input']>;
  containerType_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  containerTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  device_IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCollectionCalendars?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRouteSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  measurement_FillPercentage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noProperty?: InputMaybe<Scalars['Boolean']['input']>;
  noRouteOnDay?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyNumber?: InputMaybe<Scalars['String']['input']>;
  propertyTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  q?: InputMaybe<Scalars['String']['input']>;
  rfid?: InputMaybe<Scalars['String']['input']>;
  routeIdsNotCompletedStops?: InputMaybe<Scalars['String']['input']>;
  routeScheme_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scpAttachable?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchContact?: InputMaybe<Scalars['String']['input']>;
  sensor_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  storedAtDepot?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  temporarilyRelocated?: InputMaybe<Scalars['Boolean']['input']>;
  vehicle_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFractionIds?: InputMaybe<Scalars['String']['input']>;
  wasteFraction_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  wasteFraction_WasteTypes_Name_Iexact?: InputMaybe<Scalars['String']['input']>;
  wasteFraction_WasteTypes_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wasteTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zone_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enumeration. */
export enum Status {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type StepDef = {
  __typename: 'StepDef';
  branch?: Maybe<Scalars['String']['output']>;
  effects: Array<EffectDef>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  input?: Maybe<Scalars['JSONString']['output']>;
  nodeKey: Scalars['String']['output'];
  nodeKind: Scalars['String']['output'];
  output?: Maybe<Scalars['JSONString']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

/**
 * A raised low/out-of-stock alert, as the `event` of a bell-icon
 * UserNotification (a member of the notifications event union). Carries
 * the item, warehouse and severity so the notification card can read
 * "Low stock: {item} at {warehouse}" and deep-link to the warehouse.
 */
export type StockAlertEventDef = {
  __typename: 'StockAlertEventDef';
  /** Available at the moment the alert was raised */
  available: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  itemTypeName?: Maybe<Scalars['String']['output']>;
  level: InventoryStockAlertLevelChoices;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  warehouseId?: Maybe<Scalars['ID']['output']>;
  warehouseName?: Maybe<Scalars['String']['output']>;
};

/**
 * The item-kind filter for the matrix (PRO-211). Members map onto
 * the ``item_kind`` vocabulary the balance rows already stamp -
 * CONTAINER -> "container_type", SPARE_PART -> "spare_part" - so the
 * matrix reuses the existing kinds rather than inventing new ones. ALL
 * (the default) renders both kinds.
 */
export enum StockMatrixKind {
  ALL = 'ALL',
  CONTAINER = 'CONTAINER',
  SPARE_PART = 'SPARE_PART'
}

/** One staged Settings-tab row. */
export type StockThresholdInput = {
  alertsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  containerTypeId?: InputMaybe<Scalars['ID']['input']>;
  critical: Scalars['Int']['input'];
  itemTypeId?: InputMaybe<Scalars['ID']['input']>;
  minimum: Scalars['Int']['input'];
};

/** COMPASS-1695: what a completion did on the server. */
export enum StopCompletionOutcome {
  ALREADY_COMPLETED = 'ALREADY_COMPLETED',
  APPLIED = 'APPLIED'
}

/** COMPASS-1695: how the server found the stop it completed. */
export enum StopCompletionResolvedBy {
  ORDER_ID = 'ORDER_ID',
  STOP_IDENTITY = 'STOP_IDENTITY'
}

export type StopDef = Node & {
  __typename: 'StopDef';
  accessFlags: Scalars['JSONString']['output'];
  container?: Maybe<ContainerType>;
  containerTypes: Scalars['JSONString']['output'];
  fractionDemands: Scalars['JSONString']['output'];
  geocodeConfidence?: Maybe<Scalars['Float']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importIssues: ImportIssueDefConnection;
  location?: Maybe<Scalars['GeoJSON']['output']>;
  property?: Maybe<PropertyDef>;
  stopSet: StopSetDef;
};


export type StopDefImportIssuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type StopDefConnection = {
  __typename: 'StopDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StopDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `StopDef` and its cursor. */
export type StopDefEdge = {
  __typename: 'StopDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<StopDef>;
};

/**
 * COMPASS-1695: the physical stop, independent of its order id.
 *
 * A re-plan re-issues every pending stop under a new order id, so an
 * order id the app holds may be stale by the time a completion (or its
 * offline replay) arrives. Send the thing the driver stood at instead:
 * the container (relay id, or the printed number the app shows), the
 * ticket, or the depot. Container is tried before ticket before depot
 * when several are sent; a part that names nothing live on the route
 * falls through to the next.
 */
export type StopIdentityInput = {
  /** Relay id of the container. */
  containerId?: InputMaybe<Scalars['ID']['input']>;
  /** The printed container number (Container.containerId) the app shows, for clients that hold no relay id. */
  containerNumber?: InputMaybe<Scalars['String']['input']>;
  /** Relay id of the depot. A route can unload at the same station several times: with one open visit left it is the target; with several, displayNumber picks, else the refusal is AMBIGUOUS_TARGET with the candidates. */
  depotId?: InputMaybe<Scalars['ID']['input']>;
  /** 1-based ordinal of this visit to depotId as the app counted it. Advisory only (logged): the ordinal moves with every renumbering, so the server never resolves a visit by it. */
  depotVisit?: InputMaybe<Scalars['Int']['input']>;
  /** Relay id of the ticket. */
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};

export type StopListCardConfigType = Node & {
  __typename: 'StopListCardConfigType';
  fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  showWhoCompleted: Scalars['Boolean']['output'];
  stopCardConfig?: Maybe<CardConfigOptions>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StopListCardConfigTypeConnection = {
  __typename: 'StopListCardConfigTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StopListCardConfigTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StopListCardConfigType` and its cursor. */
export type StopListCardConfigTypeEdge = {
  __typename: 'StopListCardConfigTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<StopListCardConfigType>;
};

export type StopListFieldDef = {
  __typename: 'StopListFieldDef';
  configType?: Maybe<CardConfigOptions>;
  stopListFieldOptions?: Maybe<Array<Maybe<StopListFieldOptionDef>>>;
};

export type StopListFieldOptionDef = {
  __typename: 'StopListFieldOptionDef';
  kind?: Maybe<FieldTypeEnum>;
  label?: Maybe<Scalars['String']['output']>;
  metaFieldName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type StopSetDef = Node & {
  __typename: 'StopSetDef';
  baselines: BaselineDefConnection;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importBatches: ImportBatchDefConnection;
  metadata: Scalars['JSONString']['output'];
  name: Scalars['String']['output'];
  project: ProjectType;
  scenarios: ScenarioDefConnection;
  serviceUnits: ServiceUnitDefConnection;
  source: RouteStudioStopSetSourceChoices;
  stops: StopDefConnection;
};


export type StopSetDefBaselinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type StopSetDefImportBatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type StopSetDefScenariosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type StopSetDefServiceUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type StopSetDefStopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type StopSetDefConnection = {
  __typename: 'StopSetDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StopSetDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `StopSetDef` and its cursor. */
export type StopSetDefEdge = {
  __typename: 'StopSetDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<StopSetDef>;
};

export type SubjectCatalogDef = {
  __typename: 'SubjectCatalogDef';
  dateFields: Array<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  fieldSchema: Scalars['JSONString']['output'];
  label: Scalars['String']['output'];
  linkPathTemplate: Scalars['String']['output'];
  stateFields: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/**
 * Freeze a statutory draft as an IMMUTABLE as-submitted record —
 * who / to-which-authority / when / external reference + a
 * tamper-evident seal (sha256 of the canonical payload). The
 * accountable sign-off the draft flow was missing; turns the module
 * from draft-helper into system-of-record for the obligation.
 */
export type SubmitStatutoryDraft = {
  __typename: 'SubmitStatutoryDraft';
  error?: Maybe<Scalars['String']['output']>;
  submission?: Maybe<Scalars['GenericScalar']['output']>;
};

/**
 * RS-E28 stage H (D61): batch confirm / flag-with-note on the
 * validation room's route identities. Each entry is
 * {routeIdentity, verdict: confirmed|flagged[, note,
 * acceptanceLabel]}; flags REQUIRE a note. Verdicts bind to one
 * materialization version (default: the newest); re-materializing
 * starts a fresh sign-off. Refuses while the stage G gate keeps
 * the room closed (D62).
 */
export type SubmitValidationVerdictsMutation = {
  __typename: 'SubmitValidationVerdictsMutation';
  importCase?: Maybe<ImportCaseDef>;
  materialization?: Maybe<CaseMaterializationDef>;
  progress?: Maybe<Scalars['GenericScalar']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  submitted?: Maybe<Scalars['Int']['output']>;
};

/**
 * W8.2: opt in to (or retune) the personal digest. Opt-out is
 * the default — subscribing is always an explicit user action.
 */
export type SubscribeInsightsDigest = {
  __typename: 'SubscribeInsightsDigest';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/**
 * Subscribe a property to an access-fee SCP (NEXUS-556).
 *
 * Creates the membership (with its required role) and marks the property's
 * register basis ``ACCESS_BASED``. NEXUS-627: on a SUBSCRIPTION-billed SCP
 * (ADR-0002) the fee args capture the recurring ``ACCESS_FEE`` agreement
 * atomically with the membership — the tariff/fee product's active price
 * supplies the amount unless ``feeAmount`` overrides it; ``feeInterval``
 * defaults to ANNUAL.
 */
export type SubscribePropertyToScp = {
  __typename: 'SubscribePropertyToScp';
  scpMembership?: Maybe<ScpMembershipDef>;
  seasonalConflict?: Maybe<Scalars['Boolean']['output']>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Subscription = {
  __typename: 'Subscription';
  onCompanyEmailAccountMessageChanged?: Maybe<CompanyEmailAccountMessageChangedSubscription>;
  onCurrentDriverLocationChange?: Maybe<CurrentDriverLocationSubscription>;
  onHealthCheck?: Maybe<HealthCheckSubscription>;
  onLiveOperationsFeed?: Maybe<LiveOpsFeedSubscription>;
  onNotification?: Maybe<NotificationSubscription>;
  onRecordLeaseChanged?: Maybe<OnRecordLeaseChanged>;
  onRouteAvailableContainersChange?: Maybe<RouteAvailableContainersSubscription>;
  onRouteChange?: Maybe<RouteSubscription>;
  onRouteStopsChange?: Maybe<RouteStopsSubscription>;
  onTicketChanged?: Maybe<TicketChangedSubscription>;
  onTicketDraftChanged?: Maybe<TicketDraftChangedSubscription>;
  onUserJobNotification?: Maybe<UserJobNotificationSubscription>;
  onUserNotification?: Maybe<UserNotificationSubscription>;
  onVehiclePositionChange?: Maybe<VehicleSubscription>;
};


export type SubscriptionOnCompanyEmailAccountMessageChangedArgs = {
  companyEmailAccountMessageId: Scalars['ID']['input'];
};


export type SubscriptionOnCurrentDriverLocationChangeArgs = {
  routeId: Scalars['ID']['input'];
};


export type SubscriptionOnNotificationArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionOnRecordLeaseChangedArgs = {
  entityId: Scalars['ID']['input'];
  entityType: RecordLeaseEntityType;
};


export type SubscriptionOnRouteAvailableContainersChangeArgs = {
  routeId: Scalars['ID']['input'];
};


export type SubscriptionOnRouteChangeArgs = {
  routeId: Scalars['ID']['input'];
};


export type SubscriptionOnRouteStopsChangeArgs = {
  routeId: Scalars['ID']['input'];
};


export type SubscriptionOnTicketChangedArgs = {
  ticketId: Scalars['ID']['input'];
};


export type SubscriptionOnTicketDraftChangedArgs = {
  ticketDraftId: Scalars['ID']['input'];
};


export type SubscriptionOnVehiclePositionChangeArgs = {
  vehiclesIds: Scalars['String']['input'];
};

export type SubscriptionDeliveryType = {
  __typename: 'SubscriptionDeliveryType';
  error?: Maybe<Scalars['String']['output']>;
  filenames?: Maybe<Array<Scalars['String']['output']>>;
  ranAt?: Maybe<Scalars['String']['output']>;
  recipients?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * RS-1602 capture (D39): folklore lands as a SUGGESTED rule with
 * provenance. This mutation is the ONLY capture path: the frozen
 * Copilot registry (D20) has no brain tool by design; the Copilot
 * can only point users here.
 */
export type SuggestBrainRuleMutation = {
  __typename: 'SuggestBrainRuleMutation';
  brainRule?: Maybe<BrainRuleDef>;
};

/**
 * COMPASS-1773 (HSY 86/54): pause an agreement's collections for
 * ``[startDate, endDate]`` (both inclusive) — a keskeytys. The agreement
 * and its base fee keep running; route generation skips the container's
 * dates inside the window, already-planned undriven stops in it are
 * released (``releasedStops``) and put back if the suspension is
 * cancelled. Refused unless the company has agreement suspension
 * enabled, and when the window is inverted, outside the agreement's
 * life, longer than the keskeytys cap or overlapping another live
 * suspension.
 */
export type SuspendAgreement = {
  __typename: 'SuspendAgreement';
  agreement?: Maybe<AgreementDef>;
  /** Already-planned, undriven stops inside the window that were taken off their routes. */
  releasedStops: Scalars['Int']['output'];
  suspension?: Maybe<AgreementSuspensionDef>;
};

/** GraphQL representation of a SvarUt dispatch. */
export type SvarUtDispatchType = Node & {
  __typename: 'SvarUtDispatchType';
  /** Number of dispatch attempts made by the Celery task. */
  attempts: Scalars['Int']['output'];
  /** Tenant that owns this dispatch. */
  company: CompanyType;
  /** When the row was created in the WH database. */
  createdAt: Scalars['DateTime']['output'];
  /** When a terminal delivery state was reached. */
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  /** forsendelseId returned by SvarUt on accept. Null until the ACL callback confirms acceptance. */
  dispatchId?: Maybe<Scalars['UUID']['output']>;
  /** Per-konto categorisation key on the wire (forsendelsestype). Drives ACOS routing and KS billing on the customer side. */
  dispatchType: Scalars['String']['output'];
  /** Timestamp of the most recent error. */
  errorAt?: Maybe<Scalars['DateTime']['output']>;
  /** FIKS errorCode (or our own SvarUtACLUnavailable / SvarUtDispatchRejected) when this dispatch failed. */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Human-readable error description. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Idempotency key passed to the ACL as eksternReferanse. For ticket dispatches it is derived deterministically from (ticket, use_case) by dispatch_create, so a re-fire short-circuits to the existing row. The uuid4 default is only a fallback for rows created outside that path. */
  externalReference: Scalars['UUID']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Timestamp of the latest event reported by the ACL. */
  lastEventAt?: Maybe<Scalars['DateTime']['output']>;
  /** Latest free-text Norwegian event from SvarUt /hendelser, kept for audit when the ACL did not recognise it. */
  lastEventText?: Maybe<Scalars['String']['output']>;
  /** Direct download URL for the rendered PDF. */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** Postal-fallback address as a flat dict: address_line_1/2/3, postal_code, postal_city, country. Used by SvarUt only when no digital mailbox exists for the recipient. */
  recipientAddress: Scalars['JSONString']['output'];
  /** Recipient legal name (mottaker.navn on the wire). */
  recipientName: Scalars['String']['output'];
  /** When the ACL accepted the dispatch (status -> SENT). */
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current lifecycle state. See SvarUtStatus for transitions. */
  status: SvarutSvarUtDispatchStatusChoices;
  /** Ticket whose completion triggered this dispatch. Null for manually triggered dispatches that are not bound to a ticket. */
  ticket?: Maybe<TicketDef>;
  /** Subject line shown in the recipient's digital mailbox. */
  title: Scalars['String']['output'];
  /** Last write to this row. */
  updatedAt: Scalars['DateTime']['output'];
  /** Which Phase-1/2/3 SvarUt use case this dispatch represents. Drives PDF template selection and the wire-level dispatch_type. */
  useCase: SvarutSvarUtDispatchUseCaseChoices;
};

export type SvarUtDispatchTypeConnection = {
  __typename: 'SvarUtDispatchTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SvarUtDispatchTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SvarUtDispatchType` and its cursor. */
export type SvarUtDispatchTypeEdge = {
  __typename: 'SvarUtDispatchTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SvarUtDispatchType>;
};

/** An enumeration. */
export enum SvarutSvarUtDispatchStatusChoices {
  /** Accepted by ACL (submitting to SvarUt) */
  ACCEPTED = 'ACCEPTED',
  /** Delivered to digital mailbox */
  DELIVERED_DIGITAL = 'DELIVERED_DIGITAL',
  /** Delivered as physical mail */
  DELIVERED_PRINT = 'DELIVERED_PRINT',
  /** Failed */
  FAILED = 'FAILED',
  /** In flight */
  IN_FLIGHT = 'IN_FLIGHT',
  /** Manually handled */
  MANUAL_HANDLED = 'MANUAL_HANDLED',
  /** Pending */
  PENDING = 'PENDING',
  /** Read (informational) */
  READ = 'READ',
  /** Rejected by SvarUt */
  REJECTED = 'REJECTED',
  /** Sent to SvarUt */
  SENT = 'SENT'
}

/** An enumeration. */
export enum SvarutSvarUtDispatchUseCaseChoices {
  /** Billing cycle change */
  BILLING_CYCLE_CHANGE = 'BILLING_CYCLE_CHANGE',
  /** Bin change with price change */
  BIN_CHANGE_PRICE = 'BIN_CHANGE_PRICE',
  /** Business credit agreement */
  BUSINESS_CREDIT = 'BUSINESS_CREDIT',
  /** Business waste order */
  BUSINESS_ORDER = 'BUSINESS_ORDER',
  /** Driving complaint response */
  DRIVING_COMPLAINT = 'DRIVING_COMPLAINT',
  /** Exemption decision */
  EXEMPTION = 'EXEMPTION',
  /** Manually triggered */
  MANUAL = 'MANUAL',
  /** Property damage confirmation */
  PROPERTY_DAMAGE = 'PROPERTY_DAMAGE',
  /** Småbarnsdunk decision */
  SMABARNSDUNK = 'SMABARNSDUNK',
  /** Underground bin decision */
  UNDERGROUND_BIN = 'UNDERGROUND_BIN'
}

export type SwitchOffAutomationPayload = {
  __typename: 'SwitchOffAutomationPayload';
  automation: AutomationDef;
};

export type SyncCustomFieldsWithTicketTypeMutation = {
  __typename: 'SyncCustomFieldsWithTicketTypeMutation';
  ticketType?: Maybe<TicketTypeDef>;
};

export type SyncOfflineOperationsInput = {
  operations: Array<OfflineOperationInput>;
};

export type SyncOfflineOperationsResult = {
  __typename: 'SyncOfflineOperationsResult';
  acceptedCount: Scalars['Int']['output'];
  conflictCount: Scalars['Int']['output'];
  processedCount: Scalars['Int']['output'];
  rejectedCount: Scalars['Int']['output'];
  results: Array<OfflineOperationResult>;
};

/**
 * Item 6: export ONE property's UNSENT invoices to Visma.
 *
 * Narrows the normal export to this property (bypassing the per-property
 * cadence gate — it's a deliberate manual sync). The run appears in the
 * general Visma export log with a distinct key, and the invoices' status
 * flips on success (Item 5). It does NOT advance the company cursor.
 */
export type SyncPropertyToVisma = {
  __typename: 'SyncPropertyToVisma';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  exportLogId?: Maybe<Scalars['ID']['output']>;
  logId?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SystemHistoryActionDef = {
  __typename: 'SystemHistoryActionDef';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type SystemHistoryActorDef = {
  __typename: 'SystemHistoryActorDef';
  /** User id (kind=user only). */
  id?: Maybe<Scalars['ID']['output']>;
  /** user | system | staff */
  kind: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SystemHistoryEntityTypeDef = {
  __typename: 'SystemHistoryEntityTypeDef';
  fields: Array<SystemHistoryFieldDef>;
  group: Scalars['String']['output'];
  groupLabel: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** High-volume type: shown only when picked explicitly. */
  optIn: Scalars['Boolean']['output'];
  searchable: Scalars['Boolean']['output'];
};

/** One change, normalized across every history mechanism. */
export type SystemHistoryEntryDef = {
  __typename: 'SystemHistoryEntryDef';
  action: Scalars['String']['output'];
  actionLabel: Scalars['String']['output'];
  actor: SystemHistoryActorDef;
  changes: Array<SystemHistoryFieldChangeDef>;
  context?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Relay id of the record when it has a detail page. */
  entityGlobalId?: Maybe<Scalars['ID']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityLabel?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  entityTypeLabel: Scalars['String']['output'];
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  source: Scalars['String']['output'];
};

export type SystemHistoryFieldChangeDef = {
  __typename: 'SystemHistoryFieldChangeDef';
  after?: Maybe<Scalars['GenericScalar']['output']>;
  before?: Maybe<Scalars['GenericScalar']['output']>;
  field: Scalars['String']['output'];
  /** value | text | relation | choice | json | geometry | secret — secret and geometry carry no values, only the fact of the change. */
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type SystemHistoryFieldDef = {
  __typename: 'SystemHistoryFieldDef';
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type SystemHistoryFilterInput = {
  actions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** User ids, and/or "system" / "staff". */
  actors?: InputMaybe<Array<Scalars['String']['input']>>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** "entityType.field" keys from the catalog. */
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  includeOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  records?: InputMaybe<Array<SystemHistoryRecordInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SystemHistoryOptionDef = {
  __typename: 'SystemHistoryOptionDef';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type SystemHistoryPageDef = {
  __typename: 'SystemHistoryPageDef';
  entries: Array<SystemHistoryEntryDef>;
  hasMore: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** Sources that could not be read for this page (e.g. timed out) — the UI says so instead of silently showing less. */
  skippedSources: Array<Scalars['String']['output']>;
};

/** A record matched by the explorer's search box. */
export type SystemHistoryRecordHitDef = {
  __typename: 'SystemHistoryRecordHitDef';
  entityType: Scalars['String']['output'];
  entityTypeLabel: Scalars['String']['output'];
  groupLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type SystemHistoryRecordInput = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
};

/** Per-item outcome of one tag read (COMPASS-884 / HSY REQ 42). */
export enum TagConfirmationStatusEnum {
  /** The stop was already completed before this call. Terminal and non-error, so a replayed offline batch converges. */
  ALREADY_COMPLETED = 'ALREADY_COMPLETED',
  /** The tag resolves to more than one container, or the container appears more than once on the route. Never guessed. */
  AMBIGUOUS = 'AMBIGUOUS',
  /** The stop was confirmed by this call. */
  CONFIRMED = 'CONFIRMED',
  /** A repeated read of the same tag, or a second tag resolving to a stop already confirmed in this call. The stop is confirmed exactly once — this is not an error. */
  DUPLICATE = 'DUPLICATE',
  /** The tag resolves to an open stop on this route. */
  MATCHED = 'MATCHED',
  /** The container is not a stop on this route. */
  NO_STOP = 'NO_STOP',
  /** The completion funnel refused this stop; `message` carries its sentence. Other stops in the same call are unaffected. */
  REJECTED = 'REJECTED',
  /** No container in your company carries this tag (a tag belonging to another company answers the same way). */
  UNKNOWN_TAG = 'UNKNOWN_TAG'
}

/** One tag read from a reader sweep. */
export type TagReadInputType = {
  fillLevel?: InputMaybe<Scalars['Float']['input']>;
  /** Optional: the stop the app already mapped this tag to (it holds the offline package). Must be a stop on this route; the server resolves the tag itself when absent. */
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** When the tag was read. Used as the stop's completedAt so an offline sweep keeps the field instant, not the sync instant. */
  readAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Which reader reported it — REQ 42 explicitly allows two readers identifying two containers at the same moment. */
  readerId?: InputMaybe<Scalars['String']['input']>;
  /** The tag id as the reader decoded it. */
  tagId: Scalars['String']['input'];
  /** Weight from a bin-weighing lift, when present. */
  weight?: InputMaybe<Scalars['Float']['input']>;
};

/** What became of ONE tag read. */
export type TagReadResultType = {
  __typename: 'TagReadResultType';
  container?: Maybe<ContainerType>;
  /** For DUPLICATE: the tag whose confirmation already covers this stop. */
  duplicateOfTag?: Maybe<Scalars['String']['output']>;
  /** Human sentence for the driver. Empty on success. */
  message?: Maybe<Scalars['String']['output']>;
  /** The stop this tag resolved to, when it resolved. */
  orderId?: Maybe<Scalars['String']['output']>;
  /** When the tag was read. */
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /** Which reader reported the tag, echoed back. */
  readerId?: Maybe<Scalars['String']['output']>;
  status: TagConfirmationStatusEnum;
  stop?: Maybe<PickUpOrderType>;
  tagId: Scalars['String']['output'];
};

/**
 * Explicit 'Take over': steals the lease, writes the TAKEN_OVER
 * audit event and notifies the displaced holder (websocket push).
 */
export type TakeOverRecordLease = {
  __typename: 'TakeOverRecordLease';
  currentVersion?: Maybe<Scalars['Int']['output']>;
  lease?: Maybe<RecordLeaseDef>;
  status?: Maybe<Scalars['String']['output']>;
};

export type TaskHaulerReassignmentLogType = Node & {
  __typename: 'TaskHaulerReassignmentLogType';
  fromHauler?: Maybe<HaulerDef>;
  fromRoute?: Maybe<RouteType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  pickupOrder?: Maybe<PickUpOrderType>;
  reason: Scalars['String']['output'];
  reassignedAt: Scalars['DateTime']['output'];
  /** NULL when the move came from a driver session rather than a platform user. */
  reassignedBy?: Maybe<UserType>;
  toHauler?: Maybe<HaulerDef>;
  toRoute?: Maybe<RouteType>;
};

export type TaskHaulerReassignmentLogTypeConnection = {
  __typename: 'TaskHaulerReassignmentLogTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TaskHaulerReassignmentLogTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TaskHaulerReassignmentLogType` and its cursor. */
export type TaskHaulerReassignmentLogTypeEdge = {
  __typename: 'TaskHaulerReassignmentLogTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TaskHaulerReassignmentLogType>;
};

/**
 * Move a single task to a route of a DIFFERENT contractor
 * (binding 3.5.41, assumption A3). Office-only — contractor accounts are
 * refused server-side. Reuses ``Route.action_stops_move`` semantics and
 * writes a ``TaskHaulerReassignmentLog`` audit row on every
 * hauler-crossing move.
 */
export type TaskReassignHauler = {
  __typename: 'TaskReassignHauler';
  log?: Maybe<TaskHaulerReassignmentLogType>;
  pickupOrder?: Maybe<PickUpOrderType>;
};

export type TeamType = Node & {
  __typename: 'TeamType';
  alertrecipientSet: AlertRecipientDefConnection;
  assignedTeamCompanyemailaccountmessages: CompanyEmailAccountMessageDefConnection;
  assignedTeamTickets: TicketDefConnection;
  assigntoteamactionSet: AssignToTeamActionDefConnection;
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  members: UserTypeConnection;
  name: Scalars['String']['output'];
};


export type TeamTypeAlertrecipientSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamTypeAssignedTeamCompanyemailaccountmessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamTypeAssignedTeamTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamTypeAssigntoteamactionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamTypeMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TeamTypeConnection = {
  __typename: 'TeamTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeamTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TeamType` and its cursor. */
export type TeamTypeEdge = {
  __typename: 'TeamTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TeamType>;
};

export type TemplateDef = {
  __typename: 'TemplateDef';
  alreadyAppliedBy: Array<AutomationDef>;
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  graph: Scalars['JSONString']['output'];
  isMine: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parametersSchema: Scalars['JSONString']['output'];
  recommendedMode: Scalars['String']['output'];
  stepsText: Array<Scalars['String']['output']>;
  subjectType: Scalars['String']['output'];
  usedByCount: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

/** GraphQL type for temporary container location overrides (REQ-315). */
export type TemporaryContainerLocationType = Node & {
  __typename: 'TemporaryContainerLocationType';
  /** When the sweep actually applied the change (null while scheduled) */
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  /** What is being changed on the container */
  changeType: DeviceTemporaryContainerLocationChangeTypeChoices;
  /** The container this scheduled change applies to */
  container: ContainerType;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** True while the change is scheduled or active; false once reverted, expired or cancelled */
  isActive: Scalars['Boolean']['output'];
  /** Additional notes about the change */
  note: Scalars['String']['output'];
  originalLocation?: Maybe<LocationType>;
  periodEndDate?: Maybe<Scalars['Date']['output']>;
  periodStartDate?: Maybe<Scalars['Date']['output']>;
  /** Reason for the temporary change */
  reason: DeviceTemporaryContainerLocationReasonChoices;
  /** When the change was reverted (manually, on expiry, or on ticket cancellation) */
  revertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** True when an operator ended the change (Revert action or a cancelled ticket); false when the sweep auto-reverted it on expiry. Null-ish default for rows that are still live. */
  revertedManually: Scalars['Boolean']['output'];
  temporaryLocation?: Maybe<LocationType>;
  ticket?: Maybe<TicketDef>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TemporaryContainerLocationTypeConnection = {
  __typename: 'TemporaryContainerLocationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TemporaryContainerLocationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TemporaryContainerLocationType` and its cursor. */
export type TemporaryContainerLocationTypeEdge = {
  __typename: 'TemporaryContainerLocationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TemporaryContainerLocationType>;
};

/**
 * Office-only, audited (PRO-120): end a contract at a termination date
 * (its last effective day) with a mandatory reason and internal comment.
 *
 * Consequences (shown in the FE before confirming): from the day after
 * the date, the area is no longer in force — new work stops being
 * attributed to it and its agreements stop governing new collections.
 * History is never rewritten: attached agreements and settlement runs up
 * to the date remain.
 *
 * PRO-280 (H4 / decision 11): if the area has carve-outs, the mutation does
 * NOT terminate silently — it returns ``requiresCarveOutDecision: true`` with
 * the affected ``carveOuts`` so the FE can ask whether they end with the area
 * (``TERMINATE_WITH``) or become standalone (``PROMOTE_TO_STANDALONE``). Re-run
 * the mutation with ``carveOutDisposition`` set to commit the choice.
 */
export type TerminateContractArea = {
  __typename: 'TerminateContractArea';
  area?: Maybe<AreaDef>;
  /** The live carve-outs the termination decision applies to (only populated when requiresCarveOutDecision is true). */
  carveOuts: Array<AreaDef>;
  /** True when the area has carve-outs and no disposition was given: the area was NOT terminated — choose a carveOutDisposition and re-run. */
  requiresCarveOutDecision: Scalars['Boolean']['output'];
};

/**
 * Terminate a Shared Collection Point (NEXUS-536 / NEX-SS-104).
 *
 * Ends the SCP's member properties' access agreements at ``end_date``,
 * detaches the memberships and flips the profile to TERMINATED. When active or
 * future-dated access agreements exist the caller must re-submit with
 * ``confirm=True``; the first call returns ``requires_confirmation=True`` and
 * ``warnings`` without mutating anything.
 */
export type TerminateScp = {
  __typename: 'TerminateSCP';
  requiresConfirmation?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Test FTP connection for KMD Easy integration */
export type TestKmdEasyFtpConnection = {
  __typename: 'TestKmdEasyFTPConnection';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TicketAttachmentDef = Node & {
  __typename: 'TicketAttachmentDef';
  deleted?: Maybe<Scalars['DateTime']['output']>;
  eventLog?: Maybe<TicketAttachmentEventLogEventWrapper>;
  file: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  originalFileName?: Maybe<Scalars['String']['output']>;
  ticket: TicketDef;
};


export type TicketAttachmentDefEventLogArgs = {
  addTicketAttachmentEvents?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ticketAttachmentEventTypes?: InputMaybe<Array<InputMaybe<GenericAddRemoveEventTypesGraphene>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type TicketAttachmentDefConnection = {
  __typename: 'TicketAttachmentDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketAttachmentDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TicketAttachmentDef` and its cursor. */
export type TicketAttachmentDefEdge = {
  __typename: 'TicketAttachmentDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketAttachmentDef>;
};

export type TicketAttachmentEventDef = Node & {
  __typename: 'TicketAttachmentEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<GenericAddRemoveEventTypesGraphene>>>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  ticketAttachment?: Maybe<TicketAttachmentDef>;
  user?: Maybe<UserType>;
};

export type TicketAttachmentEventLogEvent = TicketAttachmentEventDef;

export type TicketAttachmentEventLogEventWrapper = {
  __typename: 'TicketAttachmentEventLogEventWrapper';
  edges?: Maybe<Array<Maybe<TicketAttachmentEventLogEvent>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TicketBulkUpdateCreateData = {
  agreementEndDate?: InputMaybe<Scalars['Date']['input']>;
  agreementExcludeFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  agreementStartDate?: InputMaybe<Scalars['Date']['input']>;
  assignedTeamId?: InputMaybe<Scalars['ID']['input']>;
  assigneeFollowAutomationRules?: InputMaybe<Scalars['Boolean']['input']>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  collectionCalendarId?: InputMaybe<Scalars['ID']['input']>;
  companyEmailAccountMessages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  companyId: Scalars['ID']['input'];
  containerId?: InputMaybe<Scalars['ID']['input']>;
  containerProductId?: InputMaybe<Scalars['ID']['input']>;
  containerTypeId?: InputMaybe<Scalars['ID']['input']>;
  customFieldsValues?: InputMaybe<Array<InputMaybe<TicketCustomFieldValueInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionAction?: InputMaybe<DescriptionActionEnum>;
  fillLevel?: InputMaybe<Scalars['Float']['input']>;
  /** Accuracy radius of that fix, metres. */
  gpsAccuracy?: InputMaybe<Scalars['Float']['input']>;
  /** When the device took that fix. */
  gpsCapturedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ignorePriority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ignoreServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  internalNote?: InputMaybe<TicketCommentInput>;
  internalNoteAttachmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Device latitude when the deviation was reported (HSY req 34). */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Device longitude when the deviation was reported (HSY req 34). */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  messageAttachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  messageReceivers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  messageSendingFrom?: InputMaybe<Scalars['ID']['input']>;
  messageType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  originalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  pickupSettingId?: InputMaybe<Scalars['ID']['input']>;
  ppContainerProductId?: InputMaybe<Scalars['String']['input']>;
  ppOriginalWeight?: InputMaybe<Scalars['Decimal']['input']>;
  ppServiceOriginalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  ppServicePrice?: InputMaybe<Scalars['Decimal']['input']>;
  ppServiceProductId?: InputMaybe<Scalars['String']['input']>;
  ppWeight?: InputMaybe<Scalars['Decimal']['input']>;
  ppWeightOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  preferredDate?: InputMaybe<Scalars['Date']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  qrCode?: InputMaybe<Scalars['String']['input']>;
  reporterDriverId?: InputMaybe<Scalars['ID']['input']>;
  reporterId?: InputMaybe<Scalars['ID']['input']>;
  requestedById?: InputMaybe<Scalars['ID']['input']>;
  requestedByOther?: InputMaybe<Scalars['String']['input']>;
  routeDescription?: InputMaybe<Scalars['String']['input']>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
  routeSchemeId?: InputMaybe<Scalars['ID']['input']>;
  runInBackground?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleToRoute?: InputMaybe<Scalars['ID']['input']>;
  serviceId?: InputMaybe<Scalars['ID']['input']>;
  serviceProducts?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  stopId?: InputMaybe<Scalars['ID']['input']>;
  ticketIdStopCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  ticketTypeId?: InputMaybe<Scalars['ID']['input']>;
  wasteFractionId?: InputMaybe<Scalars['ID']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type TicketBulkUpdateCreateInput = {
  containerId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional client-generated idempotency key (a UUID). A later call with the same key from the same user returns the entity the first call created instead of creating another one — re-send safely after a lost response. Keys are remembered for 30 days by default (CLIENT_IDEMPOTENCY_KEY_RETENTION_DAYS). */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  stopId?: InputMaybe<Scalars['ID']['input']>;
};

export type TicketBulkUpdateCreateMutation = {
  __typename: 'TicketBulkUpdateCreateMutation';
  ticketList?: Maybe<Array<Maybe<TicketDef>>>;
};

export type TicketCategoryDef = Node & {
  __typename: 'TicketCategoryDef';
  /** The category's code in the customer's own catalogue, if any. */
  code?: Maybe<Scalars['String']['output']>;
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tickettypeSet: TicketTypeDefConnection;
};


export type TicketCategoryDefTickettypeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketCategoryDefConnection = {
  __typename: 'TicketCategoryDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketCategoryDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TicketCategoryDef` and its cursor. */
export type TicketCategoryDefEdge = {
  __typename: 'TicketCategoryDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketCategoryDef>;
};

/** An enumeration. */
export enum TicketChangePriorityActionPriorityChoices {
  /** None */
  A_0 = 'A_0',
  /** Log */
  A_1 = 'A_1',
  /** Medium */
  A_2 = 'A_2',
  /** High */
  A_3 = 'A_3',
  /** Critical */
  A_4 = 'A_4'
}

/** An enumeration. */
export enum TicketChangeStatusActionStatusChoices {
  /** Created */
  A_1 = 'A_1',
  /** Open */
  A_2 = 'A_2',
  /** Pending */
  A_3 = 'A_3',
  /** On hold */
  A_4 = 'A_4',
  /** In progress */
  A_5 = 'A_5',
  /** Completed */
  A_6 = 'A_6',
  /** Rejected */
  A_7 = 'A_7'
}

export type TicketChangedSubscription = {
  __typename: 'TicketChangedSubscription';
  ticket?: Maybe<TicketDef>;
};

export type TicketClusterDef = {
  __typename: 'TicketClusterDef';
  createdFrom?: Maybe<Array<Maybe<ReportedFromDef>>>;
  duplicatedPoints?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  pointsOnTheSameLocation: Scalars['Boolean']['output'];
  ticketStatuses?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  ticketTypes?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  totalCount: Scalars['Int']['output'];
};

export type TicketCommentAttachmentDef = Node & {
  __typename: 'TicketCommentAttachmentDef';
  deleted?: Maybe<Scalars['DateTime']['output']>;
  file: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  originalFileName?: Maybe<Scalars['String']['output']>;
  ticketComment: TicketCommentDef;
};

export type TicketCommentAttachmentEventDef = Node & {
  __typename: 'TicketCommentAttachmentEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<GenericAddRemoveEventTypesGraphene>>>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  ticketMessageAttachment?: Maybe<TicketCommentAttachmentDef>;
  user?: Maybe<UserType>;
};

export type TicketCommentDef = Node & {
  __typename: 'TicketCommentDef';
  attachments?: Maybe<Array<Maybe<TicketCommentAttachmentDef>>>;
  author?: Maybe<UserType>;
  authorName?: Maybe<Scalars['String']['output']>;
  authorityEntry: Scalars['Boolean']['output'];
  body: Scalars['String']['output'];
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  ticket: TicketDef;
};

export type TicketCommentDefConnection = {
  __typename: 'TicketCommentDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketCommentDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TicketCommentDef` and its cursor. */
export type TicketCommentDefEdge = {
  __typename: 'TicketCommentDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketCommentDef>;
};

export type TicketCommentInput = {
  body: Scalars['String']['input'];
};

/** An enumeration. */
export enum TicketCreateTicketActionNewTicketPriorityChoices {
  /** None */
  A_0 = 'A_0',
  /** Log */
  A_1 = 'A_1',
  /** Medium */
  A_2 = 'A_2',
  /** High */
  A_3 = 'A_3',
  /** Critical */
  A_4 = 'A_4'
}

/**
 * PRO-824 (HSY req 147): who raised a ticket, as one column.
 *
 * ``kind`` is a string token rather than a generated enum, the local
 * convention for a derived classifier (see
 * ``TicketDef.executionWindowSource`` / ``TicketDeadlineSource``). Values
 * are ``ticket.choices.TicketCreatedByKind``: DRIVER, USER, PORTAL,
 * EXTERNAL. It exists because the name alone cannot tell a citizen from an
 * office employee, which is the distinction the office list filters on.
 */
export type TicketCreatedByDef = {
  __typename: 'TicketCreatedByDef';
  /** What kind of actor raised it: DRIVER, USER, PORTAL or EXTERNAL */
  kind: Scalars['String']['output'];
  /** Display name of whoever raised it */
  name: Scalars['String']['output'];
};

export type TicketCustomFieldDef = Node & {
  __typename: 'TicketCustomFieldDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  displayHelpText: Scalars['Boolean']['output'];
  displayOn: Array<Scalars['String']['output']>;
  displayPrefilledValue: Scalars['Boolean']['output'];
  displayUnit: Scalars['Boolean']['output'];
  helpText: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  inputType: TicketTicketCustomFieldInputTypeChoices;
  interval: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<CustomFieldOptionSelectDef>>>;
  placeholder: Scalars['String']['output'];
  prefilledValue: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  ticketTypes?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  tickettypeTicketTypes: TicketTypeDefConnection;
  tickettypeconnectioncustomfieldSet: TicketTypeCustomFieldsConnectionConnection;
  unit: Scalars['String']['output'];
};


export type TicketCustomFieldDefTickettypeTicketTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketCustomFieldDefTickettypeconnectioncustomfieldSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketCustomFieldDefConnection = {
  __typename: 'TicketCustomFieldDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketCustomFieldDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TicketCustomFieldDef` and its cursor. */
export type TicketCustomFieldDefEdge = {
  __typename: 'TicketCustomFieldDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketCustomFieldDef>;
};

export type TicketCustomFieldValueInput = {
  connectionId: Scalars['ID']['input'];
  multiSelectValue?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  selectValue?: InputMaybe<Scalars['ID']['input']>;
  textValue?: InputMaybe<Scalars['String']['input']>;
};

export type TicketDef = Node & {
  __typename: 'TicketDef';
  /** When the abortive visit was reported. */
  abortiveAt?: Maybe<Scalars['DateTime']['output']>;
  /** The photo the driver attached to the last abortive visit; null when that visit had none */
  abortiveAttachment?: Maybe<TicketAttachmentDef>;
  /** Id of the wasted-journey fee (invoicing billable event) posted for the last abortive visit; null when none was posted */
  abortiveFeeEventId?: Maybe<Scalars['ID']['output']>;
  /** Driver's note on the abortive visit. */
  abortiveNote: Scalars['String']['output'];
  /** Why the last visit for this ticket could not be carried out (driver-reported); the ticket was re-opened for rescheduling. */
  abortiveReason?: Maybe<TicketTicketAbortiveReasonChoices>;
  acosArchiveLogs: AcosArchiveLogTypeConnection;
  /** Active agreement of related container */
  activeAgreement?: Maybe<AgreementDef>;
  affectsPay?: Maybe<Scalars['Boolean']['output']>;
  affectsPaySetAt?: Maybe<Scalars['DateTime']['output']>;
  affectsPaySetBy?: Maybe<UserType>;
  agreement?: Maybe<AgreementDef>;
  /** Ended agreement of related container */
  agreementEnded?: Maybe<AgreementDef>;
  agreementStarted: AgreementDefConnection;
  agreementsEndedBy?: Maybe<Array<Maybe<AgreementDef>>>;
  agreementsStartedBy?: Maybe<Array<Maybe<AgreementDef>>>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<UserType>;
  archivedByRule?: Maybe<ArchivalRuleDef>;
  assignedTeam?: Maybe<TeamType>;
  assignee?: Maybe<UserType>;
  /** Tickets associated with the message */
  associatedInboxMessages: CompanyEmailAccountMessageDefConnection;
  attachments: TicketAttachmentDefConnection;
  automationActivity: Array<RecordActivityDef>;
  availableRoutes?: Maybe<RouteTypeConnection>;
  billingContainerPrice?: Maybe<Scalars['Int']['output']>;
  billingServicePrice?: Maybe<Scalars['Int']['output']>;
  bulkwastepickupticket?: Maybe<BulkWastePickupTicketDef>;
  canBeRejected?: Maybe<Scalars['Boolean']['output']>;
  company: CompanyType;
  completeActionsRequirements?: Maybe<CompleteActionsRequirements>;
  container?: Maybe<ContainerType>;
  containerPrice?: Maybe<PriceDef>;
  containerProduct?: Maybe<ProductDef>;
  /** Contract Area of the ticket's object's assigned-area chain */
  contractArea?: Maybe<AreaDef>;
  /** Contractor of the ticket: the explicitly assigned service provider when there is one, else the contractor of the ticket's object's assigned contract area */
  contractor?: Maybe<HaulerDef>;
  createdAt: Scalars['DateTime']['output'];
  createdAtStop: PickUpOrderTypeConnection;
  /** Who raised this ticket, across all four channels */
  createdBy?: Maybe<TicketCreatedByDef>;
  customFields: Scalars['JSONString']['output'];
  customValues?: Maybe<Array<Maybe<CustomTicketValuesDef>>>;
  /** The customer request behind a Customer request ticket (PRODUCT-484); null for every other ticket. */
  customerRequest?: Maybe<CustomerRequestDef>;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  deadlineArea?: Maybe<AreaDef>;
  deadlineSource?: Maybe<TicketTicketDeadlineSourceChoices>;
  defaultReplyTo?: Maybe<TicketDefaultReplyToDef>;
  description: Scalars['String']['output'];
  eventLog?: Maybe<TicketEventLogEventWrapper>;
  /** Which rule produced the deadline: 'area:<contract area name>' (per-area execution window), 'type' (ticket type default) or 'manual' (set by an office user); null when unknown */
  executionWindowSource?: Maybe<Scalars['String']['output']>;
  externalReference?: Maybe<Scalars['String']['output']>;
  externalSource?: Maybe<Scalars['String']['output']>;
  followers: UserTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** @deprecated Check if serviceProducts is empty instead */
  ignoreServiceFee: Scalars['Boolean']['output'];
  invoice?: Maybe<InvoiceDef>;
  invoiceItems: InvoiceItemDefConnection;
  isCustomLocation?: Maybe<Scalars['Boolean']['output']>;
  isOverdue: Scalars['Boolean']['output'];
  keyIssued: PhysicalKeyTypeConnection;
  keyReturned: PhysicalKeyTypeConnection;
  kmdEasyFileFu63303FileLines: KmdEasyFileFu63302FileLineDefConnection;
  lastView?: Maybe<TicketViewEventDef>;
  latestNotificationCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  loadClassification?: Maybe<LoadClassificationDef>;
  location?: Maybe<LocationType>;
  managecontainerticket?: Maybe<ManageContainerTicketDef>;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  notificationsLog?: Maybe<CommonUserNotificationsWrapper>;
  payerContact?: Maybe<ContactDef>;
  periodEndDate?: Maybe<Scalars['Date']['output']>;
  periodStartDate?: Maybe<Scalars['Date']['output']>;
  permits: PermitDefConnection;
  pickupOrder?: Maybe<PickUpOrderType>;
  pickuporderSet: PickUpOrderTypeConnection;
  /** Set when the conversation was originated by a ticket-system message (the ticket->portal bridge); one conversation per (ticket, participant_contact). */
  portalConversations: PortalConversationDefConnection;
  possibleContainerId?: Maybe<Scalars['String']['output']>;
  /** Postal area of the ticket's address, as '<code> <name>' */
  postalArea?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  postalCodeName?: Maybe<Scalars['String']['output']>;
  ppContainerProduct?: Maybe<PpProductDef>;
  ppOriginalPrice?: Maybe<Scalars['Decimal']['output']>;
  ppOriginalWeight?: Maybe<Scalars['Decimal']['output']>;
  ppPrice?: Maybe<Scalars['Decimal']['output']>;
  ppPriceOverridden: Scalars['Boolean']['output'];
  ppServiceOriginalPrice?: Maybe<Scalars['Decimal']['output']>;
  ppServicePrice?: Maybe<Scalars['Decimal']['output']>;
  ppServicePriceOverridden: Scalars['Boolean']['output'];
  ppServiceProduct?: Maybe<PpProductDef>;
  ppWeight?: Maybe<Scalars['Decimal']['output']>;
  ppWeightOverridden: Scalars['Boolean']['output'];
  preferredDate?: Maybe<Scalars['Date']['output']>;
  priority: TicketTicketPriorityChoices;
  property?: Maybe<PropertyDef>;
  propertyTotalPriceAtBillingTime?: Maybe<Scalars['Int']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  rentalLoadClassifications: LoadClassificationDefConnection;
  /** Relocation payload of a 'Relocate to another address' ticket: the target property, the origin, the MOVE route leg and the completion / cancellation stamps; null on other tickets */
  rentalRelocation?: Maybe<RentalRelocationDef>;
  rentalRelocations: Array<RentalRelocationDef>;
  /** Reported accuracy radius of that fix, metres. */
  reportedGpsAccuracyM?: Maybe<Scalars['Float']['output']>;
  /** When the device took that fix (not the sync time). */
  reportedGpsCapturedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Device position when the ticket was filed. NULL = not recorded. */
  reportedPoint?: Maybe<Scalars['GeoJSON']['output']>;
  reporter?: Maybe<UserType>;
  reporterDriver?: Maybe<DriverType>;
  requestedBy?: Maybe<PropertyUserDef>;
  requestedByContact?: Maybe<ContactDef>;
  requestedByOther?: Maybe<Scalars['String']['output']>;
  rfid: Scalars['String']['output'];
  route?: Maybe<RouteType>;
  routeDescription: Scalars['String']['output'];
  scheduledexportrunSet: ScheduledExportRunDefConnection;
  scpCard?: Maybe<ScpTicketCardDef>;
  searchUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  serviceFeeQuantity: Scalars['Int']['output'];
  servicePrices?: Maybe<Array<Maybe<PriceDef>>>;
  serviceProducts: ProductDefConnection;
  /** Service provider this ticket was explicitly handed to, if any */
  serviceProvider?: Maybe<HaulerDef>;
  showOnPortal?: Maybe<Scalars['Boolean']['output']>;
  status: TicketTicketStatusChoices;
  /** The user who changed the status */
  statusChangedBy?: Maybe<UserType>;
  /** The reason for the status change */
  statusChangedReason?: Maybe<TicketTicketStatusChangedReasonChoices>;
  /** The platform where the status was changed */
  statusChangedVia?: Maybe<TicketTicketStatusChangedViaChoices>;
  statusCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  statusInProgressAt?: Maybe<Scalars['DateTime']['output']>;
  statusOnHoldAt?: Maybe<Scalars['DateTime']['output']>;
  statusOpenAt?: Maybe<Scalars['DateTime']['output']>;
  statusPendingAt?: Maybe<Scalars['DateTime']['output']>;
  statusRejectedAt?: Maybe<Scalars['DateTime']['output']>;
  statusTransitions?: Maybe<Array<TicketStatusTransition>>;
  svarUtEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Ticket whose completion triggered this dispatch. Null for manually triggered dispatches that are not bound to a ticket. */
  svarutDispatches: SvarUtDispatchTypeConnection;
  /** The ticket that requested this scheduled change */
  temporarycontainerlocationSet: TemporaryContainerLocationTypeConnection;
  ticketType: TicketTypeDef;
  ticketcommentSet: TicketCommentDefConnection;
  ticketdraftSet: TicketDraftDefConnection;
  ticketeventSet: TicketEventDefConnection;
  ticketmessageSet: TicketMessageDefConnection;
  ticketvieweventSet: TicketViewEventDefConnection;
  /** in minutes */
  timeSpent?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userNotifications: UserNotificationTypeConnection;
  version: Scalars['Int']['output'];
  viaPortal: Scalars['Boolean']['output'];
  visibilityHaulers: HaulerDefConnection;
  visibilityOverridden: Scalars['Boolean']['output'];
  visibilityScope: TicketTicketVisibilityScopeChoices;
  visibilityTeams: TeamTypeConnection;
  visibilityUsers: UserTypeConnection;
  washingReturnOf?: Maybe<TicketDef>;
  washingReturnTickets: TicketDefConnection;
  wasteTransferNote?: Maybe<WasteTransferNoteDef>;
  wasteVolumeEstimate?: Maybe<Scalars['Float']['output']>;
  wasteWeightEstimate?: Maybe<Scalars['Float']['output']>;
  workTaskCorrections: WorkTaskCorrectionTypeConnection;
};


export type TicketDefAcosArchiveLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticket?: InputMaybe<Scalars['ID']['input']>;
};


export type TicketDefAgreementStartedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefAssociatedInboxMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefAvailableRoutesArgs = {
  Type?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  applicableVehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  completedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  containers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  drivers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeRoutes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  filterByDay?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fixedRoute?: InputMaybe<Scalars['Boolean']['input']>;
  hauler?: InputMaybe<Scalars['ID']['input']>;
  haulers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isEmergency?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  plannedDrivers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  plannedVehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scheduledDay?: InputMaybe<Scalars['Date']['input']>;
  scheduledDay_Gte?: InputMaybe<Scalars['Date']['input']>;
  scheduledDay_Lte?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFractions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type TicketDefCreatedAtStopArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefEventLogArgs = {
  addRecordLeaseEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addTicketAttachmentEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addTicketCommentAttachmentEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addTicketComments?: InputMaybe<Scalars['Boolean']['input']>;
  addTicketEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addTicketMessageAttachmentEvents?: InputMaybe<Scalars['Boolean']['input']>;
  authorAuthority?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  isTicketMessageInbound?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  ticketAttachmentEventTypes?: InputMaybe<Array<InputMaybe<GenericAddRemoveEventTypesGraphene>>>;
  ticketCommentAttachmentEventTypes?: InputMaybe<Array<InputMaybe<GenericAddRemoveEventTypesGraphene>>>;
  ticketEventTypes?: InputMaybe<Scalars['TicketEventTypeValuesList']['input']>;
  ticketMessageAttachmentEventTypes?: InputMaybe<Array<InputMaybe<GenericAddRemoveEventTypesGraphene>>>;
  ticketMessageVia?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketTypes?: InputMaybe<Scalars['FromGlobalIDValuesList']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type TicketDefFollowersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefInvoiceItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefKeyIssuedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefKeyReturnedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefKmdEasyFileFu63303FileLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefNotificationsLogArgs = {
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  directOnly?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  followingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  unseen?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TicketDefPermitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefPickuporderSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefPortalConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefRentalLoadClassificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefScheduledexportrunSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefServiceProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefSvarutDispatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticket?: InputMaybe<Scalars['ID']['input']>;
  useCase?: InputMaybe<Scalars['String']['input']>;
};


export type TicketDefTemporarycontainerlocationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefTicketcommentSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefTicketdraftSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefTicketeventSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefTicketmessageSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefTicketvieweventSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefUserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefVisibilityHaulersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefVisibilityTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefVisibilityUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefWashingReturnTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketDefWorkTaskCorrectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketDefConnection = {
  __typename: 'TicketDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TicketDef` and its cursor. */
export type TicketDefEdge = {
  __typename: 'TicketDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketDef>;
};

export type TicketDefFilterInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  affectsPay?: InputMaybe<Scalars['Boolean']['input']>;
  allowedForRoute?: InputMaybe<Scalars['ID']['input']>;
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignedTeam?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignee?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  company?: InputMaybe<Scalars['ID']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerBarcode?: InputMaybe<Scalars['String']['input']>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Multiple values may be separated by commas. */
  createdByKinds?: InputMaybe<Scalars['String']['input']>;
  createdBySearch?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['String']['input']>;
  excludeStatuses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeTicketTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isComplaint?: InputMaybe<Scalars['Boolean']['input']>;
  lastViewedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  managementCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  needToPairRfid?: InputMaybe<Scalars['Boolean']['input']>;
  needToScanBarcode?: InputMaybe<Scalars['Boolean']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  postalAreaSearch?: InputMaybe<Scalars['String']['input']>;
  /** Multiple values may be separated by commas. */
  postalCodes?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['ID']['input']>;
  propertyContactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroup?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reportedByPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  reporter?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reporterByDriver?: InputMaybe<Scalars['Boolean']['input']>;
  reporterDriver?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  requestedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  requestedByPortal?: InputMaybe<Scalars['Boolean']['input']>;
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusCompletedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusCompletedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusInProgressAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusInProgressAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusOnHoldAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusOnHoldAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusOpenAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusOpenAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusPendingAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusPendingAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusRejectedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusRejectedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  syncJob?: InputMaybe<Scalars['Boolean']['input']>;
  ticketType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketTypeCategory?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketTypeService?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketTypeServiceServiceType?: InputMaybe<Scalars['String']['input']>;
  ticketType_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
  wasteFraction?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type TicketDefaultReplyToDef = {
  __typename: 'TicketDefaultReplyToDef';
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TicketDefaultReplyToTypeEnum>;
};

export enum TicketDefaultReplyToTypeEnum {
  SENDER_EMAIL = 'sender_email',
  SENDER_PROPERTY_CONTACT = 'sender_property_contact',
  SENDER_PROPERTY_USER = 'sender_property_user'
}

export type TicketDraftChangedSubscription = {
  __typename: 'TicketDraftChangedSubscription';
  ticketDraft?: Maybe<TicketDraftDef>;
};

export type TicketDraftDef = Node & {
  __typename: 'TicketDraftDef';
  assignee?: Maybe<UserType>;
  company: CompanyType;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  container?: Maybe<ContainerType>;
  createdAt: Scalars['DateTime']['output'];
  createdTicket?: Maybe<TicketDef>;
  emails: CompanyEmailAccountMessageDefConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  project?: Maybe<ProjectType>;
  property?: Maybe<PropertyDef>;
  senderContact?: Maybe<ContactDef>;
  senderEmail: Scalars['String']['output'];
  senderManagementCompany?: Maybe<PropertyManagementCompanyDef>;
  senderPropertyContact?: Maybe<PropertyContactDef>;
  senderPropertyUser?: Maybe<PropertyUserDef>;
  ticketType?: Maybe<TicketTypeDef>;
};


export type TicketDraftDefEmailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketDraftDefConnection = {
  __typename: 'TicketDraftDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketDraftDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TicketDraftDef` and its cursor. */
export type TicketDraftDefEdge = {
  __typename: 'TicketDraftDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketDraftDef>;
};

export type TicketEventDef = Node & {
  __typename: 'TicketEventDef';
  authorityEntry: Scalars['Boolean']['output'];
  barcodeFileUrl: Scalars['String']['output'];
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  createdByAction: Scalars['Boolean']['output'];
  eventType: EventTicketEventEventTypeChoices;
  fromAssignedTeam?: Maybe<TeamType>;
  fromAssignee?: Maybe<UserType>;
  fromAssociatedInboxMessages: CompanyEmailAccountMessageDefConnection;
  fromPriority?: Maybe<EventTicketEventFromPriorityChoices>;
  fromStatus?: Maybe<EventTicketEventFromStatusChoices>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  modifiedData?: Maybe<Scalars['JSONString']['output']>;
  ticket: TicketDef;
  toAssignedTeam?: Maybe<TeamType>;
  toAssignee?: Maybe<UserType>;
  toAssociatedInboxMessages: CompanyEmailAccountMessageDefConnection;
  toPriority?: Maybe<EventTicketEventToPriorityChoices>;
  toStatus?: Maybe<EventTicketEventToStatusChoices>;
};


export type TicketEventDefFromAssociatedInboxMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketEventDefToAssociatedInboxMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketEventDefConnection = {
  __typename: 'TicketEventDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketEventDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TicketEventDef` and its cursor. */
export type TicketEventDefEdge = {
  __typename: 'TicketEventDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketEventDef>;
};

export type TicketEventLogEvent = RecordLeaseEventDef | TicketAttachmentEventDef | TicketCommentAttachmentEventDef | TicketCommentDef | TicketEventDef | TicketMessageAttachmentEventDef | TicketMessageDef;

export type TicketEventLogEventWrapper = {
  __typename: 'TicketEventLogEventWrapper';
  edges?: Maybe<Array<Maybe<TicketEventLogEvent>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TicketItemSnapshotDef = Node & {
  __typename: 'TicketItemSnapshotDef';
  batch: SnapshotBatchDef;
  companyId: Scalars['Int']['output'];
  containerId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** What happened during sync for this specific item */
  externalSyncMessage: Scalars['String']['output'];
  /** Status of this specific item sync */
  externalSyncStatus: EvolutionTicketItemSnapshotExternalSyncStatusChoices;
  externalSyncStatusDisplay?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  pickupOrderId?: Maybe<Scalars['UUID']['output']>;
  /** Human-readable container_id string from device.Container — sent verbatim as the SOAP ProductNumber. Different from ``container_id``, which is the Django PK and is for joins only. */
  productNumber: Scalars['String']['output'];
  /** Botek RouteID for the ticket's container at snapshot time, sourced from EvolutionContainerLink. Sent verbatim as the SOAP `RouteID` parameter. */
  routeId: Scalars['String']['output'];
  scheduledDay: Scalars['Date']['output'];
  ticketId: Scalars['Int']['output'];
};

export type TicketItemSnapshotDefConnection = {
  __typename: 'TicketItemSnapshotDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketItemSnapshotDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TicketItemSnapshotDef` and its cursor. */
export type TicketItemSnapshotDefEdge = {
  __typename: 'TicketItemSnapshotDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketItemSnapshotDef>;
};

/** An enumeration. */
export enum TicketManageContainerTicketReceiveConditionChoices {
  /** New */
  NEW = 'NEW',
  /** Used */
  USED = 'USED'
}

/** An enumeration. */
export enum TicketManageContainerTicketStatusCopyChoices {
  /** Created */
  A_1 = 'A_1',
  /** Open */
  A_2 = 'A_2',
  /** Pending */
  A_3 = 'A_3',
  /** On hold */
  A_4 = 'A_4',
  /** In progress */
  A_5 = 'A_5',
  /** Completed */
  A_6 = 'A_6',
  /** Rejected */
  A_7 = 'A_7'
}

export type TicketMapPointDef = {
  __typename: 'TicketMapPointDef';
  fillLevel?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  reporterDriverId?: Maybe<Scalars['Int']['output']>;
  reporterId?: Maybe<Scalars['Int']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  ticketTypeId?: Maybe<Scalars['String']['output']>;
  ticketTypeName?: Maybe<Scalars['String']['output']>;
};

export type TicketMessageAttachmentDef = Node & {
  __typename: 'TicketMessageAttachmentDef';
  deleted?: Maybe<Scalars['DateTime']['output']>;
  file: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  originalFileName?: Maybe<Scalars['String']['output']>;
  ticketMessage: TicketMessageDef;
};

export type TicketMessageAttachmentEventDef = Node & {
  __typename: 'TicketMessageAttachmentEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<GenericAddRemoveEventTypesGraphene>>>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  ticketMessageAttachment?: Maybe<TicketMessageAttachmentDef>;
  user?: Maybe<UserType>;
};

export type TicketMessageDef = Node & {
  __typename: 'TicketMessageDef';
  attachments?: Maybe<Array<Maybe<TicketMessageAttachmentDef>>>;
  authorityEntry: Scalars['Boolean']['output'];
  body: Scalars['String']['output'];
  company: CompanyType;
  companyEmailAccount?: Maybe<CompanyEmailAccountDef>;
  companyemailaccountmessage?: Maybe<CompanyEmailAccountMessageDef>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  createdByAction: Scalars['Boolean']['output'];
  failureReason: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isInbound?: Maybe<Scalars['Boolean']['output']>;
  isOutbound?: Maybe<Scalars['Boolean']['output']>;
  messageStatus: TicketTicketMessageMessageStatusChoices;
  notificationmessageSet: NotificationMessageDefConnection;
  receiverContact?: Maybe<ContactDef>;
  receiverEmail?: Maybe<Scalars['String']['output']>;
  receiverManagementCompany?: Maybe<PropertyManagementCompanyDef>;
  receiverPropertyContact?: Maybe<PropertyContactDef>;
  receiverPropertyUser?: Maybe<PropertyUserDef>;
  sender?: Maybe<UserType>;
  senderContact?: Maybe<ContactDef>;
  senderEmail?: Maybe<Scalars['String']['output']>;
  senderManagementCompany?: Maybe<PropertyManagementCompanyDef>;
  senderPropertyContact?: Maybe<PropertyContactDef>;
  senderPropertyUser?: Maybe<PropertyUserDef>;
  subject?: Maybe<Scalars['String']['output']>;
  ticket: TicketDef;
  via?: Maybe<TicketTicketMessageViaChoices>;
};


export type TicketMessageDefNotificationmessageSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketMessageDefConnection = {
  __typename: 'TicketMessageDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketMessageDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TicketMessageDef` and its cursor. */
export type TicketMessageDefEdge = {
  __typename: 'TicketMessageDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketMessageDef>;
};

export type TicketMessageTemplateDef = Node & {
  __typename: 'TicketMessageTemplateDef';
  company: CompanyType;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  migratedFromId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  substitutedContent?: Maybe<Scalars['String']['output']>;
};


export type TicketMessageTemplateDefSubstitutedContentArgs = {
  ticketId: Scalars['ID']['input'];
};

export type TicketMessageTemplateDefConnection = {
  __typename: 'TicketMessageTemplateDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketMessageTemplateDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TicketMessageTemplateDef` and its cursor. */
export type TicketMessageTemplateDefEdge = {
  __typename: 'TicketMessageTemplateDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketMessageTemplateDef>;
};

export type TicketPricing = {
  __typename: 'TicketPricing';
  addContainer: Array<TicketPricingContainerPriceDef>;
  changeContainerType: Array<TicketPricingContainerPriceDef>;
  changePickupSetting: Array<TicketPricingContainerPriceDef>;
  otherContainerLevel?: Maybe<TicketPricingInfoDef>;
  otherPropertyLevel?: Maybe<TicketPricingInfoDef>;
  ppChangeContainerType: Array<PpContainerOfferDef>;
  ppChangePickupSetting: Array<PpContainerOfferDef>;
};


export type TicketPricingAddContainerArgs = {
  propertyIds: Array<Scalars['ID']['input']>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};


export type TicketPricingChangeContainerTypeArgs = {
  containerIds: Array<Scalars['ID']['input']>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};


export type TicketPricingChangePickupSettingArgs = {
  containerIds: Array<Scalars['ID']['input']>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};


export type TicketPricingOtherContainerLevelArgs = {
  containerIds: Array<Scalars['ID']['input']>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
  ticketTypeId: Scalars['ID']['input'];
};


export type TicketPricingOtherPropertyLevelArgs = {
  propertyIds: Array<Scalars['ID']['input']>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
  ticketTypeId: Scalars['ID']['input'];
};


export type TicketPricingPpChangeContainerTypeArgs = {
  containerIds: Array<Scalars['ID']['input']>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};


export type TicketPricingPpChangePickupSettingArgs = {
  containerIds: Array<Scalars['ID']['input']>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};

export type TicketPricingContainerPriceDef = {
  __typename: 'TicketPricingContainerPriceDef';
  containerPrice?: Maybe<ContainerPriceOptionDef>;
  /** @deprecated Use service_prices instead in order to support multiple choices */
  servicePrice?: Maybe<PriceDef>;
  servicePrices?: Maybe<Array<PriceDef>>;
};

export type TicketPricingInfoDef = {
  __typename: 'TicketPricingInfoDef';
  mixed: Scalars['Boolean']['output'];
  /** @deprecated Use service_prices instead in order to support multiple choices */
  servicePrice?: Maybe<PriceDef>;
  servicePrices?: Maybe<Array<PriceDef>>;
};

/** An enumeration. */
export enum TicketSendMessageToPropertyContactActionViaChoices {
  /** Dkdp */
  DKDP = 'DKDP',
  /** Email */
  EMAIL = 'EMAIL',
  /** Nemsms */
  NEMSMS = 'NEMSMS',
  /** Sms */
  SMS = 'SMS',
  /** Svarut */
  SVARUT = 'SVARUT'
}

/** An enumeration. */
export enum TicketSendMessageToPropertyUserActionViaChoices {
  /** Dkdp */
  DKDP = 'DKDP',
  /** Email */
  EMAIL = 'EMAIL',
  /** Nemsms */
  NEMSMS = 'NEMSMS',
  /** Sms */
  SMS = 'SMS',
  /** Svarut */
  SVARUT = 'SVARUT'
}

export type TicketStatusDef = {
  __typename: 'TicketStatusDef';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TicketStatusTransition = {
  __typename: 'TicketStatusTransition';
  actions?: Maybe<Array<RuleActionUnionDef>>;
  status: Scalars['String']['output'];
  supersededByFlowId?: Maybe<Scalars['ID']['output']>;
  supersededByFlowName?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum TicketTicketAbortiveReasonChoices {
  /** Access blocked */
  ACCESS_BLOCKED = 'ACCESS_BLOCKED',
  /** Customer absent */
  CUSTOMER_ABSENT = 'CUSTOMER_ABSENT',
  /** Other */
  OTHER = 'OTHER',
  /** Overloaded */
  OVERLOADED = 'OVERLOADED',
  /** Permit missing */
  PERMIT_MISSING = 'PERMIT_MISSING',
  /** Prohibited items */
  PROHIBITED_ITEMS = 'PROHIBITED_ITEMS'
}

/** An enumeration. */
export enum TicketTicketCustomFieldInputTypeChoices {
  /** Date */
  DATE = 'DATE',
  /** Multi Select */
  MULTI_SELECT = 'MULTI_SELECT',
  /** Number */
  NUMBER = 'NUMBER',
  /** Select */
  SELECT = 'SELECT',
  /** Signature */
  SIGNATURE = 'SIGNATURE',
  /** Text Area */
  TEXT_AREA = 'TEXT_AREA'
}

/** An enumeration. */
export enum TicketTicketDeadlineSourceChoices {
  /** Area */
  AREA = 'AREA',
  /** Manual */
  MANUAL = 'MANUAL',
  /** Type */
  TYPE = 'TYPE'
}

/** An enumeration. */
export enum TicketTicketMessageMessageStatusChoices {
  /** Failed */
  FAILED = 'FAILED',
  /** In progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Success */
  SUCCESS = 'SUCCESS'
}

/** An enumeration. */
export enum TicketTicketMessageViaChoices {
  /** Dkdp */
  DKDP = 'DKDP',
  /** Email */
  EMAIL = 'EMAIL',
  /** Nemsms */
  NEMSMS = 'NEMSMS',
  /** Sms */
  SMS = 'SMS',
  /** Svarut */
  SVARUT = 'SVARUT'
}

/** An enumeration. */
export enum TicketTicketPriorityChoices {
  /** None */
  A_0 = 'A_0',
  /** Log */
  A_1 = 'A_1',
  /** Medium */
  A_2 = 'A_2',
  /** High */
  A_3 = 'A_3',
  /** Critical */
  A_4 = 'A_4'
}

/** An enumeration. */
export enum TicketTicketStatusChangedReasonChoices {
  /** Abortive visit */
  ABORTIVE = 'ABORTIVE',
  /** Manual */
  MANUAL = 'MANUAL',
  /** Route reset */
  ROUTE_RESET = 'ROUTE_RESET',
  /** Stop reset */
  STOP_RESET = 'STOP_RESET',
  /** Unspecified */
  UNSPECIFIED = 'UNSPECIFIED'
}

/** An enumeration. */
export enum TicketTicketStatusChangedViaChoices {
  /** Nav App */
  NAV_APP = 'NAV_APP',
  /** Platform */
  PLATFORM = 'PLATFORM',
  /** Portal */
  PORTAL = 'PORTAL'
}

/** An enumeration. */
export enum TicketTicketStatusChoices {
  /** Created */
  A_1 = 'A_1',
  /** Open */
  A_2 = 'A_2',
  /** Pending */
  A_3 = 'A_3',
  /** On hold */
  A_4 = 'A_4',
  /** In progress */
  A_5 = 'A_5',
  /** Completed */
  A_6 = 'A_6',
  /** Rejected */
  A_7 = 'A_7'
}

/** An enumeration. */
export enum TicketTicketTypeAreaExecutionWindowOffsetUnitChoices {
  /** Days */
  DAYS = 'DAYS',
  /** Months */
  MONTHS = 'MONTHS',
  /** Weeks */
  WEEKS = 'WEEKS'
}

/** An enumeration. */
export enum TicketTicketTypeDeadlineModeChoices {
  /** Fixed */
  FIXED = 'FIXED',
  /** Manual */
  MANUAL = 'MANUAL'
}

/** An enumeration. */
export enum TicketTicketTypeDeadlineOffsetUnitChoices {
  /** Days */
  DAYS = 'DAYS',
  /** Months */
  MONTHS = 'MONTHS',
  /** Weeks */
  WEEKS = 'WEEKS'
}

/** An enumeration. */
export enum TicketTicketTypeVisibilityScopeChoices {
  /** Contractors */
  CONTRACTORS = 'CONTRACTORS',
  /** Public */
  PUBLIC = 'PUBLIC',
  /** Teams */
  TEAMS = 'TEAMS',
  /** Users */
  USERS = 'USERS'
}

/** An enumeration. */
export enum TicketTicketVisibilityScopeChoices {
  /** Contractors */
  CONTRACTORS = 'CONTRACTORS',
  /** Public */
  PUBLIC = 'PUBLIC',
  /** Teams */
  TEAMS = 'TEAMS',
  /** Users */
  USERS = 'USERS'
}

export type TicketTypeActionInput = {
  assignToTeamAction?: InputMaybe<AssignToTeamActionMutationInput>;
  assignToUserAction?: InputMaybe<AssignToUserActionMutationInput>;
  changePriorityAction?: InputMaybe<ChangePriorityActionMutationInput>;
  changeStatusAction?: InputMaybe<ChangeStatusActionMutationInput>;
  containerAction?: InputMaybe<ContainerActionMutationInput>;
  createPropertyAction?: InputMaybe<CreatePropertyActionMutationInput>;
  createTicketAction?: InputMaybe<CreateTicketActionMutationInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  scheduleOnRouteAction?: InputMaybe<ScheduleOnRouteActionMutationInput>;
  sendEmailAction?: InputMaybe<SendEmailActionMutationInput>;
  sendMessageToPropertyContactAction?: InputMaybe<SendMessageToPropertyContactActionMutationInput>;
  sendMessageToPropertyUserAction?: InputMaybe<SendMessageToPropertyUserActionMutationInput>;
};

/**
 * HSY-256 — a per-area override of a task type's execution window.
 *
 * Read alongside the type's own deadline fields: absent means the type
 * default applies in that area.
 */
export type TicketTypeAreaExecutionWindowDef = Node & {
  __typename: 'TicketTypeAreaExecutionWindowDef';
  /** The contract area this window applies in. */
  area: AreaDef;
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Optional context, e.g. the contract clause behind it. */
  note: Scalars['String']['output'];
  /** How long a task of this type may take in this area. 0 means it must be executed on its scheduled day. */
  offsetNumber: Scalars['Int']['output'];
  offsetUnit: TicketTicketTypeAreaExecutionWindowOffsetUnitChoices;
  /** The kind of task this window applies to. */
  ticketType: TicketTypeDef;
  updatedAt: Scalars['DateTime']['output'];
};

export type TicketTypeAreaExecutionWindowDefConnection = {
  __typename: 'TicketTypeAreaExecutionWindowDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketTypeAreaExecutionWindowDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TicketTypeAreaExecutionWindowDef` and its cursor. */
export type TicketTypeAreaExecutionWindowDefEdge = {
  __typename: 'TicketTypeAreaExecutionWindowDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketTypeAreaExecutionWindowDef>;
};

export type TicketTypeAvailableDateDef = {
  __typename: 'TicketTypeAvailableDateDef';
  container?: Maybe<ContainerType>;
  dates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
};

/**
 * The four RED-tier container gates, named in the builder's
 * language; mapped onto the real ``ContainerAction`` fields
 * (ticket/models/rule.py): require_label_printed ->
 * require_container_label_printed, require_barcode_scan ->
 * require_container_id_barcode_scanning, require_rfid_pairing ->
 * require_rfid_pairing, require_container_location ->
 * require_container_location. Absent (or null) keys are untouched.
 */
export type TicketTypeContainerGatesInput = {
  requireBarcodeScan?: InputMaybe<Scalars['Boolean']['input']>;
  requireContainerLocation?: InputMaybe<Scalars['Boolean']['input']>;
  requireLabelPrinted?: InputMaybe<Scalars['Boolean']['input']>;
  requireRfidPairing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TicketTypeCountDef = {
  __typename: 'TicketTypeCountDef';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TicketTypeCustomFieldsConnection = Node & {
  __typename: 'TicketTypeCustomFieldsConnection';
  connectedCustomValues: CustomTicketValuesDefConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  ticketCustomField?: Maybe<TicketCustomFieldDef>;
  ticketType: TicketTypeDef;
};


export type TicketTypeCustomFieldsConnectionConnectedCustomValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketTypeCustomFieldsConnectionConnection = {
  __typename: 'TicketTypeCustomFieldsConnectionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketTypeCustomFieldsConnectionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TicketTypeCustomFieldsConnection` and its cursor. */
export type TicketTypeCustomFieldsConnectionEdge = {
  __typename: 'TicketTypeCustomFieldsConnectionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketTypeCustomFieldsConnection>;
};

export type TicketTypeDef = Node & {
  __typename: 'TicketTypeDef';
  abortiveFeeProduct?: Maybe<PpProductDef>;
  /** The kind of task this window applies to. */
  areaExecutionWindows: TicketTypeAreaExecutionWindowDefConnection;
  assigneeSetAutomatically: Scalars['Boolean']['output'];
  availableDates?: Maybe<Array<Maybe<TicketTypeAvailableDateDef>>>;
  category: TicketCategoryDef;
  /** The code an external system quotes for this type (for example a deviation code on an emptying receipt). */
  code?: Maybe<Scalars['String']['output']>;
  company: CompanyType;
  companyemailaccountruleSet: CompanyEmailAccountRuleDefConnection;
  /** Office-configured reason code/label for this complaint category (e.g. missed collection, damage). Free text so the office owns the reason set; blank for non-complaint types. */
  complaintReason: Scalars['String']['output'];
  containerDestination?: Maybe<ContainerStorageLocationDef>;
  containerSource?: Maybe<ContainerStorageLocationDef>;
  creatableFromCustomerPage: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createticketactionSet: CreateTicketActionDefConnection;
  deadlineMode?: Maybe<TicketTicketTypeDeadlineModeChoices>;
  deadlineOffsetNumber?: Maybe<Scalars['Int']['output']>;
  deadlineOffsetUnit?: Maybe<TicketTicketTypeDeadlineOffsetUnitChoices>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  enableOnNavigationApp: Scalars['Boolean']['output'];
  enableOnPlatform: Scalars['Boolean']['output'];
  enableOnPortal: Scalars['Boolean']['output'];
  eventLog?: Maybe<TicketTypeEventsWrapper>;
  /** When this period ticket type is dispatched, automatically create the pickup/return ticket due on its end date. */
  generatesReturnTicket: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  includeDeadline?: Maybe<Scalars['Boolean']['output']>;
  includePeriod?: Maybe<Scalars['Boolean']['output']>;
  /** Flags this ticket type as a citizen complaint / feedback category (W8, D5). Tickets of a complaint type are surfaced in the feedback list and can be marked as affecting pay. */
  isComplaint: Scalars['Boolean']['output'];
  isContainerLevel: Scalars['Boolean']['output'];
  isMarketing?: Maybe<Scalars['Boolean']['output']>;
  isPropertyLevel: Scalars['Boolean']['output'];
  kmdEasyImportDeletedContacts: Scalars['Boolean']['output'];
  kmdEasyImportNewAgreement: Scalars['Boolean']['output'];
  kmdEasyImportNewContact: Scalars['Boolean']['output'];
  kmdEasyImportNewProperty: Scalars['Boolean']['output'];
  kmdEasyImportUpdatedAgreement: Scalars['Boolean']['output'];
  kmdEasyImportUpdatedContacts: Scalars['Boolean']['output'];
  kmdEasyImportUpdatedProperty: Scalars['Boolean']['output'];
  manualCitizenPortalOrder?: Maybe<Scalars['Int']['output']>;
  manualNavigationAppOrder?: Maybe<Scalars['Int']['output']>;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  navigationAppRequireAttachment: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  periodDefaultDurationDays?: Maybe<Scalars['Int']['output']>;
  periodEndDateRequired?: Maybe<Scalars['Boolean']['output']>;
  portalConfirmSubtitle: Scalars['String']['output'];
  portalConfirmTitle: Scalars['String']['output'];
  portalContactInformationEmailRequired: Scalars['Boolean']['output'];
  portalContactInformationNameRequired: Scalars['Boolean']['output'];
  portalContactInformationNextButtonLabel: Scalars['String']['output'];
  portalContactInformationPhoneNumberRequired: Scalars['Boolean']['output'];
  portalDateHelpText: Scalars['String']['output'];
  portalDateHidden: Scalars['Boolean']['output'];
  portalDateLabel: Scalars['String']['output'];
  portalDateMaxDaysInFutureForBulkWaste: Scalars['Int']['output'];
  portalDateMinDaysInFutureForBulkWaste: Scalars['Int']['output'];
  portalDateRequired: Scalars['Boolean']['output'];
  portalDescription: Scalars['String']['output'];
  portalDropdownHelpText: Scalars['String']['output'];
  portalDropdownHidden: Scalars['Boolean']['output'];
  portalDropdownLabel: Scalars['String']['output'];
  portalDropdownOptions: Array<Scalars['String']['output']>;
  portalDropdownRequired: Scalars['Boolean']['output'];
  portalNoteHelpText: Scalars['String']['output'];
  portalNoteHidden: Scalars['Boolean']['output'];
  portalNoteLabel: Scalars['String']['output'];
  portalNoteRequired: Scalars['Boolean']['output'];
  portalPriceShowZero: Scalars['Boolean']['output'];
  portalRequireContactInformation: Scalars['Boolean']['output'];
  portalServiceTypeBulkWasteLimit: Scalars['Int']['output'];
  portalServiceTypeBulkWasteLimitHelpText: Scalars['String']['output'];
  portalServiceTypeBulkWasteLimitLabel: Scalars['String']['output'];
  ppServiceProduct?: Maybe<PpProductDef>;
  /** Status a ticket of this type moves to when it is added to a route from the route page. Blank leaves the status unchanged. Values: 1 Created, 2 Open, 3 Pending, 4 On hold, 5 In progress, 6 Completed, 7 Rejected. */
  routeScheduledStatus?: Maybe<Scalars['Int']['output']>;
  rules: Array<AutopilotLegacyRuleType>;
  scheduledexportSet: ScheduledExportDefConnection;
  scheduledexportrunSet: ScheduledExportRunDefConnection;
  service?: Maybe<ServiceDef>;
  statusTransitions?: Maybe<Array<TicketTypeStatusTransition>>;
  ticketCustomFieldConnections?: Maybe<Array<Maybe<TicketTypeCustomFieldsConnection>>>;
  ticketCustomFields: TicketCustomFieldDefConnection;
  ticketSet?: Maybe<TicketDefConnection>;
  ticketdraftSet: TicketDraftDefConnection;
  tickettypeconnectioncustomfieldSet: TicketTypeCustomFieldsConnectionConnection;
  useContainerStorageManagement: Scalars['Boolean']['output'];
  vehicletrailertickettypeholdSet: VehicleTrailerTicketTypeHoldTypeConnection;
  visibilityHaulers: HaulerDefConnection;
  visibilityMembersSummary: Scalars['String']['output'];
  visibilityScope: TicketTicketTypeVisibilityScopeChoices;
  visibilityTeams: TeamTypeConnection;
  visibilityUsers: UserTypeConnection;
  /** The container washing ticket type production mints one ticket per bin of. */
  washLists: WashListDefConnection;
  /** How many days after the washing ticket is completed the bin is due back (the return ticket's preferred date). */
  washingReturnAfterDays: Scalars['Int']['output'];
  /** The (container-level) ticket type of the follow-up ticket that returns the washed bin. */
  washingReturnTicketType?: Maybe<TicketTypeDef>;
  /** Off-site washing: completing a ticket of this type creates a follow-up ticket that returns the washed bin. */
  washingReturnsContainer: Scalars['Boolean']['output'];
};


export type TicketTypeDefAreaExecutionWindowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ticketType?: InputMaybe<Scalars['ID']['input']>;
};


export type TicketTypeDefAvailableDatesArgs = {
  containerIds: Array<InputMaybe<Scalars['ID']['input']>>;
  propertyId: Scalars['ID']['input'];
};


export type TicketTypeDefCompanyemailaccountruleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketTypeDefCreateticketactionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketTypeDefEventLogArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ticketTypeEventTypes?: InputMaybe<Array<InputMaybe<TicketTypeEventTypesShortGraphene>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type TicketTypeDefScheduledexportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketTypeDefScheduledexportrunSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketTypeDefTicketCustomFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketTypeDefTicketSetArgs = {
  activeProjects?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  affectsPay?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  allowedForRoute?: InputMaybe<Scalars['ID']['input']>;
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignedTeam?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignee?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerBarcode?: InputMaybe<Scalars['String']['input']>;
  containerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractAreaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  createdByKinds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdBySearch?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['String']['input']>;
  excludeStatuses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeTicketTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isComplaint?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastViewedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  managementCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  needToPairRfid?: InputMaybe<Scalars['Boolean']['input']>;
  needToScanBarcode?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  pickupSetting?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  postalAreaSearch?: InputMaybe<Scalars['String']['input']>;
  postalCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['ID']['input']>;
  propertyContactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroup?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reportedByPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  reporter?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reporterByDriver?: InputMaybe<Scalars['Boolean']['input']>;
  reporterDriver?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  requestedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  requestedByPortal?: InputMaybe<Scalars['Boolean']['input']>;
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusCompletedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusCompletedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusInProgressAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusInProgressAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusOnHoldAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusOnHoldAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusOpenAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusOpenAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusPendingAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusPendingAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  statusRejectedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statusRejectedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  syncJob?: InputMaybe<Scalars['Boolean']['input']>;
  ticketType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketTypeCategory?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketTypeService?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticketTypeServiceServiceType?: InputMaybe<Scalars['String']['input']>;
  ticketType_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
  wasteFraction?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type TicketTypeDefTicketdraftSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketTypeDefTickettypeconnectioncustomfieldSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketTypeDefVehicletrailertickettypeholdSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketTypeDefVisibilityHaulersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketTypeDefVisibilityTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketTypeDefVisibilityUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketTypeDefWashListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketTypeDefConnection = {
  __typename: 'TicketTypeDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketTypeDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TicketTypeDef` and its cursor. */
export type TicketTypeDefEdge = {
  __typename: 'TicketTypeDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketTypeDef>;
};

export type TicketTypeEventDef = Node & {
  __typename: 'TicketTypeEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<TicketTypeEventTypesShortGraphene>>>;
  fromCategory?: Maybe<TicketCategoryDef>;
  fromEnableOnNavigationApp?: Maybe<Scalars['Boolean']['output']>;
  fromEnableOnPlatform?: Maybe<Scalars['Boolean']['output']>;
  fromEnableOnPortal?: Maybe<Scalars['Boolean']['output']>;
  fromIsContainerLevel?: Maybe<Scalars['Boolean']['output']>;
  fromIsPropertyLevel?: Maybe<Scalars['Boolean']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  fromNavigationAppRequireAttachment?: Maybe<Scalars['Boolean']['output']>;
  fromOrder?: Maybe<Scalars['Int']['output']>;
  fromService?: Maybe<ServiceDef>;
  fromVisibilityMembersSummary?: Maybe<Scalars['String']['output']>;
  fromVisibilityScope?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  ticketType?: Maybe<TicketTypeDef>;
  toCategory?: Maybe<TicketCategoryDef>;
  toEnableOnNavigationApp?: Maybe<Scalars['Boolean']['output']>;
  toEnableOnPlatform?: Maybe<Scalars['Boolean']['output']>;
  toEnableOnPortal?: Maybe<Scalars['Boolean']['output']>;
  toIsContainerLevel?: Maybe<Scalars['Boolean']['output']>;
  toIsPropertyLevel?: Maybe<Scalars['Boolean']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
  toNavigationAppRequireAttachment?: Maybe<Scalars['Boolean']['output']>;
  toOrder?: Maybe<Scalars['Int']['output']>;
  toService?: Maybe<ServiceDef>;
  toVisibilityMembersSummary?: Maybe<Scalars['String']['output']>;
  toVisibilityScope?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
};

export enum TicketTypeEventTypesShortGraphene {
  CATEGORY_CHANGE = 'CATEGORY_CHANGE',
  ENABLE_ON_CHANGE = 'ENABLE_ON_CHANGE',
  IS_LEVEL_CHANGE = 'IS_LEVEL_CHANGE',
  NAME_CHANGE = 'NAME_CHANGE',
  NAVIGATION_APP_REQUIRE_ATTACHMENT_CHANGE = 'NAVIGATION_APP_REQUIRE_ATTACHMENT_CHANGE',
  ORDER_CHANGE = 'ORDER_CHANGE',
  SERVICE_CHANGE = 'SERVICE_CHANGE',
  VISIBILITY_MEMBERS_CHANGE = 'VISIBILITY_MEMBERS_CHANGE',
  VISIBILITY_SCOPE_CHANGE = 'VISIBILITY_SCOPE_CHANGE'
}

export type TicketTypeEventsWrapper = {
  __typename: 'TicketTypeEventsWrapper';
  edges?: Maybe<Array<Maybe<TicketTypeEventDef>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum TicketTypeOrderCategoriseBy {
  NONE = 'NONE',
  ROUTE_SCHEME = 'ROUTE_SCHEME'
}

export type TicketTypeOrderingObject = {
  levels?: InputMaybe<Array<InputMaybe<LevelChoices>>>;
  orderType?: InputMaybe<OrderTypeChoices>;
  platform?: InputMaybe<PlatformChoices>;
  routeScheme?: InputMaybe<Scalars['ID']['input']>;
};

export type TicketTypeStatusTransition = {
  __typename: 'TicketTypeStatusTransition';
  actions?: Maybe<Array<RuleActionUnionDef>>;
  dateField?: Maybe<RuleDateField>;
  fromStatus?: Maybe<Scalars['String']['output']>;
  offsetDays?: Maybe<Scalars['Int']['output']>;
  restrictionRoles?: Maybe<Array<CompanyRoleDef>>;
  supersededByFlowId?: Maybe<Scalars['ID']['output']>;
  supersededByFlowName?: Maybe<Scalars['String']['output']>;
  toStatus: Scalars['String']['output'];
  triggerKind: RuleTriggerKind;
};

export type TicketTypeStatusTransitionInput = {
  actions?: InputMaybe<Array<TicketTypeActionInput>>;
  dateField?: InputMaybe<RuleDateField>;
  fromStatus?: InputMaybe<Scalars['String']['input']>;
  offsetDays?: InputMaybe<Scalars['Int']['input']>;
  restrictionRoles?: InputMaybe<Array<Scalars['ID']['input']>>;
  toStatus: Scalars['String']['input'];
  triggerKind?: InputMaybe<RuleTriggerKind>;
};

export type TicketViewEventDef = Node & {
  __typename: 'TicketViewEventDef';
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  createdByAction: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  ticket: TicketDef;
  viewedBy?: Maybe<UserType>;
};

export type TicketViewEventDefConnection = {
  __typename: 'TicketViewEventDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketViewEventDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TicketViewEventDef` and its cursor. */
export type TicketViewEventDefEdge = {
  __typename: 'TicketViewEventDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketViewEventDef>;
};

export type TimerDef = {
  __typename: 'TimerDef';
  cancelReason?: Maybe<Scalars['String']['output']>;
  dueAt: Scalars['DateTime']['output'];
  firedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  nodeKey?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ToBringContainerDef = {
  __typename: 'ToBringContainerDef';
  container?: Maybe<ContainerType>;
  containerType: ContainerTypeType;
  ticket: ManageContainerTicketDef;
  wasteFraction: WasteFractionType;
};

/** An enumeration. */
export enum ToiletType {
  BOTH = 'BOTH',
  DRY_TOILET = 'DRY_TOILET',
  WATER_TOILET = 'WATER_TOILET'
}

/**
 * HSY-251: one post-hand-over to-do. ``token`` is a stable string key
 * (graphene-2 convention: string tokens, not enums — see
 * HolidayShiftDecisionAction): ENTER_CONTRACTOR_PRICES,
 * SET_BONUS_PENALTY_MODEL, SCHEME_NEEDS_MANUAL_SPLIT,
 * ROUTE_NEEDS_MANUAL_REDISPATCH, OPEN_SETTLEMENT_PERIOD_AFTER_CUTOFF.
 * ``text`` is the human sentence; ``subjectId`` / ``subjectName`` point at
 * the row the item is about when there is one.
 */
export type TransferChecklistItemDef = {
  __typename: 'TransferChecklistItemDef';
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectName?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

/**
 * Office-only, audited (D10): end a contract area at a cutoff date and
 * hand it over to a successor.
 *
 * Cutoff semantics (documented decision): ``cutoffDate`` is the LAST day
 * the outgoing contractor works — it becomes the old area's ``validTo``;
 * the successor takes over from the DAY AFTER (``validFrom = cutoff + 1``
 * for a created successor; an existing successor must already be valid on
 * that day). From the cutoff, newly generated tasks stamp the successor
 * area, and already-generated future routes of the outgoing contractor
 * are re-pointed to the successor's contractor (each move writes its own
 * RouteHaulerReassignmentLog). History is never rewritten.
 */
export type TransferContractArea = {
  __typename: 'TransferContractArea';
  /** Route schemes that generated the routes above, still point at the outgoing contractor and were NOT moved (see movedSchemes): re-point or end them, or they keep generating routes under the old contractor. */
  affectedSchemes?: Maybe<Array<RouteSchemeType>>;
  /** Future routes of the outgoing contractor carrying SOME stops of the transferred area but not unanimously — left untouched for manual re-dispatch. */
  ambiguousRoutes?: Maybe<Array<RouteType>>;
  /** The closed (old) area. */
  area?: Maybe<AreaDef>;
  /** HSY-251 (review F2): live carve-outs of the area that move under the successor together with the properties. */
  carveOutsReparented: Scalars['Int']['output'];
  /** HSY-251: what the office still owns after the hand-over, and what lands automatically on the hand-over day. Nothing contract-priced is copied — the new contractor's prices, bonus & penalty model and execution windows are entered separately — plus the property move, scheme switches, schemes to split or review, routes to re-dispatch and open settlement periods of the old award for months after the cutoff. */
  checklist: Array<TransferChecklistItemDef>;
  /** HSY-251: route schemes of the outgoing contractor whose containers all sit in areas going to the successor's contractor — switched to that contractor from the day after the cutoff (routes generated for days from the hand-over carry the new contractor). */
  movedSchemes?: Maybe<Array<RouteSchemeType>>;
  movedSchemesCount: Scalars['Int']['output'];
  /** True when the property move already ran. */
  propertiesRepointApplied: Scalars['Boolean']['output'];
  /** The day the properties move (cutoff + 1). */
  propertiesRepointOn?: Maybe<Scalars['Date']['output']>;
  /** HSY-251: how many of the area's properties follow the award to the successor (Property.area) — moved now when the hand-over day has passed, otherwise on that day by the nightly sweep. */
  propertiesRepointed: Scalars['Int']['output'];
  /** Future routes re-pointed to the successor's contractor (scheduled after the cutoff, not started, stops unanimously in the transferred area). */
  reassignedRoutes?: Maybe<Array<RouteType>>;
  reassignedRoutesCount: Scalars['Int']['output'];
  /** HSY-251: route schemes that ALSO serve areas staying with the outgoing contractor — left untouched; each is a SCHEME_NEEDS_MANUAL_SPLIT checklist item. */
  splitSchemes?: Maybe<Array<RouteSchemeType>>;
  successor?: Maybe<AreaDef>;
  successorCreated: Scalars['Boolean']['output'];
  /** HSY-251: route schemes of the outgoing contractor with no containers or planned stops in any contract area — scope undetermined, left untouched; each is a SCHEME_SCOPE_UNDETERMINED checklist item. */
  undeterminedSchemes?: Maybe<Array<RouteSchemeType>>;
};

export type TransferDocumentEventType = Node & {
  __typename: 'TransferDocumentEventType';
  actor?: Maybe<Scalars['GenericScalar']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  eventType: CrmTransferDocumentEventEventTypeChoices;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  modifiedData?: Maybe<Scalars['GenericScalar']['output']>;
};

/** The live holder link, without the secret. */
export type TransferDocumentHolderLinkType = {
  __typename: 'TransferDocumentHolderLinkType';
  channel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TransferDocumentSignatureType = Node & {
  __typename: 'TransferDocumentSignatureType';
  actorKind: CrmTransferDocumentSignatureActorKindChoices;
  displayName: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  invalidatedAt?: Maybe<Scalars['DateTime']['output']>;
  invalidatedReason: Scalars['String']['output'];
  role: CrmTransferDocumentSignatureRoleChoices;
  signedAt: Scalars['DateTime']['output'];
  signingRound: Scalars['Int']['output'];
};

/** An enumeration. */
export enum TransferDocumentStatus {
  CANCELLED = 'CANCELLED',
  COMPLETE = 'COMPLETE',
  OPEN = 'OPEN',
  SIGNED = 'SIGNED'
}

/**
 * One transfer document. ``data`` / ``prefill`` / ``access`` are opaque
 * snake_case JSON blobs — the same shape for every client.
 */
export type TransferDocumentType = Node & {
  __typename: 'TransferDocumentType';
  /** For the CALLER: {can_view, can_edit, editable_fields, signable_roles, roles, missing_by_role}. Clients render from this and never re-derive it. */
  access?: Maybe<Scalars['GenericScalar']['output']>;
  awaitingHolder?: Maybe<Scalars['Boolean']['output']>;
  cancelReason: Scalars['String']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  completionOverrideReason: Scalars['String']['output'];
  containerId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['GenericScalar']['output']>;
  /** Driver fields complete and driver-signed. */
  driverReady?: Maybe<Scalars['Boolean']['output']>;
  events?: Maybe<Array<Maybe<TransferDocumentEventType>>>;
  /** The static SIIRTO field registry. */
  fieldDefinitions?: Maybe<Scalars['GenericScalar']['output']>;
  fullySignedAt?: Maybe<Scalars['DateTime']['output']>;
  holderContactId?: Maybe<Scalars['ID']['output']>;
  holderLink?: Maybe<TransferDocumentHolderLinkType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  /** Short-lived signed URL of the PDF (10 minutes). */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  pickupOrderId?: Maybe<Scalars['ID']['output']>;
  prefill?: Maybe<Scalars['GenericScalar']['output']>;
  propertyId?: Maybe<Scalars['ID']['output']>;
  registrySubmission?: Maybe<SiirtoRegistrySubmissionType>;
  routeId?: Maybe<Scalars['ID']['output']>;
  signatures?: Maybe<Array<Maybe<TransferDocumentSignatureType>>>;
  signingRound: Scalars['Int']['output'];
  status: CrmTransferDocumentStatusChoices;
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * One transfer document. ``data`` / ``prefill`` / ``access`` are opaque
 * snake_case JSON blobs — the same shape for every client.
 */
export type TransferDocumentTypeSignaturesArgs = {
  includeInvalidated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TransferDocumentTypeConnection = {
  __typename: 'TransferDocumentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TransferDocumentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TransferDocumentType` and its cursor. */
export type TransferDocumentTypeEdge = {
  __typename: 'TransferDocumentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TransferDocumentType>;
};

/**
 * Move N spare parts between warehouses (A1). Lands immediately -
 * spare parts have no in-transit identity.
 */
export type TransferSpareParts = {
  __typename: 'TransferSpareParts';
  status?: Maybe<Scalars['String']['output']>;
};

export type TriggerExport = {
  __typename: 'TriggerExport';
  exportHistory?: Maybe<ExportHistoryDef>;
};

export type TriggerImport = {
  __typename: 'TriggerImport';
  importHistory?: Maybe<ImportHistoryDef>;
};

export type TriggerKindDef = {
  __typename: 'TriggerKindDef';
  configSchema: Scalars['JSONString']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/**
 * Async quick export (PRO-665 / PRO-689).
 *
 * The synchronous ``quickExport`` query built the whole XLSX in the request
 * and returned it base64-inline, which 504s at production volume. This
 * mutation instead persists a template-less ``ExportHistory`` carrying the
 * ad-hoc filters, dispatches it onto the same Celery Jobs pipeline the
 * scheduled/template exports use, and returns the job node — the file is
 * delivered via the in-app Jobs notification + email + download URL.
 *
 * Accepts every quick-export type (``QUICK_EXPORT_TYPES``: Property,
 * Container, Contact, Property-Management-Company); each reads its own
 * filter argument, mirroring the sync ``quickExport`` query. The remaining
 * export types run on the templated path.
 */
export type TriggerQuickExport = {
  __typename: 'TriggerQuickExport';
  exportHistory?: Maybe<ExportHistoryDef>;
};

/** Enqueue a manual full rebuild. Master/staff only (an ops lever). */
export type TriggerSearchReindex = {
  __typename: 'TriggerSearchReindex';
  enqueued: Scalars['Int']['output'];
};

/** Manually trigger a Visma EDI export for the authenticated user's company. */
export type TriggerVismaExport = {
  __typename: 'TriggerVismaExport';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  exportLogId?: Maybe<Scalars['ID']['output']>;
  logId?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  preview?: Maybe<VismaExportPreviewType>;
};

/**
 * One entry in a load's change history (Annex 3.1 §8.4).
 *
 * Backed by the temporal-table trigger, so it also captures writes that
 * fire no Django signals — including ``bulk_update`` paths.
 */
export type TruckloadCorrectionEventDef = Node & {
  __typename: 'TruckloadCorrectionEventDef';
  /** When the change landed. */
  changedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Per changed column, its `$before` and `$after` value. This is what makes a correction traceable rather than merely flagged. */
  changes?: Maybe<Scalars['JSONString']['output']>;
  /** Which kinds of change this entry contains. */
  eventType?: Maybe<Array<Maybe<LoadEventTypesGraphene>>>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  user?: Maybe<UserType>;
};

/**
 * One HSY *kuorma*.
 *
 * The computed fields below are the display rule. The underlying
 * ``*_derived`` / ``*_corrected`` slots remain individually readable on
 * the same node, so nothing a correction overwrote is lost.
 */
export type TruckloadType = Node & {
  __typename: 'TruckloadType';
  /** Load end, corrected value if one was authored. Null while the load is still open. */
  closed?: Maybe<Scalars['DateTime']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  closedAtCorrected?: Maybe<Scalars['DateTime']['output']>;
  /** The confirmed station stop that closed this load (HSY req 34). The station stop is not a member of the load — it is where the load ended — so the link lives here, not on PickUpOrder.load. NULL for a load closed without a station stop. */
  closingStop?: Maybe<PickUpOrderType>;
  /** Tenant wall, consistent with every other read surface */
  company: CompanyType;
  correctedAt?: Maybe<Scalars['DateTime']['output']>;
  correctedBy?: Maybe<UserType>;
  /** Annex 3.1 §8.4's traceable change history: what changed, from what, to what, by whom and when. Empty on a load that has never been corrected — never a fabricated entry. */
  correctionHistory?: Maybe<Array<Maybe<TruckloadCorrectionEventDef>>>;
  createdAt: Scalars['DateTime']['output'];
  /** Driver, corrected value if one was authored; else the driver of the session that opened the load. Null when neither is known. */
  driver?: Maybe<DriverType>;
  /** The driver who really drove the load. */
  driverCorrected?: Maybe<DriverType>;
  /** The driver of the session that opened the load. */
  driverDerived?: Maybe<DriverType>;
  /** The load ID to show. `number` remains the identity the weighbridge was pre-notified with and stays readable beside this, so a corrected ID never destroys the one mScales resolves an inbound weighing by. */
  effectiveNumber: Scalars['Int']['output'];
  /** Service provider, corrected value if one was authored. This is also the axis a contractor account is scoped on. */
  hauler?: Maybe<HaulerDef>;
  haulerCorrected?: Maybe<HaulerDef>;
  /** Service provider, resolved from the member stops */
  haulerDerived?: Maybe<HaulerDef>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Annex 3.1 §8.4's retrospective-correction flag. False on a load that has never been corrected. */
  isCorrected: Scalars['Boolean']['output'];
  /** Kilometres driven, corrected value if one was authored. Null means not recorded (a backfilled load, or GPS already aged out) — never 0 and never an estimate. */
  km?: Maybe<Scalars['Float']['output']>;
  kmCorrected?: Maybe<Scalars['Float']['output']>;
  /** Kilometres from GPS breadcrumb deltas, computed once at CLOSE and stored because the trail is downsampled and deleted (live_ops/retention.py). NULL = not recorded, never an estimate. */
  kmDerived?: Maybe<Scalars['Float']['output']>;
  /** The load this stop's container was emptied into. NULL when the stop is not completed, or was reset (see reset_completed). */
  memberStops: PickUpOrderTypeConnection;
  /** Annex 3.1 §8.4 free-text, e.g. the actual load identifier when ours is wrong and the real one belongs elsewhere. */
  note: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  /** The actual load ID when ours is wrong (Annex 3.1 §8.4's identification error). Never reuses another load's number in the same series, including a cancelled load's retired one. */
  numberCorrected?: Maybe<Scalars['Int']['output']>;
  /** Load start, corrected value if one was authored. */
  opened?: Maybe<Scalars['DateTime']['output']>;
  openedAt: Scalars['DateTime']['output'];
  openedAtCorrected?: Maybe<Scalars['DateTime']['output']>;
  /** Which fields THIS caller may correct on THIS load, so the UI can hide what it cannot save. Advisory only — the server refuses a denied field regardless of what the UI shows. */
  permittedCorrectionFields: Array<Maybe<Scalars['String']['output']>>;
  status: RoutesLoadStatusChoices;
  /** Reported accuracy radius of that fix, metres. */
  unloadingGpsAccuracyM?: Maybe<Scalars['Float']['output']>;
  /** When the device took that fix (not the sync time). */
  unloadingGpsCapturedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Receiving facility, corrected value if one was authored. Null while the load is open and nothing was corrected. */
  unloadingLocation?: Maybe<DepotType>;
  /** The waste station the load was really tipped at. */
  unloadingLocationCorrected?: Maybe<DepotType>;
  /** The facility recorded at CLOSE, before any correction. */
  unloadingLocationDerived?: Maybe<DepotType>;
  /** Device position recorded when the closing station stop was confirmed. NULL = not recorded. */
  unloadingPoint?: Maybe<Scalars['GeoJSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Vehicle, corrected value if one was authored. The vehicle the load was opened on stays the anchor and is `vehicleDerived`. */
  vehicle: VehicleType;
  /** The vehicle that really carried the load. */
  vehicleCorrected?: Maybe<VehicleType>;
  /** The vehicle the load was opened on, before any correction. */
  vehicleDerived: VehicleType;
  wasteTypeCorrected?: Maybe<WasteFractionType>;
  /** The load's fractions. A corrected waste type asserts ONE true fraction and replaces the derived set; `wasteTypesDerived` stays readable beside it so a multi-fraction load is never silently collapsed. */
  wasteTypes?: Maybe<Array<Maybe<WasteFractionType>>>;
  /** Fractions of the member containers */
  wasteTypesDerived: WasteFractionTypeConnection;
  /** Weighed weight, corrected value if one was authored. Null when nothing was weighed — never 0, which would read as an empty truck. */
  weight?: Maybe<Scalars['Float']['output']>;
  weightCorrected?: Maybe<Scalars['Float']['output']>;
  /** Sum of the member stops' weight. NULL when nothing was weighed — never 0, which would read as an empty truck. */
  weightDerived?: Maybe<Scalars['Float']['output']>;
  year: Scalars['Int']['output'];
};


/**
 * One HSY *kuorma*.
 *
 * The computed fields below are the display rule. The underlying
 * ``*_derived`` / ``*_corrected`` slots remain individually readable on
 * the same node, so nothing a correction overwrote is lost.
 */
export type TruckloadTypeMemberStopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * One HSY *kuorma*.
 *
 * The computed fields below are the display rule. The underlying
 * ``*_derived`` / ``*_corrected`` slots remain individually readable on
 * the same node, so nothing a correction overwrote is lost.
 */
export type TruckloadTypeWasteTypesDerivedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TruckloadTypeConnection = {
  __typename: 'TruckloadTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TruckloadTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TruckloadType` and its cursor. */
export type TruckloadTypeEdge = {
  __typename: 'TruckloadTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TruckloadType>;
};

export type UnconfirmedUserType = Node & {
  __typename: 'UnconfirmedUserType';
  createdAt: Scalars['DateTime']['output'];
  createdUser?: Maybe<UserType>;
  email: Scalars['String']['output'];
  externalCompanyGeoLat?: Maybe<Scalars['Float']['output']>;
  externalCompanyGeoLng?: Maybe<Scalars['Float']['output']>;
  externalCompanyLocation?: Maybe<Scalars['String']['output']>;
  externalCompanyLogo?: Maybe<Scalars['String']['output']>;
  externalCompanyMetricEmployees?: Maybe<Scalars['String']['output']>;
  externalCompanyMetricEstimatedAnnualRevenue?: Maybe<Scalars['String']['output']>;
  externalCrmDealId?: Maybe<Scalars['String']['output']>;
  externalCrmId?: Maybe<Scalars['String']['output']>;
  externalPersonAvatar?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  inviteUsers?: Maybe<Array<Scalars['String']['output']>>;
  ip?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  linkClickedAt?: Maybe<Scalars['DateTime']['output']>;
  metaCompanyName?: Maybe<Scalars['String']['output']>;
  metaCountry?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaFullName?: Maybe<Scalars['String']['output']>;
  metaHowDidYouHearAboutUs: Array<Scalars['String']['output']>;
  metaInterestedHardware: Array<Scalars['String']['output']>;
  metaInterestedSoftware: Array<Scalars['String']['output']>;
  metaJobTitle?: Maybe<Scalars['String']['output']>;
  metaNumberOfEmployees?: Maybe<Scalars['String']['output']>;
  metaPhoneNumber?: Maybe<Scalars['String']['output']>;
  metaSegment?: Maybe<Scalars['String']['output']>;
};

export type UnconfirmedUserTypeConnection = {
  __typename: 'UnconfirmedUserTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UnconfirmedUserTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `UnconfirmedUserType` and its cursor. */
export type UnconfirmedUserTypeEdge = {
  __typename: 'UnconfirmedUserTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UnconfirmedUserType>;
};

/**
 * Reverse `KillAutopilotFlow`: clears `Flow.killed`, restoring this
 * flow's eligibility to be matched/fired (if `live`) and to be promoted
 * or activated again -- writes a mandatory-reason
 * `FlowAuditLogEntry(action=RESTORED)` (CLAUDE.md rule 5) so the audit
 * trail shows who un-killed it, when, and why, exactly as it does for the
 * kill itself.
 *
 * Wave 2 Lane D S3: un-killing a LIVE flow is a re-entry to firing, so it
 * carries the same supersession conflict gate as the two activation
 * routes. Kill resumed the source rule; if that rule is not GREEN, or the
 * flow's current trigger has drifted since (a new version committed or a
 * rollback while killed), the GREEN-only re-suspend below would silently
 * leave the rule AND the flow both firing (BOTH-fire) -- refused unless
 * the operator confirms via `disable_source_rule`, exactly like
 * `ActivateAutopilotFlow`. The refusal leaves the flow KILLED (nothing is
 * written).
 */
export type UnkillAutopilotFlow = {
  __typename: 'UnkillAutopilotFlow';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  flow?: Maybe<FlowType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UnlinkContactFromProperty = {
  __typename: 'UnlinkContactFromProperty';
  contactProperty?: Maybe<ContactPropertyDef>;
};

export type UnlinkContactFromPropertyManagementCompany = {
  __typename: 'UnlinkContactFromPropertyManagementCompany';
  propertyManagementCompany?: Maybe<PropertyManagementCompanyDef>;
};

export type UnlinkManagementCompanyFromProperty = {
  __typename: 'UnlinkManagementCompanyFromProperty';
  managementCompanyProperty?: Maybe<ManagementCompanyPropertyDef>;
};

/**
 * Clear ``parent_property`` on a property (NEXUS-262).
 *
 * Mirrors asset-services ``DELETE /v1/properties/{id}/parent``: a
 * dedicated mutation because ``UpdateOrCreateProperty`` cannot distinguish
 * "field omitted" from "field set to null" in the form input.
 */
export type UnlinkParentProperty = {
  __typename: 'UnlinkParentProperty';
  property?: Maybe<PropertyDef>;
};

/**
 * Unlink a shared-tank member. Non-destructive: ends the membership row
 * (status ENDED + end_date) — never deletes it or the property/survey
 * (mirrors EndScpMembership).
 */
export type UnlinkSharedTankMember = {
  __typename: 'UnlinkSharedTankMember';
  membership?: Maybe<SharedTankMembershipDef>;
};

export type UnpairFillLevelDevice = {
  __typename: 'UnpairFillLevelDevice';
  fillLevelDevice?: Maybe<BaseDeviceInterface>;
};

/**
 * Remove an Account's price-list pin — its orders fall back to the
 * standard pool/catalog resolution. Idempotent: unpinning a pin-less
 * account simply answers unpinned=false.
 */
export type UnpinAccountPriceList = {
  __typename: 'UnpinAccountPriceList';
  unpinned?: Maybe<Scalars['Boolean']['output']>;
};

export type UnsubscribeInsightsDigest = {
  __typename: 'UnsubscribeInsightsDigest';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/**
 * Unsubscribe a property from an access-fee SCP (NEXUS-556).
 *
 * Ends the membership (delegating to the shared end + redistribution service)
 * and recomputes the property's register basis (``NONE``/non-compliant when no
 * other active membership remains).
 */
export type UnsubscribePropertyFromScp = {
  __typename: 'UnsubscribePropertyFromScp';
  scpMembership?: Maybe<ScpMembershipDef>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/**
 * One upcoming holiday with its impacted-item count — the
 * HolidaySelector's data source (B5).
 */
export type UpcomingHolidayDef = {
  __typename: 'UpcomingHolidayDef';
  date: Scalars['Date']['output'];
  impactedCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UpdateActiveProjects = {
  __typename: 'UpdateActiveProjects';
  status?: Maybe<Scalars['String']['output']>;
};

export type UpdateAgreementInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coefficient?: InputMaybe<Scalars['Float']['input']>;
  /** First day of a month, not after today, from which a changed coefficient, quantity or end date applies to periods that were already invoiced. The affected months are reversed and re-booked on the customer's next invoice. Leave empty for an ordinary edit. */
  effectiveFrom?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optimistic-concurrency stamp (REQ 3.12.5): the Agreement.version the client loaded. Stale -> STALE_VERSION refusal per the rollout phase. */
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  hauler?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  industry?: InputMaybe<Scalars['ID']['input']>;
  industrySpecify?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  serviceResponsibility?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateAgreementPayload = {
  __typename: 'UpdateAgreementPayload';
  agreement?: Maybe<AgreementDef>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/**
 * ``data_type`` is deliberately immutable: rows the rule already
 * archived carry ``archived_by_rule=rule`` in the OLD type's table, and a
 * type change would silently orphan them from the retention sweep
 * (``retention_expired_queryset`` only looks at the current type). A type
 * change is delete + recreate.
 */
export type UpdateArchivalRule = {
  __typename: 'UpdateArchivalRule';
  archivalRule?: Maybe<ArchivalRuleDef>;
};

export type UpdateAutomationMetaPayload = {
  __typename: 'UpdateAutomationMetaPayload';
  automation: AutomationDef;
};

/**
 * Edit the tenant's assumption set by creating a NEW version --
 * history is never mutated, so frozen projections keep the exact rows
 * they pinned. RBAC: ``automation__edit`` via the same
 * ``CompanyRolePermission.check_permission`` contract every autopilot
 * write uses. Audited by construction: the created row is immutable and
 * records actor + timestamp, and the previous version's row IS the
 * before-state.
 */
export type UpdateAutopilotAssumptions = {
  __typename: 'UpdateAutopilotAssumptions';
  assumptionSet?: Maybe<AutopilotAssumptionSetType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Validate and save the next definition for a draft Flow.
 *
 * Runs the registry-aware validator (`autopilot.builder.validator`, which
 * itself runs the AP-301 structural validator first) before writing
 * anything: an invalid definition creates no `FlowVersion` row at all, and
 * every violation found (structural and registry) comes back as one
 * `errors` entry per violation, each carrying its JSON-path location
 * (`FlowSchemaViolation.render()`) so the builder can point at the exact
 * step. Non-fatal autonomy-class advisories (money/mass_comms/bulk steps)
 * come back in `warnings` and never block the save.
 *
 * Only a `draft`-state flow may be edited this way; a `test` or `live`
 * flow must be demoted back to `draft` first (a separate concern from
 * this mutation, see `PromoteAutopilotFlow`).
 */
export type UpdateAutopilotFlowDefinition = {
  __typename: 'UpdateAutopilotFlowDefinition';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  flow?: Maybe<FlowType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type UpdateBillingInformation = {
  __typename: 'UpdateBillingInformation';
  billingInformation?: Maybe<BillingInformationType>;
};

/**
 * Office-only: edit a bonus model (D7). ``areaId`` / ``haulerId``
 * re-scope it (REQ 3.3.22/3.5.57): send ``areaId: null`` to drop the area
 * scope, ``haulerId`` for a contractor default, both null for
 * company-wide; omit an axis to leave it unchanged.
 *
 * Additive sibling of ``updateBonusModel`` (which stays scope-free for
 * non-breaking master compatibility).
 */
export type UpdateBonusModelScoped = {
  __typename: 'UpdateBonusModelScoped';
  bonusModel?: Maybe<BonusModelType>;
};

export type UpdateBulkWastePickupTicketInput = {
  addAttachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<TicketCustomFieldValueInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optimistic-concurrency stamp (REQ 3.12.5): the Ticket.version the client loaded. Stale -> STALE_VERSION refusal per the rollout phase. */
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  /** Deprecated: Send empty serviceProducts instead */
  ignoreServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<InputMaybe<BulkWastePickupTicketItemInput>>;
  location?: InputMaybe<Scalars['ID']['input']>;
  preferredDate?: InputMaybe<Scalars['Date']['input']>;
  priority: Scalars['String']['input'];
  removeAttachmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routeDescription?: InputMaybe<Scalars['String']['input']>;
  serviceProducts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdateBulkWastePickupTicketPayload = {
  __typename: 'UpdateBulkWastePickupTicketPayload';
  bulkWastePickupTicket?: Maybe<TicketDef>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/** Edit the caller's company include-list. Gated by ``company_settings__edit``. */
export type UpdateCompanySearchSettings = {
  __typename: 'UpdateCompanySearchSettings';
  settings: Array<CompanySearchEntitySetting>;
};

export type UpdateComparisonSettingsMutationInput = {
  amountOfCollection?: InputMaybe<Scalars['Int']['input']>;
  amountOfCollectionPeriod?: InputMaybe<Scalars['String']['input']>;
  averageFillLevel?: InputMaybe<Scalars['Float']['input']>;
  chanceOfOverflowing?: InputMaybe<Scalars['Float']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cost per collection */
  collectionCost: Scalars['Float']['input'];
  /** Cost per tonne */
  costPerTonne?: InputMaybe<Scalars['Float']['input']>;
  costSettings: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Income per collection */
  incomePerTonne?: InputMaybe<Scalars['Float']['input']>;
  /** Cost per overflowing collection */
  overflowingCost?: InputMaybe<Scalars['Float']['input']>;
  /** kg for m^3 */
  weightFactor?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateComparisonSettingsMutationPayload = {
  __typename: 'UpdateComparisonSettingsMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  comparisonSettings?: Maybe<ComparisonSettingsType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/** Edit the template's own attributes (not its sections or fields). */
export type UpdateCompostingNotificationTemplate = {
  __typename: 'UpdateCompostingNotificationTemplate';
  compostingNotificationTemplate?: Maybe<CompostingNotificationTemplateDef>;
};

/**
 * Correct the maintainable fields of a register row.
 *
 * Only the fields the office owns. ``notification_date`` is not among them:
 * it anchors the five-year statutory clock and is the server's record of when
 * the authority received the notification. Neither is ``inspection_*`` (that
 * is ``RecordCompostingInspection``) nor ``end_date`` (that is
 * ``EndCompostingRegistryEntry``, which is server-dated).
 *
 * Partial update: an argument that was not sent is left alone, which is why
 * the body reads ``kwargs`` rather than defaulting everything to ``None``.
 * Clearing ``notes`` by sending ``""`` and not touching it at all are
 * different requests.
 */
export type UpdateCompostingRegistryEntry = {
  __typename: 'UpdateCompostingRegistryEntry';
  compostingRegistryEntry?: Maybe<CompostingRegistryEntryDef>;
};

export type UpdateContact = {
  __typename: 'UpdateContact';
  contact?: Maybe<ContactDef>;
};

export type UpdateContactAddress = {
  __typename: 'UpdateContactAddress';
  address?: Maybe<ContactAddressDef>;
};

export type UpdateContactAuthorizationInput = {
  authorizationMethod?: InputMaybe<Scalars['ID']['input']>;
  /** External reference number for this authorization */
  authorizationReference?: InputMaybe<Scalars['String']['input']>;
  authorizationType?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When the authorization ends (null for open-ended) */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional signed mandate document (PDF/image, ≤ 5 MB) */
  mandateDocument?: InputMaybe<Scalars['String']['input']>;
  /** When the authorization becomes effective */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateContactAuthorizationPayload = {
  __typename: 'UpdateContactAuthorizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contactAuthorization?: Maybe<ContactAuthorizationDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/**
 * Staff dual-write of a Contact's comms-channel preferences.
 *
 * Writes the SAME store as the portal REST ``PATCH comms/channels`` by
 * delegating to ``crm.services.portal_comms`` — one store, two surfaces.
 */
export type UpdateContactCommsChannels = {
  __typename: 'UpdateContactCommsChannels';
  commsChannels?: Maybe<CommsChannelsDef>;
};

export type UpdateContactFieldConfiguration = {
  __typename: 'UpdateContactFieldConfiguration';
  contactFieldConfiguration: ContactFieldConfigurationDef;
};

export type UpdateContactInput = {
  additionalServicesSalesBan?: InputMaybe<Scalars['Boolean']['input']>;
  additionalServicesSalesBanReason?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addresses?: InputMaybe<Array<InputMaybe<ContactAddressInput>>>;
  authorityFeeDecision?: InputMaybe<Scalars['String']['input']>;
  authorityFeeDecisionDate?: InputMaybe<Scalars['Date']['input']>;
  bundling?: InputMaybe<Scalars['String']['input']>;
  coName?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<ContactType>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerFunctionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  defaultBillingFrequencyCode?: InputMaybe<Scalars['String']['input']>;
  defaultServiceResponsibilityId?: InputMaybe<Scalars['ID']['input']>;
  effectiveFrom?: InputMaybe<Scalars['Date']['input']>;
  effectiveTo?: InputMaybe<Scalars['Date']['input']>;
  einvoiceAddress?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  externalContactId?: InputMaybe<Scalars['String']['input']>;
  hasNonDisclosureRestriction?: InputMaybe<Scalars['Boolean']['input']>;
  industryCode?: InputMaybe<Scalars['String']['input']>;
  industrySpecify?: InputMaybe<Scalars['String']['input']>;
  invoiceDeliveryMethod?: InputMaybe<Scalars['String']['input']>;
  invoiceLanguage?: InputMaybe<Scalars['String']['input']>;
  invoiceReference?: InputMaybe<Scalars['String']['input']>;
  invoiceTemplateCode?: InputMaybe<Scalars['String']['input']>;
  issuingCountry?: InputMaybe<Scalars['String']['input']>;
  marketingOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ndrReason?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeName?: InputMaybe<Scalars['String']['input']>;
  pricingMode?: InputMaybe<Scalars['String']['input']>;
  reverseChargeVat?: InputMaybe<Scalars['Boolean']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Update the Client ID on an existing contact-property link. */
export type UpdateContactProperty = {
  __typename: 'UpdateContactProperty';
  contactProperty?: Maybe<ContactPropertyDef>;
};

export type UpdateContainer = {
  __typename: 'UpdateContainer';
  container?: Maybe<ContainerType>;
};

export type UpdateContainerMobile = {
  __typename: 'UpdateContainerMobile';
  container?: Maybe<ContainerType>;
};

/**
 * PRO-755: the missing Edit action on a subscription row — change
 * Days-before (any row) and the phone/email (manual rows, or overriding a
 * single auto row). Editing the value of a row whose method is SHARED with
 * other rows clones the method first, so siblings are untouched.
 */
export type UpdateContainerNotification = {
  __typename: 'UpdateContainerNotification';
  containerNotification?: Maybe<ContainerNotificationDef>;
};

export type UpdateContainerPriceInput = {
  amount: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** If true, then soft-delete the price, ignoring the rest of the input */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  invoiceName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateContainerPricePayload = {
  __typename: 'UpdateContainerPricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  containerPrice?: Maybe<ContainerPriceDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateContainerType = {
  __typename: 'UpdateContainerType';
  containerType?: Maybe<ContainerTypeType>;
};

/**
 * Edit a cost model. KPI recompute on change is explicit (a new
 * plan run); existing plans are never mutated (RS-205 AC): their
 * kpis keep the SBX-371 stamp of the book they were priced with,
 * only NEW solves resolve the changed rates.
 *
 * SBX-362 (D32/D45): master-gated, tenant-scoped; a rate edit flips
 * the source label to ``tenant_set`` with updated_by/updated_at and
 * emits route_studio.cost_model.updated with old and new values per
 * changed field (temporal versioning keeps the full row history).
 */
export type UpdateCostModelMutation = {
  __typename: 'UpdateCostModelMutation';
  costModel?: Maybe<CostModelDef>;
};

export type UpdateCostSettingsMutationInput = {
  amountOfCollection?: InputMaybe<Scalars['Int']['input']>;
  amountOfCollectionPeriod?: InputMaybe<Scalars['String']['input']>;
  averageFillLevel?: InputMaybe<Scalars['Float']['input']>;
  chanceOfOverflowing?: InputMaybe<Scalars['Float']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cost per collection */
  collectionCost: Scalars['Float']['input'];
  containerType: Scalars['ID']['input'];
  /** Cost per tonne */
  costPerTonne?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Income per collection */
  incomePerTonne?: InputMaybe<Scalars['Float']['input']>;
  /** Cost per overflowing collection */
  overflowingCost?: InputMaybe<Scalars['Float']['input']>;
  ownValues?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
  wasteFraction: Scalars['ID']['input'];
  /** kg for m^3 */
  weightFactor?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCostSettingsMutationPayload = {
  __typename: 'UpdateCostSettingsMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  costSettings?: Maybe<CostSettingsType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateCurrentDriverLocation = {
  __typename: 'UpdateCurrentDriverLocation';
  driver?: Maybe<DriverType>;
  route?: Maybe<RouteType>;
};

export type UpdateCustomerNoteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The note content */
  content: Scalars['String']['input'];
  /** End of visibility period (required for scheduled notes) */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Start of visibility period (required for scheduled notes) */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  visibilityLevels: Array<InputMaybe<Scalars['String']['input']>>;
};

export type UpdateCustomerNotePayload = {
  __typename: 'UpdateCustomerNotePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerNote?: Maybe<CustomerNoteDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/**
 * Review a claim: confirm, correct, or reject (stage C).
 * Corrections re-derive downstream artifacts, never retrain
 * silently.
 */
export type UpdateGrammarClaimMutation = {
  __typename: 'UpdateGrammarClaimMutation';
  grammarClaim?: Maybe<GrammarClaimDef>;
};

/** Office-only: edit a compliance document (PRO-99). */
export type UpdateHaulerComplianceDocument = {
  __typename: 'UpdateHaulerComplianceDocument';
  document?: Maybe<HaulerComplianceDocumentDef>;
};

/** A contractor manager edits their own hauler's contact fields (D17). */
export type UpdateHaulerContact = {
  __typename: 'UpdateHaulerContact';
  hauler?: Maybe<HaulerDef>;
};

/**
 * Patch a price list (RD-46). Wraps
 * ``product.price_lists.service.update_price_list`` for
 * name/description/status (reusing its status validation), then patches
 * the hauler layer's validity window, inheritance and minimumCharge as
 * plain data. Only the supplied fields change.
 */
export type UpdateHaulerPriceList = {
  __typename: 'UpdateHaulerPriceList';
  priceList?: Maybe<HaulerPriceListDef>;
};

/**
 * Patch a price row (RD-46). Wraps
 * ``product.price_rows.service.update_price_row`` — a price change writes
 * the engine's history snapshot; tuple-field changes re-run its
 * uniqueness check. ``minimumCharge`` is patched as plain data. Only the
 * supplied fields change (true PATCH).
 */
export type UpdateHaulerPriceRow = {
  __typename: 'UpdateHaulerPriceRow';
  priceRow?: Maybe<HaulerPriceRowDef>;
};

/** Case lifecycle (RS-E20): rename, complete, archive, reopen. */
export type UpdateImportCaseMutation = {
  __typename: 'UpdateImportCaseMutation';
  importCase?: Maybe<ImportCaseDef>;
};

/** Update automatic export generation settings for KMD Easy integration */
export type UpdateKmdEasyAutoExportSettings = {
  __typename: 'UpdateKmdEasyAutoExportSettings';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  kmdEasyCompanySettings?: Maybe<KmdEasyCompanySettingsDef>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Update all KMD Easy configuration settings for a company */
export type UpdateKmdEasySettings = {
  __typename: 'UpdateKmdEasySettings';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  kmdEasyCompanySettings?: Maybe<KmdEasyCompanySettingsDef>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateManageContainerTicketInput = {
  addAttachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  collectionCalendar?: InputMaybe<Scalars['ID']['input']>;
  containerDestination?: InputMaybe<ContainerStorageLocationInput>;
  containerProduct?: InputMaybe<Scalars['ID']['input']>;
  containerSource?: InputMaybe<ContainerStorageLocationInput>;
  containerToAdd?: InputMaybe<Scalars['ID']['input']>;
  containerType?: InputMaybe<Scalars['ID']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<TicketCustomFieldValueInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optimistic-concurrency stamp (REQ 3.12.5): the Ticket.version the client loaded. Stale -> STALE_VERSION refusal per the rollout phase. */
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  /** Deprecated: Send empty serviceProducts instead */
  ignoreServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  newContainerId?: InputMaybe<Scalars['String']['input']>;
  onPublicRoad?: InputMaybe<Scalars['Boolean']['input']>;
  originalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  periodEndDate?: InputMaybe<Scalars['Date']['input']>;
  periodStartDate?: InputMaybe<Scalars['Date']['input']>;
  pickupSetting?: InputMaybe<Scalars['ID']['input']>;
  ppContainerProductId?: InputMaybe<Scalars['String']['input']>;
  ppOriginalWeight?: InputMaybe<Scalars['Decimal']['input']>;
  ppWeight?: InputMaybe<Scalars['Decimal']['input']>;
  ppWeightOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  preferredDate?: InputMaybe<Scalars['Date']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priority: Scalars['String']['input'];
  removeAttachmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The portal login who asked for the ticket (PropertyUserDef id, same company, linked to the ticket's property). Null clears it; setting it clears requestedByOther. */
  requestedBy?: InputMaybe<Scalars['ID']['input']>;
  /** The customer's contact person who asked for the ticket (ContactDef id, same company). Null clears it. */
  requestedByContactId?: InputMaybe<Scalars['ID']['input']>;
  /** Free-text requester (someone on site). Null or empty clears it; setting it clears requestedBy. */
  requestedByOther?: InputMaybe<Scalars['String']['input']>;
  routeDescription?: InputMaybe<Scalars['String']['input']>;
  routeScheme?: InputMaybe<Scalars['ID']['input']>;
  serviceProducts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wasteFraction?: InputMaybe<Scalars['ID']['input']>;
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdateManageContainerTicketPayload = {
  __typename: 'UpdateManageContainerTicketPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  manageContainerTicket?: Maybe<TicketDef>;
};

/** Update the Client ID on an existing company-property link. */
export type UpdateManagementCompanyProperty = {
  __typename: 'UpdateManagementCompanyProperty';
  managementCompanyProperty?: Maybe<ManagementCompanyPropertyDef>;
};

export type UpdateMeasurementSettings = {
  __typename: 'UpdateMeasurementSettings';
  measurementSettings?: Maybe<MeasurementSettingsType>;
};

export type UpdateNotificationSetting = {
  __typename: 'UpdateNotificationSetting';
  notificationSetting?: Maybe<NotificationSettingsType>;
};

export type UpdateOrCreateContainerIdGeneratorInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyDisplayOption: Scalars['String']['input'];
  componentsOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  containerTypeDisplayOption: Scalars['String']['input'];
  incrementFrom: Scalars['Int']['input'];
  lastNumber: Scalars['Int']['input'];
  pickupSettingsDisplayOption: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
  separator: Scalars['String']['input'];
  wasteFractionDisplayOption: Scalars['String']['input'];
};

export type UpdateOrCreateContainerIdGeneratorPayload = {
  __typename: 'UpdateORCreateContainerIDGeneratorPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  containerIDGeneratorSettings?: Maybe<ContainerIdGeneratorSettingsDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateAgreementTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optimistic-concurrency stamp (REQ 3.12.5): the AgreementTemplate.version the client loaded. Stale -> STALE_VERSION refusal per the rollout phase. */
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  products: Array<InputMaybe<AgreementTemplateProductMultipleChoiceFieldInput>>;
  propertyType: Scalars['ID']['input'];
};

export type UpdateOrCreateAgreementTemplatePayload = {
  __typename: 'UpdateOrCreateAgreementTemplatePayload';
  agreementTemplate?: Maybe<AgreementTemplateDef>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateAlertRuleInput = {
  alertRecipients?: InputMaybe<Array<InputMaybe<AlertRuleAlertRecipientMultipleChoiceFieldInput>>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  containerTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  intervalType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  percentageThreshold: Scalars['Float']['input'];
  wasteFractions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdateOrCreateAlertRulePayload = {
  __typename: 'UpdateOrCreateAlertRulePayload';
  alertRule?: Maybe<AlertRuleDef>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateAreaInput = {
  /** This contract area covers ALL container types, including ones created in the future. When True the container_types M2M is ignored (the explicit 'All incl. future' choice); when False the area covers only the container types listed in the M2M. */
  allContainerTypes?: InputMaybe<Scalars['Boolean']['input']>;
  /** This contract area covers ALL waste fractions, including ones created in the future. When True the waste_fractions M2M is ignored (the explicit 'All incl. future' choice); when False the area covers only the fractions listed in the M2M. */
  allWasteFractions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attach new agreements matching this area's scope automatically while the area is in force. */
  autoAttachAgreements?: InputMaybe<Scalars['Boolean']['input']>;
  carveOutOfId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Completion radius (meters) for stops in this contract area. Governs both auto-completion and how close a driver must be to mark a stop done manually. Empty = no manual-completion distance limit; auto-completion uses the route scheme's distance / the default. */
  completionRadiusMeters?: InputMaybe<Scalars['Int']['input']>;
  containerTypes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Date the contract was signed (office-entered). */
  contractSignedDate?: InputMaybe<Scalars['Date']['input']>;
  defaultCostCentre?: InputMaybe<Scalars['ID']['input']>;
  excludedProducts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Months before the end date at which the area counts as Expiring. Empty = the platform default (12). */
  expiringLeadMonths?: InputMaybe<Scalars['Int']['input']>;
  hauler?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  /** Office-internal notes. Never exposed to contractor users. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Key contractual obligations (office-internal — the baseline the KPIs are read against). Never exposed to contractor users. */
  obligations?: InputMaybe<Scalars['String']['input']>;
  /** Payment terms of this contract, in days (e.g. 21). Numeric on purpose: the hauler-level free-text payment_terms stays the vendor-card default; this is the per-contract term. */
  paymentTermsDays?: InputMaybe<Scalars['Int']['input']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Contract reference (office-entered). */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Contract-area validity start. Required on write when a hauler is assigned; stays NULL on legacy areas. */
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Contract-area validity end. NULL = open-ended. */
  validTo?: InputMaybe<Scalars['Date']['input']>;
  wasteFractions?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  zones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateOrCreateAreaPayload = {
  __typename: 'UpdateOrCreateAreaPayload';
  area?: Maybe<AreaDef>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateBulkContainerData = {
  collectionCalendarId?: InputMaybe<Scalars['ID']['input']>;
  containerId?: InputMaybe<Scalars['String']['input']>;
  containerTypeId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  deviceToContainerSet?: InputMaybe<Array<InputMaybe<DeviceToContainerInputObject>>>;
  location?: InputMaybe<LocationInput>;
  locationCurb?: InputMaybe<Scalars['Boolean']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  overflowingSettings?: InputMaybe<OverflowingSettingsObject>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  pickupMethod?: InputMaybe<Scalars['String']['input']>;
  pickupSettingId?: InputMaybe<Scalars['ID']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  prioritizeInStartOfRoute?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
  routeDescription?: InputMaybe<Scalars['String']['input']>;
  routeSchemeId?: InputMaybe<Scalars['ID']['input']>;
  sensorFillLevel?: InputMaybe<Scalars['Int']['input']>;
  showOnRoute?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  wasteCollectorId?: InputMaybe<Scalars['ID']['input']>;
  wasteFractionId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOrCreateBulkContainerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOrCreateBulkContainerMutation = {
  __typename: 'UpdateOrCreateBulkContainerMutation';
  containerList?: Maybe<Array<Maybe<ContainerType>>>;
};

export type UpdateOrCreateCollectionCalendarDateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  collectionCalendar: Scalars['ID']['input'];
  collectionDate: Scalars['Date']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOrCreateCollectionCalendarDatePayload = {
  __typename: 'UpdateOrCreateCollectionCalendarDatePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  collectionCalendarDate?: Maybe<CollectionCalendarDateDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateCollectionCalendarDeviationInput = {
  areas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  collectionCalendars: Array<InputMaybe<Scalars['ID']['input']>>;
  containers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  excludedAreas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludedContainers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludedProperties?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludedPropertyGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  existingRoutesAction?: InputMaybe<Scalars['String']['input']>;
  futureCollectionsAction?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  periods: Array<InputMaybe<CollectionCalendarDeviationToPeriodInput>>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routeSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate: Scalars['Date']['input'];
};

export type UpdateOrCreateCollectionCalendarDeviationPayload = {
  __typename: 'UpdateOrCreateCollectionCalendarDeviationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  collectionCalendarDeviation?: Maybe<CollectionCalendarDeviationDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  moveRefusals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  movedRoutes?: Maybe<Scalars['Int']['output']>;
  removedStops?: Maybe<Scalars['Int']['output']>;
};

export type UpdateOrCreateCollectionCalendarInput = {
  allowUsageInCombinedCalendarsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  combinedCollectionCalendars?: InputMaybe<Array<InputMaybe<CollectionCalendarPeriodInput>>>;
  determinePeriodBy?: InputMaybe<Scalars['String']['input']>;
  fromDate: Scalars['Date']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  pickupSettings: Scalars['ID']['input'];
  week: Scalars['ID']['input'];
  weekdays?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateOrCreateCollectionCalendarPayload = {
  __typename: 'UpdateOrCreateCollectionCalendarPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  collectionCalendar?: Maybe<CollectionCalendarDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateCollectionCalendarWeekInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  startWeekNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOrCreateCollectionCalendarWeekPayload = {
  __typename: 'UpdateOrCreateCollectionCalendarWeekPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  collectionCalendarWeek?: Maybe<CollectionCalendarWeekDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/** target_id: ID of Route, Depot, Driver, Vehicle or Container */
export type UpdateOrCreateComment = {
  __typename: 'UpdateOrCreateComment';
  comment?: Maybe<CommentType>;
};

export type UpdateOrCreateCompanyContainerMetaType = {
  __typename: 'UpdateOrCreateCompanyContainerMetaType';
  companyContainerMetaType?: Maybe<CompanyContainerMetaTypeType>;
};

export type UpdateOrCreateCompanyEmailAccountInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOrCreateCompanyEmailAccountPayload = {
  __typename: 'UpdateOrCreateCompanyEmailAccountPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companyEmailAccount?: Maybe<CompanyEmailAccountDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateCompanyEmailAccountRuleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyEmailAccount: Scalars['ID']['input'];
  defaultAssignee?: InputMaybe<Scalars['ID']['input']>;
  defaultProject?: InputMaybe<Scalars['ID']['input']>;
  defaultTicketType?: InputMaybe<Scalars['ID']['input']>;
  emailFilter: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOrCreateCompanyEmailAccountRulePayload = {
  __typename: 'UpdateOrCreateCompanyEmailAccountRulePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companyEmailAccountRule?: Maybe<CompanyEmailAccountRuleDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateCompanyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hex color code */
  color?: InputMaybe<Scalars['String']['input']>;
  dashboardLocationLatitude?: InputMaybe<Scalars['Float']['input']>;
  dashboardLocationLongitude?: InputMaybe<Scalars['Float']['input']>;
  dashboardLocationName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  removeLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrCreateCompanyMainSettingsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 12-hour clock? */
  clockFormat12?: InputMaybe<Scalars['Boolean']['input']>;
  cluster?: InputMaybe<Scalars['Boolean']['input']>;
  country: Scalars['String']['input'];
  crmEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  currency: Scalars['String']['input'];
  dashboardLocation?: InputMaybe<Scalars['ID']['input']>;
  dashboardLocationLatitude?: InputMaybe<Scalars['Float']['input']>;
  dashboardLocationLongitude?: InputMaybe<Scalars['Float']['input']>;
  dashboardLocationName?: InputMaybe<Scalars['String']['input']>;
  drivingDistance: Scalars['String']['input'];
  taxMode?: InputMaybe<Scalars['String']['input']>;
  temperature: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  volume: Scalars['String']['input'];
  weight: Scalars['String']['input'];
};

export type UpdateOrCreateCompanyMainSettingsPayload = {
  __typename: 'UpdateOrCreateCompanyMainSettingsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  settings?: Maybe<SettingsType>;
};

export type UpdateOrCreateCompanyMetaTypeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  copyFrom?: InputMaybe<Scalars['String']['input']>;
  displayOn: Array<MetaTypeDisplayOnType>;
  enableFiltering?: InputMaybe<Scalars['Boolean']['input']>;
  enableSearch?: InputMaybe<Scalars['Boolean']['input']>;
  entity: Scalars['String']['input'];
  helpText?: InputMaybe<Scalars['String']['input']>;
  icon: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  inputType: Scalars['String']['input'];
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  rolesCanEdit?: InputMaybe<Array<Scalars['ID']['input']>>;
  rolesCanView?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateOrCreateCompanyMetaTypePayload = {
  __typename: 'UpdateOrCreateCompanyMetaTypePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companyMetaType?: Maybe<CompanyMetaTypeDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateCompanyPayload = {
  __typename: 'UpdateOrCreateCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateCompanyRole = {
  __typename: 'UpdateOrCreateCompanyRole';
  companyRole?: Maybe<CompanyRoleDef>;
};

/**
 * Create a field in a section, or edit one by id.
 *
 * ``key`` is immutable once set (see the section mutation). The
 * source/binding coherence rules and the visibleWhen grammar are enforced by
 * ``crm.services.composting.validate_field`` inside the transaction, so an
 * invalid edit rolls back instead of going live.
 */
export type UpdateOrCreateCompostingNotificationField = {
  __typename: 'UpdateOrCreateCompostingNotificationField';
  field?: Maybe<CompostingNotificationFieldDef>;
};

/** Create or edit one choice of a SELECT / MULTI_SELECT field. */
export type UpdateOrCreateCompostingNotificationFieldOption = {
  __typename: 'UpdateOrCreateCompostingNotificationFieldOption';
  option?: Maybe<CompostingNotificationFieldOptionDef>;
};

/**
 * Create a section on a template, or edit one by id.
 *
 * ``key`` is immutable once set: it is what ``visibleWhen`` conditions and
 * (later) stored answers reference, so renaming it would silently break every
 * gate pointing at a field inside this section.
 */
export type UpdateOrCreateCompostingNotificationSection = {
  __typename: 'UpdateOrCreateCompostingNotificationSection';
  section?: Maybe<CompostingNotificationSectionDef>;
};

export type UpdateOrCreateContactInput = {
  addContactToProperties?: InputMaybe<Array<InputMaybe<AddContactToPropertyInput>>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactType: Scalars['String']['input'];
  externalContactId?: InputMaybe<Scalars['String']['input']>;
  hasNonDisclosureRestriction?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  otherPhoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uniqueId?: InputMaybe<Scalars['String']['input']>;
  vatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrCreateContactPayload = {
  __typename: 'UpdateOrCreateContactPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/** Use UpdateOrCreateContainerNew instead of UpdateOrCreateContainer */
export type UpdateOrCreateContainer = {
  __typename: 'UpdateOrCreateContainer';
  container?: Maybe<ContainerType>;
};

export type UpdateOrCreateContainerGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  containers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<LocationInput>;
  locationCurb?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  project: Scalars['ID']['input'];
};

export type UpdateOrCreateContainerGroupPayload = {
  __typename: 'UpdateOrCreateContainerGroupPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  containerGroup?: Maybe<ContainerGroupDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateContainerNewInput = {
  /** PresignedUrlHolder ids from obtainAttachmentsDirectUploadUrl (objectToAttachType: CONTAINER_ATTACHMENT), obtained by the calling user, to attach to the container in this save */
  addAttachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  allowedHoursEnd?: InputMaybe<Scalars['Time']['input']>;
  allowedHoursStart?: InputMaybe<Scalars['Time']['input']>;
  /** Custom barcode or container id */
  barcode?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  collectionCalendar?: InputMaybe<Scalars['ID']['input']>;
  containerId: Scalars['String']['input'];
  containerType: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  devicesToContainer?: InputMaybe<Array<InputMaybe<SensorInputObject>>>;
  forcePair?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<LocationInput>;
  locationCurb?: InputMaybe<Scalars['Boolean']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  /** Who owns the physical bin: the company or the customer/member. Empty when unrecorded. */
  ownership?: InputMaybe<Scalars['String']['input']>;
  pickupMethod: Scalars['String']['input'];
  pickupSetting?: InputMaybe<Scalars['ID']['input']>;
  prioritizeInStartOfRoute?: InputMaybe<Scalars['Boolean']['input']>;
  project: Scalars['ID']['input'];
  /** ContainerAttachmentDef ids to detach from the container in this save */
  removeAttachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  rfid?: InputMaybe<Scalars['String']['input']>;
  routeDescription?: InputMaybe<Scalars['String']['input']>;
  routeScheme?: InputMaybe<Scalars['ID']['input']>;
  sensorFillLevel?: InputMaybe<Scalars['Int']['input']>;
  sensorFillLevelPeriodHours?: InputMaybe<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
  vehicle?: InputMaybe<Scalars['ID']['input']>;
  wasteFraction?: InputMaybe<Scalars['ID']['input']>;
  wasteFractionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdateOrCreateContainerNewPayload = {
  __typename: 'UpdateOrCreateContainerNewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  container?: Maybe<ContainerType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateContainerProductInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  containerType: Scalars['ID']['input'];
  enableOnPortal?: InputMaybe<Scalars['Boolean']['input']>;
  externalInvoiceCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeOnInvoicesIfFree?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nameOnInvoice: Scalars['String']['input'];
  pickupSetting: Scalars['ID']['input'];
  propertyType: Scalars['ID']['input'];
  wasteFraction: Scalars['ID']['input'];
};

export type UpdateOrCreateContainerProductPayload = {
  __typename: 'UpdateOrCreateContainerProductPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  product?: Maybe<ProductDef>;
};

export type UpdateOrCreateContainerTypeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  /** m */
  diameter?: InputMaybe<Scalars['Float']['input']>;
  emplacement: Scalars['String']['input'];
  emptyingTime: Scalars['Int']['input'];
  /** m */
  height: Scalars['Float']['input'];
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isCylindrical?: InputMaybe<Scalars['Boolean']['input']>;
  isRentable?: InputMaybe<Scalars['Boolean']['input']>;
  isSludgeTank?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  /** m */
  length?: InputMaybe<Scalars['Float']['input']>;
  lidType?: InputMaybe<Scalars['String']['input']>;
  /** e.g. active, retired, maintenance */
  lifecycleStatus?: InputMaybe<Scalars['String']['input']>;
  loadUnitType?: InputMaybe<Scalars['String']['input']>;
  loadingMethod?: InputMaybe<Scalars['String']['input']>;
  /** Maximum payload of this container type in kilograms (PRODUCT-475). Drives the expected-load warning before dispatch. Empty = not stated. */
  maxPayloadKg?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  project?: InputMaybe<Scalars['ID']['input']>;
  removeIcon?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleCoupling: Array<InputMaybe<Scalars['String']['input']>>;
  /** m³ */
  volume: Scalars['Float']['input'];
  warrantyMonths?: InputMaybe<Scalars['Int']['input']>;
  wasteTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** m */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOrCreateContainerTypePayload = {
  __typename: 'UpdateOrCreateContainerTypePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  containerType?: Maybe<ContainerTypeType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateCreateAgreementExportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  fromDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  mode: Scalars['String']['input'];
  modeChangeIncludeNew?: InputMaybe<Scalars['Boolean']['input']>;
  modeChangeIncludeRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  runExport: Scalars['Boolean']['input'];
  toDate: Scalars['DateTime']['input'];
};

export type UpdateOrCreateCreateAgreementExportPayload = {
  __typename: 'UpdateOrCreateCreateAgreementExportPayload';
  agreementExport?: Maybe<AgreementExportDef>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateCreateCriiptoApplicationInput = {
  allowBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  allowedAcrValues: Array<InputMaybe<Scalars['String']['input']>>;
  clientId: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientSecret: Scalars['String']['input'];
  hostname: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOrCreateCreateCriiptoApplicationPayload = {
  __typename: 'UpdateOrCreateCreateCriiptoApplicationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  criiptoApplication?: Maybe<CriiptoApplicationDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateCreateDocumentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateOrCreateCreateDocumentPayload = {
  __typename: 'UpdateOrCreateCreateDocumentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  document?: Maybe<DocumentDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateCreateScheduledExportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  createRun: Scalars['Boolean']['input'];
  excelFormat?: InputMaybe<Scalars['Boolean']['input']>;
  exportAgreementEnd?: InputMaybe<Scalars['Boolean']['input']>;
  exportAgreementNew?: InputMaybe<Scalars['Boolean']['input']>;
  exportAgreementRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  exportAgreementStart?: InputMaybe<Scalars['Boolean']['input']>;
  exportContainerCollectionCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  exportContainerCollectionCalendarFromDate?: InputMaybe<Scalars['Boolean']['input']>;
  exportContainerCollectionCalendarWeek?: InputMaybe<Scalars['Boolean']['input']>;
  exportContainerDescription?: InputMaybe<Scalars['Boolean']['input']>;
  exportContainerId?: InputMaybe<Scalars['Boolean']['input']>;
  exportContainerLocation?: InputMaybe<Scalars['Boolean']['input']>;
  exportContainerMetaTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  exportContainerPickupSetting?: InputMaybe<Scalars['Boolean']['input']>;
  exportContainerRouteDescription?: InputMaybe<Scalars['Boolean']['input']>;
  exportContainerRouteScheme?: InputMaybe<Scalars['Boolean']['input']>;
  exportContainerType?: InputMaybe<Scalars['Boolean']['input']>;
  exportContainerWasteFraction?: InputMaybe<Scalars['Boolean']['input']>;
  exportPropertyArea?: InputMaybe<Scalars['Boolean']['input']>;
  exportPropertyId?: InputMaybe<Scalars['Boolean']['input']>;
  exportPropertyLocation?: InputMaybe<Scalars['Boolean']['input']>;
  exportPropertyMetaTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  exportPropertyType?: InputMaybe<Scalars['Boolean']['input']>;
  exportTicketBulkWasteItems?: InputMaybe<Scalars['Boolean']['input']>;
  exportTicketDescription?: InputMaybe<Scalars['Boolean']['input']>;
  exportTicketPreferredDate?: InputMaybe<Scalars['Boolean']['input']>;
  exportTicketType?: InputMaybe<Scalars['Boolean']['input']>;
  filterContainerMetaTypes?: InputMaybe<Array<InputMaybe<ScheduledExportMetaTypeInput>>>;
  filterContainerPickupSettings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  filterContainerRouteSchemes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  filterContainerTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  filterContainerWasteFractions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  filterPropertyMetaTypes?: InputMaybe<Array<InputMaybe<ScheduledExportMetaTypeInput>>>;
  filterPropertyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  filterTicketDate: Scalars['String']['input'];
  filterTicketStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterTicketTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeAgreements?: InputMaybe<Scalars['Boolean']['input']>;
  includeTickets?: InputMaybe<Scalars['Boolean']['input']>;
  interval: Scalars['Int']['input'];
  intervalDayHour?: InputMaybe<Scalars['Int']['input']>;
  intervalFuture?: InputMaybe<Scalars['Boolean']['input']>;
  intervalMonthDay?: InputMaybe<Scalars['Int']['input']>;
  intervalStart: Scalars['DateTime']['input'];
  intervalType: Scalars['String']['input'];
  intervalWeekIsoweekday?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateOrCreateCreateScheduledExportPayload = {
  __typename: 'UpdateOrCreateCreateScheduledExportPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  scheduledExport?: Maybe<ScheduledExportDef>;
};

export type UpdateOrCreateCustomerFunctionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateOrCreateCustomerFunctionPayload = {
  __typename: 'UpdateOrCreateCustomerFunctionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerFunction?: Maybe<CustomerFunctionDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateDashboardInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  rolesCanView?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdateOrCreateDashboardPayload = {
  __typename: 'UpdateOrCreateDashboardPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dashboard?: Maybe<DashboardDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateDepot = {
  __typename: 'UpdateOrCreateDepot';
  depot?: Maybe<DepotType>;
};

export type UpdateOrCreateDriverInput = {
  /** In minutes */
  breakDuration?: InputMaybe<Scalars['DriverBreakDurationInput']['input']>;
  /** Time, when driver have scheduled break */
  breakTimeEnd?: InputMaybe<Scalars['Time']['input']>;
  /** Time, when driver have scheduled break */
  breakTimeStart?: InputMaybe<Scalars['Time']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<DriverCostInput>;
  daysAvailable: Array<InputMaybe<Scalars['String']['input']>>;
  driverType: Scalars['String']['input'];
  /** External driver id */
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  license?: InputMaybe<LicenseInput>;
  primaryVehicle?: InputMaybe<Scalars['ID']['input']>;
  user: Scalars['ID']['input'];
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Time, when driver ended to work */
  workTimeEnd?: InputMaybe<Scalars['Time']['input']>;
  /** Time, when driver started to work */
  workTimeStart?: InputMaybe<Scalars['Time']['input']>;
};

export type UpdateOrCreateDriverPayload = {
  __typename: 'UpdateOrCreateDriverPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<DriverType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOrCreateExternalMapLayerInput = {
  attribution?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  layerIdentifier?: InputMaybe<Scalars['String']['input']>;
  layerType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ordering?: InputMaybe<Scalars['Int']['input']>;
  refreshIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Create or edit a registered external map layer (3.1.45 / REQ-47).
 *
 * External layers are platform Settings configuration: office-only
 * (contractors denied — same rule as the Zone mutations) and company-scoped;
 * no module flag. Stores only the layer *definition* (WMS/WFS/WMTS/XYZ/raster
 * URL + identifier) — the map client renders it live from the URL.
 */
export type UpdateOrCreateExternalMapLayerPayload = {
  __typename: 'UpdateOrCreateExternalMapLayerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  externalMapLayer?: Maybe<ExternalMapLayerDef>;
};

export type UpdateOrCreateHaulerInput = {
  businessId?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Settlement currency (free text, e.g. 'EUR'). */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** 24/7 dispatch phone for operational escalation. */
  dispatchPhone?: InputMaybe<Scalars['String']['input']>;
  /** E-invoicing address. */
  eInvoicingAddress?: InputMaybe<Scalars['String']['input']>;
  /** E-invoicing operator ID. */
  eInvoicingOperator?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Headquarters / operating location of the contractor (free-text address). */
  headquarters?: InputMaybe<Scalars['String']['input']>;
  /** Bank account / IBAN the settlement payable pays to. */
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Invoicing contact email (settlement counterpart). */
  invoicingContactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Invoicing contact person (settlement counterpart). */
  invoicingContactName?: InputMaybe<Scalars['String']['input']>;
  legalAddress?: InputMaybe<Scalars['String']['input']>;
  /** Legal form of the company (free text, e.g. 'Oy'). */
  legalForm?: InputMaybe<Scalars['String']['input']>;
  mainContact?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Payment terms (free text, e.g. '30 days net'). */
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** VAT number, as printed on settlement documents. */
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrCreateHaulerPayload = {
  __typename: 'UpdateOrCreateHaulerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  hauler?: Maybe<HaulerDef>;
};

export type UpdateOrCreateHaulerPriceInput = {
  amount: Scalars['Int']['input'];
  area?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  components?: InputMaybe<Array<InputMaybe<HaulerPriceComponentInput>>>;
  endDate: Scalars['Date']['input'];
  hauler: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  ppProduct?: InputMaybe<Scalars['ID']['input']>;
  product?: InputMaybe<Scalars['ID']['input']>;
  property?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
  /** HSY-235: the contractor price in currency at up to four decimals (rounded to the tenant's price precision). When given it wins and `amount` is re-derived from it; omit to keep writing cents in `amount`. */
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateOrCreateHaulerPricePayload = {
  __typename: 'UpdateOrCreateHaulerPricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  haulerPrice?: Maybe<HaulerPriceDef>;
};

export type UpdateOrCreateIntegrationGps = {
  __typename: 'UpdateOrCreateIntegrationGps';
  integrationGps?: Maybe<IntegrationGpsType>;
};

export type UpdateOrCreateIntegrationGpsVehicle = {
  __typename: 'UpdateOrCreateIntegrationGpsVehicle';
  integrationGpsVehicle?: Maybe<IntegrationGpsVehicleType>;
};

export type UpdateOrCreateKmdEasyPropertyTypeToKmdEasyStationCodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  kmdEasyStationCode: Scalars['Int']['input'];
  propertyType: Scalars['ID']['input'];
};

export type UpdateOrCreateKmdEasyPropertyTypeToKmdEasyStationCodePayload = {
  __typename: 'UpdateOrCreateKmdEasyPropertyTypeToKmdEasyStationCodePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  propertyTypeToKmdEasyStationCodeMap?: Maybe<PropertyTypeToKmdEasyStationCodeMapDef>;
};

export type UpdateOrCreateMeasurementSettingsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  excludeDays?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hours?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  measurementExcludeDays?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  measurementHours?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  measurementMeasurementsPerHour?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  project: Scalars['ID']['input'];
};

export type UpdateOrCreateMeasurementSettingsPayload = {
  __typename: 'UpdateOrCreateMeasurementSettingsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  measurementSettings?: Maybe<MeasurementSettingsType>;
};

export type UpdateOrCreateMunicipalityInput = {
  /** May year-round and summer dwellings share one shared residential service (kimppa) in this municipality? */
  allowKimppaUsageMixing?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Maximum member count of a shared residential service (kimppa) in this municipality; empty = unrestricted */
  maxKimppaMembers?: InputMaybe<Scalars['Int']['input']>;
  /** Lower member cap applying when the kimppa serves a biowaste fraction; empty = unrestricted */
  maxKimppaMembersBio?: InputMaybe<Scalars['Int']['input']>;
  /** Permanent-dwelling base fee in euros per year; a kimppa share implying a smaller yearly amount draws an advisory warning. Empty = no floor. */
  minAnnualFeeEur?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  /** Default SCP compliance radius in metres */
  scpDefaultRadiusM?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOrCreateMunicipalityPayload = {
  __typename: 'UpdateOrCreateMunicipalityPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  municipality?: Maybe<MunicipalityDef>;
};

export type UpdateOrCreatePickUpOrderApprovalCollectionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrCreatePickUpOrderApprovalCollectionPayload = {
  __typename: 'UpdateOrCreatePickUpOrderApprovalCollectionPayload';
  approvalCollection?: Maybe<PickUpOrderApprovalCollectionDef>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  pickUpOrderApprovalCollection?: Maybe<PickUpOrderApprovalCollectionDef>;
};

export type UpdateOrCreatePickupSettingsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  collectionPerWeek?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  minimumDaysBetweenPickup?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** Count of weeks between repeats */
  pickupRepeatPeriod?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOrCreatePickupSettingsPayload = {
  __typename: 'UpdateOrCreatePickupSettingsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  pickupSetting?: Maybe<PickupSettingsType>;
  pickupSettings?: Maybe<PickupSettingsType>;
};

export type UpdateOrCreateProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hex color code */
  color?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  removeLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrCreateProjectPayload = {
  __typename: 'UpdateOrCreateProjectPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  project?: Maybe<ProjectType>;
};

export type UpdateOrCreateProjectSettingsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 12-hour clock? */
  clockFormat12?: InputMaybe<Scalars['Boolean']['input']>;
  country: Scalars['String']['input'];
  crmEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  currency: Scalars['String']['input'];
  dashboardLocationLatitude: Scalars['Float']['input'];
  dashboardLocationLongitude: Scalars['Float']['input'];
  dashboardLocationName: Scalars['String']['input'];
  drivingDistance: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  temperature: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  volume: Scalars['String']['input'];
  weight: Scalars['String']['input'];
};

export type UpdateOrCreateProjectSettingsPayload = {
  __typename: 'UpdateOrCreateProjectSettingsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  project?: Maybe<ProjectType>;
  settings?: Maybe<SettingsType>;
};

export type UpdateOrCreatePropertyContactInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coName?: InputMaybe<Scalars['String']['input']>;
  contactType: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalContactId?: InputMaybe<Scalars['String']['input']>;
  externalPropertyContactId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isAdministrator?: InputMaybe<Scalars['Boolean']['input']>;
  isCoOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isContact?: InputMaybe<Scalars['Boolean']['input']>;
  isOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isPayer?: InputMaybe<Scalars['Boolean']['input']>;
  isTenant?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  otherPhoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeName?: InputMaybe<Scalars['String']['input']>;
  property: Scalars['ID']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxSubId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrCreatePropertyContactPayload = {
  __typename: 'UpdateOrCreatePropertyContactPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  propertyContact?: Maybe<PropertyContactDef>;
};

export type UpdateOrCreatePropertyGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupType: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  singleAddress?: InputMaybe<Scalars['String']['input']>;
  singleCity?: InputMaybe<Scalars['String']['input']>;
  singleCountry?: InputMaybe<Scalars['String']['input']>;
  singleInvoiceEmail?: InputMaybe<Scalars['String']['input']>;
  singlePhone?: InputMaybe<Scalars['String']['input']>;
  singleTaxId?: InputMaybe<Scalars['String']['input']>;
  singleZipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrCreatePropertyGroupPayload = {
  __typename: 'UpdateOrCreatePropertyGroupPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  propertyGroup?: Maybe<PropertyGroupDef>;
};

export type UpdateOrCreatePropertyInput = {
  area?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emergencyPriority?: InputMaybe<Scalars['String']['input']>;
  externalPropertyNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<LocationInput>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parentProperty?: InputMaybe<Scalars['ID']['input']>;
  registerBasis?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['ID']['input'];
};

export type UpdateOrCreatePropertyManagementCompanyInput = {
  additionalServicesSalesBan?: InputMaybe<Scalars['Boolean']['input']>;
  additionalServicesSalesBanReason?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addresses?: InputMaybe<Array<InputMaybe<PropertyManagementCompanyAddressInput>>>;
  authorityFeeDecision?: InputMaybe<Scalars['String']['input']>;
  authorityFeeDecisionDate?: InputMaybe<Scalars['Date']['input']>;
  bundling?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  /** Manually placed credit hold. Read by hauler-order flows as a stop signal; never set automatically in wave 1. */
  creditHold?: InputMaybe<Scalars['Boolean']['input']>;
  /** Credit limit in the tenant's currency. Master data only — nothing in this app computes or enforces balances (money lane, ADR-E3 gate). */
  creditLimit?: InputMaybe<Scalars['Float']['input']>;
  customerFunctionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  defaultBillingFrequencyCode?: InputMaybe<Scalars['String']['input']>;
  /** Reference to the account's default price list. A plain reference string in wave 1 — the price core is money-lane territory (mirrors hauler_orders.Order.price_list_ref). */
  defaultPriceListRef?: InputMaybe<Scalars['String']['input']>;
  defaultServiceResponsibilityId?: InputMaybe<Scalars['ID']['input']>;
  /** BRIDGE-499/505: the FI YTJ registry's e-invoice OVT-tunnus (routing address), distinct from einvoiceAddress below (the pre-existing generic e-invoicing email, unrelated to any registry). */
  eInvoiceAddress?: InputMaybe<Scalars['String']['input']>;
  /** BRIDGE-499/505: the e-invoice operator's routing identifier for e_invoice_address above. */
  eInvoiceOperatorIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** BRIDGE-499/505: the e-invoice operator's display name for e_invoice_address above. */
  eInvoiceOperatorName?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  einvoiceAddress?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalContactId?: InputMaybe<Scalars['String']['input']>;
  /** HAUL-018 (hauler mode): the customer's agreement pre-authorizes moving a visit that lands on a public holiday to the next working day. False = every holiday move needs the office's explicit confirmation. Never a silent auto-move: the move is journaled either way. */
  holidayAutoMove?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  industryCode?: InputMaybe<Scalars['String']['input']>;
  industrySpecify?: InputMaybe<Scalars['String']['input']>;
  invoiceDeliveryMethod?: InputMaybe<Scalars['String']['input']>;
  invoiceLanguage?: InputMaybe<Scalars['String']['input']>;
  invoiceReference?: InputMaybe<Scalars['String']['input']>;
  invoiceTemplateCode?: InputMaybe<Scalars['String']['input']>;
  marketingOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Agreed payment terms in days (e.g. 14, 30). Null = the tenant's default terms apply. */
  paymentTermsDays?: InputMaybe<Scalars['Int']['input']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeName?: InputMaybe<Scalars['String']['input']>;
  pricingMode?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  reverseChargeVat?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<ContactRole>;
  /** Commercial segment of the account (hauler mode). Blank = not segmented. */
  segment?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxSubId?: InputMaybe<Scalars['String']['input']>;
  vatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrCreatePropertyManagementCompanyPayload = {
  __typename: 'UpdateOrCreatePropertyManagementCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  managementCompanyProperty?: Maybe<ManagementCompanyPropertyDef>;
  propertyManagementCompany?: Maybe<PropertyManagementCompanyDef>;
};

export type UpdateOrCreatePropertyPayload = {
  __typename: 'UpdateOrCreatePropertyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  property?: Maybe<PropertyDef>;
};

export type UpdateOrCreatePropertyTypeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateOrCreatePropertyTypePayload = {
  __typename: 'UpdateOrCreatePropertyTypePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  propertyType?: Maybe<PropertyTypeDef>;
};

export type UpdateOrCreatePropertyUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberToken?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type UpdateOrCreatePropertyUserPayload = {
  __typename: 'UpdateOrCreatePropertyUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  propertyUser?: Maybe<PropertyUserDef>;
};

export type UpdateOrCreateRecurringProductInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enableOnPortal?: InputMaybe<Scalars['Boolean']['input']>;
  externalInvoiceCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeOnInvoicesIfFree?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nameOnInvoice: Scalars['String']['input'];
  propertyType?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOrCreateRecurringProductPayload = {
  __typename: 'UpdateOrCreateRecurringProductPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  product?: Maybe<ProductDef>;
};

export type UpdateOrCreateRouteSchemeInput = {
  /** If this is enabled, drivers will be able to collaborate on routes */
  allowCollaborationOnRoute?: InputMaybe<Scalars['Boolean']['input']>;
  allowDriverToAddStops?: InputMaybe<Scalars['Boolean']['input']>;
  allowDriverToEditContainers?: InputMaybe<Scalars['Boolean']['input']>;
  allowDriverToMoveStops?: InputMaybe<Scalars['Boolean']['input']>;
  allowDriverToOnlyCompleteNextStop?: InputMaybe<Scalars['Boolean']['input']>;
  /** If this is enabled, drivers will be able to start routes before the scheduled date */
  allowDriverToStartRouteBeforeScheduledDate?: InputMaybe<Scalars['Boolean']['input']>;
  allowDriverToTakeStops?: InputMaybe<Scalars['Boolean']['input']>;
  /** If this is enabled, drivers which have allowed vehicles that intersect with the vehicles from route scheme will be able to view routes generated by this route scheme */
  allowDriverWithRouteSchemeVehiclesAccessToViewRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  autoCompleteDistance: Scalars['Int']['input'];
  autoCompleteDuration: Scalars['Int']['input'];
  autoCompletePlannedContainers?: InputMaybe<Scalars['Boolean']['input']>;
  autoCompleteRfid?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  collectionMethod: Scalars['String']['input'];
  collectionMethodSemiDynamicUsePrediction?: InputMaybe<Scalars['Boolean']['input']>;
  collectionMethodTicketsCollectionCalender?: InputMaybe<Scalars['ID']['input']>;
  /** Distance (meters) a driver must be within to mark a stop done manually on this scheme's routes. Empty = use the company default. A contract area's own radius always wins. */
  completionRadiusMeters?: InputMaybe<Scalars['Int']['input']>;
  defaultAutoComplete?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAutoCompleteNextStop?: InputMaybe<Scalars['Boolean']['input']>;
  defaultRouteAutoOptimize?: InputMaybe<Scalars['Boolean']['input']>;
  defaultRouteLockedStart?: InputMaybe<Scalars['Boolean']['input']>;
  /** When on, every route this scheme generates is re-sequenced to the fixed route template that covers it, and a route the templates do not cover gets a draft for the planner to confirm. Off (default) = templates are applied only by hand. */
  fixedRouteNightlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  generateRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  generateRoutesDays: Scalars['Int']['input'];
  hauler?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  keepManuallyAddedStops?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  objectives: Array<InputMaybe<Scalars['String']['input']>>;
  project: Scalars['ID']['input'];
  promptDriverForFillLevelOnContainer?: InputMaybe<Scalars['Boolean']['input']>;
  promptDriverForQrCodeOnContainer?: InputMaybe<Scalars['Boolean']['input']>;
  promptDriverForWeightOnContainer?: InputMaybe<Scalars['Boolean']['input']>;
  promptDriverForWeightOnWasteStation?: InputMaybe<Scalars['Boolean']['input']>;
  /** If this is enabled, drivers will not be able to modify turn by turn navigation in the mobile app */
  restrictTurnByTurnUsage?: InputMaybe<Scalars['Boolean']['input']>;
  suppressEmptyRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  /** If this is enabled, turn by turn navigation will be enabled by default in the mobile app */
  turnByTurnIsOn?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleDays: Array<InputMaybe<RouteSchemeVehicleDayMultipleChoiceFieldInput>>;
  vehicleTrailerCapacityMode: Scalars['String']['input'];
  vehicles: Array<InputMaybe<Scalars['ID']['input']>>;
  wasteFractionsFillLevelSets?: InputMaybe<Array<InputMaybe<RouteSchemeWasteFractionFillLevelSetMultipleChoiceFieldInput>>>;
};

export type UpdateOrCreateRouteSchemePayload = {
  __typename: 'UpdateOrCreateRouteSchemePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  routeScheme?: Maybe<RouteSchemeType>;
};

/**
 * Create or update the SCP profile on a ``PropertyGroup`` (NEXUS-530).
 *
 * Keyed by the 1:1 ``property_group``. Termination is out of scope
 * (NEX-SS-104), so the input never exposes status/termination fields and
 * profiles are always written as ACTIVE. Every change is audited by the
 * ``crm_scpprofile`` temporal-table trigger.
 */
export type UpdateOrCreateScpProfile = {
  __typename: 'UpdateOrCreateScpProfile';
  scpProfile?: Maybe<ScpProfileDef>;
};

export type UpdateOrCreateScpProfileInput = {
  accessInfo?: InputMaybe<Scalars['String']['input']>;
  availability?: InputMaybe<ScpAvailability>;
  billingMode?: InputMaybe<ScpBillingMode>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  collectionAddress?: InputMaybe<LocationInput>;
  complianceRadiusMOverride?: InputMaybe<Scalars['Float']['input']>;
  declaredContainerTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  declaredWasteFractionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  defaultPpFeeProductId?: InputMaybe<Scalars['ID']['input']>;
  exceptionalInvoicingIntervalMonths?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  municipalityId?: InputMaybe<Scalars['ID']['input']>;
  openingHours?: InputMaybe<Scalars['String']['input']>;
  openingHoursStructured?: InputMaybe<Array<ScpOpeningHoursRangeInput>>;
  propertyGroupId: Scalars['ID']['input'];
  scpType?: InputMaybe<ScpType>;
  seasonEndMonth?: InputMaybe<Scalars['Int']['input']>;
  seasonStartMonth?: InputMaybe<Scalars['Int']['input']>;
  seasonalIntervals?: InputMaybe<Array<ScpSeasonalIntervalInput>>;
};

export type UpdateOrCreateServiceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  ppAdditionalServiceCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ppAllAdditionalServiceCategories?: InputMaybe<Scalars['Boolean']['input']>;
  ppServiceProductId?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrCreateServicePayload = {
  __typename: 'UpdateOrCreateServicePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  service?: Maybe<ServiceDef>;
};

export type UpdateOrCreateServiceProductInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  containerType?: InputMaybe<Scalars['ID']['input']>;
  enableOnPortal?: InputMaybe<Scalars['Boolean']['input']>;
  externalInvoiceCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeOnInvoicesIfFree?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nameOnInvoice: Scalars['String']['input'];
  propertyType?: InputMaybe<Scalars['ID']['input']>;
  service: Scalars['ID']['input'];
  wasteFraction?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOrCreateServiceProductPayload = {
  __typename: 'UpdateOrCreateServiceProductPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  product?: Maybe<ProductDef>;
};

export type UpdateOrCreateServiceResponsibility = {
  __typename: 'UpdateOrCreateServiceResponsibility';
  serviceResponsibility?: Maybe<ServiceResponsibilityDef>;
};

export type UpdateOrCreateSkill = {
  __typename: 'UpdateOrCreateSkill';
  skill?: Maybe<SkillType>;
};

export type UpdateOrCreateSubscriptionQuote = {
  __typename: 'UpdateOrCreateSubscriptionQuote';
  billingSubscriptionQuote?: Maybe<BillingSubscriptionQuote>;
};

export type UpdateOrCreateTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  members?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name: Scalars['String']['input'];
};

export type UpdateOrCreateTeamPayload = {
  __typename: 'UpdateOrCreateTeamPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  team?: Maybe<TeamType>;
};

export type UpdateOrCreateTicketCategoryInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateOrCreateTicketCategoryPayload = {
  __typename: 'UpdateOrCreateTicketCategoryPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ticketCategory?: Maybe<TicketCategoryDef>;
};

export type UpdateOrCreateTicketMessageTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrCreateTicketMessageTemplatePayload = {
  __typename: 'UpdateOrCreateTicketMessageTemplatePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ticketMessageTemplate?: Maybe<TicketMessageTemplateDef>;
};

export type UpdateOrCreateTicketTypeInput = {
  abortiveFeeProductId?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  /** Office-configured reason code/label for this complaint category (e.g. missed collection, damage). Free text so the office owns the reason set; blank for non-complaint types. */
  complaintReason?: InputMaybe<Scalars['String']['input']>;
  containerDestination?: InputMaybe<ContainerStorageLocationInput>;
  containerSource?: InputMaybe<ContainerStorageLocationInput>;
  creatableFromCustomerPage?: InputMaybe<Scalars['Boolean']['input']>;
  deadlineMode?: InputMaybe<Scalars['String']['input']>;
  deadlineOffsetNumber?: InputMaybe<Scalars['Int']['input']>;
  deadlineOffsetUnit?: InputMaybe<Scalars['String']['input']>;
  enableOnNavigationApp?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnPortal?: InputMaybe<Scalars['Boolean']['input']>;
  /** When this period ticket type is dispatched, automatically create the pickup/return ticket due on its end date. */
  generatesReturnTicket?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeDeadline?: InputMaybe<Scalars['Boolean']['input']>;
  includePeriod?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flags this ticket type as a citizen complaint / feedback category (W8, D5). Tickets of a complaint type are surfaced in the feedback list and can be marked as affecting pay. */
  isComplaint?: InputMaybe<Scalars['Boolean']['input']>;
  isContainerLevel?: InputMaybe<Scalars['Boolean']['input']>;
  isMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  isPropertyLevel?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  navigationAppRequireAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  periodDefaultDurationDays?: InputMaybe<Scalars['Int']['input']>;
  periodEndDateRequired?: InputMaybe<Scalars['Boolean']['input']>;
  portalConfirmSubtitle?: InputMaybe<Scalars['String']['input']>;
  portalConfirmTitle?: InputMaybe<Scalars['String']['input']>;
  portalContactInformationEmailRequired?: InputMaybe<Scalars['Boolean']['input']>;
  portalContactInformationNameRequired?: InputMaybe<Scalars['Boolean']['input']>;
  portalContactInformationNextButtonLabel?: InputMaybe<Scalars['String']['input']>;
  portalContactInformationPhoneNumberRequired?: InputMaybe<Scalars['Boolean']['input']>;
  portalDateHelpText?: InputMaybe<Scalars['String']['input']>;
  portalDateHidden?: InputMaybe<Scalars['Boolean']['input']>;
  portalDateLabel?: InputMaybe<Scalars['String']['input']>;
  portalDateMaxDaysInFutureForBulkWaste?: InputMaybe<Scalars['Int']['input']>;
  portalDateMinDaysInFutureForBulkWaste?: InputMaybe<Scalars['Int']['input']>;
  portalDateRequired?: InputMaybe<Scalars['Boolean']['input']>;
  portalDescription?: InputMaybe<Scalars['String']['input']>;
  portalDropdownHelpText?: InputMaybe<Scalars['String']['input']>;
  portalDropdownHidden?: InputMaybe<Scalars['Boolean']['input']>;
  portalDropdownLabel?: InputMaybe<Scalars['String']['input']>;
  portalDropdownOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  portalDropdownRequired?: InputMaybe<Scalars['Boolean']['input']>;
  portalNoteHelpText?: InputMaybe<Scalars['String']['input']>;
  portalNoteHidden?: InputMaybe<Scalars['Boolean']['input']>;
  portalNoteLabel?: InputMaybe<Scalars['String']['input']>;
  portalNoteRequired?: InputMaybe<Scalars['Boolean']['input']>;
  portalPriceShowZero?: InputMaybe<Scalars['Boolean']['input']>;
  portalRequireContactInformation?: InputMaybe<Scalars['Boolean']['input']>;
  portalServiceTypeBulkWasteLimit?: InputMaybe<Scalars['Int']['input']>;
  portalServiceTypeBulkWasteLimitHelpText?: InputMaybe<Scalars['String']['input']>;
  portalServiceTypeBulkWasteLimitLabel?: InputMaybe<Scalars['String']['input']>;
  ppServiceProductId?: InputMaybe<Scalars['String']['input']>;
  /** Status a ticket of this type moves to when it is added to a route from the route page. Blank leaves the status unchanged. Values: 1 Created, 2 Open, 3 Pending, 4 On hold, 5 In progress, 6 Completed, 7 Rejected. */
  routeScheduledStatus?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<Scalars['ID']['input']>;
  statusTransitions?: InputMaybe<Array<TicketTypeStatusTransitionInput>>;
  useContainerStorageManagement?: InputMaybe<Scalars['Boolean']['input']>;
  visibilityHaulerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  visibilityScope?: InputMaybe<Scalars['String']['input']>;
  visibilityTeamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  visibilityUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** How many days after the washing ticket is completed the bin is due back (the return ticket's preferred date). */
  washingReturnAfterDays?: InputMaybe<Scalars['Int']['input']>;
  washingReturnTicketType?: InputMaybe<Scalars['ID']['input']>;
  /** Off-site washing: completing a ticket of this type creates a follow-up ticket that returns the washed bin. */
  washingReturnsContainer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrCreateTicketTypePayload = {
  __typename: 'UpdateOrCreateTicketTypePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ticketType?: Maybe<TicketTypeDef>;
};

export type UpdateOrCreateUserAbsence = {
  __typename: 'UpdateOrCreateUserAbsence';
  userAbsence?: Maybe<UserAbsenceType>;
};

export type UpdateOrCreateUserFilterCollection = {
  __typename: 'UpdateOrCreateUserFilterCollection';
  userFilterCollection?: Maybe<UserFilterCollectionType>;
};

export type UpdateOrCreateUserProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** This user has permission to change project settings. */
  isSuper?: InputMaybe<Scalars['Boolean']['input']>;
  project: Scalars['ID']['input'];
  user: Scalars['ID']['input'];
};

export type UpdateOrCreateUserProjectPayload = {
  __typename: 'UpdateOrCreateUserProjectPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  userProject?: Maybe<UserProjectType>;
};

export type UpdateOrCreateVehicleAbsence = {
  __typename: 'UpdateOrCreateVehicleAbsence';
  vehicleAbsence?: Maybe<VehicleAbsenceType>;
};

export type UpdateOrCreateVehicleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hex color code */
  color?: InputMaybe<Scalars['String']['input']>;
  depots: Array<InputMaybe<Scalars['ID']['input']>>;
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  hauler?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  licensePlateNumber?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  /** Vehicle's naming */
  name: Scalars['String']['input'];
  project: Scalars['ID']['input'];
  removeLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Status of vehicle */
  status: Scalars['String']['input'];
  vehicleSize: Scalars['ID']['input'];
  vehicleType: Scalars['ID']['input'];
  wasteStations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdateOrCreateVehiclePayload = {
  __typename: 'UpdateOrCreateVehiclePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  vehicle?: Maybe<VehicleType>;
};

export type UpdateOrCreateVehicleTypeInput = {
  Type: Scalars['String']['input'];
  /** Type of vehicle's body */
  body?: InputMaybe<Scalars['String']['input']>;
  /** Type of body's mechanization */
  bodyMechanization?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** With compactor */
  compactor?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  /** Crane variant */
  crane?: InputMaybe<Scalars['String']['input']>;
  /** EU EURO emission standard (e.g. EURO V / EURO VI). Required by European municipal waste tenders and low-emission zones; not derived from co2_emission_per_km. */
  emissionClass?: InputMaybe<Scalars['String']['input']>;
  /** Fixed cost for the Vehicle per day */
  fixedCost?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel cost per kilometer (less is better) */
  fuelCostPerKm?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel cost per litter (less is better) */
  fuelCostPerLtr?: InputMaybe<Scalars['Float']['input']>;
  fuelTankCapacity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Vehicle fuel type */
  fuelType?: InputMaybe<Scalars['String']['input']>;
  /** Fuel usage per kilometer (less is better) */
  fuelUsagePerKm?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Type of lifting's mechanization */
  liftingMechanization?: InputMaybe<Scalars['String']['input']>;
  /** Type of loading location */
  loadingLocation?: InputMaybe<Scalars['String']['input']>;
  /** Vehicle's manufacturer */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Vehicle manufacturer's year */
  manufacturerYear?: InputMaybe<Scalars['String']['input']>;
  /** Vehicle's model */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Name of vehicle type */
  name: Scalars['String']['input'];
  trailers: Array<InputMaybe<VehicleTrailerMultipleChoiceFieldInput>>;
  /** Vehicle's trim */
  trim?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrCreateVehicleTypePayload = {
  __typename: 'UpdateOrCreateVehicleTypePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  vehicleType?: Maybe<VehicleTypeType>;
};

export type UpdateOrCreateWasteFraction = {
  __typename: 'UpdateOrCreateWasteFraction';
  wasteFraction?: Maybe<WasteFractionType>;
};

export type UpdateOrCreateWasteFractionNewInput = {
  adsFractionCode?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  emptyingIntervalMax?: InputMaybe<Scalars['Int']['input']>;
  emptyingIntervalMin?: InputMaybe<Scalars['Int']['input']>;
  energyRecovery?: InputMaybe<Scalars['Float']['input']>;
  ewcCode?: InputMaybe<Scalars['String']['input']>;
  hazardous?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['Upload']['input']>;
  iconPreset?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  materialRecovery?: InputMaybe<Scalars['Float']['input']>;
  mustIncludeVat?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  project: Scalars['ID']['input'];
  rdCode?: InputMaybe<Scalars['String']['input']>;
  recyclable?: InputMaybe<Scalars['Boolean']['input']>;
  recyclingPercentage?: InputMaybe<Scalars['Float']['input']>;
  removeIcon?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  treatmentLocation?: InputMaybe<Scalars['String']['input']>;
  treatmentMethod?: InputMaybe<Scalars['String']['input']>;
  wasteCategory: Scalars['String']['input'];
  wasteSubstance: Scalars['String']['input'];
  wasteType: Scalars['String']['input'];
  /** kg for m3 */
  weightFactor: Scalars['Float']['input'];
};

export type UpdateOrCreateWasteFractionNewPayload = {
  __typename: 'UpdateOrCreateWasteFractionNewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  wasteFraction?: Maybe<WasteFractionType>;
};

export type UpdateOrCreateZoneInput = {
  attributes?: InputMaybe<Scalars['GenericScalar']['input']>;
  boundaryGeojson?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Per-zone map display colour as a bare hex string (e.g. '1890FF'); NULL = the map's default zone colour. */
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  labelId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  parentIsManual?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrCreateZoneLabelInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

/**
 * Create or rename a zone label (T4): one entry of the company's
 * admin-maintained label/type list. Office-only, company-scoped — same
 * rules as the zone mutations.
 */
export type UpdateOrCreateZoneLabelPayload = {
  __typename: 'UpdateOrCreateZoneLabelPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  zoneLabel?: Maybe<ZoneLabelDef>;
};

/**
 * Create or edit a geographic zone (DEV-TASK-1, platform-level since
 * T4 "Map layers & zones").
 *
 * Zones are platform Settings configuration: office-only (contractors
 * denied — same rule as the Area mutations) and company-scoped; no module
 * flag — every module consumes the same zones. ``boundaryGeojson``
 * (optional) is the free-drawing path; shapefile uploads go through
 * ``importZoneBoundary``. T4 additions: ``labelId`` (admin-maintained
 * list; explicit null clears) and ``attributes`` (free key-value object).
 */
export type UpdateOrCreateZonePayload = {
  __typename: 'UpdateOrCreateZonePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  zone?: Maybe<ZoneDef>;
};

/**
 * Change a permit's details or move it to granted / refused. Only the
 * arguments sent change; moving to GRANTED (or re-dating a granted
 * permit) re-validates the window against the hire and bills the fee
 * once.
 */
export type UpdatePermit = {
  __typename: 'UpdatePermit';
  permit?: Maybe<PermitDef>;
};

export type UpdatePlanningAreaMutation = {
  __typename: 'UpdatePlanningAreaMutation';
  planningArea?: Maybe<PlanningAreaDef>;
};

export type UpdatePriceInput = {
  amount: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
  recurringInterval: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
  weightAmount: Scalars['Int']['input'];
};

export type UpdatePricePayload = {
  __typename: 'UpdatePricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  price?: Maybe<PriceDef>;
};

export type UpdatePropertyManagementCompanyAddress = {
  __typename: 'UpdatePropertyManagementCompanyAddress';
  address?: Maybe<PropertyManagementCompanyAddressDef>;
};

/**
 * Add and/or remove files on a property note (REQ-919).
 *
 * The office front end reuses its ticket-attachment upload flow verbatim:
 * ``obtainAttachmentsDirectUploadUrl`` with
 * ``objectToAttachType: PropertyNoteAttachment`` for the presigned POSTs,
 * then this mutation to attach them (which is also what a pasted clipboard
 * photo goes through — it is an ordinary upload by the time it gets here).
 *
 * Separate from ``updatePropertyNote`` for the same reason
 * ``updateTicketAttachments`` is separate from ``updateTicket``: attaching
 * a file is not a content edit, and the front end fires it on its own.
 *
 * Gate: the note's own ``crm_property_note__edit`` permission, via the same
 * ``CompanyRolePermission.check_permission`` call ``UpdatePropertyNote``
 * makes — which also refuses a note belonging to another company.
 */
export type UpdatePropertyNoteAttachments = {
  __typename: 'UpdatePropertyNoteAttachments';
  propertyNote?: Maybe<PropertyNoteDef>;
};

/**
 * Input for ``updatePropertyNoteAttachments`` (REQ-919).
 *
 * An input object rather than ``updateTicketAttachments``' flat argument
 * list: every other note mutation in this schema
 * (``createPropertyNote``/``updatePropertyNote``) takes ``input``, so the
 * office front end's note screen keeps one call shape.
 */
export type UpdatePropertyNoteAttachmentsInput = {
  /** PresignedUrlHolder ids from obtainAttachmentsDirectUploadUrl */
  addAttachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** PropertyNoteDef id */
  id: Scalars['ID']['input'];
  /** PropertyNoteAttachmentDef ids to detach */
  removeAttachmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdatePropertyNoteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The note content */
  content: Scalars['String']['input'];
  /** End of visibility period (required for scheduled notes) */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Start of visibility period (required for scheduled notes) */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  visibilityLevels: Array<InputMaybe<Scalars['String']['input']>>;
};

export type UpdatePropertyNotePayload = {
  __typename: 'UpdatePropertyNotePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  propertyNote?: Maybe<PropertyNoteDef>;
};

export type UpdateRecurringPriceInput = {
  amount: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** If true, then soft-delete the price, ignoring the rest of the input */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  invoiceName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateRecurringPricePayload = {
  __typename: 'UpdateRecurringPricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  recurringPrice?: Maybe<RecurringPriceDef>;
};

/**
 * Office-only, audited: edit a window's dates, scope, reason or active
 * switch (HSY 263). Omitted arguments keep their value. Both the old and
 * the new coverage must be clear of CLOSED settlement periods.
 */
export type UpdateReliabilityExclusionWindow = {
  __typename: 'UpdateReliabilityExclusionWindow';
  window?: Maybe<ReliabilityExclusionWindowType>;
};

/**
 * Edit a scenario's named configuration; each edit bumps the
 * version (F5: named, versioned scenarios).
 *
 * SBX-379 item 4 (D45): optimistic locking. Pass
 * ``expectedVersion`` (the version the client loaded) and the
 * update refuses with the honest current-version error when the
 * scenario changed under the client since; the row is locked for
 * the check-and-bump (``select_for_update``), so two concurrent
 * updates can never both pass the same expected version. Omitting
 * the argument keeps last-write-wins for clients that have not
 * adopted it yet (the frontend can adopt later).
 */
export type UpdateScenarioMutation = {
  __typename: 'UpdateScenarioMutation';
  scenario?: Maybe<ScenarioDef>;
};

/**
 * Edit an SCP member: attributes, contact and/or its active role set.
 *
 * ``roleDefinitionIds`` (when provided) is the desired ACTIVE role set —
 * missing roles are assigned and surplus assignments ended, preserving the
 * NEXUS-546 invariants (min one role, Contact Person + Payer per SCP, deputy
 * promotion). Omitted fields stay untouched; pass ``clearContact: true`` to
 * remove the contact (a null variable is indistinguishable from an omitted
 * one). Shares are edited via ``updateScpShares``.
 *
 * NEXUS-717: a ``usageProfile`` edit re-runs the NEXUS-684 usage-mixing
 * rule (an edit can create the same restricted mix a join can), with the
 * edited member excluded from the pool comparison; ``overrideUsageMixing``
 * converts the block into a payload warning, mirroring the join paths.
 */
export type UpdateScpMembership = {
  __typename: 'UpdateScpMembership';
  scpMembership?: Maybe<ScpMembershipDef>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/**
 * Atomically re-balance the shares of an SCP's active members.
 *
 * Rejects any batch whose active shares do not sum to 100.00 with a
 * structured error (``SHARES_MUST_SUM_TO_100``).
 */
export type UpdateScpShares = {
  __typename: 'UpdateScpShares';
  companyMemberships?: Maybe<Array<Maybe<ScpCompanyMembershipDef>>>;
  memberships?: Maybe<Array<Maybe<ScpMembershipDef>>>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UpdateServicePriceInput = {
  amount: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** If true, then soft-delete the price, ignoring the rest of the input */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  invoiceName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateServicePricePayload = {
  __typename: 'UpdateServicePricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  servicePrice?: Maybe<ServicePriceDef>;
};

export type UpdateShippingInformation = {
  __typename: 'UpdateShippingInformation';
  billingInformation?: Maybe<BillingInformationType>;
};

/**
 * Office (transfer_document__edit / master) or staff: carrier identity
 * and the eligible fraction list. Does NOT flip the flag — that is staff-only
 * through the feature-flag surface.
 */
export type UpdateSiirtoCompanySettings = {
  __typename: 'UpdateSiirtoCompanySettings';
  siirtoCompanySettings?: Maybe<SiirtoCompanySettingsType>;
};

export type UpdateSparePart = {
  __typename: 'UpdateSparePart';
  sparePart?: Maybe<SparePartType>;
};

/** Either userId or teamId can be provided, or neither, but not both */
export type UpdateTicketAssigneeInput = {
  teamId?: InputMaybe<Scalars['ID']['input']>;
  ticketId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTicketAttachments = {
  __typename: 'UpdateTicketAttachments';
  ticket?: Maybe<TicketDef>;
};

export type UpdateTicketCustomFieldMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayHelpText?: InputMaybe<Scalars['Boolean']['input']>;
  displayOn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayPrefilledValue?: InputMaybe<Scalars['Boolean']['input']>;
  displayUnit?: InputMaybe<Scalars['Boolean']['input']>;
  helpText?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inputType?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<CustomFieldOptionSelectInput>>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prefilledValue?: InputMaybe<Scalars['Int']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTicketCustomFieldMutationPayload = {
  __typename: 'UpdateTicketCustomFieldMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ticketCustomField?: Maybe<TicketCustomFieldDef>;
};

export type UpdateTicketDraftInput = {
  assignee?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  container?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  project?: InputMaybe<Scalars['ID']['input']>;
  property?: InputMaybe<Scalars['ID']['input']>;
  ticketType?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTicketDraftPayload = {
  __typename: 'UpdateTicketDraftPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ticketDraft?: Maybe<TicketDraftDef>;
};

export type UpdateTicketFollowers = {
  __typename: 'UpdateTicketFollowers';
  ticket?: Maybe<TicketDef>;
};

export type UpdateTicketInput = {
  addAttachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<TicketCustomFieldValueInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optimistic-concurrency stamp (REQ 3.12.5): the Ticket.version the client loaded. Stale -> STALE_VERSION refusal per the rollout phase. */
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  /** Deprecated: Send empty serviceProducts instead */
  ignoreServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  ppServiceProductId?: InputMaybe<Scalars['String']['input']>;
  preferredDate?: InputMaybe<Scalars['Date']['input']>;
  priority: Scalars['String']['input'];
  removeAttachmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  routeDescription?: InputMaybe<Scalars['String']['input']>;
  serviceProducts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdateTicketPayload = {
  __typename: 'UpdateTicketPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ticket?: Maybe<TicketDef>;
};

export type UpdateTicketPriorityInput = {
  priority: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};

export type UpdateTicketStatus = {
  __typename: 'UpdateTicketStatus';
  ticket?: Maybe<TicketDef>;
};

export type UpdateTicketStatusInput = {
  status: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};

export type UpdateTicketTypeOrder = {
  __typename: 'UpdateTicketTypeOrder';
  ticketTypes: Array<TicketTypeDef>;
};

/**
 * Narrow write of the citizen-facing COPY on one ticket type: the 12
 * pure display strings the self-service portal shows a citizen --
 * description (rich text), the date/note/dropdown labels and help
 * texts, the contact-step next-button label, the confirmation page's
 * title and subtitle, and the bulk-waste item-limit label and help
 * text. Absent (or null) inputs are untouched; an explicit empty
 * string clears the text (the portal then falls back to its built-in
 * wording), so the "Citizen page" panel never needs the full-payload
 * ``UpdateOrCreateTicketType`` and its lost-update behavior.
 *
 * Field split (every portal field has exactly ONE narrow home): this
 * mutation owns the pure display STRINGS listed in ``_COPY_FIELDS``
 * and nothing else. The FLOW-SHAPING fields -- shown/required toggles,
 * dropdown options, the contact-information step's toggles
 * (``portal_require_contact_information`` and the three
 * ``portal_contact_information_*_required`` flags), the zero-price
 * display switch ``portal_price_show_zero``, and the bulk-waste limit
 * and pickup window -- belong to ``UpdateTicketTypePortalIntake``
 * above and are not accepted here (unknown-argument error at the
 * GraphQL layer, no silent drop). The contact step's next-button LABEL
 * stays here: it is display copy, not flow shape. The audience flag
 * ``enable_on_portal`` belongs to ``UpdateTicketTypeSurfaces``.
 *
 * Validation mirrors the Settings save of the same fields
 * (``TicketTypeForm`` is a plain ModelForm) and invents nothing
 * stricter for copy: values are stripped of leading/trailing
 * whitespace (Django's ``forms.CharField(strip=True)`` default), the
 * 11 ``CharField`` columns cap at their model ``max_length`` of 255,
 * and ``portal_description`` (``TextField``, authored by Settings'
 * rich-text editor) is uncapped. Newlines and quotes are legal
 * everywhere -- the Settings form refuses neither, and this is display
 * copy, not the name field the rename guard polices. Service-type
 * boundaries mirror the intake mutation's: dropdown copy is refused
 * for managed service types (their citizen dropdown is force-hidden,
 * the text could never show) and bulk-waste copy is refused for
 * non-bulk-waste types (the citizen form never shows those fields
 * there).
 *
 * Audited by the platform's ``ticket_tickettype`` temporal trigger
 * exactly like a Settings-page save (module docstring) -- these are
 * plain ORM column writes, so ``emit_audit_row`` (the Rule-table gap
 * filler) is deliberately NOT used: it would double-audit. A noop
 * resend of the stored values writes nothing and leaves no history
 * row.
 */
export type UpdateTicketTypePortalCopy = {
  __typename: 'UpdateTicketTypePortalCopy';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  portalConfirmSubtitle?: Maybe<Scalars['String']['output']>;
  portalConfirmTitle?: Maybe<Scalars['String']['output']>;
  portalContactInformationNextButtonLabel?: Maybe<Scalars['String']['output']>;
  portalDateHelpText?: Maybe<Scalars['String']['output']>;
  portalDateLabel?: Maybe<Scalars['String']['output']>;
  portalDescription?: Maybe<Scalars['String']['output']>;
  portalDropdownHelpText?: Maybe<Scalars['String']['output']>;
  portalDropdownLabel?: Maybe<Scalars['String']['output']>;
  portalNoteHelpText?: Maybe<Scalars['String']['output']>;
  portalNoteLabel?: Maybe<Scalars['String']['output']>;
  portalServiceTypeBulkWasteLimitHelpText?: Maybe<Scalars['String']['output']>;
  portalServiceTypeBulkWasteLimitLabel?: Maybe<Scalars['String']['output']>;
  ticketTypeId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Narrow write of the flow-shaping citizen-form fields on one ticket
 * type ("what the citizen fills in"): date/note/dropdown shown+required,
 * the dropdown's options, the contact-information step's toggles, the
 * zero-price display switch, and the bulk-waste item limit / pickup
 * window.
 *
 * Field split (every portal field has exactly ONE narrow home): this
 * mutation owns the FLOW-SHAPING fields -- ``portal_date_hidden`` /
 * ``portal_date_required`` / ``portal_note_hidden`` /
 * ``portal_note_required`` / ``portal_dropdown_hidden`` /
 * ``portal_dropdown_required`` / ``portal_dropdown_options`` /
 * ``portal_require_contact_information`` /
 * ``portal_contact_information_name_required`` /
 * ``portal_contact_information_phone_number_required`` /
 * ``portal_contact_information_email_required`` /
 * ``portal_price_show_zero`` /
 * ``portal_service_type_bulk_waste_limit`` /
 * ``portal_date_min_days_in_future_for_bulk_waste`` /
 * ``portal_date_max_days_in_future_for_bulk_waste``. Every pure display
 * STRING the citizen reads (description, labels, help texts, confirm
 * title/subtitle, next-button label) belongs to
 * ``UpdateTicketTypePortalCopy`` below and is deliberately not
 * accepted here.
 *
 * The five citizen-page toggles ([PC-d2], W6-P2 intake extension) are
 * written verbatim onto their same-named model columns, independent
 * booleans exactly as everywhere else in the platform: the Settings
 * ModelForm (``TicketTypeForm``) declares no coupling between
 * ``portal_require_contact_information`` and the three
 * ``portal_contact_information_*_required`` flags, the Settings FE
 * renders the three require-checkboxes unconditionally (it does not
 * render -- or even send -- ``portal_require_contact_information`` at
 * all), and the citizen portal API scheme
 * (``crm/api/v1/schemes/company.py``) relays all five to the portal
 * client unconditionally. Whether a ``*_required`` flag has a visible
 * effect while the contact step is off is the citizen portal client's
 * rendering decision; no server-side dependency exists in the Settings
 * save, so none is invented here (the Autopilot FE panel owns any
 * disable/indent rendering logic).
 *
 * ``show_*`` inputs are the FE's positive spelling; stored inverted on
 * the real hidden columns exactly like FormTicketType's uiToApiValues
 * (show_portal_date -> portal_date_hidden = !value, note and dropdown
 * alike). Bulk-waste fields map to
 * ``portal_service_type_bulk_waste_limit`` /
 * ``portal_date_min_days_in_future_for_bulk_waste`` /
 * ``portal_date_max_days_in_future_for_bulk_waste`` and are refused for
 * non-bulk-waste service types (the citizen form never shows them
 * there). The managed-service rule the FE enforces client-side is
 * enforced server-side here: a managed type's dropdown can never be
 * shown, required or given options (``MANAGED_TICKET_SERVICE_TYPES``).
 *
 * Absent (or null) inputs are untouched. Audited by the platform's
 * ticket_tickettype temporal trigger like every Settings save.
 */
export type UpdateTicketTypePortalIntake = {
  __typename: 'UpdateTicketTypePortalIntake';
  bulkWasteLimit?: Maybe<Scalars['Int']['output']>;
  bulkWasteMaxDays?: Maybe<Scalars['Int']['output']>;
  bulkWasteMinDays?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  portalContactInformationEmailRequired?: Maybe<Scalars['Boolean']['output']>;
  portalContactInformationNameRequired?: Maybe<Scalars['Boolean']['output']>;
  portalContactInformationPhoneNumberRequired?: Maybe<Scalars['Boolean']['output']>;
  portalDateRequired?: Maybe<Scalars['Boolean']['output']>;
  portalDropdownOptions?: Maybe<Array<Scalars['String']['output']>>;
  portalDropdownRequired?: Maybe<Scalars['Boolean']['output']>;
  portalNoteRequired?: Maybe<Scalars['Boolean']['output']>;
  portalPriceShowZero?: Maybe<Scalars['Boolean']['output']>;
  portalRequireContactInformation?: Maybe<Scalars['Boolean']['output']>;
  showPortalDate?: Maybe<Scalars['Boolean']['output']>;
  showPortalDropdown?: Maybe<Scalars['Boolean']['output']>;
  showPortalNote?: Maybe<Scalars['Boolean']['output']>;
  ticketTypeId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Narrow write of one transition's RED-tier requirements: the
 * container gates (label printed / barcode scan / RFID pairing / bin
 * location) and the manual schedule-on-route veto. Writes ONLY
 * ``ContainerAction`` / ``ScheduleOnRouteAction(manual=True)`` rows on
 * that transition's ``Rule`` (created with the same get_or_create shape
 * ``UpdateOrCreateTicketType`` uses when the transition has none) --
 * never any other action kind, never the delete sweep.
 *
 * Semantics per control:
 *
 * * gates: absent keys untouched; the gates row exists iff any gate is
 *   true (an all-false merge deletes the canonical row -- no dead no-op
 *   rows dressed up as requirements).
 * * schedule_manual=true creates the manual veto unless the transition
 *   already schedules AUTOMATICALLY (a GREEN action this module must
 *   not silently flip; refused in plain words). schedule_manual=false
 *   removes manual veto rows only -- automatic scheduling rows are
 *   GREEN machinery and are never touched.
 * * superseded transition: skip-or-refuse (module docstring) -- equal
 *   target state is silently skipped, a differing one is refused with
 *   the platform's planner message.
 *
 * Audits one ``product.audit_logs`` row per effective change (module
 * docstring: the Rule tables have no temporal twin).
 */
export type UpdateTicketTypeRequirements = {
  __typename: 'UpdateTicketTypeRequirements';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  requireBarcodeScan?: Maybe<Scalars['Boolean']['output']>;
  requireContainerLocation?: Maybe<Scalars['Boolean']['output']>;
  requireLabelPrinted?: Maybe<Scalars['Boolean']['output']>;
  requireRfidPairing?: Maybe<Scalars['Boolean']['output']>;
  scheduleManual?: Maybe<Scalars['Boolean']['output']>;
  superseded?: Maybe<Scalars['Boolean']['output']>;
  ticketTypeId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Narrow write of the audience/surface flags on one ticket type:
 * ``enable_on_portal`` / ``enable_on_platform`` /
 * ``enable_on_navigation_app`` plus the driver attachment requirement
 * ``navigation_app_require_attachment``. Absent (or null) input flags
 * are untouched. Returns the flags as stored after the write, so the
 * builder's audience line can render from the response while
 * GET_AUTOPILOT_BUILD_TICKET_TYPES refetches.
 */
export type UpdateTicketTypeSurfaces = {
  __typename: 'UpdateTicketTypeSurfaces';
  enableOnNavigationApp?: Maybe<Scalars['Boolean']['output']>;
  enableOnPlatform?: Maybe<Scalars['Boolean']['output']>;
  enableOnPortal?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  navigationAppRequireAttachment?: Maybe<Scalars['Boolean']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  ticketTypeId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Narrow write of one transition's permission list: which company
 * roles may move a ticket of this type through the ``from_status ->
 * to_status`` step (the "Permission" multi-select the Settings
 * transition editor shows; stored as ``ticket.models.rule.Restriction``
 * roles, enforced by ``Ticket.can_set_status``). An EMPTY list means
 * the step is open to everyone -- exactly what a cleared Settings
 * select saves; an absent (or null) ``role_ids`` writes nothing and
 * just echoes the stored state.
 *
 * RBAC (decision, documented for the wave report): ``ticket_type__edit``
 * only -- the exact permission the Settings mutation requires for the
 * same write. Deliberately NOT ``automation__edit`` on top: a
 * Restriction gates which HUMANS may perform a manual status change; it
 * is not a row of the automation engine (that extra gate belongs to
 * ``UpdateTicketTypeRequirements``, which writes Rule/RuleAction rows).
 *
 * Supersession: NOT refused here, matching the Settings save exactly --
 * its transitions loop writes the Restriction BEFORE the supersession
 * skip/refusal, because a flow supersedes a transition's automated
 * ACTIONS, never who is allowed to move the ticket by hand.
 *
 * Audit: ``ticket_restriction`` has no temporal twin (the deploy
 * trigger list registers ticket_tickettype but no Rule/Restriction
 * tables), and Settings writes it unaudited today -- so like
 * ``UpdateTicketTypeRequirements`` this fills the gap with one
 * append-only ``product.audit_logs`` row per effective change,
 * entity_type ``autopilot.ticket_type_transition_roles``. A resend of
 * the stored role set writes nothing and leaves no row.
 */
export type UpdateTicketTypeTransitionRoles = {
  __typename: 'UpdateTicketTypeTransitionRoles';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  fromStatus?: Maybe<Scalars['Int']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  roleIds?: Maybe<Array<Scalars['ID']['output']>>;
  roleNames?: Maybe<Array<Scalars['String']['output']>>;
  ticketTypeId?: Maybe<Scalars['ID']['output']>;
  toStatus?: Maybe<Scalars['Int']['output']>;
};

/**
 * 3.9.6 per-ticket override: tighten/loosen ONE ticket's visibility
 * snapshot. Sets ``visibility_overridden=True`` (the bulk re-apply
 * action skips such rows) and writes a ``VISIBILITY_CHANGED``
 * ``TicketEvent`` for the ticket's history.
 */
export type UpdateTicketVisibility = {
  __typename: 'UpdateTicketVisibility';
  ticket?: Maybe<TicketDef>;
};

export type UpdateUnconfirmedUser = {
  __typename: 'UpdateUnconfirmedUser';
  unconfirmedUser?: Maybe<UnconfirmedUserType>;
};

export type UpdateUser = {
  __typename: 'UpdateUser';
  user?: Maybe<UserType>;
};

/**
 * Sets every role a user holds in the caller's company. Roles not listed
 * in roleIds are removed from the user.
 */
export type UpdateUserCompanyRoles = {
  __typename: 'UpdateUserCompanyRoles';
  user?: Maybe<UserType>;
};

export type UpdateUserContacts = {
  __typename: 'UpdateUserContacts';
  user?: Maybe<UserType>;
};

export type UpdateUserLayoutConfig = {
  __typename: 'UpdateUserLayoutConfig';
  userLayoutConfig?: Maybe<UserLayoutConfigType>;
};

/** Set the interface theme for the current user (PRODUCT-154). */
export type UpdateUserThemePreference = {
  __typename: 'UpdateUserThemePreference';
  user: UserType;
};

export type UpdateUsername = {
  __typename: 'UpdateUsername';
  token: Scalars['String']['output'];
  user: UserType;
};

/**
 * Edit the client-facing switches on the caller's company's Visma
 * settings (Company settings -> Visma).
 *
 * Only the arguments actually passed are written; an omitted argument
 * leaves the stored value alone, so the FE can send one switch at a time.
 * Today that is just ``pricesIncludeVat``; the argument list is the place
 * to add the next client-editable switch. Secrets (bearer token, service
 * URL) and the HWM cursor are deliberately NOT reachable here.
 */
export type UpdateVismaCompanySettings = {
  __typename: 'UpdateVismaCompanySettings';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  vismaCompanySettings?: Maybe<VismaCompanySettingsType>;
};

export type UpdateWasteCollector = {
  __typename: 'UpdateWasteCollector';
  wasteCollector?: Maybe<WasteCollectorType>;
};

export type UpdateWasteFraction = {
  __typename: 'UpdateWasteFraction';
  wasteFraction?: Maybe<WasteFractionType>;
};

/** PRO-946: replace the values of a version that is not yet locked. */
export type UpdateWasteFractionEnvironmentalFactor = {
  __typename: 'UpdateWasteFractionEnvironmentalFactor';
  environmentalFactor?: Maybe<WasteFractionEnvironmentalFactorType>;
};

export type UpdateWasteType = {
  __typename: 'UpdateWasteType';
  wasteType?: Maybe<WasteTypeType>;
};

/**
 * Upload any file into a case (stage A): workbooks and csvs
 * explode into candidate tables; nothing is rejected for shape,
 * wrong shape is information on the case. ``useFrontier`` opts the
 * stage B classification into the frontier-model pass for
 * ambiguous tabs (D54); the default is deterministic heuristics
 * only, no network.
 */
export type UploadCaseFileMutation = {
  __typename: 'UploadCaseFileMutation';
  candidateTables?: Maybe<Array<Maybe<CandidateTableDef>>>;
  importFile?: Maybe<ImportFileDef>;
};

/**
 * Office-only: attach a contract file to a contract area (R2-D20).
 *
 * Multipart ``Upload`` scalar (the ``importAreaBoundary`` path). The file
 * lands on private storage; 10 MB cap and an extension allowlist are
 * enforced in the write service.
 */
export type UploadContractAreaDocument = {
  __typename: 'UploadContractAreaDocument';
  document?: Maybe<ContractAreaDocumentDef>;
};

export type UpsertCompanyHolidayInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The day itself. For a yearly holiday only the day and month are used, so any year may be entered. */
  date: Scalars['Date']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Turn off to stop a holiday applying without losing the row — a year when a normally-closed day is worked. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Shown to the office and in the customer notice. */
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  recurrence: Scalars['String']['input'];
};

/**
 * HSY-258 — enter or adjust one company holiday.
 *
 * UPSERT on (company, date, name) rather than create-or-conflict:
 * re-entering the same holiday adjusts it instead of stacking a duplicate
 * that would fire its own collision for the same day.
 */
export type UpsertCompanyHolidayPayload = {
  __typename: 'UpsertCompanyHolidayPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companyHoliday?: Maybe<CompanyHolidayDef>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/**
 * PRODUCT-475 (BE-P2-5): allow or deny a waste fraction on a
 * container type (skip hire compatibility matrix). One row per pair -
 * re-setting the pair replaces its ``allowed`` value. ``allowed: false``
 * is the hard stop at booking; deleting the row (or never creating one)
 * means "allowed".
 */
export type UpsertContainerTypeWasteFractionRule = {
  __typename: 'UpsertContainerTypeWasteFractionRule';
  rule?: Maybe<ContainerTypeWasteFractionRuleType>;
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Create or update one authority row of the council fee table. With
 * ``id`` the row is updated; without it the row named
 * ``authorityName`` is created, or updated when it already exists.
 */
export type UpsertCouncilFeeEntry = {
  __typename: 'UpsertCouncilFeeEntry';
  entry?: Maybe<CouncilFeeTableEntryDef>;
};

export type UpsertFeatureConfigRule = {
  __typename: 'UpsertFeatureConfigRule';
  batch?: Maybe<FeatureConfigBatchType>;
  rule?: Maybe<FeatureConfigRuleType>;
};

/**
 * Create or update a property's invoice sync cadence config.
 *
 * Only the user-owned config field (frequency) is written; the
 * last_synced_* watermarks are advanced by the export task and never
 * touched here. A changed frequency is applied to the property's
 * recurring fees on the fly (``cadence_transition``), not only at the
 * nightly recurring-fee run.
 *
 * ``startPeriodOverride`` is retired (visma design decision 0005, removed
 * from the UI 2026-09). The argument is kept so already-deployed clients
 * keep validating against the schema, but its value is ignored - graphene 2
 * cannot mark an argument deprecated, so the description carries the notice
 * instead.
 */
export type UpsertPropertyInvoiceSyncConfig = {
  __typename: 'UpsertPropertyInvoiceSyncConfig';
  /** Set whenever the frequency changed (all zeros when no charge had to move); null when it did not change, and when the company has invoicing or product pricing switched off - the cadence is then stored but no schedule or fee is touched. */
  cadenceTransition?: Maybe<RecurringFeeCadenceTransitionDef>;
  invoiceSyncConfig?: Maybe<PropertyInvoiceSyncConfigDef>;
  property?: Maybe<PropertyDef>;
};

/**
 * Create or update a property's waste-water treatment survey (S6).
 *
 * The form submits the full desired state on every save: optional fields
 * that are not sent are cleared to their empty defaults. When the property
 * is connected to the sewage network the connection flag alone is
 * sufficient — the FE hides the survey fields in that case.
 */
export type UpsertPropertyWasteWaterTreatment = {
  __typename: 'UpsertPropertyWasteWaterTreatment';
  property?: Maybe<PropertyDef>;
  wasteWaterTreatment?: Maybe<PropertyWasteWaterTreatmentDef>;
};

export type UrbaserCredentialsDef = Node & {
  __typename: 'UrbaserCredentialsDef';
  company: CompanyType;
  contract: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  enabled: Scalars['Boolean']['output'];
  haulerIntegrationCallResponseHistory: IntegrationUrbaserCallResponseHistoryDefConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Last historical ticket or ticket related data migrated from Urbaser to keep track of the progress */
  lastHistoricalTicket?: Maybe<TicketDef>;
  mappingForCollectionCalendars: Scalars['JSONString']['output'];
  mappingForRouteScheme: Scalars['JSONString']['output'];
  mappingForTicketTypes: Scalars['JSONString']['output'];
  mappingForVehicles: Scalars['JSONString']['output'];
  password: Scalars['String']['output'];
  updateAgreementsScheduler: Scalars['Boolean']['output'];
  updateCollectionCalendersScheduler: Scalars['Boolean']['output'];
  updateRoutesScheduler: Scalars['Boolean']['output'];
  urbaseragreementssyncSet: IntegrationUrbaserAgreementsSyncDefConnection;
  username: Scalars['String']['output'];
  whbasicdataUrl: Scalars['String']['output'];
  whcalenderUrl: Scalars['String']['output'];
  whregUrl: Scalars['String']['output'];
  whregUrlLastId: Scalars['Int']['output'];
  whregimageImageUrl: Scalars['String']['output'];
  whregimageLastId: Scalars['Int']['output'];
};


export type UrbaserCredentialsDefHaulerIntegrationCallResponseHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UrbaserCredentialsDefUrbaseragreementssyncSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UrbaserCredentialsMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contract: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
  whbasicdataUrl: Scalars['String']['input'];
  whcalenderUrl: Scalars['String']['input'];
  whregUrl: Scalars['String']['input'];
  whregimageImageUrl: Scalars['String']['input'];
};

export type UrbaserCredentialsMutationPayload = {
  __typename: 'UrbaserCredentialsMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  urbaserCredentials?: Maybe<UrbaserCredentialsDef>;
};

export type UserAbsenceType = Node & {
  __typename: 'UserAbsenceType';
  absenceType: CoreUserAbsenceAbsenceTypeChoices;
  end: Scalars['Date']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  project: ProjectType;
  replacementUser: UserType;
  start: Scalars['Date']['output'];
  user: UserType;
};

export type UserAbsenceTypeConnection = {
  __typename: 'UserAbsenceTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserAbsenceTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `UserAbsenceType` and its cursor. */
export type UserAbsenceTypeEdge = {
  __typename: 'UserAbsenceTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserAbsenceType>;
};

export type UserContactEntryType = Node & {
  __typename: 'UserContactEntryType';
  contactLabel: Scalars['String']['output'];
  contactType: ContactTypeType;
  contactValue: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  user: UserType;
};

export type UserContactEntryTypeConnection = {
  __typename: 'UserContactEntryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserContactEntryTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserContactEntryType` and its cursor. */
export type UserContactEntryTypeEdge = {
  __typename: 'UserContactEntryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserContactEntryType>;
};

export type UserFilterCollectionType = Node & {
  __typename: 'UserFilterCollectionType';
  createdAt: Scalars['DateTime']['output'];
  /** JSON object containing filter criteria and settings */
  filters: Scalars['JSONString']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Whether this is the default filter for this table */
  isDefault: Scalars['Boolean']['output'];
  /** User-defined name for this filter collection */
  name: Scalars['String']['output'];
  /** Table/view identifier (e.g., 'routes', 'or-whatever', 'identidfies_the_table') */
  tableKey: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** User who owns this filter collection */
  user: UserType;
};

export type UserFilterCollectionTypeConnection = {
  __typename: 'UserFilterCollectionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserFilterCollectionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserFilterCollectionType` and its cursor. */
export type UserFilterCollectionTypeEdge = {
  __typename: 'UserFilterCollectionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserFilterCollectionType>;
};

export type UserJobNotificationSubscription = {
  __typename: 'UserJobNotificationSubscription';
  userJobNotification?: Maybe<UserJobNotificationType>;
};

export type UserJobNotificationType = Node & {
  __typename: 'UserJobNotificationType';
  companyEmailAccountMessage?: Maybe<CompanyEmailAccountMessageDef>;
  createdAt: Scalars['DateTime']['output'];
  /** The date the notification was read. */
  dateRead?: Maybe<Scalars['DateTime']['output']>;
  /** The date the notification was seen, but not read. */
  dateSeen?: Maybe<Scalars['DateTime']['output']>;
  event?: Maybe<JobNotificationEventUnion>;
  eventObjectId: Scalars['Int']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  ticket?: Maybe<TicketDef>;
  user: UserType;
};

export type UserJobNotificationTypeConnection = {
  __typename: 'UserJobNotificationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserJobNotificationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `UserJobNotificationType` and its cursor. */
export type UserJobNotificationTypeEdge = {
  __typename: 'UserJobNotificationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserJobNotificationType>;
};

export type UserLayoutConfigType = Node & {
  __typename: 'UserLayoutConfigType';
  analyticsCalculationType: CoreUserLayoutConfigAnalyticsCalculationTypeChoices;
  analyticsCustomPeriodComparisonFrom?: Maybe<Scalars['DateTime']['output']>;
  analyticsCustomPeriodComparisonTo?: Maybe<Scalars['DateTime']['output']>;
  analyticsCustomPeriodFrom?: Maybe<Scalars['DateTime']['output']>;
  analyticsCustomPeriodTo?: Maybe<Scalars['DateTime']['output']>;
  analyticsHistoricalPeriod: CoreUserLayoutConfigAnalyticsHistoricalPeriodChoices;
  analyticsPreviousPeriod: CoreUserLayoutConfigAnalyticsPreviousPeriodChoices;
  collectionContainersDisabledColumns: Array<Scalars['String']['output']>;
  collectionContainersOrder: Scalars['String']['output'];
  collectionContainersOrderBy: Scalars['String']['output'];
  collectionContainersPageSize: Scalars['Int']['output'];
  commentsDisabledColumns: Array<Scalars['String']['output']>;
  commentsOrder: Scalars['String']['output'];
  commentsOrderBy: Scalars['String']['output'];
  commentsPageSize: Scalars['Int']['output'];
  containersDisabledColumns: Array<Scalars['String']['output']>;
  containersOrder: Scalars['String']['output'];
  containersOrderBy: Scalars['String']['output'];
  containersPageSize: Scalars['Int']['output'];
  driverDisabledColumns: Array<Scalars['String']['output']>;
  driverIconsSize: Scalars['String']['output'];
  driverOrder: Scalars['String']['output'];
  driverOrderBy: Scalars['String']['output'];
  driverPageSize: Scalars['Int']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  inquiryDisabledColumns: Array<Scalars['String']['output']>;
  inquiryOrder: Scalars['String']['output'];
  inquiryOrderBy: Scalars['String']['output'];
  inquiryPageSize: Scalars['Int']['output'];
  locationsDisabledColumns: Array<Scalars['String']['output']>;
  locationsIconsSize: Scalars['String']['output'];
  locationsOrder: Scalars['String']['output'];
  locationsOrderBy: Scalars['String']['output'];
  locationsPageSize: Scalars['Int']['output'];
  notificationsDisabledColumns: Array<Scalars['String']['output']>;
  notificationsOrder: Scalars['String']['output'];
  notificationsOrderBy: Scalars['String']['output'];
  notificationsPageSize: Scalars['Int']['output'];
  pickupOrdersDisabledColumns: Array<Scalars['String']['output']>;
  pickupOrdersOrder: Scalars['String']['output'];
  pickupOrdersOrderBy: Scalars['String']['output'];
  pickupOrdersPageSize: Scalars['Int']['output'];
  routeDisabledColumns: Array<Scalars['String']['output']>;
  routeOrder: Scalars['String']['output'];
  routeOrderBy: Scalars['String']['output'];
  routePageSize: Scalars['Int']['output'];
  user?: Maybe<UserType>;
  vehicleDisabledColumns: Array<Scalars['String']['output']>;
  vehicleIconsSize: Scalars['String']['output'];
  vehicleOrder: Scalars['String']['output'];
  vehicleOrderBy: Scalars['String']['output'];
  vehiclePageSize: Scalars['Int']['output'];
  vehicleTypesDisabledColumns: Array<Scalars['String']['output']>;
  vehicleTypesOrder: Scalars['String']['output'];
  vehicleTypesOrderBy: Scalars['String']['output'];
  vehicleTypesPageSize: Scalars['Int']['output'];
};

export type UserNotificationEventUnion = AreaExpiringEventDef | AutopilotStaffNoticeEventDef | ChangeProposalDef | CompanyEmailAccountMessageEventDef | CompostingFiledEventDef | FixedRouteAttentionEventDef | StockAlertEventDef | TicketCommentDef | TicketEventDef | TicketMessageDef;

export type UserNotificationEventsUnionDef = CompanyEmailAccountMessageDef | TicketDef;

export type UserNotificationSubscription = {
  __typename: 'UserNotificationSubscription';
  userNotification?: Maybe<UserNotificationType>;
};

export type UserNotificationType = Node & {
  __typename: 'UserNotificationType';
  companyEmailAccountMessage?: Maybe<CompanyEmailAccountMessageDef>;
  createdAt: Scalars['DateTime']['output'];
  /** The date the notification was read. */
  dateRead?: Maybe<Scalars['DateTime']['output']>;
  /** The date the notification was seen, but not read. */
  dateSeen?: Maybe<Scalars['DateTime']['output']>;
  event?: Maybe<UserNotificationEventUnion>;
  eventObjectId: Scalars['Int']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** The users who have read the notification. */
  readBy: UserTypeConnection;
  /** The users who have seen the notification. */
  seenBy: UserTypeConnection;
  ticket?: Maybe<TicketDef>;
  user: UserType;
};


export type UserNotificationTypeReadByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserNotificationTypeSeenByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UserNotificationTypeConnection = {
  __typename: 'UserNotificationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserNotificationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `UserNotificationType` and its cursor. */
export type UserNotificationTypeEdge = {
  __typename: 'UserNotificationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserNotificationType>;
};

export type UserNotificationsCounterType = {
  __typename: 'UserNotificationsCounterType';
  directNotificationsCount?: Maybe<Scalars['Int']['output']>;
  followingNotificationsCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserNotificationsEventsWrapper = {
  __typename: 'UserNotificationsEventsWrapper';
  edges?: Maybe<Array<Maybe<UserNotificationEventsUnionDef>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserProjectType = Node & {
  __typename: 'UserProjectType';
  apiKey: Scalars['UUID']['output'];
  deviceContainerCreate: Scalars['Boolean']['output'];
  deviceContainerDelete: Scalars['Boolean']['output'];
  deviceContainerEdit: Scalars['Boolean']['output'];
  fleetManagementDriverCreate: Scalars['Boolean']['output'];
  fleetManagementDriverDelete: Scalars['Boolean']['output'];
  fleetManagementDriverEdit: Scalars['Boolean']['output'];
  fleetManagementLocationCreate: Scalars['Boolean']['output'];
  fleetManagementLocationDelete: Scalars['Boolean']['output'];
  fleetManagementLocationEdit: Scalars['Boolean']['output'];
  fleetManagementVehicleAbsenceCreate: Scalars['Boolean']['output'];
  fleetManagementVehicleAbsenceDelete: Scalars['Boolean']['output'];
  fleetManagementVehicleAbsenceEdit: Scalars['Boolean']['output'];
  fleetManagementVehicleCreate: Scalars['Boolean']['output'];
  fleetManagementVehicleDelete: Scalars['Boolean']['output'];
  fleetManagementVehicleEdit: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** This user has permission to change project settings. */
  isSuper: Scalars['Boolean']['output'];
  project: ProjectType;
  routesInquiryCreate: Scalars['Boolean']['output'];
  routesInquiryDelete: Scalars['Boolean']['output'];
  routesInquiryEdit: Scalars['Boolean']['output'];
  routesPickupSettingCreate: Scalars['Boolean']['output'];
  routesPickupSettingDelete: Scalars['Boolean']['output'];
  routesPickupSettingEdit: Scalars['Boolean']['output'];
  routesRouteCreate: Scalars['Boolean']['output'];
  routesRouteDelete: Scalars['Boolean']['output'];
  routesRouteEdit: Scalars['Boolean']['output'];
  routesRouteSchemeCreate: Scalars['Boolean']['output'];
  routesRouteSchemeDelete: Scalars['Boolean']['output'];
  routesRouteSchemeEdit: Scalars['Boolean']['output'];
  user: UserType;
  userManagementUserAbsenceCreate: Scalars['Boolean']['output'];
  userManagementUserAbsenceDelete: Scalars['Boolean']['output'];
  userManagementUserAbsenceEdit: Scalars['Boolean']['output'];
  userManagementUserCreate: Scalars['Boolean']['output'];
  userManagementUserDelete: Scalars['Boolean']['output'];
  userManagementUserEdit: Scalars['Boolean']['output'];
};

export type UserProjectTypeConnection = {
  __typename: 'UserProjectTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserProjectTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserProjectType` and its cursor. */
export type UserProjectTypeEdge = {
  __typename: 'UserProjectTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserProjectType>;
};

export type UserType = Node & {
  __typename: 'UserType';
  activeProjects?: Maybe<ProjectTypeConnection>;
  activeProjectsIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  activeToken: Scalars['String']['output'];
  alertSet: AlertDefConnection;
  alertrecipientSet: AlertRecipientDefConnection;
  assignedTickets: TicketDefConnection;
  assigntouseractionSet: AssignToUserActionDefConnection;
  authorOfComments: CommentTypeConnection;
  billingrunSet: BillingRunDefConnection;
  billingrunexportSet: BillingRunExportDefConnection;
  brokerType?: Maybe<CoreIoUserBrokerTypeChoices>;
  brokerUserId?: Maybe<Scalars['String']['output']>;
  bulkactionprogressSet: BulkActionProgressDefConnection;
  /** Hex color code */
  color?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyType>;
  companyRole?: Maybe<CompanyRoleDef>;
  companyRoles?: Maybe<Array<CompanyRoleDef>>;
  companyemailaccountmessageSet: CompanyEmailAccountMessageDefConnection;
  companyemailaccountruleSet: CompanyEmailAccountRuleDefConnection;
  contactEntries: UserContactEntryTypeConnection;
  contacts?: Maybe<Array<UserContactEntryType>>;
  containerbarcodegenerationhistorySet: ContainerBarcodeGenerationHistoryDefConnection;
  correctedLoads: TruckloadTypeConnection;
  costsettingsSet: CostSettingsTypeConnection;
  createdAt: Scalars['DateTime']['output'];
  createdChangeProposals: ChangeProposalDefConnection;
  createdExportTemplates: ExportTemplateDefConnection;
  /** User who manually triggered this dispatch via GraphQL. Null for automatic dispatches triggered by ticket completion. */
  createdSvarutDispatches: SvarUtDispatchTypeConnection;
  creatorOfKmdEasyPropertyTypeToKmdEasyStationCodeMap: PropertyTypeToKmdEasyStationCodeMapDefConnection;
  /** User who created this note */
  customernoteSet: CustomerNoteDefConnection;
  dashboardConfigs?: Maybe<Array<Maybe<DashboardConfig>>>;
  dateJoined: Scalars['DateTime']['output'];
  datetimeFormatLocale: CoreIoUserDatetimeFormatLocaleChoices;
  daysBeforeDemoExpires?: Maybe<Scalars['Int']['output']>;
  debtorexportSet: DebtorExportDefConnection;
  decidedChangeProposals: ChangeProposalDefConnection;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  deleterOfKmdEasyPropertyTypeToKmdEasyStationCodeMap: PropertyTypeToKmdEasyStationCodeMapDefConnection;
  demoExpireDate?: Maybe<Scalars['Date']['output']>;
  driver?: Maybe<DriverType>;
  driverpushnotificationSet: DriverPushNotificationTypeConnection;
  email: Scalars['String']['output'];
  exportHistory: ExportHistoryDefConnection;
  exportInternalRecipients: ExportHistoryDefConnection;
  exportTemplateInternalRecipients: ExportTemplateDefConnection;
  externalCrmId?: Maybe<Scalars['String']['output']>;
  fcmdeviceSet: FcmDeviceTypeConnection;
  /** User who owns this filter collection */
  filterCollections: UserFilterCollectionTypeConnection;
  firstName: Scalars['String']['output'];
  followedTickets: TicketDefConnection;
  freshdeskToken?: Maybe<Scalars['String']['output']>;
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  groups: GroupTypeConnection;
  hauler?: Maybe<HaulerDef>;
  haulerpricechangelogSet: HaulerPriceChangeLogDefConnection;
  iamUserId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importHistory: ImportHistoryDefConnection;
  inquiries: CollectionInquiryTypeConnection;
  intercomUserHash?: Maybe<Scalars['String']['output']>;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Designates that this user has an access to Beta features. */
  isBeta: Scalars['Boolean']['output'];
  /** Designates that this user has all permissions but can`t edit any data. */
  isDemo: Scalars['Boolean']['output'];
  /** Designates that this user has an access to Developer features. */
  isDeveloper: Scalars['Boolean']['output'];
  isDriver?: Maybe<Scalars['Boolean']['output']>;
  isEmail: Scalars['Boolean']['output'];
  isHaulerUser?: Maybe<Scalars['Boolean']['output']>;
  /** Designates that this user has permissions to create projects, and assign users to them. */
  isMaster: Scalars['Boolean']['output'];
  isPureDriver?: Maybe<Scalars['Boolean']['output']>;
  isPush: Scalars['Boolean']['output'];
  /** (Resellers / partners) Designates that this user has all permissions without explicitly assigning them in companies created by him. */
  isReseller: Scalars['Boolean']['output'];
  isSms: Scalars['Boolean']['output'];
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean']['output'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean']['output'];
  jobTitle?: Maybe<JobTitleType>;
  jobtitle?: Maybe<JobTitleType>;
  kmdEasyDeltaFiles: KmdEasyDeltaFileDefConnection;
  kmdEasyImportedFiles: ImportedKmdEasyFileDefConnection;
  kmdEasyTotalFiles: KmdEasyTotalFileDefConnection;
  language: CoreIoUserLanguageChoices;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  /** User who completed the stop manually */
  manuallyCompletedPickupOrders: PickUpOrderTypeConnection;
  metaTypesCanEdit?: Maybe<Array<CompanyMetaTypeDef>>;
  metaTypesCanView?: Maybe<Array<CompanyMetaTypeDef>>;
  mixpanelIdentity?: Maybe<Scalars['JSONString']['output']>;
  notificationSet: NotificationsTypeConnection;
  notificationsettingsSet: NotificationSettingsTypeConnection;
  ownProjects?: Maybe<ProjectTypeConnection>;
  ownProjectsIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  password: Scalars['String']['output'];
  permissions?: Maybe<Array<PermissionChoices>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pickuporderSet: PickUpOrderTypeConnection;
  /** User who created this note */
  propertynoteSet: PropertyNoteDefConnection;
  propertyvieweventSet: PropertyViewEventDefConnection;
  provisioningStatus?: Maybe<CoreIoUserProvisioningStatusChoices>;
  refinerSignature?: Maybe<Scalars['String']['output']>;
  replacementUser: UserAbsenceTypeConnection;
  routeHaulerReassignments: RouteHaulerReassignmentLogTypeConnection;
  routeVehicleDriverReassignments: RouteVehicleDriverReassignmentLogTypeConnection;
  routeexportSet: RouteExportTypeConnection;
  salesofferSet: SalesOfferTypeConnection;
  scimUserId?: Maybe<Scalars['String']['output']>;
  /** NULL when the move came from a driver session rather than a platform user. */
  taskHaulerReassignments: TaskHaulerReassignmentLogTypeConnection;
  teams: TeamTypeConnection;
  themePreference: CoreIoUserThemePreferenceChoices;
  ticketSet: TicketDefConnection;
  ticketdraftSet: TicketDraftDefConnection;
  ticketvieweventSet: TicketViewEventDefConnection;
  unconfirmeduser?: Maybe<UnconfirmedUserType>;
  updatedAt: Scalars['DateTime']['output'];
  useSso: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  userLayoutConfig?: Maybe<UserLayoutConfigType>;
  /** Specific permissions for this user. */
  userPermissions: PermissionTypeConnection;
  userabsenceSet: UserAbsenceTypeConnection;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String']['output'];
  usernotificationSet: UserNotificationTypeConnection;
  userprojectSet: UserProjectTypeConnection;
  workTaskCorrections: WorkTaskCorrectionTypeConnection;
};


export type UserTypeActiveProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyProjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  projectsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type UserTypeAlertSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeAlertrecipientSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeAssignedTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeAssigntouseractionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeAuthorOfCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeBillingrunSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeBillingrunexportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeBulkactionprogressSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCompanyemailaccountmessageSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCompanyemailaccountruleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeContactEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeContainerbarcodegenerationhistorySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCorrectedLoadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  openedAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCostsettingsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCreatedChangeProposalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCreatedExportTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCreatedSvarutDispatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticket?: InputMaybe<Scalars['ID']['input']>;
  useCase?: InputMaybe<Scalars['String']['input']>;
};


export type UserTypeCreatorOfKmdEasyPropertyTypeToKmdEasyStationCodeMapArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCustomernoteSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeDebtorexportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeDecidedChangeProposalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeDeleterOfKmdEasyPropertyTypeToKmdEasyStationCodeMapArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeDriverpushnotificationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeExportHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeExportInternalRecipientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeExportTemplateInternalRecipientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeFcmdeviceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeFilterCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeFollowedTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeHaulerpricechangelogSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeImportHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeInquiriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeKmdEasyDeltaFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeKmdEasyImportedFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeKmdEasyTotalFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeManuallyCompletedPickupOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeNotificationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status_Iexact?: InputMaybe<Scalars['String']['input']>;
};


export type UserTypeNotificationsettingsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeOwnProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypePickuporderSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypePropertynoteSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypePropertyvieweventSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeReplacementUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeRouteHaulerReassignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeRouteVehicleDriverReassignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeRouteexportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeSalesofferSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeTaskHaulerReassignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeTicketSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeTicketdraftSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeTicketvieweventSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeUserPermissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeUserabsenceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeUsernotificationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeUserprojectSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeWorkTaskCorrectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** User config */
export type UserTypeConfigType = {
  __typename: 'UserTypeConfigType';
  config?: Maybe<Scalars['JSONString']['output']>;
};

export type UserTypeConnection = {
  __typename: 'UserTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `UserType` and its cursor. */
export type UserTypeEdge = {
  __typename: 'UserTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserType>;
};

export type ValidateAutomationPayload = {
  __typename: 'ValidateAutomationPayload';
  errors: Array<GraphErrorDef>;
  ok: Scalars['Boolean']['output'];
};

/**
 * Dry-run: returns all blocking issues (addressed to fields) without
 * creating anything, so the wizard can flag gaps before the user commits.
 */
export type ValidateRouteSetupMutation = {
  __typename: 'ValidateRouteSetupMutation';
  issues?: Maybe<Array<Maybe<RouteSetupIssueType>>>;
};

/**
 * RS-E28 (stage H, D61): one client verdict on one route
 * identity of one materialization version. Waivers are recorded on
 * the row (who, when, why), never silent (D62); acceptance labels
 * are data, not code.
 */
export type ValidationVerdictDef = Node & {
  __typename: 'ValidationVerdictDef';
  acceptanceLabel: Scalars['String']['output'];
  case: ImportCaseDef;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  materialization: CaseMaterializationDef;
  note: Scalars['String']['output'];
  routeIdentity: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  verdict: RouteStudioValidationVerdictVerdictChoices;
  waived: Scalars['Boolean']['output'];
  waivedAt?: Maybe<Scalars['DateTime']['output']>;
  waiverNote: Scalars['String']['output'];
};

export type ValidationVerdictDefConnection = {
  __typename: 'ValidationVerdictDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ValidationVerdictDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ValidationVerdictDef` and its cursor. */
export type ValidationVerdictDefEdge = {
  __typename: 'ValidationVerdictDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ValidationVerdictDef>;
};

export type VehicleAbsenceType = Node & {
  __typename: 'VehicleAbsenceType';
  absenceType: Scalars['String']['output'];
  end: Scalars['Date']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  project: ProjectType;
  replacementVehicle: VehicleType;
  start: Scalars['Date']['output'];
  vehicle: VehicleType;
};

export type VehicleAbsenceTypeConnection = {
  __typename: 'VehicleAbsenceTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VehicleAbsenceTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `VehicleAbsenceType` and its cursor. */
export type VehicleAbsenceTypeEdge = {
  __typename: 'VehicleAbsenceTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VehicleAbsenceType>;
};

export type VehicleAnalyticsType = {
  __typename: 'VehicleAnalyticsType';
  objects?: Maybe<VehicleTypeConnection>;
  objects_Count?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};


export type VehicleAnalyticsTypeObjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * One delivered vehicle signal — the office's audit trail for REQ 31.
 *
 * No ``fields``/``exclude`` in Meta (house convention): a column added to
 * the model is published automatically, and the model's ``help_text`` is the
 * user-facing documentation.
 */
export type VehicleConfirmationSignalType = Node & {
  __typename: 'VehicleConfirmationSignalType';
  /** Idempotency key minted by the emitter. Re-delivering the same client_id repeats the original outcome; it never confirms a second stop. */
  clientId: Scalars['String']['output'];
  /** Tenant the emitting vehicle belongs to. */
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  /** Identifier of the emitting reader/telematics unit. */
  deviceId: Scalars['String']['output'];
  /** Metres between the signal's position and the matched stop. NULL when nothing was matched. */
  distanceM?: Maybe<Scalars['Float']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** What the vehicle reported. */
  kind: RoutesVehicleConfirmationSignalKindChoices;
  /** Stop this signal confirmed. NULL when unmatched. */
  matchedPickupOrder?: Maybe<PickUpOrderType>;
  /** Net weight the signal carried, when it carried one. Written onto the confirmed stop's weight. */
  netWeightKg?: Maybe<Scalars['Float']['output']>;
  /** When the VEHICLE reported it — not when we received it. This is what the stop's completed_at is stamped from, so a signal delivered late still records the truth about when the bin was handled. */
  occurredAt: Scalars['DateTime']['output'];
  /** Where the vehicle was (x=lon, y=lat). NULL is a real answer: a signal with no position cannot be resolved to a stop and is rejected with NO_POSITION rather than guessed at. */
  point?: Maybe<Scalars['GeoJSON']['output']>;
  /** Why the signal was not applied — NO_VEHICLE, NO_ROUTE, NO_POSITION, NO_STOP_IN_RANGE, ALREADY_COMPLETED, COMPLETION_REJECTED. Empty string when it WAS applied. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Route the signal was resolved against. NULL when no active route could be found — the signal is still recorded. */
  route?: Maybe<RouteType>;
  /** Whether the signal was applied to a stop. */
  status: RoutesVehicleConfirmationSignalStatusChoices;
  /** Tag the vehicle read alongside the signal, when its reader supplies one. Recorded for provenance; tag->stop resolution itself belongs to COMPASS-881. */
  tagId: Scalars['String']['output'];
  /** Vehicle that emitted the signal. */
  vehicle: VehicleType;
};

export type VehicleConfirmationSignalTypeConnection = {
  __typename: 'VehicleConfirmationSignalTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VehicleConfirmationSignalTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `VehicleConfirmationSignalType` and its cursor. */
export type VehicleConfirmationSignalTypeEdge = {
  __typename: 'VehicleConfirmationSignalTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VehicleConfirmationSignalType>;
};

export type VehicleDepotsDef = Node & {
  __typename: 'VehicleDepotsDef';
  depot: DepotType;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  vehicle: VehicleType;
};

export type VehicleDepotsEventDef = Node & {
  __typename: 'VehicleDepotsEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<GenericMtmEventTypesGraphene>>>;
  fromDepot?: Maybe<DepotType>;
  fromVehicle?: Maybe<VehicleType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toDepot?: Maybe<DepotType>;
  toVehicle?: Maybe<VehicleType>;
  user?: Maybe<UserType>;
  vehicleDepots?: Maybe<VehicleDepotsDef>;
};

/** Per-vehicle driven-routes summary over the requested range. */
export type VehicleDrivenRoutesReportDef = {
  __typename: 'VehicleDrivenRoutesReportDef';
  /** Days in the range with a session or breadcrumb. */
  activeDays: Scalars['Int']['output'];
  /** Total driven distance in km over the range — sum of the sessions' real_distance (metres) ÷ 1000. */
  drivenDistanceKm: Scalars['Float']['output'];
  /** The routes driven, newest scheduled day first. */
  drivenRoutes: Array<DrivenRouteEntryDef>;
  /** Number of routes driven in the range. */
  drivenRoutesCount: Scalars['Int']['output'];
  /** False when the vehicle had no session and no breadcrumb in the whole range — surfaced as inactive, never as fake zeros. */
  hadActivity: Scalars['Boolean']['output'];
  /** The specific inactive days (ascending). */
  inactiveDates: Array<Scalars['Date']['output']>;
  /** Days in the range with NO session and NO breadcrumb — the honest 'did nothing' count (range length when never active). */
  inactiveDays: Scalars['Int']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  /** Relay id of the VehicleType node. */
  vehicleId: Scalars['ID']['output'];
  vehicleName: Scalars['String']['output'];
};

export type VehicleEventDef = Node & {
  __typename: 'VehicleEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<VehicleEventTypesGraphene>>>;
  fromExternalIdentifier?: Maybe<Scalars['String']['output']>;
  fromLicensePlate?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  fromStatus?: Maybe<Scalars['String']['output']>;
  fromVehicleType?: Maybe<VehicleTypeType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toExternalIdentifier?: Maybe<Scalars['String']['output']>;
  toLicensePlate?: Maybe<Scalars['String']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
  toStatus?: Maybe<Scalars['String']['output']>;
  toVehicleType?: Maybe<VehicleTypeType>;
  user?: Maybe<UserType>;
  vehicle?: Maybe<VehicleType>;
};

export type VehicleEventLogEvent = VehicleDepotsEventDef | VehicleEventDef;

export type VehicleEventLogEventWrapper = {
  __typename: 'VehicleEventLogEventWrapper';
  edges?: Maybe<Array<Maybe<VehicleEventLogEvent>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum VehicleEventTypesGraphene {
  EXTERNAL_IDENTIFIER_CHANGE = 'EXTERNAL_IDENTIFIER_CHANGE',
  LICENSE_PLATE_CHANGE = 'LICENSE_PLATE_CHANGE',
  NAME_CHANGE = 'NAME_CHANGE',
  STATUS_CHANGE = 'STATUS_CHANGE',
  VEHICLE_TYPE_CHANGE = 'VEHICLE_TYPE_CHANGE'
}

/** Slim live-location payload. */
export type VehicleLocationType = {
  __typename: 'VehicleLocationType';
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
  vehicleId: Scalars['ID']['output'];
};

export type VehicleSignalIngestPayload = {
  __typename: 'VehicleSignalIngestPayload';
  /** True when the signal is applied to a stop — by this call, or by an identical earlier delivery of the same clientId. A retrying reader therefore converges instead of retrying forever. */
  accepted: Scalars['Boolean']['output'];
  /** Metres between the signal and the matched stop. */
  distanceM?: Maybe<Scalars['Float']['output']>;
  /** orderId of the stop this signal confirmed, if any. */
  matchedOrderId?: Maybe<Scalars['String']['output']>;
  /** Why it was not applied: NO_VEHICLE, NO_ROUTE, NO_POSITION, NO_STOP_IN_RANGE, COMPLETION_REJECTED. DUPLICATE is not a failure — it flags a replay and is returned alongside the original outcome. Empty on a fresh success. */
  reason?: Maybe<Scalars['String']['output']>;
  /** The persisted record. Null only for NO_VEHICLE, the one rejection with no company to file evidence under. */
  signal?: Maybe<VehicleConfirmationSignalType>;
};

/**
 * What a vehicle reports. Every field is exactly what the emitter knows.
 *
 * ``clientId`` is required and is the idempotency key: a reader on a truck
 * with intermittent coverage WILL re-send, and re-sending must never confirm
 * a second stop.
 */
export type VehicleSignalInput = {
  /** Idempotency key minted by the emitter. Re-sending the same value repeats the original outcome and confirms nothing twice. */
  clientId: Scalars['String']['input'];
  /** Identifier of the emitting reader / telematics unit. */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** LIFT_CYCLE records the stop as auto-completed by LIFT; WEIGH_COMPLETE records it as SCALE. The kind alone decides the provenance, so an ingest cannot claim a signal the hardware did not produce. */
  kind: VehicleSignalKind;
  /** WGS84. Required in practice — see longitude. */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** WGS84. A signal without a position is rejected with NO_POSITION rather than guessed at: there is no honest way to tell which bin the lift arm just emptied. */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Net weight the signal carried; written onto the stop. */
  netWeightKg?: InputMaybe<Scalars['Float']['input']>;
  /** When the VEHICLE reported it. Becomes the stop's completedAt, so a late delivery does not rewrite when the work happened. Defaults to now. */
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional. Omit and the vehicle's started-but-not-completed route is used. */
  routeId?: InputMaybe<Scalars['ID']['input']>;
  /** Tag read alongside the signal, when the reader has one. */
  tagId?: InputMaybe<Scalars['String']['input']>;
  /** Relay id of the emitting vehicle (VehicleType). */
  vehicleId: Scalars['ID']['input'];
};

/**
 * What a vehicle reported when it emitted a confirmation signal
 *     (COMPASS-880 / HSY REQ 31, the "or equivalent" clause).
 *
 *     Each kind maps to exactly one :class:`AutoCompletedByChoices` member via
 *     :data:`VEHICLE_SIGNAL_PROVENANCE`, so an ingested signal can never be
 *     recorded under a provenance the hardware did not produce.
 *
 */
export enum VehicleSignalKind {
  LIFT_CYCLE = 'LIFT_CYCLE',
  WEIGH_COMPLETE = 'WEIGH_COMPLETE'
}

export type VehicleSizeDef = Node & {
  __typename: 'VehicleSizeDef';
  deleted?: Maybe<Scalars['DateTime']['output']>;
  height: Scalars['Float']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profile: Scalars['String']['output'];
  roadClassesToAvoid?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  vehicleSet: VehicleTypeConnection;
  width: Scalars['Float']['output'];
};


export type VehicleSizeDefVehicleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type VehicleSizeDefConnection = {
  __typename: 'VehicleSizeDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VehicleSizeDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `VehicleSizeDef` and its cursor. */
export type VehicleSizeDefEdge = {
  __typename: 'VehicleSizeDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VehicleSizeDef>;
};

/**
 * Live vehicle positions (``onVehiclePositionChange``).
 *
 * Auth contract (live-ops W2a — W4's push feed builds on this):
 *
 * 1. **Connection**: the client connects to ``ws/graphql/`` and sends
 *    ``connection_init`` with ``payload: {"auth_token": "<JWT>"}``.
 *    ``GraphqlWsConsumer.on_connect`` resolves it via
 *    ``graphql_jwt.shortcuts.get_user_by_token`` into ``scope["user"]``
 *    (``AnonymousUser`` when absent/invalid), which resolvers see as
 *    ``info.context.user``.
 * 2. **Subscribe**: ``@login_required`` rejects unauthenticated users
 *    with ``PermissionDenied``. Then EVERY requested vehicle id must
 *    resolve to a vehicle of the user's company
 *    (vehicle → project → company) via ``_allowed_vehicle_ids`` — one
 *    foreign or unknown id denies the whole subscription with a clean
 *    error. No superuser/reseller bypass: tenancy is strict.
 * 3. **Groups**: one group per vehicle (``graphql-vehicle-<pk>``);
 *    ``routes.signals.send_change_vehicle_location`` broadcasts a
 *    vehicle only to its own group, so group membership — granted only
 *    after the subscribe check — IS the authorization boundary.
 *    ``publish`` stays a pass-through and applies no further filtering.
 * 4. **Hauler seam**: contractor scoping later slots into
 *    ``_allowed_vehicle_ids`` (single chokepoint) without touching
 *    subscribe/publish or the group layout.
 */
export type VehicleSubscription = {
  __typename: 'VehicleSubscription';
  vehicle?: Maybe<VehicleType>;
};

export type VehicleTrailerMultipleChoiceFieldInput = {
  containerTypes: Array<InputMaybe<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  ticketHolds: Array<InputMaybe<Scalars['ID']['input']>>;
  wasteHolds: Array<InputMaybe<VehicleTrailerWasteHoldMultipleChoiceFieldInput>>;
};

export type VehicleTrailerTicketTypeHoldType = Node & {
  __typename: 'VehicleTrailerTicketTypeHoldType';
  capacity: Scalars['Int']['output'];
  company: CompanyType;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  ticketType: TicketTypeDef;
  vehicletrailerSet: VehicleTrailerTypeConnection;
};


export type VehicleTrailerTicketTypeHoldTypeVehicletrailerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type VehicleTrailerTicketTypeHoldTypeConnection = {
  __typename: 'VehicleTrailerTicketTypeHoldTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VehicleTrailerTicketTypeHoldTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `VehicleTrailerTicketTypeHoldType` and its cursor. */
export type VehicleTrailerTicketTypeHoldTypeEdge = {
  __typename: 'VehicleTrailerTicketTypeHoldTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VehicleTrailerTicketTypeHoldType>;
};

export type VehicleTrailerType = Node & {
  __typename: 'VehicleTrailerType';
  company: CompanyType;
  containerTypes: ContainerTypeTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  routeVehicles: RouteVehicleTypeConnection;
  routeschemevehicledaySet: RouteSchemeVehicleDayTypeConnection;
  ticketHolds: VehicleTrailerTicketTypeHoldTypeConnection;
  vehicletypeSet: VehicleTypeTypeConnection;
  wasteHolds: VehicleTrailerWasteHoldTypeConnection;
};


export type VehicleTrailerTypeContainerTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type VehicleTrailerTypeRouteVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type VehicleTrailerTypeRouteschemevehicledaySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type VehicleTrailerTypeTicketHoldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type VehicleTrailerTypeVehicletypeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type VehicleTrailerTypeWasteHoldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type VehicleTrailerTypeConnection = {
  __typename: 'VehicleTrailerTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VehicleTrailerTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `VehicleTrailerType` and its cursor. */
export type VehicleTrailerTypeEdge = {
  __typename: 'VehicleTrailerTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VehicleTrailerType>;
};

export type VehicleTrailerWasteHoldMultipleChoiceFieldInput = {
  capacity: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  industryCapacity: Scalars['Int']['input'];
  switchCapacity: Scalars['Int']['input'];
  wasteFraction: Scalars['ID']['input'];
};

export type VehicleTrailerWasteHoldType = Node & {
  __typename: 'VehicleTrailerWasteHoldType';
  capacity: Scalars['Int']['output'];
  company: CompanyType;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  industryCapacity?: Maybe<Scalars['Int']['output']>;
  switchCapacity?: Maybe<Scalars['Int']['output']>;
  vehicletrailerSet: VehicleTrailerTypeConnection;
  wasteFraction: WasteFractionType;
};


export type VehicleTrailerWasteHoldTypeVehicletrailerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type VehicleTrailerWasteHoldTypeConnection = {
  __typename: 'VehicleTrailerWasteHoldTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VehicleTrailerWasteHoldTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `VehicleTrailerWasteHoldType` and its cursor. */
export type VehicleTrailerWasteHoldTypeEdge = {
  __typename: 'VehicleTrailerWasteHoldTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VehicleTrailerWasteHoldType>;
};

/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleType = Node & {
  __typename: 'VehicleType';
  /** Current stopping place */
  activeDepot?: Maybe<DepotType>;
  /** CO2 emissiom per kilometer (less is better) */
  co2EmissionPerKm?: Maybe<Scalars['Decimal']['output']>;
  /** Hex color code */
  color?: Maybe<Scalars['String']['output']>;
  /** Relation to the Comment */
  comments: CommentTypeConnection;
  /** Vehicle that emitted the signal. */
  confirmationSignals: VehicleConfirmationSignalTypeConnection;
  containerSet: ContainerTypeConnection;
  /** Vehicle can have many days available (add them comma-separated) */
  daysAvailable: Array<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** Stopping places */
  depots: DepotTypeConnection;
  /** Vehicles a driver has access to. For assistant drivers this field can be empty. */
  drivers: DriverTypeConnection;
  eventLog?: Maybe<VehicleEventLogEventWrapper>;
  /** Vehicle identification number (VIN) */
  externalIdentifier: Scalars['String']['output'];
  /** Fixed cost for the Vehicle per day */
  fixedCost?: Maybe<Scalars['Decimal']['output']>;
  /** Fixed route templates written for this one truck. Normally there are none: a template is scheme-wide (no vehicle) and governs every route the scheme generates, whatever truck the solver assigned. A row that names a vehicle is an override for that truck alone, and wins over the scheme-wide row. */
  fixedRouteTemplates: FixedRouteTemplateTypeConnection;
  /** Fuel cost per kilometer (less is better) */
  fuelCostPerKm?: Maybe<Scalars['Decimal']['output']>;
  /** Fuel cost per litter (less is better) */
  fuelCostPerLtr?: Maybe<Scalars['Decimal']['output']>;
  fuelTankCapacity?: Maybe<Array<Scalars['Decimal']['output']>>;
  fuelType?: Maybe<Scalars['String']['output']>;
  /** Fuel usage per kilometer (less is better) */
  fuelUsagePerKm?: Maybe<Scalars['Decimal']['output']>;
  hasPrimaryDriver?: Maybe<Scalars['Boolean']['output']>;
  /** Contractor that owns this vehicle. */
  hauler?: Maybe<HaulerDef>;
  hours?: Maybe<Array<Scalars['Int']['output']>>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  integrationgpsvehicleSet: IntegrationGpsVehicleTypeConnection;
  isActive: Scalars['Boolean']['output'];
  isOnRoute?: Maybe<Scalars['Boolean']['output']>;
  /** Vehicle's license plate number */
  licensePlateNumber: Scalars['String']['output'];
  /** The load's anchor, and requirement 218's axis. A load outlives its route and its vehicle session. */
  loads: TruckloadTypeConnection;
  /** The vehicle that really carried the load. */
  loadsCorrected: TruckloadTypeConnection;
  logo: Scalars['String']['output'];
  /** Vehicle's manufacturer */
  manufacturer: Scalars['String']['output'];
  /** Vehicle manufacturer's year */
  manufacturerYear: Scalars['String']['output'];
  metaData: Scalars['JSONString']['output'];
  /** Vehicle's model */
  model: Scalars['String']['output'];
  /** Vehicle's naming */
  name: Scalars['String']['output'];
  onRouteId?: Maybe<Scalars['String']['output']>;
  primaryDriver?: Maybe<DriverType>;
  project: ProjectType;
  realtimeLocation?: Maybe<LocationWithContainerType>;
  replacementVehicle: VehicleAbsenceTypeConnection;
  rfidVehicles?: Maybe<RfidVehicleConnectionDef>;
  /** Vehicle driver was in on the route */
  routeLocationHistories: RouteLocationHistoryDefConnection;
  /** Vehicle that is used in the route */
  routeVehicles: RouteVehicleTypeConnection;
  /** Vehicles that can be used in the route and is defined in the route scheme. Used to keep track of the vehicles that can be used in the route. Which in its turn is used to know which drivers can be assigned to the route depending on vehicles they can drive. */
  routesFromRouteScheme: RouteTypeConnection;
  routeschemeSet: RouteSchemeTypeConnection;
  routeschemevehicledaySet: RouteSchemeVehicleDayTypeConnection;
  searchUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *
   *             Indicates if the vehicle is either unavailable, working or not working.
   *             Can hold one of the following string values: 'working', 'off-work', 'unavailable'
   *
   */
  status?: Maybe<Scalars['String']['output']>;
  /** Vehicle's trim */
  trim: Scalars['String']['output'];
  /** Unique identifier for the vehicle in the external system */
  uniqueExternalId: Scalars['String']['output'];
  vehicleSize: VehicleSizeDef;
  /** Type of vehicle */
  vehicleType: VehicleTypeType;
  vehicleabsenceSet: VehicleAbsenceTypeConnection;
  /** Vehicle for this waste fraction */
  wasteCapacity: VehicleWasteCapacityTypeConnection;
  wasteFractionCapacity: WasteFractionTypeConnection;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeConfirmationSignalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeContainerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeDepotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeDriversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeEventLogArgs = {
  addVehicleDepotsEvents?: InputMaybe<Scalars['Boolean']['input']>;
  addVehicleEvents?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  vehicleDepotsEventTypes?: InputMaybe<Array<InputMaybe<GenericMtmEventTypesGraphene>>>;
  vehicleEventTypes?: InputMaybe<Array<InputMaybe<VehicleEventTypesGraphene>>>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeFixedRouteTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeIntegrationgpsvehicleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeLoadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  openedAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeLoadsCorrectedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  openedAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeReplacementVehicleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeRouteLocationHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeRouteVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeRoutesFromRouteSchemeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeRouteschemeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeRouteschemevehicledaySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeVehicleabsenceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeWasteCapacityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes Vehicle, has relation to :model:`fleet_management.VehicleWasteCapacity` */
export type VehicleTypeWasteFractionCapacityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type VehicleTypeConnection = {
  __typename: 'VehicleTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VehicleTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `VehicleType` and its cursor. */
export type VehicleTypeEdge = {
  __typename: 'VehicleTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VehicleType>;
};

export type VehicleTypeType = Node & {
  __typename: 'VehicleTypeType';
  Type: Scalars['String']['output'];
  /** Type of vehicle's body */
  body: Scalars['String']['output'];
  /** Type of body's mechanization */
  bodyMechanization: Scalars['String']['output'];
  /** CO2 emissiom per kilometer (less is better) */
  co2EmissionPerKm?: Maybe<Scalars['Decimal']['output']>;
  /** With compactor */
  compactor: Scalars['String']['output'];
  company: CompanyType;
  /** Crane variant */
  crane: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  emissionClass?: Maybe<Scalars['String']['output']>;
  /** Fixed cost for the Vehicle per day */
  fixedCost?: Maybe<Scalars['Decimal']['output']>;
  /** Fuel cost per kilometer (less is better) */
  fuelCostPerKm?: Maybe<Scalars['Decimal']['output']>;
  /** Fuel cost per litter (less is better) */
  fuelCostPerLtr?: Maybe<Scalars['Decimal']['output']>;
  fuelTankCapacity?: Maybe<Array<Scalars['Decimal']['output']>>;
  /** Vehicle fuel type */
  fuelType?: Maybe<Scalars['String']['output']>;
  /** Fuel usage per kilometer (less is better) */
  fuelUsagePerKm?: Maybe<Scalars['Decimal']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isUsed?: Maybe<Scalars['Boolean']['output']>;
  /** Type of lifting's mechanization */
  liftingMechanization: Scalars['String']['output'];
  /** Type of loading location */
  loadingLocation: Scalars['String']['output'];
  /** Vehicle's manufacturer */
  manufacturer: Scalars['String']['output'];
  /** Vehicle manufacturer's year */
  manufacturerYear: Scalars['String']['output'];
  migratedFromId?: Maybe<Scalars['String']['output']>;
  /** Vehicle's model */
  model: Scalars['String']['output'];
  /** Name of vehicle type */
  name: Scalars['String']['output'];
  routeSettings: RouteSettingsTypeConnection;
  trailers: VehicleTrailerTypeConnection;
  /** Vehicle's trim */
  trim: Scalars['String']['output'];
  /** Type of vehicle */
  vehicles: VehicleTypeConnection;
};


export type VehicleTypeTypeRouteSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type VehicleTypeTypeTrailersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type VehicleTypeTypeVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type VehicleTypeTypeConnection = {
  __typename: 'VehicleTypeTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VehicleTypeTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `VehicleTypeType` and its cursor. */
export type VehicleTypeTypeEdge = {
  __typename: 'VehicleTypeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VehicleTypeType>;
};

/** Describes relation between :model:`wastecollector.WasteFraction` and :model:`fleet_management.Vehicle` */
export type VehicleWasteCapacityType = Node & {
  __typename: 'VehicleWasteCapacityType';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Volume capacity allowed for each of waste fractions */
  maxAllowedVolume: Scalars['Float']['output'];
  /** Weight capacity allowed for each of waste fractions */
  maxAllowedWeight: Scalars['Float']['output'];
  /** Vehicle for this waste fraction */
  vehicle: VehicleType;
  /** Waste fraction for this vehicle type */
  wasteFraction: WasteFractionType;
};

export type VehicleWasteCapacityTypeConnection = {
  __typename: 'VehicleWasteCapacityTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VehicleWasteCapacityTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `VehicleWasteCapacityType` and its cursor. */
export type VehicleWasteCapacityTypeEdge = {
  __typename: 'VehicleWasteCapacityTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VehicleWasteCapacityType>;
};

export type Verify = {
  __typename: 'Verify';
  payload?: Maybe<PayloadType>;
  user?: Maybe<UserType>;
};

/**
 * Second step of an MFA login: exchange a valid code for the JWT.
 *
 * On success this is where the session is actually created — mint the token,
 * pin ``active_token`` (single-active-session), stamp ``last_login`` and fire
 * the ``user:login`` Segment event, mirroring the SSO out-of-band issuance
 * (``sso_auth/views.py``) and the ``@set_jwt_cookie`` decorator. Every
 * failure mode surfaces as the same uniform error.
 */
export type VerifyMfaCode = {
  __typename: 'VerifyMfaCode';
  token?: Maybe<Scalars['String']['output']>;
};

/**
 * Status-card data for the Visma integration screen.
 *
 * Exposes only non-sensitive config. Bearer token and service URL are
 * intentionally omitted — they are write-only secrets managed by ops.
 */
export type VismaCompanySettingsType = {
  __typename: 'VismaCompanySettingsType';
  enabled: Scalars['Boolean']['output'];
  /** Earliest Invoice.issued_at to consider on the first run when the HWM cursor is NULL. For HRA, the cut-over date when WH took over invoicing. */
  epochFallback: Scalars['DateTime']['output'];
  /** Visma firm ID. HRA test=9990; production firm ID set by Asgeir. */
  firmId: Scalars['Int']['output'];
  /** True for HRA — appends R1 (Avdeling), CustPrGr (price group), CustPrG2 (deductions) to each @Actor line in personer.edi. */
  includePersonerExtensions: Scalars['Boolean']['output'];
  /** Most recent Invoice.issued_at successfully exported. Advances in the same transaction as the SUCCEEDED log write. Governs ordrersr.edi delta only; personer/avtaler are full refreshes. */
  lastSuccessfulIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** R-slot that holds the municipality number in this company's Visma setup. WasteHero default=R11; HRA=R2. */
  municipalitySlot: VismaVismaCompanySettingsMunicipalitySlotChoices;
  /** Send unit prices including VAT (Visma company configured with IncludesVat). Default off: net unit prices, Visma adds MVA. */
  pricesIncludeVat: Scalars['Boolean']['output'];
};

/**
 * One agreement an export run left out, and the stable reason code.
 *
 * Plain ObjectType (not a node): rows are only reachable through their
 * parent ``VismaExportLogType``, which is already tenant-scoped, so there is
 * no global id to leak across companies. The FE maps ``reason`` to a label.
 */
export type VismaDroppedAgreementDef = {
  __typename: 'VismaDroppedAgreementDef';
  /** crm.Agreement id, if any. */
  agreementId?: Maybe<Scalars['Int']['output']>;
  /** crm.Property id. */
  propertyId: Scalars['Int']['output'];
  /** Cadastral reference (Property.external_property_number) when known; empty otherwise. */
  propertyNumber?: Maybe<Scalars['String']['output']>;
  /** Stable code: no_payer_contact, no_cadastral_ref, no_agreement_no, missing_external_contact_id. */
  reason: Scalars['String']['output'];
};

/** GraphQL representation of a single Visma export run. */
export type VismaExportLogType = Node & {
  __typename: 'VismaExportLogType';
  agreementCount: Scalars['Int']['output'];
  attempts: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Currency code of totalAmount / totalNetAmount (the company currency). */
  currency?: Maybe<Scalars['String']['output']>;
  customerCount: Scalars['Int']['output'];
  /** Total number of droppedAgreements rows stored for this run. */
  droppedAgreementCount?: Maybe<Scalars['Int']['output']>;
  /** Agreements this run left out, with the reason. Complete for the run unless summaryJson.dropped_list_truncated is true. */
  droppedAgreements?: Maybe<Array<Maybe<VismaDroppedAgreementDef>>>;
  /** {reason_code: count} for the dropped agreements (summaryJson.dropped_by_reason). */
  droppedByReason?: Maybe<Scalars['JSONString']['output']>;
  errorMessage: Scalars['String']['output'];
  exportRunId?: Maybe<Scalars['String']['output']>;
  filesJson?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  invoiceCount: Scalars['Int']['output'];
  invoices?: Maybe<Array<Maybe<InvoiceDef>>>;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  productTotalsJson?: Maybe<Scalars['JSONString']['output']>;
  status: VismaVismaExportLogStatusChoices;
  summaryJson?: Maybe<Scalars['JSONString']['output']>;
  totalAmount?: Maybe<Scalars['Decimal']['output']>;
  totalNetAmount?: Maybe<Scalars['Decimal']['output']>;
  triggeredBy?: Maybe<UserType>;
  updatedAt: Scalars['DateTime']['output'];
};


/** GraphQL representation of a single Visma export run. */
export type VismaExportLogTypeDroppedAgreementsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL representation of a single Visma export run. */
export type VismaExportLogTypeInvoicesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type VismaExportLogTypeConnection = {
  __typename: 'VismaExportLogTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VismaExportLogTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `VismaExportLogType` and its cursor. */
export type VismaExportLogTypeEdge = {
  __typename: 'VismaExportLogTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VismaExportLogType>;
};

/**
 * Dry-run result — what the next export run would send.
 *
 * Computed by running build_export_payload() against the live DB with
 * the same window the next coordinator run would use. No service call,
 * no DB writes. Used to populate the confirmation modal and disable the
 * "Run now" button when invoice_count=0.
 */
export type VismaExportPreviewType = {
  __typename: 'VismaExportPreviewType';
  agreementCount?: Maybe<Scalars['Int']['output']>;
  /** Currency code of totalAmount / totalNetAmount (the company currency). */
  currency?: Maybe<Scalars['String']['output']>;
  customerCount?: Maybe<Scalars['Int']['output']>;
  customerCountCompany?: Maybe<Scalars['Int']['output']>;
  customerCountIndividual?: Maybe<Scalars['Int']['output']>;
  droppedAgreementCount?: Maybe<Scalars['Int']['output']>;
  droppedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  droppedLineCount?: Maybe<Scalars['Int']['output']>;
  gatedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  invoiceCount?: Maybe<Scalars['Int']['output']>;
  invoiceCountCompany?: Maybe<Scalars['Int']['output']>;
  invoiceCountIndividual?: Maybe<Scalars['Int']['output']>;
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  skippedCustomerCount?: Maybe<Scalars['Int']['output']>;
  /** Sum of the totals (incl. VAT) of the invoices that would be sent. */
  totalAmount?: Maybe<Scalars['Decimal']['output']>;
  /** NET sum of the order lines that would be sent (net unit price x quantity) - the net accounting value of the lines, whatever unit prices the file carries (net by default, gross when pricesIncludeVat is on). totalAmount is the VAT-inclusive figure. */
  totalNetAmount?: Maybe<Scalars['Decimal']['output']>;
};

/** An enumeration. */
export enum VismaVismaCompanySettingsMunicipalitySlotChoices {
  /** R2 — Prosjekt slot (HRA) */
  R2 = 'R2',
  /** R11 — Kommune slot (WasteHero default) */
  R11 = 'R11'
}

/** An enumeration. */
export enum VismaVismaExportLogStatusChoices {
  /** Failed */
  FAILED = 'FAILED',
  /** In progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Pending */
  PENDING = 'PENDING',
  /** Skipped */
  SKIPPED = 'SKIPPED',
  /** Succeeded */
  SUCCEEDED = 'SUCCEEDED'
}

/**
 * RS-E28 stage H (D61/D62): explicitly waive flagged routes so
 * the sign-off can complete with the flags on record. The waiver
 * note is mandatory and recorded (who, when, why), never silent;
 * only flagged routes can be waived.
 */
export type WaiveValidationFlagsMutation = {
  __typename: 'WaiveValidationFlagsMutation';
  importCase?: Maybe<ImportCaseDef>;
  materialization?: Maybe<CaseMaterializationDef>;
  progress?: Maybe<Scalars['GenericScalar']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  waived?: Maybe<Scalars['Int']['output']>;
};

/** A user who gets a warehouse's low-stock alerts (bell + e-mail). */
export type WarehouseAlertRecipientType = {
  __typename: 'WarehouseAlertRecipientType';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** UserType:<pk> relay id. */
  userId: Scalars['ID']['output'];
};

export type WarehouseBalanceRowType = {
  __typename: 'WarehouseBalanceRowType';
  alertsEnabled?: Maybe<Scalars['Boolean']['output']>;
  available?: Maybe<Scalars['Int']['output']>;
  critical?: Maybe<Scalars['Int']['output']>;
  fitsContainerTypeIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  incoming?: Maybe<Scalars['Int']['output']>;
  itemKind?: Maybe<Scalars['String']['output']>;
  itemTypeId?: Maybe<Scalars['ID']['output']>;
  itemTypeName?: Maybe<Scalars['String']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
  onHand?: Maybe<Scalars['Int']['output']>;
  /** Outstanding quantity on open purchase orders for this item here. */
  onOrder?: Maybe<Scalars['Int']['output']>;
  partTypeId?: Maybe<Scalars['ID']['output']>;
  partTypeName?: Maybe<Scalars['String']['output']>;
  reserved?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  stockLevel?: Maybe<Scalars['String']['output']>;
};

/**
 * One registry row, flattened for the read side of the
 * Containers tab (ADR-0005: identities in transit on this
 * warehouse's behalf - the shelf is a count and lists nothing).
 * ``id`` is the relay global id of the existing ContainerType node
 * so pairing can address the container.
 */
export type WarehouseContainerRowType = {
  __typename: 'WarehouseContainerRowType';
  barcode?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Scalars['String']['output']>;
  /**
   * The unit's structured condition (PRO-391) — distinct from the legacy
   * `condition` field above.
   */
  conditionTypeId?: Maybe<Scalars['ID']['output']>;
  conditionTypeName?: Maybe<Scalars['String']['output']>;
  containerLabel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inboundReturn?: Maybe<Scalars['Boolean']['output']>;
  itemTypeId?: Maybe<Scalars['ID']['output']>;
  itemTypeName?: Maybe<Scalars['String']['output']>;
  lastMovementAt?: Maybe<Scalars['DateTime']['output']>;
  lastMovementReason?: Maybe<Scalars['String']['output']>;
  lastMovementTicketId?: Maybe<Scalars['ID']['output']>;
  lastMovementToDepotName?: Maybe<Scalars['String']['output']>;
  lastMovementType?: Maybe<Scalars['String']['output']>;
  originPropertyId?: Maybe<Scalars['ID']['output']>;
  originPropertyName?: Maybe<Scalars['String']['output']>;
  ownership?: Maybe<Scalars['String']['output']>;
  returnTicketId?: Maybe<Scalars['ID']['output']>;
  returnToDepotName?: Maybe<Scalars['String']['output']>;
  rfid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  warrantyEnd?: Maybe<Scalars['Date']['output']>;
  warrantyMonths?: Maybe<Scalars['Int']['output']>;
  warrantyStart?: Maybe<Scalars['Date']['output']>;
};

export type WarehouseMovementActorType = {
  __typename: 'WarehouseMovementActorType';
  actorId?: Maybe<Scalars['ID']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
};

/**
 * One ledger row, flattened for the read-only Movements tab.
 *
 * ticket_id is the relay global id of the existing TicketDef node so
 * the frontend can deep-link without re-encoding anything.
 */
export type WarehouseMovementRowType = {
  __typename: 'WarehouseMovementRowType';
  actorName?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Scalars['String']['output']>;
  containerId?: Maybe<Scalars['ID']['output']>;
  containerLabel?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  fromDepotId?: Maybe<Scalars['ID']['output']>;
  fromDepotName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  itemTypeId?: Maybe<Scalars['ID']['output']>;
  itemTypeName?: Maybe<Scalars['String']['output']>;
  /** "delivery"/"pickup" for a customer-bound issue/return, else the raw movementType. */
  movementKind?: Maybe<Scalars['String']['output']>;
  movementType?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  propertyId?: Maybe<Scalars['ID']['output']>;
  propertyName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  /** 3.5.70: Ordered/Delivered/Returned/Removed; null with no customer obligation. */
  reportingStatus?: Maybe<Scalars['String']['output']>;
  routeId?: Maybe<Scalars['ID']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
  routeStopId?: Maybe<Scalars['ID']['output']>;
  sourceKind?: Maybe<Scalars['String']['output']>;
  ticketDescription?: Maybe<Scalars['String']['output']>;
  ticketId?: Maybe<Scalars['ID']['output']>;
  toDepotId?: Maybe<Scalars['ID']['output']>;
  toDepotName?: Maybe<Scalars['String']['output']>;
};

/**
 * One page of the Movements history. The ledger grows without
 * bound, so the tab pages server-side (offset/first); total_count is
 * the filtered size, capped at the tab's scan ceiling, for the pager.
 */
export type WarehouseMovementsPage = {
  __typename: 'WarehouseMovementsPage';
  rows: Array<Maybe<WarehouseMovementRowType>>;
  totalCount: Scalars['Int']['output'];
};

/**
 * PRO-390: one open (not-yet-completed) delivery/removal ticket
 * already dispatched on an active route stop - the In-transit tab's
 * forward-looking "who is coming" queue. Vehicle, driver and expected
 * date come from the dispatched task's own route
 * (:func:`inventory.selectors.transit.planned_ticket_movements`);
 * transfers carry no such row (back-office, no route behind them).
 */
export type WarehousePlannedMovementRowType = {
  __typename: 'WarehousePlannedMovementRowType';
  driverId?: Maybe<Scalars['ID']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  expectedDate?: Maybe<Scalars['Date']['output']>;
  itemTypeId?: Maybe<Scalars['ID']['output']>;
  itemTypeName?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  propertyId?: Maybe<Scalars['ID']['output']>;
  propertyName?: Maybe<Scalars['String']['output']>;
  reportingStatus?: Maybe<Scalars['String']['output']>;
  routeId?: Maybe<Scalars['ID']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
  ticketId?: Maybe<Scalars['ID']['output']>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
  vehicleName?: Maybe<Scalars['String']['output']>;
};

/**
 * One page of the In-storage listing. Bulk import can materialise
 * thousands of on-shelf identities, so the tab pages server-side
 * (offset/first) instead of shipping the whole shelf to the browser.
 * ``total_count`` is the full filtered size, for the pager.
 */
export type WarehouseStoredContainersPage = {
  __typename: 'WarehouseStoredContainersPage';
  anonymousRemainder: Scalars['Int']['output'];
  individuallyTracked: Scalars['Int']['output'];
  onHand: Scalars['Int']['output'];
  rows: Array<Maybe<WarehouseContainerRowType>>;
  totalCount: Scalars['Int']['output'];
};

/**
 * The warehouse-detail KPI numbers: "In transit (N incoming)",
 * "Reserved on open tickets" and "Adjustments · 30 days".
 */
export type WarehouseTransitSummaryType = {
  __typename: 'WarehouseTransitSummaryType';
  adjustments30Days?: Maybe<Scalars['Int']['output']>;
  inTransit?: Maybe<Scalars['Int']['output']>;
  incoming?: Maybe<Scalars['Int']['output']>;
  reserved?: Maybe<Scalars['Int']['output']>;
};

/**
 * The hard approval gate: only the designated approver (see
 * WashListDef.canApprove) approves; anybody else is refused typed
 * (NOT_DESIGNATED) with nothing written.
 */
export type WashListApprove = {
  __typename: 'WashListApprove';
  washList?: Maybe<WashListDef>;
};

/**
 * §6.7 steps 1-4: create a DRAFT wash list - bins scoped to the
 * (service area, waste category), refinable; the washing ticket type
 * named or the company's first; window pre-filled from the
 * per-(ticket type, area) table when omitted; provider defaulting from
 * the area's contractor.
 */
export type WashListCreate = {
  __typename: 'WashListCreate';
  washList?: Maybe<WashListDef>;
};

/**
 * A wash list - company-walled and flag-gated; list AND node reads
 * both funnel through ``get_queryset``.
 */
export type WashListDef = Node & {
  __typename: 'WashListDef';
  approvalRecord?: Maybe<Scalars['JSONString']['output']>;
  /** When the standing approval was given; cleared when voided. */
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who gave the standing approval; cleared when voided. */
  approvedBy?: Maybe<UserType>;
  /** The service area this wash list plans (§6.7 step 1). */
  area: AreaDef;
  /** Whether the caller may give the final approval (the designated approver: holders of the company's container washing approver role or, when none is nominated, masters and superusers). washListApprove refuses NOT_DESIGNATED for anybody else. */
  canApprove: Scalars['Boolean']['output'];
  company: CompanyType;
  containers: Array<Maybe<ContainerType>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** Execution window end (§6.7 step 3, to). */
  executionEnd: Scalars['Date']['output'];
  /** Execution window start (§6.7 step 3, from). */
  executionStart: Scalars['Date']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** The cleaning provider - a hauler reference defaulting from the area's contractor, overridable per §6.7 step 4. */
  provider?: Maybe<HaulerDef>;
  /** BE-served: the standing approval was voided (edit / recall / stale digest) and the list must be approved again — the FE renders it, never re-derives it. */
  reapprovalRequired: Scalars['Boolean']['output'];
  /** draft | awaiting_approval | approved | in_production */
  state: Scalars['String']['output'];
  /** The container washing ticket type production mints one ticket per bin of. */
  ticketType: TicketTypeDef;
  /** The audit trail, oldest first, with each step's actor resolved (user + the name stamped at the time) and its machine-read kind; `transitions` is the same trail as raw JSON. */
  transitionLog: Array<WashListTransitionDef>;
  transitions: Scalars['JSONString']['output'];
  /** The waste category whose bins this list washes. */
  wasteFraction: WasteFractionType;
};

export type WashListDefConnection = {
  __typename: 'WashListDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WashListDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `WashListDef` and its cursor. */
export type WashListDefEdge = {
  __typename: 'WashListDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<WashListDef>;
};

export type WashListForward = {
  __typename: 'WashListForward';
  washList?: Maybe<WashListDef>;
};

/**
 * One bin of the prefill's scope, for the refine-selection UI. Served
 * HERE because the prefill's entry check is the only bin read the
 * contractor supervisor's door has - the container list roots are
 * office-walled, and the refine modal must work from both doors. ``id``
 * matches ``bin_ids`` entry for entry.
 */
export type WashListPrefillBinDef = {
  __typename: 'WashListPrefillBinDef';
  containerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
};

/**
 * What the creation screen pre-fills for (area, waste category): the
 * suggested window from the per-(ticket type, area) table (null when no
 * row exists), the provider defaulting from the area's contractor, the
 * designatable providers (§6.7 step 4), the washing ticket types (the
 * first one pre-selected) and the enumerated bins scope.
 */
export type WashListPrefillDef = {
  __typename: 'WashListPrefillDef';
  binCount: Scalars['Int']['output'];
  binIds: Array<Scalars['ID']['output']>;
  bins: Array<WashListPrefillBinDef>;
  executionEnd?: Maybe<Scalars['Date']['output']>;
  executionStart?: Maybe<Scalars['Date']['output']>;
  provider?: Maybe<HaulerDef>;
  providers: Array<WashListPrefillProviderDef>;
  ticketType?: Maybe<TicketTypeDef>;
  ticketTypes: Array<WashListPrefillTicketTypeDef>;
};

/**
 * One designatable cleaning provider (§6.7 step 4) - the company's
 * haulers. ``id`` is the HaulerDef global id, matching both the
 * ``provider`` default and the create mutation's ``providerId``.
 */
export type WashListPrefillProviderDef = {
  __typename: 'WashListPrefillProviderDef';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/**
 * One of the company's container washing ticket types - the create
 * screen's ticket-type select. ``id`` is the TicketTypeDef global id,
 * matching the create/update mutations' ``ticketTypeId``.
 */
export type WashListPrefillTicketTypeDef = {
  __typename: 'WashListPrefillTicketTypeDef';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type WashListRecall = {
  __typename: 'WashListRecall';
  washList?: Maybe<WashListDef>;
};

export type WashListReject = {
  __typename: 'WashListReject';
  washList?: Maybe<WashListDef>;
};

/**
 * Mint one container ticket per bin of the approved plan; with
 * ``routeId`` the tickets are put straight on that route.
 */
export type WashListSendToProduction = {
  __typename: 'WashListSendToProduction';
  washList?: Maybe<WashListDef>;
};

/**
 * One step of a wash list's audit trail, with the actor RESOLVED for
 * the timeline: ``by`` is the user (null when the account is gone),
 * ``byName`` the name stamped when the step was taken (so the trail
 * reads the same after a rename or a deletion). ``kind`` is the
 * machine-read step type (created / forwarded / approved / rejected /
 * recalled / edited / approval_voided / sent_to_production); ``note``
 * is the free text (an approver's rejection reason, say).
 */
export type WashListTransitionDef = {
  __typename: 'WashListTransitionDef';
  at?: Maybe<Scalars['DateTime']['output']>;
  by?: Maybe<UserType>;
  byName: Scalars['String']['output'];
  fromState?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  note: Scalars['String']['output'];
  toState: Scalars['String']['output'];
};

/**
 * Edit under the corrections ruling: awaiting-approval edits re-enter
 * draft, approved edits void the approval (re-approval required),
 * produced lists are immutable history.
 */
export type WashListUpdate = {
  __typename: 'WashListUpdate';
  washList?: Maybe<WashListDef>;
};

/** Store information about Waste Collector */
export type WasteCollectorType = Node & {
  __typename: 'WasteCollectorType';
  /** Naming of company */
  companyName: Scalars['String']['output'];
  containers: ContainerTypeConnection;
  email: Array<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Collector's, phone number */
  phone?: Maybe<Scalars['String']['output']>;
};


/** Store information about Waste Collector */
export type WasteCollectorTypeContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * PRO-946: a dated version of a waste fraction's environmental factors.
 *
 * The office environmental account uses the version valid on each
 * collection's date; see ``wastecollector.services.environmental_factors``.
 */
export type WasteFractionEnvironmentalFactorType = Node & {
  __typename: 'WasteFractionEnvironmentalFactorType';
  assumedFillPercentage?: Maybe<Scalars['Float']['output']>;
  co2eFactor?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  densityKgM3?: Maybe<Scalars['Float']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  recyclingPercentage?: Maybe<Scalars['Float']['output']>;
  source: Scalars['String']['output'];
  validFrom: Scalars['Date']['output'];
};

export type WasteFractionEventDef = Node & {
  __typename: 'WasteFractionEventDef';
  authorityEntry?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType?: Maybe<Array<Maybe<WasteFractionEventTypesGraphene>>>;
  fromColor?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  fromWasteCategory?: Maybe<Scalars['String']['output']>;
  fromWasteSubstance?: Maybe<Scalars['String']['output']>;
  fromWasteType?: Maybe<Scalars['String']['output']>;
  fromWeightFactor?: Maybe<Scalars['Float']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  state?: Maybe<HistoryObjectStateGraphene>;
  sysPeriod?: Maybe<Scalars['RangeDateTimeScalar']['output']>;
  toColor?: Maybe<Scalars['String']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
  toWasteCategory?: Maybe<Scalars['String']['output']>;
  toWasteSubstance?: Maybe<Scalars['String']['output']>;
  toWasteType?: Maybe<Scalars['String']['output']>;
  toWeightFactor?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<UserType>;
  wasteFraction?: Maybe<WasteFractionType>;
};

export enum WasteFractionEventTypesGraphene {
  COLOR_CHANGE = 'COLOR_CHANGE',
  NAME_CHANGE = 'NAME_CHANGE',
  WASTE_CATEGORY_CHANGE = 'WASTE_CATEGORY_CHANGE',
  WASTE_SUBSTANCE_CHANGE = 'WASTE_SUBSTANCE_CHANGE',
  WASTE_TYPE_CHANGE = 'WASTE_TYPE_CHANGE',
  WEIGHT_FACTOR_CHANGE = 'WEIGHT_FACTOR_CHANGE'
}

export type WasteFractionType = Node & {
  __typename: 'WasteFractionType';
  adsFractionCode?: Maybe<Scalars['String']['output']>;
  alertruleSet: AlertRuleDefConnection;
  binsCount?: Maybe<Scalars['Float']['output']>;
  bulkwastepickupticketitemSet: BulkWastePickupTicketItemDefConnection;
  collectedKg?: Maybe<Scalars['Float']['output']>;
  collectedM3?: Maybe<Scalars['Float']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  containerSet: ContainerTypeConnection;
  containerTypeRules: ContainerTypeWasteFractionRuleTypeConnection;
  containerTypes: ContainerTypeTypeConnection;
  containers: ContainerTypeConnection;
  costsettingsSet: CostSettingsTypeConnection;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** Relation to the WasteFraction */
  depots: DepotTypeConnection;
  emptyingIntervalMax?: Maybe<Scalars['Int']['output']>;
  emptyingIntervalMin?: Maybe<Scalars['Int']['output']>;
  energyRecovery?: Maybe<Scalars['Decimal']['output']>;
  /** Dated environmental factor versions, newest first. */
  environmentalFactors: Array<WasteFractionEnvironmentalFactorType>;
  ewcCode?: Maybe<Scalars['String']['output']>;
  fractionServiceBindings: FractionServiceBindingDefConnection;
  hazardous: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  iconPreset?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  inquiries: CollectionInquiryTypeConnection;
  isUsed?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  loadsCorrected: TruckloadTypeConnection;
  /** Fractions of the member containers */
  loadsDerived: TruckloadTypeConnection;
  materialRecovery?: Maybe<Scalars['Decimal']['output']>;
  migratedFromId?: Maybe<Scalars['String']['output']>;
  mustIncludeVat: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  project: ProjectType;
  projectsVisible: ProjectTypeConnection;
  rdCode?: Maybe<Scalars['String']['output']>;
  recyclable: Scalars['Boolean']['output'];
  recyclingPercentage?: Maybe<Scalars['Decimal']['output']>;
  routeSettings: RouteSettingsTypeConnection;
  routes: RouteTypeConnection;
  routeschemewastefractionfilllevelsetSet: RouteSchemeWasteFractionFillLevelSetTypeConnection;
  scheduledexportSet: ScheduledExportDefConnection;
  scheduledexportrunSet: ScheduledExportRunDefConnection;
  scpProfiles: ScpProfileDefConnection;
  siirtoSettings: SiirtoCompanySettingsTypeConnection;
  status?: Maybe<WastecollectorWasteFractionStatusChoices>;
  style?: Maybe<Scalars['String']['output']>;
  treatmentLocation: Scalars['String']['output'];
  treatmentMethod: Scalars['String']['output'];
  vehicleSet: VehicleTypeConnection;
  /** Waste fraction for this vehicle type */
  vehiclesCapacity: VehicleWasteCapacityTypeConnection;
  vehicletrailerwasteholdSet: VehicleTrailerWasteHoldTypeConnection;
  wasteCategory?: Maybe<Scalars['String']['output']>;
  wasteSubstance?: Maybe<Scalars['String']['output']>;
  wasteType?: Maybe<Scalars['String']['output']>;
  wasteTypes: WasteTypeTypeConnection;
  /** kg for m3 */
  weightFactor: Scalars['Float']['output'];
};


export type WasteFractionTypeAlertruleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeBulkwastepickupticketitemSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeContainerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeContainerTypeRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeContainerTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeCostsettingsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeDepotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeFractionServiceBindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeInquiriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeLoadsCorrectedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  openedAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeLoadsDerivedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  haulerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  openedAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeProjectsVisibleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeRouteSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeRouteschemewastefractionfilllevelsetSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeScheduledexportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeScheduledexportrunSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeScpProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeSiirtoSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeVehicleSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeVehiclesCapacityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeVehicletrailerwasteholdSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteFractionTypeWasteTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type WasteFractionTypeConnection = {
  __typename: 'WasteFractionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WasteFractionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `WasteFractionType` and its cursor. */
export type WasteFractionTypeEdge = {
  __typename: 'WasteFractionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<WasteFractionType>;
};

/**
 * The archived Duty of Care note of one movement: reference,
 * revision, retention window and a download URL for the PDF.
 */
export type WasteTransferNoteDef = Node & {
  __typename: 'WasteTransferNoteDef';
  contentHash: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  /** Where the PDF can be fetched (a signed storage URL). */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  generatedAt: Scalars['DateTime']['output'];
  generatedBy?: Maybe<UserType>;
  hashAlgorithm: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  noteNumber: Scalars['String']['output'];
  rendererVersion: Scalars['String']['output'];
  retentionPolicy: Scalars['String']['output'];
  retentionUntil: Scalars['Date']['output'];
  sizeBytes: Scalars['Int']['output'];
  ticket: TicketDef;
  transferDate: Scalars['Date']['output'];
  version: Scalars['Int']['output'];
};

export type WasteTransferNoteDefConnection = {
  __typename: 'WasteTransferNoteDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WasteTransferNoteDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `WasteTransferNoteDef` and its cursor. */
export type WasteTransferNoteDefEdge = {
  __typename: 'WasteTransferNoteDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<WasteTransferNoteDef>;
};

export type WasteTypeType = Node & {
  __typename: 'WasteTypeType';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<WasteTypeType>;
  parentId?: Maybe<Scalars['ID']['output']>;
  project?: Maybe<ProjectType>;
  wastefractionSet: WasteFractionTypeConnection;
  wastetypeSet: WasteTypeTypeConnection;
  /** kg for m^3 */
  weightFactor?: Maybe<Scalars['Float']['output']>;
};


export type WasteTypeTypeWastefractionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type WasteTypeTypeWastetypeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type WasteTypeTypeConnection = {
  __typename: 'WasteTypeTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WasteTypeTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `WasteTypeType` and its cursor. */
export type WasteTypeTypeEdge = {
  __typename: 'WasteTypeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<WasteTypeType>;
};

/**
 * REQ-386 slice 4: a company's admin-extensible waste-water appliance
 * catalogue entry (mirrors device.PartTypeType).
 */
export type WasteWaterApplianceOptionDef = Node & {
  __typename: 'WasteWaterApplianceOptionDef';
  /** Company that owns this appliance-catalogue entry. */
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Part of the canonical, system-seeded appliance library. */
  isSystemSeeded: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type WasteWaterApplianceOptionDefConnection = {
  __typename: 'WasteWaterApplianceOptionDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WasteWaterApplianceOptionDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `WasteWaterApplianceOptionDef` and its cursor. */
export type WasteWaterApplianceOptionDefEdge = {
  __typename: 'WasteWaterApplianceOptionDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<WasteWaterApplianceOptionDef>;
};

/** An enumeration. */
export enum WasteWaterTypes {
  BLACK_AND_GREY_WATER = 'BLACK_AND_GREY_WATER',
  ONLY_BLACK_WATER = 'ONLY_BLACK_WATER',
  ONLY_GREY_WATER = 'ONLY_GREY_WATER'
}

/** An enumeration. */
export enum WastecollectorWasteFractionStatusChoices {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Inactive */
  INACTIVE = 'INACTIVE'
}

/**
 * What an unloading site's weighing system sends.
 *
 * Only ``externalId``, ``system``, ``measuredAt`` and a net weight (either
 * ``netKg`` or a ``grossKg``/``tareKg`` pair) are required. Everything else
 * improves matching or the audit trail, and a site that cannot supply a
 * field simply omits it — the weighing is still stored, for the office.
 */
export type WeighTicketInput = {
  /** WasteHero depot the weighing happened at, when the site system knows it. Narrows matching to that station's stop. */
  depotId?: InputMaybe<Scalars['ID']['input']>;
  /** The weighing system's own id. THE idempotency key: re-sending it returns the stored ticket and writes nothing. */
  externalId: Scalars['String']['input'];
  /** Laden weight, in `unit`. */
  grossKg?: InputMaybe<Scalars['Float']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** When the SCALE measured. Drives vehicle-session matching, and is stored as the weight's measurement time. */
  measuredAt: Scalars['DateTime']['input'];
  /** Net load weight, in `unit`. Required unless both grossKg and tareKg are given. */
  netKg?: InputMaybe<Scalars['Float']['input']>;
  /** WasteHero stop (order id). With routeId this bypasses all heuristics — explicit always beats inferred. */
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** WasteHero route, when the site system already knows it. */
  routeId?: InputMaybe<Scalars['ID']['input']>;
  /** The site's id for the weighing station. Stored for the office; it does not resolve a depot yet (Depot has no vendor-id column). */
  stationExternalId?: InputMaybe<Scalars['String']['input']>;
  /** Vendor key — 'mscales', 'once', or the site's own key. */
  system: Scalars['String']['input'];
  /** Empty weight, in `unit`. */
  tareKg?: InputMaybe<Scalars['Float']['input']>;
  /** Human-readable slip number printed at the site. */
  ticketNumber?: InputMaybe<Scalars['String']['input']>;
  /** kg | t | lb. Defaults to kg — what every current caller means. */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Plate read at the gate. Matched case-insensitively ignoring separators, against both the planned and the actually-driven vehicle of a live session. */
  vehicleRegistration?: InputMaybe<Scalars['String']['input']>;
  /** EWC / site fraction code printed on the slip. */
  wasteFractionCode?: InputMaybe<Scalars['String']['input']>;
};

export type WeighTicketResult = {
  __typename: 'WeighTicketResult';
  created?: Maybe<Scalars['Boolean']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  matched?: Maybe<Scalars['Boolean']['output']>;
  matchedOrderId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

/**
 * One weighing delivered BY an unloading site's weighing system
 * (COMPASS-877 / HSY REQ 18).
 *
 * The requirement puts the scale at the SITE — "integrated into the
 * unloading site's system" — so the direction of travel is site → backend →
 * app, never app → hardware. This model is the landing zone for that push:
 * ``ingestWeighTicket`` writes one row per measurement, tries to attach it
 * to the open unloading stop it belongs to, and stamps that stop's weight
 * provenance. The stop is deliberately LEFT PENDING: REQ 18 says the driver
 * must confirm the unloading event, so nothing here completes a stop.
 *
 * Why a row of its own rather than columns on ``PickUpOrder``:
 *
 * * **Idempotency.** A vendor that does not get a 200 will re-POST. The
 *   unique ``(company, system, external_id)`` triple makes the second POST a
 *   provable no-op instead of a second weight.
 * * **Nothing is dropped.** A measurement that matches no stop (wrong site
 *   id, a truck not on a route, a slip that arrives before the driver
 *   reaches the station) is kept as ``UNMATCHED`` for the office
 *   manual-match queue, not discarded.
 * * **The raw payload survives.** ``raw_payload`` keeps exactly what the
 *   vendor sent, so a disputed transfer can be reconstructed even after our
 *   mapping is found to be wrong.
 *
 * Precedent: the two production ingests this is modelled on —
 * ``evolution/services/pickup_orders.py`` (Botek: RFID + weight + GPS) and
 * ``integrations/services/urbaser/mappers.py`` — both match an external feed
 * onto a stop; neither keeps the source record, which is why neither can
 * answer "did we already process this?".
 */
export type WeighTicketType = Node & {
  __typename: 'WeighTicketType';
  /** Tenant this weighing belongs to (never client-supplied) */
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  /** Resolved WasteHero unloading point, when known. */
  depot?: Maybe<DepotType>;
  /** The weighing system's own id for this measurement. The idempotency key: re-sending it is a no-op. */
  externalId: Scalars['String']['output'];
  grossKg?: Maybe<Scalars['Float']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** WGS84 latitude of the weighing, when the site reports one. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** WGS84 longitude of the weighing, when the site reports one. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Why matching succeeded or failed (vehicle_session, explicit_order, no_vehicle_session, no_open_unloading_stop, manual). Read by the office queue; never shown to a driver. */
  matchReason?: Maybe<Scalars['String']['output']>;
  /** The unloading stop this weighing was attached to. */
  matchedPickupOrder?: Maybe<PickUpOrderType>;
  /** When the scale measured. Drives session matching. */
  measuredAt: Scalars['DateTime']['output'];
  /** Net weight in kilograms. Required — a weighing without a net figure cannot quantify a transfer. */
  netKg: Scalars['Float']['output'];
  /** Where the weighing happened (x=longitude, y=latitude), when the site reports it. REQ 40's unloading location. */
  point?: Maybe<Scalars['GeoJSON']['output']>;
  /** Exactly what the vendor sent. Kept so a disputed transfer can be reconstructed even if our mapping turns out to be wrong. */
  rawPayload?: Maybe<Scalars['JSONString']['output']>;
  /** The site's id for the weighing station in the vendor's system, used to resolve a WasteHero depot when depot is not sent. */
  stationExternalId?: Maybe<Scalars['String']['output']>;
  /** received / matched / unmatched / rejected. UNMATCHED is the office manual-match queue — nothing is ever silently dropped. */
  status: RoutesWeighTicketStatusChoices;
  /** Vendor key — 'mscales', 'once', a site's own key. */
  system: Scalars['String']['output'];
  tareKg?: Maybe<Scalars['Float']['output']>;
  /** Human-readable slip number printed at the site. */
  ticketNumber?: Maybe<Scalars['String']['output']>;
  /** Unit the site REPORTED in. The stored numbers are kilograms; NULL when the vendor stated no unit. */
  unit?: Maybe<RoutesWeighTicketUnitChoices>;
  updatedAt: Scalars['DateTime']['output'];
  /** Registration/plate the site read at the gate — the primary join key back to a live vehicle session. */
  vehicleRegistration?: Maybe<Scalars['String']['output']>;
  /** EWC / site fraction code as printed on the slip. */
  wasteFractionCode?: Maybe<Scalars['String']['output']>;
};

export type WeighTicketTypeConnection = {
  __typename: 'WeighTicketTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WeighTicketTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `WeighTicketType` and its cursor. */
export type WeighTicketTypeEdge = {
  __typename: 'WeighTicketTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<WeighTicketType>;
};

export type WidgetResolutionResult = {
  __typename: 'WidgetResolutionResult';
  widgets: Array<ResolvedWidget>;
};

export type WidgetSpecInput = {
  surface?: InputMaybe<Scalars['String']['input']>;
  widgets: Array<WidgetSpecItem>;
};

/**
 * Input for a single widget resolution request.
 *
 * Exactly one of ``metric`` (legacy mode), ``plan`` (plan mode), ``blend``
 * (cross-fact blend) or ``sql`` (a New dashboards SQL tile) should be
 * provided. Precedence: sql > blend > plan > metric. If none is set the
 * widget resolves to ``UNKNOWN_METRIC``.
 */
export type WidgetSpecItem = {
  blend?: InputMaybe<BlendInput>;
  comparePrevious?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  days?: InputMaybe<Scalars['Int']['input']>;
  dimension?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<Scalars['GenericScalar']['input']>>>;
  headline?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreBoardDate?: InputMaybe<Scalars['Boolean']['input']>;
  metric?: InputMaybe<Scalars['String']['input']>;
  newerThan?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<PlanInput>;
  sql?: InputMaybe<SqlTileInput>;
  viz?: InputMaybe<Scalars['String']['input']>;
};

export type WorkTaskCorrectionType = Node & {
  __typename: 'WorkTaskCorrectionType';
  correctedAt: Scalars['DateTime']['output'];
  correctedBy?: Maybe<UserType>;
  handover: RoutesWorkTaskCorrectionHandoverChoices;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  pickupOrder: PickUpOrderType;
  previousCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  previousRoute?: Maybe<RouteType>;
  reason: Scalars['String']['output'];
  reroutingTicket?: Maybe<TicketDef>;
  toHauler?: Maybe<HaulerDef>;
  toRoute?: Maybe<RouteType>;
};

export type WorkTaskCorrectionTypeConnection = {
  __typename: 'WorkTaskCorrectionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkTaskCorrectionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `WorkTaskCorrectionType` and its cursor. */
export type WorkTaskCorrectionTypeEdge = {
  __typename: 'WorkTaskCorrectionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<WorkTaskCorrectionType>;
};

/**
 * The zones home (`routes.Zone` — DEV-TASK-1 D-1, platform-level since
 * T4 "Map layers & zones": zones are platform Settings configuration
 * consumed by contract areas, pricing and map views — no module flag).
 *
 * Zones are office configuration: contractors are denied the whole record
 * server-side (unlike Area there is no legacy contractor path to a Zone; a
 * contractor still sees the zone NAMES of their own contract areas via
 * ``AreaDef.zones``, which resolves names directly off the model).
 */
export type ZoneDef = Node & {
  __typename: 'ZoneDef';
  areasCount?: Maybe<Scalars['Int']['output']>;
  attributes?: Maybe<Scalars['GenericScalar']['output']>;
  boundaryGeojson?: Maybe<Scalars['JSONString']['output']>;
  children?: Maybe<Array<Maybe<ZoneDef>>>;
  /** Per-zone map display colour as a bare hex string (e.g. '1890FF'); NULL = the map's default zone colour. */
  color?: Maybe<Scalars['String']['output']>;
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  depth?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Label/type of the zone from the company's admin-maintained list (e.g. contract area boundary, price zone). */
  label?: Maybe<ZoneLabelDef>;
  name: Scalars['String']['output'];
  parent?: Maybe<ZoneDef>;
  /** True when an operator pinned ``parent`` by hand; the geometry-driven recompute then leaves it untouched. */
  parentIsManual: Scalars['Boolean']['output'];
  /** How many live customer price rows (product pricing) reference this zone as a price condition. */
  priceRowsCount?: Maybe<Scalars['Int']['output']>;
  source: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usedByAreas?: Maybe<Array<Maybe<AreaDef>>>;
};

export type ZoneDefConnection = {
  __typename: 'ZoneDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoneDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ZoneDef` and its cursor. */
export type ZoneDefEdge = {
  __typename: 'ZoneDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ZoneDef>;
};

/**
 * T4: one entry of the company's admin-maintained zone label/type list
 * (e.g. "contract area boundary", "price zone"). Platform Settings
 * configuration — company-walled, contractors denied (rides the same rule
 * as ZoneDef).
 */
export type ZoneLabelDef = Node & {
  __typename: 'ZoneLabelDef';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ZoneLabelDefConnection = {
  __typename: 'ZoneLabelDefConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoneLabelDefEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Total count of queryable objects */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ZoneLabelDef` and its cursor. */
export type ZoneLabelDefEdge = {
  __typename: 'ZoneLabelDefEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ZoneLabelDef>;
};
